import q, { useMemo as Te, useEffect as Wt, forwardRef as qu, useContext as _t, useRef as Q, useState as le, useImperativeHandle as Yu, useLayoutEffect as wr, useCallback as he, createContext as BC, memo as Ss, createElement as KF, Component as qF } from "react";
import { FormikAsyncAutocompleteField as YF, FormikAutocompleteField as XF, FormikNumberField as ZF, FormikPercentageField as QF, FormikSelectField as JF, FormikTextField as eP } from "@cmg/design-system-formik";
import { useFormik as tP, FormikProvider as ro } from "formik";
import { Typography as Xu, Box as Zu, DotStatus as sP, Stack as vl, Tooltip as VC, SvgIcon as Bg, ErrorIcon as Qd, InfoIcon as iP, WarningIcon as rP, styled as NC, AsyncAutocomplete as nP, TableContainer as oP, Table as aP, TableBody as lP, TableRow as cP, TableCell as dP, Skeleton as uP, ViewWeekOutlinedIcon as hP, FilterAltOutlinedIcon as pP } from "@cmg/design-system";
import gP, { createPortal as HC } from "react-dom";
import { zonedTimeToUtc as fP } from "date-fns-tz";
import { parseISO as mP, isDate as CP } from "date-fns";
var Mr = class {
  constructor() {
    this.allSyncListeners = /* @__PURE__ */ new Map(), this.allAsyncListeners = /* @__PURE__ */ new Map(), this.globalSyncListeners = /* @__PURE__ */ new Set(), this.globalAsyncListeners = /* @__PURE__ */ new Set(), this.asyncFunctionsQueue = [], this.scheduled = !1, this.firedEvents = {};
  }
  setFrameworkOverrides(e) {
    this.frameworkOverrides = e;
  }
  getListeners(e, t, s) {
    const i = t ? this.allAsyncListeners : this.allSyncListeners;
    let r = i.get(e);
    return !r && s && (r = /* @__PURE__ */ new Set(), i.set(e, r)), r;
  }
  noRegisteredListenersExist() {
    return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
  }
  addEventListener(e, t, s = !1) {
    this.getListeners(e, s, !0).add(t);
  }
  removeEventListener(e, t, s = !1) {
    const i = this.getListeners(e, s, !1);
    i && (i.delete(t), i.size === 0 && (s ? this.allAsyncListeners : this.allSyncListeners).delete(e));
  }
  addGlobalListener(e, t = !1) {
    (t ? this.globalAsyncListeners : this.globalSyncListeners).add(e);
  }
  removeGlobalListener(e, t = !1) {
    (t ? this.globalAsyncListeners : this.globalSyncListeners).delete(e);
  }
  dispatchEvent(e) {
    const t = e;
    this.dispatchToListeners(t, !0), this.dispatchToListeners(t, !1), this.firedEvents[t.type] = !0;
  }
  dispatchEventOnce(e) {
    this.firedEvents[e.type] || this.dispatchEvent(e);
  }
  dispatchToListeners(e, t) {
    const s = e.type;
    if (t && "event" in e) {
      const a = e.event;
      a instanceof Event && (e.eventPath = a.composedPath());
    }
    const i = (a, l) => a.forEach((c) => {
      if (!l.has(c))
        return;
      const d = this.frameworkOverrides ? () => this.frameworkOverrides.wrapIncoming(() => c(e)) : () => c(e);
      t ? this.dispatchAsync(d) : d();
    }), r = this.getListeners(s, t, !1) ?? /* @__PURE__ */ new Set(), n = new Set(r);
    n.size > 0 && i(n, r), new Set(
      t ? this.globalAsyncListeners : this.globalSyncListeners
    ).forEach((a) => {
      const l = this.frameworkOverrides ? () => this.frameworkOverrides.wrapIncoming(() => a(s, e)) : () => a(s, e);
      t ? this.dispatchAsync(l) : l();
    });
  }
  // this gets called inside the grid's thread, for each event that it
  // wants to set async. the grid then batches the events into one setTimeout()
  // because setTimeout() is an expensive operation. ideally we would have
  // each event in it's own setTimeout(), but we batch for performance.
  dispatchAsync(e) {
    if (this.asyncFunctionsQueue.push(e), !this.scheduled) {
      const t = () => {
        window.setTimeout(this.flushAsyncQueue.bind(this), 0);
      };
      this.frameworkOverrides ? this.frameworkOverrides.wrapIncoming(t) : t(), this.scheduled = !0;
    }
  }
  // this happens in the next VM turn only, and empties the queue of events
  flushAsyncQueue() {
    this.scheduled = !1;
    const e = this.asyncFunctionsQueue.slice();
    this.asyncFunctionsQueue = [], e.forEach((t) => t());
  }
};
function vP(e, t) {
  return t;
}
function Qu(e) {
  return (e == null ? void 0 : e.getLocaleTextFunc()) ?? vP;
}
function $s(e, t, s) {
  s == null || typeof s == "string" && s == "" ? Ju(e, t) : js(e, t, s);
}
function js(e, t, s) {
  e.setAttribute(zC(t), s.toString());
}
function Ju(e, t) {
  e.removeAttribute(zC(t));
}
function zC(e) {
  return `aria-${e}`;
}
function nt(e, t) {
  t ? e.setAttribute("role", t) : e.removeAttribute("role");
}
function wP(e) {
  let t;
  return e === "asc" ? t = "ascending" : e === "desc" ? t = "descending" : e === "mixed" ? t = "other" : t = "none", t;
}
function yP(e) {
  return parseInt(e.getAttribute("aria-posinset"), 10);
}
function bP(e) {
  return e.getAttribute("aria-label");
}
function ot(e, t) {
  $s(e, "label", t);
}
function xr(e, t) {
  $s(e, "labelledby", t);
}
function sc(e, t) {
  $s(e, "describedby", t);
}
function WC(e, t) {
  $s(e, "live", t);
}
function SP(e, t) {
  $s(e, "atomic", t);
}
function xP(e, t) {
  $s(e, "relevant", t);
}
function ha(e, t) {
  $s(e, "level", t);
}
function wl(e, t) {
  $s(e, "disabled", t);
}
function eh(e, t) {
  $s(e, "hidden", t);
}
function _C(e, t) {
  $s(e, "activedescendant", t);
}
function ns(e, t) {
  js(e, "expanded", t);
}
function UC(e) {
  Ju(e, "expanded");
}
function ic(e, t) {
  js(e, "setsize", t);
}
function rc(e, t) {
  js(e, "posinset", t);
}
function RP(e, t) {
  js(e, "multiselectable", t);
}
function $C(e, t) {
  js(e, "rowcount", t);
}
function th(e, t) {
  js(e, "rowindex", t);
}
function jC(e, t) {
  js(e, "colcount", t);
}
function sh(e, t) {
  js(e, "colindex", t);
}
function KC(e, t) {
  js(e, "colspan", t);
}
function qC(e, t) {
  js(e, "sort", t);
}
function YC(e) {
  Ju(e, "sort");
}
function sa(e, t) {
  $s(e, "selected", t);
}
function XC(e, t) {
  js(e, "checked", t === void 0 ? "mixed" : t);
}
function ih(e, t) {
  $s(e, "controls", t.id), xr(t, e.id);
}
function rh(e, t) {
  return t === void 0 ? e("ariaIndeterminate", "indeterminate") : t === !0 ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked");
}
var id, rd, nd, od, ad, Jd, eu, ld;
function Rn() {
  return id === void 0 && (id = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)), id;
}
function ZC() {
  if (rd === void 0) {
    const e = window;
    rd = !!e.chrome && (!!e.chrome.webstore || !!e.chrome.runtime) || /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }
  return rd;
}
function QC() {
  return nd === void 0 && (nd = /(firefox)/i.test(navigator.userAgent)), nd;
}
function JC() {
  return od === void 0 && (od = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)), od;
}
function yr() {
  return ad === void 0 && (ad = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1), ad;
}
function tu(e) {
  if (!e)
    return null;
  const t = e.tabIndex, s = e.getAttribute("tabIndex");
  return t === -1 && (s === null || s === "" && !QC()) ? null : t.toString();
}
function FP() {
  if (ld !== void 0)
    return ld;
  if (!document.body)
    return -1;
  let e = 1e6;
  const t = QC() ? 6e6 : 1e9, s = document.createElement("div");
  for (document.body.appendChild(s); ; ) {
    const i = e * 2;
    if (s.style.height = i + "px", i > t || s.clientHeight !== i)
      break;
    e = i;
  }
  return document.body.removeChild(s), ld = e, e;
}
function PP() {
  return eu == null && ev(), eu;
}
function ev() {
  const e = document.body, t = document.createElement("div");
  t.style.width = t.style.height = "100px", t.style.opacity = "0", t.style.overflow = "scroll", t.style.msOverflowStyle = "scrollbar", t.style.position = "absolute", e.appendChild(t);
  let s = t.offsetWidth - t.clientWidth;
  s === 0 && t.clientWidth === 0 && (s = null), t.parentNode && t.parentNode.removeChild(t), s != null && (eu = s, Jd = s === 0);
}
function tv() {
  return Jd == null && ev(), Jd;
}
var Ha;
function yl(e, t, s) {
  const i = e.parentElement;
  let r = i && i.firstChild;
  for (; r; )
    t && r.classList.toggle(t, r === e), s && r.classList.toggle(s, r !== e), r = r.nextSibling;
}
var TP = "[tabindex], input, select, button, textarea, [href]", sv = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function nh(e) {
  const t = Element.prototype.matches || Element.prototype.msMatchesSelector, i = t.call(e, "input, select, button, textarea"), r = t.call(e, sv), n = Xt(e);
  return i && !r && n;
}
function re(e, t, s = {}) {
  const { skipAriaHidden: i } = s;
  e.classList.toggle("ag-hidden", !t), i || eh(e, !t);
}
function iv(e, t, s = {}) {
  const { skipAriaHidden: i } = s;
  e.classList.toggle("ag-invisible", !t), i || eh(e, !t);
}
function Bs(e, t) {
  const s = "disabled", i = t ? (r) => r.setAttribute(s, "") : (r) => r.removeAttribute(s);
  i(e), cv(e.querySelectorAll("input"), (r) => i(r));
}
function an(e, t, s) {
  let i = 0;
  for (; e; ) {
    if (e.classList.contains(t))
      return !0;
    if (e = e.parentElement, typeof s == "number") {
      if (++i > s)
        break;
    } else if (e === s)
      break;
  }
  return !1;
}
function Fn(e) {
  const {
    height: t,
    width: s,
    borderTopWidth: i,
    borderRightWidth: r,
    borderBottomWidth: n,
    borderLeftWidth: o,
    paddingTop: a,
    paddingRight: l,
    paddingBottom: c,
    paddingLeft: d,
    marginTop: u,
    marginRight: h,
    marginBottom: p,
    marginLeft: g,
    boxSizing: f
  } = window.getComputedStyle(e);
  return {
    height: parseFloat(t || "0"),
    width: parseFloat(s || "0"),
    borderTopWidth: parseFloat(i || "0"),
    borderRightWidth: parseFloat(r || "0"),
    borderBottomWidth: parseFloat(n || "0"),
    borderLeftWidth: parseFloat(o || "0"),
    paddingTop: parseFloat(a || "0"),
    paddingRight: parseFloat(l || "0"),
    paddingBottom: parseFloat(c || "0"),
    paddingLeft: parseFloat(d || "0"),
    marginTop: parseFloat(u || "0"),
    marginRight: parseFloat(h || "0"),
    marginBottom: parseFloat(p || "0"),
    marginLeft: parseFloat(g || "0"),
    boxSizing: f
  };
}
function nc(e) {
  const t = Fn(e);
  return t.boxSizing === "border-box" ? t.height - t.paddingTop - t.paddingBottom : t.height;
}
function jn(e) {
  const t = Fn(e);
  return t.boxSizing === "border-box" ? t.width - t.paddingLeft - t.paddingRight : t.width;
}
function oc(e) {
  const { height: t, marginBottom: s, marginTop: i } = Fn(e);
  return Math.floor(t + s + i);
}
function gn(e) {
  const { width: t, marginLeft: s, marginRight: i } = Fn(e);
  return Math.floor(t + s + i);
}
function rv(e) {
  const t = e.getBoundingClientRect(), { borderTopWidth: s, borderLeftWidth: i, borderRightWidth: r, borderBottomWidth: n } = Fn(e);
  return {
    top: t.top + (s || 0),
    left: t.left + (i || 0),
    right: t.right + (r || 0),
    bottom: t.bottom + (n || 0)
  };
}
function bl() {
  if (typeof Ha == "boolean")
    return Ha;
  const e = document.createElement("div");
  return e.style.direction = "rtl", e.style.width = "1px", e.style.height = "1px", e.style.position = "fixed", e.style.top = "0px", e.style.overflow = "hidden", e.dir = "rtl", e.innerHTML = /* html */
  `<div style="width: 2px">
            <span style="display: inline-block; width: 1px"></span>
            <span style="display: inline-block; width: 1px"></span>
        </div>`, document.body.appendChild(e), e.scrollLeft = 1, Ha = Math.floor(e.scrollLeft) === 0, document.body.removeChild(e), Ha;
}
function Sl(e, t) {
  let s = e.scrollLeft;
  return t && (s = Math.abs(s), ZC() && !bl() && (s = e.scrollWidth - e.getBoundingClientRect().width - s)), s;
}
function xl(e, t, s) {
  s && (bl() ? t *= -1 : (Rn() || ZC()) && (t = e.scrollWidth - e.getBoundingClientRect().width - t)), e.scrollLeft = t;
}
function ze(e) {
  for (; e && e.firstChild; )
    e.removeChild(e.firstChild);
}
function ut(e) {
  e && e.parentNode && e.parentNode.removeChild(e);
}
function nv(e) {
  return !!e.offsetParent;
}
function Xt(e) {
  const t = e;
  return t.checkVisibility ? t.checkVisibility({ checkVisibilityCSS: !0 }) : !(!nv(e) || window.getComputedStyle(e).visibility !== "visible");
}
function ss(e) {
  const t = document.createElement("div");
  return t.innerHTML = (e || "").trim(), t.firstChild;
}
function ov(e, t, s) {
  s && s.nextSibling === t || (s ? s.nextSibling ? e.insertBefore(t, s.nextSibling) : e.appendChild(t) : e.firstChild && e.firstChild !== t && e.insertAdjacentElement("afterbegin", t));
}
function av(e, t) {
  for (let s = 0; s < t.length; s++) {
    const i = t[s], r = e.children[s];
    r !== i && e.insertBefore(i, r);
  }
}
function EP(e, t, s) {
  s ? s.insertAdjacentElement("afterend", t) : e.firstChild ? e.insertAdjacentElement("afterbegin", t) : e.appendChild(t);
}
function DP(e) {
  return e.replace(/[A-Z]/g, (t) => `-${t.toLocaleLowerCase()}`);
}
function lv(e, t) {
  if (t)
    for (const [s, i] of Object.entries(t)) {
      if (!s || !s.length || i == null)
        continue;
      const r = DP(s), n = i.toString(), o = n.replace(/\s*!important/g, ""), a = o.length != n.length ? "important" : void 0;
      e.style.setProperty(r, o, a);
    }
}
function AP(e) {
  return e.clientWidth < e.scrollWidth;
}
function MP(e) {
  return e.clientHeight < e.scrollHeight;
}
function Rl(e, t) {
  t === "flex" ? (e.style.removeProperty("width"), e.style.removeProperty("minWidth"), e.style.removeProperty("maxWidth"), e.style.flex = "1 1 auto") : si(e, t);
}
function si(e, t) {
  t = oh(t), e.style.width = t.toString(), e.style.maxWidth = t.toString(), e.style.minWidth = t.toString();
}
function Uo(e, t) {
  t = oh(t), e.style.height = t.toString(), e.style.maxHeight = t.toString(), e.style.minHeight = t.toString();
}
function oh(e) {
  return typeof e == "number" ? `${e}px` : e;
}
function ac(e) {
  return e instanceof Node || e instanceof HTMLElement;
}
function IP(e) {
  if (e == null)
    return [];
  const t = [];
  return cv(e, (s) => t.push(s)), t;
}
function LP(e, t) {
  if (e)
    for (let s = 0; s < e.length; s++) {
      const i = e[s];
      t(i.name, i.value);
    }
}
function zs(e, t, s) {
  s == null || s === "" ? e.removeAttribute(t) : e.setAttribute(t, s.toString());
}
function cv(e, t) {
  if (e != null)
    for (let s = 0; s < e.length; s++)
      t(e[s]);
}
function dv(e, t) {
  e.then((s) => {
    const i = s.getGui();
    i != null && (typeof i == "object" ? t.appendChild(i) : t.innerHTML = i);
  });
}
function Ms(e, t, s) {
  const r = wv(e).ResizeObserver, n = r ? new r(s) : null;
  return n == null || n.observe(t), () => n == null ? void 0 : n.disconnect();
}
function St(e) {
  return e == null || e === "" ? null : e;
}
function W(e) {
  return e != null && e !== "";
}
function ke(e) {
  return !W(e);
}
function Cs(e) {
  return e != null && typeof e.toString == "function" ? e.toString() : null;
}
function Kn(e, t) {
  const s = e ? JSON.stringify(e) : null, i = t ? JSON.stringify(t) : null;
  return s === i;
}
function nl(e, t, s = !1) {
  const i = e == null, r = t == null;
  if (e && e.toNumber && (e = e.toNumber()), t && t.toNumber && (t = t.toNumber()), i && r)
    return 0;
  if (i)
    return -1;
  if (r)
    return 1;
  function n(o, a) {
    return o > a ? 1 : o < a ? -1 : 0;
  }
  if (typeof e != "string" || !s)
    return n(e, t);
  try {
    return e.localeCompare(t);
  } catch {
    return n(e, t);
  }
}
var uv = "https://www.ag-grid.com", Vg = {};
function ah(e, t) {
  Vg[t] || (e(), Vg[t] = !0);
}
function Rr(e, t, ...s) {
  e.get("debug") && console.log("AG Grid: " + t, ...s);
}
function Si(e, ...t) {
  ah(() => console.warn("AG Grid: " + e, ...t), e + (t == null ? void 0 : t.join("")));
}
function zn(e, ...t) {
  ah(() => console.error("AG Grid: " + e, ...t), e + (t == null ? void 0 : t.join("")));
}
var cd = [], dd = !1;
function Ng(e) {
  cd.push(e), !dd && (dd = !0, window.setTimeout(() => {
    const t = cd.slice();
    cd.length = 0, dd = !1, t.forEach((s) => s());
  }, 0));
}
function Et(e, t, s) {
  let i;
  return function(...r) {
    const n = this;
    window.clearTimeout(i), i = window.setTimeout(function() {
      e.isAlive() && t.apply(n, r);
    }, s);
  };
}
function Hg(e, t) {
  let s = 0;
  return function(...i) {
    const r = this, n = (/* @__PURE__ */ new Date()).getTime();
    n - s < t || (s = n, e.apply(r, i));
  };
}
function hv(e, t, s = 100, i) {
  const r = (/* @__PURE__ */ new Date()).getTime();
  let n = null, o = !1;
  const a = () => {
    const l = (/* @__PURE__ */ new Date()).getTime() - r > s;
    (e() || l) && (t(), o = !0, n != null && (window.clearInterval(n), n = null));
  };
  a(), o || (n = window.setInterval(a, 10));
}
var de = "33.0.4", zg = 2e3, Wg = 100, pv = "_version_", ol = null, qn = `${uv}/javascript-data-grid`;
function kP(e) {
  ol = e;
}
function OP(e) {
  qn = e;
}
function gv(e, t, s) {
  return (ol == null ? void 0 : ol.getConsoleMessage(e, t)) ?? [NP(e, t, s)];
}
function lh(e, t, s, i) {
  e(`error #${t}`, ...gv(t, s, i));
}
function GP(e) {
  if (!e)
    return String(e);
  const t = {};
  for (const s of Object.keys(e))
    typeof e[s] != "object" && typeof e[s] != "function" && (t[s] = e[s]);
  return JSON.stringify(t);
}
function BP(e) {
  let t = e;
  return e instanceof Error ? t = e.toString() : typeof e == "object" && (t = GP(e)), t;
}
function Fl(e) {
  return e === void 0 ? "undefined" : e === null ? "null" : e;
}
function su(e, t) {
  return `${e}?${t.toString()}`;
}
function VP(e, t, s) {
  const i = Array.from(t.entries()).sort((n, o) => o[1].length - n[1].length);
  let r = su(e, t);
  for (const [n, o] of i) {
    if (n === pv)
      continue;
    const a = r.length - s;
    if (a <= 0)
      break;
    const l = "...", c = a + l.length, d = o.length - c > Wg ? o.slice(0, o.length - c) + l : o.slice(0, Wg) + l;
    t.set(n, d), r = su(e, t);
  }
  return r;
}
function fv(e, t) {
  const s = new URLSearchParams();
  s.append(pv, de), t && Object.entries(t).forEach(([n, o]) => {
    s.append(n, BP(o));
  });
  const i = `${qn}/errors/${e}`, r = su(i, s);
  return r.length <= zg ? r : VP(i, s, zg);
}
var NP = (e, t, s) => {
  const i = fv(e, t);
  return `${s ? s + ` 
` : ""}Visit ${i}${s ? "" : ` 
  Alternatively register the ValidationModule to see the full message in the console.`}`;
};
function I(...e) {
  lh(Si, e[0], e[1]);
}
function be(...e) {
  lh(zn, e[0], e[1]);
}
function iu(e, t, s) {
  lh(zn, e, t, s);
}
function mv(e, t) {
  const s = t[0];
  return `error #${s} ` + gv(s, t[1], e).join(" ");
}
function Ws(...e) {
  return mv(void 0, e);
}
function Cv(...e) {
  return mv(`
`, e);
}
function vv(e, t) {
  return e.get("rowModelType") === t;
}
function Ye(e, t) {
  return vv(e, "clientSide");
}
function Lt(e, t) {
  return vv(e, "serverSide");
}
function It(e, t) {
  return e.get("domLayout") === t;
}
function Es(e) {
  return Zn(e) !== void 0;
}
function ch(e) {
  return typeof e.get("getRowHeight") == "function";
}
function HP(e, t) {
  return t ? !e.get("enableStrictPivotColumnOrder") : e.get("maintainColumnOrder");
}
function qt(e, t, s = !1, i) {
  const { gos: r, environment: n } = e;
  if (i == null && (i = n.getDefaultRowHeight()), ch(r)) {
    if (s)
      return { height: i, estimated: !0 };
    const l = {
      node: t,
      data: t.data
    }, c = r.getCallback("getRowHeight")(l);
    if (ru(c))
      return c === 0 && I(23), { height: Math.max(1, c), estimated: !1 };
  }
  if (t.detail && r.get("masterDetail"))
    return zP(r);
  const o = r.get("rowHeight");
  return { height: o && ru(o) ? o : i, estimated: !1 };
}
function zP(e) {
  if (e.get("detailRowAutoHeight"))
    return { height: 1, estimated: !1 };
  const t = e.get("detailRowHeight");
  return ru(t) ? { height: t, estimated: !1 } : { height: 300, estimated: !1 };
}
function vs(e) {
  const { environment: t, gos: s } = e, i = s.get("rowHeight");
  if (!i || ke(i))
    return t.getDefaultRowHeight();
  const r = t.refreshRowHeightVariable();
  return r !== -1 ? r : (I(24), t.getDefaultRowHeight());
}
function ru(e) {
  return !isNaN(e) && typeof e == "number" && isFinite(e);
}
function Pl(e, t, s) {
  const i = t[e.getDomDataKey()];
  return i ? i[s] : void 0;
}
function fn(e, t, s, i) {
  const r = e.getDomDataKey();
  let n = t[r];
  ke(n) && (n = {}, t[r] = n), n[s] = i;
}
function We(e) {
  const { gos: t, eGridDiv: s } = e;
  let i = null;
  const r = t.get("getDocument");
  return r && W(r) ? i = r() : s && (i = s.ownerDocument), i && W(i) ? i : document;
}
function wv(e) {
  return We(e).defaultView || window;
}
function Yn(e) {
  return e.eGridDiv.getRootNode();
}
function Ie(e) {
  return Yn(e).activeElement;
}
function lc(e) {
  let t = null, s = null;
  try {
    t = We(e).fullscreenElement;
  } catch {
  } finally {
    t || (t = Yn(e));
    const i = t.querySelector("body");
    i ? s = i : t instanceof ShadowRoot ? s = t : t instanceof Document ? s = t == null ? void 0 : t.documentElement : s = t;
  }
  return s;
}
function WP(e) {
  const t = lc(e);
  return (t == null ? void 0 : t.clientWidth) ?? (window.innerHeight || -1);
}
function _P(e) {
  const t = lc(e);
  return (t == null ? void 0 : t.clientHeight) ?? (window.innerHeight || -1);
}
function nu(e, t, s) {
  const r = e.getBoundingClientRect().height, n = WP(s) - 2, o = _P(s) - 2;
  if (!e.offsetParent)
    return;
  const l = rv(e.offsetParent), { clientY: c, clientX: d } = t;
  let u = c - l.top - r / 2, h = d - l.left - 10;
  const p = We(s), g = p.defaultView || window, f = g.pageYOffset || p.documentElement.scrollTop, m = g.pageXOffset || p.documentElement.scrollLeft;
  n > 0 && h + e.clientWidth > n + m && (h = n + m - e.clientWidth), h < 0 && (h = 0), o > 0 && u + e.clientHeight > o + f && (u = o + f - e.clientHeight), u < 0 && (u = 0), e.style.left = `${h}px`, e.style.top = `${u}px`;
}
function Fr(e) {
  const t = We(e), s = Ie(e);
  return s === null || s === t.body;
}
function Wn(e) {
  return e.get("ensureDomOrder") ? !1 : e.get("animateRows");
}
function cc(e) {
  return !(e.get("paginateChildRows") || e.get("groupHideOpenParents") || It(e, "print"));
}
function ti(e) {
  const t = e.get("autoGroupColumnDef");
  return !(t != null && t.comparator) && !e.get("treeData");
}
function ia(e) {
  const t = e.get("groupAggFiltering");
  if (typeof t == "function")
    return e.getCallback("groupAggFiltering");
  if (t === !0)
    return () => !0;
}
function dc(e) {
  return e.get("grandTotalRow");
}
function Xn(e) {
  const t = e.get("groupTotalRow");
  return typeof t == "function" ? e.getCallback("groupTotalRow") : () => t ?? void 0;
}
function dh(e) {
  return e.exists("groupDisplayType") ? e.get("groupDisplayType") === "multipleColumns" : e.get("groupHideOpenParents");
}
function uc(e, t) {
  return t ? !1 : e.get("groupDisplayType") === "groupRows";
}
function _i(e) {
  const t = e.getCallback("getRowId");
  return t === void 0 ? t : (s) => {
    let i = t(s);
    return typeof i != "string" && (I(25, { id: i }), i = String(i)), i;
  };
}
function UP(e, t) {
  const s = e.get("groupHideParentOfSingleChild");
  return !!(s === !0 || s === "leafGroupsOnly" && t.leafGroup || e.get("groupRemoveSingleChildren") || e.get("groupRemoveLowestSingleChildren") && t.leafGroup);
}
function yv(e) {
  const t = e.get("maxConcurrentDatasourceRequests");
  return t > 0 ? t : void 0;
}
function bv(e, t) {
  const s = e.get("suppressGroupChangesColumnVisibility");
  if (s === !0 || t && s === "suppressHideOnGroup" || !t && s === "suppressShowOnUngroup")
    return !1;
  const i = e.get("suppressRowGroupHidesColumns");
  if (t && i === !0)
    return !1;
  const r = e.get("suppressMakeColumnVisibleAfterUnGroup");
  return !(!t && r === !0);
}
function ln(e) {
  return (e == null ? void 0 : e.checkboxes) ?? !0;
}
function al(e) {
  return (e == null ? void 0 : e.mode) === "multiRow" && (e.headerCheckbox ?? !0);
}
function Tl(e) {
  if (typeof e == "object")
    return e.checkboxLocation ?? "selectionColumn";
}
function ud(e) {
  return (e == null ? void 0 : e.hideDisabledCheckboxes) ?? !1;
}
function uh(e) {
  return typeof e.get("rowSelection") != "string";
}
function $P(e) {
  return e.get("cellSelection") !== void 0;
}
function za(e) {
  const t = e.get("cellSelection");
  return t !== void 0 ? typeof t != "boolean" ? (t == null ? void 0 : t.suppressMultiRanges) ?? !1 : !1 : e.get("suppressMultiRangeSelection");
}
function is(e) {
  const t = e.get("cellSelection");
  return t !== void 0 ? !!t : e.get("enableRangeSelection");
}
function hd(e) {
  var i;
  const t = e.get("cellSelection");
  return t !== void 0 ? typeof t != "boolean" && ((i = t.handle) == null ? void 0 : i.mode) === "fill" ? t.handle : void 0 : {
    mode: "fill",
    setFillValue: e.get("fillOperation"),
    direction: e.get("fillHandleDirection"),
    suppressClearOnFillReduction: e.get("suppressClearOnFillReduction")
  };
}
function Sv(e) {
  const t = e.get("rowSelection") ?? "single";
  if (typeof t == "string") {
    const s = e.get("suppressRowClickSelection"), i = e.get("suppressRowDeselection");
    return s && i ? !1 : s ? "enableDeselection" : i ? "enableSelection" : !0;
  }
  return t.mode === "singleRow" || t.mode === "multiRow" ? t.enableClickSelection ?? !1 : !1;
}
function jP(e) {
  const t = Sv(e);
  return t === !0 || t === "enableSelection";
}
function _g(e) {
  const t = Sv(e);
  return t === !0 || t === "enableDeselection";
}
function ou(e) {
  const t = e.get("rowSelection");
  return typeof t == "string" ? e.get("isRowSelectable") : t == null ? void 0 : t.isRowSelectable;
}
function Zn(e) {
  const t = e.get("rowSelection");
  if (typeof t == "string")
    switch (t) {
      case "multiple":
        return "multiRow";
      case "single":
        return "singleRow";
      default:
        return;
    }
  switch (t == null ? void 0 : t.mode) {
    case "multiRow":
    case "singleRow":
      return t.mode;
    default:
      return;
  }
}
function Pr(e) {
  return Zn(e) === "multiRow";
}
function KP(e) {
  const t = e.get("rowSelection");
  return typeof t == "string" ? e.get("rowMultiSelectWithClick") : (t == null ? void 0 : t.enableSelectionWithoutKeys) ?? !1;
}
function El(e) {
  const t = e.get("rowSelection");
  if (typeof t == "string") {
    const s = e.get("groupSelectsChildren"), i = e.get("groupSelectsFiltered");
    return s && i ? "filteredDescendants" : s ? "descendants" : "self";
  }
  return (t == null ? void 0 : t.mode) === "multiRow" ? t.groupSelects : void 0;
}
function xv(e, t = !0) {
  const s = e.get("rowSelection");
  return typeof s != "object" ? t ? "all" : void 0 : s.mode === "multiRow" ? s.selectAll : "all";
}
function mn(e) {
  const t = El(e);
  return t === "descendants" || t === "filteredDescendants";
}
function pd(e) {
  return e.isModuleRegistered("SetFilter") && !e.get("suppressSetFilterByDefault");
}
function Mt(e) {
  return e.get("columnMenu") === "legacy";
}
function Rv(e) {
  return !Mt(e);
}
function Fv(e) {
  return !e || e.length < 2 ? e : "on" + e[0].toUpperCase() + e.substring(1);
}
function qP(e, t, s) {
  typeof e != "object" && (e = {});
  const i = { ...e };
  return s.forEach((r) => {
    const n = t[r];
    typeof n < "u" && (i[r] = n);
  }), i;
}
function YP(e, t) {
  if (!e)
    return;
  const s = {};
  let i = !1;
  if (Object.keys(e).forEach((o) => {
    s[o] = e[o], i = !0;
  }), !i)
    return;
  const r = {
    type: "gridOptionsChanged",
    options: s
  };
  t.dispatchEvent(r);
  const n = {
    type: "componentStateChanged",
    ...s
  };
  t.dispatchEvent(n);
}
var Pv = "__ag_Grid_Stop_Propagation", XP = ["touchstart", "touchend", "touchmove", "touchcancel", "scroll"], ZP = ["wheel"], gd = {};
function gt(e) {
  e[Pv] = !0;
}
function Ds(e) {
  return e[Pv] === !0;
}
var Tv = /* @__PURE__ */ (() => {
  const e = {
    select: "input",
    change: "input",
    submit: "form",
    reset: "form",
    error: "img",
    load: "img",
    abort: "img"
  };
  return (s) => {
    if (typeof gd[s] == "boolean")
      return gd[s];
    const i = document.createElement(e[s] || "div");
    return s = "on" + s, gd[s] = s in i;
  };
})();
function Ev(e, t, s) {
  let i = t;
  for (; i; ) {
    const r = Pl(e, i, s);
    if (r)
      return r;
    i = i.parentElement;
  }
  return null;
}
function au(e, t) {
  return !t || !e ? !1 : JP(t).indexOf(e) >= 0;
}
function QP(e) {
  const t = [];
  let s = e.target;
  for (; s; )
    t.push(s), s = s.parentElement;
  return t;
}
function JP(e) {
  const t = e;
  return t.path ? t.path : t.composedPath ? t.composedPath() : QP(t);
}
function eT(e, t, s, i) {
  const r = Dv(s);
  let n;
  r != null && (n = { passive: r }), e && e.addEventListener && e.addEventListener(t, s, i, n);
}
var Dv = (e) => {
  const t = XP.includes(e), s = ZP.includes(e);
  if (t)
    return !0;
  if (s)
    return !1;
}, L = class {
  constructor() {
    this.destroyFunctions = [], this.destroyed = !1, this.__v_skip = !0, this.propertyListenerId = 0, this.lastChangeSetIdLookup = {}, this.isAlive = () => !this.destroyed;
  }
  preWireBeans(e) {
    this.beans = e, this.stubContext = e.context, this.eventSvc = e.eventSvc, this.gos = e.gos;
  }
  // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
  // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
  // points to a bean or component that was not properly disposed of.
  // constructor() {
  //     setTimeout(()=> {
  //         if (this.isAlive()) {
  //             let prototype: any = Object.getPrototypeOf(this);
  //             const constructor: any = prototype.constructor;
  //             const constructorString = constructor.toString();
  //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
  //             console.log('is alive ' + beanName);
  //         }
  //     }, 5000);
  // }
  destroy() {
    const { destroyFunctions: e } = this;
    for (let t = 0; t < e.length; t++)
      e[t]();
    e.length = 0, this.destroyed = !0, this.dispatchLocalEvent({ type: "destroyed" });
  }
  // The typing of AgEventListener<any, any, any> is not ideal, but it's the best we can do at the moment to enable
  // eventSvc to have the best typing at the expense of BeanStub local events
  /** Add a local event listener against this BeanStub */
  addEventListener(e, t, s) {
    this.localEventService || (this.localEventService = new Mr()), this.localEventService.addEventListener(e, t, s);
  }
  /** Remove a local event listener from this BeanStub */
  removeEventListener(e, t, s) {
    var i;
    (i = this.localEventService) == null || i.removeEventListener(e, t, s);
  }
  dispatchLocalEvent(e) {
    var t;
    (t = this.localEventService) == null || t.dispatchEvent(e);
  }
  addManagedElementListeners(e, t) {
    return this._setupListeners(e, t);
  }
  addManagedEventListeners(e) {
    return this._setupListeners(this.eventSvc, e);
  }
  addManagedListeners(e, t) {
    return this._setupListeners(e, t);
  }
  _setupListeners(e, t) {
    const s = [];
    for (const i of Object.keys(t)) {
      const r = t[i];
      r && s.push(this._setupListener(e, i, r));
    }
    return s;
  }
  _setupListener(e, t, s) {
    if (this.destroyed)
      return () => null;
    e instanceof HTMLElement ? eT(this.beans.frameworkOverrides, e, t, s) : e.addEventListener(t, s);
    const i = () => (e.removeEventListener(t, s), null);
    return this.destroyFunctions.push(i), () => (i(), this.destroyFunctions = this.destroyFunctions.filter((r) => r !== i), null);
  }
  /**
   * Setup a managed property listener for the given GridOption property.
   * However, stores the destroy function in the beanStub so that if this bean
   * is a component the destroy function will be called when the component is destroyed
   * as opposed to being cleaned up only when the GridOptionsService is destroyed.
   */
  setupGridOptionListener(e, t) {
    const { gos: s } = this;
    s.addPropertyEventListener(e, t);
    const i = () => (s.removePropertyEventListener(e, t), null);
    return this.destroyFunctions.push(i), () => (i(), this.destroyFunctions = this.destroyFunctions.filter((r) => r !== i), null);
  }
  /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */
  addManagedPropertyListener(e, t) {
    return this.destroyed ? () => null : this.setupGridOptionListener(e, t);
  }
  /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */
  addManagedPropertyListeners(e, t) {
    if (this.destroyed)
      return;
    const s = e.join("-") + this.propertyListenerId++, i = (r) => {
      if (r.changeSet) {
        if (r.changeSet && r.changeSet.id === this.lastChangeSetIdLookup[s])
          return;
        this.lastChangeSetIdLookup[s] = r.changeSet.id;
      }
      const n = {
        type: "gridPropertyChanged",
        changeSet: r.changeSet,
        source: r.source
      };
      t(n);
    };
    e.forEach((r) => this.setupGridOptionListener(r, i));
  }
  getLocaleTextFunc() {
    return Qu(this.beans.localeSvc);
  }
  addDestroyFunc(e) {
    this.isAlive() ? this.destroyFunctions.push(e) : e();
  }
  /** doesn't throw an error if `bean` is undefined */
  createOptionalManagedBean(e, t) {
    return e ? this.createManagedBean(e, t) : void 0;
  }
  createManagedBean(e, t) {
    const s = this.createBean(e, t);
    return this.addDestroyFunc(this.destroyBean.bind(this, e, t)), s;
  }
  createBean(e, t, s) {
    return (t || this.stubContext).createBean(e, s);
  }
  /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */
  destroyBean(e, t) {
    return (t || this.stubContext).destroyBean(e);
  }
  /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */
  destroyBeans(e, t) {
    return (t || this.stubContext).destroyBeans(e);
  }
}, Av = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
function tT(e, t) {
  if (e != null) {
    if (Array.isArray(e)) {
      for (let s = 0; s < e.length; s++)
        t(s.toString(), e[s]);
      return;
    }
    for (const [s, i] of Object.entries(e))
      t(s, i);
  }
}
function bt(e, t, s = !0, i = !1) {
  W(t) && tT(t, (r, n) => {
    if (Av.has(r))
      return;
    let o = e[r];
    o !== n && (i && o == null && n != null && typeof n == "object" && n.constructor === Object && (o = {}, e[r] = o), Ug(n) && Ug(o) && !Array.isArray(o) ? bt(o, n, s, i) : (s || n !== void 0) && (e[r] = n));
  });
}
function $o(e, t, s) {
  if (!t || !e)
    return;
  if (!s)
    return e[t];
  const i = t.split(".");
  let r = e;
  for (let n = 0; n < i.length; n++) {
    if (r == null)
      return;
    r = r[i[n]];
  }
  return r;
}
function Ug(e) {
  return typeof e == "object" && e !== null;
}
var sT = {
  resizable: !0,
  sortable: !0
}, iT = 0;
function Mv() {
  return iT++;
}
function Ri(e) {
  return e instanceof hc;
}
var hc = class extends L {
  constructor(e, t, s, i) {
    super(), this.colDef = e, this.userProvidedColDef = t, this.colId = s, this.primary = i, this.isColumn = !0, this.instanceId = Mv(), this.autoHeaderHeight = null, this.moving = !1, this.menuVisible = !1, this.lastLeftPinned = !1, this.firstRightPinned = !1, this.filterActive = !1, this.colEventSvc = new Mr(), this.tooltipEnabled = !1, this.rowGroupActive = !1, this.pivotActive = !1, this.aggregationActive = !1, this.flex = null;
  }
  getInstanceId() {
    return this.instanceId;
  }
  setState() {
    const {
      colDef: e,
      beans: { sortSvc: t, pinnedCols: s, colFlex: i }
    } = this;
    t == null || t.initCol(this);
    const r = e.hide;
    r !== void 0 ? this.visible = !r : this.visible = !e.initialHide, s == null || s.initCol(this), i == null || i.initCol(this);
  }
  // gets called when user provides an alternative colDef, eg
  setColDef(e, t, s) {
    this.colDef = e, this.userProvidedColDef = t, this.initMinAndMaxWidths(), this.initDotNotation(), this.initTooltip(), this.dispatchColEvent("colDefChanged", s);
  }
  getUserProvidedColDef() {
    return this.userProvidedColDef;
  }
  getParent() {
    return this.parent;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  // this is done after constructor as it uses gridOptionsService
  postConstruct() {
    this.setState(), this.initMinAndMaxWidths(), this.resetActualWidth("gridInitializing"), this.initDotNotation(), this.initTooltip();
  }
  initDotNotation() {
    const {
      gos: e,
      colDef: { field: t, tooltipField: s }
    } = this, i = e.get("suppressFieldDotNotation");
    this.fieldContainsDots = W(t) && t.indexOf(".") >= 0 && !i, this.tooltipFieldContainsDots = W(s) && s.indexOf(".") >= 0 && !i;
  }
  initMinAndMaxWidths() {
    const e = this.colDef;
    this.minWidth = e.minWidth ?? this.beans.environment.getDefaultColumnMinWidth(), this.maxWidth = e.maxWidth ?? Number.MAX_SAFE_INTEGER;
  }
  initTooltip() {
    var e;
    (e = this.beans.tooltipSvc) == null || e.initCol(this);
  }
  resetActualWidth(e) {
    const t = this.calculateColInitialWidth(this.colDef);
    this.setActualWidth(t, e, !0);
  }
  calculateColInitialWidth(e) {
    let t;
    const s = e.width, i = e.initialWidth;
    return s != null ? t = s : i != null ? t = i : t = 200, Math.max(Math.min(t, this.maxWidth), this.minWidth);
  }
  isEmptyGroup() {
    return !1;
  }
  isRowGroupDisplayed(e) {
    var t;
    return ((t = this.beans.showRowGroupCols) == null ? void 0 : t.isRowGroupDisplayed(this, e)) ?? !1;
  }
  isPrimary() {
    return this.primary;
  }
  isFilterAllowed() {
    return !!this.colDef.filter;
  }
  isFieldContainsDots() {
    return this.fieldContainsDots;
  }
  isTooltipEnabled() {
    return this.tooltipEnabled;
  }
  isTooltipFieldContainsDots() {
    return this.tooltipFieldContainsDots;
  }
  getHighlighted() {
    return this.highlighted;
  }
  addEventListener(e, t) {
    var i, r, n;
    this.frameworkEventListenerService = (r = (i = this.beans.frameworkOverrides).createLocalEventListenerWrapper) == null ? void 0 : r.call(
      i,
      this.frameworkEventListenerService,
      this.colEventSvc
    );
    const s = ((n = this.frameworkEventListenerService) == null ? void 0 : n.wrap(t)) ?? t;
    this.colEventSvc.addEventListener(e, s);
  }
  removeEventListener(e, t) {
    var i;
    const s = ((i = this.frameworkEventListenerService) == null ? void 0 : i.unwrap(t)) ?? t;
    this.colEventSvc.removeEventListener(e, s);
  }
  createColumnFunctionCallbackParams(e) {
    return this.gos.addGridCommonParams({
      node: e,
      data: e.data,
      column: this,
      colDef: this.colDef
    });
  }
  isSuppressNavigable(e) {
    var t;
    return ((t = this.beans.cellNavigation) == null ? void 0 : t.isSuppressNavigable(this, e)) ?? !1;
  }
  isCellEditable(e) {
    var t;
    return ((t = this.beans.editSvc) == null ? void 0 : t.isCellEditable(this, e)) ?? !1;
  }
  isSuppressFillHandle() {
    return !!this.colDef.suppressFillHandle;
  }
  isAutoHeight() {
    return !!this.colDef.autoHeight;
  }
  isAutoHeaderHeight() {
    return !!this.colDef.autoHeaderHeight;
  }
  isRowDrag(e) {
    return this.isColumnFunc(e, this.colDef.rowDrag);
  }
  isDndSource(e) {
    return this.isColumnFunc(e, this.colDef.dndSource);
  }
  isCellCheckboxSelection(e) {
    var t;
    return ((t = this.beans.selectionSvc) == null ? void 0 : t.isCellCheckboxSelection(this, e)) ?? !1;
  }
  isSuppressPaste(e) {
    var t;
    return this.isColumnFunc(e, ((t = this.colDef) == null ? void 0 : t.suppressPaste) ?? null);
  }
  isResizable() {
    return !!this.getColDefValue("resizable");
  }
  /** Get value from ColDef or default if it exists. */
  getColDefValue(e) {
    return this.colDef[e] ?? sT[e];
  }
  isColumnFunc(e, t) {
    if (typeof t == "boolean")
      return t;
    if (typeof t == "function") {
      const s = this.createColumnFunctionCallbackParams(e);
      return t(s);
    }
    return !1;
  }
  createColumnEvent(e, t) {
    return this.gos.addGridCommonParams({
      type: e,
      column: this,
      columns: [this],
      source: t
    });
  }
  isMoving() {
    return this.moving;
  }
  getSort() {
    return this.sort;
  }
  isSortable() {
    return !!this.getColDefValue("sortable");
  }
  /** @deprecated v32 use col.getSort() === 'asc */
  isSortAscending() {
    return this.sort === "asc";
  }
  /** @deprecated v32 use col.getSort() === 'desc */
  isSortDescending() {
    return this.sort === "desc";
  }
  /** @deprecated v32 use col.getSort() === undefined */
  isSortNone() {
    return ke(this.sort);
  }
  /** @deprecated v32 use col.getSort() !== undefined */
  isSorting() {
    return W(this.sort);
  }
  getSortIndex() {
    return this.sortIndex;
  }
  isMenuVisible() {
    return this.menuVisible;
  }
  getAggFunc() {
    return this.aggFunc;
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  getRight() {
    return this.left + this.actualWidth;
  }
  setLeft(e, t) {
    this.oldLeft = this.left, this.left !== e && (this.left = e, this.dispatchColEvent("leftChanged", t));
  }
  isFilterActive() {
    return this.filterActive;
  }
  /** @deprecated v33 Use `api.isColumnHovered(column)` instead. */
  isHovered() {
    var e;
    return I(261), !!((e = this.beans.colHover) != null && e.isHovered(this));
  }
  setFirstRightPinned(e, t) {
    this.firstRightPinned !== e && (this.firstRightPinned = e, this.dispatchColEvent("firstRightPinnedChanged", t));
  }
  setLastLeftPinned(e, t) {
    this.lastLeftPinned !== e && (this.lastLeftPinned = e, this.dispatchColEvent("lastLeftPinnedChanged", t));
  }
  isFirstRightPinned() {
    return this.firstRightPinned;
  }
  isLastLeftPinned() {
    return this.lastLeftPinned;
  }
  isPinned() {
    return this.pinned === "left" || this.pinned === "right";
  }
  isPinnedLeft() {
    return this.pinned === "left";
  }
  isPinnedRight() {
    return this.pinned === "right";
  }
  getPinned() {
    return this.pinned;
  }
  setVisible(e, t) {
    const s = e === !0;
    this.visible !== s && (this.visible = s, this.dispatchColEvent("visibleChanged", t)), this.dispatchStateUpdatedEvent("hide");
  }
  isVisible() {
    return this.visible;
  }
  isSpanHeaderHeight() {
    return !this.getColDef().suppressSpanHeaderHeight;
  }
  getColumnGroupPaddingInfo() {
    let e = this.getParent();
    if (!e || !e.isPadding())
      return { numberOfParents: 0, isSpanningTotal: !1 };
    const t = e.getPaddingLevel() + 1;
    let s = !0;
    for (; e; ) {
      if (!e.isPadding()) {
        s = !1;
        break;
      }
      e = e.getParent();
    }
    return { numberOfParents: t, isSpanningTotal: s };
  }
  getColDef() {
    return this.colDef;
  }
  getDefinition() {
    return this.colDef;
  }
  getColumnGroupShow() {
    return this.colDef.columnGroupShow;
  }
  getColId() {
    return this.colId;
  }
  getId() {
    return this.colId;
  }
  getUniqueId() {
    return this.colId;
  }
  getActualWidth() {
    return this.actualWidth;
  }
  getAutoHeaderHeight() {
    return this.autoHeaderHeight;
  }
  /** Returns true if the header height has changed */
  setAutoHeaderHeight(e) {
    const t = e !== this.autoHeaderHeight;
    return this.autoHeaderHeight = e, t;
  }
  createBaseColDefParams(e) {
    return this.gos.addGridCommonParams({
      node: e,
      data: e.data,
      colDef: this.colDef,
      column: this
    });
  }
  getColSpan(e) {
    if (ke(this.colDef.colSpan))
      return 1;
    const t = this.createBaseColDefParams(e), s = this.colDef.colSpan(t);
    return Math.max(s, 1);
  }
  getRowSpan(e) {
    if (ke(this.colDef.rowSpan))
      return 1;
    const t = this.createBaseColDefParams(e), s = this.colDef.rowSpan(t);
    return Math.max(s, 1);
  }
  setActualWidth(e, t, s = !1) {
    e = Math.max(e, this.minWidth), e = Math.min(e, this.maxWidth), this.actualWidth !== e && (this.actualWidth = e, this.flex && t !== "flex" && t !== "gridInitializing" && (this.flex = null), s || this.fireColumnWidthChangedEvent(t)), this.dispatchStateUpdatedEvent("width");
  }
  fireColumnWidthChangedEvent(e) {
    this.dispatchColEvent("widthChanged", e);
  }
  isGreaterThanMax(e) {
    return e > this.maxWidth;
  }
  getMinWidth() {
    return this.minWidth;
  }
  getMaxWidth() {
    return this.maxWidth;
  }
  getFlex() {
    return this.flex;
  }
  isRowGroupActive() {
    return this.rowGroupActive;
  }
  isPivotActive() {
    return this.pivotActive;
  }
  isAnyFunctionActive() {
    return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
  }
  isAnyFunctionAllowed() {
    return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
  }
  isValueActive() {
    return this.aggregationActive;
  }
  isAllowPivot() {
    return this.colDef.enablePivot === !0;
  }
  isAllowValue() {
    return this.colDef.enableValue === !0;
  }
  isAllowRowGroup() {
    return this.colDef.enableRowGroup === !0;
  }
  dispatchColEvent(e, t, s) {
    const i = this.createColumnEvent(e, t);
    s && bt(i, s), this.colEventSvc.dispatchEvent(i);
  }
  dispatchStateUpdatedEvent(e) {
    this.colEventSvc.dispatchEvent({
      type: "columnStateUpdated",
      key: e
    });
  }
};
function ct(e) {
  return e instanceof jo;
}
var jo = class extends L {
  constructor(e, t, s, i) {
    super(), this.colGroupDef = e, this.groupId = t, this.padding = s, this.level = i, this.isColumn = !1, this.expandable = !1, this.instanceId = Mv(), this.expandableListenerRemoveCallback = null, this.expanded = !!(e != null && e.openByDefault);
  }
  destroy() {
    this.expandableListenerRemoveCallback && this.reset(null, void 0), super.destroy();
  }
  reset(e, t) {
    this.colGroupDef = e, this.level = t, this.originalParent = null, this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback(), this.children = void 0, this.expandable = void 0;
  }
  getInstanceId() {
    return this.instanceId;
  }
  getOriginalParent() {
    return this.originalParent;
  }
  getLevel() {
    return this.level;
  }
  isVisible() {
    return this.children ? this.children.some((e) => e.isVisible()) : !1;
  }
  isPadding() {
    return this.padding;
  }
  setExpanded(e) {
    this.expanded = e === void 0 ? !1 : e, this.dispatchLocalEvent({ type: "expandedChanged" });
  }
  isExpandable() {
    return this.expandable;
  }
  isExpanded() {
    return this.expanded;
  }
  getGroupId() {
    return this.groupId;
  }
  getId() {
    return this.getGroupId();
  }
  setChildren(e) {
    this.children = e;
  }
  getChildren() {
    return this.children;
  }
  getColGroupDef() {
    return this.colGroupDef;
  }
  getLeafColumns() {
    const e = [];
    return this.addLeafColumns(e), e;
  }
  addLeafColumns(e) {
    this.children && this.children.forEach((t) => {
      Ri(t) ? e.push(t) : ct(t) && t.addLeafColumns(e);
    });
  }
  getColumnGroupShow() {
    const e = this.colGroupDef;
    if (e)
      return e.columnGroupShow;
  }
  // need to check that this group has at least one col showing when both expanded and contracted.
  // if not, then we don't allow expanding and contracting on this group
  setupExpandable() {
    this.setExpandable(), this.expandableListenerRemoveCallback && this.expandableListenerRemoveCallback();
    const e = this.onColumnVisibilityChanged.bind(this);
    this.getLeafColumns().forEach((t) => t.addEventListener("visibleChanged", e)), this.expandableListenerRemoveCallback = () => {
      this.getLeafColumns().forEach((t) => t.removeEventListener("visibleChanged", e)), this.expandableListenerRemoveCallback = null;
    };
  }
  setExpandable() {
    if (this.isPadding())
      return;
    let e = !1, t = !1, s = !1;
    const i = this.findChildrenRemovingPadding();
    for (let n = 0, o = i.length; n < o; n++) {
      const a = i[n];
      if (!a.isVisible())
        continue;
      const l = a.getColumnGroupShow();
      l === "open" ? (e = !0, s = !0) : l === "closed" ? (t = !0, s = !0) : (e = !0, t = !0);
    }
    const r = e && t && s;
    this.expandable !== r && (this.expandable = r, this.dispatchLocalEvent({ type: "expandableChanged" }));
  }
  findChildrenRemovingPadding() {
    const e = [], t = (s) => {
      s.forEach((i) => {
        ct(i) && i.isPadding() ? t(i.children) : e.push(i);
      });
    };
    return t(this.children), e;
  }
  onColumnVisibilityChanged() {
    this.setExpandable();
  }
}, rT = {
  numericColumn: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  },
  rightAligned: {
    headerClass: "ag-right-aligned-header",
    cellClass: "ag-right-aligned-cell"
  }
}, nT = class {
  constructor() {
    this.existingKeys = {};
  }
  addExistingKeys(e) {
    for (let t = 0; t < e.length; t++)
      this.existingKeys[e[t]] = !0;
  }
  getUniqueKey(e, t) {
    e = Cs(e);
    let s = 0;
    for (; ; ) {
      let i = e ?? t;
      if (i ? s !== 0 && (i += "_" + s) : i = s, !this.existingKeys[i])
        return this.existingKeys[i] = !0, String(i);
      s++;
    }
  }
}, Tt = Object.freeze([]);
function pe(e) {
  if (e != null && e.length)
    return e[e.length - 1];
}
function Ht(e, t, s) {
  return e == null && t == null ? !0 : e != null && t != null && e.length === t.length && e.every((i, r) => s ? s(i, t[r]) : t[r] === i);
}
function oT(e) {
  return e.sort((t, s) => t - s);
}
function kt(e, t) {
  const s = e.indexOf(t);
  s >= 0 && e.splice(s, 1);
}
function $g(e, t, s) {
  for (let i = 0; i < t.length; i++)
    kt(e, t[i]);
  for (let i = t.length - 1; i >= 0; i--)
    e.splice(s, 0, t[i]);
}
function Iv(e, t) {
  const s = [], i = [], r = [];
  return e.forEach((o) => {
    const a = o.getColDef().lockPosition;
    a === "right" ? r.push(o) : a === "left" || a === !0 ? s.push(o) : i.push(o);
  }), t.get("enableRtl") ? [...r, ...i, ...s] : [...s, ...i, ...r];
}
function Lv(e, t) {
  let s = !0;
  return Hi(null, t, (i) => {
    if (!ct(i))
      return;
    const r = i, n = r.getColGroupDef();
    if (!(n && n.marryChildren))
      return;
    const a = [];
    r.getLeafColumns().forEach((h) => {
      const p = e.indexOf(h);
      a.push(p);
    });
    const l = Math.max.apply(Math, a), c = Math.min.apply(Math, a), d = l - c, u = r.getLeafColumns().length - 1;
    d > u && (s = !1);
  }), s;
}
function kv(e, t) {
  if (!e || e.length == 0)
    return;
  const s = t(e[0]);
  for (let i = 1; i < e.length; i++)
    if (s !== t(e[i]))
      return;
  return s;
}
function Ov(e, t, s) {
  if (!t.length)
    return;
  const i = t.length === 1 ? t[0] : null, r = kv(t, (n) => n.getPinned());
  e.dispatchEvent({
    type: "columnPinned",
    // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
    pinned: r ?? null,
    columns: t,
    column: i,
    source: s
  });
}
function aT(e, t, s) {
  if (!t.length)
    return;
  const i = t.length === 1 ? t[0] : null, r = kv(t, (n) => n.isVisible());
  e.dispatchEvent({
    type: "columnVisible",
    visible: r,
    columns: t,
    column: i,
    source: s
  });
}
function Gv(e, t, s, i) {
  e.dispatchEvent({
    type: t,
    columns: s,
    column: s && s.length == 1 ? s[0] : null,
    source: i
  });
}
function Qn(e, t, s, i, r = null) {
  t != null && t.length && e.dispatchEvent({
    type: "columnResized",
    columns: t,
    column: t.length === 1 ? t[0] : null,
    flexColumns: r,
    finished: s,
    source: i
  });
}
function ws(e, t, s) {
  var b;
  const {
    colModel: i,
    rowGroupColsSvc: r,
    pivotColsSvc: n,
    autoColSvc: o,
    selectionColSvc: a,
    colAnimation: l,
    visibleCols: c,
    pivotResultCols: d,
    environment: u,
    valueColsSvc: h,
    eventSvc: p,
    gos: g
  } = e, f = i.getColDefCols() || [];
  if (!(f != null && f.length))
    return !1;
  if (t != null && t.state && !t.state.forEach)
    return I(32), !1;
  const m = (x, M, T, F, k) => {
    if (!x)
      return;
    const O = hT(M, t.defaultState), D = O("flex").value1;
    if (Kv(
      e,
      x,
      O("hide").value1,
      O("sort").value1,
      O("sortIndex").value1,
      O("pinned").value1,
      D,
      s
    ), D == null) {
      const $ = O("width").value1;
      if ($ != null) {
        const j = x.getColDef().minWidth ?? u.getDefaultColumnMinWidth();
        j != null && $ >= j && x.setActualWidth($, s);
      }
    }
    k || !x.isPrimary() || (h == null || h.syncColumnWithState(x, s, O), r == null || r.syncColumnWithState(x, s, O, T), n == null || n.syncColumnWithState(x, s, O, F));
  }, C = (x, M, T) => {
    var Se, xe;
    const F = Vv(e, s), k = M.slice(), O = {}, D = {}, $ = [], j = [], J = [];
    let X = 0;
    const ie = (r == null ? void 0 : r.columns.slice()) ?? [], Ce = (n == null ? void 0 : n.columns.slice()) ?? [];
    x.forEach((ce) => {
      const Re = ce.colId;
      if (Re.startsWith(Tr)) {
        $.push(ce), J.push(ce);
        return;
      }
      if (xi(Re)) {
        j.push(ce), J.push(ce);
        return;
      }
      const Xe = T(Re);
      Xe ? (m(Xe, ce, O, D, !1), kt(k, Xe)) : (J.push(ce), X += 1);
    });
    const ae = (ce) => m(ce, null, O, D, !1);
    k.forEach(ae), r == null || r.sortColumns(jg.bind(r, O, ie)), n == null || n.sortColumns(jg.bind(n, D, Ce)), i.refreshCols(!1);
    const ge = (ce, Re, De = []) => {
      Re.forEach((Xe) => {
        const He = ce(Xe.colId);
        kt(De, He), m(He, Xe, null, null, !0);
      }), De.forEach(ae);
    };
    return ge(
      (ce) => (o == null ? void 0 : o.getAutoCol(ce)) ?? null,
      $,
      (Se = o == null ? void 0 : o.getAutoCols()) == null ? void 0 : Se.slice()
    ), ge(
      (ce) => (a == null ? void 0 : a.getSelectionCol(ce)) ?? null,
      j,
      (xe = a == null ? void 0 : a.getSelectionCols()) == null ? void 0 : xe.slice()
    ), lT(t, i, g), c.refresh(s), p.dispatchEvent({
      type: "columnEverythingChanged",
      source: s
    }), F(), { unmatchedAndAutoStates: J, unmatchedCount: X };
  };
  l == null || l.start();
  let { unmatchedAndAutoStates: w, unmatchedCount: y } = C(
    t.state || [],
    f,
    (x) => i.getColDefCol(x)
  );
  if (w.length > 0 || W(t.defaultState)) {
    const x = ((b = d == null ? void 0 : d.getPivotResultCols()) == null ? void 0 : b.list) ?? [];
    y = C(
      w,
      x,
      (M) => (d == null ? void 0 : d.getPivotResultCol(M)) ?? null
    ).unmatchedCount;
  }
  return l == null || l.finish(), y === 0;
}
function Bv(e, t) {
  const { colModel: s, autoColSvc: i } = e, r = s.getColDefCols();
  if (!(r != null && r.length))
    return;
  const n = s.getColDefColTree(), o = hh(n), a = [];
  let l = 1e3, c = 1e3, d = [];
  const u = i == null ? void 0 : i.getAutoCols();
  u && (d = d.concat(u)), d = d.concat(o), d.forEach((h) => {
    const p = Nv(h);
    ke(p.rowGroupIndex) && p.rowGroup && (p.rowGroupIndex = l++), ke(p.pivotIndex) && p.pivot && (p.pivotIndex = c++), a.push(p);
  }), ws(e, { state: a, applyOrder: !0 }, t);
}
function Vv(e, t) {
  const { rowGroupColsSvc: s, pivotColsSvc: i, valueColsSvc: r, colModel: n, sortSvc: o, eventSvc: a } = e, l = {
    rowGroupColumns: (s == null ? void 0 : s.columns.slice()) ?? [],
    pivotColumns: (i == null ? void 0 : i.columns.slice()) ?? [],
    valueColumns: (r == null ? void 0 : r.columns.slice()) ?? []
  }, c = ra(e), d = {};
  return c.forEach((u) => {
    d[u.colId] = u;
  }), () => {
    const u = n.getAllCols(), h = (T, F, k, O) => {
      const D = F.map(O), $ = k.map(O);
      if (Ht(D, $))
        return;
      const J = new Set(F);
      k.forEach((ie) => {
        J.delete(ie) || J.add(ie);
      });
      const X = [...J];
      a.dispatchEvent({
        type: T,
        columns: X,
        column: X.length === 1 ? X[0] : null,
        source: t
      });
    }, p = (T) => {
      const F = [];
      return u.forEach((k) => {
        const O = d[k.getColId()];
        O && T(O, k) && F.push(k);
      }), F;
    }, g = (T) => T.getColId();
    h(
      "columnRowGroupChanged",
      l.rowGroupColumns,
      (s == null ? void 0 : s.columns) ?? [],
      g
    ), h(
      "columnPivotChanged",
      l.pivotColumns,
      (i == null ? void 0 : i.columns) ?? [],
      g
    );
    const m = p((T, F) => {
      const k = T.aggFunc != null, O = k != F.isValueActive(), D = k && T.aggFunc != F.getAggFunc();
      return O || D;
    });
    m.length > 0 && Gv(a, "columnValueChanged", m, t), Qn(a, p((T, F) => T.width != F.getActualWidth()), !0, t), Ov(a, p((T, F) => T.pinned != F.getPinned()), t), aT(a, p((T, F) => T.hide == F.isVisible()), t);
    const x = p((T, F) => T.sort != F.getSort() || T.sortIndex != F.getSortIndex());
    x.length > 0 && (o == null || o.dispatchSortChangedEvents(t, x));
    const M = ra(e);
    dT(c, M, t, n, a);
  };
}
function ra(e) {
  const { colModel: t, rowGroupColsSvc: s, pivotColsSvc: i } = e, r = t.getColDefCols();
  if (ke(r) || !t.isAlive())
    return [];
  const n = t.getAllCols(), o = s == null ? void 0 : s.columns, a = i == null ? void 0 : i.columns, l = (u) => {
    const h = u.isRowGroupActive() && o ? o.indexOf(u) : null, p = u.isPivotActive() && a ? a.indexOf(u) : null, g = u.isValueActive() ? u.getAggFunc() : null, f = u.getSort() != null ? u.getSort() : null, m = u.getSortIndex() != null ? u.getSortIndex() : null;
    return {
      colId: u.getColId(),
      width: u.getActualWidth(),
      hide: !u.isVisible(),
      pinned: u.getPinned(),
      sort: f,
      sortIndex: m,
      aggFunc: g,
      rowGroup: u.isRowGroupActive(),
      rowGroupIndex: h,
      pivot: u.isPivotActive(),
      pivotIndex: p,
      flex: u.getFlex() ?? null
    };
  }, c = n.map((u) => l(u)), d = new Map(
    t.getCols().map((u, h) => [u.getColId(), h])
  );
  return c.sort((u, h) => {
    const p = d.has(u.colId) ? d.get(u.colId) : -1, g = d.has(h.colId) ? d.get(h.colId) : -1;
    return p - g;
  }), c;
}
function Nv(e) {
  const t = (g, f) => g ?? f ?? null, s = e.getColDef(), i = t(s.sort, s.initialSort), r = t(s.sortIndex, s.initialSortIndex), n = t(s.hide, s.initialHide), o = t(s.pinned, s.initialPinned), a = t(s.width, s.initialWidth), l = t(s.flex, s.initialFlex);
  let c = t(s.rowGroupIndex, s.initialRowGroupIndex), d = t(s.rowGroup, s.initialRowGroup);
  c == null && (d == null || d == !1) && (c = null, d = null);
  let u = t(s.pivotIndex, s.initialPivotIndex), h = t(s.pivot, s.initialPivot);
  u == null && (h == null || h == !1) && (u = null, h = null);
  const p = t(s.aggFunc, s.initialAggFunc);
  return {
    colId: e.getColId(),
    sort: i,
    sortIndex: r,
    hide: n,
    pinned: o,
    width: a,
    flex: l,
    rowGroup: d,
    rowGroupIndex: c,
    pivot: h,
    pivotIndex: u,
    aggFunc: p
  };
}
function lT(e, t, s) {
  if (!e.applyOrder || !e.state)
    return;
  const i = [];
  e.state.forEach((r) => {
    r.colId != null && i.push(r.colId);
  }), cT(t.cols, i, t, s);
}
function cT(e, t, s, i) {
  if (e == null)
    return;
  let r = [];
  const n = {};
  t.forEach((a) => {
    if (n[a])
      return;
    const l = e.map[a];
    l && (r.push(l), n[a] = !0);
  });
  let o = 0;
  if (e.list.forEach((a) => {
    const l = a.getColId();
    if (n[l] != null)
      return;
    l.startsWith(Tr) ? r.splice(o++, 0, a) : r.push(a);
  }), r = Iv(r, i), !Lv(r, s.getColTree())) {
    I(39);
    return;
  }
  e.list = r;
}
function dT(e, t, s, i, r) {
  const n = {};
  t.forEach((d) => n[d.colId] = d);
  const o = {};
  e.forEach((d) => {
    n[d.colId] && (o[d.colId] = !0);
  });
  const a = e.filter((d) => o[d.colId]), l = t.filter((d) => o[d.colId]), c = [];
  l.forEach((d, u) => {
    const h = a && a[u];
    if (h && h.colId !== d.colId) {
      const p = i.getCol(h.colId);
      p && c.push(p);
    }
  }), c.length && r.dispatchEvent({
    type: "columnMoved",
    columns: c,
    column: c.length === 1 ? c[0] : null,
    finished: !0,
    source: s
  });
}
var jg = (e, t, s, i) => {
  const r = e[s.getId()], n = e[i.getId()], o = r != null, a = n != null;
  if (o && a)
    return r - n;
  if (o)
    return -1;
  if (a)
    return 1;
  const l = t.indexOf(s), c = t.indexOf(i), d = l >= 0, u = c >= 0;
  return d && u ? l - c : d ? -1 : 1;
}, Hv = "ag-Grid-SelectionColumn", uT = class extends L {
  constructor() {
    super(...arguments), this.beanName = "selectionColSvc";
  }
  postConstruct() {
    this.addManagedPropertyListener("rowSelection", (e) => {
      this.onSelectionOptionsChanged(
        e.currentValue,
        e.previousValue,
        cn(e.source)
      );
    });
  }
  addSelectionCols(e) {
    const t = this.selectionCols;
    t != null && (e.list = t.list.concat(e.list), e.tree = t.tree.concat(e.tree), Uv(e));
  }
  createSelectionCols(e, t) {
    var h, p;
    const s = () => {
      var g;
      Er(this.beans, (g = this.selectionCols) == null ? void 0 : g.tree), this.selectionCols = null;
    }, i = e.treeDepth, n = (((h = this.selectionCols) == null ? void 0 : h.treeDepth) ?? -1) == i, o = this.generateSelectionCols();
    if (_v(o, ((p = this.selectionCols) == null ? void 0 : p.list) ?? []) && n)
      return;
    s();
    const { colGroupSvc: l } = this.beans, c = (l == null ? void 0 : l.findDepth(e.tree)) ?? 0, d = (l == null ? void 0 : l.balanceTreeForAutoCols(o, c)) ?? [];
    this.selectionCols = {
      list: o,
      tree: d,
      treeDepth: c,
      map: {}
    }, t((g) => {
      if (!g)
        return null;
      const f = g.filter((m) => !xi(m));
      return [...o, ...f];
    });
  }
  isSelectionColumnEnabled() {
    var o, a;
    const { gos: e, beans: t } = this, s = e.get("rowSelection");
    if (typeof s != "object" || !Es(e))
      return !1;
    const i = (((a = (o = t.autoColSvc) == null ? void 0 : o.getAutoCols()) == null ? void 0 : a.length) ?? 0) > 0;
    if (s.checkboxLocation === "autoGroupColumn" && i)
      return !1;
    const r = !!ln(s), n = al(s);
    return r || n;
  }
  generateSelectionCols() {
    if (!this.isSelectionColumnEnabled())
      return [];
    const { gos: e, validation: t } = this.beans, s = e.get("selectionColumnDef"), r = {
      // overridable properties
      width: 50,
      resizable: !1,
      suppressHeaderMenuButton: !0,
      sortable: !1,
      suppressMovable: !0,
      lockPosition: e.get("enableRtl") ? "right" : "left",
      comparator(a, l, c, d) {
        const u = c.isSelected(), h = d.isSelected();
        return u === h ? 0 : u ? 1 : -1;
      },
      editable: !1,
      suppressFillHandle: !0,
      // overrides
      ...s,
      // non-overridable properties
      colId: Hv
    }, n = r.colId;
    t == null || t.validateColDef(r, n, !0);
    const o = new hc(r, null, n, !1);
    return this.createBean(o), [o];
  }
  putSelectionColsFirstInList(e, t) {
    if (!t)
      return null;
    const s = t.filter((i) => !xi(i));
    return [...e, ...s];
  }
  getSelectionCol(e) {
    var t;
    return ((t = this.selectionCols) == null ? void 0 : t.list.find((s) => ph(s, e))) ?? null;
  }
  getSelectionCols() {
    var e;
    return ((e = this.selectionCols) == null ? void 0 : e.list) ?? null;
  }
  onSelectionOptionsChanged(e, t, s) {
    const i = t && typeof t != "string" ? ln(t) : void 0, r = e && typeof e != "string" ? ln(e) : void 0, n = i !== r, o = t && typeof t != "string" ? al(t) : void 0, a = e && typeof e != "string" ? al(e) : void 0, l = o !== a, c = Tl(e), d = Tl(t);
    (n || l || c !== d) && this.beans.colModel.refreshAll(s);
  }
  destroy() {
    var e;
    Er(this.beans, (e = this.selectionCols) == null ? void 0 : e.tree), super.destroy();
  }
  refreshVisibility(e) {
    if (!this.isSelectionColumnEnabled())
      return;
    const t = this.beans, s = t.visibleCols.getAllTrees() ?? [];
    if (s.length !== 0) {
      if (!s.some(zv)) {
        const i = ra(t).find((r) => xi(r.colId));
        i && ws(
          t,
          {
            state: [{ colId: i.colId, hide: !i.hide }]
          },
          e
        );
      }
      if (s.length === 1) {
        const i = s[0], r = Wv(i);
        if (!r)
          return;
        ws(t, { state: [{ colId: r.getColId(), hide: !0 }] }, e);
      }
    }
  }
}, zv = (e) => {
  var t;
  return e.isColumn ? xi(e) : ((t = e.getChildren()) == null ? void 0 : t.some(zv)) ?? !1;
};
function Wv(e) {
  if (e.isColumn)
    return xi(e) ? e : null;
  const t = e.getChildren() ?? [];
  for (const s of t) {
    const i = Wv(s);
    if (i)
      return i;
  }
  return null;
}
var Tr = "ag-Grid-AutoColumn";
function hh(e) {
  const t = [], s = (i) => {
    for (let r = 0; r < i.length; r++) {
      const n = i[r];
      Ri(n) ? t.push(n) : ct(n) && s(n.getChildren());
    }
  };
  return s(e), t;
}
function Gi(e) {
  return e.reduce((t, s) => t + s.getActualWidth(), 0);
}
function Er(e, t, s) {
  const i = {};
  if (!t)
    return;
  Hi(null, t, (n) => {
    i[n.getInstanceId()] = n;
  }), s && Hi(null, s, (n) => {
    i[n.getInstanceId()] = null;
  });
  const r = Object.values(i).filter((n) => n != null);
  e.context.destroyBeans(r);
}
function pc(e) {
  return e.getId().startsWith(Tr);
}
function xi(e) {
  const t = typeof e == "string" ? e : "getColId" in e ? e.getColId() : e.colId;
  return (t == null ? void 0 : t.startsWith(Hv)) ?? !1;
}
function Dl(e) {
  let t = [];
  return e instanceof Array ? t = e : typeof e == "string" && (t = e.split(",")), t;
}
function _v(e, t) {
  return Ht(e, t, (s, i) => s.getColId() === i.getColId());
}
function Uv(e) {
  e.map = {}, e.list.forEach((t) => e.map[t.getId()] = t);
}
function cn(e) {
  return e === "gridOptionsUpdated" ? "gridOptionsChanged" : e;
}
function ph(e, t) {
  const s = e === t, i = e.getColDef() === t, r = e.getColId() == t;
  return s || i || r;
}
var hT = (e, t) => (s, i) => {
  const r = {
    value1: void 0,
    value2: void 0
  };
  let n = !1;
  return e && (e[s] !== void 0 && (r.value1 = e[s], n = !0), W(i) && e[i] !== void 0 && (r.value2 = e[i], n = !0)), !n && t && (t[s] !== void 0 && (r.value1 = t[s]), W(i) && t[i] !== void 0 && (r.value2 = t[i])), r;
};
function $v(e, t = null, s, i, r) {
  const n = new nT(), { existingCols: o, existingGroups: a, existingColKeys: l } = pT(i);
  n.addExistingKeys(l);
  const c = jv(
    e,
    t,
    0,
    s,
    o,
    n,
    a,
    r
  ), { colGroupSvc: d } = e, u = (d == null ? void 0 : d.findMaxDepth(c, 0)) ?? 0, h = d ? d.balanceColumnTree(c, 0, u, n) : c;
  return Hi(null, h, (g, f) => {
    ct(g) && g.setupExpandable(), g.originalParent = f;
  }), {
    columnTree: h,
    treeDept: u
  };
}
function pT(e) {
  const t = [], s = [], i = [];
  return e && Hi(null, e, (r) => {
    if (ct(r)) {
      const n = r;
      s.push(n);
    } else {
      const n = r;
      i.push(n.getId()), t.push(n);
    }
  }), { existingCols: t, existingGroups: s, existingColKeys: i };
}
function jv(e, t, s, i, r, n, o, a) {
  if (!t)
    return [];
  const { colGroupSvc: l } = e, c = new Array(t.length);
  for (let d = 0; d < c.length; d++) {
    const u = t[d];
    l && vT(u) ? c[d] = l.createProvidedColumnGroup(
      i,
      u,
      s,
      r,
      n,
      o,
      a
    ) : c[d] = gT(e, i, u, r, n, a);
  }
  return c;
}
function gT(e, t, s, i, r, n) {
  var l;
  const o = fT(s, i);
  o && (i == null || i.splice(o.idx, 1));
  let a = o == null ? void 0 : o.column;
  if (a) {
    const c = Al(e, s, a.getColId());
    a.setColDef(c, s, n), qv(e, a, c, n);
  } else {
    const c = r.getUniqueKey(s.colId, s.field), d = Al(e, s, c);
    a = new hc(d, s, c, t), e.context.createBean(a);
  }
  return (l = e.dataTypeSvc) == null || l.addColumnListeners(a), a;
}
function Kv(e, t, s, i, r, n, o, a) {
  const { sortSvc: l, pinnedCols: c, colFlex: d } = e;
  s !== void 0 && t.setVisible(!s, a), l && (l.updateColSort(t, i, a), r !== void 0 && l.setColSortIndex(t, r)), n !== void 0 && (c == null || c.setColPinned(t, n)), o !== void 0 && (d == null || d.setColFlex(t, o));
}
function qv(e, t, s, i) {
  Kv(
    e,
    t,
    s.hide,
    s.sort,
    s.sortIndex,
    s.pinned,
    s.flex,
    i
  );
  const r = t.getFlex();
  if (!(r != null && r > 0))
    if (s.width != null)
      t.setActualWidth(s.width, i);
    else {
      const n = t.getActualWidth();
      t.setActualWidth(n, i);
    }
}
function fT(e, t) {
  if (t)
    for (let s = 0; s < t.length; s++) {
      const i = t[s].getUserProvidedColDef();
      if (!i)
        continue;
      if (e.colId != null) {
        if (t[s].getId() === e.colId)
          return { idx: s, column: t[s] };
        continue;
      }
      if (e.field != null) {
        if (i.field === e.field)
          return { idx: s, column: t[s] };
        continue;
      }
      if (i === e)
        return { idx: s, column: t[s] };
    }
}
function Al(e, t, s, i) {
  const { gos: r, dataTypeSvc: n, validation: o } = e, a = {}, l = r.get("defaultColDef");
  bt(a, l, !1, !0);
  const c = mT(e, a, t, s);
  c && CT(e, c, a), bt(a, t, !1, !0);
  const d = r.get("autoGroupColumnDef"), u = ti(r);
  return t.rowGroup && d && u && bt(
    a,
    { sort: d.sort, initialSort: d.initialSort },
    !1,
    !0
  ), n == null || n.validateColDef(a), o == null || o.validateColDef(a, s, i), a;
}
function mT(e, t, s, i) {
  var o;
  const r = (o = e.dataTypeSvc) == null ? void 0 : o.updateColDefAndGetColumnType(t, s, i), n = s.type ?? r ?? t.type;
  return t.type = n, n ? Dl(n) : void 0;
}
function CT(e, t, s) {
  if (!t.length)
    return;
  const i = Object.assign({}, rT), r = e.gos.get("columnTypes") || {};
  for (const [n, o] of Object.entries(r))
    n in i ? I(34, { key: n }) : (o.type && I(35), i[n] = o);
  t.forEach((n) => {
    const o = i[n.trim()];
    o ? bt(s, o, !1, !0) : I(36, { t: n });
  });
}
function vT(e) {
  return e.children !== void 0;
}
function Hi(e, t, s) {
  if (t)
    for (let i = 0; i < t.length; i++) {
      const r = t[i];
      ct(r) && Hi(r, r.getChildren(), s), s(r, e);
    }
}
var wT = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colModel", this.pivotMode = !1, this.ready = !1, this.changeEventsDispatching = !1;
  }
  postConstruct() {
    this.pivotMode = this.gos.get("pivotMode"), this.addManagedPropertyListeners(
      ["groupDisplayType", "treeData", "treeDataDisplayType", "groupHideOpenParents"],
      (e) => this.refreshAll(cn(e.source))
    ), this.addManagedPropertyListeners(
      ["defaultColDef", "defaultColGroupDef", "columnTypes", "suppressFieldDotNotation"],
      (e) => this.recreateColumnDefs(cn(e.source))
    ), this.addManagedPropertyListener(
      "pivotMode",
      (e) => this.setPivotMode(this.gos.get("pivotMode"), cn(e.source))
    );
  }
  // called from SyncService, when grid has finished initialising
  createColsFromColDefs(e) {
    var w, y, b;
    const { beans: t } = this, {
      valueCache: s,
      colAutosize: i,
      rowGroupColsSvc: r,
      pivotColsSvc: n,
      valueColsSvc: o,
      visibleCols: a,
      colViewport: l,
      eventSvc: c
    } = t, d = this.colDefs ? Vv(t, e) : void 0;
    s == null || s.expire();
    const u = (w = this.colDefCols) == null ? void 0 : w.list, h = (y = this.colDefCols) == null ? void 0 : y.tree, p = $v(t, this.colDefs, !0, h, e);
    Er(t, (b = this.colDefCols) == null ? void 0 : b.tree, p.columnTree);
    const g = p.columnTree, f = p.treeDept, m = hh(g), C = {};
    m.forEach((x) => C[x.getId()] = x), this.colDefCols = { tree: g, treeDepth: f, list: m, map: C }, r == null || r.extractCols(e, u), n == null || n.extractCols(e, u), o == null || o.extractCols(e, u), this.ready = !0, this.refreshCols(!0), a.refresh(e), l.checkViewportColumns(), c.dispatchEvent({
      type: "columnEverythingChanged",
      source: e
    }), d && (this.changeEventsDispatching = !0, d(), this.changeEventsDispatching = !1), c.dispatchEvent({
      type: "newColumnsLoaded",
      source: e
    }), e === "gridInitializing" && (i == null || i.applyAutosizeStrategy());
  }
  // called from: buildAutoGroupColumns (events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents')
  // createColsFromColDefs (recreateColumnDefs, setColumnsDefs),
  // setPivotMode, applyColumnState,
  // functionColsService.setPrimaryColList, functionColsService.updatePrimaryColList,
  // pivotResultCols.setPivotResultCols
  refreshCols(e) {
    var g;
    if (!this.colDefCols)
      return;
    const t = (g = this.cols) == null ? void 0 : g.tree;
    this.saveColOrder();
    const {
      autoColSvc: s,
      selectionColSvc: i,
      quickFilter: r,
      pivotResultCols: n,
      showRowGroupCols: o,
      rowAutoHeight: a,
      visibleCols: l,
      colViewport: c,
      eventSvc: d
    } = this.beans, u = this.selectCols(n, this.colDefCols);
    s == null || s.createAutoCols(u, (f) => {
      this.lastOrder = f(this.lastOrder), this.lastPivotOrder = f(this.lastPivotOrder);
    }), s == null || s.addAutoCols(u), i == null || i.createSelectionCols(u, (f) => {
      this.lastOrder = f(this.lastOrder) ?? null, this.lastPivotOrder = f(this.lastPivotOrder) ?? null;
    }), i == null || i.addSelectionCols(u);
    const h = HP(this.gos, this.showingPivotResult);
    (!e || h) && this.restoreColOrder(u), this.positionLockedCols(u), o == null || o.refresh(), r == null || r.refreshCols(), this.setColSpanActive(), a == null || a.setAutoHeightActive(u), l.clear(), c.clear(), !Ht(t, this.cols.tree) && d.dispatchEvent({
      type: "gridColumnsChanged"
    });
  }
  selectCols(e, t) {
    const s = (e == null ? void 0 : e.getPivotResultCols()) ?? null;
    this.showingPivotResult = s != null;
    const { map: i, list: r, tree: n, treeDepth: o } = s ?? t;
    return this.cols = {
      list: r.slice(),
      map: { ...i },
      tree: n.slice(),
      treeDepth: o
    }, s && (s.list.some((l) => {
      var c;
      return ((c = this.cols) == null ? void 0 : c.map[l.getColId()]) !== void 0;
    }) || (this.lastPivotOrder = null)), this.cols;
  }
  getColsToShow() {
    var i;
    if (!this.cols)
      return [];
    const e = this.isPivotMode() && !this.showingPivotResult, t = (i = this.beans.valueColsSvc) == null ? void 0 : i.columns;
    return this.cols.list.filter((r) => {
      const n = pc(r);
      if (e) {
        const o = t == null ? void 0 : t.includes(r);
        return n || o;
      } else
        return n || r.isVisible();
    });
  }
  // on events 'groupDisplayType', 'treeData', 'treeDataDisplayType', 'groupHideOpenParents'
  refreshAll(e) {
    this.ready && (this.refreshCols(!1), this.beans.visibleCols.refresh(e));
  }
  setColsVisible(e, t = !1, s) {
    ws(
      this.beans,
      {
        state: e.map((i) => ({
          colId: typeof i == "string" ? i : i.getColId(),
          hide: !t
        }))
      },
      s
    );
  }
  restoreColOrder(e) {
    const t = this.showingPivotResult ? this.lastPivotOrder : this.lastOrder;
    if (!t)
      return;
    const s = new Map(t.map((c, d) => [c, d]));
    if (!e.list.some((c) => s.has(c)))
      return;
    const r = new Map(e.list.map((c) => [c, !0])), n = t.filter((c) => r.has(c)), o = new Map(n.map((c) => [c, !0])), a = e.list.filter((c) => !o.has(c)), l = n.slice();
    a.forEach((c) => {
      let d = c.getOriginalParent();
      if (!d) {
        l.push(c);
        return;
      }
      const u = [];
      for (; !u.length && d; )
        d.getLeafColumns().forEach((f) => {
          const m = l.indexOf(f) >= 0, C = u.indexOf(f) < 0;
          m && C && u.push(f);
        }), d = d.getOriginalParent();
      if (!u.length) {
        l.push(c);
        return;
      }
      const h = u.map((g) => l.indexOf(g)), p = Math.max(...h);
      l.splice(p + 1, 0, c);
    }), e.list = l;
  }
  positionLockedCols(e) {
    e.list = Iv(e.list, this.gos);
  }
  saveColOrder() {
    var e, t;
    this.showingPivotResult ? this.lastPivotOrder = ((e = this.cols) == null ? void 0 : e.list) ?? null : this.lastOrder = ((t = this.cols) == null ? void 0 : t.list) ?? null;
  }
  getColumnDefs() {
    var e, t;
    return this.colDefCols ? (t = this.beans.colDefFactory) == null ? void 0 : t.getColumnDefs(
      this.colDefCols.list,
      this.showingPivotResult,
      this.lastOrder,
      ((e = this.cols) == null ? void 0 : e.list) ?? []
    ) : void 0;
  }
  setColSpanActive() {
    var e;
    this.colSpanActive = !!((e = this.cols) != null && e.list.some((t) => t.getColDef().colSpan != null));
  }
  isPivotMode() {
    return this.pivotMode;
  }
  setPivotMode(e, t) {
    if (e === this.pivotMode || (this.pivotMode = e, !this.ready))
      return;
    this.refreshCols(!1);
    const { visibleCols: s, eventSvc: i } = this.beans;
    s.refresh(t), i.dispatchEvent({
      type: "columnPivotModeChanged"
    });
  }
  // + clientSideRowModel
  isPivotActive() {
    var t;
    const e = (t = this.beans.pivotColsSvc) == null ? void 0 : t.columns;
    return this.pivotMode && !!(e != null && e.length);
  }
  // called when dataTypes change
  recreateColumnDefs(e) {
    var t;
    this.cols && ((t = this.beans.autoColSvc) == null || t.updateAutoCols(e), this.createColsFromColDefs(e));
  }
  setColumnDefs(e, t) {
    this.colDefs = e, this.createColsFromColDefs(t);
  }
  destroy() {
    var e;
    Er(this.beans, (e = this.colDefCols) == null ? void 0 : e.tree), super.destroy();
  }
  getColTree() {
    var e;
    return ((e = this.cols) == null ? void 0 : e.tree) ?? [];
  }
  // + columnSelectPanel
  getColDefColTree() {
    var e;
    return ((e = this.colDefCols) == null ? void 0 : e.tree) ?? [];
  }
  // + clientSideRowController -> sorting, building quick filter text
  // + headerRenderer -> sorting (clearing icon)
  getColDefCols() {
    var e;
    return ((e = this.colDefCols) == null ? void 0 : e.list) ?? null;
  }
  // + moveColumnController
  getCols() {
    var e;
    return ((e = this.cols) == null ? void 0 : e.list) ?? [];
  }
  // returns colDefCols, pivotResultCols and autoCols
  getAllCols() {
    var r, n, o, a;
    const { pivotResultCols: e, autoColSvc: t, selectionColSvc: s } = this.beans, i = (r = e == null ? void 0 : e.getPivotResultCols()) == null ? void 0 : r.list;
    return [
      ((n = this.colDefCols) == null ? void 0 : n.list) ?? [],
      ((o = t == null ? void 0 : t.autoCols) == null ? void 0 : o.list) ?? [],
      ((a = s == null ? void 0 : s.selectionCols) == null ? void 0 : a.list) ?? [],
      i ?? []
    ].flat();
  }
  getColsForKeys(e) {
    return e ? e.map((t) => this.getCol(t)).filter((t) => t != null) : [];
  }
  getColDefCol(e) {
    var t;
    return (t = this.colDefCols) != null && t.list ? this.getColFromCollection(e, this.colDefCols) : null;
  }
  getCol(e) {
    return e == null ? null : this.getColFromCollection(e, this.cols);
  }
  getColFromCollection(e, t) {
    var r;
    if (t == null)
      return null;
    const { map: s, list: i } = t;
    if (typeof e == "string" && s[e])
      return s[e];
    for (let n = 0; n < i.length; n++)
      if (ph(i[n], e))
        return i[n];
    return ((r = this.beans.autoColSvc) == null ? void 0 : r.getAutoCol(e)) ?? null;
  }
}, gh = class extends L {
  constructor() {
    super(...arguments), this.dispatchColumnChangedEvent = Gv, this.columns = [];
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.aggFuncSvc = e.aggFuncSvc, this.visibleCols = e.visibleCols;
  }
  sortColumns(e) {
    this.columns.sort(e);
  }
  setColumns(e, t) {
    this.setColList(e, this.columns, this.eventName, !0, !0, this.columnProcessors.set, t);
  }
  addColumns(e, t) {
    this.updateColList(e, this.columns, !0, !0, this.columnProcessors.add, this.eventName, t);
  }
  removeColumns(e, t) {
    this.updateColList(e, this.columns, !1, !0, this.columnProcessors.remove, this.eventName, t);
  }
  setColList(e = [], t, s, i, r, n, o) {
    const a = this.colModel.getCols();
    if (!a || a.length === 0)
      return;
    const l = /* @__PURE__ */ new Map();
    t.forEach((d, u) => l.set(d, u)), t.length = 0, W(e) && e.forEach((d) => {
      const u = this.colModel.getColDefCol(d);
      u && t.push(u);
    }), t.forEach((d, u) => {
      const h = l.get(d);
      if (h === void 0) {
        l.set(d, 0);
        return;
      }
      i && h !== u || l.delete(d);
    }), (this.colModel.getColDefCols() || []).forEach((d) => {
      const u = t.indexOf(d) >= 0;
      n(d, u, o);
    }), r && this.colModel.refreshCols(!1), this.visibleCols.refresh(o), this.dispatchColumnChangedEvent(this.eventSvc, s, [...l.keys()], o);
  }
  updateColList(e = [], t, s, i, r, n, o) {
    if (!e || e.length === 0)
      return;
    let a = !1;
    const l = /* @__PURE__ */ new Set();
    if (e.forEach((d) => {
      if (!d)
        return;
      const u = this.colModel.getColDefCol(d);
      if (u) {
        if (l.add(u), s) {
          if (t.indexOf(u) >= 0)
            return;
          t.push(u);
        } else {
          const h = t.indexOf(u);
          if (h < 0)
            return;
          for (let p = h + 1; p < t.length; p++)
            l.add(t[p]);
          kt(t, u);
        }
        r(u, s, o), a = !0;
      }
    }), !a)
      return;
    i && this.colModel.refreshCols(!1), this.visibleCols.refresh(o);
    const c = Array.from(l);
    this.eventSvc.dispatchEvent({
      type: n,
      columns: c,
      column: c.length === 1 ? c[0] : null,
      source: o
    });
  }
  extractCols(e, t = []) {
    const s = this.columns, i = [], r = [], { setFlagFunc: n, getIndexFunc: o, getInitialIndexFunc: a, getValueFunc: l, getInitialValueFunc: c } = this.columnExtractors;
    (this.colModel.getColDefCols() || []).forEach((p) => {
      const g = t.indexOf(p) < 0, f = p.getColDef(), m = l(f), C = c(f), w = o(f), y = a(f);
      let b;
      m !== void 0 ? b = m : w !== void 0 ? w === null ? b = !1 : b = w >= 0 : g ? C !== void 0 ? b = C : y !== void 0 ? b = y != null && y >= 0 : b = !1 : b = s.indexOf(p) >= 0, b && ((g ? w != null || y != null : w != null) ? i.push(p) : r.push(p));
    });
    const u = (p) => {
      const g = o(p.getColDef()), f = a(p.getColDef());
      return g ?? f;
    };
    i.sort((p, g) => {
      const f = u(p), m = u(g);
      return f === m ? 0 : f < m ? -1 : 1;
    });
    const h = [].concat(i);
    return s.forEach((p) => {
      r.indexOf(p) >= 0 && h.push(p);
    }), r.forEach((p) => {
      h.indexOf(p) < 0 && h.push(p);
    }), s.forEach((p) => {
      h.indexOf(p) < 0 && n(p, !1, e);
    }), h.forEach((p) => {
      s.indexOf(p) < 0 && n(p, !0, e);
    }), this.columns = h;
  }
  restoreColumnOrder(e, t) {
    const s = this.columns, i = this.colModel.getColDefCols();
    if (!s.length || !i)
      return e;
    const r = Object.keys(t), n = new Set(r), o = new Set(r), a = new Set(
      s.map((y) => {
        const b = y.getColId();
        return o.delete(b), b;
      }).concat(r)
    ), l = [], c = {};
    let d = 0;
    for (let y = 0; y < i.length; y++) {
      const b = i[y].getColId();
      a.has(b) && (l.push(b), c[b] = d++);
    }
    let u = 1e3, h = !1, p = 0;
    const g = this.columnOrdering.enableProp, f = this.columnOrdering.initialEnableProp, m = this.columnOrdering.indexProp, C = this.columnOrdering.initialIndexProp, w = (y) => {
      const b = c[y];
      for (let x = p; x < b; x++) {
        const M = l[x];
        o.has(M) && (t[M][m] = u++, o.delete(M));
      }
      p = b;
    };
    return s.forEach((y) => {
      const b = y.getColId();
      if (n.has(b))
        w(b), t[b][m] = u++;
      else {
        const x = y.getColDef();
        (x[m] === null || x[m] === void 0 && x[C] == null) && (h || (x[g] || x[g] === void 0 && x[f] ? w(b) : (o.forEach((F) => {
          t[F][m] = u + c[F];
        }), u += l.length, h = !0)), e[b] || (e[b] = { colId: b }), e[b][m] = u++);
      }
    }), e;
  }
}, Yv = class {
  constructor() {
    this.existingIds = {};
  }
  getInstanceIdForKey(e) {
    const t = this.existingIds[e];
    let s;
    return typeof t != "number" ? s = 0 : s = t + 1, this.existingIds[e] = s, s;
  }
}, no = class extends L {
};
function pa(e, t, s) {
  return s && e.addDestroyFunc(() => t.destroyBean(s)), s ?? e;
}
var ga = class {
  constructor(e) {
    this.cssClassStates = {}, this.getGui = e;
  }
  addCssClass(e) {
    this.addOrRemoveCssClass(e, !0);
  }
  removeCssClass(e) {
    this.addOrRemoveCssClass(e, !1);
  }
  containsCssClass(e) {
    const t = this.getGui();
    return t ? t.classList.contains(e) : !1;
  }
  addOrRemoveCssClass(e, t) {
    if (!e)
      return;
    if (e.indexOf(" ") >= 0) {
      const i = (e || "").split(" ");
      if (i.length > 1) {
        i.forEach((r) => this.addOrRemoveCssClass(r, t));
        return;
      }
    }
    if (this.cssClassStates[e] !== t && e.length) {
      const i = this.getGui();
      i && i.classList.toggle(e, t), this.cssClassStates[e] = t;
    }
  }
}, yT = 0, E = null, _ = class extends L {
  constructor(e, t) {
    super(), this.suppressDataRefValidation = !1, this.displayed = !0, this.visible = !0, this.compId = yT++, this.cssClassManager = new ga(() => this.eGui), this.componentSelectors = new Map((t ?? []).map((s) => [s.selector, s])), e && this.setTemplate(e);
  }
  preConstruct() {
    var t, s, i;
    this.wireTemplate(this.getGui());
    const e = "component-" + ((s = (t = Object.getPrototypeOf(this)) == null ? void 0 : t.constructor) == null ? void 0 : s.name);
    (i = this.css) == null || i.forEach((r) => this.beans.environment.addGlobalCSS(r, e));
  }
  wireTemplate(e, t) {
    e && this.gos && (this.applyElementsToComponent(e), this.createChildComponentsFromTags(e, t));
  }
  getCompId() {
    return this.compId;
  }
  getDataRefAttribute(e) {
    return e.getAttribute ? e.getAttribute("data-ref") : null;
  }
  applyElementsToComponent(e, t, s, i = null) {
    if (t === void 0 && (t = this.getDataRefAttribute(e)), t) {
      const r = this[t];
      if (r === E)
        this[t] = i ?? e;
      else {
        const n = s && s[t];
        if (!this.suppressDataRefValidation && !n)
          throw new Error(`data-ref: ${t} on ${this.constructor.name} with ${r}`);
      }
    }
  }
  // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
  createChildComponentsFromTags(e, t) {
    IP(e.childNodes).forEach((i) => {
      if (!(i instanceof HTMLElement))
        return;
      const r = this.createComponentFromElement(
        i,
        (n) => {
          n.getGui() && this.copyAttributesFromNode(i, n.getGui());
        },
        t
      );
      if (r) {
        if (r.addItems && i.children.length) {
          this.createChildComponentsFromTags(i, t);
          const n = Array.prototype.slice.call(i.children);
          r.addItems(n);
        }
        this.swapComponentForNode(r, e, i);
      } else i.childNodes && this.createChildComponentsFromTags(i, t);
    });
  }
  createComponentFromElement(e, t, s) {
    const i = e.nodeName, r = this.getDataRefAttribute(e), n = i.indexOf("AG-") === 0, o = n ? this.componentSelectors.get(i) : null;
    let a = null;
    if (o) {
      const l = s && r ? s[r] : void 0;
      a = new o.component(l), a.setParentComponent(this), this.createBean(a, null, t);
    } else if (n)
      throw new Error(`selector: ${i}`);
    return this.applyElementsToComponent(e, r, s, a), a;
  }
  copyAttributesFromNode(e, t) {
    LP(e.attributes, (s, i) => t.setAttribute(s, i));
  }
  swapComponentForNode(e, t, s) {
    const i = e.getGui();
    t.replaceChild(i, s), t.insertBefore(document.createComment(s.nodeName), i), this.addDestroyFunc(this.destroyBean.bind(this, e));
  }
  activateTabIndex(e) {
    const t = this.gos.get("tabIndex");
    e || (e = []), e.length || e.push(this.getGui()), e.forEach((s) => s.setAttribute("tabindex", t.toString()));
  }
  setTemplate(e, t, s) {
    const i = ss(e);
    this.setTemplateFromElement(i, t, s);
  }
  setTemplateFromElement(e, t, s, i = !1) {
    if (this.eGui = e, this.suppressDataRefValidation = i, t)
      for (let r = 0; r < t.length; r++) {
        const n = t[r];
        this.componentSelectors.set(n.selector, n);
      }
    this.wireTemplate(e, s);
  }
  getGui() {
    return this.eGui;
  }
  getFocusableElement() {
    return this.eGui;
  }
  getAriaElement() {
    return this.getFocusableElement();
  }
  setParentComponent(e) {
    this.parentComponent = e;
  }
  getParentComponent() {
    return this.parentComponent;
  }
  // this method is for older code, that wants to provide the gui element,
  // it is not intended for this to be in ag-Stack
  setGui(e) {
    this.eGui = e;
  }
  queryForHtmlElement(e) {
    return this.eGui.querySelector(e);
  }
  getContainerAndElement(e, t) {
    let s = t;
    return e == null ? null : (s || (s = this.eGui), ac(e) ? {
      element: e,
      parent: s
    } : {
      element: e.getGui(),
      parent: s
    });
  }
  prependChild(e, t) {
    const { element: s, parent: i } = this.getContainerAndElement(e, t) || {};
    !s || !i || i.insertAdjacentElement("afterbegin", s);
  }
  appendChild(e, t) {
    const { element: s, parent: i } = this.getContainerAndElement(e, t) || {};
    !s || !i || i.appendChild(s);
  }
  isDisplayed() {
    return this.displayed;
  }
  setVisible(e, t = {}) {
    if (e !== this.visible) {
      this.visible = e;
      const { skipAriaHidden: s } = t;
      iv(this.eGui, e, { skipAriaHidden: s });
    }
  }
  setDisplayed(e, t = {}) {
    if (e !== this.displayed) {
      this.displayed = e;
      const { skipAriaHidden: s } = t;
      re(this.eGui, e, { skipAriaHidden: s });
      const i = {
        type: "displayChanged",
        visible: this.displayed
      };
      this.dispatchLocalEvent(i);
    }
  }
  destroy() {
    this.parentComponent && (this.parentComponent = void 0), super.destroy();
  }
  addGuiEventListener(e, t, s) {
    this.eGui.addEventListener(e, t, s), this.addDestroyFunc(() => this.eGui.removeEventListener(e, t));
  }
  addCssClass(e) {
    this.cssClassManager.addCssClass(e);
  }
  removeCssClass(e) {
    this.cssClassManager.removeCssClass(e);
  }
  containsCssClass(e) {
    return this.cssClassManager.containsCssClass(e);
  }
  addOrRemoveCssClass(e, t) {
    this.cssClassManager.addOrRemoveCssClass(e, t);
  }
  registerCSS(e) {
    this.css || (this.css = []), this.css.push(e);
  }
};
function bT(e) {
  return typeof e.then == "function";
}
var fe = class No {
  constructor(t) {
    this.status = 0, this.resolution = null, this.waiters = [], t(
      (s) => this.onDone(s),
      (s) => this.onReject(s)
    );
  }
  static all(t) {
    return t.length ? new No((s) => {
      let i = t.length;
      const r = new Array(i);
      t.forEach((n, o) => {
        n.then((a) => {
          r[o] = a, i--, i === 0 && s(r);
        });
      });
    }) : No.resolve();
  }
  static resolve(t = null) {
    return new No((s) => s(t));
  }
  then(t) {
    return new No((s) => {
      this.status === 1 ? s(t(this.resolution)) : this.waiters.push((i) => s(t(i)));
    });
  }
  onDone(t) {
    this.status = 1, this.resolution = t, this.waiters.forEach((s) => s(t));
  }
  onReject(t) {
  }
};
function ST(e) {
  return e ? e.prototype && "getGui" in e.prototype : !1;
}
function Xv(e, t, s, i) {
  const { name: r } = s;
  let n, o, a, l, c, d;
  if (t) {
    const u = t, h = u[r + "Selector"], p = h ? h(i) : null, g = (f) => {
      typeof f == "string" ? n = f : f != null && f !== !0 && (e.isFrameworkComponent(f) ? a = f : o = f);
    };
    p ? (g(p.component), l = p.params, c = p.popup, d = p.popupPosition) : g(u[r]);
  }
  return { compName: n, jsComp: o, fwComp: a, paramsFromSelector: l, popupFromSelector: c, popupPositionFromSelector: d };
}
var xT = class extends L {
  constructor() {
    super(...arguments), this.beanName = "userCompFactory";
  }
  wireBeans(e) {
    this.agCompUtils = e.agCompUtils, this.registry = e.registry, this.frameworkCompWrapper = e.frameworkCompWrapper, this.gridOptions = e.gridOptions;
  }
  getCompDetailsFromGridOptions(e, t, s, i = !1) {
    return this.getCompDetails(this.gridOptions, e, t, s, i);
  }
  getCompDetails(e, t, s, i, r = !1) {
    var w;
    const { name: n, cellRenderer: o } = t;
    let { compName: a, jsComp: l, fwComp: c, paramsFromSelector: d, popupFromSelector: u, popupPositionFromSelector: h } = Xv(this.beans.frameworkOverrides, e, t, i), p;
    const g = (y) => {
      const b = this.registry.getUserComponent(n, y);
      b && (l = b.componentFromFramework ? void 0 : b.component, c = b.componentFromFramework ? b.component : void 0, p = b.params);
    };
    if (a != null && g(a), l == null && c == null && s != null && g(s), l && o && !ST(l) && (l = (w = this.agCompUtils) == null ? void 0 : w.adaptFunction(t, l)), !l && !c) {
      const { validation: y } = this.beans;
      r && (a !== s || !s) ? a ? y != null && y.isProvidedUserComp(a) || be(50, { compName: a }) : s ? y || be(260, {
        ...this.gos.getModuleErrorParams(),
        propName: n,
        compName: s
      }) : be(216, { name: n }) : s && !y && be(146, { comp: s });
      return;
    }
    const f = this.mergeParams(e, t, i, d, p), m = l == null, C = l ?? c;
    return {
      componentFromFramework: m,
      componentClass: C,
      params: f,
      type: t,
      popupFromSelector: u,
      popupPositionFromSelector: h,
      newAgStackInstance: () => this.newAgStackInstance(C, m, f, t)
    };
  }
  newAgStackInstance(e, t, s, i) {
    var a;
    const r = !t;
    let n;
    r ? n = new e() : n = this.frameworkCompWrapper.wrap(
      e,
      i.mandatoryMethods,
      i.optionalMethods,
      i
    ), this.createBean(n);
    const o = (a = n.init) == null ? void 0 : a.call(n, s);
    return o == null ? fe.resolve(n) : o.then(() => n);
  }
  /**
   * merges params with application provided params
   * used by Floating Filter
   */
  mergeParams(e, t, s, i = null, r) {
    const n = this.gos.getGridCommonParams();
    bt(n, s), r && bt(n, r);
    const o = e, a = o && o[t.name + "Params"];
    if (typeof a == "function") {
      const l = a(s);
      bt(n, l);
    } else typeof a == "object" && bt(n, a);
    return bt(n, i), n;
  }
}, RT = {
  name: "dateComponent",
  mandatoryMethods: ["getDate", "setDate"],
  optionalMethods: ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel", "setDisabled", "refresh"]
}, FT = {
  name: "dragAndDropImageComponent",
  mandatoryMethods: ["setIcon", "setLabel"]
}, PT = { name: "headerComponent", optionalMethods: ["refresh"] }, TT = { name: "innerHeaderComponent" }, ET = { name: "innerHeaderGroupComponent" }, DT = { name: "headerGroupComponent" }, AT = {
  name: "innerRenderer",
  cellRenderer: !0,
  optionalMethods: ["afterGuiAttached"]
}, MT = {
  name: "cellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"],
  cellRenderer: !0
}, IT = {
  name: "cellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"]
}, LT = { name: "loadingCellRenderer", cellRenderer: !0 }, kT = {
  name: "cellEditor",
  mandatoryMethods: ["getValue"],
  optionalMethods: [
    "isPopup",
    "isCancelBeforeStart",
    "isCancelAfterEnd",
    "getPopupPosition",
    "focusIn",
    "focusOut",
    "afterGuiAttached",
    "refresh"
  ]
}, OT = { name: "loadingOverlayComponent", optionalMethods: ["refresh"] }, GT = { name: "noRowsOverlayComponent", optionalMethods: ["refresh"] }, BT = { name: "tooltipComponent" }, fh = {
  name: "filter",
  mandatoryMethods: ["isFilterActive", "doesFilterPass", "getModel", "setModel"],
  optionalMethods: [
    "afterGuiAttached",
    "afterGuiDetached",
    "onNewRowsLoaded",
    "getModelAsString",
    "onFloatingFilterChanged",
    "onAnyFilterChanged",
    "refresh"
  ]
}, VT = {
  name: "floatingFilterComponent",
  mandatoryMethods: ["onParentModelChanged"],
  optionalMethods: ["afterGuiAttached", "refresh"]
}, NT = {
  name: "fullWidthCellRenderer",
  optionalMethods: ["refresh", "afterGuiAttached"],
  cellRenderer: !0
}, HT = { name: "loadingCellRenderer", cellRenderer: !0 }, zT = {
  name: "groupRowRenderer",
  optionalMethods: ["afterGuiAttached"],
  cellRenderer: !0
}, WT = { name: "detailCellRenderer", optionalMethods: ["refresh"], cellRenderer: !0 };
function _T(e, t) {
  return e.getCompDetailsFromGridOptions(FT, "agDragAndDropImage", t, !0);
}
function fd(e, t, s) {
  return e.getCompDetails(t, AT, void 0, s);
}
function UT(e, t, s) {
  return e.getCompDetails(t, PT, "agColumnHeader", s);
}
function $T(e, t, s) {
  return e.getCompDetails(t, TT, void 0, s);
}
function jT(e, t) {
  const s = t.columnGroup.getColGroupDef();
  return e.getCompDetails(s, DT, "agColumnGroupHeader", t);
}
function KT(e, t, s) {
  return e.getCompDetails(t, ET, void 0, s);
}
function qT(e, t) {
  return e.getCompDetailsFromGridOptions(NT, void 0, t, !0);
}
function YT(e, t) {
  return e.getCompDetailsFromGridOptions(HT, "agLoadingCellRenderer", t, !0);
}
function XT(e, t) {
  return e.getCompDetailsFromGridOptions(zT, "agGroupRowRenderer", t, !0);
}
function ZT(e, t) {
  return e.getCompDetailsFromGridOptions(WT, "agDetailCellRenderer", t, !0);
}
function Ml(e, t, s) {
  return e.getCompDetails(t, MT, void 0, s);
}
function Zv(e, t, s) {
  return e.getCompDetails(
    t,
    IT,
    void 0,
    s
  );
}
function QT(e, t, s) {
  return e.getCompDetails(t, LT, "agSkeletonCellRenderer", s, !0);
}
function Kg(e, t, s) {
  return e.getCompDetails(t, kT, "agCellEditor", s, !0);
}
function Qv(e, t, s, i) {
  return e.getCompDetails(t, fh, i, s, !0);
}
function JT(e, t) {
  return e.getCompDetailsFromGridOptions(RT, "agDateInput", t, !0);
}
function eE(e, t) {
  return e.getCompDetailsFromGridOptions(OT, "agLoadingOverlay", t, !0);
}
function tE(e, t) {
  return e.getCompDetailsFromGridOptions(GT, "agNoRowsOverlay", t, !0);
}
function sE(e, t) {
  return e.getCompDetails(t.colDef, BT, "agTooltipComponent", t, !0);
}
function Jv(e, t, s, i) {
  return e.getCompDetails(t, VT, i, s);
}
function iE(e, t) {
  return Xv(e, t, fh);
}
function rE(e, t, s) {
  return e.mergeParams(t, fh, s);
}
function Cn(e) {
  const t = e;
  return t != null && t.getFrameworkComponentInstance != null ? t.getFrameworkComponentInstance() : e;
}
var ew = /* @__PURE__ */ new Set(), Il = {}, dn = {}, ll, tw = !1;
function nE(e) {
  const [t, s] = e.version.split(".") || [], [i, r] = ll.split(".") || [];
  return t === i && s === r;
}
function oE(e) {
  ll || (ll = e.version);
  const t = (s) => `You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. ${s} Please update all modules to the same version.`;
  if (e.version ? nE(e) || zn(
    t(
      `'${e.moduleName}' is version ${e.version} but the other modules are version ${ll}.`
    )
  ) : zn(t(`'${e.moduleName}' is incompatible.`)), e.validate) {
    const s = e.validate();
    s.isValid || zn(`${s.message}`);
  }
}
function na(e, t) {
  oE(e);
  const s = e.rowModels ?? ["all"];
  ew.add(e);
  let i;
  t !== void 0 ? (tw = !0, dn[t] === void 0 && (dn[t] = {}), i = dn[t]) : i = Il, s.forEach((r) => {
    i[r] === void 0 && (i[r] = {}), i[r][e.moduleName] = e;
  }), e.dependsOn && e.dependsOn.forEach((r) => na(r, t));
}
function aE(e) {
  delete dn[e];
}
function sw(e, t, s) {
  const i = (r) => {
    var n, o, a;
    return !!((n = Il[r]) != null && n[e]) || !!((a = (o = dn[t]) == null ? void 0 : o[r]) != null && a[e]);
  };
  return i(s) || i("all");
}
function mh() {
  return tw;
}
function lE(e, t) {
  const s = dn[e] ?? {};
  return [
    ...Object.values(Il.all ?? {}),
    ...Object.values(s.all ?? {}),
    ...Object.values(Il[t] ?? {}),
    ...Object.values(s[t] ?? {})
  ];
}
function cE() {
  return new Set(ew);
}
function iw(e, t) {
  const s = dn[e] ?? {};
  return [...Object.values(s.all ?? {}), ...Object.values(s[t] ?? {})];
}
var dE = class {
  /**
   * @deprecated v33 Use `registerModules([module])` instead.
   */
  static register(e) {
    na(e, void 0);
  }
  /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */
  static registerModules(e) {
    e.forEach((t) => na(t, void 0));
  }
}, uE = class {
  constructor(e) {
    this.beans = {}, this.createdBeans = [], this.destroyed = !1, !(!e || !e.beanClasses) && (this.beanDestroyComparator = e.beanDestroyComparator, this.init(e));
  }
  init(e) {
    var t;
    Object.entries(e.providedBeanInstances).forEach(([s, i]) => {
      this.beans[s] = i;
    }), e.beanClasses.forEach((s) => {
      const i = new s();
      i.beanName ? this.beans[i.beanName] = i : console.error(`Bean ${s.name} is missing beanName`), this.createdBeans.push(i);
    }), (t = e.derivedBeans) == null || t.forEach((s) => {
      const { beanName: i, bean: r } = s(this);
      this.beans[i] = r, this.createdBeans.push(r);
    }), e.beanInitComparator && this.createdBeans.sort(e.beanInitComparator), this.initBeans(this.createdBeans);
  }
  getBeanInstances() {
    return Object.values(this.beans);
  }
  createBean(e, t) {
    if (!e)
      throw Error("null bean");
    return this.initBeans([e], t), e;
  }
  initBeans(e, t) {
    e.forEach((s) => {
      var i, r;
      (i = s.preWireBeans) == null || i.call(s, this.beans), (r = s.wireBeans) == null || r.call(s, this.beans);
    }), e.forEach((s) => {
      var i;
      return (i = s.preConstruct) == null ? void 0 : i.call(s);
    }), t && e.forEach(t), e.forEach((s) => {
      var i;
      return (i = s.postConstruct) == null ? void 0 : i.call(s);
    });
  }
  getBeans() {
    return this.beans;
  }
  getBean(e) {
    return this.beans[e];
  }
  destroy() {
    if (this.destroyed)
      return;
    this.destroyed = !0;
    const e = this.getBeanInstances();
    this.beanDestroyComparator && e.sort(this.beanDestroyComparator), this.destroyBeans(e), this.beans = {}, this.createdBeans = [];
  }
  /**
   * Destroys a bean and returns undefined to support destruction and clean up in a single line.
   * this.dateComp = this.context.destroyBean(this.dateComp);
   */
  destroyBean(e) {
    var t;
    (t = e == null ? void 0 : e.destroy) == null || t.call(e);
  }
  /**
   * Destroys an array of beans and returns an empty array to support destruction and clean up in a single line.
   * this.dateComps = this.context.destroyBeans(this.dateComps);
   */
  destroyBeans(e) {
    if (e)
      for (let t = 0; t < e.length; t++)
        this.destroyBean(e[t]);
    return [];
  }
  isDestroyed() {
    return this.destroyed;
  }
}, hE = class extends uE {
  init(e) {
    this.gridId = e.gridId, this.beans.context = this, this.destroyCallback = e.destroyCallback, super.init(e);
  }
  destroy() {
    var e;
    super.destroy(), aE(this.gridId), (e = this.destroyCallback) == null || e.call(this);
  }
  getGridId() {
    return this.gridId;
  }
}, pE = "ag-column-first", gE = "ag-column-last";
function Ch(e, t, s, i) {
  return ke(e) ? [] : ow(e.headerClass, e, t, s, i);
}
function rw(e, t, s, i) {
  return ke(e) ? [] : ow(e.toolPanelClass, e, t, s, i);
}
function nw(e, t, s) {
  e.addOrRemoveCssClass(pE, s.isColAtEdge(t, "first")), e.addOrRemoveCssClass(gE, s.isColAtEdge(t, "last"));
}
function fE(e, t, s, i) {
  return t.addGridCommonParams({
    // bad naming, as colDef here can be a group or a column,
    // however most people won't appreciate the difference,
    // so keeping it as colDef to avoid confusion.
    colDef: e,
    column: s,
    columnGroup: i
  });
}
function ow(e, t, s, i, r) {
  if (ke(e))
    return [];
  let n;
  if (typeof e == "function") {
    const o = fE(t, s, i, r);
    n = e(o);
  } else
    n = e;
  return typeof n == "string" ? [n] : Array.isArray(n) ? [...n] : [];
}
function _s(e, t) {
  const s = wv(e);
  s.requestAnimationFrame ? s.requestAnimationFrame(t) : s.webkitRequestAnimationFrame ? s.webkitRequestAnimationFrame(t) : s.setTimeout(t, 0);
}
var mE = class extends L {
  constructor() {
    super(...arguments), this.beanName = "animationFrameSvc", this.createTasksP1 = { list: [], sorted: !1 }, this.createTasksP2 = { list: [], sorted: !1 }, this.destroyTasks = [], this.ticking = !1, this.scrollGoingDown = !0, this.lastPage = 0, this.lastScrollTop = 0, this.taskCount = 0, this.cancelledTasks = /* @__PURE__ */ new Set();
  }
  setScrollTop(e) {
    const { gos: t, pagination: s } = this.beans, i = t.get("pagination");
    if (this.scrollGoingDown = e >= this.lastScrollTop, i && e === 0) {
      const r = (s == null ? void 0 : s.getCurrentPage()) ?? 0;
      r !== this.lastPage && (this.lastPage = r, this.scrollGoingDown = !0);
    }
    this.lastScrollTop = e;
  }
  postConstruct() {
    this.active = !this.gos.get("suppressAnimationFrame");
  }
  // this method is for our AG Grid sanity only - if animation frames are turned off,
  // then no place in the code should be looking to add any work to be done in animation
  // frames. this stops bugs - where some code is asking for a frame to be executed
  // when it should not.
  verifyAnimationFrameOn(e) {
    this.active === !1 && I(92, { methodName: e });
  }
  createTask(e, t, s) {
    this.verifyAnimationFrameOn(s);
    const i = { task: e, index: t, createOrder: ++this.taskCount };
    this.addTaskToList(this[s], i), this.schedule();
  }
  cancelTask(e) {
    this.cancelledTasks.add(e);
  }
  addTaskToList(e, t) {
    e.list.push(t), e.sorted = !1;
  }
  sortTaskList(e) {
    if (e.sorted)
      return;
    const t = this.scrollGoingDown ? 1 : -1;
    e.list.sort(
      (s, i) => s.index !== i.index ? t * (i.index - s.index) : i.createOrder - s.createOrder
    ), e.sorted = !0;
  }
  addDestroyTask(e) {
    this.verifyAnimationFrameOn("createTasksP3"), this.destroyTasks.push(e), this.schedule();
  }
  executeFrame(e) {
    this.verifyAnimationFrameOn("executeFrame");
    const t = this.createTasksP1, s = t.list, i = this.createTasksP2, r = i.list, n = this.destroyTasks, o = (/* @__PURE__ */ new Date()).getTime();
    let a = (/* @__PURE__ */ new Date()).getTime() - o;
    const l = e <= 0, c = this.beans.ctrlsSvc.getScrollFeature();
    for (; l || a < e; ) {
      if (!c.scrollGridIfNeeded()) {
        let u;
        if (s.length)
          this.sortTaskList(t), u = s.pop().task;
        else if (r.length)
          this.sortTaskList(i), u = r.pop().task;
        else if (n.length)
          u = n.pop();
        else {
          this.cancelledTasks.clear();
          break;
        }
        this.cancelledTasks.has(u) || u();
      }
      a = (/* @__PURE__ */ new Date()).getTime() - o;
    }
    s.length || r.length || n.length ? this.requestFrame() : this.ticking = !1;
  }
  flushAllFrames() {
    this.active && this.executeFrame(-1);
  }
  schedule() {
    this.active && (this.ticking || (this.ticking = !0, this.requestFrame()));
  }
  requestFrame() {
    const e = this.executeFrame.bind(this, 60);
    _s(this.beans, e);
  }
  isQueueEmpty() {
    return !this.ticking;
  }
}, P = {
  BACKSPACE: "Backspace",
  TAB: "Tab",
  ENTER: "Enter",
  ESCAPE: "Escape",
  SPACE: " ",
  LEFT: "ArrowLeft",
  UP: "ArrowUp",
  RIGHT: "ArrowRight",
  DOWN: "ArrowDown",
  DELETE: "Delete",
  F2: "F2",
  PAGE_UP: "PageUp",
  PAGE_DOWN: "PageDown",
  PAGE_HOME: "Home",
  PAGE_END: "End",
  // these should be used with `event.code` instead of `event.key`
  // as `event.key` changes when non-latin keyboards are used
  A: "KeyA",
  C: "KeyC",
  D: "KeyD",
  V: "KeyV",
  X: "KeyX",
  Y: "KeyY",
  Z: "KeyZ"
}, lu = !1, Ll = 0;
function CE(e) {
  Ll > 0 || (e.addEventListener("keydown", kl), e.addEventListener("mousedown", kl));
}
function vE(e) {
  Ll > 0 || (e.removeEventListener("keydown", kl), e.removeEventListener("mousedown", kl));
}
function kl(e) {
  const t = lu, s = e.type === "keydown";
  s && (e.ctrlKey || e.metaKey || e.altKey) || t !== s && (lu = s);
}
function wE(e) {
  const t = We(e);
  return CE(t), Ll++, () => {
    Ll--, vE(t);
  };
}
function gc() {
  return lu;
}
function aw(e, t, s) {
  t.addManagedElementListeners(s, {
    keydown: (i) => {
      if (!i.defaultPrevented && i.key === P.TAB) {
        const r = i.shiftKey;
        zt(e, s, !1, r) || Ui(e, r) && i.preventDefault();
      }
    }
  });
}
function ii(e, t, s = !1) {
  const i = TP;
  let r = sv;
  t && (r += ", " + t), s && (r += ', [tabindex="-1"]');
  const n = Array.prototype.slice.apply(e.querySelectorAll(i)).filter((l) => Xt(l)), o = Array.prototype.slice.apply(e.querySelectorAll(r));
  return o.length ? ((l, c) => l.filter((d) => c.indexOf(d) === -1))(n, o) : n;
}
function Dt(e, t = !1, s = !1) {
  const i = ii(e, null, s), r = t ? pe(i) : i[0];
  return r ? (r.focus({ preventScroll: !0 }), !0) : !1;
}
function zt(e, t, s, i) {
  const r = ii(t, s ? ':not([tabindex="-1"])' : null), n = Ie(e);
  let o;
  s ? o = r.findIndex((l) => l.contains(n)) : o = r.indexOf(n);
  const a = o + (i ? -1 : 1);
  return a < 0 || a >= r.length ? null : r[a];
}
function vh(e, t = 5) {
  let s = 0;
  for (; e && tu(e) === null && ++s <= t; )
    e = e.parentElement;
  return tu(e) === null ? null : e;
}
function lw(e, t) {
  return e.ctrlsSvc.get("gridCtrl").focusInnerElement(t);
}
function _n(e) {
  var t;
  return e.gos.get("suppressHeaderFocus") || !!((t = e.overlays) != null && t.isExclusive());
}
function cw(e) {
  var t;
  return e.gos.get("suppressCellFocus") || !!((t = e.overlays) != null && t.isExclusive());
}
function Ui(e, t, s = !1) {
  const i = e.ctrlsSvc.get("gridCtrl");
  return !s && i.focusNextInnerContainer(t) ? !0 : ((s || !t && !i.isDetailGrid()) && i.forceFocusOutOfContainer(t), !1);
}
var yE = /[&<>"']/g, bE = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function Ke(e, t) {
  if (e == null)
    return null;
  const s = e.toString().toString();
  return t ? s : s.replace(yE, (i) => bE[i]);
}
function SE(e, t = !1) {
  return e === P.DELETE ? !0 : !t && e === P.BACKSPACE ? JC() : !1;
}
var xE = class extends L {
  constructor(e, t, s, i) {
    super(), this.cellCtrl = e, this.rowNode = s, this.rowCtrl = i, this.beans = t;
  }
  setComp(e) {
    this.eGui = e;
  }
  onKeyDown(e) {
    const t = e.key;
    switch (t) {
      case P.ENTER:
        this.onEnterKeyDown(e);
        break;
      case P.F2:
        this.onF2KeyDown(e);
        break;
      case P.ESCAPE:
        this.onEscapeKeyDown(e);
        break;
      case P.TAB:
        this.onTabKeyDown(e);
        break;
      case P.BACKSPACE:
      case P.DELETE:
        this.onBackspaceOrDeleteKeyDown(t, e);
        break;
      case P.DOWN:
      case P.UP:
      case P.RIGHT:
      case P.LEFT:
        this.onNavigationKeyDown(e, t);
        break;
    }
  }
  onNavigationKeyDown(e, t) {
    var s;
    this.cellCtrl.editing || (e.shiftKey && this.cellCtrl.isRangeSelectionEnabled() ? this.onShiftRangeSelect(e) : (s = this.beans.navigation) == null || s.navigateToNextCell(e, t, this.cellCtrl.cellPosition, !0), e.preventDefault());
  }
  onShiftRangeSelect(e) {
    const { rangeSvc: t, navigation: s } = this.beans;
    if (!t)
      return;
    const i = t.extendLatestRangeInDirection(e);
    i && (s == null || s.ensureCellVisible(i));
  }
  onTabKeyDown(e) {
    var t;
    (t = this.beans.navigation) == null || t.onTabKeyDown(this.cellCtrl, e);
  }
  onBackspaceOrDeleteKeyDown(e, t) {
    var l;
    const { cellCtrl: s, beans: i, rowNode: r } = this, { gos: n, rangeSvc: o, eventSvc: a } = i;
    if (!s.editing) {
      if (a.dispatchEvent({ type: "keyShortcutChangedCellStart" }), SE(e, n.get("enableCellEditingOnBackspace"))) {
        if (o && is(n))
          o.clearCellRangeCellValues({ dispatchWrapperEvents: !0, wrapperEventSource: "deleteKey" });
        else if (s.isCellEditable()) {
          const { column: c } = s, d = this.beans.valueSvc.getDeleteValue(c, r);
          r.setDataValue(c, d, "cellClear");
        }
      } else
        (l = i.editSvc) == null || l.startRowOrCellEdit(s, e, t);
      a.dispatchEvent({ type: "keyShortcutChangedCellEnd" });
    }
  }
  onEnterKeyDown(e) {
    var i, r;
    const { cellCtrl: t, beans: s } = this;
    if (t.editing || this.rowCtrl.editing)
      t.stopEditingAndFocus(!1, e.shiftKey);
    else if (s.gos.get("enterNavigatesVertically")) {
      const n = e.shiftKey ? P.UP : P.DOWN;
      (i = s.navigation) == null || i.navigateToNextCell(null, n, t.cellPosition, !1);
    } else
      (r = s.editSvc) == null || r.startRowOrCellEdit(t, P.ENTER, e), t.editing && e.preventDefault();
  }
  onF2KeyDown(e) {
    var i;
    const { cellCtrl: t, beans: s } = this;
    t.editing || (i = s.editSvc) == null || i.startRowOrCellEdit(t, P.F2, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onEscapeKeyDown(e) {
    var i;
    const { cellCtrl: t, beans: s } = this;
    t.editing && ((i = s.editSvc) == null || i.stopRowOrCellEdit(t, !0), t.focusCell(!0));
  }
  processCharacter(e) {
    var r;
    if (e.target !== this.eGui || this.cellCtrl.editing)
      return;
    const i = e.key;
    i === P.SPACE ? this.onSpaceKeyDown(e) : (r = this.beans.editSvc) != null && r.startRowOrCellEdit(this.cellCtrl, i, e) && e.preventDefault();
  }
  onSpaceKeyDown(e) {
    var s;
    const { gos: t } = this.beans;
    !this.cellCtrl.editing && Es(t) && ((s = this.beans.selectionSvc) == null || s.handleSelectionEvent(e, this.rowNode, "spaceKey")), e.preventDefault();
  }
  destroy() {
    super.destroy();
  }
}, RE = class extends L {
  constructor(e, t, s) {
    super(), this.cellCtrl = e, this.column = s, this.beans = t;
  }
  onMouseEvent(e, t) {
    if (!Ds(t))
      switch (e) {
        case "click":
          this.onCellClicked(t);
          break;
        case "mousedown":
        case "touchstart":
          this.onMouseDown(t);
          break;
        case "dblclick":
          this.onCellDoubleClicked(t);
          break;
        case "mouseout":
          this.onMouseOut(t);
          break;
        case "mouseover":
          this.onMouseOver(t);
          break;
      }
  }
  onCellClicked(e) {
    var c;
    if ((c = this.beans.touchSvc) != null && c.handleCellDoubleClick(this, e))
      return;
    const { eventSvc: t, rangeSvc: s, gos: i, editSvc: r } = this.beans, n = e.ctrlKey || e.metaKey;
    s && n && s.getCellRangeCount(this.cellCtrl.cellPosition) > 1 && s.intersectLastRange(!0);
    const o = this.cellCtrl.createEvent(e, "cellClicked");
    t.dispatchEvent(o);
    const a = this.column.getColDef();
    a.onCellClicked && window.setTimeout(() => {
      this.beans.frameworkOverrides.wrapOutgoing(() => {
        a.onCellClicked(o);
      });
    }, 0), (i.get("singleClickEdit") || a.singleClickEdit) && !i.get("suppressClickEdit") && !(e.shiftKey && (s == null ? void 0 : s.getCellRanges().length) != 0) && (r == null || r.startRowOrCellEdit(this.cellCtrl));
  }
  onCellDoubleClicked(e) {
    const { column: t, beans: s, cellCtrl: i } = this, { eventSvc: r, frameworkOverrides: n, gos: o, editSvc: a } = s, l = t.getColDef(), c = i.createEvent(e, "cellDoubleClicked");
    r.dispatchEvent(c), typeof l.onCellDoubleClicked == "function" && window.setTimeout(() => {
      n.wrapOutgoing(() => {
        l.onCellDoubleClicked(c);
      });
    }, 0), !o.get("singleClickEdit") && !o.get("suppressClickEdit") && (a == null || a.startRowOrCellEdit(i, null, e));
  }
  onMouseDown(e) {
    const { ctrlKey: t, metaKey: s, shiftKey: i } = e, r = e.target, { cellCtrl: n, beans: o } = this, { eventSvc: a, rangeSvc: l, focusSvc: c, gos: d } = o;
    if (this.isRightClickInExistingRange(e))
      return;
    const u = l && !l.isEmpty(), h = this.containsWidget(r), { cellPosition: p } = n;
    if (!i || !u) {
      const f = d.get("enableCellTextSelection") && e.defaultPrevented, m = (Rn() || f) && !n.editing && !nh(r) && !h;
      n.focusCell(m);
    }
    if (i && u && !c.isCellFocused(p)) {
      e.preventDefault();
      const g = c.getFocusedCell();
      if (g) {
        const { column: f, rowIndex: m, rowPinned: C } = g, w = o.rowRenderer.getRowByPosition({ rowIndex: m, rowPinned: C }), y = w == null ? void 0 : w.getCellCtrl(f);
        y != null && y.editing && y.stopEditing(), c.setFocusedCell({
          column: f,
          rowIndex: m,
          rowPinned: C,
          forceBrowserFocus: !0,
          preventScrollOnBrowserFocus: !0
        });
      }
    }
    if (!h) {
      if (l)
        if (i)
          l.extendLatestRangeToCell(p);
        else {
          const g = t || s;
          l.setRangeToCell(p, g);
        }
      a.dispatchEvent(this.cellCtrl.createEvent(e, "cellMouseDown"));
    }
  }
  isRightClickInExistingRange(e) {
    const { rangeSvc: t } = this.beans;
    if (t) {
      const s = t.isCellInAnyRange(this.cellCtrl.cellPosition), i = e.button === 2 || e.ctrlKey && this.beans.gos.get("allowContextMenuWithControlKey");
      if (s && i)
        return !0;
    }
    return !1;
  }
  containsWidget(e) {
    return an(e, "ag-selection-checkbox", 3) || an(e, "ag-drag-handle", 3);
  }
  onMouseOut(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const { eventSvc: t, colHover: s } = this.beans;
    t.dispatchEvent(this.cellCtrl.createEvent(e, "cellMouseOut")), s == null || s.clearMouseOver();
  }
  onMouseOver(e) {
    if (this.mouseStayingInsideCell(e))
      return;
    const { eventSvc: t, colHover: s } = this.beans;
    t.dispatchEvent(this.cellCtrl.createEvent(e, "cellMouseOver")), s == null || s.setMouseOver([this.column]);
  }
  mouseStayingInsideCell(e) {
    if (!e.target || !e.relatedTarget)
      return !1;
    const { eGui: t } = this.cellCtrl, s = t.contains(e.target), i = t.contains(e.relatedTarget);
    return s && i;
  }
  destroy() {
    super.destroy();
  }
}, FE = class extends L {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.beans = t, this.column = e.column, this.rowNode = e.rowNode;
  }
  setupRowSpan() {
    this.rowSpan = this.column.getRowSpan(this.rowNode), this.addManagedListeners(this.beans.eventSvc, { newColumnsLoaded: () => this.onNewColumnsLoaded() });
  }
  setComp(e) {
    this.eGui = e, this.setupColSpan(), this.setupRowSpan(), this.onLeftChanged(), this.onWidthChanged(), this.applyRowSpan();
  }
  onNewColumnsLoaded() {
    const e = this.column.getRowSpan(this.rowNode);
    this.rowSpan !== e && (this.rowSpan = e, this.applyRowSpan(!0));
  }
  onDisplayColumnsChanged() {
    const e = this.getColSpanningList();
    Ht(this.colsSpanning, e) || (this.colsSpanning = e, this.onWidthChanged(), this.onLeftChanged());
  }
  setupColSpan() {
    this.column.getColDef().colSpan != null && (this.colsSpanning = this.getColSpanningList(), this.addManagedListeners(this.beans.eventSvc, {
      // because we are col spanning, a reorder of the cols can change what cols we are spanning over
      displayedColumnsChanged: this.onDisplayColumnsChanged.bind(this),
      // because we are spanning over multiple cols, we check for width any time any cols width changes.
      // this is expensive - really we should be explicitly checking only the cols we are spanning over
      // instead of every col, however it would be tricky code to track the cols we are spanning over, so
      // because hardly anyone will be using colSpan, am favouring this easier way for more maintainable code.
      displayedColumnsWidthChanged: this.onWidthChanged.bind(this)
    }));
  }
  onWidthChanged() {
    if (!this.eGui)
      return;
    const e = this.getCellWidth();
    this.eGui.style.width = `${e}px`;
  }
  getCellWidth() {
    return this.colsSpanning ? this.colsSpanning.reduce((e, t) => e + t.getActualWidth(), 0) : this.column.getActualWidth();
  }
  getColSpanningList() {
    const { column: e, rowNode: t } = this, s = e.getColSpan(t), i = [];
    if (s === 1)
      i.push(e);
    else {
      let r = e;
      const n = e.getPinned();
      for (let o = 0; r && o < s && (i.push(r), r = this.beans.visibleCols.getColAfter(r), !(!r || ke(r) || n !== r.getPinned())); o++)
        ;
    }
    return i;
  }
  onLeftChanged() {
    if (!this.eGui)
      return;
    const e = this.modifyLeftForPrintLayout(this.getCellLeft());
    this.eGui.style.left = e + "px";
  }
  getCellLeft() {
    let e;
    return this.beans.gos.get("enableRtl") && this.colsSpanning ? e = pe(this.colsSpanning) : e = this.column, e.getLeft();
  }
  modifyLeftForPrintLayout(e) {
    if (!this.cellCtrl.printLayout || this.column.getPinned() === "left")
      return e;
    const { visibleCols: t } = this.beans, s = t.getColsLeftWidth();
    if (this.column.getPinned() === "right") {
      const i = t.bodyWidth;
      return s + i + (e || 0);
    }
    return s + (e || 0);
  }
  applyRowSpan(e) {
    if (this.rowSpan === 1 && !e)
      return;
    const s = vs(this.beans) * this.rowSpan;
    this.eGui.style.height = `${s}px`, this.eGui.style.zIndex = "1";
  }
  // overriding to make public, as we don't dispose this bean via context
  destroy() {
    super.destroy();
  }
}, PE = "ag-cell", TE = "ag-cell-auto-height", EE = "ag-cell-normal-height", DE = "ag-cell-focus", AE = "ag-cell-first-right-pinned", ME = "ag-cell-last-left-pinned", IE = "ag-cell-not-inline-editing", LE = "ag-cell-wrap-text", Ol = "cellCtrl";
function wh(e, t) {
  return Ev(e, t, Ol);
}
var kE = 0, cl = class extends L {
  constructor(e, t, s, i) {
    super(), this.column = e, this.rowNode = t, this.rowCtrl = i, this.rangeFeature = void 0, this.positionFeature = void 0, this.customStyleFeature = void 0, this.tooltipFeature = void 0, this.mouseListener = void 0, this.keyboardListener = void 0, this.suppressRefreshCell = !1, this.onCompAttachedFuncs = [], this.onEditorAttachedFuncs = [], this.beans = s, this.instanceId = e.getId() + "-" + kE++, this.colIdSanitised = Ke(this.column.getId()), this.createCellPosition(), this.updateAndFormatValue(!1);
  }
  shouldRestoreFocus() {
    return this.beans.focusSvc.shouldRestoreFocus(this.cellPosition);
  }
  onFocusOut() {
    this.beans.focusSvc.clearRestoreFocus();
  }
  addFeatures() {
    var i;
    const { beans: e } = this;
    this.positionFeature = new FE(this, e), this.customStyleFeature = (i = e.cellStyles) == null ? void 0 : i.createCellCustomStyleFeature(this, e), this.mouseListener = new RE(this, e, this.column), this.keyboardListener = new xE(this, e, this.rowNode, this.rowCtrl), this.column.isTooltipEnabled() && this.enableTooltipFeature();
    const { rangeSvc: t } = e;
    t && is(e.gos) && (this.rangeFeature = t.createCellRangeFeature(e, this));
  }
  removeFeatures() {
    const e = this.beans.context;
    this.positionFeature = e.destroyBean(this.positionFeature), this.customStyleFeature = e.destroyBean(this.customStyleFeature), this.mouseListener = e.destroyBean(this.mouseListener), this.keyboardListener = e.destroyBean(this.keyboardListener), this.rangeFeature = e.destroyBean(this.rangeFeature), this.disableTooltipFeature();
  }
  enableTooltipFeature(e, t) {
    var s;
    this.tooltipFeature = (s = this.beans.tooltipSvc) == null ? void 0 : s.enableCellTooltipFeature(this, e, t);
  }
  disableTooltipFeature() {
    this.tooltipFeature = this.beans.context.destroyBean(this.tooltipFeature);
  }
  setComp(e, t, s, i, r, n) {
    var o, a, l, c, d;
    this.comp = e, this.eGui = t, this.printLayout = i, n ?? (n = this), this.addDomData(n), this.addFeatures(), n.addDestroyFunc(() => this.removeFeatures()), this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus")), this.onCellFocused(this.focusEventToRestore), this.applyStaticCssClasses(), this.setWrapText(), this.onFirstRightPinnedChanged(), this.onLastLeftPinnedChanged(), this.onColumnHover(), this.setupControlComps(), this.setupAutoHeight(s, n), this.refreshFirstAndLastStyles(), this.refreshAriaColIndex(), (o = this.positionFeature) == null || o.setComp(t), (a = this.customStyleFeature) == null || a.setComp(e), (l = this.tooltipFeature) == null || l.refreshTooltip(), (c = this.keyboardListener) == null || c.setComp(this.eGui), this.rangeFeature && this.rangeFeature.setComp(e, t), r && this.isCellEditable() ? (d = this.beans.editSvc) == null || d.startEditing(this) : this.showValue(), this.onCompAttachedFuncs.length && (this.onCompAttachedFuncs.forEach((u) => u()), this.onCompAttachedFuncs = []);
  }
  setupAutoHeight(e, t) {
    var s;
    this.isAutoHeight = this.column.isAutoHeight(), !(!this.isAutoHeight || !e) && ((s = this.beans.rowAutoHeight) == null || s.setupCellAutoHeight(this, e, t));
  }
  getCellAriaRole() {
    return this.column.getColDef().cellAriaRole ?? "gridcell";
  }
  isCellRenderer() {
    const e = this.column.getColDef();
    return e.cellRenderer != null || e.cellRendererSelector != null;
  }
  getValueToDisplay() {
    return this.valueFormatted ?? this.value;
  }
  showValue(e = !1) {
    var c;
    const { beans: t, column: s, rowNode: i, rangeFeature: r } = this, { userCompFactory: n } = t, o = this.getValueToDisplay();
    let a;
    if (i.stub && ((c = i.groupData) == null ? void 0 : c[s.getId()]) == null) {
      const d = this.createCellRendererParams();
      a = QT(n, s.getColDef(), d);
    } else if (this.isCellRenderer()) {
      const d = this.createCellRendererParams();
      a = Ml(n, s.getColDef(), d);
    }
    this.comp.setRenderDetails(a, o, e), r && _s(t, () => r == null ? void 0 : r.refreshHandle());
  }
  setupControlComps() {
    const e = this.column.getColDef();
    this.includeSelection = this.isIncludeControl(this.isCheckboxSelection(e)), this.includeRowDrag = this.isIncludeControl(e.rowDrag), this.includeDndSource = this.isIncludeControl(e.dndSource), this.comp.setIncludeSelection(this.includeSelection), this.comp.setIncludeDndSource(this.includeDndSource), this.comp.setIncludeRowDrag(this.includeRowDrag);
  }
  isForceWrapper() {
    return this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  isIncludeControl(e) {
    return this.rowNode.rowPinned != null ? !1 : typeof e == "function" || e === !0;
  }
  isCheckboxSelection(e) {
    const { rowSelection: t } = this.beans.gridOptions;
    return e.checkboxSelection || xi(this.column) && t && typeof t != "string" && ln(t);
  }
  refreshShouldDestroy() {
    const e = this.column.getColDef(), t = this.includeSelection != this.isIncludeControl(this.isCheckboxSelection(e)), s = this.includeRowDrag != this.isIncludeControl(e.rowDrag), i = this.includeDndSource != this.isIncludeControl(e.dndSource), r = this.isAutoHeight != this.column.isAutoHeight();
    return t || s || i || r;
  }
  onPopupEditorClosed() {
    this.editing && this.stopEditingAndFocus();
  }
  /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */
  stopEditing(e = !1) {
    var t;
    return ((t = this.beans.editSvc) == null ? void 0 : t.stopEditing(this, e)) ?? !1;
  }
  createCellRendererParams() {
    const {
      value: e,
      valueFormatted: t,
      column: s,
      rowNode: i,
      comp: r,
      eGui: n,
      beans: { valueSvc: o, gos: a }
    } = this;
    return a.addGridCommonParams({
      value: e,
      valueFormatted: t,
      getValue: () => o.getValueForDisplay(s, i),
      setValue: (c) => o.setValue(i, s, c),
      formatValue: this.formatValue.bind(this),
      data: i.data,
      node: i,
      pinned: s.getPinned(),
      colDef: s.getColDef(),
      column: s,
      refreshCell: this.refreshCell.bind(this),
      eGridCell: n,
      eParentOfValue: r.getParentOfValue(),
      registerRowDragger: (c, d, u, h) => this.registerRowDragger(c, d, h),
      setTooltip: (c, d) => {
        var u;
        a.assertModuleRegistered("Tooltip", 3), this.tooltipFeature && this.disableTooltipFeature(), this.enableTooltipFeature(c, d), (u = this.tooltipFeature) == null || u.refreshTooltip();
      }
    });
  }
  onCellChanged(e) {
    e.column === this.column && this.refreshCell({});
  }
  refreshOrDestroyCell(e) {
    var t;
    this.refreshShouldDestroy() ? (t = this.rowCtrl) == null || t.recreateCell(this) : this.refreshCell(e);
  }
  // + stop editing {forceRefresh: true, suppressFlash: true}
  // + event cellChanged {}
  // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
  // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
  // + rowCtrl: api refreshCells() {animate: true/false}
  // + rowRenderer: api softRefreshView() {}
  refreshCell(e) {
    var c, d, u, h, p, g;
    if (this.suppressRefreshCell || this.editing)
      return;
    const t = this.column.getColDef(), s = e != null && !!e.newData, i = e != null && !!e.suppressFlash, r = t.field == null && t.valueGetter == null && t.showRowGroup == null, n = e && e.forceRefresh || r || s, o = !!this.comp, a = this.updateAndFormatValue(o), l = n || a;
    if (o) {
      if (l) {
        this.showValue(s);
        const f = (c = this.beans.filterManager) == null ? void 0 : c.isSuppressFlashingCellsBecauseFiltering();
        !i && !f && t.enableCellChangeFlash && ((d = this.beans.cellFlashSvc) == null || d.flashCell(this)), (u = this.customStyleFeature) == null || u.applyUserStyles(), (h = this.customStyleFeature) == null || h.applyClassesFromColDef();
      }
      (p = this.tooltipFeature) == null || p.refreshTooltip(), (g = this.customStyleFeature) == null || g.applyCellClassRules();
    }
  }
  // cell editors call this, when they want to stop for reasons other
  // than what we pick up on. eg selecting from a dropdown ends editing.
  stopEditingAndFocus(e = !1, t = !1) {
    var s;
    (s = this.beans.editSvc) == null || s.stopEditingAndFocus(this, e, t);
  }
  isCellEditable() {
    return this.column.isCellEditable(this.rowNode);
  }
  formatValue(e) {
    return this.callValueFormatter(e) ?? e;
  }
  callValueFormatter(e) {
    return this.beans.valueSvc.formatValue(this.column, this.rowNode, e);
  }
  updateAndFormatValue(e) {
    const t = this.value, s = this.valueFormatted;
    return this.value = this.beans.valueSvc.getValueForDisplay(this.column, this.rowNode), this.valueFormatted = this.callValueFormatter(this.value), e ? !this.valuesAreEqual(t, this.value) || this.valueFormatted != s : !0;
  }
  valuesAreEqual(e, t) {
    const s = this.column.getColDef();
    return s.equals ? s.equals(e, t) : e === t;
  }
  addDomData(e) {
    const t = this.eGui;
    fn(this.beans.gos, t, Ol, this), e.addDestroyFunc(() => fn(this.beans.gos, t, Ol, null));
  }
  createEvent(e, t) {
    const { rowNode: s, column: i, value: r } = this;
    return this.beans.gos.addGridCommonParams({
      type: t,
      node: s,
      data: s.data,
      value: r,
      column: i,
      colDef: i.getColDef(),
      rowPinned: s.rowPinned,
      event: e,
      rowIndex: s.rowIndex
    });
  }
  processCharacter(e) {
    var t;
    (t = this.keyboardListener) == null || t.processCharacter(e);
  }
  onKeyDown(e) {
    var t;
    (t = this.keyboardListener) == null || t.onKeyDown(e);
  }
  onMouseEvent(e, t) {
    var s;
    (s = this.mouseListener) == null || s.onMouseEvent(e, t);
  }
  getColSpanningList() {
    return this.positionFeature.getColSpanningList();
  }
  onLeftChanged() {
    var e;
    this.comp && ((e = this.positionFeature) == null || e.onLeftChanged());
  }
  onDisplayedColumnsChanged() {
    this.eGui && (this.refreshAriaColIndex(), this.refreshFirstAndLastStyles());
  }
  refreshFirstAndLastStyles() {
    const { comp: e, column: t, beans: s } = this;
    nw(e, t, s.visibleCols);
  }
  refreshAriaColIndex() {
    const e = this.beans.visibleCols.getAriaColIndex(this.column);
    sh(this.eGui, e);
  }
  onWidthChanged() {
    var e;
    return (e = this.positionFeature) == null ? void 0 : e.onWidthChanged();
  }
  getRowPosition() {
    const { rowIndex: e, rowPinned: t } = this.cellPosition;
    return {
      rowIndex: e,
      rowPinned: t
    };
  }
  updateRangeBordersIfRangeCount() {
    var e;
    this.comp && ((e = this.rangeFeature) == null || e.updateRangeBordersIfRangeCount());
  }
  onCellSelectionChanged() {
    var e;
    this.comp && ((e = this.rangeFeature) == null || e.onCellSelectionChanged());
  }
  isRangeSelectionEnabled() {
    return this.rangeFeature != null;
  }
  focusCell(e = !1) {
    this.beans.focusSvc.setFocusedCell({
      rowIndex: this.cellPosition.rowIndex,
      column: this.column,
      rowPinned: this.rowNode.rowPinned,
      forceBrowserFocus: e
    });
  }
  onRowIndexChanged() {
    var e;
    this.createCellPosition(), this.onCellFocused(), (e = this.rangeFeature) == null || e.onCellSelectionChanged();
  }
  onSuppressCellFocusChanged(e) {
    this.eGui && zs(this.eGui, "tabindex", e ? void 0 : -1);
  }
  onFirstRightPinnedChanged() {
    if (!this.comp)
      return;
    const e = this.column.isFirstRightPinned();
    this.comp.addOrRemoveCssClass(AE, e);
  }
  onLastLeftPinnedChanged() {
    if (!this.comp)
      return;
    const e = this.column.isLastLeftPinned();
    this.comp.addOrRemoveCssClass(ME, e);
  }
  onCellFocused(e) {
    var r;
    const { beans: t } = this;
    if (cw(t))
      return;
    const s = t.focusSvc.isCellFocused(this.cellPosition);
    if (!this.comp) {
      s && (e != null && e.forceBrowserFocus) && (this.focusEventToRestore = e);
      return;
    }
    if (this.focusEventToRestore = void 0, this.comp.addOrRemoveCssClass(DE, s), s && e && e.forceBrowserFocus) {
      let n = this.comp.getFocusableElement();
      if (this.editing) {
        const o = ii(n, null, !0);
        o.length && (n = o[0]);
      }
      n.focus({ preventScroll: !!e.preventScrollOnBrowserFocus });
    }
    const i = t.gos.get("editType") === "fullRow";
    !s && !i && this.editing && ((r = t.editSvc) == null || r.stopRowOrCellEdit(this)), s && this.rowCtrl.announceDescription();
  }
  createCellPosition() {
    const { rowIndex: e, rowPinned: t } = this.rowNode;
    this.cellPosition = {
      rowIndex: e,
      rowPinned: St(t),
      column: this.column
    };
  }
  setInlineEditingCss() {
    var e;
    (e = this.beans.editSvc) == null || e.setInlineEditingCss(this.rowCtrl);
  }
  // CSS Classes that only get applied once, they never change
  applyStaticCssClasses() {
    const { comp: e } = this;
    e.addOrRemoveCssClass(PE, !0), e.addOrRemoveCssClass(IE, !0);
    const t = this.column.isAutoHeight() == !0;
    e.addOrRemoveCssClass(TE, t), e.addOrRemoveCssClass(EE, !t);
  }
  onColumnHover() {
    var e;
    (e = this.beans.colHover) == null || e.onCellColumnHover(this.column, this.comp);
  }
  onColDefChanged() {
    var e;
    this.comp && (this.column.isTooltipEnabled() ? (this.disableTooltipFeature(), this.enableTooltipFeature()) : this.disableTooltipFeature(), this.setWrapText(), this.editing ? (e = this.beans.editSvc) == null || e.handleColDefChanged(this) : this.refreshOrDestroyCell({ forceRefresh: !0, suppressFlash: !0 }));
  }
  setWrapText() {
    const e = this.column.getColDef().wrapText == !0;
    this.comp.addOrRemoveCssClass(LE, e);
  }
  dispatchCellContextMenuEvent(e) {
    const t = this.column.getColDef(), s = this.createEvent(e, "cellContextMenu"), { beans: i } = this;
    i.eventSvc.dispatchEvent(s), t.onCellContextMenu && window.setTimeout(() => {
      i.frameworkOverrides.wrapOutgoing(() => {
        t.onCellContextMenu(s);
      });
    }, 0);
  }
  getCellRenderer() {
    var e;
    return ((e = this.comp) == null ? void 0 : e.getCellRenderer()) ?? null;
  }
  destroy() {
    this.onCompAttachedFuncs = [], this.onEditorAttachedFuncs = [], super.destroy();
  }
  createSelectionCheckbox() {
    var t;
    const e = (t = this.beans.selectionSvc) == null ? void 0 : t.createCheckboxSelectionComponent();
    if (e)
      return this.beans.context.createBean(e), e.init({ rowNode: this.rowNode, column: this.column }), e;
  }
  createDndSource() {
    const e = this.beans.registry.createDynamicBean(
      "dndSourceComp",
      !1,
      this.rowNode,
      this.column,
      this.eGui
    );
    return e && this.beans.context.createBean(e), e;
  }
  registerRowDragger(e, t, s) {
    if (this.customRowDragComp) {
      this.customRowDragComp.setDragElement(e, t);
      return;
    }
    const i = this.createRowDragComp(e, t, s);
    i && (this.customRowDragComp = i, this.addDestroyFunc(() => {
      this.beans.context.destroyBean(i), this.customRowDragComp = null;
    }));
  }
  createRowDragComp(e, t, s) {
    var r;
    const i = (r = this.beans.rowDragSvc) == null ? void 0 : r.createRowDragCompForCell(
      this.rowNode,
      this.column,
      () => this.value,
      e,
      t,
      s
    );
    if (i)
      return this.beans.context.createBean(i), i;
  }
  cellEditorAttached() {
    this.onEditorAttachedFuncs.forEach((e) => e()), this.onEditorAttachedFuncs = [];
  }
}, dw = "__ag_grid_instance";
function uw(e, t) {
  t[dw] = e.gridInstanceId;
}
function Gl(e, t) {
  return hw(e, t.target);
}
function hw(e, t) {
  let s = t;
  for (; s; ) {
    const i = s[dw];
    if (W(i))
      return i === e.gridInstanceId;
    s = s.parentElement;
  }
  return !1;
}
function pw(e, t) {
  var s;
  return ((s = wh(e, t.target)) == null ? void 0 : s.cellPosition) ?? null;
}
function Ko(e, t) {
  const s = It(e.gos, "normal"), i = t;
  let r, n;
  if (i.clientX != null || i.clientY != null ? (r = i.clientX, n = i.clientY) : (r = i.x, n = i.y), s) {
    const o = e.ctrlsSvc.getScrollFeature(), a = o.getVScrollPosition(), l = o.getHScrollPosition();
    r += l.left, n += a.top;
  }
  return { x: r, y: n };
}
var ni = /* @__PURE__ */ ((e) => (e[e.ToolPanel = 0] = "ToolPanel", e[e.HeaderCell = 1] = "HeaderCell", e[e.RowDrag = 2] = "RowDrag", e[e.ChartPanel = 3] = "ChartPanel", e[e.AdvancedFilterBuilder = 4] = "AdvancedFilterBuilder", e))(ni || {}), OE = class extends L {
  constructor() {
    super(...arguments), this.beanName = "dragAndDrop", this.dragSourceAndParamsList = [], this.dropTargets = [];
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.dragSvc = e.dragSvc, this.environment = e.environment, this.userCompFactory = e.userCompFactory;
  }
  addDragSource(e, t = !1) {
    const s = {
      eElement: e.eElement,
      dragStartPixels: e.dragStartPixels,
      onDragStart: this.onDragStart.bind(this, e),
      onDragStop: this.onDragStop.bind(this),
      onDragging: this.onDragging.bind(this),
      onDragCancel: this.onDragCancel.bind(this),
      includeTouch: t
    };
    this.dragSourceAndParamsList.push({ params: s, dragSource: e }), this.dragSvc.addDragSource(s);
  }
  getDragAndDropImageComponent() {
    const { dragAndDropImageComp: e } = this;
    return !e || !e.comp ? null : e.comp;
  }
  removeDragSource(e) {
    const { dragSourceAndParamsList: t, dragSvc: s } = this, i = t.find((r) => r.dragSource === e);
    i && (s.removeDragSource(i.params), kt(t, i));
  }
  destroy() {
    const { dragSourceAndParamsList: e, dragSvc: t, dropTargets: s } = this;
    e.forEach((i) => t.removeDragSource(i.params)), e.length = 0, s.length = 0, this.clearDragAndDropProperties(), super.destroy();
  }
  nudge() {
    this.dragging && this.onDragging(this.eventLastTime, !0);
  }
  onDragStart(e, t) {
    var s;
    this.dragging = !0, this.dragSource = e, this.eventLastTime = t, this.dragItem = e.getDragItem(), (s = e.onDragStarted) == null || s.call(e), this.createDragAndDropImageComponent();
  }
  onDragStop(e) {
    var s, i;
    (i = (s = this.dragSource) == null ? void 0 : s.onDragStopped) == null || i.call(s);
    const { lastDropTarget: t } = this;
    if (t != null && t.onDragStop) {
      const r = this.createDropTargetEvent(t, e, null, null, !1);
      t.onDragStop(r);
    }
    this.clearDragAndDropProperties();
  }
  onDragCancel() {
    var s;
    const { dragSource: e, lastDropTarget: t } = this;
    (s = e == null ? void 0 : e.onDragCancelled) == null || s.call(e), t != null && t.onDragCancel && t.onDragCancel(
      this.createDropTargetEvent(t, this.eventLastTime, null, null, !1)
    ), this.clearDragAndDropProperties();
  }
  clearDragAndDropProperties() {
    this.eventLastTime = null, this.dragging = !1, this.lastDropTarget = void 0, this.dragItem = null, this.dragSource = null, this.removeDragAndDropImageComponent();
  }
  onDragging(e, t = !1) {
    var d, u;
    const s = this.getHorizontalDirection(e), i = this.getVerticalDirection(e);
    this.eventLastTime = e, this.positionDragAndDropImageComp(e);
    const r = this.dropTargets.filter((h) => this.isMouseOnDropTarget(e, h)), n = this.findCurrentDropTarget(e, r), { lastDropTarget: o, dragSource: a, dragAndDropImageComp: l, dragItem: c } = this;
    if (n !== o) {
      if (this.leaveLastTargetIfExists(e, s, i, t), o !== null && n === null && ((d = a == null ? void 0 : a.onGridExit) == null || d.call(a, c)), o === null && n !== null && ((u = a == null ? void 0 : a.onGridEnter) == null || u.call(a, c)), this.enterDragTargetIfExists(n, e, s, i, t), n && l) {
        const { comp: h, promise: p } = l;
        h ? h.setIcon(n.getIconName ? n.getIconName() : null, !1) : p.then((g) => {
          g && g.setIcon(n.getIconName ? n.getIconName() : null, !1);
        });
      }
      this.lastDropTarget = n;
    } else if (n && n.onDragging) {
      const h = this.createDropTargetEvent(n, e, s, i, t);
      n.onDragging(h);
    }
  }
  getAllContainersFromDropTarget(e) {
    const t = e.getSecondaryContainers ? e.getSecondaryContainers() : null, s = [[e.getContainer()]];
    return t ? s.concat(t) : s;
  }
  // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
  isMouseOnDropTarget(e, t) {
    const s = this.getAllContainersFromDropTarget(t);
    let i = !1;
    const r = (a, l) => {
      for (const c of l) {
        const { width: d, height: u, left: h, right: p, top: g, bottom: f } = c.getBoundingClientRect();
        if (d === 0 || u === 0)
          return !1;
        const m = a.clientX >= h && a.clientX < p, C = a.clientY >= g && a.clientY < f;
        if (!m || !C)
          return !1;
      }
      return !0;
    };
    for (const a of s)
      if (r(e, a)) {
        i = !0;
        break;
      }
    const { eElement: n, type: o } = this.dragSource;
    return t.targetContainsSource && !t.getContainer().contains(n) ? !1 : i && t.isInterestedIn(o, n);
  }
  findCurrentDropTarget(e, t) {
    const s = t.length;
    if (s === 0)
      return null;
    if (s === 1)
      return t[0];
    const r = Yn(this.beans).elementsFromPoint(e.clientX, e.clientY);
    for (const n of r)
      for (const o of t)
        if (this.getAllContainersFromDropTarget(o).flatMap((l) => l).indexOf(n) !== -1)
          return o;
    return null;
  }
  enterDragTargetIfExists(e, t, s, i, r) {
    if (e && e.onDragEnter) {
      const n = this.createDropTargetEvent(
        e,
        t,
        s,
        i,
        r
      );
      e.onDragEnter(n);
    }
  }
  leaveLastTargetIfExists(e, t, s, i) {
    const { lastDropTarget: r } = this;
    if (!r)
      return;
    if (r.onDragLeave) {
      const o = this.createDropTargetEvent(
        r,
        e,
        t,
        s,
        i
      );
      r.onDragLeave(o);
    }
    const n = this.getDragAndDropImageComponent();
    n && n.setIcon(null, !1);
  }
  addDropTarget(e) {
    this.dropTargets.push(e);
  }
  removeDropTarget(e) {
    this.dropTargets = this.dropTargets.filter((t) => t.getContainer() !== e.getContainer());
  }
  hasExternalDropZones() {
    return this.dropTargets.some((e) => e.external);
  }
  findExternalZone(e) {
    return this.dropTargets.filter((s) => s.external).find((s) => s.getContainer() === e.getContainer()) || null;
  }
  isDropZoneWithinThisGrid(e) {
    const s = this.ctrlsSvc.getGridBodyCtrl().eGridBody, { dropZoneTarget: i } = e;
    return s.contains(i);
  }
  getHorizontalDirection(e) {
    var i;
    const t = (i = this.eventLastTime) == null ? void 0 : i.clientX, s = e.clientX;
    return t === s ? null : t > s ? "left" : "right";
  }
  getVerticalDirection(e) {
    var i;
    const t = (i = this.eventLastTime) == null ? void 0 : i.clientY, s = e.clientY;
    return t === s ? null : t > s ? "up" : "down";
  }
  createDropTargetEvent(e, t, s, i, r) {
    const n = e.getContainer(), o = n.getBoundingClientRect(), { dragItem: a, dragSource: l, gos: c } = this, d = t.clientX - o.left, u = t.clientY - o.top;
    return c.addGridCommonParams({
      event: t,
      x: d,
      y: u,
      vDirection: i,
      hDirection: s,
      dragSource: l,
      fromNudge: r,
      dragItem: a,
      dropZoneTarget: n
    });
  }
  positionDragAndDropImageComp(e) {
    const t = this.getDragAndDropImageComponent();
    t && nu(t.getGui(), e, this.beans);
  }
  removeDragAndDropImageComponent() {
    var t;
    const { dragAndDropImageComp: e } = this;
    if (e) {
      const { comp: s } = e;
      if (s) {
        const i = s.getGui();
        (t = this.dragAndDropImageParent) == null || t.removeChild(i), this.destroyBean(s);
      }
    }
    this.dragAndDropImageComp = null;
  }
  createDragAndDropImageComponent() {
    const { dragSource: e } = this;
    if (!e)
      return;
    const t = _T(this.userCompFactory, {
      dragSource: e
    });
    if (!t)
      return;
    const s = t.newAgStackInstance();
    this.dragAndDropImageComp = {
      promise: s
    }, s.then((i) => {
      !i || !this.isAlive() || (this.processDragAndDropImageComponent(i), this.dragAndDropImageComp.comp = i);
    });
  }
  processDragAndDropImageComponent(e) {
    const { dragSource: t, environment: s } = this;
    if (!t)
      return;
    const i = e.getGui();
    i.style.setProperty("position", "absolute"), i.style.setProperty("z-index", "9999"), uw(this.gos, i), s.applyThemeClasses(i), e.setIcon(null, !1);
    let { dragItemName: r } = t;
    typeof r == "function" && (r = r()), e.setLabel(r || ""), i.style.top = "20px", i.style.left = "20px";
    const n = lc(this.beans);
    this.dragAndDropImageParent = n, n ? n.appendChild(i) : I(54);
  }
  registerGridDropTarget(e, t) {
    const s = {
      getContainer: e,
      isInterestedIn: (i) => i === 1 || i === 0,
      getIconName: () => "notAllowed"
    };
    this.addDropTarget(s), t.addDestroyFunc(() => this.removeDropTarget(s));
  }
}, yh = class {
  constructor(e) {
    this.tickingInterval = null, this.onScrollCallback = null, this.scrollContainer = e.scrollContainer, this.scrollHorizontally = e.scrollAxis.indexOf("x") !== -1, this.scrollVertically = e.scrollAxis.indexOf("y") !== -1, this.scrollByTick = e.scrollByTick != null ? e.scrollByTick : 20, e.onScrollCallback && (this.onScrollCallback = e.onScrollCallback), this.scrollVertically && (this.getVerticalPosition = e.getVerticalPosition, this.setVerticalPosition = e.setVerticalPosition), this.scrollHorizontally && (this.getHorizontalPosition = e.getHorizontalPosition, this.setHorizontalPosition = e.setHorizontalPosition), this.shouldSkipVerticalScroll = e.shouldSkipVerticalScroll || (() => !1), this.shouldSkipHorizontalScroll = e.shouldSkipHorizontalScroll || (() => !1);
  }
  check(e, t = !1) {
    const s = t || this.shouldSkipVerticalScroll();
    if (s && this.shouldSkipHorizontalScroll())
      return;
    const i = this.scrollContainer.getBoundingClientRect(), r = this.scrollByTick;
    this.tickLeft = e.clientX < i.left + r, this.tickRight = e.clientX > i.right - r, this.tickUp = e.clientY < i.top + r && !s, this.tickDown = e.clientY > i.bottom - r && !s, this.tickLeft || this.tickRight || this.tickUp || this.tickDown ? this.ensureTickingStarted() : this.ensureCleared();
  }
  ensureTickingStarted() {
    this.tickingInterval === null && (this.tickingInterval = window.setInterval(this.doTick.bind(this), 100), this.tickCount = 0);
  }
  doTick() {
    this.tickCount++;
    const e = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
    if (this.scrollVertically) {
      const t = this.getVerticalPosition();
      this.tickUp && this.setVerticalPosition(t - e), this.tickDown && this.setVerticalPosition(t + e);
    }
    if (this.scrollHorizontally) {
      const t = this.getHorizontalPosition();
      this.tickLeft && this.setHorizontalPosition(t - e), this.tickRight && this.setHorizontalPosition(t + e);
    }
    this.onScrollCallback && this.onScrollCallback();
  }
  ensureCleared() {
    this.tickingInterval && (window.clearInterval(this.tickingInterval), this.tickingInterval = null);
  }
};
function cr(e) {
  const { rowIndex: t, rowPinned: s, column: i } = e;
  return `${t}.${s ?? "null"}.${i.getId()}`;
}
function Jn(e, t) {
  const s = e.column === t.column, i = e.rowPinned === t.rowPinned, r = e.rowIndex === t.rowIndex;
  return s && i && r;
}
function jt(e, t) {
  switch (e.rowPinned) {
    case "top":
      if (t.rowPinned !== "top")
        return !0;
      break;
    case "bottom":
      if (t.rowPinned !== "bottom")
        return !1;
      break;
    default:
      if (W(t.rowPinned))
        return t.rowPinned !== "top";
      break;
  }
  return e.rowIndex < t.rowIndex;
}
function Pt(e, t) {
  return !e && !t ? !0 : e && !t || !e && t ? !1 : e.rowIndex === t.rowIndex && e.rowPinned == t.rowPinned;
}
function GE(e) {
  let t = 0, s;
  const { pinnedRowModel: i, rowModel: r, pageBounds: n } = e;
  return i != null && i.getPinnedTopRowCount() ? s = "top" : r.getRowCount() ? (s = null, t = n.getFirstRow()) : i != null && i.getPinnedBottomRowCount() && (s = "bottom"), s === void 0 ? null : { rowIndex: t, rowPinned: s };
}
function BE(e) {
  let t, s = null;
  const { pinnedRowModel: i, pageBounds: r } = e, n = i == null ? void 0 : i.getPinnedBottomRowCount(), o = i == null ? void 0 : i.getPinnedTopRowCount();
  return n ? (s = "bottom", t = n - 1) : e.rowModel.getRowCount() ? (s = null, t = r.getLastRow()) : o && (s = "top", t = o - 1), t === void 0 ? null : { rowIndex: t, rowPinned: s };
}
function ri(e, t) {
  var s, i;
  switch (t.rowPinned) {
    case "top":
      return (s = e.pinnedRowModel) == null ? void 0 : s.getPinnedTopRow(t.rowIndex);
    case "bottom":
      return (i = e.pinnedRowModel) == null ? void 0 : i.getPinnedBottomRow(t.rowIndex);
    default:
      return e.rowModel.getRow(t.rowIndex);
  }
}
function yi(e, t) {
  const s = e.rowRenderer.getRowByPosition(t);
  return s ? s.getCellCtrl(t.column) : null;
}
var VE = class extends L {
  constructor(e) {
    super(), this.eContainer = e;
  }
  postConstruct() {
    const { rowModel: e, gos: t, ctrlsSvc: s } = this.beans;
    Ye(t) && (this.clientSideRowModel = e), s.whenReady(this, (i) => {
      const r = i.gridBodyCtrl;
      this.autoScrollService = new yh({
        scrollContainer: r.eBodyViewport,
        scrollAxis: "y",
        getVerticalPosition: () => r.scrollFeature.getVScrollPosition().top,
        setVerticalPosition: (n) => r.scrollFeature.setVerticalScrollPosition(n),
        onScrollCallback: () => {
          this.onDragging(this.lastDraggingEvent);
        }
      });
    });
  }
  getContainer() {
    return this.eContainer;
  }
  isInterestedIn(e) {
    return e === 2;
  }
  getIconName() {
    return this.gos.get("rowDragManaged") && this.shouldPreventRowMove() ? "notAllowed" : "move";
  }
  shouldPreventRowMove() {
    const { rowGroupColsSvc: e, filterManager: t, sortSvc: s } = this.beans;
    return !!(((e == null ? void 0 : e.columns) ?? []).length || (t == null ? void 0 : t.isAnyFilterPresent()) || (s == null ? void 0 : s.isSortActive()));
  }
  getRowNodes(e) {
    var i;
    if (!this.isFromThisGrid(e))
      return e.dragItem.rowNodes || [];
    const t = e.dragItem.rowNode;
    if (this.gos.get("rowDragMultiRow")) {
      const r = [...((i = this.beans.selectionSvc) == null ? void 0 : i.getSelectedNodes()) ?? []].sort((n, o) => n.rowIndex == null || o.rowIndex == null ? 0 : this.getRowIndexNumber(n) - this.getRowIndexNumber(o));
      if (r.indexOf(t) !== -1)
        return r;
    }
    return [t];
  }
  onDragEnter(e) {
    e.dragItem.rowNodes = this.getRowNodes(e), this.dispatchGridEvent("rowDragEnter", e), this.getRowNodes(e).forEach((t) => {
      this.setRowNodeDragging(t, !0);
    }), this.onEnterOrDragging(e);
  }
  onDragging(e) {
    this.onEnterOrDragging(e);
  }
  isFromThisGrid(e) {
    const { dragSourceDomDataKey: t } = e.dragSource;
    return t === this.gos.getDomDataKey();
  }
  onEnterOrDragging(e) {
    this.dispatchGridEvent("rowDragMove", e), this.lastDraggingEvent = e;
    const t = Ko(this.beans, e).y;
    this.gos.get("rowDragManaged") && this.doManagedDrag(e, t), this.autoScrollService.check(e.event);
  }
  doManagedDrag(e, t) {
    const { dragAndDrop: s, gos: i } = this.beans, r = this.isFromThisGrid(e), n = i.get("rowDragManaged"), o = e.dragItem.rowNodes;
    n && this.shouldPreventRowMove() || (i.get("suppressMoveWhenRowDragging") || !r ? s.isDropZoneWithinThisGrid(e) && this.clientSideRowModel.highlightRowAtPixel(o[0], t) : this.moveRows(o, t));
  }
  getRowIndexNumber(e) {
    const t = e.getRowIndexString();
    return parseInt(pe(t.split("-")), 10);
  }
  moveRowAndClearHighlight(e) {
    const t = this.clientSideRowModel, s = t.getLastHighlightedRowNode(), i = s && s.highlighted === "Below", r = Ko(this.beans, e).y, n = e.dragItem.rowNodes;
    let o = i ? 1 : 0;
    if (this.isFromThisGrid(e))
      n.forEach((a) => {
        a.rowTop < r && (o -= 1);
      }), this.moveRows(n, r, o);
    else {
      const a = _i(this.gos);
      let l = t.getRowIndexAtPixel(r) + 1;
      t.getHighlightPosition(r) === "Above" && l--, t.updateRowData({
        add: n.filter(
          (c) => !t.getRowNode(
            (a == null ? void 0 : a({ data: c.data, level: 0, rowPinned: c.rowPinned })) ?? c.data.id
          )
        ).map((c) => c.data),
        addIndex: l
      });
    }
    this.clearRowHighlight();
  }
  clearRowHighlight() {
    this.clientSideRowModel.highlightRowAtPixel(null);
  }
  moveRows(e, t, s = 0) {
    const i = this.beans.focusSvc, r = i.getFocusedCell(), n = r && yi(this.beans, r);
    this.clientSideRowModel.ensureRowsAtPixel(e, t, s) && (n ? n.focusCell() : i.clearFocusedCell());
  }
  addRowDropZone(e) {
    if (!e.getContainer()) {
      I(55);
      return;
    }
    const t = this.beans.dragAndDrop;
    if (t.findExternalZone(e)) {
      I(56);
      return;
    }
    let s = {
      getContainer: e.getContainer
    };
    e.fromGrid ? s = e : (e.onDragEnter && (s.onDragEnter = (r) => {
      e.onDragEnter(this.draggingToRowDragEvent("rowDragEnter", r));
    }), e.onDragLeave && (s.onDragLeave = (r) => {
      e.onDragLeave(this.draggingToRowDragEvent("rowDragLeave", r));
    }), e.onDragging && (s.onDragging = (r) => {
      e.onDragging(this.draggingToRowDragEvent("rowDragMove", r));
    }), e.onDragStop && (s.onDragStop = (r) => {
      e.onDragStop(this.draggingToRowDragEvent("rowDragEnd", r));
    }), e.onDragCancel && (s.onDragCancel = (r) => {
      e.onDragCancel(this.draggingToRowDragEvent("rowDragCancel", r));
    }));
    const i = {
      isInterestedIn: (r) => r === 2,
      getIconName: () => "move",
      external: !0,
      ...s
    };
    t.addDropTarget(i), this.addDestroyFunc(() => t.removeDropTarget(i));
  }
  getRowDropZone(e) {
    const t = this.getContainer.bind(this), s = this.onDragEnter.bind(this), i = this.onDragLeave.bind(this), r = this.onDragging.bind(this), n = this.onDragStop.bind(this), o = this.onDragCancel.bind(this);
    let a;
    return e ? a = {
      getContainer: t,
      onDragEnter: e.onDragEnter ? (l) => {
        s(l), e.onDragEnter(this.draggingToRowDragEvent("rowDragEnter", l));
      } : s,
      onDragLeave: e.onDragLeave ? (l) => {
        i(l), e.onDragLeave(this.draggingToRowDragEvent("rowDragLeave", l));
      } : i,
      onDragging: e.onDragging ? (l) => {
        r(l), e.onDragging(this.draggingToRowDragEvent("rowDragMove", l));
      } : r,
      onDragStop: e.onDragStop ? (l) => {
        n(l), e.onDragStop(this.draggingToRowDragEvent("rowDragEnd", l));
      } : n,
      onDragCancel: e.onDragCancel ? (l) => {
        o(l), e.onDragCancel(this.draggingToRowDragEvent("rowDragCancel", l));
      } : o,
      fromGrid: !0
    } : a = {
      getContainer: t,
      onDragEnter: s,
      onDragLeave: i,
      onDragging: r,
      onDragStop: n,
      onDragCancel: o,
      /* @private */
      fromGrid: !0
    }, a;
  }
  draggingToRowDragEvent(e, t) {
    const s = this.beans, { pageBounds: i, rowModel: r, gos: n } = s, o = Ko(s, t).y, a = o > i.getCurrentPageHeight();
    let l = -1, c;
    return a || (l = r.getRowIndexAtPixel(o), c = r.getRow(l)), n.addGridCommonParams({
      type: e,
      event: t.event,
      node: t.dragItem.rowNode,
      nodes: t.dragItem.rowNodes,
      overIndex: l,
      overNode: c,
      y: o,
      vDirection: t.vDirection
    });
  }
  dispatchGridEvent(e, t) {
    const s = this.draggingToRowDragEvent(e, t);
    this.eventSvc.dispatchEvent(s);
  }
  onDragLeave(e) {
    this.dispatchGridEvent("rowDragLeave", e), this.stopDragging(e), this.gos.get("rowDragManaged") && this.clearRowHighlight();
  }
  onDragStop(e) {
    this.dispatchGridEvent("rowDragEnd", e), this.stopDragging(e);
    const { dragAndDrop: t, gos: s } = this.beans;
    s.get("rowDragManaged") && (s.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(e)) && t.isDropZoneWithinThisGrid(e) && this.moveRowAndClearHighlight(e);
  }
  onDragCancel(e) {
    this.dispatchGridEvent("rowDragCancel", e), this.stopDragging(e);
    const { dragAndDrop: t, gos: s } = this.beans;
    s.get("rowDragManaged") && (s.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(e)) && t.isDropZoneWithinThisGrid(e) && this.clearRowHighlight();
  }
  stopDragging(e) {
    this.autoScrollService.ensureCleared(), this.getRowNodes(e).forEach((t) => {
      this.setRowNodeDragging(t, !1);
    });
  }
  setRowNodeDragging(e, t) {
    e.dragging !== t && (e.dragging = t, e.dispatchRowEvent("draggingChanged"));
  }
};
function gw(e, t, s) {
  if (s === 0)
    return !1;
  const i = Math.abs(e.clientX - t.clientX), r = Math.abs(e.clientY - t.clientY);
  return Math.max(i, r) <= s;
}
var NE = class extends L {
  constructor() {
    super(...arguments), this.beanName = "dragSvc", this.dragEndFunctions = [], this.dragSources = [];
  }
  destroy() {
    const { dragSources: e } = this;
    e.forEach(this.removeListener.bind(this)), e.length = 0, super.destroy();
  }
  removeListener(e) {
    const t = e.dragSource.eElement, s = e.mouseDownListener;
    if (t.removeEventListener("mousedown", s), e.touchEnabled) {
      const i = e.touchStartListener;
      t.removeEventListener("touchstart", i, { passive: !0 });
    }
  }
  removeDragSource(e) {
    const { dragSources: t } = this, s = t.find((i) => i.dragSource === e);
    s && (this.removeListener(s), kt(t, s));
  }
  addDragSource(e) {
    const t = this.onMouseDown.bind(this, e), { eElement: s, includeTouch: i, stopPropagationForTouch: r } = e;
    s.addEventListener("mousedown", t);
    let n = null;
    const o = this.gos.get("suppressTouch");
    i && !o && (n = (a) => {
      nh(a.target) || (r && a.stopPropagation(), this.onTouchStart(e, a));
    }, s.addEventListener("touchstart", n, { passive: !1 })), this.dragSources.push({
      dragSource: e,
      mouseDownListener: t,
      touchStartListener: n,
      touchEnabled: !!i
    });
  }
  // gets called whenever mouse down on any drag source
  onTouchStart(e, t) {
    this.currentDragParams = e, this.dragging = !1;
    const s = t.touches[0];
    this.touchLastTime = s, this.touchStart = s;
    const i = (l) => this.onTouchMove(l, e.eElement), r = (l) => this.onTouchUp(l, e.eElement), n = (l) => {
      l.cancelable && l.preventDefault();
    }, o = t.target, a = [
      // Prevents the page document from moving while we are dragging items around.
      // preventDefault needs to be called in the touchmove listener and never inside the
      // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
      {
        target: Yn(this.beans),
        type: "touchmove",
        listener: n,
        options: { passive: !1 }
      },
      { target: o, type: "touchmove", listener: i, options: { passive: !0 } },
      { target: o, type: "touchend", listener: r, options: { passive: !0 } },
      { target: o, type: "touchcancel", listener: r, options: { passive: !0 } }
    ];
    this.addTemporaryEvents(a), e.dragStartPixels === 0 && this.onCommonMove(s, this.touchStart, e.eElement);
  }
  // gets called whenever mouse down on any drag source
  onMouseDown(e, t) {
    const s = t;
    if (e.skipMouseEvent && e.skipMouseEvent(t) || s._alreadyProcessedByDragService || (s._alreadyProcessedByDragService = !0, t.button !== 0))
      return;
    this.shouldPreventMouseEvent(t) && t.preventDefault(), this.currentDragParams = e, this.dragging = !1, this.mouseStartEvent = t, this.startTarget = t.target;
    const i = (c) => this.onMouseMove(c, e.eElement), r = (c) => this.onMouseUp(c, e.eElement), n = (c) => c.preventDefault(), o = (c) => {
      c.key === P.ESCAPE && this.cancelDrag(e.eElement);
    }, a = Yn(this.beans), l = [
      { target: a, type: "mousemove", listener: i },
      { target: a, type: "mouseup", listener: r },
      { target: a, type: "contextmenu", listener: n },
      { target: a, type: "keydown", listener: o }
    ];
    this.addTemporaryEvents(l), e.dragStartPixels === 0 && this.onMouseMove(t, e.eElement);
  }
  addTemporaryEvents(e) {
    e.forEach((t) => {
      const { target: s, type: i, listener: r, options: n } = t;
      s.addEventListener(i, r, n);
    }), this.dragEndFunctions.push(() => {
      e.forEach((t) => {
        const { target: s, type: i, listener: r, options: n } = t;
        s.removeEventListener(i, r, n);
      });
    });
  }
  // returns true if the event is close to the original event by X pixels either vertically or horizontally.
  // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
  isEventNearStartEvent(e, t) {
    const { dragStartPixels: s } = this.currentDragParams, i = W(s) ? s : 4;
    return gw(e, t, i);
  }
  getFirstActiveTouch(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].identifier === this.touchStart.identifier)
        return e[t];
    return null;
  }
  onCommonMove(e, t, s) {
    var i;
    if (!this.dragging) {
      if (this.isEventNearStartEvent(e, t))
        return;
      if (this.dragging = !0, this.eventSvc.dispatchEvent({
        type: "dragStarted",
        target: s
      }), this.currentDragParams.onDragStart(t), !this.currentDragParams) {
        this.dragging = !1;
        return;
      }
      this.currentDragParams.onDragging(t);
    }
    (i = this.currentDragParams) == null || i.onDragging(e);
  }
  onTouchMove(e, t) {
    const s = this.getFirstActiveTouch(e.touches);
    s && this.onCommonMove(s, this.touchStart, t);
  }
  // only gets called after a mouse down - as this is only added after mouseDown
  // and is removed when mouseUp happens
  onMouseMove(e, t) {
    var s;
    Rn() && ((s = We(this.beans).getSelection()) == null || s.removeAllRanges()), this.shouldPreventMouseEvent(e) && e.preventDefault(), this.onCommonMove(e, this.mouseStartEvent, t);
  }
  shouldPreventMouseEvent(e) {
    const { gos: t } = this, s = t.get("enableCellTextSelection"), i = e.type === "mousemove", r = (n) => {
      const o = n.target, a = o == null ? void 0 : o.tagName.toLocaleLowerCase();
      return !!(a != null && a.match("^a$|textarea|input|select|button"));
    };
    return (
      // when `isEnableCellTextSelect` is `true`, we need to preventDefault on mouseMove
      // to avoid the grid text being selected while dragging components.
      s && i && e.cancelable && Gl(t, e) && !r(e)
    );
  }
  onTouchUp(e, t) {
    let s = this.getFirstActiveTouch(e.changedTouches);
    s || (s = this.touchLastTime), this.onUpCommon(s, t);
  }
  onMouseUp(e, t) {
    this.onUpCommon(e, t);
  }
  onUpCommon(e, t) {
    this.dragging && (this.dragging = !1, this.currentDragParams.onDragStop(e), this.eventSvc.dispatchEvent({
      type: "dragStopped",
      target: t
    })), this.resetDragProperties();
  }
  cancelDrag(e) {
    var t, s;
    this.eventSvc.dispatchEvent({
      type: "dragCancelled",
      target: e
    }), (s = (t = this.currentDragParams) == null ? void 0 : t.onDragCancel) == null || s.call(t), this.resetDragProperties();
  }
  resetDragProperties() {
    this.mouseStartEvent = null, this.startTarget = null, this.touchStart = null, this.touchLastTime = null, this.currentDragParams = null;
    const { dragEndFunctions: e } = this;
    e.forEach((t) => t()), e.length = 0;
  }
};
function fw(e, t) {
  return e + "_" + t;
}
function pt(e) {
  return e instanceof mw;
}
var mw = class extends L {
  constructor(e, t, s, i) {
    super(), this.providedColumnGroup = e, this.groupId = t, this.partId = s, this.pinned = i, this.isColumn = !1, this.displayedChildren = [], this.autoHeaderHeight = null, this.parent = null;
  }
  // as the user is adding and removing columns, the groups are recalculated.
  // this reset clears out all children, ready for children to be added again
  reset() {
    this.parent = null, this.children = null, this.displayedChildren = null;
  }
  getParent() {
    return this.parent;
  }
  getUniqueId() {
    return fw(this.groupId, this.partId);
  }
  isEmptyGroup() {
    return this.displayedChildren.length === 0;
  }
  isMoving() {
    const e = this.getProvidedColumnGroup().getLeafColumns();
    return !e || e.length === 0 ? !1 : e.every((t) => t.isMoving());
  }
  checkLeft() {
    if (this.displayedChildren.forEach((e) => {
      pt(e) && e.checkLeft();
    }), this.displayedChildren.length > 0)
      if (this.gos.get("enableRtl")) {
        const t = pe(this.displayedChildren).getLeft();
        this.setLeft(t);
      } else {
        const e = this.displayedChildren[0].getLeft();
        this.setLeft(e);
      }
    else
      this.setLeft(null);
  }
  getLeft() {
    return this.left;
  }
  getOldLeft() {
    return this.oldLeft;
  }
  setLeft(e) {
    this.oldLeft = this.left, this.left !== e && (this.left = e, this.dispatchLocalEvent({ type: "leftChanged" }));
  }
  getPinned() {
    return this.pinned;
  }
  getGroupId() {
    return this.groupId;
  }
  getPartId() {
    return this.partId;
  }
  getActualWidth() {
    var t;
    let e = 0;
    return (t = this.displayedChildren) == null || t.forEach((s) => {
      e += s.getActualWidth();
    }), e;
  }
  isResizable() {
    if (!this.displayedChildren)
      return !1;
    let e = !1;
    return this.displayedChildren.forEach((t) => {
      t.isResizable() && (e = !0);
    }), e;
  }
  getMinWidth() {
    let e = 0;
    return this.displayedChildren.forEach((t) => {
      e += t.getMinWidth();
    }), e;
  }
  addChild(e) {
    this.children || (this.children = []), this.children.push(e);
  }
  getDisplayedChildren() {
    return this.displayedChildren;
  }
  getLeafColumns() {
    const e = [];
    return this.addLeafColumns(e), e;
  }
  getDisplayedLeafColumns() {
    const e = [];
    return this.addDisplayedLeafColumns(e), e;
  }
  getDefinition() {
    return this.providedColumnGroup.getColGroupDef();
  }
  getColGroupDef() {
    return this.providedColumnGroup.getColGroupDef();
  }
  isPadding() {
    return this.providedColumnGroup.isPadding();
  }
  isExpandable() {
    return this.providedColumnGroup.isExpandable();
  }
  isExpanded() {
    return this.providedColumnGroup.isExpanded();
  }
  setExpanded(e) {
    this.providedColumnGroup.setExpanded(e);
  }
  isAutoHeaderHeight() {
    var e;
    return !!((e = this.getColGroupDef()) != null && e.autoHeaderHeight);
  }
  getAutoHeaderHeight() {
    return this.autoHeaderHeight;
  }
  /** Returns true if the header height has changed */
  setAutoHeaderHeight(e) {
    const t = e !== this.autoHeaderHeight;
    return this.autoHeaderHeight = e, t;
  }
  addDisplayedLeafColumns(e) {
    this.displayedChildren.forEach((t) => {
      Ri(t) ? e.push(t) : pt(t) && t.addDisplayedLeafColumns(e);
    });
  }
  addLeafColumns(e) {
    this.children.forEach((t) => {
      Ri(t) ? e.push(t) : pt(t) && t.addLeafColumns(e);
    });
  }
  getChildren() {
    return this.children;
  }
  getColumnGroupShow() {
    return this.providedColumnGroup.getColumnGroupShow();
  }
  getProvidedColumnGroup() {
    return this.providedColumnGroup;
  }
  getPaddingLevel() {
    const e = this.getParent();
    return !this.isPadding() || !e || !e.isPadding() ? 0 : 1 + e.getPaddingLevel();
  }
  calculateDisplayedColumns() {
    this.displayedChildren = [];
    let e = this;
    for (; e != null && e.isPadding(); )
      e = e.getParent();
    if (!(e ? e.getProvidedColumnGroup().isExpandable() : !1)) {
      this.displayedChildren = this.children, this.dispatchLocalEvent({ type: "displayedChildrenChanged" });
      return;
    }
    this.children.forEach((s) => {
      if (pt(s) && (!s.displayedChildren || !s.displayedChildren.length))
        return;
      switch (s.getColumnGroupShow()) {
        case "open":
          e.getProvidedColumnGroup().isExpanded() && this.displayedChildren.push(s);
          break;
        case "closed":
          e.getProvidedColumnGroup().isExpanded() || this.displayedChildren.push(s);
          break;
        default:
          this.displayedChildren.push(s);
          break;
      }
    }), this.dispatchLocalEvent({ type: "displayedChildrenChanged" });
  }
}, oa = "row-group-", Cw = "t-", vw = "b-", HE = 0, bs = class {
  constructor(e) {
    this.master = !1, this.detail = void 0, this.rowIndex = null, this.key = null, this.sourceRowIndex = -1, this.childrenMapped = {}, this.treeNode = null, this.treeNodeFlags = 0, this.displayed = !1, this.rowTop = null, this.oldRowTop = null, this.selectable = !0, this.__objectId = HE++, this.alreadyRendered = !1, this.highlighted = null, this.hovered = !1, this.__selected = !1, this.beans = e;
  }
  /**
   * Replaces the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */
  setData(e) {
    this.setDataCommon(e, !1);
  }
  // similar to setRowData, however it is expected that the data is the same data item. this
  // is intended to be used with Redux type stores, where the whole data can be changed. we are
  // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
  // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
  // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).
  /**
   * Updates the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */
  updateData(e) {
    this.setDataCommon(e, !0);
  }
  setDataCommon(e, t) {
    var r, n, o;
    const s = this.data;
    this.data = e, (r = this.beans.valueCache) == null || r.onDataChanged(), this.updateDataOnDetailNode(), (n = this.beans.selectionSvc) == null || n.updateRowSelectable(this), this.resetQuickFilterAggregateText();
    const i = this.createDataChangedEvent(e, s, t);
    (o = this.__localEventService) == null || o.dispatchEvent(i);
  }
  // when we are doing master / detail, the detail node is lazy created, but then kept around.
  // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
  // in sync, otherwise expand/collapse of the detail would still show the old values.
  updateDataOnDetailNode() {
    this.detailNode && (this.detailNode.data = this.data);
  }
  createDataChangedEvent(e, t, s) {
    return {
      type: "dataChanged",
      node: this,
      oldData: t,
      newData: e,
      update: s
    };
  }
  getRowIndexString() {
    return this.rowIndex == null ? (be(13), null) : this.rowPinned === "top" ? Cw + this.rowIndex : this.rowPinned === "bottom" ? vw + this.rowIndex : this.rowIndex.toString();
  }
  setDataAndId(e, t) {
    var o, a;
    const { selectionSvc: s } = this.beans, i = (o = s == null ? void 0 : s.createDaemonNode) == null ? void 0 : o.call(s, this), r = this.data;
    this.data = e, this.updateDataOnDetailNode(), this.setId(t), s && (s.updateRowSelectable(this), s.syncInRowNode(this, i));
    const n = this.createDataChangedEvent(e, r, !1);
    (a = this.__localEventService) == null || a.dispatchEvent(n);
  }
  setId(e) {
    var s;
    const t = _i(this.beans.gos);
    if (t)
      if (this.data) {
        const i = ((s = this.parent) == null ? void 0 : s.getRoute()) ?? [];
        this.id = t({
          data: this.data,
          parentKeys: i.length > 0 ? i : void 0,
          level: this.level,
          rowPinned: this.rowPinned
        }), this.id.startsWith(oa) && be(14, {
          groupPrefix: oa
        });
      } else
        this.id = void 0;
    else
      this.id = e;
  }
  setRowTop(e) {
    this.oldRowTop = this.rowTop, this.rowTop !== e && (this.rowTop = e, this.dispatchRowEvent("topChanged"), this.setDisplayed(e !== null));
  }
  clearRowTopAndRowIndex() {
    this.oldRowTop = null, this.setRowTop(null), this.setRowIndex(null);
  }
  setHovered(e) {
    this.hovered = e;
  }
  isHovered() {
    return this.hovered;
  }
  /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */
  setRowHeight(e, t = !1) {
    this.rowHeight = e, this.rowHeightEstimated = t, this.dispatchRowEvent("heightChanged");
  }
  setExpanded(e, t, s) {
    var i;
    (i = this.beans.expansionSvc) == null || i.setExpanded(this, e, t, s);
  }
  /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid will refresh the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */
  setDataValue(e, t, s) {
    const { colModel: i, valueSvc: r, gos: n, selectionSvc: o } = this.beans, a = typeof e != "string" ? e : i.getCol(e) ?? i.getColDefCol(e);
    if (!a)
      return !1;
    const l = r.getValueForDisplay(a, this);
    if (n.get("readOnlyEdit")) {
      const {
        beans: { eventSvc: d },
        data: u,
        rowIndex: h,
        rowPinned: p
      } = this;
      return d.dispatchEvent({
        type: "cellEditRequest",
        event: null,
        rowIndex: h,
        rowPinned: p,
        column: a,
        colDef: a.colDef,
        data: u,
        node: this,
        oldValue: l,
        newValue: t,
        value: t,
        source: s
      }), !1;
    }
    const c = r.setValue(this, a, t, s);
    return this.dispatchCellChangedEvent(a, t, l), o == null || o.updateRowSelectable(this), c;
  }
  updateHasChildren() {
    let e = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
    const { rowChildrenSvc: t } = this.beans;
    t && (e = t.getHasChildrenValue(this)), e !== this.__hasChildren && (this.__hasChildren = !!e, this.dispatchRowEvent("hasChildrenChanged"));
  }
  hasChildren() {
    return this.__hasChildren == null && this.updateHasChildren(), this.__hasChildren;
  }
  dispatchCellChangedEvent(e, t, s) {
    var r;
    const i = {
      type: "cellChanged",
      node: this,
      column: e,
      newValue: t,
      oldValue: s
    };
    (r = this.__localEventService) == null || r.dispatchEvent(i);
  }
  /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However if you edit without using grid editing, you will need to clear this string down for the row to be updated with the new values.
   * Otherwise new values will not work with the `quickFilter`. */
  resetQuickFilterAggregateText() {
    this.quickFilterAggregateText = null;
  }
  /** Returns:
   * - `true` if the node can be expanded, i.e it is a group or master row.
   * - `false` if the node cannot be expanded
   */
  isExpandable() {
    var e;
    return ((e = this.beans.expansionSvc) == null ? void 0 : e.isExpandable(this)) ?? !1;
  }
  /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */
  isSelected() {
    return this.footer ? this.sibling.isSelected() : this.__selected;
  }
  /** Perform a depth-first search of this node and its children. */
  depthFirstSearch(e) {
    var t;
    (t = this.childrenAfterGroup) == null || t.forEach((s) => s.depthFirstSearch(e)), e(this);
  }
  dispatchRowEvent(e) {
    var t;
    (t = this.__localEventService) == null || t.dispatchEvent({
      type: e,
      node: this
    });
  }
  /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` will select the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that will appear in the `selectionChanged` event.
   */
  setSelected(e, t = !1, s = "api") {
    var i;
    (i = this.beans.selectionSvc) == null || i.setNodesSelected({
      nodes: [this],
      newValue: e,
      clearSelection: t,
      source: s
    });
  }
  /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */
  isRowPinned() {
    return !!this.rowPinned;
  }
  /** Add an event listener. */
  addEventListener(e, t) {
    var i, r, n, o;
    (i = this.beans.validation) == null || i.checkRowEvents(e), this.__localEventService || (this.__localEventService = new Mr()), this.frameworkEventListenerService = (n = (r = this.beans.frameworkOverrides).createLocalEventListenerWrapper) == null ? void 0 : n.call(
      r,
      this.frameworkEventListenerService,
      this.__localEventService
    );
    const s = ((o = this.frameworkEventListenerService) == null ? void 0 : o.wrap(t)) ?? t;
    this.__localEventService.addEventListener(e, s);
  }
  /** Remove event listener. */
  removeEventListener(e, t) {
    var i;
    if (!this.__localEventService)
      return;
    const s = ((i = this.frameworkEventListenerService) == null ? void 0 : i.unwrap(t)) ?? t;
    this.__localEventService.removeEventListener(e, s), this.__localEventService.noRegisteredListenersExist() && (this.__localEventService = null);
  }
  /**
   * @deprecated v32.2.0 Check `node.detail` then user provided callback `isFullWidthRow` instead.
   *
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */
  isFullWidthCell() {
    if (I(61), this.detail)
      return !0;
    const e = this.beans.gos.getCallback("isFullWidthRow");
    return e ? e({ rowNode: this }) : !1;
  }
  /**
   * Returns the route of keys to the row node. Returns undefined if the node has no key.
   */
  getRoute() {
    if (this.level === -1)
      return [];
    if (this.key == null)
      return;
    const e = [];
    let t = this;
    for (; t && t.key != null; )
      e.push(t.key), t = t.parent;
    return e.reverse();
  }
  setFirstChild(e) {
    this.firstChild !== e && (this.firstChild = e, this.dispatchRowEvent("firstChildChanged"));
  }
  setDisplayed(e) {
    this.displayed !== e && (this.displayed = e, this.dispatchRowEvent("displayedChanged"));
  }
  setRowIndex(e) {
    this.rowIndex !== e && (this.rowIndex = e, this.dispatchRowEvent("rowIndexChanged"));
  }
  setAllChildrenCount(e) {
    this.allChildrenCount !== e && (this.allChildrenCount = e, this.dispatchRowEvent("allChildrenCountChanged"));
  }
  setUiLevel(e) {
    this.uiLevel !== e && (this.uiLevel = e, this.dispatchRowEvent("uiLevelChanged"));
  }
};
function ww(e, t, s) {
  return t.addGridCommonParams({
    type: s,
    node: e,
    data: e.data,
    rowIndex: e.rowIndex,
    rowPinned: e.rowPinned
  });
}
var fc = class extends _ {
  constructor(e, t) {
    super(
      /* html */
      '<div class="ag-filter"></div>'
    ), this.column = e, this.source = t, this.filterWrapper = null;
  }
  postConstruct() {
    this.createFilter(!0), this.addManagedEventListeners({ filterDestroyed: this.onFilterDestroyed.bind(this) });
  }
  hasFilter() {
    return !!this.filterWrapper;
  }
  getFilter() {
    var e;
    return ((e = this.filterWrapper) == null ? void 0 : e.filterPromise) ?? null;
  }
  afterInit() {
    var e, t;
    return ((t = (e = this.filterWrapper) == null ? void 0 : e.filterPromise) == null ? void 0 : t.then(() => {
    })) ?? fe.resolve();
  }
  afterGuiAttached(e) {
    var t, s;
    (s = (t = this.filterWrapper) == null ? void 0 : t.filterPromise) == null || s.then((i) => {
      var r;
      (r = i == null ? void 0 : i.afterGuiAttached) == null || r.call(i, e);
    });
  }
  afterGuiDetached() {
    var e, t;
    (t = (e = this.filterWrapper) == null ? void 0 : e.filterPromise) == null || t.then((s) => {
      var i;
      (i = s == null ? void 0 : s.afterGuiDetached) == null || i.call(s);
    });
  }
  createFilter(e) {
    var i, r;
    const { column: t, source: s } = this;
    this.filterWrapper = ((i = this.beans.filterManager) == null ? void 0 : i.getOrCreateFilterWrapper(t)) ?? null, (r = this.filterWrapper) != null && r.filterPromise && this.filterWrapper.filterPromise.then((n) => {
      const o = n.getGui();
      W(o) || I(69, { guiFromFilter: o }), this.appendChild(o), e && this.eventSvc.dispatchEvent({
        type: "filterOpened",
        column: t,
        source: s,
        eGui: this.getGui()
      });
    });
  }
  onFilterDestroyed(e) {
    (e.source === "api" || e.source === "paramsUpdated") && e.column.getId() === this.column.getId() && this.beans.colModel.getColDefCol(this.column) && (ze(this.getGui()), this.createFilter());
  }
  destroy() {
    this.filterWrapper = null, super.destroy();
  }
}, yw = "ag-resizer-wrapper", or = (e, t) => `<div data-ref="${e}Resizer" class="ag-resizer ag-resizer-${t}"></div>`, zE = (
  /* html */
  `<div class="${yw}">
        ${or("eTopLeft", "topLeft")}
        ${or("eTop", "top")}
        ${or("eTopRight", "topRight")}
        ${or("eRight", "right")}
        ${or("eBottomRight", "bottomRight")}
        ${or("eBottom", "bottom")}
        ${or("eBottomLeft", "bottomLeft")}
        ${or("eLeft", "left")}
    </div>`
), mc = class extends L {
  constructor(e, t) {
    super(), this.element = e, this.dragStartPosition = {
      x: 0,
      y: 0
    }, this.position = {
      x: 0,
      y: 0
    }, this.lastSize = {
      width: -1,
      height: -1
    }, this.positioned = !1, this.resizersAdded = !1, this.resizeListeners = [], this.boundaryEl = null, this.isResizing = !1, this.isMoving = !1, this.resizable = {}, this.movable = !1, this.currentResizer = null, this.config = Object.assign({}, { popup: !1 }, t);
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc, this.dragSvc = e.dragSvc;
  }
  center() {
    const { clientHeight: e, clientWidth: t } = this.offsetParent, s = t / 2 - this.getWidth() / 2, i = e / 2 - this.getHeight() / 2;
    this.offsetElement(s, i);
  }
  initialisePosition() {
    if (this.positioned)
      return;
    const { centered: e, forcePopupParentAsOffsetParent: t, minWidth: s, width: i, minHeight: r, height: n, x: o, y: a } = this.config;
    this.offsetParent || this.setOffsetParent();
    let l = 0, c = 0;
    const d = Xt(this.element);
    if (d) {
      const u = this.findBoundaryElement(), h = window.getComputedStyle(u);
      if (h.minWidth != null) {
        const p = u.offsetWidth - this.element.offsetWidth;
        c = parseInt(h.minWidth, 10) - p;
      }
      if (h.minHeight != null) {
        const p = u.offsetHeight - this.element.offsetHeight;
        l = parseInt(h.minHeight, 10) - p;
      }
    }
    if (this.minHeight = r || l, this.minWidth = s || c, i && this.setWidth(i), n && this.setHeight(n), (!i || !n) && this.refreshSize(), e)
      this.center();
    else if (o || a)
      this.offsetElement(o, a);
    else if (d && t) {
      let u = this.boundaryEl, h = !0;
      if (u || (u = this.findBoundaryElement(), h = !1), u) {
        const p = parseFloat(u.style.top), g = parseFloat(u.style.left);
        h ? this.offsetElement(isNaN(g) ? 0 : g, isNaN(p) ? 0 : p) : this.setPosition(g, p);
      }
    }
    this.positioned = !!this.offsetParent;
  }
  isPositioned() {
    return this.positioned;
  }
  getPosition() {
    return this.position;
  }
  setMovable(e, t) {
    var i, r;
    if (!this.config.popup || e === this.movable)
      return;
    this.movable = e;
    const s = this.moveElementDragListener || {
      eElement: t,
      onDragStart: this.onMoveStart.bind(this),
      onDragging: this.onMove.bind(this),
      onDragStop: this.onMoveEnd.bind(this)
    };
    e ? ((i = this.dragSvc) == null || i.addDragSource(s), this.moveElementDragListener = s) : ((r = this.dragSvc) == null || r.removeDragSource(s), this.moveElementDragListener = void 0);
  }
  setResizable(e) {
    if (this.clearResizeListeners(), e ? this.addResizers() : this.removeResizers(), typeof e == "boolean") {
      if (e === !1)
        return;
      e = {
        topLeft: e,
        top: e,
        topRight: e,
        right: e,
        bottomRight: e,
        bottom: e,
        bottomLeft: e,
        left: e
      };
    }
    Object.keys(e).forEach((t) => {
      var o;
      const i = !!e[t], r = this.getResizerElement(t), n = {
        dragStartPixels: 0,
        eElement: r,
        onDragStart: (a) => this.onResizeStart(a, t),
        onDragging: this.onResize.bind(this),
        onDragStop: (a) => this.onResizeEnd(a, t)
      };
      (i || !this.isAlive() && !i) && (i ? ((o = this.dragSvc) == null || o.addDragSource(n), this.resizeListeners.push(n), r.style.pointerEvents = "all") : r.style.pointerEvents = "none", this.resizable[t] = i);
    });
  }
  removeSizeFromEl() {
    this.element.style.removeProperty("height"), this.element.style.removeProperty("width"), this.element.style.removeProperty("flex");
  }
  restoreLastSize() {
    this.element.style.flex = "0 0 auto";
    const { height: e, width: t } = this.lastSize;
    t !== -1 && (this.element.style.width = `${t}px`), e !== -1 && (this.element.style.height = `${e}px`);
  }
  getHeight() {
    return this.element.offsetHeight;
  }
  setHeight(e) {
    const { popup: t } = this.config, s = this.element;
    let i = !1;
    if (typeof e == "string" && e.indexOf("%") !== -1)
      Uo(s, e), e = oc(s), i = !0;
    else if (e = Math.max(this.minHeight, e), this.positioned) {
      const r = this.getAvailableHeight();
      r && e > r && (e = r);
    }
    this.getHeight() !== e && (i ? (s.style.maxHeight = "unset", s.style.minHeight = "unset") : t ? Uo(s, e) : (s.style.height = `${e}px`, s.style.flex = "0 0 auto", this.lastSize.height = typeof e == "number" ? e : parseFloat(e)));
  }
  getAvailableHeight() {
    const { popup: e, forcePopupParentAsOffsetParent: t } = this.config;
    this.positioned || this.initialisePosition();
    const { clientHeight: s } = this.offsetParent;
    if (!s)
      return null;
    const i = this.element.getBoundingClientRect(), r = this.offsetParent.getBoundingClientRect(), n = e ? this.position.y : i.top, o = e ? 0 : r.top;
    let a = 0;
    if (t) {
      const c = this.element.parentElement;
      if (c) {
        const { bottom: d } = c.getBoundingClientRect();
        a = d - i.bottom;
      }
    }
    return s + o - n - a;
  }
  getWidth() {
    return this.element.offsetWidth;
  }
  setWidth(e) {
    const t = this.element, { popup: s } = this.config;
    let i = !1;
    if (typeof e == "string" && e.indexOf("%") !== -1)
      si(t, e), e = gn(t), i = !0;
    else if (this.positioned) {
      e = Math.max(this.minWidth, e);
      const { clientWidth: r } = this.offsetParent, n = s ? this.position.x : this.element.getBoundingClientRect().left;
      r && e + n > r && (e = r - n);
    }
    this.getWidth() !== e && (i ? (t.style.maxWidth = "unset", t.style.minWidth = "unset") : this.config.popup ? si(t, e) : (t.style.width = `${e}px`, t.style.flex = " unset", this.lastSize.width = typeof e == "number" ? e : parseFloat(e)));
  }
  offsetElement(e = 0, t = 0) {
    var r;
    const { forcePopupParentAsOffsetParent: s } = this.config, i = s ? this.boundaryEl : this.element;
    i && ((r = this.popupSvc) == null || r.positionPopup({
      ePopup: i,
      keepWithinBounds: !0,
      skipObserver: this.movable || this.isResizable(),
      updatePosition: () => ({ x: e, y: t })
    }), this.setPosition(parseFloat(i.style.left), parseFloat(i.style.top)));
  }
  constrainSizeToAvailableHeight(e) {
    var s;
    if (!this.config.forcePopupParentAsOffsetParent)
      return;
    const t = () => {
      const i = this.getAvailableHeight();
      this.element.style.setProperty("max-height", `${i}px`);
    };
    e && this.popupSvc ? this.resizeObserverSubscriber = Ms(
      this.beans,
      (s = this.popupSvc) == null ? void 0 : s.getPopupParent(),
      t
    ) : (this.element.style.removeProperty("max-height"), this.resizeObserverSubscriber && (this.resizeObserverSubscriber(), this.resizeObserverSubscriber = void 0));
  }
  setPosition(e, t) {
    this.position.x = e, this.position.y = t;
  }
  updateDragStartPosition(e, t) {
    this.dragStartPosition = { x: e, y: t };
  }
  calculateMouseMovement(e) {
    const { e: t, isLeft: s, isTop: i, anywhereWithin: r, topBuffer: n } = e, o = t.clientX - this.dragStartPosition.x, a = t.clientY - this.dragStartPosition.y, l = this.shouldSkipX(t, !!s, !!r, o) ? 0 : o, c = this.shouldSkipY(t, !!i, n, a) ? 0 : a;
    return { movementX: l, movementY: c };
  }
  shouldSkipX(e, t, s, i) {
    const r = this.element.getBoundingClientRect(), n = this.offsetParent.getBoundingClientRect(), o = this.boundaryEl.getBoundingClientRect(), a = this.config.popup ? this.position.x : r.left;
    let l = a <= 0 && n.left >= e.clientX || n.right <= e.clientX && n.right <= o.right;
    return l ? !0 : (t ? l = // skip if we are moving to the left and the cursor
    // is positioned to the right of the left side anchor
    i < 0 && e.clientX > a + n.left || // skip if we are moving to the right and the cursor
    // is positioned to the left of the dialog
    i > 0 && e.clientX < a + n.left : s ? l = i < 0 && e.clientX > o.right || i > 0 && e.clientX < a + n.left : l = // if the movement is bound to the right side of the dialog
    // we skip if we are moving to the left and the cursor
    // is to the right of the dialog
    i < 0 && e.clientX > o.right || // or skip if we are moving to the right and the cursor
    // is to the left of the right side anchor
    i > 0 && e.clientX < o.right, l);
  }
  shouldSkipY(e, t, s = 0, i) {
    const r = this.element.getBoundingClientRect(), n = this.offsetParent.getBoundingClientRect(), o = this.boundaryEl.getBoundingClientRect(), a = this.config.popup ? this.position.y : r.top;
    let l = a <= 0 && n.top >= e.clientY || n.bottom <= e.clientY && n.bottom <= o.bottom;
    return l ? !0 : (t ? l = // skip if we are moving to towards top and the cursor is
    // below the top anchor + topBuffer
    // note: topBuffer is used when moving the dialog using the title bar
    i < 0 && e.clientY > a + n.top + s || // skip if we are moving to the bottom and the cursor is
    // above the top anchor
    i > 0 && e.clientY < a + n.top : l = // skip if we are moving towards the top and the cursor
    // is below the bottom anchor
    i < 0 && e.clientY > o.bottom || // skip if we are moving towards the bottom and the cursor
    // is above the bottom anchor
    i > 0 && e.clientY < o.bottom, l);
  }
  createResizeMap() {
    const e = this.element;
    this.resizerMap = {
      topLeft: { element: e.querySelector("[data-ref=eTopLeftResizer]") },
      top: { element: e.querySelector("[data-ref=eTopResizer]") },
      topRight: { element: e.querySelector("[data-ref=eTopRightResizer]") },
      right: { element: e.querySelector("[data-ref=eRightResizer]") },
      bottomRight: { element: e.querySelector("[data-ref=eBottomRightResizer]") },
      bottom: { element: e.querySelector("[data-ref=eBottomResizer]") },
      bottomLeft: { element: e.querySelector("[data-ref=eBottomLeftResizer]") },
      left: { element: e.querySelector("[data-ref=eLeftResizer]") }
    };
  }
  addResizers() {
    if (this.resizersAdded)
      return;
    const e = this.element;
    if (!e)
      return;
    const s = new DOMParser().parseFromString(zE, "text/html").body;
    e.appendChild(s.firstChild), this.createResizeMap(), this.resizersAdded = !0;
  }
  removeResizers() {
    this.resizerMap = void 0;
    const e = this.element.querySelector(`.${yw}`);
    e && this.element.removeChild(e), this.resizersAdded = !1;
  }
  getResizerElement(e) {
    return this.resizerMap[e].element;
  }
  onResizeStart(e, t) {
    this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.currentResizer = {
      isTop: !!t.match(/top/i),
      isRight: !!t.match(/right/i),
      isBottom: !!t.match(/bottom/i),
      isLeft: !!t.match(/left/i)
    }, this.element.classList.add("ag-resizing"), this.resizerMap[t].element.classList.add("ag-active");
    const { popup: s, forcePopupParentAsOffsetParent: i } = this.config;
    !s && !i && this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop), this.isResizing = !0, this.updateDragStartPosition(e.clientX, e.clientY);
  }
  getSiblings() {
    const t = this.element.parentElement;
    return t ? Array.prototype.slice.call(t.children).filter((s) => !s.classList.contains("ag-hidden")) : null;
  }
  getMinSizeOfSiblings() {
    const e = this.getSiblings() || [];
    let t = 0, s = 0;
    for (let i = 0; i < e.length; i++) {
      const r = e[i], n = !!r.style.flex && r.style.flex !== "0 0 auto";
      if (r === this.element)
        continue;
      let o = this.minHeight || 0, a = this.minWidth || 0;
      if (n) {
        const l = window.getComputedStyle(r);
        l.minHeight && (o = parseInt(l.minHeight, 10)), l.minWidth && (a = parseInt(l.minWidth, 10));
      } else
        o = r.offsetHeight, a = r.offsetWidth;
      t += o, s += a;
    }
    return { height: t, width: s };
  }
  applySizeToSiblings(e) {
    let t = null;
    const s = this.getSiblings();
    if (s) {
      for (let i = 0; i < s.length; i++) {
        const r = s[i];
        r !== t && (e ? r.style.height = `${r.offsetHeight}px` : r.style.width = `${r.offsetWidth}px`, r.style.flex = "0 0 auto", r === this.element && (t = s[i + 1]));
      }
      t && (t.style.removeProperty("height"), t.style.removeProperty("min-height"), t.style.removeProperty("max-height"), t.style.flex = "1 1 auto");
    }
  }
  isResizable() {
    return Object.values(this.resizable).some((e) => e);
  }
  onResize(e) {
    if (!this.isResizing || !this.currentResizer)
      return;
    const { popup: t, forcePopupParentAsOffsetParent: s } = this.config, { isTop: i, isRight: r, isBottom: n, isLeft: o } = this.currentResizer, a = r || o, l = n || i, { movementX: c, movementY: d } = this.calculateMouseMovement({ e, isLeft: o, isTop: i }), u = this.position.x, h = this.position.y;
    let p = 0, g = 0;
    if (a && c) {
      const f = o ? -1 : 1, m = this.getWidth(), C = m + c * f;
      let w = !1;
      o && (p = m - C, (u + p <= 0 || C <= this.minWidth) && (w = !0, p = 0)), w || this.setWidth(C);
    }
    if (l && d) {
      const f = i ? -1 : 1, m = this.getHeight(), C = m + d * f;
      let w = !1;
      i ? (g = m - C, (h + g <= 0 || C <= this.minHeight) && (w = !0, g = 0)) : !this.config.popup && !this.config.forcePopupParentAsOffsetParent && m < C && this.getMinSizeOfSiblings().height + C > this.element.parentElement.offsetHeight && (w = !0), w || this.setHeight(C);
    }
    this.updateDragStartPosition(e.clientX, e.clientY), ((t || s) && p || g) && this.offsetElement(u + p, h + g);
  }
  onResizeEnd(e, t) {
    this.isResizing = !1, this.currentResizer = null, this.boundaryEl = null, this.element.classList.remove("ag-resizing"), this.resizerMap[t].element.classList.remove("ag-active"), this.dispatchLocalEvent({ type: "resize" });
  }
  refreshSize() {
    const e = this.element;
    this.config.popup && (this.config.width || this.setWidth(e.offsetWidth), this.config.height || this.setHeight(e.offsetHeight));
  }
  onMoveStart(e) {
    this.boundaryEl = this.findBoundaryElement(), this.positioned || this.initialisePosition(), this.isMoving = !0, this.element.classList.add("ag-moving"), this.updateDragStartPosition(e.clientX, e.clientY);
  }
  onMove(e) {
    if (!this.isMoving)
      return;
    const { x: t, y: s } = this.position;
    let i;
    this.config.calculateTopBuffer && (i = this.config.calculateTopBuffer());
    const { movementX: r, movementY: n } = this.calculateMouseMovement({
      e,
      isTop: !0,
      anywhereWithin: !0,
      topBuffer: i
    });
    this.offsetElement(t + r, s + n), this.updateDragStartPosition(e.clientX, e.clientY);
  }
  onMoveEnd() {
    this.isMoving = !1, this.boundaryEl = null, this.element.classList.remove("ag-moving");
  }
  setOffsetParent() {
    this.config.forcePopupParentAsOffsetParent && this.popupSvc ? this.offsetParent = this.popupSvc.getPopupParent() : this.offsetParent = this.element.offsetParent;
  }
  findBoundaryElement() {
    let e = this.element;
    for (; e; ) {
      if (window.getComputedStyle(e).position !== "static")
        return e;
      e = e.parentElement;
    }
    return this.element;
  }
  clearResizeListeners() {
    var e;
    for (; this.resizeListeners.length; ) {
      const t = this.resizeListeners.pop();
      (e = this.dragSvc) == null || e.removeDragSource(t);
    }
  }
  destroy() {
    var e;
    super.destroy(), this.moveElementDragListener && ((e = this.dragSvc) == null || e.removeDragSource(this.moveElementDragListener)), this.constrainSizeToAvailableHeight(!1), this.clearResizeListeners(), this.removeResizers();
  }
}, bw = "ag-focus-managed", Ir = class extends L {
  constructor(e, t = {}) {
    super(), this.eFocusable = e, this.callbacks = t, this.callbacks = {
      shouldStopEventPropagation: () => !1,
      onTabKeyDown: (s) => {
        if (s.defaultPrevented)
          return;
        const i = zt(this.beans, this.eFocusable, !1, s.shiftKey);
        i && (i.focus(), s.preventDefault());
      },
      ...t
    };
  }
  postConstruct() {
    const {
      eFocusable: e,
      callbacks: { onFocusIn: t, onFocusOut: s }
    } = this;
    e.classList.add(bw), this.addKeyDownListeners(e), t && this.addManagedElementListeners(e, { focusin: t }), s && this.addManagedElementListeners(e, { focusout: s });
  }
  addKeyDownListeners(e) {
    this.addManagedElementListeners(e, {
      keydown: (t) => {
        if (t.defaultPrevented || Ds(t))
          return;
        const { callbacks: s } = this;
        if (s.shouldStopEventPropagation(t)) {
          gt(t);
          return;
        }
        t.key === P.TAB ? s.onTabKeyDown(t) : s.handleKeyDown && s.handleKeyDown(t);
      }
    });
  }
}, Sw = {
  applyFilter: "Apply",
  clearFilter: "Clear",
  resetFilter: "Reset",
  cancelFilter: "Cancel",
  textFilter: "Text Filter",
  numberFilter: "Number Filter",
  dateFilter: "Date Filter",
  setFilter: "Set Filter",
  filterOoo: "Filter...",
  empty: "Choose one",
  equals: "Equals",
  notEqual: "Does not equal",
  lessThan: "Less than",
  greaterThan: "Greater than",
  inRange: "Between",
  inRangeStart: "From",
  inRangeEnd: "To",
  lessThanOrEqual: "Less than or equal to",
  greaterThanOrEqual: "Greater than or equal to",
  contains: "Contains",
  notContains: "Does not contain",
  startsWith: "Begins with",
  endsWith: "Ends with",
  blank: "Blank",
  notBlank: "Not blank",
  before: "Before",
  after: "After",
  andCondition: "AND",
  orCondition: "OR",
  dateFormatOoo: "yyyy-mm-dd"
};
function bh(e, t) {
  const { debounceMs: s } = e;
  return Bl(e) ? (s != null && I(71), 0) : s ?? t;
}
function Bl(e) {
  var t;
  return (((t = e.buttons) == null ? void 0 : t.indexOf("apply")) ?? -1) >= 0;
}
var Cc = class extends _ {
  constructor(e) {
    super(), this.filterNameKey = e, this.applyActive = !1, this.hidePopup = null, this.debouncePending = !1, this.appliedModel = null, this.eFilterBody = E, this.buttonListeners = [], this.defaultDebounceMs = 0;
  }
  postConstruct() {
    this.resetTemplate(), this.createManagedBean(
      new Ir(this.getFocusableElement(), {
        handleKeyDown: this.handleKeyDown.bind(this)
      })
    ), this.positionableFeature = new mc(this.getPositionableElement(), {
      forcePopupParentAsOffsetParent: !0
    }), this.createBean(this.positionableFeature);
  }
  // override
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleKeyDown(e) {
  }
  getFilterTitle() {
    return this.translate(this.filterNameKey);
  }
  isFilterActive() {
    return !!this.appliedModel;
  }
  resetTemplate(e) {
    let t = this.getGui();
    t && t.removeEventListener("submit", this.onFormSubmit);
    const s = (
      /* html */
      `
            <form class="ag-filter-wrapper">
                <div class="ag-filter-body-wrapper ag-${this.getCssIdentifier()}-body-wrapper" data-ref="eFilterBody">
                    ${this.createBodyTemplate()}
                </div>
            </form>`
    );
    this.setTemplate(s, this.getAgComponents(), e), t = this.getGui(), t == null || t.addEventListener("submit", this.onFormSubmit);
  }
  isReadOnly() {
    return !!this.params.readOnly;
  }
  init(e) {
    this.setParams(e), this.resetUiToDefaults(!0).then(() => {
      this.updateUiVisibility(), this.setupOnBtApplyDebounce();
    });
  }
  setParams(e) {
    this.params = e, this.applyActive = Bl(e), this.resetButtonsPanel(e);
  }
  updateParams(e) {
    this.params = e, this.applyActive = Bl(e), this.resetUiToActiveModel(this.getModel(), () => {
      this.updateUiVisibility(), this.setupOnBtApplyDebounce();
    });
  }
  resetButtonsPanel(e, t) {
    const { buttons: s, readOnly: i } = t ?? {}, { buttons: r, readOnly: n } = e;
    if (i === n && Kn(s, r))
      return;
    const o = r && r.length > 0 && !this.isReadOnly();
    if (this.eButtonsPanel ? (ze(this.eButtonsPanel), this.buttonListeners.forEach((c) => c()), this.buttonListeners = []) : o && (this.eButtonsPanel = document.createElement("div"), this.eButtonsPanel.classList.add("ag-filter-apply-panel")), !o) {
      this.eButtonsPanel && ut(this.eButtonsPanel);
      return;
    }
    const a = document.createDocumentFragment(), l = (c) => {
      let d;
      const u = c ? this.translate(`${c}Filter`) : void 0;
      switch (c) {
        case "apply":
          d = (g) => this.onBtApply(!1, !1, g);
          break;
        case "clear":
          d = () => this.onBtClear();
          break;
        case "reset":
          d = () => this.onBtReset();
          break;
        case "cancel":
          d = (g) => {
            this.onBtCancel(g);
          };
          break;
        default:
          I(75);
          return;
      }
      const p = ss(
        /* html */
        `<button
                    type="${c === "apply" ? "submit" : "button"}"
                    data-ref="${c}FilterButton"
                    class="ag-button ag-standard-button ag-filter-apply-panel-button"
                >${u}
                </button>`
      );
      this.buttonListeners.push(...this.addManagedElementListeners(p, { click: d })), a.append(p);
    };
    r.forEach((c) => l(c)), this.eButtonsPanel.append(a), this.getGui().appendChild(this.eButtonsPanel);
  }
  setupOnBtApplyDebounce() {
    const e = bh(this.params, this.defaultDebounceMs), t = Et(this, this.checkApplyDebounce.bind(this), e);
    this.onBtApplyDebounce = () => {
      this.debouncePending = !0, t();
    };
  }
  checkApplyDebounce() {
    this.debouncePending && (this.debouncePending = !1, this.onBtApply());
  }
  getModel() {
    return this.appliedModel ?? null;
  }
  setModel(e) {
    return (e != null ? this.setModelIntoUi(e) : this.resetUiToDefaults()).then(() => {
      this.updateUiVisibility(), this.applyModel("api");
    });
  }
  onBtCancel(e) {
    this.resetUiToActiveModel(this.getModel(), () => {
      this.handleCancelEnd(e);
    });
  }
  handleCancelEnd(e) {
    this.params.closeOnApply && this.close(e);
  }
  resetUiToActiveModel(e, t) {
    const s = () => {
      this.onUiChanged(!1, "prevent"), t == null || t();
    };
    e != null ? this.setModelIntoUi(e).then(s) : this.resetUiToDefaults().then(s);
  }
  onBtClear() {
    this.resetUiToDefaults().then(() => this.onUiChanged());
  }
  onBtReset() {
    this.onBtClear(), this.onBtApply();
  }
  /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  applyModel(e = "api") {
    const t = this.getModelFromUi();
    if (!this.isModelValid(t))
      return !1;
    const s = this.appliedModel;
    return this.appliedModel = t, !this.areModelsEqual(s, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isModelValid(e) {
    return !0;
  }
  onFormSubmit(e) {
    e.preventDefault();
  }
  onBtApply(e = !1, t = !1, s) {
    s && s.preventDefault(), this.applyModel(t ? "rowDataUpdated" : "ui") && this.params.filterChangedCallback({ afterFloatingFilter: e, afterDataChange: t, source: "columnFilter" });
    const { closeOnApply: i } = this.params;
    i && this.applyActive && !e && !t && this.close(s);
  }
  onNewRowsLoaded() {
  }
  close(e) {
    if (!this.hidePopup)
      return;
    const t = e, s = t && t.key;
    let i;
    (s === "Enter" || s === "Space") && (i = { keyboardEvent: t }), this.hidePopup(i), this.hidePopup = null;
  }
  /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */
  onUiChanged(e = !1, t) {
    if (this.updateUiVisibility(), this.params.filterModifiedCallback(), this.applyActive && !this.isReadOnly()) {
      const s = this.isModelValid(this.getModelFromUi()), i = this.queryForHtmlElement('[data-ref="applyFilterButton"]');
      i && Bs(i, !s);
    }
    e && !t || t === "immediately" ? this.onBtApply(e) : (!this.applyActive && !t || t === "debounce") && this.onBtApplyDebounce();
  }
  afterGuiAttached(e) {
    e && (this.hidePopup = e.hidePopup), this.refreshFilterResizer(e == null ? void 0 : e.container);
  }
  refreshFilterResizer(e) {
    const { positionableFeature: t, gos: s } = this;
    if (!t || e === "toolPanel")
      return;
    e === "floatingFilter" || e === "columnFilter" ? (t.restoreLastSize(), t.setResizable(
      s.get("enableRtl") ? { bottom: !0, bottomLeft: !0, left: !0 } : { bottom: !0, bottomRight: !0, right: !0 }
    )) : (t.removeSizeFromEl(), t.setResizable(!1)), t.constrainSizeToAvailableHeight(!0);
  }
  afterGuiDetached() {
    var e;
    this.checkApplyDebounce(), (e = this.positionableFeature) == null || e.constrainSizeToAvailableHeight(!1);
  }
  refresh(e) {
    const t = this.params;
    return this.params = e, this.resetButtonsPanel(e, t), !0;
  }
  destroy() {
    const e = this.getGui();
    e && e.removeEventListener("submit", this.onFormSubmit), this.hidePopup = null, this.positionableFeature && (this.positionableFeature = this.destroyBean(this.positionableFeature)), this.appliedModel = null, super.destroy();
  }
  translate(e) {
    return this.getLocaleTextFunc()(e, Sw[e]);
  }
  getCellValue(e) {
    return this.params.getValue(e);
  }
  // override to control positionable feature
  getPositionableElement() {
    return this.eFilterBody;
  }
};
function xw(e, t, s) {
  if (t == null)
    return null;
  let i = null;
  const { compName: r, jsComp: n, fwComp: o } = iE(e, t);
  return r ? i = {
    agSetColumnFilter: "agSetColumnFloatingFilter",
    agMultiColumnFilter: "agMultiColumnFloatingFilter",
    agGroupColumnFilter: "agGroupColumnFloatingFilter",
    agNumberColumnFilter: "agNumberColumnFloatingFilter",
    agDateColumnFilter: "agDateColumnFloatingFilter",
    agTextColumnFilter: "agTextColumnFloatingFilter"
  }[r] : n == null && o == null && t.filter === !0 && (i = s()), i;
}
var ei = {
  AUTO_HEIGHT: "ag-layout-auto-height",
  NORMAL: "ag-layout-normal",
  PRINT: "ag-layout-print"
}, Sh = class extends L {
  constructor(e) {
    super(), this.view = e;
  }
  postConstruct() {
    this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this)), this.updateLayoutClasses();
  }
  updateLayoutClasses() {
    const e = this.gos.get("domLayout"), t = {
      autoHeight: e === "autoHeight",
      normal: e === "normal",
      print: e === "print"
    }, s = t.autoHeight ? ei.AUTO_HEIGHT : t.print ? ei.PRINT : ei.NORMAL;
    this.view.updateLayoutClasses(s, t);
  }
}, ar = "Viewport", qg = "fakeVScrollComp", Yg = [
  "fakeHScrollComp",
  "centerHeader",
  "topCenter",
  "bottomCenter",
  "stickyTopCenter",
  "stickyBottomCenter"
], WE = class extends L {
  constructor(e) {
    super(), this.lastScrollSource = [null, null], this.scrollLeft = -1, this.nextScrollTop = -1, this.scrollTop = -1, this.lastOffsetHeight = -1, this.lastScrollTop = -1, this.scrollTimer = 0, this.needsRefreshedScrollPosition = !0, this.eBodyViewport = e, this.resetLastHScrollDebounced = Et(
      this,
      () => this.lastScrollSource[
        1
        /* Horizontal */
      ] = null,
      500
    ), this.resetLastVScrollDebounced = Et(
      this,
      () => this.lastScrollSource[
        0
        /* Vertical */
      ] = null,
      500
    );
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.animationFrameSvc = e.animationFrameSvc, this.visibleCols = e.visibleCols;
  }
  destroy() {
    super.destroy(), window.clearTimeout(this.scrollTimer);
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl");
    const e = this.requireUpdatedScrollPosition.bind(this);
    this.addManagedEventListeners({
      displayedColumnsWidthChanged: this.onDisplayedColumnsWidthChanged.bind(this),
      gridSizeChanged: e
    }), this.addManagedElementListeners(this.eBodyViewport, {
      scroll: e
    }), this.ctrlsSvc.whenReady(this, (t) => {
      this.centerRowsCtrl = t.center, this.onDisplayedColumnsWidthChanged(), this.addScrollListener();
    });
  }
  requireUpdatedScrollPosition() {
    this.needsRefreshedScrollPosition = !0;
  }
  addScrollListener() {
    this.addHorizontalScrollListeners(), this.addVerticalScrollListeners();
  }
  addHorizontalScrollListeners() {
    this.addManagedElementListeners(this.centerRowsCtrl.eViewport, {
      scroll: this.onHScroll.bind(this, ar)
    });
    for (const e of Yg) {
      const t = this.ctrlsSvc.get(e);
      this.registerScrollPartner(t, this.onHScroll.bind(this, e));
    }
  }
  addVerticalScrollListeners() {
    const e = this.ctrlsSvc.get("fakeVScrollComp"), t = this.gos.get("debounceVerticalScrollbar"), s = t ? Et(this, this.onVScroll.bind(this, ar), 100) : this.onVScroll.bind(this, ar), i = t ? Et(this, this.onVScroll.bind(this, qg), 100) : this.onVScroll.bind(this, qg);
    this.addManagedElementListeners(this.eBodyViewport, { scroll: s }), this.registerScrollPartner(e, i);
  }
  registerScrollPartner(e, t) {
    e.onScrollCallback(t);
  }
  onDisplayedColumnsWidthChanged() {
    this.enableRtl && this.horizontallyScrollHeaderCenterAndFloatingCenter();
  }
  horizontallyScrollHeaderCenterAndFloatingCenter(e) {
    this.centerRowsCtrl != null && (e === void 0 && (e = this.centerRowsCtrl.getCenterViewportScrollLeft()), this.setScrollLeftForAllContainersExceptCurrent(Math.abs(e)));
  }
  setScrollLeftForAllContainersExceptCurrent(e) {
    for (const t of [...Yg, ar]) {
      if (this.lastScrollSource[
        1
        /* Horizontal */
      ] === t)
        continue;
      const s = this.getViewportForSource(t);
      xl(s, e, this.enableRtl);
    }
  }
  getViewportForSource(e) {
    return e === ar ? this.centerRowsCtrl.eViewport : this.ctrlsSvc.get(e).eViewport;
  }
  isControllingScroll(e, t) {
    return this.lastScrollSource[t] == null ? (t === 0 ? this.lastScrollSource[0] = e : this.lastScrollSource[1] = e, !0) : this.lastScrollSource[t] === e;
  }
  onHScroll(e) {
    if (!this.isControllingScroll(
      e,
      1
      /* Horizontal */
    ))
      return;
    const t = this.centerRowsCtrl.eViewport, { scrollLeft: s } = t;
    if (this.shouldBlockScrollUpdate(1, s, !0))
      return;
    const i = Sl(this.getViewportForSource(e), this.enableRtl);
    this.doHorizontalScroll(i), this.resetLastHScrollDebounced();
  }
  onVScroll(e) {
    if (!this.isControllingScroll(
      e,
      0
      /* Vertical */
    ))
      return;
    let t;
    if (e === ar ? t = this.eBodyViewport.scrollTop : t = this.ctrlsSvc.get("fakeVScrollComp").getScrollPosition(), this.shouldBlockScrollUpdate(0, t, !0))
      return;
    const { animationFrameSvc: s } = this;
    s == null || s.setScrollTop(t), this.nextScrollTop = t, e === ar ? this.ctrlsSvc.get("fakeVScrollComp").setScrollPosition(t) : this.eBodyViewport.scrollTop = t, !s || this.gos.get("suppressAnimationFrame") ? this.scrollGridIfNeeded() : s.schedule(), this.resetLastVScrollDebounced();
  }
  doHorizontalScroll(e) {
    const t = this.ctrlsSvc.get("fakeHScrollComp").getScrollPosition();
    this.scrollLeft === e && e === t || (this.scrollLeft = e, this.fireScrollEvent(
      1
      /* Horizontal */
    ), this.horizontallyScrollHeaderCenterAndFloatingCenter(e), this.centerRowsCtrl.onHorizontalViewportChanged(!0));
  }
  fireScrollEvent(e) {
    const t = {
      type: "bodyScroll",
      direction: e === 1 ? "horizontal" : "vertical",
      left: this.scrollLeft,
      top: this.scrollTop
    };
    this.eventSvc.dispatchEvent(t), window.clearTimeout(this.scrollTimer), this.scrollTimer = window.setTimeout(() => {
      this.scrollTimer = 0, this.eventSvc.dispatchEvent({
        ...t,
        type: "bodyScrollEnd"
      });
    }, 100);
  }
  shouldBlockScrollUpdate(e, t, s = !1) {
    return s && !yr() ? !1 : e === 0 ? this.shouldBlockVerticalScroll(t) : this.shouldBlockHorizontalScroll(t);
  }
  shouldBlockVerticalScroll(e) {
    const t = nc(this.eBodyViewport), { scrollHeight: s } = this.eBodyViewport;
    return e < 0 || e + t > s;
  }
  shouldBlockHorizontalScroll(e) {
    const t = this.centerRowsCtrl.getCenterWidth(), { scrollWidth: s } = this.centerRowsCtrl.eViewport;
    if (this.enableRtl && bl()) {
      if (e > 0)
        return !0;
    } else if (e < 0)
      return !0;
    return Math.abs(e) + t > s;
  }
  redrawRowsAfterScroll() {
    this.fireScrollEvent(
      0
      /* Vertical */
    );
  }
  // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
  // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
  // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
  // back to the left to be kept in sync.
  // adding and removing the grid from the DOM both resets the scroll position and
  // triggers a resize event, so notify listeners if the scroll position has changed
  checkScrollLeft() {
    this.scrollLeft !== this.centerRowsCtrl.getCenterViewportScrollLeft() && this.onHScroll(ar);
  }
  scrollGridIfNeeded() {
    const e = this.scrollTop != this.nextScrollTop;
    return e && (this.scrollTop = this.nextScrollTop, this.redrawRowsAfterScroll()), e;
  }
  // called by scrollHorizontally method and alignedGridsService
  setHorizontalScrollPosition(e, t = !1) {
    const i = this.centerRowsCtrl.eViewport.scrollWidth - this.centerRowsCtrl.getCenterWidth();
    !t && this.shouldBlockScrollUpdate(1, e) && (this.enableRtl && bl() ? e = e > 0 ? 0 : i : e = Math.min(Math.max(e, 0), i)), xl(this.centerRowsCtrl.eViewport, Math.abs(e), this.enableRtl), this.doHorizontalScroll(e);
  }
  setVerticalScrollPosition(e) {
    this.eBodyViewport.scrollTop = e;
  }
  getVScrollPosition() {
    if (!this.needsRefreshedScrollPosition) {
      const { lastOffsetHeight: s, lastScrollTop: i } = this;
      return {
        top: i,
        bottom: i + s
      };
    }
    this.needsRefreshedScrollPosition = !1;
    const { scrollTop: e, offsetHeight: t } = this.eBodyViewport;
    return this.lastScrollTop = e, this.lastOffsetHeight = t, {
      top: e,
      bottom: e + t
    };
  }
  /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */
  getApproximateVScollPosition() {
    return this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0 ? {
      top: this.scrollTop,
      bottom: this.scrollTop + this.lastOffsetHeight
    } : this.getVScrollPosition();
  }
  getHScrollPosition() {
    return this.centerRowsCtrl.getHScrollPosition();
  }
  isHorizontalScrollShowing() {
    return this.centerRowsCtrl.isHorizontalScrollShowing();
  }
  // called by the headerRootComp and moveColumnController
  scrollHorizontally(e) {
    const t = this.centerRowsCtrl.eViewport.scrollLeft;
    return this.setHorizontalScrollPosition(t + e), this.centerRowsCtrl.eViewport.scrollLeft - t;
  }
  // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
  scrollToTop() {
    this.eBodyViewport.scrollTop = 0;
  }
  // Valid values for position are bottom, middle and top
  ensureNodeVisible(e, t = null) {
    const { rowModel: s } = this.beans, i = s.getRowCount();
    let r = -1;
    for (let n = 0; n < i; n++) {
      const o = s.getRow(n);
      if (typeof e == "function") {
        if (o && e(o)) {
          r = n;
          break;
        }
      } else if (e === o || e === o.data) {
        r = n;
        break;
      }
    }
    r >= 0 && this.ensureIndexVisible(r, t);
  }
  // Valid values for position are bottom, middle and top
  // position should be {'top','middle','bottom', or undefined/null}.
  // if undefined/null, then the grid will to the minimal amount of scrolling,
  // eg if grid needs to scroll up, it scrolls until row is on top,
  //    if grid needs to scroll down, it scrolls until row is on bottom,
  //    if row is already in view, grid does not scroll
  ensureIndexVisible(e, t) {
    if (It(this.gos, "print"))
      return;
    const { rowModel: s } = this.beans, i = s.getRowCount();
    if (typeof e != "number" || e < 0 || e >= i) {
      I(88, { index: e });
      return;
    }
    const n = this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel"), {
      frameworkOverrides: o,
      pagination: a,
      pageBounds: l,
      rowContainerHeight: c,
      rowRenderer: d
    } = this.beans;
    o.wrapIncoming(() => {
      var m;
      n || a == null || a.goToPageWithIndex(e);
      const u = this.ctrlsSvc.getGridBodyCtrl(), h = u.stickyTopHeight, p = u.stickyBottomHeight, g = s.getRow(e);
      let f;
      do {
        const C = g.rowTop, w = g.rowHeight, y = l.getPixelOffset(), b = g.rowTop - y, x = b + g.rowHeight, M = this.getVScrollPosition(), T = c.divStretchOffset, F = M.top + T, k = M.bottom + T, O = k - F, D = c.getScrollPositionForPixel(b), $ = c.getScrollPositionForPixel(x - O), j = Math.min((D + $) / 2, b), J = F + h > b, X = k - p < x;
        let ie = null;
        t === "top" ? ie = D : t === "bottom" ? ie = $ : t === "middle" ? ie = j : J ? ie = D - h : X && (ie = $ + p), ie !== null && (this.setVerticalScrollPosition(ie), d.redraw({ afterScroll: !0 })), f = C !== g.rowTop || w !== g.rowHeight;
      } while (f);
      (m = this.animationFrameSvc) == null || m.flushAllFrames();
    });
  }
  ensureColumnVisible(e, t = "auto") {
    const { colModel: s, frameworkOverrides: i } = this.beans, r = s.getCol(e);
    if (!r || r.isPinned() || !this.visibleCols.isColDisplayed(r))
      return;
    const n = this.getPositionedHorizontalScroll(r, t);
    i.wrapIncoming(() => {
      var o;
      n !== null && this.centerRowsCtrl.setCenterViewportScrollLeft(n), this.centerRowsCtrl.onHorizontalViewportChanged(), (o = this.animationFrameSvc) == null || o.flushAllFrames();
    });
  }
  getPositionedHorizontalScroll(e, t) {
    const { columnBeforeStart: s, columnAfterEnd: i } = this.isColumnOutsideViewport(e), r = this.centerRowsCtrl.getCenterWidth() < e.getActualWidth(), n = this.centerRowsCtrl.getCenterWidth(), o = this.enableRtl;
    let a = (o ? s : i) || r, l = o ? i : s;
    t !== "auto" && (a = t === "start", l = t === "end");
    const c = t === "middle";
    if (a || l || c) {
      const { colLeft: d, colMiddle: u, colRight: h } = this.getColumnBounds(e);
      return c ? u - n / 2 : a ? o ? h : d : o ? d - n : h - n;
    }
    return null;
  }
  isColumnOutsideViewport(e) {
    const { start: t, end: s } = this.getViewportBounds(), { colLeft: i, colRight: r } = this.getColumnBounds(e), n = this.enableRtl, o = n ? t > r : s < r, a = n ? s < i : t > i;
    return { columnBeforeStart: o, columnAfterEnd: a };
  }
  getColumnBounds(e) {
    const t = this.enableRtl, s = this.visibleCols.bodyWidth, i = e.getActualWidth(), r = e.getLeft(), n = t ? -1 : 1, o = t ? s - r : r, a = o + i * n, l = o + i / 2 * n;
    return { colLeft: o, colMiddle: l, colRight: a };
  }
  getViewportBounds() {
    const e = this.centerRowsCtrl.getCenterWidth(), t = this.centerRowsCtrl.getCenterViewportScrollLeft(), s = t, i = e + t;
    return { start: s, end: i, width: e };
  }
}, xh = class extends L {
  constructor(e, t = !1) {
    super(), this.callback = e, this.addSpacer = t;
  }
  postConstruct() {
    const e = this.setWidth.bind(this);
    this.addManagedPropertyListener("domLayout", e), this.addManagedEventListeners({
      columnContainerWidthChanged: e,
      displayedColumnsChanged: e,
      leftPinnedWidthChanged: e
    }), this.addSpacer && this.addManagedEventListeners({
      rightPinnedWidthChanged: e,
      scrollVisibilityChanged: e,
      scrollbarWidthChanged: e
    }), this.setWidth();
  }
  setWidth() {
    const e = It(this.gos, "print"), { visibleCols: t, scrollVisibleSvc: s } = this.beans, i = t.bodyWidth, r = t.getColsLeftWidth(), n = t.getDisplayedColumnsRightWidth();
    let o;
    e ? o = i + r + n : (o = i, this.addSpacer && (this.gos.get("enableRtl") ? r : n) === 0 && s.verticalScrollShowing && (o += s.getScrollbarWidth())), this.callback(o);
  }
}, _E = class extends L {
  constructor(e) {
    super(), this.centerContainerCtrl = e;
  }
  wireBeans(e) {
    this.scrollVisibleSvc = e.scrollVisibleSvc;
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.listenForResize();
    }), this.addManagedEventListeners({ scrollbarWidthChanged: this.onScrollbarWidthChanged.bind(this) }), this.addManagedPropertyListeners(["alwaysShowHorizontalScroll", "alwaysShowVerticalScroll"], () => {
      this.checkViewportAndScrolls();
    });
  }
  listenForResize() {
    const { beans: e, centerContainerCtrl: t, gridBodyCtrl: s } = this, i = () => {
      _s(e, () => {
        this.onCenterViewportResized();
      });
    };
    t.registerViewportResizeListener(i), s.registerBodyViewportResizeListener(i);
  }
  onScrollbarWidthChanged() {
    this.checkViewportAndScrolls();
  }
  onCenterViewportResized() {
    if (this.scrollVisibleSvc.updateScrollGap(), this.centerContainerCtrl.isViewportInTheDOMTree()) {
      const { pinnedCols: e, colFlex: t } = this.beans;
      e == null || e.keepPinnedColumnsNarrowerThanViewport(), this.checkViewportAndScrolls();
      const s = this.centerContainerCtrl.getCenterWidth();
      s !== this.centerWidth && (this.centerWidth = s, t == null || t.refreshFlexedColumns({
        viewportWidth: this.centerWidth,
        updateBodyWidths: !0,
        fireResizedEvent: !0
      }));
    } else
      this.bodyHeight = 0;
  }
  // gets called every time the viewport size changes. we use this to check visibility of scrollbars
  // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
  checkViewportAndScrolls() {
    this.updateScrollVisibleService(), this.checkBodyHeight(), this.onHorizontalViewportChanged(), this.gridBodyCtrl.scrollFeature.checkScrollLeft();
  }
  getBodyHeight() {
    return this.bodyHeight;
  }
  checkBodyHeight() {
    const e = this.gridBodyCtrl.eBodyViewport, t = nc(e);
    this.bodyHeight !== t && (this.bodyHeight = t, this.eventSvc.dispatchEvent({
      type: "bodyHeightChanged"
    }));
  }
  updateScrollVisibleService() {
    this.updateScrollVisibleServiceImpl(), setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
  }
  updateScrollVisibleServiceImpl() {
    const e = {
      horizontalScrollShowing: this.centerContainerCtrl.isHorizontalScrollShowing(),
      verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
    };
    this.scrollVisibleSvc.setScrollsVisible(e);
  }
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
  onHorizontalViewportChanged() {
    const e = this.centerContainerCtrl.getCenterWidth(), t = this.centerContainerCtrl.getViewportScrollLeft();
    this.beans.colViewport.setScrollPosition(e, t);
  }
};
function Rh(e, t, s, i, r, n) {
  if (s == null && t == null)
    return;
  const o = {}, a = {}, l = (c, d) => {
    c.split(" ").forEach((u) => {
      u.trim() != "" && d(u);
    });
  };
  if (s) {
    const c = Object.keys(s);
    for (let d = 0; d < c.length; d++) {
      const u = c[d], h = s[u];
      let p;
      typeof h == "string" ? p = e ? e.evaluate(h, i) : !0 : typeof h == "function" && (p = h(i)), l(u, (g) => {
        p ? o[g] = !0 : a[g] = !0;
      });
    }
  }
  t && n && Object.keys(t).forEach(
    (c) => l(c, (d) => {
      o[d] || (a[d] = !0);
    })
  ), n && Object.keys(a).forEach(n), Object.keys(o).forEach(r);
}
function Xg(e) {
  if (e.group)
    return e.level;
  const t = e.parent;
  return t ? t.level + 1 : 0;
}
var UE = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowStyleSvc";
  }
  processClassesFromGridOptions(e, t) {
    const s = this.gos, i = (o) => {
      typeof o == "string" ? e.push(o) : Array.isArray(o) && o.forEach((a) => e.push(a));
    }, r = s.get("rowClass");
    r && i(r);
    const n = s.getCallback("getRowClass");
    if (n) {
      const o = {
        data: t.data,
        node: t,
        rowIndex: t.rowIndex
      }, a = n(o);
      i(a);
    }
  }
  preProcessRowClassRules(e, t) {
    this.processRowClassRules(
      t,
      (s) => {
        e.push(s);
      },
      () => {
      }
    );
  }
  processRowClassRules(e, t, s) {
    const { gos: i, expressionSvc: r } = this.beans, n = i.addGridCommonParams({
      data: e.data,
      node: e,
      rowIndex: e.rowIndex
    });
    Rh(
      r,
      void 0,
      i.get("rowClassRules"),
      n,
      t,
      s
    );
  }
  processStylesFromGridOptions(e) {
    const t = this.gos, s = t.get("rowStyle"), i = t.getCallback("getRowStyle");
    let r;
    if (i) {
      const n = {
        data: e.data,
        node: e,
        rowIndex: e.rowIndex
      };
      r = i(n);
    }
    if (r || s)
      return Object.assign({}, s, r);
  }
}, $E = 0, aa = "renderedRow", cu = class extends L {
  constructor(e, t, s, i, r) {
    var n;
    super(), this.rowNode = e, this.useAnimationFrameForCreate = i, this.printLayout = r, this.allRowGuis = [], this.active = !0, this.centerCellCtrls = { list: [], map: {} }, this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} }, this.slideInAnimation = {
      left: !1,
      center: !1,
      right: !1,
      fullWidth: !1
    }, this.fadeInAnimation = {
      left: !1,
      center: !1,
      right: !1,
      fullWidth: !1
    }, this.rowDragComps = [], this.lastMouseDownOnDragger = !1, this.emptyStyle = {}, this.updateColumnListsPending = !1, this.rowId = null, this.businessKey = null, this.beans = t, this.gos = t.gos, this.paginationPage = ((n = t.pagination) == null ? void 0 : n.getCurrentPage()) ?? 0, this.suppressRowTransform = this.gos.get("suppressRowTransform"), this.instanceId = e.id + "-" + $E++, this.rowId = Ke(e.id), this.initRowBusinessKey(), this.rowFocused = t.focusSvc.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned), this.rowLevel = Xg(this.rowNode), this.setRowType(), this.setAnimateFlags(s), this.rowStyles = this.processStylesFromGridOptions(), this.addListeners();
  }
  initRowBusinessKey() {
    this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode"), this.updateRowBusinessKey();
  }
  updateRowBusinessKey() {
    if (typeof this.businessKeyForNodeFunc != "function")
      return;
    const e = this.businessKeyForNodeFunc(this.rowNode);
    this.businessKey = Ke(e);
  }
  updateGui(e, t) {
    e === "left" ? this.leftGui = t : e === "right" ? this.rightGui = t : e === "fullWidth" ? this.fullWidthGui = t : this.centerGui = t;
  }
  setComp(e, t, s, i) {
    i = pa(this, this.beans.context, i);
    const r = { rowComp: e, element: t, containerType: s, compBean: i };
    this.allRowGuis.push(r), this.updateGui(s, r), this.initialiseRowComp(r), this.rowType !== "FullWidthLoading" && !this.rowNode.rowPinned && this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
  }
  unsetComp(e) {
    this.allRowGuis = this.allRowGuis.filter((t) => t.containerType !== e), this.updateGui(e, void 0);
  }
  isCacheable() {
    return this.rowType === "FullWidthDetail" && this.gos.get("keepDetailRows");
  }
  setCached(e) {
    const t = e ? "none" : "";
    this.allRowGuis.forEach((s) => s.element.style.display = t);
  }
  initialiseRowComp(e) {
    var r;
    const t = this.gos;
    this.onSuppressCellFocusChanged(this.beans.gos.get("suppressCellFocus")), this.listenOnDomOrder(e), (r = this.beans.rowAutoHeight) == null || r.checkAutoHeights(this.rowNode), this.onRowHeightChanged(e), this.updateRowIndexes(e), this.setFocusedClasses(e), this.setStylesFromGridOptions(!1, e), Es(t) && this.rowNode.selectable && this.onRowSelected(e), this.updateColumnLists(!this.useAnimationFrameForCreate);
    const s = e.rowComp;
    this.getInitialRowClasses(e.containerType).forEach((n) => s.addOrRemoveCssClass(n, !0)), this.executeSlideAndFadeAnimations(e), this.rowNode.group && ns(e.element, this.rowNode.expanded == !0), this.setRowCompRowId(s), this.setRowCompRowBusinessKey(s), fn(t, e.element, aa, this), e.compBean.addDestroyFunc(() => fn(t, e.element, aa, null)), this.useAnimationFrameForCreate ? this.beans.animationFrameSvc.createTask(
      this.addHoverFunctionality.bind(this, e),
      this.rowNode.rowIndex,
      "createTasksP2"
    ) : this.addHoverFunctionality(e), this.isFullWidth() && this.setupFullWidth(e), t.get("rowDragEntireRow") && this.addRowDraggerToRow(e), this.useAnimationFrameForCreate && this.beans.animationFrameSvc.addDestroyTask(() => {
      this.isAlive() && e.rowComp.addOrRemoveCssClass("ag-after-created", !0);
    }), this.executeProcessRowPostCreateFunc();
  }
  setRowCompRowBusinessKey(e) {
    this.businessKey != null && e.setRowBusinessKey(this.businessKey);
  }
  setRowCompRowId(e) {
    const t = Ke(this.rowNode.id);
    this.rowId = t, t != null && e.setRowId(t);
  }
  executeSlideAndFadeAnimations(e) {
    const { containerType: t } = e;
    this.slideInAnimation[t] && (Ng(() => {
      this.onTopChanged();
    }), this.slideInAnimation[t] = !1), this.fadeInAnimation[t] && (Ng(() => {
      e.rowComp.addOrRemoveCssClass("ag-opacity-zero", !1);
    }), this.fadeInAnimation[t] = !1);
  }
  addRowDraggerToRow(e) {
    var i;
    const t = (i = this.beans.rowDragSvc) == null ? void 0 : i.createRowDragCompForRow(this.rowNode, e.element);
    if (!t)
      return;
    const s = this.createBean(t, this.beans.context);
    this.rowDragComps.push(s), e.compBean.addDestroyFunc(() => {
      this.rowDragComps = this.rowDragComps.filter((r) => r !== s), this.destroyBean(s, this.beans.context);
    });
  }
  setupFullWidth(e) {
    const t = this.getPinnedForContainer(e.containerType), s = this.createFullWidthCompDetails(e.element, t);
    e.rowComp.showFullWidth(s);
  }
  getFullWidthCellRenderers() {
    var e, t;
    return this.gos.get("embedFullWidthRows") ? this.allRowGuis.map((s) => {
      var i;
      return (i = s == null ? void 0 : s.rowComp) == null ? void 0 : i.getFullWidthCellRenderer();
    }) : [(t = (e = this.fullWidthGui) == null ? void 0 : e.rowComp) == null ? void 0 : t.getFullWidthCellRenderer()];
  }
  executeProcessRowPostCreateFunc() {
    const e = this.gos.getCallback("processRowPostCreate");
    if (!e || !this.areAllContainersReady())
      return;
    const t = {
      // areAllContainersReady asserts that centerGui is not null
      eRow: this.centerGui.element,
      ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
      ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
      node: this.rowNode,
      rowIndex: this.rowNode.rowIndex,
      addRenderedRowListener: this.addEventListener.bind(this)
    };
    e(t);
  }
  areAllContainersReady() {
    const {
      leftGui: e,
      centerGui: t,
      rightGui: s,
      beans: { visibleCols: i }
    } = this, r = !!e || !i.isPinningLeft(), n = !!t, o = !!s || !i.isPinningRight();
    return r && n && o;
  }
  isNodeFullWidthCell() {
    if (this.rowNode.detail)
      return !0;
    const e = this.beans.gos.getCallback("isFullWidthRow");
    return e ? e({ rowNode: this.rowNode }) : !1;
  }
  setRowType() {
    const e = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow") && !this.gos.get("groupHideOpenParents"), t = this.isNodeFullWidthCell(), s = this.gos.get("masterDetail") && this.rowNode.detail, i = this.beans.colModel.isPivotMode(), n = !!this.rowNode.group && !this.rowNode.footer && uc(this.gos, i);
    e ? this.rowType = "FullWidthLoading" : s ? this.rowType = "FullWidthDetail" : t ? this.rowType = "FullWidth" : n ? this.rowType = "FullWidthGroup" : this.rowType = "Normal";
  }
  updateColumnLists(e = !1, t = !1) {
    if (this.isFullWidth())
      return;
    const { animationFrameSvc: s } = this.beans;
    if (!s || e || this.gos.get("suppressAnimationFrame") || this.printLayout) {
      this.updateColumnListsImpl(t);
      return;
    }
    this.updateColumnListsPending || (s.createTask(
      () => {
        this.active && this.updateColumnListsImpl(!0);
      },
      this.rowNode.rowIndex,
      "createTasksP1"
    ), this.updateColumnListsPending = !0);
  }
  createCellCtrls(e, t, s = null) {
    const i = {
      list: [],
      map: {}
    }, r = (n, o) => {
      i.list.push(o), i.map[n] = o;
    };
    return t.forEach((n) => {
      const o = n.getInstanceId();
      let a = e.map[o];
      a || (a = new cl(n, this.rowNode, this.beans, this)), r(o, a);
    }), e.list.forEach((n) => {
      const o = n.column.getInstanceId();
      if (i.map[o] != null)
        return;
      if (!this.isCellEligibleToBeRemoved(n, s)) {
        r(o, n);
        return;
      }
      n.destroy();
    }), i;
  }
  updateColumnListsImpl(e) {
    this.updateColumnListsPending = !1, this.createAllCellCtrls(), this.setCellCtrls(e);
  }
  setCellCtrls(e) {
    this.allRowGuis.forEach((t) => {
      const s = this.getCellCtrlsForContainer(t.containerType);
      t.rowComp.setCellCtrls(s, e);
    });
  }
  getCellCtrlsForContainer(e) {
    switch (e) {
      case "left":
        return this.leftCellCtrls.list;
      case "right":
        return this.rightCellCtrls.list;
      case "fullWidth":
        return [];
      case "center":
        return this.centerCellCtrls.list;
    }
  }
  createAllCellCtrls() {
    const e = this.beans.colViewport, t = this.beans.visibleCols;
    if (this.printLayout)
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, t.allCols), this.leftCellCtrls = { list: [], map: {} }, this.rightCellCtrls = { list: [], map: {} };
    else {
      const s = e.getColsWithinViewport(this.rowNode);
      this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, s);
      const i = t.getLeftColsForRow(this.rowNode);
      this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, i, "left");
      const r = t.getRightColsForRow(this.rowNode);
      this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, r, "right");
    }
  }
  isCellEligibleToBeRemoved(e, t) {
    const { column: r } = e;
    if (r.getPinned() != t)
      return !0;
    const { editing: n, cellPosition: o } = e, { focusSvc: a, visibleCols: l } = this.beans, c = a.isCellFocused(o);
    return n || c ? !(l.allCols.indexOf(r) >= 0) : !0;
  }
  getDomOrder() {
    return this.gos.get("ensureDomOrder") || It(this.gos, "print");
  }
  listenOnDomOrder(e) {
    const t = () => {
      e.rowComp.setDomOrder(this.getDomOrder());
    };
    e.compBean.addManagedPropertyListeners(["domLayout", "ensureDomOrder"], t);
  }
  setAnimateFlags(e) {
    if (this.rowNode.sticky || !e)
      return;
    const t = W(this.rowNode.oldRowTop), { visibleCols: s } = this.beans, i = s.isPinningLeft(), r = s.isPinningRight();
    if (t) {
      const { slideInAnimation: n } = this;
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
        n.fullWidth = !0;
        return;
      }
      n.center = !0, n.left = i, n.right = r;
    } else {
      const { fadeInAnimation: n } = this;
      if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
        n.fullWidth = !0;
        return;
      }
      n.center = !0, n.left = i, n.right = r;
    }
  }
  isFullWidth() {
    return this.rowType !== "Normal";
  }
  refreshFullWidth() {
    const e = (o, a) => o ? o.rowComp.refreshFullWidth(() => this.createFullWidthCompDetails(o.element, a).params) : !0, t = e(this.fullWidthGui, null), s = e(this.centerGui, null), i = e(this.leftGui, "left"), r = e(this.rightGui, "right");
    return t && s && i && r;
  }
  addListeners() {
    var e;
    this.addManagedListeners(this.rowNode, {
      heightChanged: () => this.onRowHeightChanged(),
      rowSelected: () => this.onRowSelected(),
      rowIndexChanged: this.onRowIndexChanged.bind(this),
      topChanged: this.onTopChanged.bind(this),
      ...((e = this.beans.expansionSvc) == null ? void 0 : e.getRowExpandedListeners(this)) ?? {}
    }), this.rowNode.detail && this.addManagedListeners(this.rowNode.parent, { dataChanged: this.onRowNodeDataChanged.bind(this) }), this.addManagedListeners(this.rowNode, {
      dataChanged: this.onRowNodeDataChanged.bind(this),
      cellChanged: this.postProcessCss.bind(this),
      rowHighlightChanged: this.onRowNodeHighlightChanged.bind(this),
      draggingChanged: this.postProcessRowDragging.bind(this),
      uiLevelChanged: this.onUiLevelChanged.bind(this)
    }), this.addManagedListeners(this.beans.eventSvc, {
      paginationPixelOffsetChanged: this.onPaginationPixelOffsetChanged.bind(this),
      heightScaleChanged: this.onTopChanged.bind(this),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      virtualColumnsChanged: this.onVirtualColumnsChanged.bind(this),
      cellFocused: this.onCellFocusChanged.bind(this),
      cellFocusCleared: this.onCellFocusChanged.bind(this),
      paginationChanged: this.onPaginationChanged.bind(this),
      modelUpdated: this.refreshFirstAndLastRowStyles.bind(this),
      columnMoved: () => this.updateColumnLists()
    }), this.addDestroyFunc(() => {
      this.rowDragComps = this.destroyBeans(this.rowDragComps, this.beans.context), this.tooltipFeature = this.destroyBean(this.tooltipFeature, this.beans.context);
    }), this.addManagedPropertyListeners(
      ["rowStyle", "getRowStyle", "rowClass", "getRowClass", "rowClassRules"],
      this.postProcessCss.bind(this)
    ), this.addManagedPropertyListener("rowDragEntireRow", () => {
      if (this.gos.get("rowDragEntireRow")) {
        this.allRowGuis.forEach((s) => {
          this.addRowDraggerToRow(s);
        });
        return;
      }
      this.rowDragComps = this.destroyBeans(this.rowDragComps, this.beans.context);
    }), this.addListenersForCellComps();
  }
  addListenersForCellComps() {
    this.addManagedListeners(this.rowNode, {
      rowIndexChanged: () => {
        this.getAllCellCtrls().forEach((e) => e.onRowIndexChanged());
      },
      cellChanged: (e) => {
        this.getAllCellCtrls().forEach((t) => t.onCellChanged(e));
      }
    });
  }
  onRowNodeDataChanged(e) {
    if (this.isFullWidth() !== !!this.isNodeFullWidthCell()) {
      this.beans.rowRenderer.redrawRow(this.rowNode);
      return;
    }
    if (this.isFullWidth()) {
      this.refreshFullWidth() || this.beans.rowRenderer.redrawRow(this.rowNode);
      return;
    }
    this.getAllCellCtrls().forEach(
      (s) => s.refreshCell({
        suppressFlash: !e.update,
        newData: !e.update
      })
    ), this.allRowGuis.forEach((s) => {
      this.setRowCompRowId(s.rowComp), this.updateRowBusinessKey(), this.setRowCompRowBusinessKey(s.rowComp);
    }), this.onRowSelected(), this.postProcessCss();
  }
  postProcessCss() {
    this.setStylesFromGridOptions(!0), this.postProcessClassesFromGridOptions(), this.postProcessRowClassRules(), this.postProcessRowDragging();
  }
  onRowNodeHighlightChanged() {
    const e = this.rowNode.highlighted;
    this.allRowGuis.forEach((t) => {
      const s = e === "Above", i = e === "Below";
      t.rowComp.addOrRemoveCssClass("ag-row-highlight-above", s), t.rowComp.addOrRemoveCssClass("ag-row-highlight-below", i);
    });
  }
  postProcessRowDragging() {
    const e = this.rowNode.dragging;
    this.allRowGuis.forEach((t) => t.rowComp.addOrRemoveCssClass("ag-row-dragging", e));
  }
  onDisplayedColumnsChanged() {
    var e;
    this.updateColumnLists(!0), (e = this.beans.rowAutoHeight) == null || e.checkAutoHeights(this.rowNode);
  }
  onVirtualColumnsChanged() {
    this.updateColumnLists(!1, !0);
  }
  getRowPosition() {
    return {
      rowPinned: St(this.rowNode.rowPinned),
      rowIndex: this.rowNode.rowIndex
    };
  }
  findFullWidthRowGui(e) {
    return this.allRowGuis.find((t) => t.element.contains(e));
  }
  onKeyboardNavigate(e) {
    const t = this.findFullWidthRowGui(e.target);
    if (!((t ? t.element : null) === e.target))
      return;
    const r = this.rowNode, { focusSvc: n, navigation: o } = this.beans, a = n.getFocusedCell(), l = {
      rowIndex: r.rowIndex,
      rowPinned: r.rowPinned,
      column: (a == null ? void 0 : a.column) ?? this.getColumnForFullWidth(t)
    };
    o == null || o.navigateToNextCell(e, e.key, l, !0), e.preventDefault();
  }
  onTabKeyDown(e) {
    var a;
    if (e.defaultPrevented || Ds(e))
      return;
    const t = this.allRowGuis.find(
      (l) => l.element.contains(e.target)
    ), s = t ? t.element : null, i = s === e.target, r = Ie(this.beans);
    let n = !1;
    s && r && (n = s.contains(r) && r.classList.contains("ag-cell"));
    let o = null;
    !i && !n && (o = zt(this.beans, s, !1, e.shiftKey)), (this.isFullWidth() && i || !o) && ((a = this.beans.navigation) == null || a.onTabKeyDown(this, e));
  }
  getFullWidthElement() {
    return this.fullWidthGui ? this.fullWidthGui.element : null;
  }
  getRowYPosition() {
    var t;
    const e = (t = this.allRowGuis.find((s) => Xt(s.element))) == null ? void 0 : t.element;
    return e ? e.getBoundingClientRect().top : 0;
  }
  onSuppressCellFocusChanged(e) {
    const t = this.isFullWidth() && e ? void 0 : -1;
    this.allRowGuis.forEach((s) => {
      zs(s.element, "tabindex", t);
    });
  }
  onFullWidthRowFocused(e) {
    var r;
    const t = this.rowNode, s = e ? this.isFullWidth() && e.rowIndex === t.rowIndex && e.rowPinned == t.rowPinned : !1, i = this.fullWidthGui ? this.fullWidthGui.element : (r = this.centerGui) == null ? void 0 : r.element;
    i && (i.classList.toggle("ag-full-width-focus", s), s && (e != null && e.forceBrowserFocus) && i.focus({ preventScroll: !0 }));
  }
  recreateCell(e) {
    this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, e), this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, e), this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, e), e.destroy(), this.updateColumnLists();
  }
  removeCellCtrl(e, t) {
    const s = {
      list: [],
      map: {}
    };
    return e.list.forEach((i) => {
      i !== t && (s.list.push(i), s.map[i.column.getInstanceId()] = i);
    }), s;
  }
  onMouseEvent(e, t) {
    switch (e) {
      case "dblclick":
        this.onRowDblClick(t);
        break;
      case "click":
        this.onRowClick(t);
        break;
      case "touchstart":
      case "mousedown":
        this.onRowMouseDown(t);
        break;
    }
  }
  createRowEvent(e, t) {
    const { rowNode: s } = this;
    return this.gos.addGridCommonParams({
      type: e,
      node: s,
      data: s.data,
      rowIndex: s.rowIndex,
      rowPinned: s.rowPinned,
      event: t
    });
  }
  createRowEventWithSource(e, t) {
    const s = this.createRowEvent(e, t);
    return s.source = this, s;
  }
  onRowDblClick(e) {
    Ds(e) || this.beans.eventSvc.dispatchEvent(this.createRowEventWithSource("rowDoubleClicked", e));
  }
  getColumnForFullWidth(e) {
    const { visibleCols: t } = this.beans;
    switch (e == null ? void 0 : e.containerType) {
      case "center":
        return t.centerCols[0];
      case "left":
        return t.leftCols[0];
      case "right":
        return t.rightCols[0];
      default:
        return t.allCols[0];
    }
  }
  onRowMouseDown(e) {
    if (this.lastMouseDownOnDragger = an(e.target, "ag-row-drag", 3), !this.isFullWidth())
      return;
    const t = this.rowNode, { rangeSvc: s, focusSvc: i } = this.beans;
    s == null || s.removeAllCellRanges();
    const r = this.findFullWidthRowGui(e.target), n = r == null ? void 0 : r.element, o = e.target;
    let a = !0;
    n && n.contains(o) && nh(o) && (a = !1), i.setFocusedCell({
      rowIndex: t.rowIndex,
      column: this.getColumnForFullWidth(r),
      rowPinned: t.rowPinned,
      forceBrowserFocus: a
    });
  }
  onRowClick(e) {
    if (Ds(e) || this.lastMouseDownOnDragger)
      return;
    const { eventSvc: s, selectionSvc: i } = this.beans;
    s.dispatchEvent(this.createRowEventWithSource("rowClicked", e)), i == null || i.handleSelectionEvent(e, this.rowNode, "rowClicked");
  }
  setupDetailRowAutoHeight(e) {
    var t;
    this.rowType === "FullWidthDetail" && ((t = this.beans.masterDetailSvc) == null || t.setupDetailRowAutoHeight(this, e));
  }
  createFullWidthCompDetails(e, t) {
    const { gos: s, rowNode: i } = this, r = s.addGridCommonParams({
      fullWidth: !0,
      data: i.data,
      node: i,
      value: i.key,
      valueFormatted: i.key,
      // these need to be taken out, as part of 'afterAttached' now
      eGridCell: e,
      eParentOfValue: e,
      pinned: t,
      addRenderedRowListener: this.addEventListener.bind(this),
      registerRowDragger: (o, a, l, c) => this.addFullWidthRowDragging(o, a, l, c),
      setTooltip: (o, a) => {
        s.assertModuleRegistered("Tooltip", 3), this.refreshRowTooltip(o, a);
      }
    }), n = this.beans.userCompFactory;
    switch (this.rowType) {
      case "FullWidthDetail":
        return ZT(n, r);
      case "FullWidthGroup":
        return XT(n, r);
      case "FullWidthLoading":
        return YT(n, r);
      default:
        return qT(n, r);
    }
  }
  refreshRowTooltip(e, t) {
    var s;
    this.fullWidthGui && (this.tooltipFeature = (s = this.beans.tooltipSvc) == null ? void 0 : s.refreshRowTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    ));
  }
  addFullWidthRowDragging(e, t, s = "", i) {
    const { rowDragSvc: r, context: n } = this.beans;
    if (!r || !this.isFullWidth())
      return;
    const o = r.createRowDragComp(
      () => s,
      this.rowNode,
      void 0,
      e,
      t,
      i
    );
    this.createBean(o, n), this.addDestroyFunc(() => {
      this.destroyBean(o, n);
    });
  }
  onUiLevelChanged() {
    const e = Xg(this.rowNode);
    if (this.rowLevel != e) {
      const t = "ag-row-level-" + e, s = "ag-row-level-" + this.rowLevel;
      this.allRowGuis.forEach((i) => {
        i.rowComp.addOrRemoveCssClass(t, !0), i.rowComp.addOrRemoveCssClass(s, !1);
      });
    }
    this.rowLevel = e;
  }
  isFirstRowOnPage() {
    return this.rowNode.rowIndex === this.beans.pageBounds.getFirstRow();
  }
  isLastRowOnPage() {
    return this.rowNode.rowIndex === this.beans.pageBounds.getLastRow();
  }
  refreshFirstAndLastRowStyles() {
    const e = this.isFirstRowOnPage(), t = this.isLastRowOnPage();
    this.firstRowOnPage !== e && (this.firstRowOnPage = e, this.allRowGuis.forEach((s) => s.rowComp.addOrRemoveCssClass("ag-row-first", e))), this.lastRowOnPage !== t && (this.lastRowOnPage = t, this.allRowGuis.forEach((s) => s.rowComp.addOrRemoveCssClass("ag-row-last", t)));
  }
  getAllCellCtrls() {
    return this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0 ? this.centerCellCtrls.list : [...this.centerCellCtrls.list, ...this.leftCellCtrls.list, ...this.rightCellCtrls.list];
  }
  postProcessClassesFromGridOptions() {
    var t;
    const e = [];
    (t = this.beans.rowStyleSvc) == null || t.processClassesFromGridOptions(e, this.rowNode), e.length && e.forEach((s) => {
      this.allRowGuis.forEach((i) => i.rowComp.addOrRemoveCssClass(s, !0));
    });
  }
  postProcessRowClassRules() {
    var e;
    (e = this.beans.rowStyleSvc) == null || e.processRowClassRules(
      this.rowNode,
      (t) => {
        this.allRowGuis.forEach((s) => s.rowComp.addOrRemoveCssClass(t, !0));
      },
      (t) => {
        this.allRowGuis.forEach((s) => s.rowComp.addOrRemoveCssClass(t, !1));
      }
    );
  }
  setStylesFromGridOptions(e, t) {
    e && (this.rowStyles = this.processStylesFromGridOptions()), this.forEachGui(t, (s) => s.rowComp.setUserStyles(this.rowStyles));
  }
  getPinnedForContainer(e) {
    return e === "left" || e === "right" ? e : null;
  }
  getInitialRowClasses(e) {
    var a;
    const t = this.getPinnedForContainer(e), s = this.isFullWidth(), { rowNode: i, beans: r } = this, n = [];
    n.push("ag-row"), n.push(this.rowFocused ? "ag-row-focus" : "ag-row-no-focus"), this.fadeInAnimation[e] && n.push("ag-opacity-zero"), n.push(i.rowIndex % 2 === 0 ? "ag-row-even" : "ag-row-odd"), i.isRowPinned() && n.push("ag-row-pinned"), i.isSelected() && n.push("ag-row-selected"), i.footer && n.push("ag-row-footer"), n.push("ag-row-level-" + this.rowLevel), i.stub && n.push("ag-row-loading"), s && n.push("ag-full-width-row"), (a = r.expansionSvc) == null || a.addExpandedCss(n, i), i.dragging && n.push("ag-row-dragging");
    const { rowStyleSvc: o } = r;
    return o && (o.processClassesFromGridOptions(n, i), o.preProcessRowClassRules(n, i)), n.push(this.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute"), this.isFirstRowOnPage() && n.push("ag-row-first"), this.isLastRowOnPage() && n.push("ag-row-last"), s && (t === "left" && n.push("ag-cell-last-left-pinned"), t === "right" && n.push("ag-cell-first-right-pinned")), n;
  }
  processStylesFromGridOptions() {
    var e;
    return ((e = this.beans.rowStyleSvc) == null ? void 0 : e.processStylesFromGridOptions(this.rowNode)) ?? this.emptyStyle;
  }
  onRowSelected(e) {
    var t;
    (t = this.beans.selectionSvc) == null || t.onRowCtrlSelected(
      this,
      (s) => {
        (s === this.centerGui || s === this.fullWidthGui) && this.announceDescription();
      },
      e
    );
  }
  announceDescription() {
    var e;
    (e = this.beans.selectionSvc) == null || e.announceAriaRowSelection(this.rowNode);
  }
  addHoverFunctionality(e) {
    if (!this.active)
      return;
    const { element: t, compBean: s } = e, { rowNode: i, beans: r, gos: n } = this;
    s.addManagedListeners(t, {
      mouseenter: () => i.dispatchRowEvent("mouseEnter"),
      mouseleave: () => i.dispatchRowEvent("mouseLeave")
    }), s.addManagedListeners(i, {
      mouseEnter: () => {
        var o;
        !((o = r.dragSvc) != null && o.dragging) && !n.get("suppressRowHoverHighlight") && (t.classList.add("ag-row-hover"), i.setHovered(!0));
      },
      mouseLeave: () => {
        t.classList.remove("ag-row-hover"), i.setHovered(!1);
      }
    });
  }
  // for animation, we don't want to animate entry or exit to a very far away pixel,
  // otherwise the row would move so fast, it would appear to disappear. so this method
  // moves the row closer to the viewport if it is far away, so the row slide in / out
  // at a speed the user can see.
  roundRowTopToBounds(e) {
    const t = this.beans.ctrlsSvc.getScrollFeature().getApproximateVScollPosition(), s = this.applyPaginationOffset(t.top, !0) - 100, i = this.applyPaginationOffset(t.bottom, !0) + 100;
    return Math.min(Math.max(s, e), i);
  }
  forEachGui(e, t) {
    e ? t(e) : this.allRowGuis.forEach(t);
  }
  onRowHeightChanged(e) {
    if (this.rowNode.rowHeight == null)
      return;
    const t = this.rowNode.rowHeight, s = this.beans.environment.getDefaultRowHeight(), r = ch(this.gos) ? qt(this.beans, this.rowNode).height : void 0, n = r ? `${Math.min(s, r) - 2}px` : void 0;
    this.forEachGui(e, (o) => {
      o.element.style.height = `${t}px`, n && o.element.style.setProperty("--ag-line-height", n);
    });
  }
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  destroyFirstPass(e = !1) {
    this.active = !1;
    const { rowNode: t } = this;
    if (!e && Wn(this.gos) && !t.sticky)
      if (t.rowTop != null) {
        const r = this.roundRowTopToBounds(t.rowTop);
        this.setRowTop(r);
      } else
        this.allRowGuis.forEach((r) => r.rowComp.addOrRemoveCssClass("ag-opacity-zero", !0));
    t.setHovered(!1);
    const s = this.createRowEvent("virtualRowRemoved");
    this.dispatchLocalEvent(s), this.beans.eventSvc.dispatchEvent(s), super.destroy();
  }
  destroySecondPass() {
    var t;
    this.allRowGuis.length = 0, (t = this.beans.editSvc) == null || t.stopRowEditing(this);
    const e = (s) => (s.list.forEach((i) => i.destroy()), { list: [], map: {} });
    this.centerCellCtrls = e(this.centerCellCtrls), this.leftCellCtrls = e(this.leftCellCtrls), this.rightCellCtrls = e(this.rightCellCtrls);
  }
  setFocusedClasses(e) {
    this.forEachGui(e, (t) => {
      t.rowComp.addOrRemoveCssClass("ag-row-focus", this.rowFocused), t.rowComp.addOrRemoveCssClass("ag-row-no-focus", !this.rowFocused);
    });
  }
  onCellFocusChanged() {
    const { focusSvc: e, editSvc: t } = this.beans, s = e.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
    s !== this.rowFocused && (this.rowFocused = s, this.setFocusedClasses()), !s && this.editing && (t == null || t.stopRowEditing(this, !1));
  }
  onPaginationChanged() {
    var t;
    const e = ((t = this.beans.pagination) == null ? void 0 : t.getCurrentPage()) ?? 0;
    this.paginationPage !== e && (this.paginationPage = e, this.onTopChanged()), this.refreshFirstAndLastRowStyles();
  }
  onTopChanged() {
    this.setRowTop(this.rowNode.rowTop);
  }
  onPaginationPixelOffsetChanged() {
    this.onTopChanged();
  }
  // applies pagination offset, eg if on second page, and page height is 500px, then removes
  // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
  // reverse will take the offset away rather than add.
  applyPaginationOffset(e, t = !1) {
    if (this.rowNode.isRowPinned() || this.rowNode.sticky)
      return e;
    const s = this.beans.pageBounds.getPixelOffset();
    return e + s * (t ? 1 : -1);
  }
  setRowTop(e) {
    if (!this.printLayout && W(e)) {
      const t = this.applyPaginationOffset(e), r = `${this.rowNode.isRowPinned() || this.rowNode.sticky ? t : this.beans.rowContainerHeight.getRealPixelPosition(t)}px`;
      this.setRowTopStyle(r);
    }
  }
  // the top needs to be set into the DOM element when the element is created, not updated afterwards.
  // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
  // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
  // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
  // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
  // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
  // time, the row would animate down (ie from position zero).
  getInitialRowTop(e) {
    return this.suppressRowTransform ? this.getInitialRowTopShared(e) : void 0;
  }
  getInitialTransform(e) {
    return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(e)})`;
  }
  getInitialRowTopShared(e) {
    if (this.printLayout)
      return "";
    const t = this.rowNode;
    let s;
    if (t.sticky)
      s = t.stickyRowTop;
    else {
      const i = this.slideInAnimation[e] ? this.roundRowTopToBounds(t.oldRowTop) : t.rowTop, r = this.applyPaginationOffset(i);
      s = t.isRowPinned() ? r : this.beans.rowContainerHeight.getRealPixelPosition(r);
    }
    return s + "px";
  }
  setRowTopStyle(e) {
    this.allRowGuis.forEach(
      (t) => this.suppressRowTransform ? t.rowComp.setTop(e) : t.rowComp.setTransform(`translateY(${e})`)
    );
  }
  getCellCtrl(e, t = !1) {
    let s = null;
    return this.getAllCellCtrls().forEach((i) => {
      i.column == e && (s = i);
    }), s != null || t || this.getAllCellCtrls().forEach((i) => {
      i.getColSpanningList().indexOf(e) >= 0 && (s = i);
    }), s;
  }
  onRowIndexChanged() {
    this.rowNode.rowIndex != null && (this.onCellFocusChanged(), this.updateRowIndexes(), this.postProcessCss());
  }
  updateRowIndexes(e) {
    var n, o;
    const t = this.rowNode.getRowIndexString();
    if (t === null)
      return;
    const s = (((n = this.beans.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : n.getRowCount()) ?? 0) + (((o = this.beans.filterManager) == null ? void 0 : o.getHeaderRowCount()) ?? 0), i = this.rowNode.rowIndex % 2 === 0, r = s + this.rowNode.rowIndex + 1;
    this.forEachGui(e, (a) => {
      a.rowComp.setRowIndex(t), a.rowComp.addOrRemoveCssClass("ag-row-even", i), a.rowComp.addOrRemoveCssClass("ag-row-odd", !i), th(a.element, r);
    });
  }
};
function Fh(e) {
  var s;
  return e.altKey || e.ctrlKey || e.metaKey ? !1 : ((s = e.key) == null ? void 0 : s.length) === 1;
}
function du(e, t, s, i, r) {
  const n = i ? i.getColDef().suppressKeyboardEvent : void 0;
  if (!n)
    return !1;
  const o = e.addGridCommonParams({
    event: t,
    editing: r,
    column: i,
    node: s,
    data: s.data,
    colDef: i.getColDef()
  });
  return !!(n && n(o));
}
var jE = 65, KE = 67, qE = 86, YE = 68, XE = 90, ZE = 89;
function QE(e) {
  const { keyCode: t } = e;
  let s;
  switch (t) {
    case jE:
      s = P.A;
      break;
    case KE:
      s = P.C;
      break;
    case qE:
      s = P.V;
      break;
    case YE:
      s = P.D;
      break;
    case XE:
      s = P.Z;
      break;
    case ZE:
      s = P.Y;
      break;
    default:
      s = e.code;
  }
  return s;
}
var JE = class extends L {
  constructor(e) {
    super(), this.element = e;
  }
  postConstruct() {
    var e;
    this.addKeyboardListeners(), this.addMouseListeners(), (e = this.beans.touchSvc) == null || e.mockRowContextMenu(this);
  }
  addKeyboardListeners() {
    const e = "keydown", t = this.processKeyboardEvent.bind(this, e);
    this.addManagedElementListeners(this.element, { [e]: t });
  }
  addMouseListeners() {
    ["dblclick", "contextmenu", "mouseover", "mouseout", "click", Tv("touchstart") ? "touchstart" : "mousedown"].forEach((s) => {
      const i = this.processMouseEvent.bind(this, s);
      this.addManagedElementListeners(this.element, { [s]: i });
    });
  }
  processMouseEvent(e, t) {
    var r;
    if (!Gl(this.gos, t) || Ds(t))
      return;
    const { cellCtrl: s, rowCtrl: i } = this.getControlsForEventTarget(t.target);
    e === "contextmenu" ? (s != null && s.column && s.dispatchCellContextMenuEvent(t), (r = this.beans.contextMenuSvc) == null || r.handleContextMenuMouseEvent(t, void 0, i, s)) : (s && s.onMouseEvent(e, t), i && i.onMouseEvent(e, t));
  }
  getControlsForEventTarget(e) {
    const { gos: t } = this;
    return {
      cellCtrl: wh(t, e),
      rowCtrl: Ev(t, e, aa)
    };
  }
  processKeyboardEvent(e, t) {
    const { cellCtrl: s, rowCtrl: i } = this.getControlsForEventTarget(t.target);
    t.defaultPrevented || (s ? this.processCellKeyboardEvent(s, e, t) : i && i.isFullWidth() && this.processFullWidthRowKeyboardEvent(i, e, t));
  }
  processCellKeyboardEvent(e, t, s) {
    var a;
    const { rowNode: i, column: r, editing: n } = e;
    !du(
      this.gos,
      s,
      i,
      r,
      n
    ) && t === "keydown" && (!n && ((a = this.beans.navigation) != null && a.handlePageScrollingKey(s)) || e.onKeyDown(s), this.doGridOperations(s, e.editing), Fh(s) && e.processCharacter(s)), t === "keydown" && this.eventSvc.dispatchEvent(e.createEvent(s, "cellKeyDown"));
  }
  processFullWidthRowKeyboardEvent(e, t, s) {
    const { rowNode: i } = e, { focusSvc: r, navigation: n } = this.beans, o = r.getFocusedCell(), a = o && o.column;
    if (!du(this.gos, s, i, a, !1)) {
      const c = s.key;
      if (t === "keydown")
        switch (c) {
          case P.PAGE_HOME:
          case P.PAGE_END:
          case P.PAGE_UP:
          case P.PAGE_DOWN:
            n == null || n.handlePageScrollingKey(s, !0);
            break;
          case P.UP:
          case P.DOWN:
            e.onKeyboardNavigate(s);
            break;
          case P.TAB:
            e.onTabKeyDown(s);
            break;
        }
    }
    t === "keydown" && this.eventSvc.dispatchEvent(e.createRowEvent("cellKeyDown", s));
  }
  doGridOperations(e, t) {
    if (!e.ctrlKey && !e.metaKey || t || !Gl(this.gos, e))
      return;
    const s = QE(e), { clipboardSvc: i, undoRedo: r } = this.beans;
    if (s === P.A)
      return this.onCtrlAndA(e);
    if (s === P.C)
      return this.onCtrlAndC(i, e);
    if (s === P.D)
      return this.onCtrlAndD(i, e);
    if (s === P.V)
      return this.onCtrlAndV(i, e);
    if (s === P.X)
      return this.onCtrlAndX(i, e);
    if (s === P.Y)
      return this.onCtrlAndY(r);
    if (s === P.Z)
      return this.onCtrlAndZ(r, e);
  }
  onCtrlAndA(e) {
    const {
      beans: { pinnedRowModel: t, rowModel: s, visibleCols: i, rangeSvc: r, selectionSvc: n },
      gos: o
    } = this;
    if (r && is(o) && s.isRowsToRender()) {
      const [a, l] = [
        (t == null ? void 0 : t.isEmpty("top")) ?? !0,
        (t == null ? void 0 : t.isEmpty("bottom")) ?? !0
      ], c = a ? null : "top";
      let d, u;
      l ? (d = null, u = s.getRowCount() - 1) : (d = "bottom", u = (t == null ? void 0 : t.getPinnedBottomRowCount()) ?? -1);
      const h = i.allCols;
      if (!(h != null && h.length))
        return;
      r.setCellRange({
        rowStartIndex: 0,
        rowStartPinned: c,
        rowEndIndex: u,
        rowEndPinned: d,
        columnStart: h[0],
        columnEnd: pe(h)
      });
    } else n && (n == null || n.selectAllRowNodes({ source: "keyboardSelectAll", selectAll: xv(o) }));
    e.preventDefault();
  }
  onCtrlAndC(e, t) {
    if (!e || this.gos.get("enableCellTextSelection"))
      return;
    const { cellCtrl: s, rowCtrl: i } = this.getControlsForEventTarget(t.target);
    s != null && s.editing || i != null && i.editing || (t.preventDefault(), e.copyToClipboard());
  }
  onCtrlAndX(e, t) {
    if (!e || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard"))
      return;
    const { cellCtrl: s, rowCtrl: i } = this.getControlsForEventTarget(t.target);
    s != null && s.editing || i != null && i.editing || (t.preventDefault(), e.cutToClipboard(void 0, "ui"));
  }
  onCtrlAndV(e, t) {
    const { cellCtrl: s, rowCtrl: i } = this.getControlsForEventTarget(t.target);
    s != null && s.editing || i != null && i.editing || e && !this.gos.get("suppressClipboardPaste") && e.pasteFromClipboard();
  }
  onCtrlAndD(e, t) {
    e && !this.gos.get("suppressClipboardPaste") && e.copyRangeDown(), t.preventDefault();
  }
  onCtrlAndZ(e, t) {
    !this.gos.get("undoRedoCellEditing") || !e || (t.preventDefault(), t.shiftKey ? e.redo("ui") : e.undo("ui"));
  }
  onCtrlAndY(e) {
    e == null || e.redo("ui");
  }
}, Rw = class extends L {
  constructor(e, t) {
    super(), this.eContainer = e, this.eViewport = t;
  }
  postConstruct() {
    this.addManagedEventListeners({
      rowContainerHeightChanged: this.onHeightChanged.bind(this, this.beans.rowContainerHeight)
    });
  }
  onHeightChanged(e) {
    const t = e.uiContainerHeight, s = t != null ? `${t}px` : "";
    this.eContainer.style.height = s, this.eViewport && (this.eViewport.style.height = s);
  }
}, Wa = (e) => e.topRowCtrls, _a = (e) => e.getStickyTopRowCtrls(), Ua = (e) => e.getStickyBottomRowCtrls(), $a = (e) => e.bottomRowCtrls, ja = (e) => e.allRowCtrls, eD = {
  center: {
    type: "center",
    container: "ag-center-cols-container",
    viewport: "ag-center-cols-viewport",
    getRowCtrls: ja
  },
  left: {
    type: "left",
    container: "ag-pinned-left-cols-container",
    pinnedType: "left",
    getRowCtrls: ja
  },
  right: {
    type: "right",
    container: "ag-pinned-right-cols-container",
    pinnedType: "right",
    getRowCtrls: ja
  },
  fullWidth: {
    type: "fullWidth",
    container: "ag-full-width-container",
    fullWidth: !0,
    getRowCtrls: ja
  },
  topCenter: {
    type: "center",
    container: "ag-floating-top-container",
    viewport: "ag-floating-top-viewport",
    getRowCtrls: Wa
  },
  topLeft: {
    type: "left",
    container: "ag-pinned-left-floating-top",
    pinnedType: "left",
    getRowCtrls: Wa
  },
  topRight: {
    type: "right",
    container: "ag-pinned-right-floating-top",
    pinnedType: "right",
    getRowCtrls: Wa
  },
  topFullWidth: {
    type: "fullWidth",
    container: "ag-floating-top-full-width-container",
    fullWidth: !0,
    getRowCtrls: Wa
  },
  stickyTopCenter: {
    type: "center",
    container: "ag-sticky-top-container",
    viewport: "ag-sticky-top-viewport",
    getRowCtrls: _a
  },
  stickyTopLeft: {
    type: "left",
    container: "ag-pinned-left-sticky-top",
    pinnedType: "left",
    getRowCtrls: _a
  },
  stickyTopRight: {
    type: "right",
    container: "ag-pinned-right-sticky-top",
    pinnedType: "right",
    getRowCtrls: _a
  },
  stickyTopFullWidth: {
    type: "fullWidth",
    container: "ag-sticky-top-full-width-container",
    fullWidth: !0,
    getRowCtrls: _a
  },
  stickyBottomCenter: {
    type: "center",
    container: "ag-sticky-bottom-container",
    viewport: "ag-sticky-bottom-viewport",
    getRowCtrls: Ua
  },
  stickyBottomLeft: {
    type: "left",
    container: "ag-pinned-left-sticky-bottom",
    pinnedType: "left",
    getRowCtrls: Ua
  },
  stickyBottomRight: {
    type: "right",
    container: "ag-pinned-right-sticky-bottom",
    pinnedType: "right",
    getRowCtrls: Ua
  },
  stickyBottomFullWidth: {
    type: "fullWidth",
    container: "ag-sticky-bottom-full-width-container",
    fullWidth: !0,
    getRowCtrls: Ua
  },
  bottomCenter: {
    type: "center",
    container: "ag-floating-bottom-container",
    viewport: "ag-floating-bottom-viewport",
    getRowCtrls: $a
  },
  bottomLeft: {
    type: "left",
    container: "ag-pinned-left-floating-bottom",
    pinnedType: "left",
    getRowCtrls: $a
  },
  bottomRight: {
    type: "right",
    container: "ag-pinned-right-floating-bottom",
    pinnedType: "right",
    getRowCtrls: $a
  },
  bottomFullWidth: {
    type: "fullWidth",
    container: "ag-floating-bottom-full-width-container",
    fullWidth: !0,
    getRowCtrls: $a
  }
};
function sn(e) {
  return eD[e];
}
var tD = ["topCenter", "topLeft", "topRight"], sD = ["bottomCenter", "bottomLeft", "bottomRight"], iD = ["center", "left", "right"], rD = ["center", "left", "right", "fullWidth"], nD = ["stickyTopCenter", "stickyBottomCenter", "center", "topCenter", "bottomCenter"], oD = ["left", "bottomLeft", "topLeft", "stickyTopLeft", "stickyBottomLeft"], aD = ["right", "bottomRight", "topRight", "stickyTopRight", "stickyBottomRight"], Fw = ["stickyTopCenter", "stickyTopLeft", "stickyTopRight"], Pw = ["stickyBottomCenter", "stickyBottomLeft", "stickyBottomRight"], lD = [
  ...Fw,
  "stickyTopFullWidth",
  ...Pw,
  "stickyBottomFullWidth"
], cD = [
  ...tD,
  ...sD,
  ...iD,
  ...Fw,
  ...Pw
], Tw = class extends L {
  constructor(e) {
    super(), this.name = e, this.visible = !0, this.EMPTY_CTRLS = [], this.options = sn(e);
  }
  postConstruct() {
    this.enableRtl = this.gos.get("enableRtl"), this.forContainers(["center"], () => {
      this.viewportSizeFeature = this.createManagedBean(new _E(this)), this.addManagedEventListeners({
        stickyTopOffsetChanged: this.onStickyTopOffsetChanged.bind(this)
      });
    });
  }
  onStickyTopOffsetChanged(e) {
    this.comp.setOffsetTop(`${e.offset}px`);
  }
  registerWithCtrlsService() {
    this.options.fullWidth || this.beans.ctrlsSvc.register(this.name, this);
  }
  forContainers(e, t) {
    e.indexOf(this.name) >= 0 && t();
  }
  setComp(e, t, s) {
    this.comp = e, this.eContainer = t, this.eViewport = s, this.createManagedBean(new JE(this.eContainer)), this.addPreventScrollWhileDragging(), this.listenOnDomOrder();
    const { pinnedCols: i, rangeSvc: r } = this.beans, n = () => this.onPinnedWidthChanged();
    this.forContainers(oD, () => {
      this.pinnedWidthFeature = this.createOptionalManagedBean(
        i == null ? void 0 : i.createPinnedWidthFeature(this.eContainer, !0)
      ), this.addManagedEventListeners({ leftPinnedWidthChanged: n });
    }), this.forContainers(aD, () => {
      this.pinnedWidthFeature = this.createOptionalManagedBean(
        i == null ? void 0 : i.createPinnedWidthFeature(this.eContainer, !1)
      ), this.addManagedEventListeners({ rightPinnedWidthChanged: n });
    }), this.forContainers(
      rD,
      () => this.createManagedBean(
        new Rw(this.eContainer, this.name === "center" ? s : void 0)
      )
    ), r && this.forContainers(
      cD,
      () => this.createManagedBean(r.createDragListenerFeature(this.eContainer))
    ), this.forContainers(
      nD,
      () => this.createManagedBean(new xh((o) => this.comp.setContainerWidth(`${o}px`)))
    ), this.visible = this.isContainerVisible(), this.addListeners(), this.registerWithCtrlsService();
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
  addListeners() {
    this.addManagedEventListeners({
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      displayedColumnsWidthChanged: this.onDisplayedColumnsChanged.bind(this),
      displayedRowsChanged: (e) => this.onDisplayedRowsChanged(e.afterScroll)
    }), this.onDisplayedColumnsChanged(), this.onDisplayedRowsChanged();
  }
  listenOnDomOrder() {
    if (lD.indexOf(this.name) >= 0) {
      this.comp.setDomOrder(!0);
      return;
    }
    const t = () => {
      const s = this.gos.get("ensureDomOrder"), i = It(this.gos, "print");
      this.comp.setDomOrder(s || i);
    };
    this.addManagedPropertyListener("domLayout", t), t();
  }
  onDisplayedColumnsChanged() {
    this.forContainers(["center"], () => this.onHorizontalViewportChanged());
  }
  // this methods prevents the grid views from being scrolled while the dragService is being used
  // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
  addPreventScrollWhileDragging() {
    const { dragSvc: e } = this.beans;
    if (!e)
      return;
    const t = (s) => {
      e.dragging && s.cancelable && s.preventDefault();
    };
    this.eContainer.addEventListener("touchmove", t, { passive: !1 }), this.addDestroyFunc(() => this.eContainer.removeEventListener("touchmove", t));
  }
  // this gets called whenever a change in the viewport, so we can inform column controller it has to work
  // out the virtual columns again. gets called from following locations:
  // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
  onHorizontalViewportChanged(e = !1) {
    const t = this.getCenterWidth(), s = this.getCenterViewportScrollLeft();
    this.beans.colViewport.setScrollPosition(t, s, e);
  }
  hasHorizontalScrollGap() {
    return this.eContainer.clientWidth - this.eViewport.clientWidth < 0;
  }
  hasVerticalScrollGap() {
    return this.eContainer.clientHeight - this.eViewport.clientHeight < 0;
  }
  getCenterWidth() {
    return jn(this.eViewport);
  }
  getCenterViewportScrollLeft() {
    return Sl(this.eViewport, this.enableRtl);
  }
  registerViewportResizeListener(e) {
    const t = Ms(this.beans, this.eViewport, e);
    this.addDestroyFunc(() => t());
  }
  isViewportInTheDOMTree() {
    return nv(this.eViewport);
  }
  getViewportScrollLeft() {
    return Sl(this.eViewport, this.enableRtl);
  }
  isHorizontalScrollShowing() {
    return this.gos.get("alwaysShowHorizontalScroll") || AP(this.eViewport);
  }
  setHorizontalScroll(e) {
    this.comp.setHorizontalScroll(e);
  }
  getHScrollPosition() {
    return {
      left: this.eViewport.scrollLeft,
      right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
    };
  }
  setCenterViewportScrollLeft(e) {
    xl(this.eViewport, e, this.enableRtl);
  }
  isContainerVisible() {
    return !(this.options.pinnedType != null) || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
  }
  onPinnedWidthChanged() {
    const e = this.isContainerVisible();
    this.visible != e && (this.visible = e, this.onDisplayedRowsChanged());
  }
  onDisplayedRowsChanged(e = !1) {
    const t = this.options.getRowCtrls(this.beans.rowRenderer);
    if (!this.visible || t.length === 0) {
      this.comp.setRowCtrls({ rowCtrls: this.EMPTY_CTRLS });
      return;
    }
    const s = It(this.gos, "print"), r = this.gos.get("embedFullWidthRows") || s, n = t.filter((o) => {
      const a = o.isFullWidth();
      return this.options.fullWidth ? !r && a : r || !a;
    });
    this.comp.setRowCtrls({ rowCtrls: n, useFlushSync: e });
  }
}, Ew = "ag-force-vertical-scroll", dD = "ag-selectable", uD = "ag-column-moving", Dw = class extends L {
  constructor() {
    super(...arguments), this.stickyTopHeight = 0, this.stickyBottomHeight = 0;
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.colModel = e.colModel, this.scrollVisibleSvc = e.scrollVisibleSvc, this.pinnedRowModel = e.pinnedRowModel, this.filterManager = e.filterManager, this.rowGroupColsSvc = e.rowGroupColsSvc;
  }
  setComp(e, t, s, i, r, n, o) {
    var a, l;
    this.comp = e, this.eGridBody = t, this.eBodyViewport = s, this.eTop = i, this.eBottom = r, this.eStickyTop = n, this.eStickyBottom = o, this.eCenterColsViewport = s.querySelector(
      `.${sn("center").viewport}`
    ), this.eFullWidthContainer = s.querySelector(
      `.${sn("fullWidth").container}`
    ), this.eStickyTopFullWidthContainer = n.querySelector(
      `.${sn("stickyTopFullWidth").container}`
    ), this.eStickyBottomFullWidthContainer = o.querySelector(
      `.${sn("stickyBottomFullWidth").container}`
    ), this.setCellTextSelection(this.gos.get("enableCellTextSelection")), this.addManagedPropertyListener(
      "enableCellTextSelection",
      (c) => this.setCellTextSelection(c.currentValue)
    ), this.createManagedBean(new Sh(this.comp)), this.scrollFeature = this.createManagedBean(new WE(this.eBodyViewport)), (a = this.beans.rowDragSvc) == null || a.setupRowDrag(this.eBodyViewport, this), this.setupRowAnimationCssClass(), this.addEventListeners(), this.addFocusListeners([i, s, r, n, o]), this.setGridRootRole(), this.onGridColumnsChanged(), this.addBodyViewportListener(), this.setFloatingHeights(), this.disableBrowserDragging(), this.addStopEditingWhenGridLosesFocus(), this.updateScrollingClasses(), (l = this.filterManager) == null || l.setupAdvFilterHeaderComp(i), this.ctrlsSvc.register("gridBodyCtrl", this);
  }
  addEventListeners() {
    const e = this.setFloatingHeights.bind(this), t = this.setGridRootRole.bind(this);
    this.addManagedEventListeners({
      gridColumnsChanged: this.onGridColumnsChanged.bind(this),
      scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this),
      scrollGapChanged: this.updateScrollingClasses.bind(this),
      pinnedRowDataChanged: e,
      pinnedHeightChanged: e,
      headerHeightChanged: this.setStickyTopOffsetTop.bind(this),
      columnRowGroupChanged: t,
      columnPivotChanged: t
    }), this.addManagedPropertyListener("treeData", t);
  }
  onGridColumnsChanged() {
    const e = this.beans.colModel.getCols();
    this.comp.setColumnCount(e.length);
  }
  onScrollVisibilityChanged() {
    const { scrollVisibleSvc: e } = this, t = e.verticalScrollShowing;
    this.setVerticalScrollPaddingVisible(t), this.setStickyWidth(t), this.setStickyBottomOffsetBottom();
    const s = t && e.getScrollbarWidth() || 0, i = tv() ? 16 : 0, r = `calc(100% + ${s + i}px)`;
    _s(this.beans, () => this.comp.setBodyViewportWidth(r)), this.updateScrollingClasses();
  }
  setGridRootRole() {
    const { rowGroupColsSvc: e, colModel: t } = this;
    let s = this.gos.get("treeData");
    if (!s) {
      const i = t.isPivotMode();
      s = (e ? e.columns.length : 0) >= (i ? 2 : 1);
    }
    this.comp.setGridRootRole(s ? "treegrid" : "grid");
  }
  addFocusListeners(e) {
    e.forEach((t) => {
      this.addManagedElementListeners(t, {
        focusin: (s) => {
          const { target: i } = s, r = an(i, "ag-root", t);
          t.classList.toggle("ag-has-focus", !r);
        },
        focusout: (s) => {
          const { target: i, relatedTarget: r } = s, n = t.contains(r), o = an(
            r,
            "ag-root",
            t
          );
          an(i, "ag-root", t) || (!n || o) && t.classList.remove("ag-has-focus");
        }
      });
    });
  }
  // used by ColumnAnimationService
  setColumnMovingCss(e) {
    this.comp.setColumnMovingCss(uD, e);
  }
  setCellTextSelection(e = !1) {
    this.comp.setCellSelectableCss(dD, e);
  }
  updateScrollingClasses() {
    const {
      eGridBody: { classList: e },
      scrollVisibleSvc: t
    } = this;
    e.toggle("ag-body-vertical-content-no-gap", !t.verticalScrollGap), e.toggle("ag-body-horizontal-content-no-gap", !t.horizontalScrollGap);
  }
  // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
  // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
  disableBrowserDragging() {
    this.addManagedElementListeners(this.eGridBody, {
      dragstart: (e) => {
        if (e.target instanceof HTMLImageElement)
          return e.preventDefault(), !1;
      }
    });
  }
  addStopEditingWhenGridLosesFocus() {
    var e;
    (e = this.beans.editSvc) == null || e.addStopEditingWhenGridLosesFocus([
      this.eBodyViewport,
      this.eBottom,
      this.eTop,
      this.eStickyTop,
      this.eStickyBottom
    ]);
  }
  updateRowCount() {
    var r, n;
    const e = (((r = this.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : r.getRowCount()) ?? 0) + (((n = this.filterManager) == null ? void 0 : n.getHeaderRowCount()) ?? 0), { rowModel: t } = this.beans, s = t.isLastRowIndexKnown() ? t.getRowCount() : -1, i = s === -1 ? -1 : e + s;
    this.comp.setRowCount(i);
  }
  registerBodyViewportResizeListener(e) {
    this.comp.registerBodyViewportResizeListener(e);
  }
  setVerticalScrollPaddingVisible(e) {
    const t = e ? "scroll" : "hidden";
    this.comp.setPinnedTopBottomOverflowY(t);
  }
  isVerticalScrollShowing() {
    const e = this.gos.get("alwaysShowVerticalScroll"), t = e ? Ew : null, s = It(this.gos, "normal");
    return this.comp.setAlwaysVerticalScrollClass(t, e), e || s && MP(this.eBodyViewport);
  }
  setupRowAnimationCssClass() {
    const { rowContainerHeight: e, environment: t } = this.beans;
    let s = t.sizesMeasured;
    const i = () => {
      const r = s && Wn(this.gos) && !e.stretching, n = r ? "ag-row-animation" : "ag-row-no-animation";
      this.comp.setRowAnimationCssOnBodyViewport(n, r);
    };
    i(), this.addManagedEventListeners({ heightScaleChanged: i }), this.addManagedPropertyListener("animateRows", i), this.addManagedEventListeners({
      gridStylesChanged: () => {
        !s && t.sizesMeasured && (s = !0, i());
      }
    });
  }
  addBodyViewportListener() {
    const { popupSvc: e, touchSvc: t } = this.beans, s = this.onBodyViewportContextMenu.bind(this);
    this.addManagedElementListeners(this.eBodyViewport, { contextmenu: s }), t == null || t.mockBodyContextMenu(this, s), this.addManagedElementListeners(this.eBodyViewport, {
      wheel: this.onBodyViewportWheel.bind(this, e)
    }), this.addManagedElementListeners(this.eStickyTop, { wheel: this.onStickyWheel.bind(this) }), this.addManagedElementListeners(this.eStickyBottom, { wheel: this.onStickyWheel.bind(this) }), this.addFullWidthContainerWheelListener();
  }
  addFullWidthContainerWheelListener() {
    this.addManagedElementListeners(this.eFullWidthContainer, {
      wheel: (e) => this.onFullWidthContainerWheel(e)
    });
  }
  onFullWidthContainerWheel(e) {
    const { deltaX: t, deltaY: s, shiftKey: i } = e;
    (i || Math.abs(t) > Math.abs(s)) && Gl(this.gos, e) && this.scrollGridBodyToMatchEvent(e);
  }
  onStickyWheel(e) {
    const { deltaX: t, deltaY: s, shiftKey: i } = e, r = i || Math.abs(t) > Math.abs(s), n = e.target;
    r ? (this.eStickyTopFullWidthContainer.contains(n) || this.eStickyBottomFullWidthContainer.contains(n)) && this.scrollGridBodyToMatchEvent(e) : (e.preventDefault(), this.scrollVertically(s));
  }
  scrollGridBodyToMatchEvent(e) {
    const { deltaX: t, deltaY: s } = e;
    e.preventDefault(), this.eCenterColsViewport.scrollBy({ left: t || s });
  }
  onBodyViewportContextMenu(e, t, s) {
    var r;
    if (!e && !s)
      return;
    this.gos.get("preventDefaultOnContextMenu") && (e || s).preventDefault();
    const { target: i } = e || t;
    (i === this.eBodyViewport || i === this.ctrlsSvc.get("center").eViewport) && ((r = this.beans.contextMenuSvc) == null || r.showContextMenu({
      mouseEvent: e,
      touchEvent: s,
      value: null,
      anchorToElement: this.eGridBody
    }));
  }
  onBodyViewportWheel(e, t) {
    this.gos.get("suppressScrollWhenPopupsAreOpen") && e != null && e.hasAnchoredPopup() && t.preventDefault();
  }
  // called by rowDragFeature
  scrollVertically(e) {
    const t = this.eBodyViewport.scrollTop;
    return this.scrollFeature.setVerticalScrollPosition(t + e), this.eBodyViewport.scrollTop - t;
  }
  setFloatingHeights() {
    const { pinnedRowModel: e } = this, t = (e == null ? void 0 : e.getPinnedTopTotalHeight()) ?? 0, s = (e == null ? void 0 : e.getPinnedBottomTotalHeight()) ?? 0;
    this.comp.setTopHeight(t), this.comp.setBottomHeight(s), this.comp.setTopDisplay(t ? "inherit" : "none"), this.comp.setBottomDisplay(s ? "inherit" : "none"), this.setStickyTopOffsetTop(), this.setStickyBottomOffsetBottom();
  }
  setStickyTopHeight(e = 0) {
    this.comp.setStickyTopHeight(`${e}px`), this.stickyTopHeight = e;
  }
  setStickyBottomHeight(e = 0) {
    this.comp.setStickyBottomHeight(`${e}px`), this.stickyBottomHeight = e;
  }
  setStickyWidth(e) {
    if (!e)
      this.comp.setStickyTopWidth("100%"), this.comp.setStickyBottomWidth("100%");
    else {
      const t = this.scrollVisibleSvc.getScrollbarWidth();
      this.comp.setStickyTopWidth(`calc(100% - ${t}px)`), this.comp.setStickyBottomWidth(`calc(100% - ${t}px)`);
    }
  }
  setStickyTopOffsetTop() {
    var r, n;
    const t = this.ctrlsSvc.get("gridHeaderCtrl").headerHeight + (((r = this.filterManager) == null ? void 0 : r.getHeaderHeight()) ?? 0), s = ((n = this.pinnedRowModel) == null ? void 0 : n.getPinnedTopTotalHeight()) ?? 0;
    let i = 0;
    t > 0 && (i += t), s > 0 && (i += s), i > 0 && (i += 1), this.comp.setStickyTopTop(`${i}px`);
  }
  setStickyBottomOffsetBottom() {
    const { pinnedRowModel: e, scrollVisibleSvc: t, comp: s } = this, i = (e == null ? void 0 : e.getPinnedBottomTotalHeight()) ?? 0, n = t.horizontalScrollShowing && t.getScrollbarWidth() || 0, o = i + n;
    s.setStickyBottomBottom(`${o}px`);
  }
}, Aw = class extends _ {
  constructor(e, t) {
    super(), this.direction = t, this.eViewport = E, this.eContainer = E, this.hideTimeout = 0, this.setTemplate(e);
  }
  postConstruct() {
    this.addManagedEventListeners({
      scrollVisibilityChanged: this.onScrollVisibilityChanged.bind(this)
    }), this.onScrollVisibilityChanged(), this.addOrRemoveCssClass("ag-apple-scrollbar", JC() || yr());
  }
  destroy() {
    super.destroy(), window.clearTimeout(this.hideTimeout);
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.invisibleScrollbar = tv(), this.invisibleScrollbar && (this.hideAndShowInvisibleScrollAsNeeded(), this.addActiveListenerToggles()));
  }
  addActiveListenerToggles() {
    const e = this.getGui(), t = () => this.addOrRemoveCssClass("ag-scrollbar-active", !0), s = () => this.addOrRemoveCssClass("ag-scrollbar-active", !1);
    this.addManagedListeners(e, {
      mouseenter: t,
      mousedown: t,
      touchstart: t,
      mouseleave: s,
      touchend: s
    });
  }
  onScrollVisibilityChanged() {
    this.invisibleScrollbar === void 0 && this.initialiseInvisibleScrollbar(), _s(this.beans, () => this.setScrollVisible());
  }
  hideAndShowInvisibleScrollAsNeeded() {
    this.addManagedEventListeners({
      bodyScroll: (e) => {
        e.direction === this.direction && (this.hideTimeout && (window.clearTimeout(this.hideTimeout), this.hideTimeout = 0), this.addOrRemoveCssClass("ag-scrollbar-scrolling", !0));
      },
      bodyScrollEnd: () => {
        this.hideTimeout = window.setTimeout(() => {
          this.addOrRemoveCssClass("ag-scrollbar-scrolling", !1), this.hideTimeout = 0;
        }, 400);
      }
    });
  }
  attemptSettingScrollPosition(e) {
    const t = this.eViewport;
    hv(
      () => Xt(t),
      () => this.setScrollPosition(e),
      100
    );
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
}, Mw = class extends Aw {
  constructor() {
    super(
      /* html */
      `<div class="ag-body-horizontal-scroll" aria-hidden="true">
            <div class="ag-horizontal-left-spacer" data-ref="eLeftSpacer"></div>
            <div class="ag-body-horizontal-scroll-viewport" data-ref="eViewport">
                <div class="ag-body-horizontal-scroll-container" data-ref="eContainer"></div>
            </div>
            <div class="ag-horizontal-right-spacer" data-ref="eRightSpacer"></div>
        </div>`,
      "horizontal"
    ), this.eLeftSpacer = E, this.eRightSpacer = E, this.setScrollVisibleDebounce = 0;
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.scrollVisibleSvc = e.scrollVisibleSvc;
  }
  postConstruct() {
    super.postConstruct();
    const e = this.setFakeHScrollSpacerWidths.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: e,
      displayedColumnsWidthChanged: e,
      pinnedRowDataChanged: this.refreshCompBottom.bind(this)
    }), this.addManagedPropertyListener("domLayout", e), this.beans.ctrlsSvc.register("fakeHScrollComp", this), this.createManagedBean(new xh((t) => this.eContainer.style.width = `${t}px`)), this.addManagedPropertyListeners(["suppressHorizontalScroll"], this.onScrollVisibilityChanged.bind(this));
  }
  destroy() {
    window.clearTimeout(this.setScrollVisibleDebounce), super.destroy();
  }
  initialiseInvisibleScrollbar() {
    this.invisibleScrollbar === void 0 && (this.enableRtl = this.gos.get("enableRtl"), super.initialiseInvisibleScrollbar(), this.invisibleScrollbar && this.refreshCompBottom());
  }
  refreshCompBottom() {
    var t;
    if (!this.invisibleScrollbar)
      return;
    const e = ((t = this.beans.pinnedRowModel) == null ? void 0 : t.getPinnedBottomTotalHeight()) ?? 0;
    this.getGui().style.bottom = `${e}px`;
  }
  onScrollVisibilityChanged() {
    super.onScrollVisibilityChanged(), this.setFakeHScrollSpacerWidths();
  }
  setFakeHScrollSpacerWidths() {
    const e = this.scrollVisibleSvc.verticalScrollShowing;
    let t = this.visibleCols.getDisplayedColumnsRightWidth();
    const s = !this.enableRtl && e, i = this.scrollVisibleSvc.getScrollbarWidth();
    s && (t += i), si(this.eRightSpacer, t), this.eRightSpacer.classList.toggle("ag-scroller-corner", t <= i);
    let r = this.visibleCols.getColsLeftWidth();
    this.enableRtl && e && (r += i), si(this.eLeftSpacer, r), this.eLeftSpacer.classList.toggle("ag-scroller-corner", r <= i);
  }
  setScrollVisible() {
    const e = this.scrollVisibleSvc.horizontalScrollShowing, t = this.invisibleScrollbar, s = this.gos.get("suppressHorizontalScroll"), i = e && this.scrollVisibleSvc.getScrollbarWidth() || 0, n = s ? 0 : i === 0 && t ? 16 : i, o = () => {
      this.setScrollVisibleDebounce = 0, this.addOrRemoveCssClass("ag-scrollbar-invisible", t), Uo(this.getGui(), n), Uo(this.eViewport, n), Uo(this.eContainer, n), this.setDisplayed(e, { skipAriaHidden: !0 });
    };
    window.clearTimeout(this.setScrollVisibleDebounce), e ? this.setScrollVisibleDebounce = window.setTimeout(o, 100) : o();
  }
  getScrollPosition() {
    return Sl(this.eViewport, this.enableRtl);
  }
  setScrollPosition(e) {
    Xt(this.eViewport) || this.attemptSettingScrollPosition(e), xl(this.eViewport, e, this.enableRtl);
  }
}, hD = {
  selector: "AG-FAKE-HORIZONTAL-SCROLL",
  component: Mw
}, Iw = class extends Aw {
  constructor() {
    super(
      /* html */
      `<div class="ag-body-vertical-scroll" aria-hidden="true">
            <div class="ag-body-vertical-scroll-viewport" data-ref="eViewport">
                <div class="ag-body-vertical-scroll-container" data-ref="eContainer"></div>
            </div>
        </div>`,
      "vertical"
    );
  }
  postConstruct() {
    super.postConstruct(), this.createManagedBean(new Rw(this.eContainer));
    const { ctrlsSvc: e } = this.beans;
    e.register("fakeVScrollComp", this), this.addManagedEventListeners({
      rowContainerHeightChanged: this.onRowContainerHeightChanged.bind(this, e)
    });
  }
  setScrollVisible() {
    const { scrollVisibleSvc: e } = this.beans, t = e.verticalScrollShowing, s = this.invisibleScrollbar, i = t && e.getScrollbarWidth() || 0, r = i === 0 && s ? 16 : i;
    this.addOrRemoveCssClass("ag-scrollbar-invisible", s), si(this.getGui(), r), si(this.eViewport, r), si(this.eContainer, r), this.setDisplayed(t, { skipAriaHidden: !0 });
  }
  onRowContainerHeightChanged(e) {
    const s = e.getGridBodyCtrl().eBodyViewport, i = this.getScrollPosition(), r = s.scrollTop;
    i != r && this.setScrollPosition(r, !0);
  }
  getScrollPosition() {
    return this.eViewport.scrollTop;
  }
  setScrollPosition(e, t) {
    !t && !Xt(this.eViewport) && this.attemptSettingScrollPosition(e), this.eViewport.scrollTop = e;
  }
}, pD = {
  selector: "AG-FAKE-VERTICAL-SCROLL",
  component: Iw
};
function Lw(e) {
  return e.cols ? e.cols.treeDepth + 1 : -1;
}
function Vi(e) {
  var t;
  return ((t = e.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : t.getRowCount()) ?? 0;
}
function Ph(e) {
  const t = [], s = e.ctrlsSvc.getHeaderRowContainerCtrls();
  for (const i of s) {
    if (!i)
      continue;
    const r = i.getGroupRowCount() || 0;
    for (let n = 0; n < r; n++) {
      const o = i.getGroupRowCtrlAtIndex(n), a = t[n];
      if (o) {
        const l = gD(e, o);
        (a == null || l > a) && (t[n] = l);
      }
    }
  }
  return t;
}
function gD(e, t) {
  const s = e.colModel.isPivotMode() ? mD(e) : kw(e);
  let i = 0;
  const r = t.getHeaderCtrls();
  for (const n of r) {
    const { column: o } = n;
    if (o.isAutoHeaderHeight()) {
      const a = o.getAutoHeaderHeight();
      a != null && a > i && (i = a);
    }
  }
  return Math.max(s, i);
}
function Th(e) {
  const t = e.colModel.isPivotMode() ? fD(e) : fa(e), i = e.visibleCols.allCols.filter((r) => r.isAutoHeaderHeight()).map((r) => r.getAutoHeaderHeight() || 0);
  return Math.max(t, ...i);
}
function fa(e) {
  return e.gos.get("headerHeight") ?? e.environment.getDefaultHeaderHeight();
}
function Eh(e) {
  return e.gos.get("floatingFiltersHeight") ?? fa(e);
}
function kw(e) {
  return e.gos.get("groupHeaderHeight") ?? fa(e);
}
function fD(e) {
  return e.gos.get("pivotHeaderHeight") ?? fa(e);
}
function mD(e) {
  return e.gos.get("pivotGroupHeaderHeight") ?? kw(e);
}
var Ow = class extends L {
  setComp(e, t, s) {
    this.comp = e, this.eGui = t;
    const { beans: i } = this, { headerNavigation: r, touchSvc: n, ctrlsSvc: o } = i;
    r && this.createManagedBean(
      new Ir(s, {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })
    ), this.addManagedEventListeners({
      columnPivotModeChanged: this.onPivotModeChanged.bind(this, i),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this, i)
    }), this.onPivotModeChanged(i), this.setupHeaderHeight();
    const a = this.onHeaderContextMenu.bind(this);
    this.addManagedElementListeners(this.eGui, { contextmenu: a }), n == null || n.mockHeaderContextMenu(this, a), o.register("gridHeaderCtrl", this);
  }
  setupHeaderHeight() {
    const e = this.setHeaderHeight.bind(this);
    e(), this.addManagedPropertyListeners(
      [
        "headerHeight",
        "pivotHeaderHeight",
        "groupHeaderHeight",
        "pivotGroupHeaderHeight",
        "floatingFiltersHeight"
      ],
      e
    ), this.addManagedEventListeners({
      displayedColumnsChanged: e,
      columnHeaderHeightChanged: e,
      // add this to the animation frame to avoid a feedback loop
      columnGroupHeaderHeightChanged: () => _s(this.beans, () => e()),
      gridStylesChanged: e,
      advancedFilterEnabledChanged: e
    });
  }
  setHeaderHeight() {
    var n;
    const { beans: e } = this;
    let t = 0;
    const s = Ph(e).reduce((o, a) => o + a, 0), i = Th(e);
    if ((n = e.filterManager) != null && n.hasFloatingFilters() && (t += Eh(e)), t += s, t += i, this.headerHeight === t)
      return;
    this.headerHeight = t;
    const r = `${t + 1}px`;
    this.comp.setHeightAndMinHeight(r), this.eventSvc.dispatchEvent({
      type: "headerHeightChanged"
    });
  }
  onPivotModeChanged(e) {
    const t = e.colModel.isPivotMode();
    this.comp.addOrRemoveCssClass("ag-pivot-on", t), this.comp.addOrRemoveCssClass("ag-pivot-off", !t);
  }
  onDisplayedColumnsChanged(e) {
    const s = e.visibleCols.allCols.some((i) => i.isSpanHeaderHeight());
    this.comp.addOrRemoveCssClass("ag-header-allow-overflow", s);
  }
  onTabKeyDown(e) {
    const t = this.gos.get("enableRtl"), s = e.shiftKey, i = s !== t ? "LEFT" : "RIGHT", { beans: r } = this, { headerNavigation: n, focusSvc: o } = r;
    (n.navigateHorizontally(i, !0, e) || !s && o.focusOverlay(!1) || Ui(r, s, !0)) && e.preventDefault();
  }
  handleKeyDown(e) {
    let t = null;
    const { headerNavigation: s } = this.beans;
    switch (e.key) {
      case P.LEFT:
        t = "LEFT";
      case P.RIGHT: {
        W(t) || (t = "RIGHT"), s.navigateHorizontally(t, !1, e) && e.preventDefault();
        break;
      }
      case P.UP:
        t = "UP";
      case P.DOWN: {
        W(t) || (t = "DOWN"), s.navigateVertically(t, null, e) && e.preventDefault();
        break;
      }
      default:
        return;
    }
  }
  onFocusOut(e) {
    const { relatedTarget: t } = e, { eGui: s, beans: i } = this;
    !t && s.contains(Ie(i)) || s.contains(t) || (i.focusSvc.focusedHeader = null);
  }
  onHeaderContextMenu(e, t, s) {
    var o;
    const { menuSvc: i, ctrlsSvc: r } = this.beans;
    if (!e && !s || !(i != null && i.isHeaderContextMenuEnabled()))
      return;
    const { target: n } = e ?? t;
    (n === this.eGui || n === ((o = r.getHeaderRowContainerCtrl()) == null ? void 0 : o.eViewport)) && i.showHeaderContextMenu(void 0, e, s);
  }
}, Dh = class extends _ {
  constructor(e, t) {
    super(e), this.ctrl = t;
  }
  getCtrl() {
    return this.ctrl;
  }
}, CD = class extends Dh {
  constructor(t) {
    super(
      /* html */
      `<div class="ag-header-cell" role="columnheader">
            <div data-ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
            <div data-ref="eHeaderCompWrapper" class="ag-header-cell-comp-wrapper" role="presentation"></div>
        </div>`,
      t
    ), this.eResize = E, this.eHeaderCompWrapper = E, this.headerCompVersion = 0;
  }
  postConstruct() {
    const t = this.getGui();
    ((n, o) => {
      o != null && o != "" ? t.setAttribute(n, o) : t.removeAttribute(n);
    })("col-id", this.ctrl.column.getColId());
    const i = {
      setWidth: (n) => t.style.width = n,
      addOrRemoveCssClass: (n, o) => this.addOrRemoveCssClass(n, o),
      setAriaSort: (n) => n ? qC(t, n) : YC(t),
      setUserCompDetails: (n) => this.setUserCompDetails(n),
      getUserCompInstance: () => this.headerComp
    };
    this.ctrl.setComp(i, this.getGui(), this.eResize, this.eHeaderCompWrapper, void 0);
    const r = this.ctrl.getSelectAllGui();
    r && this.eResize.insertAdjacentElement("afterend", r);
  }
  destroy() {
    this.destroyHeaderComp(), super.destroy();
  }
  destroyHeaderComp() {
    this.headerComp && (this.eHeaderCompWrapper.removeChild(this.headerCompGui), this.headerComp = this.destroyBean(this.headerComp), this.headerCompGui = void 0);
  }
  setUserCompDetails(t) {
    this.headerCompVersion++;
    const s = this.headerCompVersion;
    t.newAgStackInstance().then((i) => this.afterCompCreated(s, i));
  }
  afterCompCreated(t, s) {
    if (t != this.headerCompVersion || !this.isAlive()) {
      this.destroyBean(s);
      return;
    }
    this.destroyHeaderComp(), this.headerComp = s, this.headerCompGui = s.getGui(), this.eHeaderCompWrapper.appendChild(this.headerCompGui), this.ctrl.setDragSource(this.getGui());
  }
}, vD = class extends Dh {
  constructor(t) {
    super(
      /* html */
      `<div class="ag-header-group-cell" role="columnheader">
            <div data-ref="eHeaderCompWrapper" class="ag-header-cell-comp-wrapper" role="presentation"></div>
            <div data-ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
        </div>`,
      t
    ), this.eResize = E, this.eHeaderCompWrapper = E;
  }
  postConstruct() {
    const t = this.getGui(), s = (r, n) => n != null ? t.setAttribute(r, n) : t.removeAttribute(r);
    t.setAttribute("col-id", this.ctrl.column.getUniqueId());
    const i = {
      addOrRemoveCssClass: (r, n) => this.addOrRemoveCssClass(r, n),
      setHeaderWrapperHidden: (r) => {
        r ? this.eHeaderCompWrapper.style.setProperty("display", "none") : this.eHeaderCompWrapper.style.removeProperty("display");
      },
      setHeaderWrapperMaxHeight: (r) => {
        r != null ? this.eHeaderCompWrapper.style.setProperty("max-height", `${r}px`) : this.eHeaderCompWrapper.style.removeProperty("max-height"), this.eHeaderCompWrapper.classList.toggle("ag-header-cell-comp-wrapper-limited-height", r != null);
      },
      setResizableDisplayed: (r) => re(this.eResize, r),
      setWidth: (r) => t.style.width = r,
      setAriaExpanded: (r) => s("aria-expanded", r),
      setUserCompDetails: (r) => this.setUserCompDetails(r),
      getUserCompInstance: () => this.headerGroupComp
    };
    this.ctrl.setComp(i, t, this.eResize, this.eHeaderCompWrapper, void 0);
  }
  setUserCompDetails(t) {
    t.newAgStackInstance().then((s) => this.afterHeaderCompCreated(s));
  }
  afterHeaderCompCreated(t) {
    const s = () => this.destroyBean(t);
    if (!this.isAlive()) {
      s();
      return;
    }
    const i = this.getGui(), r = t.getGui();
    this.eHeaderCompWrapper.appendChild(r), this.addDestroyFunc(s), this.headerGroupComp = t, this.ctrl.setDragSource(i);
  }
  addOrRemoveHeaderWrapperStyle(t, s) {
    const { eHeaderCompWrapper: i } = this;
    s ? i.style.setProperty(t, s) : i.style.removeProperty(t);
  }
}, wD = class extends Dh {
  constructor(t) {
    super(
      /* html */
      `<div class="ag-header-cell ag-floating-filter" role="gridcell">
            <div data-ref="eFloatingFilterBody" role="presentation"></div>
            <div class="ag-floating-filter-button ag-hidden" data-ref="eButtonWrapper" role="presentation">
                <button type="button" class="ag-button ag-floating-filter-button-button" data-ref="eButtonShowMainFilter" tabindex="-1"></button>
            </div>
        </div>`,
      t
    ), this.eFloatingFilterBody = E, this.eButtonWrapper = E, this.eButtonShowMainFilter = E;
  }
  postConstruct() {
    const t = this.getGui(), s = {
      addOrRemoveCssClass: (i, r) => this.addOrRemoveCssClass(i, r),
      addOrRemoveBodyCssClass: (i, r) => this.eFloatingFilterBody.classList.toggle(i, r),
      setButtonWrapperDisplayed: (i) => re(this.eButtonWrapper, i),
      setCompDetails: (i) => this.setCompDetails(i),
      getFloatingFilterComp: () => this.compPromise,
      setWidth: (i) => t.style.width = i,
      setMenuIcon: (i) => this.eButtonShowMainFilter.appendChild(i)
    };
    this.ctrl.setComp(s, t, this.eButtonShowMainFilter, this.eFloatingFilterBody, void 0);
  }
  setCompDetails(t) {
    if (!t) {
      this.destroyFloatingFilterComp(), this.compPromise = null;
      return;
    }
    this.compPromise = t.newAgStackInstance(), this.compPromise.then((s) => this.afterCompCreated(s));
  }
  destroy() {
    this.destroyFloatingFilterComp(), super.destroy();
  }
  destroyFloatingFilterComp() {
    this.floatingFilterComp && (this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui()), this.floatingFilterComp = this.destroyBean(this.floatingFilterComp));
  }
  afterCompCreated(t) {
    if (t) {
      if (!this.isAlive()) {
        this.destroyBean(t);
        return;
      }
      this.destroyFloatingFilterComp(), this.floatingFilterComp = t, this.eFloatingFilterBody.appendChild(t.getGui()), t.afterGuiAttached && t.afterGuiAttached();
    }
  }
}, yD = class extends _ {
  constructor(t) {
    super(), this.headerComps = {}, this.ctrl = t, this.setTemplate(
      /* html */
      `<div class="${this.ctrl.headerRowClass}" role="row"></div>`
    );
  }
  postConstruct() {
    th(this.getGui(), this.ctrl.getAriaRowIndex());
    const t = {
      setHeight: (s) => this.getGui().style.height = s,
      setTop: (s) => this.getGui().style.top = s,
      setHeaderCtrls: (s, i) => this.setHeaderCtrls(s, i),
      setWidth: (s) => this.getGui().style.width = s
    };
    this.ctrl.setComp(t, void 0);
  }
  destroy() {
    this.setHeaderCtrls([], !1), super.destroy();
  }
  setHeaderCtrls(t, s) {
    if (!this.isAlive())
      return;
    const i = this.headerComps;
    if (this.headerComps = {}, t.forEach((r) => {
      const n = r.instanceId;
      let o = i[n];
      delete i[n], o == null && (o = this.createHeaderComp(r), this.getGui().appendChild(o.getGui())), this.headerComps[n] = o;
    }), Object.values(i).forEach((r) => {
      this.getGui().removeChild(r.getGui()), this.destroyBean(r);
    }), s) {
      const r = Object.values(this.headerComps);
      r.sort(
        (o, a) => {
          const l = o.getCtrl().column.getLeft(), c = a.getCtrl().column.getLeft();
          return l - c;
        }
      );
      const n = r.map((o) => o.getGui());
      av(this.getGui(), n);
    }
  }
  createHeaderComp(t) {
    let s;
    switch (this.ctrl.type) {
      case "group":
        s = new vD(t);
        break;
      case "filter":
        s = new wD(t);
        break;
      default:
        s = new CD(t);
        break;
    }
    return this.createBean(s), s.setParentComponent(this), s;
  }
}, Ah = class extends L {
  constructor(e, t, s, i) {
    super(), this.columnOrGroup = e, this.eCell = t, this.colsSpanning = i, this.columnOrGroup = e, this.ariaEl = t.querySelector("[role=columnheader]") || t, this.beans = s;
  }
  setColsSpanning(e) {
    this.colsSpanning = e, this.onLeftChanged();
  }
  getColumnOrGroup() {
    const { beans: e, colsSpanning: t } = this;
    return e.gos.get("enableRtl") && t ? pe(t) : this.columnOrGroup;
  }
  postConstruct() {
    const e = this.onLeftChanged.bind(this);
    this.addManagedListeners(this.columnOrGroup, { leftChanged: e }), this.setLeftFirstTime(), this.addManagedEventListeners({ displayedColumnsWidthChanged: e }), this.addManagedPropertyListener("domLayout", e);
  }
  setLeftFirstTime() {
    const { gos: e, colAnimation: t } = this.beans, s = e.get("suppressColumnMoveAnimation"), i = W(this.columnOrGroup.getOldLeft());
    (t == null ? void 0 : t.isActive()) && i && !s ? this.animateInLeft() : this.onLeftChanged();
  }
  animateInLeft() {
    const e = this.getColumnOrGroup(), t = this.modifyLeftForPrintLayout(e, e.getOldLeft()), s = this.modifyLeftForPrintLayout(e, e.getLeft());
    this.setLeft(t), this.actualLeft = s, this.beans.colAnimation.executeNextVMTurn(() => {
      this.actualLeft === s && this.setLeft(s);
    });
  }
  onLeftChanged() {
    const e = this.getColumnOrGroup(), t = e.getLeft();
    this.actualLeft = this.modifyLeftForPrintLayout(e, t), this.setLeft(this.actualLeft);
  }
  modifyLeftForPrintLayout(e, t) {
    const { gos: s, visibleCols: i } = this.beans;
    if (!It(s, "print") || e.getPinned() === "left")
      return t;
    const n = i.getColsLeftWidth();
    if (e.getPinned() === "right") {
      const o = i.bodyWidth;
      return n + o + t;
    }
    return n + t;
  }
  setLeft(e) {
    if (W(e) && (this.eCell.style.left = `${e}px`), pt(this.columnOrGroup)) {
      const t = this.columnOrGroup.getLeafColumns();
      if (!t.length)
        return;
      t.length > 1 && KC(this.ariaEl, t.length);
    }
  }
}, bD = 0, Gw = "headerCtrl", Mh = class extends L {
  constructor(e, t) {
    super(), this.column = e, this.rowCtrl = t, this.resizeToggleTimeout = 0, this.resizeMultiplier = 1, this.resizeFeature = null, this.lastFocusEvent = null, this.dragSource = null, this.instanceId = e.getUniqueId() + "-" + bD++;
  }
  postConstruct() {
    const e = this.refreshTabIndex.bind(this);
    this.addManagedPropertyListeners(["suppressHeaderFocus"], e), this.addManagedEventListeners({
      overlayExclusiveChanged: e
    });
  }
  shouldStopEventPropagation(e) {
    const { headerRowIndex: t, column: s } = this.beans.focusSvc.focusedHeader, i = s.getDefinition(), r = i && i.suppressHeaderKeyboardEvent;
    if (!W(r))
      return !1;
    const n = this.gos.addGridCommonParams({
      colDef: i,
      column: s,
      headerRowIndex: t,
      event: e
    });
    return !!r(n);
  }
  getWrapperHasFocus() {
    return Ie(this.beans) === this.eGui;
  }
  setGui(e, t) {
    this.eGui = e, this.addDomData(t), t.addManagedListeners(this.beans.eventSvc, {
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this)
    }), t.addManagedElementListeners(this.eGui, {
      focus: this.onGuiFocus.bind(this)
    }), this.onDisplayedColumnsChanged(), this.refreshTabIndex();
  }
  onGuiFocus() {
    this.eventSvc.dispatchEvent({
      type: "headerFocused",
      column: this.column
    });
  }
  setupAutoHeight(e) {
    const { wrapperElement: t, checkMeasuringCallback: s, compBean: i } = e, { beans: r } = this, n = (u) => {
      if (!this.isAlive() || !i.isAlive())
        return;
      const { paddingTop: h, paddingBottom: p, borderBottomWidth: g, borderTopWidth: f } = Fn(this.eGui), m = h + p + g + f, w = t.offsetHeight + m;
      if (u < 5) {
        const y = We(r), b = !y || !y.contains(t), x = w == 0;
        if (b || x) {
          _s(r, () => n(u + 1));
          return;
        }
      }
      this.setColHeaderHeight(this.column, w);
    };
    let o = !1, a;
    const l = () => {
      const u = this.column.isAutoHeaderHeight();
      u && !o && c(), !u && o && d();
    }, c = () => {
      o = !0, n(0), this.comp.addOrRemoveCssClass("ag-header-cell-auto-height", !0), a = Ms(this.beans, t, () => n(0));
    }, d = () => {
      o = !1, a && a(), this.comp.addOrRemoveCssClass("ag-header-cell-auto-height", !1), a = void 0;
    };
    l(), i.addDestroyFunc(() => d()), i.addManagedListeners(this.column, { widthChanged: () => o && n(0) }), i.addManagedEventListeners({
      sortChanged: () => {
        o && window.setTimeout(() => n(0));
      }
    }), s && s(l);
  }
  onDisplayedColumnsChanged() {
    const { comp: e, column: t, beans: s, eGui: i } = this;
    !e || !t || !i || (nw(e, t, s.visibleCols), sh(i, s.visibleCols.getAriaColIndex(t)));
  }
  addResizeAndMoveKeyboardListeners(e) {
    e.addManagedListeners(this.eGui, {
      keydown: this.onGuiKeyDown.bind(this),
      keyup: this.onGuiKeyUp.bind(this)
    });
  }
  refreshTabIndex() {
    const e = _n(this.beans);
    this.eGui && zs(this.eGui, "tabindex", e ? null : "-1");
  }
  onGuiKeyDown(e) {
    var n;
    const t = Ie(this.beans), s = e.key === P.LEFT || e.key === P.RIGHT;
    if (this.isResizing && (e.preventDefault(), e.stopImmediatePropagation()), // if elements within the header are focused, we don't process the event
    t !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
    !e.shiftKey && !e.altKey || ((this.isResizing || s) && (e.preventDefault(), e.stopImmediatePropagation()), !s))
      return;
    const r = e.key === P.LEFT !== this.gos.get("enableRtl") ? "left" : "right";
    if (e.altKey) {
      this.isResizing = !0, this.resizeMultiplier += 1;
      const o = this.getViewportAdjustedResizeDiff(e);
      this.resizeHeader(o, e.shiftKey), (n = this.resizeFeature) == null || n.toggleColumnResizing(!0);
    } else
      this.moveHeader(r);
  }
  moveHeader(e) {
    var t;
    (t = this.beans.colMoves) == null || t.moveHeader(e, this.eGui, this.column, this.rowCtrl.pinned, this);
  }
  getViewportAdjustedResizeDiff(e) {
    const t = this.getResizeDiff(e), { pinnedCols: s } = this.beans;
    return s ? s.getHeaderResizeDiff(t, this.column) : t;
  }
  getResizeDiff(e) {
    const { gos: t, column: s } = this;
    let i = e.key === P.LEFT !== t.get("enableRtl");
    const r = s.getPinned(), n = t.get("enableRtl");
    return r && n !== (r === "right") && (i = !i), (i ? -1 : 1) * this.resizeMultiplier;
  }
  onGuiKeyUp() {
    this.isResizing && (this.resizeToggleTimeout && (window.clearTimeout(this.resizeToggleTimeout), this.resizeToggleTimeout = 0), this.isResizing = !1, this.resizeMultiplier = 1, this.resizeToggleTimeout = window.setTimeout(() => {
      var e;
      (e = this.resizeFeature) == null || e.toggleColumnResizing(!1);
    }, 150));
  }
  handleKeyDown(e) {
    const t = this.getWrapperHasFocus();
    switch (e.key) {
      case P.PAGE_DOWN:
      case P.PAGE_UP:
      case P.PAGE_HOME:
      case P.PAGE_END:
        t && e.preventDefault();
    }
  }
  addDomData(e) {
    const t = Gw, { eGui: s, gos: i } = this;
    fn(i, s, t, this), e.addDestroyFunc(() => fn(i, s, t, null));
  }
  focus(e) {
    const { eGui: t } = this;
    return t ? (this.lastFocusEvent = e || null, t.focus(), !0) : !1;
  }
  focusThis() {
    this.beans.focusSvc.focusedHeader = { headerRowIndex: this.rowCtrl.rowIndex, column: this.column };
  }
  removeDragSource() {
    var e;
    this.dragSource && ((e = this.beans.dragAndDrop) == null || e.removeDragSource(this.dragSource), this.dragSource = null);
  }
  handleContextMenuMouseEvent(e, t, s) {
    const i = e ?? t, { menuSvc: r, gos: n } = this.beans;
    n.get("preventDefaultOnContextMenu") && i.preventDefault(), r != null && r.isHeaderContextMenuEnabled(s) && r.showHeaderContextMenu(s, e, t), this.dispatchColumnMouseEvent("columnHeaderContextMenu", s);
  }
  dispatchColumnMouseEvent(e, t) {
    this.eventSvc.dispatchEvent({
      type: e,
      column: t
    });
  }
  setColHeaderHeight(e, t) {
    if (!e.setAutoHeaderHeight(t))
      return;
    const { eventSvc: s } = this;
    e.isColumn ? s.dispatchEvent({
      type: "columnHeaderHeightChanged",
      column: e,
      columns: [e],
      source: "autosizeColumnHeaderHeight"
    }) : s.dispatchEvent({
      type: "columnGroupHeaderHeightChanged",
      columnGroup: e,
      source: "autosizeColumnGroupHeaderHeight"
    });
  }
  clearComponent() {
    this.removeDragSource(), this.resizeFeature = null, this.comp = null, this.eGui = null;
  }
  destroy() {
    super.destroy(), this.column = null, this.lastFocusEvent = null, this.rowCtrl = null;
  }
}, SD = class extends Mh {
  constructor() {
    super(...arguments), this.refreshFunctions = {}, this.userHeaderClasses = /* @__PURE__ */ new Set(), this.ariaDescriptionProperties = /* @__PURE__ */ new Map();
  }
  setComp(e, t, s, i, r) {
    this.comp = e;
    const { colResize: n, context: o, colHover: a } = this.beans, l = pa(this, o, r);
    this.setGui(t, l), this.updateState(), this.setupWidth(l), this.setupMovingCss(l), this.setupMenuClass(l), this.setupSortableClass(l), this.setupWrapTextClass(), this.refreshSpanHeaderHeight(), this.setupAutoHeight({
      wrapperElement: i,
      checkMeasuringCallback: (d) => this.setRefreshFunction("measuring", d),
      compBean: l
    }), this.addColumnHoverListener(l), this.setupFilterClass(l), this.setupClassesFromColDef(), this.setupTooltip(), this.addActiveHeaderMouseListeners(l), this.setupSelectAll(l), this.setupUserComp(), this.refreshAria(), n ? this.resizeFeature = l.createManagedBean(
      n.createResizeFeature(this.rowCtrl.pinned, this.column, s, e, this)
    ) : re(s, !1), a == null || a.createHoverFeature(l, [this.column], t), l.createManagedBean(new Ah(this.column, t, this.beans)), l.createManagedBean(
      new Ir(t, {
        shouldStopEventPropagation: (d) => this.shouldStopEventPropagation(d),
        onTabKeyDown: () => null,
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this),
        onFocusOut: this.onFocusOut.bind(this)
      })
    ), this.addResizeAndMoveKeyboardListeners(l), l.addManagedPropertyListeners(
      ["suppressMovableColumns", "suppressMenuHide", "suppressAggFuncInHeader"],
      () => this.refresh()
    ), l.addManagedListeners(this.column, { colDefChanged: () => this.refresh() }), l.addManagedListeners(this.column, { headerHighlightChanged: this.onHeaderHighlightChanged.bind(this) });
    const c = () => this.checkDisplayName();
    l.addManagedEventListeners({
      columnValueChanged: c,
      columnRowGroupChanged: c,
      columnPivotChanged: c,
      headerHeightChanged: this.onHeaderHeightChanged.bind(this)
    }), l.addDestroyFunc(() => {
      this.refreshFunctions = {}, this.selectAllFeature = null, this.dragSourceElement = void 0, this.userCompDetails = null, this.userHeaderClasses.clear(), this.ariaDescriptionProperties.clear(), this.clearComponent();
    });
  }
  resizeHeader(e, t) {
    var s;
    (s = this.beans.colResize) == null || s.resizeHeader(this.column, e, t);
  }
  setupUserComp() {
    const e = this.lookupUserCompDetails();
    e && this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setUserCompDetails(e);
  }
  lookupUserCompDetails() {
    const e = this.createParams(), t = this.column.getColDef();
    return UT(this.beans.userCompFactory, t, e);
  }
  createParams() {
    const { menuSvc: e, sortSvc: t, colFilter: s, gos: i } = this.beans;
    return i.addGridCommonParams({
      column: this.column,
      displayName: this.displayName,
      enableSorting: this.column.isSortable(),
      enableMenu: this.menuEnabled,
      enableFilterButton: this.openFilterEnabled && !!(e != null && e.isHeaderFilterButtonEnabled(this.column)),
      enableFilterIcon: !!s && (!this.openFilterEnabled || Mt(this.gos)),
      showColumnMenu: (n) => {
        e == null || e.showColumnMenu({
          column: this.column,
          buttonElement: n,
          positionBy: "button"
        });
      },
      showColumnMenuAfterMouseClick: (n) => {
        e == null || e.showColumnMenu({
          column: this.column,
          mouseEvent: n,
          positionBy: "mouse"
        });
      },
      showFilter: (n) => {
        e == null || e.showFilterMenu({
          column: this.column,
          buttonElement: n,
          containerType: "columnFilter",
          positionBy: "button"
        });
      },
      progressSort: (n) => {
        t == null || t.progressSort(this.column, !!n, "uiColumnSorted");
      },
      setSort: (n, o) => {
        t == null || t.setSortForColumn(this.column, n, !!o, "uiColumnSorted");
      },
      eGridHeader: this.eGui,
      setTooltip: (n, o) => {
        i.assertModuleRegistered("Tooltip", 3), this.setupTooltip(n, o);
      }
    });
  }
  setupSelectAll(e) {
    const { selectionSvc: t } = this.beans;
    t && (this.selectAllFeature = e.createManagedBean(t.createSelectAllFeature(this.column)), this.selectAllFeature.setComp(this));
  }
  getSelectAllGui() {
    var e;
    return (e = this.selectAllFeature) == null ? void 0 : e.getCheckboxGui();
  }
  handleKeyDown(e) {
    var t;
    super.handleKeyDown(e), e.key === P.SPACE && ((t = this.selectAllFeature) == null || t.onSpaceKeyDown(e)), e.key === P.ENTER && this.onEnterKeyDown(e), e.key === P.DOWN && e.altKey && this.showMenuOnKeyPress(e, !1);
  }
  onEnterKeyDown(e) {
    var t;
    e.ctrlKey || e.metaKey ? this.showMenuOnKeyPress(e, !0) : this.sortable && ((t = this.beans.sortSvc) == null || t.progressSort(this.column, e.shiftKey, "uiColumnSorted"));
  }
  showMenuOnKeyPress(e, t) {
    const s = this.comp.getUserCompInstance();
    Zg(s) && s.onMenuKeyboardShortcut(t) && e.preventDefault();
  }
  onFocusIn(e) {
    this.eGui.contains(e.relatedTarget) || (this.focusThis(), this.announceAriaDescription()), gc() && this.setActiveHeader(!0);
  }
  onFocusOut(e) {
    this.eGui.contains(e.relatedTarget) || this.setActiveHeader(!1);
  }
  setupTooltip(e, t) {
    var s;
    this.tooltipFeature = (s = this.beans.tooltipSvc) == null ? void 0 : s.setupHeaderTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    );
  }
  setupClassesFromColDef() {
    const e = () => {
      const t = this.column.getColDef(), s = Ch(t, this.gos, this.column, null), i = this.userHeaderClasses;
      this.userHeaderClasses = new Set(s), s.forEach((r) => {
        i.has(r) ? i.delete(r) : this.comp.addOrRemoveCssClass(r, !0);
      }), i.forEach((r) => this.comp.addOrRemoveCssClass(r, !1));
    };
    this.setRefreshFunction("headerClasses", e), e();
  }
  setDragSource(e) {
    var t;
    this.dragSourceElement = e, this.removeDragSource(), !(!e || !this.draggable) && (this.dragSource = ((t = this.beans.colMoves) == null ? void 0 : t.setDragSourceForHeader(e, this.column, this.displayName)) ?? null);
  }
  updateState() {
    const { menuSvc: e } = this.beans;
    this.menuEnabled = !!(e != null && e.isColumnMenuInHeaderEnabled(this.column)), this.openFilterEnabled = !!(e != null && e.isFilterMenuInHeaderEnabled(this.column)), this.sortable = this.column.isSortable(), this.displayName = this.calculateDisplayName(), this.draggable = this.workOutDraggable();
  }
  setRefreshFunction(e, t) {
    this.refreshFunctions[e] = t;
  }
  refresh() {
    this.updateState(), this.refreshHeaderComp(), this.refreshAria(), Object.values(this.refreshFunctions).forEach((e) => e());
  }
  refreshHeaderComp() {
    const e = this.lookupUserCompDetails();
    if (!e)
      return;
    (this.comp.getUserCompInstance() != null && this.userCompDetails.componentClass == e.componentClass ? this.attemptHeaderCompRefresh(e.params) : !1) ? this.setDragSource(this.dragSourceElement) : this.setCompDetails(e);
  }
  attemptHeaderCompRefresh(e) {
    const t = this.comp.getUserCompInstance();
    return !t || !t.refresh ? !1 : t.refresh(e);
  }
  calculateDisplayName() {
    return this.beans.colNames.getDisplayNameForColumn(this.column, "header", !0);
  }
  checkDisplayName() {
    this.displayName !== this.calculateDisplayName() && this.refresh();
  }
  workOutDraggable() {
    const e = this.column.getColDef();
    return !!(!this.gos.get("suppressMovableColumns") && !e.suppressMovable && !e.lockPosition) || !!e.enableRowGroup || !!e.enablePivot;
  }
  setupWidth(e) {
    const t = () => {
      const s = this.column.getActualWidth();
      this.comp.setWidth(`${s}px`);
    };
    e.addManagedListeners(this.column, { widthChanged: t }), t();
  }
  setupMovingCss(e) {
    const t = () => {
      this.comp.addOrRemoveCssClass("ag-header-cell-moving", this.column.isMoving());
    };
    e.addManagedListeners(this.column, { movingChanged: t }), t();
  }
  setupMenuClass(e) {
    const t = () => {
      this.comp.addOrRemoveCssClass("ag-column-menu-visible", this.column.isMenuVisible());
    };
    e.addManagedListeners(this.column, { menuVisibleChanged: t }), t();
  }
  setupSortableClass(e) {
    const t = () => {
      this.comp.addOrRemoveCssClass("ag-header-cell-sortable", !!this.sortable);
    };
    t(), this.setRefreshFunction("updateSortable", t), e.addManagedEventListeners({ sortChanged: this.refreshAriaSort.bind(this) });
  }
  setupFilterClass(e) {
    const t = () => {
      const s = this.column.isFilterActive();
      this.comp.addOrRemoveCssClass("ag-header-cell-filtered", s), this.refreshAria();
    };
    e.addManagedListeners(this.column, { filterActiveChanged: t }), t();
  }
  setupWrapTextClass() {
    const e = () => {
      const t = !!this.column.getColDef().wrapHeaderText;
      this.comp.addOrRemoveCssClass("ag-header-cell-wrap-text", t);
    };
    e(), this.setRefreshFunction("wrapText", e);
  }
  onHeaderHighlightChanged() {
    const e = this.column.getHighlighted(), t = e === 0, s = e === 1;
    this.comp.addOrRemoveCssClass("ag-header-highlight-before", t), this.comp.addOrRemoveCssClass("ag-header-highlight-after", s);
  }
  onDisplayedColumnsChanged() {
    super.onDisplayedColumnsChanged(), this.isAlive() && this.onHeaderHeightChanged();
  }
  onHeaderHeightChanged() {
    this.refreshSpanHeaderHeight();
  }
  refreshSpanHeaderHeight() {
    const { eGui: e, column: t, comp: s, beans: i } = this, r = Ph(this.beans), n = r.reduce((d, u) => d += u, 0) === 0;
    if (s.addOrRemoveCssClass("ag-header-parent-hidden", n), !t.isSpanHeaderHeight()) {
      e.style.removeProperty("top"), e.style.removeProperty("height"), s.addOrRemoveCssClass("ag-header-span-height", !1), s.addOrRemoveCssClass("ag-header-span-total", !1);
      return;
    }
    const { numberOfParents: o, isSpanningTotal: a } = this.column.getColumnGroupPaddingInfo();
    s.addOrRemoveCssClass("ag-header-span-height", o > 0);
    const l = Th(i);
    if (o === 0) {
      s.addOrRemoveCssClass("ag-header-span-total", !1), e.style.setProperty("top", "0px"), e.style.setProperty("height", `${l}px`);
      return;
    }
    s.addOrRemoveCssClass("ag-header-span-total", a);
    let c = 0;
    for (let d = 0; d < o; d++)
      c += r[r.length - 1 - d];
    e.style.setProperty("top", `${-c}px`), e.style.setProperty("height", `${l + c}px`);
  }
  refreshAriaSort() {
    var e;
    if (this.sortable) {
      const t = this.getLocaleTextFunc(), s = ((e = this.beans.sortSvc) == null ? void 0 : e.getDisplaySortForColumn(this.column)) || null;
      this.comp.setAriaSort(wP(s)), this.setAriaDescriptionProperty("sort", t("ariaSortableColumn", "Press ENTER to sort"));
    } else
      this.comp.setAriaSort(), this.setAriaDescriptionProperty("sort", null);
  }
  refreshAriaMenu() {
    if (this.menuEnabled) {
      const e = this.getLocaleTextFunc();
      this.setAriaDescriptionProperty("menu", e("ariaMenuColumn", "Press ALT DOWN to open column menu"));
    } else
      this.setAriaDescriptionProperty("menu", null);
  }
  refreshAriaFilterButton() {
    if (this.openFilterEnabled && !Mt(this.gos)) {
      const e = this.getLocaleTextFunc();
      this.setAriaDescriptionProperty(
        "filterButton",
        e("ariaFilterColumn", "Press CTRL ENTER to open filter")
      );
    } else
      this.setAriaDescriptionProperty("filterButton", null);
  }
  refreshAriaFiltered() {
    const e = this.getLocaleTextFunc();
    this.column.isFilterActive() ? this.setAriaDescriptionProperty("filter", e("ariaColumnFiltered", "Column Filtered")) : this.setAriaDescriptionProperty("filter", null);
  }
  setAriaDescriptionProperty(e, t) {
    t != null ? this.ariaDescriptionProperties.set(e, t) : this.ariaDescriptionProperties.delete(e);
  }
  announceAriaDescription() {
    var t;
    if (!this.eGui.contains(Ie(this.beans)))
      return;
    const e = Array.from(this.ariaDescriptionProperties.keys()).sort((s, i) => s === "filter" ? -1 : i.charCodeAt(0) - s.charCodeAt(0)).map((s) => this.ariaDescriptionProperties.get(s)).join(". ");
    (t = this.beans.ariaAnnounce) == null || t.announceValue(e, "columnHeader");
  }
  refreshAria() {
    this.refreshAriaSort(), this.refreshAriaMenu(), this.refreshAriaFilterButton(), this.refreshAriaFiltered();
  }
  addColumnHoverListener(e) {
    var t;
    (t = this.beans.colHover) == null || t.addHeaderColumnHoverListener(e, this.comp, this.column);
  }
  addActiveHeaderMouseListeners(e) {
    const t = (r) => this.handleMouseOverChange(r.type === "mouseenter"), s = () => this.dispatchColumnMouseEvent("columnHeaderClicked", this.column), i = (r) => this.handleContextMenuMouseEvent(r, void 0, this.column);
    e.addManagedListeners(this.eGui, {
      mouseenter: t,
      mouseleave: t,
      click: s,
      contextmenu: i
    });
  }
  handleMouseOverChange(e) {
    this.setActiveHeader(e), this.eventSvc.dispatchEvent({
      type: e ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
      column: this.column
    });
  }
  setActiveHeader(e) {
    this.comp.addOrRemoveCssClass("ag-header-active", e);
  }
  getAnchorElementForMenu(e) {
    const t = this.comp.getUserCompInstance();
    return Zg(t) ? t.getAnchorElementForMenu(e) : this.eGui;
  }
  destroy() {
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), super.destroy();
  }
};
function Zg(e) {
  return typeof e.getAnchorElementForMenu == "function" && typeof e.onMenuKeyboardShortcut == "function";
}
var xD = 0, md = class extends L {
  constructor(e, t, s) {
    super(), this.rowIndex = e, this.pinned = t, this.type = s, this.instanceId = xD++;
    const i = s == "group" ? "ag-header-row-column-group" : s == "filter" ? "ag-header-row-column-filter" : "ag-header-row-column";
    this.headerRowClass = `ag-header-row ${i}`;
  }
  postConstruct() {
    this.isPrintLayout = It(this.gos, "print"), this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
  }
  /** Checks that every header cell that is currently visible has been rendered.
   * Can only be false under some circumstances when using React
   */
  areCellsRendered() {
    return this.comp ? this.getHeaderCellCtrls().every((e) => e.eGui != null) : !1;
  }
  /**
   *
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */
  setComp(e, t, s = !0) {
    this.comp = e, t = pa(this, this.beans.context, t), s && (this.onRowHeightChanged(), this.onVirtualColumnsChanged()), this.setWidth(), this.addEventListeners(t);
  }
  getAriaRowIndex() {
    return this.rowIndex + 1;
  }
  addEventListeners(e) {
    const t = this.onRowHeightChanged.bind(this);
    e.addManagedEventListeners({
      columnResized: this.setWidth.bind(this),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      virtualColumnsChanged: (s) => this.onVirtualColumnsChanged(s.afterScroll),
      columnGroupHeaderHeightChanged: t,
      columnHeaderHeightChanged: t,
      gridStylesChanged: t,
      advancedFilterEnabledChanged: t
    }), e.addManagedPropertyListener("domLayout", this.onDisplayedColumnsChanged.bind(this)), e.addManagedPropertyListener("ensureDomOrder", (s) => this.isEnsureDomOrder = s.currentValue), e.addManagedPropertyListeners(
      [
        "headerHeight",
        "pivotHeaderHeight",
        "groupHeaderHeight",
        "pivotGroupHeaderHeight",
        "floatingFiltersHeight"
      ],
      t
    );
  }
  getHeaderCellCtrl(e) {
    if (this.headerCellCtrls) {
      for (const t of this.headerCellCtrls.values())
        if (t.column === e)
          return t;
    }
  }
  onDisplayedColumnsChanged() {
    this.isPrintLayout = It(this.gos, "print"), this.onVirtualColumnsChanged(), this.setWidth(), this.onRowHeightChanged();
  }
  setWidth() {
    const e = this.getWidthForRow();
    this.comp.setWidth(`${e}px`);
  }
  getWidthForRow() {
    const { visibleCols: e } = this.beans;
    return this.isPrintLayout ? this.pinned != null ? 0 : e.getContainerWidth("right") + e.getContainerWidth("left") + e.getContainerWidth(null) : e.getContainerWidth(this.pinned);
  }
  onRowHeightChanged() {
    const { topOffset: e, rowHeight: t } = this.getTopAndHeight();
    this.comp.setTop(e + "px"), this.comp.setHeight(t + "px");
  }
  getTopAndHeight() {
    const { filterManager: e } = this.beans, t = [], s = Ph(this.beans), i = Th(this.beans);
    t.push(...s), t.push(i), e != null && e.hasFloatingFilters() && t.push(Eh(this.beans));
    let r = 0;
    for (let o = 0; o < this.rowIndex; o++)
      r += t[o];
    const n = t[this.rowIndex];
    return { topOffset: r, rowHeight: n };
  }
  onVirtualColumnsChanged(e = !1) {
    const t = this.getHeaderCtrls(), s = this.isEnsureDomOrder || this.isPrintLayout;
    this.comp.setHeaderCtrls(t, s, e);
  }
  getHeaderCtrls() {
    const e = this.headerCellCtrls;
    this.headerCellCtrls = /* @__PURE__ */ new Map();
    const t = this.getColumnsInViewport();
    for (const i of t)
      this.recycleAndCreateHeaderCtrls(i, e);
    const s = (i) => {
      const { focusSvc: r, visibleCols: n } = this.beans;
      return r.isHeaderWrapperFocused(i) ? n.isVisible(i.column) : !1;
    };
    if (e)
      for (const [i, r] of e)
        s(r) ? this.headerCellCtrls.set(i, r) : this.destroyBean(r);
    return this.getHeaderCellCtrls();
  }
  getHeaderCellCtrls() {
    var e;
    return Array.from(((e = this.headerCellCtrls) == null ? void 0 : e.values()) ?? []);
  }
  recycleAndCreateHeaderCtrls(e, t) {
    if (!this.headerCellCtrls || e.isEmptyGroup())
      return;
    const s = e.getUniqueId();
    let i;
    if (t && (i = t.get(s), t.delete(s)), i && i.column != e && (this.destroyBean(i), i = void 0), i == null)
      switch (this.type) {
        case "filter": {
          i = this.createBean(
            this.beans.registry.createDynamicBean(
              "headerFilterCellCtrl",
              !0,
              e,
              this
            )
          );
          break;
        }
        case "group":
          i = this.createBean(
            this.beans.registry.createDynamicBean(
              "headerGroupCellCtrl",
              !0,
              e,
              this
            )
          );
          break;
        default:
          i = this.createBean(new SD(e, this));
          break;
      }
    this.headerCellCtrls.set(s, i);
  }
  getColumnsInViewport() {
    return this.isPrintLayout ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
  }
  getColumnsInViewportPrintLayout() {
    if (this.pinned != null)
      return [];
    let e = [];
    const t = this.getActualDepth(), { colViewport: s } = this.beans;
    return ["left", null, "right"].forEach((i) => {
      const r = s.getHeadersToRender(i, t);
      e = e.concat(r);
    }), e;
  }
  getActualDepth() {
    return this.type == "filter" ? this.rowIndex - 1 : this.rowIndex;
  }
  getColumnsInViewportNormalLayout() {
    return this.beans.colViewport.getHeadersToRender(this.pinned, this.getActualDepth());
  }
  findHeaderCellCtrl(e) {
    if (!this.headerCellCtrls)
      return;
    const t = this.getHeaderCellCtrls();
    let s;
    return typeof e == "function" ? s = t.find(e) : s = t.find((i) => i.column == e), s;
  }
  focusHeader(e, t) {
    const s = this.findHeaderCellCtrl(e);
    return s ? s.focus(t) : !1;
  }
  destroy() {
    var e;
    (e = this.headerCellCtrls) == null || e.forEach((t) => {
      this.destroyBean(t);
    }), this.headerCellCtrls = void 0, super.destroy();
  }
}, Bw = class extends L {
  constructor(e) {
    super(), this.pinned = e, this.hidden = !1, this.includeFloatingFilter = !1, this.groupsRowCtrls = [];
  }
  setComp(e, t) {
    this.comp = e, this.eViewport = t;
    const { pinnedCols: s, ctrlsSvc: i, colModel: r, colMoves: n, filterManager: o } = this.beans;
    this.setupCenterWidth(), s == null || s.setupHeaderPinnedWidth(this), this.setupDragAndDrop(n, this.eViewport);
    const a = this.onDisplayedColumnsChanged.bind(this, o);
    this.addManagedEventListeners({
      gridColumnsChanged: this.onGridColumnsChanged.bind(this),
      displayedColumnsChanged: a,
      advancedFilterEnabledChanged: a
    });
    const l = `${typeof this.pinned == "string" ? this.pinned : "center"}Header`;
    i.register(l, this), r.ready && this.refresh();
  }
  getAllCtrls() {
    const e = [...this.groupsRowCtrls];
    return this.columnsRowCtrl && e.push(this.columnsRowCtrl), this.filtersRowCtrl && e.push(this.filtersRowCtrl), e;
  }
  refresh(e = !1) {
    const { focusSvc: t, colModel: s, filterManager: i } = this.beans;
    let r = 0;
    const n = t.getFocusHeaderToUseAfterRefresh(), o = () => {
      const d = Lw(s) - 1;
      this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
      for (let u = 0; u < d; u++) {
        const h = this.createBean(new md(r++, this.pinned, "group"));
        this.groupsRowCtrls.push(h);
      }
    }, a = () => {
      const d = r++, u = !this.hidden && (this.columnsRowCtrl == null || !e || this.columnsRowCtrl.rowIndex !== d);
      (u || this.hidden) && (this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl)), u && (this.columnsRowCtrl = this.createBean(new md(d, this.pinned, "column")));
    }, l = () => {
      this.includeFloatingFilter = !!(i != null && i.hasFloatingFilters()) && !this.hidden;
      const d = () => {
        this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
      };
      if (!this.includeFloatingFilter) {
        d();
        return;
      }
      const u = r++;
      if (this.filtersRowCtrl) {
        const h = this.filtersRowCtrl.rowIndex !== u;
        (!e || h) && d();
      }
      this.filtersRowCtrl || (this.filtersRowCtrl = this.createBean(new md(u, this.pinned, "filter")));
    };
    o(), a(), l();
    const c = this.getAllCtrls();
    this.comp.setCtrls(c), this.restoreFocusOnHeader(t, n);
  }
  getHeaderCtrlForColumn(e) {
    var t;
    if (Ri(e))
      return (t = this.columnsRowCtrl) == null ? void 0 : t.getHeaderCellCtrl(e);
    if (this.groupsRowCtrls.length !== 0)
      for (let s = 0; s < this.groupsRowCtrls.length; s++) {
        const i = this.groupsRowCtrls[s].getHeaderCellCtrl(e);
        if (i)
          return i;
      }
  }
  getHtmlElementForColumnHeader(e) {
    var t;
    return ((t = this.getHeaderCtrlForColumn(e)) == null ? void 0 : t.eGui) ?? null;
  }
  getRowType(e) {
    var t;
    return (t = this.getAllCtrls()[e]) == null ? void 0 : t.type;
  }
  focusHeader(e, t, s) {
    const r = this.getAllCtrls()[e];
    return r ? r.focusHeader(t, s) : !1;
  }
  getGroupRowCount() {
    return this.groupsRowCtrls.length;
  }
  getGroupRowCtrlAtIndex(e) {
    return this.groupsRowCtrls[e];
  }
  getRowCount() {
    return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
  }
  setHorizontalScroll(e) {
    this.comp.setViewportScrollLeft(e);
  }
  onScrollCallback(e) {
    this.addManagedElementListeners(this.eViewport, { scroll: e });
  }
  destroy() {
    this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl), this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl), this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls), super.destroy();
  }
  setupDragAndDrop(e, t) {
    const s = e == null ? void 0 : e.createBodyDropTarget(this.pinned, t);
    s && this.createManagedBean(s);
  }
  restoreFocusOnHeader(e, t) {
    if (!t)
      return;
    const { column: s } = t;
    s.getPinned() == this.pinned && e.focusHeaderPosition({ headerPosition: t });
  }
  // grid cols have changed - this also means the number of rows in the header can have
  // changed. so we remove all the old rows and insert new ones for a complete refresh
  onGridColumnsChanged() {
    this.refresh(!0);
  }
  onDisplayedColumnsChanged(e) {
    const t = !!(e != null && e.hasFloatingFilters()) && !this.hidden;
    this.includeFloatingFilter !== t && this.refresh(!0);
  }
  setupCenterWidth() {
    this.pinned == null && this.createManagedBean(new xh((e) => this.comp.setCenterWidth(`${e}px`), !0));
  }
}, RD = class extends L {
  constructor() {
    super(...arguments), this.beanName = "menuSvc";
  }
  postConstruct() {
    const { enterpriseMenuFactory: e, filterMenuFactory: t } = this.beans;
    this.activeMenuFactory = e ?? t;
  }
  showColumnMenu(e) {
    this.showColumnMenuCommon(this.activeMenuFactory, e, "columnMenu");
  }
  showFilterMenu(e) {
    const { enterpriseMenuFactory: t, filterMenuFactory: s } = this.beans, i = t && Mt(this.gos) ? t : s;
    this.showColumnMenuCommon(i, e, e.containerType, !0);
  }
  showHeaderContextMenu(e, t, s) {
    var i;
    (i = this.activeMenuFactory) == null || i.showMenuAfterContextMenuEvent(e, t, s);
  }
  hidePopupMenu() {
    var e, t;
    (e = this.beans.contextMenuSvc) == null || e.hideActiveMenu(), (t = this.activeMenuFactory) == null || t.hideActiveMenu();
  }
  isColumnMenuInHeaderEnabled(e) {
    var s;
    const { suppressHeaderMenuButton: t } = e.getColDef();
    return !t && !!((s = this.activeMenuFactory) != null && s.isMenuEnabled(e)) && (Mt(this.gos) || !!this.beans.enterpriseMenuFactory);
  }
  isFilterMenuInHeaderEnabled(e) {
    var t;
    return !e.getColDef().suppressHeaderFilterButton && !!((t = this.beans.filterManager) != null && t.isFilterAllowed(e));
  }
  isHeaderContextMenuEnabled(e) {
    const t = e && Ri(e) ? e.getColDef() : e == null ? void 0 : e.getColGroupDef();
    return !(t != null && t.suppressHeaderContextMenu) && this.gos.get("columnMenu") === "new";
  }
  isHeaderMenuButtonAlwaysShowEnabled() {
    return this.isSuppressMenuHide();
  }
  isHeaderMenuButtonEnabled() {
    const e = !this.isSuppressMenuHide();
    return !(yr() && e);
  }
  isHeaderFilterButtonEnabled(e) {
    return this.isFilterMenuInHeaderEnabled(e) && !Mt(this.gos) && !this.isFloatingFilterButtonDisplayed(e);
  }
  isFilterMenuItemEnabled(e) {
    var t;
    return !!((t = this.beans.filterManager) != null && t.isFilterAllowed(e)) && !Mt(this.gos) && !this.isFilterMenuInHeaderEnabled(e) && !this.isFloatingFilterButtonDisplayed(e);
  }
  isFloatingFilterButtonEnabled(e) {
    return !e.getColDef().suppressFloatingFilterButton;
  }
  isFloatingFilterButtonDisplayed(e) {
    return !!e.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(e);
  }
  isSuppressMenuHide() {
    const e = this.gos, t = e.get("suppressMenuHide");
    return Mt(e) ? e.exists("suppressMenuHide") ? t : !1 : t;
  }
  showColumnMenuCommon(e, t, s, i) {
    const { positionBy: r } = t, n = t.column;
    if (r === "button") {
      const { buttonElement: o } = t;
      e == null || e.showMenuAfterButtonClick(n, o, s, i);
    } else if (r === "mouse") {
      const { mouseEvent: o } = t;
      e == null || e.showMenuAfterMouseEvent(n, o, s, i);
    } else if (n) {
      const o = this.beans, a = o.ctrlsSvc;
      a.getScrollFeature().ensureColumnVisible(n, "auto"), _s(o, () => {
        var c;
        const l = (c = a.getHeaderRowContainerCtrl(n.getPinned())) == null ? void 0 : c.getHeaderCtrlForColumn(n);
        l && (e == null || e.showMenuAfterButtonClick(
          n,
          l.getAnchorElementForMenu(i),
          s,
          !0
        ));
      });
    }
  }
};
function Vl(e, t, s) {
  e.menuVisible !== t && (e.menuVisible = t, e.dispatchColEvent("menuVisibleChanged", s));
}
var Vw = class extends _ {
  constructor() {
    super();
  }
}, FD = class extends Vw {
  init() {
    var t;
    const e = St((t = this.gos.get("overlayLoadingTemplate")) == null ? void 0 : t.trim());
    if (this.setTemplate(
      e ?? /* html */
      '<span aria-live="polite" aria-atomic="true" class="ag-overlay-loading-center"></span>'
    ), !e) {
      const s = this.getLocaleTextFunc();
      setTimeout(() => {
        this.getGui().textContent = s("loadingOoo", "Loading...");
      });
    }
  }
}, PD = class extends Vw {
  init() {
    var t;
    const e = St((t = this.gos.get("overlayNoRowsTemplate")) == null ? void 0 : t.trim());
    if (this.setTemplate(e ?? /* html */
    '<span class="ag-overlay-no-rows-center"></span>'), !e) {
      const s = this.getLocaleTextFunc();
      setTimeout(() => {
        this.getGui().textContent = s("noRowsToShow", "No Rows To Show");
      });
    }
  }
};
function br(e, t, s) {
  const i = ue(e, t, s);
  if (i) {
    const { className: n } = i;
    if (typeof n == "string" && n.indexOf("ag-icon") > -1 || typeof n == "object" && n["ag-icon"])
      return i;
  }
  const r = document.createElement("span");
  return r.appendChild(i), r;
}
function ue(e, t, s) {
  var n;
  let i = null;
  e === "smallDown" ? I(262) : e === "smallLeft" ? I(263) : e === "smallRight" && I(264);
  const r = s && s.getColDef().icons;
  if (r && (i = r[e]), t.gos && !i) {
    const o = t.gos.get("icons");
    o && (i = o[e]);
  }
  if (i) {
    let o;
    if (typeof i == "function")
      o = i();
    else if (typeof i == "string")
      o = i;
    else {
      I(38, { iconName: e });
      return;
    }
    if (typeof o == "string")
      return ss(o);
    if (ac(o))
      return o;
    I(133, { iconName: e });
    return;
  } else {
    const o = document.createElement("span"), a = t.registry.getIcon(e);
    a || (n = t.validation) == null || n.validateIcon(e);
    const l = a ?? e;
    return o.setAttribute("class", `ag-icon ag-icon-${l}`), o.setAttribute("unselectable", "on"), nt(o, "presentation"), o;
  }
}
var TD = (
  /*css*/
  ".ag-dnd-ghost{align-items:center;background-color:var(--ag-drag-and-drop-image-background-color);border:var(--ag-drag-and-drop-image-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-drag-and-drop-image-shadow);color:var(--ag-text-color);cursor:move;display:flex;font-weight:500;gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding);text-overflow:ellipsis;transform:translateY(calc(var(--ag-spacing)*2));white-space:nowrap}"
), ED = class extends _ {
  constructor() {
    super(), this.dragSource = null, this.eIcon = E, this.eLabel = E, this.registerCSS(TD);
  }
  postConstruct() {
    const e = (t) => br(t, this.beans, null);
    this.dropIconMap = {
      pinned: e("columnMovePin"),
      hide: e("columnMoveHide"),
      move: e("columnMoveMove"),
      left: e("columnMoveLeft"),
      right: e("columnMoveRight"),
      group: e("columnMoveGroup"),
      aggregate: e("columnMoveValue"),
      pivot: e("columnMovePivot"),
      notAllowed: e("dropNotAllowed")
    };
  }
  init(e) {
    this.dragSource = e.dragSource, this.setTemplate(
      /* html */
      `<div class="ag-dnd-ghost ag-unselectable">
                <span data-ref="eIcon" class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>
                <div data-ref="eLabel" class="ag-dnd-ghost-label"></div>
            </div>`
    );
  }
  destroy() {
    this.dragSource = null, super.destroy();
  }
  setIcon(e, t) {
    const { eIcon: s, dragSource: i, dropIconMap: r, gos: n } = this;
    ze(s);
    let o = null;
    e || (e = i != null && i.getDefaultIconName ? i.getDefaultIconName() : "notAllowed"), o = r[e], s.classList.toggle("ag-shake-left-to-right", t), !(o === r.hide && n.get("suppressDragLeaveHidesColumns")) && o && s.appendChild(o);
  }
  setLabel(e) {
    this.eLabel.textContent = Ke(e);
  }
}, DD = (
  /*css*/
  ".ag-label{white-space:nowrap}:where(.ag-ltr) .ag-label{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-label-align-right) .ag-label{order:1}:where(.ag-ltr) :where(.ag-label-align-right) .ag-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) :where(.ag-label-align-right) .ag-label{margin-right:var(--ag-spacing)}.ag-label-align-right>*{flex:none}.ag-label-align-top{align-items:flex-start;flex-direction:column;>*{align-self:stretch}}.ag-label-ellipsis{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-label-align-top) .ag-label{margin-bottom:calc(var(--ag-spacing)*.5)}"
), Ih = class extends _ {
  constructor(e, t, s) {
    super(t, s), this.labelSeparator = "", this.labelAlignment = "left", this.disabled = !1, this.label = "", this.config = e || {}, this.registerCSS(DD);
  }
  postConstruct() {
    this.addCssClass("ag-labeled"), this.eLabel.classList.add("ag-label");
    const { labelSeparator: e, label: t, labelWidth: s, labelAlignment: i, disabled: r } = this.config;
    r != null && this.setDisabled(r), e != null && this.setLabelSeparator(e), t != null && this.setLabel(t), s != null && this.setLabelWidth(s), this.setLabelAlignment(i || this.labelAlignment), this.refreshLabel();
  }
  refreshLabel() {
    const { label: e, eLabel: t } = this;
    ze(t), typeof e == "string" ? t.innerText = e + this.labelSeparator : e && t.appendChild(e), e === "" ? (re(t, !1), nt(t, "presentation")) : (re(t, !0), nt(t, null));
  }
  setLabelSeparator(e) {
    return this.labelSeparator === e ? this : (this.labelSeparator = e, this.label != null && this.refreshLabel(), this);
  }
  getLabelId() {
    const e = this.eLabel;
    return e.id = e.id || `ag-${this.getCompId()}-label`, e.id;
  }
  getLabel() {
    return this.label;
  }
  setLabel(e) {
    return this.label === e ? this : (this.label = e, this.refreshLabel(), this);
  }
  setLabelAlignment(e) {
    const s = this.getGui().classList;
    return s.toggle("ag-label-align-left", e === "left"), s.toggle("ag-label-align-right", e === "right"), s.toggle("ag-label-align-top", e === "top"), this;
  }
  setLabelEllipsis(e) {
    return this.eLabel.classList.toggle("ag-label-ellipsis", e), this;
  }
  setLabelWidth(e) {
    return this.label == null ? this : (Rl(this.eLabel, e), this);
  }
  setDisabled(e) {
    e = !!e;
    const t = this.getGui();
    return Bs(t, e), t.classList.toggle("ag-disabled", e), this.disabled = e, this;
  }
  isDisabled() {
    return !!this.disabled;
  }
}, Nw = class extends Ih {
  constructor(e, t, s, i) {
    super(e, t, s), this.className = i;
  }
  postConstruct() {
    super.postConstruct();
    const { width: e, value: t, onValueChange: s } = this.config;
    e != null && this.setWidth(e), t != null && this.setValue(t), s != null && this.onValueChange(s), this.className && this.addCssClass(this.className), this.refreshAriaLabelledBy();
  }
  setLabel(e) {
    return super.setLabel(e), this.refreshAriaLabelledBy(), this;
  }
  refreshAriaLabelledBy() {
    const e = this.getAriaElement(), t = this.getLabelId(), s = this.getLabel();
    s == null || s == "" || bP(e) !== null ? xr(e, "") : xr(e, t ?? "");
  }
  setAriaLabel(e) {
    return ot(this.getAriaElement(), e), this.refreshAriaLabelledBy(), this;
  }
  onValueChange(e) {
    return this.addManagedListeners(this, { fieldValueChanged: () => e(this.getValue()) }), this;
  }
  getWidth() {
    return this.getGui().clientWidth;
  }
  setWidth(e) {
    return si(this.getGui(), e), this;
  }
  getPreviousValue() {
    return this.previousValue;
  }
  getValue() {
    return this.value;
  }
  setValue(e, t) {
    return this.value === e ? this : (this.previousValue = this.value, this.value = e, t || this.dispatchLocalEvent({ type: "fieldValueChanged" }), this);
  }
}, mr = class extends Nw {
  constructor(e, t, s = "text", i = "input") {
    super(
      e,
      (e == null ? void 0 : e.template) ?? /* html */
      `
            <div role="presentation">
                <div data-ref="eLabel" class="ag-input-field-label"></div>
                <div data-ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation">
                    <${i} data-ref="eInput" class="ag-input-field-input"></${i}>
                </div>
            </div>`,
      [],
      t
    ), this.inputType = s, this.displayFieldTag = i, this.eLabel = E, this.eWrapper = E, this.eInput = E;
  }
  postConstruct() {
    super.postConstruct(), this.setInputType();
    const { eLabel: e, eWrapper: t, eInput: s, className: i } = this;
    e.classList.add(`${i}-label`), t.classList.add(`${i}-input-wrapper`), s.classList.add(`${i}-input`), this.addCssClass("ag-input-field"), s.id = s.id || `ag-${this.getCompId()}-input`;
    const { inputName: r, inputWidth: n } = this.config;
    r != null && this.setInputName(r), n != null && this.setInputWidth(n), this.addInputListeners(), this.activateTabIndex([s]);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, { input: (e) => this.setValue(e.target.value) });
  }
  setInputType() {
    this.displayFieldTag === "input" && this.eInput.setAttribute("type", this.inputType);
  }
  getInputElement() {
    return this.eInput;
  }
  setInputWidth(e) {
    return Rl(this.eWrapper, e), this;
  }
  setInputName(e) {
    return this.getInputElement().setAttribute("name", e), this;
  }
  getFocusableElement() {
    return this.eInput;
  }
  setMaxLength(e) {
    const t = this.eInput;
    return t.maxLength = e, this;
  }
  setInputPlaceholder(e) {
    return zs(this.eInput, "placeholder", e), this;
  }
  setInputAriaLabel(e) {
    return ot(this.eInput, e), this.refreshAriaLabelledBy(), this;
  }
  setDisabled(e) {
    return Bs(this.eInput, e), super.setDisabled(e);
  }
  setAutoComplete(e) {
    if (e === !0)
      zs(this.eInput, "autocomplete", null);
    else {
      const t = typeof e == "string" ? e : "off";
      zs(this.eInput, "autocomplete", t);
    }
    return this;
  }
}, Pn = class extends mr {
  constructor(e, t = "ag-checkbox", s = "checkbox") {
    super(e, t, s), this.labelAlignment = "right", this.selected = !1, this.readOnly = !1, this.passive = !1;
  }
  postConstruct() {
    super.postConstruct();
    const { readOnly: e, passive: t } = this.config;
    typeof e == "boolean" && this.setReadOnly(e), typeof t == "boolean" && this.setPassive(t);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, { click: this.onCheckboxClick.bind(this) }), this.addManagedElementListeners(this.eLabel, { click: this.toggle.bind(this) });
  }
  getNextValue() {
    return this.selected === void 0 ? !0 : !this.selected;
  }
  setPassive(e) {
    this.passive = e;
  }
  isReadOnly() {
    return this.readOnly;
  }
  setReadOnly(e) {
    this.eWrapper.classList.toggle("ag-disabled", e), this.eInput.disabled = e, this.readOnly = e;
  }
  setDisabled(e) {
    return this.eWrapper.classList.toggle("ag-disabled", e), super.setDisabled(e);
  }
  toggle() {
    if (this.eInput.disabled)
      return;
    const e = this.isSelected(), t = this.getNextValue();
    this.passive ? this.dispatchChange(t, e) : this.setValue(t);
  }
  getValue() {
    return this.isSelected();
  }
  setValue(e, t) {
    return this.refreshSelectedClass(e), this.setSelected(e, t), this;
  }
  setName(e) {
    const t = this.getInputElement();
    return t.name = e, this;
  }
  isSelected() {
    return this.selected;
  }
  setSelected(e, t) {
    if (this.isSelected() === e)
      return;
    this.previousValue = this.isSelected(), e = this.selected = typeof e == "boolean" ? e : void 0;
    const s = this.eInput;
    s.checked = e, s.indeterminate = e === void 0, t || this.dispatchChange(this.selected, this.previousValue);
  }
  dispatchChange(e, t, s) {
    this.dispatchLocalEvent({ type: "fieldValueChanged", selected: e, previousValue: t, event: s });
    const i = this.getInputElement();
    this.eventSvc.dispatchEvent({
      type: "checkboxChanged",
      id: i.id,
      name: i.name,
      selected: e,
      previousValue: t
    });
  }
  onCheckboxClick(e) {
    if (this.passive || this.eInput.disabled)
      return;
    const t = this.isSelected(), s = this.selected = e.target.checked;
    this.refreshSelectedClass(s), this.dispatchChange(s, t, e);
  }
  refreshSelectedClass(e) {
    const t = this.eWrapper.classList;
    t.toggle("ag-checked", e === !0), t.toggle("ag-indeterminate", e == null);
  }
}, ai = {
  selector: "AG-CHECKBOX",
  component: Pn
}, AD = (
  /*css*/
  ".ag-checkbox-cell{height:100%}"
), MD = class extends _ {
  constructor() {
    super(
      /* html*/
      `
            <div class="ag-cell-wrapper ag-checkbox-cell" role="presentation">
                <ag-checkbox role="presentation" data-ref="eCheckbox"></ag-checkbox>
            </div>`,
      [ai]
    ), this.eCheckbox = E, this.registerCSS(AD);
  }
  init(e) {
    this.refresh(e);
    const { eCheckbox: t, beans: s } = this, i = t.getInputElement();
    i.setAttribute("tabindex", "-1"), WC(i, "polite"), this.addManagedListeners(i, {
      click: (r) => {
        if (gt(r), t.isDisabled())
          return;
        const n = t.getValue();
        this.onCheckboxChanged(n);
      },
      dblclick: (r) => {
        gt(r);
      }
    }), this.addManagedElementListeners(e.eGridCell, {
      keydown: (r) => {
        if (r.key === P.SPACE && !t.isDisabled()) {
          e.eGridCell === Ie(s) && t.toggle();
          const n = t.getValue();
          this.onCheckboxChanged(n), r.preventDefault();
        }
      }
    });
  }
  refresh(e) {
    return this.params = e, this.updateCheckbox(e), !0;
  }
  updateCheckbox(e) {
    let t, s = !0;
    const { value: i, column: r, node: n } = e;
    if (n.group && r)
      if (typeof i == "boolean")
        t = i;
      else {
        const u = r.getColId();
        u.startsWith(Tr) ? t = i == null || i === "" ? void 0 : i === "true" : n.aggData && n.aggData[u] !== void 0 ? t = i ?? void 0 : s = !1;
      }
    else
      t = i ?? void 0;
    const { eCheckbox: o } = this;
    if (!s) {
      o.setDisplayed(!1);
      return;
    }
    o.setValue(t);
    const a = e.disabled ?? !(r != null && r.isCellEditable(n));
    o.setDisabled(a);
    const l = this.getLocaleTextFunc(), c = rh(l, t), d = a ? c : `${l("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${c})`;
    o.setInputAriaLabel(d);
  }
  onCheckboxChanged(e) {
    const { eventSvc: t, params: s } = this, { column: i, node: r, value: n } = s, o = {
      column: i,
      colDef: i.getColDef(),
      data: r.data,
      node: r,
      rowIndex: r.rowIndex,
      rowPinned: r.rowPinned,
      value: n
    };
    t.dispatchEvent({
      type: "cellEditingStarted",
      ...o
    });
    const a = r.setDataValue(i, e, "edit");
    t.dispatchEvent({
      type: "cellEditingStopped",
      ...o,
      oldValue: n,
      newValue: e,
      valueChanged: a
    }), a || this.updateCheckbox(s);
  }
}, ID = "ROOT_NODE_ID", Hw = class extends L {
  constructor() {
    super(...arguments), this.nextId = 0, this.allNodesMap = {}, this.rootNode = null;
  }
  get treeData() {
    return !1;
  }
  getRowNode(e) {
    return this.allNodesMap[e];
  }
  extractRowData() {
    var e, t;
    return (t = (e = this.rootNode) == null ? void 0 : e.allLeafChildren) == null ? void 0 : t.map((s) => s.data);
  }
  activate(e) {
    this.rootNode = e, e.group = !0, e.level = -1, e.id = ID, e.allLeafChildren = [], e.childrenAfterGroup = [], e.childrenAfterSort = [], e.childrenAfterAggFilter = [], e.childrenAfterFilter = [], this.updateRootSiblingArrays(e);
  }
  deactivate() {
    this.rootNode && (this.allNodesMap = {}, this.rootNode = null);
  }
  destroy() {
    super.destroy(), this.allNodesMap = {}, this.rootNode = null;
  }
  setNewRowData(e) {
    const t = this.rootNode;
    t && (this.dispatchRowDataUpdateStartedEvent(e), t.childrenAfterFilter = null, t.childrenAfterGroup = null, t.childrenAfterAggFilter = null, t.childrenAfterSort = null, t.childrenMapped = null, t.updateHasChildren(), this.allNodesMap = {}, this.nextId = 0, this.loadNewRowData(e), this.updateRootSiblingArrays(t));
  }
  updateRootSiblingArrays(e) {
    const t = e.sibling;
    t && (t.childrenAfterFilter = e.childrenAfterFilter, t.childrenAfterGroup = e.childrenAfterGroup, t.childrenAfterAggFilter = e.childrenAfterAggFilter, t.childrenAfterSort = e.childrenAfterSort, t.childrenMapped = e.childrenMapped, t.allLeafChildren = e.allLeafChildren);
  }
  loadNewRowData(e) {
    this.rootNode.allLeafChildren = (e == null ? void 0 : e.map((t, s) => this.createRowNode(t, s))) ?? [];
  }
  setImmutableRowData(e, t) {
    const s = this.createTransactionForRowData(t), i = this.updateRowData(s, e.changedRowNodes);
    let r = !1;
    this.gos.get("suppressMaintainUnsortedOrder") || (r = this.updateRowOrderFromRowData(t));
    const { rowNodeTransaction: n, rowsInserted: o } = i, { add: a, remove: l, update: c } = n;
    (o || r || a.length || l.length || c.length) && (e.step = "group", e.rowDataUpdated = !0, e.rowNodeTransactions = [n], e.rowNodesOrderChanged = o || r);
  }
  updateRowData(e, t) {
    this.dispatchRowDataUpdateStartedEvent(e.add);
    const s = {
      changedRowNodes: t,
      rowNodeTransaction: { remove: [], update: [], add: [] },
      rowsInserted: !1
    }, i = [], r = _i(this.gos);
    return this.executeRemove(r, e, s, i), this.executeUpdate(r, e, s, i), this.executeAdd(e, s), this.deselectNodes(i), s;
  }
  /** Converts the setRowData() command to a transaction */
  createTransactionForRowData(e) {
    const t = _i(this.gos), s = { ...this.allNodesMap }, i = [], r = [], n = [];
    W(e) && e.forEach((o) => {
      const a = t({ data: o, level: 0 }), l = s[a];
      l ? (l.data !== o && r.push(o), s[a] = void 0) : n.push(o);
    });
    for (const o of Object.values(s))
      o && i.push(o.data);
    return { remove: i, update: r, add: n };
  }
  /**
   * Used by setImmutableRowData, after updateRowData, after updating with a generated transaction to
   * apply the order as specified by the the new data. We use sourceRowIndex to determine the order of the rows.
   * Time complexity is O(n) where n is the number of rows/rowData
   * @returns true if the order changed, otherwise false
   */
  updateRowOrderFromRowData(e) {
    var o;
    const t = (o = this.rootNode) == null ? void 0 : o.allLeafChildren, s = (t == null ? void 0 : t.length) ?? 0, i = /* @__PURE__ */ new Map();
    let r = -1, n = -1;
    for (let a = 0; a < s; ++a) {
      const l = t[a], c = l.data;
      c !== e[a] && (n < 0 && (r = a), n = a, i.set(c, l));
    }
    if (r < 0)
      return !1;
    for (let a = r; a <= n; ++a) {
      const l = i.get(e[a]);
      l !== void 0 && (t[a] = l, l.sourceRowIndex = a);
    }
    return !0;
  }
  executeAdd(e, t) {
    const s = e.add;
    if (!(s != null && s.length))
      return;
    let i = this.rootNode.allLeafChildren, r = i.length;
    if (typeof e.addIndex == "number" && (r = this.sanitizeAddIndex(e.addIndex), r > 0 && this.gos.get("treeData") && this.gos.get("getDataPath")))
      for (let u = 0; u < i.length; u++) {
        const h = i[u];
        if ((h == null ? void 0 : h.rowIndex) == r - 1) {
          r = u + 1;
          break;
        }
      }
    const n = s.length, o = t.changedRowNodes, a = new Array(n);
    for (let d = 0; d < n; d++) {
      const u = this.createRowNode(s[d], r + d);
      o.add(u), a[d] = u;
    }
    const l = this.rootNode;
    if (r < i.length) {
      const d = i.slice(0, r), u = i.slice(r, i.length), h = d.length + a.length;
      for (let p = 0, g = u.length; p < g; ++p)
        u[p].sourceRowIndex = h + p;
      i = [...d, ...a, ...u], t.rowsInserted = !0;
    } else
      i = i.concat(a);
    l.allLeafChildren = i;
    const c = l.sibling;
    c && (c.allLeafChildren = i), t.rowNodeTransaction.add = a;
  }
  executeRemove(e, t, { changedRowNodes: s, rowNodeTransaction: i }, r) {
    var c, d;
    const { remove: n } = t;
    if (!(n != null && n.length))
      return;
    const o = {};
    n.forEach((u) => {
      const h = this.lookupRowNode(e, u);
      h && (h.isSelected() && r.push(h), h.clearRowTopAndRowIndex(), o[h.id] = !0, delete this.allNodesMap[h.id], i.remove.push(h), s.remove(h));
    });
    const a = this.rootNode;
    a.allLeafChildren = ((c = a.allLeafChildren) == null ? void 0 : c.filter((u) => !o[u.id])) ?? null, (d = a.allLeafChildren) == null || d.forEach((u, h) => {
      u.sourceRowIndex = h;
    });
    const l = a.sibling;
    l && (l.allLeafChildren = a.allLeafChildren);
  }
  executeUpdate(e, t, { changedRowNodes: s, rowNodeTransaction: i }, r) {
    const { update: n } = t;
    n != null && n.length && n.forEach((o) => {
      const a = this.lookupRowNode(e, o);
      a && (a.updateData(o), !a.selectable && a.isSelected() && r.push(a), i.update.push(a), s.update(a));
    });
  }
  dispatchRowDataUpdateStartedEvent(e) {
    this.eventSvc.dispatchEvent({
      type: "rowDataUpdateStarted",
      firstRowData: e != null && e.length ? e[0] : null
    });
  }
  deselectNodes(e) {
    var r;
    const t = "rowDataChanged", s = this.beans.selectionSvc, i = e.length > 0;
    i && (s == null || s.setNodesSelected({
      newValue: !1,
      nodes: e,
      suppressFinishActions: !0,
      source: t
    })), (r = s == null ? void 0 : s.updateGroupsFromChildrenSelections) == null || r.call(s, t), i && this.eventSvc.dispatchEvent({
      type: "selectionChanged",
      source: t
    });
  }
  sanitizeAddIndex(e) {
    var s;
    const t = ((s = this.rootNode.allLeafChildren) == null ? void 0 : s.length) ?? 0;
    return e < 0 || e >= t || Number.isNaN(e) ? t : Math.ceil(e);
  }
  createRowNode(e, t) {
    const s = new bs(this.beans);
    return s.parent = this.rootNode, s.level = 0, s.group = !1, s.expanded = !1, s.sourceRowIndex = t, s.setDataAndId(e, String(this.nextId)), this.allNodesMap[s.id] && I(2, { nodeId: s.id }), this.allNodesMap[s.id] = s, this.nextId++, s;
  }
  lookupRowNode(e, t) {
    var i, r;
    let s;
    if (e) {
      const n = e({ data: t, level: 0 });
      if (s = this.allNodesMap[n], !s)
        return be(4, { id: n }), null;
    } else if (s = (r = (i = this.rootNode) == null ? void 0 : i.allLeafChildren) == null ? void 0 : r.find((n) => n.data === t), !s)
      return be(5, { data: t }), null;
    return s || null;
  }
}, wi = /* @__PURE__ */ ((e) => (e.Applied = "Applied", e.StoreNotFound = "StoreNotFound", e.StoreLoading = "StoreLoading", e.StoreWaitingToLoad = "StoreWaitingToLoad", e.StoreLoadingFailed = "StoreLoadingFailed", e.StoreWrongType = "StoreWrongType", e.Cancelled = "Cancelled", e.StoreNotStarted = "StoreNotStarted", e))(wi || {}), LD = class extends _ {
  constructor() {
    super(
      /* html*/
      `
            <div class="ag-selection-checkbox" role="presentation">
                <ag-checkbox role="presentation" data-ref="eCheckbox"></ag-checkbox>
            </div>`,
      [ai]
    ), this.eCheckbox = E;
  }
  postConstruct() {
    this.eCheckbox.setPassive(!0);
  }
  getCheckboxId() {
    return this.eCheckbox.getInputElement().id;
  }
  onDataChanged() {
    this.onSelectionChanged();
  }
  onSelectableChanged() {
    this.showOrHideSelect();
  }
  onSelectionChanged() {
    const e = this.getLocaleTextFunc(), { rowNode: t, eCheckbox: s } = this, i = t.isSelected(), r = rh(e, i), [n, o] = t.selectable ? ["ariaRowToggleSelection", "Press Space to toggle row selection"] : ["ariaRowSelectionDisabled", "Row Selection is disabled for this row"], a = e(n, o);
    s.setValue(i, !0), s.setInputAriaLabel(`${a} (${r})`);
  }
  init(e) {
    if (this.rowNode = e.rowNode, this.column = e.column, this.overrides = e.overrides, this.onSelectionChanged(), this.addManagedListeners(this.eCheckbox.getInputElement(), {
      // we don't want double click on this icon to open a group
      dblclick: gt,
      click: (i) => {
        var r;
        gt(i), (r = this.beans.selectionSvc) == null || r.handleSelectionEvent(i, this.rowNode, "checkboxSelected");
      }
    }), this.addManagedListeners(this.rowNode, {
      rowSelected: this.onSelectionChanged.bind(this),
      dataChanged: this.onDataChanged.bind(this),
      selectableChanged: this.onSelectableChanged.bind(this)
    }), this.addManagedPropertyListener("rowSelection", ({ currentValue: i, previousValue: r }) => {
      const n = typeof i == "object" ? ud(i) : void 0, o = typeof r == "object" ? ud(r) : void 0;
      n !== o && this.onSelectableChanged();
    }), ou(this.gos) || typeof this.getIsVisible() == "function") {
      const i = this.showOrHideSelect.bind(this);
      this.addManagedEventListeners({ displayedColumnsChanged: i }), this.addManagedListeners(this.rowNode, {
        dataChanged: i,
        cellChanged: i
      }), this.showOrHideSelect();
    }
    this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
  }
  showOrHideSelect() {
    const { column: e, rowNode: t, overrides: s, gos: i } = this;
    let r = t.selectable;
    const n = this.getIsVisible();
    if (r)
      if (typeof n == "function") {
        const l = s == null ? void 0 : s.callbackParams;
        if (!e)
          r = n({ ...l, node: t, data: t.data });
        else {
          const c = e.createColumnFunctionCallbackParams(t);
          r = n({ ...l, ...c });
        }
      } else
        r = n ?? !1;
    const o = i.get("rowSelection");
    if (o && typeof o != "string" ? !ud(o) : e == null ? void 0 : e.getColDef().showDisabledCheckboxes) {
      this.eCheckbox.setDisabled(!r), this.setVisible(!0), this.setDisplayed(!0);
      return;
    }
    if (s != null && s.removeHidden) {
      this.setDisplayed(r);
      return;
    }
    this.setVisible(r);
  }
  getIsVisible() {
    var s, i;
    const e = this.overrides;
    if (e)
      return e.isVisible;
    const t = this.gos.get("rowSelection");
    return t && typeof t != "string" ? ln(t) : (i = (s = this.column) == null ? void 0 : s.getColDef()) == null ? void 0 : i.checkboxSelection;
  }
}, kD = class {
  constructor(e) {
    this.rootId = null, this.endId = null, this.cachedRange = [], this.rowModel = e;
  }
  reset() {
    this.rootId = null, this.endId = null, this.cachedRange.length = 0;
  }
  setRoot(e) {
    this.rootId = e.id, this.endId = null, this.cachedRange.length = 0;
  }
  setEndRange(e) {
    this.endId = e.id, this.cachedRange.length = 0;
  }
  getRange() {
    if (this.cachedRange.length === 0) {
      const e = this.getRoot(), t = this.getEnd();
      if (e == null || t == null)
        return this.cachedRange;
      this.cachedRange = this.rowModel.getNodesInRangeForSelection(e, t) ?? [];
    }
    return this.cachedRange;
  }
  isInRange(e) {
    return this.rootId === null ? !1 : this.getRange().some((t) => t.id === e.id);
  }
  getRoot() {
    return this.rootId ? this.rowModel.getRowNode(this.rootId) ?? null : null;
  }
  getEnd() {
    return this.endId ? this.rowModel.getRowNode(this.endId) ?? null : null;
  }
  /**
   * Truncates the range to the given node (assumed to be within the current range).
   * Returns nodes that remain in the current range and those that should be removed
   *
   * @param node - Node at which to truncate the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */
  truncate(e) {
    const t = this.getRange();
    if (t.length === 0)
      return { keep: [], discard: [] };
    const s = t[0].id === this.rootId, i = t.findIndex((r) => r.id === e.id);
    if (i > -1) {
      const r = t.slice(0, i), n = t.slice(i + 1);
      return this.setEndRange(e), s ? { keep: r, discard: n } : { keep: n, discard: r };
    } else
      return { keep: t, discard: [] };
  }
  /**
   * Extends the range to the given node. Returns nodes that remain in the current range
   * and those that should be removed.
   *
   * @param node - Node marking the new end of the range
   * @returns Object of nodes to either keep or discard (i.e. deselect) from the range
   */
  extend(e, t = !1) {
    const s = this.getRoot();
    if (s == null) {
      const r = this.getRange().slice();
      return t && e.depthFirstSearch((n) => !n.group && r.push(n)), r.push(e), this.setRoot(e), { keep: r, discard: [] };
    }
    const i = this.rowModel.getNodesInRangeForSelection(s, e);
    if (!i)
      return this.setRoot(e), { keep: [e], discard: [] };
    if (i.find((r) => r.id === this.endId))
      return this.setEndRange(e), { keep: this.getRange(), discard: [] };
    {
      const r = this.getRange().slice();
      return this.setEndRange(e), { keep: this.getRange(), discard: r };
    }
  }
}, OD = class extends L {
  constructor(e) {
    super(), this.column = e, this.cbSelectAllVisible = !1, this.processingEventFromCheckbox = !1;
  }
  onSpaceKeyDown(e) {
    const t = this.cbSelectAll;
    t.isDisplayed() && !t.getGui().contains(Ie(this.beans)) && (e.preventDefault(), t.setValue(!t.getValue()));
  }
  getCheckboxGui() {
    return this.cbSelectAll.getGui();
  }
  setComp(e) {
    this.headerCellCtrl = e;
    const t = this.createManagedBean(new Pn());
    this.cbSelectAll = t, t.addCssClass("ag-header-select-all"), nt(t.getGui(), "presentation"), this.showOrHideSelectAll(), this.addManagedEventListeners({
      newColumnsLoaded: this.showOrHideSelectAll.bind(this),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      selectionChanged: this.onSelectionChanged.bind(this),
      paginationChanged: this.onSelectionChanged.bind(this),
      modelUpdated: this.onModelChanged.bind(this)
    }), this.addManagedListeners(t, { fieldValueChanged: this.onCbSelectAll.bind(this) }), t.getInputElement().setAttribute("tabindex", "-1"), this.refreshSelectAllLabel();
  }
  onDisplayedColumnsChanged() {
    this.isAlive() && this.showOrHideSelectAll();
  }
  showOrHideSelectAll() {
    const e = this.isCheckboxSelection();
    this.cbSelectAllVisible = e, this.cbSelectAll.setDisplayed(e), e && (this.checkRightRowModelType("selectAllCheckbox"), this.checkSelectionType("selectAllCheckbox"), this.updateStateOfCheckbox()), this.refreshSelectAllLabel();
  }
  onModelChanged() {
    this.cbSelectAllVisible && this.updateStateOfCheckbox();
  }
  onSelectionChanged() {
    this.cbSelectAllVisible && this.updateStateOfCheckbox();
  }
  updateStateOfCheckbox() {
    if (this.processingEventFromCheckbox)
      return;
    this.processingEventFromCheckbox = !0;
    const e = this.getSelectAllMode(), t = this.beans.selectionSvc, s = this.cbSelectAll, i = t.getSelectAllState(e);
    s.setValue(i);
    const r = t.hasNodesToSelect(e);
    s.setDisabled(!r), this.refreshSelectAllLabel(), this.processingEventFromCheckbox = !1;
  }
  refreshSelectAllLabel() {
    const e = this.getLocaleTextFunc(), { headerCellCtrl: t, cbSelectAll: s, cbSelectAllVisible: i } = this, n = s.getValue() ? e("ariaChecked", "checked") : e("ariaUnchecked", "unchecked"), o = e("ariaRowSelectAll", "Press Space to toggle all rows selection");
    t.setAriaDescriptionProperty(
      "selectAll",
      i ? `${o} (${n})` : null
    ), s.setInputAriaLabel(e("ariaHeaderSelection", "Column with Header Selection")), t.announceAriaDescription();
  }
  checkSelectionType(e) {
    return Pr(this.gos) ? !0 : (I(128, { feature: e }), !1);
  }
  checkRightRowModelType(e) {
    const { gos: t, rowModel: s } = this.beans;
    return Ye(t) || Lt(t) ? !0 : (I(129, { feature: e, rowModel: s.getType() }), !1);
  }
  onCbSelectAll() {
    if (this.processingEventFromCheckbox || !this.cbSelectAllVisible)
      return;
    const e = this.cbSelectAll.getValue(), t = this.getSelectAllMode();
    let s = "uiSelectAll";
    t === "currentPage" ? s = "uiSelectAllCurrentPage" : t === "filtered" && (s = "uiSelectAllFiltered");
    const i = { source: s, selectAll: t }, r = this.beans.selectionSvc;
    e ? r.selectAllRowNodes(i) : r.deselectAllRowNodes(i);
  }
  /**
   * Checkbox is enabled when either the `headerCheckbox` option is enabled in the new selection API
   * or `headerCheckboxSelection` is enabled in the legacy API.
   */
  isCheckboxSelection() {
    var c;
    const { column: e, gos: t, beans: s } = this, i = t.get("rowSelection"), r = e.getColDef(), { headerCheckboxSelection: n } = r;
    let o = !1;
    const a = typeof i == "object";
    if (a) {
      const d = xi(e), u = pc(e);
      (Tl(i) === "autoGroupColumn" && u || d && ((c = s.selectionColSvc) != null && c.isSelectionColumnEnabled())) && (o = al(i));
    } else
      typeof n == "function" ? o = n(t.addGridCommonParams({ column: e, colDef: r })) : o = !!n;
    const l = a ? "headerCheckbox" : "headerCheckboxSelection";
    return o && this.checkRightRowModelType(l) && this.checkSelectionType(l);
  }
  getSelectAllMode() {
    const e = xv(this.gos, !1);
    if (e)
      return e;
    const { headerCheckboxSelectionCurrentPageOnly: t, headerCheckboxSelectionFilteredOnly: s } = this.column.getColDef();
    return t ? "currentPage" : s ? "filtered" : "all";
  }
}, zw = class extends L {
  postConstruct() {
    const { gos: e, beans: t } = this;
    this.selectionCtx = new kD(t.rowModel), this.addManagedPropertyListeners(["isRowSelectable", "rowSelection"], () => {
      const s = ou(e);
      s !== this.isRowSelectable && (this.isRowSelectable = s, this.updateSelectable());
    }), this.isRowSelectable = ou(e);
  }
  destroy() {
    super.destroy(), this.selectionCtx.reset();
  }
  createCheckboxSelectionComponent() {
    return new LD();
  }
  createSelectAllFeature(e) {
    return new OD(e);
  }
  isMultiSelect() {
    return Pr(this.gos);
  }
  onRowCtrlSelected(e, t, s) {
    const i = !!e.rowNode.isSelected();
    e.forEachGui(s, (r) => {
      r.rowComp.addOrRemoveCssClass("ag-row-selected", i);
      const n = r.element;
      sa(n, i), n.contains(Ie(this.beans)) && t(r);
    });
  }
  announceAriaRowSelection(e) {
    var r;
    if (this.isRowSelectionBlocked(e))
      return;
    const t = e.isSelected();
    if (t && !_g(this.gos))
      return;
    const i = this.getLocaleTextFunc()(
      t ? "ariaRowDeselect" : "ariaRowSelect",
      `Press SPACE to ${t ? "deselect" : "select"} this row`
    );
    (r = this.beans.ariaAnnounce) == null || r.announceValue(i, "rowSelection");
  }
  dispatchSelectionChanged(e) {
    this.eventSvc.dispatchEvent({
      type: "selectionChanged",
      source: e
    });
  }
  isRowSelectionBlocked(e) {
    return !e.selectable || !!e.rowPinned || !Es(this.gos);
  }
  updateRowSelectable(e, t) {
    var i;
    const s = ((i = this.isRowSelectable) == null ? void 0 : i.call(this, e)) ?? !0;
    return this.setRowSelectable(e, s, t), s;
  }
  setRowSelectable(e, t, s) {
    if (e.selectable !== t) {
      if (e.selectable = t, e.dispatchRowEvent("selectableChanged"), s)
        return;
      if (mn(this.gos)) {
        const r = this.calculateSelectedFromChildren(e);
        this.setNodesSelected({ nodes: [e], newValue: r ?? !1, source: "selectableChanged" });
        return;
      }
      e.isSelected() && !e.selectable && this.setNodesSelected({ nodes: [e], newValue: !1, source: "selectableChanged" });
    }
  }
  calculateSelectedFromChildren(e) {
    var i;
    let t = !1, s = !1;
    if (!((i = e.childrenAfterGroup) != null && i.length))
      return e.selectable ? e.__selected : null;
    for (let r = 0; r < e.childrenAfterGroup.length; r++) {
      const n = e.childrenAfterGroup[r];
      let o = n.isSelected();
      if (!n.selectable) {
        const a = this.calculateSelectedFromChildren(n);
        if (a === null)
          continue;
        o = a;
      }
      switch (o) {
        case !0:
          t = !0;
          break;
        case !1:
          s = !0;
          break;
        default:
          return;
      }
    }
    if (!(t && s))
      return t ? !0 : s ? !1 : e.selectable ? e.__selected : null;
  }
  selectRowNode(e, t, s, i = "api") {
    const r = !e.selectable && t, n = e.__selected === t;
    if (r || n)
      return !1;
    e.__selected = t, e.dispatchRowEvent("rowSelected");
    const o = e.sibling;
    return o && o.footer && o.__localEventService && o.dispatchRowEvent("rowSelected"), this.eventSvc.dispatchEvent({
      ...ww(e, this.gos, "rowSelected"),
      event: s || null,
      source: i
    }), !0;
  }
  isCellCheckboxSelection(e, t) {
    const s = this.gos.get("rowSelection");
    if (s && typeof s != "string") {
      const i = xi(e) && ln(s);
      return e.isColumnFunc(t, i);
    } else
      return e.isColumnFunc(t, e.colDef.checkboxSelection);
  }
  inferNodeSelections(e, t, s, i) {
    const { gos: r, selectionCtx: n } = this, o = e.isSelected(), a = mn(r), l = jP(r), c = _g(r), d = i === "rowClicked";
    if (d && a && e.group || d && !(l || c))
      return null;
    if (t && s && this.isMultiSelect()) {
      const u = n.getRoot();
      if (u)
        if (u.isSelected()) {
          const h = n.isInRange(e) ? n.truncate(e) : n.extend(e, a);
          return {
            deselect: h.discard,
            select: h.keep,
            reset: !1
          };
        } else {
          const h = n.extend(e, a);
          return {
            select: [],
            deselect: h.keep,
            reset: !1
          };
        }
      else return null;
    } else if (t && this.isMultiSelect()) {
      const u = n.getRoot(), h = n.isInRange(e) ? n.truncate(e) : n.extend(e, a);
      return {
        select: h.keep,
        deselect: h.discard,
        reset: !!(u && !u.isSelected())
      };
    } else {
      if (s)
        return n.setRoot(e), d && o && !c ? null : {
          node: e,
          newValue: !o,
          clearSelection: !this.isMultiSelect()
        };
      {
        n.setRoot(e);
        const u = KP(r), h = El(r) === "filteredDescendants", p = d && (!u || !l);
        if (h && o === void 0 && Ye(r))
          return {
            node: e,
            newValue: !1,
            clearSelection: !this.isMultiSelect() || p
          };
        if (d) {
          const g = o ? !u : l;
          return g === o ? null : {
            node: e,
            newValue: g,
            clearSelection: !this.isMultiSelect() || p
          };
        }
        return {
          node: e,
          newValue: !o,
          clearSelection: !this.isMultiSelect() || p
        };
      }
    }
  }
}, GD = class extends Pn {
  constructor(e) {
    super(e, "ag-radio-button", "radio");
  }
  isSelected() {
    return this.eInput.checked;
  }
  toggle() {
    this.eInput.disabled || this.isSelected() || this.setValue(!0);
  }
  addInputListeners() {
    super.addInputListeners(), this.addManagedEventListeners({ checkboxChanged: this.onChange.bind(this) });
  }
  /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */
  onChange(e) {
    const t = this.eInput;
    e.selected && e.name && t.name && t.name === e.name && e.id && t.id !== e.id && this.setValue(!1, !0);
  }
}, BD = (
  /*css*/
  '.ag-toggle-button{flex:none;min-width:unset;width:unset}.ag-toggle-button-input-wrapper{background-color:var(--ag-toggle-button-off-background-color);border-radius:calc(var(--ag-toggle-button-height)*.5);flex:none;height:var(--ag-toggle-button-height);max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);position:relative;transition:background-color .1s;:where(.ag-toggle-button-input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-toggle-button-height);margin:0;max-width:var(--ag-toggle-button-width);min-width:var(--ag-toggle-button-width);opacity:0}&:before{background-color:var(--ag-toggle-button-switch-background-color);border-radius:100%;content:"";display:block;height:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2);left:var(--ag-toggle-button-switch-inset);pointer-events:none;position:absolute;top:var(--ag-toggle-button-switch-inset);transition:left .1s;width:calc(var(--ag-toggle-button-height) - var(--ag-toggle-button-switch-inset)*2)}&.ag-checked{background-color:var(--ag-toggle-button-on-background-color);&:before{left:calc(100% - var(--ag-toggle-button-height) + var(--ag-toggle-button-switch-inset))}}&:focus-within{box-shadow:var(--ag-focus-shadow)}&.ag-disabled{opacity:.5}}'
), oo = class extends Pn {
  constructor(e) {
    super(e, "ag-toggle-button"), this.registerCSS(BD);
  }
  setValue(e, t) {
    return super.setValue(e, t), this.addOrRemoveCssClass("ag-selected", this.getValue()), this;
  }
}, VD = {
  selector: "AG-TOGGLE-BUTTON",
  component: oo
}, li = class extends mr {
  constructor(e, t = "ag-text-field", s = "text") {
    super(e, t, s);
  }
  postConstruct() {
    super.postConstruct(), this.config.allowedCharPattern && this.preventDisallowedCharacters();
  }
  setValue(e, t) {
    const s = this.eInput;
    return s.value !== e && (s.value = W(e) ? e : ""), super.setValue(e, t);
  }
  /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */
  setStartValue(e) {
    this.setValue(e, !0);
  }
  preventDisallowedCharacters() {
    const e = new RegExp(`[${this.config.allowedCharPattern}]`), t = (s) => {
      Fh(s) && s.key && !e.test(s.key) && s.preventDefault();
    };
    this.addManagedListeners(this.eInput, {
      keydown: t,
      paste: (s) => {
        var r;
        const i = (r = s.clipboardData) == null ? void 0 : r.getData("text");
        i && i.split("").some((n) => !e.test(n)) && s.preventDefault();
      }
    });
  }
}, Ks = {
  selector: "AG-INPUT-TEXT-FIELD",
  component: li
}, ND = class extends mr {
  constructor(e) {
    super(e, "ag-text-area", null, "textarea");
  }
  setValue(e, t) {
    const s = super.setValue(e, t);
    return this.eInput.value = e, s;
  }
  setCols(e) {
    return this.eInput.cols = e, this;
  }
  setRows(e) {
    return this.eInput.rows = e, this;
  }
}, HD = {
  selector: "AG-INPUT-TEXT-AREA",
  component: ND
}, vc = class extends li {
  constructor(e) {
    super(e, "ag-number-field", "number");
  }
  postConstruct() {
    super.postConstruct();
    const e = this.eInput;
    this.addManagedListeners(e, {
      blur: () => {
        const n = parseFloat(e.value), o = isNaN(n) ? "" : this.normalizeValue(n.toString());
        this.value !== o && this.setValue(o);
      },
      wheel: this.onWheel.bind(this)
    }), e.step = "any";
    const { precision: t, min: s, max: i, step: r } = this.config;
    typeof t == "number" && this.setPrecision(t), typeof s == "number" && this.setMin(s), typeof i == "number" && this.setMax(i), typeof r == "number" && this.setStep(r);
  }
  onWheel(e) {
    Ie(this.beans) === this.eInput && e.preventDefault();
  }
  normalizeValue(e) {
    if (e === "")
      return "";
    this.precision != null && (e = this.adjustPrecision(e));
    const t = parseFloat(e), { min: s, max: i } = this;
    return s != null && t < s ? e = s.toString() : i != null && t > i && (e = i.toString()), e;
  }
  adjustPrecision(e, t) {
    const s = this.precision;
    if (s == null)
      return e;
    if (t) {
      const r = parseFloat(e).toFixed(s);
      return parseFloat(r).toString();
    }
    const i = String(e).split(".");
    if (i.length > 1) {
      if (i[1].length <= s)
        return e;
      if (s > 0)
        return `${i[0]}.${i[1].slice(0, s)}`;
    }
    return i[0];
  }
  setMin(e) {
    return this.min === e ? this : (this.min = e, zs(this.eInput, "min", e), this);
  }
  setMax(e) {
    return this.max === e ? this : (this.max = e, zs(this.eInput, "max", e), this);
  }
  setPrecision(e) {
    return this.precision = e, this;
  }
  setStep(e) {
    return this.step === e ? this : (this.step = e, zs(this.eInput, "step", e), this);
  }
  setValue(e, t) {
    return this.setValueOrInputValue(
      (s) => super.setValue(s, t),
      () => this,
      e
    );
  }
  setStartValue(e) {
    return this.setValueOrInputValue(
      (t) => super.setValue(t, !0),
      (t) => {
        this.eInput.value = t;
      },
      e
    );
  }
  setValueOrInputValue(e, t, s) {
    if (W(s)) {
      let i = this.isScientificNotation(s);
      if (i && this.eInput.validity.valid)
        return e(s);
      if (!i) {
        s = this.adjustPrecision(s);
        const r = this.normalizeValue(s);
        i = s != r;
      }
      if (i)
        return t(s);
    }
    return e(s);
  }
  getValue() {
    const e = this.eInput;
    if (!e.validity.valid)
      return;
    const t = e.value;
    return this.isScientificNotation(t) ? this.adjustPrecision(t, !0) : super.getValue();
  }
  isScientificNotation(e) {
    return typeof e == "string" && e.includes("e");
  }
}, wc = {
  selector: "AG-INPUT-NUMBER-FIELD",
  component: vc
};
function qo(e, t) {
  return e.toString().padStart(t, "0");
}
function ys(e, t = !0, s = "-") {
  if (!e)
    return null;
  let i = [e.getFullYear(), e.getMonth() + 1, e.getDate()].map((r) => qo(r, 2)).join(s);
  return t && (i += " " + [e.getHours(), e.getMinutes(), e.getSeconds()].map((r) => qo(r, 2)).join(":")), i;
}
var Cd = (e) => {
  if (e > 3 && e < 21)
    return "th";
  switch (e % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
  }
  return "th";
};
function Yo(e, t = "YYYY-MM-DD") {
  const s = qo(e.getFullYear(), 4), i = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ], r = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], n = {
    YYYY: () => s.slice(s.length - 4, s.length),
    YY: () => s.slice(s.length - 2, s.length),
    Y: () => `${e.getFullYear()}`,
    MMMM: () => i[e.getMonth()],
    MMM: () => i[e.getMonth()].slice(0, 3),
    MM: () => qo(e.getMonth() + 1, 2),
    Mo: () => `${e.getMonth() + 1}${Cd(e.getMonth() + 1)}`,
    M: () => `${e.getMonth() + 1}`,
    Do: () => `${e.getDate()}${Cd(e.getDate())}`,
    DD: () => qo(e.getDate(), 2),
    D: () => `${e.getDate()}`,
    dddd: () => r[e.getDay()],
    ddd: () => r[e.getDay()].slice(0, 3),
    dd: () => r[e.getDay()].slice(0, 2),
    do: () => `${e.getDay()}${Cd(e.getDay())}`,
    d: () => `${e.getDay()}`
  }, o = new RegExp(Object.keys(n).join("|"), "g");
  return t.replace(o, (a) => a in n ? n[a]() : a);
}
function Yt(e) {
  if (!e)
    return null;
  const [t, s] = e.split(" ");
  if (!t)
    return null;
  const i = t.split("-").map((u) => parseInt(u, 10));
  if (i.filter((u) => !isNaN(u)).length !== 3)
    return null;
  const [r, n, o] = i, a = new Date(r, n - 1, o);
  if (a.getFullYear() !== r || a.getMonth() !== n - 1 || a.getDate() !== o)
    return null;
  if (!s || s === "00:00:00")
    return a;
  const [l, c, d] = s.split(":").map((u) => parseInt(u, 10));
  return l >= 0 && l < 24 && a.setHours(l), c >= 0 && c < 60 && a.setMinutes(c), d >= 0 && d < 60 && a.setSeconds(d), a;
}
var Ww = class extends li {
  constructor(e) {
    super(e, "ag-date-field", "date");
  }
  postConstruct() {
    super.postConstruct();
    const e = Rn();
    this.addManagedListeners(this.eInput, {
      wheel: this.onWheel.bind(this),
      mousedown: () => {
        this.isDisabled() || e || this.eInput.focus();
      }
    }), this.eInput.step = "any";
  }
  onWheel(e) {
    Ie(this.beans) === this.eInput && e.preventDefault();
  }
  setMin(e) {
    const t = e instanceof Date ? ys(e ?? null, !1) ?? void 0 : e;
    return this.min === t ? this : (this.min = t, zs(this.eInput, "min", t), this);
  }
  setMax(e) {
    const t = e instanceof Date ? ys(e ?? null, !1) ?? void 0 : e;
    return this.max === t ? this : (this.max = t, zs(this.eInput, "max", t), this);
  }
  setStep(e) {
    return this.step === e ? this : (this.step = e, zs(this.eInput, "step", e), this);
  }
  getDate() {
    if (this.eInput.validity.valid)
      return Yt(this.getValue()) ?? void 0;
  }
  setDate(e, t) {
    this.setValue(ys(e ?? null, !1), t);
  }
}, _w = {
  selector: "AG-INPUT-DATE-FIELD",
  component: Ww
}, zD = 1e3, WD = 1e3, Qg = 100, Jg, Ka = !1, _D = class extends L {
  constructor(e, t) {
    super(), this.tooltipCtrl = e, this.getTooltipValue = t, this.interactionEnabled = !1, this.isInteractingWithTooltip = !1, this.state = 0, this.tooltipInstanceCount = 0, this.tooltipMouseTrack = !1;
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc, this.userCompFactory = e.userCompFactory;
  }
  postConstruct() {
    this.gos.get("tooltipInteraction") && (this.interactionEnabled = !0), this.tooltipTrigger = this.getTooltipTrigger(), this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
    const e = this.tooltipCtrl.getGui();
    this.tooltipTrigger === 0 && this.addManagedListeners(e, {
      mouseenter: this.onMouseEnter.bind(this),
      mouseleave: this.onMouseLeave.bind(this)
    }), this.tooltipTrigger === 1 && this.addManagedListeners(e, {
      focusin: this.onFocusIn.bind(this),
      focusout: this.onFocusOut.bind(this)
    }), this.addManagedListeners(e, { mousemove: this.onMouseMove.bind(this) }), this.interactionEnabled || this.addManagedListeners(e, {
      mousedown: this.onMouseDown.bind(this),
      keydown: this.onKeyDown.bind(this)
    });
  }
  getGridOptionsTooltipDelay(e) {
    const t = this.gos.get(e);
    return Math.max(200, t);
  }
  getTooltipDelay(e) {
    var t, s, i, r;
    return e === "show" ? ((s = (t = this.tooltipCtrl).getTooltipShowDelayOverride) == null ? void 0 : s.call(t)) ?? this.getGridOptionsTooltipDelay("tooltipShowDelay") : ((r = (i = this.tooltipCtrl).getTooltipHideDelayOverride) == null ? void 0 : r.call(i)) ?? this.getGridOptionsTooltipDelay("tooltipHideDelay");
  }
  destroy() {
    this.setToDoNothing(), super.destroy();
  }
  getTooltipTrigger() {
    const e = this.gos.get("tooltipTrigger");
    return !e || e === "hover" ? 0 : 1;
  }
  onMouseEnter(e) {
    this.interactionEnabled && this.interactiveTooltipTimeoutId && (this.unlockService(), this.startHideTimeout()), !yr() && (Ka ? this.showTooltipTimeoutId = window.setTimeout(() => {
      this.prepareToShowTooltip(e);
    }, Qg) : this.prepareToShowTooltip(e));
  }
  onMouseMove(e) {
    this.lastMouseEvent && (this.lastMouseEvent = e), this.tooltipMouseTrack && this.state === 2 && this.tooltipComp && this.positionTooltip();
  }
  onMouseDown() {
    this.setToDoNothing();
  }
  onMouseLeave() {
    this.interactionEnabled ? this.lockService() : this.setToDoNothing();
  }
  onFocusIn() {
    this.prepareToShowTooltip();
  }
  onFocusOut(e) {
    var r;
    const t = e.relatedTarget, s = this.tooltipCtrl.getGui(), i = (r = this.tooltipComp) == null ? void 0 : r.getGui();
    this.isInteractingWithTooltip || s.contains(t) || this.interactionEnabled && (i != null && i.contains(t)) || this.setToDoNothing();
  }
  onKeyDown() {
    this.isInteractingWithTooltip && (this.isInteractingWithTooltip = !1), this.setToDoNothing();
  }
  prepareToShowTooltip(e) {
    if (this.state != 0 || Ka)
      return;
    let t = 0;
    e && (t = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show")), this.lastMouseEvent = e || null, this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), t), this.state = 1;
  }
  isLastTooltipHiddenRecently() {
    return (/* @__PURE__ */ new Date()).getTime() - Jg < zD;
  }
  setToDoNothing(e) {
    !e && this.state === 2 && this.hideTooltip(), this.onBodyScrollEventCallback && (this.onBodyScrollEventCallback(), this.onBodyScrollEventCallback = void 0), this.onColumnMovedEventCallback && (this.onColumnMovedEventCallback(), this.onColumnMovedEventCallback = void 0), this.onDocumentKeyDownCallback && (this.onDocumentKeyDownCallback(), this.onDocumentKeyDownCallback = void 0), this.clearTimeouts(), this.state = 0, this.lastMouseEvent = null;
  }
  showTooltip() {
    var o, a, l, c, d, u, h;
    const e = this.getTooltipValue(), t = this.tooltipCtrl;
    if (!W(e) || t.shouldDisplayTooltip && !t.shouldDisplayTooltip()) {
      this.setToDoNothing();
      return;
    }
    const s = (o = t.getRowNode) == null ? void 0 : o.call(t), i = {
      location: ((a = t.getLocation) == null ? void 0 : a.call(t)) ?? "UNKNOWN",
      //'cell',
      colDef: (l = t.getColDef) == null ? void 0 : l.call(t),
      column: (c = t.getColumn) == null ? void 0 : c.call(t),
      rowIndex: (d = t.getRowIndex) == null ? void 0 : d.call(t),
      node: s,
      data: s == null ? void 0 : s.data,
      value: e,
      valueFormatted: (u = t.getValueFormatted) == null ? void 0 : u.call(t),
      hideTooltipCallback: () => this.hideTooltip(!0),
      ...((h = t.getAdditionalParams) == null ? void 0 : h.call(t)) ?? {}
    };
    this.state = 2, this.tooltipInstanceCount++;
    const r = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount), n = sE(this.userCompFactory, i);
    n == null || n.newAgStackInstance().then(r);
  }
  hideTooltip(e) {
    !e && this.isInteractingWithTooltip || (this.tooltipComp && (this.destroyTooltipComp(), Jg = (/* @__PURE__ */ new Date()).getTime()), this.eventSvc.dispatchEvent({
      type: "tooltipHide",
      parentGui: this.tooltipCtrl.getGui()
    }), e && (this.isInteractingWithTooltip = !1), this.setToDoNothing(!0));
  }
  newTooltipComponentCallback(e, t) {
    var o;
    if (this.state !== 2 || this.tooltipInstanceCount !== e) {
      this.destroyBean(t);
      return;
    }
    const i = t.getGui();
    this.tooltipComp = t, i.classList.contains("ag-tooltip") || i.classList.add("ag-tooltip-custom"), this.tooltipTrigger === 0 && i.classList.add("ag-tooltip-animate"), this.interactionEnabled && i.classList.add("ag-tooltip-interactive");
    const r = this.getLocaleTextFunc(), n = (o = this.popupSvc) == null ? void 0 : o.addPopup({
      eChild: i,
      ariaLabel: r("ariaLabelTooltip", "Tooltip")
    });
    if (n && (this.tooltipPopupDestroyFunc = n.hideFunc), this.positionTooltip(), this.tooltipTrigger === 1) {
      const a = () => this.setToDoNothing();
      [this.onBodyScrollEventCallback, this.onColumnMovedEventCallback] = this.addManagedEventListeners({
        bodyScroll: a,
        columnMoved: a
      });
    }
    this.interactionEnabled && ([this.tooltipMouseEnterListener, this.tooltipMouseLeaveListener] = this.addManagedElementListeners(i, {
      mouseenter: this.onTooltipMouseEnter.bind(this),
      mouseleave: this.onTooltipMouseLeave.bind(this)
    }), [this.onDocumentKeyDownCallback] = this.addManagedElementListeners(We(this.beans), {
      keydown: (a) => {
        i.contains(a == null ? void 0 : a.target) || this.onKeyDown();
      }
    }), this.tooltipTrigger === 1 && ([this.tooltipFocusInListener, this.tooltipFocusOutListener] = this.addManagedElementListeners(i, {
      focusin: this.onTooltipFocusIn.bind(this),
      focusout: this.onTooltipFocusOut.bind(this)
    }))), this.eventSvc.dispatchEvent({
      type: "tooltipShow",
      tooltipGui: i,
      parentGui: this.tooltipCtrl.getGui()
    }), this.startHideTimeout();
  }
  onTooltipMouseEnter() {
    this.isInteractingWithTooltip = !0, this.unlockService();
  }
  onTooltipMouseLeave() {
    this.isTooltipFocused() || (this.isInteractingWithTooltip = !1, this.lockService());
  }
  onTooltipFocusIn() {
    this.isInteractingWithTooltip = !0;
  }
  isTooltipFocused() {
    var s;
    const e = (s = this.tooltipComp) == null ? void 0 : s.getGui(), t = Ie(this.beans);
    return !!e && e.contains(t);
  }
  onTooltipFocusOut(e) {
    const t = this.tooltipCtrl.getGui();
    this.isTooltipFocused() || (this.isInteractingWithTooltip = !1, t.contains(e.relatedTarget) ? this.startHideTimeout() : this.hideTooltip());
  }
  positionTooltip() {
    var t, s;
    const e = {
      type: "tooltip",
      ePopup: this.tooltipComp.getGui(),
      nudgeY: 18,
      skipObserver: this.tooltipMouseTrack
    };
    this.lastMouseEvent ? (t = this.popupSvc) == null || t.positionPopupUnderMouseEvent({
      ...e,
      mouseEvent: this.lastMouseEvent
    }) : (s = this.popupSvc) == null || s.positionPopupByComponent({
      ...e,
      eventSource: this.tooltipCtrl.getGui(),
      position: "under",
      keepWithinBounds: !0,
      nudgeY: 5
    });
  }
  destroyTooltipComp() {
    this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
    const e = this.tooltipPopupDestroyFunc, t = this.tooltipComp, s = this.tooltipTrigger === 0 ? WD : 0;
    window.setTimeout(() => {
      e(), this.destroyBean(t);
    }, s), this.clearTooltipListeners(), this.tooltipPopupDestroyFunc = void 0, this.tooltipComp = void 0;
  }
  clearTooltipListeners() {
    [
      this.tooltipMouseEnterListener,
      this.tooltipMouseLeaveListener,
      this.tooltipFocusInListener,
      this.tooltipFocusOutListener
    ].forEach((e) => {
      e && e();
    }), this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
  }
  lockService() {
    Ka = !0, this.interactiveTooltipTimeoutId = window.setTimeout(() => {
      this.unlockService(), this.setToDoNothing();
    }, Qg);
  }
  unlockService() {
    Ka = !1, this.clearInteractiveTimeout();
  }
  startHideTimeout() {
    this.clearHideTimeout(), this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
  }
  clearShowTimeout() {
    this.showTooltipTimeoutId && (window.clearTimeout(this.showTooltipTimeoutId), this.showTooltipTimeoutId = void 0);
  }
  clearHideTimeout() {
    this.hideTooltipTimeoutId && (window.clearTimeout(this.hideTooltipTimeoutId), this.hideTooltipTimeoutId = void 0);
  }
  clearInteractiveTimeout() {
    this.interactiveTooltipTimeoutId && (window.clearTimeout(this.interactiveTooltipTimeoutId), this.interactiveTooltipTimeoutId = void 0);
  }
  clearTimeouts() {
    this.clearShowTimeout(), this.clearHideTimeout(), this.clearInteractiveTimeout();
  }
};
function Xo(e) {
  return e.get("tooltipShowMode") === "whenTruncated";
}
function yc(e, t) {
  return Xo(e) ? un(t) : void 0;
}
function un(e) {
  return () => {
    const t = e();
    return t ? t.scrollWidth > t.clientWidth : !0;
  };
}
var UD = class extends L {
  constructor(e, t) {
    super(), this.ctrl = e, t && (this.beans = t);
  }
  postConstruct() {
    this.refreshTooltip();
  }
  setBrowserTooltip(e) {
    const t = "title", s = this.ctrl.getGui();
    s && (e != null && e != "" ? s.setAttribute(t, e) : s.removeAttribute(t));
  }
  updateTooltipText() {
    const { getTooltipValue: e } = this.ctrl;
    e && (this.tooltip = e());
  }
  createTooltipFeatureIfNeeded() {
    this.tooltipManager == null && (this.tooltipManager = this.createBean(
      new _D(this.ctrl, () => this.tooltip),
      this.beans.context
    ));
  }
  setTooltipAndRefresh(e) {
    this.tooltip = e, this.refreshTooltip();
  }
  refreshTooltip() {
    this.browserTooltips = this.beans.gos.get("enableBrowserTooltips"), this.updateTooltipText(), this.browserTooltips ? (this.setBrowserTooltip(this.tooltip), this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context)) : (this.setBrowserTooltip(null), this.createTooltipFeatureIfNeeded());
  }
  destroy() {
    this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context), super.destroy();
  }
}, $D = class extends _ {
  constructor(e = "default", t = !1) {
    super(
      /* html */
      `<div class="ag-list ag-${e}-list" role="listbox"></div>`
    ), this.cssIdentifier = e, this.unFocusable = t, this.activeClass = "ag-active-item", this.options = [], this.itemEls = [];
  }
  postConstruct() {
    const e = this.getGui();
    this.addManagedElementListeners(e, { mouseleave: () => this.clearHighlighted() }), !this.unFocusable && this.addManagedElementListeners(e, { keydown: this.handleKeyDown.bind(this) });
  }
  handleKeyDown(e) {
    const t = e.key;
    switch (t) {
      case P.ENTER:
        if (!this.highlightedEl)
          this.setValue(this.getValue());
        else {
          const s = this.itemEls.indexOf(this.highlightedEl);
          this.setValueByIndex(s);
        }
        break;
      case P.DOWN:
      case P.UP:
        e.preventDefault(), this.navigate(t);
        break;
      case P.PAGE_DOWN:
      case P.PAGE_UP:
      case P.PAGE_HOME:
      case P.PAGE_END:
        e.preventDefault(), this.navigateToPage(t);
        break;
    }
  }
  navigate(e) {
    const t = e === P.DOWN;
    let s;
    const { itemEls: i, highlightedEl: r } = this;
    if (!r)
      s = i[t ? 0 : i.length - 1];
    else {
      let o = i.indexOf(r) + (t ? 1 : -1);
      o = Math.min(Math.max(o, 0), i.length - 1), s = i[o];
    }
    this.highlightItem(s);
  }
  navigateToPage(e) {
    const { itemEls: t, highlightedEl: s } = this;
    if (!s || t.length === 0)
      return;
    const i = t.indexOf(s), r = this.options.length - 1, n = t[0].clientHeight, o = Math.floor(this.getGui().clientHeight / n);
    let a = -1;
    e === P.PAGE_HOME ? a = 0 : e === P.PAGE_END ? a = r : e === P.PAGE_DOWN ? a = Math.min(i + o, r) : e === P.PAGE_UP && (a = Math.max(i - o, 0)), a !== -1 && this.highlightItem(t[a]);
  }
  addOptions(e) {
    return e.forEach((t) => this.addOption(t)), this;
  }
  addOption(e) {
    const { value: t, text: s } = e, i = s || t;
    return this.options.push({ value: t, text: i }), this.renderOption(t, i), this.updateIndices(), this;
  }
  clearOptions() {
    this.options = [], this.reset(!0), this.itemEls.forEach((e) => {
      ut(e);
    }), this.itemEls = [];
  }
  updateIndices() {
    const e = this.getGui().querySelectorAll(".ag-list-item");
    e.forEach((t, s) => {
      rc(t, s + 1), ic(t, e.length);
    });
  }
  renderOption(e, t) {
    const s = We(this.beans), i = s.createElement("div");
    nt(i, "option"), i.classList.add("ag-list-item", `ag-${this.cssIdentifier}-list-item`);
    const r = s.createElement("span");
    i.appendChild(r), r.textContent = t, this.unFocusable || (i.tabIndex = -1), this.itemEls.push(i), this.addManagedListeners(i, {
      mouseover: () => this.highlightItem(i),
      mousedown: (n) => {
        n.preventDefault(), n.stopPropagation(), this.setValue(e);
      }
    }), this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean("tooltipFeature", !1, {
        getTooltipValue: () => t,
        getGui: () => i,
        getLocation: () => "UNKNOWN",
        // only show tooltips for items where the text cannot be fully displayed
        shouldDisplayTooltip: () => r.scrollWidth > r.clientWidth
      })
    ), this.getGui().appendChild(i);
  }
  setValue(e, t) {
    if (this.value === e)
      return this.fireItemSelected(), this;
    if (e == null)
      return this.reset(t), this;
    const s = this.options.findIndex((i) => i.value === e);
    if (s !== -1) {
      const i = this.options[s];
      this.value = i.value, this.displayValue = i.text, this.highlightItem(this.itemEls[s]), t || this.fireChangeEvent();
    }
    return this;
  }
  setValueByIndex(e) {
    return this.setValue(this.options[e].value);
  }
  getValue() {
    return this.value;
  }
  getDisplayValue() {
    return this.displayValue;
  }
  refreshHighlighted() {
    this.clearHighlighted();
    const e = this.options.findIndex((t) => t.value === this.value);
    e !== -1 && this.highlightItem(this.itemEls[e]);
  }
  reset(e) {
    this.value = null, this.displayValue = null, this.clearHighlighted(), e || this.fireChangeEvent();
  }
  highlightItem(e) {
    if (!Xt(e))
      return;
    this.clearHighlighted(), this.highlightedEl = e, e.classList.add(this.activeClass), sa(e, !0);
    const t = this.getGui(), { scrollTop: s, clientHeight: i } = t, { offsetTop: r, offsetHeight: n } = e;
    (r + n > s + i || r < s) && e.scrollIntoView({ block: "nearest" }), this.unFocusable || e.focus();
  }
  clearHighlighted() {
    const e = this.highlightedEl;
    !e || !Xt(e) || (e.classList.remove(this.activeClass), sa(e, !1), this.highlightedEl = null);
  }
  fireChangeEvent() {
    this.dispatchLocalEvent({ type: "fieldValueChanged" }), this.fireItemSelected();
  }
  fireItemSelected() {
    this.dispatchLocalEvent({ type: "selectedItem" });
  }
}, jD = (
  /*css*/
  ".ag-picker-field-display{flex:1 1 auto}.ag-picker-field{align-items:center;display:flex}.ag-picker-field-icon{border:0;cursor:pointer;display:flex;margin:0;padding:0}.ag-picker-field-wrapper{background-color:var(--ag-background-color);border:var(--ag-input-border);border-radius:5px;min-height:max(var(--ag-list-item-height),calc(var(--ag-spacing)*4));overflow:hidden;&:disabled{opacity:.5}&.ag-picker-has-focus,&:focus-within{border:var(--ag-input-focus-border);box-shadow:var(--ag-focus-shadow)}}.ag-picker-field-button{background-color:var(--ag-background-color)}"
), Lh = class extends Nw {
  constructor(e) {
    if (super(
      e,
      (e == null ? void 0 : e.template) || /* html */
      `
            <div class="ag-picker-field" role="presentation">
                <div data-ref="eLabel"></div>
                <div data-ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-picker-collapsed">
                    <div data-ref="eDisplayField" class="ag-picker-field-display"></div>
                    <div data-ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
                </div>
            </div>`,
      (e == null ? void 0 : e.agComponents) || [],
      e == null ? void 0 : e.className
    ), this.isPickerDisplayed = !1, this.skipClick = !1, this.pickerGap = 4, this.hideCurrentPicker = null, this.eLabel = E, this.eWrapper = E, this.eDisplayField = E, this.eIcon = E, this.registerCSS(jD), this.ariaRole = e == null ? void 0 : e.ariaRole, this.onPickerFocusIn = this.onPickerFocusIn.bind(this), this.onPickerFocusOut = this.onPickerFocusOut.bind(this), !e)
      return;
    const { pickerGap: t, maxPickerHeight: s, variableWidth: i, minPickerWidth: r, maxPickerWidth: n } = e;
    t != null && (this.pickerGap = t), this.variableWidth = !!i, s != null && this.setPickerMaxHeight(s), r != null && this.setPickerMinWidth(r), n != null && this.setPickerMaxWidth(n);
  }
  postConstruct() {
    super.postConstruct(), this.setupAria();
    const e = `ag-${this.getCompId()}-display`;
    this.eDisplayField.setAttribute("id", e);
    const t = this.getAriaElement();
    this.addManagedElementListeners(t, { keydown: this.onKeyDown.bind(this) }), this.addManagedElementListeners(this.eLabel, { mousedown: this.onLabelOrWrapperMouseDown.bind(this) }), this.addManagedElementListeners(this.eWrapper, { mousedown: this.onLabelOrWrapperMouseDown.bind(this) });
    const { pickerIcon: s, inputWidth: i } = this.config;
    if (s) {
      const r = ue(s, this.beans);
      r && this.eIcon.appendChild(r);
    }
    i != null && this.setInputWidth(i);
  }
  setupAria() {
    const e = this.getAriaElement();
    e.setAttribute("tabindex", this.gos.get("tabIndex").toString()), ns(e, !1), this.ariaRole && nt(e, this.ariaRole);
  }
  onLabelOrWrapperMouseDown(e) {
    if (e) {
      const t = this.getFocusableElement();
      if (t !== this.eWrapper && (e == null ? void 0 : e.target) === t)
        return;
      e.preventDefault(), this.getFocusableElement().focus();
    }
    if (this.skipClick) {
      this.skipClick = !1;
      return;
    }
    this.isDisabled() || (this.isPickerDisplayed ? this.hidePicker() : this.showPicker());
  }
  onKeyDown(e) {
    switch (e.key) {
      case P.UP:
      case P.DOWN:
      case P.ENTER:
      case P.SPACE:
        e.preventDefault(), this.onLabelOrWrapperMouseDown();
        break;
      case P.ESCAPE:
        this.isPickerDisplayed && (e.preventDefault(), e.stopPropagation(), this.hideCurrentPicker && this.hideCurrentPicker());
        break;
    }
  }
  showPicker() {
    this.isPickerDisplayed = !0, this.pickerComponent || (this.pickerComponent = this.createPickerComponent());
    const e = this.pickerComponent.getGui();
    e.addEventListener("focusin", this.onPickerFocusIn), e.addEventListener("focusout", this.onPickerFocusOut), this.hideCurrentPicker = this.renderAndPositionPicker(), this.toggleExpandedStyles(!0);
  }
  renderAndPositionPicker() {
    const e = this.pickerComponent.getGui();
    this.gos.get("suppressScrollWhenPopupsAreOpen") || ([this.destroyMouseWheelFunc] = this.addManagedEventListeners({
      bodyScroll: () => {
        this.hidePicker();
      }
    }));
    const t = this.getLocaleTextFunc(), {
      config: { pickerAriaLabelKey: s, pickerAriaLabelValue: i, modalPicker: r = !0 },
      maxPickerHeight: n,
      minPickerWidth: o,
      maxPickerWidth: a,
      variableWidth: l,
      beans: c,
      eWrapper: d
    } = this, u = {
      modal: r,
      eChild: e,
      closeOnEsc: !0,
      closedCallback: () => {
        const f = Fr(c);
        this.beforeHidePicker(), f && this.isAlive() && this.getFocusableElement().focus();
      },
      ariaLabel: t(s, i),
      anchorToElement: d
    };
    e.style.position = "absolute";
    const h = c.popupSvc, p = h.addPopup(u);
    l ? (o && (e.style.minWidth = o), e.style.width = oh(gn(d)), a && (e.style.maxWidth = a)) : Rl(e, a ?? gn(d));
    const g = n ?? `${nc(h.getPopupParent())}px`;
    return e.style.setProperty("max-height", g), this.alignPickerToComponent(), p.hideFunc;
  }
  alignPickerToComponent() {
    if (!this.pickerComponent)
      return;
    const {
      pickerGap: e,
      config: { pickerType: t },
      beans: { popupSvc: s, gos: i },
      eWrapper: r,
      pickerComponent: n
    } = this, o = i.get("enableRtl") ? "right" : "left";
    s.positionPopupByComponent({
      type: t,
      eventSource: r,
      ePopup: n.getGui(),
      position: "under",
      alignSide: o,
      keepWithinBounds: !0,
      nudgeY: e
    });
  }
  beforeHidePicker() {
    this.destroyMouseWheelFunc && (this.destroyMouseWheelFunc(), this.destroyMouseWheelFunc = void 0), this.toggleExpandedStyles(!1);
    const e = this.pickerComponent.getGui();
    e.removeEventListener("focusin", this.onPickerFocusIn), e.removeEventListener("focusout", this.onPickerFocusOut), this.isPickerDisplayed = !1, this.pickerComponent = void 0, this.hideCurrentPicker = null;
  }
  toggleExpandedStyles(e) {
    if (!this.isAlive())
      return;
    const t = this.getAriaElement();
    ns(t, e);
    const s = this.eWrapper.classList;
    s.toggle("ag-picker-expanded", e), s.toggle("ag-picker-collapsed", !e);
  }
  onPickerFocusIn() {
    this.togglePickerHasFocus(!0);
  }
  onPickerFocusOut(e) {
    var t;
    (t = this.pickerComponent) != null && t.getGui().contains(e.relatedTarget) || this.togglePickerHasFocus(!1);
  }
  togglePickerHasFocus(e) {
    this.pickerComponent && this.eWrapper.classList.toggle("ag-picker-has-focus", e);
  }
  hidePicker() {
    var e;
    (e = this.hideCurrentPicker) == null || e.call(this);
  }
  setInputWidth(e) {
    return Rl(this.eWrapper, e), this;
  }
  getFocusableElement() {
    return this.eWrapper;
  }
  setPickerGap(e) {
    return this.pickerGap = e, this;
  }
  setPickerMinWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.minPickerWidth = e ?? void 0, this;
  }
  setPickerMaxWidth(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerWidth = e ?? void 0, this;
  }
  setPickerMaxHeight(e) {
    return typeof e == "number" && (e = `${e}px`), this.maxPickerHeight = e ?? void 0, this;
  }
  destroy() {
    this.hidePicker(), super.destroy();
  }
}, KD = (
  /*css*/
  ".ag-select{align-items:center;display:flex;&.ag-disabled{opacity:.5}}:where(.ag-select){.ag-picker-field-wrapper{cursor:default}&.ag-disabled .ag-picker-field-wrapper:focus{box-shadow:none}&:not(.ag-cell-editor,.ag-label-align-top){min-height:var(--ag-list-item-height)}.ag-picker-field-display{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-picker-field-icon{align-items:center;display:flex}}:where(.ag-ltr) :where(.ag-select){.ag-picker-field-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding)/2);padding-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-select){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:calc(var(--ag-cell-horizontal-padding)/2)}}"
), rs = class extends Lh {
  constructor(e) {
    super({
      pickerAriaLabelKey: "ariaLabelSelectField",
      pickerAriaLabelValue: "Select Field",
      pickerType: "ag-list",
      className: "ag-select",
      pickerIcon: "selectOpen",
      ariaRole: "combobox",
      ...e
    }), this.registerCSS(KD);
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean("tooltipFeature", !1, {
        shouldDisplayTooltip: un(() => this.eDisplayField),
        getGui: () => this.getGui()
      })
    ), super.postConstruct(), this.createListComponent(), this.eWrapper.tabIndex = this.gos.get("tabIndex");
    const { options: e, value: t, placeholder: s } = this.config;
    e != null && this.addOptions(e), t != null && this.setValue(t, !0), s && t == null && (this.eDisplayField.textContent = s), this.addManagedElementListeners(this.eWrapper, { focusout: this.onWrapperFocusOut.bind(this) });
  }
  onWrapperFocusOut(e) {
    this.eWrapper.contains(e.relatedTarget) || this.hidePicker();
  }
  createListComponent() {
    const e = this.createBean(new $D("select", !0));
    this.listComponent = e, e.setParentComponent(this);
    const t = e.getAriaElement(), s = `ag-select-list-${e.getCompId()}`;
    t.setAttribute("id", s), ih(this.getAriaElement(), t), e.addManagedListeners(e, {
      selectedItem: () => {
        this.hidePicker(), this.dispatchLocalEvent({ type: "selectedItem" });
      }
    }), e.addManagedListeners(e, {
      fieldValueChanged: () => {
        this.listComponent && (this.setValue(this.listComponent.getValue(), !1, !0), this.hidePicker());
      }
    });
  }
  createPickerComponent() {
    return this.listComponent;
  }
  onKeyDown(e) {
    var s;
    const { key: t } = e;
    switch (t === P.TAB && this.hidePicker(), t) {
      case P.ENTER:
      case P.UP:
      case P.DOWN:
      case P.PAGE_UP:
      case P.PAGE_DOWN:
      case P.PAGE_HOME:
      case P.PAGE_END:
        e.preventDefault(), this.isPickerDisplayed ? (s = this.listComponent) == null || s.handleKeyDown(e) : super.onKeyDown(e);
        break;
      case P.ESCAPE:
        super.onKeyDown(e);
        break;
      case P.SPACE:
        this.isPickerDisplayed ? e.preventDefault() : super.onKeyDown(e);
        break;
    }
  }
  showPicker() {
    const e = this.listComponent;
    e && (super.showPicker(), e.refreshHighlighted());
  }
  addOptions(e) {
    return e.forEach((t) => this.addOption(t)), this;
  }
  addOption(e) {
    return this.listComponent.addOption(e), this;
  }
  clearOptions() {
    var e;
    return (e = this.listComponent) == null || e.clearOptions(), this;
  }
  setValue(e, t, s) {
    const {
      listComponent: i,
      config: { placeholder: r },
      eDisplayField: n,
      tooltipFeature: o
    } = this;
    if (this.value === e || !i)
      return this;
    if (s || i.setValue(e, !0), i.getValue() === this.getValue())
      return this;
    let l = i.getDisplayValue();
    return l == null && r && (l = r), n.textContent = l, o == null || o.setTooltipAndRefresh(l ?? null), super.setValue(e, t);
  }
  destroy() {
    this.listComponent = this.destroyBean(this.listComponent), super.destroy();
  }
}, ma = {
  selector: "AG-SELECT",
  component: rs
}, hn = {
  TAB_GUARD: "ag-tab-guard",
  TAB_GUARD_TOP: "ag-tab-guard-top",
  TAB_GUARD_BOTTOM: "ag-tab-guard-bottom"
}, Uw = class extends L {
  constructor(e) {
    super(), this.skipTabGuardFocus = !1, this.forcingFocusOut = !1, this.allowFocus = !1;
    const {
      comp: t,
      eTopGuard: s,
      eBottomGuard: i,
      focusTrapActive: r,
      forceFocusOutWhenTabGuardsAreEmpty: n,
      isFocusableContainer: o,
      focusInnerElement: a,
      onFocusIn: l,
      onFocusOut: c,
      shouldStopEventPropagation: d,
      onTabKeyDown: u,
      handleKeyDown: h,
      eFocusableElement: p
    } = e;
    this.comp = t, this.eTopGuard = s, this.eBottomGuard = i, this.providedFocusInnerElement = a, this.eFocusableElement = p, this.focusTrapActive = !!r, this.forceFocusOutWhenTabGuardsAreEmpty = !!n, this.isFocusableContainer = !!o, this.providedFocusIn = l, this.providedFocusOut = c, this.providedShouldStopEventPropagation = d, this.providedOnTabKeyDown = u, this.providedHandleKeyDown = h;
  }
  postConstruct() {
    this.createManagedBean(
      new Ir(this.eFocusableElement, {
        shouldStopEventPropagation: () => this.shouldStopEventPropagation(),
        onTabKeyDown: (e) => this.onTabKeyDown(e),
        handleKeyDown: (e) => this.handleKeyDown(e),
        onFocusIn: (e) => this.onFocusIn(e),
        onFocusOut: (e) => this.onFocusOut(e)
      })
    ), this.activateTabGuards(), [this.eTopGuard, this.eBottomGuard].forEach(
      (e) => this.addManagedElementListeners(e, { focus: this.onFocus.bind(this) })
    );
  }
  handleKeyDown(e) {
    this.providedHandleKeyDown && this.providedHandleKeyDown(e);
  }
  tabGuardsAreActive() {
    return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
  }
  shouldStopEventPropagation() {
    return this.providedShouldStopEventPropagation ? this.providedShouldStopEventPropagation() : !1;
  }
  activateTabGuards() {
    if (this.forcingFocusOut)
      return;
    const e = this.gos.get("tabIndex");
    this.comp.setTabIndex(e.toString());
  }
  deactivateTabGuards() {
    this.comp.setTabIndex();
  }
  onFocus(e) {
    if (this.isFocusableContainer && !this.eFocusableElement.contains(e.relatedTarget) && !this.allowFocus) {
      this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
      return;
    }
    if (this.skipTabGuardFocus) {
      this.skipTabGuardFocus = !1;
      return;
    }
    if (this.forceFocusOutWhenTabGuardsAreEmpty && ii(this.eFocusableElement, ".ag-tab-guard").length === 0) {
      this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
      return;
    }
    if (this.isFocusableContainer && this.eFocusableElement.contains(e.relatedTarget))
      return;
    const t = e.target === this.eBottomGuard;
    this.providedFocusInnerElement ? this.providedFocusInnerElement(t) : this.focusInnerElement(t);
  }
  findNextElementOutsideAndFocus(e) {
    var l;
    const t = We(this.beans), s = ii(t.body, null, !0), i = s.indexOf(e ? this.eTopGuard : this.eBottomGuard);
    if (i === -1)
      return;
    let r, n;
    e ? (r = 0, n = i) : (r = i + 1, n = s.length);
    const o = s.slice(r, n), a = this.gos.get("tabIndex");
    o.sort((c, d) => {
      const u = parseInt(c.getAttribute("tabindex") || "0"), h = parseInt(d.getAttribute("tabindex") || "0");
      return h === a ? 1 : u === a ? -1 : u === 0 ? 1 : h === 0 ? -1 : u - h;
    }), (l = o[e ? o.length - 1 : 0]) == null || l.focus();
  }
  onFocusIn(e) {
    this.focusTrapActive || this.forcingFocusOut || (this.providedFocusIn && this.providedFocusIn(e), this.isFocusableContainer || this.deactivateTabGuards());
  }
  onFocusOut(e) {
    this.focusTrapActive || (this.providedFocusOut && this.providedFocusOut(e), this.eFocusableElement.contains(e.relatedTarget) || this.activateTabGuards());
  }
  onTabKeyDown(e) {
    if (this.providedOnTabKeyDown) {
      this.providedOnTabKeyDown(e);
      return;
    }
    if (this.focusTrapActive || e.defaultPrevented)
      return;
    const t = this.tabGuardsAreActive();
    t && this.deactivateTabGuards();
    const s = this.getNextFocusableElement(e.shiftKey);
    t && setTimeout(() => this.activateTabGuards(), 0), s && (s.focus(), e.preventDefault());
  }
  focusInnerElement(e = !1) {
    const t = ii(this.eFocusableElement);
    this.tabGuardsAreActive() && (t.splice(0, 1), t.splice(t.length - 1, 1)), t.length && t[e ? t.length - 1 : 0].focus({ preventScroll: !0 });
  }
  getNextFocusableElement(e) {
    return zt(this.beans, this.eFocusableElement, !1, e);
  }
  forceFocusOutOfContainer(e = !1) {
    if (this.forcingFocusOut)
      return;
    const t = e ? this.eTopGuard : this.eBottomGuard;
    this.activateTabGuards(), this.skipTabGuardFocus = !0, this.forcingFocusOut = !0, t.focus(), window.setTimeout(() => {
      this.forcingFocusOut = !1, this.activateTabGuards();
    });
  }
  isTabGuard(e, t) {
    return e === this.eTopGuard && !t || e === this.eBottomGuard && (t ?? !0);
  }
  setAllowFocus(e) {
    this.allowFocus = e;
  }
}, $w = class extends L {
  constructor(e) {
    super(), this.comp = e;
  }
  initialiseTabGuard(e) {
    this.eTopGuard = this.createTabGuard("top"), this.eBottomGuard = this.createTabGuard("bottom"), this.eFocusableElement = this.comp.getFocusableElement();
    const { eTopGuard: t, eBottomGuard: s, eFocusableElement: i } = this, r = [t, s], n = {
      setTabIndex: (f) => {
        r.forEach(
          (m) => f != null ? m.setAttribute("tabindex", f) : m.removeAttribute("tabindex")
        );
      }
    };
    this.addTabGuards(t, s);
    const {
      focusTrapActive: o = !1,
      onFocusIn: a,
      onFocusOut: l,
      focusInnerElement: c,
      handleKeyDown: d,
      onTabKeyDown: u,
      shouldStopEventPropagation: h,
      forceFocusOutWhenTabGuardsAreEmpty: p,
      isFocusableContainer: g
    } = e;
    this.tabGuardCtrl = this.createManagedBean(
      new Uw({
        comp: n,
        focusTrapActive: o,
        eTopGuard: t,
        eBottomGuard: s,
        eFocusableElement: i,
        onFocusIn: a,
        onFocusOut: l,
        focusInnerElement: c,
        handleKeyDown: d,
        onTabKeyDown: u,
        shouldStopEventPropagation: h,
        forceFocusOutWhenTabGuardsAreEmpty: p,
        isFocusableContainer: g
      })
    );
  }
  getTabGuardCtrl() {
    return this.tabGuardCtrl;
  }
  createTabGuard(e) {
    const t = We(this.beans).createElement("div"), s = e === "top" ? hn.TAB_GUARD_TOP : hn.TAB_GUARD_BOTTOM;
    return t.classList.add(hn.TAB_GUARD, s), nt(t, "presentation"), t;
  }
  addTabGuards(e, t) {
    const s = this.eFocusableElement;
    s.insertAdjacentElement("afterbegin", e), s.insertAdjacentElement("beforeend", t);
  }
  removeAllChildrenExceptTabGuards() {
    const e = [this.eTopGuard, this.eBottomGuard];
    ze(this.comp.getFocusableElement()), this.addTabGuards(...e);
  }
  forceFocusOutOfContainer(e = !1) {
    this.tabGuardCtrl.forceFocusOutOfContainer(e);
  }
  appendChild(e, t, s) {
    ac(t) || (t = t.getGui());
    const { eBottomGuard: i } = this;
    i ? i.insertAdjacentElement("beforebegin", t) : e(t, s);
  }
}, Ti = class extends _ {
  initialiseTabGuard(t) {
    this.tabGuardFeature = this.createManagedBean(new $w(this)), this.tabGuardFeature.initialiseTabGuard(t);
  }
  forceFocusOutOfContainer(t = !1) {
    this.tabGuardFeature.forceFocusOutOfContainer(t);
  }
  appendChild(t, s) {
    this.tabGuardFeature.appendChild(super.appendChild.bind(this), t, s);
  }
}, Lr = class extends _ {
  isPopup() {
    return !0;
  }
  setParentComponent(e) {
    e.addCssClass("ag-has-popup"), super.setParentComponent(e);
  }
  destroy() {
    const e = this.parentComponent;
    e && e.isAlive() && e.getGui().classList.remove("ag-has-popup"), super.destroy();
  }
}, fr = class {
  constructor(e, t = !1) {
    this.DOUBLE_TAP_MILLIS = 500, this.destroyFuncs = [], this.touching = !1, this.localEventService = new Mr(), this.preventMouseClick = t;
    const s = this.onTouchStart.bind(this), i = this.onTouchMove.bind(this), r = this.onTouchEnd.bind(this);
    e.addEventListener("touchstart", s, { passive: !0 }), e.addEventListener("touchmove", i, { passive: !0 }), e.addEventListener("touchend", r, { passive: !1 }), this.destroyFuncs.push(() => {
      e.removeEventListener("touchstart", s, { passive: !0 }), e.removeEventListener("touchmove", i, { passive: !0 }), e.removeEventListener("touchend", r, { passive: !1 });
    });
  }
  getActiveTouch(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].identifier === this.touchStart.identifier)
        return e[t];
    return null;
  }
  addEventListener(e, t) {
    this.localEventService.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.localEventService.removeEventListener(e, t);
  }
  onTouchStart(e) {
    if (this.touching)
      return;
    this.touchStart = e.touches[0], this.touching = !0, this.moved = !1;
    const t = this.touchStart;
    window.setTimeout(() => {
      const s = this.touchStart === t;
      if (this.touching && s && !this.moved) {
        this.moved = !0;
        const i = {
          type: "longTap",
          touchStart: this.touchStart,
          touchEvent: e
        };
        this.localEventService.dispatchEvent(i);
      }
    }, 500);
  }
  onTouchMove(e) {
    if (!this.touching)
      return;
    const t = this.getActiveTouch(e.touches);
    if (!t)
      return;
    !gw(t, this.touchStart, 4) && (this.moved = !0);
  }
  onTouchEnd(e) {
    if (this.touching) {
      if (!this.moved) {
        const t = {
          type: "tap",
          touchStart: this.touchStart
        };
        this.localEventService.dispatchEvent(t), this.checkForDoubleTap();
      }
      this.preventMouseClick && e.cancelable && e.preventDefault(), this.touching = !1;
    }
  }
  checkForDoubleTap() {
    const e = (/* @__PURE__ */ new Date()).getTime();
    if (this.lastTapTime && this.lastTapTime > 0)
      if (e - this.lastTapTime > this.DOUBLE_TAP_MILLIS) {
        const s = {
          type: "doubleTap",
          touchStart: this.touchStart
        };
        this.localEventService.dispatchEvent(s), this.lastTapTime = null;
      } else
        this.lastTapTime = e;
    else
      this.lastTapTime = e;
  }
  destroy() {
    this.destroyFuncs.forEach((e) => e());
  }
}, Vs = /* @__PURE__ */ ((e) => (e[e.VALUE = 0] = "VALUE", e[e.DIMENSION = 1] = "DIMENSION", e))(Vs || {}), jw = class {
  constructor(e = "javascript") {
    this.frameworkName = e, this.renderingEngine = "vanilla", this.wrapIncoming = (t) => t(), this.wrapOutgoing = (t) => t(), this.baseDocLink = `${uv}/${this.frameworkName}-data-grid`, OP(this.baseDocLink);
  }
  setInterval(e, t) {
    return new fe((s) => {
      s(window.setInterval(e, t));
    });
  }
  // for Vanilla JS, we just add the event to the element
  addEventListener(e, t, s, i) {
    let r = {};
    if (typeof i == "object" ? r = i : typeof i == "boolean" && (r = { capture: i }), r.passive == null) {
      const n = Dv(t);
      n != null && (r.passive = n);
    }
    e.addEventListener(t, s, r);
  }
  frameworkComponent(e) {
    return null;
  }
  isFrameworkComponent(e) {
    return !1;
  }
  getDocLink(e) {
    return `${this.baseDocLink}${e ? `/${e}` : ""}`;
  }
};
function qD(e) {
  return {
    beanName: "gridApi",
    bean: e.getBean("apiFunctionSvc").api
  };
}
var YD = [
  // Validate license first
  "licenseManager",
  // core beans only
  "environment",
  "eventSvc",
  "gos",
  "paginationAutoPageSizeSvc",
  "apiFunctionSvc",
  "gridApi",
  "registry",
  "agCompUtils",
  "userCompFactory",
  "rowContainerHeight",
  "horizontalResizeSvc",
  "localeSvc",
  "pinnedRowModel",
  "dragSvc",
  "colGroupSvc",
  "visibleCols",
  "popupSvc",
  "selectionSvc",
  "colFilter",
  "quickFilter",
  "filterManager",
  "colModel",
  "headerNavigation",
  "pageBounds",
  "pagination",
  "pageBoundsListener",
  "stickyRowSvc",
  "rowRenderer",
  "expressionSvc",
  "alignedGridsSvc",
  "navigation",
  "valueCache",
  "valueSvc",
  "autoWidthCalc",
  "filterMenuFactory",
  "dragAndDrop",
  "focusSvc",
  "cellNavigation",
  "cellStyles",
  "scrollVisibleSvc",
  "sortSvc",
  "colHover",
  "colAnimation",
  "autoColSvc",
  "selectionColSvc",
  "changeDetectionSvc",
  "animationFrameSvc",
  "undoRedo",
  "colDefFactory",
  "rowStyleSvc",
  "rowNodeBlockLoader",
  "rowNodeSorter",
  "ctrlsSvc",
  "pinnedCols",
  "dataTypeSvc",
  "syncSvc",
  "overlays",
  "stateSvc",
  "expansionSvc",
  "apiEventSvc",
  "ariaAnnounce",
  "menuSvc",
  "colMoves",
  "colAutosize",
  "colFlex",
  "colResize",
  "pivotColsSvc",
  "valueColsSvc",
  "rowGroupColsSvc",
  "funcColsSvc",
  "colNames",
  "colViewport",
  "pivotResultCols",
  "showRowGroupCols",
  "validation"
  // Have validations run last
], ef = Object.fromEntries(
  YD.map((e, t) => [e, t])
);
function XD(e, t) {
  const s = (e.beanName ? ef[e.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER, i = (t.beanName ? ef[t.beanName] : void 0) ?? Number.MAX_SAFE_INTEGER;
  return s - i;
}
function ZD(e, t) {
  return (e == null ? void 0 : e.beanName) === "gridDestroySvc" ? -1 : 0;
}
var QD = (
  /* html */
  '<div class="ag-pinned-left-header" role="rowgroup"></div>'
), JD = (
  /* html */
  '<div class="ag-pinned-right-header" role="rowgroup"></div>'
), eA = (
  /* html */
  `<div class="ag-header-viewport" role="presentation">
        <div class="ag-header-container" data-ref="eCenterContainer" role="rowgroup"></div>
    </div>`
), vd = class extends _ {
  constructor(t) {
    super(), this.eCenterContainer = E, this.headerRowComps = {}, this.rowCompsList = [], this.pinned = t;
  }
  postConstruct() {
    this.selectAndSetTemplate();
    const t = {
      setDisplayed: (i) => this.setDisplayed(i),
      setCtrls: (i) => this.setCtrls(i),
      // only gets called for center section
      setCenterWidth: (i) => this.eCenterContainer.style.width = i,
      setViewportScrollLeft: (i) => this.getGui().scrollLeft = i,
      // only gets called for pinned sections
      setPinnedContainerWidth: (i) => {
        const r = this.getGui();
        r.style.width = i, r.style.maxWidth = i, r.style.minWidth = i;
      }
    };
    this.createManagedBean(new Bw(this.pinned)).setComp(t, this.getGui());
  }
  selectAndSetTemplate() {
    const t = this.pinned == "left", s = this.pinned == "right", i = t ? QD : s ? JD : eA;
    this.setTemplate(i), this.eRowContainer = this.eCenterContainer !== E ? this.eCenterContainer : this.getGui();
  }
  destroy() {
    this.setCtrls([]), super.destroy();
  }
  destroyRowComp(t) {
    this.destroyBean(t), this.eRowContainer.removeChild(t.getGui());
  }
  setCtrls(t) {
    const s = this.headerRowComps;
    this.headerRowComps = {}, this.rowCompsList = [];
    let i;
    const r = (n) => {
      const o = n.getGui();
      o.parentElement != this.eRowContainer && this.eRowContainer.appendChild(o), i && ov(this.eRowContainer, o, i), i = o;
    };
    t.forEach((n) => {
      const o = n.instanceId, a = s[o];
      delete s[o];
      const l = a || this.createBean(new yD(n));
      this.headerRowComps[o] = l, this.rowCompsList.push(l), r(l);
    }), Object.values(s).forEach((n) => this.destroyRowComp(n));
  }
}, tA = class extends _ {
  constructor() {
    super(
      /* html */
      '<div class="ag-header" role="presentation"/>'
    );
  }
  postConstruct() {
    const t = {
      addOrRemoveCssClass: (r, n) => this.addOrRemoveCssClass(r, n),
      setHeightAndMinHeight: (r) => {
        this.getGui().style.height = r, this.getGui().style.minHeight = r;
      }
    };
    this.createManagedBean(new Ow()).setComp(t, this.getGui(), this.getFocusableElement());
    const i = (r) => {
      this.createManagedBean(r), this.appendChild(r);
    };
    i(new vd("left")), i(new vd(null)), i(new vd("right"));
  }
}, sA = {
  selector: "AG-HEADER-ROOT",
  component: tA
}, iA = class extends _ {
  constructor(t, s, i, r, n) {
    super(), this.cellCtrl = s, this.rendererVersion = 0, this.editorVersion = 0, this.beans = t, this.column = s.column, this.rowNode = s.rowNode, this.eRow = r;
    const o = document.createElement("div");
    o.setAttribute("comp-id", `${this.getCompId()}`), this.setTemplateFromElement(o);
    const a = this.getGui();
    this.forceWrapper = s.isForceWrapper(), this.refreshWrapper(!1), nt(a, s.getCellAriaRole()), a.setAttribute("col-id", s.colIdSanitised);
    const l = {
      addOrRemoveCssClass: (c, d) => this.addOrRemoveCssClass(c, d),
      setUserStyles: (c) => lv(a, c),
      getFocusableElement: () => this.getFocusableElement(),
      setIncludeSelection: (c) => this.includeSelection = c,
      setIncludeRowDrag: (c) => this.includeRowDrag = c,
      setIncludeDndSource: (c) => this.includeDndSource = c,
      setRenderDetails: (c, d, u) => this.setRenderDetails(c, d, u),
      setEditDetails: (c, d, u) => this.setEditDetails(c, d, u),
      getCellEditor: () => this.cellEditor || null,
      getCellRenderer: () => this.cellRenderer || null,
      getParentOfValue: () => this.getParentOfValue()
    };
    s.setComp(l, this.getGui(), this.eCellWrapper, i, n, void 0);
  }
  getParentOfValue() {
    return this.eCellValue ? this.eCellValue : this.eCellWrapper ? this.eCellWrapper : this.getGui();
  }
  setRenderDetails(t, s, i) {
    if (this.cellEditor && !this.cellEditorPopupWrapper)
      return;
    this.firstRender = this.firstRender == null;
    const n = this.refreshWrapper(!1);
    this.refreshEditStyles(!1), t ? !(i || n) && this.refreshCellRenderer(t) || (this.destroyRenderer(), this.createCellRendererInstance(t)) : (this.destroyRenderer(), this.insertValueWithoutCellRenderer(s));
  }
  setEditDetails(t, s, i) {
    t ? this.createCellEditorInstance(t, s, i) : this.destroyEditor();
  }
  removeControls() {
    this.checkboxSelectionComp = this.beans.context.destroyBean(this.checkboxSelectionComp), this.dndSourceComp = this.beans.context.destroyBean(this.dndSourceComp), this.rowDraggingComp = this.beans.context.destroyBean(this.rowDraggingComp);
  }
  // returns true if wrapper was changed
  refreshWrapper(t) {
    const s = this.includeRowDrag || this.includeDndSource || this.includeSelection, i = s || this.forceWrapper, r = i && this.eCellWrapper == null;
    if (r) {
      const d = document.createElement("div");
      d.setAttribute("role", "presentation"), d.setAttribute("class", "ag-cell-wrapper"), this.eCellWrapper = d, this.getGui().appendChild(this.eCellWrapper);
    }
    const n = !i && this.eCellWrapper != null;
    n && (ut(this.eCellWrapper), this.eCellWrapper = void 0), this.addOrRemoveCssClass("ag-cell-value", !i);
    const o = !t && i, a = o && this.eCellValue == null;
    if (a) {
      const d = document.createElement("span");
      d.setAttribute("role", "presentation"), d.setAttribute("class", "ag-cell-value"), this.eCellValue = d, this.eCellWrapper.appendChild(this.eCellValue);
    }
    const l = !o && this.eCellValue != null;
    l && (ut(this.eCellValue), this.eCellValue = void 0);
    const c = r || n || a || l;
    return c && this.removeControls(), t || s && this.addControls(), c;
  }
  addControls() {
    this.includeRowDrag && this.rowDraggingComp == null && (this.rowDraggingComp = this.cellCtrl.createRowDragComp(), this.rowDraggingComp && this.eCellWrapper.insertBefore(this.rowDraggingComp.getGui(), this.eCellValue)), this.includeDndSource && this.dndSourceComp == null && (this.dndSourceComp = this.cellCtrl.createDndSource(), this.dndSourceComp && this.eCellWrapper.insertBefore(this.dndSourceComp.getGui(), this.eCellValue)), this.includeSelection && this.checkboxSelectionComp == null && (this.checkboxSelectionComp = this.cellCtrl.createSelectionCheckbox(), this.checkboxSelectionComp && this.eCellWrapper.insertBefore(this.checkboxSelectionComp.getGui(), this.eCellValue));
  }
  createCellEditorInstance(t, s, i) {
    const r = this.editorVersion, n = t.newAgStackInstance(), { params: o } = t;
    n.then((l) => this.afterCellEditorCreated(r, l, o, s, i)), ke(this.cellEditor) && o.cellStartedEdit && this.cellCtrl.focusCell(!0);
  }
  insertValueWithoutCellRenderer(t) {
    const s = this.getParentOfValue();
    ze(s);
    const i = t != null ? Ke(t, !0) : null;
    i != null && (s.textContent = i);
  }
  destroyEditorAndRenderer() {
    this.destroyRenderer(), this.destroyEditor();
  }
  destroyRenderer() {
    const { context: t } = this.beans;
    this.cellRenderer = t.destroyBean(this.cellRenderer), ut(this.cellRendererGui), this.cellRendererGui = null, this.rendererVersion++;
  }
  destroyEditor() {
    const { context: t } = this.beans;
    this.hideEditorPopup && this.hideEditorPopup(), this.hideEditorPopup = void 0, this.cellEditor = t.destroyBean(this.cellEditor), this.cellEditorPopupWrapper = t.destroyBean(this.cellEditorPopupWrapper), ut(this.cellEditorGui), this.cellEditorGui = null, this.editorVersion++;
  }
  refreshCellRenderer(t) {
    if (this.cellRenderer == null || this.cellRenderer.refresh == null || this.cellRendererClass !== t.componentClass)
      return !1;
    const s = this.cellRenderer.refresh(t.params);
    return s === !0 || s === void 0;
  }
  createCellRendererInstance(t) {
    const i = !this.beans.gos.get("suppressAnimationFrame") && this.beans.animationFrameSvc, r = this.rendererVersion, { componentClass: n } = t, o = () => {
      if (this.rendererVersion !== r || !this.isAlive())
        return;
      const l = t.newAgStackInstance(), c = this.afterCellRendererCreated.bind(this, r, n);
      l && l.then(c);
    };
    i && this.firstRender ? this.beans.animationFrameSvc.createTask(o, this.rowNode.rowIndex, "createTasksP2") : o();
  }
  afterCellRendererCreated(t, s, i) {
    if (!this.isAlive() || t !== this.rendererVersion) {
      this.beans.context.destroyBean(i);
      return;
    }
    if (this.cellRenderer = i, this.cellRendererClass = s, this.cellRendererGui = this.cellRenderer.getGui(), this.cellRendererGui != null) {
      const n = this.getParentOfValue();
      ze(n), n.appendChild(this.cellRendererGui);
    }
  }
  afterCellEditorCreated(t, s, i, r, n) {
    if (t !== this.editorVersion) {
      this.beans.context.destroyBean(s);
      return;
    }
    if (s.isCancelBeforeStart && s.isCancelBeforeStart()) {
      this.beans.context.destroyBean(s), this.cellCtrl.stopEditing(!0);
      return;
    }
    if (!s.getGui) {
      I(97, { colId: this.column.getId() }), this.beans.context.destroyBean(s);
      return;
    }
    this.cellEditor = s, this.cellEditorGui = s.getGui();
    const l = r || s.isPopup !== void 0 && s.isPopup();
    l ? this.addPopupCellEditor(i, n) : this.addInCellEditor(), this.refreshEditStyles(!0, l), s.afterGuiAttached && s.afterGuiAttached(), this.cellCtrl.cellEditorAttached();
  }
  refreshEditStyles(t, s) {
    this.addOrRemoveCssClass("ag-cell-inline-editing", t && !s), this.addOrRemoveCssClass("ag-cell-popup-editing", t && !!s), this.addOrRemoveCssClass("ag-cell-not-inline-editing", !t || !!s), this.cellCtrl.setInlineEditingCss();
  }
  addInCellEditor() {
    const t = this.getGui();
    t.contains(Ie(this.beans)) && t.focus(), this.destroyRenderer(), this.refreshWrapper(!0), this.clearParentOfValue(), this.cellEditorGui && this.getParentOfValue().appendChild(this.cellEditorGui);
  }
  addPopupCellEditor(t, s) {
    var p;
    this.beans.gos.get("editType") === "fullRow" && I(98);
    const i = this.cellEditor;
    this.cellEditorPopupWrapper = this.beans.context.createBean(
      this.beans.editSvc.createPopupEditorWrapper(t)
    );
    const r = this.cellEditorPopupWrapper.getGui();
    this.cellEditorGui && r.appendChild(this.cellEditorGui);
    const n = this.beans.popupSvc, o = this.beans.gos.get("stopEditingWhenCellsLoseFocus"), a = s ?? ((p = i.getPopupPosition) == null ? void 0 : p.call(i)) ?? "over", l = this.beans.gos.get("enableRtl"), c = {
      ePopup: r,
      column: this.column,
      rowNode: this.rowNode,
      type: "popupCellEditor",
      eventSource: this.getGui(),
      position: a,
      alignSide: l ? "right" : "left",
      keepWithinBounds: !0
    }, d = n.positionPopupByComponent.bind(n, c), u = Qu(this.beans.localeSvc), h = n.addPopup({
      modal: o,
      eChild: r,
      closeOnEsc: !0,
      closedCallback: () => {
        this.cellCtrl.onPopupEditorClosed();
      },
      anchorToElement: this.getGui(),
      positionCallback: d,
      ariaLabel: u("ariaLabelCellEditor", "Cell Editor")
    });
    h && (this.hideEditorPopup = h.hideFunc);
  }
  detach() {
    this.eRow.removeChild(this.getGui());
  }
  // if the row is also getting destroyed, then we don't need to remove from dom,
  // as the row will also get removed, so no need to take out the cells from the row
  // if the row is going (removing is an expensive operation, so only need to remove
  // the top part)
  //
  // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
  destroy() {
    this.cellCtrl.stopEditing(), this.destroyEditorAndRenderer(), this.removeControls(), super.destroy();
  }
  clearParentOfValue() {
    const t = this.getGui();
    t.contains(Ie(this.beans)) && t.focus({ preventScroll: !0 }), ze(this.getParentOfValue());
  }
}, rA = class extends _ {
  constructor(t, s, i) {
    super(), this.cellComps = {}, this.beans = s, this.rowCtrl = t;
    const r = document.createElement("div");
    r.setAttribute("comp-id", `${this.getCompId()}`), r.setAttribute("style", this.getInitialStyle(i)), this.setTemplateFromElement(r);
    const n = this.getGui(), o = n.style;
    this.domOrder = this.rowCtrl.getDomOrder(), nt(n, "row");
    const a = {
      setDomOrder: (l) => this.domOrder = l,
      setCellCtrls: (l) => this.setCellCtrls(l),
      showFullWidth: (l) => this.showFullWidth(l),
      getFullWidthCellRenderer: () => this.fullWidthCellRenderer,
      addOrRemoveCssClass: (l, c) => this.addOrRemoveCssClass(l, c),
      setUserStyles: (l) => lv(n, l),
      setTop: (l) => o.top = l,
      setTransform: (l) => o.transform = l,
      setRowIndex: (l) => n.setAttribute("row-index", l),
      setRowId: (l) => n.setAttribute("row-id", l),
      setRowBusinessKey: (l) => n.setAttribute("row-business-key", l),
      refreshFullWidth: (l) => {
        var c, d;
        return ((d = (c = this.fullWidthCellRenderer) == null ? void 0 : c.refresh) == null ? void 0 : d.call(c, l())) ?? !1;
      }
    };
    t.setComp(a, this.getGui(), i, void 0), this.addDestroyFunc(() => {
      t.unsetComp(i);
    });
  }
  getInitialStyle(t) {
    const s = this.rowCtrl.getInitialTransform(t);
    return s ? `transform: ${s}` : `top: ${this.rowCtrl.getInitialRowTop(t)}`;
  }
  showFullWidth(t) {
    const s = (r) => {
      if (this.isAlive()) {
        const n = r.getGui();
        this.getGui().appendChild(n), this.rowCtrl.setupDetailRowAutoHeight(n), this.setFullWidthRowComp(r);
      } else
        this.beans.context.destroyBean(r);
    };
    t.newAgStackInstance().then(s);
  }
  setCellCtrls(t) {
    const s = Object.assign({}, this.cellComps);
    t.forEach((r) => {
      const n = r.instanceId;
      this.cellComps[n] == null ? this.newCellComp(r) : s[n] = null;
    });
    const i = Object.values(s).filter((r) => r != null);
    this.destroyCells(i), this.ensureDomOrder(t);
  }
  ensureDomOrder(t) {
    if (!this.domOrder)
      return;
    const s = [];
    t.forEach((i) => {
      const r = this.cellComps[i.instanceId];
      r && s.push(r.getGui());
    }), av(this.getGui(), s);
  }
  newCellComp(t) {
    const s = new iA(
      this.beans,
      t,
      this.rowCtrl.printLayout,
      this.getGui(),
      this.rowCtrl.editing
    );
    this.cellComps[t.instanceId] = s, this.getGui().appendChild(s.getGui());
  }
  destroy() {
    super.destroy(), this.destroyAllCells();
  }
  destroyAllCells() {
    const t = Object.values(this.cellComps).filter((s) => s != null);
    this.destroyCells(t);
  }
  setFullWidthRowComp(t) {
    this.fullWidthCellRenderer = t, this.addDestroyFunc(() => {
      this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer);
    });
  }
  destroyCells(t) {
    t.forEach((s) => {
      if (!s)
        return;
      const i = s.cellCtrl.instanceId;
      this.cellComps[i] === s && (s.detach(), s.destroy(), this.cellComps[i] = null);
    });
  }
};
function nA(e) {
  let t;
  return e.type === "center" ? t = /* html */
  `<div class="${e.viewport}" data-ref="eViewport" role="presentation">
                <div class="${e.container}" data-ref="eContainer"></div>
            </div>` : t = /* html */
  `<div class="${e.container}" data-ref="eContainer"></div>`, t;
}
var oA = class extends _ {
  constructor(t) {
    super(), this.eViewport = E, this.eContainer = E, this.rowComps = {}, this.name = t == null ? void 0 : t.name, this.options = sn(this.name), this.setTemplate(nA(this.options));
  }
  postConstruct() {
    const t = {
      setHorizontalScroll: (i) => this.eViewport.scrollLeft = i,
      setViewportHeight: (i) => this.eViewport.style.height = i,
      setRowCtrls: ({ rowCtrls: i }) => this.setRowCtrls(i),
      setDomOrder: (i) => {
        this.domOrder = i;
      },
      setContainerWidth: (i) => this.eContainer.style.width = i,
      setOffsetTop: (i) => this.eContainer.style.transform = `translateY(${i})`
    };
    this.createManagedBean(new Tw(this.name)).setComp(t, this.eContainer, this.eViewport);
  }
  destroy() {
    this.setRowCtrls([]), super.destroy();
  }
  setRowCtrls(t) {
    const s = { ...this.rowComps };
    this.rowComps = {}, this.lastPlacedElement = null;
    const i = (r) => {
      const n = r.instanceId, o = s[n];
      if (o)
        this.rowComps[n] = o, delete s[n], this.ensureDomOrder(o.getGui());
      else {
        if (!r.rowNode.displayed)
          return;
        const a = new rA(r, this.beans, this.options.type);
        this.rowComps[n] = a, this.appendRow(a.getGui());
      }
    };
    t.forEach(i), Object.values(s).forEach((r) => {
      this.eContainer.removeChild(r.getGui()), r.destroy();
    }), nt(this.eContainer, "rowgroup");
  }
  appendRow(t) {
    this.domOrder ? EP(this.eContainer, t, this.lastPlacedElement) : this.eContainer.appendChild(t), this.lastPlacedElement = t;
  }
  ensureDomOrder(t) {
    this.domOrder && (ov(this.eContainer, t, this.lastPlacedElement), this.lastPlacedElement = t);
  }
}, aA = {
  selector: "AG-ROW-CONTAINER",
  component: oA
};
function Ao(e, t) {
  return t.map((s) => {
    const i = `e${s[0].toUpperCase() + s.substring(1)}RowContainer`;
    return e[i] = { name: s }, /* html */
    `<ag-row-container name="${s}" data-ref="${i}"></ag-row-container>`;
  }).join("");
}
function lA(e) {
  const t = {}, s = (
    /* html */
    `<div class="ag-root ag-unselectable" data-ref="eGridRoot">
        <ag-header-root></ag-header-root>
        <div class="ag-floating-top" data-ref="eTop" role="presentation">
            ${Ao(t, ["topLeft", "topCenter", "topRight", "topFullWidth"])}
        </div>
        <div class="ag-body" data-ref="eBody" role="presentation">
            <div class="ag-body-viewport" data-ref="eBodyViewport" role="presentation">
            ${Ao(t, ["left", "center", "right", "fullWidth"])}
            </div>
            <ag-fake-vertical-scroll></ag-fake-vertical-scroll>
        </div>
        <div class="ag-sticky-top" data-ref="eStickyTop" role="presentation">
            ${Ao(t, ["stickyTopLeft", "stickyTopCenter", "stickyTopRight", "stickyTopFullWidth"])}
        </div>
        <div class="ag-sticky-bottom" data-ref="eStickyBottom" role="presentation">
            ${Ao(t, ["stickyBottomLeft", "stickyBottomCenter", "stickyBottomRight", "stickyBottomFullWidth"])}
        </div>
        <div class="ag-floating-bottom" data-ref="eBottom" role="presentation">
            ${Ao(t, ["bottomLeft", "bottomCenter", "bottomRight", "bottomFullWidth"])}
        </div>
        <ag-fake-horizontal-scroll></ag-fake-horizontal-scroll>
        ${e ? (
      /* html */
      "<ag-overlay-wrapper></ag-overlay-wrapper>"
    ) : ""}
    </div>`
  );
  return { paramsMap: t, template: s };
}
var cA = class extends _ {
  constructor() {
    super(...arguments), this.eGridRoot = E, this.eBodyViewport = E, this.eStickyTop = E, this.eStickyBottom = E, this.eTop = E, this.eBottom = E, this.eBody = E;
  }
  postConstruct() {
    const { overlays: t, rangeSvc: s } = this.beans, i = t == null ? void 0 : t.getOverlayWrapperSelector(), { paramsMap: r, template: n } = lA(!!i);
    this.setTemplate(
      n,
      [
        ...i ? [i] : [],
        hD,
        pD,
        sA,
        aA
      ],
      r
    );
    const o = (l, c) => {
      const d = `${l}px`;
      c.style.minHeight = d, c.style.height = d;
    }, a = {
      setRowAnimationCssOnBodyViewport: (l, c) => this.setRowAnimationCssOnBodyViewport(l, c),
      setColumnCount: (l) => jC(this.getGui(), l),
      setRowCount: (l) => $C(this.getGui(), l),
      setTopHeight: (l) => o(l, this.eTop),
      setBottomHeight: (l) => o(l, this.eBottom),
      setTopDisplay: (l) => this.eTop.style.display = l,
      setBottomDisplay: (l) => this.eBottom.style.display = l,
      setStickyTopHeight: (l) => this.eStickyTop.style.height = l,
      setStickyTopTop: (l) => this.eStickyTop.style.top = l,
      setStickyTopWidth: (l) => this.eStickyTop.style.width = l,
      setStickyBottomHeight: (l) => {
        this.eStickyBottom.style.height = l, this.eStickyBottom.classList.toggle("ag-hidden", l === "0px");
      },
      setStickyBottomBottom: (l) => this.eStickyBottom.style.bottom = l,
      setStickyBottomWidth: (l) => this.eStickyBottom.style.width = l,
      setColumnMovingCss: (l, c) => this.addOrRemoveCssClass(l, c),
      updateLayoutClasses: (l, c) => {
        [this.eBodyViewport.classList, this.eBody.classList].forEach((u) => {
          u.toggle(ei.AUTO_HEIGHT, c.autoHeight), u.toggle(ei.NORMAL, c.normal), u.toggle(ei.PRINT, c.print);
        }), this.addOrRemoveCssClass(ei.AUTO_HEIGHT, c.autoHeight), this.addOrRemoveCssClass(ei.NORMAL, c.normal), this.addOrRemoveCssClass(ei.PRINT, c.print);
      },
      setAlwaysVerticalScrollClass: (l, c) => this.eBodyViewport.classList.toggle(Ew, c),
      registerBodyViewportResizeListener: (l) => {
        const c = Ms(this.beans, this.eBodyViewport, l);
        this.addDestroyFunc(() => c());
      },
      setPinnedTopBottomOverflowY: (l) => this.eTop.style.overflowY = this.eBottom.style.overflowY = l,
      setCellSelectableCss: (l, c) => {
        [this.eTop, this.eBodyViewport, this.eBottom].forEach(
          (d) => d.classList.toggle(l, c)
        );
      },
      setBodyViewportWidth: (l) => this.eBodyViewport.style.width = l,
      setGridRootRole: (l) => nt(this.eGridRoot, l)
    };
    this.ctrl = this.createManagedBean(new Dw()), this.ctrl.setComp(
      a,
      this.getGui(),
      this.eBodyViewport,
      this.eTop,
      this.eBottom,
      this.eStickyTop,
      this.eStickyBottom
    ), (s && is(this.gos) || Pr(this.gos)) && RP(this.getGui(), !0);
  }
  setRowAnimationCssOnBodyViewport(t, s) {
    const i = this.eBodyViewport.classList;
    i.toggle("ag-row-animation", s), i.toggle("ag-row-no-animation", !s);
  }
}, dA = {
  selector: "AG-GRID-BODY",
  component: cA
}, Kw = class extends L {
  constructor() {
    super(...arguments), this.additionalFocusableContainers = /* @__PURE__ */ new Set();
  }
  setComp(e, t, s) {
    this.view = e, this.eGridHostDiv = t, this.eGui = s, this.eGui.setAttribute("grid-id", this.beans.context.getGridId());
    const { dragAndDrop: i, ctrlsSvc: r } = this.beans;
    i == null || i.registerGridDropTarget(() => this.eGui, this), uw(this.gos, t), this.createManagedBean(new Sh(this.view)), this.view.setRtlClass(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
    const n = Ms(this.beans, this.eGridHostDiv, this.onGridSizeChanged.bind(this));
    this.addDestroyFunc(() => n()), r.register("gridCtrl", this);
  }
  isDetailGrid() {
    var t;
    const e = vh(this.getGui());
    return ((t = e == null ? void 0 : e.getAttribute("row-id")) == null ? void 0 : t.startsWith("detail")) || !1;
  }
  getOptionalSelectors() {
    var t, s, i, r;
    const e = this.beans;
    return {
      paginationSelector: (t = e.pagination) == null ? void 0 : t.getPaginationSelector(),
      gridHeaderDropZonesSelector: e.registry.getSelector("AG-GRID-HEADER-DROP-ZONES"),
      sideBarSelector: (s = e.sideBar) == null ? void 0 : s.getSelector(),
      statusBarSelector: (i = e.registry) == null ? void 0 : i.getSelector("AG-STATUS-BAR"),
      watermarkSelector: (r = e.licenseManager) == null ? void 0 : r.getWatermarkSelector()
    };
  }
  onGridSizeChanged() {
    this.eventSvc.dispatchEvent({
      type: "gridSizeChanged",
      clientWidth: this.eGridHostDiv.clientWidth,
      clientHeight: this.eGridHostDiv.clientHeight
    });
  }
  destroyGridUi() {
    this.view.destroyGridUi();
  }
  getGui() {
    return this.eGui;
  }
  setResizeCursor(e) {
    this.view.setCursor(e ? "ew-resize" : null);
  }
  disableUserSelect(e) {
    this.view.setUserSelect(e ? "none" : null);
  }
  focusNextInnerContainer(e) {
    const t = this.getFocusableContainers(), { indexWithFocus: s, nextIndex: i } = this.getNextFocusableIndex(t, e);
    if (i < 0 || i >= t.length)
      return !1;
    if (i === 0) {
      if (s > 0) {
        const { visibleCols: r, focusSvc: n } = this.beans, o = r.allCols, a = pe(o);
        if (n.focusGridView(a, !0))
          return !0;
      }
      return !1;
    }
    return this.focusContainer(t[i], e);
  }
  focusInnerElement(e) {
    const t = this.gos.getCallback("focusGridInnerElement");
    if (t && t({ fromBottom: !!e }))
      return !0;
    const s = this.getFocusableContainers(), { focusSvc: i, visibleCols: r } = this.beans, n = r.allCols;
    if (e) {
      if (s.length > 1)
        return this.focusContainer(pe(s), !0);
      const o = pe(n);
      if (i.focusGridView(o, !0))
        return !0;
    }
    if (this.gos.get("headerHeight") === 0 || _n(this.beans)) {
      if (i.focusGridView(n[0]))
        return !0;
      for (let o = 1; o < s.length; o++)
        if (Dt(s[o].getGui()))
          return !0;
      return !1;
    }
    return i.focusFirstHeader();
  }
  forceFocusOutOfContainer(e = !1) {
    this.view.forceFocusOutOfContainer(e);
  }
  addFocusableContainer(e) {
    this.additionalFocusableContainers.add(e);
  }
  removeFocusableContainer(e) {
    this.additionalFocusableContainers.delete(e);
  }
  allowFocusForNextCoreContainer(e) {
    var n;
    const t = this.view.getFocusableContainers(), { nextIndex: s, indexWithFocus: i } = this.getNextFocusableIndex(t, e);
    if (i === -1 || s < 0 || s >= t.length)
      return;
    const r = t[s];
    (n = r.setAllowFocus) == null || n.call(r, !0), setTimeout(() => {
      var o;
      (o = r.setAllowFocus) == null || o.call(r, !1);
    });
  }
  getNextFocusableIndex(e, t) {
    const s = Ie(this.beans), i = e.findIndex((n) => n.getGui().contains(s)), r = i + (t ? -1 : 1);
    return {
      indexWithFocus: i,
      nextIndex: r
    };
  }
  focusContainer(e, t) {
    var i, r;
    (i = e.setAllowFocus) == null || i.call(e, !0);
    const s = Dt(e.getGui(), t);
    return (r = e.setAllowFocus) == null || r.call(e, !1), s;
  }
  getFocusableContainers() {
    return [...this.view.getFocusableContainers(), ...this.additionalFocusableContainers];
  }
  destroy() {
    this.additionalFocusableContainers.clear(), super.destroy();
  }
}, uA = class extends Ti {
  constructor(t) {
    super(), this.gridBody = E, this.sideBar = E, this.pagination = E, this.rootWrapperBody = E, this.eGridDiv = t;
  }
  postConstruct() {
    const t = {
      destroyGridUi: () => this.destroyBean(this),
      setRtlClass: (o) => this.addCssClass(o),
      forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
      updateLayoutClasses: this.updateLayoutClasses.bind(this),
      getFocusableContainers: this.getFocusableContainers.bind(this),
      setUserSelect: (o) => {
        this.getGui().style.userSelect = o ?? "", this.getGui().style.webkitUserSelect = o ?? "";
      },
      setCursor: (o) => {
        this.getGui().style.cursor = o ?? "";
      }
    }, s = this.createManagedBean(new Kw()), i = s.getOptionalSelectors(), r = this.createTemplate(i), n = [dA, ...Object.values(i).filter((o) => !!o)];
    this.setTemplate(r, n), s.setComp(t, this.eGridDiv, this.getGui()), this.insertGridIntoDom(), this.initialiseTabGuard({
      // we want to override the default behaviour to do nothing for onTabKeyDown
      onTabKeyDown: () => {
      },
      focusInnerElement: (o) => s.focusInnerElement(o),
      forceFocusOutWhenTabGuardsAreEmpty: !0
    });
  }
  insertGridIntoDom() {
    const t = this.getGui();
    this.eGridDiv.appendChild(t), this.addDestroyFunc(() => {
      this.eGridDiv.removeChild(t), Rr(this.gos, "Grid removed from DOM");
    });
  }
  updateLayoutClasses(t, s) {
    const i = this.rootWrapperBody.classList, { AUTO_HEIGHT: r, NORMAL: n, PRINT: o } = ei, { autoHeight: a, normal: l, print: c } = s;
    i.toggle(r, a), i.toggle(n, l), i.toggle(o, c), this.addOrRemoveCssClass(r, a), this.addOrRemoveCssClass(n, l), this.addOrRemoveCssClass(o, c);
  }
  createTemplate(t) {
    const s = t.gridHeaderDropZonesSelector ? "<ag-grid-header-drop-zones></ag-grid-header-drop-zones>" : "", i = t.sideBarSelector ? '<ag-side-bar data-ref="sideBar"></ag-side-bar>' : "", r = t.statusBarSelector ? "<ag-status-bar></ag-status-bar>" : "", n = t.watermarkSelector ? "<ag-watermark></ag-watermark>" : "", o = t.paginationSelector ? '<ag-pagination data-ref="pagination"></ag-pagination>' : "";
    return (
      /* html */
      `<div class="ag-root-wrapper" role="presentation">
                ${s}
                <div class="ag-root-wrapper-body" data-ref="rootWrapperBody" role="presentation">
                    <ag-grid-body data-ref="gridBody"></ag-grid-body>
                    ${i}
                </div>
                ${r}
                ${o}
                ${n}
            </div>`
    );
  }
  getFocusableElement() {
    return this.rootWrapperBody;
  }
  forceFocusOutOfContainer(t = !1) {
    var s;
    if (!t && ((s = this.pagination) != null && s.isDisplayed())) {
      this.pagination.forceFocusOutOfContainer(t);
      return;
    }
    super.forceFocusOutOfContainer(t);
  }
  getFocusableContainers() {
    const t = [this.gridBody];
    return [this.sideBar, this.pagination].forEach((s) => {
      s && t.push(s);
    }), t.filter((s) => Xt(s.getGui()));
  }
}, Ae = (e, t) => {
  for (const s of Object.keys(t))
    t[s] = e;
  return t;
}, tf = {
  dispatchEvent: "CommunityCore",
  // this is always registered
  ...Ae("CommunityCore", {
    destroy: 0,
    getGridId: 0,
    getGridOption: 0,
    isDestroyed: 0,
    setGridOption: 0,
    updateGridOptions: 0
  }),
  ...Ae("GridState", {
    getState: 0
  }),
  ...Ae("SharedRowSelection", {
    setNodesSelected: 0,
    selectAll: 0,
    deselectAll: 0,
    selectAllFiltered: 0,
    deselectAllFiltered: 0,
    selectAllOnCurrentPage: 0,
    deselectAllOnCurrentPage: 0,
    getSelectedNodes: 0,
    getSelectedRows: 0
  }),
  ...Ae("RowApi", {
    redrawRows: 0,
    setRowNodeExpanded: 0,
    getRowNode: 0,
    addRenderedRowListener: 0,
    getRenderedNodes: 0,
    forEachNode: 0,
    getFirstDisplayedRowIndex: 0,
    getLastDisplayedRowIndex: 0,
    getDisplayedRowAtIndex: 0,
    getDisplayedRowCount: 0
  }),
  ...Ae("ScrollApi", {
    getVerticalPixelRange: 0,
    getHorizontalPixelRange: 0,
    ensureColumnVisible: 0,
    ensureIndexVisible: 0,
    ensureNodeVisible: 0
  }),
  ...Ae("KeyboardNavigation", {
    getFocusedCell: 0,
    clearFocusedCell: 0,
    setFocusedCell: 0,
    tabToNextCell: 0,
    tabToPreviousCell: 0,
    setFocusedHeader: 0
  }),
  ...Ae("EventApi", {
    addEventListener: 0,
    addGlobalListener: 0,
    removeEventListener: 0,
    removeGlobalListener: 0
  }),
  ...Ae("ValueCache", {
    expireValueCache: 0
  }),
  ...Ae("CellApi", {
    getCellValue: 0
  }),
  ...Ae("SharedMenu", {
    showColumnMenu: 0,
    hidePopupMenu: 0
  }),
  ...Ae("Sort", {
    onSortChanged: 0
  }),
  ...Ae("PinnedRow", {
    getPinnedTopRowCount: 0,
    getPinnedBottomRowCount: 0,
    getPinnedTopRow: 0,
    getPinnedBottomRow: 0
  }),
  ...Ae("Overlay", {
    showLoadingOverlay: 0,
    showNoRowsOverlay: 0,
    hideOverlay: 0
  }),
  ...Ae("RenderApi", {
    setGridAriaProperty: 0,
    refreshCells: 0,
    refreshHeader: 0,
    isAnimationFrameQueueEmpty: 0,
    flushAllAnimationFrames: 0,
    getSizesForCurrentTheme: 0,
    getCellRendererInstances: 0
  }),
  ...Ae("HighlightChanges", {
    flashCells: 0
  }),
  ...Ae("RowDrag", {
    addRowDropZone: 0,
    removeRowDropZone: 0,
    getRowDropZoneParams: 0
  }),
  ...Ae("ColumnApi", {
    getColumnDefs: 0,
    getColumnDef: 0,
    getDisplayNameForColumn: 0,
    getColumn: 0,
    getColumns: 0,
    applyColumnState: 0,
    getColumnState: 0,
    resetColumnState: 0,
    isPinning: 0,
    isPinningLeft: 0,
    isPinningRight: 0,
    getDisplayedColAfter: 0,
    getDisplayedColBefore: 0,
    setColumnsVisible: 0,
    setColumnsPinned: 0,
    getAllGridColumns: 0,
    getDisplayedLeftColumns: 0,
    getDisplayedCenterColumns: 0,
    getDisplayedRightColumns: 0,
    getAllDisplayedColumns: 0,
    getAllDisplayedVirtualColumns: 0
  }),
  ...Ae("ColumnAutoSize", {
    sizeColumnsToFit: 0,
    autoSizeColumns: 0,
    autoSizeAllColumns: 0
  }),
  ...Ae("ColumnGroup", {
    setColumnGroupOpened: 0,
    getColumnGroup: 0,
    getProvidedColumnGroup: 0,
    getDisplayNameForColumnGroup: 0,
    getColumnGroupState: 0,
    setColumnGroupState: 0,
    resetColumnGroupState: 0,
    getLeftDisplayedColumnGroups: 0,
    getCenterDisplayedColumnGroups: 0,
    getRightDisplayedColumnGroups: 0,
    getAllDisplayedColumnGroups: 0
  }),
  ...Ae("ColumnMove", {
    moveColumnByIndex: 0,
    moveColumns: 0
  }),
  ...Ae("ColumnResize", {
    setColumnWidths: 0
  }),
  ...Ae("ColumnHover", {
    isColumnHovered: 0
  }),
  ...Ae("EditCore", {
    getCellEditorInstances: 0,
    getEditingCells: 0,
    stopEditing: 0,
    startEditingCell: 0
  }),
  ...Ae("UndoRedoEdit", {
    undoCellEditing: 0,
    redoCellEditing: 0,
    getCurrentUndoSize: 0,
    getCurrentRedoSize: 0
  }),
  ...Ae("FilterCore", {
    isAnyFilterPresent: 0,
    onFilterChanged: 0
  }),
  ...Ae("ColumnFilter", {
    isColumnFilterPresent: 0,
    getColumnFilterInstance: 0,
    destroyFilter: 0,
    setFilterModel: 0,
    getFilterModel: 0,
    getColumnFilterModel: 0,
    setColumnFilterModel: 0,
    showColumnFilter: 0
  }),
  ...Ae("QuickFilter", {
    isQuickFilterPresent: 0,
    getQuickFilter: 0,
    resetQuickFilter: 0
  }),
  ...Ae("Pagination", {
    paginationIsLastPageFound: 0,
    paginationGetPageSize: 0,
    paginationGetCurrentPage: 0,
    paginationGetTotalPages: 0,
    paginationGetRowCount: 0,
    paginationGoToNextPage: 0,
    paginationGoToPreviousPage: 0,
    paginationGoToFirstPage: 0,
    paginationGoToLastPage: 0,
    paginationGoToPage: 0
  }),
  ...Ae("CsrmSsrmSharedApi", {
    expandAll: 0,
    collapseAll: 0,
    onRowHeightChanged: 0
  }),
  ...Ae("SsrmInfiniteSharedApi", {
    setRowCount: 0,
    getCacheBlockState: 0,
    isLastRowIndexKnown: 0
  }),
  ...Ae("ClientSideRowModelApi", {
    onGroupExpandedOrCollapsed: 0,
    refreshClientSideRowModel: 0,
    isRowDataEmpty: 0,
    forEachLeafNode: 0,
    forEachNodeAfterFilter: 0,
    forEachNodeAfterFilterAndSort: 0,
    resetRowHeights: 0,
    applyTransaction: 0,
    applyTransactionAsync: 0,
    flushAsyncTransactions: 0,
    getBestCostNodeSelection: 0
  }),
  ...Ae("CsvExport", {
    getDataAsCsv: 0,
    exportDataAsCsv: 0
  }),
  ...Ae("InfiniteRowModel", {
    refreshInfiniteCache: 0,
    purgeInfiniteCache: 0,
    getInfiniteRowCount: 0
  }),
  ...Ae("AdvancedFilter", {
    getAdvancedFilterModel: 0,
    setAdvancedFilterModel: 0,
    showAdvancedFilterBuilder: 0,
    hideAdvancedFilterBuilder: 0
  }),
  ...Ae("IntegratedCharts", {
    getChartModels: 0,
    getChartRef: 0,
    getChartImageDataURL: 0,
    downloadChart: 0,
    openChartToolPanel: 0,
    closeChartToolPanel: 0,
    createRangeChart: 0,
    createPivotChart: 0,
    createCrossFilterChart: 0,
    updateChart: 0,
    restoreChart: 0
  }),
  ...Ae("Clipboard", {
    copyToClipboard: 0,
    cutToClipboard: 0,
    copySelectedRowsToClipboard: 0,
    copySelectedRangeToClipboard: 0,
    copySelectedRangeDown: 0,
    pasteFromClipboard: 0
  }),
  ...Ae("ExcelExport", {
    getDataAsExcel: 0,
    exportDataAsExcel: 0,
    getSheetDataForExcel: 0,
    getMultipleSheetsAsExcel: 0,
    exportMultipleSheetsAsExcel: 0
  }),
  ...Ae("SharedMasterDetail", {
    addDetailGridInfo: 0,
    removeDetailGridInfo: 0,
    getDetailGridInfo: 0,
    forEachDetailGridInfo: 0
  }),
  ...Ae("ContextMenu", {
    showContextMenu: 0
  }),
  ...Ae("ColumnMenu", {
    showColumnChooser: 0,
    hideColumnChooser: 0
  }),
  ...Ae("CellSelection", {
    getCellRanges: 0,
    addCellRange: 0,
    clearRangeSelection: 0,
    clearCellSelection: 0
  }),
  ...Ae("SharedRowGrouping", {
    setRowGroupColumns: 0,
    removeRowGroupColumns: 0,
    addRowGroupColumns: 0,
    getRowGroupColumns: 0,
    moveRowGroupColumn: 0
  }),
  ...Ae("SharedAggregation", {
    addAggFuncs: 0,
    clearAggFuncs: 0,
    setColumnAggFunc: 0
  }),
  ...Ae("SharedPivot", {
    isPivotMode: 0,
    getPivotResultColumn: 0,
    setValueColumns: 0,
    getValueColumns: 0,
    removeValueColumns: 0,
    addValueColumns: 0,
    setPivotColumns: 0,
    removePivotColumns: 0,
    addPivotColumns: 0,
    getPivotColumns: 0,
    setPivotResultColumns: 0,
    getPivotResultColumns: 0
  }),
  ...Ae("ServerSideRowModelApi", {
    getServerSideSelectionState: 0,
    setServerSideSelectionState: 0,
    applyServerSideTransaction: 0,
    applyServerSideTransactionAsync: 0,
    applyServerSideRowData: 0,
    retryServerSideLoads: 0,
    flushServerSideAsyncTransactions: 0,
    refreshServerSide: 0,
    getServerSideGroupLevelState: 0
  }),
  ...Ae("SideBar", {
    isSideBarVisible: 0,
    setSideBarVisible: 0,
    setSideBarPosition: 0,
    openToolPanel: 0,
    closeToolPanel: 0,
    getOpenedToolPanel: 0,
    refreshToolPanel: 0,
    isToolPanelShowing: 0,
    getToolPanelInstance: 0,
    getSideBar: 0
  }),
  ...Ae("StatusBar", {
    getStatusPanel: 0
  })
}, wd = {
  isDestroyed: () => !0,
  destroy() {
  },
  preConstruct() {
  },
  postConstruct() {
  },
  preWireBeans() {
  },
  wireBeans() {
  }
}, hA = (e, t) => e.eventSvc.dispatchEvent(t), qw = class {
};
Reflect.defineProperty(qw, "name", { value: "GridApi" });
var pA = class extends L {
  constructor() {
    super(), this.beanName = "apiFunctionSvc", this.api = new qw(), this.fns = {
      ...wd,
      // dispatchEvent is used by frameworks, also used by aligned grids to identify a grid api instance
      dispatchEvent: hA
    }, this.preDestroyLink = "";
    const { api: e } = this;
    for (const t of Object.keys(tf))
      e[t] = this.makeApi(t)[t];
  }
  postConstruct() {
    this.preDestroyLink = this.beans.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed");
  }
  addFunction(e, t) {
    var r;
    const { fns: s, beans: i } = this;
    s !== wd && (s[e] = ((r = i == null ? void 0 : i.validation) == null ? void 0 : r.validateApiFunction(e, t)) ?? t);
  }
  makeApi(e) {
    return {
      [e]: (...t) => {
        const {
          beans: s,
          fns: { [e]: i }
        } = this;
        return i ? i(s, ...t) : this.apiNotFound(e);
      }
    };
  }
  apiNotFound(e) {
    const { beans: t, gos: s, preDestroyLink: i } = this;
    if (!t)
      I(26, { fnName: e, preDestroyLink: i });
    else {
      const r = tf[e];
      s.assertModuleRegistered(r, `api.${e}`) && I(27, { fnName: e, module: r });
    }
  }
  destroy() {
    super.destroy(), this.fns = wd, this.beans = null;
  }
};
function gA(e) {
  return e.context.getGridId();
}
function fA(e) {
  e.gridDestroySvc.destroy();
}
function mA(e) {
  return e.gridDestroySvc.destroyCalled;
}
function CA(e, t) {
  return e.gos.get(t);
}
function vA(e, t, s) {
  Yw(e, { [t]: s });
}
function Yw(e, t) {
  e.gos.updateGridOptions({ options: t });
}
var wA = class extends _ {
  constructor(e, t, s) {
    super(
      /* html */
      '<div class="ag-drag-handle ag-row-drag" draggable="true"></div>'
    ), this.rowNode = e, this.column = t, this.eCell = s;
  }
  postConstruct() {
    this.getGui().appendChild(ue("rowDrag", this.beans, null)), this.addGuiEventListener("mousedown", (t) => {
      t.stopPropagation();
    }), this.addDragSource(), this.checkVisibility();
  }
  addDragSource() {
    this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
  }
  onDragStart(e) {
    const { rowNode: t, column: s, eCell: i, gos: r } = this, n = s.getColDef().dndSourceOnRowDrag, o = e.dataTransfer;
    if (o.setDragImage(i, 0, 0), n) {
      const a = r.addGridCommonParams({
        rowNode: t,
        dragEvent: e
      });
      n(a);
    } else
      try {
        const a = JSON.stringify(t.data);
        o.setData("application/json", a), o.setData("text/plain", a);
      } catch {
      }
  }
  checkVisibility() {
    const e = this.column.isDndSource(this.rowNode);
    this.setDisplayed(e);
  }
};
function yA(e, t) {
  var s, i;
  (i = (s = e.rowDragSvc) == null ? void 0 : s.rowDragFeature) == null || i.addRowDropZone(t);
}
function bA(e, t) {
  var i, r;
  const s = (i = e.dragAndDrop) == null ? void 0 : i.findExternalZone(t);
  s && ((r = e.dragAndDrop) == null || r.removeDropTarget(s));
}
function SA(e, t) {
  var s, i;
  return (i = (s = e.rowDragSvc) == null ? void 0 : s.rowDragFeature) == null ? void 0 : i.getRowDropZone(t);
}
var xA = class extends L {
  constructor() {
    super(...arguments), this.beanName = "horizontalResizeSvc";
  }
  addResizeBar(e) {
    const t = {
      dragStartPixels: e.dragStartPixels || 0,
      eElement: e.eResizeBar,
      onDragStart: this.onDragStart.bind(this, e),
      onDragStop: this.onDragStop.bind(this, e),
      onDragging: this.onDragging.bind(this, e),
      onDragCancel: this.onDragStop.bind(this, e),
      includeTouch: !0,
      stopPropagationForTouch: !0
    }, { dragSvc: s } = this.beans;
    return s.addDragSource(t), () => s.removeDragSource(t);
  }
  onDragStart(e, t) {
    this.dragStartX = t.clientX, this.setResizeIcons();
    const s = t instanceof MouseEvent && t.shiftKey === !0;
    e.onResizeStart(s);
  }
  setResizeIcons() {
    const e = this.beans.ctrlsSvc.get("gridCtrl");
    e.setResizeCursor(!0), e.disableUserSelect(!0);
  }
  onDragStop(e) {
    e.onResizeEnd(this.resizeAmount), this.resetIcons();
  }
  resetIcons() {
    const e = this.beans.ctrlsSvc.get("gridCtrl");
    e.setResizeCursor(!1), e.disableUserSelect(!1);
  }
  onDragging(e, t) {
    this.resizeAmount = t.clientX - this.dragStartX, e.onResizing(this.resizeAmount);
  }
}, RA = class extends _ {
  constructor(e, t, s, i, r, n) {
    super(), this.cellValueFn = e, this.rowNode = t, this.column = s, this.customGui = i, this.dragStartPixels = r, this.suppressVisibilityChange = n, this.dragSource = null;
  }
  isCustomGui() {
    return this.customGui != null;
  }
  postConstruct() {
    const { beans: e, rowNode: t, column: s, gos: i } = this;
    if (this.customGui ? this.setDragElement(this.customGui, this.dragStartPixels) : (this.setTemplate(
      /* html */
      '<div class="ag-drag-handle ag-row-drag" aria-hidden="true"></div>'
    ), this.getGui().appendChild(ue("rowDrag", e, null)), this.addDragSource()), !this.suppressVisibilityChange) {
      const r = i.get("rowDragManaged") ? new PA(this, t, s) : new FA(this, t, s);
      this.createManagedBean(r, this.beans.context);
    }
  }
  setDragElement(e, t) {
    this.setTemplateFromElement(e, void 0, void 0, !0), this.addDragSource(t);
  }
  getSelectedNodes() {
    var i;
    const e = this.rowNode;
    if (!this.gos.get("rowDragMultiRow"))
      return [e];
    const s = ((i = this.beans.selectionSvc) == null ? void 0 : i.getSelectedNodes()) ?? [];
    return s.indexOf(e) !== -1 ? s : [e];
  }
  getDragItem() {
    const { column: e, rowNode: t } = this;
    return {
      rowNode: t,
      rowNodes: this.getSelectedNodes(),
      columns: e ? [e] : void 0,
      defaultTextValue: this.cellValueFn()
    };
  }
  getRowDragText(e) {
    if (e) {
      const t = e.getColDef();
      if (t.rowDragText)
        return t.rowDragText;
    }
    return this.gos.get("rowDragText");
  }
  addDragSource(e = 4) {
    this.dragSource && this.removeDragSource();
    const t = this.getGui();
    this.gos.get("enableCellTextSelection") && (this.removeMouseDownListener(), this.mouseDownListener = this.addManagedElementListeners(t, {
      mousedown: (i) => {
        i == null || i.preventDefault();
      }
    })[0]);
    const s = this.getLocaleTextFunc();
    this.dragSource = {
      type: 2,
      eElement: t,
      dragItemName: () => {
        var o;
        const i = this.getDragItem(), r = ((o = i.rowNodes) == null ? void 0 : o.length) || 1, n = this.getRowDragText(this.column);
        return n ? n(i, r) : r === 1 ? this.cellValueFn() : `${r} ${s("rowDragRows", "rows")}`;
      },
      getDragItem: () => this.getDragItem(),
      dragStartPixels: e,
      dragSourceDomDataKey: this.gos.getDomDataKey()
    }, this.beans.dragAndDrop.addDragSource(this.dragSource, !0);
  }
  destroy() {
    this.removeDragSource(), this.removeMouseDownListener(), super.destroy();
  }
  removeDragSource() {
    this.dragSource && (this.beans.dragAndDrop.removeDragSource(this.dragSource), this.dragSource = null);
  }
  removeMouseDownListener() {
    this.mouseDownListener && (this.mouseDownListener(), this.mouseDownListener = void 0);
  }
}, Xw = class extends L {
  constructor(e, t, s) {
    super(), this.parent = e, this.rowNode = t, this.column = s;
  }
  setDisplayedOrVisible(e) {
    const t = { skipAriaHidden: !0 };
    if (e)
      this.parent.setDisplayed(!1, t);
    else {
      let s = !0, i = !1;
      const { column: r, rowNode: n, parent: o } = this;
      r && (s = r.isRowDrag(n) || o.isCustomGui(), i = typeof r.getColDef().rowDrag == "function"), i ? (o.setDisplayed(!0, t), o.setVisible(s, t)) : (o.setDisplayed(s, t), o.setVisible(!0, t));
    }
  }
}, FA = class extends Xw {
  postConstruct() {
    this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
    const e = this.workOutVisibility.bind(this);
    this.addManagedListeners(this.rowNode, {
      dataChanged: e,
      cellChanged: e
    }), this.addManagedListeners(this.beans.eventSvc, { newColumnsLoaded: e }), this.workOutVisibility();
  }
  onSuppressRowDrag() {
    this.workOutVisibility();
  }
  workOutVisibility() {
    const e = this.gos.get("suppressRowDrag");
    this.setDisplayedOrVisible(e);
  }
}, PA = class extends Xw {
  postConstruct() {
    const e = this.workOutVisibility.bind(this);
    this.addManagedListeners(this.beans.eventSvc, {
      sortChanged: e,
      filterChanged: e,
      columnRowGroupChanged: e,
      newColumnsLoaded: e
    }), this.addManagedListeners(this.rowNode, {
      dataChanged: e,
      cellChanged: e
    }), this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this)), this.workOutVisibility();
  }
  onSuppressRowDrag() {
    this.workOutVisibility();
  }
  workOutVisibility() {
    const { rowDragSvc: e, dragAndDrop: t, gos: s } = this.beans, i = e.rowDragFeature, r = i && i.shouldPreventRowMove(), n = s.get("suppressRowDrag"), o = t.hasExternalDropZones(), a = r && !o || n;
    this.setDisplayedOrVisible(a);
  }
}, TA = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowDragSvc";
  }
  setupRowDrag(e, t) {
    const s = t.createManagedBean(new VE(e)), i = this.beans.dragAndDrop;
    i.addDropTarget(s), t.addDestroyFunc(() => i.removeDropTarget(s)), this.rowDragFeature = s;
  }
  createRowDragComp(e, t, s, i, r, n) {
    return new RA(e, t, s, i, r, n);
  }
  createRowDragCompForRow(e, t) {
    if (is(this.gos))
      return;
    const s = this.getLocaleTextFunc();
    return this.createRowDragComp(
      () => `1 ${s("rowDragRow", "row")}`,
      e,
      void 0,
      t,
      void 0,
      !0
    );
  }
  createRowDragCompForCell(e, t, s, i, r, n) {
    const o = this.gos;
    return o.get("rowDragManaged") && (!Ye(o) || o.get("pagination")) ? void 0 : this.createRowDragComp(
      s,
      e,
      t,
      i,
      r,
      n
    );
  }
}, kh = {
  moduleName: "Drag",
  version: de,
  beans: [NE]
}, EA = {
  moduleName: "DragAndDrop",
  version: de,
  dynamicBeans: {
    dndSourceComp: wA
  },
  icons: {
    // drag handle used to pick up draggable rows
    rowDrag: "grip"
  }
}, ao = {
  moduleName: "SharedDragAndDrop",
  version: de,
  beans: [OE],
  dependsOn: [kh],
  userComponents: {
    agDragAndDropImage: ED
  },
  icons: {
    // shown on drag and drop image component icon while dragging column to the side of the grid to pin
    columnMovePin: "pin",
    // shown on drag and drop image component icon while dragging over part of the page that is not a drop zone
    columnMoveHide: "eye-slash",
    // shown on drag and drop image component icon while dragging columns to reorder
    columnMoveMove: "arrows",
    // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
    columnMoveLeft: "left",
    // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
    columnMoveRight: "right",
    // shown on drag and drop image component icon while dragging over Row Groups drop zone
    columnMoveGroup: "group",
    // shown on drag and drop image component icon while dragging over Values drop zone
    columnMoveValue: "aggregation",
    // shown on drag and drop image component icon while dragging over pivot drop zone
    columnMovePivot: "pivot",
    // shown on drag and drop image component icon while dragging over drop zone that doesn't support it, e.g.
    // string column over aggregation drop zone
    dropNotAllowed: "not-allowed",
    // drag handle used to pick up draggable rows
    rowDrag: "grip"
  }
}, DA = {
  moduleName: "RowDrag",
  version: de,
  beans: [TA],
  apiFunctions: {
    addRowDropZone: yA,
    removeRowDropZone: bA,
    getRowDropZoneParams: SA
  },
  dependsOn: [ao]
}, Zw = {
  moduleName: "HorizontalResize",
  version: de,
  beans: [xA],
  dependsOn: [kh]
}, AA = (
  /*css*/
  ":where(.ag-ltr) :where(.ag-column-moving){.ag-cell,.ag-header-cell{transition:left .2s}.ag-header-group-cell{transition:left .2s,width .2s}}:where(.ag-rtl) :where(.ag-column-moving){.ag-cell,.ag-header-cell{transition:right .2s}.ag-header-group-cell{transition:right .2s,width .2s}}"
), MA = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colAnimation", this.executeNextFuncs = [], this.executeLaterFuncs = [], this.active = !1, this.activeNext = !1, this.suppressAnimation = !1, this.animationThreadCount = 0;
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => this.gridBodyCtrl = e.gridBodyCtrl);
  }
  isActive() {
    return this.active && !this.suppressAnimation;
  }
  setSuppressAnimation(e) {
    this.suppressAnimation = e;
  }
  start() {
    if (this.active)
      return;
    const { gos: e } = this;
    e.get("suppressColumnMoveAnimation") || e.get("enableRtl") || (this.ensureAnimationCssClassPresent(), this.active = !0, this.activeNext = !0);
  }
  finish() {
    this.active && this.flush(
      () => this.activeNext = !1,
      () => this.active = !1
    );
  }
  executeNextVMTurn(e) {
    this.activeNext ? this.executeNextFuncs.push(e) : e();
  }
  executeLaterVMTurn(e) {
    this.active ? this.executeLaterFuncs.push(e) : e();
  }
  ensureAnimationCssClassPresent() {
    this.animationThreadCount++;
    const e = this.animationThreadCount, { gridBodyCtrl: t } = this;
    t.setColumnMovingCss(!0), this.executeLaterFuncs.push(() => {
      this.animationThreadCount === e && t.setColumnMovingCss(!1);
    });
  }
  flush(e, t) {
    const { executeNextFuncs: s, executeLaterFuncs: i } = this;
    if (s.length === 0 && i.length === 0) {
      e(), t();
      return;
    }
    const r = (n) => {
      for (; n.length; ) {
        const o = n.pop();
        o && o();
      }
    };
    this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e(), r(s);
      }, 0), window.setTimeout(() => {
        t(), r(i);
      }, 200);
    });
  }
};
function IA(e, t, s) {
  var i;
  (i = e.colMoves) == null || i.moveColumnByIndex(t, s, "api");
}
function LA(e, t, s) {
  var i;
  (i = e.colMoves) == null || i.moveColumns(t, s, "api");
}
var kA = class extends L {
  constructor(e) {
    super(), this.pinned = e, this.columnsToAggregate = [], this.columnsToGroup = [], this.columnsToPivot = [];
  }
  /** Callback for when drag enters */
  onDragEnter(e) {
    if (this.clearColumnsList(), this.gos.get("functionsReadOnly"))
      return;
    const t = e.dragItem.columns;
    t && t.forEach((s) => {
      s.isPrimary() && (s.isAnyFunctionActive() || (s.isAllowValue() ? this.columnsToAggregate.push(s) : s.isAllowRowGroup() ? this.columnsToGroup.push(s) : s.isAllowPivot() && this.columnsToPivot.push(s)));
    });
  }
  getIconName() {
    return this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length > 0 ? this.pinned ? "pinned" : "move" : null;
  }
  /** Callback for when drag leaves */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragLeave(e) {
    this.clearColumnsList();
  }
  clearColumnsList() {
    this.columnsToAggregate.length = 0, this.columnsToGroup.length = 0, this.columnsToPivot.length = 0;
  }
  /** Callback for when dragging */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragging(e) {
  }
  /** Callback for when drag stops */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDragStop(e) {
    const { valueColsSvc: t, rowGroupColsSvc: s, pivotColsSvc: i } = this.beans;
    this.columnsToAggregate.length > 0 && (t == null || t.addColumns(this.columnsToAggregate, "toolPanelDragAndDrop")), this.columnsToGroup.length > 0 && (s == null || s.addColumns(this.columnsToGroup, "toolPanelDragAndDrop")), this.columnsToPivot.length > 0 && (i == null || i.addColumns(this.columnsToPivot, "toolPanelDragAndDrop"));
  }
  onDragCancel() {
    this.clearColumnsList();
  }
};
function OA(e, t) {
  !t || t.length <= 1 || t.filter((i) => e.indexOf(i) < 0).length > 0 || t.sort((i, r) => {
    const n = e.indexOf(i), o = e.indexOf(r);
    return n - o;
  });
}
function Qw(e) {
  const { isFromHeader: t, fromLeft: s, xPosition: i, fromEnter: r, fakeEvent: n, pinned: o, gos: a, colModel: l, colMoves: c, visibleCols: d } = e;
  let { allMovingColumns: u } = e;
  if (t) {
    const x = [];
    u.forEach((M) => {
      var k;
      let T = null, F = M.getParent();
      for (; F != null && F.getDisplayedLeafColumns().length === 1; )
        T = F, F = F.getParent();
      T != null ? (!!((k = T.getColGroupDef()) != null && k.marryChildren) ? (
        // when marry children is true, we also have to move hidden
        // columns within the group, so grab them from the `providedColumnGroup`
        T.getProvidedColumnGroup().getLeafColumns()
      ) : T.getLeafColumns()).forEach(($) => {
        x.includes($) || x.push($);
      }) : x.includes(M) || x.push(M);
    }), u = x;
  }
  const h = u.slice();
  OA(l.getCols(), h);
  const p = NA({
    movingCols: h,
    draggingRight: s,
    xPosition: i,
    pinned: o,
    gos: a,
    colModel: l,
    visibleCols: d
  }), g = GA(h, l);
  if (p.length === 0)
    return;
  const f = p[0];
  let m = g !== null && !r;
  if (t && (m = g !== null), m && !n && (!s && f >= g || s && f <= g))
    return;
  const C = d.allCols, w = [];
  let y = null;
  for (let x = 0; x < p.length; x++) {
    const M = p[x], T = c.getProposedColumnOrder(h, M);
    if (!c.doesOrderPassRules(T))
      continue;
    const F = T.filter((O) => C.includes(O));
    if (y === null)
      y = F;
    else if (!Ht(F, y))
      break;
    const k = BA(T);
    w.push({ move: M, fragCount: k });
  }
  if (w.length === 0)
    return;
  w.sort((x, M) => x.fragCount - M.fragCount);
  const b = w[0].move;
  if (!(b > l.getCols().length - u.length))
    return { columns: u, toIndex: b };
}
function Jw(e) {
  const { columns: t, toIndex: s } = Qw(e) || {}, { finished: i, colMoves: r } = e;
  return !t || s == null ? null : (r.moveColumns(t, s, "uiColumnMoved", i), i ? null : { columns: t, toIndex: s });
}
function GA(e, t) {
  const s = t.getCols(), i = oT(e.map((l) => s.indexOf(l))), r = i[0];
  return pe(i) - r !== i.length - 1 ? null : r;
}
function BA(e) {
  function t(i) {
    const r = [];
    let n = i.getOriginalParent();
    for (; n != null; )
      r.push(n), n = n.getOriginalParent();
    return r;
  }
  let s = 0;
  for (let i = 0; i < e.length - 1; i++) {
    let r = t(e[i]), n = t(e[i + 1]);
    [r, n] = r.length > n.length ? [r, n] : [n, r], r.forEach((o) => {
      n.indexOf(o) === -1 && s++;
    });
  }
  return s;
}
function VA(e, t) {
  switch (t) {
    case "left":
      return e.leftCols;
    case "right":
      return e.rightCols;
    default:
      return e.centerCols;
  }
}
function NA(e) {
  const { movingCols: t, draggingRight: s, xPosition: i, pinned: r, gos: n, colModel: o, visibleCols: a } = e;
  if (n.get("suppressMovableColumns") || t.some((y) => y.getColDef().suppressMovable))
    return [];
  const c = VA(a, r), d = o.getCols(), u = c.filter((y) => t.includes(y)), h = c.filter((y) => !t.includes(y)), p = d.filter((y) => !t.includes(y));
  let g = 0, f = i;
  if (s) {
    let y = 0;
    u.forEach((b) => y += b.getActualWidth()), f -= y;
  }
  if (f > 0) {
    for (let y = 0; y < h.length; y++) {
      const b = h[y];
      if (f -= b.getActualWidth(), f < 0)
        break;
      g++;
    }
    s && g++;
  }
  let m;
  if (g > 0) {
    const y = h[g - 1];
    m = p.indexOf(y) + 1;
  } else
    m = p.indexOf(h[0]), m === -1 && (m = 0);
  const C = [m], w = (y, b) => y - b;
  if (s) {
    let y = m + 1;
    const b = d.length - 1;
    for (; y <= b; )
      C.push(y), y++;
    C.sort(w);
  } else {
    let y = m;
    const b = d.length - 1;
    let x = d[y];
    for (; y <= b && c.indexOf(x) < 0; )
      y++, C.push(y), x = d[y];
    y = m - 1;
    const M = 0;
    for (; y >= M; )
      C.push(y), y--;
    C.sort(w).reverse();
  }
  return C;
}
function uu(e) {
  var c;
  const { pinned: t, fromKeyboard: s, gos: i, ctrlsSvc: r, useHeaderRow: n, skipScrollPadding: o } = e;
  let a = (c = r.getHeaderRowContainerCtrl(t)) == null ? void 0 : c.eViewport, { x: l } = e;
  return a ? (s && (l -= a.getBoundingClientRect().left), i.get("enableRtl") && (n && (a = a.querySelector(".ag-header-row")), l = a.clientWidth - l), t == null && !o && (l += r.get("center").getCenterViewportScrollLeft()), l) : 0;
}
function yd(e, t) {
  for (const s of e)
    s.moving = t, s.dispatchColEvent("movingChanged", "uiColumnMoved");
}
var sf = 7, hu = 100, qa = hu / 2, HA = 5, zA = 100, WA = class extends L {
  constructor(e) {
    super(), this.pinned = e, this.needToMoveLeft = !1, this.needToMoveRight = !1, this.lastMovedInfo = null, this.isCenterContainer = !W(e);
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  getIconName() {
    const { pinned: e, lastDraggingEvent: t } = this, s = (t == null ? void 0 : t.dragItem.columns) ?? [];
    for (const i of s) {
      const r = i.getPinned();
      if (i.getColDef().lockPinned) {
        if (r == e)
          return "move";
        continue;
      }
      if (r === e || !e)
        return "move";
      if (!r && e)
        return "pinned";
    }
    return "notAllowed";
  }
  onDragEnter(e) {
    const t = e.dragItem, s = t.columns;
    if (e.dragSource.type === 0)
      this.setColumnsVisible(s, !0, "uiColumnDragged");
    else {
      const r = t.visibleState, n = (s || []).filter((o) => r[o.getId()]);
      this.setColumnsVisible(n, !0, "uiColumnDragged");
    }
    this.gos.get("suppressMoveWhenColumnDragging") || this.attemptToPinColumns(s, this.pinned), this.onDragging(e, !0, !0);
  }
  onDragging(e = this.lastDraggingEvent, t = !1, s = !1, i = !1) {
    const { gos: r, ctrlsSvc: n } = this.beans, o = r.get("suppressMoveWhenColumnDragging");
    if (i && !o) {
      this.finishColumnMoving();
      return;
    }
    if (this.lastDraggingEvent = e, !e || !i && ke(e.hDirection))
      return;
    const a = uu({
      x: e.x,
      pinned: this.pinned,
      gos: r,
      ctrlsSvc: n
    });
    t || this.checkCenterForScrolling(a), o ? this.handleColumnDragWhileSuppressingMovement(e, t, s, a, i) : this.handleColumnDragWhileAllowingMovement(e, t, s, a, i);
  }
  onDragLeave() {
    this.ensureIntervalCleared(), this.clearHighlighted(), this.lastMovedInfo = null;
  }
  onDragStop() {
    this.onDragging(this.lastDraggingEvent, !1, !0, !0), this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  onDragCancel() {
    this.clearHighlighted(), this.ensureIntervalCleared(), this.lastMovedInfo = null;
  }
  setColumnsVisible(e, t, s) {
    if (!e)
      return;
    const i = e.filter((r) => !r.getColDef().lockVisible);
    this.beans.colModel.setColsVisible(i, t, s);
  }
  finishColumnMoving() {
    this.clearHighlighted();
    const e = this.lastMovedInfo;
    if (!e)
      return;
    const { columns: t, toIndex: s } = e;
    this.beans.colMoves.moveColumns(t, s, "uiColumnMoved", !0);
  }
  handleColumnDragWhileSuppressingMovement(e, t, s, i, r) {
    const n = this.getAllMovingColumns(e, !0);
    if (r) {
      const o = this.isAttemptingToPin(n);
      o && this.attemptToPinColumns(n, void 0, !0);
      const { fromLeft: a, xPosition: l } = this.getNormalisedXPositionInfo(n, o) || {};
      if (a == null || l == null) {
        this.finishColumnMoving();
        return;
      }
      this.moveColumnsAfterHighlight({
        allMovingColumns: n,
        xPosition: l,
        fromEnter: t,
        fakeEvent: s,
        fromLeft: a
      });
    } else {
      if (!this.beans.dragAndDrop.isDropZoneWithinThisGrid(e))
        return;
      this.highlightHoveredColumn(n, i);
    }
  }
  handleColumnDragWhileAllowingMovement(e, t, s, i, r) {
    const n = this.getAllMovingColumns(e), o = this.normaliseDirection(e.hDirection) === "right", a = e.dragSource.type === 1, l = this.getMoveColumnParams({
      allMovingColumns: n,
      isFromHeader: a,
      xPosition: i,
      fromLeft: o,
      fromEnter: t,
      fakeEvent: s
    }), c = Jw({ ...l, finished: r });
    c && (this.lastMovedInfo = c);
  }
  getAllMovingColumns(e, t = !1) {
    const s = e.dragSource.getDragItem();
    let i = null;
    t ? (i = s.columnsInSplit, i || (i = s.columns)) : i = s.columns;
    const r = (n) => n.getColDef().lockPinned ? n.getPinned() == this.pinned : !0;
    return i ? i.filter(r) : [];
  }
  getMoveColumnParams(e) {
    const { allMovingColumns: t, isFromHeader: s, xPosition: i, fromLeft: r, fromEnter: n, fakeEvent: o } = e, { gos: a, colModel: l, colMoves: c, visibleCols: d } = this.beans;
    return {
      allMovingColumns: t,
      isFromHeader: s,
      fromLeft: r,
      xPosition: i,
      pinned: this.pinned,
      fromEnter: n,
      fakeEvent: o,
      gos: a,
      colModel: l,
      colMoves: c,
      visibleCols: d
    };
  }
  highlightHoveredColumn(e, t) {
    var d;
    const { gos: s, colModel: i } = this.beans, r = s.get("enableRtl"), n = i.getCols().filter((u) => u.isVisible() && u.getPinned() === this.pinned);
    let o = null, a = null, l = null;
    for (const u of n) {
      if (a = u.getActualWidth(), o = this.getNormalisedColumnLeft(u, 0, r), o != null) {
        const h = o + a;
        if (o <= t && h >= t) {
          l = u;
          break;
        }
      }
      o = null, a = null;
    }
    if (l)
      e.indexOf(l) !== -1 && (l = null);
    else {
      for (let u = n.length - 1; u >= 0; u--) {
        const h = n[u], p = n[u].getParent();
        if (!p) {
          l = h;
          break;
        }
        const g = p == null ? void 0 : p.getDisplayedLeafColumns();
        if (g.length) {
          l = pe(g);
          break;
        }
      }
      if (!l)
        return;
      o = this.getNormalisedColumnLeft(l, 0, r), a = l.getActualWidth();
    }
    if (((d = this.lastHighlightedColumn) == null ? void 0 : d.column) !== l && this.clearHighlighted(), l == null || o == null || a == null)
      return;
    let c;
    t - o < a / 2 !== r ? c = 0 : c = 1, rf(l, c), this.lastHighlightedColumn = { column: l, position: c };
  }
  getNormalisedXPositionInfo(e, t) {
    const { gos: s, visibleCols: i } = this.beans, r = s.get("enableRtl"), { firstMovingCol: n, column: o, position: a } = this.getColumnMoveAndTargetInfo(
      e,
      t,
      r
    );
    if (!n || !o || a == null)
      return;
    const l = i.allCols, c = l.indexOf(n), d = l.indexOf(o), u = a === 0 !== r, h = c < d || c === d && !u;
    let p = 0;
    if (u ? h && (p -= 1) : h || (p += 1), d + p === c)
      return;
    const g = l[d + p];
    if (!g)
      return;
    const f = this.getNormalisedColumnLeft(g, 20, r);
    return { fromLeft: h, xPosition: f };
  }
  getColumnMoveAndTargetInfo(e, t, s) {
    const i = this.lastHighlightedColumn || {}, { firstMovingCol: r, lastMovingCol: n } = _A(e);
    if (!r || !n || i.column || !t)
      return {
        firstMovingCol: r,
        ...i
      };
    const a = this.getPinDirection() === "left";
    return {
      firstMovingCol: r,
      position: a ? 1 : 0,
      column: a !== s ? r : n
    };
  }
  normaliseDirection(e) {
    if (this.gos.get("enableRtl"))
      switch (e) {
        case "left":
          return "right";
        case "right":
          return "left";
      }
    return e;
  }
  getNormalisedColumnLeft(e, t, s) {
    const { gos: i, ctrlsSvc: r } = this.beans, n = e.getLeft();
    if (n == null)
      return null;
    const o = e.getActualWidth();
    return uu({
      x: s ? n + o - t : n + t,
      pinned: e.getPinned(),
      useHeaderRow: s,
      skipScrollPadding: !0,
      gos: i,
      ctrlsSvc: r
    });
  }
  isAttemptingToPin(e) {
    const t = this.needToMoveLeft || this.needToMoveRight, s = this.failedMoveAttempts > sf;
    return t && s || e.some((i) => i.getPinned() !== this.pinned);
  }
  moveColumnsAfterHighlight(e) {
    const { allMovingColumns: t, xPosition: s, fromEnter: i, fakeEvent: r, fromLeft: n } = e, o = this.getMoveColumnParams({
      allMovingColumns: t,
      isFromHeader: !0,
      xPosition: s,
      fromLeft: n,
      fromEnter: i,
      fakeEvent: r
    }), { columns: a, toIndex: l } = Qw(o) || {};
    a && l != null && (this.lastMovedInfo = {
      columns: a,
      toIndex: l
    }), this.finishColumnMoving();
  }
  clearHighlighted() {
    const { lastHighlightedColumn: e } = this;
    e && (rf(e.column, null), this.lastHighlightedColumn = null);
  }
  checkCenterForScrolling(e) {
    if (!this.isCenterContainer)
      return;
    const t = this.beans.ctrlsSvc.get("center"), s = t.getCenterViewportScrollLeft(), i = s + t.getCenterWidth();
    let r, n;
    this.gos.get("enableRtl") ? (r = e < s + qa, n = e > i - qa) : (n = e < s + qa, r = e > i - qa), this.needToMoveRight = r, this.needToMoveLeft = n, n || r ? this.ensureIntervalStarted() : this.ensureIntervalCleared();
  }
  ensureIntervalStarted() {
    var e;
    this.movingIntervalId || (this.intervalCount = 0, this.failedMoveAttempts = 0, this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), zA), (e = this.beans.dragAndDrop.getDragAndDropImageComponent()) == null || e.setIcon(this.needToMoveLeft ? "left" : "right", !0));
  }
  ensureIntervalCleared() {
    var e;
    this.movingIntervalId && (window.clearInterval(this.movingIntervalId), this.movingIntervalId = null, this.failedMoveAttempts = 0, (e = this.beans.dragAndDrop.getDragAndDropImageComponent()) == null || e.setIcon(this.getIconName(), !1));
  }
  moveInterval() {
    var i, r;
    let e;
    this.intervalCount++, e = 10 + this.intervalCount * HA, e > hu && (e = hu);
    let t = null;
    const s = this.gridBodyCon.scrollFeature;
    if (this.needToMoveLeft ? t = s.scrollHorizontally(-e) : this.needToMoveRight && (t = s.scrollHorizontally(e)), t !== 0)
      this.onDragging(this.lastDraggingEvent), this.failedMoveAttempts = 0;
    else {
      this.failedMoveAttempts++;
      const { pinnedCols: n, dragAndDrop: o, gos: a } = this.beans;
      if (this.failedMoveAttempts <= sf + 1 || !n)
        return;
      if ((i = o.getDragAndDropImageComponent()) == null || i.setIcon("pinned", !1), !a.get("suppressMoveWhenColumnDragging")) {
        const l = (r = this.lastDraggingEvent) == null ? void 0 : r.dragItem.columns;
        this.attemptToPinColumns(l, void 0, !0);
      }
    }
  }
  getPinDirection() {
    if (this.needToMoveLeft || this.pinned === "left")
      return "left";
    if (this.needToMoveRight || this.pinned === "right")
      return "right";
  }
  attemptToPinColumns(e, t, s = !1) {
    const i = (e || []).filter((o) => !o.getColDef().lockPinned);
    if (!i.length)
      return 0;
    s && (t = this.getPinDirection());
    const { pinnedCols: r, dragAndDrop: n } = this.beans;
    return r == null || r.setColsPinned(i, t, "uiColumnDragged"), s && n.nudge(), i.length;
  }
  destroy() {
    super.destroy(), this.lastDraggingEvent = null, this.clearHighlighted(), this.lastMovedInfo = null;
  }
};
function rf(e, t) {
  e.highlighted !== t && (e.highlighted = t, e.dispatchColEvent("headerHighlightChanged", "uiColumnMoved"));
}
function _A(e) {
  const t = e.length;
  let s, i;
  for (let r = 0; r <= t; r++) {
    if (!s) {
      const n = e[r];
      n.getLeft() != null && (s = n);
    }
    if (!i) {
      const n = e[t - 1 - r];
      n.getLeft() != null && (i = n);
    }
    if (s && i)
      break;
  }
  return { firstMovingCol: s, lastMovingCol: i };
}
var UA = class extends L {
  constructor(e, t) {
    super(), this.pinned = e, this.eContainer = t;
  }
  postConstruct() {
    const { ctrlsSvc: e, dragAndDrop: t } = this.beans, s = this.pinned;
    e.whenReady(this, (i) => {
      let r;
      const n = i.gridBodyCtrl.eBodyViewport;
      switch (s) {
        case "left":
          r = [
            [n, i.left.eContainer],
            [i.bottomLeft.eContainer],
            [i.topLeft.eContainer]
          ];
          break;
        case "right":
          r = [
            [n, i.right.eContainer],
            [i.bottomRight.eContainer],
            [i.topRight.eContainer]
          ];
          break;
        default:
          r = [
            [n, i.center.eViewport],
            [i.bottomCenter.eViewport],
            [i.topCenter.eViewport]
          ];
          break;
      }
      this.eSecondaryContainers = r;
    }), this.moveColumnFeature = this.createManagedBean(new WA(s)), this.bodyDropPivotTarget = this.createManagedBean(new kA(s)), t.addDropTarget(this), this.addDestroyFunc(() => t.removeDropTarget(this));
  }
  isInterestedIn(e) {
    return e === 1 || e === 0 && this.gos.get("allowDragFromColumnsToolPanel");
  }
  getSecondaryContainers() {
    return this.eSecondaryContainers;
  }
  getContainer() {
    return this.eContainer;
  }
  getIconName() {
    return this.currentDropListener.getIconName();
  }
  // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
  // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
  // dropped into the grid's body.
  isDropColumnInPivotMode(e) {
    return this.beans.colModel.isPivotMode() && e.dragSource.type === 0;
  }
  onDragEnter(e) {
    this.currentDropListener = this.isDropColumnInPivotMode(e) ? this.bodyDropPivotTarget : this.moveColumnFeature, this.currentDropListener.onDragEnter(e);
  }
  onDragLeave(e) {
    this.currentDropListener.onDragLeave(e);
  }
  onDragging(e) {
    this.currentDropListener.onDragging(e);
  }
  onDragStop(e) {
    this.currentDropListener.onDragStop(e);
  }
  onDragCancel() {
    this.currentDropListener.onDragCancel();
  }
}, $A = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colMoves";
  }
  moveColumnByIndex(e, t, s) {
    const i = this.beans.colModel.getCols();
    if (!i)
      return;
    const r = i[e];
    this.moveColumns([r], t, s);
  }
  moveColumns(e, t, s, i = !0) {
    const { colModel: r, colAnimation: n, visibleCols: o, eventSvc: a } = this.beans, l = r.getCols();
    if (!l)
      return;
    if (t > l.length - e.length) {
      I(30, { toIndex: t });
      return;
    }
    n == null || n.start();
    const c = r.getColsForKeys(e);
    this.doesMovePassRules(c, t) && ($g(r.getCols(), c, t), o.refresh(s), a.dispatchEvent({
      type: "columnMoved",
      columns: c,
      column: c.length === 1 ? c[0] : null,
      toIndex: t,
      finished: i,
      source: s
    })), n == null || n.finish();
  }
  doesMovePassRules(e, t) {
    const s = this.getProposedColumnOrder(e, t);
    return this.doesOrderPassRules(s);
  }
  doesOrderPassRules(e) {
    const { colModel: t, gos: s } = this.beans;
    return !(!Lv(e, t.getColTree()) || !((r) => {
      const n = (c) => c ? c === "left" || c === !0 ? -1 : 1 : 0, o = s.get("enableRtl");
      let a = o ? 1 : -1, l = !0;
      return r.forEach((c) => {
        const d = n(c.getColDef().lockPosition);
        o ? d > a && (l = !1) : d < a && (l = !1), a = d;
      }), l;
    })(e));
  }
  getProposedColumnOrder(e, t) {
    const i = this.beans.colModel.getCols().slice();
    return $g(i, e, t), i;
  }
  createBodyDropTarget(e, t) {
    return new UA(e, t);
  }
  moveHeader(e, t, s, i, r) {
    const { ctrlsSvc: n, gos: o, colModel: a, visibleCols: l, focusSvc: c } = this.beans, d = t.getBoundingClientRect(), u = d.left, h = pt(s), p = h ? d.width : s.getActualWidth(), g = e === "left" !== o.get("enableRtl"), f = uu({
      x: g ? u - 20 : u + p + 20,
      pinned: i,
      fromKeyboard: !0,
      gos: o,
      ctrlsSvc: n
    }), m = c.focusedHeader;
    Jw({
      allMovingColumns: h ? s.getLeafColumns() : [s],
      isFromHeader: !0,
      fromLeft: e === "right",
      xPosition: f,
      pinned: i,
      fromEnter: !1,
      fakeEvent: !1,
      gos: o,
      colModel: a,
      colMoves: this,
      visibleCols: l,
      finished: !0
    });
    let C;
    if (h) {
      const w = s.getDisplayedLeafColumns();
      C = g ? w[0] : pe(w);
    } else
      C = s;
    if (n.getScrollFeature().ensureColumnVisible(C, "auto"), (!r.isAlive() || o.get("ensureDomOrder")) && m) {
      let w;
      if (h) {
        const y = s.getGroupId(), b = s.getLeafColumns();
        if (!b.length)
          return;
        const x = b[0].getParent();
        if (!x)
          return;
        w = jA(x, y);
      } else
        w = s;
      w && c.focusHeaderPosition({
        headerPosition: {
          ...m,
          column: w
        }
      });
    }
  }
  setDragSourceForHeader(e, t, s) {
    const { gos: i, colModel: r, dragAndDrop: n, visibleCols: o } = this.beans;
    let a = !i.get("suppressDragLeaveHidesColumns");
    const l = pt(t), c = l ? t.getProvidedColumnGroup().getLeafColumns() : [t], u = {
      type: 1,
      eElement: e,
      getDefaultIconName: () => a ? "hide" : "notAllowed",
      getDragItem: l ? () => qA(t, o.allCols) : () => KA(t),
      dragItemName: s,
      onDragStarted: () => {
        a = !i.get("suppressDragLeaveHidesColumns"), yd(c, !0);
      },
      onDragStopped: () => yd(c, !1),
      onDragCancelled: () => yd(c, !1),
      onGridEnter: (h) => {
        if (a) {
          const { columns: p = [], visibleState: g } = h ?? {}, f = l ? (C) => !g || g[C.getColId()] : () => !0, m = p.filter(
            (C) => !C.getColDef().lockVisible && f(C)
          );
          r.setColsVisible(m, !0, "uiColumnMoved");
        }
      },
      onGridExit: (h) => {
        var p;
        if (a) {
          const g = ((p = h == null ? void 0 : h.columns) == null ? void 0 : p.filter((f) => !f.getColDef().lockVisible)) || [];
          r.setColsVisible(g, !1, "uiColumnMoved");
        }
      }
    };
    return n.addDragSource(u, !0), u;
  }
};
function jA(e, t) {
  for (; e; ) {
    if (e.getGroupId() === t)
      return e;
    e = e.getParent();
  }
}
function KA(e) {
  const t = {};
  return t[e.getId()] = e.isVisible(), {
    columns: [e],
    visibleState: t
  };
}
function qA(e, t) {
  const s = e.getProvidedColumnGroup().getLeafColumns(), i = {};
  s.forEach((a) => i[a.getId()] = a.isVisible());
  const r = [];
  t.forEach((a) => {
    s.indexOf(a) >= 0 && (r.push(a), kt(s, a));
  }), s.forEach((a) => r.push(a));
  const n = [], o = e.getLeafColumns();
  for (const a of r)
    o.indexOf(a) !== -1 && n.push(a);
  return {
    columns: r,
    columnsInSplit: n,
    visibleState: i
  };
}
var Oh = {
  moduleName: "ColumnMove",
  version: de,
  beans: [$A, MA],
  apiFunctions: {
    moveColumnByIndex: IA,
    moveColumns: LA
  },
  dependsOn: [ao],
  css: [AA]
}, YA = class extends L {
  constructor() {
    super(...arguments), this.beanName = "autoWidthCalc";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.centerRowContainerCtrl = e.center;
    });
  }
  // this is the trick: we create a dummy container and clone all the cells
  // into the dummy, then check the dummy's width. then destroy the dummy
  // as we don't need it any more.
  // drawback: only the cells visible on the screen are considered
  getPreferredWidthForColumn(e, t) {
    const s = this.getHeaderCellForColumn(e);
    if (!s)
      return -1;
    const i = this.beans.rowRenderer.getAllCellsNotSpanningForColumn(e);
    return t || i.push(s), this.addElementsToContainerAndGetWidth(i);
  }
  getPreferredWidthForColumnGroup(e) {
    const t = this.getHeaderCellForColumn(e);
    return t ? this.addElementsToContainerAndGetWidth([t]) : -1;
  }
  addElementsToContainerAndGetWidth(e) {
    const t = document.createElement("form");
    t.style.position = "fixed";
    const s = this.centerRowContainerCtrl.eContainer;
    e.forEach((n) => this.cloneItemIntoDummy(n, t)), s.appendChild(t);
    const i = t.offsetWidth;
    s.removeChild(t);
    const r = this.gos.get("autoSizePadding");
    return i + r;
  }
  getHeaderCellForColumn(e) {
    let t = null;
    return this.beans.ctrlsSvc.getHeaderRowContainerCtrls().forEach((s) => {
      const i = s.getHtmlElementForColumnHeader(e);
      i != null && (t = i);
    }), t;
  }
  cloneItemIntoDummy(e, t) {
    const s = e.cloneNode(!0);
    s.style.width = "", s.style.position = "static", s.style.left = "";
    const i = document.createElement("div"), r = i.classList;
    ["ag-header-cell", "ag-header-group-cell"].some((a) => s.classList.contains(a)) ? (r.add("ag-header", "ag-header-row"), i.style.position = "static") : r.add("ag-row");
    let o = e.parentElement;
    for (; o; ) {
      if (["ag-header-row", "ag-row"].some((l) => o.classList.contains(l))) {
        for (let l = 0; l < o.classList.length; l++) {
          const c = o.classList[l];
          c != "ag-row-position-absolute" && r.add(c);
        }
        break;
      }
      o = o.parentElement;
    }
    i.appendChild(s), t.appendChild(i);
  }
}, ey = {
  moduleName: "AutoWidth",
  version: de,
  beans: [YA]
};
function XA(e, t, s = !0, i = "api") {
  var r;
  (r = e.colResize) == null || r.setColumnWidths(t, !1, s, i);
}
var ZA = class extends L {
  constructor(e, t, s, i) {
    super(), this.comp = e, this.eResize = t, this.pinned = s, this.columnGroup = i;
  }
  postConstruct() {
    if (!this.columnGroup.isResizable()) {
      this.comp.setResizableDisplayed(!1);
      return;
    }
    const { horizontalResizeSvc: e, gos: t, colAutosize: s } = this.beans, i = e.addResizeBar({
      eResizeBar: this.eResize,
      onResizeStart: this.onResizeStart.bind(this),
      onResizing: this.onResizing.bind(this, !1),
      onResizeEnd: this.onResizing.bind(this, !0)
    });
    this.addDestroyFunc(i), !t.get("suppressAutoSize") && s && this.addDestroyFunc(
      s.addColumnGroupResize(
        this.eResize,
        this.columnGroup,
        () => this.resizeLeafColumnsToFit("uiColumnResized")
      )
    );
  }
  onResizeStart(e) {
    const {
      columnsToResize: t,
      resizeStartWidth: s,
      resizeRatios: i,
      groupAfterColumns: r,
      groupAfterStartWidth: n,
      groupAfterRatios: o
    } = this.getInitialValues(e);
    this.resizeCols = t, this.resizeStartWidth = s, this.resizeRatios = i, this.resizeTakeFromCols = r, this.resizeTakeFromStartWidth = n, this.resizeTakeFromRatios = o, this.toggleColumnResizing(!0);
  }
  onResizing(e, t, s = "uiColumnResized") {
    const i = this.normaliseDragChange(t), r = this.resizeStartWidth + i;
    this.resizeColumnsFromLocalValues(r, s, e);
  }
  getInitialValues(e) {
    var l;
    const t = (c) => c.reduce((d, u) => d + u.getActualWidth(), 0), s = (c, d) => c.map((u) => u.getActualWidth() / d), i = this.getColumnsToResize(), r = t(i), n = s(i, r), o = {
      columnsToResize: i,
      resizeStartWidth: r,
      resizeRatios: n
    };
    let a = null;
    if (e && (a = ((l = this.beans.colGroupSvc) == null ? void 0 : l.getGroupAtDirection(this.columnGroup, "After")) ?? null), a) {
      const c = a.getDisplayedLeafColumns(), d = o.groupAfterColumns = c.filter(
        (h) => h.isResizable()
      ), u = o.groupAfterStartWidth = t(d);
      o.groupAfterRatios = s(d, u);
    } else
      o.groupAfterColumns = void 0, o.groupAfterStartWidth = void 0, o.groupAfterRatios = void 0;
    return o;
  }
  resizeLeafColumnsToFit(e) {
    const t = this.beans.autoWidthCalc.getPreferredWidthForColumnGroup(this.columnGroup), s = this.getInitialValues();
    t > s.resizeStartWidth && this.resizeColumns(s, t, e, !0);
  }
  resizeColumnsFromLocalValues(e, t, s = !0) {
    if (!this.resizeCols || !this.resizeRatios)
      return;
    const i = {
      columnsToResize: this.resizeCols,
      resizeStartWidth: this.resizeStartWidth,
      resizeRatios: this.resizeRatios,
      groupAfterColumns: this.resizeTakeFromCols,
      groupAfterStartWidth: this.resizeTakeFromStartWidth,
      groupAfterRatios: this.resizeTakeFromRatios
    };
    this.resizeColumns(i, e, t, s);
  }
  resizeColumns(e, t, s, i = !0) {
    var u;
    const {
      columnsToResize: r,
      resizeStartWidth: n,
      resizeRatios: o,
      groupAfterColumns: a,
      groupAfterStartWidth: l,
      groupAfterRatios: c
    } = e, d = [];
    if (d.push({
      columns: r,
      ratios: o,
      width: t
    }), a) {
      const h = t - n;
      d.push({
        columns: a,
        ratios: c,
        width: l - h
      });
    }
    (u = this.beans.colResize) == null || u.resizeColumnSets({
      resizeSets: d,
      finished: i,
      source: s
    }), i && this.toggleColumnResizing(!1);
  }
  toggleColumnResizing(e) {
    this.comp.addOrRemoveCssClass("ag-column-resizing", e);
  }
  getColumnsToResize() {
    return this.columnGroup.getDisplayedLeafColumns().filter((t) => t.isResizable());
  }
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderCell - should refactor out?
  normaliseDragChange(e) {
    let t = e;
    return this.gos.get("enableRtl") ? this.pinned !== "left" && (t *= -1) : this.pinned === "right" && (t *= -1), t;
  }
  destroy() {
    super.destroy(), this.resizeCols = void 0, this.resizeRatios = void 0, this.resizeTakeFromCols = void 0, this.resizeTakeFromRatios = void 0;
  }
}, QA = class extends L {
  constructor(e, t, s, i, r) {
    super(), this.pinned = e, this.column = t, this.eResize = s, this.comp = i, this.ctrl = r;
  }
  postConstruct() {
    const e = [];
    let t, s;
    const i = () => {
      if (re(this.eResize, t), !t)
        return;
      const { horizontalResizeSvc: o, colAutosize: a } = this.beans, l = o.addResizeBar({
        eResizeBar: this.eResize,
        onResizeStart: this.onResizeStart.bind(this),
        onResizing: this.onResizing.bind(this, !1),
        onResizeEnd: this.onResizing.bind(this, !0)
      });
      e.push(l), s && a && e.push(a.addColumnAutosize(this.eResize, this.column));
    }, r = () => {
      e.forEach((o) => o()), e.length = 0;
    }, n = () => {
      const o = this.column.isResizable(), a = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
      (o !== t || a !== s) && (t = o, s = a, r(), i());
    };
    n(), this.addDestroyFunc(r), this.ctrl.setRefreshFunction("resize", n);
  }
  onResizing(e, t) {
    const { column: s, lastResizeAmount: i, resizeStartWidth: r, beans: n } = this, o = this.normaliseResizeAmount(t), a = r + o, l = [{ key: s, newWidth: a }], { pinnedCols: c, ctrlsSvc: d, colResize: u } = n;
    if (this.column.getPinned()) {
      const h = (c == null ? void 0 : c.leftWidth) ?? 0, p = (c == null ? void 0 : c.rightWidth) ?? 0, g = jn(d.getGridBodyCtrl().eBodyViewport) - 50;
      if (h + p + (o - i) > g)
        return;
    }
    this.lastResizeAmount = o, u == null || u.setColumnWidths(l, this.resizeWithShiftKey, e, "uiColumnResized"), e && this.toggleColumnResizing(!1);
  }
  onResizeStart(e) {
    this.resizeStartWidth = this.column.getActualWidth(), this.lastResizeAmount = 0, this.resizeWithShiftKey = e, this.toggleColumnResizing(!0);
  }
  toggleColumnResizing(e) {
    this.comp.addOrRemoveCssClass("ag-column-resizing", e);
  }
  // optionally inverts the drag, depending on pinned and RTL
  // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
  normaliseResizeAmount(e) {
    let t = e;
    const s = this.pinned !== "left", i = this.pinned === "right";
    return this.gos.get("enableRtl") ? s && (t *= -1) : i && (t *= -1), t;
  }
}, JA = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colResize";
  }
  setColumnWidths(e, t, s, i) {
    const r = [], { colModel: n, gos: o, visibleCols: a } = this.beans;
    e.forEach((l) => {
      const c = n.getColDefCol(l.key) || n.getCol(l.key);
      if (!c)
        return;
      if (r.push({
        width: l.newWidth,
        ratios: [1],
        columns: [c]
      }), o.get("colResizeDefault") === "shift" && (t = !t), t) {
        const u = a.getColAfter(c);
        if (!u)
          return;
        const h = c.getActualWidth() - l.newWidth, p = u.getActualWidth() + h;
        r.push({
          width: p,
          ratios: [1],
          columns: [u]
        });
      }
    }), r.length !== 0 && this.resizeColumnSets({
      resizeSets: r,
      finished: s,
      source: i
    });
  }
  // method takes sets of columns and resizes them. either all sets will be resized, or nothing
  // be resized. this is used for example when user tries to resize a group and holds shift key,
  // then both the current group (grows), and the adjacent group (shrinks), will get resized,
  // so that's two sets for this method.
  resizeColumnSets(e) {
    const { resizeSets: t, finished: s, source: i } = e;
    if (!(!t || t.every((d) => eM(d)))) {
      if (s) {
        const d = t && t.length > 0 ? t[0].columns : null;
        Qn(this.eventSvc, d, s, i);
      }
      return;
    }
    const n = [], o = [];
    t.forEach((d) => {
      const { width: u, columns: h, ratios: p } = d, g = {}, f = {};
      h.forEach((w) => o.push(w));
      let m = !0, C = 0;
      for (; m; ) {
        if (C++, C > 1e3) {
          be(31);
          break;
        }
        m = !1;
        const w = [];
        let y = 0, b = u;
        h.forEach((M, T) => {
          if (f[M.getId()])
            b -= g[M.getId()];
          else {
            w.push(M);
            const k = p[T];
            y += k;
          }
        });
        const x = 1 / y;
        w.forEach((M, T) => {
          const F = T === w.length - 1;
          let k;
          F ? k = b : (k = Math.round(p[T] * u * x), b -= k);
          const O = M.getMinWidth(), D = M.getMaxWidth();
          k < O ? (k = O, f[M.getId()] = !0, m = !0) : D > 0 && k > D && (k = D, f[M.getId()] = !0, m = !0), g[M.getId()] = k;
        });
      }
      h.forEach((w) => {
        const y = g[w.getId()];
        w.getActualWidth() !== y && (w.setActualWidth(y, i), n.push(w));
      });
    });
    const a = n.length > 0;
    let l = [];
    if (a) {
      const { colFlex: d, visibleCols: u, colViewport: h } = this.beans;
      l = (d == null ? void 0 : d.refreshFlexedColumns({
        resizingCols: o,
        skipSetLeft: !0
      })) ?? [], u.setLeftValues(i), u.updateBodyWidths(), h.checkViewportColumns();
    }
    const c = o.concat(l);
    (a || s) && Qn(this.eventSvc, c, s, i, l);
  }
  resizeHeader(e, t, s) {
    if (!e.isResizable())
      return;
    const i = e.getActualWidth(), r = e.getMinWidth(), n = e.getMaxWidth(), o = Math.min(Math.max(i + t, r), n);
    this.setColumnWidths([{ key: e, newWidth: o }], s, !0, "uiColumnResized");
  }
  createResizeFeature(e, t, s, i, r) {
    return new QA(e, t, s, i, r);
  }
  createGroupResizeFeature(e, t, s, i) {
    return new ZA(e, t, s, i);
  }
};
function eM(e) {
  const { columns: t, width: s } = e;
  let i = 0, r = 0, n = !0;
  t.forEach((l) => {
    const c = l.getMinWidth();
    i += c || 0;
    const d = l.getMaxWidth();
    d > 0 ? r += d : n = !1;
  });
  const o = s >= i, a = !n || s <= r;
  return o && a;
}
var tM = {
  moduleName: "ColumnResize",
  version: de,
  beans: [JA],
  apiFunctions: {
    setColumnWidths: XA
  },
  dependsOn: [Zw, ey]
}, sM = class extends L {
  constructor(e, t) {
    super(), this.removeChildListenersFuncs = [], this.columnGroup = t, this.comp = e;
  }
  postConstruct() {
    this.addListenersToChildrenColumns(), this.addManagedListeners(this.columnGroup, {
      displayedChildrenChanged: this.onDisplayedChildrenChanged.bind(this)
    }), this.onWidthChanged(), this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
  }
  addListenersToChildrenColumns() {
    this.removeListenersOnChildrenColumns();
    const e = this.onWidthChanged.bind(this);
    this.columnGroup.getLeafColumns().forEach((t) => {
      t.addEventListener("widthChanged", e), t.addEventListener("visibleChanged", e), this.removeChildListenersFuncs.push(() => {
        t.removeEventListener("widthChanged", e), t.removeEventListener("visibleChanged", e);
      });
    });
  }
  removeListenersOnChildrenColumns() {
    this.removeChildListenersFuncs.forEach((e) => e()), this.removeChildListenersFuncs = [];
  }
  onDisplayedChildrenChanged() {
    this.addListenersToChildrenColumns(), this.onWidthChanged();
  }
  onWidthChanged() {
    const e = this.columnGroup.getActualWidth();
    this.comp.setWidth(`${e}px`), this.comp.addOrRemoveCssClass("ag-hidden", e === 0);
  }
}, iM = class extends Mh {
  constructor() {
    super(...arguments), this.onSuppressColMoveChange = () => {
      !this.isAlive() || this.isSuppressMoving() ? this.removeDragSource() : this.dragSource || this.setDragSource(this.eGui);
    };
  }
  setComp(e, t, s, i, r) {
    const { column: n, beans: o } = this, { context: a, colNames: l, colHover: c, colResize: d } = o;
    this.comp = e, r = pa(this, a, r), this.setGui(t, r), this.displayName = l.getDisplayNameForColumnGroup(n, "header"), this.addClasses(), this.setupMovingCss(r), this.setupExpandable(r), this.setupTooltip(), this.setupAutoHeight({
      wrapperElement: i,
      compBean: r
    }), this.setupUserComp(), this.addHeaderMouseListeners(r), this.addManagedPropertyListener("groupHeaderHeight", this.refreshMaxHeaderHeight.bind(this)), this.refreshMaxHeaderHeight();
    const u = this.rowCtrl.pinned, h = n.getProvidedColumnGroup().getLeafColumns();
    c == null || c.createHoverFeature(r, h, t), r.createManagedBean(new Ah(n, t, o)), r.createManagedBean(new sM(e, n)), d ? this.resizeFeature = r.createManagedBean(
      d.createGroupResizeFeature(e, s, u, n)
    ) : e.setResizableDisplayed(!1), r.createManagedBean(
      new Ir(t, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: () => {
        },
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      })
    ), this.addHighlightListeners(r, h), r.addManagedPropertyListener("suppressMovableColumns", this.onSuppressColMoveChange), this.addResizeAndMoveKeyboardListeners(r), r.addDestroyFunc(() => this.clearComponent());
  }
  refreshMaxHeaderHeight() {
    const { gos: e, comp: t } = this, s = e.get("groupHeaderHeight");
    s != null ? s === 0 ? t.setHeaderWrapperHidden(!0) : t.setHeaderWrapperMaxHeight(s) : (t.setHeaderWrapperHidden(!1), t.setHeaderWrapperMaxHeight(null));
  }
  addHighlightListeners(e, t) {
    if (this.beans.gos.get("suppressMoveWhenColumnDragging"))
      for (const s of t)
        e.addManagedListeners(s, {
          headerHighlightChanged: this.onLeafColumnHighlightChanged.bind(this, s)
        });
  }
  onLeafColumnHighlightChanged(e) {
    const t = this.column.getDisplayedLeafColumns(), s = t[0] === e, i = pe(t) === e;
    if (!s && !i)
      return;
    const r = e.getHighlighted(), n = !!this.rowCtrl.findHeaderCellCtrl((l) => l.column.isMoving());
    let o = !1, a = !1;
    if (n) {
      const l = this.beans.gos.get("enableRtl"), c = r === 1, d = r === 0;
      s && (l ? a = c : o = d), i && (l ? o = d : a = c);
    }
    this.comp.addOrRemoveCssClass("ag-header-highlight-before", o), this.comp.addOrRemoveCssClass("ag-header-highlight-after", a);
  }
  resizeHeader(e, t) {
    const { resizeFeature: s } = this;
    if (!s)
      return;
    const i = s.getInitialValues(t);
    s.resizeColumns(i, i.resizeStartWidth + e, "uiColumnResized", !0);
  }
  resizeLeafColumnsToFit(e) {
    var t;
    (t = this.resizeFeature) == null || t.resizeLeafColumnsToFit(e);
  }
  setupUserComp() {
    const { colGroupSvc: e, userCompFactory: t, gos: s } = this.beans, i = s.addGridCommonParams({
      displayName: this.displayName,
      columnGroup: this.column,
      setExpanded: (n) => {
        e.setColumnGroupOpened(this.column.getProvidedColumnGroup(), n, "gridInitializing");
      },
      setTooltip: (n, o) => {
        s.assertModuleRegistered("Tooltip", 3), this.setupTooltip(n, o);
      }
    }), r = jT(t, i);
    r && this.comp.setUserCompDetails(r);
  }
  addHeaderMouseListeners(e) {
    const t = (r) => this.handleMouseOverChange(r.type === "mouseenter"), s = () => this.dispatchColumnMouseEvent("columnHeaderClicked", this.column.getProvidedColumnGroup()), i = (r) => this.handleContextMenuMouseEvent(r, void 0, this.column.getProvidedColumnGroup());
    e.addManagedListeners(this.eGui, {
      mouseenter: t,
      mouseleave: t,
      click: s,
      contextmenu: i
    });
  }
  handleMouseOverChange(e) {
    this.eventSvc.dispatchEvent({
      type: e ? "columnHeaderMouseOver" : "columnHeaderMouseLeave",
      column: this.column.getProvidedColumnGroup()
    });
  }
  setupTooltip(e, t) {
    var s;
    this.tooltipFeature = (s = this.beans.tooltipSvc) == null ? void 0 : s.setupHeaderGroupTooltip(
      this.tooltipFeature,
      this,
      e,
      t
    );
  }
  setupExpandable(e) {
    const t = this.column.getProvidedColumnGroup();
    this.refreshExpanded();
    const s = this.refreshExpanded.bind(this);
    e.addManagedListeners(t, {
      expandedChanged: s,
      expandableChanged: s
    });
  }
  refreshExpanded() {
    const { column: e } = this;
    this.expandable = e.isExpandable();
    const t = e.isExpanded();
    this.expandable ? this.comp.setAriaExpanded(t ? "true" : "false") : this.comp.setAriaExpanded(void 0);
  }
  addClasses() {
    const { column: e } = this, t = e.getColGroupDef(), s = Ch(t, this.gos, null, e);
    e.isPadding() ? (s.push("ag-header-group-cell-no-group"), e.getLeafColumns().every((r) => r.isSpanHeaderHeight()) && s.push("ag-header-span-height")) : (s.push("ag-header-group-cell-with-group"), t != null && t.wrapHeaderText && s.push("ag-header-cell-wrap-text")), s.forEach((i) => this.comp.addOrRemoveCssClass(i, !0));
  }
  setupMovingCss(e) {
    const { column: t } = this, i = t.getProvidedColumnGroup().getLeafColumns(), r = () => this.comp.addOrRemoveCssClass("ag-header-cell-moving", t.isMoving());
    i.forEach((n) => {
      e.addManagedListeners(n, { movingChanged: r });
    }), r();
  }
  onFocusIn(e) {
    this.eGui.contains(e.relatedTarget) || this.focusThis();
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    if (!(!this.expandable || !t) && e.key === P.ENTER) {
      const s = this.column, i = !s.isExpanded();
      this.beans.colGroupSvc.setColumnGroupOpened(
        s.getProvidedColumnGroup(),
        i,
        "uiColumnExpanded"
      );
    }
  }
  // unlike columns, this will only get called once, as we don't react on props on column groups
  // (we will always destroy and recreate this comp if something changes)
  setDragSource(e) {
    var t;
    !this.isAlive() || this.isSuppressMoving() || (this.removeDragSource(), e && (this.dragSource = ((t = this.beans.colMoves) == null ? void 0 : t.setDragSourceForHeader(e, this.column, this.displayName)) ?? null));
  }
  isSuppressMoving() {
    return this.gos.get("suppressMovableColumns") || this.column.getLeafColumns().some((e) => e.getColDef().suppressMovable || e.getColDef().lockPosition);
  }
  destroy() {
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), super.destroy();
  }
};
function rM(e, t, s) {
  var i;
  (i = e.colGroupSvc) == null || i.setColumnGroupOpened(t, s, "api");
}
function nM(e, t, s) {
  var i;
  return ((i = e.colGroupSvc) == null ? void 0 : i.getColumnGroup(t, s)) ?? null;
}
function oM(e, t) {
  var s;
  return ((s = e.colGroupSvc) == null ? void 0 : s.getProvidedColGroup(t)) ?? null;
}
function aM(e, t, s) {
  return e.colNames.getDisplayNameForColumnGroup(t, s) || "";
}
function lM(e) {
  var t;
  return ((t = e.colGroupSvc) == null ? void 0 : t.getColumnGroupState()) ?? [];
}
function cM(e, t) {
  var s;
  (s = e.colGroupSvc) == null || s.setColumnGroupState(t, "api");
}
function dM(e) {
  var t;
  (t = e.colGroupSvc) == null || t.resetColumnGroupState("api");
}
function uM(e) {
  return e.visibleCols.treeLeft;
}
function hM(e) {
  return e.visibleCols.treeCenter;
}
function pM(e) {
  return e.visibleCols.treeRight;
}
function gM(e) {
  return e.visibleCols.getAllTrees();
}
function fM(e, t) {
  for (let s = 0; s < t.length; s++) {
    const i = e.indexOf(t[s]);
    i >= 0 && (e[i] = e[e.length - 1], e.pop());
  }
}
var mM = class extends L {
  constructor() {
    super(...arguments), this.beanName = "visibleCols", this.colsAndGroupsMap = {}, this.leftCols = [], this.rightCols = [], this.centerCols = [], this.allCols = [], this.bodyWidth = 0, this.leftWidth = 0, this.rightWidth = 0, this.isBodyWidthDirty = !0;
  }
  refresh(e, t = !1) {
    var a;
    const { colModel: s, colGroupSvc: i, colViewport: r } = this.beans;
    t || this.buildTrees(s, i), i == null || i.updateOpenClosedVisibility();
    const n = bd(this.treeLeft);
    this.leftCols = n, this.centerCols = bd(this.treeCenter);
    const o = bd(this.treeRight);
    this.rightCols = o, this.joinColsAriaOrder(s), this.joinCols(), this.setLeftValues(e), this.autoHeightCols = this.allCols.filter((l) => l.isAutoHeight()), (a = this.beans.colFlex) == null || a.refreshFlexedColumns(), this.updateBodyWidths(), r.checkViewportColumns(!1), this.setFirstRightAndLastLeftPinned(s, n, o, e), this.eventSvc.dispatchEvent({
      type: "displayedColumnsChanged",
      source: e
    });
  }
  // after setColumnWidth or updateGroupsAndPresentedCols
  updateBodyWidths() {
    const e = Gi(this.centerCols), t = Gi(this.leftCols), s = Gi(this.rightCols);
    this.isBodyWidthDirty = this.bodyWidth !== e, (this.bodyWidth !== e || this.leftWidth !== t || this.rightWidth !== s) && (this.bodyWidth = e, this.leftWidth = t, this.rightWidth = s, this.eventSvc.dispatchEvent({
      type: "columnContainerWidthChanged"
    }), this.eventSvc.dispatchEvent({
      type: "displayedColumnsWidthChanged"
    }));
  }
  // sets the left pixel position of each column
  setLeftValues(e) {
    this.setLeftValuesOfCols(e), this.setLeftValuesOfGroups();
  }
  setFirstRightAndLastLeftPinned(e, t, s, i) {
    let r, n;
    this.gos.get("enableRtl") ? (r = t ? t[0] : null, n = s ? pe(s) : null) : (r = t ? pe(t) : null, n = s ? s[0] : null), e.getCols().forEach((o) => {
      o.setLastLeftPinned(o === r, i), o.setFirstRightPinned(o === n, i);
    });
  }
  buildTrees(e, t) {
    const s = e.getColsToShow(), i = s.filter((l) => l.getPinned() == "left"), r = s.filter((l) => l.getPinned() == "right"), n = s.filter((l) => l.getPinned() != "left" && l.getPinned() != "right"), o = new Yv(), a = (l) => t ? t.createColumnGroups(l) : l.columns;
    this.treeLeft = a({
      columns: i,
      idCreator: o,
      pinned: "left",
      oldDisplayedGroups: this.treeLeft
    }), this.treeRight = a({
      columns: r,
      idCreator: o,
      pinned: "right",
      oldDisplayedGroups: this.treeRight
    }), this.treeCenter = a({
      columns: n,
      idCreator: o,
      pinned: null,
      oldDisplayedGroups: this.treeCenter
    }), this.updateColsAndGroupsMap();
  }
  clear() {
    this.leftCols = [], this.rightCols = [], this.centerCols = [], this.allCols = [], this.ariaOrderColumns = [];
  }
  joinColsAriaOrder(e) {
    const t = e.getCols(), s = [], i = [], r = [];
    for (const n of t) {
      const o = n.getPinned();
      o ? o === !0 || o === "left" ? s.push(n) : r.push(n) : i.push(n);
    }
    this.ariaOrderColumns = s.concat(i).concat(r);
  }
  getAriaColIndex(e) {
    let t;
    return pt(e) ? t = e.getLeafColumns()[0] : t = e, this.ariaOrderColumns.indexOf(t) + 1;
  }
  setLeftValuesOfGroups() {
    [this.treeLeft, this.treeRight, this.treeCenter].forEach((e) => {
      e.forEach((t) => {
        pt(t) && t.checkLeft();
      });
    });
  }
  setLeftValuesOfCols(e) {
    const { colModel: t } = this.beans;
    if (!t.getColDefCols())
      return;
    const i = t.getCols().slice(0), r = this.gos.get("enableRtl");
    [this.leftCols, this.rightCols, this.centerCols].forEach((n) => {
      if (r) {
        let o = Gi(n);
        n.forEach((a) => {
          o -= a.getActualWidth(), a.setLeft(o, e);
        });
      } else {
        let o = 0;
        n.forEach((a) => {
          a.setLeft(o, e), o += a.getActualWidth();
        });
      }
      fM(i, n);
    }), i.forEach((n) => {
      n.setLeft(null, e);
    });
  }
  joinCols() {
    this.gos.get("enableRtl") ? this.allCols = this.rightCols.concat(this.centerCols).concat(this.leftCols) : this.allCols = this.leftCols.concat(this.centerCols).concat(this.rightCols);
  }
  getAllTrees() {
    return this.treeLeft && this.treeRight && this.treeCenter ? this.treeLeft.concat(this.treeCenter).concat(this.treeRight) : null;
  }
  // gridPanel -> ensureColumnVisible
  isColDisplayed(e) {
    return this.allCols.indexOf(e) >= 0;
  }
  getLeftColsForRow(e) {
    const {
      leftCols: t,
      beans: { colModel: s }
    } = this;
    return s.colSpanActive ? this.getColsForRow(e, t) : t;
  }
  getRightColsForRow(e) {
    const {
      rightCols: t,
      beans: { colModel: s }
    } = this;
    return s.colSpanActive ? this.getColsForRow(e, t) : t;
  }
  getColsForRow(e, t, s, i) {
    const r = [];
    let n = null;
    for (let o = 0; o < t.length; o++) {
      const a = t[o], l = t.length - o, c = Math.min(a.getColSpan(e), l), d = [a];
      if (c > 1) {
        const h = c - 1;
        for (let p = 1; p <= h; p++)
          d.push(t[o + p]);
        o += h;
      }
      let u;
      s ? (u = !1, d.forEach((h) => {
        s(h) && (u = !0);
      })) : u = !0, u && (r.length === 0 && n && (i && i(a)) && r.push(n), r.push(a)), n = a;
    }
    return r;
  }
  getContainerWidth(e) {
    switch (e) {
      case "left":
        return this.leftWidth;
      case "right":
        return this.rightWidth;
      default:
        return this.bodyWidth;
    }
  }
  getColBefore(e) {
    const t = this.allCols, s = t.indexOf(e);
    return s > 0 ? t[s - 1] : null;
  }
  isPinningLeft() {
    return this.leftCols.length > 0;
  }
  isPinningRight() {
    return this.rightCols.length > 0;
  }
  updateColsAndGroupsMap() {
    this.colsAndGroupsMap = {};
    const e = (t) => {
      this.colsAndGroupsMap[t.getUniqueId()] = t;
    };
    pn(this.treeCenter, !1, e), pn(this.treeLeft, !1, e), pn(this.treeRight, !1, e);
  }
  isVisible(e) {
    return this.colsAndGroupsMap[e.getUniqueId()] === e;
  }
  getFirstColumn() {
    const e = this.gos.get("enableRtl"), t = ["leftCols", "centerCols", "rightCols"];
    e && t.reverse();
    for (let s = 0; s < t.length; s++) {
      const i = this[t[s]];
      if (i.length)
        return e ? pe(i) : i[0];
    }
    return null;
  }
  // used by:
  // + rowRenderer -> for navigation
  getColAfter(e) {
    const t = this.allCols, s = t.indexOf(e);
    return s < t.length - 1 ? t[s + 1] : null;
  }
  // used by:
  // + angularGrid -> setting pinned body width
  // note: this should be cached
  getColsLeftWidth() {
    return Gi(this.leftCols);
  }
  // note: this should be cached
  getDisplayedColumnsRightWidth() {
    return Gi(this.rightCols);
  }
  isColAtEdge(e, t) {
    const s = this.allCols;
    if (!s.length)
      return !1;
    const i = t === "first";
    let r;
    if (pt(e)) {
      const n = e.getDisplayedLeafColumns();
      if (!n.length)
        return !1;
      r = i ? n[0] : pe(n);
    } else
      r = e;
    return (i ? s[0] : pe(s)) === r;
  }
};
function pn(e, t, s) {
  if (e)
    for (let i = 0; i < e.length; i++) {
      const r = e[i];
      if (pt(r)) {
        const n = t ? r.getDisplayedChildren() : r.getChildren();
        pn(n, t, s);
      }
      s(r);
    }
}
function bd(e) {
  const t = [];
  return pn(e, !0, (s) => {
    Ri(s) && t.push(s);
  }), t;
}
var CM = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colGroupSvc";
  }
  getColumnGroupState() {
    const e = [], t = this.beans.colModel.getColTree();
    return Hi(null, t, (s) => {
      ct(s) && e.push({
        groupId: s.getGroupId(),
        open: s.isExpanded()
      });
    }), e;
  }
  resetColumnGroupState(e) {
    const t = this.beans.colModel.getColDefColTree();
    if (!t)
      return;
    const s = [];
    Hi(null, t, (i) => {
      if (ct(i)) {
        const r = i.getColGroupDef(), n = {
          groupId: i.getGroupId(),
          open: r ? r.openByDefault : void 0
        };
        s.push(n);
      }
    }), this.setColumnGroupState(s, e);
  }
  setColumnGroupState(e, t) {
    const { colModel: s, colAnimation: i, visibleCols: r, eventSvc: n } = this.beans;
    if (!s.getColTree())
      return;
    i == null || i.start();
    const a = [];
    e.forEach((l) => {
      const c = l.groupId, d = l.open, u = this.getProvidedColGroup(c);
      u && u.isExpanded() !== d && (u.setExpanded(d), a.push(u));
    }), r.refresh(t, !0), a.length && n.dispatchEvent({
      type: "columnGroupOpened",
      columnGroup: a.length === 1 ? a[0] : void 0,
      columnGroups: a
    }), i == null || i.finish();
  }
  // called by headerRenderer - when a header is opened or closed
  setColumnGroupOpened(e, t, s) {
    let i;
    ct(e) ? i = e.getId() : i = e || "", this.setColumnGroupState([{ groupId: i, open: t }], s);
  }
  getProvidedColGroup(e) {
    let t = null;
    return Hi(null, this.beans.colModel.getColTree(), (s) => {
      ct(s) && s.getId() === e && (t = s);
    }), t;
  }
  getGroupAtDirection(e, t) {
    const s = e.getProvidedColumnGroup().getLevel() + e.getPaddingLevel(), i = e.getDisplayedLeafColumns(), r = t === "After" ? pe(i) : i[0], n = `getCol${t}`;
    for (; ; ) {
      const o = this.beans.visibleCols[n](r);
      if (!o)
        return null;
      const a = this.getColGroupAtLevel(o, s);
      if (a !== e)
        return a;
    }
  }
  getColGroupAtLevel(e, t) {
    let s = e.getParent(), i, r;
    for (; i = s.getProvidedColumnGroup().getLevel(), r = s.getPaddingLevel(), !(i + r <= t); )
      s = s.getParent();
    return s;
  }
  updateOpenClosedVisibility() {
    const e = this.beans.visibleCols.getAllTrees();
    pn(e, !1, (t) => {
      pt(t) && t.calculateDisplayedColumns();
    });
  }
  // returns the group with matching colId and instanceId. If instanceId is missing,
  // matches only on the colId.
  getColumnGroup(e, t) {
    if (!e)
      return null;
    if (pt(e))
      return e;
    const s = this.beans.visibleCols.getAllTrees(), i = typeof t == "number";
    let r = null;
    return pn(s, !1, (n) => {
      if (pt(n)) {
        const o = n;
        let a;
        i ? a = e === o.getGroupId() && t === o.getPartId() : a = e === o.getGroupId(), a && (r = o);
      }
    }), r;
  }
  createColumnGroups(e) {
    const { columns: t, idCreator: s, pinned: i, oldDisplayedGroups: r, isStandaloneStructure: n } = e, o = this.mapOldGroupsById(r), a = [];
    let l = t;
    for (; l.length; ) {
      const c = l;
      l = [];
      let d = 0;
      const u = (h) => {
        const p = d;
        d = h;
        const g = c[p], m = (pt(g) ? g.getProvidedColumnGroup() : g).getOriginalParent();
        if (m == null) {
          for (let w = p; w < h; w++)
            a.push(c[w]);
          return;
        }
        const C = this.createColumnGroup(
          m,
          s,
          o,
          i,
          n
        );
        for (let w = p; w < h; w++)
          C.addChild(c[w]);
        l.push(C);
      };
      for (let h = 1; h < c.length; h++) {
        const p = c[h], f = (pt(p) ? p.getProvidedColumnGroup() : p).getOriginalParent(), m = c[d], w = (pt(m) ? m.getProvidedColumnGroup() : m).getOriginalParent();
        f !== w && u(h);
      }
      d < c.length && u(c.length);
    }
    return n || this.setupParentsIntoCols(a, null), a;
  }
  createProvidedColumnGroup(e, t, s, i, r, n, o) {
    const a = r.getUniqueKey(t.groupId || null, null), l = this.createMergedColGroupDef(t, a), c = new jo(l, a, !1, s);
    this.createBean(c);
    const d = this.findExistingGroup(t, n);
    d && n.splice(d.idx, 1);
    const u = d == null ? void 0 : d.group;
    u && c.setExpanded(u.isExpanded());
    const h = jv(
      this.beans,
      l.children,
      s + 1,
      e,
      i,
      r,
      n,
      o
    );
    return c.setChildren(h), c;
  }
  balanceColumnTree(e, t, s, i) {
    const r = [];
    for (let n = 0; n < e.length; n++) {
      const o = e[n];
      if (ct(o)) {
        const a = o, l = this.balanceColumnTree(
          a.getChildren(),
          t + 1,
          s,
          i
        );
        a.setChildren(l), r.push(a);
      } else {
        let a, l;
        for (let c = s - 1; c >= t; c--) {
          const d = i.getUniqueKey(null, null), u = this.createMergedColGroupDef(null, d), h = new jo(u, d, !0, t);
          this.createBean(h), l && l.setChildren([h]), l = h, a || (a = l);
        }
        if (a && l)
          if (r.push(a), e.some((d) => ct(d))) {
            l.setChildren([o]);
            continue;
          } else {
            l.setChildren(e);
            break;
          }
        r.push(o);
      }
    }
    return r;
  }
  findDepth(e) {
    let t = 0, s = e;
    for (; s && s[0] && ct(s[0]); )
      t++, s = s[0].getChildren();
    return t;
  }
  findMaxDepth(e, t) {
    let s = t;
    for (let i = 0; i < e.length; i++) {
      const r = e[i];
      if (ct(r)) {
        const n = r, o = this.findMaxDepth(n.getChildren(), t + 1);
        s < o && (s = o);
      }
    }
    return s;
  }
  /**
   * Inserts dummy group columns in the hierarchy above auto-generated columns
   * in order to ensure auto-generated columns are leaf nodes (and therefore are
   * displayed correctly)
   */
  balanceTreeForAutoCols(e, t) {
    const s = [];
    return e.forEach((i) => {
      let r = i;
      for (let n = t - 1; n >= 0; n--) {
        const o = new jo(null, `FAKE_PATH_${i.getId()}}_${n}`, !0, n);
        this.createBean(o), o.setChildren([r]), r.originalParent = o, r = o;
      }
      t === 0 && (i.originalParent = null), s.push(r);
    }), s;
  }
  createMergedColGroupDef(e, t) {
    const s = {}, { gos: i, validation: r } = this.beans;
    return Object.assign(s, i.get("defaultColGroupDef")), Object.assign(s, e), r == null || r.validateColDef(s, t), s;
  }
  findExistingGroup(e, t) {
    if (e.groupId != null)
      for (let i = 0; i < t.length; i++) {
        const r = t[i];
        if (r.getColGroupDef() && r.getId() === e.groupId)
          return { idx: i, group: r };
      }
  }
  createColumnGroup(e, t, s, i, r) {
    const n = e.getGroupId(), o = t.getInstanceIdForKey(n), a = fw(n, o);
    let l = s[a];
    return l && l.getProvidedColumnGroup() !== e && (l = null), W(l) ? l.reset() : (l = new mw(e, n, o, i), r || this.createBean(l)), l;
  }
  // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
  mapOldGroupsById(e) {
    const t = {}, s = (i) => {
      i.forEach((r) => {
        if (pt(r)) {
          const n = r;
          t[r.getUniqueId()] = n, s(n.getChildren());
        }
      });
    };
    return e && s(e), t;
  }
  setupParentsIntoCols(e, t) {
    e.forEach((s) => {
      if (s.parent = t, pt(s)) {
        const i = s;
        this.setupParentsIntoCols(i.getChildren(), i);
      }
    });
  }
}, ty = {
  moduleName: "ColumnGroup",
  version: de,
  dynamicBeans: { headerGroupCellCtrl: iM },
  beans: [CM],
  apiFunctions: {
    getAllDisplayedColumnGroups: gM,
    getCenterDisplayedColumnGroups: hM,
    getColumnGroup: nM,
    getColumnGroupState: lM,
    getDisplayNameForColumnGroup: aM,
    getLeftDisplayedColumnGroups: uM,
    getProvidedColumnGroup: oM,
    getRightDisplayedColumnGroups: pM,
    resetColumnGroupState: dM,
    setColumnGroupOpened: rM,
    setColumnGroupState: cM
  }
}, vM = {
  moduleName: "CheckboxCellRenderer",
  version: de,
  userComponents: {
    agCheckboxCellRenderer: MD
  }
};
function wM(e, t) {
  const s = e.colModel.getColDefCol(t);
  return s ? s.getColDef() : null;
}
function yM(e) {
  return e.colModel.getColumnDefs();
}
function bM(e, t, s) {
  return e.colNames.getDisplayNameForColumn(t, s) || "";
}
function SM(e, t) {
  return e.colModel.getColDefCol(t);
}
function xM(e) {
  return e.colModel.getColDefCols();
}
function RM(e, t) {
  return ws(e, t, "api");
}
function FM(e) {
  return ra(e);
}
function PM(e) {
  Bv(e, "api");
}
function TM(e) {
  return e.visibleCols.isPinningLeft() || e.visibleCols.isPinningRight();
}
function EM(e) {
  return e.visibleCols.isPinningLeft();
}
function DM(e) {
  return e.visibleCols.isPinningRight();
}
function AM(e, t) {
  return e.visibleCols.getColAfter(t);
}
function MM(e, t) {
  return e.visibleCols.getColBefore(t);
}
function IM(e, t, s) {
  e.colModel.setColsVisible(t, s, "api");
}
function LM(e, t, s) {
  var i;
  (i = e.pinnedCols) == null || i.setColsPinned(t, s, "api");
}
function kM(e) {
  return e.colModel.getCols();
}
function OM(e) {
  return e.visibleCols.leftCols;
}
function GM(e) {
  return e.visibleCols.centerCols;
}
function BM(e) {
  return e.visibleCols.rightCols;
}
function VM(e) {
  return e.visibleCols.allCols;
}
function NM(e) {
  return e.colViewport.getViewportColumns();
}
function pu(e, t) {
  if (!e)
    return;
  const s = e, i = {};
  return Object.keys(s).forEach((r) => {
    if (t && t.indexOf(r) >= 0 || Av.has(r))
      return;
    const n = s[r];
    typeof n == "object" && n !== null && n.constructor === Object ? i[r] = pu(n) : i[r] = n;
  }), i;
}
var HM = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colDefFactory";
  }
  wireBeans(e) {
    this.rowGroupColsSvc = e.rowGroupColsSvc, this.pivotColsSvc = e.pivotColsSvc;
  }
  getColumnDefs(e, t, s, i) {
    var a, l;
    const r = e.slice();
    t ? r.sort((c, d) => s.indexOf(c) - s.indexOf(d)) : s && r.sort((c, d) => i.indexOf(c) - i.indexOf(d));
    const n = (a = this.rowGroupColsSvc) == null ? void 0 : a.columns, o = (l = this.pivotColsSvc) == null ? void 0 : l.columns;
    return this.buildColumnDefs(r, n, o);
  }
  buildColumnDefs(e, t = [], s = []) {
    const i = [], r = {};
    return e.forEach((n) => {
      const o = this.createDefFromColumn(n, t, s);
      let a = !0, l = o, c = n.getOriginalParent(), d = null;
      for (; c; ) {
        let u = null;
        if (c.isPadding()) {
          c = c.getOriginalParent();
          continue;
        }
        const h = r[c.getGroupId()];
        if (h) {
          h.children.push(l), a = !1;
          break;
        }
        if (u = this.createDefFromGroup(c), u && (u.children = [l], r[u.groupId] = u, l = u, c = c.getOriginalParent()), c != null && d === c) {
          a = !1;
          break;
        }
        d = c;
      }
      a && i.push(l);
    }), i;
  }
  createDefFromGroup(e) {
    const t = pu(e.getColGroupDef(), ["children"]);
    return t && (t.groupId = e.getGroupId()), t;
  }
  createDefFromColumn(e, t, s) {
    const i = pu(e.getColDef());
    return i.colId = e.getColId(), i.width = e.getActualWidth(), i.rowGroup = e.isRowGroupActive(), i.rowGroupIndex = e.isRowGroupActive() ? t.indexOf(e) : null, i.pivot = e.isPivotActive(), i.pivotIndex = e.isPivotActive() ? s.indexOf(e) : null, i.aggFunc = e.isValueActive() ? e.getAggFunc() : null, i.hide = e.isVisible() ? void 0 : !0, i.pinned = e.isPinned() ? e.getPinned() : null, i.sort = e.getSort() ? e.getSort() : null, i.sortIndex = e.getSortIndex() != null ? e.getSortIndex() : null, i;
  }
}, zM = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colFlex";
  }
  refreshFlexedColumns(e = {}) {
    const t = e.source ? e.source : "flex";
    e.viewportWidth != null && (this.flexViewportWidth = e.viewportWidth);
    const s = this.flexViewportWidth;
    if (!s)
      return [];
    const { visibleCols: i } = this.beans, r = i.centerCols;
    let n = -1;
    if (e.resizingCols) {
      const g = new Set(e.resizingCols);
      for (let f = r.length - 1; f >= 0; f--)
        if (g.has(r[f])) {
          n = f;
          break;
        }
    }
    let o = !1;
    const a = r.map((g, f) => {
      const m = g.getFlex(), C = m != null && m > 0 && f > n;
      return o || (o = C), {
        col: g,
        isFlex: C,
        flex: Math.max(0, m ?? 0),
        initialSize: g.getActualWidth(),
        min: g.getMinWidth(),
        max: g.getMaxWidth(),
        targetSize: 0
      };
    });
    if (!o)
      return [];
    let l = a.length, c = a.reduce((g, f) => g + f.flex, 0), d = s;
    const u = (g, f) => {
      g.frozenSize = f, g.col.setActualWidth(f, t), d -= f, c -= g.flex, l -= 1;
    }, h = (g) => g.frozenSize != null;
    for (const g of a)
      g.isFlex || u(g, g.initialSize);
    for (; l > 0; ) {
      const g = Math.round(c < 1 ? d * c : d);
      let f, m = 0, C = 0;
      for (const b of a) {
        if (h(b))
          continue;
        f = b, C += g * (b.flex / c);
        const x = C - m, M = Math.round(x);
        b.targetSize = M, m += M;
      }
      f && (f.targetSize += g - m);
      let w = 0;
      for (const b of a) {
        if (h(b))
          continue;
        const x = b.targetSize, M = Math.min(Math.max(x, b.min), b.max);
        w += M - x, b.violationType = M === x ? void 0 : M < x ? "max" : "min", b.targetSize = M;
      }
      const y = w === 0 ? "all" : w > 0 ? "min" : "max";
      for (const b of a)
        h(b) || (y === "all" || b.violationType === y) && u(b, b.targetSize);
    }
    e.skipSetLeft || i.setLeftValues(t), e.updateBodyWidths && i.updateBodyWidths();
    const p = a.filter((g) => g.isFlex && !g.violationType).map((g) => g.col);
    if (e.fireResizedEvent) {
      const g = a.filter((m) => m.initialSize !== m.frozenSize).map((m) => m.col), f = a.filter((m) => m.flex).map((m) => m.col);
      Qn(this.eventSvc, g, !0, t, f);
    }
    return p;
  }
  initCol(e) {
    const { flex: t, initialFlex: s } = e.colDef;
    t !== void 0 ? e.flex = t : s !== void 0 && (e.flex = s);
  }
  // this method should only be used by the colModel to
  // change flex when required by the applyColumnState method.
  setColFlex(e, t) {
    e.flex = t ?? null, e.dispatchStateUpdatedEvent("flex");
  }
}, WM = class extends L {
  constructor() {
    super(...arguments), this.beanName = "dataTypeSvc", this.dataTypeDefinitions = {}, this.isPendingInference = !1, this.isColumnTypeOverrideInDataTypeDefinitions = !1, this.columnStateUpdatesPendingInference = {}, this.columnStateUpdateListenerDestroyFuncs = [];
  }
  wireBeans(e) {
    this.colModel = e.colModel;
  }
  postConstruct() {
    this.processDataTypeDefinitions(), this.addManagedPropertyListener("dataTypeDefinitions", (e) => {
      this.processDataTypeDefinitions(), this.colModel.recreateColumnDefs(cn(e.source));
    });
  }
  processDataTypeDefinitions() {
    const e = this.getDefaultDataTypes(), t = {};
    this.dataTypeDefinitions = t;
    const s = {};
    this.formatValueFuncs = s;
    const i = (o) => (a) => {
      const { column: l, node: c, value: d } = a;
      let u = l.getColDef().valueFormatter;
      return u === o.groupSafeValueFormatter && (u = o.valueFormatter), this.beans.valueSvc.formatValue(l, c, d, u);
    };
    Object.entries(e).forEach(([o, a]) => {
      const l = {
        ...a,
        groupSafeValueFormatter: af(a, this.gos)
      };
      t[o] = l, s[o] = i(l);
    });
    const r = this.gos.get("dataTypeDefinitions") ?? {}, n = {};
    this.dataTypeMatchers = n, Object.entries(r).forEach(([o, a]) => {
      const l = this.processDataTypeDefinition(
        a,
        r,
        [o],
        e
      );
      l && (t[o] = l, a.dataTypeMatcher && (n[o] = a.dataTypeMatcher), s[o] = i(l));
    }), this.checkObjectValueHandlers(e), ["dateString", "text", "number", "boolean", "date"].forEach((o) => {
      const a = n[o];
      a && delete n[o], n[o] = a ?? e[o].dataTypeMatcher;
    });
  }
  processDataTypeDefinition(e, t, s, i) {
    let r;
    const n = e.extendsDataType;
    if (e.columnTypes && (this.isColumnTypeOverrideInDataTypeDefinitions = !0), e.extendsDataType === e.baseDataType) {
      let o = i[n];
      const a = t[n];
      if (o && a && (o = a), !of(e, o, n))
        return;
      r = nf(o, e);
    } else {
      if (s.includes(n)) {
        I(44);
        return;
      }
      const o = t[n];
      if (!of(e, o, n))
        return;
      const a = this.processDataTypeDefinition(
        o,
        t,
        [...s, n],
        i
      );
      if (!a)
        return;
      r = nf(a, e);
    }
    return {
      ...r,
      groupSafeValueFormatter: af(r, this.gos)
    };
  }
  updateColDefAndGetColumnType(e, t, s) {
    let { cellDataType: i } = t;
    const { field: r } = t;
    if (i === void 0 && (i = e.cellDataType), (i == null || i === !0) && (i = this.canInferCellDataType(e, t) ? this.inferCellDataType(r, s) : !1), !i) {
      e.cellDataType = !1;
      return;
    }
    const n = this.dataTypeDefinitions[i];
    if (!n) {
      I(47, { cellDataType: i });
      return;
    }
    return e.cellDataType = i, n.groupSafeValueFormatter && (e.valueFormatter = n.groupSafeValueFormatter), n.valueParser && (e.valueParser = n.valueParser), n.suppressDefaultProperties || this.setColDefPropertiesForBaseDataType(e, i, n, s), n.columnTypes;
  }
  addColumnListeners(e) {
    if (!this.isPendingInference)
      return;
    const t = this.columnStateUpdatesPendingInference[e.getColId()];
    if (!t)
      return;
    const s = (i) => {
      t.add(i.key);
    };
    e.addEventListener("columnStateUpdated", s), this.columnStateUpdateListenerDestroyFuncs.push(
      () => e.removeEventListener("columnStateUpdated", s)
    );
  }
  canInferCellDataType(e, t) {
    const { gos: s } = this;
    if (!Ye(s))
      return !1;
    const i = { cellRenderer: !0, valueGetter: !0, valueParser: !0, refData: !0 };
    if (Sd(t, i))
      return !1;
    const r = t.type === null ? e.type : t.type;
    if (r) {
      const n = s.get("columnTypes") ?? {};
      if (Dl(r).some((a) => {
        const l = n[a.trim()];
        return l && Sd(l, i);
      }))
        return !1;
    }
    return !Sd(e, i);
  }
  inferCellDataType(e, t) {
    if (!e)
      return;
    let s;
    const i = this.getInitialData();
    if (i) {
      const n = e.indexOf(".") >= 0 && !this.gos.get("suppressFieldDotNotation");
      s = $o(i, e, n);
    } else
      this.initWaitForRowData(t);
    if (s == null)
      return;
    const [r] = Object.entries(this.dataTypeMatchers).find(
      ([n, o]) => o(s)
    ) ?? ["object"];
    return r;
  }
  getInitialData() {
    var t;
    const e = this.gos.get("rowData");
    if (e != null && e.length)
      return e[0];
    if (this.initialData)
      return this.initialData;
    {
      const s = (t = this.beans.rowModel.rootNode) == null ? void 0 : t.allLeafChildren;
      if (s != null && s.length)
        return s[0].data;
    }
    return null;
  }
  initWaitForRowData(e) {
    if (this.columnStateUpdatesPendingInference[e] = /* @__PURE__ */ new Set(), this.isPendingInference)
      return;
    this.isPendingInference = !0;
    const t = this.isColumnTypeOverrideInDataTypeDefinitions, { colAutosize: s, eventSvc: i } = this.beans;
    t && s && (s.shouldQueueResizeOperations = !0);
    const [r] = this.addManagedEventListeners({
      rowDataUpdateStarted: (n) => {
        const { firstRowData: o } = n;
        o && (r == null || r(), this.isPendingInference = !1, this.processColumnsPendingInference(o, t), this.columnStateUpdatesPendingInference = {}, t && (s == null || s.processResizeOperations()), i.dispatchEvent({
          type: "dataTypesInferred"
        }));
      }
    });
  }
  processColumnsPendingInference(e, t) {
    this.initialData = e;
    const s = [];
    this.destroyColumnStateUpdateListeners();
    const i = {}, r = {};
    Object.entries(this.columnStateUpdatesPendingInference).forEach(([n, o]) => {
      const a = this.colModel.getCol(n);
      if (!a)
        return;
      const l = a.getColDef();
      if (!this.resetColDefIntoCol(a, "cellDataTypeInferred"))
        return;
      const c = a.getColDef();
      if (t && c.type && c.type !== l.type) {
        const d = UM(a, o);
        d.rowGroup && d.rowGroupIndex == null && (i[n] = d), d.pivot && d.pivotIndex == null && (r[n] = d), s.push(d);
      }
    }), t && s.push(
      ...this.generateColumnStateForRowGroupAndPivotIndexes(
        i,
        r
      )
    ), s.length && ws(this.beans, { state: s }, "cellDataTypeInferred"), this.initialData = null;
  }
  generateColumnStateForRowGroupAndPivotIndexes(e, t) {
    const s = {}, { rowGroupColsSvc: i, pivotColsSvc: r } = this.beans;
    return i == null || i.restoreColumnOrder(s, e), r == null || r.restoreColumnOrder(s, t), Object.values(s);
  }
  resetColDefIntoCol(e, t) {
    const s = e.getUserProvidedColDef();
    if (!s)
      return !1;
    const i = Al(this.beans, s, e.getColId());
    return e.setColDef(i, s, t), !0;
  }
  checkObjectValueHandlers(e) {
    const t = this.dataTypeDefinitions.object, s = e.object;
    this.hasObjectValueParser = t.valueParser !== s.valueParser, this.hasObjectValueFormatter = t.valueFormatter !== s.valueFormatter;
  }
  getDateStringTypeDefinition(e) {
    const { dateString: t } = this.dataTypeDefinitions;
    return e ? this.getDataTypeDefinition(e) ?? t : t;
  }
  getDateParserFunction(e) {
    return this.getDateStringTypeDefinition(e).dateParser;
  }
  getDateFormatterFunction(e) {
    return this.getDateStringTypeDefinition(e).dateFormatter;
  }
  getDataTypeDefinition(e) {
    const t = e.getColDef();
    if (t.cellDataType)
      return this.dataTypeDefinitions[t.cellDataType];
  }
  getBaseDataType(e) {
    var t;
    return (t = this.getDataTypeDefinition(e)) == null ? void 0 : t.baseDataType;
  }
  checkType(e, t) {
    var i;
    if (t == null)
      return !0;
    const s = (i = this.getDataTypeDefinition(e)) == null ? void 0 : i.dataTypeMatcher;
    return s ? s(t) : !0;
  }
  validateColDef(e) {
    const t = (s) => I(48, { property: s });
    if (e.cellDataType === "object") {
      const { object: s } = this.dataTypeDefinitions;
      e.valueFormatter === s.groupSafeValueFormatter && !this.hasObjectValueFormatter && t("Formatter"), e.editable && e.valueParser === s.valueParser && !this.hasObjectValueParser && t("Parser");
    }
  }
  getFormatValue(e) {
    return this.formatValueFuncs[e];
  }
  isColPendingInference(e) {
    return this.isPendingInference && !!this.columnStateUpdatesPendingInference[e];
  }
  setColDefPropertiesForBaseDataType(e, t, s, i) {
    var n;
    const r = this.formatValueFuncs[t];
    switch (s.baseDataType) {
      case "number": {
        e.cellEditor = "agNumberCellEditor";
        break;
      }
      case "boolean": {
        e.cellEditor = "agCheckboxCellEditor", e.cellRenderer = "agCheckboxCellRenderer", e.suppressKeyboardEvent = (o) => !!o.colDef.editable && o.event.key === P.SPACE;
        break;
      }
      case "date": {
        e.cellEditor = "agDateCellEditor", e.keyCreator = r;
        break;
      }
      case "dateString": {
        e.cellEditor = "agDateStringCellEditor", e.keyCreator = r;
        break;
      }
      case "object": {
        e.cellEditorParams = {
          useFormatter: !0
        }, e.comparator = (o, a) => {
          const l = this.colModel.getColDefCol(i), c = l == null ? void 0 : l.getColDef();
          if (!l || !c)
            return 0;
          const d = o == null ? "" : r({ column: l, node: null, value: o }), u = a == null ? "" : r({ column: l, node: null, value: a });
          return d === u ? 0 : d > u ? 1 : -1;
        }, e.keyCreator = r;
        break;
      }
    }
    (n = this.beans.filterManager) == null || n.setColDefPropertiesForDataType(e, s, r);
  }
  getDefaultDataTypes() {
    const e = (s) => !!s.match("^\\d{4}-\\d{2}-\\d{2}$"), t = this.getLocaleTextFunc();
    return {
      number: {
        baseDataType: "number",
        // can be empty space with legacy copy
        valueParser: (s) => {
          var i, r;
          return ((r = (i = s.newValue) == null ? void 0 : i.trim) == null ? void 0 : r.call(i)) === "" ? null : Number(s.newValue);
        },
        valueFormatter: (s) => s.value == null ? "" : typeof s.value != "number" || isNaN(s.value) ? t("invalidNumber", "Invalid Number") : String(s.value),
        dataTypeMatcher: (s) => typeof s == "number"
      },
      text: {
        baseDataType: "text",
        valueParser: (s) => s.newValue === "" ? null : Cs(s.newValue),
        dataTypeMatcher: (s) => typeof s == "string"
      },
      boolean: {
        baseDataType: "boolean",
        valueParser: (s) => {
          var i, r;
          return s.newValue == null ? s.newValue : ((r = (i = s.newValue) == null ? void 0 : i.trim) == null ? void 0 : r.call(i)) === "" ? null : String(s.newValue).toLowerCase() === "true";
        },
        valueFormatter: (s) => s.value == null ? "" : String(s.value),
        dataTypeMatcher: (s) => typeof s == "boolean"
      },
      date: {
        baseDataType: "date",
        valueParser: (s) => Yt(s.newValue == null ? null : String(s.newValue)),
        valueFormatter: (s) => s.value == null ? "" : !(s.value instanceof Date) || isNaN(s.value.getTime()) ? t("invalidDate", "Invalid Date") : ys(s.value, !1) ?? "",
        dataTypeMatcher: (s) => s instanceof Date
      },
      dateString: {
        baseDataType: "dateString",
        dateParser: (s) => Yt(s) ?? void 0,
        dateFormatter: (s) => ys(s ?? null, !1) ?? void 0,
        valueParser: (s) => e(String(s.newValue)) ? s.newValue : null,
        valueFormatter: (s) => e(String(s.value)) ? s.value : "",
        dataTypeMatcher: (s) => typeof s == "string" && e(s)
      },
      object: {
        baseDataType: "object",
        valueParser: () => null,
        valueFormatter: (s) => Cs(s.value) ?? ""
      }
    };
  }
  destroyColumnStateUpdateListeners() {
    this.columnStateUpdateListenerDestroyFuncs.forEach((e) => e()), this.columnStateUpdateListenerDestroyFuncs = [];
  }
  destroy() {
    this.dataTypeDefinitions = {}, this.dataTypeMatchers = {}, this.formatValueFuncs = {}, this.columnStateUpdatesPendingInference = {}, this.destroyColumnStateUpdateListeners(), super.destroy();
  }
};
function nf(e, t) {
  const s = {
    ...e,
    ...t
  };
  return e.columnTypes && t.columnTypes && t.appendColumnTypes && (s.columnTypes = [
    ...Dl(e.columnTypes),
    ...Dl(t.columnTypes)
  ]), s;
}
function of(e, t, s) {
  return t ? t.baseDataType !== e.baseDataType ? (I(46), !1) : !0 : (I(45, { parentCellDataType: s }), !1);
}
function af(e, t) {
  if (e.valueFormatter)
    return (s) => {
      var i, r;
      if ((i = s.node) != null && i.group) {
        const n = (s.colDef.pivotValueColumn ?? s.column).getAggFunc();
        if (n) {
          if (n === "first" || n === "last")
            return e.valueFormatter(s);
          if (e.baseDataType === "number" && n !== "count") {
            if (typeof s.value == "number")
              return e.valueFormatter(s);
            if (typeof s.value == "object") {
              if (!s.value)
                return;
              if ("toNumber" in s.value)
                return e.valueFormatter({
                  ...s,
                  value: s.value.toNumber()
                });
              if ("value" in s.value)
                return e.valueFormatter({
                  ...s,
                  value: s.value.value
                });
            }
          }
          return;
        }
        if (t.get("groupDisplayType") === "groupRows" && !t.get("treeData"))
          return;
      } else if (t.get("groupHideOpenParents") && s.column.isRowGroupActive() && typeof s.value == "string" && !((r = e.dataTypeMatcher) != null && r.call(e, s.value)))
        return;
      return e.valueFormatter(s);
    };
}
function _M(e, t, s, i) {
  if (!t[s])
    return !1;
  const r = e[s];
  return r === null ? (t[s] = !1, !1) : i === void 0 ? !!r : r === i;
}
function Sd(e, t) {
  return [
    ["cellRenderer", "agSparklineCellRenderer"],
    ["valueGetter", void 0],
    ["valueParser", void 0],
    ["refData", void 0]
  ].some(
    ([s, i]) => _M(e, t, s, i)
  );
}
function UM(e, t) {
  const s = Nv(e);
  return t.forEach((i) => {
    delete s[i], i === "rowGroup" ? delete s.rowGroupIndex : i === "pivot" && delete s.pivotIndex;
  }), s;
}
var $M = {
  moduleName: "DataType",
  version: de,
  beans: [WM],
  dependsOn: [vM]
}, jM = {
  moduleName: "ColumnFlex",
  version: de,
  beans: [zM]
}, KM = {
  moduleName: "ColumnApi",
  version: de,
  beans: [HM],
  apiFunctions: {
    getColumnDef: wM,
    getDisplayNameForColumn: bM,
    getColumn: SM,
    getColumns: xM,
    applyColumnState: RM,
    getColumnState: FM,
    resetColumnState: PM,
    isPinning: TM,
    isPinningLeft: EM,
    isPinningRight: DM,
    getDisplayedColAfter: AM,
    getDisplayedColBefore: MM,
    setColumnsVisible: IM,
    setColumnsPinned: LM,
    getAllGridColumns: kM,
    getDisplayedLeftColumns: OM,
    getDisplayedCenterColumns: GM,
    getDisplayedRightColumns: BM,
    getAllDisplayedColumns: VM,
    getAllDisplayedVirtualColumns: NM,
    getColumnDefs: yM
  }
};
function qM(e) {
  if (!e || e == null)
    return null;
  const t = /([a-z])([A-Z])/g, s = /([A-Z]+)([A-Z])([a-z])/g;
  return e.replace(t, "$1 $2").replace(s, "$1 $2$3").replace(/\./g, " ").split(" ").map((r) => r.substring(0, 1).toUpperCase() + (r.length > 1 ? r.substring(1, r.length) : "")).join(" ");
}
var YM = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colNames";
  }
  getDisplayNameForColumn(e, t, s = !1) {
    if (!e)
      return null;
    const i = this.getHeaderName(e.getColDef(), e, null, null, t), { aggColNameSvc: r } = this.beans;
    return s && r ? r.getHeaderName(e, i) : i;
  }
  getDisplayNameForProvidedColumnGroup(e, t, s) {
    const i = t == null ? void 0 : t.getColGroupDef();
    return i ? this.getHeaderName(i, null, e, t, s) : null;
  }
  getDisplayNameForColumnGroup(e, t) {
    return this.getDisplayNameForProvidedColumnGroup(e, e.getProvidedColumnGroup(), t);
  }
  // location is where the column is going to appear, ie who is calling us
  getHeaderName(e, t, s, i, r) {
    var o;
    const n = e.headerValueGetter;
    if (n) {
      const a = this.gos.addGridCommonParams({
        colDef: e,
        column: t,
        columnGroup: s,
        providedColumnGroup: i,
        location: r
      });
      return typeof n == "function" ? n(a) : typeof n == "string" ? ((o = this.beans.expressionSvc) == null ? void 0 : o.evaluate(n, a)) ?? null : "";
    } else {
      if (e.headerName != null)
        return e.headerName;
      if (e.field)
        return qM(e.field);
    }
    return "";
  }
}, XM = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colViewport", this.colsWithinViewport = [], this.headerColsWithinViewport = [], this.colsWithinViewportHash = "", this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {};
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.colModel = e.colModel;
  }
  postConstruct() {
    this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
  }
  setScrollPosition(e, t, s = !1) {
    const { visibleCols: i } = this, r = i.isBodyWidthDirty;
    if (!(e === this.scrollWidth && t === this.scrollPosition && !r)) {
      if (this.scrollWidth = e, this.scrollPosition = t, i.isBodyWidthDirty = !0, this.gos.get("enableRtl")) {
        const o = i.bodyWidth;
        this.viewportLeft = o - t - e, this.viewportRight = o - t;
      } else
        this.viewportLeft = t, this.viewportRight = e + t;
      this.colModel.ready && this.checkViewportColumns(s);
    }
  }
  getHeadersToRender(e, t) {
    let s;
    switch (e) {
      case "left":
        s = this.rowsOfHeadersToRenderLeft[t];
        break;
      case "right":
        s = this.rowsOfHeadersToRenderRight[t];
        break;
      default:
        s = this.rowsOfHeadersToRenderCenter[t];
        break;
    }
    return s || [];
  }
  extractViewportColumns() {
    const e = this.visibleCols.centerCols;
    this.isColumnVirtualisationSuppressed() ? (this.colsWithinViewport = e, this.headerColsWithinViewport = e) : (this.colsWithinViewport = e.filter(this.isColumnInRowViewport.bind(this)), this.headerColsWithinViewport = e.filter(this.isColumnInHeaderViewport.bind(this)));
  }
  isColumnVirtualisationSuppressed() {
    return this.suppressColumnVirtualisation || this.viewportRight === 0;
  }
  clear(e) {
    this.rowsOfHeadersToRenderLeft = {}, this.rowsOfHeadersToRenderRight = {}, this.rowsOfHeadersToRenderCenter = {}, e || (this.colsWithinViewportHash = "");
  }
  isColumnInHeaderViewport(e) {
    return e.isAutoHeaderHeight() || ZM(e) ? !0 : this.isColumnInRowViewport(e);
  }
  isColumnInRowViewport(e) {
    if (e.isAutoHeight())
      return !0;
    const t = e.getLeft() || 0, s = t + e.getActualWidth(), i = this.viewportLeft - 200, r = this.viewportRight + 200, n = t < i && s < i, o = t > r && s > r;
    return !n && !o;
  }
  // used by Grid API only
  getViewportColumns() {
    const { leftCols: e, rightCols: t } = this.visibleCols;
    return this.colsWithinViewport.concat(e).concat(t);
  }
  // + rowRenderer
  // if we are not column spanning, this just returns back the virtual centre columns,
  // however if we are column spanning, then different rows can have different virtual
  // columns, so we have to work out the list for each individual row.
  getColsWithinViewport(e) {
    if (!this.colModel.colSpanActive)
      return this.colsWithinViewport;
    const t = (n) => {
      const o = n.getLeft();
      return W(o) && o > this.viewportLeft;
    }, s = this.isColumnVirtualisationSuppressed() ? void 0 : this.isColumnInRowViewport.bind(this), { visibleCols: i } = this, r = i.centerCols;
    return i.getColsForRow(e, r, s, t);
  }
  // checks what columns are currently displayed due to column virtualisation. dispatches an event
  // if the list of columns has changed.
  // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
  checkViewportColumns(e = !1) {
    this.extractViewport() && this.eventSvc.dispatchEvent({
      type: "virtualColumnsChanged",
      afterScroll: e
    });
  }
  calculateHeaderRows() {
    this.clear(!0);
    const e = {}, { leftCols: t, rightCols: s, treeLeft: i, treeRight: r, treeCenter: n } = this.visibleCols;
    this.headerColsWithinViewport.concat(t).concat(s).forEach((l) => e[l.getId()] = !0);
    const a = (l, c, d) => {
      let u = !1;
      for (let h = 0; h < l.length; h++) {
        const p = l[h];
        let g = !1;
        if (Ri(p))
          g = e[p.getId()] === !0;
        else {
          const m = p.getDisplayedChildren();
          m && (g = a(m, c, d + 1));
        }
        g && (u = !0, c[d] || (c[d] = []), c[d].push(p));
      }
      return u;
    };
    a(i, this.rowsOfHeadersToRenderLeft, 0), a(r, this.rowsOfHeadersToRenderRight, 0), a(n, this.rowsOfHeadersToRenderCenter, 0);
  }
  extractViewport() {
    const e = (i) => `${i.getId()}-${i.getPinned() || "normal"}`;
    this.extractViewportColumns();
    const t = this.getViewportColumns().map(e).join("#"), s = this.colsWithinViewportHash !== t;
    return s && (this.colsWithinViewportHash = t, this.calculateHeaderRows()), s;
  }
};
function ZM(e) {
  for (; e; ) {
    if (e.isAutoHeaderHeight())
      return !0;
    e = e.getParent();
  }
  return !1;
}
var QM = class extends L {
  constructor() {
    super(...arguments), this.beanName = "agCompUtils";
  }
  adaptFunction(e, t) {
    if (!e.cellRenderer)
      return null;
    class s {
      refresh() {
        return !1;
      }
      getGui() {
        return this.eGui;
      }
      init(r) {
        const n = t(r), o = typeof n;
        if (o === "string" || o === "number" || o === "boolean") {
          this.eGui = ss("<span>" + n + "</span>");
          return;
        }
        if (n == null) {
          this.eGui = ss("<span></span>");
          return;
        }
        this.eGui = n;
      }
    }
    return s;
  }
}, JM = {
  moduleName: "CellRendererFunction",
  version: de,
  beans: [QM]
}, eI = class extends L {
  constructor() {
    super(...arguments), this.beanName = "registry", this.agGridDefaults = {}, this.agGridDefaultParams = {}, this.jsComps = {}, this.dynamicBeans = {}, this.selectors = {}, this.icons = {};
  }
  postConstruct() {
    const e = this.gos.get("components");
    e != null && Object.entries(e).forEach(([t, s]) => {
      this.jsComps[t] = s;
    });
  }
  registerModule(e) {
    const { icons: t, userComponents: s, dynamicBeans: i, selectors: r } = e;
    if (s) {
      const n = (o, a, l) => {
        this.agGridDefaults[o] = a, l && (this.agGridDefaultParams[o] = l);
      };
      for (const o of Object.keys(s)) {
        const a = s[o];
        typeof a == "object" ? n(o, a.classImp, a.params) : n(o, a);
      }
    }
    if (i)
      for (const n of Object.keys(i))
        this.dynamicBeans[n] = i[n];
    if (r == null || r.forEach((n) => {
      this.selectors[n.selector] = n;
    }), t)
      for (const n of Object.keys(t))
        this.icons[n] = t[n];
  }
  getUserComponent(e, t) {
    var a;
    const s = (l, c, d) => ({
      componentFromFramework: c,
      component: l,
      params: d
    }), { frameworkOverrides: i } = this.beans, r = i.frameworkComponent(t, this.gos.get("components"));
    if (r != null)
      return s(r, !0);
    const n = this.jsComps[t];
    if (n) {
      const l = i.isFrameworkComponent(n);
      return s(n, l);
    }
    const o = this.agGridDefaults[t];
    return o ? s(o, !1, this.agGridDefaultParams[t]) : ((a = this.beans.validation) == null || a.missingUserComponent(e, t, this.agGridDefaults, this.jsComps), null);
  }
  createDynamicBean(e, t, ...s) {
    const i = this.dynamicBeans[e];
    if (i == null) {
      if (t)
        throw new Error(Ws(256));
      return;
    }
    return new i(...s);
  }
  getSelector(e) {
    return this.selectors[e];
  }
  getIcon(e) {
    return this.icons[e];
  }
}, tI = 23, sI = class extends L {
  constructor() {
    super(...arguments), this.beanName = "ctrlsSvc", this.params = {}, this.ready = !1, this.readyCallbacks = [];
  }
  postConstruct() {
    var e, t;
    this.addEventListener(
      "ready",
      () => {
        this.updateReady(), this.ready && (this.readyCallbacks.forEach((s) => s(this.params)), this.readyCallbacks.length = 0);
      },
      ((t = (e = this.beans.frameworkOverrides).runWhenReadyAsync) == null ? void 0 : t.call(e)) ?? !1
    );
  }
  updateReady() {
    const e = Object.values(this.params);
    this.ready = e.length === tI && e.every((t) => (t == null ? void 0 : t.isAlive()) ?? !1);
  }
  whenReady(e, t) {
    this.ready ? t(this.params) : this.readyCallbacks.push(t), e.addDestroyFunc(() => {
      const s = this.readyCallbacks.indexOf(t);
      s >= 0 && this.readyCallbacks.splice(s, 1);
    });
  }
  register(e, t) {
    this.params[e] = t, this.updateReady(), this.ready && this.dispatchLocalEvent({ type: "ready" }), t.addDestroyFunc(() => {
      this.updateReady();
    });
  }
  get(e) {
    return this.params[e];
  }
  getGridBodyCtrl() {
    return this.params.gridBodyCtrl;
  }
  getHeaderRowContainerCtrls() {
    const { leftHeader: e, centerHeader: t, rightHeader: s } = this.params;
    return [e, s, t];
  }
  getHeaderRowContainerCtrl(e) {
    const t = this.params;
    switch (e) {
      case "left":
        return t.leftHeader;
      case "right":
        return t.rightHeader;
      default:
        return t.centerHeader;
    }
  }
  getScrollFeature() {
    return this.getGridBodyCtrl().scrollFeature;
  }
}, iI = (
  /*css*/
  ':where(.ag-root-wrapper,.ag-popup,.ag-dnd-ghost,.ag-chart),:where(.ag-root-wrapper,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]){box-sizing:border-box;&:after,&:before{box-sizing:border-box}&:where(div,span,label):focus-visible{box-shadow:inset var(--ag-focus-shadow);outline:none}}:where(.ag-root-wrapper,.ag-popup,.ag-dnd-ghost,.ag-chart) :where([class^=ag-]) ::-ms-clear{display:none}.ag-aria-description-container{border:0;z-index:9999;clip:rect(1px,1px,1px,1px);height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}.ag-hidden{display:none!important}.ag-invisible{visibility:hidden!important}.ag-unselectable{-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-selectable{-webkit-user-select:text;-moz-user-select:text;user-select:text}.ag-tab-guard{display:block;height:0;position:absolute;width:0}:where(.ag-virtual-list-viewport) .ag-tab-guard{position:sticky}.ag-tab-guard-top{top:1px}.ag-tab-guard-bottom{bottom:1px}.ag-shake-left-to-right{animation-direction:alternate;animation-duration:.2s;animation-iteration-count:infinite;animation-name:ag-shake-left-to-right}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}.ag-body-horizontal-scroll-viewport,.ag-body-vertical-scroll-viewport,.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport,.ag-virtual-list-viewport{flex:1 1 auto;height:100%;min-width:0;overflow:hidden;position:relative}.ag-body-viewport,.ag-center-cols-viewport,.ag-floating-bottom-viewport,.ag-floating-top-viewport,.ag-header-viewport,.ag-sticky-bottom-viewport,.ag-sticky-top-viewport{overflow-x:auto;-ms-overflow-style:none!important;scrollbar-width:none!important;&::-webkit-scrollbar{display:none!important}}.ag-body-viewport{display:flex;overflow-x:hidden;&:where(.ag-layout-normal){overflow-y:auto;-webkit-overflow-scrolling:touch}}.ag-sticky-bottom-container,.ag-sticky-top-container{min-height:1px}.ag-center-cols-viewport{min-height:100%;width:100%}.ag-body-horizontal-scroll-viewport{overflow-x:scroll}.ag-body-vertical-scroll-viewport{overflow-y:scroll}.ag-virtual-list-viewport{overflow:auto;width:100%}.ag-body-container,.ag-body-horizontal-scroll-container,.ag-body-vertical-scroll-container,.ag-center-cols-container,.ag-floating-bottom-container,.ag-floating-bottom-full-width-container,.ag-floating-top-container,.ag-full-width-container,.ag-header-container,.ag-pinned-left-cols-container,.ag-pinned-right-cols-container,.ag-sticky-bottom-container,.ag-sticky-top-container,.ag-virtual-list-container{position:relative}.ag-floating-bottom-container,.ag-floating-top-container,.ag-header-container,.ag-sticky-bottom-container,.ag-sticky-top-container{height:100%;white-space:nowrap}.ag-center-cols-container,.ag-pinned-right-cols-container{display:block}.ag-body-horizontal-scroll-container{height:100%}.ag-body-vertical-scroll-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container,.ag-full-width-container,.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{pointer-events:none;position:absolute;top:0}:where(.ag-ltr) .ag-floating-bottom-full-width-container,:where(.ag-ltr) .ag-floating-top-full-width-container,:where(.ag-ltr) .ag-full-width-container,:where(.ag-ltr) .ag-sticky-bottom-full-width-container,:where(.ag-ltr) .ag-sticky-top-full-width-container{left:0}:where(.ag-rtl) .ag-floating-bottom-full-width-container,:where(.ag-rtl) .ag-floating-top-full-width-container,:where(.ag-rtl) .ag-full-width-container,:where(.ag-rtl) .ag-sticky-bottom-full-width-container,:where(.ag-rtl) .ag-sticky-top-full-width-container{right:0}.ag-full-width-container{width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{display:inline-block;height:100%;overflow:hidden;width:100%}.ag-virtual-list-container{overflow:hidden}.ag-body{display:flex;flex:1 1 auto;flex-direction:row!important;min-height:0;position:relative}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:flex;min-height:0;min-width:0;position:relative;&:where(.ag-scrollbar-invisible){bottom:0;position:absolute;&:where(.ag-apple-scrollbar){opacity:0;transition:opacity .4s;visibility:hidden;&:where(.ag-scrollbar-scrolling,.ag-scrollbar-active){opacity:1;visibility:visible}}}}.ag-body-horizontal-scroll{width:100%;&:where(.ag-scrollbar-invisible){left:0;right:0}}.ag-body-vertical-scroll{height:100%;&:where(.ag-scrollbar-invisible){top:0;z-index:10}}:where(.ag-ltr) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){right:0}}:where(.ag-rtl) .ag-body-vertical-scroll{&:where(.ag-scrollbar-invisible){left:0}}.ag-force-vertical-scroll{overflow-y:scroll!important}.ag-horizontal-left-spacer,.ag-horizontal-right-spacer{height:100%;min-width:0;overflow-x:scroll;&:where(.ag-scroller-corner){overflow-x:hidden}}:where(.ag-row-animation) .ag-row{transition:transform .4s,top .4s,opacity .2s;&:where(.ag-after-created){transition:transform .4s,top .4s,height .4s,opacity .2s}}:where(.ag-row-no-animation) .ag-row{transition:none}.ag-row-loading{align-items:center;display:flex}.ag-row-position-absolute{position:absolute}.ag-row-position-relative{position:relative}.ag-full-width-row{overflow:hidden;pointer-events:all}.ag-row-inline-editing{z-index:1}.ag-row-dragging{z-index:2}.ag-stub-cell{align-items:center;display:flex}.ag-cell{display:inline-block;height:100%;position:absolute;white-space:nowrap;&:focus-visible{box-shadow:none}}.ag-cell-value{flex:1 1 auto}.ag-cell-value,.ag-group-value{overflow:hidden;text-overflow:ellipsis}.ag-cell-wrap-text{white-space:normal;word-break:break-word}:where(.ag-cell) .ag-icon{display:inline-block;vertical-align:middle}.ag-floating-top{border-bottom:var(--ag-pinned-row-border)}.ag-floating-bottom,.ag-floating-top{display:flex;overflow:hidden;position:relative;white-space:nowrap;width:100%}.ag-floating-bottom{border-top:var(--ag-pinned-row-border)}.ag-sticky-bottom,.ag-sticky-top{background-color:var(--ag-background-color);display:flex;height:0;overflow:hidden;position:absolute;width:100%}.ag-opacity-zero{opacity:0!important}.ag-cell-label-container{align-items:center;display:flex;flex-direction:row-reverse;height:100%;justify-content:space-between;width:100%}:where(.ag-right-aligned-header){.ag-cell-label-container{flex-direction:row}.ag-header-cell-text{text-align:end}}.ag-column-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr){direction:ltr;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row}}:where(.ag-rtl){direction:rtl;text-align:right;.ag-body,.ag-body-horizontal-scroll,.ag-body-viewport,.ag-floating-bottom,.ag-floating-top,.ag-header,.ag-sticky-bottom,.ag-sticky-top{flex-direction:row-reverse}.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{display:block}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(180deg)}}:where(.ag-rtl){.ag-icon-contracted,.ag-icon-expanded,.ag-icon-tree-closed{transform:rotate(-180deg)}}.ag-measurement-container{height:0;overflow:hidden;visibility:hidden;width:0}.ag-measurement-element-border{display:inline-block;&:before{border-left:var(--ag-internal-measurement-border);content:"";display:block}}.ag-group{position:relative;width:100%}.ag-group-title-bar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-title{display:inline;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:where(.ag-group-title-bar) .ag-group-title{cursor:default}.ag-group-toolbar{align-items:center;display:flex;padding:var(--ag-spacing)}.ag-group-container{display:flex}.ag-disabled .ag-group-container{pointer-events:none}.ag-disabled-group-container,.ag-disabled-group-title-bar{opacity:.5}.ag-group-container-horizontal{flex-flow:row wrap}.ag-group-container-vertical{flex-direction:column}.ag-group-title-bar-icon{cursor:pointer;flex:none}:where(.ag-ltr) .ag-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-group-title-bar-icon{margin-left:var(--ag-spacing)}:where(.ag-group-item-alignment-stretch) .ag-group-item{align-items:stretch}:where(.ag-group-item-alignment-start) .ag-group-item{align-items:flex-start}:where(.ag-group-item-alignment-end) .ag-group-item{align-items:flex-end}.ag-popup-child{top:0;z-index:5;&:where(:not(.ag-tooltip-custom)){box-shadow:var(--ag-popup-shadow)}}.ag-popup-editor{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-large-text-input{display:block}:where(.ag-ltr) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-left:var(--ag-row-group-indent-size)}:where(.ag-rtl) .ag-row:not(.ag-row-level-0) .ag-pivot-leaf-group{margin-right:var(--ag-row-group-indent-size)}:where(.ag-ltr) .ag-row-group-leaf-indent{margin-left:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}:where(.ag-rtl) .ag-row-group-leaf-indent{margin-right:calc(var(--ag-cell-widget-spacing) + var(--ag-icon-size))}.ag-value-change-delta{padding:0 2px}.ag-value-change-delta-up{color:var(--ag-value-change-delta-up-color)}.ag-value-change-delta-down{color:var(--ag-value-change-delta-down-color)}.ag-value-change-value{background-color:transparent;border-radius:1px;padding-left:1px;padding-right:1px;transition:background-color 1s}.ag-value-change-value-highlight{background-color:var(--ag-value-change-value-highlight-background-color);transition:background-color .1s}.ag-cell-data-changed{background-color:var(--ag-value-change-value-highlight-background-color)!important}.ag-cell-data-changed-animation{background-color:transparent}.ag-cell-highlight{background-color:var(--ag-range-selection-highlight-color)!important}.ag-row{background-color:var(--ag-background-color);border-bottom:var(--ag-row-border);color:var(--ag-cell-text-color);font-family:var(--ag-cell-font-family);font-size:var(--ag-data-font-size);height:var(--ag-row-height);white-space:nowrap;width:100%;--ag-internal-content-line-height:calc(min(var(--ag-row-height), var(--ag-line-height, 1000px)) - var(--ag-internal-row-border-width, 1px))}:where(.ag-body-vertical-content-no-gap>div>div>div,.ag-body-vertical-content-no-gap>div>div>div>div)>.ag-row-last{border-bottom-color:transparent}.ag-sticky-bottom{border-top:var(--ag-row-border);box-sizing:content-box!important}.ag-group-contracted,.ag-group-expanded{cursor:pointer}.ag-cell,.ag-full-width-row .ag-cell-wrapper.ag-row-group{border:1px solid transparent;line-height:var(--ag-internal-content-line-height);-webkit-font-smoothing:subpixel-antialiased}:where(.ag-ltr) .ag-cell{border-right:var(--ag-column-border)}:where(.ag-rtl) .ag-cell{border-left:var(--ag-column-border)}:where(.ag-ltr) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-right-color:transparent}:where(.ag-rtl) :where(.ag-body-horizontal-content-no-gap) .ag-column-last{border-left-color:transparent}.ag-cell-wrapper{align-items:center;display:flex;>:where(:not(.ag-cell-value,.ag-group-value)){align-items:center;display:flex;height:var(--ag-internal-content-line-height)}&:where(.ag-row-group){align-items:flex-start}:where(.ag-full-width-row) &:where(.ag-row-group){align-items:center;height:100%}}:where(.ag-ltr) .ag-cell-wrapper{padding-left:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-rtl) .ag-cell-wrapper{padding-right:calc(var(--ag-indentation-level)*var(--ag-row-group-indent-size))}:where(.ag-ltr) .ag-row>.ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-row>.ag-cell-wrapper.ag-row-group{padding-right:calc(var(--ag-cell-horizontal-padding) + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-cell-focus:not(.ag-cell-range-selected):focus-within,.ag-cell-range-single-cell,.ag-cell-range-single-cell.ag-cell-range-handle,.ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),.ag-full-width-row.ag-row-focus:focus .ag-cell-wrapper.ag-row-group{border:1px solid;border-color:var(--ag-range-selection-border-color);border-style:var(--ag-range-selection-border-style);outline:initial}:where(.ag-ltr) .ag-group-contracted,:where(.ag-ltr) .ag-group-expanded,:where(.ag-ltr) .ag-row-drag,:where(.ag-ltr) .ag-selection-checkbox{margin-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-group-contracted,:where(.ag-rtl) .ag-group-expanded,:where(.ag-rtl) .ag-row-drag,:where(.ag-rtl) .ag-selection-checkbox{margin-left:var(--ag-cell-widget-spacing)}:where(.ag-ltr) .ag-group-child-count{margin-left:3px}:where(.ag-rtl) .ag-group-child-count{margin-right:3px}.ag-row-highlight-above:after,.ag-row-highlight-below:after{background-color:var(--ag-range-selection-border-color);content:"";height:1px;position:absolute;width:calc(100% - 1px)}:where(.ag-ltr) .ag-row-highlight-above:after,:where(.ag-ltr) .ag-row-highlight-below:after{left:1px}:where(.ag-rtl) .ag-row-highlight-above:after,:where(.ag-rtl) .ag-row-highlight-below:after{right:1px}.ag-row-highlight-above:after{top:0}.ag-row-highlight-below:after{bottom:0}.ag-row-odd{background-color:var(--ag-odd-row-background-color)}.ag-row-selected:before{background-color:var(--ag-selected-row-background-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-full-width-row.ag-row-group:before,.ag-row-hover:not(.ag-full-width-row):before{background-color:var(--ag-row-hover-color);content:"";display:block;inset:0;pointer-events:none;position:absolute}.ag-row-hover.ag-row-selected:before{background-color:var(--ag-row-hover-color);background-image:linear-gradient(var(--ag-selected-row-background-color),var(--ag-selected-row-background-color))}.ag-row-hover.ag-full-width-row.ag-row-group>*{position:relative}.ag-column-hover{background-color:var(--ag-column-hover-color)}.ag-right-aligned-cell{font-variant-numeric:tabular-nums}:where(.ag-ltr) .ag-right-aligned-cell{text-align:right}:where(.ag-rtl) .ag-right-aligned-cell{text-align:left}.ag-right-aligned-cell .ag-cell-value,.ag-right-aligned-cell .ag-group-value{margin-left:auto}:where(.ag-ltr) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-ltr) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level));padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}:where(.ag-rtl) .ag-cell:not(.ag-cell-inline-editing),:where(.ag-rtl) .ag-full-width-row .ag-cell-wrapper.ag-row-group{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px + var(--ag-row-group-indent-size)*var(--ag-indentation-level))}.ag-row>.ag-cell-wrapper{padding-left:calc(var(--ag-cell-horizontal-padding) - 1px);padding-right:calc(var(--ag-cell-horizontal-padding) - 1px)}.ag-row-dragging{cursor:move;opacity:.5}.ag-details-row{background-color:var(--ag-background-color);padding:calc(var(--ag-spacing)*3.75)}.ag-layout-auto-height,.ag-layout-print{.ag-center-cols-container,.ag-center-cols-viewport{min-height:150px}}.ag-overlay-loading-wrapper{background-color:var(--ag-modal-overlay-background-color)}.ag-skeleton-container{align-content:center;height:100%;width:100%}.ag-skeleton-effect{animation:ag-skeleton-loading 1.5s ease-in-out .5s infinite;background-color:var(--ag-row-loading-skeleton-effect-color);border-radius:.25rem;height:1em;width:100%}:where(.ag-ltr) .ag-right-aligned-cell .ag-skeleton-effect{margin-left:auto}:where(.ag-rtl) .ag-right-aligned-cell .ag-skeleton-effect{margin-right:auto}@keyframes ag-skeleton-loading{0%{opacity:1}50%{opacity:.4}to{opacity:1}}.ag-loading{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-loading{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-loading{padding-right:var(--ag-cell-horizontal-padding)}:where(.ag-ltr) .ag-loading-icon{padding-right:var(--ag-cell-widget-spacing)}:where(.ag-rtl) .ag-loading-icon{padding-left:var(--ag-cell-widget-spacing)}.ag-icon-loading{animation-duration:1s;animation-iteration-count:infinite;animation-name:spin;animation-timing-function:linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.ag-input-wrapper,.ag-picker-field-wrapper{align-items:center;display:flex;flex:1 1 auto;line-height:normal;position:relative}.ag-input-field{align-items:center;display:flex;flex-direction:row}.ag-input-field-input:where(:not([type=checkbox],[type=radio])){flex:1 1 auto;min-width:0;width:100%}.ag-header{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);color:var(--ag-header-text-color);display:flex;font-family:var(--ag-header-font-family);font-size:var(--ag-header-font-size);font-weight:var(--ag-header-font-weight);overflow:hidden;white-space:nowrap;width:100%}.ag-header-row{height:var(--ag-header-height);position:absolute}.ag-floating-filter-button-button,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,:where(.ag-header-cell-sortable) .ag-header-cell-label{cursor:pointer}:where(.ag-ltr) .ag-header-expand-icon{margin-left:4px}:where(.ag-rtl) .ag-header-expand-icon{margin-right:4px}.ag-header-row:where(:not(:first-child)){:where(.ag-header-cell:not(.ag-header-span-height.ag-header-span-total,.ag-header-parent-hidden),.ag-header-group-cell.ag-header-group-cell-with-group){border-top:var(--ag-header-row-border)}}.ag-header-row:where(:not(.ag-header-row-column-group)){overflow:hidden}:where(.ag-header.ag-header-allow-overflow) .ag-header-row{overflow:visible}.ag-header-cell{display:inline-flex;overflow:hidden}.ag-header-group-cell{display:flex}.ag-header-cell,.ag-header-group-cell{align-items:center;gap:var(--ag-cell-widget-spacing);height:100%;padding:0 var(--ag-cell-horizontal-padding);position:absolute}@property --ag-internal-moving-color{syntax:"<color>";inherits:false;initial-value:transparent}@property --ag-internal-hover-color{syntax:"<color>";inherits:false;initial-value:transparent}.ag-header-cell:where(:not(.ag-floating-filter)),.ag-header-group-cell{&:before{background-image:linear-gradient(var(--ag-internal-hover-color),var(--ag-internal-hover-color)),linear-gradient(var(--ag-internal-moving-color),var(--ag-internal-moving-color));content:"";inset:0;position:absolute;--ag-internal-moving-color:transparent;--ag-internal-hover-color:transparent;transition:--ag-internal-moving-color var(--ag-header-cell-background-transition-duration),--ag-internal-hover-color var(--ag-header-cell-background-transition-duration)}&:where(:hover):before{--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}&:where(.ag-header-cell-moving):before{--ag-internal-moving-color:var(--ag-header-cell-moving-background-color);--ag-internal-hover-color:var(--ag-header-cell-hover-background-color)}}:where(.ag-header-cell:not(.ag-floating-filter) *,.ag-header-group-cell *){position:relative;z-index:1}.ag-header-cell-menu-button:where(:not(.ag-header-menu-always-show)){opacity:0;transition:opacity .2s}.ag-header-cell-filter-button,:where(.ag-header-cell.ag-header-active) .ag-header-cell-menu-button{opacity:1}.ag-header-cell-label,.ag-header-group-cell-label{align-items:center;align-self:stretch;display:flex;flex:1 1 auto;overflow:hidden;padding:5px 0}:where(.ag-ltr) .ag-sort-indicator-icon{padding-left:var(--ag-spacing)}:where(.ag-rtl) .ag-sort-indicator-icon{padding-right:var(--ag-spacing)}.ag-header-cell-label{text-overflow:ellipsis}.ag-header-group-cell-label.ag-sticky-label{flex:none;max-width:100%;overflow:visible;position:sticky}:where(.ag-ltr) .ag-header-group-cell-label.ag-sticky-label{left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-header-group-cell-label.ag-sticky-label{right:var(--ag-cell-horizontal-padding)}.ag-header-cell-text,.ag-header-group-text{overflow:hidden;text-overflow:ellipsis}.ag-header-cell-text{word-break:break-word}.ag-header-cell-comp-wrapper{width:100%}:where(.ag-header-group-cell) .ag-header-cell-comp-wrapper{display:flex}:where(.ag-header-cell:not(.ag-header-cell-auto-height)) .ag-header-cell-comp-wrapper{align-items:center;display:flex;height:100%}.ag-header-cell-wrap-text .ag-header-cell-comp-wrapper{white-space:normal}.ag-header-cell-comp-wrapper-limited-height>*{overflow:hidden}:where(.ag-right-aligned-header) .ag-header-cell-label{flex-direction:row-reverse}:where(.ag-ltr) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell:not(.ag-right-aligned-header)){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-ltr) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-header-cell.ag-right-aligned-header){.ag-header-label-icon,.ag-header-menu-icon{margin-left:var(--ag-spacing)}}.ag-header-cell:after,.ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{content:"";height:var(--ag-header-column-border-height);position:absolute;top:calc(50% - var(--ag-header-column-border-height)*.5);z-index:1}:where(.ag-ltr) .ag-header-cell:after,:where(.ag-ltr) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-right:var(--ag-header-column-border);right:0}:where(.ag-rtl) .ag-header-cell:after,:where(.ag-rtl) .ag-header-group-cell:where(:not(.ag-header-span-height.ag-header-group-cell-no-group)):after{border-left:var(--ag-header-column-border);left:0}.ag-header-highlight-after:after,.ag-header-highlight-before:after{background-color:var(--ag-accent-color);content:"";height:100%;position:absolute;width:1px}:where(.ag-ltr) .ag-header-highlight-before:after{left:0}:where(.ag-rtl) .ag-header-highlight-before:after{right:0}:where(.ag-ltr) .ag-header-highlight-after:after{right:0;:where(.ag-pinned-left-header) &{right:1px}}:where(.ag-rtl) .ag-header-highlight-after:after{left:0;:where(.ag-pinned-left-header) &{left:1px}}.ag-header-cell-resize{align-items:center;cursor:ew-resize;display:flex;height:100%;position:absolute;top:0;width:8px;z-index:2;&:after{background-color:var(--ag-header-column-resize-handle-color);content:"";height:var(--ag-header-column-resize-handle-height);position:absolute;top:calc(50% - var(--ag-header-column-resize-handle-height)*.5);width:var(--ag-header-column-resize-handle-width);z-index:1}}:where(.ag-ltr) .ag-header-cell-resize{right:-3px;&:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-rtl) .ag-header-cell-resize{left:-3px;&:after{right:calc(50% - var(--ag-header-column-resize-handle-width))}}:where(.ag-header-cell.ag-header-span-height) .ag-header-cell-resize:after{height:calc(100% - var(--ag-spacing)*4);top:calc(var(--ag-spacing)*2)}.ag-header-group-cell-no-group:where(.ag-header-span-height){display:none}.ag-sort-indicator-container{display:flex;gap:var(--ag-spacing)}.ag-layout-print{&.ag-body{display:block;height:unset}&.ag-root-wrapper{display:inline-block}.ag-body-horizontal-scroll,.ag-body-vertical-scroll{display:none}&.ag-force-vertical-scroll{overflow-y:visible!important}}@media print{.ag-root-wrapper.ag-layout-print{display:table;.ag-body-horizontal-scroll-viewport,.ag-body-viewport,.ag-center-cols-container,.ag-center-cols-viewport,.ag-root,.ag-root-wrapper-body,.ag-virtual-list-viewport{display:block!important;height:auto!important;overflow:hidden!important}.ag-cell,.ag-row{-moz-column-break-inside:avoid;break-inside:avoid}}}ag-grid,ag-grid-angular{display:block}.ag-chart,.ag-dnd-ghost,.ag-popup,.ag-root-wrapper{cursor:default;line-height:normal;white-space:normal;-webkit-font-smoothing:antialiased;background-color:var(--ag-background-color);color:var(--ag-text-color);color-scheme:var(--ag-browser-color-scheme);font-family:var(--ag-font-family);font-size:var(--ag-font-size);--ag-indentation-level:0}.ag-root-wrapper{border:var(--ag-wrapper-border);border-radius:var(--ag-wrapper-border-radius);display:flex;flex-direction:column;overflow:hidden;position:relative;&.ag-layout-normal{height:100%}}.ag-root-wrapper-body{display:flex;flex-direction:row;&.ag-layout-normal{flex:1 1 auto;height:0;min-height:0}}.ag-root{display:flex;flex-direction:column;position:relative;&.ag-layout-auto-height,&.ag-layout-normal{flex:1 1 auto;overflow:hidden;width:0}&.ag-layout-normal{height:100%}}:where(.ag-button){background:none;border:none;color:inherit;cursor:pointer;font-family:inherit;font-size:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0;text-indent:inherit;text-shadow:inherit;text-transform:inherit;word-spacing:inherit;&:focus-visible{box-shadow:var(--ag-focus-shadow);outline:none}}.ag-standard-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:var(--ag-background-color);border:var(--ag-input-border);border-radius:var(--ag-border-radius);cursor:pointer;font-family:inherit;padding:var(--ag-spacing) calc(var(--ag-spacing)*2);&:hover{background-color:var(--ag-row-hover-color)}&:active{border-color:var(--ag-accent-color)}&:disabled{background-color:var(--ag-input-disabled-background-color);border:var(--ag-input-disabled-border);color:var(--ag-input-disabled-text-color)}}.ag-drag-handle{color:var(--ag-drag-handle-color);cursor:grab}.ag-list-item,.ag-virtual-list-item{height:var(--ag-list-item-height)}.ag-virtual-list-item{position:absolute;width:100%}.ag-select-list{background-color:var(--ag-background-color);border:var(--ag-input-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);overflow:hidden auto}.ag-list-item{align-items:center;display:flex;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;&.ag-active-item{background-color:var(--ag-row-hover-color)}}.ag-select-list-item{cursor:default;-webkit-user-select:none;-moz-user-select:none;user-select:none;:where(span){overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}:where(.ag-ltr) .ag-select-list-item{padding-left:calc(var(--ag-cell-horizontal-padding)/2)}:where(.ag-rtl) .ag-select-list-item{padding-right:calc(var(--ag-cell-horizontal-padding)/2)}.ag-list-item-hovered:after{background-color:var(--ag-accent-color);content:"";height:1px;left:0;position:absolute;right:0}.ag-item-highlight-top:after{top:0}.ag-item-highlight-bottom:after{bottom:0}.ag-column-select-column-group-readonly,.ag-column-select-column-readonly,.ag-disabled,[disabled]{.ag-icon{opacity:.5}&.ag-icon-grip{opacity:.35}}.ag-column-select-column-readonly{&.ag-icon-grip,.ag-icon-grip{opacity:.35}}.ag-chart-menu-icon,.ag-chart-settings-next,.ag-chart-settings-prev,.ag-column-group-icons,.ag-column-select-header-icon,.ag-filter-toolpanel-expand,.ag-floating-filter-button-button,.ag-group-title-bar-icon,.ag-header-cell-filter-button,.ag-header-cell-menu-button,.ag-header-expand-icon,.ag-panel-title-bar-button,.ag-panel-title-bar-button-icon,.ag-set-filter-group-icons,:where(.ag-group-contracted) .ag-icon,:where(.ag-group-expanded) .ag-icon{&:hover{background-color:var(--ag-icon-button-hover-color);border-radius:1px;box-shadow:0 0 0 4px var(--ag-icon-button-hover-color)}}.ag-filter-active{--ag-icon-button-hover-color:color-mix(in srgb,transparent,var(--ag-accent-color) 28%);background-color:color-mix(in srgb,transparent,var(--ag-accent-color) 14%);border-radius:1px;outline:solid 4px color-mix(in srgb,transparent,var(--ag-accent-color) 14%);position:relative;&:after{background-color:var(--ag-accent-color);border-radius:50%;content:"";height:6px;position:absolute;top:-1px;width:6px}:where(.ag-icon-filter){clip-path:path("M8,0C8,4.415 11.585,8 16,8L16,16L0,16L0,0L8,0Z")}}:where(.ag-ltr) .ag-filter-active{&:after{right:-1px}}:where(.ag-rtl) .ag-filter-active{&:after{left:-1px}}.ag-menu{background-color:var(--ag-menu-background-color);border:var(--ag-menu-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-menu-shadow);color:var(--ag-menu-text-color);max-height:100%;overflow-y:auto}.ag-menu,.ag-resizer{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-resizer{pointer-events:none;z-index:1}:where(.ag-resizer){&.ag-resizer-topLeft{height:5px;left:0;top:0;width:5px}&.ag-resizer-top{cursor:ns-resize;height:5px;left:5px;right:5px;top:0}&.ag-resizer-topRight{height:5px;right:0;top:0;width:5px}&.ag-resizer-right{bottom:5px;cursor:ew-resize;right:0;top:5px;width:5px}&.ag-resizer-bottomRight{bottom:0;height:5px;right:0;width:5px}&.ag-resizer-bottom{bottom:0;cursor:ns-resize;height:5px;left:5px;right:5px}&.ag-resizer-bottomLeft{bottom:0;height:5px;left:0;width:5px}&.ag-resizer-left{bottom:5px;cursor:ew-resize;left:0;top:5px;width:5px}}:where(.ag-ltr) :where(.ag-resizer){&.ag-resizer-topLeft{cursor:nwse-resize}&.ag-resizer-topRight{cursor:nesw-resize}&.ag-resizer-bottomRight{cursor:nwse-resize}&.ag-resizer-bottomLeft{cursor:nesw-resize}}:where(.ag-rtl) :where(.ag-resizer){&.ag-resizer-topLeft{cursor:nesw-resize}&.ag-resizer-topRight{cursor:nwse-resize}&.ag-resizer-bottomRight{cursor:nesw-resize}&.ag-resizer-bottomLeft{cursor:nwse-resize}}'
), kC, OC, Gh = typeof window != "object" || !((OC = (kC = window == null ? void 0 : window.document) == null ? void 0 : kC.fonts) != null && OC.forEach), gu = /* @__PURE__ */ new WeakMap(), eo = (e, t, s) => {
  if (Gh)
    return;
  const i = t.getRootNode() === document ? document.head : t;
  let r = gu.get(i);
  if (r || (r = { css: /* @__PURE__ */ new Set() }, gu.set(i, r)), r.css.has(e))
    return;
  const n = document.createElement("style");
  n.dataset.agGlobalCss = s, n.textContent = e, r.last ? r.last.insertAdjacentElement("afterend", n) : i.insertBefore(n, i.querySelector(":not(title, meta)")), r.css.add(e), r.last = n;
}, sy = (e) => {
  eo(iI, e, "core"), Array.from(cE()).sort((t, s) => t.moduleName.localeCompare(s.moduleName)).forEach(
    (t) => {
      var s;
      return (s = t.css) == null ? void 0 : s.forEach((i) => eo(i, e, `module-${t.moduleName}`));
    }
  );
}, fu = /* @__PURE__ */ new Set(), rI = (e) => {
  fu.add(e);
}, nI = (e) => {
  if (fu.delete(e), fu.size === 0) {
    gu = /* @__PURE__ */ new WeakMap();
    for (const t of document.head.querySelectorAll("style[data-ag-global-css]"))
      t.remove();
  }
}, os = (e) => new iy(e), dr = "$default", oI = 0, iy = class {
  constructor({ feature: e, params: t, modeParams: s = {}, css: i, cssImports: r }) {
    this.feature = e, this.css = i, this.cssImports = r, this.modeParams = {
      // NOTE: it's important that default is defined first, putting it
      // first in iteration order, because when merging params the default
      // params override any prior modal params, so modal params in this
      // part need to come after default params to prevent them from being
      // immediately overridden.
      [dr]: {
        ...s[dr] ?? {},
        ...t ?? {}
      },
      ...s
    };
  }
  use(e) {
    let t = this._inject;
    if (t == null) {
      let { css: s } = this;
      if (s) {
        const i = `ag-theme-${this.feature ?? "part"}-${++oI}`;
        typeof s == "function" && (s = s()), s = `:where(.${i}) {
${s}
}
`;
        for (const r of this.cssImports ?? [])
          s = `@import url(${JSON.stringify(r)});
${s}`;
        t = { css: s, class: i };
      } else
        t = !1;
      this._inject = t;
    }
    return t && e && eo(t.css, e, t.class), t ? t.class : !1;
  }
}, aI = (e) => e.replace(/[A-Z]/g, (t) => `-${t}`).toLowerCase(), ry = (e) => `--ag-${aI(e)}`, $i = (e) => `var(${ry(e)})`, lI = (e, t, s) => Math.max(t, Math.min(s, e)), cI = (e) => {
  const t = /* @__PURE__ */ new Map();
  return (s) => {
    const i = s;
    return t.has(i) || t.set(i, e(s)), t.get(i);
  };
}, ur = (e) => ({ ref: "accentColor", mix: e }), ms = (e) => ({ ref: "foregroundColor", mix: e }), Ns = (e) => ({
  ref: "foregroundColor",
  mix: e,
  onto: "backgroundColor"
}), dI = { ref: "foregroundColor" }, zi = { ref: "accentColor" }, to = {
  backgroundColor: "#fff",
  foregroundColor: "#181d1f",
  borderColor: ms(0.15),
  chromeBackgroundColor: Ns(0.02),
  browserColorScheme: "light"
}, uI = {
  ...to,
  textColor: dI,
  accentColor: "#2196f3",
  invalidColor: "#e02525",
  wrapperBorder: !0,
  rowBorder: !0,
  headerRowBorder: !0,
  footerRowBorder: {
    ref: "rowBorder"
  },
  columnBorder: {
    style: "solid",
    width: 1,
    color: "transparent"
  },
  headerColumnBorder: !1,
  headerColumnBorderHeight: "100%",
  pinnedColumnBorder: !0,
  pinnedRowBorder: !0,
  sidePanelBorder: !0,
  sideBarPanelWidth: 250,
  sideBarBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  sideButtonBarBackgroundColor: {
    ref: "sideBarBackgroundColor"
  },
  sideButtonBarTopPadding: 0,
  sideButtonSelectedUnderlineWidth: 2,
  sideButtonSelectedUnderlineColor: "transparent",
  sideButtonSelectedUnderlineTransitionDuration: 0,
  sideButtonBackgroundColor: "transparent",
  sideButtonTextColor: { ref: "textColor" },
  sideButtonHoverBackgroundColor: { ref: "sideButtonBackgroundColor" },
  sideButtonHoverTextColor: { ref: "sideButtonTextColor" },
  sideButtonSelectedBackgroundColor: { ref: "backgroundColor" },
  sideButtonSelectedTextColor: { ref: "sideButtonTextColor" },
  sideButtonSelectedBorder: !0,
  sideButtonLeftPadding: { ref: "spacing" },
  sideButtonRightPadding: { ref: "spacing" },
  sideButtonVerticalPadding: { calc: "spacing * 3" },
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Oxygen-Sans",
    "Ubuntu",
    "Cantarell",
    "Helvetica Neue",
    "sans-serif"
  ],
  headerBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  headerFontFamily: {
    ref: "fontFamily"
  },
  cellFontFamily: {
    ref: "fontFamily"
  },
  headerFontWeight: 500,
  headerFontSize: {
    ref: "fontSize"
  },
  dataFontSize: {
    ref: "fontSize"
  },
  headerTextColor: {
    ref: "textColor"
  },
  headerCellHoverBackgroundColor: "transparent",
  headerCellMovingBackgroundColor: { ref: "headerCellHoverBackgroundColor" },
  headerCellBackgroundTransitionDuration: "0.2s",
  cellTextColor: {
    ref: "textColor"
  },
  subtleTextColor: {
    ref: "textColor",
    mix: 0.5
  },
  rangeSelectionBorderStyle: "solid",
  rangeSelectionBorderColor: zi,
  rangeSelectionBackgroundColor: ur(0.2),
  rangeSelectionChartBackgroundColor: "#0058FF1A",
  rangeSelectionChartCategoryBackgroundColor: "#00FF841A",
  rangeSelectionHighlightColor: ur(0.5),
  rowHoverColor: ur(0.08),
  columnHoverColor: ur(0.05),
  selectedRowBackgroundColor: ur(0.12),
  modalOverlayBackgroundColor: {
    ref: "backgroundColor",
    mix: 0.66
  },
  oddRowBackgroundColor: {
    ref: "backgroundColor"
  },
  borderRadius: 4,
  wrapperBorderRadius: 8,
  cellHorizontalPadding: {
    calc: "spacing * 2 * cellHorizontalPaddingScale"
  },
  cellWidgetSpacing: {
    calc: "spacing * 1.5"
  },
  cellHorizontalPaddingScale: 1,
  rowGroupIndentSize: {
    calc: "cellWidgetSpacing + iconSize"
  },
  valueChangeDeltaUpColor: "#43a047",
  valueChangeDeltaDownColor: "#e53935",
  valueChangeValueHighlightBackgroundColor: "#16a08580",
  spacing: 8,
  fontSize: 14,
  rowHeight: {
    calc: "max(iconSize, dataFontSize) + spacing * 3.25 * rowVerticalPaddingScale"
  },
  rowVerticalPaddingScale: 1,
  headerHeight: {
    calc: "max(iconSize, dataFontSize) + spacing * 4 * headerVerticalPaddingScale"
  },
  headerVerticalPaddingScale: 1,
  popupShadow: "0 0 16px #00000026",
  cardShadow: "0 1px 4px 1px #00000018",
  dropdownShadow: { ref: "cardShadow" },
  dragAndDropImageBackgroundColor: {
    ref: "backgroundColor"
  },
  dragAndDropImageBorder: !0,
  dragAndDropImageShadow: {
    ref: "popupShadow"
  },
  dragHandleColor: ms(0.7),
  focusShadow: {
    spread: 3,
    color: ur(0.5)
  },
  headerColumnResizeHandleHeight: "30%",
  headerColumnResizeHandleWidth: 2,
  headerColumnResizeHandleColor: {
    ref: "borderColor"
  },
  widgetContainerHorizontalPadding: {
    calc: "spacing * 1.5"
  },
  widgetContainerVerticalPadding: {
    calc: "spacing * 1.5"
  },
  widgetHorizontalSpacing: {
    calc: "spacing * 1.5"
  },
  widgetVerticalSpacing: {
    ref: "spacing"
  },
  listItemHeight: {
    calc: "iconSize + widgetVerticalSpacing"
  },
  iconSize: 16,
  toggleButtonWidth: 28,
  toggleButtonHeight: 18,
  toggleButtonOnBackgroundColor: zi,
  toggleButtonOffBackgroundColor: Ns(0.3),
  toggleButtonSwitchBackgroundColor: {
    ref: "backgroundColor"
  },
  toggleButtonSwitchInset: 2,
  menuBorder: {
    color: ms(0.2)
  },
  menuBackgroundColor: Ns(0.03),
  menuTextColor: Ns(0.95),
  menuShadow: {
    ref: "popupShadow"
  },
  menuSeparatorColor: {
    ref: "borderColor"
  },
  setFilterIndentSize: {
    ref: "iconSize"
  },
  chartMenuPanelWidth: 260,
  chartMenuLabelColor: ms(0.8),
  iconButtonHoverColor: ms(0.1),
  dialogShadow: {
    ref: "popupShadow"
  },
  cellEditingBorder: {
    color: zi
  },
  cellEditingShadow: { ref: "cardShadow" },
  dialogBorder: {
    color: ms(0.2)
  },
  panelBackgroundColor: {
    ref: "backgroundColor"
  },
  panelTitleBarBackgroundColor: {
    ref: "headerBackgroundColor"
  },
  panelTitleBarBorder: !0,
  columnSelectIndentSize: {
    ref: "iconSize"
  },
  toolPanelSeparatorBorder: !0,
  tooltipBackgroundColor: {
    ref: "chromeBackgroundColor"
  },
  tooltipTextColor: {
    ref: "textColor"
  },
  tooltipBorder: !0,
  columnDropCellBackgroundColor: ms(0.07),
  columnDropCellTextColor: {
    ref: "textColor"
  },
  columnDropCellDragHandleColor: {
    ref: "textColor"
  },
  columnDropCellBorder: {
    color: ms(0.13)
  },
  selectCellBackgroundColor: ms(0.07),
  selectCellBorder: {
    color: ms(0.13)
  },
  advancedFilterBuilderButtonBarBorder: !0,
  advancedFilterBuilderIndentSize: {
    calc: "spacing * 2 + iconSize"
  },
  advancedFilterBuilderJoinPillColor: "#f08e8d",
  advancedFilterBuilderColumnPillColor: "#a6e194",
  advancedFilterBuilderOptionPillColor: "#f3c08b",
  advancedFilterBuilderValuePillColor: "#85c0e4",
  filterToolPanelGroupIndent: {
    ref: "spacing"
  },
  iconButtonHoverBackgroundColor: ms(0.1),
  rowLoadingSkeletonEffectColor: ms(0.15)
}, hI = [
  "colorScheme",
  "color",
  "length",
  "scale",
  "borderStyle",
  "border",
  "shadow",
  "image",
  "fontFamily",
  "fontWeight",
  "duration"
], pI = cI((e) => (e = e.toLowerCase(), hI.find((t) => e.endsWith(t.toLowerCase())) ?? "length")), bc = (e) => typeof e == "string" ? e : typeof e == "number" ? String(e) : !1, Bh = (e) => {
  if (typeof e == "string")
    return e;
  if (e && "ref" in e) {
    const t = $i(e.ref);
    return e.mix == null ? t : `color-mix(in srgb, ${e.onto ? $i(e.onto) : "transparent"}, ${t} ${lI(e.mix * 100, 0, 100)}%)`;
  }
  return !1;
}, gI = bc, Nn = (e) => typeof e == "string" ? e : typeof e == "number" ? `${e}px` : e && "calc" in e ? `calc(${e.calc.replace(/ ?[*/+] ?/g, " $& ").replace(/-?[a-z][a-z0-9]*\b(?![-(])/gi, (s) => s[0] === "-" ? s : ` ${$i(s)} `)})` : e && "ref" in e ? $i(e.ref) : !1, fI = bc, mI = (e, t) => typeof e == "string" ? e : e === !0 ? "solid 1px var(--ag-border-color)" : e === !1 ? t === "columnBorder" ? "solid 1px transparent" : "none" : e && "ref" in e ? $i(e.ref) : ny(e.style ?? "solid") + " " + Nn(e.width ?? 1) + " " + Bh(e.color ?? { ref: "borderColor" }), CI = (e) => typeof e == "string" ? e : e === !1 ? "none" : e && "ref" in e ? $i(e.ref) : [
  Nn(e.offsetX ?? 0),
  Nn(e.offsetY ?? 0),
  Nn(e.radius ?? 0),
  Nn(e.spread ?? 0),
  Bh(e.color ?? { ref: "foregroundColor" })
].join(" "), ny = bc, oy = (e) => typeof e == "string" ? e : e && "googleFont" in e ? oy(e.googleFont) : e && "ref" in e ? $i(e.ref) : Array.isArray(e) ? e.map((t) => (typeof t == "object" && "googleFont" in t && (t = t.googleFont), vI(t))).join(", ") : !1, vI = (e) => (
  // don't quote var() expressions or quote safe identifier names, so that
  // people can specify fonts like sans-serif which are keywords not strings,
  // or var(--my-var)
  /^[\w-]+$|\w\(/.test(e) ? e : JSON.stringify(e)
), wI = bc, ay = (e) => typeof e == "string" ? e : e && "url" in e ? `url(${JSON.stringify(e.url)})` : e && "svg" in e ? ay({ url: `data:image/svg+xml,${encodeURIComponent(e.svg)}` }) : e && "ref" in e ? $i(e.ref) : !1, yI = (e, t) => typeof e == "string" ? e : typeof e == "number" ? (e >= 10 && be(104, { value: e, param: t }), `${e}s`) : e && "ref" in e ? $i(e.ref) : !1, bI = {
  color: Bh,
  colorScheme: gI,
  length: Nn,
  scale: fI,
  border: mI,
  borderStyle: ny,
  shadow: CI,
  image: ay,
  fontFamily: oy,
  fontWeight: wI,
  duration: yI
}, SI = (e, t) => {
  const s = pI(e);
  return bI[s](t, e);
}, xI = () => new ly(), ly = class cy {
  constructor(t = []) {
    this.parts = t;
  }
  withPart(t) {
    return typeof t == "function" && (t = t()), t instanceof iy ? new cy([...this.parts, t]) : (iu(259, { part: t }, "Invalid part"), this);
  }
  withoutPart(t) {
    return this.withPart(os({ feature: t }));
  }
  withParams(t, s = dr) {
    return this.withPart(
      os({
        modeParams: { [s]: t }
      })
    );
  }
  /**
   * Called by a grid instance when it starts using the theme. This installs
   * the theme's parts into document head, or the shadow DOM if the provided
   * container is within a shadow root.
   */
  _startUse({ container: t, loadThemeGoogleFonts: s }) {
    if (Gh)
      return;
    FI(), sy(t);
    const i = RI(this);
    if (i.length > 0)
      for (const r of i)
        s && TI(r);
    for (const r of this.parts)
      r.use(t);
  }
  /**
   * Return CSS that that applies the params of this theme to elements with
   * the provided class name
   */
  _getCssClass() {
    return this._cssClassCache ?? (this._cssClassCache = lf(this.parts).map((t) => t.use()).filter(Boolean).join(" "));
  }
  _getModeParams() {
    let t = this._paramsCache;
    if (!t) {
      const s = {
        // NOTE: defining the default mode here is important, it ensures
        // that the default mode is first in iteration order, which puts
        // it first in outputted CSS, allowing other modes to override it
        [dr]: { ...uI }
      };
      for (const i of lf(this.parts))
        for (const [r, n] of Object.entries(i.modeParams))
          if (n) {
            const o = s[r] ?? (s[r] = {}), a = /* @__PURE__ */ new Set();
            for (const [l, c] of Object.entries(n))
              c !== void 0 && (o[l] = c, a.add(l));
            if (r === dr) {
              for (const [l, c] of Object.entries(s))
                if (l !== dr)
                  for (const d of a)
                    delete c[d];
            }
          }
      this._paramsCache = t = s;
    }
    return t;
  }
  /**
   * Return the CSS chunk that is inserted into the grid DOM, and will
   * therefore be removed automatically when the grid is destroyed or it
   * starts to use a new theme.
   *
   * @param className a unique class name on the grid wrapper used to scope the returned CSS to the grid instance
   */
  _getPerGridCss(t) {
    const s = "##SELECTOR##";
    let i = this._paramsCssCache;
    if (!i) {
      let r = "", n = "";
      for (const [a, l] of Object.entries(this._getModeParams())) {
        if (a !== dr) {
          const d = `:where([data-ag-theme-mode="${typeof CSS == "object" ? CSS.escape(a) : a}"]) & {
`;
          r += d, n += d;
        }
        for (const [c, d] of Object.entries(l)) {
          const u = SI(c, d);
          if (u === !1)
            be(107, { key: c, value: d });
          else {
            const h = ry(c), p = h.replace("--ag-", "--ag-inherited-");
            r += `	${h}: var(${p}, ${u});
`, n += `	${p}: var(${h});
`;
          }
        }
        a !== dr && (r += `}
`, n += `}
`);
      }
      let o = `${s} {
${r}}
`;
      o += `:has(> ${s}):not(${s}) {
${n}}
`, this._paramsCssCache = i = o;
    }
    return i.replaceAll(s, `:where(.${t})`);
  }
}, lf = (e) => {
  const t = /* @__PURE__ */ new Map();
  for (const i of e)
    t.set(i.feature, i);
  const s = [];
  for (const i of e)
    (!i.feature || t.get(i.feature) === i) && s.push(i);
  return s;
}, RI = (e) => {
  const t = /* @__PURE__ */ new Set(), s = (n) => {
    if (Array.isArray(n))
      n.forEach(s);
    else {
      const o = n == null ? void 0 : n.googleFont;
      typeof o == "string" && t.add(o);
    }
  };
  return Object.values(e._getModeParams()).flatMap((n) => Object.values(n)).forEach(s), Array.from(t).sort();
}, cf = !1, FI = () => {
  if (!cf) {
    cf = !0;
    for (const e of Array.from(document.head.querySelectorAll('style[data-ag-scope="legacy"]')))
      e.remove();
  }
}, PI = /* @__PURE__ */ new Set(), TI = async (e) => {
  PI.add(e);
  const t = `@import url('https://${EI}/css2?family=${encodeURIComponent(e)}:wght@100;200;300;400;500;600;700;800;900&display=swap');
`;
  eo(t, document.head, `googleFont:${e}`);
}, EI = "fonts.googleapis.com", DI = (
  /*css*/
  '.ag-checkbox-input-wrapper,.ag-radio-button-input-wrapper{background-color:var(--ag-checkbox-unchecked-background-color);border:solid var(--ag-checkbox-border-width) var(--ag-checkbox-unchecked-border-color);flex:none;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);:where(input){-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer;display:block;height:var(--ag-icon-size);margin:0;opacity:0;width:var(--ag-icon-size)}&:after{content:"";display:block;inset:0;-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;pointer-events:none;position:absolute}&:where(.ag-checked){background-color:var(--ag-checkbox-checked-background-color);border-color:var(--ag-checkbox-checked-border-color);&:after{background-color:var(--ag-checkbox-checked-shape-color)}}&:where(:focus-within,:active){box-shadow:var(--ag-focus-shadow)}&:where(.ag-disabled){filter:grayscale();opacity:.5}}.ag-checkbox-input-wrapper{border-radius:var(--ag-checkbox-border-radius);&:where(.ag-checked):after{-webkit-mask-image:var(--ag-checkbox-checked-shape-image);mask-image:var(--ag-checkbox-checked-shape-image)}&:where(.ag-indeterminate){background-color:var(--ag-checkbox-indeterminate-background-color);border-color:var(--ag-checkbox-indeterminate-border-color);&:after{background-color:var(--ag-checkbox-indeterminate-shape-color);-webkit-mask-image:var(--ag-checkbox-indeterminate-shape-image);mask-image:var(--ag-checkbox-indeterminate-shape-image)}}}.ag-radio-button-input-wrapper{border-radius:100%;&:where(.ag-checked):after{-webkit-mask-image:var(--ag-radio-checked-shape-image);mask-image:var(--ag-radio-checked-shape-image)}}'
), AI = os({
  feature: "checkboxStyle",
  params: {
    checkboxBorderWidth: 1,
    checkboxBorderRadius: {
      ref: "borderRadius"
    },
    checkboxUncheckedBackgroundColor: {
      ref: "backgroundColor"
    },
    checkboxUncheckedBorderColor: Ns(0.3),
    checkboxCheckedBackgroundColor: zi,
    checkboxCheckedBorderColor: zi,
    checkboxCheckedShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M1 3.5 3.5 6l5-5"/></svg>'
    },
    checkboxCheckedShapeColor: {
      ref: "backgroundColor"
    },
    checkboxIndeterminateBackgroundColor: Ns(0.3),
    checkboxIndeterminateBorderColor: Ns(0.3),
    checkboxIndeterminateShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" fill="none"><rect width="10" height="2" fill="#000" rx="1"/></svg>'
    },
    checkboxIndeterminateShapeColor: {
      ref: "backgroundColor"
    },
    radioCheckedShapeImage: {
      svg: '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" fill="none"><circle cx="3" cy="3" r="3" fill="#000"/></svg>'
    }
  },
  css: DI
});
({
  ...to
});
({
  ...to
});
var dy = {
  ...to,
  backgroundColor: "hsl(217, 0%, 17%)",
  foregroundColor: "#FFF",
  chromeBackgroundColor: Ns(0.05),
  rowHoverColor: ur(0.15),
  selectedRowBackgroundColor: ur(0.2),
  menuBackgroundColor: Ns(0.1),
  browserColorScheme: "dark",
  popupShadow: "0 0px 20px #000A",
  cardShadow: "0 1px 4px 1px #000A",
  advancedFilterBuilderJoinPillColor: "#7a3a37",
  advancedFilterBuilderColumnPillColor: "#355f2d",
  advancedFilterBuilderOptionPillColor: "#5a3168",
  advancedFilterBuilderValuePillColor: "#374c86",
  checkboxUncheckedBorderColor: Ns(0.4),
  toggleButtonOffBackgroundColor: Ns(0.4)
}, MI = {
  ...dy,
  backgroundColor: "#1f2836"
}, II = /* @__PURE__ */ os({
  feature: "colorScheme",
  params: to,
  modeParams: {
    light: to,
    dark: dy,
    "dark-blue": MI
  }
}), LI = (
  /*css*/
  ':where(.ag-icon):before{align-items:center;background-color:currentcolor;color:inherit;content:"";display:flex;font-family:inherit;font-size:var(--ag-icon-size);font-style:normal;font-variant:normal;height:var(--ag-icon-size);justify-content:center;line-height:var(--ag-icon-size);-webkit-mask-size:contain;mask-size:contain;text-transform:none;width:var(--ag-icon-size)}.ag-icon{background-position:50%;background-repeat:no-repeat;background-size:contain;display:block;height:var(--ag-icon-size);position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-icon-size)}'
), uy = {
  aggregation: '<path d="M18 7V4H6l6 8-6 8h12v-3"/>',
  arrows: '<polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/>',
  asc: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
  cancel: '<path d="m18 6-12 12"/><path d="m6 6 12 12"/>',
  chart: '<line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="14"/>',
  "color-picker": '<path d="m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z"/><path d="m5 2 5 5"/><path d="M2 13h15"/><path d="M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z"/>',
  columns: '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"/>',
  contracted: '<path d="m9 18 6-6-6-6"/>',
  copy: '<rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>',
  cross: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
  csv: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
  cut: '<circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/>',
  desc: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
  down: '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',
  excel: '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13h2"/><path d="M8 17h2"/><path d="M14 13h2"/><path d="M14 17h2"/>',
  expanded: '<path d="m15 18-6-6 6-6"/>',
  "eye-slash": '<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/>',
  eye: '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
  filter: '<path d="M3 6h18"/><path d="M7 12h10"/><path d="M10 18h4"/>',
  first: '<path d="m17 18-6-6 6-6"/><path d="M7 6v12"/>',
  group: '<path d="M16 12H3"/><path d="M16 18H3"/><path d="M10 6H3"/><path d="M21 18V8a2 2 0 0 0-2-2h-5"/><path d="m16 8-2-2 2-2"/>',
  last: '<path d="m7 18 6-6-6-6"/><path d="M17 6v12"/>',
  left: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
  linked: '<path d="M9 17H7A5 5 0 0 1 7 7h2"/><path d="M15 7h2a5 5 0 1 1 0 10h-2"/><line x1="8" x2="16" y1="12" y2="12"/>',
  loading: '<line x1="12" x2="12" y1="2" y2="6"/><line x1="12" x2="12" y1="18" y2="22"/><line x1="4.93" x2="7.76" y1="4.93" y2="7.76"/><line x1="16.24" x2="19.07" y1="16.24" y2="19.07"/><line x1="2" x2="6" y1="12" y2="12"/><line x1="18" x2="22" y1="12" y2="12"/><line x1="4.93" x2="7.76" y1="19.07" y2="16.24"/><line x1="16.24" x2="19.07" y1="7.76" y2="4.93"/>',
  maximize: '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" x2="14" y1="3" y2="10"/><line x1="3" x2="10" y1="21" y2="14"/>',
  menu: '<line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/>',
  "menu-alt": '<circle cx="12" cy="5" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="12" r="0.75" fill="#D9D9D9"/><circle cx="12" cy="19" r="0.75" fill="#D9D9D9"/>',
  minimize: '<polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" x2="21" y1="10" y2="3"/><line x1="3" x2="10" y1="21" y2="14"/>',
  minus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/>',
  next: '<path d="m9 18 6-6-6-6"/>',
  none: '<path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/>',
  "not-allowed": '<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>',
  paste: '<path d="M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z"/><path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10"/><path d="m17 10 4 4-4 4"/>',
  pin: '<line x1="12" x2="12" y1="17" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>',
  pivot: '<path d="M15 3v18"/><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M21 9H3"/><path d="M21 15H3"/>',
  plus: '<circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/>',
  previous: '<path d="m15 18-6-6 6-6"/>',
  right: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
  save: '<path d="M12 17V3"/><path d="m6 11 6 6 6-6"/><path d="M19 21H5"/>',
  "small-left": '<path d="m15 18-6-6 6-6"/>',
  "small-right": '<path d="m9 18 6-6-6-6"/>',
  tick: '<path d="M20 6 9 17l-5-5"/>',
  "tree-closed": '<path d="m9 18 6-6-6-6"/>',
  "tree-indeterminate": '<path d="M5 12h14"/>',
  "tree-open": '<path d="m6 9 6 6 6-6"/>',
  unlinked: '<path d="M9 17H7A5 5 0 0 1 7 7"/><path d="M15 7h2a5 5 0 0 1 4 8"/><line x1="8" x2="12" y1="12" y2="12"/><line x1="2" x2="22" y1="2" y2="22"/>',
  up: '<path d="m5 12 7-7 7 7"/><path d="M12 19V5"/>',
  grip: '<circle cx="5" cy="8" r="0.5"/><circle cx="12" cy="8" r="0.5"/><circle cx="19" cy="8" r="0.5"/><circle cx="5" cy="16" r="0.5"/><circle cx="12" cy="16" r="0.5"/><circle cx="19" cy="16" r="0.5"/><g stroke="none" fill="currentColor"><circle cx="5" cy="8" r="1"/><circle cx="12" cy="8" r="1"/><circle cx="19" cy="8" r="1"/><circle cx="5" cy="16" r="1"/><circle cx="12" cy="16" r="1"/><circle cx="19" cy="16" r="1"/></g>',
  settings: '<path d="M20 7h-9"/><path d="M14 17H5"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/>'
}, hy = {
  "small-down": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 10.667 16 21.334l8.667-10.667H7.334Z"/></svg>',
  "small-up": '<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="black" stroke="none" viewBox="0 0 32 32"><path d="M7.334 21.333 16 10.666l8.667 10.667H7.334Z"/></svg>'
}, kI = (e = {}) => {
  let t = LI;
  for (const s of [...Object.keys(uy), ...Object.keys(hy)]) {
    const i = OI(s, e.strokeWidth);
    t += `.ag-icon-${s}::before { mask-image: url('data:image/svg+xml,${encodeURIComponent(i)}'); }
`;
  }
  return t;
}, OI = (e, t = 1.5) => {
  const s = hy[e];
  if (s)
    return s;
  const i = uy[e];
  if (!i)
    throw new Error(`Missing icon data for ${e}`);
  return `<svg xmlns="http://www.w3.org/2000/svg" class="ag-icon" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke="black" stroke-width="${t}" viewBox="0 0 24 24"><style>* { vector-effect: non-scaling-stroke; }</style>` + i + "</svg>";
}, GI = (e = {}) => os({
  feature: "iconSet",
  css: () => kI(e)
}), BI = /* @__PURE__ */ GI(), Vh = (
  /*css*/
  ':where(.ag-input-field-input[type=number]:not(.ag-number-field-input-stepper)){-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}}:where(input.ag-input-field-input:not([type]),input.ag-input-field-input[type=text],input.ag-input-field-input[type=number],input.ag-input-field-input[type=tel],input.ag-input-field-input[type=date],input.ag-input-field-input[type=datetime-local],textarea.ag-input-field-input){background-color:var(--ag-input-background-color);border:var(--ag-input-border);border-radius:var(--ag-input-border-radius);color:var(--ag-input-text-color);font-family:inherit;font-size:inherit;line-height:inherit;margin:0;min-height:var(--ag-input-height);padding:0;&:where(:disabled){background-color:var(--ag-input-disabled-background-color);border:var(--ag-input-disabled-border);color:var(--ag-input-disabled-text-color)}&:where(:focus){background-color:var(--ag-input-focus-background-color);border:var(--ag-input-focus-border);box-shadow:var(--ag-input-focus-shadow);color:var(--ag-input-focus-text-color);outline:none}&:where(:invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&:where(.invalid){background-color:var(--ag-input-invalid-background-color);border:var(--ag-input-invalid-border);color:var(--ag-input-invalid-text-color)}&::-moz-placeholder{color:var(--ag-input-placeholder-text-color)}&::placeholder{color:var(--ag-input-placeholder-text-color)}}:where(.ag-ltr) :where(input.ag-input-field-input:not([type]),input.ag-input-field-input[type=text],input.ag-input-field-input[type=number],input.ag-input-field-input[type=tel],input.ag-input-field-input[type=date],input.ag-input-field-input[type=datetime-local],textarea.ag-input-field-input){padding-left:var(--ag-input-padding-start)}:where(.ag-rtl) :where(input.ag-input-field-input:not([type]),input.ag-input-field-input[type=text],input.ag-input-field-input[type=number],input.ag-input-field-input[type=tel],input.ag-input-field-input[type=date],input.ag-input-field-input[type=datetime-local],textarea.ag-input-field-input){padding-right:var(--ag-input-padding-start)}:where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter){.ag-input-wrapper:before{background-color:currentcolor;color:var(--ag-input-icon-color);content:"";display:block;height:12px;-webkit-mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");mask-image:url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij48cGF0aCBkPSJNNS4zIDlhMy43IDMuNyAwIDEgMCAwLTcuNSAzLjcgMy43IDAgMCAwIDAgNy41Wk0xMC41IDEwLjUgOC4zIDguMiIvPjwvc3ZnPg==");-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;opacity:.5;position:absolute;width:12px}}:where(.ag-ltr) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter){.ag-input-wrapper:before{margin-left:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-left:calc(var(--ag-spacing)*1.5 + 12px)}}:where(.ag-rtl) :where(.ag-column-select-header-filter-wrapper,.ag-filter-toolpanel-search,.ag-mini-filter,.ag-filter-filter){.ag-input-wrapper:before{margin-right:var(--ag-spacing)}.ag-number-field-input,.ag-text-field-input{padding-right:calc(var(--ag-spacing)*1.5 + 12px)}}'
), VI = (
  /*css*/
  ":where(input.ag-input-field-input:not([type]),input.ag-input-field-input[type=text],input.ag-input-field-input[type=number],input.ag-input-field-input[type=tel],input.ag-input-field-input[type=date],input.ag-input-field-input[type=datetime-local],textarea.ag-input-field-input){&:focus{box-shadow:var(--ag-focus-shadow)}}"
), NI = (
  /*css*/
  ":where(input.ag-input-field-input:not([type]),input.ag-input-field-input[type=text],input.ag-input-field-input[type=number],input.ag-input-field-input[type=tel],input.ag-input-field-input[type=date],input.ag-input-field-input[type=datetime-local],textarea.ag-input-field-input){border-left:none;border-right:none;border-top:none}"
), Nh = {
  inputBackgroundColor: "transparent",
  inputBorder: !1,
  inputBorderRadius: 0,
  inputTextColor: {
    ref: "textColor"
  },
  inputPlaceholderTextColor: {
    ref: "inputTextColor",
    mix: 0.5
  },
  inputPaddingStart: 0,
  inputHeight: {
    calc: "max(iconSize, fontSize) + spacing * 2"
  },
  inputFocusBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputFocusBorder: {
    ref: "inputBorder"
  },
  inputFocusShadow: "none",
  inputFocusTextColor: {
    ref: "inputTextColor"
  },
  inputDisabledBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputDisabledBorder: {
    ref: "inputBorder"
  },
  inputDisabledTextColor: {
    ref: "inputTextColor"
  },
  inputInvalidBackgroundColor: {
    ref: "inputBackgroundColor"
  },
  inputInvalidBorder: {
    ref: "inputBorder"
  },
  inputInvalidTextColor: {
    ref: "inputTextColor"
  },
  inputIconColor: {
    ref: "inputTextColor"
  }
};
os({
  feature: "inputStyle",
  params: Nh,
  css: Vh
});
var HI = /* @__PURE__ */ os({
  feature: "inputStyle",
  params: {
    ...Nh,
    inputBackgroundColor: {
      ref: "backgroundColor"
    },
    inputBorder: !0,
    inputBorderRadius: {
      ref: "borderRadius"
    },
    inputPaddingStart: {
      ref: "spacing"
    },
    inputFocusBorder: {
      color: zi
    },
    inputFocusShadow: {
      ref: "focusShadow"
    },
    inputDisabledBackgroundColor: Ns(0.06),
    inputDisabledTextColor: {
      ref: "textColor",
      mix: 0.5
    },
    inputInvalidBorder: {
      color: { ref: "invalidColor" }
    }
  },
  css: () => Vh + VI
});
({
  ...Nh,
  inputBorder: ms(0.3)
});
var Ca = (
  /*css*/
  '.ag-tabs-header{background-color:var(--ag-tab-bar-background-color);border-bottom:var(--ag-tab-bar-border);display:flex;flex:1;gap:var(--ag-tab-spacing);padding:var(--ag-tab-bar-top-padding) var(--ag-tab-bar-horizontal-padding) 0}.ag-tabs-header-wrapper{display:flex}.ag-tabs-close-button-wrapper{align-items:center;border:0;display:flex;padding:var(--ag-spacing)}:where(.ag-ltr) .ag-tabs-close-button-wrapper{border-right:1px solid var(--ag-border-color)}:where(.ag-rtl) .ag-tabs-close-button-wrapper{border-left:1px solid var(--ag-border-color)}.ag-tabs-close-button{background-color:unset;border:0;cursor:pointer;padding:0}.ag-tab{align-items:center;background-color:var(--ag-tab-background-color);border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;color:var(--ag-tab-text-color);cursor:pointer;display:flex;flex:1;justify-content:center;padding:var(--ag-tab-top-padding) var(--ag-tab-horizontal-padding) var(--ag-tab-bottom-padding);position:relative;&:hover{background-color:var(--ag-tab-hover-background-color);color:var(--ag-tab-hover-text-color)}&.ag-tab-selected{background-color:var(--ag-tab-selected-background-color);color:var(--ag-tab-selected-text-color)}&:after{background-color:var(--ag-tab-selected-underline-color);bottom:0;content:"";display:block;height:var(--ag-tab-selected-underline-width);left:0;opacity:0;position:absolute;right:0;transition:opacity var(--ag-tab-selected-underline-transition-duration)}&.ag-tab-selected:after{opacity:1}}:where(.ag-ltr) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-left-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-right-color:var(--ag-tab-selected-border-color)}}}:where(.ag-rtl) .ag-tab{&.ag-tab-selected{&:where(:not(:first-of-type)){border-right-color:var(--ag-tab-selected-border-color)}&:where(:not(:last-of-type)){border-left-color:var(--ag-tab-selected-border-color)}}}'
), zI = (
  /*css*/
  ".ag-tab{border-left:var(--ag-tab-selected-border-width) solid transparent;border-right:var(--ag-tab-selected-border-width) solid transparent;border-top:var(--ag-tab-selected-border-width) solid transparent;flex:0;&.ag-tab-selected{border-left-color:var(--ag-tab-selected-border-color);border-right-color:var(--ag-tab-selected-border-color);border-top-color:var(--ag-tab-selected-border-color);margin-bottom:-1px;padding-bottom:calc(var(--ag-tab-bottom-padding) + 1px)}}"
), va = {
  tabBarBackgroundColor: "transparent",
  tabBarHorizontalPadding: 0,
  tabBarTopPadding: 0,
  tabBackgroundColor: "transparent",
  tabTextColor: {
    ref: "textColor"
  },
  tabHorizontalPadding: {
    ref: "spacing"
  },
  tabTopPadding: {
    ref: "spacing"
  },
  tabBottomPadding: {
    ref: "spacing"
  },
  tabSpacing: "0",
  tabHoverBackgroundColor: {
    ref: "tabBackgroundColor"
  },
  tabHoverTextColor: {
    ref: "tabTextColor"
  },
  tabSelectedBackgroundColor: {
    ref: "tabBackgroundColor"
  },
  tabSelectedTextColor: {
    ref: "tabTextColor"
  },
  tabSelectedBorderWidth: 1,
  tabSelectedBorderColor: "transparent",
  tabSelectedUnderlineColor: "transparent",
  tabSelectedUnderlineWidth: 0,
  tabSelectedUnderlineTransitionDuration: 0,
  tabBarBorder: !1
};
os({
  feature: "tabStyle",
  params: va,
  css: Ca
});
var WI = /* @__PURE__ */ os({
  feature: "tabStyle",
  params: {
    ...va,
    tabBarBorder: !0,
    tabBarBackgroundColor: ms(0.05),
    tabTextColor: {
      ref: "textColor",
      mix: 0.7
    },
    tabSelectedTextColor: {
      ref: "textColor"
    },
    tabHoverTextColor: {
      ref: "textColor"
    },
    tabSelectedBorderColor: {
      ref: "borderColor"
    },
    tabSelectedBackgroundColor: {
      ref: "backgroundColor"
    }
  },
  css: Ca
});
({
  ...va
});
({
  ...va
});
({
  ...va
});
var _I = /* @__PURE__ */ xI().withPart(AI).withPart(II).withPart(BI).withPart(WI).withPart(() => HI).withParams({
  fontFamily: [
    { googleFont: "IBM Plex Sans" },
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Oxygen-Sans",
    "Ubuntu"
  ]
}), df = {
  cssName: "--ag-row-height",
  changeKey: "rowHeightChanged",
  defaultValue: 42
}, uf = {
  cssName: "--ag-header-height",
  changeKey: "headerHeightChanged",
  defaultValue: 48
}, hf = {
  cssName: "--ag-list-item-height",
  changeKey: "listItemHeightChanged",
  defaultValue: 24
}, xd = {
  cssName: "--ag-row-border",
  changeKey: "rowBorderWidthChanged",
  defaultValue: 1,
  border: !0
}, UI = 0, $I = class extends L {
  constructor() {
    super(...arguments), this.beanName = "environment", this.sizeEls = /* @__PURE__ */ new Map(), this.lastKnownValues = /* @__PURE__ */ new Map(), this.sizesMeasured = !1, this.paramsClass = `ag-theme-params-${++UI}`, this.globalCSS = [];
  }
  wireBeans(e) {
    this.eGridDiv = e.eGridDiv;
  }
  postConstruct() {
    this.addManagedPropertyListener("theme", () => this.handleThemeGridOptionChange()), this.handleThemeGridOptionChange(), this.addManagedPropertyListener("rowHeight", () => this.refreshRowHeightVariable()), this.getSizeEl(df), this.getSizeEl(uf), this.getSizeEl(hf), this.getSizeEl(xd), this.refreshRowBorderWidthVariable(), this.addDestroyFunc(() => nI(this));
  }
  getDefaultRowHeight() {
    return this.getCSSVariablePixelValue(df);
  }
  getDefaultHeaderHeight() {
    return this.getCSSVariablePixelValue(uf);
  }
  getDefaultColumnMinWidth() {
    return Math.min(36, this.getDefaultRowHeight());
  }
  getDefaultListItemHeight() {
    return this.getCSSVariablePixelValue(hf);
  }
  getRowBorderWidth() {
    return this.getCSSVariablePixelValue(xd);
  }
  applyThemeClasses(e) {
    const { gridTheme: t } = this;
    let s = "";
    if (t)
      s = `${this.paramsClass} ${t._getCssClass()}`;
    else {
      let i = this.eGridDiv;
      for (; i; ) {
        for (const r of Array.from(i.classList))
          r.startsWith("ag-theme-") && (s = s ? `${s} ${r}` : r);
        i = i.parentElement;
      }
    }
    for (const i of Array.from(e.classList))
      i.startsWith("ag-theme-") && e.classList.remove(i);
    if (s) {
      const i = e.className;
      e.className = i + (i ? " " : "") + s;
    }
  }
  refreshRowHeightVariable() {
    const { eGridDiv: e } = this, t = e.style.getPropertyValue("--ag-line-height").trim(), s = this.gos.get("rowHeight");
    if (s == null || isNaN(s) || !isFinite(s))
      return t !== null && e.style.setProperty("--ag-line-height", null), -1;
    const i = `${s}px`;
    return t != i ? (e.style.setProperty("--ag-line-height", i), s) : t != "" ? parseFloat(t) : -1;
  }
  addGlobalCSS(e, t) {
    this.gridTheme ? eo(e, this.eGridDiv, t) : this.globalCSS.push([e, t]);
  }
  getCSSVariablePixelValue(e) {
    const t = this.lastKnownValues.get(e);
    if (t != null)
      return t;
    const s = this.measureSizeEl(e);
    return s === "detached" || s === "no-styles" ? e.defaultValue : (this.lastKnownValues.set(e, s), s);
  }
  measureSizeEl(e) {
    const t = this.getSizeEl(e);
    if (t.offsetParent == null)
      return "detached";
    const s = t.offsetWidth;
    return s === Rd ? "no-styles" : (this.sizesMeasured = !0, s);
  }
  getMeasurementContainer() {
    let e = this.eMeasurementContainer;
    return e || (e = this.eMeasurementContainer = document.createElement("div"), e.className = "ag-measurement-container", this.eGridDiv.appendChild(e)), e;
  }
  getSizeEl(e) {
    let t = this.sizeEls.get(e);
    if (t)
      return t;
    const s = this.getMeasurementContainer();
    t = document.createElement("div");
    const { border: i } = e;
    i ? (t.className = "ag-measurement-element-border", t.style.setProperty(
      "--ag-internal-measurement-border",
      `var(${e.cssName}, solid ${Rd}px`
    )) : t.style.width = `var(${e.cssName}, ${Rd}px)`, s.appendChild(t), this.sizeEls.set(e, t);
    let r = this.measureSizeEl(e);
    r === "no-styles" && I(9, { variable: e });
    const n = Ms(this.beans, t, () => {
      const o = this.measureSizeEl(e);
      o === "detached" || o === "no-styles" || (this.lastKnownValues.set(e, o), o !== r && (r = o, this.fireGridStylesChangedEvent(e.changeKey)));
    });
    return this.addDestroyFunc(() => n()), t;
  }
  fireGridStylesChangedEvent(e) {
    e === "rowBorderWidthChanged" && this.refreshRowBorderWidthVariable(), this.eventSvc.dispatchEvent({
      type: "gridStylesChanged",
      [e]: !0
    });
  }
  refreshRowBorderWidthVariable() {
    const e = this.getCSSVariablePixelValue(xd);
    this.eGridDiv.style.setProperty("--ag-internal-row-border-width", `${e}px`);
  }
  handleThemeGridOptionChange() {
    const { gos: e, eGridDiv: t, globalCSS: s, gridTheme: i } = this, r = e.get("theme");
    let n;
    if (r === "legacy")
      n = void 0;
    else {
      const o = r ?? _I;
      o instanceof ly ? n = o : be(240, { theme: o });
    }
    if (n !== i) {
      if (n) {
        rI(this), sy(t);
        for (const [a, l] of s)
          eo(a, t, l);
        s.length = 0;
      }
      this.gridTheme = n, n == null || n._startUse({
        loadThemeGoogleFonts: e.get("loadThemeGoogleFonts"),
        container: t
      });
      let o = this.eParamsStyle;
      o || (o = this.eParamsStyle = document.createElement("style"), t.appendChild(o)), Gh || (o.textContent = (n == null ? void 0 : n._getPerGridCss(this.paramsClass)) || ""), this.applyThemeClasses(t), this.fireGridStylesChangedEvent("themeChanged");
    }
    n && getComputedStyle(this.getMeasurementContainer()).getPropertyValue("--ag-legacy-styles-loaded") && be(r ? 106 : 239);
  }
}, Rd = 15538, jI = class extends L {
  constructor() {
    super(...arguments), this.beanName = "eventSvc", this.globalEventService = new Mr();
  }
  postConstruct() {
    const { globalListener: e, globalSyncListener: t } = this.beans;
    e && this.addGlobalListener(e, !0), t && this.addGlobalListener(t, !1);
  }
  addEventListener(e, t, s) {
    this.globalEventService.addEventListener(e, t, s);
  }
  removeEventListener(e, t, s) {
    this.globalEventService.removeEventListener(e, t, s);
  }
  addGlobalListener(e, t = !1) {
    this.globalEventService.addGlobalListener(e, t);
  }
  removeGlobalListener(e, t = !1) {
    this.globalEventService.removeGlobalListener(e, t);
  }
  /** @deprecated DO NOT FIRE LOCAL EVENTS OFF THE EVENT SERVICE */
  dispatchLocalEvent() {
  }
  dispatchEvent(e) {
    this.globalEventService.dispatchEvent(this.gos.addGridCommonParams(e));
  }
  dispatchEventOnce(e) {
    this.globalEventService.dispatchEventOnce(this.gos.addGridCommonParams(e));
  }
};
function py(e) {
  return e ? e.getLeafColumns().some((t) => t.isSpanHeaderHeight()) : !1;
}
function mu(e, t) {
  let s;
  if (pt(e) && py(e) && e.isPadding()) {
    const i = e;
    s = i.getLeafColumns()[0];
    let r = s;
    for (; r !== i; )
      t++, r = r.getParent();
  }
  return {
    column: s || e,
    headerRowIndex: t
  };
}
var KI = class extends L {
  constructor() {
    super(...arguments), this.beanName = "headerNavigation", this.currentHeaderRowWithoutSpan = -1;
  }
  postConstruct() {
    const e = this.beans;
    e.ctrlsSvc.whenReady(this, (s) => {
      this.gridBodyCon = s.gridBodyCtrl;
    });
    const t = We(e);
    this.addManagedElementListeners(t, {
      mousedown: () => {
        this.currentHeaderRowWithoutSpan = -1;
      }
    });
  }
  getHeaderPositionForColumn(e, t) {
    let s;
    const { colModel: i, colGroupSvc: r, ctrlsSvc: n } = this.beans;
    if (typeof e == "string" ? (s = i.getCol(e), s || (s = (r == null ? void 0 : r.getColumnGroup(e)) ?? null)) : s = e, !s)
      return null;
    const o = n.getHeaderRowContainerCtrl(), a = o == null ? void 0 : o.getAllCtrls(), l = pe(a || []).type === "filter", c = Vi(this.beans) - 1;
    let d = -1, u = s;
    for (; u; )
      d++, u = u.getParent();
    let h = d;
    return t && l && h === c - 1 && h++, h === -1 ? null : {
      headerRowIndex: h,
      column: s
    };
  }
  /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */
  navigateVertically(e, t, s) {
    const i = this.beans.focusSvc;
    if (t || (t = i.focusedHeader), !t)
      return !1;
    const { headerRowIndex: r } = t, n = t.column, o = Vi(this.beans), a = e === "UP", l = this.getHeaderRowType(r);
    let {
      headerRowIndex: c,
      column: d,
      headerRowIndexWithoutSpan: u
    } = a ? qI(l, n, r) : YI(l, n, r), h = !1;
    return c < 0 && (c = 0, d = n, h = !0), c >= o ? (c = -1, this.currentHeaderRowWithoutSpan = -1) : u !== void 0 && (this.currentHeaderRowWithoutSpan = u), !h && !d ? !1 : i.focusHeaderPosition({
      headerPosition: { headerRowIndex: c, column: d },
      allowUserOverride: !0,
      event: s
    });
  }
  /*
   * This method navigates grid header horizontally
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */
  navigateHorizontally(e, t = !1, s) {
    const { focusSvc: i, gos: r } = this.beans, n = i.focusedHeader;
    let o, a;
    if (this.currentHeaderRowWithoutSpan !== -1 ? n.headerRowIndex = this.currentHeaderRowWithoutSpan : this.currentHeaderRowWithoutSpan = n.headerRowIndex, e === "LEFT" !== r.get("enableRtl") ? (a = "Before", o = this.findHeader(n, a)) : (a = "After", o = this.findHeader(n, a)), o || !t)
      return i.focusHeaderPosition({
        headerPosition: o,
        direction: a,
        fromTab: t,
        allowUserOverride: !0,
        event: s
      });
    if (t) {
      const l = r.getCallback("tabToNextHeader");
      if (l)
        return i.focusHeaderPositionFromUserFunc({
          userFunc: l,
          headerPosition: o,
          direction: a
        });
    }
    return this.focusNextHeaderRow(n, a, s);
  }
  focusNextHeaderRow(e, t, s) {
    const i = e.headerRowIndex;
    let r = null, n;
    const o = this.beans;
    if (t === "Before" ? i > 0 && (n = i - 1, this.currentHeaderRowWithoutSpan -= 1, r = this.findColAtEdgeForHeaderRow(n, "end")) : (n = i + 1, this.currentHeaderRowWithoutSpan < Vi(o) ? this.currentHeaderRowWithoutSpan += 1 : this.currentHeaderRowWithoutSpan = -1, r = this.findColAtEdgeForHeaderRow(n, "start")), !r)
      return !1;
    const { column: a, headerRowIndex: l } = mu(
      r.column,
      r == null ? void 0 : r.headerRowIndex
    );
    return o.focusSvc.focusHeaderPosition({
      headerPosition: { column: a, headerRowIndex: l },
      direction: t,
      fromTab: !0,
      allowUserOverride: !0,
      event: s
    });
  }
  scrollToColumn(e, t = "After") {
    if (e.getPinned())
      return;
    let s;
    if (pt(e)) {
      const i = e.getDisplayedLeafColumns();
      s = t === "Before" ? pe(i) : i[0];
    } else
      s = e;
    this.gridBodyCon.scrollFeature.ensureColumnVisible(s);
  }
  findHeader(e, t) {
    let s, i;
    const { colGroupSvc: r, visibleCols: n } = this.beans;
    if (pt(e.column) ? s = (r == null ? void 0 : r.getGroupAtDirection(e.column, t)) ?? void 0 : (i = `getCol${t}`, s = n[i](e.column)), !s)
      return;
    const { headerRowIndex: o } = e;
    if (this.getHeaderRowType(o) !== "filter") {
      const c = [s];
      for (; s.getParent(); )
        s = s.getParent(), c.push(s);
      s = c[Math.max(0, c.length - 1 - o)];
    }
    const { column: a, headerRowIndex: l } = mu(s, o);
    return {
      column: a,
      headerRowIndex: l
    };
  }
  getHeaderRowType(e) {
    const t = this.beans.ctrlsSvc.getHeaderRowContainerCtrl();
    if (t)
      return t.getRowType(e);
  }
  findColAtEdgeForHeaderRow(e, t) {
    const { visibleCols: s, ctrlsSvc: i, colGroupSvc: r } = this.beans, n = s.allCols, o = n[t === "start" ? 0 : n.length - 1];
    if (!o)
      return;
    const a = i.getHeaderRowContainerCtrl(o.getPinned()), l = a == null ? void 0 : a.getRowType(e);
    if (l == "group") {
      const c = r == null ? void 0 : r.getColGroupAtLevel(o, e);
      return {
        headerRowIndex: e,
        column: c
      };
    }
    return {
      // if type==null, means the header level didn't exist
      headerRowIndex: l == null ? -1 : e,
      column: o
    };
  }
};
function qI(e, t, s) {
  const i = e === "filter", r = e === "column";
  let n = i ? t : t.getParent(), o = s - 1, a = o;
  if (r && py(t.getParent())) {
    for (; n && n.isPadding(); )
      n = n.getParent(), o--;
    a = o, o < 0 && (n = t, o = s, a = void 0);
  }
  return { column: n, headerRowIndex: o, headerRowIndexWithoutSpan: a };
}
function YI(e, t, s, i = "After") {
  let r = t, n = s + 1;
  const o = n;
  if (e === "group") {
    const a = t.getDisplayedLeafColumns(), l = i === "After" ? a[0] : pe(a), c = [];
    let d = l;
    for (; d.getParent() !== t; )
      d = d.getParent(), c.push(d);
    if (r = l, l.isSpanHeaderHeight())
      for (let u = c.length - 1; u >= 0; u--) {
        const h = c[u];
        if (!h.isPadding()) {
          r = h;
          break;
        }
        n++;
      }
    else
      r = pe(c), r || (r = l);
  }
  return { column: r, headerRowIndex: n, headerRowIndexWithoutSpan: o };
}
var XI = class extends L {
  constructor() {
    super(...arguments), this.beanName = "focusSvc";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.visibleCols = e.visibleCols, this.rowRenderer = e.rowRenderer, this.navigation = e.navigation, this.filterManager = e.filterManager, this.overlays = e.overlays;
  }
  postConstruct() {
    const e = this.clearFocusedCell.bind(this);
    this.addManagedEventListeners({
      columnPivotModeChanged: e,
      newColumnsLoaded: this.onColumnEverythingChanged.bind(this),
      columnGroupOpened: e,
      columnRowGroupChanged: e
    }), this.addDestroyFunc(wE(this.beans));
  }
  onColumnEverythingChanged() {
    if (!this.focusedCell)
      return;
    const e = this.focusedCell.column, t = this.colModel.getCol(e.getId());
    e !== t && this.clearFocusedCell();
  }
  // we check if the browser is focusing something, and if it is, and
  // it's the cell we think is focused, then return the cell. so this
  // methods returns the cell if a) we think it has focus and b) the
  // browser thinks it has focus. this then returns nothing if we
  // first focus a cell, then second click outside the grid, as then the
  // grid cell will still be focused as far as the grid is concerned,
  // however the browser focus will have moved somewhere else.
  getFocusCellToUseAfterRefresh() {
    return this.gos.get("suppressFocusAfterRefresh") || !this.focusedCell || this.isDomDataMissingInHierarchy(Ie(this.beans), aa) ? null : this.focusedCell;
  }
  getFocusHeaderToUseAfterRefresh() {
    return this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeader || this.isDomDataMissingInHierarchy(Ie(this.beans), Gw) ? null : this.focusedHeader;
  }
  isDomDataMissingInHierarchy(e, t) {
    let s = e;
    for (; s; ) {
      if (Pl(this.gos, s, t))
        return !1;
      s = s.parentNode;
    }
    return !0;
  }
  getFocusedCell() {
    return this.focusedCell;
  }
  shouldRestoreFocus(e) {
    return this.isCellRestoreFocused(e) ? (setTimeout(() => {
      this.restoredFocusedCell = null;
    }, 0), !0) : !1;
  }
  clearRestoreFocus() {
    this.restoredFocusedCell = null, this.awaitRestoreFocusedCell = !1;
  }
  restoreFocusedCell(e, t) {
    this.awaitRestoreFocusedCell = !0, setTimeout(() => {
      this.awaitRestoreFocusedCell && (this.setRestoreFocusedCell(e), t());
    });
  }
  isCellRestoreFocused(e) {
    return this.restoredFocusedCell == null ? !1 : Jn(e, this.restoredFocusedCell);
  }
  setRestoreFocusedCell(e) {
    this.beans.frameworkOverrides.renderingEngine === "react" && (this.restoredFocusedCell = e);
  }
  getFocusEventParams(e) {
    const { rowIndex: t, rowPinned: s, column: i } = e, r = {
      rowIndex: t,
      rowPinned: s,
      column: i,
      isFullWidthCell: !1
    }, n = this.rowRenderer.getRowByPosition({ rowIndex: t, rowPinned: s });
    return n && (r.isFullWidthCell = n.isFullWidth()), r;
  }
  clearFocusedCell() {
    if (this.restoredFocusedCell = null, this.focusedCell == null)
      return;
    const e = this.getFocusEventParams(this.focusedCell);
    this.focusedCell = null, this.eventSvc.dispatchEvent({
      type: "cellFocusCleared",
      ...e
    });
  }
  setFocusedCell(e) {
    const { column: t, rowIndex: s, rowPinned: i, forceBrowserFocus: r = !1, preventScrollOnBrowserFocus: n = !1 } = e, o = this.colModel.getCol(t);
    if (!o) {
      this.focusedCell = null;
      return;
    }
    this.focusedCell = {
      rowIndex: s,
      rowPinned: St(i),
      column: o
    }, this.eventSvc.dispatchEvent({
      type: "cellFocused",
      ...this.getFocusEventParams(this.focusedCell),
      forceBrowserFocus: r,
      preventScrollOnBrowserFocus: n
    });
  }
  isCellFocused(e) {
    return this.focusedCell == null ? !1 : Jn(e, this.focusedCell);
  }
  isRowNodeFocused(e) {
    return this.isRowFocused(e.rowIndex, e.rowPinned);
  }
  isHeaderWrapperFocused(e) {
    if (this.focusedHeader == null)
      return !1;
    const {
      column: t,
      rowCtrl: { rowIndex: s, pinned: i }
    } = e, { column: r, headerRowIndex: n } = this.focusedHeader;
    return t === r && s === n && i == r.getPinned();
  }
  focusHeaderPosition(e) {
    var l;
    if (_n(this.beans))
      return !1;
    const { direction: t, fromTab: s, allowUserOverride: i, event: r, fromCell: n, rowWithoutSpanValue: o } = e;
    let { headerPosition: a } = e;
    if (n && ((l = this.filterManager) != null && l.isAdvFilterHeaderActive()))
      return this.focusAdvancedFilter(a);
    if (i) {
      const c = this.focusedHeader, d = Vi(this.beans);
      if (s) {
        const u = this.gos.getCallback("tabToNextHeader");
        u && (a = this.getHeaderPositionFromUserFunc({
          userFunc: u,
          direction: t,
          currentPosition: c,
          headerPosition: a,
          headerRowCount: d
        }));
      } else {
        const u = this.gos.getCallback("navigateToNextHeader");
        if (u && r) {
          const h = {
            key: r.key,
            previousHeaderPosition: c,
            nextHeaderPosition: a,
            headerRowCount: d,
            event: r
          };
          a = u(h);
        }
      }
    }
    return a ? this.focusProvidedHeaderPosition({
      headerPosition: a,
      direction: t,
      event: r,
      fromCell: n,
      rowWithoutSpanValue: o
    }) : !1;
  }
  focusHeaderPositionFromUserFunc(e) {
    if (_n(this.beans))
      return !1;
    const { userFunc: t, headerPosition: s, direction: i, event: r } = e, n = this.focusedHeader, o = Vi(this.beans), a = this.getHeaderPositionFromUserFunc({
      userFunc: t,
      direction: i,
      currentPosition: n,
      headerPosition: s,
      headerRowCount: o
    });
    return !!a && this.focusProvidedHeaderPosition({
      headerPosition: a,
      direction: i,
      event: r
    });
  }
  getHeaderPositionFromUserFunc(e) {
    const { userFunc: t, direction: s, currentPosition: i, headerPosition: r, headerRowCount: n } = e, a = t({
      backwards: s === "Before",
      previousHeaderPosition: i,
      nextHeaderPosition: r,
      headerRowCount: n
    });
    return a === !0 ? i : a === !1 ? null : a;
  }
  focusProvidedHeaderPosition(e) {
    const { headerPosition: t, direction: s, fromCell: i, rowWithoutSpanValue: r, event: n } = e, { column: o, headerRowIndex: a } = t, { filterManager: l, ctrlsSvc: c, headerNavigation: d } = this.beans;
    if (a === -1)
      return l != null && l.isAdvFilterHeaderActive() ? this.focusAdvancedFilter(t) : this.focusGridView(o);
    d == null || d.scrollToColumn(o, s);
    const u = c.getHeaderRowContainerCtrl(o.getPinned()), h = (u == null ? void 0 : u.focusHeader(t.headerRowIndex, o, n)) || !1;
    return d && h && (r != null || i) && (d.currentHeaderRowWithoutSpan = r ?? -1), h;
  }
  focusFirstHeader() {
    var i;
    if ((i = this.overlays) != null && i.isExclusive() && this.focusOverlay())
      return !0;
    let e = this.visibleCols.allCols[0];
    if (!e)
      return !1;
    const { colGroupSvc: t } = this.beans;
    t && e.getParent() && (e = t.getColGroupAtLevel(e, 0));
    const s = mu(e, 0);
    return this.focusHeaderPosition({
      headerPosition: s,
      rowWithoutSpanValue: 0
    });
  }
  focusLastHeader(e) {
    var i;
    if ((i = this.overlays) != null && i.isExclusive() && this.focusOverlay(!0))
      return !0;
    const t = Vi(this.beans) - 1, s = pe(this.visibleCols.allCols);
    return this.focusHeaderPosition({
      headerPosition: { headerRowIndex: t, column: s },
      rowWithoutSpanValue: -1,
      event: e
    });
  }
  focusPreviousFromFirstCell(e) {
    var t;
    return (t = this.filterManager) != null && t.isAdvFilterHeaderActive() ? this.focusAdvancedFilter(null) : this.focusLastHeader(e);
  }
  isAnyCellFocused() {
    return !!this.focusedCell;
  }
  isRowFocused(e, t) {
    return this.focusedCell == null ? !1 : this.focusedCell.rowIndex === e && this.focusedCell.rowPinned === St(t);
  }
  focusOverlay(e) {
    var s, i;
    const t = ((s = this.overlays) == null ? void 0 : s.isVisible()) && ((i = this.overlays.eWrapper) == null ? void 0 : i.getGui());
    return !!t && Dt(t, e);
  }
  focusGridView(e, t = !1, s = !0) {
    var r, n, o, a, l;
    if ((r = this.overlays) != null && r.isExclusive())
      return s && this.focusOverlay(t);
    if (cw(this.beans))
      return t && !_n(this.beans) ? this.focusLastHeader() : s && this.focusOverlay(t) ? !0 : Ui(this.beans, !1);
    const i = t ? BE(this.beans) : GE(this.beans);
    if (i) {
      const { rowIndex: c, rowPinned: d } = i;
      if (e ?? (e = (n = this.focusedHeader) == null ? void 0 : n.column), e && c !== void 0 && c !== null) {
        if ((o = this.navigation) == null || o.ensureCellVisible({ rowIndex: c, column: e, rowPinned: d }), t) {
          const u = this.rowRenderer.getRowByPosition(i);
          if (u != null && u.isFullWidth() && ((a = this.navigation) != null && a.tryToFocusFullWidthRow(i, t)))
            return !0;
        }
        return this.setFocusedCell({
          rowIndex: c,
          column: e,
          rowPinned: St(d),
          forceBrowserFocus: !0
        }), (l = this.beans.rangeSvc) == null || l.setRangeToCell({ rowIndex: c, rowPinned: d, column: e }), !0;
      }
    }
    return !!(s && this.focusOverlay(t) || t && this.focusLastHeader());
  }
  focusAdvancedFilter(e) {
    var t;
    return this.advFilterFocusColumn = e == null ? void 0 : e.column, ((t = this.beans.advancedFilter) == null ? void 0 : t.getCtrl().focusHeaderComp()) ?? !1;
  }
  focusNextFromAdvancedFilter(e, t) {
    var i;
    const s = (t ? void 0 : this.advFilterFocusColumn) ?? ((i = this.visibleCols.allCols) == null ? void 0 : i[0]);
    return e ? this.focusHeaderPosition({
      headerPosition: {
        column: s,
        headerRowIndex: Vi(this.beans) - 1
      }
    }) : this.focusGridView(s);
  }
  clearAdvancedFilterColumn() {
    this.advFilterFocusColumn = void 0;
  }
}, ZI = class extends L {
  constructor() {
    super(...arguments), this.beanName = "scrollVisibleSvc";
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.colAnimation = e.colAnimation;
  }
  postConstruct() {
    this.getScrollbarWidth(), this.addManagedEventListeners({
      displayedColumnsChanged: this.updateScrollVisible.bind(this),
      displayedColumnsWidthChanged: this.updateScrollVisible.bind(this)
    });
  }
  updateScrollVisible() {
    const { colAnimation: e } = this;
    e != null && e.isActive() ? e.executeLaterVMTurn(() => {
      e.executeLaterVMTurn(() => this.updateScrollVisibleImpl());
    }) : this.updateScrollVisibleImpl();
  }
  updateScrollVisibleImpl() {
    var s;
    const e = this.ctrlsSvc.get("center");
    if (!e || (s = this.colAnimation) != null && s.isActive())
      return;
    const t = {
      horizontalScrollShowing: e.isHorizontalScrollShowing(),
      verticalScrollShowing: this.verticalScrollShowing
    };
    this.setScrollsVisible(t), this.updateScrollGap();
  }
  updateScrollGap() {
    const e = this.ctrlsSvc.get("center"), t = e.hasHorizontalScrollGap(), s = e.hasVerticalScrollGap();
    (this.horizontalScrollGap !== t || this.verticalScrollGap !== s) && (this.horizontalScrollGap = t, this.verticalScrollGap = s, this.eventSvc.dispatchEvent({
      type: "scrollGapChanged"
    }));
  }
  setScrollsVisible(e) {
    (this.horizontalScrollShowing !== e.horizontalScrollShowing || this.verticalScrollShowing !== e.verticalScrollShowing) && (this.horizontalScrollShowing = e.horizontalScrollShowing, this.verticalScrollShowing = e.verticalScrollShowing, this.eventSvc.dispatchEvent({
      type: "scrollVisibilityChanged"
    }));
  }
  // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
  // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
  // allow the user to provide the scroll width before we work it out.
  getScrollbarWidth() {
    if (this.scrollbarWidth == null) {
      const e = this.gos.get("scrollbarWidth"), s = typeof e == "number" && e >= 0 ? e : PP();
      s != null && (this.scrollbarWidth = s, this.eventSvc.dispatchEvent({
        type: "scrollbarWidthChanged"
      }));
    }
    return this.scrollbarWidth;
  }
}, QI = class extends L {
  constructor() {
    super(...arguments), this.beanName = "gridDestroySvc", this.destroyCalled = !1;
  }
  destroy() {
    var i;
    if (this.destroyCalled)
      return;
    const { stateSvc: e, ctrlsSvc: t, context: s } = this.beans;
    this.eventSvc.dispatchEvent({
      type: "gridPreDestroyed",
      state: (e == null ? void 0 : e.getState()) ?? {}
    }), this.destroyCalled = !0, (i = t.get("gridCtrl")) == null || i.destroyGridUi(), s.destroy(), super.destroy();
  }
}, dl = /* @__PURE__ */ new Set(["gridPreDestroyed", "fillStart", "pasteStart"]), JI = {
  suppressContextMenu: !1,
  preventDefaultOnContextMenu: !1,
  allowContextMenuWithControlKey: !1,
  suppressMenuHide: !0,
  enableBrowserTooltips: !1,
  tooltipTrigger: "hover",
  tooltipShowDelay: 2e3,
  tooltipHideDelay: 1e4,
  tooltipMouseTrack: !1,
  tooltipShowMode: "standard",
  tooltipInteraction: !1,
  copyHeadersToClipboard: !1,
  copyGroupHeadersToClipboard: !1,
  clipboardDelimiter: "	",
  suppressCopyRowsToClipboard: !1,
  suppressCopySingleCellRanges: !1,
  suppressLastEmptyLineOnPaste: !1,
  suppressClipboardPaste: !1,
  suppressClipboardApi: !1,
  suppressCutToClipboard: !1,
  maintainColumnOrder: !1,
  enableStrictPivotColumnOrder: !1,
  suppressFieldDotNotation: !1,
  allowDragFromColumnsToolPanel: !1,
  suppressMovableColumns: !1,
  suppressColumnMoveAnimation: !1,
  suppressMoveWhenColumnDragging: !1,
  suppressDragLeaveHidesColumns: !1,
  suppressRowGroupHidesColumns: !1,
  suppressAutoSize: !1,
  autoSizePadding: 20,
  skipHeaderOnAutoSize: !1,
  singleClickEdit: !1,
  suppressClickEdit: !1,
  readOnlyEdit: !1,
  stopEditingWhenCellsLoseFocus: !1,
  enterNavigatesVertically: !1,
  enterNavigatesVerticallyAfterEdit: !1,
  enableCellEditingOnBackspace: !1,
  undoRedoCellEditing: !1,
  undoRedoCellEditingLimit: 10,
  suppressCsvExport: !1,
  suppressExcelExport: !1,
  cacheQuickFilter: !1,
  includeHiddenColumnsInQuickFilter: !1,
  excludeChildrenWhenTreeDataFiltering: !1,
  enableAdvancedFilter: !1,
  includeHiddenColumnsInAdvancedFilter: !1,
  enableCharts: !1,
  masterDetail: !1,
  keepDetailRows: !1,
  keepDetailRowsCount: 10,
  detailRowAutoHeight: !1,
  tabIndex: 0,
  rowBuffer: 10,
  valueCache: !1,
  valueCacheNeverExpires: !1,
  enableCellExpressions: !1,
  suppressTouch: !1,
  suppressFocusAfterRefresh: !1,
  suppressBrowserResizeObserver: !1,
  suppressPropertyNamesCheck: !1,
  suppressChangeDetection: !1,
  debug: !1,
  suppressLoadingOverlay: !1,
  suppressNoRowsOverlay: !1,
  pagination: !1,
  paginationPageSize: 100,
  paginationPageSizeSelector: !0,
  paginationAutoPageSize: !1,
  paginateChildRows: !1,
  suppressPaginationPanel: !1,
  pivotMode: !1,
  pivotPanelShow: "never",
  pivotDefaultExpanded: 0,
  pivotSuppressAutoColumn: !1,
  suppressExpandablePivotGroups: !1,
  functionsReadOnly: !1,
  suppressAggFuncInHeader: !1,
  alwaysAggregateAtRootLevel: !1,
  aggregateOnlyChangedColumns: !1,
  suppressAggFilteredOnly: !1,
  removePivotHeaderRowWhenSingleValueColumn: !1,
  animateRows: !0,
  cellFlashDuration: 500,
  cellFadeDuration: 1e3,
  allowShowChangeAfterFilter: !1,
  domLayout: "normal",
  ensureDomOrder: !1,
  enableRtl: !1,
  suppressColumnVirtualisation: !1,
  suppressMaxRenderedRowRestriction: !1,
  suppressRowVirtualisation: !1,
  rowDragManaged: !1,
  suppressRowDrag: !1,
  suppressMoveWhenRowDragging: !1,
  rowDragEntireRow: !1,
  rowDragMultiRow: !1,
  embedFullWidthRows: !1,
  groupDisplayType: "singleColumn",
  groupDefaultExpanded: 0,
  groupMaintainOrder: !1,
  groupSelectsChildren: !1,
  groupSuppressBlankHeader: !1,
  groupSelectsFiltered: !1,
  showOpenedGroup: !1,
  groupRemoveSingleChildren: !1,
  groupRemoveLowestSingleChildren: !1,
  groupHideOpenParents: !1,
  groupAllowUnbalanced: !1,
  rowGroupPanelShow: "never",
  suppressMakeColumnVisibleAfterUnGroup: !1,
  treeData: !1,
  rowGroupPanelSuppressSort: !1,
  suppressGroupRowsSticky: !1,
  rowModelType: "clientSide",
  asyncTransactionWaitMillis: 50,
  suppressModelUpdateAfterUpdateTransaction: !1,
  cacheOverflowSize: 1,
  infiniteInitialRowCount: 1,
  serverSideInitialRowCount: 1,
  cacheBlockSize: 100,
  maxBlocksInCache: -1,
  maxConcurrentDatasourceRequests: 2,
  blockLoadDebounceMillis: 0,
  purgeClosedRowNodes: !1,
  serverSideSortAllLevels: !1,
  serverSideOnlyRefreshFilteredGroups: !1,
  serverSidePivotResultFieldSeparator: "_",
  viewportRowModelPageSize: 5,
  viewportRowModelBufferSize: 5,
  alwaysShowHorizontalScroll: !1,
  alwaysShowVerticalScroll: !1,
  debounceVerticalScrollbar: !1,
  suppressHorizontalScroll: !1,
  suppressScrollOnNewData: !1,
  suppressScrollWhenPopupsAreOpen: !1,
  suppressAnimationFrame: !1,
  suppressMiddleClickScrolls: !1,
  suppressPreventDefaultOnMouseWheel: !1,
  rowMultiSelectWithClick: !1,
  suppressRowDeselection: !1,
  suppressRowClickSelection: !1,
  suppressCellFocus: !1,
  suppressHeaderFocus: !1,
  suppressMultiRangeSelection: !1,
  enableCellTextSelection: !1,
  enableRangeSelection: !1,
  enableRangeHandle: !1,
  enableFillHandle: !1,
  fillHandleDirection: "xy",
  suppressClearOnFillReduction: !1,
  accentedSort: !1,
  unSortIcon: !1,
  suppressMultiSort: !1,
  alwaysMultiSort: !1,
  suppressMaintainUnsortedOrder: !1,
  suppressRowHoverHighlight: !1,
  suppressRowTransform: !1,
  columnHoverHighlight: !1,
  deltaSort: !1,
  enableGroupEdit: !1,
  groupLockGroupColumns: 0,
  serverSideEnableClientSideSort: !1,
  suppressServerSideFullWidthLoadingRow: !1,
  pivotMaxGeneratedColumns: -1,
  columnMenu: "new",
  reactiveCustomComponents: !0,
  suppressSetFilterByDefault: !1
}, eL = 0, tL = 0, sL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "gos", this.domDataKey = "__AG_" + Math.random().toString(), this.gridInstanceId = tL++, this.propEventSvc = new Mr(), this.globalEventHandlerFactory = (e) => (t, s) => {
      if (!this.isAlive())
        return;
      const i = dl.has(t);
      if (i && !e || !i && e)
        return;
      const r = Fv(t), n = this.gridOptions[r];
      typeof n == "function" && this.beans.frameworkOverrides.wrapOutgoing(() => {
        n(s);
      });
    };
  }
  wireBeans(e) {
    this.gridOptions = e.gridOptions, this.validation = e.validation, this.api = e.gridApi, this.gridId = e.context.getGridId();
  }
  // This is quicker then having code call gridOptionsService.get('context')
  get gridOptionsContext() {
    return this.gridOptions.context;
  }
  postConstruct() {
    this.eventSvc.addGlobalListener(this.globalEventHandlerFactory().bind(this), !0), this.eventSvc.addGlobalListener(this.globalEventHandlerFactory(!0).bind(this), !1), this.propEventSvc.setFrameworkOverrides(this.beans.frameworkOverrides), this.addManagedEventListeners({
      gridOptionsChanged: ({ options: e }) => {
        this.updateGridOptions({ options: e, force: !0, source: "gridOptionsUpdated" });
      }
    });
  }
  /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */
  get(e) {
    return this.gridOptions[e] ?? JI[e];
  }
  /**
   * Get the GridOption callback but wrapped so that the common params of api and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */
  getCallback(e) {
    return this.mergeGridCommonParams(this.gridOptions[e]);
  }
  /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */
  exists(e) {
    return W(this.gridOptions[e]);
  }
  /**
   * Wrap the user callback and attach the api and context to the params object on the way through.
   * @param callback User provided callback
   * @returns Wrapped callback where the params object not require api and context
   */
  mergeGridCommonParams(e) {
    return e && ((s) => e(this.addGridCommonParams(s)));
  }
  updateGridOptions({
    options: e,
    force: t,
    source: s = "api"
  }) {
    const i = { id: eL++, properties: [] }, r = [], { gridOptions: n, validation: o } = this;
    Object.entries(e).forEach(([a, l]) => {
      o == null || o.warnOnInitialPropertyUpdate(s, a);
      const c = t || typeof l == "object" && s === "api", d = n[a];
      if (c || d !== l) {
        n[a] = l;
        const u = {
          type: a,
          currentValue: l,
          previousValue: d,
          changeSet: i,
          source: s
        };
        r.push(u);
      }
    }), o == null || o.processGridOptions(this.gridOptions), i.properties = r.map((a) => a.type), r.forEach((a) => {
      Rr(this, `Updated property ${a.type} from`, a.previousValue, " to ", a.currentValue), this.propEventSvc.dispatchEvent(a);
    });
  }
  addPropertyEventListener(e, t) {
    this.propEventSvc.addEventListener(e, t);
  }
  removePropertyEventListener(e, t) {
    this.propEventSvc.removeEventListener(e, t);
  }
  getDomDataKey() {
    return this.domDataKey;
  }
  getGridCommonParams() {
    return {
      api: this.api,
      context: this.gridOptionsContext
    };
  }
  addGridCommonParams(e) {
    const t = e;
    return t.api = this.api, t.context = this.gridOptionsContext, t;
  }
  assertModuleRegistered(e, t) {
    const s = Array.isArray(e) ? e.some((i) => this.isModuleRegistered(i)) : this.isModuleRegistered(e);
    return s || be(200, {
      ...this.getModuleErrorParams(),
      moduleName: e,
      reasonOrId: t
    }), s;
  }
  getModuleErrorParams() {
    return {
      gridId: this.gridId,
      gridScoped: mh(),
      rowModelType: this.get("rowModelType")
    };
  }
  isModuleRegistered(e) {
    return sw(e, this.gridId, this.get("rowModelType"));
  }
};
function iL(e) {
  return (
    /* html */
    `<div class="ag-cell-label-container" role="presentation">
        <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
        <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
        <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
            <span data-ref="eText" class="ag-header-cell-text"></span>
            <span data-ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
            ${e ? '<ag-sort-indicator data-ref="eSortIndicator"></ag-sort-indicator>' : ""}
        </div>
    </div>`
  );
}
var rL = class extends _ {
  constructor() {
    super(...arguments), this.eFilter = E, this.eFilterButton = E, this.eSortIndicator = E, this.eMenu = E, this.eLabel = E, this.eText = E, this.eSortOrder = E, this.eSortAsc = E, this.eSortDesc = E, this.eSortMixed = E, this.eSortNone = E, this.isLoadingInnerComponent = !1;
  }
  refresh(e) {
    const t = this.params;
    return this.params = e, this.workOutTemplate() != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || e.enableSorting != this.currentSort || this.currentSuppressMenuHide != null && this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || t.enableFilterButton != e.enableFilterButton || t.enableFilterIcon != e.enableFilterIcon ? !1 : (this.setDisplayName(e), !0);
  }
  workOutTemplate() {
    const { params: e, beans: t } = this, s = e.template ?? iL(!!t.sortSvc);
    return s != null && s.trim ? s.trim() : s;
  }
  init(e) {
    this.params = e;
    const { sortSvc: t, touchSvc: s, userCompFactory: i } = this.beans;
    this.currentTemplate = this.workOutTemplate(), this.setTemplate(this.currentTemplate, t ? [t.getSortIndicatorSelector()] : void 0), s == null || s.setupForHeader(this), this.setMenu(), this.setupSort(), this.setupFilterIcon(), this.setupFilterButton(), this.workOutInnerHeaderComponent(i, e), this.setDisplayName(e);
  }
  workOutInnerHeaderComponent(e, t) {
    const s = $T(e, t, t);
    s && (this.isLoadingInnerComponent = !0, s.newAgStackInstance().then((i) => {
      this.isLoadingInnerComponent = !1, i && (this.isAlive() ? (this.innerHeaderComponent = i, this.eText.appendChild(i.getGui())) : this.destroyBean(i));
    }));
  }
  setDisplayName(e) {
    const { displayName: t } = e, s = this.currentDisplayName;
    if (this.currentDisplayName = t, s === t || this.innerHeaderComponent || this.isLoadingInnerComponent)
      return;
    const i = Ke(t, !0);
    this.eText.textContent = i;
  }
  addInIcon(e, t, s) {
    if (t == null)
      return;
    const i = ue(e, this.beans, s);
    i && t.appendChild(i);
  }
  workOutShowMenu() {
    var e;
    return this.params.enableMenu && !!((e = this.beans.menuSvc) != null && e.isHeaderMenuButtonEnabled());
  }
  shouldSuppressMenuHide() {
    var e;
    return !!((e = this.beans.menuSvc) != null && e.isHeaderMenuButtonAlwaysShowEnabled());
  }
  setMenu() {
    if (!this.eMenu)
      return;
    if (this.currentShowMenu = this.workOutShowMenu(), !this.currentShowMenu) {
      ut(this.eMenu), this.eMenu = void 0;
      return;
    }
    const { gos: e, eMenu: t, params: s } = this, i = Mt(e);
    this.addInIcon(i ? "menu" : "menuAlt", t, s.column), t.classList.toggle("ag-header-menu-icon", !i);
    const r = this.shouldSuppressMenuHide();
    this.currentSuppressMenuHide = r, this.addManagedElementListeners(t, { click: () => s.showColumnMenu(t) }), t.classList.toggle("ag-header-menu-always-show", r);
  }
  onMenuKeyboardShortcut(e) {
    var l;
    const { params: t, gos: s, beans: i, eMenu: r, eFilterButton: n } = this, o = t.column, a = Mt(s);
    if (e && !a) {
      if ((l = i.menuSvc) != null && l.isFilterMenuInHeaderEnabled(o))
        return t.showFilter(n ?? r ?? this.getGui()), !0;
    } else if (t.enableMenu)
      return t.showColumnMenu(r ?? n ?? this.getGui()), !0;
    return !1;
  }
  setupSort() {
    const { sortSvc: e } = this.beans;
    if (!e)
      return;
    const { enableSorting: t, column: s } = this.params;
    if (this.currentSort = t, !this.eSortIndicator) {
      this.eSortIndicator = this.createBean(e.createSortIndicator(!0));
      const { eSortIndicator: i, eSortOrder: r, eSortAsc: n, eSortDesc: o, eSortMixed: a, eSortNone: l } = this;
      i.attachCustomElements(r, n, o, a, l);
    }
    this.eSortIndicator.setupSort(s), this.currentSort && e.setupHeader(this, s, this.eLabel);
  }
  setupFilterIcon() {
    const { eFilter: e, params: t } = this;
    e && this.configureFilter(t.enableFilterIcon, e, this.onFilterChangedIcon.bind(this), "filterActive");
  }
  setupFilterButton() {
    const { eFilterButton: e, params: t } = this;
    if (!e)
      return;
    this.configureFilter(
      t.enableFilterButton,
      e,
      this.onFilterChangedButton.bind(this),
      "filter"
    ) ? this.addManagedElementListeners(e, {
      click: () => t.showFilter(e)
    }) : this.eFilterButton = void 0;
  }
  configureFilter(e, t, s, i) {
    if (!e)
      return ut(t), !1;
    const r = this.params.column;
    return this.addInIcon(i, t, r), this.addManagedListeners(r, { filterChanged: s }), s(), !0;
  }
  onFilterChangedIcon() {
    const e = this.params.column.isFilterActive();
    re(this.eFilter, e, { skipAriaHidden: !0 });
  }
  onFilterChangedButton() {
    const e = this.params.column.isFilterActive();
    this.eFilterButton.classList.toggle("ag-filter-active", e);
  }
  getAnchorElementForMenu(e) {
    const { eFilterButton: t, eMenu: s } = this;
    return e ? t ?? s ?? this.getGui() : s ?? t ?? this.getGui();
  }
  destroy() {
    super.destroy(), this.innerHeaderComponent && (this.destroyBean(this.innerHeaderComponent), this.innerHeaderComponent = void 0);
  }
}, nL = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="ag-header-group-cell-label" role="presentation">
            <span data-ref="agLabel" class="ag-header-group-text" role="presentation"></span>
            <span data-ref="agOpened" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded"></span>
            <span data-ref="agClosed" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed"></span>
        </div>`
    ), this.agOpened = E, this.agClosed = E, this.agLabel = E, this.isLoadingInnerComponent = !1;
  }
  init(e) {
    const { userCompFactory: t } = this.beans;
    this.params = e, this.checkWarnings(), this.workOutInnerHeaderGroupComponent(t, e), this.setupLabel(e), this.addGroupExpandIcon(e), this.setupExpandIcons();
  }
  checkWarnings() {
    this.params.template && I(89);
  }
  workOutInnerHeaderGroupComponent(e, t) {
    const s = KT(e, t, t);
    s && (this.isLoadingInnerComponent = !0, s.newAgStackInstance().then((i) => {
      this.isLoadingInnerComponent = !1, i && (this.isAlive() ? (this.innerHeaderGroupComponent = i, this.agLabel.appendChild(i.getGui())) : this.destroyBean(i));
    }));
  }
  setupExpandIcons() {
    const {
      agOpened: e,
      agClosed: t,
      params: { columnGroup: s },
      beans: i
    } = this;
    this.addInIcon("columnGroupOpened", e), this.addInIcon("columnGroupClosed", t);
    const r = (l) => {
      if (Ds(l))
        return;
      const c = !s.isExpanded();
      i.colGroupSvc.setColumnGroupOpened(
        s.getProvidedColumnGroup(),
        c,
        "uiColumnExpanded"
      );
    };
    this.addTouchAndClickListeners(i, t, r), this.addTouchAndClickListeners(i, e, r);
    const n = (l) => {
      gt(l);
    };
    this.addManagedElementListeners(t, { dblclick: n }), this.addManagedElementListeners(e, { dblclick: n }), this.addManagedElementListeners(this.getGui(), { dblclick: r }), this.updateIconVisibility();
    const o = s.getProvidedColumnGroup(), a = this.updateIconVisibility.bind(this);
    this.addManagedListeners(o, {
      expandedChanged: a,
      expandableChanged: a
    });
  }
  addTouchAndClickListeners(e, t, s) {
    var i;
    (i = e.touchSvc) == null || i.setupForHeaderGroup(this, t, s), this.addManagedElementListeners(t, { click: s });
  }
  updateIconVisibility() {
    const {
      agOpened: e,
      agClosed: t,
      params: { columnGroup: s }
    } = this;
    if (s.isExpandable()) {
      const i = s.isExpanded();
      re(e, i), re(t, !i);
    } else
      re(e, !1), re(t, !1);
  }
  addInIcon(e, t) {
    const s = ue(e, this.beans, null);
    s && t.appendChild(s);
  }
  addGroupExpandIcon(e) {
    if (!e.columnGroup.isExpandable()) {
      const { agOpened: t, agClosed: s } = this;
      re(t, !1), re(s, !1);
      return;
    }
  }
  setupLabel(e) {
    var r;
    const { displayName: t, columnGroup: s } = e, i = this.innerHeaderGroupComponent || this.isLoadingInnerComponent;
    if (W(t) && !i) {
      const n = Ke(t, !0);
      this.agLabel.textContent = n;
    }
    this.addOrRemoveCssClass("ag-sticky-label", !((r = s.getColGroupDef()) != null && r.suppressStickyLabel));
  }
  destroy() {
    super.destroy(), this.innerHeaderGroupComponent && (this.destroyBean(this.innerHeaderGroupComponent), this.innerHeaderGroupComponent = void 0);
  }
}, oL = {
  moduleName: "ColumnHeaderComp",
  version: de,
  userComponents: {
    agColumnHeader: rL
  },
  icons: {
    // button to launch legacy column menu
    menu: "menu",
    // button to launch new enterprise column menu
    menuAlt: "menu-alt"
  }
}, aL = {
  moduleName: "ColumnGroupHeaderComp",
  version: de,
  userComponents: {
    agColumnGroupHeader: nL
  },
  icons: {
    // header column group shown when expanded (click to contract)
    columnGroupOpened: "expanded",
    // header column group shown when contracted (click to expand)
    columnGroupClosed: "contracted"
  }
}, lL = {
  moduleName: "AnimationFrame",
  version: de,
  beans: [mE]
}, cL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "touchSvc";
  }
  mockBodyContextMenu(e, t) {
    this.mockContextMenu(e, e.eBodyViewport, t);
  }
  mockHeaderContextMenu(e, t) {
    this.mockContextMenu(e, e.eGui, t);
  }
  mockRowContextMenu(e) {
    if (!yr())
      return;
    const t = (s, i, r) => {
      var a;
      const { rowCtrl: n, cellCtrl: o } = e.getControlsForEventTarget((r == null ? void 0 : r.target) ?? null);
      o != null && o.column && o.dispatchCellContextMenuEvent(r ?? null), (a = this.beans.contextMenuSvc) == null || a.handleContextMenuMouseEvent(void 0, r, n, o);
    };
    this.mockContextMenu(e, e.element, t);
  }
  handleCellDoubleClick(e, t) {
    return (() => {
      if (!yr() || Tv("dblclick"))
        return !1;
      const i = (/* @__PURE__ */ new Date()).getTime(), r = i - e.lastIPadMouseClickEvent < 200;
      return e.lastIPadMouseClickEvent = i, r;
    })() ? (e.onCellDoubleClicked(t), t.preventDefault(), !0) : !1;
  }
  setupForHeader(e) {
    const { gos: t, sortSvc: s } = this.beans;
    if (t.get("suppressTouch"))
      return;
    const { params: i, eMenu: r, eFilterButton: n } = e, o = new fr(e.getGui(), !0), a = e.shouldSuppressMenuHide(), l = a && W(r), c = l ? new fr(r, !0) : o;
    if (i.enableMenu) {
      const d = l ? "tap" : "longTap", u = (h) => i.showColumnMenuAfterMouseClick(h.touchStart);
      e.addManagedListeners(c, { [d]: u });
    }
    if (i.enableSorting) {
      const d = (u) => {
        const h = u.touchStart.target;
        a && (r != null && r.contains(h) || n != null && n.contains(h)) || s == null || s.progressSort(i.column, !1, "uiColumnSorted");
      };
      e.addManagedListeners(o, { tap: d });
    }
    if (i.enableFilterButton && n) {
      const d = new fr(n, !0);
      e.addManagedListeners(d, {
        tap: () => i.showFilter(n)
      }), e.addDestroyFunc(() => d.destroy());
    }
    e.addDestroyFunc(() => o.destroy()), l && e.addDestroyFunc(() => c.destroy());
  }
  setupForHeaderGroup(e, t, s) {
    const i = new fr(t, !0);
    e.addManagedListeners(i, { tap: s }), e.addDestroyFunc(() => i.destroy());
  }
  mockContextMenu(e, t, s) {
    if (!yr())
      return;
    const i = new fr(t), r = (n) => {
      s(void 0, n.touchStart, n.touchEvent);
    };
    e.addManagedListeners(i, { longTap: r }), e.addDestroyFunc(() => i.destroy());
  }
}, dL = {
  moduleName: "Touch",
  version: de,
  beans: [cL]
}, uL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "cellNavigation";
  }
  // returns null if no cell to focus on, ie at the end of the grid
  getNextCellToFocus(e, t, s = !1) {
    return s ? this.getNextCellToFocusWithCtrlPressed(e, t) : this.getNextCellToFocusWithoutCtrlPressed(e, t);
  }
  getNextCellToFocusWithCtrlPressed(e, t) {
    const s = e === P.UP, i = e === P.DOWN, r = e === P.LEFT;
    let n, o;
    const { pageBounds: a, gos: l, visibleCols: c } = this.beans;
    if (s || i)
      o = s ? a.getFirstRow() : a.getLastRow(), n = t.column;
    else {
      const d = c.allCols, u = l.get("enableRtl");
      o = t.rowIndex, n = r !== u ? d[0] : pe(d);
    }
    return {
      rowIndex: o,
      rowPinned: null,
      column: n
    };
  }
  getNextCellToFocusWithoutCtrlPressed(e, t) {
    let s = t, i = !1;
    for (; !i; ) {
      switch (e) {
        case P.UP:
          s = this.getCellAbove(s);
          break;
        case P.DOWN:
          s = this.getCellBelow(s);
          break;
        case P.RIGHT:
          s = this.gos.get("enableRtl") ? this.getCellToLeft(s) : this.getCellToRight(s);
          break;
        case P.LEFT:
          s = this.gos.get("enableRtl") ? this.getCellToRight(s) : this.getCellToLeft(s);
          break;
        default:
          s = null, I(8, { key: e });
          break;
      }
      s ? i = this.isCellGoodToFocusOn(s) : i = !0;
    }
    return s;
  }
  isCellGoodToFocusOn(e) {
    const t = e.column;
    let s;
    const { pinnedRowModel: i, rowModel: r } = this.beans;
    switch (e.rowPinned) {
      case "top":
        s = i == null ? void 0 : i.getPinnedTopRow(e.rowIndex);
        break;
      case "bottom":
        s = i == null ? void 0 : i.getPinnedBottomRow(e.rowIndex);
        break;
      default:
        s = r.getRow(e.rowIndex);
        break;
    }
    return s ? !this.isSuppressNavigable(t, s) : !1;
  }
  getCellToLeft(e) {
    if (!e)
      return null;
    const t = this.beans.visibleCols.getColBefore(e.column);
    return t ? {
      rowIndex: e.rowIndex,
      column: t,
      rowPinned: e.rowPinned
    } : null;
  }
  getCellToRight(e) {
    if (!e)
      return null;
    const t = this.beans.visibleCols.getColAfter(e.column);
    return t ? {
      rowIndex: e.rowIndex,
      column: t,
      rowPinned: e.rowPinned
    } : null;
  }
  getRowBelow(e) {
    const t = e.rowIndex, s = e.rowPinned;
    let i = !1;
    const { pageBounds: r, pinnedRowModel: n, rowModel: o } = this.beans;
    if (this.isLastRowInContainer(e))
      switch (s) {
        case "bottom":
          return null;
        case "top":
          return o.isRowsToRender() ? { rowIndex: r.getFirstRow(), rowPinned: null } : n != null && n.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
        default:
          return n != null && n.isRowsToRender("bottom") ? { rowIndex: 0, rowPinned: "bottom" } : null;
      }
    else s && (i = !0);
    const a = o.getRow(e.rowIndex), l = i ? void 0 : this.getNextStickyPosition(a);
    return l || { rowIndex: t + 1, rowPinned: s };
  }
  getNextStickyPosition(e, t) {
    const { gos: s, rowRenderer: i } = this.beans;
    if (!cc(s) || !e || !e.sticky)
      return;
    const r = i.getStickyTopRowCtrls().some((c) => c.rowNode.rowIndex === e.rowIndex);
    let n = [];
    r ? n = [...i.getStickyTopRowCtrls()].sort(
      (c, d) => c.rowNode.rowIndex - d.rowNode.rowIndex
    ) : n = [...i.getStickyBottomRowCtrls()].sort(
      (c, d) => d.rowNode.rowIndex - c.rowNode.rowIndex
    );
    const o = t ? -1 : 1, a = n.findIndex((c) => c.rowNode.rowIndex === e.rowIndex), l = n[a + o];
    if (l)
      return { rowIndex: l.rowNode.rowIndex, rowPinned: null };
  }
  getCellBelow(e) {
    if (!e)
      return null;
    const t = this.getRowBelow(e);
    return t ? {
      rowIndex: t.rowIndex,
      column: e.column,
      rowPinned: t.rowPinned
    } : null;
  }
  isLastRowInContainer(e) {
    const t = e.rowPinned, s = e.rowIndex, { pinnedRowModel: i, pageBounds: r } = this.beans;
    return t === "top" ? ((i == null ? void 0 : i.getPinnedTopRowCount()) ?? -1) <= s : t === "bottom" ? ((i == null ? void 0 : i.getPinnedBottomRowCount()) ?? -1) <= s : r.getLastRow() <= s;
  }
  getRowAbove(e) {
    const t = e.rowIndex, s = e.rowPinned, { pageBounds: i, pinnedRowModel: r, rowModel: n } = this.beans, o = s ? t === 0 : t === i.getFirstRow();
    let a = !1;
    const l = () => ({ rowIndex: (r == null ? void 0 : r.getPinnedTopRowCount()) ?? -1, rowPinned: "top" });
    if (o)
      return s === "top" ? null : s && n.isRowsToRender() ? { rowIndex: i.getLastRow(), rowPinned: null } : r != null && r.isRowsToRender("top") ? l() : null;
    s && (a = !0);
    const c = n.getRow(e.rowIndex), d = a ? void 0 : this.getNextStickyPosition(c, !0);
    return d || { rowIndex: t - 1, rowPinned: s };
  }
  getCellAbove(e) {
    if (!e)
      return null;
    const t = this.getRowAbove({ rowIndex: e.rowIndex, rowPinned: e.rowPinned });
    return t ? {
      rowIndex: t.rowIndex,
      column: e.column,
      rowPinned: t.rowPinned
    } : null;
  }
  getNextTabbedCell(e, t) {
    return t ? this.getNextTabbedCellBackwards(e) : this.getNextTabbedCellForwards(e);
  }
  getNextTabbedCellForwards(e) {
    const { visibleCols: t, pagination: s } = this.beans, i = t.allCols;
    let r = e.rowIndex, n = e.rowPinned, o = t.getColAfter(e.column);
    if (!o) {
      o = i[0];
      const a = this.getRowBelow(e);
      if (ke(a) || !a.rowPinned && !((s == null ? void 0 : s.isRowInPage(a)) ?? !0))
        return null;
      r = a ? a.rowIndex : null, n = a ? a.rowPinned : null;
    }
    return { rowIndex: r, column: o, rowPinned: n };
  }
  getNextTabbedCellBackwards(e) {
    const { visibleCols: t, pagination: s } = this.beans, i = t.allCols;
    let r = e.rowIndex, n = e.rowPinned, o = t.getColBefore(e.column);
    if (!o) {
      o = pe(i);
      const a = this.getRowAbove({ rowIndex: e.rowIndex, rowPinned: e.rowPinned });
      if (ke(a) || !a.rowPinned && !((s == null ? void 0 : s.isRowInPage(a)) ?? !0))
        return null;
      r = a ? a.rowIndex : null, n = a ? a.rowPinned : null;
    }
    return { rowIndex: r, column: o, rowPinned: n };
  }
  isSuppressNavigable(e, t) {
    const { suppressNavigable: s } = e.colDef;
    if (typeof s == "boolean")
      return s;
    if (typeof s == "function") {
      const i = e.createColumnFunctionCallbackParams(t);
      return s(i);
    }
    return !1;
  }
};
function hL(e) {
  return e.focusSvc.getFocusedCell();
}
function pL(e) {
  return e.focusSvc.clearFocusedCell();
}
function gL(e, t, s, i) {
  e.focusSvc.setFocusedCell({ rowIndex: t, column: s, rowPinned: i, forceBrowserFocus: !0 });
}
function fL(e, t) {
  var s;
  return ((s = e.navigation) == null ? void 0 : s.tabToNextCell(!1, t)) ?? !1;
}
function mL(e, t) {
  var s;
  return ((s = e.navigation) == null ? void 0 : s.tabToNextCell(!0, t)) ?? !1;
}
function CL(e, t, s = !1) {
  var r;
  const i = (r = e.headerNavigation) == null ? void 0 : r.getHeaderPositionForColumn(t, s);
  i && e.focusSvc.focusHeaderPosition({ headerPosition: i });
}
var vL = class extends L {
  constructor() {
    super(), this.beanName = "navigation", this.onPageDown = Hg(this.onPageDown, 100), this.onPageUp = Hg(this.onPageUp, 100);
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCon = e.gridBodyCtrl;
    });
  }
  handlePageScrollingKey(e, t = !1) {
    const s = e.key, i = e.altKey, r = e.ctrlKey || e.metaKey, n = !!this.beans.rangeSvc && e.shiftKey, o = pw(this.gos, e);
    let a = !1;
    switch (s) {
      case P.PAGE_HOME:
      case P.PAGE_END:
        !r && !i && (this.onHomeOrEndKey(s), a = !0);
        break;
      case P.LEFT:
      case P.RIGHT:
      case P.UP:
      case P.DOWN:
        if (!o)
          return !1;
        r && !i && !n && (this.onCtrlUpDownLeftRight(s, o), a = !0);
        break;
      case P.PAGE_DOWN:
      case P.PAGE_UP:
        !r && !i && (a = this.handlePageUpDown(s, o, t));
        break;
    }
    return a && e.preventDefault(), a;
  }
  handlePageUpDown(e, t, s) {
    return s && (t = this.beans.focusSvc.getFocusedCell()), t ? (e === P.PAGE_UP ? this.onPageUp(t) : this.onPageDown(t), !0) : !1;
  }
  navigateTo(e) {
    const { scrollIndex: t, scrollType: s, scrollColumn: i, focusIndex: r, focusColumn: n } = e, { scrollFeature: o } = this.gridBodyCon;
    W(i) && !i.isPinned() && o.ensureColumnVisible(i), W(t) && o.ensureIndexVisible(t, s), e.isAsync || o.ensureIndexVisible(r);
    const { focusSvc: a, rangeSvc: l } = this.beans;
    a.setFocusedCell({
      rowIndex: r,
      column: n,
      rowPinned: null,
      forceBrowserFocus: !0
    }), l == null || l.setRangeToCell({ rowIndex: r, rowPinned: null, column: n });
  }
  // this method is throttled, see the `constructor`
  onPageDown(e) {
    const t = this.beans, s = Fd(t), i = this.getViewportHeight(), { pageBounds: r, rowModel: n, rowAutoHeight: o } = t, a = r.getPixelOffset(), l = s.top + i, c = n.getRowIndexAtPixel(l + a);
    o != null && o.active ? this.navigateToNextPageWithAutoHeight(e, c) : this.navigateToNextPage(e, c);
  }
  // this method is throttled, see the `constructor`
  onPageUp(e) {
    const t = this.beans, s = Fd(t), { pageBounds: i, rowModel: r, rowAutoHeight: n } = t, o = i.getPixelOffset(), a = s.top, l = r.getRowIndexAtPixel(a + o);
    n != null && n.active ? this.navigateToNextPageWithAutoHeight(e, l, !0) : this.navigateToNextPage(e, l, !0);
  }
  navigateToNextPage(e, t, s = !1) {
    const { pageBounds: i, rowModel: r } = this.beans, n = this.getViewportHeight(), o = i.getFirstRow(), a = i.getLastRow(), l = i.getPixelOffset(), c = r.getRow(e.rowIndex), d = s ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
      (c == null ? void 0 : c.rowHeight) - n - l
    ) : n - l, u = (c == null ? void 0 : c.rowTop) + d;
    let h = r.getRowIndexAtPixel(u + l);
    if (h === e.rowIndex) {
      const g = s ? -1 : 1;
      t = h = e.rowIndex + g;
    }
    let p;
    s ? (p = "bottom", h < o && (h = o), t < o && (t = o)) : (p = "top", h > a && (h = a), t > a && (t = a)), this.isRowTallerThanView(r.getRow(h)) && (t = h, p = "top"), this.navigateTo({
      scrollIndex: t,
      scrollType: p,
      scrollColumn: null,
      focusIndex: h,
      focusColumn: e.column
    });
  }
  navigateToNextPageWithAutoHeight(e, t, s = !1) {
    this.navigateTo({
      scrollIndex: t,
      scrollType: s ? "bottom" : "top",
      scrollColumn: null,
      focusIndex: t,
      focusColumn: e.column
    }), setTimeout(() => {
      const i = this.getNextFocusIndexForAutoHeight(e, s);
      this.navigateTo({
        scrollIndex: t,
        scrollType: s ? "bottom" : "top",
        scrollColumn: null,
        focusIndex: i,
        focusColumn: e.column,
        isAsync: !0
      });
    }, 50);
  }
  getNextFocusIndexForAutoHeight(e, t = !1) {
    const s = t ? -1 : 1, i = this.getViewportHeight(), { pageBounds: r, rowModel: n } = this.beans, o = r.getLastRow();
    let a = 0, l = e.rowIndex;
    for (; l >= 0 && l <= o; ) {
      const c = n.getRow(l);
      if (c) {
        const d = c.rowHeight ?? 0;
        if (a + d > i)
          break;
        a += d;
      }
      l += s;
    }
    return Math.max(0, Math.min(l, o));
  }
  getViewportHeight() {
    const e = this.beans, t = Fd(e), s = this.beans.scrollVisibleSvc.getScrollbarWidth();
    let i = t.bottom - t.top;
    return e.ctrlsSvc.get("center").isHorizontalScrollShowing() && (i -= s), i;
  }
  isRowTallerThanView(e) {
    if (!e)
      return !1;
    const t = e.rowHeight;
    return typeof t != "number" ? !1 : t > this.getViewportHeight();
  }
  onCtrlUpDownLeftRight(e, t) {
    const s = this.beans.cellNavigation.getNextCellToFocus(e, t, !0), { rowIndex: i } = s, r = s.column;
    this.navigateTo({
      scrollIndex: i,
      scrollType: null,
      scrollColumn: r,
      focusIndex: i,
      focusColumn: r
    });
  }
  // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
  // same cell into view (which means either scroll all the way up, or all the way down).
  onHomeOrEndKey(e) {
    const t = e === P.PAGE_HOME, { visibleCols: s, pageBounds: i } = this.beans, r = s.allCols, n = t ? r[0] : pe(r), o = t ? i.getFirstRow() : i.getLastRow();
    this.navigateTo({
      scrollIndex: o,
      scrollType: null,
      scrollColumn: n,
      focusIndex: o,
      focusColumn: n
    });
  }
  // result of keyboard event
  onTabKeyDown(e, t) {
    const s = t.shiftKey, i = this.tabToNextCellCommon(e, s, t), r = this.beans, { ctrlsSvc: n, pageBounds: o, focusSvc: a, gos: l } = r;
    if (i !== !1) {
      i ? t.preventDefault() : i === null && n.get("gridCtrl").allowFocusForNextCoreContainer(s);
      return;
    }
    if (s) {
      const { rowIndex: c, rowPinned: d } = e.getRowPosition();
      (d ? c === 0 : c === o.getFirstRow()) && (l.get("headerHeight") === 0 || _n(r) ? Ui(r, !0, !0) : (t.preventDefault(), a.focusPreviousFromFirstCell(t)));
    } else
      e instanceof cl && e.focusCell(!0), (!s && a.focusOverlay(!1) || Ui(r, s)) && t.preventDefault();
  }
  // comes from API
  tabToNextCell(e, t) {
    const s = this.beans, { focusSvc: i, rowRenderer: r } = s, n = i.getFocusedCell();
    if (!n)
      return !1;
    let o = yi(s, n);
    return !o && (o = r.getRowByPosition(n), !o || !o.isFullWidth()) ? !1 : !!this.tabToNextCellCommon(o, e, t);
  }
  tabToNextCellCommon(e, t, s) {
    let i = e.editing;
    if (!i && e instanceof cl) {
      const o = e.rowCtrl;
      o && (i = o.editing);
    }
    let r;
    return i ? this.gos.get("editType") === "fullRow" ? r = this.moveToNextEditingRow(e, t, s) : r = this.moveToNextEditingCell(e, t, s) : r = this.moveToNextCellNotEditing(e, t), r === null ? r : r || !!this.beans.focusSvc.focusedHeader;
  }
  // returns null if no navigation should be performed
  moveToNextEditingCell(e, t, s = null) {
    var n;
    const i = e.cellPosition;
    e.eGui.focus(), e.stopEditing();
    const r = this.findNextCellToFocusOn(i, t, !0);
    return r === !1 ? null : r == null ? !1 : ((n = this.beans.editSvc) == null || n.startEditing(r, null, !0, s), r.focusCell(!1), !0);
  }
  // returns null if no navigation should be performed
  moveToNextEditingRow(e, t, s = null) {
    const i = e.cellPosition, r = this.findNextCellToFocusOn(i, t, !0);
    if (r === !1)
      return null;
    if (r == null)
      return !1;
    const n = r.cellPosition, o = this.isCellEditable(i), a = this.isCellEditable(n), l = n && i.rowIndex === n.rowIndex && i.rowPinned === n.rowPinned, { editSvc: c, rowEditSvc: d } = this.beans;
    if (o && (c == null || c.setFocusOutOnEditor(e)), !l) {
      const u = e.rowCtrl;
      c == null || c.stopRowEditing(u);
      const h = r.rowCtrl;
      d == null || d.startEditing(h, void 0, void 0, s);
    }
    return a ? (c == null || c.setFocusInOnEditor(r), r.focusCell()) : r.focusCell(!0), !0;
  }
  // returns null if no navigation should be performed
  moveToNextCellNotEditing(e, t) {
    const s = this.beans.visibleCols.allCols;
    let i;
    e instanceof cu ? i = {
      ...e.getRowPosition(),
      column: t ? s[0] : pe(s)
    } : i = e.cellPosition;
    const r = this.findNextCellToFocusOn(i, t, !1);
    if (r === !1)
      return null;
    if (r instanceof cl)
      r.focusCell(!0);
    else if (r)
      return this.tryToFocusFullWidthRow(r.getRowPosition(), t);
    return W(r);
  }
  /**
   * called by the cell, when tab is pressed while editing.
   * @return: RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */
  findNextCellToFocusOn(e, t, s) {
    let i = e;
    const r = this.beans, { cellNavigation: n, gos: o, focusSvc: a, rowRenderer: l, rangeSvc: c } = r;
    for (; ; ) {
      e !== i && (e = i), t || (i = this.getLastCellOfColSpan(i)), i = n.getNextTabbedCell(i, t);
      const d = o.getCallback("tabToNextCell");
      if (W(d)) {
        const g = d({
          backwards: t,
          editing: s,
          previousCellPosition: e,
          nextCellPosition: i || null
        });
        if (g === !0)
          i = e;
        else {
          if (g === !1)
            return !1;
          i = {
            rowIndex: g.rowIndex,
            column: g.column,
            rowPinned: g.rowPinned
          };
        }
      }
      if (!i)
        return null;
      if (i.rowIndex < 0) {
        const p = Vi(r);
        return a.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: p + i.rowIndex,
            column: i.column
          },
          fromCell: !0
        }), null;
      }
      const u = o.get("editType") === "fullRow";
      if (s && !u && !this.isCellEditable(i))
        continue;
      this.ensureCellVisible(i);
      const h = yi(r, i);
      if (!h) {
        const p = l.getRowByPosition(i);
        if (!p || !p.isFullWidth() || s)
          continue;
        return p;
      }
      if (!n.isSuppressNavigable(h.column, h.rowNode))
        return c == null || c.setRangeToCell(i), h;
    }
  }
  isCellEditable(e) {
    const t = this.lookupRowNodeForCell(e);
    return t ? e.column.isCellEditable(t) : !1;
  }
  lookupRowNodeForCell({ rowIndex: e, rowPinned: t }) {
    const { pinnedRowModel: s, rowModel: i } = this.beans;
    return t === "top" ? s == null ? void 0 : s.getPinnedTopRow(e) : t === "bottom" ? s == null ? void 0 : s.getPinnedBottomRow(e) : i.getRow(e);
  }
  // we use index for rows, but column object for columns, as the next column (by index) might not
  // be visible (header grouping) so it's not reliable, so using the column object instead.
  navigateToNextCell(e, t, s, i) {
    let r = s, n = !1;
    const o = this.beans, { cellNavigation: a, focusSvc: l, gos: c } = o;
    for (; r && (r === s || !this.isValidNavigateCell(r)); )
      c.get("enableRtl") ? t === P.LEFT && (r = this.getLastCellOfColSpan(r)) : t === P.RIGHT && (r = this.getLastCellOfColSpan(r)), r = a.getNextCellToFocus(t, r), n = ke(r);
    if (n && e && e.key === P.UP && (r = {
      rowIndex: -1,
      rowPinned: null,
      column: s.column
    }), i) {
      const u = c.getCallback("navigateToNextCell");
      if (W(u)) {
        const p = u({
          key: t,
          previousCellPosition: s,
          nextCellPosition: r || null,
          event: e
        });
        W(p) ? r = {
          rowPinned: p.rowPinned,
          rowIndex: p.rowIndex,
          column: p.column
        } : r = null;
      }
    }
    if (!r)
      return;
    if (r.rowIndex < 0) {
      const u = Vi(o);
      l.focusHeaderPosition({
        headerPosition: { headerRowIndex: u + r.rowIndex, column: s.column },
        event: e || void 0,
        fromCell: !0
      });
      return;
    }
    const d = this.getNormalisedPosition(r);
    d ? this.focusPosition(d) : this.tryToFocusFullWidthRow(r);
  }
  getNormalisedPosition(e) {
    this.ensureCellVisible(e);
    const t = yi(this.beans, e);
    return t ? (e = t.cellPosition, this.ensureCellVisible(e), e) : null;
  }
  tryToFocusFullWidthRow(e, t) {
    const { visibleCols: s, rowRenderer: i, focusSvc: r, eventSvc: n } = this.beans, o = s.allCols, a = i.getRowByPosition(e);
    if (!a || !a.isFullWidth())
      return !1;
    const l = r.getFocusedCell(), c = {
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: e.column || (t ? pe(o) : o[0])
    };
    this.focusPosition(c);
    const d = t ?? (l != null && jt(c, l));
    return n.dispatchEvent({
      type: "fullWidthRowFocused",
      rowIndex: c.rowIndex,
      rowPinned: c.rowPinned,
      column: c.column,
      isFullWidthCell: !0,
      fromBelow: d
    }), !0;
  }
  focusPosition(e) {
    const { focusSvc: t, rangeSvc: s } = this.beans;
    t.setFocusedCell({
      rowIndex: e.rowIndex,
      column: e.column,
      rowPinned: e.rowPinned,
      forceBrowserFocus: !0
    }), s == null || s.setRangeToCell(e);
  }
  isValidNavigateCell(e) {
    return !!ri(this.beans, e);
  }
  getLastCellOfColSpan(e) {
    const t = yi(this.beans, e);
    if (!t)
      return e;
    const s = t.getColSpanningList();
    return s.length === 1 ? e : {
      rowIndex: e.rowIndex,
      column: pe(s),
      rowPinned: e.rowPinned
    };
  }
  ensureCellVisible(e) {
    const t = cc(this.gos), s = this.beans.rowModel.getRow(e.rowIndex), i = t && (s == null ? void 0 : s.sticky), { scrollFeature: r } = this.gridBodyCon;
    !i && ke(e.rowPinned) && r.ensureIndexVisible(e.rowIndex), e.column.isPinned() || r.ensureColumnVisible(e.column);
  }
};
function Fd(e) {
  return e.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
var Sc = {
  moduleName: "KeyboardNavigation",
  version: de,
  beans: [vL, uL, KI],
  apiFunctions: {
    getFocusedCell: hL,
    clearFocusedCell: pL,
    setFocusedCell: gL,
    setFocusedHeader: CL,
    tabToNextCell: fL,
    tabToPreviousCell: mL
  }
}, wL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "pageBoundsListener";
  }
  postConstruct() {
    this.addManagedEventListeners({
      modelUpdated: this.onModelUpdated.bind(this),
      recalculateRowBounds: this.calculatePages.bind(this)
    }), this.onModelUpdated();
  }
  onModelUpdated(e) {
    this.calculatePages(), this.eventSvc.dispatchEvent({
      type: "paginationChanged",
      animate: (e == null ? void 0 : e.animate) ?? !1,
      newData: (e == null ? void 0 : e.newData) ?? !1,
      newPage: (e == null ? void 0 : e.newPage) ?? !1,
      newPageSize: (e == null ? void 0 : e.newPageSize) ?? !1,
      keepRenderedRows: (e == null ? void 0 : e.keepRenderedRows) ?? !1
    });
  }
  calculatePages() {
    const { pageBounds: e, pagination: t, rowModel: s } = this.beans;
    t ? t.calculatePages() : e.calculateBounds(0, s.getRowCount() - 1);
  }
}, yL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "pageBounds", this.pixelOffset = 0;
  }
  getFirstRow() {
    var e;
    return ((e = this.topRowBounds) == null ? void 0 : e.rowIndex) ?? -1;
  }
  getLastRow() {
    var e;
    return ((e = this.bottomRowBounds) == null ? void 0 : e.rowIndex) ?? -1;
  }
  getCurrentPageHeight() {
    const { topRowBounds: e, bottomRowBounds: t } = this;
    return !e || !t ? 0 : Math.max(t.rowTop + t.rowHeight - e.rowTop, 0);
  }
  getCurrentPagePixelRange() {
    const { topRowBounds: e, bottomRowBounds: t } = this, s = (e == null ? void 0 : e.rowTop) ?? 0, i = t ? t.rowTop + t.rowHeight : 0;
    return { pageFirstPixel: s, pageLastPixel: i };
  }
  calculateBounds(e, t) {
    const { rowModel: s } = this.beans, i = s.getRowBounds(e);
    i && (i.rowIndex = e), this.topRowBounds = i;
    const r = s.getRowBounds(t);
    r && (r.rowIndex = t), this.bottomRowBounds = r, this.calculatePixelOffset();
  }
  getPixelOffset() {
    return this.pixelOffset;
  }
  calculatePixelOffset() {
    var t;
    const e = ((t = this.topRowBounds) == null ? void 0 : t.rowTop) ?? 0;
    this.pixelOffset !== e && (this.pixelOffset = e, this.eventSvc.dispatchEvent({ type: "paginationPixelOffsetChanged" }));
  }
}, bL = (
  /*css*/
  ".ag-pinned-left-floating-bottom,.ag-pinned-left-floating-top,.ag-pinned-right-floating-bottom,.ag-pinned-right-floating-top{display:inline-block;min-width:0;overflow:hidden;position:relative}.ag-pinned-left-sticky-top,.ag-pinned-right-sticky-top{height:100%;overflow:hidden;position:relative}.ag-sticky-bottom-full-width-container,.ag-sticky-top-full-width-container{height:100%;overflow:hidden;width:100%}.ag-pinned-left-header,.ag-pinned-right-header{display:inline-block;height:100%;overflow:hidden;position:relative}.ag-body-horizontal-scroll:not(.ag-scrollbar-invisible){.ag-horizontal-left-spacer:not(.ag-scroller-corner){border-right:var(--ag-pinned-column-border)}.ag-horizontal-right-spacer:not(.ag-scroller-corner){border-left:var(--ag-pinned-column-border)}}.ag-pinned-right-header{border-left:var(--ag-pinned-column-border)}.ag-pinned-left-header{border-right:var(--ag-pinned-column-border)}.ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-left:var(--ag-pinned-column-border)}.ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right,.ag-cell-range-single-cell,.ag-cell-focus:not(.ag-cell-range-selected):focus-within){border-right:var(--ag-pinned-column-border)}.ag-pinned-left-header .ag-header-cell-resize:after{left:calc(50% - var(--ag-header-column-resize-handle-width))}.ag-pinned-right-header .ag-header-cell-resize:after{left:50%}.ag-pinned-left-header .ag-header-cell-resize{right:-3px}.ag-pinned-right-header .ag-header-cell-resize{left:-3px}"
), SL = class extends L {
  constructor(e, t) {
    super(), this.element = e, this.isLeft = t, this.getWidth = t ? () => this.beans.pinnedCols.leftWidth : () => this.beans.pinnedCols.rightWidth;
  }
  postConstruct() {
    this.addManagedEventListeners({
      [`${this.isLeft ? "left" : "right"}PinnedWidthChanged`]: this.onPinnedWidthChanged.bind(this)
    });
  }
  onPinnedWidthChanged() {
    const e = this.getWidth(), t = e > 0;
    re(this.element, t), si(this.element, e);
  }
}, xL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "pinnedCols";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (t) => {
      this.gridBodyCtrl = t.gridBodyCtrl;
    });
    const e = this.checkContainerWidths.bind(this);
    this.addManagedEventListeners({
      displayedColumnsChanged: e,
      displayedColumnsWidthChanged: e
    }), this.addManagedPropertyListener("domLayout", e);
  }
  checkContainerWidths() {
    const { gos: e, visibleCols: t, eventSvc: s } = this.beans, i = It(e, "print"), r = i ? 0 : t.getColsLeftWidth(), n = i ? 0 : t.getDisplayedColumnsRightWidth();
    r != this.leftWidth && (this.leftWidth = r, s.dispatchEvent({ type: "leftPinnedWidthChanged" })), n != this.rightWidth && (this.rightWidth = n, s.dispatchEvent({ type: "rightPinnedWidthChanged" }));
  }
  keepPinnedColumnsNarrowerThanViewport() {
    const e = this.gridBodyCtrl.eBodyViewport, t = jn(e);
    if (t <= 50)
      return;
    let s = this.getPinnedColumnsOverflowingViewport(t - 50);
    const i = this.gos.getCallback("processUnpinnedColumns");
    s.length && (i && (s = i({
      columns: s,
      viewportWidth: t
    })), this.setColsPinned(s, null, "viewportSizeFeature"));
  }
  createPinnedWidthFeature(e, t) {
    return new SL(e, t);
  }
  setColsPinned(e, t, s) {
    const { colModel: i, colAnimation: r, visibleCols: n, gos: o } = this.beans;
    if (!i.cols || !(e != null && e.length))
      return;
    if (It(o, "print")) {
      I(37);
      return;
    }
    r == null || r.start();
    let a;
    t === !0 || t === "left" ? a = "left" : t === "right" ? a = "right" : a = null;
    const l = [];
    e.forEach((c) => {
      if (!c)
        return;
      const d = i.getCol(c);
      d && d.getPinned() !== a && (this.setColPinned(d, a), l.push(d));
    }), l.length && (n.refresh(s), Ov(this.eventSvc, l, s)), r == null || r.finish();
  }
  initCol(e) {
    const { pinned: t, initialPinned: s } = e.colDef;
    t !== void 0 ? this.setColPinned(e, t) : this.setColPinned(e, s);
  }
  setColPinned(e, t) {
    t === !0 || t === "left" ? e.pinned = "left" : t === "right" ? e.pinned = "right" : e.pinned = null, e.dispatchStateUpdatedEvent("pinned");
  }
  setupHeaderPinnedWidth(e) {
    const { scrollVisibleSvc: t } = this.beans;
    if (e.pinned == null)
      return;
    const s = e.pinned === "left", i = e.pinned === "right";
    e.hidden = !0;
    const r = () => {
      const n = s ? this.leftWidth : this.rightWidth;
      if (n == null)
        return;
      const o = n == 0, a = e.hidden !== o, l = this.gos.get("enableRtl"), c = t.getScrollbarWidth(), u = t.verticalScrollShowing && (l && s || !l && i) ? n + c : n;
      e.comp.setPinnedContainerWidth(`${u}px`), e.comp.setDisplayed(!o), a && (e.hidden = o, e.refresh());
    };
    e.addManagedEventListeners({
      leftPinnedWidthChanged: r,
      rightPinnedWidthChanged: r,
      scrollVisibilityChanged: r,
      scrollbarWidthChanged: r
    });
  }
  getHeaderResizeDiff(e, t) {
    if (t.getPinned()) {
      const { leftWidth: i, rightWidth: r } = this, n = jn(this.beans.ctrlsSvc.getGridBodyCtrl().eBodyViewport) - 50;
      if (i + r + e > n)
        if (n > i + r)
          e = n - i - r;
        else
          return 0;
    }
    return e;
  }
  getPinnedColumnsOverflowingViewport(e) {
    const t = this.rightWidth ?? 0, s = this.leftWidth ?? 0, i = t + s;
    if (i < e)
      return [];
    const { visibleCols: r } = this.beans, n = [...r.leftCols], o = [...r.rightCols];
    let a = 0, l = 0;
    const c = 0, d = [];
    let u = i - c - e;
    for (; (l < n.length || a < o.length) && u > 0; ) {
      if (a < o.length) {
        const h = o[a++];
        u -= h.getActualWidth(), d.push(h);
      }
      if (l < n.length && u > 0) {
        const h = n[l++];
        u -= h.getActualWidth(), d.push(h);
      }
    }
    return d;
  }
}, RL = {
  moduleName: "PinnedColumn",
  version: de,
  beans: [xL],
  css: [bL]
}, FL = class extends L {
  constructor() {
    super(), this.beanName = "ariaAnnounce", this.descriptionContainer = null, this.pendingAnnouncements = /* @__PURE__ */ new Map(), this.lastAnnouncement = "", this.updateAnnouncement = Et(this, this.updateAnnouncement.bind(this), 200);
  }
  postConstruct() {
    const e = this.beans, t = We(e), s = this.descriptionContainer = t.createElement("div");
    s.classList.add("ag-aria-description-container"), WC(s, "polite"), xP(s, "additions text"), SP(s, !0), e.eGridDiv.appendChild(s);
  }
  /**
   * @param key used for debouncing calls
   */
  announceValue(e, t) {
    this.pendingAnnouncements.set(t, e), this.updateAnnouncement();
  }
  updateAnnouncement() {
    if (!this.descriptionContainer)
      return;
    const e = Array.from(this.pendingAnnouncements.values()).join(". ");
    this.pendingAnnouncements.clear(), this.descriptionContainer.textContent = "", setTimeout(() => {
      if (this.isAlive() && this.descriptionContainer) {
        let t = e;
        this.lastAnnouncement === t && (t = `${t}.`), this.lastAnnouncement = t, this.descriptionContainer.textContent = t;
      }
    }, 50);
  }
  destroy() {
    var t;
    super.destroy();
    const { descriptionContainer: e } = this;
    e && (ze(e), (t = e.parentElement) == null || t.removeChild(e)), this.descriptionContainer = null, this.pendingAnnouncements.clear();
  }
}, PL = {
  moduleName: "Aria",
  version: de,
  beans: [FL]
};
function TL(e) {
  var t;
  (t = e.overlays) == null || t.showLoadingOverlay();
}
function EL(e) {
  var t;
  (t = e.overlays) == null || t.showNoRowsOverlay();
}
function DL(e) {
  var t;
  (t = e.overlays) == null || t.hideOverlay();
}
var AL = (
  /*css*/
  ".ag-overlay{inset:0;pointer-events:none;position:absolute;z-index:2}.ag-overlay-panel,.ag-overlay-wrapper{display:flex;height:100%;width:100%}.ag-overlay-wrapper{align-items:center;flex:none;justify-content:center;text-align:center}.ag-overlay-loading-wrapper{pointer-events:all}.ag-overlay-loading-center{background:var(--ag-background-color);border:1px solid var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-popup-shadow);padding:var(--ag-spacing)}"
), gy = class extends _ {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-overlay" role="presentation">
                <div class="ag-overlay-panel" role="presentation">
                    <div class="ag-overlay-wrapper" data-ref="eOverlayWrapper" role="presentation"></div>
                </div>
            </div>`
    ), this.eOverlayWrapper = E, this.activePromise = null, this.activeOverlay = null, this.updateListenerDestroyFunc = null, this.activeCssClass = null, this.elToFocusAfter = null, this.registerCSS(AL);
  }
  handleKeyDown(e) {
    if (e.key !== P.TAB || e.defaultPrevented || Ds(e))
      return;
    const t = this.beans;
    if (zt(t, this.eOverlayWrapper, !1, e.shiftKey))
      return;
    let i = !1;
    e.shiftKey ? i = t.focusSvc.focusGridView(pe(t.visibleCols.allCols), !0, !1) : i = Ui(t, !1), i && e.preventDefault();
  }
  updateLayoutClasses(e, t) {
    const s = this.eOverlayWrapper.classList, { AUTO_HEIGHT: i, NORMAL: r, PRINT: n } = ei;
    s.toggle(i, t.autoHeight), s.toggle(r, t.normal), s.toggle(n, t.print);
  }
  postConstruct() {
    this.createManagedBean(new Sh(this)), this.setDisplayed(!1, { skipAriaHidden: !0 }), this.beans.overlays.setOverlayWrapperComp(this), this.addManagedElementListeners(this.getFocusableElement(), { keydown: this.handleKeyDown.bind(this) });
  }
  setWrapperTypeClass(e) {
    const t = this.eOverlayWrapper.classList;
    this.activeCssClass && t.toggle(this.activeCssClass, !1), this.activeCssClass = e, t.toggle(e, !0);
  }
  showOverlay(e, t, s, i) {
    if (this.setWrapperTypeClass(t), this.destroyActiveOverlay(), this.elToFocusAfter = null, this.activePromise = e, !!e) {
      if (this.setDisplayed(!0, { skipAriaHidden: !0 }), s && this.isGridFocused()) {
        const r = Ie(this.beans);
        r && !Fr(this.beans) && (this.elToFocusAfter = r);
      }
      e.then((r) => {
        if (this.activePromise !== e) {
          this.activeOverlay !== r && (this.destroyBean(r), r = null);
          return;
        }
        if (this.activePromise = null, !!r) {
          if (this.activeOverlay !== r && (this.eOverlayWrapper.appendChild(r.getGui()), this.activeOverlay = r, i)) {
            const n = r;
            this.updateListenerDestroyFunc = this.addManagedPropertyListener(i, ({ currentValue: o }) => {
              var a;
              (a = n.refresh) == null || a.call(n, this.gos.addGridCommonParams({ ...o ?? {} }));
            });
          }
          s && this.isGridFocused() && Dt(this.eOverlayWrapper);
        }
      });
    }
  }
  updateOverlayWrapperPaddingTop(e) {
    this.eOverlayWrapper.style.setProperty("padding-top", `${e}px`);
  }
  destroyActiveOverlay() {
    var i;
    this.activePromise = null;
    const e = this.activeOverlay;
    if (!e)
      return;
    let t = this.elToFocusAfter;
    this.activeOverlay = null, this.elToFocusAfter = null, t && !this.isGridFocused() && (t = null);
    const s = this.updateListenerDestroyFunc;
    s && (s(), this.updateListenerDestroyFunc = null), this.destroyBean(e), ze(this.eOverlayWrapper), (i = t == null ? void 0 : t.focus) == null || i.call(t, { preventScroll: !0 });
  }
  hideOverlay() {
    this.destroyActiveOverlay(), this.setDisplayed(!1, { skipAriaHidden: !0 });
  }
  isGridFocused() {
    const e = Ie(this.beans);
    return !!e && this.beans.eGridDiv.contains(e);
  }
  destroy() {
    this.elToFocusAfter = null, this.destroyActiveOverlay(), this.beans.overlays.setOverlayWrapperComp(void 0), super.destroy();
  }
}, ML = {
  selector: "AG-OVERLAY-WRAPPER",
  component: gy
}, IL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "overlays", this.state = 0, this.showInitialOverlay = !0, this.wrapperPadding = 0;
  }
  postConstruct() {
    this.isClientSide = Ye(this.gos);
    const e = () => this.updateOverlayVisibility();
    this.addManagedEventListeners({
      newColumnsLoaded: e,
      rowDataUpdated: e,
      gridSizeChanged: this.refreshWrapperPadding.bind(this),
      rowCountReady: () => {
        this.showInitialOverlay = !1, this.updateOverlayVisibility();
      }
    }), this.addManagedPropertyListener("loading", e);
  }
  setOverlayWrapperComp(e) {
    this.eWrapper = e, this.updateOverlayVisibility();
  }
  /** Returns true if the overlay is visible. */
  isVisible() {
    return this.state !== 0 && !!this.eWrapper;
  }
  /** Returns true if the overlay is visible and is exclusive (popup over the grid) */
  isExclusive() {
    return this.state === 1 && !!this.eWrapper;
  }
  showLoadingOverlay() {
    this.showInitialOverlay = !1;
    const e = this.gos, t = e.get("loading");
    !t && (t !== void 0 || e.get("suppressLoadingOverlay")) || this.doShowLoadingOverlay();
  }
  showNoRowsOverlay() {
    this.showInitialOverlay = !1;
    const e = this.gos;
    e.get("loading") || e.get("suppressNoRowsOverlay") || this.doShowNoRowsOverlay();
  }
  hideOverlay() {
    if (this.showInitialOverlay = !1, this.gos.get("loading")) {
      I(99);
      return;
    }
    this.doHideOverlay();
  }
  getOverlayWrapperSelector() {
    return ML;
  }
  getOverlayWrapperCompClass() {
    return gy;
  }
  updateOverlayVisibility() {
    if (!this.eWrapper) {
      this.state = 0;
      return;
    }
    const {
      state: e,
      isClientSide: t,
      beans: { gos: s, colModel: i, rowModel: r }
    } = this;
    let n = this.gos.get("loading");
    n !== void 0 && (this.showInitialOverlay = !1), this.showInitialOverlay && n === void 0 && !s.get("suppressLoadingOverlay") && (n = !s.get("columnDefs") || !i.ready || !s.get("rowData") && t), n ? e !== 1 && this.doShowLoadingOverlay() : (this.showInitialOverlay = !1, r.isEmpty() && !s.get("suppressNoRowsOverlay") && t ? e !== 2 && this.doShowNoRowsOverlay() : e !== 0 && this.doHideOverlay());
  }
  doShowLoadingOverlay() {
    this.eWrapper && (this.state = 1, this.showOverlay(
      eE(this.beans.userCompFactory, {}),
      "ag-overlay-loading-wrapper",
      "loadingOverlayComponentParams"
    ), this.updateExclusive());
  }
  doShowNoRowsOverlay() {
    this.eWrapper && (this.state = 2, this.showOverlay(
      tE(this.beans.userCompFactory, {}),
      "ag-overlay-no-rows-wrapper",
      "noRowsOverlayComponentParams"
    ), this.updateExclusive());
  }
  doHideOverlay() {
    this.eWrapper && (this.state = 0, this.eWrapper.hideOverlay(), this.updateExclusive());
  }
  showOverlay(e, t, s) {
    var r;
    const i = (e == null ? void 0 : e.newAgStackInstance()) ?? null;
    (r = this.eWrapper) == null || r.showOverlay(i, t, this.isExclusive(), s), this.refreshWrapperPadding();
  }
  updateExclusive() {
    const e = this.exclusive;
    this.exclusive = this.isExclusive(), this.exclusive !== e && this.eventSvc.dispatchEvent({
      type: "overlayExclusiveChanged"
    });
  }
  refreshWrapperPadding() {
    const e = this.eWrapper;
    if (!e)
      return;
    let t = 0;
    if (this.state === 2) {
      const s = this.beans.ctrlsSvc.get("gridHeaderCtrl");
      t = (s == null ? void 0 : s.headerHeight) || 0;
    } else this.wrapperPadding !== 0 && (t = 0);
    this.wrapperPadding !== t && (this.wrapperPadding = t, e.updateOverlayWrapperPaddingTop(t));
  }
}, LL = {
  moduleName: "Overlay",
  version: de,
  userComponents: {
    agLoadingOverlay: FD,
    agNoRowsOverlay: PD
  },
  apiFunctions: {
    showLoadingOverlay: TL,
    showNoRowsOverlay: EL,
    hideOverlay: DL
  },
  beans: [IL]
}, kL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowContainerHeight", this.scrollY = 0, this.uiBodyHeight = 0;
  }
  postConstruct() {
    this.addManagedEventListeners({ bodyHeightChanged: this.updateOffset.bind(this) }), this.maxDivHeight = FP(), Rr(this.gos, "RowContainerHeightService - maxDivHeight = " + this.maxDivHeight);
  }
  updateOffset() {
    if (!this.stretching)
      return;
    const e = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition().top, t = this.getUiBodyHeight();
    (e !== this.scrollY || t !== this.uiBodyHeight) && (this.scrollY = e, this.uiBodyHeight = t, this.calculateOffset());
  }
  calculateOffset() {
    this.setUiContainerHeight(this.maxDivHeight), this.pixelsToShave = this.modelHeight - this.uiContainerHeight, this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
    const e = this.scrollY / this.maxScrollY, t = e * this.pixelsToShave;
    Rr(
      this.gos,
      `RowContainerHeightService - Div Stretch Offset = ${t} (${this.pixelsToShave} * ${e})`
    ), this.setDivStretchOffset(t);
  }
  setUiContainerHeight(e) {
    e !== this.uiContainerHeight && (this.uiContainerHeight = e, this.eventSvc.dispatchEvent({ type: "rowContainerHeightChanged" }));
  }
  clearOffset() {
    this.setUiContainerHeight(this.modelHeight), this.pixelsToShave = 0, this.setDivStretchOffset(0);
  }
  setDivStretchOffset(e) {
    const t = typeof e == "number" ? Math.floor(e) : null;
    this.divStretchOffset !== t && (this.divStretchOffset = t, this.eventSvc.dispatchEvent({ type: "heightScaleChanged" }));
  }
  setModelHeight(e) {
    this.modelHeight = e, this.stretching = e != null && // null happens when in print layout
    this.maxDivHeight > 0 && e > this.maxDivHeight, this.stretching ? this.calculateOffset() : this.clearOffset();
  }
  getRealPixelPosition(e) {
    return e - this.divStretchOffset;
  }
  getUiBodyHeight() {
    const e = this.beans.ctrlsSvc.getScrollFeature().getVScrollPosition();
    return e.bottom - e.top;
  }
  getScrollPositionForPixel(e) {
    if (this.pixelsToShave <= 0)
      return e;
    const t = this.modelHeight - this.getUiBodyHeight(), s = e / t;
    return this.maxScrollY * s;
  }
}, OL = 400, GL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowRenderer", this.destroyFuncsForColumnListeners = [], this.rowCtrlsByRowIndex = {}, this.zombieRowCtrls = {}, this.allRowCtrls = [], this.topRowCtrls = [], this.bottomRowCtrls = [], this.refreshInProgress = !1, this.dataFirstRenderedFired = !1, this.setupRangeSelectionListeners = () => {
      const e = () => {
        this.getAllCellCtrls().forEach((n) => n.onCellSelectionChanged());
      }, t = () => {
        this.getAllCellCtrls().forEach((n) => n.updateRangeBordersIfRangeCount());
      }, s = () => {
        this.eventSvc.addEventListener("cellSelectionChanged", e), this.eventSvc.addEventListener("columnMoved", t), this.eventSvc.addEventListener("columnPinned", t), this.eventSvc.addEventListener("columnVisible", t);
      }, i = () => {
        this.eventSvc.removeEventListener("cellSelectionChanged", e), this.eventSvc.removeEventListener("columnMoved", t), this.eventSvc.removeEventListener("columnPinned", t), this.eventSvc.removeEventListener("columnVisible", t);
      };
      this.addDestroyFunc(() => i()), this.addManagedPropertyListeners(["enableRangeSelection", "cellSelection"], () => {
        is(this.gos) ? s() : i();
      }), is(this.gos) && s();
    };
  }
  wireBeans(e) {
    this.pageBounds = e.pageBounds, this.colModel = e.colModel, this.pinnedRowModel = e.pinnedRowModel, this.rowModel = e.rowModel, this.focusSvc = e.focusSvc, this.rowContainerHeight = e.rowContainerHeight, this.ctrlsSvc = e.ctrlsSvc;
  }
  postConstruct() {
    this.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl, this.initialise();
    });
  }
  initialise() {
    this.addManagedEventListeners({
      paginationChanged: this.onPageLoaded.bind(this),
      pinnedRowDataChanged: this.onPinnedRowDataChanged.bind(this),
      displayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
      bodyScroll: this.onBodyScroll.bind(this),
      bodyHeightChanged: this.redraw.bind(this, {})
    }), this.addManagedPropertyListeners(["domLayout", "embedFullWidthRows"], () => this.onDomLayoutChanged()), this.addManagedPropertyListeners(["suppressMaxRenderedRowRestriction", "rowBuffer"], () => this.redraw()), this.addManagedPropertyListener("suppressCellFocus", (s) => this.onSuppressCellFocusChanged(s.currentValue)), this.addManagedPropertyListeners(
      [
        "groupSuppressBlankHeader",
        "getBusinessKeyForNode",
        "fullWidthCellRenderer",
        "fullWidthCellRendererParams",
        "suppressStickyTotalRow",
        "groupRowRenderer",
        "groupRowRendererParams",
        // maybe only needs to refresh FW rows...
        "loadingCellRenderer",
        "loadingCellRendererParams",
        "detailCellRenderer",
        "detailCellRendererParams",
        "enableRangeSelection",
        "enableCellTextSelection"
      ],
      () => this.redrawRows()
    ), this.addManagedPropertyListener("cellSelection", ({ currentValue: s, previousValue: i }) => {
      (!i && s || i && !s) && this.redrawRows();
    });
    const { stickyRowSvc: e, gos: t } = this.beans;
    if (e)
      this.stickyRowFeature = e.createStickyRowFeature(
        this,
        this.createRowCon.bind(this),
        this.destroyRowCtrls.bind(this)
      );
    else {
      const s = this.gridBodyCtrl;
      s.setStickyTopHeight(0), s.setStickyBottomHeight(0);
    }
    this.registerCellEventListeners(), this.initialiseCache(), this.printLayout = It(t, "print"), this.embedFullWidthRows = this.printLayout || t.get("embedFullWidthRows"), this.redrawAfterModelUpdate();
  }
  initialiseCache() {
    if (this.gos.get("keepDetailRows")) {
      const e = this.getKeepDetailRowsCount(), t = e ?? 3;
      this.cachedRowCtrls = new BL(t);
    }
  }
  getKeepDetailRowsCount() {
    return this.gos.get("keepDetailRowsCount");
  }
  getStickyTopRowCtrls() {
    var e;
    return ((e = this.stickyRowFeature) == null ? void 0 : e.stickyTopRowCtrls) ?? [];
  }
  getStickyBottomRowCtrls() {
    var e;
    return ((e = this.stickyRowFeature) == null ? void 0 : e.stickyBottomRowCtrls) ?? [];
  }
  updateAllRowCtrls() {
    var i;
    const e = Object.values(this.rowCtrlsByRowIndex), t = Object.values(this.zombieRowCtrls), s = ((i = this.cachedRowCtrls) == null ? void 0 : i.getEntries()) ?? [];
    t.length > 0 || s.length > 0 ? this.allRowCtrls = [...e, ...t, ...s] : this.allRowCtrls = e;
  }
  onCellFocusChanged(e) {
    this.getAllCellCtrls().forEach((t) => t.onCellFocused(e)), this.getFullWidthRowCtrls().forEach((t) => t.onFullWidthRowFocused(e));
  }
  onSuppressCellFocusChanged(e) {
    this.getAllCellCtrls().forEach((t) => t.onSuppressCellFocusChanged(e)), this.getFullWidthRowCtrls().forEach((t) => t.onSuppressCellFocusChanged(e));
  }
  // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
  // registering and de-registering for events is a performance bottleneck. so we register here once and inform
  // all active cells.
  registerCellEventListeners() {
    this.addManagedEventListeners({
      cellFocused: (e) => {
        this.onCellFocusChanged(e);
      },
      cellFocusCleared: () => this.onCellFocusChanged(),
      flashCells: (e) => {
        const { cellFlashSvc: t } = this.beans;
        t && this.getAllCellCtrls().forEach((s) => t.onFlashCells(s, e));
      },
      columnHoverChanged: () => {
        this.getAllCellCtrls().forEach((e) => e.onColumnHover());
      },
      displayedColumnsChanged: () => {
        this.getAllCellCtrls().forEach((e) => e.onDisplayedColumnsChanged());
      },
      displayedColumnsWidthChanged: () => {
        this.printLayout && this.getAllCellCtrls().forEach((e) => e.onLeftChanged());
      }
    }), this.setupRangeSelectionListeners(), this.refreshListenersToColumnsForCellComps(), this.addManagedEventListeners({
      gridColumnsChanged: this.refreshListenersToColumnsForCellComps.bind(this)
    }), this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
  }
  // executes all functions in destroyFuncsForColumnListeners and then clears the list
  removeGridColumnListeners() {
    this.destroyFuncsForColumnListeners.forEach((e) => e()), this.destroyFuncsForColumnListeners.length = 0;
  }
  // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
  // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
  // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
  // once instead.
  refreshListenersToColumnsForCellComps() {
    this.removeGridColumnListeners(), this.colModel.getCols().forEach((t) => {
      const s = (l) => {
        this.getAllCellCtrls().forEach((c) => {
          c.column === t && l(c);
        });
      }, i = () => {
        s((l) => l.onLeftChanged());
      }, r = () => {
        s((l) => l.onWidthChanged());
      }, n = () => {
        s((l) => l.onFirstRightPinnedChanged());
      }, o = () => {
        s((l) => l.onLastLeftPinnedChanged());
      }, a = () => {
        s((l) => l.onColDefChanged());
      };
      t.addEventListener("leftChanged", i), t.addEventListener("widthChanged", r), t.addEventListener("firstRightPinnedChanged", n), t.addEventListener("lastLeftPinnedChanged", o), t.addEventListener("colDefChanged", a), this.destroyFuncsForColumnListeners.push(() => {
        t.removeEventListener("leftChanged", i), t.removeEventListener("widthChanged", r), t.removeEventListener("firstRightPinnedChanged", n), t.removeEventListener("lastLeftPinnedChanged", o), t.removeEventListener("colDefChanged", a);
      });
    });
  }
  onDomLayoutChanged() {
    const e = It(this.gos, "print"), t = e || this.gos.get("embedFullWidthRows"), s = t !== this.embedFullWidthRows || this.printLayout !== e;
    this.printLayout = e, this.embedFullWidthRows = t, s && this.redrawAfterModelUpdate({ domLayoutChanged: !0 });
  }
  // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
  // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
  datasourceChanged() {
    this.firstRenderedRow = 0, this.lastRenderedRow = -1;
    const e = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(e);
  }
  onPageLoaded(e) {
    const t = {
      recycleRows: e.keepRenderedRows,
      animate: e.animate,
      newData: e.newData,
      newPage: e.newPage,
      // because this is a model updated event (not pinned rows), we
      // can skip updating the pinned rows. this is needed so that if user
      // is doing transaction updates, the pinned rows are not getting constantly
      // trashed - or editing cells in pinned rows are not refreshed and put into read mode
      onlyBody: !0
    };
    this.redrawAfterModelUpdate(t);
  }
  /**
   * @param column AgColumn
   * @returns An array with HTMLElement for every cell of the column passed as param.
   * If the cell is spanning across multiple columns, it only returns the html element
   * if the column passed is the first column of the span (used for auto width calculation).
   */
  getAllCellsNotSpanningForColumn(e) {
    const t = [];
    return this.getAllRowCtrls().forEach((s) => {
      var r;
      const i = (r = s.getCellCtrl(e, !0)) == null ? void 0 : r.eGui;
      i && t.push(i);
    }), t;
  }
  refreshFloatingRowComps() {
    this.refreshFloatingRows(this.topRowCtrls, "top"), this.refreshFloatingRows(this.bottomRowCtrls, "bottom");
  }
  /**
   * Determines which row controllers need to be destroyed and re-created vs which ones can
   * be re-used.
   *
   * This is operation is to pinned/floating rows as `this.recycleRows` is to normal/body rows.
   *
   * All `RowCtrl` instances in `rowCtrls` that don't correspond to `RowNode` instances in `rowNodes` are destroyed.
   * All `RowNode` instances in `rowNodes` that don't correspond to `RowCtrl` instances in `rowCtrls` are created.
   * All instances in `rowCtrls` must be in the same order as their corresponding nodes in `rowNodes`.
   *
   * @param rowCtrls The list of existing row controllers
   * @param rowNodes The canonical list of row nodes that should have associated controllers
   */
  refreshFloatingRows(e, t) {
    const { pinnedRowModel: s, beans: i, printLayout: r } = this, n = Object.fromEntries(e.map((a) => [a.rowNode.id, a]));
    s == null || s.forEachPinnedRow(t, (a, l) => {
      const c = e[l];
      c && s.getPinnedRowById(c.rowNode.id, t) === void 0 && (c.destroyFirstPass(), c.destroySecondPass()), a.id in n ? (e[l] = n[a.id], delete n[a.id]) : e[l] = new cu(a, i, !1, !1, r);
    });
    const o = (t === "top" ? s == null ? void 0 : s.getPinnedTopRowCount() : s == null ? void 0 : s.getPinnedBottomRowCount()) ?? 0;
    e.length = o;
  }
  onPinnedRowDataChanged() {
    const e = {
      recycleRows: !0
    };
    this.redrawAfterModelUpdate(e);
  }
  redrawRow(e, t = !1) {
    var s, i;
    if (e.sticky)
      (s = this.stickyRowFeature) == null || s.refreshStickyNode(e);
    else if ((i = this.cachedRowCtrls) != null && i.has(e)) {
      this.cachedRowCtrls.removeRow(e);
      return;
    } else {
      const r = (n) => {
        const o = n[e.rowIndex];
        o && o.rowNode === e && (o.destroyFirstPass(), o.destroySecondPass(), n[e.rowIndex] = this.createRowCon(e, !1, !1));
      };
      switch (e.rowPinned) {
        case "top":
          r(this.topRowCtrls);
          break;
        case "bottom":
          r(this.bottomRowCtrls);
          break;
        default:
          r(this.rowCtrlsByRowIndex), this.updateAllRowCtrls();
      }
    }
    t || this.dispatchDisplayedRowsChanged(!1);
  }
  redrawRows(e) {
    if (e != null) {
      e == null || e.forEach((s) => this.redrawRow(s, !0)), this.dispatchDisplayedRowsChanged(!1);
      return;
    }
    this.redrawAfterModelUpdate();
  }
  getCellToRestoreFocusToAfterRefresh(e) {
    const t = e != null && e.suppressKeepFocus ? null : this.focusSvc.getFocusCellToUseAfterRefresh();
    if (t == null)
      return null;
    const s = Ie(this.beans), i = Pl(this.gos, s, Ol), r = Pl(this.gos, s, aa);
    return i || r ? t : null;
  }
  // gets called from:
  // +) initialisation (in registerGridComp) params = null
  // +) onDomLayoutChanged, params = null
  // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
  // +) onPinnedRowDataChanged, recycleRows = true
  // +) redrawRows (from Grid API), recycleRows = true/false
  redrawAfterModelUpdate(e = {}) {
    this.getLockOnRefresh();
    const t = this.getCellToRestoreFocusToAfterRefresh(e);
    this.updateContainerHeights(), this.scrollToTopIfNewData(e);
    const s = !e.domLayoutChanged && !!e.recycleRows, i = e.animate && Wn(this.gos), r = s ? this.getRowsToRecycle() : null;
    s || this.removeAllRowComps(), this.workOutFirstAndLastRowsToRender();
    const { stickyRowFeature: n } = this;
    if (n) {
      n.checkStickyRows();
      const o = n.extraTopHeight + n.extraBottomHeight;
      o && this.updateContainerHeights(o);
    }
    this.recycleRows(r, i), this.gridBodyCtrl.updateRowCount(), e.onlyBody || this.refreshFloatingRowComps(), this.dispatchDisplayedRowsChanged(), t != null && this.restoreFocusedCell(t), this.releaseLockOnRefresh();
  }
  scrollToTopIfNewData(e) {
    var i;
    const t = e.newData || e.newPage, s = this.gos.get("suppressScrollOnNewData");
    t && !s && (this.gridBodyCtrl.scrollFeature.scrollToTop(), (i = this.stickyRowFeature) == null || i.resetOffsets());
  }
  updateContainerHeights(e = 0) {
    const { rowContainerHeight: t } = this;
    if (this.printLayout) {
      t.setModelHeight(null);
      return;
    }
    let s = this.pageBounds.getCurrentPageHeight();
    s === 0 && (s = 1), t.setModelHeight(s + e);
  }
  getLockOnRefresh() {
    var e, t;
    if (this.refreshInProgress)
      throw new Error(Ws(252));
    this.refreshInProgress = !0, (t = (e = this.beans.frameworkOverrides).getLockOnRefresh) == null || t.call(e);
  }
  releaseLockOnRefresh() {
    var e, t;
    this.refreshInProgress = !1, (t = (e = this.beans.frameworkOverrides).releaseLockOnRefresh) == null || t.call(e);
  }
  isRefreshInProgress() {
    return this.refreshInProgress;
  }
  // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
  // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
  // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
  // edited cell).
  restoreFocusedCell(e) {
    e && this.focusSvc.restoreFocusedCell(e, () => {
      this.onCellFocusChanged(
        this.gos.addGridCommonParams({
          rowIndex: e.rowIndex,
          column: e.column,
          rowPinned: e.rowPinned,
          forceBrowserFocus: !0,
          preventScrollOnBrowserFocus: !0,
          type: "cellFocused"
        })
      );
    });
  }
  getAllCellCtrls() {
    const e = [], t = this.getAllRowCtrls(), s = t.length;
    for (let i = 0; i < s; i++) {
      const r = t[i].getAllCellCtrls(), n = r.length;
      for (let o = 0; o < n; o++)
        e.push(r[o]);
    }
    return e;
  }
  getAllRowCtrls() {
    const e = this.getStickyTopRowCtrls(), t = this.getStickyBottomRowCtrls();
    return [
      ...this.topRowCtrls,
      ...this.bottomRowCtrls,
      ...e,
      ...t,
      ...Object.values(this.rowCtrlsByRowIndex)
    ];
  }
  addRenderedRowListener(e, t, s) {
    const i = this.rowCtrlsByRowIndex[t];
    i && i.addEventListener(e, s);
  }
  refreshCells(e = {}) {
    const t = {
      forceRefresh: e.force,
      newData: !1,
      suppressFlash: e.suppressFlash
    };
    for (const s of this.getCellCtrls(e.rowNodes, e.columns))
      s.refreshOrDestroyCell(t);
    this.refreshFullWidth(e.rowNodes);
  }
  refreshFullWidth(e) {
    if (!e)
      return;
    let t = null;
    this.stickyRowFeature && (t = this.getCellToRestoreFocusToAfterRefresh() || null);
    for (const s of this.getRowCtrls(e)) {
      if (!s.isFullWidth())
        continue;
      s.refreshFullWidth() || this.redrawRow(s.rowNode, !0);
    }
    this.dispatchDisplayedRowsChanged(!1), t && this.restoreFocusedCell(t);
  }
  /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */
  getRowCtrls(e) {
    const t = Cu(e), s = this.getAllRowCtrls();
    return !e || !t ? s : s.filter((i) => {
      const r = i.rowNode;
      return vu(r, t);
    });
  }
  // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
  // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
  getCellCtrls(e, t) {
    let s;
    W(t) && (s = {}, t.forEach((r) => {
      const n = this.colModel.getCol(r);
      W(n) && (s[n.getId()] = !0);
    }));
    const i = [];
    return this.getRowCtrls(e).forEach((r) => {
      r.getAllCellCtrls().forEach((n) => {
        const o = n.column.getId();
        s && !s[o] || i.push(n);
      });
    }), i;
  }
  destroy() {
    this.removeAllRowComps(!0), super.destroy();
  }
  removeAllRowComps(e = !1) {
    var s;
    const t = Object.keys(this.rowCtrlsByRowIndex);
    this.removeRowCtrls(t, e), (s = this.stickyRowFeature) == null || s.destroyStickyCtrls();
  }
  getRowsToRecycle() {
    const e = [];
    for (const [s, i] of Object.entries(this.rowCtrlsByRowIndex))
      i.rowNode.id == null && e.push(s);
    this.removeRowCtrls(e);
    const t = {};
    for (const s of Object.values(this.rowCtrlsByRowIndex)) {
      const i = s.rowNode;
      t[i.id] = s;
    }
    return this.rowCtrlsByRowIndex = {}, t;
  }
  // takes array of row indexes
  removeRowCtrls(e, t = !1) {
    e.forEach((s) => {
      const i = this.rowCtrlsByRowIndex[s];
      i && (i.destroyFirstPass(t), i.destroySecondPass()), delete this.rowCtrlsByRowIndex[s];
    });
  }
  onBodyScroll(e) {
    e.direction === "vertical" && this.redraw({ afterScroll: !0 });
  }
  // gets called when rows don't change, but viewport does, so after:
  // 1) height of grid body changes, ie number of displayed rows has changed
  // 2) grid scrolled to new position
  // 3) ensure index visible (which is a scroll)
  redraw(e = {}) {
    var l;
    const { afterScroll: t } = e;
    let s;
    const i = this.stickyRowFeature;
    i && (s = this.getCellToRestoreFocusToAfterRefresh() || void 0);
    const r = this.firstRenderedRow, n = this.lastRenderedRow;
    this.workOutFirstAndLastRowsToRender();
    let o = !1;
    if (i) {
      o = i.checkStickyRows();
      const c = i.extraTopHeight + i.extraBottomHeight;
      c && this.updateContainerHeights(c);
    }
    const a = this.firstRenderedRow !== r || this.lastRenderedRow !== n;
    if (!(t && !o && !a) && (this.getLockOnRefresh(), this.recycleRows(null, !1, t), this.releaseLockOnRefresh(), this.dispatchDisplayedRowsChanged(t && !o), s != null)) {
      const c = this.getCellToRestoreFocusToAfterRefresh();
      s != null && c == null && ((l = this.beans.animationFrameSvc) == null || l.flushAllFrames(), this.restoreFocusedCell(s));
    }
  }
  removeRowCompsNotToDraw(e, t) {
    const s = {};
    e.forEach((n) => s[n] = !0);
    const r = Object.keys(this.rowCtrlsByRowIndex).filter((n) => !s[n]);
    this.removeRowCtrls(r, t);
  }
  calculateIndexesToDraw(e) {
    const t = [];
    for (let r = this.firstRenderedRow; r <= this.lastRenderedRow; r++)
      t.push(r);
    const s = (r) => {
      const n = r.rowNode.rowIndex;
      n != null && (n < this.firstRenderedRow || n > this.lastRenderedRow) && this.doNotUnVirtualiseRow(r) && t.push(n);
    };
    for (const r of Object.values(this.rowCtrlsByRowIndex))
      s(r);
    if (e)
      for (const r of Object.values(e))
        s(r);
    t.sort((r, n) => r - n);
    const i = [];
    for (let r = 0; r < t.length; r++) {
      const n = t[r], o = this.rowModel.getRow(n);
      o && !o.sticky && i.push(n);
    }
    return i;
  }
  recycleRows(e, t = !1, s = !1) {
    const i = this.calculateIndexesToDraw(e);
    if ((this.printLayout || s) && (t = !1), this.removeRowCompsNotToDraw(i, !t), i.forEach((r) => {
      this.createOrUpdateRowCtrl(r, e, t, s);
    }), e) {
      const { animationFrameSvc: r } = this.beans;
      r && s && !this.gos.get("suppressAnimationFrame") && !this.printLayout ? r.addDestroyTask(() => {
        this.destroyRowCtrls(e, t), this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged();
      }) : this.destroyRowCtrls(e, t);
    }
    this.updateAllRowCtrls();
  }
  dispatchDisplayedRowsChanged(e = !1) {
    this.eventSvc.dispatchEvent({
      type: "displayedRowsChanged",
      afterScroll: e
    });
  }
  onDisplayedColumnsChanged() {
    const { visibleCols: e } = this.beans, t = e.isPinningLeft(), s = e.isPinningRight();
    (this.pinningLeft !== t || s !== this.pinningRight) && (this.pinningLeft = t, this.pinningRight = s, this.embedFullWidthRows && this.redrawFullWidthEmbeddedRows());
  }
  // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
  // then it should go into the pinned left area if pinning left, or the center area if not pinning.
  redrawFullWidthEmbeddedRows() {
    const e = [];
    this.getFullWidthRowCtrls().forEach((t) => {
      const s = t.rowNode.rowIndex;
      e.push(s.toString());
    }), this.refreshFloatingRowComps(), this.removeRowCtrls(e), this.redraw({ afterScroll: !0 });
  }
  getFullWidthRowCtrls(e) {
    const t = Cu(e);
    return this.getAllRowCtrls().filter((s) => {
      if (!s.isFullWidth())
        return !1;
      const i = s.rowNode;
      return !(t != null && !vu(i, t));
    });
  }
  createOrUpdateRowCtrl(e, t, s, i) {
    let r, n = this.rowCtrlsByRowIndex[e];
    if (n || (r = this.rowModel.getRow(e), W(r) && W(t) && t[r.id] && r.alreadyRendered && (n = t[r.id], t[r.id] = null)), !n)
      if (r || (r = this.rowModel.getRow(e)), W(r))
        n = this.createRowCon(r, s, i);
      else
        return;
    return r && (r.alreadyRendered = !0), this.rowCtrlsByRowIndex[e] = n, n;
  }
  destroyRowCtrls(e, t) {
    const s = [];
    if (e) {
      for (const i of Object.values(e))
        if (i) {
          if (this.cachedRowCtrls && i.isCacheable()) {
            this.cachedRowCtrls.addRow(i);
            continue;
          }
          if (i.destroyFirstPass(!t), t) {
            const r = i.instanceId;
            this.zombieRowCtrls[r] = i, s.push(() => {
              i.destroySecondPass(), delete this.zombieRowCtrls[r];
            });
          } else
            i.destroySecondPass();
        }
    }
    t && (s.push(() => {
      this.updateAllRowCtrls(), this.dispatchDisplayedRowsChanged();
    }), window.setTimeout(() => s.forEach((i) => i()), OL));
  }
  getRowBuffer() {
    return this.gos.get("rowBuffer");
  }
  getRowBufferInPixels() {
    const e = this.getRowBuffer(), t = vs(this.beans);
    return e * t;
  }
  workOutFirstAndLastRowsToRender() {
    const { rowContainerHeight: e, pageBounds: t, rowModel: s } = this;
    e.updateOffset();
    let i, r;
    if (!s.isRowsToRender())
      i = 0, r = -1;
    else if (this.printLayout)
      this.beans.environment.refreshRowHeightVariable(), i = t.getFirstRow(), r = t.getLastRow();
    else {
      const d = this.getRowBufferInPixels(), u = this.ctrlsSvc.getScrollFeature(), h = this.gos.get("suppressRowVirtualisation");
      let p = !1, g, f;
      do {
        const b = t.getPixelOffset(), { pageFirstPixel: x, pageLastPixel: M } = t.getCurrentPagePixelRange(), T = e.divStretchOffset, F = u.getVScrollPosition(), k = F.top, O = F.bottom;
        h ? (g = x + T, f = M + T) : (g = Math.max(k + b - d, x) + T, f = Math.min(O + b + d, M) + T), this.firstVisibleVPixel = Math.max(k + b, x) + T, this.lastVisibleVPixel = Math.min(O + b, M) + T, p = this.ensureAllRowsInRangeHaveHeightsCalculated(g, f);
      } while (p);
      let m = s.getRowIndexAtPixel(g), C = s.getRowIndexAtPixel(f);
      const w = t.getFirstRow(), y = t.getLastRow();
      m < w && (m = w), C > y && (C = y), i = m, r = C;
    }
    const n = It(this.gos, "normal"), o = this.gos.get("suppressMaxRenderedRowRestriction"), a = Math.max(this.getRowBuffer(), 500);
    n && !o && r - i > a && (r = i + a);
    const l = i !== this.firstRenderedRow, c = r !== this.lastRenderedRow;
    (l || c) && (this.firstRenderedRow = i, this.lastRenderedRow = r, this.eventSvc.dispatchEvent({
      type: "viewportChanged",
      firstRow: i,
      lastRow: r
    }));
  }
  /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */
  dispatchFirstDataRenderedEvent() {
    this.dataFirstRenderedFired || (this.dataFirstRenderedFired = !0, window.requestAnimationFrame(() => {
      this.beans.eventSvc.dispatchEvent({
        type: "firstDataRendered",
        firstRow: this.firstRenderedRow,
        lastRow: this.lastRenderedRow
      });
    }));
  }
  ensureAllRowsInRangeHaveHeightsCalculated(e, t) {
    var a, l;
    const s = (a = this.pinnedRowModel) == null ? void 0 : a.ensureRowHeightsValid(), i = (l = this.stickyRowFeature) == null ? void 0 : l.ensureRowHeightsValid(), { pageBounds: r, rowModel: n } = this, o = n.ensureRowHeightsValid(
      e,
      t,
      r.getFirstRow(),
      r.getLastRow()
    );
    return (o || i) && this.eventSvc.dispatchEvent({
      type: "recalculateRowBounds"
    }), i || o || s ? (this.updateContainerHeights(), !0) : !1;
  }
  // check that none of the rows to remove are editing or focused as:
  // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
  //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
  //    the edit is reset - so we want to keep it rendered.
  // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
  //    otherwise the user can range select and drag (with focus cell going out of the viewport)
  //    and then ctrl+c, nothing will happen if cell is removed from dom.
  // c) if detail record of master detail, as users complained that the context of detail rows
  //    was getting lost when detail row out of view. eg user expands to show detail row,
  //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
  //    after detail panel is scrolled out of / into view.
  doNotUnVirtualiseRow(e) {
    const i = e.rowNode, r = this.focusSvc.isRowNodeFocused(i), n = e.editing, o = i.detail;
    return r || n || o ? !!this.isRowPresent(i) : !1;
  }
  isRowPresent(e) {
    var t;
    return this.rowModel.isRowPresent(e) ? ((t = this.beans.pagination) == null ? void 0 : t.isRowPresent(e)) ?? !0 : !1;
  }
  createRowCon(e, t, s) {
    var a;
    const i = ((a = this.cachedRowCtrls) == null ? void 0 : a.getRow(e)) ?? null;
    if (i)
      return i;
    const r = this.gos.get("suppressAnimationFrame"), n = s && !r && !this.printLayout && !!this.beans.animationFrameSvc;
    return new cu(e, this.beans, t, n, this.printLayout);
  }
  getRenderedNodes() {
    const e = this.rowCtrlsByRowIndex;
    return Object.values(e).map((t) => t.rowNode);
  }
  getRowByPosition(e) {
    let t;
    const { rowIndex: s } = e;
    switch (e.rowPinned) {
      case "top":
        t = this.topRowCtrls[s];
        break;
      case "bottom":
        t = this.bottomRowCtrls[s];
        break;
      default:
        t = this.rowCtrlsByRowIndex[s], t || (t = this.getStickyTopRowCtrls().find((i) => i.rowNode.rowIndex === s) || null, t || (t = this.getStickyBottomRowCtrls().find((i) => i.rowNode.rowIndex === s) || null));
        break;
    }
    return t;
  }
  // returns true if any row between startIndex and endIndex is rendered. used by
  // SSRM or IRM, as they don't want to purge visible blocks from cache.
  isRangeInRenderedViewport(e, t) {
    if (e == null || t == null)
      return !1;
    const i = e > this.lastRenderedRow;
    return !(t < this.firstRenderedRow) && !i;
  }
}, BL = class {
  constructor(e) {
    this.entriesMap = {}, this.entriesList = [], this.maxCount = e;
  }
  addRow(e) {
    if (this.entriesMap[e.rowNode.id] = e, this.entriesList.push(e), e.setCached(!0), this.entriesList.length > this.maxCount) {
      const t = this.entriesList[0];
      t.destroyFirstPass(), t.destroySecondPass(), this.removeFromCache(t);
    }
  }
  getRow(e) {
    if (e == null || e.id == null)
      return null;
    const t = this.entriesMap[e.id];
    return t ? (this.removeFromCache(t), t.setCached(!1), t.rowNode != e ? null : t) : null;
  }
  has(e) {
    return this.entriesMap[e.id] != null;
  }
  removeRow(e) {
    const t = e.id, s = this.entriesMap[t];
    delete this.entriesMap[t], kt(this.entriesList, s);
  }
  removeFromCache(e) {
    const t = e.rowNode.id;
    delete this.entriesMap[t], kt(this.entriesList, e);
  }
  getEntries() {
    return this.entriesList;
  }
};
function Cu(e) {
  if (!e)
    return;
  const t = {
    top: {},
    bottom: {},
    normal: {}
  };
  return e.forEach((s) => {
    const i = s.id;
    switch (s.rowPinned) {
      case "top":
        t.top[i] = s;
        break;
      case "bottom":
        t.bottom[i] = s;
        break;
      default:
        t.normal[i] = s;
        break;
    }
  }), t;
}
function vu(e, t) {
  const s = e.id;
  switch (e.rowPinned) {
    case "top":
      return t.top[s] != null;
    case "bottom":
      return t.bottom[s] != null;
    default:
      return t.normal[s] != null;
  }
}
var VL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowNodeSorter";
  }
  postConstruct() {
    const { gos: e } = this;
    this.isAccentedSort = e.get("accentedSort"), this.primaryColumnsSortGroups = ti(e), this.addManagedPropertyListener(
      "accentedSort",
      (t) => this.isAccentedSort = t.currentValue
    ), this.addManagedPropertyListener(
      "autoGroupColumnDef",
      () => this.primaryColumnsSortGroups = ti(e)
    );
  }
  doFullSort(e, t) {
    const s = e.map((i, r) => ({
      currentPos: r,
      rowNode: i
    }));
    return s.sort(this.compareRowNodes.bind(this, t)), s.map((i) => i.rowNode);
  }
  compareRowNodes(e, t, s) {
    const i = t.rowNode, r = s.rowNode;
    for (let n = 0, o = e.length; n < o; n++) {
      const a = e[n], l = a.sort === "desc", c = this.getValue(i, a.column), d = this.getValue(r, a.column);
      let u;
      const h = this.getComparator(a, i);
      if (h ? u = h(c, d, i, r, l) : u = nl(c, d, this.isAccentedSort), !isNaN(u) && u !== 0)
        return a.sort === "asc" ? u : u * -1;
    }
    return t.currentPos - s.currentPos;
  }
  getComparator(e, t) {
    const s = e.column, i = s.getColDef().comparator;
    if (i != null)
      return i;
    if (!s.getColDef().showRowGroup)
      return;
    const r = !t.group && s.getColDef().field;
    if (!r)
      return;
    const n = this.beans.colModel.getColDefCol(r);
    if (n)
      return n.getColDef().comparator;
  }
  getValue(e, t) {
    var a, l;
    const { valueSvc: s, colModel: i, showRowGroupCols: r, gos: n } = this.beans;
    if (!this.primaryColumnsSortGroups)
      return s.getValue(t, e, !1);
    if (e.rowGroupColumn === t) {
      if (uc(n, i.isPivotActive())) {
        const u = (a = e.allLeafChildren) == null ? void 0 : a[0];
        return u ? s.getValue(t, u, !1) : void 0;
      }
      const d = r == null ? void 0 : r.getShowRowGroupCol(t.getId());
      return d ? (l = e.groupData) == null ? void 0 : l[d.getId()] : void 0;
    }
    if (!(e.group && t.getColDef().showRowGroup))
      return s.getValue(t, e, !1);
  }
};
function NL(e) {
  var t;
  (t = e.sortSvc) == null || t.onSortChanged("api");
}
function Mo(e, t) {
  return (
    /* html */
    `<span data-ref="eSort${e}" class="ag-sort-indicator-icon ag-sort-${t} ag-hidden" aria-hidden="true"></span>`
  );
}
var HL = (
  /* html */
  `<span class="ag-sort-indicator-container">
        ${Mo("Order", "order")}
        ${Mo("Asc", "ascending-icon")}
        ${Mo("Desc", "descending-icon")}
        ${Mo("Mixed", "mixed-icon")}
        ${Mo("None", "none-icon")}
    </span>`
), Hh = class extends _ {
  constructor(e) {
    super(), this.eSortOrder = E, this.eSortAsc = E, this.eSortDesc = E, this.eSortMixed = E, this.eSortNone = E, e || this.setTemplate(HL);
  }
  attachCustomElements(e, t, s, i, r) {
    this.eSortOrder = e, this.eSortAsc = t, this.eSortDesc = s, this.eSortMixed = i, this.eSortNone = r;
  }
  setupSort(e, t = !1) {
    if (this.column = e, this.suppressOrder = t, this.setupMultiSortIndicator(), !e.isSortable() && !e.getColDef().showRowGroup)
      return;
    this.addInIcon("sortAscending", this.eSortAsc, e), this.addInIcon("sortDescending", this.eSortDesc, e), this.addInIcon("sortUnSort", this.eSortNone, e);
    const s = this.updateIcons.bind(this), i = this.onSortChanged.bind(this);
    this.addManagedPropertyListener("unSortIcon", s), this.addManagedEventListeners({
      newColumnsLoaded: s,
      // Watch global events, as row group columns can effect their display column.
      sortChanged: i,
      // when grouping changes so can sort indexes and icons
      columnRowGroupChanged: i
    }), this.onSortChanged();
  }
  addInIcon(e, t, s) {
    if (t == null)
      return;
    const i = ue(e, this.beans, s);
    i && t.appendChild(i);
  }
  onSortChanged() {
    this.updateIcons(), this.suppressOrder || this.updateSortOrder();
  }
  updateIcons() {
    const { eSortAsc: e, eSortDesc: t, eSortNone: s, column: i, gos: r, beans: n } = this, o = n.sortSvc.getDisplaySortForColumn(i);
    if (e && re(e, o === "asc", { skipAriaHidden: !0 }), t && re(t, o === "desc", { skipAriaHidden: !0 }), s) {
      const a = !i.getColDef().unSortIcon && !r.get("unSortIcon"), l = o == null;
      re(s, !a && l, { skipAriaHidden: !0 });
    }
  }
  setupMultiSortIndicator() {
    const { eSortMixed: e, column: t, gos: s } = this;
    this.addInIcon("sortUnSort", e, t);
    const i = t.getColDef().showRowGroup;
    ti(s) && i && (this.addManagedEventListeners({
      // Watch global events, as row group columns can effect their display column.
      sortChanged: this.updateMultiSortIndicator.bind(this),
      // when grouping changes so can sort indexes and icons
      columnRowGroupChanged: this.updateMultiSortIndicator.bind(this)
    }), this.updateMultiSortIndicator());
  }
  updateMultiSortIndicator() {
    const { eSortMixed: e, beans: t, column: s } = this;
    if (e) {
      const i = t.sortSvc.getDisplaySortForColumn(s) === "mixed";
      re(e, i, { skipAriaHidden: !0 });
    }
  }
  // we listen here for global sort events, NOT column sort events, as we want to do this
  // when sorting has been set on all column (if we listened just for our col (where we
  // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
  updateSortOrder() {
    const {
      eSortOrder: e,
      column: t,
      beans: { sortSvc: s }
    } = this;
    if (!e)
      return;
    const i = s.getColumnsWithSortingOrdered(), r = s.getDisplaySortIndexForColumn(t) ?? -1, n = i.some(
      (a) => s.getDisplaySortIndexForColumn(a) ?? !1
    ), o = r >= 0 && n;
    re(e, o, { skipAriaHidden: !0 }), r >= 0 ? e.textContent = (r + 1).toString() : ze(e);
  }
}, zL = {
  selector: "AG-SORT-INDICATOR",
  component: Hh
}, la = ["asc", "desc", null], WL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "sortSvc";
  }
  progressSort(e, t, s) {
    const i = this.getNextSortDirection(e);
    this.setSortForColumn(e, i, t, s);
  }
  progressSortFromEvent(e, t) {
    const i = this.gos.get("multiSortKey") === "ctrl" ? t.ctrlKey || t.metaKey : t.shiftKey;
    this.progressSort(e, i, "uiColumnSorted");
  }
  setSortForColumn(e, t, s, i) {
    var d;
    t !== "asc" && t !== "desc" && (t = null);
    const { gos: r, showRowGroupCols: n } = this.beans, o = ti(r);
    let a = [e];
    if (o && e.getColDef().showRowGroup) {
      const u = (d = n == null ? void 0 : n.getSourceColumnsForGroupColumn) == null ? void 0 : d.call(n, e), h = u == null ? void 0 : u.filter((p) => p.isSortable());
      h && (a = [e, ...h]);
    }
    a.forEach((u) => this.setColSort(u, t, i));
    const l = (s || r.get("alwaysMultiSort")) && !r.get("suppressMultiSort"), c = [];
    if (!l) {
      const u = this.clearSortBarTheseColumns(a, i);
      c.push(...u);
    }
    this.updateSortIndex(e), c.push(...a), this.dispatchSortChangedEvents(i, c);
  }
  updateSortIndex(e) {
    const { gos: t, colModel: s, showRowGroupCols: i } = this.beans, r = ti(t), n = i == null ? void 0 : i.getShowRowGroupCol(e.getId()), o = r && n || e, a = this.getColumnsWithSortingOrdered();
    s.getAllCols().forEach((d) => this.setColSortIndex(d, null));
    const l = a.filter((d) => r && d.getColDef().showRowGroup ? !1 : d !== o);
    (o.getSort() ? [...l, o] : l).forEach((d, u) => this.setColSortIndex(d, u));
  }
  // gets called by API, so if data changes, use can call this, which will end up
  // working out the sort order again of the rows.
  onSortChanged(e, t) {
    this.dispatchSortChangedEvents(e, t);
  }
  isSortActive() {
    const t = this.beans.colModel.getAllCols().filter((s) => !!s.getSort());
    return t && t.length > 0;
  }
  dispatchSortChangedEvents(e, t) {
    const s = {
      type: "sortChanged",
      source: e
    };
    t && (s.columns = t), this.eventSvc.dispatchEvent(s);
  }
  clearSortBarTheseColumns(e, t) {
    const s = [];
    return this.beans.colModel.getAllCols().forEach((i) => {
      e.includes(i) || (i.getSort() && s.push(i), this.setColSort(i, void 0, t));
    }), s;
  }
  getNextSortDirection(e) {
    const t = e.getColDef().sortingOrder ?? this.gos.get("sortingOrder") ?? la, s = t.indexOf(e.getSort()), i = s < 0, r = s == t.length - 1;
    return i || r ? t[0] : t[s + 1];
  }
  /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */
  getIndexedSortMap() {
    const { gos: e, colModel: t, showRowGroupCols: s, rowGroupColsSvc: i } = this.beans;
    let r = t.getAllCols().filter((c) => !!c.getSort());
    if (t.isPivotMode()) {
      const c = ti(e);
      r = r.filter((d) => {
        const u = !!d.getAggFunc(), h = !d.isPrimary(), p = c ? s == null ? void 0 : s.getShowRowGroupCol(d.getId()) : d.getColDef().showRowGroup;
        return u || h || p;
      });
    }
    const n = (i == null ? void 0 : i.columns.filter((c) => !!c.getSort())) ?? [], o = {};
    r.forEach((c, d) => o[c.getId()] = d), r.sort((c, d) => {
      const u = c.getSortIndex(), h = d.getSortIndex();
      if (u != null && h != null)
        return u - h;
      if (u == null && h == null) {
        const p = o[c.getId()], g = o[d.getId()];
        return p > g ? 1 : -1;
      } else return h == null ? -1 : 1;
    });
    const a = ti(e) && !!n.length;
    a && (r = [
      ...new Set(
        // if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
        r.map((c) => (s == null ? void 0 : s.getShowRowGroupCol(c.getId())) ?? c)
      )
    ]);
    const l = /* @__PURE__ */ new Map();
    return r.forEach((c, d) => l.set(c, d)), a && n.forEach((c) => {
      const d = s.getShowRowGroupCol(c.getId());
      l.set(c, l.get(d));
    }), l;
  }
  getColumnsWithSortingOrdered() {
    return [...this.getIndexedSortMap().entries()].sort(([e, t], [s, i]) => t - i).map(([e]) => e);
  }
  // used by server side row models, to sent sort to server
  getSortModel() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({
      sort: e.getSort(),
      colId: e.getId()
    }));
  }
  getSortOptions() {
    return this.getColumnsWithSortingOrdered().filter((e) => e.getSort()).map((e) => ({
      sort: e.getSort(),
      column: e
    }));
  }
  canColumnDisplayMixedSort(e) {
    const t = ti(this.gos), s = !!e.getColDef().showRowGroup;
    return t && s;
  }
  getDisplaySortForColumn(e) {
    var o;
    const t = (o = this.beans.showRowGroupCols) == null ? void 0 : o.getSourceColumnsForGroupColumn(e);
    if (!this.canColumnDisplayMixedSort(e) || !(t != null && t.length))
      return e.getSort();
    const i = e.getColDef().field != null || !!e.getColDef().valueGetter ? [e, ...t] : t, r = i[0].getSort();
    return i.every((a) => a.getSort() == r) ? r : "mixed";
  }
  getDisplaySortIndexForColumn(e) {
    return this.getIndexedSortMap().get(e);
  }
  setupHeader(e, t, s) {
    let i = 0;
    e.addManagedListeners(t, {
      movingChanged: () => {
        i = (/* @__PURE__ */ new Date()).getTime();
      }
    }), s && e.addManagedElementListeners(s, {
      click: (n) => {
        const o = t.isMoving(), l = (/* @__PURE__ */ new Date()).getTime() - i < 50;
        o || l || this.progressSortFromEvent(t, n);
      }
    });
    const r = () => {
      var o;
      const n = t.getSort();
      if (e.addOrRemoveCssClass("ag-header-cell-sorted-asc", n === "asc"), e.addOrRemoveCssClass("ag-header-cell-sorted-desc", n === "desc"), e.addOrRemoveCssClass("ag-header-cell-sorted-none", !n), t.getColDef().showRowGroup) {
        const a = (o = this.beans.showRowGroupCols) == null ? void 0 : o.getSourceColumnsForGroupColumn(t), c = !(a == null ? void 0 : a.every(
          (d) => t.getSort() == d.getSort()
        ));
        e.addOrRemoveCssClass("ag-header-cell-sorted-mixed", c);
      }
    };
    e.addManagedEventListeners({
      sortChanged: r,
      columnRowGroupChanged: r
    });
  }
  initCol(e) {
    const { sort: t, initialSort: s, sortIndex: i, initialSortIndex: r } = e.colDef;
    t !== void 0 ? (t === "asc" || t === "desc") && (e.sort = t) : (s === "asc" || s === "desc") && (e.sort = s), i !== void 0 ? i !== null && (e.sortIndex = i) : r !== null && (e.sortIndex = r);
  }
  updateColSort(e, t, s) {
    t !== void 0 && (t === "desc" || t === "asc" ? this.setColSort(e, t, s) : this.setColSort(e, void 0, s));
  }
  setColSort(e, t, s) {
    e.sort !== t && (e.sort = t, e.dispatchColEvent("sortChanged", s)), e.dispatchStateUpdatedEvent("sort");
  }
  setColSortIndex(e, t) {
    e.sortIndex = t, e.dispatchStateUpdatedEvent("sortIndex");
  }
  createSortIndicator(e) {
    return new Hh(e);
  }
  getSortIndicatorSelector() {
    return zL;
  }
}, zh = {
  moduleName: "Sort",
  version: de,
  beans: [WL, VL],
  apiFunctions: {
    onSortChanged: NL
  },
  userComponents: {
    agSortIndicator: Hh
  },
  icons: {
    // show on column header when column is sorted ascending
    sortAscending: "asc",
    // show on column header when column is sorted descending
    sortDescending: "desc",
    // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
    sortUnSort: "none"
  }
}, _L = class extends L {
  constructor() {
    super(...arguments), this.beanName = "syncSvc", this.waitingForColumns = !1;
  }
  postConstruct() {
    this.addManagedPropertyListener("columnDefs", (e) => this.setColumnDefs(e));
  }
  start() {
    this.beans.ctrlsSvc.whenReady(this, () => {
      const e = this.gos.get("columnDefs");
      e ? this.setColumnsAndData(e) : this.waitingForColumns = !0, this.gridReady();
    });
  }
  setColumnsAndData(e) {
    const { colModel: t, rowModel: s } = this.beans;
    t.setColumnDefs(e ?? [], "gridInitializing"), s.start();
  }
  gridReady() {
    const { eventSvc: e, gos: t } = this;
    e.dispatchEvent({
      type: "gridReady"
    }), Rr(t, `initialised successfully, enterprise = ${t.isModuleRegistered("EnterpriseCore")}`);
  }
  setColumnDefs(e) {
    const t = this.gos.get("columnDefs");
    if (t) {
      if (this.waitingForColumns) {
        this.waitingForColumns = !1, this.setColumnsAndData(t);
        return;
      }
      this.beans.colModel.setColumnDefs(t, cn(e.source));
    }
  }
};
function UL(e) {
  var t;
  (t = e.valueCache) == null || t.expire();
}
function $L(e, t) {
  const { colKey: s, rowNode: i, useFormatter: r } = t, n = e.colModel.getColDefCol(s) ?? e.colModel.getCol(s);
  if (ke(n))
    return null;
  const o = e.valueSvc.getValueForDisplay(n, i);
  return r ? e.valueSvc.formatValue(n, i, o) ?? Ke(o, !0) : o;
}
var so = class {
  constructor(e, t) {
    this.active = !0, this.nodeIdsToColumns = {}, this.mapToItems = {}, this.keepingColumns = e, this.pathRoot = {
      rowNode: t,
      children: null
    }, this.mapToItems[t.id] = this.pathRoot;
  }
  depthFirstSearchChangedPath(e, t) {
    const { rowNode: s, children: i } = e;
    if (i)
      for (let r = 0; r < i.length; ++r)
        this.depthFirstSearchChangedPath(i[r], t);
    t(s);
  }
  depthFirstSearchEverything(e, t, s) {
    const i = e.childrenAfterGroup;
    if (i)
      for (let r = 0, n = i.length; r < n; ++r) {
        const o = i[r];
        o.childrenAfterGroup ? this.depthFirstSearchEverything(o, t, s) : s && t(o);
      }
    t(e);
  }
  // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
  // will be called for child nodes in addition to parent nodes.
  forEachChangedNodeDepthFirst(e, t = !1, s = !1) {
    this.active && !s ? this.depthFirstSearchChangedPath(this.pathRoot, e) : this.depthFirstSearchEverything(this.pathRoot.rowNode, e, t);
  }
  executeFromRootNode(e) {
    e(this.pathRoot.rowNode);
  }
  createPathItems(e) {
    let t = e, s = 0;
    for (; !this.mapToItems[t.id]; ) {
      const i = {
        rowNode: t,
        children: null
      };
      this.mapToItems[t.id] = i, s++, t = t.parent;
    }
    return s;
  }
  populateColumnsMap(e, t) {
    if (!this.keepingColumns || !t)
      return;
    let s = e;
    for (; s; )
      this.nodeIdsToColumns[s.id] || (this.nodeIdsToColumns[s.id] = {}), t.forEach((i) => this.nodeIdsToColumns[s.id][i.getId()] = !0), s = s.parent;
  }
  linkPathItems(e, t) {
    let s = e;
    for (let i = 0; i < t; i++) {
      const r = this.mapToItems[s.id], n = this.mapToItems[s.parent.id];
      n.children || (n.children = []), n.children.push(r), s = s.parent;
    }
  }
  // called by
  // 1) change detection (provides cols) and
  // 2) groupStage if doing transaction update (doesn't provide cols)
  addParentNode(e, t) {
    if (!e || e.isRowPinned())
      return;
    const s = this.createPathItems(e);
    this.linkPathItems(e, s), this.populateColumnsMap(e, t);
  }
  canSkip(e) {
    return this.active && !this.mapToItems[e.id];
  }
  getValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return t;
    const s = this.nodeIdsToColumns[e.id];
    return t.filter((r) => s[r.getId()]);
  }
  getNotValueColumnsForNode(e, t) {
    if (!this.keepingColumns)
      return null;
    const s = this.nodeIdsToColumns[e.id];
    return t.filter((r) => !s[r.getId()]);
  }
}, jL = "paste", KL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "changeDetectionSvc", this.clientSideRowModel = null;
  }
  postConstruct() {
    const { gos: e, rowModel: t } = this.beans;
    Ye(e) && (this.clientSideRowModel = t), this.addManagedEventListeners({ cellValueChanged: this.onCellValueChanged.bind(this) });
  }
  onCellValueChanged(e) {
    const { gos: t, rowRenderer: s } = this.beans;
    if (e.source === jL || t.get("suppressChangeDetection"))
      return;
    const i = e.node, r = [i], n = this.clientSideRowModel, o = n == null ? void 0 : n.rootNode;
    if (o && !i.isRowPinned()) {
      const a = t.get("aggregateOnlyChangedColumns"), l = new so(a, o);
      l.addParentNode(i.parent, [e.column]), n.doAggregate(l), l.forEachChangedNodeDepthFirst((c) => {
        r.push(c);
      });
    }
    s.refreshCells({ rowNodes: r });
  }
}, qL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "expressionSvc", this.cache = {};
  }
  evaluate(e, t) {
    if (typeof e == "string")
      return this.evaluateExpression(e, t);
    be(15, { expression: e });
  }
  evaluateExpression(e, t) {
    try {
      return this.createExpressionFunction(e)(
        t.value,
        t.context,
        t.oldValue,
        t.newValue,
        t.value,
        t.node,
        t.data,
        t.colDef,
        t.rowIndex,
        t.api,
        t.getValue,
        t.column,
        t.columnGroup
      );
    } catch (s) {
      return be(16, { expression: e, params: t, e: s }), null;
    }
  }
  createExpressionFunction(e) {
    const t = this.cache;
    if (t[e])
      return t[e];
    const s = this.createFunctionBody(e), i = new Function(
      "x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, getValue, column, columnGroup",
      s
    );
    return t[e] = i, i;
  }
  createFunctionBody(e) {
    return e.indexOf("return") >= 0 ? e : "return " + e + ";";
  }
}, YL = class extends L {
  constructor() {
    super(...arguments), this.beanName = "valueCache", this.cacheVersion = 0;
  }
  postConstruct() {
    const e = this.gos;
    this.active = e.get("valueCache"), this.neverExpires = e.get("valueCacheNeverExpires");
  }
  onDataChanged() {
    this.neverExpires || this.expire();
  }
  expire() {
    this.cacheVersion++;
  }
  setValue(e, t, s) {
    if (this.active) {
      const i = this.cacheVersion;
      e.__cacheVersion !== i && (e.__cacheVersion = i, e.__cacheData = {}), e.__cacheData[t] = s;
    }
  }
  getValue(e, t) {
    if (!(!this.active || e.__cacheVersion !== this.cacheVersion))
      return e.__cacheData[t];
  }
}, XL = {
  moduleName: "ValueCache",
  version: de,
  beans: [YL],
  apiFunctions: {
    expireValueCache: UL
  }
}, ZL = {
  moduleName: "Expression",
  version: de,
  beans: [qL]
}, QL = {
  moduleName: "ChangeDetection",
  version: de,
  beans: [KL]
}, JL = {
  moduleName: "CellApi",
  version: de,
  apiFunctions: {
    getCellValue: $L
  }
}, e0 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "valueSvc", this.initialised = !1, this.isSsrm = !1;
  }
  wireBeans(e) {
    this.expressionSvc = e.expressionSvc, this.colModel = e.colModel, this.valueCache = e.valueCache, this.dataTypeSvc = e.dataTypeSvc;
  }
  postConstruct() {
    this.initialised || this.init();
  }
  init() {
    this.executeValueGetter = this.valueCache ? this.executeValueGetterWithValueCache.bind(this) : this.executeValueGetterWithoutValueCache.bind(this), this.isSsrm = Lt(this.gos), this.cellExpressions = this.gos.get("enableCellExpressions"), this.isTreeData = this.gos.get("treeData"), this.initialised = !0;
    const e = (t) => this.callColumnCellValueChangedHandler(t);
    this.eventSvc.addEventListener("cellValueChanged", e, !0), this.addDestroyFunc(() => this.eventSvc.removeEventListener("cellValueChanged", e, !0)), this.addManagedPropertyListener("treeData", (t) => this.isTreeData = t.currentValue);
  }
  /**
   * Use this function to get a displayable cell value.
   * This hides values in expanded group rows which are instead displayed by the footer row.
   */
  getValueForDisplay(e, t) {
    const s = t.leafGroup && this.colModel.isPivotMode(), i = t.group && t.expanded && !t.footer && !s, r = this.gos.get("groupSuppressBlankHeader");
    if (!i || r)
      return this.getValue(e, t);
    let n = !1;
    const o = this.gos.get("groupTotalRow");
    typeof o != "function" ? n = !!o : n = !!this.gos.getCallback("groupTotalRow")({ node: this });
    const a = i && n;
    return this.getValue(e, t, a);
  }
  getValue(e, t, s = !1) {
    if (this.initialised || this.init(), !t)
      return;
    const i = e.getColDef(), r = i.field, n = e.getColId(), o = t.data;
    let a;
    const l = t.groupData && t.groupData[n] !== void 0, c = !s && t.aggData && t.aggData[n] !== void 0, d = this.isSsrm && s && !!e.getColDef().aggFunc, u = this.isSsrm && t.footer && t.field && (e.getColDef().showRowGroup === !0 || e.getColDef().showRowGroup === t.field);
    if (this.isTreeData && c ? a = t.aggData[n] : this.isTreeData && i.valueGetter ? a = this.executeValueGetter(i.valueGetter, o, e, t) : this.isTreeData && r && o ? a = $o(o, r, e.isFieldContainsDots()) : l ? a = t.groupData[n] : c ? a = t.aggData[n] : i.valueGetter ? a = this.executeValueGetter(i.valueGetter, o, e, t) : u ? a = $o(o, t.field, e.isFieldContainsDots()) : r && o && !d && (a = $o(o, r, e.isFieldContainsDots())), this.cellExpressions && typeof a == "string" && a.indexOf("=") === 0) {
      const h = a.substring(1);
      a = this.executeValueGetter(h, o, e, t);
    }
    if (a == null) {
      const h = this.getOpenedGroup(t, e);
      if (h != null)
        return h;
    }
    return a;
  }
  parseValue(e, t, s, i) {
    var o;
    const r = e.getColDef(), n = r.valueParser;
    if (W(n)) {
      const a = this.gos.addGridCommonParams({
        node: t,
        data: t == null ? void 0 : t.data,
        oldValue: i,
        newValue: s,
        colDef: r,
        column: e
      });
      return typeof n == "function" ? n(a) : (o = this.expressionSvc) == null ? void 0 : o.evaluate(n, a);
    }
    return s;
  }
  getDeleteValue(e, t) {
    return W(e.getColDef().valueParser) ? this.parseValue(e, t, "", this.getValueForDisplay(e, t)) ?? null : null;
  }
  formatValue(e, t, s, i, r = !0) {
    let n = null, o;
    const a = e.getColDef();
    if (i ? o = i : r && (o = a.valueFormatter), o) {
      const l = this.gos.addGridCommonParams({
        value: s,
        node: t,
        data: t ? t.data : null,
        colDef: a,
        column: e
      });
      typeof o == "function" ? n = o(l) : n = this.expressionSvc ? this.expressionSvc.evaluate(o, l) : null;
    } else if (a.refData)
      return a.refData[s] || "";
    return n == null && Array.isArray(s) && (n = s.join(", ")), n;
  }
  getOpenedGroup(e, t) {
    if (!this.gos.get("showOpenedGroup") || !t.getColDef().showRowGroup)
      return;
    const i = t.getColDef().showRowGroup;
    let r = e.parent;
    for (; r != null; ) {
      if (r.rowGroupColumn && (i === !0 || i === r.rowGroupColumn.getColId()))
        return r.key;
      r = r.parent;
    }
  }
  /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */
  setValue(e, t, s, i) {
    var d, u;
    const r = this.colModel.getColDefCol(t);
    if (!e || !r)
      return !1;
    ke(e.data) && (e.data = {});
    const { field: n, valueSetter: o } = r.getColDef();
    if (ke(n) && ke(o))
      return I(17), !1;
    if (this.dataTypeSvc && !this.dataTypeSvc.checkType(r, s))
      return I(135), !1;
    const a = this.gos.addGridCommonParams({
      node: e,
      data: e.data,
      oldValue: this.getValue(r, e),
      newValue: s,
      colDef: r.getColDef(),
      column: r
    });
    a.newValue = s;
    let l;
    if (W(o) ? typeof o == "function" ? l = o(a) : l = (d = this.expressionSvc) == null ? void 0 : d.evaluate(o, a) : l = this.setValueUsingField(e.data, n, s, r.isFieldContainsDots()), l === void 0 && (l = !0), !l)
      return !1;
    e.resetQuickFilterAggregateText(), (u = this.valueCache) == null || u.onDataChanged();
    const c = this.getValue(r, e);
    return this.eventSvc.dispatchEvent({
      type: "cellValueChanged",
      event: null,
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned,
      column: a.column,
      colDef: a.colDef,
      data: e.data,
      node: e,
      oldValue: a.oldValue,
      newValue: c,
      value: c,
      source: i
    }), !0;
  }
  callColumnCellValueChangedHandler(e) {
    const t = e.colDef.onCellValueChanged;
    typeof t == "function" && this.beans.frameworkOverrides.wrapOutgoing(() => {
      t({
        node: e.node,
        data: e.data,
        oldValue: e.oldValue,
        newValue: e.newValue,
        colDef: e.colDef,
        column: e.column,
        api: e.api,
        context: e.context
      });
    });
  }
  setValueUsingField(e, t, s, i) {
    if (!t)
      return !1;
    let r = !1;
    if (!i)
      r = e[t] === s, r || (e[t] = s);
    else {
      const n = t.split(".");
      let o = e;
      for (; n.length > 0 && o; ) {
        const a = n.shift();
        n.length === 0 ? (r = o[a] === s, r || (o[a] = s)) : o = o[a];
      }
    }
    return !r;
  }
  executeValueGetterWithValueCache(e, t, s, i) {
    const r = s.getColId(), n = this.valueCache.getValue(i, r);
    if (n !== void 0)
      return n;
    const o = this.executeValueGetterWithoutValueCache(e, t, s, i);
    return this.valueCache.setValue(i, r, o), o;
  }
  executeValueGetterWithoutValueCache(e, t, s, i) {
    var o;
    const r = this.gos.addGridCommonParams({
      data: t,
      node: i,
      column: s,
      colDef: s.getColDef(),
      getValue: this.getValueCallback.bind(this, i)
    });
    let n;
    return typeof e == "function" ? n = e(r) : n = (o = this.expressionSvc) == null ? void 0 : o.evaluate(e, r), n;
  }
  getValueCallback(e, t) {
    const s = this.colModel.getColDefCol(t);
    return s ? this.getValue(s, e) : null;
  }
  // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
  getKeyForNode(e, t) {
    const s = this.getValue(e, t), i = e.getColDef().keyCreator;
    let r = s;
    if (i) {
      const n = this.gos.addGridCommonParams({
        value: s,
        colDef: e.getColDef(),
        column: e,
        node: t,
        data: t.data
      });
      r = i(n);
    }
    return typeof r == "string" || r == null || (r = String(r), r === "[object Object]" && I(121)), r;
  }
}, t0 = {
  moduleName: "CommunityCore",
  version: de,
  beans: [
    QI,
    pA,
    eI,
    xT,
    kL,
    mM,
    jI,
    sL,
    wT,
    yL,
    wL,
    GL,
    e0,
    XI,
    $I,
    ZI,
    sI,
    _L,
    YM,
    XM
  ],
  icons: {
    // icon on select dropdowns (select cell editor, charts tool panels)
    selectOpen: "small-down",
    /** @deprecated v33 */
    smallDown: "small-down",
    /** @deprecated v33 */
    colorPicker: "color-picker",
    /** @deprecated v33 */
    smallUp: "small-up",
    /** @deprecated v33 */
    checkboxChecked: "small-up",
    /** @deprecated v33 */
    checkboxIndeterminate: "checkbox-indeterminate",
    /** @deprecated v33 */
    checkboxUnchecked: "checkbox-unchecked",
    /** @deprecated v33 */
    radioButtonOn: "radio-button-on",
    /** @deprecated v33 */
    radioButtonOff: "radio-button-off",
    /** @deprecated v33 */
    smallLeft: "small-left",
    /** @deprecated v33 */
    smallRight: "small-right"
  },
  apiFunctions: {
    getGridId: gA,
    destroy: fA,
    isDestroyed: mA,
    getGridOption: CA,
    setGridOption: vA,
    updateGridOptions: Yw
  },
  dependsOn: [
    $M,
    Oh,
    tM,
    zh,
    oL,
    ty,
    aL,
    LL,
    QL,
    lL,
    Sc,
    RL,
    PL,
    dL,
    JM,
    jM,
    ZL
  ]
}, Wh = class Yr {
  /**
   * @param providedOptions
   * @returns Shallow copy of the provided options with global options merged in.
   */
  static applyGlobalGridOptions(t) {
    if (!Yr.gridOptions)
      return { ...t };
    let s = {};
    return bt(s, Yr.gridOptions, !0, !0), Yr.mergeStrategy === "deep" ? bt(s, t, !0, !0) : s = { ...s, ...t }, Yr.gridOptions.context && (s.context = Yr.gridOptions.context), t.context && (Yr.mergeStrategy === "deep" && s.context && bt(t.context, s.context, !0, !0), s.context = t.context), s;
  }
};
Wh.gridOptions = void 0;
Wh.mergeStrategy = "shallow";
var Nl = Wh;
function s0(e, t = "shallow") {
  Nl.gridOptions = e, Nl.mergeStrategy = t;
}
function i0(e) {
  var t;
  return (t = Nl.gridOptions) == null ? void 0 : t[e];
}
function r0(e, t, s) {
  if (!t)
    return be(11), {};
  const i = s;
  let r;
  if (!(i != null && i.setThemeOnGridDiv)) {
    const o = document.createElement("div");
    o.style.height = "100%", e.appendChild(o), e = o, r = () => e.remove();
  }
  return new fy().create(
    e,
    t,
    (o) => {
      const a = new uA(e);
      o.createBean(a);
    },
    void 0,
    s,
    r
  );
}
var n0 = 1, fy = class {
  create(e, t, s, i, r, n) {
    const o = Nl.applyGlobalGridOptions(t), a = o.gridId ?? String(n0++), l = o.rowModelType ?? "clientSide", c = this.getRegisteredModules(r, a, l), d = this.createBeansList(l, c, a), u = this.createProvidedBeans(e, o, r);
    if (!d)
      return;
    const h = {
      providedBeanInstances: u,
      beanClasses: d,
      gridId: a,
      beanInitComparator: XD,
      beanDestroyComparator: ZD,
      derivedBeans: [qD],
      destroyCallback: n
    }, p = new hE(h);
    return this.registerModuleFeatures(p, c), s(p), p.getBean("syncSvc").start(), i && i(p), p.getBean("gridApi");
  }
  getRegisteredModules(e, t, s) {
    var i;
    return na(t0, void 0), (i = e == null ? void 0 : e.modules) == null || i.forEach((r) => na(r, t)), lE(t, s);
  }
  registerModuleFeatures(e, t) {
    const s = e.getBean("registry"), i = e.getBean("apiFunctionSvc");
    t.forEach((r) => {
      s.registerModule(r);
      const n = r.apiFunctions;
      n && Object.keys(n).forEach((a) => {
        i == null || i.addFunction(a, n[a]);
      });
    });
  }
  createProvidedBeans(e, t, s) {
    let i = s ? s.frameworkOverrides : null;
    ke(i) && (i = new jw());
    const r = {
      gridOptions: t,
      eGridDiv: e,
      globalListener: s ? s.globalListener : null,
      globalSyncListener: s ? s.globalSyncListener : null,
      frameworkOverrides: i
    };
    return s && s.providedBeanInstances && Object.assign(r, s.providedBeanInstances), r;
  }
  createBeansList(e, t, s) {
    const r = {
      clientSide: "ClientSideRowModel",
      infinite: "InfiniteRowModel",
      serverSide: "ServerSideRowModel",
      viewport: "ViewportRowModel"
    }[e];
    if (!r) {
      iu(201, { rowModelType: e }, `Unknown rowModelType ${e}.`);
      return;
    }
    if (!sw(r, s, e)) {
      iu(
        200,
        {
          reasonOrId: `rowModelType = '${e}'`,
          moduleName: r,
          gridScoped: mh(),
          gridId: s,
          rowModelType: e
        },
        `Missing module ${r}Module for rowModelType ${e}. 
If upgrading from before v33, see ${qn}/upgrading-to-ag-grid-33/#changes-to-modules/`
      );
      return;
    }
    const n = /* @__PURE__ */ new Set();
    return t.forEach((o) => {
      var a;
      return (a = o.beans) == null ? void 0 : a.forEach((l) => n.add(l));
    }), Array.from(n);
  }
};
function ci(e) {
  const t = e.rowModel;
  return t.getType() === "clientSide" ? t : void 0;
}
function xc(e) {
  const t = e.rowModel;
  return t.getType() === "infinite" ? t : void 0;
}
function lo(e) {
  const t = e.rowModel;
  return t.getType() === "serverSide" ? t : void 0;
}
var o0 = [
  "columnEverythingChanged",
  "newColumnsLoaded",
  "columnPivotModeChanged",
  "pivotMaxColumnsExceeded",
  "columnRowGroupChanged",
  "expandOrCollapseAll",
  "columnPivotChanged",
  "gridColumnsChanged",
  "columnValueChanged",
  "columnMoved",
  "columnVisible",
  "columnPinned",
  "columnGroupOpened",
  "columnResized",
  "displayedColumnsChanged",
  "virtualColumnsChanged",
  "columnHeaderMouseOver",
  "columnHeaderMouseLeave",
  "columnHeaderClicked",
  "columnHeaderContextMenu",
  "asyncTransactionsFlushed",
  "rowGroupOpened",
  "rowDataUpdated",
  "pinnedRowDataChanged",
  "rangeSelectionChanged",
  "cellSelectionChanged",
  "chartCreated",
  "chartRangeSelectionChanged",
  "chartOptionsChanged",
  "chartDestroyed",
  "toolPanelVisibleChanged",
  "toolPanelSizeChanged",
  "modelUpdated",
  "cutStart",
  "cutEnd",
  "pasteStart",
  "pasteEnd",
  "fillStart",
  "fillEnd",
  "cellSelectionDeleteStart",
  "cellSelectionDeleteEnd",
  "rangeDeleteStart",
  "rangeDeleteEnd",
  "undoStarted",
  "undoEnded",
  "redoStarted",
  "redoEnded",
  "cellClicked",
  "cellDoubleClicked",
  "cellMouseDown",
  "cellContextMenu",
  "cellValueChanged",
  "cellEditRequest",
  "rowValueChanged",
  "headerFocused",
  "cellFocused",
  "rowSelected",
  "selectionChanged",
  "tooltipShow",
  "tooltipHide",
  "cellKeyDown",
  "cellMouseOver",
  "cellMouseOut",
  "filterChanged",
  "filterModified",
  "filterOpened",
  "advancedFilterBuilderVisibleChanged",
  "sortChanged",
  "virtualRowRemoved",
  "rowClicked",
  "rowDoubleClicked",
  "gridReady",
  "gridPreDestroyed",
  "gridSizeChanged",
  "viewportChanged",
  "firstDataRendered",
  "dragStarted",
  "dragStopped",
  "dragCancelled",
  "rowEditingStarted",
  "rowEditingStopped",
  "cellEditingStarted",
  "cellEditingStopped",
  "bodyScroll",
  "bodyScrollEnd",
  "paginationChanged",
  "componentStateChanged",
  "storeRefreshed",
  "stateUpdated",
  "columnMenuVisibleChanged",
  "contextMenuVisibleChanged",
  "rowDragEnter",
  "rowDragMove",
  "rowDragLeave",
  "rowDragEnd",
  "rowDragCancel"
], a0 = [
  "scrollbarWidthChanged",
  "keyShortcutChangedCellStart",
  "keyShortcutChangedCellEnd",
  "pinnedHeightChanged",
  "cellFocusCleared",
  "fullWidthRowFocused",
  "checkboxChanged",
  "heightScaleChanged",
  "suppressMovableColumns",
  "suppressMenuHide",
  "suppressFieldDotNotation",
  "columnPanelItemDragStart",
  "columnPanelItemDragEnd",
  "bodyHeightChanged",
  "columnContainerWidthChanged",
  "displayedColumnsWidthChanged",
  "scrollVisibilityChanged",
  "scrollGapChanged",
  "columnHoverChanged",
  "flashCells",
  "paginationPixelOffsetChanged",
  "displayedRowsChanged",
  "leftPinnedWidthChanged",
  "rightPinnedWidthChanged",
  "rowContainerHeightChanged",
  "headerHeightChanged",
  "columnGroupHeaderHeightChanged",
  "columnHeaderHeightChanged",
  "gridStylesChanged",
  "storeUpdated",
  "filterDestroyed",
  "rowDataUpdateStarted",
  "rowCountReady",
  "advancedFilterEnabledChanged",
  "dataTypesInferred",
  "fieldValueChanged",
  "fieldPickerValueSelected",
  "richSelectListRowSelected",
  "sideBarUpdated",
  "alignedGridScroll",
  "alignedGridColumn",
  "gridOptionsChanged",
  "chartTitleEdit",
  "recalculateRowBounds",
  "stickyTopOffsetChanged",
  "overlayExclusiveChanged",
  "beforeRefreshModel"
], l0 = [...o0, ...a0], c0 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "localeSvc";
  }
  getLocaleTextFunc() {
    const e = this.gos, t = e.getCallback("getLocaleText");
    if (t)
      return (i, r, n) => t({
        key: i,
        defaultValue: r,
        variableValues: n
      });
    const s = e.get("localeText");
    return (i, r, n) => {
      let o = s && s[i];
      if (o && n && n.length) {
        let a = 0;
        for (; !(a >= n.length || o.indexOf("${variable}") === -1); )
          o = o.replace("${variable}", n[a++]);
      }
      return o ?? r;
    };
  }
}, d0 = [
  "overlayLoadingTemplate",
  "overlayNoRowsTemplate",
  "gridId",
  "quickFilterText",
  "rowModelType",
  "editType",
  "domLayout",
  "clipboardDelimiter",
  "rowGroupPanelShow",
  "multiSortKey",
  "pivotColumnGroupTotals",
  "pivotRowTotals",
  "pivotPanelShow",
  "fillHandleDirection",
  "groupDisplayType",
  "treeDataDisplayType",
  "colResizeDefault",
  "tooltipTrigger",
  "serverSidePivotResultFieldSeparator",
  "columnMenu",
  "tooltipShowMode",
  "grandTotalRow"
  // 'treeDataChildrenField',
], u0 = [
  "components",
  "rowStyle",
  "context",
  "autoGroupColumnDef",
  "localeText",
  "icons",
  "datasource",
  "dragAndDropImageComponentParams",
  "serverSideDatasource",
  "viewportDatasource",
  "groupRowRendererParams",
  "aggFuncs",
  "fullWidthCellRendererParams",
  "defaultColGroupDef",
  "defaultColDef",
  "defaultCsvExportParams",
  "defaultExcelExportParams",
  "columnTypes",
  "rowClassRules",
  "detailCellRendererParams",
  "loadingCellRendererParams",
  "loadingOverlayComponentParams",
  "noRowsOverlayComponentParams",
  "popupParent",
  "statusBar",
  "chartThemeOverrides",
  "customChartThemes",
  "chartToolPanelsDef",
  "dataTypeDefinitions",
  "advancedFilterParent",
  "advancedFilterBuilderParams",
  "initialState",
  "autoSizeStrategy",
  "selectionColumnDef"
], h0 = [
  "sortingOrder",
  "alignedGrids",
  "rowData",
  "columnDefs",
  "excelStyles",
  "pinnedTopRowData",
  "pinnedBottomRowData",
  "chartThemes",
  "rowClass",
  "paginationPageSizeSelector"
], my = [
  "rowHeight",
  "detailRowHeight",
  "rowBuffer",
  "headerHeight",
  "groupHeaderHeight",
  "groupLockGroupColumns",
  "floatingFiltersHeight",
  "pivotHeaderHeight",
  "pivotGroupHeaderHeight",
  "groupDefaultExpanded",
  "pivotDefaultExpanded",
  "viewportRowModelPageSize",
  "viewportRowModelBufferSize",
  "autoSizePadding",
  "maxBlocksInCache",
  "maxConcurrentDatasourceRequests",
  "tooltipShowDelay",
  "tooltipHideDelay",
  "cacheOverflowSize",
  "paginationPageSize",
  "cacheBlockSize",
  "infiniteInitialRowCount",
  "serverSideInitialRowCount",
  "scrollbarWidth",
  "asyncTransactionWaitMillis",
  "blockLoadDebounceMillis",
  "keepDetailRowsCount",
  "undoRedoCellEditingLimit",
  "cellFlashDuration",
  "cellFadeDuration",
  "tabIndex",
  "pivotMaxGeneratedColumns"
], p0 = ["theme", "rowSelection"], g0 = [
  "cellSelection",
  "sideBar",
  "suppressGroupChangesColumnVisibility",
  "groupAggFiltering",
  "suppressStickyTotalRow",
  "groupHideParentOfSingleChild"
], Cy = [
  "loadThemeGoogleFonts",
  "suppressMakeColumnVisibleAfterUnGroup",
  "suppressRowClickSelection",
  "suppressCellFocus",
  "suppressHeaderFocus",
  "suppressHorizontalScroll",
  "groupSelectsChildren",
  "alwaysShowHorizontalScroll",
  "alwaysShowVerticalScroll",
  "debug",
  "enableBrowserTooltips",
  "enableCellExpressions",
  "groupSuppressBlankHeader",
  "suppressMenuHide",
  "suppressRowDeselection",
  "unSortIcon",
  "suppressMultiSort",
  "alwaysMultiSort",
  "singleClickEdit",
  "suppressLoadingOverlay",
  "suppressNoRowsOverlay",
  "suppressAutoSize",
  "skipHeaderOnAutoSize",
  "suppressColumnMoveAnimation",
  "suppressMoveWhenColumnDragging",
  "suppressMovableColumns",
  "suppressFieldDotNotation",
  "enableRangeSelection",
  "enableRangeHandle",
  "enableFillHandle",
  "suppressClearOnFillReduction",
  "deltaSort",
  "suppressTouch",
  "allowContextMenuWithControlKey",
  "suppressContextMenu",
  "suppressDragLeaveHidesColumns",
  "suppressRowGroupHidesColumns",
  "suppressMiddleClickScrolls",
  "suppressPreventDefaultOnMouseWheel",
  "suppressCopyRowsToClipboard",
  "copyHeadersToClipboard",
  "copyGroupHeadersToClipboard",
  "pivotMode",
  "suppressAggFuncInHeader",
  "suppressColumnVirtualisation",
  "alwaysAggregateAtRootLevel",
  "suppressFocusAfterRefresh",
  "functionsReadOnly",
  "animateRows",
  "groupSelectsFiltered",
  "groupRemoveSingleChildren",
  "groupRemoveLowestSingleChildren",
  "enableRtl",
  "suppressClickEdit",
  "rowDragEntireRow",
  "rowDragManaged",
  "suppressRowDrag",
  "suppressMoveWhenRowDragging",
  "rowDragMultiRow",
  "enableGroupEdit",
  "embedFullWidthRows",
  "suppressPaginationPanel",
  "groupHideOpenParents",
  "groupAllowUnbalanced",
  "pagination",
  "paginationAutoPageSize",
  "suppressScrollOnNewData",
  "suppressScrollWhenPopupsAreOpen",
  "purgeClosedRowNodes",
  "cacheQuickFilter",
  "includeHiddenColumnsInQuickFilter",
  "ensureDomOrder",
  "accentedSort",
  "suppressChangeDetection",
  "valueCache",
  "valueCacheNeverExpires",
  "aggregateOnlyChangedColumns",
  "suppressAnimationFrame",
  "suppressExcelExport",
  "suppressCsvExport",
  "includeHiddenColumnsInAdvancedFilter",
  "suppressMultiRangeSelection",
  "enterNavigatesVerticallyAfterEdit",
  "enterNavigatesVertically",
  "suppressPropertyNamesCheck",
  "rowMultiSelectWithClick",
  "suppressRowHoverHighlight",
  "suppressRowTransform",
  "suppressClipboardPaste",
  "suppressLastEmptyLineOnPaste",
  "enableCharts",
  "suppressMaintainUnsortedOrder",
  "enableCellTextSelection",
  "suppressBrowserResizeObserver",
  "suppressMaxRenderedRowRestriction",
  "excludeChildrenWhenTreeDataFiltering",
  "tooltipMouseTrack",
  "tooltipInteraction",
  "keepDetailRows",
  "paginateChildRows",
  "preventDefaultOnContextMenu",
  "undoRedoCellEditing",
  "allowDragFromColumnsToolPanel",
  "pivotSuppressAutoColumn",
  "suppressExpandablePivotGroups",
  "debounceVerticalScrollbar",
  "detailRowAutoHeight",
  "serverSideSortAllLevels",
  "serverSideEnableClientSideSort",
  "serverSideOnlyRefreshFilteredGroups",
  "suppressAggFilteredOnly",
  "showOpenedGroup",
  "suppressClipboardApi",
  "suppressModelUpdateAfterUpdateTransaction",
  "stopEditingWhenCellsLoseFocus",
  "groupMaintainOrder",
  "columnHoverHighlight",
  "readOnlyEdit",
  "suppressRowVirtualisation",
  "enableCellEditingOnBackspace",
  "resetRowDataOnUpdate",
  "removePivotHeaderRowWhenSingleValueColumn",
  "suppressCopySingleCellRanges",
  "suppressGroupRowsSticky",
  "suppressCutToClipboard",
  "rowGroupPanelSuppressSort",
  "allowShowChangeAfterFilter",
  "enableAdvancedFilter",
  "masterDetail",
  "treeData",
  "reactiveCustomComponents",
  "applyQuickFilterBeforePivotOrAgg",
  "suppressServerSideFullWidthLoadingRow",
  "suppressAdvancedFilterEval",
  "loading",
  "maintainColumnOrder",
  "enableStrictPivotColumnOrder",
  "suppressSetFilterByDefault"
], f0 = [
  "doesExternalFilterPass",
  "processPivotResultColDef",
  "processPivotResultColGroupDef",
  "getBusinessKeyForNode",
  "isRowSelectable",
  "rowDragText",
  "groupRowRenderer",
  "dragAndDropImageComponent",
  "fullWidthCellRenderer",
  "loadingCellRenderer",
  "loadingOverlayComponent",
  "noRowsOverlayComponent",
  "detailCellRenderer",
  "quickFilterParser",
  "quickFilterMatcher",
  "getLocaleText",
  "isExternalFilterPresent",
  "getRowHeight",
  "getRowClass",
  "getRowStyle",
  "getContextMenuItems",
  "getMainMenuItems",
  "processRowPostCreate",
  "processCellForClipboard",
  "getGroupRowAgg",
  "isFullWidthRow",
  "sendToClipboard",
  "focusGridInnerElement",
  "navigateToNextHeader",
  "tabToNextHeader",
  "navigateToNextCell",
  "tabToNextCell",
  "processCellFromClipboard",
  "getDocument",
  "postProcessPopup",
  "getChildCount",
  "getDataPath",
  "isRowMaster",
  "postSortRows",
  "processHeaderForClipboard",
  "processUnpinnedColumns",
  "processGroupHeaderForClipboard",
  "paginationNumberFormatter",
  "processDataFromClipboard",
  "getServerSideGroupKey",
  "isServerSideGroup",
  "createChartContainer",
  "getChartToolbarItems",
  "fillOperation",
  "isApplyServerSideTransaction",
  "getServerSideGroupLevelParams",
  "isServerSideGroupOpenByDefault",
  "isGroupOpenByDefault",
  "initialGroupOrderComparator",
  "loadingCellRendererSelector",
  "getRowId",
  "chartMenuItems",
  "groupTotalRow",
  "alwaysPassFilter"
], m0 = [
  ...h0,
  ...u0,
  ...d0,
  ...my,
  ...f0,
  ...Cy,
  ...g0,
  ...p0
], C0 = class {
  wrap(e, t, s, i) {
    const r = this.createWrapper(e, i);
    return t == null || t.forEach((n) => {
      this.createMethod(r, n, !0);
    }), s == null || s.forEach((n) => {
      this.createMethod(r, n, !1);
    }), r;
  }
  createMethod(e, t, s) {
    e.addMethod(t, this.createMethodProxy(e, t, s));
  }
  createMethodProxy(e, t, s) {
    return function() {
      return e.hasMethod(t) ? e.callMethod(t, arguments) : (s && I(49, { methodName: t }), null);
    };
  }
}, v0 = class extends Lr {
  constructor() {
    super(
      /* html */
      '<div class="ag-tooltip"></div>'
    );
  }
  // will need to type params
  init(e) {
    const { value: t } = e;
    this.getGui().textContent = Ke(t, !0);
  }
};
function Rc(e) {
  const { inputValue: t, allSuggestions: s, hideIrrelevant: i, filterByPercentageOfBestMatch: r, addSequentialWeight: n } = e;
  let o = s.map((c, d) => ({
    value: c,
    relevance: y0(t.toLowerCase(), c.toLocaleLowerCase(), n),
    idx: d
  }));
  if (o.sort((c, d) => d.relevance - c.relevance), i && (o = o.filter((c) => c.relevance !== 0)), o.length > 0 && r && r > 0) {
    const d = o[0].relevance * r;
    o = o.filter((u) => d - u.relevance < 0);
  }
  const a = [], l = [];
  for (const c of o)
    a.push(c.value), l.push(c.idx);
  return { values: a, indices: l };
}
function w0(e) {
  const t = [], s = e.length;
  for (let i = 1; i <= s; i++)
    for (let r = 0; r <= s - i; r++) {
      const n = r + i - 1;
      t.push(e.slice(r, n + 1));
    }
  return t;
}
function y0(e, t, s = !1) {
  const i = e.replace(/\s/g, ""), r = t.replace(/\s/g, ""), n = i.length, o = r.length, a = new Array(n + 1).fill(null).map(() => new Array(o + 1).fill(0));
  for (let u = 0; u <= n; u += 1)
    a[u][0] = u;
  for (let u = 0; u <= o; u += 1)
    a[0][u] = u;
  for (let u = 1; u <= n; u++)
    for (let h = 1; h <= o; h++)
      i[u - 1] === r[h - 1] ? a[u][h] = a[u - 1][h - 1] : a[u][h] = 1 + Math.min(a[u][h - 1], Math.min(a[u - 1][h], a[u - 1][h - 1]));
  const l = a[n][o];
  let d = Math.max(n, o) - l;
  if (s) {
    const u = w0(i);
    for (let h = 0; h < u.length; h++) {
      const p = u[h];
      r.indexOf(p) !== -1 && (d += 1, d *= p.length);
    }
  }
  return d;
}
function vn(e, t) {
  if (typeof e != "number")
    return "";
  const s = t(), i = s("thousandSeparator", ","), r = s("decimalSeparator", ".");
  return e.toString().replace(".", r).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${i}`);
}
var vy = class extends L {
  getFileName(e) {
    const t = this.getDefaultFileExtension();
    return (e == null || !e.length) && (e = this.getDefaultFileName()), e.indexOf(".") === -1 ? `${e}.${t}` : e;
  }
  getData(e) {
    const t = this.createSerializingSession(e);
    return this.beans.gridSerializer.serialize(t, e);
  }
  getDefaultFileName() {
    return `export.${this.getDefaultFileExtension()}`;
  }
}, wy = class {
  constructor(e) {
    this.groupColumns = [];
    const {
      colModel: t,
      rowGroupColsSvc: s,
      colNames: i,
      valueSvc: r,
      gos: n,
      processCellCallback: o,
      processHeaderCallback: a,
      processGroupHeaderCallback: l,
      processRowGroupCallback: c
    } = e;
    this.colModel = t, this.rowGroupColsSvc = s, this.colNames = i, this.valueSvc = r, this.gos = n, this.processCellCallback = o, this.processHeaderCallback = a, this.processGroupHeaderCallback = l, this.processRowGroupCallback = c;
  }
  prepare(e) {
    this.groupColumns = e.filter((t) => !!t.getColDef().showRowGroup);
  }
  extractHeaderValue(e) {
    return this.getHeaderName(this.processHeaderCallback, e) ?? "";
  }
  extractRowCellValue(e, t, s, i, r) {
    const o = (!this.gos.get("groupHideOpenParents") || r.footer) && this.shouldRenderGroupSummaryCell(r, e, t) ? this.createValueForGroupNode(e, r) : this.valueSvc.getValue(e, r);
    return this.processCell({
      accumulatedRowIndex: s,
      rowNode: r,
      column: e,
      value: o,
      processCellCallback: this.processCellCallback,
      type: i
    });
  }
  shouldRenderGroupSummaryCell(e, t, s) {
    var o, a;
    if (!(e.group && !this.gos.get("treeData")))
      return !1;
    if (this.groupColumns.indexOf(t) !== -1) {
      if (((o = e.groupData) == null ? void 0 : o[t.getId()]) !== void 0 || Lt(this.gos) && e.group)
        return !0;
      if (e.footer && e.level === -1) {
        const l = t.getColDef();
        return l == null || l.showRowGroup === !0 || l.showRowGroup === ((a = this.rowGroupColsSvc) == null ? void 0 : a.columns[0].getId());
      }
    }
    const n = uc(this.gos, this.colModel.isPivotMode());
    return s === 0 && n;
  }
  getHeaderName(e, t) {
    return e ? e(this.gos.addGridCommonParams({ column: t })) : this.colNames.getDisplayNameForColumn(t, "csv", !0);
  }
  createValueForGroupNode(e, t) {
    if (this.processRowGroupCallback)
      return this.processRowGroupCallback(this.gos.addGridCommonParams({ column: e, node: t }));
    const s = this.gos.get("treeData"), i = (a) => {
      var c;
      if (s)
        return a.key;
      const l = (c = a.groupData) == null ? void 0 : c[e.getId()];
      return !l || !a.rowGroupColumn || a.rowGroupColumn.getColDef().useValueFormatterForExport === !1 ? l : this.valueSvc.formatValue(a.rowGroupColumn, a, l) ?? l;
    }, r = t.footer, n = [i(t)];
    if (!dh(this.gos))
      for (; t.parent; )
        t = t.parent, n.push(i(t));
    const o = n.reverse().join(" -> ");
    return r ? `Total ${o}` : o;
  }
  processCell(e) {
    const { accumulatedRowIndex: t, rowNode: s, column: i, value: r, processCellCallback: n, type: o } = e;
    return n ? {
      value: n(
        this.gos.addGridCommonParams({
          accumulatedRowIndex: t,
          column: i,
          node: s,
          value: r,
          type: o,
          parseValue: (a) => this.valueSvc.parseValue(
            i,
            s,
            a,
            this.valueSvc.getValue(i, s)
          ),
          formatValue: (a) => this.valueSvc.formatValue(i, s, a) ?? a
        })
      ) ?? ""
    } : i.getColDef().useValueFormatterForExport !== !1 ? {
      value: r ?? "",
      valueFormatted: this.valueSvc.formatValue(i, s, r)
    } : { value: r ?? "" };
  }
};
function _h(e, t) {
  const s = document.defaultView || window;
  if (!s) {
    I(52);
    return;
  }
  const i = document.createElement("a"), r = s.URL.createObjectURL(t);
  i.setAttribute("href", r), i.setAttribute("download", e), i.style.display = "none", document.body.appendChild(i), i.dispatchEvent(
    new MouseEvent("click", {
      bubbles: !1,
      cancelable: !0,
      view: s
    })
  ), document.body.removeChild(i), s.setTimeout(() => {
    s.URL.revokeObjectURL(r);
  }, 0);
}
var b0 = {
  enableBrowserTooltips: !0,
  tooltipTrigger: !0,
  tooltipMouseTrack: !0,
  tooltipShowMode: !0,
  tooltipInteraction: !0,
  defaultColGroupDef: !0,
  suppressAutoSize: !0,
  skipHeaderOnAutoSize: !0,
  autoSizeStrategy: !0,
  components: !0,
  stopEditingWhenCellsLoseFocus: !0,
  undoRedoCellEditing: !0,
  undoRedoCellEditingLimit: !0,
  excelStyles: !0,
  cacheQuickFilter: !0,
  customChartThemes: !0,
  chartThemeOverrides: !0,
  chartToolPanelsDef: !0,
  loadingCellRendererSelector: !0,
  localeText: !0,
  keepDetailRows: !0,
  keepDetailRowsCount: !0,
  detailRowHeight: !0,
  detailRowAutoHeight: !0,
  tabIndex: !0,
  valueCache: !0,
  valueCacheNeverExpires: !0,
  enableCellExpressions: !0,
  suppressTouch: !0,
  suppressBrowserResizeObserver: !0,
  suppressPropertyNamesCheck: !0,
  debug: !0,
  dragAndDropImageComponent: !0,
  loadingOverlayComponent: !0,
  suppressLoadingOverlay: !0,
  noRowsOverlayComponent: !0,
  paginationPageSizeSelector: !0,
  paginateChildRows: !0,
  pivotPanelShow: !0,
  pivotSuppressAutoColumn: !0,
  suppressExpandablePivotGroups: !0,
  aggFuncs: !0,
  allowShowChangeAfterFilter: !0,
  ensureDomOrder: !0,
  enableRtl: !0,
  suppressColumnVirtualisation: !0,
  suppressMaxRenderedRowRestriction: !0,
  suppressRowVirtualisation: !0,
  rowDragText: !0,
  groupLockGroupColumns: !0,
  suppressGroupRowsSticky: !0,
  rowModelType: !0,
  cacheOverflowSize: !0,
  infiniteInitialRowCount: !0,
  serverSideInitialRowCount: !0,
  maxBlocksInCache: !0,
  maxConcurrentDatasourceRequests: !0,
  blockLoadDebounceMillis: !0,
  serverSideOnlyRefreshFilteredGroups: !0,
  serverSidePivotResultFieldSeparator: !0,
  viewportRowModelPageSize: !0,
  viewportRowModelBufferSize: !0,
  debounceVerticalScrollbar: !0,
  suppressAnimationFrame: !0,
  suppressPreventDefaultOnMouseWheel: !0,
  scrollbarWidth: !0,
  icons: !0,
  suppressRowTransform: !0,
  gridId: !0,
  enableGroupEdit: !0,
  initialState: !0,
  processUnpinnedColumns: !0,
  createChartContainer: !0,
  getLocaleText: !0,
  getRowId: !0,
  reactiveCustomComponents: !0,
  columnMenu: !0,
  suppressSetFilterByDefault: !0,
  getDataPath: !0
}, ps = "clientSide", ts = "serverSide", Gn = "infinite", S0 = {
  onGroupExpandedOrCollapsed: [ps],
  refreshClientSideRowModel: [ps],
  isRowDataEmpty: [ps],
  forEachLeafNode: [ps],
  forEachNodeAfterFilter: [ps],
  forEachNodeAfterFilterAndSort: [ps],
  resetRowHeights: [ps],
  applyTransaction: [ps],
  applyTransactionAsync: [ps],
  flushAsyncTransactions: [ps],
  getBestCostNodeSelection: [ps],
  getServerSideSelectionState: [ts],
  setServerSideSelectionState: [ts],
  applyServerSideTransaction: [ts],
  applyServerSideTransactionAsync: [ts],
  applyServerSideRowData: [ts],
  retryServerSideLoads: [ts],
  flushServerSideAsyncTransactions: [ts],
  refreshServerSide: [ts],
  getServerSideGroupLevelState: [ts],
  refreshInfiniteCache: [Gn],
  purgeInfiniteCache: [Gn],
  getInfiniteRowCount: [Gn],
  isLastRowIndexKnown: [Gn, ts],
  expandAll: [ps, ts],
  collapseAll: [ps, ts],
  onRowHeightChanged: [ps, ts],
  setRowCount: [Gn, ts],
  getCacheBlockState: [Gn, ts]
}, x0 = {
  showLoadingOverlay: {
    version: "v32",
    message: '`showLoadingOverlay` is deprecated. Use the grid option "loading"=true instead or setGridOption("loading", true).'
  },
  clearRangeSelection: {
    version: "v32.2",
    message: "Use `clearCellSelection` instead."
  },
  getInfiniteRowCount: {
    version: "v32.2",
    old: "getInfiniteRowCount()",
    new: "getDisplayedRowCount()"
  },
  selectAllFiltered: {
    version: "v33",
    old: "selectAllFiltered()",
    new: 'selectAll("filtered")'
  },
  deselectAllFiltered: {
    version: "v33",
    old: "deselectAllFiltered()",
    new: 'deselectAll("filtered")'
  },
  selectAllOnCurrentPage: {
    version: "v33",
    old: "selectAllOnCurrentPage()",
    new: 'selectAll("currentPage")'
  },
  deselectAllOnCurrentPage: {
    version: "v33",
    old: "deselectAllOnCurrentPage()",
    new: 'deselectAll("currentPage")'
  }
};
function R0(e, t, s) {
  const i = x0[e];
  if (i) {
    const { version: n, new: o, old: a, message: l } = i, c = a ?? e;
    return (...d) => {
      const u = o ? `Please use ${o} instead. ` : "";
      return Si(`Since ${n} api.${c} is deprecated. ${u}${l ?? ""}`), t.apply(t, d);
    };
  }
  const r = S0[e];
  return r ? (...n) => {
    const o = s.rowModel.getType();
    if (!r.includes(o)) {
      zn(
        `api.${e} can only be called when gridOptions.rowModelType is ${r.join(" or ")}`
      );
      return;
    }
    return t.apply(t, n);
  } : t;
}
var F0 = {
  AdvancedFilter: 1,
  AllEnterprise: 1,
  CellSelection: 1,
  Clipboard: 1,
  ColumnMenu: 1,
  ColumnsToolPanel: 1,
  ContextMenu: 1,
  ExcelExport: 1,
  FiltersToolPanel: 1,
  GridCharts: 1,
  IntegratedCharts: 1,
  GroupFilter: 1,
  MasterDetail: 1,
  Menu: 1,
  MultiFilter: 1,
  Pivot: 1,
  RangeSelection: 1,
  RichSelect: 1,
  RowGrouping: 1,
  RowGroupingPanel: 1,
  ServerSideRowModelApi: 1,
  ServerSideRowModel: 1,
  SetFilter: 1,
  SideBar: 1,
  Sparklines: 1,
  StatusBar: 1,
  TreeData: 1,
  ViewportRowModel: 1
}, Pd = [
  "TextFilter",
  "NumberFilter",
  "DateFilter",
  "SetFilter",
  "MultiFilter",
  "GroupFilter",
  "CustomFilter"
], P0 = {
  EditCore: [
    "TextEditor",
    "NumberEditor",
    "DateEditor",
    "CheckboxEditor",
    "LargeTextEditor",
    "SelectEditor",
    "RichSelect",
    "CustomEditor"
  ],
  CheckboxCellRenderer: ["AllCommunity"],
  ClientSideRowModelHierarchy: ["RowGrouping", "Pivot", "TreeData"],
  ColumnFilter: Pd,
  ColumnGroupHeaderComp: ["AllCommunity"],
  ColumnGroup: ["AllCommunity"],
  ColumnHeaderComp: ["AllCommunity"],
  ColumnMove: ["AllCommunity"],
  ColumnResize: ["AllCommunity"],
  CommunityCore: ["AllCommunity"],
  CsrmSsrmSharedApi: ["ClientSideRowModelApi", "ServerSideRowModelApi"],
  EnterpriseCore: ["AllEnterprise"],
  FilterCore: [...Pd, "QuickFilter", "ExternalFilter", "AdvancedFilter"],
  GroupCellRenderer: ["RowGrouping", "Pivot", "TreeData", "MasterDetail", "ServerSideRowModel"],
  KeyboardNavigation: ["AllCommunity"],
  LoadingCellRenderer: ["ServerSideRowModel"],
  MenuCore: ["ColumnMenu", "ContextMenu"],
  MenuItem: ["ColumnMenu", "ContextMenu", "MultiFilter", "IntegratedCharts", "ColumnsToolPanel"],
  Overlay: ["AllCommunity"],
  PinnedColumn: ["AllCommunity"],
  SharedAggregation: ["RowGrouping", "Pivot", "TreeData", "ServerSideRowModel"],
  SharedDragAndDrop: ["AllCommunity"],
  SharedMasterDetail: ["MasterDetail", "ServerSideRowModel"],
  SharedMenu: [...Pd, "ColumnMenu", "ContextMenu"],
  SharedPivot: ["Pivot", "ServerSideRowModel"],
  SharedRowGrouping: ["RowGrouping", "ServerSideRowModel"],
  SharedRowSelection: ["RowSelection", "ServerSideRowModel"],
  SkeletonCellRenderer: ["ServerSideRowModel"],
  Sort: ["AllCommunity"],
  SsrmInfiniteSharedApi: ["InfiniteRowModel", "ServerSideRowModelApi"],
  SharedTreeData: ["TreeData", "ServerSideRowModel"]
}, T0 = {
  InfiniteRowModel: "infinite",
  ClientSideRowModelApi: "clientSide",
  ClientSideRowModel: "clientSide",
  ServerSideRowModelApi: "serverSide",
  ServerSideRowModel: "serverSide",
  ViewportRowModel: "viewport"
};
function E0(e, t) {
  const s = [];
  return (Array.isArray(e) ? e : [e]).forEach((i) => {
    const r = P0[i];
    r ? r.forEach((n) => {
      const o = T0[n];
      (!o || o === t) && s.push(n);
    }) : s.push(i);
  }), s;
}
var Un = {
  agSetColumnFilter: "SetFilter",
  agSetColumnFloatingFilter: "SetFilter",
  agMultiColumnFilter: "MultiFilter",
  agMultiColumnFloatingFilter: "MultiFilter",
  agGroupColumnFilter: "GroupFilter",
  agGroupColumnFloatingFilter: "GroupFilter",
  agGroupCellRenderer: "GroupCellRenderer",
  agGroupRowRenderer: "GroupCellRenderer",
  agRichSelect: "RichSelect",
  agRichSelectCellEditor: "RichSelect",
  agDetailCellRenderer: "SharedMasterDetail",
  agSparklineCellRenderer: "Sparklines",
  agDragAndDropImage: "SharedDragAndDrop",
  agColumnHeader: "ColumnHeaderComp",
  agColumnGroupHeader: "ColumnGroupHeaderComp",
  agSortIndicator: "Sort",
  agAnimateShowChangeCellRenderer: "HighlightChanges",
  agAnimateSlideCellRenderer: "HighlightChanges",
  agLoadingCellRenderer: "LoadingCellRenderer",
  agSkeletonCellRenderer: "SkeletonCellRenderer",
  agCheckboxCellRenderer: "CheckboxCellRenderer",
  agLoadingOverlay: "Overlay",
  agNoRowsOverlay: "Overlay",
  agTooltipComponent: "Tooltip",
  agReadOnlyFloatingFilter: "CustomFilter",
  agTextColumnFilter: "TextFilter",
  agNumberColumnFilter: "NumberFilter",
  agDateColumnFilter: "DateFilter",
  agDateInput: "DateFilter",
  agTextColumnFloatingFilter: "TextFilter",
  agNumberColumnFloatingFilter: "NumberFilter",
  agDateColumnFloatingFilter: "DateFilter",
  agCellEditor: "TextEditor",
  agSelectCellEditor: "SelectEditor",
  agTextCellEditor: "TextEditor",
  agNumberCellEditor: "NumberEditor",
  agDateCellEditor: "DateEditor",
  agDateStringCellEditor: "DateEditor",
  agCheckboxCellEditor: "CheckboxEditor",
  agLargeTextCellEditor: "LargeTextEditor",
  agMenuItem: "MenuItem",
  agColumnsToolPanel: "ColumnsToolPanel",
  agFiltersToolPanel: "FiltersToolPanel",
  agAggregationComponent: "StatusBar",
  agSelectedRowCountComponent: "StatusBar",
  agTotalRowCountComponent: "StatusBar",
  agFilteredRowCountComponent: "StatusBar",
  agTotalAndFilteredRowCountComponent: "StatusBar"
}, D0 = (e) => `import { ModuleRegistry } from 'ag-grid-community'; 
${e.map(
  (s) => `import { ${Hl(s)} } from '${F0[s] ? "ag-grid-enterprise" : "ag-grid-community"}';`
).join(` 
`)} 

ModuleRegistry.registerModules([ ${e.map(Hl).join(", ")} ]); 

For more info see: ${qn}/modules/`;
function Hl(e) {
  return `${e}Module`;
}
var pf = ({
  reasonOrId: e,
  moduleName: t,
  gridScoped: s,
  gridId: i,
  rowModelType: r,
  additionalText: n
}) => {
  const o = E0(t, r);
  return `Unable to use ${typeof e == "string" ? e : L0[e]} as ${o.length > 1 ? "one of " + o.map(Hl).join(", ") : Hl(o[0])} is not registered${s ? " for gridId: " + i : ""}. Check if you have registered the module:
${D0(o)}` + (n ? ` 

${n}` : "");
}, gf = (e) => `${e} must be initialised with an AG Charts module. One of 'AgChartsCommunityModule' / 'AgChartsEnterpriseModule'.

import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { ${e} } from 'ag-grid-enterprise';
    
ModuleRegistry.registerModules([${e}.with(AgChartsEnterpriseModule)]);
    `, A0 = (e) => `AG Grid: Unable to use the Clipboard API (navigator.clipboard.${e}()). The reason why it could not be used has been logged in the previous line. For this reason the grid has defaulted to using a workaround which doesn't perform as well. Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.`, M0 = {
  1: () => "`rowData` must be an array",
  2: ({ nodeId: e }) => `Duplicate node id '${e}' detected from getRowId callback, this could cause issues in your grid.`,
  3: () => "Calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.",
  4: ({ id: e }) => `Could not find row id=${e}, data item was not found for this id`,
  5: ({ data: e }) => [
    "Could not find data item as object was not found.",
    e,
    " Consider using getRowId to help the Grid find matching row data"
  ],
  6: () => "'groupHideOpenParents' only works when specifying specific columns for 'colDef.showRowGroup'",
  7: () => "Pivoting is not supported with aligned grids as it may produce different columns in each grid.",
  8: ({ key: e }) => `Unknown key for navigation ${e}`,
  9: ({ variable: e }) => `No value for ${e.cssName}. This usually means that the grid has been initialised before styles have been loaded. The default value of ${e.defaultValue} will be used and updated when styles load.`,
  10: ({ eventType: e }) => `As of v33, the '${e}' event is deprecated. Use the global 'modelUpdated' event to determine when row children have changed.`,
  11: () => "No gridOptions provided to createGrid",
  12: ({ colKey: e }) => ["column ", e, " not found"],
  13: () => "Could not find rowIndex, this means tasks are being executed on a rowNode that has been removed from the grid.",
  14: ({ groupPrefix: e }) => `Row IDs cannot start with ${e}, this is a reserved prefix for AG Grid's row grouping feature.`,
  15: ({ expression: e }) => ["value should be either a string or a function", e],
  16: ({ expression: e, params: t, e: s }) => [
    "Processing of the expression failed",
    "Expression = ",
    e,
    "Params = ",
    t,
    "Exception = ",
    s
  ],
  17: () => "you need either field or valueSetter set on colDef for editing to work",
  18: () => "alignedGrids contains an undefined option.",
  19: () => "alignedGrids - No api found on the linked grid.",
  20: () => `You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`,
  21: () => "pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.",
  22: ({ key: e }) => `${e} is an initial property and cannot be updated.`,
  23: () => "The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.",
  24: () => "row height must be a number if not using standard row model",
  25: ({ id: e }) => ["The getRowId callback must return a string. The ID ", e, " is being cast to a string."],
  26: ({ fnName: e, preDestroyLink: t }) => `Grid API function ${e}() cannot be called as the grid has been destroyed.
 Either clear local references to the grid api, when it is destroyed, or check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
 To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${t}`,
  27: ({ fnName: e, module: t }) => `API function '${e}' not registered to module '${t}'`,
  28: () => "setRowCount cannot be used while using row grouping.",
  29: () => "tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?",
  30: ({ toIndex: e }) => [
    "tried to insert columns in invalid location, toIndex = ",
    e,
    "remember that you should not count the moving columns when calculating the new index"
  ],
  31: () => "infinite loop in resizeColumnSets",
  32: () => "applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.",
  33: () => "stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.",
  34: ({ key: e }) => `the column type '${e}' is a default column type and cannot be overridden.`,
  35: () => "Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.",
  36: ({ t: e }) => "colDef.type '" + e + "' does not correspond to defined gridOptions.columnTypes",
  37: () => "Changing the column pinning status is not allowed with domLayout='print'",
  38: ({ iconName: e }) => `provided icon '${e}' needs to be a string or a function`,
  39: () => "Applying column order broke a group where columns should be married together. Applying new order has been discarded.",
  40: ({ e, method: t }) => `${e}
${A0(t)}`,
  41: () => "Browser did not allow document.execCommand('copy'). Ensure 'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise the browser will prevent it for security reasons.",
  42: () => "Browser does not support document.execCommand('copy') for clipboard operations",
  43: ({ iconName: e }) => `As of v33, icon '${e}' is deprecated. Use the icon CSS name instead.`,
  44: () => 'Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.',
  45: ({ parentCellDataType: e }) => `The data type definition ${e} does not exist.`,
  46: () => 'The "baseDataType" property of a data type definition must match that of its parent.',
  47: ({ cellDataType: e }) => `Missing data type definition - "${e}"`,
  48: ({ property: e }) => `Cell data type is "object" but no Value ${e} has been provided. Please either provide an object data type definition with a Value ${e}, or set "colDef.value${e}"`,
  49: ({ methodName: e }) => `Framework component is missing the method ${e}()`,
  50: ({ compName: e }) => `Could not find component ${e}, did you forget to configure this component?`,
  51: () => "Export cancelled. Export is not allowed as per your configuration.",
  52: () => "There is no `window` associated with the current `document`",
  53: () => "unknown value type during csv conversion",
  54: () => "Could not find document body, it is needed for drag and drop and context menu.",
  55: () => "addRowDropZone - A container target needs to be provided",
  56: () => "addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.",
  57: () => "unable to show popup filter, filter instantiation failed",
  58: () => "no values found for select cellEditor",
  59: () => "cannot select pinned rows",
  60: () => "cannot select node until it has finished loading",
  61: () => "since version v32.2.0, rowNode.isFullWidthCell() has been deprecated. Instead check `rowNode.detail` followed by the user provided `isFullWidthRow` grid option.",
  62: ({ colId: e }) => `setFilterModel() - no column found for colId: ${e}`,
  63: ({ colId: e }) => `setFilterModel() - unable to fully apply model, filtering disabled for colId: ${e}`,
  64: ({ colId: e }) => `setFilterModel() - unable to fully apply model, unable to create filter for colId: ${e}`,
  65: () => "filter missing setModel method, which is needed for setFilterModel",
  66: () => "filter API missing getModel method, which is needed for getFilterModel",
  67: () => "Filter is missing isFilterActive() method",
  68: () => "Column Filter API methods have been disabled as Advanced Filters are enabled.",
  69: ({ guiFromFilter: e }) => `getGui method from filter returned ${e}; it should be a DOM element.`,
  70: ({ newFilter: e }) => `Grid option quickFilterText only supports string inputs, received: ${typeof e}`,
  71: () => "debounceMs is ignored when apply button is present",
  72: ({ keys: e }) => ["ignoring FilterOptionDef as it doesn't contain one of ", e],
  73: () => "invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'",
  74: () => "no filter options for filter",
  75: () => "Unknown button type specified",
  76: ({ filterModelType: e }) => [
    'Unexpected type of filter "',
    e,
    '", it looks like the filter was configured with incorrect Filter Options'
  ],
  77: () => "Filter model is missing 'conditions'",
  78: () => 'Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.',
  79: () => '"filterParams.maxNumConditions" must be greater than or equal to zero.',
  80: () => '"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.',
  81: () => '"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".',
  82: ({ param: e }) => `DateFilter ${e} is not a number`,
  83: () => "DateFilter minValidYear should be <= maxValidYear",
  84: () => "DateFilter minValidDate should be <= maxValidDate",
  85: () => "DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.",
  86: () => "DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.",
  87: () => "DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.",
  88: ({ index: e }) => `Invalid row index for ensureIndexVisible: ${e}`,
  89: () => "A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)",
  90: () => "datasource is missing getRows method",
  91: () => "Filter is missing method doesFilterPass",
  92: ({ methodName: e }) => `AnimationFrameService.${e} called but animation frames are off`,
  93: () => "cannot add multiple ranges when `cellSelection.suppressMultiRanges = true`",
  94: ({
    paginationPageSizeOption: e,
    pageSizeSet: t,
    pageSizesSet: s,
    pageSizeOptions: i
  }) => `'paginationPageSize=${e}'${t ? "" : " (default value)"}, but ${e} is not included in${s ? "" : " the default"} paginationPageSizeSelector=[${i.join(", ")}].`,
  95: ({
    paginationPageSizeOption: e,
    paginationPageSizeSelector: t
  }) => `Either set '${t}' to an array that includes ${e} or to 'false' to disable the page size selector.`,
  96: ({ id: e, data: t }) => [
    "Duplicate ID",
    e,
    "found for pinned row with data",
    t,
    "When `getRowId` is defined, it must return unique IDs for all pinned rows. Use the `rowPinned` parameter."
  ],
  97: ({ colId: e }) => `cellEditor for column ${e} is missing getGui() method`,
  98: () => "popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.",
  99: () => "Since v32, `api.hideOverlay()` does not hide the loading overlay when `loading=true`. Set `loading=false` instead.",
  100: ({ rowModelType: e }) => `selectAll only available when rowModelType='clientSide', ie not ${e}`,
  101: ({
    propertyName: e,
    componentName: t,
    agGridDefaults: s,
    jsComps: i
  }) => {
    const r = [], n = [
      // Don't include the old names / internals in potential suggestions
      ...Object.keys(s).filter(
        (a) => !["agCellEditor", "agGroupRowRenderer", "agSortIndicator"].includes(a)
      ),
      ...Object.keys(i)
    ], o = Rc({
      inputValue: t,
      allSuggestions: n,
      hideIrrelevant: !0,
      filterByPercentageOfBestMatch: 0.8
    }).values;
    return r.push(
      `Could not find '${t}' component. It was configured as "${e}: '${t}'" but it wasn't found in the list of registered components.
`
    ), o.length > 0 && r.push(`         Did you mean: [${o.slice(0, 3)}]?
`), r.push("If using a custom component check it has been registered correctly."), r;
  },
  102: () => "selecting just filtered only works when gridOptions.rowModelType='clientSide'",
  103: () => "Invalid selection state. When using client-side row model, the state must conform to `string[]`.",
  104: ({ value: e, param: t }) => `Numeric value ${e} passed to ${t} param will be interpreted as ${e} seconds. If this is intentional use "${e}s" to silence this warning.`,
  105: ({ e }) => ["chart rendering failed", e],
  106: () => `Theming API and Legacy Themes are both used in the same page. A Theming API theme has been provided to the 'theme' grid option, but the file (ag-grid.css) is also included and will cause styling issues. Remove ag-grid.css from the page. See the migration guide: ${qn}/theming-migration/`,
  107: ({ key: e, value: t }) => `Invalid value for theme param ${e} - ${t}`,
  108: ({ e }) => ["chart update failed", e],
  109: ({ aggFuncOrString: e }) => `unrecognised aggregation function ${e}`,
  110: () => "groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup",
  111: () => "Invalid selection state. When `groupSelectsChildren` is enabled, the state must conform to `IServerSideGroupSelectionState`.",
  113: () => "Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values",
  114: ({ component: e }) => `Could not find component with name of ${e}. Is it in Vue.components?`,
  115: () => "The provided selection state should be an object.",
  116: () => "Invalid selection state. The state must conform to `IServerSideSelectionState`.",
  117: () => "selectAll must be of boolean type.",
  118: () => "Infinite scrolling must be enabled in order to set the row count.",
  119: () => "Unable to instantiate filter",
  120: () => "MultiFloatingFilterComp expects MultiFilter as its parent",
  121: () => "a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (see AG Grid docs) or b) to toString() on the object to return a key",
  122: () => "could not find the document, document is empty",
  123: () => "Advanced Filter is only supported with the Client-Side Row Model or Server-Side Row Model.",
  124: () => "No active charts to update.",
  125: ({ chartId: e }) => `Unable to update chart. No active chart found with ID: ${e}.`,
  126: () => "unable to restore chart as no chart model is provided",
  127: ({ allRange: e }) => `unable to create chart as ${e ? "there are no columns in the grid" : "no range is selected"}.`,
  128: ({ feature: e }) => `${e} is only available if using 'multiRow' selection mode.`,
  129: ({ feature: e, rowModel: t }) => `${e} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${t}.`,
  130: () => 'cannot multi select unless selection mode is "multiRow"',
  131: () => "cannot range select while selecting multiple rows",
  132: () => "Row selection features are not available unless `rowSelection` is enabled.",
  133: ({ iconName: e }) => `icon '${e}' function should return back a string or a dom object`,
  134: ({ iconName: e }) => `Did not find icon '${e}'`,
  135: () => "Data type of the new value does not match the cell data type of the column",
  136: () => "Unable to update chart as the 'type' is missing. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.",
  137: ({ type: e, currentChartType: t }) => `Unable to update chart as a '${e}' update type is not permitted on a ${t}.`,
  138: ({ chartType: e }) => `invalid chart type supplied: ${e}`,
  139: ({ customThemeName: e }) => `a custom chart theme with the name ${e} has been supplied but not added to the 'chartThemes' list`,
  140: ({ name: e }) => `no stock theme exists with the name '${e}' and no custom chart theme with that name was supplied to 'customChartThemes'`,
  141: () => "cross filtering with row grouping is not supported.",
  142: () => "cross filtering is only supported in the client side row model.",
  143: ({ panel: e }) => `'${e}' is not a valid Chart Tool Panel name`,
  144: ({ type: e }) => `Invalid charts data panel group name supplied: '${e}'`,
  145: ({ group: e }) => `As of v32, only one charts customize panel group can be expanded at a time. '${e}' will not be expanded.`,
  146: ({ comp: e }) => `Unable to instantiate component '${e}' as its module hasn't been loaded. Add 'ValidationModule' to see which module is required.`,
  147: ({ group: e }) => `Invalid charts customize panel group name supplied: '${e}'`,
  148: ({ group: e }) => `invalid chartGroupsDef config '${e}'`,
  149: ({ group: e, chartType: t }) => `invalid chartGroupsDef config '${e}.${t}'`,
  150: () => "'seriesChartTypes' are required when the 'customCombo' chart type is specified.",
  151: ({ chartType: e }) => `invalid chartType '${e}' supplied in 'seriesChartTypes', converting to 'line' instead.`,
  152: ({ colId: e }) => `no 'seriesChartType' found for colId = '${e}', defaulting to 'line'.`,
  153: ({ chartDataType: e }) => `unexpected chartDataType value '${e}' supplied, instead use 'category', 'series' or 'excluded'`,
  154: ({ colId: e }) => `cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' to be defined on the column with id: ${e}`,
  155: ({ option: e }) => `'${e}' is not a valid Chart Toolbar Option`,
  156: ({ panel: e }) => `Invalid panel in chartToolPanelsDef.panels: '${e}'`,
  157: ({ unrecognisedGroupIds: e }) => ["unable to find group(s) for supplied groupIds:", e],
  158: () => "can not expand a column item that does not represent a column group header",
  159: () => "Invalid params supplied to createExcelFileForExcel() - `ExcelExportParams.data` is empty.",
  160: () => "Export cancelled. Export is not allowed as per your configuration.",
  161: () => "The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'",
  162: ({ id: e, dataType: t }) => `Unrecognized data type for excel export [${e}.dataType=${t}]`,
  163: ({ featureName: e }) => `Excel table export does not work with ${e}. The exported Excel file will not contain any Excel tables.
 Please turn off ${e} to enable Excel table exports.`,
  164: () => "Unable to add data table to Excel sheet: A table already exists.",
  165: () => "Unable to add data table to Excel sheet: Missing required parameters.",
  166: ({ unrecognisedGroupIds: e }) => ["unable to find groups for these supplied groupIds:", e],
  167: ({ unrecognisedColIds: e }) => ["unable to find columns for these supplied colIds:", e],
  168: () => "detailCellRendererParams.template should be function or string",
  169: () => 'Reference to eDetailGrid was missing from the details template. Please add data-ref="eDetailGrid" to the template.',
  170: ({ providedStrategy: e }) => `invalid cellRendererParams.refreshStrategy = ${e} supplied, defaulting to refreshStrategy = 'rows'.`,
  171: () => "could not find detail grid options for master detail, please set gridOptions.detailCellRendererParams.detailGridOptions",
  172: () => "could not find getDetailRowData for master / detail, please set gridOptions.detailCellRendererParams.getDetailRowData",
  173: ({ group: e }) => `invalid chartGroupsDef config '${e}'`,
  174: ({ group: e, chartType: t }) => `invalid chartGroupsDef config '${e}.${t}'`,
  175: ({ menuTabName: e, itemsToConsider: t }) => [
    `Trying to render an invalid menu item '${e}'. Check that your 'menuTabs' contains one of `,
    t
  ],
  176: ({ key: e }) => `unknown menu item type ${e}`,
  177: () => "valid values for fillHandleDirection are 'x', 'y' and 'xy'. Default to 'xy'.",
  178: ({ colId: e }) => `column ${e} is not visible`,
  179: () => "totalValueGetter should be either a function or a string (expression)",
  180: () => "agRichSelectCellEditor requires cellEditorParams.values to be set",
  181: () => "agRichSelectCellEditor cannot have `multiSelect` and `allowTyping` set to `true`. AllowTyping has been turned off.",
  182: () => 'you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data',
  183: () => "Group Column Filter only works on group columns. Please use a different filter.",
  184: ({ parentGroupData: e, childNodeData: t }) => ["duplicate group keys for row data, keys should be unique", [e, t]],
  185: ({ data: e }) => ["getDataPath() should not return an empty path", [e]],
  186: ({
    rowId: e,
    rowData: t,
    duplicateRowsData: s
  }) => ["duplicate group keys for row data, keys should be unique", e, t, ...s],
  187: ({ rowId: e, firstData: t, secondData: s }) => [
    `Duplicate node id ${e}. Row IDs are provided via the getRowId() callback. Please modify the getRowId() callback code to provide unique row id values.`,
    "first instance",
    t,
    "second instance",
    s
  ],
  188: () => "getRowId callback must be provided for Server Side Row Model selection to work correctly.",
  189: ({ startRow: e }) => `invalid value ${e} for startRow, the value should be >= 0`,
  190: ({ rowGroupId: e, data: t }) => [
    "null and undefined values are not allowed for server side row model keys",
    e ? `column = ${e}` : "",
    "data is ",
    t
  ],
  191: () => "cannot multi select unless selection mode is 'multiRow'",
  192: () => "cannot use range selection when multi selecting rows",
  193: () => "cannot multi select unless selection mode is 'multiRow'",
  194: ({ method: e }) => `calling gridApi.${e}() is only possible when using rowModelType=\`clientSide\`.`,
  195: ({ justCurrentPage: e }) => `selecting just ${e ? "current page" : "filtered"} only works when gridOptions.rowModelType='clientSide'`,
  196: ({ key: e }) => `Provided ids must be of string type. Invalid id provided: ${e}`,
  197: () => "`toggledNodes` must be an array of string ids.",
  198: () => "cannot multi select unless selection mode is 'multiRow'",
  199: () => "getSelectedNodes and getSelectedRows functions cannot be used with select all functionality with the server-side row model. Use `api.getServerSideSelectionState()` instead.",
  200: pf,
  201: ({ rowModelType: e }) => `Could not find row model for rowModelType = ${e}`,
  202: () => "`getSelectedNodes` and `getSelectedRows` functions cannot be used with `groupSelectsChildren` and the server-side row model. Use `api.getServerSideSelectionState()` instead.",
  203: () => "Server Side Row Model does not support Dynamic Row Height and Cache Purging. Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.",
  204: () => "Server Side Row Model does not support Auto Row Height and Cache Purging. Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.",
  205: ({ duplicateIdText: e }) => `Unable to display rows as duplicate row ids (${e}) were returned by the getRowId callback. Please modify the getRowId callback to provide unique ids.`,
  206: () => "getRowId callback must be implemented for transactions to work. Transaction was ignored.",
  207: () => 'The Set Filter Parameter "defaultToNothingSelected" value was ignored because it does not work when "excelMode" is used.',
  208: () => "Set Filter Value Formatter must return string values. Please ensure the Set Filter Value Formatter returns string values for complex objects.",
  209: () => `Set Filter Key Creator is returning null for provided values and provided values are primitives. Please provide complex objects. See ${qn}/filter-set-filter-list/#filter-value-types`,
  210: () => "Set Filter has a Key Creator, but provided values are primitives. Did you mean to provide complex objects?",
  211: () => "property treeList=true for Set Filter params, but you did not provide a treeListPathGetter or values of type Date.",
  212: () => "please review all your toolPanel components, it seems like at least one of them doesn't have an id",
  213: () => "Advanced Filter does not work with Filters Tool Panel. Filters Tool Panel has been disabled.",
  214: ({ key: e }) => `unable to lookup Tool Panel as invalid key supplied: ${e}`,
  215: ({ key: e, defaultByKey: t }) => `the key ${e} is not a valid key for specifying a tool panel, valid keys are: ${Object.keys(t).join(",")}`,
  216: ({ name: e }) => `Missing component for '${e}'`,
  217: ({ invalidColIds: e }) => ["unable to find grid columns for the supplied colDef(s):", e],
  218: ({ property: e, defaultOffset: t }) => `${e} must be a number, the value you provided is not a valid number. Using the default of ${t}px.`,
  219: ({ property: e }) => `Property ${e} does not exist on the target object.`,
  220: ({ lineDash: e }) => `'${e}' is not a valid 'lineDash' option.`,
  221: () => "agAggregationComponent should only be used with the client and server side row model.",
  222: () => "agFilteredRowCountComponent should only be used with the client side row model.",
  223: () => "agSelectedRowCountComponent should only be used with the client and server side row model.",
  224: () => "agTotalAndFilteredRowCountComponent should only be used with the client side row model.",
  225: () => "agTotalRowCountComponent should only be used with the client side row model.",
  226: () => "viewport is missing init method.",
  227: () => "menu item icon must be DOM node or string",
  228: ({ menuItemOrString: e }) => `unrecognised menu item ${e}`,
  229: ({ index: e }) => ["invalid row index for ensureIndexVisible: ", e],
  230: () => "detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://ag-grid.com/react-data-grid/master-detail-custom-detail/",
  // @deprecated v32 mark for removal as part of v32 deprecated features
  231: () => "As of v32, using custom components with `reactiveCustomComponents = false` is deprecated.",
  232: () => "Using both rowData and v-model. rowData will be ignored.",
  233: ({ methodName: e }) => `Framework component is missing the method ${e}()`,
  234: () => 'Group Column Filter does not work with the colDef property "field". This property will be ignored.',
  235: () => 'Group Column Filter does not work with the colDef property "filterValueGetter". This property will be ignored.',
  236: () => 'Group Column Filter does not work with the colDef property "filterParams". This property will be ignored.',
  237: () => "Group Column Filter does not work with Tree Data enabled. Please disable Tree Data, or use a different filter.",
  238: () => "setRowCount can only accept a positive row count.",
  239: () => 'Theming API and CSS File Themes are both used in the same page. In v33 we released the Theming API as the new default method of styling the grid. See the migration docs https://www.ag-grid.com/react-data-grid/theming-migration/. Because no value was provided to the `theme` grid option it defaulted to themeQuartz. But the file (ag-grid.css) is also included and will cause styling issues. Either pass the string "legacy" to the theme grid option to use v32 style themes, or remove ag-grid.css from the page to use Theming API.',
  240: ({ theme: e }) => `theme grid option must be a Theming API theme object or the string "legacy", received: ${e}`,
  241: () => "cannot select multiple rows when rowSelection.mode is set to 'singleRow'",
  242: () => "cannot select multiple rows when using rangeSelect",
  243: () => "Failed to deserialize state - each provided state object must be an object.",
  244: () => "Failed to deserialize state - `selectAllChildren` must be a boolean value or undefined.",
  245: () => "Failed to deserialize state - `toggledNodes` must be an array.",
  246: () => "Failed to deserialize state - Every `toggledNode` requires an associated string id.",
  247: () => `Row selection state could not be parsed due to invalid data. Ensure all child state has toggledNodes or does not conform with the parent rule. 
Please rebuild the selection state and reapply it.`,
  248: () => "SetFloatingFilter expects SetFilter as its parent",
  249: () => "Must supply a Value Formatter in Set Filter params when using a Key Creator",
  250: () => "Must supply a Key Creator in Set Filter params when `treeList = true` on a group column, and Tree Data or Row Grouping is enabled.",
  251: ({ chartType: e }) => `AG Grid: Unable to create chart as an invalid chartType = '${e}' was supplied.`,
  252: () => `cannot get grid to draw rows when it is in the middle of drawing rows. 
Your code probably called a grid API method while the grid was in the render stage. 
To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). 
To see what part of your code that caused the refresh check this stacktrace.`,
  253: ({ version: e }) => ["Illegal version string: ", e],
  254: () => "Cannot create chart: no chart themes available.",
  255: ({ point: e }) => `Lone surrogate U+${e.toString(16).toUpperCase()} is not a scalar value`,
  256: () => "Unable to initialise. See validation error, or load ValidationModule if missing.",
  257: () => gf("IntegratedChartsModule"),
  258: () => gf("SparklinesModule"),
  259: ({ part: e }) => `the argument to theme.withPart must be a Theming API part object, received: ${e}`,
  260: ({
    propName: e,
    compName: t,
    gridScoped: s,
    gridId: i,
    rowModelType: r
  }) => pf({
    reasonOrId: `AG Grid '${e}' component: ${t}`,
    moduleName: Un[t],
    gridId: i,
    gridScoped: s,
    rowModelType: r
  }),
  261: () => "As of v33, `column.isHovered()` is deprecated. Use `api.isColumnHovered(column)` instead.",
  262: () => 'As of v33, icon key "smallDown" is deprecated. Use "advancedFilterBuilderSelect" for Advanced Filter Builder dropdown, "selectOpen" for Select cell editor and dropdowns (e.g. Integrated Charts menu), "richSelectOpen" for Rich Select cell editor',
  263: () => 'As of v33, icon key "smallLeft" is deprecated. Use "panelDelimiterRtl" for Row Group Panel / Pivot Panel, "subMenuOpenRtl" for sub-menus.',
  264: () => 'As of v33, icon key "smallRight" is deprecated. Use "panelDelimiter" for Row Group Panel / Pivot Panel, "subMenuOpen" for sub-menus'
};
function I0(e, t) {
  const s = M0[e];
  if (!s)
    return [`Missing error text for error id ${e}!`];
  const i = s(t), n = `
See ${fv(e, t)}`;
  return Array.isArray(i) ? i.concat(n) : [i, n];
}
var L0 = {
  1: "Charting Aggregation",
  2: "pivotResultFields",
  3: "setTooltip"
}, k0 = () => ({
  checkboxSelection: { version: "32.2", message: "Use `rowSelection.checkboxes` in `GridOptions` instead." },
  headerCheckboxSelection: {
    version: "32.2",
    message: "Use `rowSelection.headerCheckbox = true` in `GridOptions` instead."
  },
  headerCheckboxSelectionFilteredOnly: {
    version: "32.2",
    message: 'Use `rowSelection.selectAll = "filtered"` in `GridOptions` instead.'
  },
  headerCheckboxSelectionCurrentPageOnly: {
    version: "32.2",
    message: 'Use `rowSelection.selectAll = "currentPage"` in `GridOptions` instead.'
  },
  showDisabledCheckboxes: {
    version: "32.2",
    message: "Use `rowSelection.hideDisabledCheckboxes = true` in `GridOptions` instead."
  }
}), O0 = () => ({
  aggFunc: { module: "SharedAggregation" },
  autoHeight: {
    supportedRowModels: ["clientSide", "serverSide"],
    module: "RowAutoHeight"
  },
  cellClass: { module: "CellStyle" },
  cellClassRules: { module: "CellStyle" },
  cellEditor: ({ cellEditor: e, editable: t }) => {
    if (!t)
      return null;
    if (typeof e == "string") {
      const s = Un[e];
      if (s)
        return { module: s };
    }
    return { module: "CustomEditor" };
  },
  cellRenderer: ({ cellRenderer: e }) => {
    if (typeof e != "string")
      return null;
    const t = Un[e];
    return t ? { module: t } : null;
  },
  cellRendererParams: {
    validate: (e) => (e.rowGroup != null || e.rowGroupIndex != null || e.cellRenderer === "agGroupCellRenderer") && "checkbox" in e.cellRendererParams ? 'Since v33.0, `cellRendererParams.checkbox` has been deprecated. Use `rowSelection.checkboxLocation = "autoGroupColumn"` instead.' : null
  },
  cellStyle: { module: "CellStyle" },
  children: () => yy(),
  columnChooserParams: {
    module: "ColumnMenu"
  },
  contextMenuItems: { module: "ContextMenu" },
  dndSource: { module: "DragAndDrop" },
  dndSourceOnRowDrag: { module: "DragAndDrop" },
  editable: ({ editable: e, cellEditor: t }) => e && !t ? {
    module: "TextEditor"
  } : null,
  enableCellChangeFlash: { module: "HighlightChanges" },
  enablePivot: { module: "SharedPivot" },
  enableRowGroup: { module: "SharedRowGrouping" },
  enableValue: { module: "SharedAggregation" },
  filter: ({ filter: e }) => {
    if (e && typeof e != "string" && typeof e != "boolean")
      return { module: "CustomFilter" };
    if (typeof e == "string") {
      const t = Un[e];
      if (t)
        return { module: t };
    }
    return { module: "ColumnFilter" };
  },
  floatingFilter: { module: "ColumnFilter" },
  headerCheckboxSelection: {
    supportedRowModels: ["clientSide", "serverSide"],
    validate: (e, { rowSelection: t }) => t === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
  },
  headerCheckboxSelectionCurrentPageOnly: {
    supportedRowModels: ["clientSide"],
    validate: (e, { rowSelection: t }) => t === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
  },
  headerCheckboxSelectionFilteredOnly: {
    supportedRowModels: ["clientSide"],
    validate: (e, { rowSelection: t }) => t === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
  },
  headerTooltip: { module: "Tooltip" },
  headerValueGetter: {
    validate: (e) => {
      const t = e.headerValueGetter;
      return typeof t == "function" || typeof t == "string" ? null : "headerValueGetter must be a function or a valid string expression";
    }
  },
  icons: {
    validate: ({ icons: e }) => {
      if (e) {
        if (e.smallDown)
          return Ws(262);
        if (e.smallLeft)
          return Ws(263);
        if (e.smallRight)
          return Ws(264);
      }
      return null;
    }
  },
  mainMenuItems: { module: "ColumnMenu" },
  menuTabs: (e) => {
    var s;
    const t = ["columnsMenuTab", "generalMenuTab"];
    return (s = e.menuTabs) != null && s.some((i) => t.includes(i)) ? {
      module: "ColumnMenu"
    } : null;
  },
  pivot: { module: "SharedPivot" },
  pivotIndex: { module: "SharedPivot" },
  rowDrag: { module: "RowDrag" },
  rowGroup: { module: "SharedRowGrouping" },
  rowGroupIndex: { module: "SharedRowGrouping" },
  sortingOrder: {
    validate: (e) => {
      const t = e.sortingOrder;
      if (Array.isArray(t) && t.length > 0) {
        const s = t.filter((i) => !la.includes(i));
        if (s.length > 0)
          return `sortingOrder must be an array with elements from [${la.map(Fl).join()}], currently it includes [${s.map(Fl).join()}]`;
      } else if (!Array.isArray(t) || t.length <= 0)
        return `sortingOrder must be an array with at least one element, currently it's ${t}`;
      return null;
    }
  },
  tooltipField: { module: "Tooltip" },
  tooltipValueGetter: { module: "Tooltip" },
  type: {
    validate: (e) => {
      const t = e.type;
      return t instanceof Array ? t.some((i) => typeof i != "string") ? "if colDef.type is supplied an array it should be of type 'string[]'" : null : typeof t == "string" ? null : "colDef.type should be of type 'string' | 'string[]'";
    }
  },
  rowSpan: {
    validate: (e, { suppressRowTransform: t }) => t ? null : "colDef.rowSpan requires suppressRowTransform to be enabled."
  }
}), G0 = {
  headerName: void 0,
  columnGroupShow: void 0,
  headerClass: void 0,
  toolPanelClass: void 0,
  headerValueGetter: void 0,
  pivotKeys: void 0,
  groupId: void 0,
  colId: void 0,
  sort: void 0,
  initialSort: void 0,
  field: void 0,
  type: void 0,
  cellDataType: void 0,
  tooltipComponent: void 0,
  tooltipField: void 0,
  headerTooltip: void 0,
  cellClass: void 0,
  showRowGroup: void 0,
  filter: void 0,
  initialAggFunc: void 0,
  defaultAggFunc: void 0,
  aggFunc: void 0,
  pinned: void 0,
  initialPinned: void 0,
  chartDataType: void 0,
  cellAriaRole: void 0,
  cellEditorPopupPosition: void 0,
  headerGroupComponent: void 0,
  headerGroupComponentParams: void 0,
  cellStyle: void 0,
  cellRenderer: void 0,
  cellRendererParams: void 0,
  cellEditor: void 0,
  cellEditorParams: void 0,
  filterParams: void 0,
  pivotValueColumn: void 0,
  headerComponent: void 0,
  headerComponentParams: void 0,
  floatingFilterComponent: void 0,
  floatingFilterComponentParams: void 0,
  tooltipComponentParams: void 0,
  refData: void 0,
  columnChooserParams: void 0,
  children: void 0,
  sortingOrder: void 0,
  allowedAggFuncs: void 0,
  menuTabs: void 0,
  pivotTotalColumnIds: void 0,
  cellClassRules: void 0,
  icons: void 0,
  sortIndex: void 0,
  initialSortIndex: void 0,
  flex: void 0,
  initialFlex: void 0,
  width: void 0,
  initialWidth: void 0,
  minWidth: void 0,
  maxWidth: void 0,
  rowGroupIndex: void 0,
  initialRowGroupIndex: void 0,
  pivotIndex: void 0,
  initialPivotIndex: void 0,
  suppressColumnsToolPanel: void 0,
  suppressFiltersToolPanel: void 0,
  openByDefault: void 0,
  marryChildren: void 0,
  suppressStickyLabel: void 0,
  hide: void 0,
  initialHide: void 0,
  rowGroup: void 0,
  initialRowGroup: void 0,
  pivot: void 0,
  initialPivot: void 0,
  checkboxSelection: void 0,
  showDisabledCheckboxes: void 0,
  headerCheckboxSelection: void 0,
  headerCheckboxSelectionFilteredOnly: void 0,
  headerCheckboxSelectionCurrentPageOnly: void 0,
  suppressHeaderMenuButton: void 0,
  suppressMovable: void 0,
  lockPosition: void 0,
  lockVisible: void 0,
  lockPinned: void 0,
  unSortIcon: void 0,
  suppressSizeToFit: void 0,
  suppressAutoSize: void 0,
  enableRowGroup: void 0,
  enablePivot: void 0,
  enableValue: void 0,
  editable: void 0,
  suppressPaste: void 0,
  suppressNavigable: void 0,
  enableCellChangeFlash: void 0,
  rowDrag: void 0,
  dndSource: void 0,
  autoHeight: void 0,
  wrapText: void 0,
  sortable: void 0,
  resizable: void 0,
  singleClickEdit: void 0,
  floatingFilter: void 0,
  cellEditorPopup: void 0,
  suppressFillHandle: void 0,
  wrapHeaderText: void 0,
  autoHeaderHeight: void 0,
  dndSourceOnRowDrag: void 0,
  valueGetter: void 0,
  valueSetter: void 0,
  filterValueGetter: void 0,
  keyCreator: void 0,
  valueFormatter: void 0,
  valueParser: void 0,
  comparator: void 0,
  equals: void 0,
  pivotComparator: void 0,
  suppressKeyboardEvent: void 0,
  suppressHeaderKeyboardEvent: void 0,
  colSpan: void 0,
  rowSpan: void 0,
  getQuickFilterText: void 0,
  onCellValueChanged: void 0,
  onCellClicked: void 0,
  onCellDoubleClicked: void 0,
  onCellContextMenu: void 0,
  rowDragText: void 0,
  tooltipValueGetter: void 0,
  cellRendererSelector: void 0,
  cellEditorSelector: void 0,
  suppressSpanHeaderHeight: void 0,
  useValueFormatterForExport: void 0,
  useValueParserForImport: void 0,
  mainMenuItems: void 0,
  contextMenuItems: void 0,
  suppressFloatingFilterButton: void 0,
  suppressHeaderFilterButton: void 0,
  suppressHeaderContextMenu: void 0,
  loadingCellRenderer: void 0,
  loadingCellRendererParams: void 0,
  loadingCellRendererSelector: void 0,
  context: void 0
}, B0 = () => Object.keys(G0), yy = () => ({
  objectName: "colDef",
  allProperties: B0(),
  docsUrl: "column-properties/",
  deprecations: k0(),
  validations: O0()
}), V0 = () => ({
  suppressLoadingOverlay: { version: "32", message: "Use `loading`=false instead." },
  enableFillHandle: { version: "32.2", message: "Use `cellSelection.handle` instead." },
  enableRangeHandle: { version: "32.2", message: "Use `cellSelection.handle` instead." },
  enableRangeSelection: { version: "32.2", message: "Use `cellSelection = true` instead." },
  suppressMultiRangeSelection: {
    version: "32.2",
    message: "Use `cellSelection.suppressMultiRanges` instead."
  },
  suppressClearOnFillReduction: {
    version: "32.2",
    message: "Use `cellSelection.handle.suppressClearOnFillReduction` instead."
  },
  fillHandleDirection: { version: "32.2", message: "Use `cellSelection.handle.direction` instead." },
  fillOperation: { version: "32.2", message: "Use `cellSelection.handle.setFillValue` instead." },
  suppressRowClickSelection: {
    version: "32.2",
    message: "Use `rowSelection.enableClickSelection` instead."
  },
  suppressRowDeselection: { version: "32.2", message: "Use `rowSelection.enableClickSelection` instead." },
  rowMultiSelectWithClick: {
    version: "32.2",
    message: "Use `rowSelection.enableSelectionWithoutKeys` instead."
  },
  groupSelectsChildren: {
    version: "32.2",
    message: 'Use `rowSelection.groupSelects = "descendants"` instead.'
  },
  groupSelectsFiltered: {
    version: "32.2",
    message: 'Use `rowSelection.groupSelects = "filteredDescendants"` instead.'
  },
  isRowSelectable: { version: "32.2", message: "Use `selectionOptions.isRowSelectable` instead." },
  suppressCopySingleCellRanges: { version: "32.2", message: "Use `rowSelection.copySelectedRows` instead." },
  suppressCopyRowsToClipboard: { version: "32.2", message: "Use `rowSelection.copySelectedRows` instead." },
  onRangeSelectionChanged: { version: "32.2", message: "Use `onCellSelectionChanged` instead." },
  onRangeDeleteStart: { version: "32.2", message: "Use `onCellSelectionDeleteStart` instead." },
  onRangeDeleteEnd: { version: "32.2", message: "Use `onCellSelectionDeleteEnd` instead." },
  suppressBrowserResizeObserver: {
    version: "32.2",
    message: "The grid always uses the browser's ResizeObserver, this grid option has no effect."
  },
  onColumnEverythingChanged: {
    version: "32.2",
    message: "Either use `onDisplayedColumnsChanged` which is fired at the same time, or use one of the more specific column events."
  },
  groupRemoveSingleChildren: {
    version: "33",
    message: "Use `groupHideParentOfSingleChild` instead."
  },
  groupRemoveLowestSingleChildren: {
    version: "33",
    message: 'Use `groupHideParentOfSingleChild: "leafGroupsOnly"` instead.'
  },
  suppressRowGroupHidesColumns: {
    version: "33",
    message: 'Use `suppressGroupChangesColumnVisibility: "suppressHideOnGroup"` instead.'
  },
  suppressMakeColumnVisibleAfterUnGroup: {
    version: "33",
    message: 'Use `suppressGroupChangesColumnVisibility: "suppressShowOnUngroup"` instead.'
  },
  unSortIcon: { version: "33", message: "Use `defaultColDef.unSortIcon` instead." },
  sortingOrder: { version: "33", message: "Use `defaultColDef.sortingOrder` instead." },
  suppressPropertyNamesCheck: {
    version: "33",
    message: "`gridOptions` and `columnDefs` both have a `context` property that should be used for arbitrary user data. This means that column definitions and gridOptions should only contain valid properties making this property redundant."
  }
});
function vi(e, t, s, i = Number.MAX_VALUE) {
  return typeof t == "number" || t == null ? t == null || t >= s && t <= i ? null : i === Number.MAX_VALUE ? `${e}: value should be greater than or equal to ${s}` : `${e}: value should be between ${s} and ${i}` : `${e}: value should be a number`;
}
var N0 = () => {
  const e = {
    alignedGrids: { module: "AlignedGrids" },
    allowContextMenuWithControlKey: { module: "ContextMenu" },
    autoSizePadding: {
      validate({ autoSizePadding: s }) {
        return vi("autoSizePadding", s, 0);
      }
    },
    autoSizeStrategy: { module: "ColumnAutoSize" },
    cacheBlockSize: {
      supportedRowModels: ["serverSide", "infinite"],
      validate({ cacheBlockSize: s }) {
        return vi("cacheBlockSize", s, 1);
      }
    },
    cacheOverflowSize: {
      validate({ cacheOverflowSize: s }) {
        return vi("cacheOverflowSize", s, 1);
      }
    },
    cellSelection: {
      module: "CellSelection"
    },
    columnHoverHighlight: { module: "ColumnHover" },
    datasource: {
      supportedRowModels: ["infinite"],
      module: "InfiniteRowModel"
    },
    doesExternalFilterPass: { module: "ExternalFilter" },
    domLayout: {
      validate: (s) => {
        const i = s.domLayout, r = ["autoHeight", "normal", "print"];
        return i && !r.includes(i) ? `domLayout must be one of [${r.join()}], currently it's ${i}` : null;
      }
    },
    editType: {
      module: "EditCore"
    },
    enableAdvancedFilter: { module: "AdvancedFilter" },
    enableCharts: { module: "IntegratedCharts" },
    enableFillHandle: {
      dependencies: {
        enableRangeSelection: { required: [!0] }
      }
    },
    enableRangeHandle: {
      dependencies: {
        enableRangeSelection: { required: [!0] }
      }
    },
    enableRangeSelection: {
      module: "CellSelection",
      dependencies: {
        rowDragEntireRow: { required: [!1, void 0] }
      }
    },
    getContextMenuItems: { module: "ContextMenu" },
    getLocaleText: { module: "Locale" },
    getMainMenuItems: { module: "ColumnMenu" },
    getRowClass: { module: "RowStyle" },
    getRowStyle: { module: "RowStyle" },
    grandTotalRow: { module: "SharedRowGrouping" },
    groupDefaultExpanded: {
      supportedRowModels: ["clientSide"]
    },
    groupHideOpenParents: {
      supportedRowModels: ["clientSide", "serverSide"],
      dependencies: {
        groupTotalRow: { required: [void 0, "bottom"] },
        treeData: {
          required: [void 0, !1],
          reason: "Tree Data has values at the group level so it doesn't make sense to hide them."
        }
      }
    },
    groupHideParentOfSingleChild: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] }
      }
    },
    groupRemoveLowestSingleChildren: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] },
        groupRemoveSingleChildren: { required: [void 0, !1] }
      }
    },
    groupRemoveSingleChildren: {
      dependencies: {
        groupHideOpenParents: { required: [void 0, !1] },
        groupRemoveLowestSingleChildren: { required: [void 0, !1] }
      }
    },
    groupSelectsChildren: {
      dependencies: {
        rowSelection: { required: ["multiple"] }
      }
    },
    icons: {
      validate: ({ icons: s }) => {
        if (s) {
          if (s.smallDown)
            return Ws(262);
          if (s.smallLeft)
            return Ws(263);
          if (s.smallRight)
            return Ws(264);
        }
        return null;
      }
    },
    infiniteInitialRowCount: {
      validate({ infiniteInitialRowCount: s }) {
        return vi("infiniteInitialRowCount", s, 1);
      }
    },
    initialGroupOrderComparator: {
      supportedRowModels: ["clientSide"]
    },
    initialState: { module: "GridState" },
    isExternalFilterPresent: { module: "ExternalFilter" },
    keepDetailRowsCount: {
      validate({ keepDetailRowsCount: s }) {
        return vi("keepDetailRowsCount", s, 1);
      }
    },
    localeText: {
      module: "Locale"
    },
    masterDetail: { module: "SharedMasterDetail" },
    pagination: { module: "Pagination" },
    paginationPageSize: {
      validate({ paginationPageSize: s }) {
        return vi("paginationPageSize", s, 1);
      }
    },
    paginationPageSizeSelector: {
      validate: (s) => {
        const i = s.paginationPageSizeSelector;
        return typeof i == "boolean" || i == null || i.length ? null : `'paginationPageSizeSelector' cannot be an empty array.
                    If you want to hide the page size selector, set paginationPageSizeSelector to false.`;
      }
    },
    pinnedTopRowData: {
      module: "PinnedRow"
    },
    pinnedBottomRowData: {
      module: "PinnedRow"
    },
    pivotMode: {
      dependencies: {
        treeData: {
          required: [!1, void 0],
          reason: "Pivot Mode is not supported with Tree Data."
        }
      },
      module: "SharedPivot"
    },
    pivotPanelShow: { module: "RowGroupingPanel" },
    quickFilterText: {
      supportedRowModels: ["clientSide"],
      module: "QuickFilter"
    },
    rowBuffer: {
      validate({ rowBuffer: s }) {
        return vi("rowBuffer", s, 0);
      }
    },
    rowClass: {
      validate: (s) => typeof s.rowClass == "function" ? "rowClass should not be a function, please use getRowClass instead" : null,
      module: "RowStyle"
    },
    rowClassRules: { module: "RowStyle" },
    rowData: {
      supportedRowModels: ["clientSide"],
      module: "ClientSideRowModel"
    },
    rowDragManaged: {
      supportedRowModels: ["clientSide"],
      dependencies: {
        treeData: {
          required: [!1, void 0]
        },
        pagination: {
          required: [!1, void 0]
        }
      },
      module: "RowDrag"
    },
    rowGroupPanelShow: { module: "RowGroupingPanel" },
    rowSelection: {
      validate({ rowSelection: s }) {
        return s && typeof s == "string" ? 'As of version 32.2.1, using `rowSelection` with the values "single" or "multiple" has been deprecated. Use the object value instead.' : s && typeof s != "object" ? "Expected `RowSelectionOptions` object for the `rowSelection` property." : s && s.mode !== "multiRow" && s.mode !== "singleRow" ? `Selection mode "${s.mode}" is invalid. Use one of 'singleRow' or 'multiRow'.` : null;
      },
      module: "SharedRowSelection"
    },
    rowStyle: {
      validate: (s) => {
        const i = s.rowStyle;
        return i && typeof i == "function" ? "rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead" : null;
      },
      module: "RowStyle"
    },
    serverSideDatasource: {
      supportedRowModels: ["serverSide"],
      module: "ServerSideRowModel"
    },
    serverSideInitialRowCount: {
      supportedRowModels: ["serverSide"],
      validate({ serverSideInitialRowCount: s }) {
        return vi("serverSideInitialRowCount", s, 1);
      }
    },
    serverSideOnlyRefreshFilteredGroups: {
      supportedRowModels: ["serverSide"]
    },
    serverSideSortAllLevels: {
      supportedRowModels: ["serverSide"]
    },
    sideBar: { module: "SideBar" },
    sortingOrder: {
      validate: (s) => {
        const i = s.sortingOrder;
        if (Array.isArray(i) && i.length > 0) {
          const r = i.filter((n) => !la.includes(n));
          if (r.length > 0)
            return `sortingOrder must be an array with elements from [${la.map(Fl).join()}], currently it includes [${r.map(Fl).join()}]`;
        } else if (!Array.isArray(i) || i.length <= 0)
          return `sortingOrder must be an array with at least one element, currently it's ${i}`;
        return null;
      }
    },
    statusBar: { module: "StatusBar" },
    tooltipHideDelay: {
      validate: (s) => s.tooltipHideDelay && s.tooltipHideDelay < 0 ? "tooltipHideDelay should not be lower than 0" : null
    },
    tooltipShowDelay: {
      validate: (s) => s.tooltipShowDelay && s.tooltipShowDelay < 0 ? "tooltipShowDelay should not be lower than 0" : null
    },
    treeData: {
      supportedRowModels: ["clientSide", "serverSide"],
      module: "SharedTreeData",
      validate: (s) => {
        const i = s.rowModelType ?? "clientSide";
        switch (i) {
          case "clientSide": {
            const r = `treeData requires 'getDataPath' in the ${i} row model.`;
            return s.treeDataChildrenField || s.getDataPath ? null : r;
          }
          case "serverSide": {
            const r = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${i} row model.`;
            return s.isServerSideGroup && s.getServerSideGroupKey ? null : r;
          }
        }
        return null;
      }
    },
    treeDataChildrenField: {
      module: "SharedTreeData"
    },
    undoRedoCellEditing: { module: "UndoRedoEdit" },
    valueCache: { module: "ValueCache" },
    viewportDatasource: {
      supportedRowModels: ["viewport"],
      module: "ViewportRowModel"
    },
    viewportRowModelBufferSize: {
      validate({ viewportRowModelBufferSize: s }) {
        return vi("viewportRowModelBufferSize", s, 0);
      }
    },
    viewportRowModelPageSize: {
      validate({ viewportRowModelPageSize: s }) {
        return vi("viewportRowModelPageSize", s, 1);
      }
    },
    rowDragEntireRow: {
      dependencies: {
        cellSelection: { required: [void 0] }
      }
    }
  }, t = {};
  return Cy.forEach((s) => {
    t[s] = { expectedType: "boolean" };
  }), my.forEach((s) => {
    t[s] = { expectedType: "number" };
  }), bt(t, e), t;
}, H0 = () => ({
  objectName: "gridOptions",
  allProperties: [...m0, ...l0.map((e) => Fv(e))],
  propertyExceptions: ["api", "treeDataChildrenField"],
  docsUrl: "grid-options/",
  deprecations: V0(),
  validations: N0()
}), z0 = {
  expanded: 1,
  contracted: 1,
  "tree-closed": 1,
  "tree-open": 1,
  "tree-indeterminate": 1,
  pin: 1,
  "eye-slash": 1,
  arrows: 1,
  left: 1,
  right: 1,
  group: 1,
  aggregation: 1,
  pivot: 1,
  "not-allowed": 1,
  chart: 1,
  cross: 1,
  cancel: 1,
  tick: 1,
  first: 1,
  previous: 1,
  next: 1,
  last: 1,
  linked: 1,
  unlinked: 1,
  "color-picker": 1,
  loading: 1,
  menu: 1,
  "menu-alt": 1,
  filter: 1,
  columns: 1,
  maximize: 1,
  minimize: 1,
  copy: 1,
  cut: 1,
  paste: 1,
  grip: 1,
  save: 1,
  csv: 1,
  excel: 1,
  "small-down": 1,
  "small-left": 1,
  "small-right": 1,
  "small-up": 1,
  asc: 1,
  desc: 1,
  none: 1,
  up: 1,
  down: 1,
  plus: 1,
  minus: 1,
  settings: 1,
  "checkbox-checked": 1,
  "checkbox-indeterminate": 1,
  "checkbox-unchecked": 1,
  "radio-button-on": 1,
  "radio-button-off": 1,
  eye: 1
}, W0 = {
  chart: "MenuCore",
  cancel: "EnterpriseCore",
  first: "Pagination",
  previous: "Pagination",
  next: "Pagination",
  last: "Pagination",
  linked: "IntegratedCharts",
  loadingMenuItems: "MenuCore",
  unlinked: "IntegratedCharts",
  menu: "ColumnHeaderComp",
  legacyMenu: "ColumnMenu",
  filter: "ColumnFilter",
  filterActive: "ColumnFilter",
  filterTab: "ColumnMenu",
  filtersToolPanel: "FiltersToolPanel",
  columns: ["MenuCore"],
  columnsToolPanel: ["ColumnsToolPanel"],
  maximize: "EnterpriseCore",
  minimize: "EnterpriseCore",
  save: "MenuCore",
  columnGroupOpened: "ColumnGroupHeaderComp",
  columnGroupClosed: "ColumnGroupHeaderComp",
  accordionOpen: "EnterpriseCore",
  accordionClosed: "EnterpriseCore",
  accordionIndeterminate: "EnterpriseCore",
  columnSelectClosed: ["ColumnsToolPanel", "ColumnMenu"],
  columnSelectOpen: ["ColumnsToolPanel", "ColumnMenu"],
  columnSelectIndeterminate: ["ColumnsToolPanel", "ColumnMenu"],
  columnMovePin: "SharedDragAndDrop",
  columnMoveHide: "SharedDragAndDrop",
  columnMoveMove: "SharedDragAndDrop",
  columnMoveLeft: "SharedDragAndDrop",
  columnMoveRight: "SharedDragAndDrop",
  columnMoveGroup: "SharedDragAndDrop",
  columnMoveValue: "SharedDragAndDrop",
  columnMovePivot: "SharedDragAndDrop",
  dropNotAllowed: "SharedDragAndDrop",
  groupContracted: "GroupCellRenderer",
  groupExpanded: "GroupCellRenderer",
  setFilterGroupClosed: "SetFilter",
  setFilterGroupOpen: "SetFilter",
  setFilterGroupIndeterminate: "SetFilter",
  close: "EnterpriseCore",
  check: "MenuItem",
  colorPicker: "CommunityCore",
  groupLoading: "LoadingCellRenderer",
  menuAlt: "ColumnHeaderComp",
  menuPin: "MenuCore",
  menuValue: "MenuCore",
  menuAddRowGroup: ["MenuCore", "ColumnsToolPanel"],
  menuRemoveRowGroup: ["MenuCore", "ColumnsToolPanel"],
  clipboardCopy: "MenuCore",
  clipboardCut: "MenuCore",
  clipboardPaste: "MenuCore",
  pivotPanel: ["ColumnsToolPanel", "RowGroupingPanel"],
  rowGroupPanel: ["ColumnsToolPanel", "RowGroupingPanel"],
  valuePanel: "ColumnsToolPanel",
  columnDrag: "EnterpriseCore",
  rowDrag: ["RowDrag", "DragAndDrop"],
  csvExport: "MenuCore",
  excelExport: "MenuCore",
  smallDown: "CommunityCore",
  selectOpen: "CommunityCore",
  richSelectOpen: "RichSelect",
  richSelectRemove: "RichSelect",
  smallLeft: "CommunityCore",
  smallRight: "CommunityCore",
  subMenuOpen: "MenuItem",
  subMenuOpenRtl: "MenuItem",
  panelDelimiter: "RowGroupingPanel",
  panelDelimiterRtl: "RowGroupingPanel",
  smallUp: "CommunityCore",
  sortAscending: ["MenuCore", "Sort"],
  sortDescending: ["MenuCore", "Sort"],
  sortUnSort: ["MenuCore", "Sort"],
  advancedFilterBuilder: "AdvancedFilter",
  advancedFilterBuilderDrag: "AdvancedFilter",
  advancedFilterBuilderInvalid: "AdvancedFilter",
  advancedFilterBuilderMoveUp: "AdvancedFilter",
  advancedFilterBuilderMoveDown: "AdvancedFilter",
  advancedFilterBuilderAdd: "AdvancedFilter",
  advancedFilterBuilderRemove: "AdvancedFilter",
  advancedFilterBuilderSelectOpen: "AdvancedFilter",
  chartsMenu: "IntegratedCharts",
  chartsMenuEdit: "IntegratedCharts",
  chartsMenuAdvancedSettings: "IntegratedCharts",
  chartsMenuAdd: "IntegratedCharts",
  chartsColorPicker: "IntegratedCharts",
  chartsThemePrevious: "IntegratedCharts",
  chartsThemeNext: "IntegratedCharts",
  chartsDownload: "IntegratedCharts",
  checkboxChecked: "CommunityCore",
  checkboxIndeterminate: "CommunityCore",
  checkboxUnchecked: "CommunityCore",
  radioButtonOn: "CommunityCore",
  radioButtonOff: "CommunityCore"
}, _0 = /* @__PURE__ */ new Set([
  "colorPicker",
  "smallUp",
  "checkboxChecked",
  "checkboxIndeterminate",
  "checkboxUnchecked",
  "radioButtonOn",
  "radioButtonOff",
  "smallDown",
  "smallLeft",
  "smallRight"
]), U0 = {
  pinSubMenu: "PinnedColumn",
  pinLeft: "PinnedColumn",
  pinRight: "PinnedColumn",
  clearPinned: "PinnedColumn",
  valueAggSubMenu: "SharedAggregation",
  autoSizeThis: "ColumnAutoSize",
  autoSizeAll: "ColumnAutoSize",
  rowGroup: "SharedRowGrouping",
  rowUnGroup: "SharedRowGrouping",
  resetColumns: "CommunityCore",
  expandAll: ["ClientSideRowModelHierarchy", "ServerSideRowModel"],
  contractAll: ["ClientSideRowModelHierarchy", "ServerSideRowModel"],
  copy: "Clipboard",
  copyWithHeaders: "Clipboard",
  copyWithGroupHeaders: "Clipboard",
  cut: "Clipboard",
  paste: "Clipboard",
  export: ["CsvExport", "ExcelExport"],
  csvExport: "CsvExport",
  excelExport: "ExcelExport",
  separator: "CommunityCore",
  pivotChart: "IntegratedCharts",
  chartRange: "IntegratedCharts",
  columnFilter: "ColumnFilter",
  columnChooser: "ColumnMenu",
  sortAscending: "Sort",
  sortDescending: "Sort",
  sortUnSort: "Sort"
}, $0 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "validation";
  }
  wireBeans(e) {
    this.gridOptions = e.gridOptions, kP(this);
  }
  postConstruct() {
    this.processGridOptions(this.gridOptions);
  }
  warnOnInitialPropertyUpdate(e, t) {
    e === "api" && b0[t] && I(22, { key: t });
  }
  processGridOptions(e) {
    this.processOptions(e, H0());
  }
  validateApiFunction(e, t) {
    return R0(e, t, this.beans);
  }
  missingUserComponent(e, t, s, i) {
    const r = Un[t];
    r ? this.gos.assertModuleRegistered(
      r,
      `AG Grid '${e}' component: ${t}`
    ) : I(101, {
      propertyName: e,
      componentName: t,
      agGridDefaults: s,
      jsComps: i
    });
  }
  checkRowEvents(e) {
    K0.has(e) && I(10, { eventType: e });
  }
  validateIcon(e) {
    if (_0.has(e) && I(43, { iconName: e }), z0[e])
      return;
    const t = W0[e];
    if (t) {
      be(200, {
        reasonOrId: `icon '${e}'`,
        moduleName: t,
        gridScoped: mh(),
        gridId: this.beans.context.getGridId(),
        rowModelType: this.gos.get("rowModelType"),
        additionalText: "Alternatively, use the CSS icon name directly."
      });
      return;
    }
    I(134, { iconName: e });
  }
  validateMenuItem(e) {
    const t = U0[e];
    t && this.gos.assertModuleRegistered(t, `menu item '${e}'`);
  }
  isProvidedUserComp(e) {
    return !!Un[e];
  }
  validateColDef(e, t, s) {
    var i;
    (s || !((i = this.beans.dataTypeSvc) != null && i.isColPendingInference(t))) && this.processOptions(e, yy());
  }
  processOptions(e, t) {
    const { validations: s, deprecations: i, allProperties: r, propertyExceptions: n, objectName: o, docsUrl: a } = t;
    r && this.gridOptions.suppressPropertyNamesCheck !== !0 && this.checkProperties(
      e,
      [...n ?? [], ...Object.keys(i)],
      r,
      o,
      a
    );
    const l = /* @__PURE__ */ new Set(), c = (u) => {
      const h = s[u];
      if (h)
        if (typeof h == "function") {
          const p = h(e, this.gridOptions, this.beans);
          if (!p)
            return;
          if ("objectName" in p) {
            const g = e[u];
            if (Array.isArray(g)) {
              g.forEach((f) => {
                this.processOptions(f, p);
              });
              return;
            }
            this.processOptions(e[u], p);
            return;
          }
          return p;
        } else
          return h;
      else return;
    };
    Object.keys(e).forEach((u) => {
      const h = i[u];
      if (h) {
        const { message: b, version: x } = h;
        l.add(`As of v${x}, ${String(u)} is deprecated. ${b ?? ""}`);
      }
      const p = e[u];
      if (p == null || p === !1)
        return;
      const g = c(u);
      if (!g)
        return;
      const { module: f, dependencies: m, validate: C, supportedRowModels: w, expectedType: y } = g;
      if (y) {
        const b = typeof p;
        if (b !== y) {
          l.add(
            `${String(u)} should be of type '${y}' but received '${b}' (${p}).`
          );
          return;
        }
      }
      if (w) {
        const b = this.gridOptions.rowModelType ?? "clientSide";
        if (!w.includes(b)) {
          l.add(
            `${String(u)} is not supported with the '${b}' row model. It is only valid with: ${w.join(", ")}.`
          );
          return;
        }
      }
      if (f) {
        const b = Array.isArray(f) ? f : [f];
        let x = !0;
        if (b.forEach((M) => {
          this.gos.assertModuleRegistered(M, String(u)) || (x = !1);
        }), !x)
          return;
      }
      if (m) {
        const b = this.checkForRequiredDependencies(u, m, e);
        if (b) {
          l.add(b);
          return;
        }
      }
      if (C) {
        const b = C(e, this.gridOptions, this.beans);
        if (b) {
          l.add(b);
          return;
        }
      }
    }), l.size > 0 && l.forEach((u) => {
      Si(u);
    });
  }
  checkForRequiredDependencies(e, t, s) {
    const r = Object.entries(t).filter(([n, o]) => {
      const a = s[n];
      return !o.required.includes(a);
    });
    return r.length === 0 ? null : r.map(
      ([n, o]) => `'${String(e)}' requires '${n}' to be one of [${o.required.map((a) => a === null ? "null" : a === void 0 ? "undefined" : a).join(", ")}]. ${o.reason ?? ""}`
    ).join(`
           `);
  }
  checkProperties(e, t, s, i, r) {
    const n = ["__ob__", "__v_skip", "__metadata__"], o = j0(
      Object.getOwnPropertyNames(e),
      [...n, ...t, ...s],
      s
    );
    if (Object.entries(o).forEach(([a, l]) => {
      let c = `invalid ${i} property '${a}' did you mean any of these: ${l.slice(0, 8).join(", ")}.`;
      s.includes("context") && (c += `
If you are trying to annotate ${i} with application data, use the '${i}.context' property instead.`), Si(c);
    }), Object.keys(o).length > 0 && r) {
      const a = this.beans.frameworkOverrides.getDocLink(r);
      Si(`to see all the valid ${i} properties please check: ${a}`);
    }
  }
  getConsoleMessage(e, t) {
    return I0(e, t);
  }
};
function j0(e, t, s) {
  const i = {}, r = e.filter(
    (n) => !t.some((o) => o === n)
  );
  return r.length > 0 && r.forEach(
    (n) => i[n] = Rc({ inputValue: n, allSuggestions: s }).values
  ), i;
}
var K0 = /* @__PURE__ */ new Set([
  "firstChildChanged",
  "lastChildChanged",
  "childIndexChanged"
]), q0 = {
  moduleName: "Validation",
  version: de,
  beans: [$0]
};
function by(e) {
  e.sibling && (e.sibling.childrenAfterFilter = e.childrenAfterFilter);
}
var Y0 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "filterStage", this.refreshProps = /* @__PURE__ */ new Set(["excludeChildrenWhenTreeDataFiltering"]), this.step = "filter";
  }
  wireBeans(e) {
    this.filterManager = e.filterManager;
  }
  execute(e) {
    const { changedPath: t } = e;
    this.filter(t);
  }
  filter(e) {
    var s;
    const t = !!((s = this.filterManager) != null && s.isChildFilterPresent());
    this.filterNodes(t, e);
  }
  filterNodes(e, t) {
    const s = (i, r) => {
      i.hasChildren() && e && !r ? i.childrenAfterFilter = i.childrenAfterGroup.filter((n) => {
        const o = n.childrenAfterFilter && n.childrenAfterFilter.length > 0, a = n.data && this.filterManager.doesRowPassFilter({ rowNode: n });
        return o || a;
      }) : i.childrenAfterFilter = i.childrenAfterGroup, by(i);
    };
    if (this.doingTreeDataFiltering()) {
      const i = (n, o) => {
        if (n.childrenAfterGroup)
          for (let a = 0; a < n.childrenAfterGroup.length; a++) {
            const l = n.childrenAfterGroup[a], c = o || this.filterManager.doesRowPassFilter({ rowNode: l });
            l.childrenAfterGroup ? i(n.childrenAfterGroup[a], c) : s(l, c);
          }
        s(n, o);
      }, r = (n) => i(n, !1);
      t.executeFromRootNode(r);
    } else {
      const i = (r) => s(r, !1);
      t.forEachChangedNodeDepthFirst(i, !0);
    }
  }
  doingTreeDataFiltering() {
    return this.gos.get("treeData") && !this.gos.get("excludeChildrenWhenTreeDataFiltering");
  }
}, X0 = class extends Mh {
  constructor() {
    super(...arguments), this.iconCreated = !1;
  }
  setComp(e, t, s, i, r) {
    this.comp = e;
    const n = pa(this, this.beans.context, r);
    this.eButtonShowMainFilter = s, this.eFloatingFilterBody = i, this.setGui(t, n), this.setupActive(), this.setupWidth(n), this.setupLeft(n), this.setupHover(n), this.setupFocus(n), this.setupAria(), this.setupFilterButton(), this.setupUserComp(), this.setupSyncWithFilter(n), this.setupUi(), n.addManagedElementListeners(this.eButtonShowMainFilter, { click: this.showParentFilter.bind(this) }), this.setupFilterChangedListener(n), n.addManagedListeners(this.column, { colDefChanged: () => this.onColDefChanged(n) }), n.addDestroyFunc(() => {
      this.eButtonShowMainFilter = null, this.eFloatingFilterBody = null, this.userCompDetails = null, this.clearComponent();
    });
  }
  // empty abstract method
  resizeHeader() {
  }
  moveHeader() {
  }
  setupActive() {
    const e = this.column.getColDef(), t = !!e.filter, s = !!e.floatingFilter;
    this.active = t && s;
  }
  setupUi() {
    if (this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton), this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton), !this.active || this.iconCreated)
      return;
    const e = ue("filter", this.beans, this.column);
    e && (this.iconCreated = !0, this.eButtonShowMainFilter.appendChild(e));
  }
  setupFocus(e) {
    e.createManagedBean(
      new Ir(this.eGui, {
        shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this),
        onFocusIn: this.onFocusIn.bind(this)
      })
    );
  }
  setupAria() {
    const e = this.getLocaleTextFunc();
    ot(this.eButtonShowMainFilter, e("ariaFilterMenuOpen", "Open Filter Menu"));
  }
  onTabKeyDown(e) {
    var o;
    const { beans: t } = this;
    if (Ie(t) === this.eGui)
      return;
    const r = zt(t, this.eGui, null, e.shiftKey);
    if (r) {
      (o = t.headerNavigation) == null || o.scrollToColumn(this.column), e.preventDefault(), r.focus();
      return;
    }
    const n = this.findNextColumnWithFloatingFilter(e.shiftKey);
    n && t.focusSvc.focusHeaderPosition({
      headerPosition: {
        headerRowIndex: this.rowCtrl.rowIndex,
        column: n
      },
      event: e
    }) && e.preventDefault();
  }
  findNextColumnWithFloatingFilter(e) {
    const t = this.beans.visibleCols;
    let s = this.column;
    do
      if (s = e ? t.getColBefore(s) : t.getColAfter(s), !s)
        break;
    while (!s.getColDef().filter || !s.getColDef().floatingFilter);
    return s;
  }
  handleKeyDown(e) {
    super.handleKeyDown(e);
    const t = this.getWrapperHasFocus();
    switch (e.key) {
      case P.UP:
      case P.DOWN:
        t || e.preventDefault();
      case P.LEFT:
      case P.RIGHT:
        if (t)
          return;
        e.stopPropagation();
      case P.ENTER:
        t && Dt(this.eGui) && e.preventDefault();
        break;
      case P.ESCAPE:
        t || this.eGui.focus();
    }
  }
  onFocusIn(e) {
    if (this.eGui.contains(e.relatedTarget))
      return;
    const s = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter"), i = !!e.relatedTarget && an(e.relatedTarget, "ag-floating-filter");
    if (s && i && e.target === this.eGui) {
      const r = this.lastFocusEvent, n = !!(r && r.key === P.TAB);
      if (r && n) {
        const o = r.shiftKey;
        Dt(this.eGui, o);
      }
    }
    this.focusThis();
  }
  setupHover(e) {
    var t;
    (t = this.beans.colHover) == null || t.addHeaderFilterColumnHoverListener(e, this.comp, this.column, this.eGui);
  }
  setupLeft(e) {
    const t = new Ah(this.column, this.eGui, this.beans);
    e.createManagedBean(t);
  }
  setupFilterButton() {
    var e;
    this.suppressFilterButton = !((e = this.beans.menuSvc) != null && e.isFloatingFilterButtonEnabled(this.column)), this.highlightFilterButtonWhenActive = !Mt(this.gos);
  }
  setupUserComp() {
    var t;
    if (!this.active)
      return;
    const e = (t = this.beans.filterManager) == null ? void 0 : t.getFloatingFilterCompDetails(
      this.column,
      () => this.showParentFilter()
    );
    e && this.setCompDetails(e);
  }
  setCompDetails(e) {
    this.userCompDetails = e, this.comp.setCompDetails(e);
  }
  showParentFilter() {
    var t;
    const e = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
    (t = this.beans.menuSvc) == null || t.showFilterMenu({
      column: this.column,
      buttonElement: e,
      containerType: "floatingFilter",
      positionBy: "button"
    });
  }
  setupSyncWithFilter(e) {
    if (!this.active)
      return;
    const { filterManager: t } = this.beans, s = (i) => {
      if ((i == null ? void 0 : i.source) === "filterDestroyed" && !this.isAlive())
        return;
      const r = this.comp.getFloatingFilterComp();
      r && r.then((n) => {
        if (n) {
          const o = t == null ? void 0 : t.getCurrentFloatingFilterParentModel(this.column), a = i ? {
            // event can have additional params like `afterDataChange` which need to be passed through
            ...i,
            columns: i.columns ?? [],
            source: i.source === "api" ? "api" : "columnFilter"
          } : null;
          n.onParentModelChanged(o, a);
        }
      });
    };
    [this.destroySyncListener] = e.addManagedListeners(this.column, { filterChanged: s }), t != null && t.isFilterActive(this.column) && s(null);
  }
  setupWidth(e) {
    const t = () => {
      const s = `${this.column.getActualWidth()}px`;
      this.comp.setWidth(s);
    };
    e.addManagedListeners(this.column, { widthChanged: t }), t();
  }
  setupFilterChangedListener(e) {
    this.active && ([this.destroyFilterChangedListener] = e.addManagedListeners(this.column, {
      filterChanged: this.updateFilterButton.bind(this)
    }), this.updateFilterButton());
  }
  updateFilterButton() {
    var e;
    if (!this.suppressFilterButton && this.comp) {
      const t = !!((e = this.beans.filterManager) != null && e.isFilterAllowed(this.column));
      this.comp.setButtonWrapperDisplayed(t), this.highlightFilterButtonWhenActive && t && this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
    }
  }
  onColDefChanged(e) {
    var n;
    const t = this.active;
    this.setupActive();
    const s = !t && this.active;
    t && !this.active && (this.destroySyncListener(), this.destroyFilterChangedListener());
    const i = this.active ? (n = this.beans.filterManager) == null ? void 0 : n.getFloatingFilterCompDetails(this.column, () => this.showParentFilter()) : null, r = this.comp.getFloatingFilterComp();
    !r || !i ? this.updateCompDetails(e, i, s) : r.then((o) => {
      var a;
      !o || (a = this.beans.filterManager) != null && a.areFilterCompsDifferent(this.userCompDetails ?? null, i) ? this.updateCompDetails(e, i, s) : this.updateFloatingFilterParams(i);
    });
  }
  updateCompDetails(e, t, s) {
    this.isAlive() && (this.setCompDetails(t), this.setupFilterButton(), this.setupUi(), s && (this.setupSyncWithFilter(e), this.setupFilterChangedListener(e)));
  }
  updateFloatingFilterParams(e) {
    var s;
    if (!e)
      return;
    const t = e.params;
    (s = this.comp.getFloatingFilterComp()) == null || s.then((i) => {
      i != null && i.refresh && typeof i.refresh == "function" && i.refresh(t);
    });
  }
  addResizeAndMoveKeyboardListeners() {
  }
  destroy() {
    super.destroy(), this.destroySyncListener = null, this.destroyFilterChangedListener = null;
  }
};
function Z0(e, t) {
  var i;
  const s = e.colModel.getCol(t);
  if (!s) {
    be(12, { colKey: t });
    return;
  }
  (i = e.menuSvc) == null || i.showColumnMenu({
    column: s,
    positionBy: "auto"
  });
}
function Q0(e) {
  var t;
  (t = e.menuSvc) == null || t.hidePopupMenu();
}
var Sy = {
  moduleName: "SharedMenu",
  version: de,
  beans: [RD],
  apiFunctions: {
    showColumnMenu: Z0,
    hidePopupMenu: Q0
  }
}, J0 = 0, ek = 200, tk = class extends L {
  constructor() {
    super(...arguments), this.beanName = "popupSvc", this.popupList = [];
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridCtrl = e.gridCtrl;
    }), this.addManagedEventListeners({ gridStylesChanged: this.handleThemeChange.bind(this) });
  }
  getPopupParent() {
    const e = this.gos.get("popupParent");
    return e || this.gridCtrl.getGui();
  }
  positionPopupForMenu(e) {
    const { eventSource: t, ePopup: s } = e, i = this.getPopupIndex(s);
    if (i !== -1) {
      const p = this.popupList[i];
      p.alignedToElement = t;
    }
    const r = t.getBoundingClientRect(), n = this.getParentRect(), o = this.keepXYWithinBounds(
      s,
      r.top - n.top,
      0
      /* vertical */
    ), a = s.clientWidth > 0 ? s.clientWidth : 200;
    s.style.minWidth = `${a}px`;
    const c = n.right - n.left - a;
    let d;
    this.gos.get("enableRtl") ? (d = h(), d < 0 && (d = u(), this.setAlignedStyles(s, "left")), d > c && (d = 0, this.setAlignedStyles(s, "right"))) : (d = u(), d > c && (d = h(), this.setAlignedStyles(s, "right")), d < 0 && (d = 0, this.setAlignedStyles(s, "left"))), s.style.left = `${d}px`, s.style.top = `${o}px`;
    function u() {
      return r.right - n.left - 2;
    }
    function h() {
      return r.left - n.left - a;
    }
  }
  positionPopupUnderMouseEvent(e) {
    const { ePopup: t, nudgeX: s, nudgeY: i, skipObserver: r } = e;
    this.positionPopup({
      ePopup: t,
      nudgeX: s,
      nudgeY: i,
      keepWithinBounds: !0,
      skipObserver: r,
      updatePosition: () => this.calculatePointerAlign(e.mouseEvent),
      postProcessCallback: () => this.callPostProcessPopup(
        e.type,
        e.ePopup,
        null,
        e.mouseEvent,
        e.column,
        e.rowNode
      )
    });
  }
  calculatePointerAlign(e) {
    const t = this.getParentRect();
    return {
      x: e.clientX - t.left,
      y: e.clientY - t.top
    };
  }
  positionPopupByComponent(e) {
    const {
      ePopup: t,
      nudgeX: s,
      nudgeY: i,
      keepWithinBounds: r,
      eventSource: n,
      alignSide: o = "left",
      position: a = "over",
      column: l,
      rowNode: c,
      type: d
    } = e, u = n.getBoundingClientRect(), h = this.getParentRect(), p = this.getPopupIndex(t);
    if (p !== -1) {
      const f = this.popupList[p];
      f.alignedToElement = n;
    }
    const g = () => {
      let f = u.left - h.left;
      o === "right" && (f -= t.offsetWidth - u.width);
      let m;
      return a === "over" ? (m = u.top - h.top, this.setAlignedStyles(t, "over")) : (this.setAlignedStyles(t, "under"), this.shouldRenderUnderOrAbove(t, u, h, e.nudgeY || 0) === "under" ? m = u.top - h.top + u.height : m = u.top - t.offsetHeight - (i || 0) * 2 - h.top), { x: f, y: m };
    };
    this.positionPopup({
      ePopup: t,
      nudgeX: s,
      nudgeY: i,
      keepWithinBounds: r,
      updatePosition: g,
      postProcessCallback: () => this.callPostProcessPopup(d, t, n, null, l, c)
    });
  }
  shouldRenderUnderOrAbove(e, t, s, i) {
    const r = s.bottom - t.bottom, n = t.top - s.top, o = e.offsetHeight + i;
    return r > o ? "under" : n > o || n > r ? "above" : "under";
  }
  setAlignedStyles(e, t) {
    const s = this.getPopupIndex(e);
    if (s === -1)
      return;
    const i = this.popupList[s], { alignedToElement: r } = i;
    !r || (["right", "left", "over", "above", "under"].forEach((o) => {
      r.classList.remove(`ag-has-popup-positioned-${o}`), e.classList.remove(`ag-popup-positioned-${o}`);
    }), !t) || (r.classList.add(`ag-has-popup-positioned-${t}`), e.classList.add(`ag-popup-positioned-${t}`));
  }
  callPostProcessPopup(e, t, s, i, r, n) {
    const o = this.gos.getCallback("postProcessPopup");
    o && o({
      column: r,
      rowNode: n,
      ePopup: t,
      type: e,
      eventSource: s,
      mouseEvent: i
    });
  }
  positionPopup(e) {
    const { ePopup: t, keepWithinBounds: s, nudgeX: i, nudgeY: r, skipObserver: n, updatePosition: o } = e, a = { width: 0, height: 0 }, l = (c = !1) => {
      let { x: d, y: u } = o();
      c && t.clientWidth === a.width && t.clientHeight === a.height || (a.width = t.clientWidth, a.height = t.clientHeight, i && (d += i), r && (u += r), s && (d = this.keepXYWithinBounds(
        t,
        d,
        1
        /* horizontal */
      ), u = this.keepXYWithinBounds(
        t,
        u,
        0
        /* vertical */
      )), t.style.left = `${d}px`, t.style.top = `${u}px`, e.postProcessCallback && e.postProcessCallback());
    };
    if (l(), !n) {
      const c = Ms(this.beans, t, () => l(!0));
      setTimeout(() => c(), ek);
    }
  }
  getActivePopups() {
    return this.popupList.map((e) => e.element);
  }
  getParentRect() {
    const e = We(this.beans);
    let t = this.getPopupParent();
    return t === e.body ? t = e.documentElement : getComputedStyle(t).position === "static" && (t = t.offsetParent), rv(t);
  }
  keepXYWithinBounds(e, t, s) {
    const i = s === 0, r = i ? "clientHeight" : "clientWidth", n = i ? "top" : "left", o = i ? "height" : "width", a = i ? "scrollTop" : "scrollLeft", l = We(this.beans), c = l.documentElement, d = this.getPopupParent(), u = e.getBoundingClientRect(), h = d.getBoundingClientRect(), p = l.documentElement.getBoundingClientRect(), g = d === l.body, f = Math.ceil(u[o]);
    let C = g ? (i ? oc : gn)(c) + c[a] : d[r];
    g && (C -= Math.abs(p[n] - h[n]));
    const w = C - f;
    return Math.min(Math.max(t, 0), Math.abs(w));
  }
  addPopup(e) {
    const t = We(this.beans), { eChild: s, ariaLabel: i, alwaysOnTop: r, positionCallback: n, anchorToElement: o } = e;
    if (!t)
      return I(122), { hideFunc: () => {
      } };
    const a = this.getPopupIndex(s);
    if (a !== -1)
      return { hideFunc: this.popupList[a].hideFunc };
    this.initialisePopupPosition(s);
    const l = this.createPopupWrapper(s, i, !!r), c = this.addEventListenersToPopup({ ...e, wrapperEl: l });
    return n && n(), this.addPopupToPopupList(s, l, c, o), {
      hideFunc: c
    };
  }
  initialisePopupPosition(e) {
    const s = this.getPopupParent().getBoundingClientRect();
    W(e.style.top) || (e.style.top = `${s.top * -1}px`), W(e.style.left) || (e.style.left = `${s.left * -1}px`);
  }
  createPopupWrapper(e, t, s) {
    const i = this.getPopupParent(), r = document.createElement("div"), { environment: n, gos: o } = this.beans;
    return n.applyThemeClasses(r), r.classList.add("ag-popup"), e.classList.add(o.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child"), e.hasAttribute("role") || nt(e, "dialog"), ot(e, t), r.appendChild(e), i.appendChild(r), s ? this.setAlwaysOnTop(e, !0) : this.bringPopupToFront(e), r;
  }
  handleThemeChange(e) {
    if (e.themeChanged) {
      const t = this.beans.environment;
      for (const s of this.popupList)
        t.applyThemeClasses(s.wrapper);
    }
  }
  addEventListenersToPopup(e) {
    const t = this.beans, s = We(t), i = this.getPopupParent(), { wrapperEl: r, eChild: n, closedCallback: o, afterGuiAttached: a, closeOnEsc: l, modal: c } = e;
    let d = !1;
    const u = (f) => {
      if (!r.contains(Ie(t)))
        return;
      f.key === P.ESCAPE && !Ds(f) && g({ keyboardEvent: f });
    }, h = (f) => g({ mouseEvent: f }), p = (f) => g({ touchEvent: f }), g = (f = {}) => {
      const { mouseEvent: m, touchEvent: C, keyboardEvent: w, forceHide: y } = f;
      !y && // we don't hide popup if the event was on the child, or any
      // children of this child
      (this.isEventFromCurrentPopup({ mouseEvent: m, touchEvent: C }, n) || // this method should only be called once. the client can have different
      // paths, each one wanting to close, so this method may be called multiple times.
      d) || (d = !0, i.removeChild(r), s.removeEventListener("keydown", u), s.removeEventListener("mousedown", h), s.removeEventListener("touchstart", p), s.removeEventListener("contextmenu", h), this.eventSvc.removeEventListener("dragStarted", h), o && o(m || C || w), this.removePopupFromPopupList(n));
    };
    return a && a({ hidePopup: g }), window.setTimeout(() => {
      l && s.addEventListener("keydown", u), c && (s.addEventListener("mousedown", h), this.eventSvc.addEventListener("dragStarted", h), s.addEventListener("touchstart", p), s.addEventListener("contextmenu", h));
    }, 0), g;
  }
  addPopupToPopupList(e, t, s, i) {
    this.popupList.push({
      element: e,
      wrapper: t,
      hideFunc: s,
      instanceId: J0++,
      isAnchored: !!i
    }), i && this.setPopupPositionRelatedToElement(e, i);
  }
  getPopupIndex(e) {
    return this.popupList.findIndex((t) => t.element === e);
  }
  setPopupPositionRelatedToElement(e, t) {
    const s = this.getPopupIndex(e);
    if (s === -1)
      return;
    const i = this.popupList[s];
    if (i.stopAnchoringPromise && i.stopAnchoringPromise.then((n) => n && n()), i.stopAnchoringPromise = void 0, i.isAnchored = !1, !t)
      return;
    const r = this.keepPopupPositionedRelativeTo({
      element: t,
      ePopup: e,
      hidePopup: i.hideFunc
    });
    return i.stopAnchoringPromise = r, i.isAnchored = !0, r;
  }
  removePopupFromPopupList(e) {
    this.setAlignedStyles(e, null), this.setPopupPositionRelatedToElement(e, null), this.popupList = this.popupList.filter((t) => t.element !== e);
  }
  keepPopupPositionedRelativeTo(e) {
    const t = this.getPopupParent(), s = t.getBoundingClientRect(), { element: i, ePopup: r } = e, n = i.getBoundingClientRect(), o = (u) => parseInt(u.substring(0, u.length - 1), 10), a = (u, h) => {
      const p = s[u] - n[u], g = o(r.style[u]);
      return {
        initialDiff: p,
        lastDiff: p,
        initial: g,
        last: g,
        direction: h
      };
    }, l = a(
      "top",
      0
      /* vertical */
    ), c = a(
      "left",
      1
      /* horizontal */
    ), d = this.beans.frameworkOverrides;
    return new fe((u) => {
      d.wrapIncoming(() => {
        d.setInterval(() => {
          const h = t.getBoundingClientRect(), p = i.getBoundingClientRect();
          if (p.top == 0 && p.left == 0 && p.height == 0 && p.width == 0) {
            e.hidePopup();
            return;
          }
          const f = (m, C) => {
            const w = o(r.style[C]);
            m.last !== w && (m.initial = w, m.last = w);
            const y = h[C] - p[C];
            if (y != m.lastDiff) {
              const b = this.keepXYWithinBounds(
                r,
                m.initial + m.initialDiff - y,
                m.direction
              );
              r.style[C] = `${b}px`, m.last = b;
            }
            m.lastDiff = y;
          };
          f(l, "top"), f(c, "left");
        }, 200).then((h) => {
          u(() => {
            h != null && window.clearInterval(h);
          });
        });
      }, "popupPositioning");
    });
  }
  hasAnchoredPopup() {
    return this.popupList.some((e) => e.isAnchored);
  }
  isEventFromCurrentPopup(e, t) {
    const { mouseEvent: s, touchEvent: i } = e, r = s || i;
    if (!r)
      return !1;
    const n = this.getPopupIndex(t);
    if (n === -1)
      return !1;
    for (let o = n; o < this.popupList.length; o++) {
      const a = this.popupList[o];
      if (au(a.element, r))
        return !0;
    }
    return this.isElementWithinCustomPopup(r.target);
  }
  isElementWithinCustomPopup(e) {
    const t = We(this.beans);
    for (; e && e !== t.body; ) {
      if (e.classList.contains("ag-custom-component-popup") || e.parentElement === null)
        return !0;
      e = e.parentElement;
    }
    return !1;
  }
  getWrapper(e) {
    for (; !e.classList.contains("ag-popup") && e.parentElement; )
      e = e.parentElement;
    return e.classList.contains("ag-popup") ? e : null;
  }
  setAlwaysOnTop(e, t) {
    const s = this.getWrapper(e);
    s && (s.classList.toggle("ag-always-on-top", !!t), t && this.bringPopupToFront(s));
  }
  /** @return true if moved */
  bringPopupToFront(e) {
    const t = this.getPopupParent(), s = Array.prototype.slice.call(t.querySelectorAll(".ag-popup")), i = s.length, r = this.getWrapper(e);
    if (!r || i <= 1 || !t.contains(e))
      return;
    const n = [], o = [];
    for (const h of s)
      h !== r && (h.classList.contains("ag-always-on-top") ? o.push(h) : n.push(h));
    const a = [], l = o.length, u = r.classList.contains("ag-always-on-top") || !l ? [...n, ...o, r] : [...n, r, ...o];
    for (let h = 0; h <= i; h++) {
      const p = u[h];
      if (s[h] === u[h] || p === r)
        continue;
      p.querySelectorAll("div").forEach((f) => {
        f.scrollTop !== 0 && a.push([f, f.scrollTop]);
      }), h === 0 ? t.insertAdjacentElement("afterbegin", p) : u[h - 1].insertAdjacentElement("afterend", p);
    }
    for (; a.length; ) {
      const h = a.pop();
      h[0].scrollTop = h[1];
    }
  }
}, Yi = {
  moduleName: "Popup",
  version: de,
  beans: [tk]
}, sk = (
  /*css*/
  ".ag-set-filter{--ag-indentation-level:0}.ag-set-filter-item{align-items:center;display:flex;height:100%}:where(.ag-ltr) .ag-set-filter-item{padding-left:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}:where(.ag-rtl) .ag-set-filter-item{padding-right:calc(var(--ag-widget-container-horizontal-padding) + var(--ag-indentation-level)*var(--ag-set-filter-indent-size))}.ag-set-filter-item-checkbox{display:flex;height:100%;width:100%}.ag-set-filter-group-icons{display:block;>*{cursor:pointer}}:where(.ag-ltr) .ag-set-filter-group-icons{margin-right:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-set-filter-group-icons{margin-left:var(--ag-widget-container-horizontal-padding)}.ag-filter-body-wrapper{display:flex;flex-direction:column}:where(.ag-menu:not(.ag-tabs) .ag-filter) .ag-filter-body-wrapper,:where(.ag-menu:not(.ag-tabs) .ag-filter)>:not(.ag-filter-wrapper){min-width:180px}.ag-filter-filter{flex:1 1 0px}.ag-filter-condition{display:flex;justify-content:center}.ag-floating-filter-body{display:flex;flex:1 1 auto;height:100%;position:relative}.ag-floating-filter-full-body{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;width:100%}.ag-floating-filter-input{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}:where(.ag-input-field-input[type=date]){width:1px}}.ag-floating-filter-button{display:flex;flex:none}.ag-set-floating-filter-input [disabled]{pointer-events:none}.ag-floating-filter-button-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;height:var(--ag-icon-size);width:var(--ag-icon-size)}.ag-filter-loading{background-color:var(--ag-chrome-background-color);height:100%;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:absolute;width:100%;z-index:1;:where(.ag-menu) &{background-color:var(--ag-menu-background-color)}}.ag-filter-separator{border-top:1px solid var(--menu-separator-color)}:where(.ag-filter-select) .ag-picker-field-wrapper{width:0}.ag-filter-condition-operator{height:17px}:where(.ag-ltr) .ag-filter-condition-operator-or{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-condition-operator-or{margin-right:calc(var(--ag-spacing)*2)}.ag-set-filter-select-all{padding-top:var(--ag-widget-container-vertical-padding)}.ag-filter-no-matches,.ag-set-filter-list{height:calc(var(--ag-list-item-height)*6)}.ag-filter-no-matches{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}.ag-set-filter-tree-list{height:calc(var(--ag-list-item-height)*10)}.ag-set-filter-filter{margin-left:var(--ag-widget-container-horizontal-padding);margin-right:var(--ag-widget-container-horizontal-padding);margin-top:var(--ag-widget-container-vertical-padding)}.ag-filter-to{margin-top:var(--ag-widget-vertical-spacing)}.ag-mini-filter{margin:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-set-filter-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-rtl) .ag-set-filter-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-widget-container-horizontal-padding))}:where(.ag-filter-menu) .ag-set-filter-list{min-width:200px}.ag-filter-virtual-list-item:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-filter-apply-panel{display:flex;justify-content:flex-end;overflow:hidden;padding:var(--ag-widget-vertical-spacing) var(--ag-widget-container-horizontal-padding) var(--ag-widget-container-vertical-padding)}.ag-filter-apply-panel-button{line-height:1.5}:where(.ag-ltr) .ag-filter-apply-panel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-filter-apply-panel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-simple-filter-body-wrapper{display:flex;flex-direction:column;min-height:calc(var(--ag-list-item-height) + var(--ag-widget-container-vertical-padding) + var(--ag-widget-vertical-spacing));overflow-y:auto;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);padding-bottom:calc(var(--ag-widget-container-vertical-padding) - var(--ag-widget-vertical-spacing));&>*{margin-bottom:var(--ag-widget-vertical-spacing)}:where(.ag-resizer-wrapper){margin:0}}.ag-multi-filter-menu-item{margin:var(--ag-spacing) 0}.ag-multi-filter-group-title-bar{background-color:transparent;color:var(--ag-header-text-color);font-weight:500;padding:calc(var(--ag-spacing)*1.5) var(--ag-spacing)}.ag-group-filter-field-select-wrapper{display:flex;flex-direction:column;gap:var(--ag-widget-vertical-spacing);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}"
);
function ik(e) {
  const t = e.filterManager;
  return !!(t != null && t.isColumnFilterPresent()) || !!(t != null && t.isAggregateFilterPresent());
}
function rk(e, t) {
  var s;
  return ((s = e.filterManager) == null ? void 0 : s.getColumnFilterInstance(t)) ?? Promise.resolve(void 0);
}
function nk(e, t) {
  var i;
  const s = e.colModel.getColDefCol(t);
  if (s)
    return (i = e.filterManager) == null ? void 0 : i.destroyFilter(s, "api");
}
function ok(e, t) {
  e.frameworkOverrides.wrapIncoming(() => {
    var s;
    return (s = e.filterManager) == null ? void 0 : s.setFilterModel(t);
  });
}
function ak(e) {
  var t;
  return ((t = e.filterManager) == null ? void 0 : t.getFilterModel()) ?? {};
}
function lk(e, t) {
  var s;
  return ((s = e.filterManager) == null ? void 0 : s.getColumnFilterModel(t)) ?? null;
}
function ck(e, t, s) {
  var i;
  return ((i = e.filterManager) == null ? void 0 : i.setColumnFilterModel(t, s)) ?? Promise.resolve();
}
function dk(e, t) {
  var i;
  const s = e.colModel.getCol(t);
  if (!s) {
    be(12, { colKey: t });
    return;
  }
  (i = e.menuSvc) == null || i.showFilterMenu({
    column: s,
    containerType: "columnFilter",
    positionBy: "auto"
  });
}
var ff = {
  january: "January",
  february: "February",
  march: "March",
  april: "April",
  may: "May",
  june: "June",
  july: "July",
  august: "August",
  september: "September",
  october: "October",
  november: "November",
  december: "December"
}, mf = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december"
];
function uk(e, t) {
  return e == null ? -1 : t == null ? 1 : parseFloat(e) - parseFloat(t);
}
var hk = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colFilter", this.allColumnFilters = /* @__PURE__ */ new Map(), this.allColumnListeners = /* @__PURE__ */ new Map(), this.activeAggregateFilters = [], this.activeColumnFilters = [], this.processingFilterChange = !1, this.filterModelUpdateQueue = [], this.columnFilterModelUpdateQueue = [];
  }
  postConstruct() {
    var e, t;
    this.addManagedEventListeners({
      gridColumnsChanged: this.onColumnsChanged.bind(this),
      beforeRefreshModel: ({ params: s }) => {
        var i;
        (s.rowDataUpdated || (i = s.changedProps) != null && i.has("treeData")) && this.onNewRowsLoaded("rowDataUpdated");
      },
      dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
    }), this.initialFilterModel = {
      ...((t = (e = this.gos.get("initialState")) == null ? void 0 : e.filter) == null ? void 0 : t.filterModel) ?? {}
    };
  }
  setFilterModel(e, t = "api") {
    const { colModel: s, dataTypeSvc: i, filterManager: r } = this.beans;
    if (i != null && i.isPendingInference) {
      this.filterModelUpdateQueue.push({ model: e, source: t });
      return;
    }
    const n = [], o = this.getFilterModel(!0);
    if (e) {
      const a = new Set(Object.keys(e));
      this.allColumnFilters.forEach((l, c) => {
        const d = e[c];
        n.push(Ya(l.filterPromise, d)), a.delete(c);
      }), a.forEach((l) => {
        const c = s.getColDefCol(l) || s.getCol(l);
        if (!c) {
          I(62, { colId: l });
          return;
        }
        if (!c.isFilterAllowed()) {
          I(63, { colId: l });
          return;
        }
        const d = this.getOrCreateFilterWrapper(c);
        if (!d) {
          I(64, { colId: l });
          return;
        }
        n.push(Ya(d.filterPromise, e[l]));
      });
    } else
      this.allColumnFilters.forEach((a) => {
        n.push(Ya(a.filterPromise, null));
      });
    fe.all(n).then(() => {
      const a = this.getFilterModel(!0), l = [];
      this.allColumnFilters.forEach((c, d) => {
        const u = o ? o[d] : null, h = a ? a[d] : null;
        Kn(u, h) || l.push(c.column);
      }), l.length > 0 && (r == null || r.onFilterChanged({ columns: l, source: t }));
    });
  }
  getFilterModel(e) {
    const t = {}, {
      allColumnFilters: s,
      initialFilterModel: i,
      beans: { colModel: r }
    } = this;
    return s.forEach((n, o) => {
      const a = this.getModelFromFilterWrapper(n);
      W(a) && (t[o] = a);
    }), e || Object.entries(i).forEach(([n, o]) => {
      var a;
      W(o) && !s.has(n) && ((a = r.getCol(n)) != null && a.isFilterAllowed()) && (t[n] = o);
    }), t;
  }
  getModelFromFilterWrapper(e) {
    const { filter: t } = e;
    return t ? typeof t.getModel != "function" ? (I(66), null) : t.getModel() : this.getModelFromInitialState(e.column);
  }
  getModelFromInitialState(e) {
    return this.initialFilterModel[e.getColId()] ?? null;
  }
  isColumnFilterPresent() {
    return this.activeColumnFilters.length > 0;
  }
  isAggregateFilterPresent() {
    return !!this.activeAggregateFilters.length;
  }
  disableColumnFilters() {
    const { allColumnFilters: e } = this;
    return e.size ? (e.forEach(
      (t) => this.disposeFilterWrapper(t, "advancedFilterEnabled")
    ), !0) : !1;
  }
  doAggregateFiltersPass(e, t) {
    return this.doColumnFiltersPass(e, t, !0);
  }
  updateActiveFilters() {
    const e = (a) => a ? a.isFilterActive ? a.isFilterActive() : (I(67), !1) : !1, { colModel: t, gos: s } = this.beans, i = !!ia(s), r = (a) => {
      if (!a.isPrimary())
        return !0;
      const c = !t.isPivotActive();
      return !a.isValueActive() || !c ? !1 : t.isPivotMode() ? !0 : i;
    }, n = [], o = [];
    return this.forEachColumnFilter((a, l) => {
      e(a) && (r(l.column) ? n.push(a) : o.push(a));
    }).then(() => {
      this.activeAggregateFilters = n, this.activeColumnFilters = o;
    });
  }
  updateFilterFlagInColumns(e, t) {
    return this.forEachColumnFilter(
      (s, i) => this.setColFilterActive(i.column, s.isFilterActive(), e, t)
    );
  }
  forEachColumnFilter(e) {
    const t = [];
    return this.allColumnFilters.forEach((s) => {
      const i = s.filterPromise;
      i && t.push(i.then((r) => e(r, s)));
    }), fe.all(t);
  }
  doColumnFiltersPass(e, t, s) {
    const { data: i, aggData: r } = e, n = s ? this.activeAggregateFilters : this.activeColumnFilters, o = s ? r : i;
    for (let a = 0; a < n.length; a++) {
      const l = n[a];
      if (!(l == null || l === t)) {
        if (typeof l.doesFilterPass != "function") {
          be(91);
          continue;
        }
        if (!l.doesFilterPass({ node: e, data: o }))
          return !1;
      }
    }
    return !0;
  }
  // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
  // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
  // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
  // which results in React State getting applied in the main application, triggering a useEffect() to
  // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
  // getting it's useEffect() triggered in this way.
  callOnFilterChangedOutsideRenderCycle(e) {
    const { rowRenderer: t, filterManager: s } = this.beans, i = () => {
      this.isAlive() && (s == null || s.onFilterChanged(e));
    };
    t.isRefreshInProgress() ? setTimeout(i, 0) : i();
  }
  updateBeforeFilterChanged(e = {}) {
    const { filterInstance: t, additionalEventAttributes: s } = e;
    return this.updateDependentFilters(), this.updateActiveFilters().then(
      () => this.updateFilterFlagInColumns("filterChanged", s).then(() => {
        this.allColumnFilters.forEach((i) => {
          i.filterPromise && i.filterPromise.then((r) => {
            r && r !== t && r.onAnyFilterChanged && r.onAnyFilterChanged();
          });
        }), this.processingFilterChange = !0;
      })
    );
  }
  updateAfterFilterChanged() {
    this.processingFilterChange = !1;
  }
  isSuppressFlashingCellsBecauseFiltering() {
    return !(this.gos.get("allowShowChangeAfterFilter") ?? !1) && this.processingFilterChange;
  }
  onNewRowsLoaded(e) {
    this.forEachColumnFilter((t) => {
      var s;
      (s = t.onNewRowsLoaded) == null || s.call(t);
    }).then(() => this.updateFilterFlagInColumns(e, { afterDataChange: !0 })).then(() => this.updateActiveFilters());
  }
  createGetValue(e) {
    const { filterValueSvc: t, colModel: s } = this.beans;
    return (i, r) => {
      const n = r ? s.getCol(r) : e;
      return n ? t.getValue(n, i) : void 0;
    };
  }
  isFilterActive(e) {
    const { filter: t } = this.cachedFilter(e) ?? {};
    return t ? t.isFilterActive() : this.getModelFromInitialState(e) != null;
  }
  getOrCreateFilterWrapper(e) {
    if (!e.isFilterAllowed())
      return null;
    let t = this.cachedFilter(e);
    return t || (t = this.createFilterWrapper(e), this.setColumnFilterWrapper(e, t)), t;
  }
  cachedFilter(e) {
    return this.allColumnFilters.get(e.getColId());
  }
  getDefaultFilter(e) {
    let t;
    const { gos: s, dataTypeSvc: i } = this.beans;
    if (pd(s))
      t = "agSetColumnFilter";
    else {
      const r = i == null ? void 0 : i.getBaseDataType(e);
      r === "number" ? t = "agNumberColumnFilter" : r === "date" || r === "dateString" ? t = "agDateColumnFilter" : t = "agTextColumnFilter";
    }
    return t;
  }
  getDefaultFloatingFilter(e) {
    let t;
    const { gos: s, dataTypeSvc: i } = this.beans;
    if (pd(s))
      t = "agSetColumnFloatingFilter";
    else {
      const r = i == null ? void 0 : i.getBaseDataType(e);
      r === "number" ? t = "agNumberColumnFloatingFilter" : r === "date" || r === "dateString" ? t = "agDateColumnFloatingFilter" : t = "agTextColumnFloatingFilter";
    }
    return t;
  }
  createFilterInstance(e, t) {
    const s = this.getDefaultFilter(e), i = e.getColDef();
    let r;
    const n = {
      ...this.createFilterParams(e, i),
      filterModifiedCallback: () => this.filterModifiedCallbackFactory(r, e)(),
      filterChangedCallback: (a) => this.filterChangedCallbackFactory(r, e)(a),
      doesRowPassOtherFilter: (a) => {
        var l;
        return ((l = this.beans.filterManager) == null ? void 0 : l.doesRowPassOtherFilters(r, a)) ?? !0;
      }
    }, o = Qv(this.beans.userCompFactory, i, n, s);
    return o ? {
      filterPromise: () => {
        const a = o.newAgStackInstance();
        return a.then((l) => {
          r = l, t && (t.filter = l ?? void 0);
        }), a;
      },
      compDetails: o
    } : { filterPromise: null, compDetails: null };
  }
  createFilterParams(e, t) {
    return this.gos.addGridCommonParams({
      column: e,
      colDef: t,
      rowModel: this.beans.rowModel,
      filterChangedCallback: () => {
      },
      filterModifiedCallback: () => {
      },
      getValue: this.createGetValue(e),
      doesRowPassOtherFilter: () => !0
    });
  }
  createFilterWrapper(e) {
    const t = {
      column: e,
      filterPromise: null,
      compDetails: null
    }, { filterPromise: s, compDetails: i } = this.createFilterInstance(e, t);
    return t.filterPromise = (s == null ? void 0 : s()) ?? null, t.compDetails = i, t;
  }
  onColumnsChanged() {
    const e = [], { colModel: t, filterManager: s } = this.beans;
    this.allColumnFilters.forEach((r, n) => {
      let o;
      r.column.isPrimary() ? o = t.getColDefCol(n) : o = t.getCol(n), !(o && o === r.column) && (e.push(r.column), this.disposeFilterWrapper(r, "columnChanged"), this.disposeColumnListener(n));
    });
    const i = e.every(
      (r) => r.getColDef().filter === "agGroupColumnFilter"
    );
    e.length > 0 && !i ? s == null || s.onFilterChanged({ columns: e, source: "api" }) : this.updateDependentFilters();
  }
  updateDependentFilters() {
    var e, t;
    (t = (e = this.beans.autoColSvc) == null ? void 0 : e.getAutoCols()) == null || t.forEach((s) => {
      s.getColDef().filter === "agGroupColumnFilter" && this.getOrCreateFilterWrapper(s);
    });
  }
  // for group filters, can change dynamically whether they are allowed or not
  isFilterAllowed(e) {
    if (!e.isFilterAllowed())
      return !1;
    const { filter: s } = this.allColumnFilters.get(e.getColId()) ?? {};
    return s && typeof (s == null ? void 0 : s.isFilterAllowed) == "function" ? s.isFilterAllowed() : !0;
  }
  getFloatingFilterCompDetails(e, t) {
    const s = (d) => {
      var h;
      const u = (h = this.getOrCreateFilterWrapper(e)) == null ? void 0 : h.filterPromise;
      u != null && u.then((p) => {
        d(Cn(p));
      });
    }, i = e.getColDef(), r = {
      ...this.createFilterParams(e, i),
      filterChangedCallback: () => s(
        (d) => this.filterChangedCallbackFactory(d, e)()
      )
    }, { userCompFactory: n, frameworkOverrides: o } = this.beans, a = rE(
      n,
      i,
      r
    );
    let l = xw(
      o,
      i,
      () => this.getDefaultFloatingFilter(e)
    );
    return l == null && (l = "agReadOnlyFloatingFilter"), Jv(n, i, {
      column: e,
      filterParams: a,
      currentParentModel: () => this.getCurrentFloatingFilterParentModel(e),
      parentFilterInstance: s,
      showParentFilter: t
    }, l);
  }
  getCurrentFloatingFilterParentModel(e) {
    return this.getModelFromFilterWrapper(this.cachedFilter(e) ?? { column: e });
  }
  // destroys the filter, so it no longer takes part
  destroyFilter(e, t = "api") {
    var r;
    const s = e.getColId(), i = this.allColumnFilters.get(s);
    this.disposeColumnListener(s), delete this.initialFilterModel[s], i && (this.disposeFilterWrapper(i, t), (r = this.beans.filterManager) == null || r.onFilterChanged({
      columns: [e],
      source: "api"
    }));
  }
  disposeColumnListener(e) {
    const t = this.allColumnListeners.get(e);
    t && (this.allColumnListeners.delete(e), t());
  }
  disposeFilterWrapper(e, t) {
    var s;
    (s = e.filterPromise) == null || s.then((i) => {
      this.destroyBean(i), this.setColFilterActive(e.column, !1, "filterDestroyed"), this.allColumnFilters.delete(e.column.getColId()), this.eventSvc.dispatchEvent({
        type: "filterDestroyed",
        source: t,
        column: e.column
      });
    });
  }
  filterModifiedCallbackFactory(e, t) {
    return () => {
      this.eventSvc.dispatchEvent({
        type: "filterModified",
        column: t,
        filterInstance: e
      });
    };
  }
  filterChangedCallbackFactory(e, t) {
    return (s) => {
      const i = (s == null ? void 0 : s.source) ?? "columnFilter", r = {
        filter: e,
        additionalEventAttributes: s,
        columns: [t],
        source: i
      };
      this.callOnFilterChangedOutsideRenderCycle(r);
    };
  }
  checkDestroyFilter(e) {
    const t = this.allColumnFilters.get(e);
    if (!t)
      return;
    const s = t.column, { compDetails: i } = s.isFilterAllowed() ? this.createFilterInstance(s) : { compDetails: null };
    if (this.areFilterCompsDifferent(t.compDetails, i)) {
      this.destroyFilter(s, "paramsUpdated");
      return;
    }
    const r = s.getColDef().filterParams;
    if (!t.filterPromise) {
      this.destroyFilter(s, "paramsUpdated");
      return;
    }
    t.filterPromise.then((n) => {
      (n != null && n.refresh ? n.refresh({
        ...this.createFilterParams(s, s.getColDef()),
        filterModifiedCallback: this.filterModifiedCallbackFactory(n, s),
        filterChangedCallback: this.filterChangedCallbackFactory(n, s),
        doesRowPassOtherFilter: (a) => {
          var l;
          return ((l = this.beans.filterManager) == null ? void 0 : l.doesRowPassOtherFilters(n, a)) ?? !0;
        },
        ...r
      }) : !0) === !1 && this.destroyFilter(s, "paramsUpdated");
    });
  }
  setColumnFilterWrapper(e, t) {
    const s = e.getColId();
    this.allColumnFilters.set(s, t), this.allColumnListeners.set(
      s,
      this.addManagedListeners(e, { colDefChanged: () => this.checkDestroyFilter(s) })[0]
    );
  }
  areFilterCompsDifferent(e, t) {
    if (!t || !e)
      return !0;
    const { componentClass: s } = e, { componentClass: i } = t;
    return !(s === i || // react hooks returns new wrappers, so check nested render method
    (s == null ? void 0 : s.render) && (i == null ? void 0 : i.render) && s.render === i.render);
  }
  hasFloatingFilters() {
    return this.beans.colModel.getCols().some((t) => t.getColDef().floatingFilter);
  }
  getColumnFilterInstance(e) {
    return new Promise((t) => {
      this.getFilterInstanceImpl(e).then((s) => {
        t(Cn(s));
      });
    });
  }
  getFilterInstanceImpl(e) {
    var i;
    const t = this.beans.colModel.getColDefCol(e);
    return t ? ((i = this.getOrCreateFilterWrapper(t)) == null ? void 0 : i.filterPromise) ?? fe.resolve(null) : fe.resolve(void 0);
  }
  processFilterModelUpdateQueue() {
    this.filterModelUpdateQueue.forEach(({ model: e, source: t }) => this.setFilterModel(e, t)), this.filterModelUpdateQueue = [], this.columnFilterModelUpdateQueue.forEach(({ key: e, model: t, resolve: s }) => {
      this.setColumnFilterModel(e, t).then(() => s());
    }), this.columnFilterModelUpdateQueue = [];
  }
  getColumnFilterModel(e) {
    const t = this.getFilterWrapper(e);
    return t ? this.getModelFromFilterWrapper(t) : null;
  }
  setColumnFilterModel(e, t) {
    const { colModel: s, dataTypeSvc: i } = this.beans;
    if (i != null && i.isPendingInference) {
      let a = () => {
      };
      const l = new Promise((c) => {
        a = c;
      });
      return this.columnFilterModelUpdateQueue.push({ key: e, model: t, resolve: a }), l;
    }
    const r = s.getColDefCol(e), n = r ? this.getOrCreateFilterWrapper(r) : null;
    return n ? ((a) => new Promise((l) => {
      a.then((c) => l(c));
    }))(Ya(n.filterPromise, t)) : Promise.resolve();
  }
  getFilterWrapper(e) {
    const t = this.beans.colModel.getColDefCol(e);
    return t ? this.cachedFilter(t) ?? null : null;
  }
  setColDefPropertiesForDataType(e, t, s) {
    const i = pd(this.gos), r = this.getLocaleTextFunc(), n = (o) => {
      const { filterParams: a } = e;
      e.filterParams = typeof a == "object" ? {
        ...a,
        ...o
      } : o;
    };
    switch (t.baseDataType) {
      case "number": {
        i && n({
          comparator: uk
        });
        break;
      }
      case "boolean": {
        n(i ? {
          valueFormatter: (o) => W(o.value) ? r(String(o.value), o.value ? "True" : "False") : r("blanks", "(Blanks)")
        } : {
          maxNumConditions: 1,
          debounceMs: 0,
          filterOptions: [
            "empty",
            {
              displayKey: "true",
              displayName: "True",
              predicate: (o, a) => a,
              numberOfInputs: 0
            },
            {
              displayKey: "false",
              displayName: "False",
              predicate: (o, a) => a === !1,
              numberOfInputs: 0
            }
          ]
        });
        break;
      }
      case "date": {
        i && n({
          valueFormatter: (o) => {
            const a = s(o);
            return W(a) ? a : r("blanks", "(Blanks)");
          },
          treeList: !0,
          treeListFormatter: (o, a) => {
            if (a === 1 && o != null) {
              const l = mf[Number(o) - 1];
              return r(l, ff[l]);
            }
            return o ?? r("blanks", "(Blanks)");
          }
        });
        break;
      }
      case "dateString": {
        const o = t.dateParser;
        n(i ? {
          valueFormatter: (a) => {
            const l = s(a);
            return W(l) ? l : r("blanks", "(Blanks)");
          },
          treeList: !0,
          treeListPathGetter: (a) => {
            const l = o(a ?? void 0);
            return l ? [String(l.getFullYear()), String(l.getMonth() + 1), String(l.getDate())] : null;
          },
          treeListFormatter: (a, l) => {
            if (l === 1 && a != null) {
              const c = mf[Number(a) - 1];
              return r(c, ff[c]);
            }
            return a ?? r("blanks", "(Blanks)");
          }
        } : {
          comparator: (a, l) => {
            const c = o(l);
            return l == null || c < a ? -1 : c > a ? 1 : 0;
          }
        });
        break;
      }
      case "object": {
        i ? n({
          valueFormatter: (o) => {
            const a = s(o);
            return W(a) ? a : r("blanks", "(Blanks)");
          }
        }) : e.filterValueGetter = (o) => s({
          column: o.column,
          node: o.node,
          value: this.beans.valueSvc.getValue(o.column, o.node)
        });
        break;
      }
    }
  }
  // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
  setColFilterActive(e, t, s, i) {
    e.filterActive !== t && (e.filterActive = t, e.dispatchColEvent("filterActiveChanged", s)), e.dispatchColEvent("filterChanged", s, i);
  }
  destroy() {
    super.destroy(), this.allColumnFilters.forEach((e) => this.disposeFilterWrapper(e, "gridDestroyed")), this.allColumnListeners.clear();
  }
};
function Ya(e, t) {
  return e ? new fe((s) => {
    e.then((i) => {
      typeof i.setModel != "function" && (I(65), s()), (i.setModel(t) || fe.resolve()).then(() => s());
    });
  }) : fe.resolve();
}
function pk(e) {
  var t;
  return !!((t = e.filterManager) != null && t.isAnyFilterPresent());
}
function gk(e, t = "api") {
  var s;
  (s = e.filterManager) == null || s.onFilterChanged({ source: t });
}
var fk = class extends L {
  constructor() {
    super(...arguments), this.beanName = "filterManager", this.advFilterModelUpdateQueue = [];
  }
  wireBeans(e) {
    this.quickFilter = e.quickFilter, this.advancedFilter = e.advancedFilter, this.colFilter = e.colFilter;
  }
  postConstruct() {
    const e = this.refreshFiltersForAggregations.bind(this), t = this.updateAdvFilterColumns.bind(this);
    this.addManagedEventListeners({
      columnValueChanged: e,
      columnPivotChanged: e,
      columnPivotModeChanged: e,
      newColumnsLoaded: t,
      columnVisible: t,
      advancedFilterEnabledChanged: ({ enabled: i }) => this.onAdvFilterEnabledChanged(i),
      dataTypesInferred: this.processFilterModelUpdateQueue.bind(this)
    }), this.externalFilterPresent = this.isExternalFilterPresentCallback(), this.addManagedPropertyListeners(["isExternalFilterPresent", "doesExternalFilterPass"], () => {
      this.onFilterChanged({ source: "api" });
    }), this.updateAggFiltering(), this.addManagedPropertyListener("groupAggFiltering", () => {
      this.updateAggFiltering(), this.onFilterChanged();
    }), this.quickFilter && this.addManagedListeners(this.quickFilter, {
      quickFilterChanged: () => this.onFilterChanged({ source: "quickFilter" })
    });
    const { gos: s } = this;
    this.alwaysPassFilter = s.get("alwaysPassFilter"), this.addManagedPropertyListener("alwaysPassFilter", () => {
      this.alwaysPassFilter = s.get("alwaysPassFilter"), this.onFilterChanged({ source: "api" });
    });
  }
  isExternalFilterPresentCallback() {
    const e = this.gos.getCallback("isExternalFilterPresent");
    return typeof e == "function" && e({});
  }
  doesExternalFilterPass(e) {
    const t = this.gos.get("doesExternalFilterPass");
    return typeof t == "function" && t(e);
  }
  setFilterModel(e, t = "api") {
    var s;
    if (this.isAdvFilterEnabled()) {
      this.warnAdvFilters();
      return;
    }
    (s = this.colFilter) == null || s.setFilterModel(e, t);
  }
  getFilterModel() {
    var e;
    return ((e = this.colFilter) == null ? void 0 : e.getFilterModel()) ?? {};
  }
  isColumnFilterPresent() {
    var e;
    return !!((e = this.colFilter) != null && e.isColumnFilterPresent());
  }
  isAggregateFilterPresent() {
    var e;
    return !!((e = this.colFilter) != null && e.isAggregateFilterPresent());
  }
  isChildFilterPresent() {
    return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.externalFilterPresent || this.isAdvFilterPresent();
  }
  isAnyFilterPresent() {
    return this.isChildFilterPresent() || this.isAggregateFilterPresent();
  }
  isAdvFilterPresent() {
    return this.isAdvFilterEnabled() && this.advancedFilter.isFilterPresent();
  }
  onAdvFilterEnabledChanged(e) {
    var t, s;
    e ? (t = this.colFilter) != null && t.disableColumnFilters() && this.onFilterChanged({ source: "advancedFilter" }) : (s = this.advancedFilter) != null && s.isFilterPresent() && (this.advancedFilter.setModel(null), this.onFilterChanged({ source: "advancedFilter" }));
  }
  isAdvFilterEnabled() {
    var e;
    return !!((e = this.advancedFilter) != null && e.isEnabled());
  }
  isAdvFilterHeaderActive() {
    return this.isAdvFilterEnabled() && this.advancedFilter.isHeaderActive();
  }
  resetQuickFilterCache() {
    var e;
    (e = this.quickFilter) == null || e.resetCache();
  }
  refreshFiltersForAggregations() {
    ia(this.gos) && this.onFilterChanged();
  }
  onFilterChanged(e = {}) {
    const { source: t, additionalEventAttributes: s, columns: i = [] } = e;
    this.externalFilterPresent = this.isExternalFilterPresentCallback(), (this.colFilter ? this.colFilter.updateBeforeFilterChanged(e) : fe.resolve()).then(() => {
      var n;
      const r = {
        source: t,
        type: "filterChanged",
        columns: i
      };
      s && bt(r, s), this.eventSvc.dispatchEvent(r), (n = this.colFilter) == null || n.updateAfterFilterChanged();
    });
  }
  isSuppressFlashingCellsBecauseFiltering() {
    var e;
    return !!((e = this.colFilter) != null && e.isSuppressFlashingCellsBecauseFiltering());
  }
  isQuickFilterPresent() {
    var e;
    return !!((e = this.quickFilter) != null && e.isFilterPresent());
  }
  updateAggFiltering() {
    this.aggFiltering = !!ia(this.gos);
  }
  isAggregateQuickFilterPresent() {
    return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
  }
  isNonAggregateQuickFilterPresent() {
    return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
  }
  shouldApplyQuickFilterAfterAgg() {
    return (this.aggFiltering || this.beans.colModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
  }
  doesRowPassOtherFilters(e, t) {
    return this.doesRowPassFilter({ rowNode: t, filterInstanceToSkip: e });
  }
  doesRowPassAggregateFilters(e) {
    var s;
    const { rowNode: t } = e;
    return (s = this.alwaysPassFilter) != null && s.call(this, t) ? !0 : !(this.isAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(t) || this.isAggregateFilterPresent() && !this.colFilter.doAggregateFiltersPass(t, e.filterInstanceToSkip));
  }
  doesRowPassFilter(e) {
    var s;
    const { rowNode: t } = e;
    return (s = this.alwaysPassFilter) != null && s.call(this, t) ? !0 : !(this.isNonAggregateQuickFilterPresent() && !this.quickFilter.doesRowPass(t) || this.externalFilterPresent && !this.doesExternalFilterPass(t) || this.isColumnFilterPresent() && !this.colFilter.doColumnFiltersPass(t, e.filterInstanceToSkip) || this.isAdvFilterPresent() && !this.advancedFilter.doesFilterPass(t));
  }
  isFilterActive(e) {
    var t;
    return !!((t = this.colFilter) != null && t.isFilterActive(e));
  }
  getOrCreateFilterWrapper(e) {
    var t;
    return ((t = this.colFilter) == null ? void 0 : t.getOrCreateFilterWrapper(e)) ?? null;
  }
  getDefaultFloatingFilter(e) {
    return this.colFilter.getDefaultFloatingFilter(e);
  }
  createFilterParams(e, t) {
    return this.colFilter.createFilterParams(e, t);
  }
  // for group filters, can change dynamically whether they are allowed or not
  isFilterAllowed(e) {
    var t;
    return this.isAdvFilterEnabled() ? !1 : !!((t = this.colFilter) != null && t.isFilterAllowed(e));
  }
  getFloatingFilterCompDetails(e, t) {
    var s;
    return (s = this.colFilter) == null ? void 0 : s.getFloatingFilterCompDetails(e, t);
  }
  getCurrentFloatingFilterParentModel(e) {
    var t;
    return (t = this.colFilter) == null ? void 0 : t.getCurrentFloatingFilterParentModel(e);
  }
  // destroys the filter, so it no longer takes part
  destroyFilter(e, t = "api") {
    var s;
    (s = this.colFilter) == null || s.destroyFilter(e, t);
  }
  areFilterCompsDifferent(e, t) {
    var s;
    return !!((s = this.colFilter) != null && s.areFilterCompsDifferent(e, t));
  }
  getAdvFilterModel() {
    return this.isAdvFilterEnabled() ? this.advancedFilter.getModel() : null;
  }
  setAdvFilterModel(e) {
    var t;
    if (this.isAdvFilterEnabled()) {
      if ((t = this.beans.dataTypeSvc) != null && t.isPendingInference) {
        this.advFilterModelUpdateQueue.push(e);
        return;
      }
      this.advancedFilter.setModel(e ?? null), this.onFilterChanged({ source: "advancedFilter" });
    }
  }
  toggleAdvFilterBuilder(e, t) {
    this.isAdvFilterEnabled() && this.advancedFilter.getCtrl().toggleFilterBuilder({ source: t, force: e });
  }
  updateAdvFilterColumns() {
    this.isAdvFilterEnabled() && this.advancedFilter.updateValidity() && this.onFilterChanged({ source: "advancedFilter" });
  }
  hasFloatingFilters() {
    var e;
    return this.isAdvFilterEnabled() ? !1 : !!((e = this.colFilter) != null && e.hasFloatingFilters());
  }
  getColumnFilterInstance(e) {
    var t;
    return this.isAdvFilterEnabled() ? (this.warnAdvFilters(), Promise.resolve(void 0)) : ((t = this.colFilter) == null ? void 0 : t.getColumnFilterInstance(e)) ?? Promise.resolve(void 0);
  }
  warnAdvFilters() {
    I(68);
  }
  setupAdvFilterHeaderComp(e) {
    var t;
    (t = this.advancedFilter) == null || t.getCtrl().setupHeaderComp(e);
  }
  getHeaderRowCount() {
    return this.isAdvFilterHeaderActive() ? 1 : 0;
  }
  getHeaderHeight() {
    return this.isAdvFilterHeaderActive() ? this.advancedFilter.getCtrl().getHeaderHeight() : 0;
  }
  processFilterModelUpdateQueue() {
    this.advFilterModelUpdateQueue.forEach((e) => this.setAdvFilterModel(e)), this.advFilterModelUpdateQueue = [];
  }
  getColumnFilterModel(e) {
    var t;
    return (t = this.colFilter) == null ? void 0 : t.getColumnFilterModel(e);
  }
  setColumnFilterModel(e, t) {
    var s;
    return this.isAdvFilterEnabled() ? (this.warnAdvFilters(), Promise.resolve()) : ((s = this.colFilter) == null ? void 0 : s.setColumnFilterModel(e, t)) ?? Promise.resolve();
  }
  setColDefPropertiesForDataType(e, t, s) {
    var i;
    (i = this.colFilter) == null || i.setColDefPropertiesForDataType(e, t, s);
  }
}, mk = class extends L {
  constructor() {
    super(...arguments), this.beanName = "filterMenuFactory";
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  hideActiveMenu() {
    var e;
    (e = this.hidePopup) == null || e.call(this);
  }
  showMenuAfterMouseEvent(e, t, s) {
    this.showPopup(
      e,
      (i) => {
        var r;
        (r = this.popupSvc) == null || r.positionPopupUnderMouseEvent({
          column: e,
          type: s,
          mouseEvent: t,
          ePopup: i
        });
      },
      s,
      t.target,
      Mt(this.gos)
    );
  }
  showMenuAfterButtonClick(e, t, s) {
    let i = -1, r = "left";
    const n = Mt(this.gos);
    !n && this.gos.get("enableRtl") && (i = 1, r = "right");
    const o = n ? void 0 : 4 * i, a = n ? void 0 : 4;
    this.showPopup(
      e,
      (l) => {
        var c;
        (c = this.popupSvc) == null || c.positionPopupByComponent({
          type: s,
          eventSource: t,
          ePopup: l,
          nudgeX: o,
          nudgeY: a,
          alignSide: r,
          keepWithinBounds: !0,
          position: "under",
          column: e
        });
      },
      s,
      t,
      n
    );
  }
  showPopup(e, t, s, i, r) {
    var g;
    const n = e ? this.createBean(new fc(e, "COLUMN_MENU")) : void 0;
    if (this.activeMenu = n, !(n != null && n.hasFilter()) || !e) {
      be(57);
      return;
    }
    const o = document.createElement("div");
    nt(o, "presentation"), o.classList.add("ag-menu"), r || o.classList.add("ag-filter-menu"), [this.tabListener] = this.addManagedElementListeners(o, {
      keydown: (f) => this.trapFocusWithin(f, o)
    }), o.appendChild(n == null ? void 0 : n.getGui());
    let a;
    const l = () => n == null ? void 0 : n.afterGuiDetached(), c = Rv(this.gos) ? i ?? this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody : void 0, d = (f) => {
      Vl(e, !1, "contextMenu");
      const m = f instanceof KeyboardEvent;
      if (this.tabListener && (this.tabListener = this.tabListener()), m && i && Xt(i)) {
        const C = vh(i);
        C == null || C.focus({ preventScroll: !0 });
      }
      l(), this.destroyBean(this.activeMenu), this.dispatchVisibleChangedEvent(!1, s, e);
    }, u = this.getLocaleTextFunc(), h = r && s !== "columnFilter" ? u("ariaLabelColumnMenu", "Column Menu") : u("ariaLabelColumnFilter", "Column Filter"), p = (g = this.popupSvc) == null ? void 0 : g.addPopup({
      modal: !0,
      eChild: o,
      closeOnEsc: !0,
      closedCallback: d,
      positionCallback: () => t(o),
      anchorToElement: c,
      ariaLabel: h
    });
    p && (this.hidePopup = a = p.hideFunc), n.afterInit().then(() => {
      t(o), n.afterGuiAttached({ container: s, hidePopup: a });
    }), Vl(e, !0, "contextMenu"), this.dispatchVisibleChangedEvent(!0, s, e);
  }
  trapFocusWithin(e, t) {
    e.key !== P.TAB || e.defaultPrevented || zt(this.beans, t, !1, e.shiftKey) || (e.preventDefault(), Dt(t, e.shiftKey));
  }
  dispatchVisibleChangedEvent(e, t, s) {
    this.eventSvc.dispatchEvent({
      type: "columnMenuVisibleChanged",
      visible: e,
      switchingTab: !1,
      key: t,
      column: s ?? null,
      columnGroup: null
    });
  }
  isMenuEnabled(e) {
    return e.isFilterAllowed() && (e.getColDef().menuTabs ?? ["filterMenuTab"]).includes("filterMenuTab");
  }
  showMenuAfterContextMenuEvent() {
  }
  destroy() {
    this.destroyBean(this.activeMenu), super.destroy();
  }
}, Ck = class extends L {
  constructor() {
    super(...arguments), this.beanName = "filterValueSvc";
  }
  getValue(e, t) {
    if (!t)
      return;
    const s = e.getColDef(), { filterValueGetter: i } = s;
    return i ? this.executeFilterValueGetter(i, t.data, e, t, s) : this.beans.valueSvc.getValue(e, t);
  }
  executeFilterValueGetter(e, t, s, i, r) {
    const { expressionSvc: n, valueSvc: o } = this.beans, a = this.gos.addGridCommonParams({
      data: t,
      node: i,
      column: s,
      colDef: r,
      getValue: o.getValueCallback.bind(o, i)
    });
    return typeof e == "function" ? e(a) : n == null ? void 0 : n.evaluate(e, a);
  }
}, vk = class extends _ {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field data-ref="eFloatingFilterText"></ag-input-text-field>
            </div>`,
      [Ks]
    ), this.eFloatingFilterText = E;
  }
  init(e) {
    this.params = e;
    const t = this.beans.colNames.getDisplayNameForColumn(e.column, "header", !0);
    this.eFloatingFilterText.setDisabled(!0).setInputAriaLabel(`${t} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`);
  }
  onParentModelChanged(e) {
    if (e == null) {
      this.eFloatingFilterText.setValue("");
      return;
    }
    this.params.parentFilterInstance((t) => {
      if (t.getModelAsString) {
        const s = t.getModelAsString(e);
        this.eFloatingFilterText.setValue(s);
      }
    });
  }
  refresh(e) {
    this.init(e);
  }
}, xy = class {
  constructor() {
    this.customFilterOptions = {};
  }
  init(e, t) {
    this.filterOptions = e.filterOptions || t, this.mapCustomOptions(), this.selectDefaultItem(e);
  }
  mapCustomOptions() {
    const { filterOptions: e } = this;
    e && e.forEach((t) => {
      if (typeof t == "string")
        return;
      const s = [["displayKey"], ["displayName"], ["predicate", "test"]], i = (r) => r.some((n) => t[n] != null) ? !0 : (I(72, { keys: r }), !1);
      if (!s.every(i)) {
        this.filterOptions = e.filter((r) => r === t) || [];
        return;
      }
      this.customFilterOptions[t.displayKey] = t;
    });
  }
  selectDefaultItem(e) {
    const { filterOptions: t } = this;
    if (e.defaultOption)
      this.defaultOption = e.defaultOption;
    else if (t.length >= 1) {
      const s = t[0];
      typeof s == "string" ? this.defaultOption = s : s.displayKey ? this.defaultOption = s.displayKey : I(73);
    } else
      I(74);
  }
  getCustomOption(e) {
    return this.customFilterOptions[e];
  }
};
function Zo(e, t, s) {
  return s == null ? e.splice(t) : e.splice(t, s);
}
function zl(e) {
  return e == null || typeof e == "string" && e.trim().length === 0;
}
function wk(e) {
  return e === "AND" || e === "OR" ? e : "AND";
}
function yk(e, t, s) {
  if (e == null)
    return;
  const { predicate: i } = e;
  if (i != null && !t.some((r) => r == null))
    return i(t, s);
}
function bk(e, t) {
  let s = e.length;
  return s > t && (e.splice(t), I(78), s = t), s;
}
var Ry = class extends Cc {
  constructor() {
    super(...arguments), this.eTypes = [], this.eJoinOperatorPanels = [], this.eJoinOperatorsAnd = [], this.eJoinOperatorsOr = [], this.eConditionBodies = [], this.listener = () => this.onUiChanged(), this.lastUiCompletePosition = null, this.joinOperatorId = 0;
  }
  getNumberOfInputs(e) {
    const t = this.optionsFactory.getCustomOption(e);
    if (t) {
      const { numberOfInputs: i } = t;
      return i ?? 1;
    }
    return e && ["empty", "notBlank", "blank"].indexOf(e) >= 0 ? 0 : e === "inRange" ? 2 : 1;
  }
  // floating filter calls this when user applies filter from floating filter
  onFloatingFilterChanged(e, t) {
    this.setTypeFromFloatingFilter(e), this.setValueFromFloatingFilter(t), this.onUiChanged(!0);
  }
  setTypeFromFloatingFilter(e) {
    this.eTypes.forEach((t, s) => {
      const i = s === 0 ? e : this.optionsFactory.defaultOption;
      t.setValue(i, !0);
    });
  }
  getModelFromUi() {
    const e = this.getUiCompleteConditions();
    return e.length === 0 ? null : this.maxNumConditions > 1 && e.length > 1 ? {
      filterType: this.filterType,
      operator: this.getJoinOperator(),
      conditions: e
    } : e[0];
  }
  getConditionTypes() {
    return this.eTypes.map((e) => e.getValue());
  }
  getConditionType(e) {
    return this.eTypes[e].getValue();
  }
  getJoinOperator() {
    const { eJoinOperatorsOr: e, defaultJoinOperator: t } = this;
    return e.length === 0 ? t : e[0].getValue() === !0 ? "OR" : "AND";
  }
  areModelsEqual(e, t) {
    if (!e && !t)
      return !0;
    if (!e && t || e && !t)
      return !1;
    const s = !e.operator, i = !t.operator;
    if (!s && i || s && !i)
      return !1;
    let n;
    if (s) {
      const o = e, a = t;
      n = this.areSimpleModelsEqual(o, a);
    } else {
      const o = e, a = t;
      n = o.operator === a.operator && Ht(
        o.conditions,
        a.conditions,
        (l, c) => this.areSimpleModelsEqual(l, c)
      );
    }
    return n;
  }
  shouldRefresh(e) {
    var n;
    const t = this.getModel(), s = t ? t.conditions ?? [t] : null, i = ((n = e.filterOptions) == null ? void 0 : n.map((o) => typeof o == "string" ? o : o.displayKey)) ?? this.getDefaultFilterOptions();
    return !(!(!s || s.every((o) => i.find((a) => a === o.type) !== void 0)) || typeof e.maxNumConditions == "number" && s && s.length > e.maxNumConditions);
  }
  refresh(e) {
    return !this.shouldRefresh(e) || !super.refresh(e) ? !1 : (this.setParams(e), this.removeConditionsAndOperators(0), this.createOption(), this.setModel(this.getModel()), !0);
  }
  setModelIntoUi(e) {
    if (e.operator) {
      const s = e;
      let i = s.conditions;
      i == null && (i = [], I(77));
      const r = bk(i, this.maxNumConditions), n = this.getNumConditions();
      if (r < n)
        this.removeConditionsAndOperators(r);
      else if (r > n)
        for (let a = n; a < r; a++)
          this.createJoinOperatorPanel(), this.createOption();
      const o = s.operator === "OR";
      this.eJoinOperatorsAnd.forEach((a) => a.setValue(!o, !0)), this.eJoinOperatorsOr.forEach((a) => a.setValue(o, !0)), i.forEach((a, l) => {
        this.eTypes[l].setValue(a.type, !0), this.setConditionIntoUi(a, l);
      });
    } else {
      const s = e;
      this.getNumConditions() > 1 && this.removeConditionsAndOperators(1), this.eTypes[0].setValue(s.type, !0), this.setConditionIntoUi(s, 0);
    }
    return this.lastUiCompletePosition = this.getNumConditions() - 1, this.createMissingConditionsAndOperators(), this.onUiChanged(), fe.resolve();
  }
  doesFilterPass(e) {
    const t = this.getModel();
    if (t == null)
      return !0;
    const { operator: s } = t, i = [];
    if (s) {
      const n = t;
      i.push(...n.conditions ?? []);
    } else
      i.push(t);
    return i[s && s === "OR" ? "some" : "every"]((n) => this.individualConditionPasses(e, n));
  }
  setParams(e) {
    super.setParams(e), this.setNumConditions(e), this.defaultJoinOperator = wk(e.defaultJoinOperator), this.filterPlaceholder = e.filterPlaceholder, this.optionsFactory = new xy(), this.optionsFactory.init(e, this.getDefaultFilterOptions()), this.createFilterListOptions(), this.createOption(), this.createMissingConditionsAndOperators(), this.isReadOnly() && this.eFilterBody.setAttribute("tabindex", "-1");
  }
  setNumConditions(e) {
    let t = e.maxNumConditions ?? 2;
    t < 1 && (I(79), t = 1), this.maxNumConditions = t;
    let s = e.numAlwaysVisibleConditions ?? 1;
    s < 1 && (I(80), s = 1), s > t && (I(81), s = t), this.numAlwaysVisibleConditions = s;
  }
  createOption() {
    const e = this.createManagedBean(new rs());
    this.eTypes.push(e), e.addCssClass("ag-filter-select"), this.eFilterBody.appendChild(e.getGui());
    const t = this.createValueElement();
    this.eConditionBodies.push(t), this.eFilterBody.appendChild(t), this.putOptionsIntoDropdown(e), this.resetType(e);
    const s = this.getNumConditions() - 1;
    this.forEachPositionInput(s, (i) => this.resetInput(i)), this.addChangedListeners(e, s);
  }
  createJoinOperatorPanel() {
    const e = document.createElement("div");
    this.eJoinOperatorPanels.push(e), e.classList.add("ag-filter-condition");
    const t = this.createJoinOperator(this.eJoinOperatorsAnd, e, "and"), s = this.createJoinOperator(this.eJoinOperatorsOr, e, "or");
    this.eFilterBody.appendChild(e);
    const i = this.eJoinOperatorPanels.length - 1, r = this.joinOperatorId++;
    this.resetJoinOperatorAnd(t, i, r), this.resetJoinOperatorOr(s, i, r), this.isReadOnly() || (t.onValueChange(this.listener), s.onValueChange(this.listener));
  }
  createJoinOperator(e, t, s) {
    const i = this.createManagedBean(new GD());
    e.push(i);
    const r = "ag-filter-condition-operator";
    return i.addCssClass(r), i.addCssClass(`${r}-${s}`), t.appendChild(i.getGui()), i;
  }
  createFilterListOptions() {
    this.filterListOptions = this.optionsFactory.filterOptions.map(
      (e) => typeof e == "string" ? this.createBoilerplateListOption(e) : this.createCustomListOption(e)
    );
  }
  putOptionsIntoDropdown(e) {
    const { filterListOptions: t } = this;
    t.forEach((s) => {
      e.addOption(s);
    }), e.setDisabled(t.length <= 1);
  }
  createBoilerplateListOption(e) {
    return { value: e, text: this.translate(e) };
  }
  createCustomListOption(e) {
    const { displayKey: t } = e, s = this.optionsFactory.getCustomOption(e.displayKey);
    return {
      value: t,
      text: s ? this.getLocaleTextFunc()(s.displayKey, s.displayName) : this.translate(t)
    };
  }
  createBodyTemplate() {
    return "";
  }
  getAgComponents() {
    return [];
  }
  getCssIdentifier() {
    return "simple-filter";
  }
  updateUiVisibility() {
    const e = this.getJoinOperator();
    this.updateNumConditions(), this.updateConditionStatusesAndValues(this.lastUiCompletePosition, e);
  }
  updateNumConditions() {
    let e = -1, t = !0;
    for (let s = 0; s < this.getNumConditions(); s++)
      this.isConditionUiComplete(s) ? e = s : t = !1;
    if (this.shouldAddNewConditionAtEnd(t))
      this.createJoinOperatorPanel(), this.createOption();
    else {
      const s = this.lastUiCompletePosition ?? this.getNumConditions() - 2;
      if (e < s) {
        this.removeConditionsAndOperators(s + 1);
        const i = e + 1, r = s - i;
        r > 0 && this.removeConditionsAndOperators(i, r), this.createMissingConditionsAndOperators();
      }
    }
    this.lastUiCompletePosition = e;
  }
  updateConditionStatusesAndValues(e, t) {
    this.eTypes.forEach((i, r) => {
      const n = this.isConditionDisabled(r, e);
      i.setDisabled(n || this.filterListOptions.length <= 1), r === 1 && (Bs(this.eJoinOperatorPanels[0], n), this.eJoinOperatorsAnd[0].setDisabled(n), this.eJoinOperatorsOr[0].setDisabled(n));
    }), this.eConditionBodies.forEach((i, r) => {
      re(i, this.isConditionBodyVisible(r));
    });
    const s = (t ?? this.getJoinOperator()) === "OR";
    this.eJoinOperatorsAnd.forEach((i) => {
      i.setValue(!s, !0);
    }), this.eJoinOperatorsOr.forEach((i) => {
      i.setValue(s, !0);
    }), this.forEachInput((i, r, n, o) => {
      this.setElementDisplayed(i, r < o), this.setElementDisabled(i, this.isConditionDisabled(n, e));
    }), this.resetPlaceholder();
  }
  shouldAddNewConditionAtEnd(e) {
    return e && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
  }
  removeConditionsAndOperators(e, t) {
    if (e >= this.getNumConditions())
      return;
    const { eTypes: s, eConditionBodies: i, eJoinOperatorPanels: r, eJoinOperatorsAnd: n, eJoinOperatorsOr: o } = this;
    this.removeComponents(s, e, t), this.removeElements(i, e, t), this.removeValueElements(e, t);
    const a = Math.max(e - 1, 0);
    this.removeElements(r, a, t), this.removeComponents(n, a, t), this.removeComponents(o, a, t);
  }
  removeElements(e, t, s) {
    Zo(e, t, s).forEach((r) => ut(r));
  }
  removeComponents(e, t, s) {
    Zo(e, t, s).forEach((r) => {
      ut(r.getGui()), this.destroyBean(r);
    });
  }
  afterGuiAttached(e) {
    var t;
    if (super.afterGuiAttached(e), this.resetPlaceholder(), !(e != null && e.suppressFocus)) {
      const { eFilterBody: s, eTypes: i } = this;
      let r;
      if (!this.isReadOnly()) {
        const n = this.getInputs(0)[0];
        n instanceof mr && this.isConditionBodyVisible(0) ? r = n.getInputElement() : r = (t = i[0]) == null ? void 0 : t.getFocusableElement();
      }
      (r ?? s).focus({ preventScroll: !0 });
    }
  }
  afterGuiDetached() {
    super.afterGuiDetached();
    const e = this.getModel();
    this.resetUiToActiveModel(e);
    let t = -1, s = -1, i = !1;
    const r = this.getJoinOperator();
    for (let o = this.getNumConditions() - 1; o >= 0; o--)
      if (this.isConditionUiComplete(o))
        t === -1 && (t = o, s = o);
      else {
        const a = o >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(o - 1), l = o < t;
        (a || l) && (this.removeConditionsAndOperators(o, 1), i = !0, l && s--);
      }
    let n = !1;
    this.getNumConditions() < this.numAlwaysVisibleConditions && (this.createMissingConditionsAndOperators(), n = !0), this.shouldAddNewConditionAtEnd(s === this.getNumConditions() - 1) && (this.createJoinOperatorPanel(), this.createOption(), n = !0), n && this.updateConditionStatusesAndValues(s, r), i && this.updateJoinOperatorsDisabled(), this.lastUiCompletePosition = s;
  }
  getPlaceholderText(e, t) {
    let s = this.translate(e);
    if (typeof this.filterPlaceholder == "function") {
      const i = this.eTypes[t].getValue(), r = this.translate(i);
      s = this.filterPlaceholder({
        filterOptionKey: i,
        filterOption: r,
        placeholder: s
      });
    } else typeof this.filterPlaceholder == "string" && (s = this.filterPlaceholder);
    return s;
  }
  // allow sub-classes to reset HTML placeholders after UI update.
  resetPlaceholder() {
    const e = this.getLocaleTextFunc();
    this.forEachInput((t, s, i, r) => {
      if (!(t instanceof mr))
        return;
      const n = s === 0 && r > 1 ? "inRangeStart" : s === 0 ? "filterOoo" : "inRangeEnd", o = s === 0 && r > 1 ? e("ariaFilterFromValue", "Filter from value") : s === 0 ? e("ariaFilterValue", "Filter Value") : e("ariaFilterToValue", "Filter to Value");
      t.setInputPlaceholder(this.getPlaceholderText(n, i)), t.setInputAriaLabel(o);
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setElementValue(e, t, s) {
    e instanceof mr && e.setValue(t != null ? String(t) : null, !0);
  }
  setElementDisplayed(e, t) {
    e instanceof _ && re(e.getGui(), t);
  }
  setElementDisabled(e, t) {
    e instanceof _ && Bs(e.getGui(), t);
  }
  attachElementOnChange(e, t) {
    e instanceof mr && e.onValueChange(t);
  }
  forEachInput(e) {
    this.getConditionTypes().forEach((t, s) => {
      this.forEachPositionTypeInput(s, t, e);
    });
  }
  forEachPositionInput(e, t) {
    const s = this.getConditionType(e);
    this.forEachPositionTypeInput(e, s, t);
  }
  forEachPositionTypeInput(e, t, s) {
    const i = this.getNumberOfInputs(t), r = this.getInputs(e);
    for (let n = 0; n < r.length; n++) {
      const o = r[n];
      o != null && s(o, n, e, i);
    }
  }
  isConditionDisabled(e, t) {
    return this.isReadOnly() ? !0 : e === 0 ? !1 : e > t + 1;
  }
  isConditionBodyVisible(e) {
    const t = this.getConditionType(e);
    return this.getNumberOfInputs(t) > 0;
  }
  // returns true if the UI represents a working filter, eg all parts are filled out.
  // eg if text filter and textfield blank then returns false.
  isConditionUiComplete(e) {
    return !(e >= this.getNumConditions() || this.getConditionType(e) === "empty" || this.getValues(e).some((s) => s == null));
  }
  getNumConditions() {
    return this.eTypes.length;
  }
  getUiCompleteConditions() {
    const e = [];
    for (let t = 0; t < this.getNumConditions(); t++)
      this.isConditionUiComplete(t) && e.push(this.createCondition(t));
    return e;
  }
  createMissingConditionsAndOperators() {
    if (!this.isReadOnly())
      for (let e = this.getNumConditions(); e < this.numAlwaysVisibleConditions; e++)
        this.createJoinOperatorPanel(), this.createOption();
  }
  resetUiToDefaults(e) {
    return this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions), this.eTypes.forEach((t) => this.resetType(t)), this.eJoinOperatorsAnd.forEach(
      (t, s) => this.resetJoinOperatorAnd(t, s, this.joinOperatorId + s)
    ), this.eJoinOperatorsOr.forEach(
      (t, s) => this.resetJoinOperatorOr(t, s, this.joinOperatorId + s)
    ), this.joinOperatorId++, this.forEachInput((t) => this.resetInput(t)), this.resetPlaceholder(), this.createMissingConditionsAndOperators(), this.lastUiCompletePosition = null, e || this.onUiChanged(), fe.resolve();
  }
  resetType(e) {
    const s = this.getLocaleTextFunc()("ariaFilteringOperator", "Filtering operator");
    e.setValue(this.optionsFactory.defaultOption, !0).setAriaLabel(s).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
  }
  resetJoinOperatorAnd(e, t, s) {
    this.resetJoinOperator(
      e,
      t,
      this.defaultJoinOperator === "AND",
      this.translate("andCondition"),
      s
    );
  }
  resetJoinOperatorOr(e, t, s) {
    this.resetJoinOperator(
      e,
      t,
      this.defaultJoinOperator === "OR",
      this.translate("orCondition"),
      s
    );
  }
  resetJoinOperator(e, t, s, i, r) {
    this.updateJoinOperatorDisabled(
      e.setValue(s, !0).setName(`ag-simple-filter-and-or-${this.getCompId()}-${r}`).setLabel(i),
      t
    );
  }
  updateJoinOperatorsDisabled() {
    const e = (t, s) => this.updateJoinOperatorDisabled(t, s);
    this.eJoinOperatorsAnd.forEach(e), this.eJoinOperatorsOr.forEach(e);
  }
  updateJoinOperatorDisabled(e, t) {
    e.setDisabled(this.isReadOnly() || t > 0);
  }
  resetInput(e) {
    this.setElementValue(e, null), this.setElementDisabled(e, this.isReadOnly());
  }
  // puts model values into the UI
  setConditionIntoUi(e, t) {
    const s = this.mapValuesFromModel(e);
    this.forEachInput((i, r, n) => {
      n === t && this.setElementValue(i, s[r] != null ? s[r] : null);
    });
  }
  // after floating filter changes, this sets the 'value' section. this is implemented by the base class
  // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
  setValueFromFloatingFilter(e) {
    this.forEachInput((t, s, i) => {
      this.setElementValue(t, s === 0 && i === 0 ? e : null, !0);
    });
  }
  addChangedListeners(e, t) {
    this.isReadOnly() || (e.onValueChange(this.listener), this.forEachPositionInput(t, (s) => {
      this.attachElementOnChange(s, this.listener);
    }));
  }
  /** returns true if the row passes the said condition */
  individualConditionPasses(e, t) {
    const s = this.getCellValue(e.node), i = this.mapValuesFromModel(t), r = this.optionsFactory.getCustomOption(t.type), n = yk(r, i, s);
    return n ?? (s == null ? this.evaluateNullValue(t.type) : this.evaluateNonNullValue(i, s, t, e));
  }
  hasInvalidInputs() {
    return !1;
  }
}, Fy = class extends Ry {
  setParams(e) {
    super.setParams(e), this.scalarFilterParams = e;
  }
  evaluateNullValue(e) {
    const {
      includeBlanksInEquals: t,
      includeBlanksInNotEqual: s,
      includeBlanksInGreaterThan: i,
      includeBlanksInLessThan: r,
      includeBlanksInRange: n
    } = this.scalarFilterParams;
    switch (e) {
      case "equals":
        if (t)
          return !0;
        break;
      case "notEqual":
        if (s)
          return !0;
        break;
      case "greaterThan":
      case "greaterThanOrEqual":
        if (i)
          return !0;
        break;
      case "lessThan":
      case "lessThanOrEqual":
        if (r)
          return !0;
        break;
      case "inRange":
        if (n)
          return !0;
        break;
      case "blank":
        return !0;
      case "notBlank":
        return !1;
    }
    return !1;
  }
  evaluateNonNullValue(e, t, s) {
    const i = this.comparator(), r = e[0] != null ? i(e[0], t) : 0;
    switch (s.type) {
      case "equals":
        return r === 0;
      case "notEqual":
        return r !== 0;
      case "greaterThan":
        return r > 0;
      case "greaterThanOrEqual":
        return r >= 0;
      case "lessThan":
        return r < 0;
      case "lessThanOrEqual":
        return r <= 0;
      case "inRange": {
        const n = i(e[1], t);
        return this.scalarFilterParams.inRangeInclusive ? r >= 0 && n <= 0 : r > 0 && n < 0;
      }
      case "blank":
        return zl(t);
      case "notBlank":
        return !zl(t);
      default:
        return I(76, { filterModelType: s.type }), !0;
    }
  }
}, Py = class {
  constructor(e, t, s, i, r) {
    this.alive = !0, this.context = e, this.eParent = i;
    const n = JT(t, s);
    n && n.newAgStackInstance().then((o) => {
      var c, d;
      if (!this.alive) {
        e.destroyBean(o);
        return;
      }
      if (this.dateComp = o, !o)
        return;
      i.appendChild(o.getGui()), (c = o == null ? void 0 : o.afterGuiAttached) == null || c.call(o);
      const { tempValue: a, disabled: l } = this;
      a && o.setDate(a), l != null && ((d = o.setDisabled) == null || d.call(o, l)), r == null || r(this);
    });
  }
  destroy() {
    this.alive = !1, this.dateComp = this.context.destroyBean(this.dateComp);
  }
  getDate() {
    return this.dateComp ? this.dateComp.getDate() : this.tempValue;
  }
  setDate(e) {
    const t = this.dateComp;
    t ? t.setDate(e) : this.tempValue = e;
  }
  setDisabled(e) {
    var s;
    const t = this.dateComp;
    t ? (s = t.setDisabled) == null || s.call(t, e) : this.disabled = e;
  }
  setDisplayed(e) {
    re(this.eParent, e);
  }
  setInputPlaceholder(e) {
    var t, s;
    (s = (t = this.dateComp) == null ? void 0 : t.setInputPlaceholder) == null || s.call(t, e);
  }
  setInputAriaLabel(e) {
    var t, s;
    (s = (t = this.dateComp) == null ? void 0 : t.setInputAriaLabel) == null || s.call(t, e);
  }
  afterGuiAttached(e) {
    var t, s;
    (s = (t = this.dateComp) == null ? void 0 : t.afterGuiAttached) == null || s.call(t, e);
  }
  updateParams(e) {
    var t, s;
    (s = (t = this.dateComp) == null ? void 0 : t.refresh) == null || s.call(t, e);
  }
}, Ty = [
  "equals",
  "notEqual",
  "lessThan",
  "greaterThan",
  "inRange",
  "blank",
  "notBlank"
], Uh = class {
  constructor(e, t, s) {
    this.getLocaleTextFunc = e, this.optionsFactory = t, this.valueFormatter = s;
  }
  // used by:
  // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
  // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
  getModelAsString(e) {
    if (!e)
      return null;
    const t = e.operator != null, s = this.getLocaleTextFunc();
    if (t) {
      const i = e, n = (i.conditions ?? []).map((a) => this.getModelAsString(a)), o = i.operator === "AND" ? "andCondition" : "orCondition";
      return n.join(
        ` ${s(o, Sw[o])} `
      );
    } else {
      if (e.type === "blank" || e.type === "notBlank")
        return s(e.type, e.type);
      {
        const i = e, r = this.optionsFactory.getCustomOption(i.type), { displayKey: n, displayName: o, numberOfInputs: a } = r || {};
        return n && o && a === 0 ? (s(n, o), o) : this.conditionToString(i, r);
      }
    }
  }
  updateParams(e) {
    this.optionsFactory = e.optionsFactory;
  }
  formatValue(e) {
    const t = this.valueFormatter;
    return t ? t(e ?? null) ?? "" : String(e);
  }
}, Ey = class extends Uh {
  constructor(e, t, s) {
    super(t, s), this.dateFilterParams = e;
  }
  conditionToString(e, t) {
    const { type: s } = e, { numberOfInputs: i } = t || {}, r = s == "inRange" || i === 2, n = Yt(e.dateFrom), o = Yt(e.dateTo), a = this.dateFilterParams.inRangeFloatingFilterDateFormat;
    if (r) {
      const l = n !== null ? Yo(n, a) : "null", c = o !== null ? Yo(o, a) : "null";
      return `${l}-${c}`;
    }
    return n != null ? Yo(n, a) : `${s}`;
  }
  updateParams(e) {
    super.updateParams(e), this.dateFilterParams = e.dateFilterParams;
  }
}, Cf = 1e3, vf = 1 / 0, Sk = class extends Fy {
  constructor() {
    super("dateFilter"), this.eConditionPanelsFrom = [], this.eConditionPanelsTo = [], this.dateConditionFromComps = [], this.dateConditionToComps = [], this.minValidYear = Cf, this.maxValidYear = vf, this.minValidDate = null, this.maxValidDate = null, this.filterType = "date";
  }
  afterGuiAttached(e) {
    super.afterGuiAttached(e), this.dateConditionFromComps[0].afterGuiAttached(e);
  }
  mapValuesFromModel(e) {
    const { dateFrom: t, dateTo: s, type: i } = e || {};
    return [
      t && Yt(t) || null,
      s && Yt(s) || null
    ].slice(0, this.getNumberOfInputs(i));
  }
  comparator() {
    return this.dateFilterParams.comparator ?? xk;
  }
  setParams(e) {
    this.dateFilterParams = e, super.setParams(e);
    const t = (s, i) => {
      if (e[s] != null)
        if (isNaN(e[s]))
          I(82, { param: s });
        else
          return e[s] == null ? i : Number(e[s]);
      return i;
    };
    this.minValidYear = t("minValidYear", Cf), this.maxValidYear = t("maxValidYear", vf), this.minValidYear > this.maxValidYear && I(83), this.minValidDate = e.minValidDate ? e.minValidDate instanceof Date ? e.minValidDate : Yt(e.minValidDate) : null, this.maxValidDate = e.maxValidDate ? e.maxValidDate instanceof Date ? e.maxValidDate : Yt(e.maxValidDate) : null, this.minValidDate && this.maxValidDate && this.minValidDate > this.maxValidDate && I(84), this.filterModelFormatter = new Ey(
      this.dateFilterParams,
      this.getLocaleTextFunc.bind(this),
      this.optionsFactory
    );
  }
  createDateCompWrapper(e) {
    const { userCompFactory: t, context: s } = this.beans, i = new Py(
      s,
      t,
      {
        onDateChanged: () => this.onUiChanged(),
        filterParams: this.dateFilterParams,
        location: "filter"
      },
      e
    );
    return this.addDestroyFunc(() => i.destroy()), i;
  }
  setElementValue(e, t) {
    e.setDate(t);
  }
  setElementDisplayed(e, t) {
    e.setDisplayed(t);
  }
  setElementDisabled(e, t) {
    e.setDisabled(t);
  }
  getDefaultFilterOptions() {
    return Ty;
  }
  createValueElement() {
    const t = We(this.beans).createElement("div");
    return t.classList.add("ag-filter-body"), this.createFromToElement(t, this.eConditionPanelsFrom, this.dateConditionFromComps, "from"), this.createFromToElement(t, this.eConditionPanelsTo, this.dateConditionToComps, "to"), t;
  }
  createFromToElement(e, t, s, i) {
    const n = We(this.beans).createElement("div");
    n.classList.add(`ag-filter-${i}`), n.classList.add(`ag-filter-date-${i}`), t.push(n), e.appendChild(n), s.push(this.createDateCompWrapper(n));
  }
  removeValueElements(e, t) {
    this.removeDateComps(this.dateConditionFromComps, e, t), this.removeDateComps(this.dateConditionToComps, e, t), Zo(this.eConditionPanelsFrom, e, t), Zo(this.eConditionPanelsTo, e, t);
  }
  removeDateComps(e, t, s) {
    Zo(e, t, s).forEach((r) => r.destroy());
  }
  isValidDateValue(e) {
    if (e === null)
      return !1;
    const { minValidDate: t, maxValidDate: s, minValidYear: i, maxValidYear: r } = this;
    if (t) {
      if (e < t)
        return !1;
    } else if (e.getUTCFullYear() < i)
      return !1;
    if (s) {
      if (e > s)
        return !1;
    } else if (e.getUTCFullYear() > r)
      return !1;
    return !0;
  }
  isConditionUiComplete(e) {
    if (!super.isConditionUiComplete(e))
      return !1;
    let t = !0;
    return this.forEachInput((s, i, r, n) => {
      r !== e || !t || i >= n || (t = t && this.isValidDateValue(s.getDate()));
    }), t;
  }
  areSimpleModelsEqual(e, t) {
    return e.dateFrom === t.dateFrom && e.dateTo === t.dateTo && e.type === t.type;
  }
  createCondition(e) {
    const t = this.getConditionType(e), s = {}, i = this.getValues(e);
    return i.length > 0 && (s.dateFrom = ys(i[0])), i.length > 1 && (s.dateTo = ys(i[1])), {
      dateFrom: null,
      dateTo: null,
      filterType: this.filterType,
      type: t,
      ...s
    };
  }
  resetPlaceholder() {
    const e = this.getLocaleTextFunc(), t = this.translate("dateFormatOoo"), s = e("ariaFilterValue", "Filter Value");
    this.forEachInput((i) => {
      i.setInputPlaceholder(t), i.setInputAriaLabel(s);
    });
  }
  getInputs(e) {
    const { dateConditionFromComps: t, dateConditionToComps: s } = this;
    return e >= t.length ? [null, null] : [t[e], s[e]];
  }
  getValues(e) {
    const t = [];
    return this.forEachPositionInput(e, (s, i, r, n) => {
      i < n && t.push(s.getDate());
    }), t;
  }
  translate(e) {
    return e === "lessThan" ? super.translate("before") : e === "greaterThan" ? super.translate("after") : super.translate(e);
  }
  getModelAsString(e) {
    return this.filterModelFormatter.getModelAsString(e) ?? "";
  }
};
function xk(e, t) {
  const s = t;
  return t == null || s < e ? -1 : s > e ? 1 : 0;
}
var Dy = class extends _ {
  constructor() {
    super(...arguments), this.defaultDebounceMs = 0;
  }
  setLastTypeFromModel(e) {
    if (!e) {
      this.lastType = this.optionsFactory.defaultOption;
      return;
    }
    const t = e.operator;
    let s;
    t ? s = e.conditions[0] : s = e, this.lastType = s.type;
  }
  canWeEditAfterModelFromParentFilter(e) {
    if (!e)
      return this.isTypeEditable(this.lastType);
    if (e.operator)
      return !1;
    const s = e;
    return this.isTypeEditable(s.type);
  }
  init(e) {
    this.setSimpleParams(e, !1);
  }
  setSimpleParams(e, t = !0) {
    const s = new xy();
    this.optionsFactory = s, s.init(e.filterParams, this.getDefaultOptions());
    const i = s.defaultOption;
    t || (this.lastType = i), this.readOnly = !!e.filterParams.readOnly;
    const r = this.isTypeEditable(i);
    this.setEditable(r);
  }
  refresh(e) {
    this.setSimpleParams(e);
  }
  hasSingleInput(e) {
    var s;
    const t = (s = this.optionsFactory.getCustomOption(e)) == null ? void 0 : s.numberOfInputs;
    return t == null || t == 1;
  }
  isTypeEditable(e) {
    const t = ["inRange", "empty", "blank", "notBlank"];
    return !!e && !this.readOnly && this.hasSingleInput(e) && t.indexOf(e) < 0;
  }
  getAriaLabel(e) {
    return `${this.beans.colNames.getDisplayNameForColumn(e.column, "header", !0)} ${this.getLocaleTextFunc()("ariaFilterInput", "Filter Input")}`;
  }
}, Rk = class extends Dy {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field data-ref="eReadOnlyText"></ag-input-text-field>
                <div data-ref="eDateWrapper" style="display: flex;"></div>
            </div>`,
      [Ks]
    ), this.eReadOnlyText = E, this.eDateWrapper = E;
  }
  getDefaultOptions() {
    return Ty;
  }
  init(e) {
    super.init(e), this.params = e, this.filterParams = e.filterParams, this.createDateComponent(), this.filterModelFormatter = new Ey(
      this.filterParams,
      this.getLocaleTextFunc.bind(this),
      this.optionsFactory
    );
    const t = this.getLocaleTextFunc();
    this.eReadOnlyText.setDisabled(!0).setInputAriaLabel(t("ariaDateFilterInput", "Date Filter Input"));
  }
  refresh(e) {
    super.refresh(e), this.params = e, this.filterParams = e.filterParams;
    const t = this.gos.addGridCommonParams(this.getDateComponentParams());
    this.dateComp.updateParams(t), this.filterModelFormatter.updateParams({
      optionsFactory: this.optionsFactory,
      dateFilterParams: this.filterParams
    }), this.updateCompOnModelChange(e.currentParentModel());
  }
  updateCompOnModelChange(e) {
    const t = !this.readOnly && this.canWeEditAfterModelFromParentFilter(e);
    if (this.setEditable(t), t) {
      const s = e ? Yt(e.dateFrom) : null;
      this.dateComp.setDate(s), this.eReadOnlyText.setValue("");
    } else
      this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(e)), this.dateComp.setDate(null);
  }
  setEditable(e) {
    re(this.eDateWrapper, e), re(this.eReadOnlyText.getGui(), !e);
  }
  onParentModelChanged(e, t) {
    t != null && t.afterFloatingFilter || t != null && t.afterDataChange || (super.setLastTypeFromModel(e), this.updateCompOnModelChange(e));
  }
  onDateChanged() {
    const e = this.dateComp.getDate(), t = ys(e);
    this.params.parentFilterInstance((s) => {
      if (s) {
        const i = Yt(t);
        s.onFloatingFilterChanged(this.lastType || null, i);
      }
    });
  }
  getDateComponentParams() {
    const { filterParams: e, column: t } = this.params, s = bh(e, this.defaultDebounceMs);
    return {
      onDateChanged: Et(this, this.onDateChanged.bind(this), s),
      filterParams: t.getColDef().filterParams,
      location: "floatingFilter"
    };
  }
  createDateComponent() {
    const {
      beans: { context: e, userCompFactory: t },
      eDateWrapper: s
    } = this;
    this.dateComp = new Py(
      e,
      t,
      this.getDateComponentParams(),
      s,
      (i) => {
        i.setInputAriaLabel(this.getAriaLabel(this.params));
      }
    ), this.addDestroyFunc(() => this.dateComp.destroy());
  }
}, Fk = class extends _ {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-filter-filter">
                <ag-input-text-field class="ag-date-filter" data-ref="eDateInput"></ag-input-text-field>
            </div>`,
      [Ks]
    ), this.eDateInput = E, this.isApply = !1, this.applyOnFocusOut = !1;
  }
  init(e) {
    this.params = e, this.setParams(e);
    const t = this.eDateInput.getInputElement();
    this.addManagedListeners(t, {
      // ensures that the input element is focussed when a clear button is clicked,
      // unless using safari as there is no clear button and focus does not work properly
      mouseDown: () => {
        this.eDateInput.isDisabled() || this.usingSafariDatePicker || t.focus({ preventScroll: !0 });
      },
      input: this.handleInput.bind(this, !1),
      change: this.handleInput.bind(this, !0),
      focusout: this.handleFocusOut.bind(this)
    });
  }
  handleInput(e, t) {
    if (t.target === Ie(this.beans) && !this.eDateInput.isDisabled()) {
      if (this.isApply) {
        this.applyOnFocusOut = !e, e && this.params.onDateChanged();
        return;
      }
      e || this.params.onDateChanged();
    }
  }
  handleFocusOut() {
    this.applyOnFocusOut && (this.applyOnFocusOut = !1, this.params.onDateChanged());
  }
  setParams(e) {
    const t = this.eDateInput.getInputElement(), s = this.shouldUseBrowserDatePicker(e);
    this.usingSafariDatePicker = s && Rn(), t.type = s ? "date" : "text";
    const { minValidYear: i, maxValidYear: r, minValidDate: n, maxValidDate: o, buttons: a } = e.filterParams || {};
    if (n && i && I(85), o && r && I(86), n && o) {
      const [l, c] = [n, o].map(
        (d) => d instanceof Date ? d : Yt(d)
      );
      l && c && l.getTime() > c.getTime() && I(87);
    }
    n ? n instanceof Date ? t.min = Yo(n) : t.min = n : i && (t.min = `${i}-01-01`), o ? o instanceof Date ? t.max = Yo(o) : t.max = o : r && (t.max = `${r}-12-31`), this.isApply = e.location === "floatingFilter" && !!(a != null && a.includes("apply"));
  }
  refresh(e) {
    this.params = e, this.setParams(e);
  }
  getDate() {
    return Yt(this.eDateInput.getValue());
  }
  setDate(e) {
    this.eDateInput.setValue(ys(e, !1));
  }
  setInputPlaceholder(e) {
    this.eDateInput.setInputPlaceholder(e);
  }
  setInputAriaLabel(e) {
    this.eDateInput.setAriaLabel(e);
  }
  setDisabled(e) {
    this.eDateInput.setDisabled(e);
  }
  afterGuiAttached(e) {
    (!e || !e.suppressFocus) && this.eDateInput.getInputElement().focus({ preventScroll: !0 });
  }
  shouldUseBrowserDatePicker(e) {
    var t;
    return ((t = e == null ? void 0 : e.filterParams) == null ? void 0 : t.browserDatePicker) ?? !0;
  }
}, Ay = [
  "equals",
  "notEqual",
  "greaterThan",
  "greaterThanOrEqual",
  "lessThan",
  "lessThanOrEqual",
  "inRange",
  "blank",
  "notBlank"
], My = class extends Uh {
  conditionToString(e, t) {
    const { numberOfInputs: s } = t || {}, { filter: i, filterTo: r, type: n } = e, o = n == "inRange" || s === 2, a = this.formatValue.bind(this);
    return o ? `${a(i)}-${a(r)}` : i != null ? a(i) : `${n}`;
  }
};
function wu(e) {
  const { allowedCharPattern: t } = e ?? {};
  return t ?? null;
}
var Pk = class extends Fy {
  constructor() {
    super("numberFilter"), this.eValuesFrom = [], this.eValuesTo = [], this.filterType = "number", this.defaultDebounceMs = 500;
  }
  refresh(e) {
    return this.numberFilterParams.allowedCharPattern !== e.allowedCharPattern ? !1 : super.refresh(e);
  }
  mapValuesFromModel(e) {
    const { filter: t, filterTo: s, type: i } = e || {};
    return [this.processValue(t), this.processValue(s)].slice(0, this.getNumberOfInputs(i));
  }
  comparator() {
    return (e, t) => e === t ? 0 : e < t ? 1 : -1;
  }
  setParams(e) {
    this.numberFilterParams = e, super.setParams(e), this.filterModelFormatter = new My(
      this.getLocaleTextFunc.bind(this),
      this.optionsFactory,
      this.numberFilterParams.numberFormatter
    );
  }
  getDefaultFilterOptions() {
    return Ay;
  }
  setElementValue(e, t, s) {
    const { numberFormatter: i } = this.numberFilterParams, r = !s && i ? i(t ?? null) : t;
    super.setElementValue(e, r);
  }
  createValueElement() {
    const e = wu(this.numberFilterParams), t = document.createElement("div");
    return t.classList.add("ag-filter-body"), nt(t, "presentation"), this.createFromToElement(t, this.eValuesFrom, "from", e), this.createFromToElement(t, this.eValuesTo, "to", e), t;
  }
  createFromToElement(e, t, s, i) {
    const r = this.createManagedBean(
      i ? new li({ allowedCharPattern: i }) : new vc()
    );
    r.addCssClass(`ag-filter-${s}`), r.addCssClass("ag-filter-filter"), t.push(r), e.appendChild(r.getGui());
  }
  removeValueElements(e, t) {
    const s = (i) => this.removeComponents(i, e, t);
    s(this.eValuesFrom), s(this.eValuesTo);
  }
  getValues(e) {
    const t = [];
    return this.forEachPositionInput(e, (s, i, r, n) => {
      i < n && t.push(this.processValue(this.stringToFloat(s.getValue())));
    }), t;
  }
  areSimpleModelsEqual(e, t) {
    return e.filter === t.filter && e.filterTo === t.filterTo && e.type === t.type;
  }
  processValue(e) {
    return e == null || isNaN(e) ? null : e;
  }
  stringToFloat(e) {
    if (typeof e == "number")
      return e;
    let t = St(e);
    t != null && t.trim() === "" && (t = null);
    const s = this.numberFilterParams.numberParser;
    return s ? s(t) : t == null || t.trim() === "-" ? null : parseFloat(t);
  }
  createCondition(e) {
    const t = this.getConditionType(e), s = {
      filterType: this.filterType,
      type: t
    }, i = this.getValues(e);
    return i.length > 0 && (s.filter = i[0]), i.length > 1 && (s.filterTo = i[1]), s;
  }
  getInputs(e) {
    const { eValuesFrom: t, eValuesTo: s } = this;
    return e >= t.length ? [null, null] : [t[e], s[e]];
  }
  getModelAsString(e) {
    return this.filterModelFormatter.getModelAsString(e) ?? "";
  }
  hasInvalidInputs() {
    let e = !1;
    return this.forEachInput((t) => {
      if (!t.getInputElement().validity.valid) {
        e = !0;
        return;
      }
    }), e;
  }
}, Iy = class extends L {
  constructor(e) {
    super(), this.params = e, this.eInput = E, this.onValueChanged = () => {
    };
  }
  setupGui(e) {
    var i;
    this.eInput = this.createManagedBean(new li((i = this.params) == null ? void 0 : i.config));
    const t = this.eInput.getGui();
    e.appendChild(t);
    const s = (r) => this.onValueChanged(r);
    this.addManagedListeners(t, {
      input: s,
      keydown: s
    });
  }
  setEditable(e) {
    this.eInput.setDisabled(!e);
  }
  getValue() {
    return this.eInput.getValue();
  }
  setValue(e, t) {
    this.eInput.setValue(e, t);
  }
  setValueChangedListener(e) {
    this.onValueChanged = e;
  }
  setParams({ ariaLabel: e, autoComplete: t }) {
    const { eInput: s } = this;
    s.setInputAriaLabel(e), t !== void 0 && s.setAutoComplete(t);
  }
};
function Ly(e) {
  const t = e == null ? void 0 : e.trim();
  return t === "" ? e : t;
}
var ky = class extends Dy {
  constructor() {
    super(...arguments), this.eFloatingFilterInputContainer = E, this.defaultDebounceMs = 500;
  }
  postConstruct() {
    this.setTemplate(
      /* html */
      `
            <div class="ag-floating-filter-input" role="presentation" data-ref="eFloatingFilterInputContainer"></div>
        `
    );
  }
  onParentModelChanged(e, t) {
    t != null && t.afterFloatingFilter || t != null && t.afterDataChange || (this.setLastTypeFromModel(e), this.setEditable(this.canWeEditAfterModelFromParentFilter(e)), this.inputSvc.setValue(this.filterModelFormatter.getModelAsString(e)));
  }
  init(e) {
    this.setupFloatingFilterInputService(e), super.init(e), this.setTextInputParams(e);
  }
  setupFloatingFilterInputService(e) {
    this.inputSvc = this.createFloatingFilterInputService(e), this.inputSvc.setupGui(this.eFloatingFilterInputContainer);
  }
  setTextInputParams(e) {
    this.params = e;
    const t = e.browserAutoComplete ?? !1, { inputSvc: s, defaultDebounceMs: i, readOnly: r } = this;
    if (s.setParams({
      ariaLabel: this.getAriaLabel(e),
      autoComplete: t
    }), this.applyActive = Bl(e.filterParams), !r) {
      const n = bh(e.filterParams, i), o = Et(
        this,
        this.syncUpWithParentFilter.bind(this),
        n
      );
      s.setValueChangedListener(o);
    }
  }
  refresh(e) {
    super.refresh(e), this.setTextInputParams(e);
  }
  recreateFloatingFilterInputService(e) {
    const { inputSvc: t } = this, s = t.getValue();
    ze(this.eFloatingFilterInputContainer), this.destroyBean(t), this.setupFloatingFilterInputService(e), t.setValue(s, !0);
  }
  syncUpWithParentFilter(e) {
    const t = e.key === P.ENTER;
    if (this.applyActive && !t)
      return;
    const { inputSvc: s, params: i } = this;
    let r = s.getValue();
    i.filterParams.trimInput && (r = Ly(r), s.setValue(r, !0)), i.parentFilterInstance((n) => {
      n == null || n.onFloatingFilterChanged(this.lastType || null, r || null);
    });
  }
  setEditable(e) {
    this.inputSvc.setEditable(e);
  }
}, Tk = class extends L {
  constructor() {
    super(...arguments), this.onValueChanged = () => {
    }, this.numberInputActive = !0;
  }
  setupGui(e) {
    this.eNumberInput = this.createManagedBean(new vc()), this.eTextInput = this.createManagedBean(new li()), this.eTextInput.setDisabled(!0);
    const t = this.eNumberInput.getGui(), s = this.eTextInput.getGui();
    e.appendChild(t), e.appendChild(s), this.setupListeners(t, (i) => this.onValueChanged(i)), this.setupListeners(s, (i) => this.onValueChanged(i));
  }
  setEditable(e) {
    this.numberInputActive = e, this.eNumberInput.setDisplayed(this.numberInputActive), this.eTextInput.setDisplayed(!this.numberInputActive);
  }
  setAutoComplete(e) {
    this.eNumberInput.setAutoComplete(e), this.eTextInput.setAutoComplete(e);
  }
  getValue() {
    return this.getActiveInputElement().getValue();
  }
  setValue(e, t) {
    this.getActiveInputElement().setValue(e, t);
  }
  getActiveInputElement() {
    return this.numberInputActive ? this.eNumberInput : this.eTextInput;
  }
  setValueChangedListener(e) {
    this.onValueChanged = e;
  }
  setupListeners(e, t) {
    this.addManagedListeners(e, {
      input: t,
      keydown: t
    });
  }
  setParams(e) {
    this.setAriaLabel(e.ariaLabel), e.autoComplete !== void 0 && this.setAutoComplete(e.autoComplete);
  }
  setAriaLabel(e) {
    this.eNumberInput.setInputAriaLabel(e), this.eTextInput.setInputAriaLabel(e);
  }
}, Ek = class extends ky {
  init(e) {
    var t;
    super.init(e), this.filterModelFormatter = new My(
      this.getLocaleTextFunc.bind(this),
      this.optionsFactory,
      (t = e.filterParams) == null ? void 0 : t.numberFormatter
    );
  }
  refresh(e) {
    wu(e.filterParams) !== this.allowedCharPattern && this.recreateFloatingFilterInputService(e), super.refresh(e), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory });
  }
  getDefaultOptions() {
    return Ay;
  }
  createFloatingFilterInputService(e) {
    return this.allowedCharPattern = wu(e.filterParams), this.allowedCharPattern ? this.createManagedBean(
      new Iy({
        config: { allowedCharPattern: this.allowedCharPattern }
      })
    ) : this.createManagedBean(new Tk());
  }
}, Oy = [
  "contains",
  "notContains",
  "equals",
  "notEqual",
  "startsWith",
  "endsWith",
  "blank",
  "notBlank"
], Gy = class extends Uh {
  conditionToString(e, t) {
    const { numberOfInputs: s } = t || {}, { filter: i, filterTo: r, type: n } = e;
    return n == "inRange" || s === 2 ? `${i}-${r}` : i != null ? `${i}` : `${n}`;
  }
}, Dk = class extends Ry {
  constructor() {
    super("textFilter"), this.filterType = "text", this.defaultFormatter = (e) => e, this.defaultLowercaseFormatter = (e) => e == null ? null : e.toString().toLowerCase(), this.defaultMatcher = ({ filterOption: e, value: t, filterText: s }) => {
      if (s == null)
        return !1;
      switch (e) {
        case "contains":
          return t.indexOf(s) >= 0;
        case "notContains":
          return t.indexOf(s) < 0;
        case "equals":
          return t === s;
        case "notEqual":
          return t != s;
        case "startsWith":
          return t.indexOf(s) === 0;
        case "endsWith": {
          const i = t.lastIndexOf(s);
          return i >= 0 && i === t.length - s.length;
        }
        default:
          return !1;
      }
    }, this.eValuesFrom = [], this.eValuesTo = [], this.defaultDebounceMs = 500;
  }
  setParams(e) {
    this.textFilterParams = e, super.setParams(e), this.matcher = e.textMatcher || this.defaultMatcher, this.formatter = e.textFormatter || (e.caseSensitive ? this.defaultFormatter : this.defaultLowercaseFormatter), this.filterModelFormatter = new Gy(
      this.getLocaleTextFunc.bind(this),
      this.optionsFactory
    );
  }
  createCondition(e) {
    const t = this.getConditionType(e), s = {
      filterType: this.filterType,
      type: t
    }, i = this.getValuesWithSideEffects(e, !0);
    return i.length > 0 && (s.filter = i[0]), i.length > 1 && (s.filterTo = i[1]), s;
  }
  areSimpleModelsEqual(e, t) {
    return e.filter === t.filter && e.filterTo === t.filterTo && e.type === t.type;
  }
  getInputs(e) {
    const { eValuesFrom: t, eValuesTo: s } = this;
    return e >= t.length ? [null, null] : [t[e], s[e]];
  }
  getValues(e) {
    return this.getValuesWithSideEffects(e, !1);
  }
  getValuesWithSideEffects(e, t) {
    const s = [];
    return this.forEachPositionInput(e, (i, r, n, o) => {
      if (r < o) {
        let a = St(i.getValue());
        t && this.textFilterParams.trimInput && (a = Ly(a) ?? null, i.setValue(a, !0)), s.push(a);
      }
    }), s;
  }
  getDefaultFilterOptions() {
    return Oy;
  }
  createValueElement() {
    const e = document.createElement("div");
    return e.classList.add("ag-filter-body"), nt(e, "presentation"), this.createFromToElement(e, this.eValuesFrom, "from"), this.createFromToElement(e, this.eValuesTo, "to"), e;
  }
  createFromToElement(e, t, s) {
    const i = this.createManagedBean(new li());
    i.addCssClass(`ag-filter-${s}`), i.addCssClass("ag-filter-filter"), t.push(i), e.appendChild(i.getGui());
  }
  removeValueElements(e, t) {
    const s = (i) => this.removeComponents(i, e, t);
    s(this.eValuesFrom), s(this.eValuesTo);
  }
  mapValuesFromModel(e) {
    const { filter: t, filterTo: s, type: i } = e || {};
    return [t || null, s || null].slice(0, this.getNumberOfInputs(i));
  }
  evaluateNullValue(e) {
    return e ? ["notEqual", "notContains", "blank"].indexOf(e) >= 0 : !1;
  }
  evaluateNonNullValue(e, t, s, i) {
    const r = e.map((h) => this.formatter(h)) || [], n = this.formatter(t), { api: o, colDef: a, column: l, context: c, textFormatter: d } = this.textFilterParams;
    if (s.type === "blank")
      return zl(t);
    if (s.type === "notBlank")
      return !zl(t);
    const u = {
      api: o,
      colDef: a,
      column: l,
      context: c,
      node: i.node,
      data: i.data,
      filterOption: s.type,
      value: n,
      textFormatter: d
    };
    return r.some((h) => this.matcher({ ...u, filterText: h }));
  }
  getModelAsString(e) {
    return this.filterModelFormatter.getModelAsString(e) ?? "";
  }
}, Ak = class extends ky {
  init(e) {
    super.init(e), this.filterModelFormatter = new Gy(
      this.getLocaleTextFunc.bind(this),
      this.optionsFactory
    );
  }
  refresh(e) {
    super.refresh(e), this.filterModelFormatter.updateParams({ optionsFactory: this.optionsFactory });
  }
  getDefaultOptions() {
    return Oy;
  }
  createFloatingFilterInputService() {
    return this.createManagedBean(new Iy());
  }
};
function Mk(e) {
  var t;
  return !!((t = e.filterManager) != null && t.isQuickFilterPresent());
}
function Ik(e) {
  return e.gos.get("quickFilterText");
}
function Lk(e) {
  var t;
  (t = e.filterManager) == null || t.resetQuickFilterCache();
}
var kk = class extends L {
  constructor() {
    super(...arguments), this.beanName = "quickFilter", this.quickFilter = null, this.quickFilterParts = null;
  }
  postConstruct() {
    const e = this.resetCache.bind(this), t = this.gos;
    this.addManagedEventListeners({
      columnPivotModeChanged: e,
      newColumnsLoaded: e,
      columnRowGroupChanged: e,
      columnVisible: () => {
        t.get("includeHiddenColumnsInQuickFilter") || this.resetCache();
      }
    }), this.addManagedPropertyListener("quickFilterText", (s) => this.setFilter(s.currentValue)), this.addManagedPropertyListeners(
      ["includeHiddenColumnsInQuickFilter", "applyQuickFilterBeforePivotOrAgg"],
      () => this.onColumnConfigChanged()
    ), this.quickFilter = this.parseFilter(t.get("quickFilterText")), this.parser = t.get("quickFilterParser"), this.matcher = t.get("quickFilterMatcher"), this.setFilterParts(), this.addManagedPropertyListeners(["quickFilterMatcher", "quickFilterParser"], () => this.setParserAndMatcher());
  }
  // if we are using autoGroupCols, then they should be included for quick filter. this covers the
  // following scenarios:
  // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
  // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
  //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
  refreshCols() {
    var l;
    const { autoColSvc: e, colModel: t, gos: s, pivotResultCols: i } = this.beans, r = t.isPivotMode(), n = e == null ? void 0 : e.getAutoCols(), o = t.getColDefCols();
    let a = (r && !s.get("applyQuickFilterBeforePivotOrAgg") ? (l = i == null ? void 0 : i.getPivotResultCols()) == null ? void 0 : l.list : o) ?? [];
    n && (a = a.concat(n)), this.colsToUse = s.get("includeHiddenColumnsInQuickFilter") ? a : a.filter((c) => c.isVisible() || c.isRowGroupActive());
  }
  isFilterPresent() {
    return this.quickFilter !== null;
  }
  doesRowPass(e) {
    const t = this.gos.get("cacheQuickFilter");
    return this.matcher ? this.doesRowPassMatcher(t, e) : this.quickFilterParts.every(
      (s) => t ? this.doesRowPassCache(e, s) : this.doesRowPassNoCache(e, s)
    );
  }
  resetCache() {
    this.beans.rowModel.forEachNode((e) => e.quickFilterAggregateText = null);
  }
  setFilterParts() {
    const { quickFilter: e, parser: t } = this;
    e ? this.quickFilterParts = t ? t(e) : e.split(" ") : this.quickFilterParts = null;
  }
  parseFilter(e) {
    return W(e) ? e.toUpperCase() : null;
  }
  setFilter(e) {
    if (e != null && typeof e != "string") {
      I(70, { newFilter: e });
      return;
    }
    const t = this.parseFilter(e);
    this.quickFilter !== t && (this.quickFilter = t, this.setFilterParts(), this.dispatchLocalEvent({ type: "quickFilterChanged" }));
  }
  setParserAndMatcher() {
    const e = this.gos.get("quickFilterParser"), t = this.gos.get("quickFilterMatcher"), s = e !== this.parser || t !== this.matcher;
    this.parser = e, this.matcher = t, s && (this.setFilterParts(), this.dispatchLocalEvent({ type: "quickFilterChanged" }));
  }
  onColumnConfigChanged() {
    this.refreshCols(), this.resetCache(), this.isFilterPresent() && this.dispatchLocalEvent({ type: "quickFilterChanged" });
  }
  doesRowPassNoCache(e, t) {
    return this.colsToUse.some((s) => {
      const i = this.getTextForColumn(s, e);
      return W(i) && i.indexOf(t) >= 0;
    });
  }
  doesRowPassCache(e, t) {
    return this.checkGenerateAggText(e), e.quickFilterAggregateText.indexOf(t) >= 0;
  }
  doesRowPassMatcher(e, t) {
    let s;
    e ? (this.checkGenerateAggText(t), s = t.quickFilterAggregateText) : s = this.getAggText(t);
    const { quickFilterParts: i, matcher: r } = this;
    return r(i, s);
  }
  checkGenerateAggText(e) {
    e.quickFilterAggregateText || (e.quickFilterAggregateText = this.getAggText(e));
  }
  getTextForColumn(e, t) {
    let s = this.beans.filterValueSvc.getValue(e, t);
    const i = e.getColDef();
    if (i.getQuickFilterText) {
      const r = this.gos.addGridCommonParams({
        value: s,
        node: t,
        data: t.data,
        column: e,
        colDef: i
      });
      s = i.getQuickFilterText(r);
    }
    return W(s) ? s.toString().toUpperCase() : null;
  }
  getAggText(e) {
    const t = [];
    return this.colsToUse.forEach((s) => {
      const i = this.getTextForColumn(s, e);
      W(i) && t.push(i);
    }), t.join(`
`);
  }
}, Ok = {
  moduleName: "ClientSideRowModelFilter",
  version: de,
  rowModels: ["clientSide"],
  beans: [Y0]
}, Fc = {
  moduleName: "FilterCore",
  version: de,
  beans: [fk],
  apiFunctions: {
    isAnyFilterPresent: pk,
    onFilterChanged: gk
  },
  css: [sk],
  dependsOn: [Ok]
}, $h = {
  moduleName: "FilterValue",
  version: de,
  beans: [Ck]
}, kr = {
  moduleName: "ColumnFilter",
  version: de,
  beans: [hk, mk],
  dynamicBeans: { headerFilterCellCtrl: X0 },
  icons: {
    // open filter button - header, floating filter, menu
    filter: "filter",
    // filter is applied - header (legacy column menu), filter tool panel
    filterActive: "filter"
  },
  apiFunctions: {
    isColumnFilterPresent: ik,
    getColumnFilterInstance: rk,
    destroyFilter: nk,
    setFilterModel: ok,
    getFilterModel: ak,
    getColumnFilterModel: lk,
    setColumnFilterModel: ck,
    showColumnFilter: dk
  },
  dependsOn: [Fc, Yi, $h, Sy]
}, Gk = {
  moduleName: "CustomFilter",
  version: de,
  userComponents: { agReadOnlyFloatingFilter: vk },
  dependsOn: [kr]
}, Bk = {
  moduleName: "TextFilter",
  version: de,
  dependsOn: [kr],
  userComponents: {
    agTextColumnFilter: Dk,
    agTextColumnFloatingFilter: Ak
  }
}, Vk = {
  moduleName: "NumberFilter",
  version: de,
  dependsOn: [kr],
  userComponents: {
    agNumberColumnFilter: Pk,
    agNumberColumnFloatingFilter: Ek
  }
}, Nk = {
  moduleName: "DateFilter",
  version: de,
  dependsOn: [kr],
  userComponents: {
    agDateColumnFilter: Sk,
    agDateInput: Fk,
    agDateColumnFloatingFilter: Rk
  }
}, Hk = {
  moduleName: "QuickFilter",
  version: de,
  rowModels: ["clientSide"],
  beans: [kk],
  apiFunctions: {
    isQuickFilterPresent: Mk,
    getQuickFilter: Ik,
    resetQuickFilter: Lk
  },
  dependsOn: [Fc, $h]
}, zk = {
  moduleName: "ExternalFilter",
  version: de,
  dependsOn: [Fc]
}, Ho = class {
  constructor(e) {
    this.cellValueChanges = e;
  }
}, Td = class extends Ho {
  constructor(e, t, s, i) {
    super(e), this.initialRange = t, this.finalRange = s, this.ranges = i;
  }
}, Wk = 10, wf = class {
  constructor(e) {
    this.actionStack = [], this.maxStackSize = e || Wk, this.actionStack = new Array(this.maxStackSize);
  }
  pop() {
    return this.actionStack.pop();
  }
  push(e) {
    e.cellValueChanges && e.cellValueChanges.length > 0 && (this.actionStack.length === this.maxStackSize && this.actionStack.shift(), this.actionStack.push(e));
  }
  clear() {
    this.actionStack = [];
  }
  getCurrentStackSize() {
    return this.actionStack.length;
  }
}, _k = class extends L {
  constructor() {
    super(...arguments), this.beanName = "undoRedo", this.cellValueChanges = [], this.activeCellEdit = null, this.activeRowEdit = null, this.isPasting = !1, this.isRangeInAction = !1, this.onCellValueChanged = (e) => {
      const t = { column: e.column, rowIndex: e.rowIndex, rowPinned: e.rowPinned }, s = this.activeCellEdit !== null && Jn(this.activeCellEdit, t), i = this.activeRowEdit !== null && Pt(this.activeRowEdit, t);
      if (!(s || i || this.isPasting || this.isRangeInAction))
        return;
      const { rowPinned: n, rowIndex: o, column: a, oldValue: l, value: c } = e, d = {
        rowPinned: n,
        rowIndex: o,
        columnId: a.getColId(),
        newValue: c,
        oldValue: l
      };
      this.cellValueChanges.push(d);
    }, this.clearStacks = () => {
      this.undoStack.clear(), this.redoStack.clear();
    };
  }
  postConstruct() {
    const { gos: e, ctrlsSvc: t } = this.beans;
    if (!e.get("undoRedoCellEditing"))
      return;
    const s = e.get("undoRedoCellEditingLimit");
    if (s <= 0)
      return;
    this.undoStack = new wf(s), this.redoStack = new wf(s), this.addListeners();
    const i = this.clearStacks.bind(this);
    this.addManagedEventListeners({
      cellValueChanged: this.onCellValueChanged.bind(this),
      // undo / redo is restricted to actual editing so we clear the stacks when other operations are
      // performed that change the order of the row / cols.
      modelUpdated: (r) => {
        r.keepUndoRedoStack || this.clearStacks();
      },
      columnPivotModeChanged: i,
      newColumnsLoaded: i,
      columnGroupOpened: i,
      columnRowGroupChanged: i,
      columnMoved: i,
      columnPinned: i,
      columnVisible: i,
      rowDragEnd: i
    }), t.whenReady(this, (r) => {
      this.gridBodyCtrl = r.gridBodyCtrl;
    });
  }
  getCurrentUndoStackSize() {
    var e;
    return ((e = this.undoStack) == null ? void 0 : e.getCurrentStackSize()) ?? 0;
  }
  getCurrentRedoStackSize() {
    var e;
    return ((e = this.redoStack) == null ? void 0 : e.getCurrentStackSize()) ?? 0;
  }
  undo(e) {
    const { eventSvc: t, undoStack: s, redoStack: i } = this;
    t.dispatchEvent({
      type: "undoStarted",
      source: e
    });
    const r = this.undoRedo(s, i, "initialRange", "oldValue", "undo");
    t.dispatchEvent({
      type: "undoEnded",
      source: e,
      operationPerformed: r
    });
  }
  redo(e) {
    const { eventSvc: t, undoStack: s, redoStack: i } = this;
    t.dispatchEvent({
      type: "redoStarted",
      source: e
    });
    const r = this.undoRedo(i, s, "finalRange", "newValue", "redo");
    t.dispatchEvent({
      type: "redoEnded",
      source: e,
      operationPerformed: r
    });
  }
  undoRedo(e, t, s, i, r) {
    if (!e)
      return !1;
    const n = e.pop();
    return !n || !n.cellValueChanges ? !1 : (this.processAction(
      n,
      (o) => o[i],
      r
    ), n instanceof Td ? this.processRange(n.ranges || [n[s]]) : this.processCell(n.cellValueChanges), t.push(n), !0);
  }
  processAction(e, t, s) {
    e.cellValueChanges.forEach((i) => {
      const { rowIndex: r, rowPinned: n, columnId: o } = i, a = { rowIndex: r, rowPinned: n }, l = ri(this.beans, a);
      l.displayed && l.setDataValue(o, t(i), s);
    });
  }
  processRange(e) {
    let t;
    const s = this.beans.rangeSvc;
    s.removeAllCellRanges(!0), e.forEach((i, r) => {
      if (!i)
        return;
      const n = i.startRow, o = i.endRow;
      r === e.length - 1 && (t = {
        rowPinned: n.rowPinned,
        rowIndex: n.rowIndex,
        columnId: i.startColumn.getColId()
      }, this.setLastFocusedCell(t));
      const a = {
        rowStartIndex: n.rowIndex,
        rowStartPinned: n.rowPinned,
        rowEndIndex: o.rowIndex,
        rowEndPinned: o.rowPinned,
        columnStart: i.startColumn,
        columns: i.columns
      };
      s.addCellRange(a);
    });
  }
  processCell(e) {
    const t = e[0], { rowIndex: s, rowPinned: i } = t, r = { rowIndex: s, rowPinned: i }, n = ri(this.beans, r), o = {
      rowPinned: t.rowPinned,
      rowIndex: n.rowIndex,
      columnId: t.columnId
    };
    this.setLastFocusedCell(o);
  }
  setLastFocusedCell(e) {
    const { rowIndex: t, columnId: s, rowPinned: i } = e, { colModel: r, focusSvc: n, rangeSvc: o } = this.beans, a = r.getCol(s);
    if (!a)
      return;
    const { scrollFeature: l } = this.gridBodyCtrl;
    l.ensureIndexVisible(t), l.ensureColumnVisible(a);
    const c = { rowIndex: t, column: a, rowPinned: i };
    n.setFocusedCell({ ...c, forceBrowserFocus: !0 }), o == null || o.setRangeToCell(c);
  }
  addListeners() {
    this.addManagedEventListeners({
      rowEditingStarted: (e) => {
        this.activeRowEdit = { rowIndex: e.rowIndex, rowPinned: e.rowPinned };
      },
      rowEditingStopped: () => {
        const e = new Ho(this.cellValueChanges);
        this.pushActionsToUndoStack(e), this.activeRowEdit = null;
      },
      cellEditingStarted: (e) => {
        this.activeCellEdit = { column: e.column, rowIndex: e.rowIndex, rowPinned: e.rowPinned };
      },
      cellEditingStopped: (e) => {
        if (this.activeCellEdit = null, e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction) {
          const s = new Ho(this.cellValueChanges);
          this.pushActionsToUndoStack(s);
        }
      },
      pasteStart: () => {
        this.isPasting = !0;
      },
      pasteEnd: () => {
        const e = new Ho(this.cellValueChanges);
        this.pushActionsToUndoStack(e), this.isPasting = !1;
      },
      fillStart: () => {
        this.isRangeInAction = !0;
      },
      fillEnd: (e) => {
        const t = new Td(this.cellValueChanges, e.initialRange, e.finalRange);
        this.pushActionsToUndoStack(t), this.isRangeInAction = !1;
      },
      keyShortcutChangedCellStart: () => {
        this.isRangeInAction = !0;
      },
      keyShortcutChangedCellEnd: () => {
        let e;
        const { rangeSvc: t, gos: s } = this.beans;
        t && is(s) ? e = new Td(this.cellValueChanges, void 0, void 0, [
          ...t.getCellRanges()
        ]) : e = new Ho(this.cellValueChanges), this.pushActionsToUndoStack(e), this.isRangeInAction = !1;
      }
    });
  }
  pushActionsToUndoStack(e) {
    this.undoStack.push(e), this.cellValueChanges = [], this.redoStack.clear();
  }
}, Uk = (
  /*css*/
  ".ag-cell-inline-editing{border:var(--ag-cell-editing-border)!important;border-radius:var(--ag-border-radius);box-shadow:var(--ag-cell-editing-shadow);padding:0;z-index:1;.ag-cell-edit-wrapper,.ag-cell-editor,.ag-cell-wrapper,:where(.ag-cell-editor) .ag-input-field-input,:where(.ag-cell-editor) .ag-wrapper{height:100%;line-height:normal;width:100%}}:where(.ag-popup-editor) .ag-large-text{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0}.ag-large-text-input{height:auto;padding:var(--ag-cell-horizontal-padding)}:where(.ag-rtl .ag-large-text-input) textarea{resize:none}:where(.ag-ltr) .ag-checkbox-edit{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-checkbox-edit{padding-right:var(--ag-cell-horizontal-padding)}"
), $k = class extends Lr {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit">
                <ag-checkbox role="presentation" data-ref="eCheckbox"></ag-checkbox>
            </div>`,
      [ai]
    ), this.eCheckbox = E;
  }
  init(e) {
    this.params = e;
    const t = e.value ?? void 0, s = this.eCheckbox;
    s.setValue(t), s.getInputElement().setAttribute("tabindex", "-1"), this.setAriaLabel(t), this.addManagedListeners(s, {
      fieldValueChanged: (r) => this.setAriaLabel(r.selected)
    });
  }
  getValue() {
    return this.eCheckbox.getValue();
  }
  focusIn() {
    this.eCheckbox.getFocusableElement().focus();
  }
  afterGuiAttached() {
    this.params.cellStartedEdit && this.focusIn();
  }
  isPopup() {
    return !1;
  }
  setAriaLabel(e) {
    const t = this.getLocaleTextFunc(), s = rh(t, e), i = t("ariaToggleCellValue", "Press SPACE to toggle cell value");
    this.eCheckbox.setInputAriaLabel(`${i} (${s})`);
  }
}, Pc = class extends Lr {
  constructor(e) {
    super(
      /* html */
      `
            <div class="ag-cell-edit-wrapper">
                ${e.getTemplate()}
            </div>`,
      e.getAgComponents()
    ), this.cellEditorInput = e, this.eInput = E;
  }
  init(e) {
    this.params = e;
    const { cellStartedEdit: t, eventKey: s, suppressPreventDefault: i } = e, r = this.eInput;
    this.cellEditorInput.init(r, e);
    let n, o = !0;
    t ? (this.focusAfterAttached = !0, s === P.BACKSPACE || s === P.DELETE ? n = "" : s && s.length === 1 ? i ? o = !1 : n = s : (n = this.cellEditorInput.getStartValue(), s !== P.F2 && (this.highlightAllOnFocus = !0))) : (this.focusAfterAttached = !1, n = this.cellEditorInput.getStartValue()), o && n != null && r.setStartValue(n), this.addManagedElementListeners(r.getGui(), {
      keydown: (a) => {
        const { key: l } = a;
        (l === P.PAGE_UP || l === P.PAGE_DOWN) && a.preventDefault();
      }
    });
  }
  afterGuiAttached() {
    var i, r;
    const e = this.getLocaleTextFunc(), t = this.eInput;
    if (t.setInputAriaLabel(e("ariaInputEditor", "Input Editor")), !this.focusAfterAttached)
      return;
    Rn() || t.getFocusableElement().focus();
    const s = t.getInputElement();
    this.highlightAllOnFocus ? s.select() : (r = (i = this.cellEditorInput).setCaret) == null || r.call(i);
  }
  // gets called when tabbing through cells and in full row edit mode
  focusIn() {
    const e = this.eInput, t = e.getFocusableElement(), s = e.getInputElement();
    t.focus(), s.select();
  }
  getValue() {
    return this.cellEditorInput.getValue();
  }
  isPopup() {
    return !1;
  }
}, jk = class {
  getTemplate() {
    return (
      /* html */
      '<ag-input-date-field class="ag-cell-editor" data-ref="eInput"></ag-input-date-field>'
    );
  }
  getAgComponents() {
    return [_w];
  }
  init(e, t) {
    this.eInput = e, this.params = t;
    const { min: s, max: i, step: r } = t;
    s != null && e.setMin(s), i != null && e.setMax(i), r != null && e.setStep(r);
  }
  getValue() {
    const { eInput: e, params: t } = this, s = e.getDate();
    return !W(s) && !W(t.value) ? t.value : s ?? null;
  }
  getStartValue() {
    const { value: e } = this.params;
    if (e instanceof Date)
      return ys(e, !1);
  }
}, Kk = class extends Pc {
  constructor() {
    super(new jk());
  }
}, qk = class {
  constructor(e) {
    this.getDataTypeService = e;
  }
  getTemplate() {
    return (
      /* html */
      '<ag-input-date-field class="ag-cell-editor" data-ref="eInput"></ag-input-date-field>'
    );
  }
  getAgComponents() {
    return [_w];
  }
  init(e, t) {
    this.eInput = e, this.params = t;
    const { min: s, max: i, step: r } = t;
    s != null && e.setMin(s), i != null && e.setMax(i), r != null && e.setStep(r);
  }
  getValue() {
    const { params: e, eInput: t } = this, s = this.formatDate(t.getDate());
    return !W(s) && !W(e.value) ? e.value : e.parseValue(s ?? "");
  }
  getStartValue() {
    return ys(this.parseDate(this.params.value ?? void 0) ?? null, !1);
  }
  parseDate(e) {
    const t = this.getDataTypeService();
    return t ? t.getDateParserFunction(this.params.column)(e) : Yt(e) ?? void 0;
  }
  formatDate(e) {
    const t = this.getDataTypeService();
    return t ? t.getDateFormatterFunction(this.params.column)(e) : ys(e ?? null, !1) ?? void 0;
  }
}, Yk = class extends Pc {
  constructor() {
    super(new qk(() => this.beans.dataTypeSvc));
  }
}, Xk = class extends Lr {
  constructor() {
    super(
      /* html */
      `<div class="ag-large-text">
        <ag-input-text-area data-ref="eTextArea" class="ag-large-text-input"></ag-input-text-area>
        </div>`,
      [HD]
    ), this.eTextArea = E;
  }
  init(e) {
    this.params = e, this.focusAfterAttached = e.cellStartedEdit, this.eTextArea.setMaxLength(e.maxLength || 200).setCols(e.cols || 60).setRows(e.rows || 10), e.value != null && this.eTextArea.setValue(e.value.toString(), !0), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.activateTabIndex();
  }
  onKeyDown(e) {
    const t = e.key;
    (t === P.LEFT || t === P.UP || t === P.RIGHT || t === P.DOWN || e.shiftKey && t === P.ENTER) && e.stopPropagation();
  }
  afterGuiAttached() {
    const e = this.getLocaleTextFunc();
    this.eTextArea.setInputAriaLabel(e("ariaInputEditor", "Input Editor")), this.focusAfterAttached && this.eTextArea.getFocusableElement().focus();
  }
  getValue() {
    const e = this.eTextArea.getValue(), t = this.params;
    return !W(e) && !W(t.value) ? t.value : t.parseValue(e);
  }
}, Zk = class {
  getTemplate() {
    return (
      /* html */
      '<ag-input-number-field class="ag-cell-editor" data-ref="eInput"></ag-input-number-field>'
    );
  }
  getAgComponents() {
    return [wc];
  }
  init(e, t) {
    this.eInput = e, this.params = t;
    const { max: s, min: i, precision: r, step: n } = t;
    s != null && e.setMax(s), i != null && e.setMin(i), r != null && e.setPrecision(r), n != null && e.setStep(n);
    const o = e.getInputElement();
    t.preventStepping ? e.addManagedElementListeners(o, { keydown: this.preventStepping }) : t.showStepperButtons && o.classList.add("ag-number-field-input-stepper");
  }
  preventStepping(e) {
    (e.key === P.UP || e.key === P.DOWN) && e.preventDefault();
  }
  getValue() {
    const { eInput: e, params: t } = this, s = e.getValue();
    if (!W(s) && !W(t.value))
      return t.value;
    let i = t.parseValue(s);
    if (i == null)
      return i;
    if (typeof i == "string") {
      if (i === "")
        return null;
      i = Number(i);
    }
    return isNaN(i) ? null : i;
  }
  getStartValue() {
    return this.params.value;
  }
  setCaret() {
    Rn() && this.eInput.getInputElement().focus({ preventScroll: !0 });
  }
}, Qk = class extends Pc {
  constructor() {
    super(new Zk());
  }
}, Jk = class extends Lr {
  constructor() {
    super(
      /* html */
      `<div class="ag-cell-edit-wrapper">
                <ag-select class="ag-cell-editor" data-ref="eSelect"></ag-select>
            </div>`,
      [ma]
    ), this.eSelect = E, this.startedByEnter = !1;
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc;
  }
  init(e) {
    this.focusAfterAttached = e.cellStartedEdit;
    const { eSelect: t, valueSvc: s, gos: i } = this, { values: r, value: n, eventKey: o } = e;
    if (ke(r)) {
      I(58);
      return;
    }
    this.startedByEnter = o != null ? o === P.ENTER : !1;
    let a = !1;
    r.forEach((u) => {
      const h = { value: u }, p = s.formatValue(e.column, null, u), g = p != null;
      h.text = g ? p : u, t.addOption(h), a = a || n === u;
    }), a ? t.setValue(e.value, !0) : e.values.length && t.setValue(e.values[0], !0);
    const { valueListGap: l, valueListMaxWidth: c, valueListMaxHeight: d } = e;
    l != null && t.setPickerGap(l), d != null && t.setPickerMaxHeight(d), c != null && t.setPickerMaxWidth(c), i.get("editType") !== "fullRow" && this.addManagedListeners(this.eSelect, { selectedItem: () => e.stopEditing() });
  }
  afterGuiAttached() {
    this.focusAfterAttached && this.eSelect.getFocusableElement().focus(), this.startedByEnter && setTimeout(() => {
      this.isAlive() && this.eSelect.showPicker();
    });
  }
  focusIn() {
    this.eSelect.getFocusableElement().focus();
  }
  getValue() {
    return this.eSelect.getValue();
  }
  isPopup() {
    return !1;
  }
}, eO = class {
  getTemplate() {
    return (
      /* html */
      '<ag-input-text-field class="ag-cell-editor" data-ref="eInput"></ag-input-text-field>'
    );
  }
  getAgComponents() {
    return [Ks];
  }
  init(e, t) {
    this.eInput = e, this.params = t;
    const s = t.maxLength;
    s != null && e.setMaxLength(s);
  }
  getValue() {
    const { eInput: e, params: t } = this, s = e.getValue();
    return !W(s) && !W(t.value) ? t.value : t.parseValue(s);
  }
  getStartValue() {
    const e = this.params;
    return e.useFormatter || e.column.getColDef().refData ? e.formatValue(e.value) : e.value;
  }
  setCaret() {
    const e = this.eInput, t = e.getValue(), s = W(t) && t.length || 0;
    s && e.getInputElement().setSelectionRange(s, s);
  }
}, yf = class extends Pc {
  constructor() {
    super(new eO());
  }
};
function tO(e) {
  return e.ctrlsSvc.getScrollFeature().getVScrollPosition();
}
function sO(e) {
  return e.ctrlsSvc.getScrollFeature().getHScrollPosition();
}
function By(e, t, s = "auto") {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getScrollFeature().ensureColumnVisible(t, s),
    "ensureVisible"
  );
}
function Vy(e, t, s) {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getScrollFeature().ensureIndexVisible(t, s),
    "ensureVisible"
  );
}
function iO(e, t, s = null) {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getScrollFeature().ensureNodeVisible(t, s),
    "ensureVisible"
  );
}
function rO(e) {
  var t;
  (t = e.undoRedo) == null || t.undo("api");
}
function nO(e) {
  var t;
  (t = e.undoRedo) == null || t.redo("api");
}
function oO(e, t = {}) {
  const s = [];
  return e.rowRenderer.getCellCtrls(t.rowNodes, t.columns).forEach((i) => {
    var n;
    const r = (n = i.comp) == null ? void 0 : n.getCellEditor();
    r && s.push(Cn(r));
  }), s;
}
function aO(e) {
  const t = [];
  return e.rowRenderer.getAllCellCtrls().forEach((s) => {
    if (s.editing) {
      const { cellPosition: i } = s;
      t.push(i);
    }
  }), t;
}
function lO(e, t = !1) {
  var s;
  (s = e.editSvc) == null || s.stopAllEditing(t);
}
function cO(e, t) {
  const s = e.colModel.getCol(t.colKey);
  if (!s) {
    I(12, { colKey: t.colKey });
    return;
  }
  const i = {
    rowIndex: t.rowIndex,
    rowPinned: t.rowPinned || null,
    column: s
  };
  t.rowPinned == null && Vy(e, t.rowIndex), By(e, t.colKey);
  const n = yi(e, i);
  if (!n)
    return;
  const { focusSvc: o, gos: a, editSvc: l } = e, c = () => {
    const u = Ie(e), h = n.eGui;
    return u !== h && !!(h != null && h.contains(u));
  }, d = a.get("stopEditingWhenCellsLoseFocus") && c();
  (d || !o.isCellFocused(i)) && o.setFocusedCell({
    ...i,
    forceBrowserFocus: d,
    preventScrollOnBrowserFocus: !0
  }), l == null || l.startRowOrCellEdit(n, t.key);
}
function dO(e) {
  var t;
  return ((t = e.undoRedo) == null ? void 0 : t.getCurrentUndoStackSize()) ?? 0;
}
function uO(e) {
  var t;
  return ((t = e.undoRedo) == null ? void 0 : t.getCurrentRedoStackSize()) ?? 0;
}
var hO = class extends Lr {
  constructor(e) {
    super(
      /* html */
      '<div class="ag-popup-editor" tabindex="-1"/>'
    ), this.params = e;
  }
  postConstruct() {
    fn(this.gos, this.getGui(), "popupEditorWrapper", !0), this.addKeyDownListener();
  }
  addKeyDownListener() {
    const e = this.getGui(), t = this.params, s = (i) => {
      du(this.gos, i, t.node, t.column, !0) || t.onKeyDown(i);
    };
    this.addManagedElementListeners(e, { keydown: s });
  }
}, pO = class extends L {
  constructor() {
    super(...arguments), this.beanName = "editSvc";
  }
  startEditing(e, t = null, s = !1, i = null) {
    var c;
    if (!e.isCellEditable() || e.editing)
      return !0;
    if (!e.comp)
      return e.onCompAttachedFuncs.push(() => {
        this.startEditing(e, t, s, i);
      }), !0;
    const r = this.createCellEditorParams(e, t, s), n = e.column.getColDef(), o = Kg(this.beans.userCompFactory, n, r), a = (o == null ? void 0 : o.popupFromSelector) != null ? o.popupFromSelector : !!n.cellEditorPopup, l = (o == null ? void 0 : o.popupPositionFromSelector) != null ? o.popupPositionFromSelector : n.cellEditorPopupPosition;
    return bf(e, !0, o), e.comp.setEditDetails(o, a, l, this.gos.get("reactiveCustomComponents")), this.eventSvc.dispatchEvent(e.createEvent(i, "cellEditingStarted")), !((c = o == null ? void 0 : o.params) != null && c.suppressPreventDefault);
  }
  /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */
  stopEditing(e, t = !1) {
    if (e.onEditorAttachedFuncs = [], !e.editing)
      return !1;
    const { comp: s, column: i, rowNode: r } = e, { newValue: n, newValueExists: o } = gO(t, s), a = this.beans.valueSvc.getValueForDisplay(i, r);
    let l = !1;
    return o && (l = fO(e, a, n, r, i)), bf(e, !1, void 0), s.setEditDetails(), e.updateAndFormatValue(!1), e.refreshCell({ forceRefresh: !0, suppressFlash: !0 }), this.eventSvc.dispatchEvent({
      ...e.createEvent(null, "cellEditingStopped"),
      oldValue: a,
      newValue: n,
      valueChanged: l
    }), l;
  }
  handleColDefChanged(e) {
    var s;
    const t = (s = e.comp) == null ? void 0 : s.getCellEditor();
    if (t != null && t.refresh) {
      const { eventKey: i, cellStartedEdit: r } = e.editCompDetails.params, n = this.createCellEditorParams(e, i, r), o = e.column.getColDef(), a = Kg(this.beans.userCompFactory, o, n);
      t.refresh(a.params);
    }
  }
  setFocusOutOnEditor(e) {
    if (!e.editing)
      return;
    const t = e.comp.getCellEditor();
    t && t.focusOut && t.focusOut();
  }
  setFocusInOnEditor(e) {
    if (!e.editing)
      return;
    const t = e.comp, s = t.getCellEditor();
    s != null && s.focusIn ? s.focusIn() : (e.focusCell(!0), e.onEditorAttachedFuncs.push(() => {
      var i, r;
      return (r = (i = t.getCellEditor()) == null ? void 0 : i.focusIn) == null ? void 0 : r.call(i);
    }));
  }
  stopEditingAndFocus(e, t = !1, s = !1) {
    this.stopRowOrCellEdit(e), e.focusCell(!0), t || this.navigateAfterEdit(s, e.cellPosition);
  }
  createPopupEditorWrapper(e) {
    return new hO(e);
  }
  stopAllEditing(e = !1) {
    this.beans.rowRenderer.getAllRowCtrls().forEach((t) => this.stopRowEditing(t, e));
  }
  stopRowEditing(e, t = !1) {
    var n;
    if (e.stoppingRowEdit)
      return;
    const s = e.getAllCellCtrls(), i = e.editing;
    e.stoppingRowEdit = !0;
    let r = !1;
    for (const o of s) {
      const a = o.stopEditing(t);
      i && !t && !r && a && (r = !0);
    }
    r && this.eventSvc.dispatchEvent(e.createRowEvent("rowValueChanged")), i && ((n = this.beans.rowEditSvc) == null || n.setEditing(e, !1)), e.stoppingRowEdit = !1;
  }
  addStopEditingWhenGridLosesFocus(e) {
    if (!this.gos.get("stopEditingWhenCellsLoseFocus"))
      return;
    const t = (s) => {
      const i = s.relatedTarget;
      if (tu(i) === null) {
        this.stopAllEditing();
        return;
      }
      let r = (
        // see if click came from inside the viewports
        e.some((n) => n.contains(i)) && // and also that it's not from a detail grid
        hw(this.gos, i)
      );
      if (!r) {
        const n = this.beans.popupSvc;
        r = !!n && (n.getActivePopups().some((o) => o.contains(i)) || n.isElementWithinCustomPopup(i));
      }
      r || this.stopAllEditing();
    };
    e.forEach((s) => this.addManagedElementListeners(s, { focusout: t }));
  }
  setInlineEditingCss(e) {
    const t = e.editing || e.getAllCellCtrls().some((s) => s.editing);
    e.forEachGui(void 0, (s) => {
      s.rowComp.addOrRemoveCssClass("ag-row-inline-editing", t), s.rowComp.addOrRemoveCssClass("ag-row-not-inline-editing", !t);
    });
  }
  isCellEditable(e, t) {
    if (t.group) {
      if (this.gos.get("treeData")) {
        if (!t.data && !this.gos.get("enableGroupEdit"))
          return !1;
      } else if (!this.gos.get("enableGroupEdit"))
        return !1;
    }
    return e.isColumnFunc(t, e.colDef.editable);
  }
  // called by rowRenderer when user navigates via tab key
  startRowOrCellEdit(e, t, s = null) {
    var i;
    return e.comp ? this.gos.get("editType") === "fullRow" ? ((i = this.beans.rowEditSvc) == null ? void 0 : i.startEditing(e.rowCtrl, t, e)) ?? !0 : this.startEditing(e, t, !0, s) : (e.onCompAttachedFuncs.push(() => {
      this.startRowOrCellEdit(e, t, s);
    }), !0);
  }
  // pass in 'true' to cancel the editing.
  stopRowOrCellEdit(e, t = !1) {
    this.gos.get("editType") === "fullRow" ? this.stopRowEditing(e.rowCtrl, t) : this.stopEditing(e, t);
  }
  createCellEditorParams(e, t, s) {
    const {
      column: i,
      rowNode: r,
      eGui: n,
      cellPosition: { rowIndex: o }
    } = e, { valueSvc: a, gos: l } = this.beans;
    return l.addGridCommonParams({
      value: a.getValueForDisplay(i, r),
      eventKey: t,
      column: i,
      colDef: i.getColDef(),
      rowIndex: o,
      node: r,
      data: r.data,
      cellStartedEdit: s,
      onKeyDown: e.onKeyDown.bind(e),
      stopEditing: e.stopEditingAndFocus.bind(e),
      eGridCell: n,
      parseValue: (c) => a.parseValue(i, r, c, e.value),
      formatValue: e.formatValue.bind(e)
    });
  }
  navigateAfterEdit(e, t) {
    var i;
    if (this.gos.get("enterNavigatesVerticallyAfterEdit")) {
      const r = e ? P.UP : P.DOWN;
      (i = this.beans.navigation) == null || i.navigateToNextCell(null, r, t, !1);
    }
  }
};
function bf(e, t, s) {
  e.editCompDetails = s, e.editing !== t && (e.editing = t);
}
function gO(e, t) {
  const s = { newValueExists: !1 };
  if (e)
    return s;
  const i = t.getCellEditor();
  return !i || i.isCancelAfterEnd && i.isCancelAfterEnd() ? s : {
    newValue: i.getValue(),
    newValueExists: !0
  };
}
function fO(e, t, s, i, r) {
  if (s === t)
    return !1;
  e.suppressRefreshCell = !0;
  const n = i.setDataValue(r, s, "edit");
  return e.suppressRefreshCell = !1, n;
}
var mO = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowEditSvc";
  }
  startEditing(e, t = null, s = null, i = null) {
    if (e.editing)
      return !0;
    let r = !0, n = !1;
    const { editSvc: o } = this.beans;
    return e.getAllCellCtrls().forEach((a) => {
      const l = a === s;
      l ? r = (o == null ? void 0 : o.startEditing(a, t, l, i)) ?? !0 : o == null || o.startEditing(a, null, l, i), n || (n = a.editing);
    }), n && this.setEditing(e, !0), r;
  }
  setEditing(e, t) {
    e.editing = t, e.forEachGui(void 0, (i) => i.rowComp.addOrRemoveCssClass("ag-row-editing", t));
    const s = t ? e.createRowEvent("rowEditingStarted") : e.createRowEvent("rowEditingStopped");
    this.eventSvc.dispatchEvent(s);
  }
}, Xi = {
  moduleName: "EditCore",
  version: de,
  beans: [pO, mO],
  apiFunctions: {
    getCellEditorInstances: oO,
    getEditingCells: aO,
    stopEditing: lO,
    startEditingCell: cO
  },
  dependsOn: [Yi],
  css: [Uk]
}, CO = {
  moduleName: "UndoRedoEdit",
  version: de,
  beans: [_k],
  apiFunctions: {
    undoCellEditing: rO,
    redoCellEditing: nO,
    getCurrentUndoSize: dO,
    getCurrentRedoSize: uO
  },
  dependsOn: [Xi]
}, vO = {
  moduleName: "TextEditor",
  version: de,
  userComponents: { agCellEditor: yf, agTextCellEditor: yf },
  dependsOn: [Xi]
}, wO = {
  moduleName: "NumberEditor",
  version: de,
  userComponents: {
    agNumberCellEditor: {
      classImp: Qk,
      params: {
        suppressPreventDefault: !0
      }
    }
  },
  dependsOn: [Xi]
}, yO = {
  moduleName: "DateEditor",
  version: de,
  userComponents: {
    agDateCellEditor: Kk,
    agDateStringCellEditor: Yk
  },
  dependsOn: [Xi]
}, bO = {
  moduleName: "CheckboxEditor",
  version: de,
  userComponents: {
    agCheckboxCellEditor: $k
  },
  dependsOn: [Xi]
}, SO = {
  moduleName: "SelectEditor",
  version: de,
  userComponents: { agSelectCellEditor: Jk },
  dependsOn: [Xi]
}, xO = {
  moduleName: "LargeTextEditor",
  version: de,
  userComponents: { agLargeTextCellEditor: Xk },
  dependsOn: [Xi]
}, RO = {
  moduleName: "CustomEditor",
  version: de,
  dependsOn: [Xi]
};
function FO(e, t) {
  var a;
  if (!t.nodes.every((l) => l.rowPinned ? (I(59), !1) : l.id === void 0 ? (I(60), !1) : !0))
    return;
  const { nodes: i, source: r, newValue: n } = t, o = i;
  (a = e.selectionSvc) == null || a.setNodesSelected({ nodes: o, source: r ?? "api", newValue: n });
}
function PO(e, t, s = "apiSelectAll") {
  var i;
  (i = e.selectionSvc) == null || i.selectAllRowNodes({ source: s, selectAll: t });
}
function TO(e, t, s = "apiSelectAll") {
  var i;
  (i = e.selectionSvc) == null || i.deselectAllRowNodes({ source: s, selectAll: t });
}
function EO(e, t = "apiSelectAllFiltered") {
  var s;
  (s = e.selectionSvc) == null || s.selectAllRowNodes({ source: t, selectAll: "filtered" });
}
function DO(e, t = "apiSelectAllFiltered") {
  var s;
  (s = e.selectionSvc) == null || s.deselectAllRowNodes({ source: t, selectAll: "filtered" });
}
function AO(e, t = "apiSelectAllCurrentPage") {
  var s;
  (s = e.selectionSvc) == null || s.selectAllRowNodes({ source: t, selectAll: "currentPage" });
}
function MO(e, t = "apiSelectAllCurrentPage") {
  var s;
  (s = e.selectionSvc) == null || s.deselectAllRowNodes({ source: t, selectAll: "currentPage" });
}
function IO(e) {
  var t;
  return ((t = e.selectionSvc) == null ? void 0 : t.getSelectedNodes()) ?? [];
}
function LO(e) {
  var t;
  return ((t = e.selectionSvc) == null ? void 0 : t.getSelectedRows()) ?? [];
}
var kO = class extends zw {
  constructor() {
    super(...arguments), this.beanName = "selectionSvc", this.selectedNodes = /* @__PURE__ */ new Map();
  }
  postConstruct() {
    super.postConstruct();
    const { gos: e } = this;
    this.mode = Zn(e), this.groupSelectsDescendants = mn(e), this.groupSelectsFiltered = El(e) === "filteredDescendants", this.addManagedPropertyListeners(["groupSelectsChildren", "groupSelectsFiltered", "rowSelection"], () => {
      const t = mn(e), s = Zn(e), i = El(e) === "filteredDescendants";
      (t !== this.groupSelectsDescendants || i !== this.groupSelectsFiltered || s !== this.mode) && (this.deselectAllRowNodes({ source: "api" }), this.groupSelectsDescendants = t, this.groupSelectsFiltered = i, this.mode = s);
    }), this.addManagedEventListeners({ rowSelected: this.onRowSelected.bind(this) });
  }
  destroy() {
    super.destroy(), this.resetNodes();
  }
  handleSelectionEvent(e, t, s) {
    if (this.isRowSelectionBlocked(t))
      return 0;
    const i = this.inferNodeSelections(t, e.shiftKey, e.metaKey || e.ctrlKey, s);
    return i == null ? 0 : "select" in i ? (i.reset ? this.resetNodes() : this.selectRange(i.deselect, !1, s), this.selectRange(i.select, !0, s)) : this.setNodesSelected({
      nodes: [i.node],
      newValue: i.newValue,
      clearSelection: i.clearSelection,
      event: e,
      source: s
    });
  }
  setNodesSelected({
    newValue: e,
    clearSelection: t,
    suppressFinishActions: s,
    nodes: i,
    event: r,
    source: n
  }) {
    var a;
    if (!Es(this.gos) && e)
      return I(132), 0;
    if (i.length === 0)
      return 0;
    if (i.length > 1 && !this.isMultiSelect())
      return I(130), 0;
    let o = 0;
    for (let l = 0; l < i.length; l++) {
      const c = i[l], d = c.footer ? c.sibling : c, u = this.groupSelectsFiltered && d.group;
      if (d.rowPinned) {
        I(59);
        continue;
      }
      if (d.id === void 0) {
        I(60);
        continue;
      }
      u || this.selectRowNode(d, e, r, n) && o++, this.groupSelectsDescendants && ((a = d.childrenAfterGroup) != null && a.length) && (o += this.selectChildren(d, e, n));
    }
    return s || (e && (t || !this.isMultiSelect()) && (o += this.clearOtherNodes(i[0], n)), o > 0 && (this.updateGroupsFromChildrenSelections(n), this.dispatchSelectionChanged(n))), o;
  }
  // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
  // holding down 'shift'.
  selectRange(e, t, s) {
    let i = 0;
    return e.forEach((r) => {
      if (r.group && this.groupSelectsDescendants)
        return;
      this.selectRowNode(r, t, void 0, s) && i++;
    }), i > 0 && (this.updateGroupsFromChildrenSelections(s), this.dispatchSelectionChanged(s)), i;
  }
  selectChildren(e, t, s) {
    const i = this.groupSelectsFiltered ? e.childrenAfterAggFilter : e.childrenAfterGroup;
    return i ? this.setNodesSelected({
      newValue: t,
      clearSelection: !1,
      suppressFinishActions: !0,
      source: s,
      nodes: i
    }) : 0;
  }
  getSelectedNodes() {
    return Array.from(this.selectedNodes.values());
  }
  getSelectedRows() {
    const e = [];
    return this.selectedNodes.forEach((t) => e.push(t.data)), e;
  }
  getSelectionCount() {
    return this.selectedNodes.size;
  }
  /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */
  filterFromSelection(e) {
    const t = /* @__PURE__ */ new Map();
    this.selectedNodes.forEach((s, i) => {
      e(s) && t.set(i, s);
    }), this.selectedNodes = t;
  }
  updateGroupsFromChildrenSelections(e, t) {
    if (!this.groupSelectsDescendants)
      return !1;
    const { gos: s, rowModel: i } = this.beans;
    if (!Ye(s))
      return !1;
    const r = i.rootNode;
    if (!r)
      return !1;
    t || (t = new so(!0, r), t.active = !1);
    let n = !1;
    return t.forEachChangedNodeDepthFirst((o) => {
      if (o !== r) {
        const a = this.calculateSelectedFromChildren(o);
        n = this.selectRowNode(o, a === null ? !1 : a, void 0, e) || n;
      }
    }), n;
  }
  clearOtherNodes(e, t) {
    const s = /* @__PURE__ */ new Map();
    let i = 0;
    return this.selectedNodes.forEach((r) => {
      if (r && r.id !== e.id) {
        const n = this.selectedNodes.get(r.id);
        i += this.setNodesSelected({
          nodes: [n],
          newValue: !1,
          clearSelection: !1,
          suppressFinishActions: !0,
          source: t
        }), this.groupSelectsDescendants && r.parent && s.set(r.parent.id, r.parent);
      }
    }), s.forEach((r) => {
      const n = this.calculateSelectedFromChildren(r);
      this.selectRowNode(r, n === null ? !1 : n, void 0, t);
    }), i;
  }
  onRowSelected(e) {
    const t = e.node;
    this.groupSelectsDescendants && t.group || (t.isSelected() ? this.selectedNodes.set(t.id, t) : this.selectedNodes.delete(t.id));
  }
  syncInRowNode(e, t) {
    this.syncInOldRowNode(e, t), this.syncInNewRowNode(e);
  }
  createDaemonNode(e) {
    if (!e.id)
      return;
    const t = new bs(this.beans);
    return t.id = e.id, t.data = e.data, t.__daemon = !0, t.__selected = e.__selected, t.level = e.level, t;
  }
  // if the id has changed for the node, then this means the rowNode
  // is getting used for a different data item, which breaks
  // our selectedNodes, as the node now is mapped by the old id
  // which is inconsistent. so to keep the old node as selected,
  // we swap in the clone (with the old id and old data). this means
  // the oldNode is effectively a daemon we keep a reference to,
  // so if client calls api.getSelectedNodes(), it gets the daemon
  // in the result. when the client un-selects, the reference to the
  // daemon is removed. the daemon, because it's an oldNode, is not
  // used by the grid for rendering, it's a copy of what the node used
  // to be like before the id was changed.
  syncInOldRowNode(e, t) {
    t && e.id !== t.id && this.selectedNodes.get(t.id) == e && this.selectedNodes.set(t.id, t);
  }
  syncInNewRowNode(e) {
    this.selectedNodes.has(e.id) ? (e.__selected = !0, this.selectedNodes.set(e.id, e)) : e.__selected = !1;
  }
  reset(e) {
    const t = this.getSelectionCount();
    this.resetNodes(), t && this.dispatchSelectionChanged(e);
  }
  resetNodes() {
    this.selectedNodes.forEach((e) => {
      this.selectRowNode(e, !1);
    }), this.selectedNodes.clear();
  }
  // returns a list of all nodes at 'best cost' - a feature to be used
  // with groups / trees. if a group has all it's children selected,
  // then the group appears in the result, but not the children.
  // Designed for use with 'children' as the group selection type,
  // where groups don't actually appear in the selection normally.
  getBestCostNodeSelection() {
    const { gos: e, rowModel: t } = this.beans;
    if (!Ye(e))
      return;
    const s = t.getTopLevelNodes();
    if (s === null)
      return;
    const i = [];
    function r(n) {
      for (let o = 0, a = n.length; o < a; o++) {
        const l = n[o];
        l.isSelected() ? i.push(l) : l.group && l.childrenAfterGroup && r(l.childrenAfterGroup);
      }
    }
    return r(s), i;
  }
  isEmpty() {
    return this.getSelectionCount() === 0;
  }
  deselectAllRowNodes(e) {
    const t = (n) => this.selectRowNode(n.footer ? n.sibling : n, !1, void 0, i), s = Ye(this.gos), { source: i, selectAll: r } = e;
    if (r === "currentPage" || r === "filtered") {
      if (!s) {
        be(102);
        return;
      }
      this.getNodesToSelect(r).forEach(t);
    } else
      this.selectedNodes.forEach(t), this.reset(i);
    s && this.groupSelectsDescendants && this.updateGroupsFromChildrenSelections(i), this.dispatchSelectionChanged(i);
  }
  getSelectedCounts(e) {
    let t = 0, s = 0;
    const i = (r) => {
      this.groupSelectsDescendants && r.group || (r.isSelected() ? t++ : r.selectable && s++);
    };
    return this.getNodesToSelect(e).forEach(i), { selectedCount: t, notSelectedCount: s };
  }
  getSelectAllState(e) {
    const { selectedCount: t, notSelectedCount: s } = this.getSelectedCounts(e);
    return t === 0 && s === 0 ? !1 : t > 0 && s > 0 ? null : t > 0;
  }
  hasNodesToSelect(e) {
    return this.getNodesToSelect(e).filter((t) => t.selectable).length > 0;
  }
  /**
   * @param selectAll See `MultiRowSelectionOptions.selectAll`
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */
  getNodesToSelect(e) {
    if (!this.canSelectAll())
      return [];
    const t = [];
    if (e === "currentPage")
      return this.forEachNodeOnPage((i) => {
        if (!i.group) {
          t.push(i);
          return;
        }
        if (!i.expanded && !i.footer) {
          const r = (n) => {
            var o;
            t.push(n), (o = n.childrenAfterFilter) != null && o.length && n.childrenAfterFilter.forEach(r);
          };
          r(i);
          return;
        }
        this.groupSelectsDescendants || t.push(i);
      }), t;
    const s = this.beans.rowModel;
    return e === "filtered" ? (s.forEachNodeAfterFilter((i) => {
      t.push(i);
    }), t) : (s.forEachNode((i) => {
      t.push(i);
    }), t);
  }
  forEachNodeOnPage(e) {
    const { pageBounds: t, rowModel: s } = this.beans, i = t.getFirstRow(), r = t.getLastRow();
    for (let n = i; n <= r; n++) {
      const o = s.getRow(n);
      o && e(o);
    }
  }
  selectAllRowNodes(e) {
    const { gos: t } = this;
    if (!Es(t)) {
      I(132);
      return;
    }
    if (uh(t) && !Pr(t)) {
      I(130);
      return;
    }
    if (!this.canSelectAll())
      return;
    const { source: s, selectAll: i } = e;
    this.getNodesToSelect(i).forEach((r) => {
      this.selectRowNode(r.footer ? r.sibling : r, !0, void 0, s);
    }), Ye(t) && this.groupSelectsDescendants && this.updateGroupsFromChildrenSelections(s), this.dispatchSelectionChanged(s);
  }
  getSelectionState() {
    const e = [];
    return this.selectedNodes.forEach((t) => {
      t != null && t.id && e.push(t.id);
    }), e.length ? e : null;
  }
  setSelectionState(e, t) {
    if (!Array.isArray(e)) {
      be(103);
      return;
    }
    const s = new Set(e), i = [];
    this.beans.rowModel.forEachNode((r) => {
      s.has(r.id) && i.push(r);
    }), this.setNodesSelected({
      newValue: !0,
      nodes: i,
      source: t
    });
  }
  canSelectAll() {
    const { gos: e, rowModel: t } = this.beans;
    return Ye(e) ? !0 : (be(100, { rowModelType: t.getType() }), !1);
  }
  /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData via `updateSelectableAfterGrouping`
   */
  updateSelectable(e) {
    var l;
    const { gos: t, rowModel: s } = this.beans;
    if (!Es(t))
      return;
    const i = "selectableChanged", r = e !== void 0, n = Ye(t) && this.groupSelectsDescendants, o = [], a = (c) => {
      var u;
      if (r && !c.group)
        return;
      if (n && c.group) {
        const h = ((u = c.childrenAfterGroup) == null ? void 0 : u.some((p) => p.selectable)) ?? !1;
        this.setRowSelectable(c, h, !0);
        return;
      }
      !this.updateRowSelectable(c, !0) && c.isSelected() && o.push(c);
    };
    if (n) {
      if (e === void 0) {
        const c = s.rootNode;
        e = c ? new so(!1, c) : void 0;
      }
      e == null || e.forEachChangedNodeDepthFirst(a, !r, !r);
    } else
      s.forEachNode(a);
    o.length && this.setNodesSelected({
      nodes: o,
      newValue: !1,
      source: i
    }), !r && n && ((l = this.updateGroupsFromChildrenSelections) == null || l.call(this, i));
  }
  // only called by CSRM
  updateSelectableAfterGrouping(e) {
    var t;
    this.updateSelectable(e), this.groupSelectsDescendants && ((t = this.updateGroupsFromChildrenSelections) != null && t.call(this, "rowGroupChanged", e)) && this.eventSvc.dispatchEvent({
      type: "selectionChanged",
      source: "rowGroupChanged"
    });
  }
}, Ny = {
  moduleName: "SharedRowSelection",
  version: de,
  beans: [uT],
  apiFunctions: {
    setNodesSelected: FO,
    selectAll: PO,
    deselectAll: TO,
    selectAllFiltered: EO,
    deselectAllFiltered: DO,
    selectAllOnCurrentPage: AO,
    deselectAllOnCurrentPage: MO,
    getSelectedNodes: IO,
    getSelectedRows: LO
  }
}, OO = {
  moduleName: "RowSelection",
  version: de,
  rowModels: ["clientSide", "infinite", "viewport"],
  beans: [kO],
  dependsOn: [Ny]
};
function GO(e) {
  var t;
  (t = e.expansionSvc) == null || t.expandAll(!0);
}
function BO(e) {
  var t;
  (t = e.expansionSvc) == null || t.expandAll(!1);
}
function VO(e) {
  const t = ci(e), s = lo(e);
  t ? t.onRowHeightChanged() : s && s.onRowHeightChanged();
}
function NO(e, t, s) {
  var n;
  const i = lo(e);
  if (i) {
    if (((n = e.rowGroupColsSvc) == null ? void 0 : n.columns.length) === 0) {
      if (t < 0) {
        be(238);
        return;
      }
      i.setRowCount(t, s);
      return;
    }
    be(28);
    return;
  }
  const r = xc(e);
  if (r) {
    r.setRowCount(t, s);
    return;
  }
}
function HO(e) {
  var t;
  return Lt(e.gos) ? e.rowModel.getBlockStates() : ((t = e.rowNodeBlockLoader) == null ? void 0 : t.getBlockState()) ?? {};
}
function zO(e) {
  return e.rowModel.isLastRowIndexKnown();
}
var Hy = {
  moduleName: "CsrmSsrmSharedApi",
  version: de,
  apiFunctions: {
    expandAll: GO,
    collapseAll: BO,
    onRowHeightChanged: VO
  }
}, zy = {
  moduleName: "SsrmInfiniteSharedApi",
  version: de,
  apiFunctions: {
    setRowCount: NO,
    getCacheBlockState: HO,
    isLastRowIndexKnown: zO
  }
}, WO = class extends L {
  constructor() {
    super(...arguments), this.beanName = "alignedGridsSvc", this.consuming = !1;
  }
  getAlignedGridApis() {
    let e = this.gos.get("alignedGrids") ?? [];
    const t = typeof e == "function";
    return typeof e == "function" && (e = e()), e.map((i) => {
      var n;
      if (!i) {
        be(18), t || be(20);
        return;
      }
      if (this.isGridApi(i))
        return i;
      const r = i;
      return "current" in r ? (n = r.current) == null ? void 0 : n.api : (r.api || be(19), r.api);
    }).filter((i) => !!i && !i.isDestroyed());
  }
  isGridApi(e) {
    return !!e && !!e.dispatchEvent;
  }
  postConstruct() {
    const e = this.fireColumnEvent.bind(this);
    this.addManagedEventListeners({
      columnMoved: e,
      columnVisible: e,
      columnPinned: e,
      columnGroupOpened: e,
      columnResized: e,
      bodyScroll: this.fireScrollEvent.bind(this),
      alignedGridColumn: ({ event: t }) => this.onColumnEvent(t),
      alignedGridScroll: ({ event: t }) => this.onScrollEvent(t)
    });
  }
  // common logic across all the fire methods
  fireEvent(e) {
    this.consuming || this.getAlignedGridApis().forEach((t) => {
      t.isDestroyed() || t.dispatchEvent(e);
    });
  }
  // common logic across all consume methods. very little common logic, however extracting
  // guarantees consistency across the methods.
  onEvent(e) {
    this.consuming = !0, e(), this.consuming = !1;
  }
  fireColumnEvent(e) {
    this.fireEvent({
      type: "alignedGridColumn",
      event: e
    });
  }
  fireScrollEvent(e) {
    e.direction === "horizontal" && this.fireEvent({
      type: "alignedGridScroll",
      event: e
    });
  }
  onScrollEvent(e) {
    this.onEvent(() => {
      this.beans.ctrlsSvc.getScrollFeature().setHorizontalScrollPosition(e.left, !0);
    });
  }
  extractDataFromEvent(e, t) {
    const s = [];
    return e.columns ? e.columns.forEach((i) => {
      s.push(t(i));
    }) : e.column && s.push(t(e.column)), s;
  }
  getMasterColumns(e) {
    return this.extractDataFromEvent(e, (t) => t);
  }
  getColumnIds(e) {
    return this.extractDataFromEvent(e, (t) => t.getColId());
  }
  onColumnEvent(e) {
    this.onEvent(() => {
      switch (e.type) {
        case "columnMoved":
        case "columnVisible":
        case "columnPinned":
        case "columnResized": {
          this.processColumnEvent(e);
          break;
        }
        case "columnGroupOpened": {
          this.processGroupOpenedEvent(e);
          break;
        }
        case "columnPivotChanged":
          I(21);
          break;
      }
    });
  }
  processGroupOpenedEvent(e) {
    const { colGroupSvc: t } = this.beans;
    t && e.columnGroups.forEach((s) => {
      let i = null;
      s && (i = t.getProvidedColGroup(s.getGroupId())), !(s && !i) && t.setColumnGroupOpened(i, s.isExpanded(), "alignedGridChanged");
    });
  }
  processColumnEvent(e) {
    var d;
    const t = e.column;
    let s = null;
    const i = this.beans, { colResize: r, ctrlsSvc: n, colModel: o } = i;
    if (t && (s = o.getColDefCol(t.getColId())), t && !s)
      return;
    const a = this.getMasterColumns(e);
    switch (e.type) {
      case "columnMoved":
        {
          const h = e.api.getColumnState().map((p) => ({ colId: p.colId }));
          ws(i, { state: h, applyOrder: !0 }, "alignedGridChanged");
        }
        break;
      case "columnVisible":
        {
          const h = e.api.getColumnState().map((p) => ({ colId: p.colId, hide: p.hide }));
          ws(i, { state: h }, "alignedGridChanged");
        }
        break;
      case "columnPinned":
        {
          const h = e.api.getColumnState().map((p) => ({ colId: p.colId, pinned: p.pinned }));
          ws(i, { state: h }, "alignedGridChanged");
        }
        break;
      case "columnResized": {
        const u = e, h = {};
        a.forEach((p) => {
          h[p.getId()] = { key: p.getColId(), newWidth: p.getActualWidth() };
        }), (d = u.flexColumns) == null || d.forEach((p) => {
          h[p.getId()] && delete h[p.getId()];
        }), r == null || r.setColumnWidths(
          Object.values(h),
          !1,
          u.finished,
          "alignedGridChanged"
        );
        break;
      }
    }
    const c = n.getGridBodyCtrl().isVerticalScrollShowing();
    this.getAlignedGridApis().forEach((u) => {
      u.setGridOption("alwaysShowVerticalScroll", c);
    });
  }
}, _O = {
  moduleName: "AlignedGrids",
  version: de,
  beans: [WO]
}, UO = class extends Hw {
  constructor() {
    super(...arguments), this.beanName = "csrmNodeSvc";
  }
}, Ed = class {
  constructor() {
    this.removals = /* @__PURE__ */ new Set(), this.updates = /* @__PURE__ */ new Map();
  }
  /** Marks a row as removed. Order of operations is: remove, update, add */
  remove(e) {
    this.removals.add(e), this.updates.delete(e);
  }
  /** Marks a row as updated. Order of operations is: remove, update, add */
  update(e) {
    this.updates.has(e) || (this.removals.delete(e), this.updates.set(e, !1));
  }
  /** Marks a row as added. Order of operation is: remove, update, add */
  add(e) {
    this.removals.delete(e), this.updates.set(e, !0);
  }
};
function $O(e) {
  if (ke(e.childrenAfterSort))
    return;
  const t = e.childrenAfterSort;
  for (let s = 0; s < t.length; s++) {
    const i = t[s], r = s === 0, n = s === e.childrenAfterSort.length - 1;
    i.setFirstChild(r), i.lastChild !== n && (i.lastChild = n, i.dispatchRowEvent("lastChildChanged")), i.childIndex !== s && (i.childIndex = s, i.dispatchRowEvent("childIndexChanged"));
  }
}
function Wy(e) {
  e.sibling && (e.sibling.childrenAfterSort = e.childrenAfterSort), $O(e);
}
var jO = class extends L {
  constructor() {
    super(...arguments), this.beanName = "sortStage", this.refreshProps = /* @__PURE__ */ new Set(["postSortRows", "groupDisplayType", "accentedSort"]), this.step = "sort";
  }
  execute(e) {
    const t = this.beans, s = t.sortSvc.getSortOptions(), i = W(s) && s.length > 0, r = i && !!e.changedRowNodes && // in time we can remove this check, so that delta sort is always
    // on if transactions are present. it's off for now so that we can
    // selectively turn it on and test it with some select users before
    // rolling out to everyone.
    this.gos.get("deltaSort"), n = s.some(({ column: o }) => ti(t.gos) ? o.isPrimary() && o.isRowGroupActive() : !!o.getColDef().showRowGroup);
    this.sort(
      t,
      s,
      i,
      r,
      e.changedRowNodes,
      e.changedPath,
      n
    );
  }
  sort(e, t, s, i, r, n, o) {
    const { gos: a, colModel: l, rowGroupColsSvc: c, groupHideOpenParentsSvc: d, rowNodeSorter: u } = e, h = a.get("groupMaintainOrder"), p = l.getCols().some((C) => C.isRowGroupActive()), g = l.isPivotMode(), f = a.getCallback("postSortRows"), m = (C) => {
      var x;
      d == null || d.pullDownGroupDataForHideOpenParents(C.childrenAfterAggFilter, !0);
      const w = g && C.leafGroup, y = h && p && !C.leafGroup && !o;
      let b;
      if (y) {
        const M = (x = c == null ? void 0 : c.columns) == null ? void 0 : x[C.level + 1], T = (M == null ? void 0 : M.getSort()) === null, F = C.childrenAfterAggFilter.slice(0);
        if (C.childrenAfterSort && !T) {
          const k = {};
          C.childrenAfterSort.forEach((O, D) => {
            k[O.id] = D;
          }), F.sort(
            (O, D) => (k[O.id] ?? 0) - (k[D.id] ?? 0)
          );
        }
        b = F;
      } else !s || w ? b = C.childrenAfterAggFilter.slice(0) : i && r ? b = KO(u, C, r, n, t) : b = u.doFullSort(C.childrenAfterAggFilter, t);
      if (C.childrenAfterSort = b, Wy(C), f) {
        const M = { nodes: C.childrenAfterSort };
        f(M);
      }
    };
    n == null || n.forEachChangedNodeDepthFirst(m);
  }
};
function KO(e, t, s, i, r) {
  const n = t.childrenAfterAggFilter, o = t.childrenAfterSort;
  if (!o)
    return e.doFullSort(n, r);
  const a = /* @__PURE__ */ new Set(), l = [], c = s.updates;
  for (let u = 0, h = n.length; u < h; ++u) {
    const p = n[u];
    c.has(p) || i && !i.canSkip(p) ? l.push({
      currentPos: l.length,
      rowNode: p
    }) : a.add(p.id);
  }
  const d = o.filter((u) => a.has(u.id)).map((u, h) => ({ currentPos: h, rowNode: u }));
  return l.sort((u, h) => e.compareRowNodes(r, u, h)), qO(e, r, l, d);
}
function qO(e, t, s, i) {
  const r = [];
  let n = 0, o = 0;
  const a = s.length, l = i.length;
  for (; n < a && o < l; ) {
    const c = s[n], d = i[o], u = e.compareRowNodes(t, c, d);
    let h;
    u < 0 ? (h = c, ++n) : (h = d, ++o), r.push(h.rowNode);
  }
  for (; n < a; )
    r.push(s[n++].rowNode);
  for (; o < l; )
    r.push(i[o++].rowNode);
  return r;
}
var YO = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowModel", this.onRowHeightChanged_debounced = Et(this, this.onRowHeightChanged.bind(this), 100), this.rootNode = null, this.rowsToDisplay = [], this.started = !1, this.shouldSkipSettingDataOnStart = !1, this.isRefreshingModel = !1, this.rowNodesCountReady = !1, this.rowCountReady = !1;
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.valueCache = e.valueCache, this.filterStage = e.filterStage, this.sortStage = e.sortStage, this.flattenStage = e.flattenStage, this.groupStage = e.groupStage, this.aggStage = e.aggStage, this.pivotStage = e.pivotStage, this.filterAggStage = e.filterAggStage;
  }
  postConstruct() {
    this.orderedStages = [
      this.groupStage,
      this.filterStage,
      this.pivotStage,
      this.aggStage,
      this.sortStage,
      this.filterAggStage,
      this.flattenStage
    ].filter((s) => !!s);
    const e = this.refreshModel.bind(this, { step: "group" }), t = this.refreshModel.bind(this, {
      step: "group",
      // after cols change, row grouping (the first stage) could of changed
      afterColumnsChanged: !0,
      keepRenderedRows: !0,
      // we want animations cos sorting or filtering could be applied
      animate: !this.gos.get("suppressAnimationFrame")
    });
    this.addManagedEventListeners({
      newColumnsLoaded: t,
      columnRowGroupChanged: e,
      columnValueChanged: this.onValueChanged.bind(this),
      columnPivotChanged: this.refreshModel.bind(this, { step: "pivot" }),
      filterChanged: this.onFilterChanged.bind(this),
      sortChanged: this.onSortChanged.bind(this),
      columnPivotModeChanged: e,
      gridStylesChanged: this.onGridStylesChanges.bind(this),
      gridReady: this.onGridReady.bind(this)
    }), this.addPropertyListeners(), this.rootNode = new bs(this.beans), this.initRowManager();
  }
  initRowManager() {
    const { gos: e, beans: t, nodeManager: s } = this, i = e.get("treeData"), r = e.get("treeDataChildrenField"), n = r || i;
    let o;
    n && (o = r ? t.csrmChildrenTreeNodeSvc : t.csrmPathTreeNodeSvc), o || (o = t.csrmNodeSvc), s !== o && (s == null || s.deactivate(), this.nodeManager = o), o.activate(this.rootNode);
  }
  addPropertyListeners() {
    const e = [
      "treeData",
      "treeDataChildrenField",
      ...this.orderedStages.flatMap(({ refreshProps: t }) => [...t])
    ];
    this.addManagedPropertyListeners(e, (t) => {
      var i;
      const s = (i = t.changeSet) == null ? void 0 : i.properties;
      s && this.onPropChange(s);
    }), this.addManagedPropertyListener("rowData", () => this.onPropChange(["rowData"])), this.addManagedPropertyListener("rowHeight", () => this.resetRowHeights());
  }
  start() {
    this.started = !0, this.shouldSkipSettingDataOnStart ? this.refreshModel({
      step: "group",
      newData: !0,
      rowDataUpdated: !0
    }) : this.setInitialData();
  }
  setInitialData() {
    this.gos.get("rowData") && (this.shouldSkipSettingDataOnStart = !0, this.onPropChange(["rowData"]));
  }
  ensureRowHeightsValid(e, t, s, i) {
    let r, n = !1;
    do {
      r = !1;
      const o = this.getRowIndexAtPixel(e), a = this.getRowIndexAtPixel(t), l = Math.max(o, s), c = Math.min(a, i);
      for (let d = l; d <= c; d++) {
        const u = this.getRow(d);
        if (u.rowHeightEstimated) {
          const h = qt(this.beans, u);
          u.setRowHeight(h.height), r = !0, n = !0;
        }
      }
      r && this.setRowTopAndRowIndex();
    } while (r);
    return n;
  }
  onPropChange(e) {
    var c, d;
    if (!this.rootNode)
      return;
    const t = this.gos, s = new Set(e), i = {
      step: "nothing",
      changedProps: s
    }, r = s.has("rowData"), n = s.has("treeData"), a = s.has("treeDataChildrenField") || n && !t.get("treeDataChildrenField");
    let l;
    if (n && (i.step = "group"), (a || r) && (l = t.get("rowData"), l != null && !Array.isArray(l) && (l = null, I(1))), a && (r || (l = ((c = this.nodeManager) == null ? void 0 : c.extractRowData()) ?? l), this.initRowManager()), l && (!a && this.started && !this.isEmpty() && l.length > 0 && t.exists("getRowId") && // this property is a backwards compatibility property, for those who want
    // the old behaviour of Row IDs but NOT Immutable Data.
    !t.get("resetRowDataOnUpdate") ? (i.keepRenderedRows = !0, i.animate = !this.gos.get("suppressAnimationFrame"), i.changedRowNodes = new Ed(), this.nodeManager.setImmutableRowData(i, l)) : (i.step = "group", i.rowDataUpdated = !0, i.newData = !0, (d = this.beans.selectionSvc) == null || d.reset("rowDataChanged"), this.rowNodesCountReady = !0, this.nodeManager.setNewRowData(l))), i.step === "nothing") {
      for (const { refreshProps: u, step: h } of this.orderedStages)
        if (e.some((p) => u.has(p))) {
          i.step = h;
          break;
        }
    }
    i.step !== "nothing" && this.refreshModel(i);
  }
  setRowTopAndRowIndex() {
    const { beans: e } = this, t = e.environment.getDefaultRowHeight();
    let s = 0;
    const i = /* @__PURE__ */ new Set(), r = It(this.gos, "normal"), n = this.rowsToDisplay;
    for (let o = 0, a = n.length; o < a; ++o) {
      const l = n[o];
      if (l.id != null && i.add(l.id), l.rowHeight == null) {
        const c = qt(e, l, r, t);
        l.setRowHeight(c.height, c.estimated);
      }
      l.setRowTop(s), l.setRowIndex(o), s += l.rowHeight;
    }
    return i;
  }
  clearRowTopAndRowIndex(e, t) {
    const s = e.active, i = (n) => {
      n && n.id != null && !t.has(n.id) && n.clearRowTopAndRowIndex();
    }, r = (n) => {
      if (n !== null && (i(n), i(n.detailNode), i(n.sibling), n.hasChildren() && n.childrenAfterGroup)) {
        const o = n.level == -1;
        s && !o && !n.expanded || n.childrenAfterGroup.forEach(r);
      }
    };
    r(this.rootNode);
  }
  // returns false if row was moved, otherwise true
  ensureRowsAtPixel(e, t, s = 0) {
    var a;
    const i = this.getRowIndexAtPixel(t), r = this.getRow(i), n = !this.gos.get("suppressAnimationFrame");
    if (r === e[0])
      return !1;
    const o = (a = this.rootNode) == null ? void 0 : a.allLeafChildren;
    return o ? (e.forEach((l) => {
      kt(o, l);
    }), e.forEach((l, c) => {
      o.splice(Math.max(i + s, 0) + c, 0, l);
    }), e.forEach((l, c) => {
      l.sourceRowIndex = c;
    }), this.refreshModel({
      step: "group",
      keepRenderedRows: !0,
      animate: n,
      rowNodesOrderChanged: !0
      // We assume the order changed and we don't need to check if it really did
    }), !0) : !1;
  }
  highlightRowAtPixel(e, t) {
    const s = t != null ? this.getRowIndexAtPixel(t) : null, i = s != null ? this.getRow(s) : null;
    if (!i || !e || t == null) {
      this.clearHighlightedRow();
      return;
    }
    const r = this.getHighlightPosition(t, i), n = this.isHighlightingCurrentPosition(e, i, r), o = this.lastHighlightedRow != null && this.lastHighlightedRow !== i;
    (n || o) && (this.clearHighlightedRow(), n) || (this.setRowNodeHighlighted(i, r), this.lastHighlightedRow = i);
  }
  setRowNodeHighlighted(e, t) {
    e.highlighted !== t && (e.highlighted = t, e.dispatchRowEvent("rowHighlightChanged"));
  }
  getHighlightPosition(e, t) {
    if (!t) {
      const r = this.getRowIndexAtPixel(e);
      if (t = this.getRow(r || 0), !t)
        return "Below";
    }
    const { rowTop: s, rowHeight: i } = t;
    return e - s < i / 2 ? "Above" : "Below";
  }
  getLastHighlightedRowNode() {
    return this.lastHighlightedRow;
  }
  isHighlightingCurrentPosition(e, t, s) {
    if (e === t)
      return !0;
    const i = s === "Above" ? -1 : 1;
    return this.getRow(t.rowIndex + i) === e;
  }
  clearHighlightedRow() {
    this.lastHighlightedRow && (this.setRowNodeHighlighted(this.lastHighlightedRow, null), this.lastHighlightedRow = null);
  }
  isLastRowIndexKnown() {
    return !0;
  }
  getRowCount() {
    return this.rowsToDisplay ? this.rowsToDisplay.length : 0;
  }
  /**
   * Returns the number of rows with level === 1
   */
  getTopLevelRowCount() {
    const e = this.rootNode;
    if (!e || this.rowsToDisplay.length === 0)
      return 0;
    if (this.rowsToDisplay && this.rowsToDisplay[0] === e)
      return 1;
    const s = e.childrenAfterAggFilter, i = e.sibling ? 1 : 0;
    return (s ? s.length : 0) + i;
  }
  /**
   * Get the row display index by the top level index
   * top level index is the index of rows with level === 1
   */
  getTopLevelRowDisplayedIndex(e) {
    const { rootNode: t, rowsToDisplay: s } = this;
    if (!t || !s.length || s[0] === t)
      return e;
    const { childrenAfterSort: r } = t, n = (a) => {
      let l = r[a];
      if (this.gos.get("groupHideOpenParents"))
        for (; l.expanded && l.childrenAfterSort && l.childrenAfterSort.length > 0; )
          l = l.childrenAfterSort[0];
      return l.rowIndex;
    }, { footerSvc: o } = this.beans;
    return o ? o.getTopDisplayIndex(s, e, r, n) : n(e);
  }
  getRowBounds(e) {
    const t = this.rowsToDisplay[e];
    return t ? {
      rowTop: t.rowTop,
      rowHeight: t.rowHeight
    } : null;
  }
  onRowGroupOpened() {
    const e = Wn(this.gos);
    this.refreshModel({ step: "map", keepRenderedRows: !0, animate: e });
  }
  onFilterChanged(e) {
    if (e.afterDataChange)
      return;
    const t = Wn(this.gos), i = e.columns.length === 0 || e.columns.some((r) => r.isPrimary()) ? "filter" : "filter_aggregates";
    this.refreshModel({ step: i, keepRenderedRows: !0, animate: t });
  }
  onSortChanged() {
    const e = Wn(this.gos);
    this.refreshModel({
      step: "sort",
      keepRenderedRows: !0,
      animate: e
    });
  }
  getType() {
    return "clientSide";
  }
  onValueChanged() {
    this.refreshModel({ step: this.colModel.isPivotActive() ? "pivot" : "aggregate" });
  }
  createChangePath(e) {
    const t = !(e != null && e.length), s = new so(!1, this.rootNode);
    return t && (s.active = !1), s;
  }
  isSuppressModelUpdateAfterUpdateTransaction(e) {
    if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction"))
      return !1;
    const t = e.rowNodeTransactions;
    return t ? !t.some(
      (r) => r.add != null && r.add.length > 0 || r.remove != null && r.remove.length > 0
    ) : !1;
  }
  refreshModel(e) {
    var r, n;
    if (!this.rootNode)
      return;
    const t = e.rowNodeTransactions, s = e.changedPath ?? (e.changedPath = this.createChangePath(t));
    if ((n = (r = this.nodeManager).refreshModel) == null || n.call(r, e), this.eventSvc.dispatchEvent({ type: "beforeRefreshModel", params: e }), !this.started || (e.rowDataUpdated && this.eventSvc.dispatchEvent({ type: "rowDataUpdated" }), this.isRefreshingModel || this.colModel.changeEventsDispatching || this.isSuppressModelUpdateAfterUpdateTransaction(e)))
      return;
    switch (this.isRefreshingModel = !0, e.step) {
      case "group":
        this.doRowGrouping(
          e.rowNodeTransactions,
          e.changedRowNodes,
          s,
          !!e.rowNodesOrderChanged,
          !!e.afterColumnsChanged
        );
      case "filter":
        this.doFilter(s);
      case "pivot":
        this.doPivot(s);
      case "aggregate":
        this.doAggregate(s);
      case "filter_aggregates":
        this.doFilterAggregates(s);
      case "sort":
        this.doSort(e.changedRowNodes, s);
      case "map":
        this.doRowsToDisplay();
    }
    const i = this.setRowTopAndRowIndex();
    this.clearRowTopAndRowIndex(s, i), this.isRefreshingModel = !1, this.eventSvc.dispatchEvent({
      type: "modelUpdated",
      animate: e.animate,
      keepRenderedRows: e.keepRenderedRows,
      newData: e.newData,
      newPage: !1,
      keepUndoRedoStack: e.keepUndoRedoStack
    });
  }
  isEmpty() {
    var e, t, s;
    return !((t = (e = this.rootNode) == null ? void 0 : e.allLeafChildren) != null && t.length) || !((s = this.colModel) != null && s.ready);
  }
  isRowsToRender() {
    return this.rowsToDisplay.length > 0;
  }
  getNodesInRangeForSelection(e, t) {
    let s = !1, i = !1;
    const r = [], n = mn(this.gos);
    return this.forEachNodeAfterFilterAndSort((o) => {
      if (i)
        return;
      if (s && (o === t || o === e) && (i = !0, o.group && n)) {
        r.push(...o.allLeafChildren);
        return;
      }
      if (!s) {
        if (o !== t && o !== e)
          return;
        s = !0;
      }
      if (!o.group || !n) {
        r.push(o);
        return;
      }
    }), r;
  }
  getTopLevelNodes() {
    var e;
    return ((e = this.rootNode) == null ? void 0 : e.childrenAfterGroup) ?? null;
  }
  getRow(e) {
    return this.rowsToDisplay[e];
  }
  isRowPresent(e) {
    return this.rowsToDisplay.indexOf(e) >= 0;
  }
  getRowIndexAtPixel(e) {
    const t = this.rowsToDisplay;
    if (this.isEmpty() || t.length === 0)
      return -1;
    let s = 0, i = t.length - 1;
    if (e <= 0)
      return 0;
    if (pe(t).rowTop <= e)
      return t.length - 1;
    let n = -1, o = -1;
    for (; ; ) {
      const a = Math.floor((s + i) / 2), l = t[a];
      if (this.isRowInPixel(l, e) || (l.rowTop < e ? s = a + 1 : l.rowTop > e && (i = a - 1), n === s && o === i))
        return a;
      n = s, o = i;
    }
  }
  isRowInPixel(e, t) {
    const s = e.rowTop, i = e.rowTop + e.rowHeight;
    return s <= t && i > t;
  }
  forEachLeafNode(e) {
    var t, s;
    (s = (t = this.rootNode) == null ? void 0 : t.allLeafChildren) == null || s.forEach((i, r) => e(i, r));
  }
  forEachNode(e, t = !1) {
    var s;
    this.recursivelyWalkNodesAndCallback({
      nodes: [...((s = this.rootNode) == null ? void 0 : s.childrenAfterGroup) || []],
      callback: e,
      recursionType: 0,
      index: 0,
      includeFooterNodes: t
    });
  }
  forEachNodeAfterFilter(e, t = !1) {
    var s;
    this.recursivelyWalkNodesAndCallback({
      nodes: [...((s = this.rootNode) == null ? void 0 : s.childrenAfterAggFilter) || []],
      callback: e,
      recursionType: 1,
      index: 0,
      includeFooterNodes: t
    });
  }
  forEachNodeAfterFilterAndSort(e, t = !1) {
    var s;
    this.recursivelyWalkNodesAndCallback({
      nodes: [...((s = this.rootNode) == null ? void 0 : s.childrenAfterSort) || []],
      callback: e,
      recursionType: 2,
      index: 0,
      includeFooterNodes: t
    });
  }
  forEachPivotNode(e, t = !1) {
    const s = this.rootNode;
    s && this.recursivelyWalkNodesAndCallback({
      nodes: [s],
      callback: e,
      recursionType: 3,
      index: 0,
      includeFooterNodes: t
    });
  }
  // iterates through each item in memory, and calls the callback function
  // nodes - the rowNodes to traverse
  // callback - the user provided callback
  // recursion type - need this to know what child nodes to recurse, eg if looking at all nodes, or filtered notes etc
  // index - works similar to the index in forEach in javascript's array function
  recursivelyWalkNodesAndCallback(e) {
    const { nodes: t, callback: s, recursionType: i, includeFooterNodes: r } = e;
    let { index: n } = e;
    const { footerSvc: o } = this.beans;
    o == null || o.addNodes(e, t, s, r, this.rootNode, "top");
    for (let a = 0; a < t.length; a++) {
      const l = t[a];
      if (s(l, n++), l.hasChildren() && !l.footer) {
        let c = null;
        switch (i) {
          case 0:
            c = l.childrenAfterGroup;
            break;
          case 1:
            c = l.childrenAfterAggFilter;
            break;
          case 2:
            c = l.childrenAfterSort;
            break;
          case 3:
            c = l.leafGroup ? null : l.childrenAfterSort;
            break;
        }
        c && (n = this.recursivelyWalkNodesAndCallback({
          nodes: [...c],
          callback: s,
          recursionType: i,
          index: n,
          includeFooterNodes: r
        }));
      }
    }
    return o == null || o.addNodes(e, t, s, r, this.rootNode, "bottom"), n;
  }
  // it's possible to recompute the aggregate without doing the other parts
  // + api.refreshClientSideRowModel('aggregate')
  doAggregate(e) {
    var s;
    const t = this.rootNode;
    t && ((s = this.aggStage) == null || s.execute({ rowNode: t, changedPath: e }));
  }
  doFilterAggregates(e) {
    const t = this.rootNode;
    this.filterAggStage ? this.filterAggStage.execute({ rowNode: t, changedPath: e }) : t.childrenAfterAggFilter = t.childrenAfterFilter;
  }
  doSort(e, t) {
    const { groupHideOpenParentsSvc: s } = this.beans;
    this.sortStage ? this.sortStage.execute({
      rowNode: this.rootNode,
      changedRowNodes: e,
      changedPath: t
    }) : t.forEachChangedNodeDepthFirst((i) => {
      s == null || s.pullDownGroupDataForHideOpenParents(i.childrenAfterAggFilter, !0), i.childrenAfterSort = i.childrenAfterAggFilter.slice(0), Wy(i);
    }), s == null || s.updateGroupDataForHideOpenParents(t);
  }
  doRowGrouping(e, t, s, i, r) {
    const n = this.nodeManager.treeData, o = this.rootNode;
    if (!n) {
      const a = this.groupStage;
      if (a)
        a.execute({
          rowNode: o,
          changedPath: s,
          changedRowNodes: t,
          rowNodeTransactions: e,
          rowNodesOrderChanged: i,
          afterColumnsChanged: r
        });
      else {
        const l = o.sibling;
        o.childrenAfterGroup = o.allLeafChildren, l && (l.childrenAfterGroup = o.childrenAfterGroup), o.updateHasChildren();
      }
    }
    this.rowNodesCountReady && (this.rowCountReady = !0, this.eventSvc.dispatchEventOnce({ type: "rowCountReady" }));
  }
  doFilter(e) {
    this.filterStage ? this.filterStage.execute({ rowNode: this.rootNode, changedPath: e }) : e.forEachChangedNodeDepthFirst((t) => {
      t.childrenAfterFilter = t.childrenAfterGroup, by(t);
    }, !0);
  }
  doPivot(e) {
    var t;
    (t = this.pivotStage) == null || t.execute({ rowNode: this.rootNode, changedPath: e });
  }
  getRowNode(e) {
    if (typeof e == "string" && e.indexOf(oa) == 0) {
      let s;
      return this.forEachNode((i) => {
        i.id === e && (s = i);
      }), s;
    }
    return this.nodeManager.getRowNode(e);
  }
  batchUpdateRowData(e, t) {
    if (this.applyAsyncTransactionsTimeout == null) {
      this.rowDataTransactionBatch = [];
      const s = this.gos.get("asyncTransactionWaitMillis");
      this.applyAsyncTransactionsTimeout = window.setTimeout(() => {
        this.isAlive() && this.executeBatchUpdateRowData();
      }, s);
    }
    this.rowDataTransactionBatch.push({ rowDataTransaction: e, callback: t });
  }
  flushAsyncTransactions() {
    this.applyAsyncTransactionsTimeout != null && (clearTimeout(this.applyAsyncTransactionsTimeout), this.executeBatchUpdateRowData());
  }
  executeBatchUpdateRowData() {
    var r, n;
    (r = this.valueCache) == null || r.onDataChanged();
    const e = [], t = [], s = new Ed();
    let i = !1;
    (n = this.rowDataTransactionBatch) == null || n.forEach((o) => {
      this.rowNodesCountReady = !0;
      const { rowNodeTransaction: a, rowsInserted: l } = this.nodeManager.updateRowData(
        o.rowDataTransaction,
        s
      );
      l && (i = !0), t.push(a), o.callback && e.push(o.callback.bind(null, a));
    }), this.commitTransactions(t, i, s), e.length > 0 && window.setTimeout(() => {
      e.forEach((o) => o());
    }, 0), t.length > 0 && this.eventSvc.dispatchEvent({
      type: "asyncTransactionsFlushed",
      results: t
    }), this.rowDataTransactionBatch = null, this.applyAsyncTransactionsTimeout = void 0;
  }
  /**
   * Used to apply transaction changes.
   * Called by gridApi & rowDragFeature
   */
  updateRowData(e) {
    var r;
    (r = this.valueCache) == null || r.onDataChanged(), this.rowNodesCountReady = !0;
    const t = new Ed(), { rowNodeTransaction: s, rowsInserted: i } = this.nodeManager.updateRowData(e, t);
    return this.commitTransactions([s], i, t), s;
  }
  /**
   * Common to:
   * - executeBatchUpdateRowData (batch transactions)
   * - updateRowData (single transaction)
   * - setImmutableRowData (generated transaction)
   *
   * @param rowNodeTrans - the transactions to apply
   * @param orderChanged - whether the order of the rows has changed, either via generated transaction or user provided addIndex
   */
  commitTransactions(e, t, s) {
    this.refreshModel({
      step: "group",
      rowDataUpdated: !0,
      rowNodeTransactions: e,
      rowNodesOrderChanged: t,
      keepRenderedRows: !0,
      animate: !this.gos.get("suppressAnimationFrame"),
      changedRowNodes: s,
      changedPath: this.createChangePath(e)
    });
  }
  doRowsToDisplay() {
    const { flattenStage: e, rootNode: t } = this;
    let s;
    if (e)
      s = e.execute({ rowNode: t });
    else {
      s = (t == null ? void 0 : t.childrenAfterSort) ?? [];
      for (const i of s)
        i.setUiLevel(0);
    }
    this.rowsToDisplay = s;
  }
  onRowHeightChanged() {
    this.refreshModel({
      step: "map",
      keepRenderedRows: !0,
      keepUndoRedoStack: !0
    });
  }
  /** This method is debounced. It is used for row auto-height. If we don't debounce,
   * then the Row Models will end up recalculating each row position
   * for each row height change and result in the Row Renderer laying out rows.
   * This is particularly bad if using print layout, and showing eg 1,000 rows,
   * each row will change it's height, causing Row Model to update 1,000 times.
   */
  onRowHeightChangedDebounced() {
    this.onRowHeightChanged_debounced();
  }
  resetRowHeights() {
    const e = this.rootNode;
    if (!e)
      return;
    const t = this.resetRowHeightsForAllRowNodes();
    e.setRowHeight(e.rowHeight, !0), e.sibling && e.sibling.setRowHeight(e.sibling.rowHeight, !0), t && this.onRowHeightChanged();
  }
  resetRowHeightsForAllRowNodes() {
    let e = !1;
    return this.forEachNode((t) => {
      t.setRowHeight(t.rowHeight, !0);
      const s = t.detailNode;
      s && s.setRowHeight(s.rowHeight, !0), t.sibling && t.sibling.setRowHeight(t.sibling.rowHeight, !0), e = !0;
    }), e;
  }
  onGridStylesChanges(e) {
    var t;
    if (e.rowHeightChanged) {
      if ((t = this.beans.rowAutoHeight) != null && t.active)
        return;
      this.resetRowHeights();
    }
  }
  onGridReady() {
    this.started || this.setInitialData();
  }
  isRowDataLoaded() {
    return this.rowCountReady;
  }
  destroy() {
    super.destroy(), this.clearHighlightedRow(), this.started = !1, this.rootNode = null, this.nodeManager = null, this.rowDataTransactionBatch = null, this.lastHighlightedRow = null, this.orderedStages = Tt, this.rowsToDisplay = Tt;
  }
};
function XO(e) {
  var t;
  (t = e.expansionSvc) == null || t.onGroupExpandedOrCollapsed();
}
function ZO(e, t) {
  const s = ci(e);
  s && ((!t || t === "everything") && (t = "group"), s.refreshModel({
    step: t,
    keepRenderedRows: !0,
    animate: !e.gos.get("suppressAnimationFrame")
  }));
}
function QO(e) {
  var t;
  return ((t = ci(e)) == null ? void 0 : t.isEmpty()) ?? !0;
}
function JO(e, t) {
  var s;
  (s = ci(e)) == null || s.forEachLeafNode(t);
}
function eG(e, t) {
  var s;
  (s = ci(e)) == null || s.forEachNodeAfterFilter(t);
}
function tG(e, t) {
  var s;
  (s = ci(e)) == null || s.forEachNodeAfterFilterAndSort(t);
}
function sG(e) {
  var t, s;
  if ((t = e.rowAutoHeight) != null && t.active) {
    I(3);
    return;
  }
  (s = ci(e)) == null || s.resetRowHeights();
}
function iG(e, t) {
  return e.frameworkOverrides.wrapIncoming(
    () => {
      var s;
      return (s = ci(e)) == null ? void 0 : s.updateRowData(t);
    }
  );
}
function rG(e, t, s) {
  e.frameworkOverrides.wrapIncoming(
    () => {
      var i;
      return (i = ci(e)) == null ? void 0 : i.batchUpdateRowData(t, s);
    }
  );
}
function nG(e) {
  e.frameworkOverrides.wrapIncoming(() => {
    var t;
    return (t = ci(e)) == null ? void 0 : t.flushAsyncTransactions();
  });
}
function oG(e) {
  var t;
  return (t = e.selectionSvc) == null ? void 0 : t.getBestCostNodeSelection();
}
var aG = {
  moduleName: "ClientSideRowModel",
  version: de,
  rowModels: ["clientSide"],
  beans: [UO, YO, jO],
  dependsOn: [zh]
}, lG = {
  moduleName: "ClientSideRowModelApi",
  version: de,
  rowModels: ["clientSide"],
  apiFunctions: {
    onGroupExpandedOrCollapsed: XO,
    refreshClientSideRowModel: ZO,
    isRowDataEmpty: QO,
    forEachLeafNode: JO,
    forEachNodeAfterFilter: eG,
    forEachNodeAfterFilterAndSort: tG,
    resetRowHeights: sG,
    applyTransaction: iG,
    applyTransactionAsync: rG,
    flushAsyncTransactions: nG,
    getBestCostNodeSelection: oG
  },
  dependsOn: [Hy]
}, cG = class extends L {
  constructor() {
    super(...arguments), this.beanName = "gridSerializer";
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.colModel = e.colModel, this.rowModel = e.rowModel, this.pinnedRowModel = e.pinnedRowModel;
  }
  serialize(e, t = {}) {
    const { allColumns: s, columnKeys: i, skipRowGroups: r } = t, n = this.getColumnsToExport(
      s,
      r,
      i
    );
    return [
      // first pass, put in the header names of the cols
      this.prepareSession(n),
      this.prependContent(t),
      this.exportColumnGroups(t, n),
      this.exportHeaders(t, n),
      this.processPinnedTopRows(t, n),
      this.processRows(t, n),
      this.processPinnedBottomRows(t, n),
      this.appendContent(t)
    ].reduce((o, a) => a(o), e).parse();
  }
  processRow(e, t, s, i) {
    var g;
    const r = t.shouldRowBeSkipped || (() => !1), o = t.rowPositions != null || !!t.onlySelected, a = this.gos.get("groupHideOpenParents") && !o, l = this.colModel.isPivotMode() ? i.leafGroup : !i.group, c = !!i.footer, d = i.allChildrenCount === 1 && ((g = i.childrenAfterGroup) == null ? void 0 : g.length) === 1 && UP(this.gos, i);
    if (!l && !c && (t.skipRowGroups || d || a) || t.onlySelected && !i.isSelected() || t.skipPinnedTop && i.rowPinned === "top" || t.skipPinnedBottom && i.rowPinned === "bottom" || i.level === -1 && !l && !c || r(this.gos.addGridCommonParams({ node: i })))
      return;
    const p = e.onNewBodyRow(i);
    if (s.forEach((f, m) => {
      p.onColumn(f, m, i);
    }), t.getCustomContentBelowRow) {
      const f = t.getCustomContentBelowRow(this.gos.addGridCommonParams({ node: i }));
      f && e.addCustomContent(f);
    }
  }
  appendContent(e) {
    return (t) => {
      const s = e.appendContent;
      return s && t.addCustomContent(s), t;
    };
  }
  prependContent(e) {
    return (t) => {
      const s = e.prependContent;
      return s && t.addCustomContent(s), t;
    };
  }
  prepareSession(e) {
    return (t) => (t.prepare(e), t);
  }
  exportColumnGroups(e, t) {
    return (s) => {
      if (!e.skipColumnGroupHeaders) {
        const i = new Yv(), { colGroupSvc: r } = this.beans, n = r ? r.createColumnGroups({
          columns: t,
          idCreator: i,
          pinned: null,
          isStandaloneStructure: !0
        }) : t;
        this.recursivelyAddHeaderGroups(
          n,
          s,
          e.processGroupHeaderCallback
        );
      }
      return s;
    };
  }
  exportHeaders(e, t) {
    return (s) => {
      if (!e.skipColumnHeaders) {
        const i = s.onNewHeaderRow();
        t.forEach((r, n) => {
          i.onColumn(r, n, void 0);
        });
      }
      return s;
    };
  }
  processPinnedTopRows(e, t) {
    return (s) => {
      var r;
      const i = this.processRow.bind(this, s, e, t);
      return e.rowPositions ? e.rowPositions.filter((n) => n.rowPinned === "top").sort((n, o) => n.rowIndex - o.rowIndex).map((n) => {
        var o;
        return (o = this.pinnedRowModel) == null ? void 0 : o.getPinnedTopRow(n.rowIndex);
      }).forEach(i) : (r = this.pinnedRowModel) == null || r.forEachPinnedRow("top", i), s;
    };
  }
  processRows(e, t) {
    return (s) => {
      var c;
      const i = this.rowModel, r = Ye(this.gos), n = Lt(this.gos), o = !r && e.onlySelected, a = this.processRow.bind(this, s, e, t), { exportedRows: l = "filteredAndSorted" } = e;
      if (e.rowPositions)
        return e.rowPositions.filter((d) => d.rowPinned == null).sort((d, u) => d.rowIndex - u.rowIndex).map((d) => i.getRow(d.rowIndex)).forEach(a), s;
      if (this.colModel.isPivotMode())
        return r ? i.forEachPivotNode(a, !0) : n ? i.forEachNodeAfterFilterAndSort(a, !0) : i.forEachNode(a), s;
      if (e.onlySelectedAllPages || o) {
        const d = ((c = this.beans.selectionSvc) == null ? void 0 : c.getSelectedNodes()) ?? [];
        this.replicateSortedOrder(d), d.forEach(a);
      } else
        l === "all" ? i.forEachNode(a) : r || n ? i.forEachNodeAfterFilterAndSort(a, !0) : i.forEachNode(a);
      return s;
    };
  }
  replicateSortedOrder(e) {
    const { sortSvc: t, rowNodeSorter: s } = this.beans;
    if (!t || !s)
      return;
    const i = t.getSortOptions(), r = (n, o) => {
      var a, l;
      return n.rowIndex != null && o.rowIndex != null ? n.rowIndex - o.rowIndex : n.level === o.level ? ((a = n.parent) == null ? void 0 : a.id) === ((l = o.parent) == null ? void 0 : l.id) ? s.compareRowNodes(
        i,
        {
          rowNode: n,
          currentPos: n.rowIndex ?? -1
        },
        {
          rowNode: o,
          currentPos: o.rowIndex ?? -1
        }
      ) : r(n.parent, o.parent) : n.level > o.level ? r(n.parent, o) : r(n, o.parent);
    };
    e.sort(r);
  }
  processPinnedBottomRows(e, t) {
    return (s) => {
      var r;
      const i = this.processRow.bind(this, s, e, t);
      return e.rowPositions ? e.rowPositions.filter((n) => n.rowPinned === "bottom").sort((n, o) => n.rowIndex - o.rowIndex).map((n) => {
        var o;
        return (o = this.pinnedRowModel) == null ? void 0 : o.getPinnedBottomRow(n.rowIndex);
      }).forEach(i) : (r = this.pinnedRowModel) == null || r.forEachPinnedRow("bottom", i), s;
    };
  }
  getColumnsToExport(e = !1, t = !1, s) {
    const { colModel: i, gos: r, visibleCols: n } = this, o = i.isPivotMode();
    if (s && s.length)
      return i.getColsForKeys(s);
    const a = r.get("treeData");
    let l = [];
    return e && !o ? l = i.getCols() : l = n.allCols, l = l.filter(
      (c) => !xi(c) && (t && !a ? !pc(c) : !0)
    ), l;
  }
  recursivelyAddHeaderGroups(e, t, s) {
    const i = [];
    e.forEach((r) => {
      const n = r;
      n.getChildren && n.getChildren().forEach((o) => i.push(o));
    }), e.length > 0 && pt(e[0]) && this.doAddHeaderHeader(t, e, s), i.length > 0 && this.recursivelyAddHeaderGroups(
      i,
      t,
      s
    );
  }
  doAddHeaderHeader(e, t, s) {
    const i = e.onNewHeaderGroupingRow();
    let r = 0;
    t.forEach((n) => {
      const o = n;
      let a;
      s ? a = s(
        this.gos.addGridCommonParams({
          columnGroup: o
        })
      ) : a = this.beans.colNames.getDisplayNameForColumnGroup(o, "header");
      const l = o.getLeafColumns().reduce((c, d, u, h) => {
        let p = pe(c);
        return d.getColumnGroupShow() === "open" ? (!p || p[1] != null) && (p = [u], c.push(p)) : p && p[1] == null && (p[1] = u - 1), u === h.length - 1 && p && p[1] == null && (p[1] = u), c;
      }, []);
      i.onColumn(
        o,
        a || "",
        r++,
        o.getLeafColumns().length - 1,
        l
      );
    });
  }
}, _y = {
  moduleName: "SharedExport",
  version: de,
  beans: [cG]
}, Sf = `\r
`, dG = class extends wy {
  constructor(e) {
    super(e), this.isFirstLine = !0, this.result = "";
    const { suppressQuotes: t, columnSeparator: s } = e;
    this.suppressQuotes = t, this.columnSeparator = s;
  }
  addCustomContent(e) {
    e && (typeof e == "string" ? (/^\s*\n/.test(e) || this.beginNewLine(), e = e.replace(/\r?\n/g, Sf), this.result += e) : e.forEach((t) => {
      this.beginNewLine(), t.forEach((s, i) => {
        i !== 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(s.data.value || ""), s.mergeAcross && this.appendEmptyCells(s.mergeAcross);
      });
    }));
  }
  onNewHeaderGroupingRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
    };
  }
  onNewHeaderGroupingRowColumn(e, t, s, i) {
    s != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(t), this.appendEmptyCells(i);
  }
  appendEmptyCells(e) {
    for (let t = 1; t <= e; t++)
      this.result += this.columnSeparator + this.putInQuotes("");
  }
  onNewHeaderRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewHeaderRowColumn.bind(this)
    };
  }
  onNewHeaderRowColumn(e, t) {
    t != 0 && (this.result += this.columnSeparator), this.result += this.putInQuotes(this.extractHeaderValue(e));
  }
  onNewBodyRow() {
    return this.beginNewLine(), {
      onColumn: this.onNewBodyRowColumn.bind(this)
    };
  }
  onNewBodyRowColumn(e, t, s) {
    t != 0 && (this.result += this.columnSeparator);
    const i = this.extractRowCellValue(e, t, t, "csv", s);
    this.result += this.putInQuotes(i.valueFormatted ?? i.value);
  }
  putInQuotes(e) {
    if (this.suppressQuotes)
      return e;
    if (e == null)
      return '""';
    let t;
    return typeof e == "string" ? t = e : typeof e.toString == "function" ? t = e.toString() : (I(53), t = ""), '"' + t.replace(/"/g, '""') + '"';
  }
  parse() {
    return this.result;
  }
  beginNewLine() {
    this.isFirstLine || (this.result += Sf), this.isFirstLine = !1;
  }
}, uG = class extends vy {
  constructor() {
    super(...arguments), this.beanName = "csvCreator";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.colNames = e.colNames, this.rowGroupColsSvc = e.rowGroupColsSvc, this.valueSvc = e.valueSvc;
  }
  getMergedParams(e) {
    const t = this.gos.get("defaultCsvExportParams");
    return Object.assign({}, t, e);
  }
  export(e) {
    if (this.isExportSuppressed()) {
      I(51);
      return;
    }
    const t = this.getMergedParams(e), s = this.getData(t), i = new Blob(["\uFEFF", s], { type: "text/plain" }), r = typeof t.fileName == "function" ? t.fileName(this.gos.getGridCommonParams()) : t.fileName;
    _h(this.getFileName(r), i);
  }
  exportDataAsCsv(e) {
    this.export(e);
  }
  getDataAsCsv(e, t = !1) {
    const s = t ? Object.assign({}, e) : this.getMergedParams(e);
    return this.getData(s);
  }
  getDefaultFileExtension() {
    return "csv";
  }
  createSerializingSession(e) {
    const { colModel: t, colNames: s, rowGroupColsSvc: i, valueSvc: r, gos: n } = this, {
      processCellCallback: o,
      processHeaderCallback: a,
      processGroupHeaderCallback: l,
      processRowGroupCallback: c,
      suppressQuotes: d,
      columnSeparator: u
    } = e;
    return new dG({
      colModel: t,
      colNames: s,
      valueSvc: r,
      gos: n,
      processCellCallback: o || void 0,
      processHeaderCallback: a || void 0,
      processGroupHeaderCallback: l || void 0,
      processRowGroupCallback: c || void 0,
      suppressQuotes: d || !1,
      columnSeparator: u || ",",
      rowGroupColsSvc: i
    });
  }
  isExportSuppressed() {
    return this.gos.get("suppressCsvExport");
  }
};
function hG(e, t) {
  var s;
  return (s = e.csvCreator) == null ? void 0 : s.getDataAsCsv(t);
}
function pG(e, t) {
  var s;
  (s = e.csvCreator) == null || s.exportDataAsCsv(t);
}
var Uy = {
  moduleName: "CsvExport",
  version: de,
  beans: [uG],
  apiFunctions: {
    getDataAsCsv: hG,
    exportDataAsCsv: pG
  },
  dependsOn: [_y]
}, gG = class extends L {
  constructor(e, t, s) {
    super(), this.id = e, this.parentCache = t, this.params = s, this.state = "needsLoading", this.version = 0, this.startRow = e * s.blockSize, this.endRow = this.startRow + s.blockSize;
  }
  load() {
    this.state = "loading", this.loadFromDatasource();
  }
  setStateWaitingToLoad() {
    this.version++, this.state = "needsLoading";
  }
  pageLoadFailed(e) {
    this.isRequestMostRecentAndLive(e) && (this.state = "failed"), this.dispatchLocalEvent({ type: "loadComplete" });
  }
  pageLoaded(e, t, s) {
    this.successCommon(e, { rowData: t, rowCount: s });
  }
  isRequestMostRecentAndLive(e) {
    const t = e === this.version, s = this.isAlive();
    return t && s;
  }
  successCommon(e, t) {
    this.dispatchLocalEvent({ type: "loadComplete" }), this.isRequestMostRecentAndLive(e) && (this.state = "loaded", this.processServerResult(t));
  }
  postConstruct() {
    this.rowNodes = [];
    const {
      params: { blockSize: e, rowHeight: t },
      startRow: s,
      beans: i,
      rowNodes: r
    } = this;
    for (let n = 0; n < e; n++) {
      const o = s + n, a = new bs(i);
      a.setRowHeight(t), a.uiLevel = 0, a.setRowIndex(o), a.setRowTop(t * o), r.push(a);
    }
  }
  getBlockStateJson() {
    const { id: e, startRow: t, endRow: s, state: i } = this;
    return {
      id: "" + e,
      state: {
        blockNumber: e,
        startRow: t,
        endRow: s,
        pageStatus: i
      }
    };
  }
  setDataAndId(e, t, s) {
    W(t) ? e.setDataAndId(t, s.toString()) : e.setDataAndId(void 0, void 0);
  }
  loadFromDatasource() {
    const e = this.createLoadParams();
    if (ke(this.params.datasource.getRows)) {
      I(90);
      return;
    }
    window.setTimeout(() => {
      this.params.datasource.getRows(e);
    }, 0);
  }
  createLoadParams() {
    const {
      startRow: e,
      endRow: t,
      version: s,
      params: { sortModel: i, filterModel: r },
      gos: n
    } = this;
    return {
      startRow: e,
      endRow: t,
      successCallback: this.pageLoaded.bind(this, s),
      failCallback: this.pageLoadFailed.bind(this, s),
      sortModel: i,
      filterModel: r,
      context: n.getGridCommonParams().context
    };
  }
  forEachNode(e, t, s) {
    this.rowNodes.forEach((i, r) => {
      this.startRow + r < s && e(i, t.value++);
    });
  }
  getRow(e, t = !1) {
    t || (this.lastAccessed = this.params.lastAccessedSequence.value++);
    const s = e - this.startRow;
    return this.rowNodes[s];
  }
  processServerResult(e) {
    const { rowNodes: t, beans: s } = this;
    t.forEach((r, n) => {
      const o = e.rowData ? e.rowData[n] : void 0;
      !r.id && r.alreadyRendered && o && (t[n] = new bs(s), t[n].setRowIndex(r.rowIndex), t[n].setRowTop(r.rowTop), t[n].setRowHeight(r.rowHeight), r.clearRowTopAndRowIndex()), this.setDataAndId(t[n], o, this.startRow + n);
    });
    const i = e.rowCount != null && e.rowCount >= 0 ? e.rowCount : void 0;
    this.parentCache.pageLoaded(this, i);
  }
  destroy() {
    this.rowNodes.forEach((e) => {
      e.clearRowTopAndRowIndex();
    }), super.destroy();
  }
}, fG = 2, mG = class extends L {
  constructor(e) {
    super(), this.params = e, this.lastRowIndexKnown = !1, this.blocks = {}, this.blockCount = 0, this.rowCount = e.initialRowCount;
  }
  // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
  // it will want new pages in the cache as it asks for rows. only when we are inserting /
  // removing rows via the api is dontCreatePage set, where we move rows between the pages.
  getRow(e, t = !1) {
    const s = Math.floor(e / this.params.blockSize);
    let i = this.blocks[s];
    if (!i) {
      if (t)
        return;
      i = this.createBlock(s);
    }
    return i.getRow(e);
  }
  createBlock(e) {
    const t = this.params, s = this.createBean(new gG(e, this, t));
    return this.blocks[s.id] = s, this.blockCount++, this.purgeBlocksIfNeeded(s), t.rowNodeBlockLoader.addBlock(s), s;
  }
  // we have this on infinite row model only, not server side row model,
  // because for server side, it would leave the children in inconsistent
  // state - eg if a node had children, but after the refresh it had data
  // for a different row, then the children would be with the wrong row node.
  refreshCache() {
    if (this.blockCount == 0) {
      this.purgeCache();
      return;
    }
    this.getBlocksInOrder().forEach((t) => t.setStateWaitingToLoad()), this.params.rowNodeBlockLoader.checkBlockToLoad();
  }
  destroy() {
    this.getBlocksInOrder().forEach((e) => this.destroyBlock(e)), super.destroy();
  }
  getRowCount() {
    return this.rowCount;
  }
  isLastRowIndexKnown() {
    return this.lastRowIndexKnown;
  }
  // block calls this, when page loaded
  pageLoaded(e, t) {
    this.isAlive() && (Rr(this.gos, `InfiniteCache - onPageLoaded: page = ${e.id}, lastRow = ${t}`), this.checkRowCount(e, t), this.onCacheUpdated());
  }
  purgeBlocksIfNeeded(e) {
    const t = this.getBlocksInOrder().filter((o) => o != e), s = (o, a) => a.lastAccessed - o.lastAccessed;
    t.sort(s);
    const i = this.params.maxBlocksInCache > 0, r = i ? this.params.maxBlocksInCache - 1 : null, n = fG - 1;
    t.forEach((o, a) => {
      const l = o.state === "needsLoading" && a >= n, c = i ? a >= r : !1;
      if (l || c) {
        if (this.isBlockCurrentlyDisplayed(o) || this.isBlockFocused(o))
          return;
        this.removeBlockFromCache(o);
      }
    });
  }
  isBlockFocused(e) {
    const t = this.beans.focusSvc.getFocusCellToUseAfterRefresh();
    if (!t || t.rowPinned != null)
      return !1;
    const { startRow: s, endRow: i } = e;
    return t.rowIndex >= s && t.rowIndex < i;
  }
  isBlockCurrentlyDisplayed(e) {
    const { startRow: t, endRow: s } = e;
    return this.beans.rowRenderer.isRangeInRenderedViewport(t, s - 1);
  }
  removeBlockFromCache(e) {
    e && this.destroyBlock(e);
  }
  checkRowCount(e, t) {
    if (typeof t == "number" && t >= 0)
      this.rowCount = t, this.lastRowIndexKnown = !0;
    else if (!this.lastRowIndexKnown) {
      const { blockSize: s, overflowSize: i } = this.params, n = (e.id + 1) * s + i;
      this.rowCount < n && (this.rowCount = n);
    }
  }
  setRowCount(e, t) {
    this.rowCount = e, W(t) && (this.lastRowIndexKnown = t), this.lastRowIndexKnown || this.rowCount % this.params.blockSize === 0 && this.rowCount++, this.onCacheUpdated();
  }
  forEachNodeDeep(e) {
    const t = { value: 0 };
    this.getBlocksInOrder().forEach((s) => s.forEachNode(e, t, this.rowCount));
  }
  getBlocksInOrder() {
    const e = (s, i) => s.id - i.id;
    return Object.values(this.blocks).sort(e);
  }
  destroyBlock(e) {
    delete this.blocks[e.id], this.destroyBean(e), this.blockCount--, this.params.rowNodeBlockLoader.removeBlock(e);
  }
  // gets called 1) row count changed 2) cache purged 3) items inserted
  onCacheUpdated() {
    this.isAlive() && (this.destroyAllBlocksPastVirtualRowCount(), this.eventSvc.dispatchEvent({
      type: "storeUpdated"
    }));
  }
  destroyAllBlocksPastVirtualRowCount() {
    const e = [];
    this.getBlocksInOrder().forEach((t) => {
      t.id * this.params.blockSize >= this.rowCount && e.push(t);
    }), e.length > 0 && e.forEach((t) => this.destroyBlock(t));
  }
  purgeCache() {
    this.getBlocksInOrder().forEach((e) => this.removeBlockFromCache(e)), this.lastRowIndexKnown = !1, this.rowCount === 0 && (this.rowCount = this.params.initialRowCount), this.onCacheUpdated();
  }
  getRowNodesInRange(e, t) {
    const s = [];
    let i = -1, r = !1;
    const n = { value: 0 };
    let o = !1;
    return this.getBlocksInOrder().forEach((l) => {
      if (!o) {
        if (r && i + 1 !== l.id) {
          o = !0;
          return;
        }
        i = l.id, l.forEachNode(
          (c) => {
            const d = c === e || c === t;
            (r || d) && s.push(c), d && (r = !r);
          },
          n,
          this.rowCount
        );
      }
    }), o || r ? [] : s;
  }
}, CG = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowModel";
  }
  getRowBounds(e) {
    return {
      rowHeight: this.rowHeight,
      rowTop: this.rowHeight * e
    };
  }
  // we don't implement as lazy row heights is not supported in this row model
  ensureRowHeightsValid() {
    return !1;
  }
  postConstruct() {
    this.gos.get("rowModelType") === "infinite" && (this.rowHeight = vs(this.beans), this.addEventListeners(), this.addDestroyFunc(() => this.destroyCache()));
  }
  start() {
    this.setDatasource(this.gos.get("datasource"));
  }
  destroy() {
    this.destroyDatasource(), super.destroy();
  }
  destroyDatasource() {
    this.datasource && (this.destroyBean(this.datasource), this.beans.rowRenderer.datasourceChanged(), this.datasource = null);
  }
  addEventListeners() {
    this.addManagedEventListeners({
      filterChanged: this.reset.bind(this),
      sortChanged: this.reset.bind(this),
      newColumnsLoaded: this.onColumnEverything.bind(this),
      storeUpdated: this.dispatchModelUpdatedEvent.bind(this)
    }), this.addManagedPropertyListener("datasource", () => this.setDatasource(this.gos.get("datasource"))), this.addManagedPropertyListener("cacheBlockSize", () => this.resetCache()), this.addManagedPropertyListener("rowHeight", () => {
      this.rowHeight = vs(this.beans), this.cacheParams.rowHeight = this.rowHeight, this.updateRowHeights();
    });
  }
  onColumnEverything() {
    var t;
    let e;
    this.cacheParams ? e = !Kn(this.cacheParams.sortModel, ((t = this.beans.sortSvc) == null ? void 0 : t.getSortModel()) ?? []) : e = !0, e && this.reset();
  }
  getType() {
    return "infinite";
  }
  setDatasource(e) {
    this.destroyDatasource(), this.datasource = e, e && this.reset();
  }
  isEmpty() {
    return !this.infiniteCache;
  }
  isRowsToRender() {
    return !!this.infiniteCache;
  }
  getNodesInRangeForSelection(e, t) {
    var s;
    return ((s = this.infiniteCache) == null ? void 0 : s.getRowNodesInRange(e, t)) ?? [];
  }
  reset() {
    var s;
    if (!this.datasource)
      return;
    _i(this.gos) != null || (s = this.beans.selectionSvc) == null || s.reset("rowDataChanged"), this.resetCache();
  }
  dispatchModelUpdatedEvent() {
    this.eventSvc.dispatchEvent({
      type: "modelUpdated",
      // not sure if these should all be false - noticed if after implementing,
      // maybe they should be true?
      newPage: !1,
      newPageSize: !1,
      newData: !1,
      keepRenderedRows: !0,
      animate: !1
    });
  }
  resetCache() {
    this.destroyCache();
    const e = this.beans, { filterManager: t, sortSvc: s, rowNodeBlockLoader: i, eventSvc: r, gos: n } = e;
    this.cacheParams = {
      // the user provided datasource
      datasource: this.datasource,
      // sort and filter model
      filterModel: (t == null ? void 0 : t.getFilterModel()) ?? {},
      sortModel: (s == null ? void 0 : s.getSortModel()) ?? [],
      rowNodeBlockLoader: i,
      // properties - this way we take a snapshot of them, so if user changes any, they will be
      // used next time we create a new cache, which is generally after a filter or sort change,
      // or a new datasource is set
      initialRowCount: n.get("infiniteInitialRowCount"),
      maxBlocksInCache: n.get("maxBlocksInCache"),
      rowHeight: vs(e),
      // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
      // the current page and request first row of next page
      overflowSize: n.get("cacheOverflowSize"),
      // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
      // server for one page at a time. so the default if not specified is 100.
      blockSize: n.get("cacheBlockSize"),
      // the cache could create this, however it is also used by the pages, so handy to create it
      // here as the settings are also passed to the pages
      lastAccessedSequence: { value: 0 }
    }, this.infiniteCache = this.createBean(new mG(this.cacheParams)), r.dispatchEventOnce({
      type: "rowCountReady"
    }), this.dispatchModelUpdatedEvent();
  }
  updateRowHeights() {
    this.forEachNode((e) => {
      e.setRowHeight(this.rowHeight), e.setRowTop(this.rowHeight * e.rowIndex);
    }), this.dispatchModelUpdatedEvent();
  }
  destroyCache() {
    this.infiniteCache = this.destroyBean(this.infiniteCache);
  }
  getRow(e) {
    const t = this.infiniteCache;
    if (t && !(e >= t.getRowCount()))
      return t.getRow(e);
  }
  getRowNode(e) {
    let t;
    return this.forEachNode((s) => {
      s.id === e && (t = s);
    }), t;
  }
  forEachNode(e) {
    var t;
    (t = this.infiniteCache) == null || t.forEachNodeDeep(e);
  }
  getTopLevelRowCount() {
    return this.getRowCount();
  }
  getTopLevelRowDisplayedIndex(e) {
    return e;
  }
  getRowIndexAtPixel(e) {
    if (this.rowHeight !== 0) {
      const t = Math.floor(e / this.rowHeight), s = this.getRowCount() - 1;
      return t > s ? s : t;
    }
    return 0;
  }
  getRowCount() {
    return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
  }
  isRowPresent(e) {
    return !!this.getRowNode(e.id);
  }
  refreshCache() {
    var e;
    (e = this.infiniteCache) == null || e.refreshCache();
  }
  purgeCache() {
    var e;
    (e = this.infiniteCache) == null || e.purgeCache();
  }
  // for iRowModel
  isLastRowIndexKnown() {
    var e;
    return ((e = this.infiniteCache) == null ? void 0 : e.isLastRowIndexKnown()) ?? !1;
  }
  setRowCount(e, t) {
    var s;
    (s = this.infiniteCache) == null || s.setRowCount(e, t);
  }
};
function vG(e) {
  var t;
  (t = xc(e)) == null || t.refreshCache();
}
function wG(e) {
  var t;
  (t = xc(e)) == null || t.purgeCache();
}
function yG(e) {
  var t;
  return (t = xc(e)) == null ? void 0 : t.getRowCount();
}
var bG = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowNodeBlockLoader", this.activeBlockLoadsCount = 0, this.blocks = [], this.active = !0;
  }
  postConstruct() {
    this.maxConcurrentRequests = yv(this.gos);
    const e = this.gos.get("blockLoadDebounceMillis");
    e && e > 0 && (this.checkBlockToLoadDebounce = Et(
      this,
      this.performCheckBlocksToLoad.bind(this),
      e
    ));
  }
  addBlock(e) {
    this.blocks.push(e), e.addEventListener("loadComplete", this.loadComplete.bind(this)), this.checkBlockToLoad();
  }
  removeBlock(e) {
    kt(this.blocks, e);
  }
  destroy() {
    super.destroy(), this.active = !1;
  }
  loadComplete() {
    this.activeBlockLoadsCount--, this.checkBlockToLoad();
  }
  checkBlockToLoad() {
    this.checkBlockToLoadDebounce ? this.checkBlockToLoadDebounce() : this.performCheckBlocksToLoad();
  }
  performCheckBlocksToLoad() {
    if (!this.active)
      return;
    if (this.printCacheStatus(), this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
      Rr(this.gos, "RowNodeBlockLoader - checkBlockToLoad: max loads exceeded");
      return;
    }
    const e = this.maxConcurrentRequests != null ? this.maxConcurrentRequests - this.activeBlockLoadsCount : 1, t = this.blocks.filter((s) => s.state === "needsLoading").slice(0, e);
    this.activeBlockLoadsCount += t.length, t.forEach((s) => s.load()), this.printCacheStatus();
  }
  getBlockState() {
    const e = {};
    return this.blocks.forEach((t) => {
      const { id: s, state: i } = t.getBlockStateJson();
      e[s] = i;
    }), e;
  }
  printCacheStatus() {
    Rr(
      this.gos,
      `RowNodeBlockLoader - printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`
    );
  }
}, SG = {
  moduleName: "InfiniteRowModel",
  version: de,
  rowModels: ["infinite"],
  apiFunctions: {
    refreshInfiniteCache: vG,
    purgeInfiniteCache: wG,
    getInfiniteRowCount: yG
  },
  beans: [CG, bG],
  dependsOn: [zy]
}, xG = "↑", RG = "↓", FG = class extends _ {
  constructor() {
    super(), this.refreshCount = 0;
    const e = document.createElement("span"), t = document.createElement("span");
    t.setAttribute("class", "ag-value-change-delta");
    const s = document.createElement("span");
    s.setAttribute("class", "ag-value-change-value"), e.appendChild(t), e.appendChild(s), this.setTemplateFromElement(e);
  }
  init(e) {
    this.eValue = this.queryForHtmlElement(".ag-value-change-value"), this.eDelta = this.queryForHtmlElement(".ag-value-change-delta"), this.refresh(e, !0);
  }
  showDelta(e, t) {
    const s = Math.abs(t), i = e.formatValue(s), r = W(i) ? i : s, n = t >= 0, o = this.eDelta;
    n ? o.textContent = xG + r : o.textContent = RG + r, o.classList.toggle("ag-value-change-delta-up", n), o.classList.toggle("ag-value-change-delta-down", !n);
  }
  setTimerToRemoveDelta() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.hideDeltaValue();
      }, 2e3);
    });
  }
  hideDeltaValue() {
    this.eValue.classList.remove("ag-value-change-value-highlight"), ze(this.eDelta);
  }
  refresh(e, t = !1) {
    var a;
    const { value: s, valueFormatted: i } = e, { eValue: r, lastValue: n, beans: o } = this;
    if (s === n || (W(i) ? r.textContent = i : W(s) ? r.textContent = s : ze(r), (a = o.filterManager) != null && a.isSuppressFlashingCellsBecauseFiltering()))
      return !1;
    if (typeof s == "number" && typeof n == "number") {
      const l = s - n;
      this.showDelta(e, l);
    }
    return n && r.classList.add("ag-value-change-value-highlight"), t || this.setTimerToRemoveDelta(), this.lastValue = s, !0;
  }
}, PG = (
  /*css*/
  ".ag-value-slide-out{opacity:1}:where(.ag-ltr) .ag-value-slide-out{margin-right:5px;transition:opacity 3s,margin-right 3s}:where(.ag-rtl) .ag-value-slide-out{margin-left:5px;transition:opacity 3s,margin-left 3s}:where(.ag-ltr,.ag-rtl) .ag-value-slide-out{transition-timing-function:linear}.ag-value-slide-out-end{opacity:0}:where(.ag-ltr) .ag-value-slide-out-end{margin-right:10px}:where(.ag-rtl) .ag-value-slide-out-end{margin-left:10px}"
), TG = class extends _ {
  constructor() {
    super(), this.refreshCount = 0;
    const e = document.createElement("span"), t = document.createElement("span");
    t.setAttribute("class", "ag-value-slide-current"), e.appendChild(t), this.setTemplateFromElement(e), this.eCurrent = this.queryForHtmlElement(".ag-value-slide-current"), this.registerCSS(PG);
  }
  init(e) {
    this.refresh(e, !0);
  }
  addSlideAnimation() {
    this.refreshCount++;
    const e = this.refreshCount;
    this.ePrevious && this.getGui().removeChild(this.ePrevious);
    const { beans: t, eCurrent: s } = this, i = We(t).createElement("span");
    i.setAttribute("class", "ag-value-slide-previous ag-value-slide-out"), this.ePrevious = i, i.textContent = s.textContent, this.getGui().insertBefore(i, s), t.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e === this.refreshCount && this.ePrevious.classList.add("ag-value-slide-out-end");
      }, 50), window.setTimeout(() => {
        e === this.refreshCount && (this.getGui().removeChild(this.ePrevious), this.ePrevious = null);
      }, 3e3);
    });
  }
  refresh(e, t = !1) {
    var r;
    let s = e.value;
    if (ke(s) && (s = ""), s === this.lastValue || (r = this.beans.filterManager) != null && r.isSuppressFlashingCellsBecauseFiltering())
      return !1;
    t || this.addSlideAnimation(), this.lastValue = s;
    const i = this.eCurrent;
    return W(e.valueFormatted) ? i.textContent = e.valueFormatted : W(e.value) ? i.textContent = s : ze(i), !0;
  }
}, EG = class extends L {
  constructor() {
    super(...arguments), this.beanName = "cellFlashSvc";
  }
  onFlashCells(e, t) {
    if (!e.comp)
      return;
    const s = cr(e.cellPosition);
    t.cells[s] && this.animateCell(e, "highlight");
  }
  flashCell(e, t) {
    this.animateCell(e, "data-changed", t == null ? void 0 : t.flashDuration, t == null ? void 0 : t.fadeDuration);
  }
  animateCell(e, t, s, i) {
    const r = e.comp;
    if (!r)
      return;
    const { gos: n } = this;
    if (s || (s = n.get("cellFlashDuration")), s === 0)
      return;
    W(i) || (i = n.get("cellFadeDuration"));
    const o = `ag-cell-${t}`, a = `ag-cell-${t}-animation`;
    r.addOrRemoveCssClass(o, !0), r.addOrRemoveCssClass(a, !1);
    const { eGui: l } = e;
    this.beans.frameworkOverrides.wrapIncoming(() => {
      window.setTimeout(() => {
        e.isAlive() && (r.addOrRemoveCssClass(o, !1), r.addOrRemoveCssClass(a, !0), l.style.transition = `background-color ${i}ms`, window.setTimeout(() => {
          e.isAlive() && (r.addOrRemoveCssClass(a, !1), l.style.transition = "");
        }, i));
      }, s);
    });
  }
};
function DG(e, t = {}) {
  const { cellFlashSvc: s } = e;
  s && e.frameworkOverrides.wrapIncoming(() => {
    e.rowRenderer.getCellCtrls(t.rowNodes, t.columns).forEach((i) => s.flashCell(i, t));
  });
}
var $y = {
  moduleName: "HighlightChanges",
  version: de,
  beans: [EG],
  userComponents: {
    agAnimateShowChangeCellRenderer: FG,
    agAnimateSlideCellRenderer: TG
  },
  apiFunctions: {
    flashCells: DG
  }
};
function AG(e) {
  var t;
  return ((t = e.stateSvc) == null ? void 0 : t.getState()) ?? {};
}
function MG(e) {
  switch (e = { ...e }, e.version || (e.version = "32.1.0"), e.version) {
    case "32.1.0":
      e = IG(e);
  }
  return e;
}
function IG(e) {
  return e.cellSelection = LG(e, "rangeSelection"), e;
}
function LG(e, t) {
  if (e && typeof e == "object")
    return e[t];
}
var kG = class extends L {
  constructor() {
    super(...arguments), this.beanName = "stateSvc", this.updateRowGroupExpansionStateTimer = 0, this.suppressEvents = !0, this.queuedUpdateSources = /* @__PURE__ */ new Set(), this.dispatchStateUpdateEventDebounced = Et(this, () => this.dispatchQueuedStateUpdateEvents(), 0), this.onRowGroupOpenedDebounced = Et(
      this,
      () => {
        this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
      },
      0
    ), this.onRowSelectedDebounced = Et(
      this,
      () => {
        this.staleStateKeys.delete("rowSelection"), this.updateCachedState("rowSelection", this.getRowSelectionState());
      },
      0
    ), this.staleStateKeys = /* @__PURE__ */ new Set();
  }
  postConstruct() {
    this.isClientSideRowModel = Ye(this.gos), this.cachedState = this.getInitialState(), this.setCachedStateValue("version", de);
    const e = this.suppressEventsAndDispatchInitEvent.bind(this);
    this.beans.ctrlsSvc.whenReady(
      this,
      () => e(() => this.setupStateOnGridReady())
    );
    const [t, s, i] = this.addManagedEventListeners({
      newColumnsLoaded: ({ source: r }) => {
        r === "gridInitializing" && (t(), e(() => this.setupStateOnColumnsInitialised()));
      },
      rowCountReady: () => {
        s == null || s(), e(() => this.setupStateOnRowCountReady());
      },
      firstDataRendered: () => {
        i == null || i(), e(() => this.setupStateOnFirstDataRendered());
      }
    });
  }
  destroy() {
    super.destroy(), clearTimeout(this.updateRowGroupExpansionStateTimer), this.queuedUpdateSources.clear();
  }
  getInitialState() {
    return MG(this.gos.get("initialState") ?? {});
  }
  getState() {
    return this.staleStateKeys.size && this.refreshStaleState(), this.cachedState;
  }
  setupStateOnGridReady() {
    const e = () => this.updateCachedState("sideBar", this.getSideBarState());
    e(), this.addManagedEventListeners({
      toolPanelVisibleChanged: e,
      sideBarUpdated: e
    });
  }
  setupStateOnColumnsInitialised() {
    const e = this.getInitialState();
    this.setColumnState(e), this.setColumnGroupState(e), this.updateColumnState([
      "aggregation",
      "columnOrder",
      "columnPinning",
      "columnSizing",
      "columnVisibility",
      "pivot",
      "pivot",
      "rowGroup",
      "sort"
    ]), this.updateCachedState("columnGroup", this.getColumnGroupState());
    const t = (s) => () => this.updateColumnState([s]);
    this.addManagedEventListeners({
      columnValueChanged: t("aggregation"),
      columnMoved: t("columnOrder"),
      columnPinned: t("columnPinning"),
      columnResized: t("columnSizing"),
      columnVisible: t("columnVisibility"),
      columnPivotChanged: t("pivot"),
      columnPivotModeChanged: t("pivot"),
      columnRowGroupChanged: t("rowGroup"),
      sortChanged: t("sort"),
      newColumnsLoaded: () => this.updateColumnState([
        "aggregation",
        "columnOrder",
        "columnPinning",
        "columnSizing",
        "columnVisibility",
        "pivot",
        "rowGroup",
        "sort"
      ]),
      columnGroupOpened: () => this.updateCachedState("columnGroup", this.getColumnGroupState())
    });
  }
  setupStateOnRowCountReady() {
    const {
      filter: e,
      rowGroupExpansion: t,
      rowSelection: s,
      pagination: i
    } = this.getInitialState();
    e && this.setFilterState(e), t && this.setRowGroupExpansionState(t), s && this.setRowSelectionState(s), i && this.setPaginationState(i);
    const r = this.updateCachedState.bind(this);
    r("filter", this.getFilterState()), r("rowGroupExpansion", this.getRowGroupExpansionState()), r("rowSelection", this.getRowSelectionState()), r("pagination", this.getPaginationState());
    const n = () => {
      this.updateRowGroupExpansionStateTimer = 0, r("rowGroupExpansion", this.getRowGroupExpansionState());
    };
    this.addManagedEventListeners({
      filterChanged: () => r("filter", this.getFilterState()),
      rowGroupOpened: () => this.onRowGroupOpenedDebounced(),
      expandOrCollapseAll: n,
      // `groupDefaultExpanded` updates expansion state without an expansion event
      columnRowGroupChanged: n,
      rowDataUpdated: () => {
        this.gos.get("groupDefaultExpanded") !== 0 && (this.updateRowGroupExpansionStateTimer || (this.updateRowGroupExpansionStateTimer = setTimeout(n)));
      },
      selectionChanged: () => {
        this.staleStateKeys.add("rowSelection"), this.onRowSelectedDebounced();
      },
      paginationChanged: (o) => {
        (o.newPage || o.newPageSize) && r("pagination", this.getPaginationState());
      }
    });
  }
  setupStateOnFirstDataRendered() {
    const {
      scroll: e,
      cellSelection: t,
      focusedCell: s,
      columnOrder: i
    } = this.getInitialState();
    s && this.setFocusedCellState(s), t && this.setCellSelectionState(t), e && this.setScrollState(e), this.setColumnPivotState(!!(i != null && i.orderedColIds));
    const r = this.updateCachedState.bind(this);
    r("sideBar", this.getSideBarState()), r("focusedCell", this.getFocusedCellState());
    const n = this.getRangeSelectionState();
    r("rangeSelection", n), r("cellSelection", n), r("scroll", this.getScrollState()), this.addManagedEventListeners({
      cellFocused: () => r("focusedCell", this.getFocusedCellState()),
      cellSelectionChanged: (o) => {
        if (o.finished) {
          const a = this.getRangeSelectionState();
          r("rangeSelection", a), r("cellSelection", a);
        }
      },
      bodyScrollEnd: () => r("scroll", this.getScrollState())
    });
  }
  getColumnState() {
    const e = this.beans, t = e.colModel.isPivotMode(), s = [], i = [], r = [], n = [], o = [], a = [], l = [], c = [], d = [];
    let u = 0;
    const h = ra(e);
    for (let p = 0; p < h.length; p++) {
      const {
        colId: g,
        sort: f,
        sortIndex: m,
        rowGroup: C,
        rowGroupIndex: w,
        aggFunc: y,
        pivot: b,
        pivotIndex: x,
        pinned: M,
        hide: T,
        width: F,
        flex: k
      } = h[p];
      d.push(g), f && (s[m ?? u++] = { colId: g, sort: f }), C && (i[w ?? 0] = g), typeof y == "string" && r.push({ colId: g, aggFunc: y }), b && (n[x ?? 0] = g), M && (M === "right" ? a : o).push(g), T && l.push(g), (k || F) && c.push({ colId: g, flex: k ?? void 0, width: F });
    }
    return {
      sort: s.length ? { sortModel: s } : void 0,
      rowGroup: i.length ? { groupColIds: i } : void 0,
      aggregation: r.length ? { aggregationModel: r } : void 0,
      pivot: n.length || t ? { pivotMode: t, pivotColIds: n } : void 0,
      columnPinning: o.length || a.length ? { leftColIds: o, rightColIds: a } : void 0,
      columnVisibility: l.length ? { hiddenColIds: l } : void 0,
      columnSizing: c.length ? { columnSizingModel: c } : void 0,
      columnOrder: d.length ? { orderedColIds: d } : void 0
    };
  }
  setColumnState(e) {
    const {
      sort: t,
      rowGroup: s,
      aggregation: i,
      pivot: r,
      columnPinning: n,
      columnVisibility: o,
      columnSizing: a,
      columnOrder: l,
      partialColumnState: c
    } = e, d = {}, u = (m) => {
      let C = d[m];
      return C || (C = { colId: m }, d[m] = C, C);
    }, h = c ? {} : {
      sort: null,
      sortIndex: null,
      rowGroup: null,
      rowGroupIndex: null,
      aggFunc: null,
      pivot: null,
      pivotIndex: null,
      pinned: null,
      hide: null,
      flex: null
    };
    t && (t.sortModel.forEach(({ colId: m, sort: C }, w) => {
      const y = u(m);
      y.sort = C, y.sortIndex = w;
    }), h.sort = null, h.sortIndex = null), s && (s.groupColIds.forEach((m, C) => {
      const w = u(m);
      w.rowGroup = !0, w.rowGroupIndex = C;
    }), h.rowGroup = null, h.rowGroupIndex = null), i && (i.aggregationModel.forEach(({ colId: m, aggFunc: C }) => {
      u(m).aggFunc = C;
    }), h.aggFunc = null), r && (r.pivotColIds.forEach((m, C) => {
      const w = u(m);
      w.pivot = !0, w.pivotIndex = C;
    }), this.gos.updateGridOptions({
      options: { pivotMode: r.pivotMode },
      source: "gridInitializing"
    }), h.pivot = null, h.pivotIndex = null), n && (n.leftColIds.forEach((m) => {
      u(m).pinned = "left";
    }), n.rightColIds.forEach((m) => {
      u(m).pinned = "right";
    }), h.pinned = null), o && (o.hiddenColIds.forEach((m) => {
      u(m).hide = !0;
    }), h.hide = null), a && (a.columnSizingModel.forEach(({ colId: m, flex: C, width: w }) => {
      const y = u(m);
      y.flex = C ?? null, y.width = w;
    }), h.flex = null);
    const p = l == null ? void 0 : l.orderedColIds, g = !!(p != null && p.length), f = g ? p.map((m) => u(m)) : Object.values(d);
    f.length && (this.columnStates = f, ws(
      this.beans,
      {
        state: f,
        applyOrder: g,
        defaultState: h
      },
      "gridInitializing"
    ));
  }
  setColumnPivotState(e) {
    const t = this.columnStates;
    this.columnStates = void 0;
    const s = this.columnGroupStates;
    this.columnGroupStates = void 0;
    const i = this.beans, { pivotResultCols: r, colGroupSvc: n } = i;
    if (r != null && r.isPivotResultColsPresent()) {
      if (t) {
        const o = [];
        for (const a of t)
          r.getPivotResultCol(a.colId) && o.push(a);
        ws(
          i,
          {
            state: o,
            applyOrder: e
          },
          "gridInitializing"
        );
      }
      s && (n == null || n.setColumnGroupState(s, "gridInitializing"));
    }
  }
  getColumnGroupState() {
    const e = this.beans.colGroupSvc;
    if (!e)
      return;
    const t = e.getColumnGroupState(), s = [];
    return t.forEach(({ groupId: i, open: r }) => {
      r && s.push(i);
    }), s.length ? { openColumnGroupIds: s } : void 0;
  }
  setColumnGroupState(e) {
    var n;
    const t = this.beans.colGroupSvc;
    if (!Object.prototype.hasOwnProperty.call(e, "columnGroup") || !t)
      return;
    const s = new Set((n = e.columnGroup) == null ? void 0 : n.openColumnGroupIds), r = t.getColumnGroupState().map(({ groupId: o }) => {
      const a = s.has(o);
      return a && s.delete(o), {
        groupId: o,
        open: a
      };
    });
    s.forEach((o) => {
      r.push({
        groupId: o,
        open: !0
      });
    }), r.length && (this.columnGroupStates = r), t.setColumnGroupState(r, "gridInitializing");
  }
  getFilterState() {
    const e = this.beans.filterManager;
    let t = e == null ? void 0 : e.getFilterModel();
    t && Object.keys(t).length === 0 && (t = void 0);
    const s = (e == null ? void 0 : e.getAdvFilterModel()) ?? void 0;
    return t || s ? { filterModel: t, advancedFilterModel: s } : void 0;
  }
  setFilterState(e) {
    const t = this.beans.filterManager, { filterModel: s, advancedFilterModel: i } = e ?? {};
    s && (t == null || t.setFilterModel(s, "columnFilter")), i && (t == null || t.setAdvFilterModel(i));
  }
  getRangeSelectionState() {
    var t;
    const e = (t = this.beans.rangeSvc) == null ? void 0 : t.getCellRanges().map((s) => {
      const { id: i, type: r, startRow: n, endRow: o, columns: a, startColumn: l } = s;
      return {
        id: i,
        type: r,
        startRow: n,
        endRow: o,
        colIds: a.map((c) => c.getColId()),
        startColId: l.getColId()
      };
    });
    return e != null && e.length ? { cellRanges: e } : void 0;
  }
  setCellSelectionState(e) {
    const { gos: t, rangeSvc: s, colModel: i, visibleCols: r } = this.beans;
    if (!is(t) || !s)
      return;
    const n = [];
    e.cellRanges.forEach((o) => {
      const a = [];
      if (o.colIds.forEach((c) => {
        const d = i.getCol(c);
        d && a.push(d);
      }), !a.length)
        return;
      let l = i.getCol(o.startColId);
      if (!l) {
        const c = r.allCols, d = new Set(a);
        l = c.find((u) => d.has(u));
      }
      n.push({
        ...o,
        columns: a,
        startColumn: l
      });
    }), s.setCellRanges(n);
  }
  getScrollState() {
    if (!this.isClientSideRowModel)
      return;
    const e = this.beans.ctrlsSvc.getScrollFeature(), { left: t } = (e == null ? void 0 : e.getHScrollPosition()) ?? { left: 0 }, { top: s } = (e == null ? void 0 : e.getVScrollPosition()) ?? { top: 0 };
    return s || t ? {
      top: s,
      left: t
    } : void 0;
  }
  setScrollState(e) {
    if (!this.isClientSideRowModel)
      return;
    const { top: t, left: s } = e, { frameworkOverrides: i, rowRenderer: r, animationFrameSvc: n, ctrlsSvc: o } = this.beans;
    i.wrapIncoming(() => {
      var a;
      o.get("center").setCenterViewportScrollLeft(s), (a = o.getScrollFeature()) == null || a.setVerticalScrollPosition(t), r.redraw({ afterScroll: !0 }), n == null || n.flushAllFrames();
    });
  }
  getSideBarState() {
    var e, t;
    return (t = (e = this.beans.sideBar) == null ? void 0 : e.comp) == null ? void 0 : t.getState();
  }
  getFocusedCellState() {
    if (!this.isClientSideRowModel)
      return;
    const e = this.beans.focusSvc.getFocusedCell();
    if (e) {
      const { column: t, rowIndex: s, rowPinned: i } = e;
      return {
        colId: t.getColId(),
        rowIndex: s,
        rowPinned: i
      };
    }
  }
  setFocusedCellState(e) {
    if (!this.isClientSideRowModel)
      return;
    const { colId: t, rowIndex: s, rowPinned: i } = e, { focusSvc: r, colModel: n } = this.beans;
    r.setFocusedCell({
      column: n.getCol(t),
      rowIndex: s,
      rowPinned: i,
      forceBrowserFocus: !0,
      preventScrollOnBrowserFocus: !0
    });
  }
  getPaginationState() {
    const { pagination: e, gos: t } = this.beans;
    if (!e)
      return;
    const s = e.getCurrentPage(), i = t.get("paginationAutoPageSize") ? void 0 : e.getPageSize();
    if (!(!s && !i))
      return { page: s, pageSize: i };
  }
  setPaginationState(e) {
    const { pagination: t, gos: s } = this.beans;
    t && (e.pageSize && !s.get("paginationAutoPageSize") && t.setPageSize(e.pageSize, "initialState"), typeof e.page == "number" && t.setPage(e.page));
  }
  getRowSelectionState() {
    var i;
    const e = this.beans.selectionSvc;
    if (!e)
      return;
    const t = e.getSelectionState();
    return !t || !Array.isArray(t) && (t.selectAll === !1 || t.selectAllChildren === !1) && !((i = t == null ? void 0 : t.toggledNodes) != null && i.length) ? void 0 : t;
  }
  setRowSelectionState(e) {
    var t;
    (t = this.beans.selectionSvc) == null || t.setSelectionState(e, "gridInitializing");
  }
  getRowGroupExpansionState() {
    const { expansionSvc: e, rowModel: t } = this.beans;
    if (!e)
      return;
    const s = [];
    return t.forEachNode(({ expanded: i, id: r }) => {
      i && r && s.push(r);
    }), s.length ? {
      expandedRowGroupIds: s
    } : void 0;
  }
  setRowGroupExpansionState(e) {
    var t;
    (t = this.beans.expansionSvc) == null || t.expandRows(e.expandedRowGroupIds);
  }
  updateColumnState(e) {
    const t = this.getColumnState();
    let s = !1;
    const i = this.cachedState;
    Object.entries(t).forEach(([r, n]) => {
      Kn(n, i[r]) || (s = !0);
    }), this.cachedState = {
      ...i,
      ...t
    }, s && this.dispatchStateUpdateEvent(e);
  }
  updateCachedState(e, t) {
    const s = this.cachedState[e];
    this.setCachedStateValue(e, t), Kn(t, s) || this.dispatchStateUpdateEvent([e]);
  }
  setCachedStateValue(e, t) {
    this.cachedState = {
      ...this.cachedState,
      [e]: t
    };
  }
  refreshStaleState() {
    const e = this.staleStateKeys;
    e.forEach((t) => {
      switch (t) {
        case "rowSelection":
          this.setCachedStateValue(t, this.getRowSelectionState());
          break;
      }
    }), e.clear();
  }
  dispatchStateUpdateEvent(e) {
    this.suppressEvents || (e.forEach((t) => this.queuedUpdateSources.add(t)), this.dispatchStateUpdateEventDebounced());
  }
  dispatchQueuedStateUpdateEvents() {
    const e = this.queuedUpdateSources, t = Array.from(e);
    e.clear(), this.eventSvc.dispatchEvent({
      type: "stateUpdated",
      sources: t,
      state: this.cachedState
    });
  }
  suppressEventsAndDispatchInitEvent(e) {
    this.suppressEvents = !0;
    const t = this.beans.colAnimation;
    t == null || t.setSuppressAnimation(!0), e(), setTimeout(() => {
      this.suppressEvents = !1, this.queuedUpdateSources.clear(), this.isAlive() && (t == null || t.setSuppressAnimation(!1), this.dispatchStateUpdateEvent(["gridInitializing"]));
    });
  }
}, OG = {
  moduleName: "GridState",
  version: de,
  beans: [kG],
  apiFunctions: {
    getState: AG
  }
};
function GG(e) {
  return e.rowModel.isLastRowIndexKnown();
}
function BG(e) {
  var t;
  return ((t = e.pagination) == null ? void 0 : t.getPageSize()) ?? 100;
}
function VG(e) {
  var t;
  return ((t = e.pagination) == null ? void 0 : t.getCurrentPage()) ?? 0;
}
function NG(e) {
  var t;
  return ((t = e.pagination) == null ? void 0 : t.getTotalPages()) ?? 1;
}
function HG(e) {
  return e.pagination ? e.pagination.getMasterRowCount() : e.rowModel.getRowCount();
}
function zG(e) {
  var t;
  (t = e.pagination) == null || t.goToNextPage();
}
function WG(e) {
  var t;
  (t = e.pagination) == null || t.goToPreviousPage();
}
function _G(e) {
  var t;
  (t = e.pagination) == null || t.goToFirstPage();
}
function UG(e) {
  var t;
  (t = e.pagination) == null || t.goToLastPage();
}
function $G(e, t) {
  var s;
  (s = e.pagination) == null || s.goToPage(t);
}
var jG = class extends L {
  constructor() {
    super(...arguments), this.beanName = "paginationAutoPageSizeSvc";
  }
  postConstruct() {
    this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.centerRowsCtrl = e.center;
      const t = this.checkPageSize.bind(this);
      this.addManagedEventListeners({
        bodyHeightChanged: t,
        scrollVisibilityChanged: t
      }), this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this)), this.checkPageSize();
    });
  }
  notActive() {
    return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
  }
  onPaginationAutoSizeChanged() {
    this.notActive() ? this.beans.pagination.unsetAutoCalculatedPageSize() : this.checkPageSize();
  }
  checkPageSize() {
    if (this.notActive())
      return;
    const e = this.centerRowsCtrl.viewportSizeFeature.getBodyHeight();
    if (e > 0) {
      const t = this.beans, s = () => {
        const i = Math.max(vs(t), 1), r = Math.floor(e / i);
        t.pagination.setPageSize(r, "autoCalculated");
      };
      this.isBodyRendered ? Et(this, s, 50)() : (s(), this.isBodyRendered = !0);
    } else
      this.isBodyRendered = !1;
  }
}, Io = "paginationPageSizeSelector", KG = class extends _ {
  constructor() {
    super(
      /* html */
      '<span class="ag-paging-page-size"></span>'
    ), this.hasEmptyOption = !1, this.handlePageSizeItemSelected = () => {
      if (!this.selectPageSizeComp)
        return;
      const e = this.selectPageSizeComp.getValue();
      if (!e)
        return;
      const t = Number(e);
      isNaN(t) || t < 1 || t === this.pagination.getPageSize() || (this.pagination.setPageSize(t, "pageSizeSelector"), this.hasEmptyOption && this.toggleSelectDisplay(!0), this.selectPageSizeComp.getFocusableElement().focus());
    };
  }
  wireBeans(e) {
    this.pagination = e.pagination;
  }
  postConstruct() {
    this.addManagedPropertyListener(Io, () => {
      this.onPageSizeSelectorValuesChange();
    }), this.addManagedEventListeners({ paginationChanged: (e) => this.handlePaginationChanged(e) });
  }
  handlePaginationChanged(e) {
    if (!this.selectPageSizeComp || !(e != null && e.newPageSize))
      return;
    const t = this.pagination.getPageSize();
    this.getPageSizeSelectorValues().includes(t) ? this.selectPageSizeComp.setValue(t.toString()) : this.hasEmptyOption ? this.selectPageSizeComp.setValue("") : this.toggleSelectDisplay(!0);
  }
  toggleSelectDisplay(e) {
    this.selectPageSizeComp && !e && this.reset(), e && (this.reloadPageSizesSelector(), this.selectPageSizeComp);
  }
  reset() {
    ze(this.getGui()), this.selectPageSizeComp && (this.selectPageSizeComp = this.destroyBean(this.selectPageSizeComp));
  }
  onPageSizeSelectorValuesChange() {
    this.selectPageSizeComp && this.shouldShowPageSizeSelector() && this.reloadPageSizesSelector();
  }
  shouldShowPageSizeSelector() {
    return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get(Io) !== !1;
  }
  reloadPageSizesSelector() {
    const e = this.getPageSizeSelectorValues(), t = this.pagination.getPageSize(), s = !t || !e.includes(t);
    if (s) {
      const r = this.gos.exists("paginationPageSize"), n = this.gos.get(Io) !== !0;
      I(94, { pageSizeSet: r, pageSizesSet: n, pageSizeOptions: e, paginationPageSizeOption: t }), n || I(95, { paginationPageSizeOption: t, paginationPageSizeSelector: Io }), e.unshift("");
    }
    const i = String(s ? "" : t);
    this.selectPageSizeComp ? (Ht(this.pageSizeOptions, e) || (this.selectPageSizeComp.clearOptions().addOptions(this.createPageSizeSelectOptions(e)), this.pageSizeOptions = e), this.selectPageSizeComp.setValue(i, !0)) : this.createPageSizeSelectorComp(e, i), this.hasEmptyOption = s;
  }
  createPageSizeSelectOptions(e) {
    return e.map((t) => ({
      value: String(t)
    }));
  }
  createPageSizeSelectorComp(e, t) {
    const s = this.getLocaleTextFunc(), i = s("pageSizeSelectorLabel", "Page Size:"), r = s("ariaPageSizeSelectorLabel", "Page Size");
    this.selectPageSizeComp = this.createManagedBean(new rs()).addOptions(this.createPageSizeSelectOptions(e)).setValue(t).setAriaLabel(r).setLabel(i).onValueChange(() => this.handlePageSizeItemSelected()), this.appendChild(this.selectPageSizeComp);
  }
  getPageSizeSelectorValues() {
    const e = [20, 50, 100], t = this.gos.get(Io);
    return !Array.isArray(t) || !(t != null && t.length) ? e : [...t].sort((s, i) => s - i);
  }
  destroy() {
    this.toggleSelectDisplay(!1), super.destroy();
  }
}, qG = {
  selector: "AG-PAGE-SIZE-SELECTOR",
  component: KG
}, YG = (
  /*css*/
  ".ag-paging-panel{align-items:center;border-top:var(--ag-footer-row-border);display:flex;gap:calc(var(--ag-spacing)*4);height:max(var(--ag-row-height),22px);justify-content:flex-end;padding:0 var(--ag-cell-horizontal-padding)}:where(.ag-paging-page-size) .ag-wrapper{min-width:50px}.ag-paging-page-summary-panel{align-items:center;display:flex;gap:var(--ag-cell-widget-spacing);.ag-disabled &{pointer-events:none}}.ag-paging-button{cursor:pointer;position:relative;&.ag-disabled{cursor:default;opacity:.5}}.ag-paging-number,.ag-paging-row-summary-panel-number{font-weight:500}"
), XG = class extends Ti {
  constructor() {
    super(), this.btFirst = E, this.btPrevious = E, this.btNext = E, this.btLast = E, this.lbRecordCount = E, this.lbFirstRowOnPage = E, this.lbLastRowOnPage = E, this.lbCurrent = E, this.lbTotal = E, this.pageSizeComp = E, this.previousAndFirstButtonsDisabled = !1, this.nextButtonDisabled = !1, this.lastButtonDisabled = !1, this.areListenersSetup = !1, this.allowFocusInnerElement = !1, this.registerCSS(YG);
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.pagination = e.pagination, this.ariaAnnounce = e.ariaAnnounce;
  }
  postConstruct() {
    const e = this.gos.get("enableRtl");
    this.setTemplate(this.getTemplate(), [qG]);
    const { btFirst: t, btPrevious: s, btNext: i, btLast: r } = this;
    this.activateTabIndex([t, s, i, r]), t.insertAdjacentElement("afterbegin", ue(e ? "last" : "first", this.beans)), s.insertAdjacentElement("afterbegin", ue(e ? "next" : "previous", this.beans)), i.insertAdjacentElement("afterbegin", ue(e ? "previous" : "next", this.beans)), r.insertAdjacentElement("afterbegin", ue(e ? "first" : "last", this.beans)), this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this)), this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this)), this.addManagedPropertyListeners(
      ["paginationPageSizeSelector", "paginationAutoPageSize", "suppressPaginationPanel"],
      () => this.onPageSizeRelatedOptionsChange()
    ), this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector()), this.initialiseTabGuard({
      // prevent tab guard default logic
      onTabKeyDown: () => {
      },
      focusInnerElement: (n) => {
        this.allowFocusInnerElement ? this.tabGuardFeature.getTabGuardCtrl().focusInnerElement(n) : lw(this.beans, n);
      },
      forceFocusOutWhenTabGuardsAreEmpty: !0
    }), this.onPaginationChanged();
  }
  setAllowFocus(e) {
    this.allowFocusInnerElement = e;
  }
  onPaginationChanged() {
    const t = this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel");
    this.setDisplayed(t), t && (this.setupListeners(), this.enableOrDisableButtons(), this.updateLabels(), this.onPageSizeRelatedOptionsChange());
  }
  onPageSizeRelatedOptionsChange() {
    this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
  }
  setupListeners() {
    this.areListenersSetup || (this.addManagedEventListeners({ paginationChanged: this.onPaginationChanged.bind(this) }), [
      { el: this.btFirst, fn: this.onBtFirst.bind(this) },
      { el: this.btPrevious, fn: this.onBtPrevious.bind(this) },
      { el: this.btNext, fn: this.onBtNext.bind(this) },
      { el: this.btLast, fn: this.onBtLast.bind(this) }
    ].forEach((e) => {
      const { el: t, fn: s } = e;
      this.addManagedListeners(t, {
        click: s,
        keydown: (i) => {
          (i.key === P.ENTER || i.key === P.SPACE) && (i.preventDefault(), s());
        }
      });
    }), aw(this.beans, this, this.getGui()), this.areListenersSetup = !0);
  }
  onBtFirst() {
    this.previousAndFirstButtonsDisabled || this.pagination.goToFirstPage();
  }
  formatNumber(e) {
    const t = this.gos.getCallback("paginationNumberFormatter");
    return t ? t({ value: e }) : vn(e, this.getLocaleTextFunc.bind(this));
  }
  getTemplate() {
    const e = this.getLocaleTextFunc(), t = e("page", "Page"), s = e("to", "to"), i = e("of", "of"), r = e("firstPage", "First Page"), n = e("previousPage", "Previous Page"), o = e("nextPage", "Next Page"), a = e("lastPage", "Last Page"), l = this.getCompId();
    return (
      /* html */
      `<div class="ag-paging-panel ag-unselectable" id="ag-${l}">
                <ag-page-size-selector data-ref="pageSizeComp"></ag-page-size-selector>
                <span class="ag-paging-row-summary-panel">
                    <span id="ag-${l}-first-row" data-ref="lbFirstRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-${l}-to">${s}</span>
                    <span id="ag-${l}-last-row" data-ref="lbLastRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-${l}-of">${i}</span>
                    <span id="ag-${l}-row-count" data-ref="lbRecordCount" class="ag-paging-row-summary-panel-number"></span>
                </span>
                <span class="ag-paging-page-summary-panel" role="presentation">
                    <div data-ref="btFirst" class="ag-button ag-paging-button" role="button" aria-label="${r}"></div>
                    <div data-ref="btPrevious" class="ag-button ag-paging-button" role="button" aria-label="${n}"></div>
                    <span class="ag-paging-description">
                        <span id="ag-${l}-start-page">${t}</span>
                        <span id="ag-${l}-start-page-number" data-ref="lbCurrent" class="ag-paging-number"></span>
                        <span id="ag-${l}-of-page">${i}</span>
                        <span id="ag-${l}-of-page-number" data-ref="lbTotal" class="ag-paging-number"></span>
                    </span>
                    <div data-ref="btNext" class="ag-button ag-paging-button" role="button" aria-label="${o}"></div>
                    <div data-ref="btLast" class="ag-button ag-paging-button" role="button" aria-label="${a}"></div>
                </span>
            </div>`
    );
  }
  onBtNext() {
    this.nextButtonDisabled || this.pagination.goToNextPage();
  }
  onBtPrevious() {
    this.previousAndFirstButtonsDisabled || this.pagination.goToPreviousPage();
  }
  onBtLast() {
    this.lastButtonDisabled || this.pagination.goToLastPage();
  }
  enableOrDisableButtons() {
    const e = this.pagination.getCurrentPage(), t = this.rowModel.isLastRowIndexKnown(), s = this.pagination.getTotalPages();
    this.previousAndFirstButtonsDisabled = e === 0, this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled), this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
    const i = this.isZeroPagesToDisplay(), r = e === s - 1;
    this.nextButtonDisabled = r || i, this.lastButtonDisabled = !t || i || e === s - 1, this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled), this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
  }
  toggleButtonDisabled(e, t) {
    wl(e, t), e.classList.toggle("ag-disabled", t);
  }
  isZeroPagesToDisplay() {
    const e = this.rowModel.isLastRowIndexKnown(), t = this.pagination.getTotalPages();
    return e && t === 0;
  }
  updateLabels() {
    const e = this.rowModel.isLastRowIndexKnown(), t = this.pagination.getTotalPages(), s = this.pagination.getMasterRowCount(), i = e ? s : null;
    if (i === 1) {
      const w = this.rowModel.getRow(0);
      if (w && w.group && !(w.groupData || w.aggData)) {
        this.setTotalLabelsToZero();
        return;
      }
    }
    const r = this.pagination.getCurrentPage(), n = this.pagination.getPageSize();
    let o, a;
    this.isZeroPagesToDisplay() ? o = a = 0 : (o = n * r + 1, a = o + n - 1, e && a > i && (a = i));
    const l = o + n - 1, c = !e && s < l, d = this.formatNumber(o);
    this.lbFirstRowOnPage.textContent = d;
    let u;
    const h = this.getLocaleTextFunc();
    c ? u = h("pageLastRowUnknown", "?") : u = this.formatNumber(a), this.lbLastRowOnPage.textContent = u;
    const g = t > 0 ? r + 1 : 0, f = this.formatNumber(g);
    this.lbCurrent.textContent = f;
    let m, C;
    if (e)
      m = this.formatNumber(t), C = this.formatNumber(i);
    else {
      const w = h("more", "more");
      m = w, C = w;
    }
    this.lbTotal.textContent = m, this.lbRecordCount.textContent = C, this.announceAriaStatus(d, u, C, f, m);
  }
  announceAriaStatus(e, t, s, i, r) {
    var u, h;
    const n = this.getLocaleTextFunc(), o = n("page", "Page"), a = n("to", "to"), l = n("of", "of"), c = `${e} ${a} ${t} ${l} ${s}`, d = `${o} ${i} ${l} ${r}`;
    c !== this.ariaRowStatus && (this.ariaRowStatus = c, (u = this.ariaAnnounce) == null || u.announceValue(c, "paginationRow")), d !== this.ariaPageStatus && (this.ariaPageStatus = d, (h = this.ariaAnnounce) == null || h.announceValue(d, "paginationPage"));
  }
  setTotalLabelsToZero() {
    const e = this.formatNumber(0);
    this.lbFirstRowOnPage.textContent = e, this.lbCurrent.textContent = e, this.lbLastRowOnPage.textContent = e, this.lbTotal.textContent = e, this.lbRecordCount.textContent = e, this.announceAriaStatus(e, e, e, e, e);
  }
}, ZG = {
  selector: "AG-PAGINATION",
  component: XG
}, QG = class extends L {
  constructor() {
    super(...arguments), this.beanName = "pagination", this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = 0, this.masterRowCount = 0;
  }
  postConstruct() {
    const e = this.gos;
    this.active = e.get("pagination"), this.pageSizeFromGridOptions = e.get("paginationPageSize"), this.paginateChildRows = this.isPaginateChildRows(), this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this)), this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
  }
  getPaginationSelector() {
    return ZG;
  }
  isPaginateChildRows() {
    const e = this.gos;
    return e.get("groupHideParentOfSingleChild") || // following two properties deprecated v32.3.0
    e.get("groupRemoveSingleChildren") || e.get("groupRemoveLowestSingleChildren") ? !0 : e.get("paginateChildRows");
  }
  onPaginationGridOptionChanged() {
    this.active = this.gos.get("pagination"), this.calculatePages(), this.dispatchPaginationChangedEvent({ keepRenderedRows: !0 });
  }
  onPageSizeGridOptionChanged() {
    this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
  }
  goToPage(e) {
    const t = this.currentPage;
    !this.active || t === e || typeof t != "number" || (this.currentPage = e, this.calculatePages(), this.dispatchPaginationChangedEvent({ newPage: !0 }));
  }
  isRowPresent(e) {
    return e.rowIndex >= this.topDisplayedRowIndex && e.rowIndex <= this.bottomDisplayedRowIndex;
  }
  getPageForIndex(e) {
    return Math.floor(e / this.pageSize);
  }
  goToPageWithIndex(e) {
    if (!this.active)
      return;
    const t = this.getPageForIndex(e);
    this.goToPage(t);
  }
  isRowInPage(e) {
    return this.active ? this.getPageForIndex(e.rowIndex) === this.currentPage : !0;
  }
  getCurrentPage() {
    return this.currentPage;
  }
  goToNextPage() {
    this.goToPage(this.currentPage + 1);
  }
  goToPreviousPage() {
    this.goToPage(this.currentPage - 1);
  }
  goToFirstPage() {
    this.goToPage(0);
  }
  goToLastPage() {
    const e = this.beans.rowModel.getRowCount(), t = Math.floor(e / this.pageSize);
    this.goToPage(t);
  }
  getPageSize() {
    return this.pageSize;
  }
  getTotalPages() {
    return this.totalPages;
  }
  /** This is only for state setting before data has been loaded */
  setPage(e) {
    this.currentPage = e;
  }
  get pageSize() {
    return W(this.pageSizeAutoCalculated) && this.gos.get("paginationAutoPageSize") ? this.pageSizeAutoCalculated : W(this.pageSizeFromPageSizeSelector) ? this.pageSizeFromPageSizeSelector : W(this.pageSizeFromInitialState) ? this.pageSizeFromInitialState : W(this.pageSizeFromGridOptions) ? this.pageSizeFromGridOptions : this.defaultPageSize;
  }
  calculatePages() {
    this.active ? this.paginateChildRows ? this.calculatePagesAllRows() : this.calculatePagesMasterRowsOnly() : this.calculatedPagesNotActive(), this.beans.pageBounds.calculateBounds(this.topDisplayedRowIndex, this.bottomDisplayedRowIndex);
  }
  unsetAutoCalculatedPageSize() {
    if (this.pageSizeAutoCalculated === void 0)
      return;
    const e = this.pageSizeAutoCalculated;
    this.pageSizeAutoCalculated = void 0, this.pageSize !== e && (this.calculatePages(), this.dispatchPaginationChangedEvent({ newPageSize: !0 }));
  }
  setPageSize(e, t) {
    const s = this.pageSize;
    switch (t) {
      case "autoCalculated":
        this.pageSizeAutoCalculated = e;
        break;
      case "pageSizeSelector":
        this.pageSizeFromPageSizeSelector = e, this.currentPage !== 0 && this.goToFirstPage();
        break;
      case "initialState":
        this.pageSizeFromInitialState = e;
        break;
      case "gridOptions":
        this.pageSizeFromGridOptions = e, this.pageSizeFromInitialState = void 0, this.pageSizeFromPageSizeSelector = void 0, this.currentPage !== 0 && this.goToFirstPage();
        break;
    }
    s !== this.pageSize && (this.calculatePages(), this.dispatchPaginationChangedEvent({ newPageSize: !0, keepRenderedRows: !0 }));
  }
  setZeroRows() {
    this.masterRowCount = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = -1, this.currentPage = 0, this.totalPages = 0;
  }
  adjustCurrentPageIfInvalid() {
    const e = this.totalPages;
    this.currentPage >= e && (this.currentPage = e - 1);
    const t = this.currentPage;
    (!isFinite(t) || isNaN(t) || t < 0) && (this.currentPage = 0);
  }
  calculatePagesMasterRowsOnly() {
    const e = this.beans.rowModel, t = e.getTopLevelRowCount();
    if (this.masterRowCount = t, t <= 0) {
      this.setZeroRows();
      return;
    }
    const s = this.pageSize, i = t - 1;
    this.totalPages = Math.floor(i / s) + 1, this.adjustCurrentPageIfInvalid();
    const r = this.currentPage, n = s * r;
    let o = s * (r + 1) - 1;
    if (o > i && (o = i), this.topDisplayedRowIndex = e.getTopLevelRowDisplayedIndex(n), o === i)
      this.bottomDisplayedRowIndex = e.getRowCount() - 1;
    else {
      const a = e.getTopLevelRowDisplayedIndex(o + 1);
      this.bottomDisplayedRowIndex = a - 1;
    }
  }
  getMasterRowCount() {
    return this.masterRowCount;
  }
  calculatePagesAllRows() {
    const e = this.beans.rowModel.getRowCount();
    if (this.masterRowCount = e, e === 0) {
      this.setZeroRows();
      return;
    }
    const { pageSize: t, currentPage: s } = this, i = e - 1;
    this.totalPages = Math.floor(i / t) + 1, this.adjustCurrentPageIfInvalid(), this.topDisplayedRowIndex = t * s, this.bottomDisplayedRowIndex = t * (s + 1) - 1, this.bottomDisplayedRowIndex > i && (this.bottomDisplayedRowIndex = i);
  }
  calculatedPagesNotActive() {
    this.setPageSize(void 0, "autoCalculated"), this.totalPages = 1, this.currentPage = 0, this.topDisplayedRowIndex = 0, this.bottomDisplayedRowIndex = this.beans.rowModel.getRowCount() - 1;
  }
  dispatchPaginationChangedEvent(e) {
    const { keepRenderedRows: t = !1, newPage: s = !1, newPageSize: i = !1 } = e;
    this.eventSvc.dispatchEvent({
      type: "paginationChanged",
      animate: !1,
      newData: !1,
      newPage: s,
      newPageSize: i,
      keepRenderedRows: t
    });
  }
}, JG = {
  moduleName: "Pagination",
  version: de,
  beans: [QG, jG],
  icons: {
    // "go to first" button in pagination controls
    first: "first",
    // "go to previous" button in pagination controls
    previous: "previous",
    // "go to next" button in pagination controls
    next: "next",
    // "go to last" button in pagination controls
    last: "last"
  },
  apiFunctions: {
    paginationIsLastPageFound: GG,
    paginationGetPageSize: BG,
    paginationGetCurrentPage: VG,
    paginationGetTotalPages: NG,
    paginationGetRowCount: HG,
    paginationGoToNextPage: zG,
    paginationGoToPreviousPage: WG,
    paginationGoToFirstPage: _G,
    paginationGoToLastPage: UG,
    paginationGoToPage: $G
  },
  dependsOn: [Yi]
};
function e1(e, t = {}) {
  const s = t ? t.rowNodes : void 0;
  e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.redrawRows(s));
}
function jy(e, t, s, i, r) {
  t && (i && t.parent && t.parent.level !== -1 && jy(e, t.parent, s, i, r), t.setExpanded(s, void 0, r));
}
function t1(e, t) {
  return e.rowModel.getRowNode(t);
}
function s1(e, t, s, i) {
  e.rowRenderer.addRenderedRowListener(t, s, i);
}
function i1(e) {
  return e.rowRenderer.getRenderedNodes();
}
function r1(e, t, s) {
  e.rowModel.forEachNode(t, s);
}
function n1(e) {
  return e.rowRenderer.firstRenderedRow;
}
function o1(e) {
  return e.rowRenderer.lastRenderedRow;
}
function a1(e, t) {
  return e.rowModel.getRow(t);
}
function l1(e) {
  return e.rowModel.getRowCount();
}
var c1 = {
  moduleName: "RowApi",
  version: de,
  apiFunctions: {
    redrawRows: e1,
    setRowNodeExpanded: jy,
    getRowNode: t1,
    addRenderedRowListener: s1,
    getRenderedNodes: i1,
    forEachNode: r1,
    getFirstDisplayedRowIndex: n1,
    getLastDisplayedRowIndex: o1,
    getDisplayedRowAtIndex: a1,
    getDisplayedRowCount: l1
  }
}, d1 = {
  moduleName: "ScrollApi",
  version: de,
  apiFunctions: {
    getVerticalPixelRange: tO,
    getHorizontalPixelRange: sO,
    ensureColumnVisible: By,
    ensureIndexVisible: Vy,
    ensureNodeVisible: iO
  }
};
function u1(e, t, s) {
  if (!t)
    return;
  const i = e.ctrlsSvc.getGridBodyCtrl().eGridBody, r = `aria-${t}`;
  s === null ? i.removeAttribute(r) : i.setAttribute(r, s);
}
function h1(e, t = {}) {
  e.frameworkOverrides.wrapIncoming(() => e.rowRenderer.refreshCells(t));
}
function p1(e) {
  e.frameworkOverrides.wrapIncoming(
    () => e.ctrlsSvc.getHeaderRowContainerCtrls().forEach((t) => t.refresh())
  );
}
function g1(e) {
  var t;
  return ((t = e.animationFrameSvc) == null ? void 0 : t.isQueueEmpty()) ?? !0;
}
function f1(e) {
  var t;
  (t = e.animationFrameSvc) == null || t.flushAllFrames();
}
function m1(e) {
  return {
    rowHeight: vs(e),
    headerHeight: fa(e)
  };
}
function C1(e, t = {}) {
  var n;
  const s = [];
  if (e.rowRenderer.getCellCtrls(t.rowNodes, t.columns).forEach((o) => {
    const a = o.getCellRenderer();
    a != null && s.push(Cn(a));
  }), (n = t.columns) != null && n.length)
    return s;
  const i = [], r = Cu(t.rowNodes);
  return e.rowRenderer.getAllRowCtrls().forEach((o) => {
    if (r && !vu(o.rowNode, r) || !o.isFullWidth())
      return;
    const a = o.getFullWidthCellRenderers();
    for (let l = 0; l < a.length; l++) {
      const c = a[l];
      c != null && i.push(Cn(c));
    }
  }), [...i, ...s];
}
var v1 = {
  moduleName: "RenderApi",
  version: de,
  apiFunctions: {
    setGridAriaProperty: u1,
    refreshCells: h1,
    refreshHeader: p1,
    isAnimationFrameQueueEmpty: g1,
    flushAllAnimationFrames: f1,
    getSizesForCurrentTheme: m1,
    getCellRendererInstances: C1
  }
};
function w1(e, t) {
  var s, i;
  typeof t == "number" ? (s = e.colAutosize) == null || s.sizeColumnsToFit(t, "api") : (i = e.colAutosize) == null || i.sizeColumnsToFitGridBody(t);
}
function y1(e, t, s) {
  var i;
  (i = e.colAutosize) == null || i.autoSizeCols({ colKeys: t, skipHeader: s, source: "api" });
}
function b1(e, t) {
  var s;
  (s = e.colAutosize) == null || s.autoSizeAllColumns("api", t);
}
var S1 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colAutosize", this.timesDelayed = 0, this.shouldQueueResizeOperations = !1, this.resizeOperationQueue = [];
  }
  postConstruct() {
    this.addManagedEventListeners({ firstDataRendered: () => this.onFirstDataRendered() });
  }
  autoSizeCols(e) {
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.autoSizeCols(e));
      return;
    }
    const { colKeys: t, skipHeader: s, skipHeaderGroups: i, stopAtGroup: r, source: n = "api" } = e, { animationFrameSvc: o, renderStatus: a, colModel: l, autoWidthCalc: c, visibleCols: d } = this.beans;
    if (o == null || o.flushAllFrames(), this.timesDelayed < 5 && a && !a.areHeaderCellsRendered()) {
      this.timesDelayed++, setTimeout(() => {
        this.isAlive() && this.autoSizeCols(e);
      });
      return;
    }
    this.timesDelayed = 0;
    const u = [];
    let h = -1;
    const p = s ?? this.gos.get("skipHeaderOnAutoSize"), g = i ?? p;
    for (; h !== 0; ) {
      h = 0;
      const f = [];
      t.forEach((m) => {
        if (!m)
          return;
        const C = l.getCol(m);
        if (!C || u.indexOf(C) >= 0)
          return;
        const w = c.getPreferredWidthForColumn(C, p);
        if (w > 0) {
          const y = x1(C, w);
          C.setActualWidth(y, n), u.push(C), h++;
        }
        f.push(C);
      }), f.length && d.refresh(n);
    }
    g || this.autoSizeColumnGroupsByColumns(t, n, r), Qn(this.eventSvc, u, !0, "autosizeColumns");
  }
  autoSizeColumn(e, t, s) {
    e && this.autoSizeCols({ colKeys: [e], skipHeader: s, skipHeaderGroups: !0, source: t });
  }
  autoSizeColumnGroupsByColumns(e, t, s) {
    const { colModel: i, ctrlsSvc: r } = this.beans, n = /* @__PURE__ */ new Set();
    i.getColsForKeys(e).forEach((c) => {
      let d = c.getParent();
      for (; d && d != s; )
        d.isPadding() || n.add(d), d = d.getParent();
    });
    let a;
    const l = [];
    for (const c of n) {
      for (const d of r.getHeaderRowContainerCtrls())
        if (a = d.getHeaderCtrlForColumn(c), a)
          break;
      a && a.resizeLeafColumnsToFit(t);
    }
    return l;
  }
  autoSizeAllColumns(e, t) {
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.autoSizeAllColumns(e, t));
      return;
    }
    const s = this.beans.visibleCols.allCols;
    this.autoSizeCols({ colKeys: s, skipHeader: t, source: e });
  }
  addColumnAutosize(e, t) {
    const s = this.gos.get("skipHeaderOnAutoSize"), i = () => {
      this.autoSizeColumn(t, "uiColumnResized", s);
    };
    e.addEventListener("dblclick", i);
    const r = new fr(e);
    return r.addEventListener("doubleTap", i), () => {
      e.removeEventListener("dblclick", i), r.removeEventListener("doubleTap", i), r.destroy();
    };
  }
  addColumnGroupResize(e, t, s) {
    const i = this.gos.get("skipHeaderOnAutoSize"), r = () => {
      const n = [];
      t.getDisplayedLeafColumns().forEach((a) => {
        a.getColDef().suppressAutoSize || n.push(a.getColId());
      }), n.length > 0 && this.autoSizeCols({
        colKeys: n,
        skipHeader: i,
        stopAtGroup: t,
        source: "uiColumnResized"
      }), s();
    };
    return e.addEventListener("dblclick", r), () => e.removeEventListener("dblclick", r);
  }
  // method will call itself if no available width. this covers if the grid
  // isn't visible, but is just about to be visible.
  sizeColumnsToFitGridBody(e, t) {
    if (!this.isAlive())
      return;
    const { ctrlsSvc: s, scrollVisibleSvc: i } = this.beans, r = s.getGridBodyCtrl(), o = r.isVerticalScrollShowing() ? i.getScrollbarWidth() : 0, l = jn(r.eGridBody) - o;
    if (l > 0) {
      this.sizeColumnsToFit(l, "sizeColumnsToFit", !1, e);
      return;
    }
    t === void 0 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, 100);
    }, 0) : t === 100 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, 500);
    }, 100) : t === 500 ? window.setTimeout(() => {
      this.sizeColumnsToFitGridBody(e, -1);
    }, 500) : I(29);
  }
  // called from api
  sizeColumnsToFit(e, t = "sizeColumnsToFit", s, i) {
    var p;
    if (this.shouldQueueResizeOperations) {
      this.pushResizeOperation(() => this.sizeColumnsToFit(e, t, s, i));
      return;
    }
    const r = {};
    i && ((p = i == null ? void 0 : i.columnLimits) == null || p.forEach(({ key: g, ...f }) => {
      r[typeof g == "string" ? g : g.getColId()] = f;
    }));
    const n = this.beans.visibleCols.allCols, o = e === Gi(n);
    if (e <= 0 || !n.length || o)
      return;
    const a = [], l = [];
    n.forEach((g) => {
      g.getColDef().suppressSizeToFit === !0 ? l.push(g) : a.push(g);
    });
    const c = a.slice(0);
    let d = !1;
    const u = (g) => {
      kt(a, g), l.push(g);
    };
    for (a.forEach((g) => {
      g.resetActualWidth(t);
      const f = r == null ? void 0 : r[g.getId()], m = (f == null ? void 0 : f.minWidth) ?? (i == null ? void 0 : i.defaultMinWidth), C = (f == null ? void 0 : f.maxWidth) ?? (i == null ? void 0 : i.defaultMaxWidth), w = g.getActualWidth();
      typeof m == "number" && w < m ? g.setActualWidth(m, t, !0) : typeof C == "number" && w > C && g.setActualWidth(C, t, !0);
    }); !d; ) {
      d = !0;
      const g = e - Gi(l);
      if (g <= 0)
        a.forEach((f) => {
          var C;
          const m = ((C = r == null ? void 0 : r[f.getId()]) == null ? void 0 : C.minWidth) ?? (i == null ? void 0 : i.defaultMinWidth);
          if (typeof m == "number") {
            f.setActualWidth(m, t, !0);
            return;
          }
          f.setActualWidth(f.minWidth, t);
        });
      else {
        const f = g / Gi(a);
        let m = g;
        for (let C = a.length - 1; C >= 0; C--) {
          const w = a[C], y = r == null ? void 0 : r[w.getId()], b = (y == null ? void 0 : y.minWidth) ?? (i == null ? void 0 : i.defaultMinWidth), x = (y == null ? void 0 : y.maxWidth) ?? (i == null ? void 0 : i.defaultMaxWidth), M = w.getMinWidth(), T = w.getMaxWidth(), F = typeof b == "number" && b > M ? b : M, k = typeof x == "number" && x < T ? x : T;
          let O = Math.round(w.getActualWidth() * f);
          O < F ? (O = F, u(w), d = !1) : O > k ? (O = k, u(w), d = !1) : C === 0 && (O = m), w.setActualWidth(O, t, !0), m -= O;
        }
      }
    }
    c.forEach((g) => {
      g.fireColumnWidthChangedEvent(t);
    });
    const h = this.beans.visibleCols;
    h.setLeftValues(t), h.updateBodyWidths(), !s && Qn(this.eventSvc, c, !0, t);
  }
  applyAutosizeStrategy() {
    const e = this.gos.get("autoSizeStrategy");
    if (!e)
      return;
    const { type: t } = e;
    setTimeout(() => {
      if (t === "fitGridWidth") {
        const { columnLimits: s, defaultMinWidth: i, defaultMaxWidth: r } = e, n = s == null ? void 0 : s.map(({ colId: o, minWidth: a, maxWidth: l }) => ({
          key: o,
          minWidth: a,
          maxWidth: l
        }));
        this.sizeColumnsToFitGridBody({
          defaultMinWidth: i,
          defaultMaxWidth: r,
          columnLimits: n
        });
      } else t === "fitProvidedWidth" && this.sizeColumnsToFit(e.width, "sizeColumnsToFit");
    });
  }
  onFirstDataRendered() {
    const e = this.gos.get("autoSizeStrategy");
    if ((e == null ? void 0 : e.type) !== "fitCellContents")
      return;
    const { colIds: t, skipHeader: s } = e;
    setTimeout(() => {
      t ? this.autoSizeCols({
        colKeys: t,
        skipHeader: s,
        source: "autosizeColumns"
      }) : this.autoSizeAllColumns("autosizeColumns", s);
    });
  }
  processResizeOperations() {
    this.shouldQueueResizeOperations = !1, this.resizeOperationQueue.forEach((e) => e()), this.resizeOperationQueue = [];
  }
  pushResizeOperation(e) {
    this.resizeOperationQueue.push(e);
  }
  destroy() {
    this.resizeOperationQueue.length = 0, super.destroy();
  }
};
function x1(e, t) {
  const s = e.getMinWidth();
  t < s && (t = s);
  const i = e.getMaxWidth();
  return e.isGreaterThanMax(t) && (t = i), t;
}
var R1 = {
  moduleName: "ColumnAutoSize",
  version: de,
  beans: [S1],
  apiFunctions: {
    sizeColumnsToFit: w1,
    autoSizeColumns: y1,
    autoSizeAllColumns: b1
  },
  dependsOn: [ey]
};
function F1(e) {
  var t;
  return ((t = e.pinnedRowModel) == null ? void 0 : t.getPinnedTopRowCount()) ?? 0;
}
function P1(e) {
  var t;
  return ((t = e.pinnedRowModel) == null ? void 0 : t.getPinnedBottomRowCount()) ?? 0;
}
function T1(e, t) {
  var s;
  return (s = e.pinnedRowModel) == null ? void 0 : s.getPinnedTopRow(t);
}
function E1(e, t) {
  var s;
  return (s = e.pinnedRowModel) == null ? void 0 : s.getPinnedBottomRow(t);
}
var D1 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "pinnedRowModel", this.nextId = 0, this.pinnedTopRows = { cache: {}, order: [] }, this.pinnedBottomRows = { cache: {}, order: [] };
  }
  postConstruct() {
    const e = this.gos;
    this.setPinnedRowData(e.get("pinnedTopRowData"), "top"), this.setPinnedRowData(e.get("pinnedBottomRowData"), "bottom"), this.addManagedPropertyListener("pinnedTopRowData", (t) => this.setPinnedRowData(t.currentValue, "top")), this.addManagedPropertyListener("pinnedBottomRowData", (t) => this.setPinnedRowData(t.currentValue, "bottom")), this.addManagedEventListeners({ gridStylesChanged: this.onGridStylesChanges.bind(this) });
  }
  isEmpty(e) {
    return this.getCache(e).order.length === 0;
  }
  isRowsToRender(e) {
    return !this.isEmpty(e);
  }
  onGridStylesChanges(e) {
    if (e.rowHeightChanged) {
      const t = (s) => {
        s.setRowHeight(s.rowHeight, !0);
      };
      Lo(this.pinnedBottomRows, t), Lo(this.pinnedTopRows, t);
    }
  }
  ensureRowHeightsValid() {
    let e = !1, t = 0;
    const s = (i) => {
      if (i.rowHeightEstimated) {
        const r = qt(this.beans, i);
        i.setRowTop(t), i.setRowHeight(r.height), t += r.height, e = !0;
      }
    };
    return Lo(this.pinnedBottomRows, s), t = 0, Lo(this.pinnedTopRows, s), this.eventSvc.dispatchEvent({
      type: "pinnedHeightChanged"
    }), e;
  }
  setPinnedRowData(e, t) {
    this.updateNodesFromRowData(e, t), this.eventSvc.dispatchEvent({
      type: "pinnedRowDataChanged"
    });
  }
  /**
   * Updates existing RowNode instances and creates new ones if necessary
   *
   * Setting data as `undefined` will clear row nodes
   */
  updateNodesFromRowData(e, t) {
    const s = this.getCache(t);
    if (e === void 0) {
      s.order.length = 0, s.cache = {};
      return;
    }
    const i = _i(this.gos), r = t === "top" ? Cw : vw, n = new Set(s.order), o = [], a = /* @__PURE__ */ new Set();
    let l = 0, c = -1;
    for (const d of e) {
      const u = (i == null ? void 0 : i({ data: d, level: 0, rowPinned: t })) ?? r + this.nextId++;
      if (a.has(u)) {
        I(96, { id: u, data: d });
        continue;
      }
      c++, a.add(u), o.push(u);
      const h = Qo(s, u);
      if (h !== void 0)
        h.data !== d && h.setData(d), l += this.setRowTopAndRowIndex(h, l, c), n.delete(u);
      else {
        const p = new bs(this.beans);
        p.id = u, p.data = d, p.rowPinned = t, l += this.setRowTopAndRowIndex(p, l, c), s.cache[u] = p, s.order.push(u);
      }
    }
    n.forEach((d) => {
      var u;
      (u = Qo(s, d)) == null || u.clearRowTopAndRowIndex(), delete s.cache[d];
    }), s.order = o;
  }
  setRowTopAndRowIndex(e, t, s) {
    return e.setRowTop(t), e.setRowHeight(qt(this.beans, e).height), e.setRowIndex(s), e.rowHeight;
  }
  getPinnedTopTotalHeight() {
    return xf(this.pinnedTopRows);
  }
  getPinnedBottomTotalHeight() {
    return xf(this.pinnedBottomRows);
  }
  getPinnedTopRowCount() {
    return bu(this.pinnedTopRows);
  }
  getPinnedBottomRowCount() {
    return bu(this.pinnedBottomRows);
  }
  getPinnedTopRow(e) {
    return yu(this.pinnedTopRows, e);
  }
  getPinnedBottomRow(e) {
    return yu(this.pinnedBottomRows, e);
  }
  getPinnedRowById(e, t) {
    return Qo(this.getCache(t), e);
  }
  forEachPinnedRow(e, t) {
    return Lo(this.getCache(e), t);
  }
  getCache(e) {
    return e === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
  }
};
function xf(e) {
  const t = bu(e);
  if (t === 0)
    return 0;
  const s = yu(e, t - 1);
  return s === void 0 ? 0 : s.rowTop + s.rowHeight;
}
function Qo(e, t) {
  return e.cache[t];
}
function yu(e, t) {
  return Qo(e, e.order[t]);
}
function Lo(e, t) {
  e.order.forEach((s, i) => {
    const r = Qo(e, s);
    r && t(r, i);
  });
}
function bu(e) {
  return e.order.length;
}
var A1 = {
  moduleName: "PinnedRow",
  version: de,
  beans: [D1],
  apiFunctions: {
    getPinnedTopRowCount: F1,
    getPinnedBottomRowCount: P1,
    getPinnedTopRow: T1,
    getPinnedBottomRow: E1
  }
}, M1 = class extends L {
  constructor(e, t) {
    super(), this.cellCtrl = e, this.staticClasses = [], this.beans = t, this.column = e.column;
  }
  setComp(e) {
    this.cellComp = e, this.applyUserStyles(), this.applyCellClassRules(), this.applyClassesFromColDef();
  }
  applyCellClassRules() {
    const { column: e, cellComp: t } = this, s = e.colDef, i = s.cellClassRules, r = this.getCellClassParams(e, s);
    Rh(
      this.beans.expressionSvc,
      // if current was previous, skip
      i === this.cellClassRules ? void 0 : this.cellClassRules,
      i,
      r,
      (n) => t.addOrRemoveCssClass(n, !0),
      (n) => t.addOrRemoveCssClass(n, !1)
    ), this.cellClassRules = i;
  }
  applyUserStyles() {
    const e = this.column, t = e.colDef, s = t.cellStyle;
    if (!s)
      return;
    let i;
    if (typeof s == "function") {
      const r = this.getCellClassParams(e, t);
      i = s(r);
    } else
      i = s;
    i && this.cellComp.setUserStyles(i);
  }
  applyClassesFromColDef() {
    const { column: e, cellComp: t } = this, s = e.colDef, i = this.getCellClassParams(e, s);
    this.staticClasses.forEach((n) => t.addOrRemoveCssClass(n, !1));
    const r = this.beans.cellStyles.getStaticCellClasses(s, i);
    this.staticClasses = r, r.forEach((n) => t.addOrRemoveCssClass(n, !0));
  }
  getCellClassParams(e, t) {
    const { value: s, rowNode: i } = this.cellCtrl;
    return this.beans.gos.addGridCommonParams({
      value: s,
      data: i.data,
      node: i,
      colDef: t,
      column: e,
      rowIndex: i.rowIndex
    });
  }
}, I1 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "cellStyles";
  }
  processAllCellClasses(e, t, s, i) {
    Rh(
      this.beans.expressionSvc,
      void 0,
      e.cellClassRules,
      t,
      s,
      i
    ), this.processStaticCellClasses(e, t, s);
  }
  getStaticCellClasses(e, t) {
    const { cellClass: s } = e;
    if (!s)
      return [];
    let i;
    return typeof s == "function" ? i = s(t) : i = s, typeof i == "string" && (i = [i]), i || [];
  }
  createCellCustomStyleFeature(e, t) {
    return new M1(e, t);
  }
  processStaticCellClasses(e, t, s) {
    this.getStaticCellClasses(e, t).forEach((r) => {
      s(r);
    });
  }
}, L1 = {
  moduleName: "CellStyle",
  version: de,
  beans: [I1]
}, k1 = {
  moduleName: "RowStyle",
  version: de,
  beans: [UE]
};
function O1(e, t) {
  var s;
  return !!((s = e.colHover) != null && s.isHovered(t));
}
var G1 = class extends L {
  constructor(e, t) {
    super(), this.columns = e, this.element = t;
  }
  postConstruct() {
    if (this.gos.get("columnHoverHighlight")) {
      const e = this.beans.colHover;
      this.addManagedListeners(this.element, {
        mouseout: e.clearMouseOver.bind(e),
        mouseover: e.setMouseOver.bind(e, this.columns)
      });
    }
  }
}, B1 = "ag-column-hover", V1 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colHover";
  }
  setMouseOver(e) {
    this.updateState(e);
  }
  clearMouseOver() {
    this.updateState(null);
  }
  isHovered(e) {
    const t = this.selectedColumns;
    return !!t && t.indexOf(e) >= 0;
  }
  addHeaderColumnHoverListener(e, t, s) {
    const i = () => {
      if (!this.gos.get("columnHoverHighlight"))
        return;
      const r = this.isHovered(s);
      t.addOrRemoveCssClass("ag-column-hover", r);
    };
    e.addManagedEventListeners({ columnHoverChanged: i }), i();
  }
  onCellColumnHover(e, t) {
    if (!t || !this.gos.get("columnHoverHighlight"))
      return;
    const s = this.isHovered(e);
    t.addOrRemoveCssClass(B1, s);
  }
  addHeaderFilterColumnHoverListener(e, t, s, i) {
    this.createHoverFeature(e, [s], i);
    const r = () => {
      if (!this.gos.get("columnHoverHighlight"))
        return;
      const n = this.isHovered(s);
      t.addOrRemoveCssClass("ag-column-hover", n);
    };
    e.addManagedEventListeners({ columnHoverChanged: r }), r();
  }
  createHoverFeature(e, t, s) {
    e.createManagedBean(new G1(t, s));
  }
  updateState(e) {
    this.selectedColumns = e, this.eventSvc.dispatchEvent({
      type: "columnHoverChanged"
    });
  }
}, N1 = {
  moduleName: "ColumnHover",
  version: de,
  beans: [V1],
  apiFunctions: {
    isColumnHovered: O1
  }
}, H1 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "apiEventSvc", this.syncListeners = /* @__PURE__ */ new Map(), this.asyncListeners = /* @__PURE__ */ new Map(), this.syncGlobalListeners = /* @__PURE__ */ new Set(), this.globalListenerPairs = /* @__PURE__ */ new Map();
  }
  postConstruct() {
    var e, t;
    this.wrapSvc = (t = (e = this.beans.frameworkOverrides).createGlobalEventListenerWrapper) == null ? void 0 : t.call(e);
  }
  addEventListener(e, t) {
    var n;
    const s = ((n = this.wrapSvc) == null ? void 0 : n.wrap(t)) ?? t, i = !dl.has(e), r = i ? this.asyncListeners : this.syncListeners;
    r.has(e) || r.set(e, /* @__PURE__ */ new Set()), r.get(e).add(s), this.eventSvc.addEventListener(e, s, i);
  }
  removeEventListener(e, t) {
    var n, o;
    const s = ((n = this.wrapSvc) == null ? void 0 : n.unwrap(t)) ?? t, i = this.asyncListeners.get(e), r = !!(i != null && i.delete(s));
    r || (o = this.syncListeners.get(e)) == null || o.delete(s), this.eventSvc.removeEventListener(e, s, r);
  }
  addGlobalListener(e) {
    var n;
    const t = ((n = this.wrapSvc) == null ? void 0 : n.wrapGlobal(e)) ?? e, s = (o, a) => {
      dl.has(o) && t(o, a);
    }, i = (o, a) => {
      dl.has(o) || t(o, a);
    };
    this.globalListenerPairs.set(e, { syncListener: s, asyncListener: i });
    const r = this.eventSvc;
    r.addGlobalListener(s, !1), r.addGlobalListener(i, !0);
  }
  removeGlobalListener(e) {
    const { eventSvc: t, wrapSvc: s, globalListenerPairs: i } = this, r = (s == null ? void 0 : s.unwrapGlobal(e)) ?? e;
    if (i.has(r)) {
      const { syncListener: o, asyncListener: a } = i.get(r);
      t.removeGlobalListener(o, !1), t.removeGlobalListener(a, !0), i.delete(e);
    } else
      this.syncGlobalListeners.delete(r), t.removeGlobalListener(r, !1);
  }
  destroyEventListeners(e, t) {
    e.forEach((s, i) => {
      s.forEach((r) => this.eventSvc.removeEventListener(i, r, t)), s.clear();
    }), e.clear();
  }
  destroyGlobalListeners(e, t) {
    e.forEach((s) => this.eventSvc.removeGlobalListener(s, t)), e.clear();
  }
  destroy() {
    super.destroy(), this.destroyEventListeners(this.syncListeners, !1), this.destroyEventListeners(this.asyncListeners, !0), this.destroyGlobalListeners(this.syncGlobalListeners, !1);
    const { globalListenerPairs: e, eventSvc: t } = this;
    e.forEach(({ syncListener: s, asyncListener: i }) => {
      t.removeGlobalListener(s, !1), t.removeGlobalListener(i, !0);
    }), e.clear();
  }
};
function z1(e, t, s) {
  var i;
  (i = e.apiEventSvc) == null || i.addEventListener(t, s);
}
function W1(e, t, s) {
  var i;
  (i = e.apiEventSvc) == null || i.removeEventListener(t, s);
}
function _1(e, t) {
  var s;
  (s = e.apiEventSvc) == null || s.addGlobalListener(t);
}
function U1(e, t) {
  var s;
  (s = e.apiEventSvc) == null || s.removeGlobalListener(t);
}
var $1 = {
  moduleName: "EventApi",
  version: de,
  apiFunctions: {
    addEventListener: z1,
    addGlobalListener: _1,
    removeEventListener: W1,
    removeGlobalListener: U1
  },
  beans: [H1]
}, j1 = (
  /*css*/
  ".ag-tooltip{background-color:var(--ag-tooltip-background-color);border:var(--ag-tooltip-border);border-radius:var(--ag-border-radius);color:var(--ag-tooltip-text-color);padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);white-space:normal}.ag-tooltip,.ag-tooltip-custom{position:absolute;z-index:99999}.ag-tooltip-custom:where(:not(.ag-tooltip-interactive)),.ag-tooltip:where(:not(.ag-tooltip-interactive)){pointer-events:none}.ag-tooltip-animate{transition:opacity 1s;&:where(.ag-tooltip-hiding){opacity:0}}"
), K1 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "tooltipSvc";
  }
  setupHeaderTooltip(e, t, s, i) {
    e && t.destroyBean(e);
    const r = Xo(this.gos), { column: n, eGui: o } = t, a = n.getColDef();
    !i && r && !a.headerComponent && (i = un(
      () => o.querySelector(".ag-header-cell-text")
    ));
    const l = {
      getColumn: () => n,
      getColDef: () => n.getColDef(),
      getGui: () => o,
      getLocation: () => "header",
      getTooltipValue: () => s ?? n.getColDef().headerTooltip,
      shouldDisplayTooltip: i
    };
    let c = this.createTooltipFeature(l);
    return c && (c = t.createBean(c), t.setRefreshFunction("tooltip", () => c.refreshTooltip())), c;
  }
  setupHeaderGroupTooltip(e, t, s, i) {
    e && t.destroyBean(e);
    const r = Xo(this.gos), { column: n, eGui: o } = t, a = n.getColGroupDef();
    !i && r && !(a != null && a.headerGroupComponent) && (i = un(
      () => o.querySelector(".ag-header-group-text")
    ));
    const l = {
      getColumn: () => n,
      getGui: () => o,
      getLocation: () => "headerGroup",
      getTooltipValue: () => s ?? (a && a.headerTooltip),
      shouldDisplayTooltip: i
    };
    a && (l.getColDef = () => a);
    const c = this.createTooltipFeature(l);
    return c && t.createBean(c);
  }
  enableCellTooltipFeature(e, t, s) {
    const { column: i, rowNode: r } = e, n = () => {
      const l = i.getColDef(), c = r.data;
      if (l.tooltipField && W(c))
        return $o(c, l.tooltipField, i.isTooltipFieldContainsDots());
      const d = l.tooltipValueGetter;
      return d ? d(
        this.gos.addGridCommonParams({
          location: "cell",
          colDef: i.getColDef(),
          column: i,
          rowIndex: e.cellPosition.rowIndex,
          node: r,
          data: r.data,
          value: e.value,
          valueFormatted: e.valueFormatted
        })
      ) : null;
    }, o = Xo(this.gos);
    !s && o && !e.isCellRenderer() && (s = un(() => {
      const { eGui: l } = e;
      return l.children.length === 0 ? l : l.querySelector(".ag-cell-value");
    }));
    const a = {
      getColumn: () => i,
      getColDef: () => i.getColDef(),
      getRowIndex: () => e.cellPosition.rowIndex,
      getRowNode: () => r,
      getGui: () => e.eGui,
      getLocation: () => "cell",
      getTooltipValue: t != null ? () => t : n,
      // this makes no sense, why is the cell formatted value passed to the tooltip???
      getValueFormatted: () => e.valueFormatted,
      shouldDisplayTooltip: s
    };
    return this.createTooltipFeature(a, this.beans);
  }
  refreshRowTooltip(e, t, s, i) {
    const r = {
      getGui: () => t.getFullWidthElement(),
      getTooltipValue: () => s,
      getLocation: () => "fullWidthRow",
      shouldDisplayTooltip: i
    }, n = this.beans, o = n.context;
    e && t.destroyBean(e, o);
    const a = this.createTooltipFeature(r, n);
    return t.createBean(a, o);
  }
  initCol(e) {
    const { colDef: t } = e;
    e.tooltipEnabled = W(t.tooltipField) || W(t.tooltipValueGetter) || W(t.tooltipComponent);
  }
  createTooltipFeature(e, t) {
    return this.beans.registry.createDynamicBean("tooltipFeature", !1, e, t);
  }
}, q1 = {
  moduleName: "Tooltip",
  version: de,
  beans: [K1],
  dynamicBeans: {
    tooltipFeature: UD
  },
  userComponents: {
    agTooltipComponent: v0
  },
  dependsOn: [Yi],
  css: [j1]
}, Y1 = {
  moduleName: "Locale",
  version: de,
  beans: [c0]
}, X1 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowAutoHeight", this.wasEverActive = !1;
  }
  setRowAutoHeight(e, t, s) {
    e.__autoHeights || (e.__autoHeights = {}), e.__autoHeights[s.getId()] = t, t != null && (e.__checkAutoHeightsDebounced == null && (e.__checkAutoHeightsDebounced = Et(this, this.doCheckAutoHeights.bind(this, e), 1)), e.__checkAutoHeightsDebounced());
  }
  checkAutoHeights(e) {
    this.wasEverActive && this.doCheckAutoHeights(e);
  }
  doCheckAutoHeights(e) {
    var d;
    const t = e.__autoHeights;
    if (t == null)
      return;
    let s = !1, i = !0, r = 0;
    const { visibleCols: n, colModel: o, colViewport: a, rowModel: l } = this.beans;
    n.autoHeightCols.forEach((u) => {
      let h = t[u.getId()];
      if (h == null)
        if (o.colSpanActive) {
          let p = [];
          switch (u.getPinned()) {
            case "left":
              p = n.getLeftColsForRow(e);
              break;
            case "right":
              p = n.getRightColsForRow(e);
              break;
            case null:
              p = a.getColsWithinViewport(e);
              break;
          }
          if (p.includes(u)) {
            s = !0;
            return;
          }
          h = -1;
        } else {
          s = !0;
          return;
        }
      else
        i = !1;
      h > r && (r = h);
    }), !s && ((i || r < 10) && (r = qt(this.beans, e).height), r != e.rowHeight && (e.setRowHeight(r), (d = l.onRowHeightChangedDebounced) == null || d.call(l)));
  }
  setupCellAutoHeight(e, t, s) {
    const i = t.parentElement, { rowNode: r, column: n } = e, o = this.beans, a = qt(o, r).height, l = (u) => {
      if (e.editing || !e.isAlive() || !s.isAlive())
        return;
      const { paddingTop: h, paddingBottom: p, borderBottomWidth: g, borderTopWidth: f } = Fn(i), m = h + p + g + f, w = t.offsetHeight + m;
      if (u < 5) {
        const b = We(o), x = !b || !b.contains(t), M = w == 0;
        if (x || M) {
          window.setTimeout(() => l(u + 1), 0);
          return;
        }
      }
      const y = Math.max(w, a);
      this.setRowAutoHeight(r, y, n);
    }, c = () => l(0);
    c();
    const d = Ms(o, t, c);
    s.addDestroyFunc(() => {
      d(), this.setRowAutoHeight(r, void 0, n);
    });
  }
  setAutoHeightActive(e) {
    this.active = e.list.some((t) => t.isVisible() && t.isAutoHeight()), this.active && (this.wasEverActive = !0);
  }
}, Z1 = {
  moduleName: "RowAutoHeight",
  version: de,
  beans: [X1]
}, Q1 = {
  moduleName: "AllCommunity",
  version: de,
  dependsOn: [
    aG,
    Uy,
    SG,
    q0,
    vO,
    wO,
    yO,
    bO,
    SO,
    xO,
    RO,
    CO,
    Bk,
    Vk,
    Nk,
    Gk,
    Hk,
    zk,
    OG,
    _O,
    JG,
    KM,
    c1,
    d1,
    v1,
    R1,
    DA,
    A1,
    OO,
    XL,
    L1,
    N1,
    k1,
    $1,
    JL,
    $y,
    q1,
    Y1,
    Z1,
    EA,
    lG
  ]
}, J1 = class {
  constructor() {
    this.ieCompatibility = !1;
  }
  init() {
    this.ieCompatibility = this.md5("hello") != "5d41402abc4b2a76b9719d911017c592";
  }
  md5cycle(e, t) {
    let s = e[0], i = e[1], r = e[2], n = e[3];
    s = this.ff(s, i, r, n, t[0], 7, -680876936), n = this.ff(n, s, i, r, t[1], 12, -389564586), r = this.ff(r, n, s, i, t[2], 17, 606105819), i = this.ff(i, r, n, s, t[3], 22, -1044525330), s = this.ff(s, i, r, n, t[4], 7, -176418897), n = this.ff(n, s, i, r, t[5], 12, 1200080426), r = this.ff(r, n, s, i, t[6], 17, -1473231341), i = this.ff(i, r, n, s, t[7], 22, -45705983), s = this.ff(s, i, r, n, t[8], 7, 1770035416), n = this.ff(n, s, i, r, t[9], 12, -1958414417), r = this.ff(r, n, s, i, t[10], 17, -42063), i = this.ff(i, r, n, s, t[11], 22, -1990404162), s = this.ff(s, i, r, n, t[12], 7, 1804603682), n = this.ff(n, s, i, r, t[13], 12, -40341101), r = this.ff(r, n, s, i, t[14], 17, -1502002290), i = this.ff(i, r, n, s, t[15], 22, 1236535329), s = this.gg(s, i, r, n, t[1], 5, -165796510), n = this.gg(n, s, i, r, t[6], 9, -1069501632), r = this.gg(r, n, s, i, t[11], 14, 643717713), i = this.gg(i, r, n, s, t[0], 20, -373897302), s = this.gg(s, i, r, n, t[5], 5, -701558691), n = this.gg(n, s, i, r, t[10], 9, 38016083), r = this.gg(r, n, s, i, t[15], 14, -660478335), i = this.gg(i, r, n, s, t[4], 20, -405537848), s = this.gg(s, i, r, n, t[9], 5, 568446438), n = this.gg(n, s, i, r, t[14], 9, -1019803690), r = this.gg(r, n, s, i, t[3], 14, -187363961), i = this.gg(i, r, n, s, t[8], 20, 1163531501), s = this.gg(s, i, r, n, t[13], 5, -1444681467), n = this.gg(n, s, i, r, t[2], 9, -51403784), r = this.gg(r, n, s, i, t[7], 14, 1735328473), i = this.gg(i, r, n, s, t[12], 20, -1926607734), s = this.hh(s, i, r, n, t[5], 4, -378558), n = this.hh(n, s, i, r, t[8], 11, -2022574463), r = this.hh(r, n, s, i, t[11], 16, 1839030562), i = this.hh(i, r, n, s, t[14], 23, -35309556), s = this.hh(s, i, r, n, t[1], 4, -1530992060), n = this.hh(n, s, i, r, t[4], 11, 1272893353), r = this.hh(r, n, s, i, t[7], 16, -155497632), i = this.hh(i, r, n, s, t[10], 23, -1094730640), s = this.hh(s, i, r, n, t[13], 4, 681279174), n = this.hh(n, s, i, r, t[0], 11, -358537222), r = this.hh(r, n, s, i, t[3], 16, -722521979), i = this.hh(i, r, n, s, t[6], 23, 76029189), s = this.hh(s, i, r, n, t[9], 4, -640364487), n = this.hh(n, s, i, r, t[12], 11, -421815835), r = this.hh(r, n, s, i, t[15], 16, 530742520), i = this.hh(i, r, n, s, t[2], 23, -995338651), s = this.ii(s, i, r, n, t[0], 6, -198630844), n = this.ii(n, s, i, r, t[7], 10, 1126891415), r = this.ii(r, n, s, i, t[14], 15, -1416354905), i = this.ii(i, r, n, s, t[5], 21, -57434055), s = this.ii(s, i, r, n, t[12], 6, 1700485571), n = this.ii(n, s, i, r, t[3], 10, -1894986606), r = this.ii(r, n, s, i, t[10], 15, -1051523), i = this.ii(i, r, n, s, t[1], 21, -2054922799), s = this.ii(s, i, r, n, t[8], 6, 1873313359), n = this.ii(n, s, i, r, t[15], 10, -30611744), r = this.ii(r, n, s, i, t[6], 15, -1560198380), i = this.ii(i, r, n, s, t[13], 21, 1309151649), s = this.ii(s, i, r, n, t[4], 6, -145523070), n = this.ii(n, s, i, r, t[11], 10, -1120210379), r = this.ii(r, n, s, i, t[2], 15, 718787259), i = this.ii(i, r, n, s, t[9], 21, -343485551), e[0] = this.add32(s, e[0]), e[1] = this.add32(i, e[1]), e[2] = this.add32(r, e[2]), e[3] = this.add32(n, e[3]);
  }
  cmn(e, t, s, i, r, n) {
    return t = this.add32(this.add32(t, e), this.add32(i, n)), this.add32(t << r | t >>> 32 - r, s);
  }
  ff(e, t, s, i, r, n, o) {
    return this.cmn(t & s | ~t & i, e, t, r, n, o);
  }
  gg(e, t, s, i, r, n, o) {
    return this.cmn(t & i | s & ~i, e, t, r, n, o);
  }
  hh(e, t, s, i, r, n, o) {
    return this.cmn(t ^ s ^ i, e, t, r, n, o);
  }
  ii(e, t, s, i, r, n, o) {
    return this.cmn(s ^ (t | ~i), e, t, r, n, o);
  }
  md51(e) {
    const t = e.length, s = [1732584193, -271733879, -1732584194, 271733878];
    let i;
    for (i = 64; i <= e.length; i += 64)
      this.md5cycle(s, this.md5blk(e.substring(i - 64, i)));
    e = e.substring(i - 64);
    const r = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (i = 0; i < e.length; i++)
      r[i >> 2] |= e.charCodeAt(i) << (i % 4 << 3);
    if (r[i >> 2] |= 128 << (i % 4 << 3), i > 55)
      for (this.md5cycle(s, r), i = 0; i < 16; i++)
        r[i] = 0;
    return r[14] = t * 8, this.md5cycle(s, r), s;
  }
  /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
   * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
   * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
   * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
   * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
   * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
   * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
   */
  md5blk(e) {
    const t = [];
    for (let s = 0; s < 64; s += 4)
      t[s >> 2] = e.charCodeAt(s) + (e.charCodeAt(s + 1) << 8) + (e.charCodeAt(s + 2) << 16) + (e.charCodeAt(s + 3) << 24);
    return t;
  }
  rhex(e) {
    const t = "0123456789abcdef".split("");
    let s = "", i = 0;
    for (; i < 4; i++)
      s += t[e >> i * 8 + 4 & 15] + t[e >> i * 8 & 15];
    return s;
  }
  hex(e) {
    for (let t = 0; t < e.length; t++)
      e[t] = this.rhex(e[t]);
    return e.join("");
  }
  md5(e) {
    return this.hex(this.md51(e));
  }
  add32(e, t) {
    return this.ieCompatibility ? this.add32Compat(e, t) : this.add32Std(e, t);
  }
  /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
   need the idiotic second function, generated by an if clause.  */
  add32Std(e, t) {
    return e + t & 4294967295;
  }
  add32Compat(e, t) {
    const s = (e & 65535) + (t & 65535);
    return (e >> 16) + (t >> 16) + (s >> 16) << 16 | s & 65535;
  }
}, Xa = {
  "01": "GRID",
  "02": "CHARTS",
  "0102": "BOTH"
}, Rf = "https://ag-grid.com/licensing/", Ky = class fs {
  constructor(t) {
    this.watermarkMessage = void 0, this.totalMessageLength = 124, this.document = t, this.md5 = new J1(), this.md5.init();
  }
  validateLicense() {
    const t = this.getLicenseDetails(fs.licenseKey), s = `AG Grid ${t.currentLicenseType === "BOTH" ? "and AG Charts " : ""}Enterprise`, i = t.suppliedLicenseType === void 0 ? "" : `AG ${t.suppliedLicenseType === "BOTH" ? "Grid and AG Charts" : t.suppliedLicenseType === "GRID" ? "Grid" : "Charts"} Enterprise`;
    if (t.missing)
      (!this.isWebsiteUrl() || this.isForceWatermark()) && this.outputMissingLicenseKey(s);
    else if (t.expired) {
      const r = fs.getGridReleaseDate(), n = fs.formatDate(r);
      this.outputExpiredKey(t.expiry, n, s, i);
    } else t.valid ? t.isTrial && t.trialExpired && this.outputExpiredTrialKey(t.expiry, s, i) : this.outputInvalidLicenseKey(
      !!t.incorrectLicenseType,
      s,
      i
    );
  }
  static extractExpiry(t) {
    const s = t.substring(t.lastIndexOf("_") + 1, t.length);
    return new Date(parseInt(fs.decode(s), 10));
  }
  static extractLicenseComponents(t) {
    let s = t.replace(/[\u200B-\u200D\uFEFF]/g, "");
    if (s = s.replace(/\r?\n|\r/g, ""), t.length <= 32)
      return { md5: null, license: t, version: null, isTrial: null };
    const i = s.length - 32, r = s.substring(i), n = s.substring(0, i), [o, a, l] = fs.extractBracketedInformation(s);
    return { md5: r, license: n, version: o, isTrial: a, type: l };
  }
  getLicenseDetails(t) {
    const s = fs.chartsLicenseManager ? "BOTH" : "GRID";
    if (!(t != null && t.length))
      return {
        licenseKey: t,
        valid: !1,
        missing: !0,
        currentLicenseType: s
      };
    const i = fs.getGridReleaseDate(), { md5: r, license: n, version: o, isTrial: a, type: l } = fs.extractLicenseComponents(t);
    let c = r === this.md5.md5(n) && t.indexOf("For_Trialing_ag-Grid_Only") === -1, d, u, h = null, p = !1, g;
    function f() {
      d = h < /* @__PURE__ */ new Date(), u = void 0;
    }
    if (c && (h = fs.extractExpiry(n), c = !isNaN(h.getTime()), c))
      switch (u = i > h, o) {
        case "legacy":
        case "2": {
          a && f();
          break;
        }
        case "3":
          l != null && l.length ? (g = l, l !== Xa["01"] && l !== Xa["0102"] || s === "BOTH" && g !== "BOTH" ? (c = !1, p = !0) : a && f()) : c = !1;
      }
    return c ? {
      licenseKey: t,
      valid: c,
      expiry: fs.formatDate(h),
      expired: u,
      version: o,
      isTrial: a,
      trialExpired: d,
      incorrectLicenseType: p,
      currentLicenseType: s,
      suppliedLicenseType: g
    } : {
      licenseKey: t,
      valid: c,
      incorrectLicenseType: p,
      currentLicenseType: s,
      suppliedLicenseType: g
    };
  }
  isDisplayWatermark() {
    var t;
    return this.isForceWatermark() || !this.isLocalhost() && !this.isWebsiteUrl() && !!((t = this.watermarkMessage) != null && t.length);
  }
  getWatermarkMessage() {
    return this.watermarkMessage || "";
  }
  getHostname() {
    const s = (this.document.defaultView || window).location, { hostname: i = "" } = s;
    return i;
  }
  isForceWatermark() {
    const s = (this.document.defaultView || window).location, { pathname: i } = s;
    return i ? i.indexOf("forceWatermark") !== -1 : !1;
  }
  isWebsiteUrl() {
    return this.getHostname().match(/^((?:[\w-]+\.)?ag-grid\.com)$/) !== null;
  }
  isLocalhost() {
    return this.getHostname().match(/^(?:127\.0\.0\.1|localhost)$/) !== null;
  }
  static formatDate(t) {
    const s = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ], i = t.getDate(), r = t.getMonth(), n = t.getFullYear();
    return i + " " + s[r] + " " + n;
  }
  static getGridReleaseDate() {
    return new Date(parseInt(fs.decode(fs.RELEASE_INFORMATION), 10));
  }
  static decode(t) {
    const s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let i = "", r, n, o, a, l, c, d, u = 0;
    const h = t.replace(/[^A-Za-z0-9+/=]/g, "");
    for (; u < h.length; )
      a = s.indexOf(h.charAt(u++)), l = s.indexOf(h.charAt(u++)), c = s.indexOf(h.charAt(u++)), d = s.indexOf(h.charAt(u++)), r = a << 2 | l >> 4, n = (l & 15) << 4 | c >> 2, o = (c & 3) << 6 | d, i = i + String.fromCharCode(r), c != 64 && (i = i + String.fromCharCode(n)), d != 64 && (i = i + String.fromCharCode(o));
    return i = fs.utf8_decode(i), i;
  }
  static utf8_decode(t) {
    t = t.replace(/rn/g, "n");
    let s = "";
    for (let i = 0; i < t.length; i++) {
      const r = t.charCodeAt(i);
      r < 128 ? s += String.fromCharCode(r) : r > 127 && r < 2048 ? (s += String.fromCharCode(r >> 6 | 192), s += String.fromCharCode(r & 63 | 128)) : (s += String.fromCharCode(r >> 12 | 224), s += String.fromCharCode(r >> 6 & 63 | 128), s += String.fromCharCode(r & 63 | 128));
    }
    return s;
  }
  static setChartsLicenseManager(t) {
    this.chartsLicenseManager = t;
  }
  static setLicenseKey(t) {
    var s;
    this.licenseKey = t, (s = this.chartsLicenseManager) == null || s.setLicenseKey(t, !0);
  }
  static extractBracketedInformation(t) {
    if (!t.includes("["))
      return ["legacy", !1, void 0];
    const s = t.match(/\[(.*?)\]/g).map((a) => a.replace("[", "").replace("]", ""));
    if (!s || s.length === 0)
      return ["legacy", !1, void 0];
    const i = s.filter((a) => a === "TRIAL").length === 1, r = s.filter((a) => a.indexOf("v") === 0)[0], n = r ? r.replace("v", "") : "legacy", o = Xa[s.filter((a) => Xa[a])[0]];
    return [n, i, o];
  }
  centerPadAndOutput(t) {
    const s = this.totalMessageLength - t.length;
    console.error(t.padStart(s / 2 + t.length, "*").padEnd(this.totalMessageLength, "*"));
  }
  padAndOutput(t, s = "*", i = "") {
    console.error(
      t.padEnd(this.totalMessageLength - i.length, s) + i
    );
  }
  outputInvalidLicenseKey(t, s, i) {
    t ? (this.centerPadAndOutput(""), this.centerPadAndOutput(` ${s} License `), this.centerPadAndOutput(" Incompatible License Key "), this.padAndOutput(
      `* Your license key is for ${i} only and does not cover you for ${s}.`,
      " ",
      "*"
    ), this.padAndOutput(`* To troubleshoot your license key visit ${Rf}.`, " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput("")) : (this.centerPadAndOutput(""), this.centerPadAndOutput(` ${s} License `), this.centerPadAndOutput(" Invalid License Key "), this.padAndOutput("* Your license key is not valid.", " ", "*"), this.padAndOutput(`* To troubleshoot your license key visit ${Rf}.`, " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput("")), this.watermarkMessage = "Invalid License";
  }
  outputExpiredTrialKey(t, s, i) {
    this.centerPadAndOutput(""), this.centerPadAndOutput(` ${s} License `), this.centerPadAndOutput(" Trial Period Expired. "), this.padAndOutput(
      `* Your trial only license for ${i} expired on ${t}.`,
      " ",
      "*"
    ), this.padAndOutput("* Please email info@ag-grid.com to purchase a license.", " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput(""), this.watermarkMessage = "Trial Period Expired";
  }
  outputMissingLicenseKey(t) {
    this.centerPadAndOutput(""), this.centerPadAndOutput(` ${t} License `), this.centerPadAndOutput(" License Key Not Found "), this.padAndOutput(`* All ${t} features are unlocked for trial.`, " ", "*"), this.padAndOutput(
      "* If you want to hide the watermark please email info@ag-grid.com for a trial license key.",
      " ",
      "*"
    ), this.centerPadAndOutput(""), this.centerPadAndOutput(""), this.watermarkMessage = "For Trial Use Only";
  }
  outputExpiredKey(t, s, i, r) {
    this.centerPadAndOutput(""), this.centerPadAndOutput(` ${i} License `), this.centerPadAndOutput(" Incompatible Software Version "), this.padAndOutput(
      `* Your license key works with versions of ${r} released before ${t}.`,
      " ",
      "*"
    ), this.padAndOutput(`* The version you are trying to use was released on ${s}.`, " ", "*"), this.padAndOutput("* Please contact info@ag-grid.com to renew your license key.", " ", "*"), this.centerPadAndOutput(""), this.centerPadAndOutput(""), this.watermarkMessage = "License Expired";
  }
};
Ky.RELEASE_INFORMATION = "MTczNjc2MzczNzA3Mg==";
var zo = Ky, eB = (
  /*css*/
  '.ag-watermark{bottom:20px;color:#9b9b9b;opacity:.7;position:absolute;transition:opacity 1s ease-out 3s;&:before{background-image:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDkiIGhlaWdodD0iMzYiIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyMDkgMzYiPjxwYXRoIGZpbGw9IiM5QjlCOUIiIGQ9Ik0xOTIuOTkzIDIzLjY1OHYtNy45NDZoLTEzLjU0MWwtNy45NDcgNy45NDZ6TTIwOC4yNSAzLjk1aC0xNi45NzRsLTguMDEgNy45NDdoMjQuOTg0ek0xNjMuNjIyIDMxLjYwNWw0LjA2OS00LjA2OWgxMy43MzJ2Ny45NDdoLTE3LjgwMXoiLz48cGF0aCBmaWxsPSIjOUI5QjlCIiBkPSJNMTY2LjYxIDE5Ljc4aDguNzczbDguMDEtNy45NDZIMTY2LjYxek0xNTcuMDExIDMxLjYwNWg2LjYxMWw3Ljg4My03Ljk0N2gtMTQuNDk0ek0xOTEuMjc2IDMuOTVsLTQuMDY4IDQuMDdIMTYxLjI3Vi4wNzJoMzAuMDA2ek0yMC44NCAzMC4yMDZIOC4zNzhsLTIuMTYyIDUuMzRILjc1TDEyLjI1NyA4LjU5Mmg0Ljc2OEwyOC41MyAzNS41NDZoLTUuNTN6bS0xLjcxNy00LjI2TDE0LjYwOSAxNC45NWwtNC41MTQgMTAuOTk4ek0xMDQuNDM3IDE4LjUwOWMxLjU4OS0yLjM1MiA1LjU5NC0yLjYwNyA3LjI0Ny0yLjYwN3Y0LjU3OGMtMi4wMzQgMC00LjA2OS4wNjMtNS4yNzcuOTUzLTEuMjA3Ljg5LTEuODQzIDIuMDk4LTEuODQzIDMuNTZ2MTAuNTUzaC00Ljk1OVYxNS45MDJoNC43Njh6TTExOS4zNzYgMTUuOTAyaC00Ljk1OHYxOS42NDRoNC45NTh6TTExOS4zNzYgNy4xM2gtNC45NTh2NS44NDhoNC45NTh6TTE0My45NzkgNy4xM3YyOC40MTZoLTQuNzY4bC0uMTI3LTIuOTg4YTguMyA4LjMgMCAwIDEtMi42NyAyLjQ4Yy0xLjA4MS41NzItMi40MTYuODktMy45NDIuODktMS4zMzUgMC0yLjYwNi0uMjU1LTMuNjg3LS43LTEuMTQ0LS41MDgtMi4xNjItMS4xNDQtMi45ODgtMi4wMzRhOS42IDkuNiAwIDAgMS0xLjk3MS0zLjE3OWMtLjUwOC0xLjIwNy0uNjk5LTIuNjA2LS42OTktNC4xMzJzLjI1NC0yLjkyNC42OTktNC4xOTZjLjUwOS0xLjI3MSAxLjE0NS0yLjM1MiAxLjk3MS0zLjI0MnMxLjg0NC0xLjU4OSAyLjk4OC0yLjA5OCAyLjM1Mi0uNzYzIDMuNjg3LS43NjNjMS41MjYgMCAyLjc5Ny4yNTUgMy44NzguODI3czEuOTcxIDEuMzM1IDIuNjcgMi40MTZWNy4xOTNoNC45NTl6bS0xMC40MjYgMjQuNTM4YzEuNjUzIDAgMi45MjQtLjU3MiAzLjk0MS0xLjY1M3MxLjUyNi0yLjU0MyAxLjUyNi00LjMyMy0uNTA5LTMuMTc4LTEuNTI2LTQuMzIyYy0xLjAxNy0xLjA4MS0yLjI4OC0xLjY1My0zLjk0MS0xLjY1My0xLjU5IDAtMi45MjUuNTcyLTMuODc4IDEuNjUzLTEuMDE3IDEuMDgtMS41MjYgMi41NDMtMS41MjYgNC4zMjIgMCAxLjc4LjUwOSAzLjE4IDEuNTI2IDQuMjYgMS4wMTcgMS4xNDQgMi4yODggMS43MTYgMy44NzggMS43MTZNNTcuMjAyIDIwLjM1M0g0NC45MzN2NC4yNTloNi45OTNjLS4xOSAyLjE2MS0xLjAxNyAzLjgxNC0yLjQxNiA1LjE1LTEuMzk4IDEuMjctMy4xNzggMS45MDYtNS40NjcgMS45MDYtMS4yNzEgMC0yLjQ4LS4yNTQtMy40OTYtLjY5OWE3IDcgMCAwIDEtMi43MzQtMS45N2MtLjc2My0uODI3LTEuMzM1LTEuODQ0LTEuNzgtMy4wNTJzLS42MzYtMi40OC0uNjM2LTMuOTQyLjE5LTIuNzMzLjYzNi0zLjk0MWMuMzgxLTEuMjA4IDEuMDE3LTIuMTYyIDEuNzgtMy4wNTIuNzYzLS44MjYgMS42NTMtMS40NjIgMi43MzMtMS45N2E5LjEgOS4xIDAgMCAxIDMuNTYtLjdxNC4wMDUgMCA2LjEwMyAxLjkwN2wzLjMwNi0zLjMwNWMtMi40OC0xLjkwNy01LjY1OC0yLjkyNS05LjQwOS0yLjkyNS0yLjA5NyAwLTQuMDA0LjMxOC01LjcyMSAxLjAxOC0xLjcxNi42OTktMy4xNzkgMS41ODktNC4zODYgMi43OTdBMTIuMSAxMi4xIDAgMCAwIDMxLjIgMTYuMjJjLS42MzUgMS43MTctLjk1MyAzLjYyNC0uOTUzIDUuNjU4cy4zMTggMy45NDIgMS4wMTcgNS42NThjLjcgMS43MTcgMS41OSAzLjE3OSAyLjc5NyA0LjM4N2ExMi4xIDEyLjEgMCAwIDAgNC4zODcgMi43OTdjMS43MTYuNyAzLjYyMyAxLjAxNyA1LjY1NyAxLjAxNyAyLjAzNSAwIDMuODc4LS4zMTggNS41MzEtMS4wMTcgMS42NTMtLjcgMy4wNTItMS41OSA0LjE5Ni0yLjc5N3ExLjcxNi0xLjgxMiAyLjY3LTQuMzg3Yy42MzYtMS43MTYuOTU0LTMuNjIzLjk1NC01LjY1OHYtLjgyNmMtLjE5MS0uMTI3LS4yNTUtLjQ0NS0uMjU1LS43TTk1Ljk4MiAyMC4zNTNoLTEyLjI3djQuMjU5aDYuOTkzYy0uMTkgMi4xNjEtMS4wMTcgMy44MTQtMi40MTYgNS4xNS0xLjM5OCAxLjI3LTMuMTc4IDEuOTA2LTUuNDY3IDEuOTA2LTEuMjcxIDAtMi40OC0uMjU0LTMuNDk2LS42OTlhNyA3IDAgMCAxLTIuNzM0LTEuOTdjLS43NjMtLjgyNy0xLjMzNS0xLjg0NC0xLjc4LTMuMDUycy0uNjM2LTIuNDgtLjYzNi0zLjk0Mi4xOS0yLjczMy42MzYtMy45NDFjLjM4MS0xLjIwOCAxLjAxNy0yLjE2MiAxLjc4LTMuMDUyLjc2My0uODI2IDEuNjUzLTEuNDYyIDIuNzM0LTEuOTdhOS4xIDkuMSAwIDAgMSAzLjU2LS43cTQuMDA1IDAgNi4xMDMgMS45MDdsMy4zMDUtMy4zMDVjLTIuNDc5LTEuOTA3LTUuNjU4LTIuOTI1LTkuNDA4LTIuOTI1LTIuMDk4IDAtNC4wMDUuMzE4LTUuNzIyIDEuMDE4LTEuNzE2LjY5OS0zLjE3OCAxLjU4OS00LjM4NiAyLjc5N2ExMi4xIDEyLjEgMCAwIDAtMi43OTcgNC4zODZjLS42MzYgMS43MTctLjk1NCAzLjYyNC0uOTU0IDUuNjU4cy4zMTggMy45NDIgMS4wMTcgNS42NThjLjcgMS43MTcgMS41OSAzLjE3OSAyLjc5NyA0LjM4N2ExMi4xIDEyLjEgMCAwIDAgNC4zODcgMi43OTdjMS43MTYuNyAzLjYyMyAxLjAxNyA1LjY1OCAxLjAxNyAyLjAzNCAwIDMuODc4LS4zMTggNS41My0xLjAxNyAxLjY1My0uNyAzLjA1Mi0xLjU5IDQuMTk2LTIuNzk3cTEuNzE4LTEuODEyIDIuNjctNC4zODdjLjYzNi0xLjcxNi45NTQtMy42MjMuOTU0LTUuNjU4di0uODI2Yy0uMTktLjEyNy0uMjU1LS40NDUtLjI1NS0uNyIvPjwvc3ZnPg==");background-repeat:no-repeat;background-size:170px 40px;content:"";display:block;height:40px;width:170px}}:where(.ag-ltr) .ag-watermark{right:25px}:where(.ag-rtl) .ag-watermark{left:25px}.ag-watermark-text{font-family:Impact,sans-serif;font-size:19px;font-weight:700;opacity:.5}:where(.ag-ltr) .ag-watermark-text{padding-left:.7rem}:where(.ag-rtl) .ag-watermark-text{padding-right:.7rem}'
), tB = class extends _ {
  constructor() {
    super(
      /* html*/
      `<div class="ag-watermark">
                <div data-ref="eLicenseTextRef" class="ag-watermark-text"></div>
            </div>`
    ), this.eLicenseTextRef = E, this.registerCSS(eB);
  }
  wireBeans(e) {
    this.licenseManager = e.licenseManager;
  }
  postConstruct() {
    const e = this.shouldDisplayWatermark();
    this.setDisplayed(e), e && (this.eLicenseTextRef.innerText = this.licenseManager.getWatermarkMessage(), window.setTimeout(() => this.addCssClass("ag-opacity-zero"), 0), window.setTimeout(() => this.setDisplayed(!1), 5e3));
  }
  shouldDisplayWatermark() {
    return this.licenseManager.isDisplayWatermark();
  }
}, sB = {
  selector: "AG-WATERMARK",
  component: tB
}, iB = class extends L {
  constructor() {
    super(...arguments), this.beanName = "licenseManager";
  }
  postConstruct() {
    this.validateLicense();
  }
  validateLicense() {
    this.licenseManager = new zo(We(this.beans)), this.licenseManager.validateLicense();
  }
  static getLicenseDetails(e) {
    return new zo(null).getLicenseDetails(e);
  }
  getWatermarkSelector() {
    return sB;
  }
  isDisplayWatermark() {
    return this.licenseManager.isDisplayWatermark();
  }
  getWatermarkMessage() {
    return this.licenseManager.getWatermarkMessage();
  }
  static setLicenseKey(e) {
    zo.setLicenseKey(e);
  }
  static setChartsLicenseManager(e) {
    zo.setChartsLicenseManager(e);
  }
}, rB = 9525, Ff = {
  0: 1,
  "0.00": 2,
  "#,##0": 3,
  "#,##0.00": 4,
  "0%": 9,
  "0.00%": 10,
  "0.00E+00": 11,
  "# ?/?": 12,
  "# ??/??": 13,
  "mm-dd-yy": 14,
  "d-mmm-yy": 15,
  "d-mmm": 16,
  "mmm-yy": 17,
  "h:mm AM/PM": 18,
  "h:mm:ss AM/PM": 19,
  "h:mm": 20,
  "h:mm:ss": 21,
  "m/d/yy h:mm": 22,
  "#,##0 ;(#,##0)": 37,
  "#,##0 ;[Red](#,##0)": 38,
  "#,##0.00;(#,##0.00)": 39,
  "#,##0.00;[Red](#,##0.00)": 40,
  "mm:ss": 45,
  "[h]:mm:ss": 46,
  "mmss.0": 47,
  "##0.0E+0": 48,
  "@": 49
}, Za = `\r
`;
function Pf(e, t, s) {
  return !t && t !== "" && t !== 0 ? "" : ` ${e}="${t}"`;
}
function nB(e = {}) {
  const t = "<?", s = "?>", i = ["version"];
  e.version || (e.version = "1.0"), e.encoding && i.push("encoding"), e.standalone && i.push("standalone");
  const r = i.map((n) => `${n}="${e[n]}"`).join(" ");
  return `${t}xml ${r} ${s}`;
}
function qy(e, t) {
  let s = "";
  e.properties && (e.properties.prefixedAttributes && e.properties.prefixedAttributes.forEach((r) => {
    Object.keys(r.map).forEach((n) => {
      s += Pf(
        r.prefix + n,
        r.map[n]
      );
    });
  }), e.properties.rawMap && Object.keys(e.properties.rawMap).forEach((r) => {
    s += Pf(r, e.properties.rawMap[r]);
  }));
  let i = "<" + e.name + s;
  return !e.children && e.textNode == null ? i + "/>" + Za : e.textNode != null ? i + ">" + e.textNode + "</" + e.name + ">" + Za : (i += ">" + Za, e.children && e.children.forEach((r) => {
    i += qy(r);
  }), i + "</" + e.name + ">" + Za);
}
var oB = (e) => Math.round(e * 96 / 72), Bn = (e) => Math.ceil(e * rB), aB = (e) => {
  if (e === void 0)
    return;
  const s = ["Automatic", "Roman", "Swiss", "Modern", "Script", "Decorative"].indexOf(e || "Automatic");
  return Math.max(s, 0);
}, ul = (e, t) => {
  if (!t)
    return;
  let s;
  return typeof t == "number" ? s = t : s = t({ rowIndex: e }), s;
}, lB = (e, t) => {
  const { colSpan: s, column: i } = e.position;
  if (e.width)
    if (s) {
      const r = t.slice(i - 1, i + s - 1);
      let n = 0;
      for (let o = 0; o < r.length; o++) {
        const a = r[o].getActualWidth();
        if (e.width < n + a) {
          e.position.colSpan = o + 1, e.totalWidth = e.width, e.width = e.totalWidth - n;
          break;
        }
        n += a;
      }
    } else
      e.totalWidth = e.width;
}, cB = (e, t) => {
  const { rowSpan: s, row: i } = e.position;
  if (e.height)
    if (s) {
      let r = 0, n = 0;
      for (let o = i; o < i + s; o++) {
        const a = oB(ul(o, t) || 20);
        if (e.height < r + a) {
          e.position.rowSpan = n + 1, e.totalHeight = e.height, e.height = e.totalHeight - r;
          break;
        }
        r += a, n++;
      }
    } else
      e.totalHeight = e.height;
}, as = (e, t) => {
  const s = nB({
    encoding: "UTF-8",
    standalone: "yes"
  }), i = qy(e);
  return t ? i : `${s}${i}`;
}, wn = (e) => {
  const i = String.fromCharCode, r = Math.floor(e / 26), n = e % 26;
  return !r || e === 26 ? i(65 + e - 1) : n ? r < 26 ? i(65 + r - 1) + i(65 + n - 1) : wn(r) + i(65 + n - 1) : wn(r - 1) + "Z";
}, Su = (e) => {
  if (e == null)
    return null;
  let t = "";
  for (let s = 0; s < e.length; s++) {
    const i = e.charCodeAt(s);
    if (i >= 0 && i <= 31 && i !== 10) {
      const o = `_x${i.toString(16).toUpperCase().padStart(4, "0")}_`;
      t += o;
    } else
      t += e[s];
  }
  return t;
}, dB = (e) => {
  const t = [];
  for (const s of e.keys()) {
    const i = s.toString(), r = {
      name: "t",
      textNode: Ke(Su(i), !1)
    };
    i.trim().length !== i.length && (r.properties = {
      rawMap: {
        "xml:space": "preserve"
      }
    }), t.push({
      name: "si",
      children: [r]
    });
  }
  return t;
}, uB = {
  getTemplate(e) {
    const { name: t, ContentType: s, Extension: i, PartName: r } = e;
    return {
      name: t,
      properties: {
        rawMap: {
          Extension: i,
          PartName: r,
          ContentType: s
        }
      }
    };
  }
}, hB = uB, Tc = (e) => e === "jpg" ? "jpeg" : e, pB = {
  getTemplate(e) {
    const t = new Array(e).fill(void 0).map((c, d) => ({
      name: "Override",
      ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
      PartName: `/xl/worksheets/sheet${d + 1}.xml`
    })), s = bn.size, i = Dr.size, r = {};
    io.forEach((c) => {
      r[Tc(c.type)] = !0;
    });
    const n = new Array(s).fill(void 0).map((c, d) => ({
      name: "Override",
      ContentType: "application/vnd.openxmlformats-officedocument.drawing+xml",
      PartName: `/xl/drawings/drawing${d + 1}.xml`
    })), o = [];
    Ki.forEach(({ name: c }) => {
      o.push({
        name: "Override",
        ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml",
        PartName: `/xl/tables/${c}.xml`
      });
    });
    const a = Object.keys(r).map((c) => ({
      name: "Default",
      ContentType: `image/${c}`,
      Extension: c
    }));
    i && a.push({
      name: "Default",
      Extension: "vml",
      ContentType: "application/vnd.openxmlformats-officedocument.vmlDrawing"
    });
    const l = [
      ...a,
      {
        name: "Default",
        Extension: "rels",
        ContentType: "application/vnd.openxmlformats-package.relationships+xml"
      },
      {
        name: "Default",
        ContentType: "application/xml",
        Extension: "xml"
      },
      {
        name: "Override",
        ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        PartName: "/xl/workbook.xml"
      },
      ...t,
      {
        name: "Override",
        ContentType: "application/vnd.openxmlformats-officedocument.theme+xml",
        PartName: "/xl/theme/theme1.xml"
      },
      {
        name: "Override",
        ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        PartName: "/xl/styles.xml"
      },
      {
        name: "Override",
        ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        PartName: "/xl/sharedStrings.xml"
      },
      ...n,
      ...o,
      {
        name: "Override",
        ContentType: "application/vnd.openxmlformats-package.core-properties+xml",
        PartName: "/docProps/core.xml"
      }
    ].map((c) => hB.getTemplate(c));
    return {
      name: "Types",
      properties: {
        rawMap: {
          xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
        }
      },
      children: l
    };
  }
}, gB = pB, fB = {
  getTemplate(e) {
    const s = (/* @__PURE__ */ new Date()).toJSON();
    return {
      name: "cp:coreProperties",
      properties: {
        prefixedAttributes: [
          {
            prefix: "xmlns:",
            map: {
              cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
              dc: "http://purl.org/dc/elements/1.1/",
              dcterms: "http://purl.org/dc/terms/",
              dcmitype: "http://purl.org/dc/dcmitype/",
              xsi: "http://www.w3.org/2001/XMLSchema-instance"
            }
          }
        ]
      },
      children: [
        {
          name: "dc:creator",
          textNode: e
        },
        {
          name: "dc:title",
          textNode: "Workbook"
        },
        {
          name: "dcterms:created",
          properties: {
            rawMap: {
              "xsi:type": "dcterms:W3CDTF"
            }
          },
          textNode: s
        },
        {
          name: "dcterms:modified",
          properties: {
            rawMap: {
              "xsi:type": "dcterms:W3CDTF"
            }
          },
          textNode: s
        }
      ]
    };
  }
}, mB = fB, Tf = (e, t) => ({
  name: `xdr:${e}`,
  children: [
    {
      name: "xdr:col",
      textNode: t.col.toString()
    },
    {
      name: "xdr:colOff",
      textNode: t.offsetX.toString()
    },
    {
      name: "xdr:row",
      textNode: t.row.toString()
    },
    {
      name: "xdr:rowOff",
      textNode: t.offsetY.toString()
    }
  ]
}), CB = (e) => {
  const t = [
    {
      name: "a:ext",
      properties: {
        rawMap: {
          uri: "{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}"
        }
      },
      children: [
        {
          name: "a16:creationId",
          properties: {
            rawMap: {
              id: "{822E6D20-D7BC-2841-A643-D49A6EF008A2}",
              "xmlns:a16": "http://schemas.microsoft.com/office/drawing/2014/main"
            }
          }
        }
      ]
    }
  ];
  switch (e.recolor && e.recolor.toLowerCase()) {
    case "grayscale":
    case "sepia":
    case "washout":
      t.push({
        name: "a:ext",
        properties: {
          rawMap: {
            uri: "{C183D7F6-B498-43B3-948B-1728B52AA6E4}"
          }
        },
        children: [
          {
            name: "adec:decorative",
            properties: {
              rawMap: {
                val: "0",
                "xmlns:adec": "http://schemas.microsoft.com/office/drawing/2017/decorative"
              }
            }
          }
        ]
      });
  }
  return {
    name: "a:extLst",
    children: t
  };
}, vB = (e, t) => ({
  name: "xdr:nvPicPr",
  children: [
    {
      name: "xdr:cNvPr",
      properties: {
        rawMap: {
          id: t,
          name: e.id,
          descr: e.altText != null ? e.altText : void 0
        }
      },
      children: [CB(e)]
    },
    {
      name: "xdr:cNvPicPr",
      properties: {
        rawMap: {
          preferRelativeResize: "0"
        }
      },
      children: [
        {
          name: "a:picLocks"
        }
      ]
    }
  ]
}), Ef = (e) => {
  if (!e.saturation && !e.tint)
    return;
  const t = [];
  return e.saturation && t.push({
    name: "a:satMod",
    properties: {
      rawMap: {
        val: e.saturation * 1e3
      }
    }
  }), e.tint && t.push({
    name: "a:tint",
    properties: {
      rawMap: {
        val: e.tint * 1e3
      }
    }
  }), t;
}, wB = (e, t) => ({
  name: "a:duotone",
  children: [
    {
      name: "a:prstClr",
      properties: {
        rawMap: {
          val: e.color
        }
      },
      children: Ef(e)
    },
    {
      name: "a:srgbClr",
      properties: {
        rawMap: {
          val: t.color
        }
      },
      children: Ef(t)
    }
  ]
}), yB = (e, t) => {
  let s;
  if (e.transparency) {
    const i = Math.min(Math.max(e.transparency, 0), 100);
    s = [
      {
        name: "a:alphaModFix",
        properties: {
          rawMap: {
            amt: 1e5 - Math.round(i * 1e3)
          }
        }
      }
    ];
  }
  if (e.recolor)
    switch (s || (s = []), e.recolor.toLocaleLowerCase()) {
      case "grayscale":
        s.push({ name: "a:grayscl" });
        break;
      case "sepia":
        s.push(wB({ color: "black" }, { color: "D9C3A5", tint: 50, saturation: 180 }));
        break;
      case "washout":
        s.push({
          name: "a:lum",
          properties: {
            rawMap: {
              bright: "70000",
              contrast: "-70000"
            }
          }
        });
        break;
    }
  return {
    name: "xdr:blipFill",
    children: [
      {
        name: "a:blip",
        properties: {
          rawMap: {
            cstate: "print",
            "r:embed": `rId${t}`,
            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
          }
        },
        children: s
      },
      {
        name: "a:stretch",
        children: [
          {
            name: "a:fillRect"
          }
        ]
      }
    ]
  };
}, bB = (e, t) => {
  const s = {
    name: "a:xfrm",
    children: [
      {
        name: "a:off",
        properties: {
          rawMap: {
            x: 0,
            y: 0
          }
        }
      },
      {
        name: "a:ext",
        properties: {
          rawMap: {
            cx: t.width,
            cy: t.height
          }
        }
      }
    ]
  };
  if (e.rotation) {
    const n = e.rotation;
    s.properties = {
      rawMap: {
        rot: Math.min(Math.max(n, 0), 360) * 6e4
      }
    };
  }
  return {
    name: "xdr:spPr",
    children: [s, {
      name: "a:prstGeom",
      properties: {
        rawMap: {
          prst: "rect"
        }
      },
      children: [{ name: "a:avLst" }]
    }]
  };
}, SB = (e) => {
  e.fitCell = !!e.fitCell || !e.width || !e.height;
  const { position: t = {}, fitCell: s, width: i = 0, height: r = 0, totalHeight: n, totalWidth: o } = e, { offsetX: a = 0, offsetY: l = 0, row: c = 1, rowSpan: d = 1, column: u = 1, colSpan: h = 1 } = t;
  return {
    from: {
      row: c - 1,
      col: u - 1,
      offsetX: Bn(a),
      offsetY: Bn(l)
    },
    to: {
      row: c - 1 + (s ? 1 : d - 1),
      col: u - 1 + (s ? 1 : h - 1),
      offsetX: Bn(i + a),
      offsetY: Bn(r + l)
    },
    height: Bn(n || r),
    width: Bn(o || i)
  };
}, xB = (e, t, s, i) => ({
  name: "xdr:pic",
  children: [
    vB(e, t + 1),
    yB(e, s + 1),
    bB(e, i)
  ]
}), RB = {
  getTemplate(e) {
    const { sheetIndex: t } = e, s = bn.get(t), i = ca.get(t), r = s.map((n, o) => {
      const a = SB(n);
      return {
        name: "xdr:twoCellAnchor",
        properties: {
          rawMap: {
            editAs: "absolute"
          }
        },
        children: [
          Tf("from", a.from),
          Tf("to", a.to),
          xB(n, o, i.get(n.id).index, a),
          { name: "xdr:clientData" }
        ]
      };
    });
    return {
      name: "xdr:wsDr",
      properties: {
        rawMap: {
          "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main",
          "xmlns:xdr": "http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing"
        }
      },
      children: r
    };
  }
}, FB = RB, PB = {
  getTemplate(e) {
    const { Id: t, Type: s, Target: i } = e;
    return {
      name: "Relationship",
      properties: {
        rawMap: {
          Id: t,
          Type: s,
          Target: i
        }
      }
    };
  }
}, TB = PB, EB = {
  getTemplate(e) {
    const t = e.map((s) => TB.getTemplate(s));
    return {
      name: "Relationships",
      properties: {
        rawMap: {
          xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
        }
      },
      children: t
    };
  }
}, wa = EB, DB = {
  getTemplate(e) {
    return {
      name: "sst",
      properties: {
        rawMap: {
          xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
          count: e.size,
          uniqueCount: e.size
        }
      },
      children: dB(e)
    };
  }
}, AB = DB, MB = (e) => {
  switch (e) {
    case 1:
      return "thin";
    case 2:
      return "medium";
    case 3:
      return "thick";
    default:
      return "hair";
  }
}, IB = {
  None: "None",
  Dot: "Dotted",
  Dash: "Dashed",
  Double: "Double",
  DashDot: "DashDot",
  DashDotDot: "DashDotDot",
  SlantDashDot: "SlantDashDot",
  Continuous: "Continuous"
}, LB = ["Dashed", "DashDot", "DashDotDot"], kB = {
  None: "none",
  Solid: "solid",
  Gray50: "mediumGray",
  Gray75: "darkGray",
  Gray25: "lightGray",
  HorzStripe: "darkHorizontal",
  VertStripe: "darkVertical",
  ReverseDiagStripe: "darkDown",
  DiagStripe: "darkUp",
  DiagCross: "darkGrid",
  ThickDiagCross: "darkTrellis",
  ThinHorzStripe: "lightHorizontal",
  ThinVertStripe: "lightVertical",
  ThinReverseDiagStripe: "lightDown",
  ThinDiagStripe: "lightUp",
  ThinHorzCross: "lightGrid",
  ThinDiagCross: "lightTrellis",
  Gray125: "gray125",
  Gray0625: "gray0625"
}, OB = {
  Automatic: "general",
  Left: "left",
  Center: "center",
  Right: "right",
  Fill: "fill",
  Justify: "justify",
  CenterAcrossSelection: "centerContinuous",
  Distributed: "distributed",
  JustifyDistributed: "justify"
}, GB = {
  Automatic: void 0,
  Top: "top",
  Bottom: "bottom",
  Center: "center",
  Justify: "justify",
  Distributed: "distributed",
  JustifyDistributed: "justify"
}, BB = (e) => e ? kB[e] || e : "none", Cr = (e) => e == null ? e : (e.charAt(0) === "#" && (e = e.substring(1)), e.length === 6 ? "FF" + e : e), Qa = (e, t) => {
  if (!e)
    return "thin";
  const s = MB(t);
  if (e === "Continuous")
    return s;
  const i = IB[e];
  return s === "medium" && LB.some((r) => r === i) ? `medium${i}` : `${i.charAt(0).toLowerCase()}${i.substring(1)}`;
}, VB = (e) => OB[e] || "general", NB = (e) => GB[e] || void 0, ko = (e) => ({
  name: "color",
  properties: {
    rawMap: {
      rgb: Cr(e || "#000000")
    }
  }
}), HB = {
  getTemplate(e) {
    const { left: t, right: s, top: i, bottom: r, diagonal: n } = e, o = t ? [ko(t.color)] : void 0, a = s ? [ko(s.color)] : void 0, l = i ? [ko(i.color)] : void 0, c = r ? [ko(r.color)] : void 0, d = n ? [ko(n.color)] : void 0;
    return {
      name: "border",
      children: [
        {
          name: "left",
          properties: { rawMap: { style: t && t.style } },
          children: o
        },
        {
          name: "right",
          properties: { rawMap: { style: s && s.style } },
          children: a
        },
        {
          name: "top",
          properties: { rawMap: { style: i && i.style } },
          children: l
        },
        {
          name: "bottom",
          properties: { rawMap: { style: r && r.style } },
          children: c
        },
        {
          name: "diagonal",
          properties: { rawMap: { style: n && n.style } },
          children: d
        }
      ]
    };
  }
}, zB = HB, WB = {
  getTemplate(e) {
    return {
      name: "borders",
      properties: {
        rawMap: {
          count: e.length
        }
      },
      children: e.map((t) => zB.getTemplate(t))
    };
  }
}, _B = WB, UB = (e) => {
  const s = ["Context", "LeftToRight", "RightToLeft"].indexOf(e);
  return Math.max(s, 0);
}, $B = {
  getTemplate(e) {
    const { horizontal: t, indent: s, readingOrder: i, rotate: r, shrinkToFit: n, vertical: o, wrapText: a } = e;
    return {
      name: "alignment",
      properties: {
        rawMap: {
          horizontal: t && VB(t),
          indent: s,
          readingOrder: i && UB(i),
          textRotation: r,
          shrinkToFit: n,
          vertical: o && NB(o),
          wrapText: a
        }
      }
    };
  }
}, jB = $B, KB = {
  getTemplate(e) {
    const t = e.protected === !1 ? 0 : 1;
    return {
      name: "protection",
      properties: {
        rawMap: {
          hidden: e.hideFormula === !0 ? 1 : 0,
          locked: t
        }
      }
    };
  }
}, qB = KB, YB = {
  getTemplate(e) {
    const { alignment: t, borderId: s, fillId: i, fontId: r, numFmtId: n, protection: o, quotePrefix: a, xfId: l } = e, c = [];
    return t && c.push(jB.getTemplate(t)), o && c.push(qB.getTemplate(o)), {
      name: "xf",
      properties: {
        rawMap: {
          applyAlignment: t ? 1 : void 0,
          applyProtection: o ? 1 : void 0,
          applyBorder: s ? 1 : void 0,
          applyFill: i ? 1 : void 0,
          borderId: s,
          fillId: i,
          applyFont: r ? 1 : void 0,
          fontId: r,
          applyNumberFormat: n ? 1 : void 0,
          numFmtId: n,
          quotePrefix: a ? 1 : void 0,
          xfId: l
        }
      },
      children: c.length ? c : void 0
    };
  }
}, Yy = YB, XB = {
  getTemplate(e) {
    return {
      name: "cellStyleXfs",
      properties: {
        rawMap: {
          count: e.length
        }
      },
      children: e.map((t) => Yy.getTemplate(t))
    };
  }
}, ZB = XB, QB = {
  getTemplate(e) {
    const { builtinId: t, name: s, xfId: i } = e;
    return {
      name: "cellStyle",
      properties: {
        rawMap: {
          builtinId: t,
          name: s,
          xfId: i
        }
      }
    };
  }
}, JB = QB, eV = {
  getTemplate(e) {
    return {
      name: "cellStyles",
      properties: {
        rawMap: {
          count: e.length
        }
      },
      children: e.map((t) => JB.getTemplate(t))
    };
  }
}, tV = eV, sV = {
  getTemplate(e) {
    return {
      name: "cellXfs",
      properties: {
        rawMap: {
          count: e.length
        }
      },
      children: e.map((t) => Yy.getTemplate(t))
    };
  }
}, iV = sV, rV = {
  getTemplate(e) {
    const { patternType: t, fgTheme: s, fgTint: i, fgRgb: r, bgRgb: n, bgIndexed: o } = e, a = {
      name: "patternFill",
      properties: {
        rawMap: {
          patternType: t
        }
      }
    };
    return (s || i || r) && (a.children = [
      {
        name: "fgColor",
        properties: {
          rawMap: {
            theme: s,
            tint: i,
            rgb: r
          }
        }
      }
    ]), (o || n) && (a.children || (a.children = []), a.children.push({
      name: "bgColor",
      properties: {
        rawMap: {
          indexed: o,
          rgb: n
        }
      }
    })), {
      name: "fill",
      children: [a]
    };
  }
}, nV = rV, oV = {
  getTemplate(e) {
    return {
      name: "fills",
      properties: {
        rawMap: {
          count: e.length
        }
      },
      children: e.map((t) => nV.getTemplate(t))
    };
  }
}, aV = oV, lV = {
  getTemplate(e) {
    const {
      size: t,
      colorTheme: s,
      color: i = "FF000000",
      fontName: r = "Calibri",
      family: n,
      scheme: o,
      italic: a,
      bold: l,
      strikeThrough: c,
      outline: d,
      shadow: u,
      underline: h,
      verticalAlign: p
    } = e, g = [
      { name: "sz", properties: { rawMap: { val: t } } },
      { name: "color", properties: { rawMap: { theme: s, rgb: i } } },
      { name: "name", properties: { rawMap: { val: r } } }
    ];
    return n && g.push({ name: "family", properties: { rawMap: { val: n } } }), o && g.push({ name: "scheme", properties: { rawMap: { val: o } } }), a && g.push({ name: "i" }), l && g.push({ name: "b" }), c && g.push({ name: "strike" }), d && g.push({ name: "outline" }), u && g.push({ name: "shadow" }), h && g.push({ name: "u", properties: { rawMap: { val: h } } }), p && g.push({ name: "vertAlign", properties: { rawMap: { val: p } } }), { name: "font", children: g };
  }
}, cV = lV, dV = {
  getTemplate(e) {
    return {
      name: "fonts",
      properties: {
        rawMap: {
          count: e.length
        }
      },
      children: e.map((t) => cV.getTemplate(t))
    };
  }
}, uV = dV;
function hV(e) {
  const t = e.split(/(\[[^\]]*\])/);
  for (let s = 0; s < t.length; s++) {
    let i = t[s];
    i.length && (i.startsWith("[") || (i = i.replace(/\$/g, '"$"')), t[s] = Ke(i));
  }
  return t.join("");
}
var pV = {
  getTemplate(e) {
    let { formatCode: t, numFmtId: s } = e;
    return t.length && (t = hV(t)), {
      name: "numFmt",
      properties: {
        rawMap: {
          formatCode: t,
          numFmtId: s
        }
      }
    };
  }
}, gV = pV, fV = {
  getTemplate(e) {
    return {
      name: "numFmts",
      properties: {
        rawMap: {
          count: e.length
        }
      },
      children: e.map((t) => gV.getTemplate(t))
    };
  }
}, mV = fV, Wl, Hn, Jo, ea, ta, Xy, _l, Zy, xu, Qy = (e, t) => (e.indexOf("mixedStyle") !== -1 && t > 1 && (e += `_${t}`), e), Jy = () => {
  Wl = { base: 0 }, Hn = [], Jo = [{ fontName: "Calibri", colorTheme: "1", family: "2", scheme: "minor" }], ea = [{ patternType: "none" }, { patternType: "gray125" }], ta = [{ left: void 0, right: void 0, top: void 0, bottom: void 0, diagonal: void 0 }], Xy = [{ borderId: 0, fillId: 0, fontId: 0, numFmtId: 0 }], _l = [{ borderId: 0, fillId: 0, fontId: 0, numFmtId: 0, xfId: 0 }], Zy = [{ builtinId: 0, name: "Normal", xfId: 0 }];
}, CV = (e) => {
  const t = BB(e.pattern), s = Cr(e.color), i = Cr(e.patternColor);
  let r = ea.findIndex((n) => {
    const { patternType: o, fgRgb: a, bgRgb: l } = n;
    return !(o != t || a != s || l != i);
  });
  return r === -1 && (r = ea.length, ea.push({
    patternType: t,
    fgRgb: s,
    bgRgb: i
  })), r;
}, vV = (e) => {
  if (Ff[e])
    return Ff[e];
  let t = Hn.findIndex((s) => s.formatCode === e);
  return t === -1 ? (t = Hn.length + 164, Hn.push({ formatCode: e, numFmtId: t })) : t = Hn[t].numFmtId, t;
}, wV = (e) => {
  const { borderBottom: t, borderTop: s, borderLeft: i, borderRight: r } = e;
  let n, o, a, l, c, d, u, h;
  i && (a = Qa(i.lineStyle, i.weight), u = Cr(i.color)), r && (l = Qa(r.lineStyle, r.weight), h = Cr(r.color)), t && (n = Qa(t.lineStyle, t.weight), c = Cr(t.color)), s && (o = Qa(s.lineStyle, s.weight), d = Cr(s.color));
  let p = ta.findIndex((g) => {
    const { left: f, right: m, top: C, bottom: w } = g;
    if (!f && (a || u) || !m && (l || h) || !C && (o || d) || !w && (n || c))
      return !1;
    const { style: y, color: b } = f || {}, { style: x, color: M } = m || {}, { style: T, color: F } = C || {}, { style: k, color: O } = w || {};
    return !(y != a || b != u || x != l || M != h || T != o || F != d || k != n || O != c);
  });
  return p === -1 && (p = ta.length, ta.push({
    left: {
      style: a,
      color: u
    },
    right: {
      style: l,
      color: h
    },
    top: {
      style: o,
      color: d
    },
    bottom: {
      style: n,
      color: c
    },
    diagonal: {
      style: void 0,
      color: void 0
    }
  })), p;
}, yV = (e) => {
  const {
    fontName: t = "Calibri",
    color: s,
    size: i,
    bold: r,
    italic: n,
    outline: o,
    shadow: a,
    strikeThrough: l,
    underline: c,
    family: d,
    verticalAlign: u
  } = e, h = Cr(s), p = aB(d), g = c ? c.toLocaleLowerCase() : void 0, f = u ? u.toLocaleLowerCase() : void 0;
  let m = Jo.findIndex((C) => !(C.fontName != t || C.color != h || C.size != i || C.bold != r || C.italic != n || C.outline != o || C.shadow != a || C.strikeThrough != l || C.underline != g || C.verticalAlign != f || C.family != p));
  return m === -1 && (m = Jo.length, Jo.push({
    fontName: t,
    color: h,
    size: i,
    bold: r,
    italic: n,
    outline: o,
    shadow: a,
    strikeThrough: l,
    underline: g,
    verticalAlign: f,
    family: p != null ? p.toString() : void 0
  })), m;
}, bV = (e) => {
  const { alignment: t, borders: s, font: i, interior: r, numberFormat: n, protection: o, quotePrefix: a } = e;
  let { id: l } = e, c = 0, d = 0, u = 0, h = 0;
  l && (l = Qy(l, xu), Wl[l] == null && (r && (c = CV(r)), s && (d = wV(s)), i && (u = yV(i)), n && (h = vV(n.format)), Wl[l] = _l.length, _l.push({
    alignment: t,
    borderId: d || 0,
    fillId: c || 0,
    fontId: u || 0,
    numFmtId: h || 0,
    protection: o,
    quotePrefix: a,
    xfId: 0
  })));
}, SV = {
  getTemplate(e) {
    const t = mV.getTemplate(Hn), s = uV.getTemplate(
      Jo.map((l) => ({ ...l, size: l.size != null ? l.size : e }))
    ), i = aV.getTemplate(ea), r = _B.getTemplate(ta), n = ZB.getTemplate(Xy), o = iV.getTemplate(_l), a = tV.getTemplate(Zy);
    return Jy(), {
      name: "styleSheet",
      properties: {
        rawMap: {
          "mc:Ignorable": "x14ac x16r2 xr",
          xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
          "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
          "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
          "xmlns:x16r2": "http://schemas.microsoft.com/office/spreadsheetml/2015/02/main",
          "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision"
        }
      },
      children: [
        t,
        s,
        i,
        r,
        n,
        o,
        a,
        {
          name: "tableStyles",
          properties: {
            rawMap: {
              count: 0,
              defaultPivotStyle: "PivotStyleLight16",
              defaultTableStyle: "TableStyleMedium2"
            }
          }
        }
      ]
    };
  }
}, xV = (e, t) => Wl[Qy(e, t)] || 0, RV = (e, t) => {
  xu = t, xu === 1 && Jy(), e.forEach(bV);
}, FV = SV, PV = {
  getTemplate(e, t) {
    const {
      name: s,
      columns: i,
      rowRange: r,
      displayName: n,
      showRowStripes: o,
      showColumnStripes: a,
      showFilterButtons: l,
      highlightFirstColumn: c,
      highlightLastColumn: d
    } = e || {}, u = !r || r[0] - r[1] === 0;
    if (!e || !s || !Array.isArray(i) || !i.length || u)
      return { name: "table" };
    const h = i.map((w, y) => ({
      name: "filterColumn",
      properties: {
        rawMap: {
          colId: y.toString(),
          // For filters, this should start with 0
          hiddenButton: l[y] ? 0 : 1
        }
      }
    })), p = `A${r[0]}`, g = `${wn(i.length)}${r[1]}`, f = `${p}:${g}`, m = `${t + 1}`, C = t ? `${n}_${m}` : n;
    return {
      name: "table",
      properties: {
        rawMap: {
          xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
          "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
          "mc:Ignorable": "xr xr3",
          "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision",
          "xmlns:xr3": "http://schemas.microsoft.com/office/spreadsheetml/2016/revision3",
          name: s,
          displayName: C,
          ref: f,
          totalsRowShown: 0,
          id: m
        }
      },
      children: [
        {
          name: "autoFilter",
          properties: {
            rawMap: {
              ref: f
            }
          },
          children: h
        },
        {
          name: "tableColumns",
          properties: {
            rawMap: {
              count: i.length
            }
          },
          children: i.map((w, y) => ({
            name: "tableColumn",
            properties: {
              rawMap: {
                id: (y + 1).toString(),
                name: w,
                dataCellStyle: "Normal"
              }
            }
          }))
        },
        {
          name: "tableStyleInfo",
          properties: {
            rawMap: {
              name: "TableStyleLight1",
              showFirstColumn: c ? 1 : 0,
              showLastColumn: d ? 1 : 0,
              showRowStripes: o ? 1 : 0,
              showColumnStripes: a ? 1 : 0
            }
          }
        }
      ]
    };
  }
}, TV = PV, Gs = (e) => {
  const [t, s, i, r] = e;
  return {
    name: `a:${t}`,
    children: [
      {
        name: `a:${s}`,
        properties: {
          rawMap: {
            val: i,
            lastClr: r
          }
        }
      }
    ]
  };
}, EV = {
  getTemplate() {
    return {
      name: "a:clrScheme",
      properties: {
        rawMap: {
          name: "Office"
        }
      },
      children: [
        Gs(["dk1", "sysClr", "windowText", "000000"]),
        Gs(["lt1", "sysClr", "window", "FFFFFF"]),
        Gs(["dk2", "srgbClr", "44546A"]),
        Gs(["lt2", "srgbClr", "E7E6E6"]),
        Gs(["accent1", "srgbClr", "4472C4"]),
        Gs(["accent2", "srgbClr", "ED7D31"]),
        Gs(["accent3", "srgbClr", "A5A5A5"]),
        Gs(["accent4", "srgbClr", "FFC000"]),
        Gs(["accent5", "srgbClr", "5B9BD5"]),
        Gs(["accent6", "srgbClr", "70AD47"]),
        Gs(["hlink", "srgbClr", "0563C1"]),
        Gs(["folHlink", "srgbClr", "954F72"])
      ]
    };
  }
}, DV = EV, Z = (e) => {
  const [t, s, i, r] = e;
  return {
    name: `a:${t}`,
    properties: {
      rawMap: {
        script: i,
        typeface: s,
        panose: r
      }
    }
  };
}, AV = {
  getTemplate() {
    return {
      name: "a:fontScheme",
      properties: {
        rawMap: {
          name: "Office"
        }
      },
      children: [
        {
          name: "a:majorFont",
          children: [
            Z(["latin", "Calibri Light", void 0, "020F0302020204030204"]),
            Z(["ea", ""]),
            Z(["cs", ""]),
            Z(["font", "游ゴシック Light", "Jpan"]),
            Z(["font", "맑은 고딕", "Hang"]),
            Z(["font", "等线 Light", "Hans"]),
            Z(["font", "新細明體", "Hant"]),
            Z(["font", "Times New Roman", "Arab"]),
            Z(["font", "Times New Roman", "Hebr"]),
            Z(["font", "Tahoma", "Thai"]),
            Z(["font", "Nyala", "Ethi"]),
            Z(["font", "Vrinda", "Beng"]),
            Z(["font", "Shruti", "Gujr"]),
            Z(["font", "MoolBoran", "Khmr"]),
            Z(["font", "Tunga", "Knda"]),
            Z(["font", "Raavi", "Guru"]),
            Z(["font", "Euphemia", "Cans"]),
            Z(["font", "Plantagenet Cherokee", "Cher"]),
            Z(["font", "Microsoft Yi Baiti", "Yiii"]),
            Z(["font", "Microsoft Himalaya", "Tibt"]),
            Z(["font", "MV Boli", "Thaa"]),
            Z(["font", "Mangal", "Deva"]),
            Z(["font", "Gautami", "Telu"]),
            Z(["font", "Latha", "Taml"]),
            Z(["font", "Estrangelo Edessa", "Syrc"]),
            Z(["font", "Kalinga", "Orya"]),
            Z(["font", "Kartika", "Mlym"]),
            Z(["font", "DokChampa", "Laoo"]),
            Z(["font", "Iskoola Pota", "Sinh"]),
            Z(["font", "Mongolian Baiti", "Mong"]),
            Z(["font", "Times New Roman", "Viet"]),
            Z(["font", "Microsoft Uighur", "Uigh"]),
            Z(["font", "Sylfaen", "Geor"]),
            Z(["font", "Arial", "Armn"]),
            Z(["font", "Leelawadee UI", "Bugi"]),
            Z(["font", "Microsoft JhengHei", "Bopo"]),
            Z(["font", "Javanese Text", "Java"]),
            Z(["font", "Segoe UI", "Lisu"]),
            Z(["font", "Myanmar Text", "Mymr"]),
            Z(["font", "Ebrima", "Nkoo"]),
            Z(["font", "Nirmala UI", "Olck"]),
            Z(["font", "Ebrima", "Osma"]),
            Z(["font", "Phagspa", "Phag"]),
            Z(["font", "Estrangelo Edessa", "Syrn"]),
            Z(["font", "Estrangelo Edessa", "Syrj"]),
            Z(["font", "Estrangelo Edessa", "Syre"]),
            Z(["font", "Nirmala UI", "Sora"]),
            Z(["font", "Microsoft Tai Le", "Tale"]),
            Z(["font", "Microsoft New Tai Lue", "Talu"]),
            Z(["font", "Ebrima", "Tfng"])
          ]
        },
        {
          name: "a:minorFont",
          children: [
            Z(["latin", "Calibri", void 0, "020F0502020204030204"]),
            Z(["ea", ""]),
            Z(["cs", ""]),
            Z(["font", "游ゴシック", "Jpan"]),
            Z(["font", "맑은 고딕", "Hang"]),
            Z(["font", "等线", "Hans"]),
            Z(["font", "新細明體", "Hant"]),
            Z(["font", "Arial", "Arab"]),
            Z(["font", "Arial", "Hebr"]),
            Z(["font", "Tahoma", "Thai"]),
            Z(["font", "Nyala", "Ethi"]),
            Z(["font", "Vrinda", "Beng"]),
            Z(["font", "Shruti", "Gujr"]),
            Z(["font", "DaunPenh", "Khmr"]),
            Z(["font", "Tunga", "Knda"]),
            Z(["font", "Raavi", "Guru"]),
            Z(["font", "Euphemia", "Cans"]),
            Z(["font", "Plantagenet Cherokee", "Cher"]),
            Z(["font", "Microsoft Yi Baiti", "Yiii"]),
            Z(["font", "Microsoft Himalaya", "Tibt"]),
            Z(["font", "MV Boli", "Thaa"]),
            Z(["font", "Mangal", "Deva"]),
            Z(["font", "Gautami", "Telu"]),
            Z(["font", "Latha", "Taml"]),
            Z(["font", "Estrangelo Edessa", "Syrc"]),
            Z(["font", "Kalinga", "Orya"]),
            Z(["font", "Kartika", "Mlym"]),
            Z(["font", "DokChampa", "Laoo"]),
            Z(["font", "Iskoola Pota", "Sinh"]),
            Z(["font", "Mongolian Baiti", "Mong"]),
            Z(["font", "Arial", "Viet"]),
            Z(["font", "Microsoft Uighur", "Uigh"]),
            Z(["font", "Sylfaen", "Geor"]),
            Z(["font", "Arial", "Armn"]),
            Z(["font", "Leelawadee UI", "Bugi"]),
            Z(["font", "Microsoft JhengHei", "Bopo"]),
            Z(["font", "Javanese Text", "Java"]),
            Z(["font", "Segoe UI", "Lisu"]),
            Z(["font", "Myanmar Text", "Mymr"]),
            Z(["font", "Ebrima", "Nkoo"]),
            Z(["font", "Nirmala UI", "Olck"]),
            Z(["font", "Ebrima", "Osma"]),
            Z(["font", "Phagspa", "Phag"]),
            Z(["font", "Estrangelo Edessa", "Syrn"]),
            Z(["font", "Estrangelo Edessa", "Syrj"]),
            Z(["font", "Estrangelo Edessa", "Syre"]),
            Z(["font", "Nirmala UI", "Sora"]),
            Z(["font", "Microsoft Tai Le", "Tale"]),
            Z(["font", "Microsoft New Tai Lue", "Talu"]),
            Z(["font", "Ebrima", "Tfng"])
          ]
        }
      ]
    };
  }
}, MV = AV, bi = (e, t, s) => ({
  name: `a:${e}`,
  properties: {
    rawMap: {
      val: t
    }
  },
  children: s
}), Dd = (e) => {
  const [t, s, i, r, n, o] = e, a = [];
  return a.push(bi("satMod", i)), r && a.push(bi("lumMod", r)), n && a.push(bi("tint", n)), o && a.push(bi("shade", o)), {
    name: "a:gs",
    properties: {
      rawMap: {
        pos: t
      }
    },
    children: [
      {
        name: "a:schemeClr",
        properties: {
          rawMap: {
            val: s
          }
        },
        children: a
      }
    ]
  };
}, Ul = (e, t) => ({
  name: "a:solidFill",
  children: [bi("schemeClr", e, t)]
}), Ru = (e) => {
  const [t, s, i, r, n] = e, [o, a] = n;
  return {
    name: "a:gradFill",
    properties: {
      rawMap: {
        rotWithShape: t
      }
    },
    children: [
      {
        name: "a:gsLst",
        children: [Dd(s), Dd(i), Dd(r)]
      },
      {
        name: "a:lin",
        properties: {
          rawMap: {
            ang: o,
            scaled: a
          }
        }
      }
    ]
  };
}, Ad = (e) => {
  const [t, s, i, r] = e;
  return {
    name: "a:ln",
    properties: {
      rawMap: { w: t, cap: s, cmpd: i, algn: r }
    },
    children: [
      Ul("phClr"),
      bi("prstDash", "solid"),
      {
        name: "a:miter",
        properties: {
          rawMap: {
            lim: "800000"
          }
        }
      }
    ]
  };
}, Md = (e) => {
  const t = [];
  if (e) {
    const [s, i, r, n, o] = e;
    t.push({
      name: "a:outerShdw",
      properties: {
        rawMap: { blurRad: s, dist: i, dir: r, algn: n, rotWithShape: o }
      },
      children: [bi("srgbClr", "000000", [bi("alpha", "63000")])]
    });
  }
  return {
    name: "a:effectStyle",
    children: [
      Object.assign(
        {},
        {
          name: "a:effectLst"
        },
        t.length ? { children: t } : {}
      )
    ]
  };
}, IV = () => ({
  name: "a:fillStyleLst",
  children: [
    Ul("phClr"),
    Ru([
      "1",
      ["0", "phClr", "105000", "110000", "67000"],
      ["50000", "phClr", "103000", "105000", "73000"],
      ["100000", "phClr", "109000", "105000", "81000"],
      ["5400000", "0"]
    ]),
    Ru([
      "1",
      ["0", "phClr", "103000", "102000", "94000"],
      ["50000", "phClr", "110000", "100000", void 0, "100000"],
      ["100000", "phClr", "120000", "99000", void 0, "78000"],
      ["5400000", "0"]
    ])
  ]
}), LV = () => ({
  name: "a:lnStyleLst",
  children: [
    Ad(["6350", "flat", "sng", "ctr"]),
    Ad(["12700", "flat", "sng", "ctr"]),
    Ad(["19050", "flat", "sng", "ctr"])
  ]
}), kV = () => ({
  name: "a:effectStyleLst",
  children: [Md(), Md(), Md(["57150", "19050", "5400000", "ctr", "0"])]
}), OV = () => ({
  name: "a:bgFillStyleLst",
  children: [
    Ul("phClr"),
    Ul("phClr", [bi("tint", "95000"), bi("satMod", "170000")]),
    Ru([
      "1",
      ["0", "phClr", "150000", "102000", "93000", "98000"],
      ["50000", "phClr", "130000", "103000", "98000", "90000"],
      ["100000", "phClr", "120000", void 0, void 0, "63000"],
      ["5400000", "0"]
    ])
  ]
}), GV = {
  getTemplate() {
    return {
      name: "a:fmtScheme",
      properties: {
        rawMap: {
          name: "Office"
        }
      },
      children: [IV(), LV(), kV(), OV()]
    };
  }
}, BV = GV, VV = {
  getTemplate() {
    return {
      name: "a:themeElements",
      children: [DV.getTemplate(), MV.getTemplate(), BV.getTemplate()]
    };
  }
}, NV = VV, HV = {
  getTemplate() {
    return {
      name: "a:theme",
      properties: {
        prefixedAttributes: [
          {
            prefix: "xmlns:",
            map: {
              a: "http://schemas.openxmlformats.org/drawingml/2006/main"
            }
          }
        ],
        rawMap: {
          name: "Office Theme"
        }
      },
      children: [
        NV.getTemplate(),
        {
          name: "a:objectDefaults"
        },
        {
          name: "a:extraClrSchemeLst"
        }
      ]
    };
  }
}, zV = HV, WV = () => ({
  name: "o:shapelayout",
  properties: {
    prefixedAttributes: [
      {
        prefix: "v:",
        map: {
          ext: "edit"
        }
      }
    ]
  },
  children: [
    {
      name: "o:idmap",
      properties: {
        prefixedAttributes: [
          {
            prefix: "v:",
            map: {
              ext: "edit"
            }
          }
        ],
        rawMap: {
          data: "1"
        }
      }
    }
  ]
}), _V = () => ({
  name: "v:stroke",
  properties: {
    rawMap: {
      joinstyle: "miter"
    }
  }
}), UV = (e) => ({
  name: "v:formulas",
  children: e.map((t) => ({
    name: "v:f",
    properties: {
      rawMap: {
        eqn: t
      }
    }
  }))
}), $V = () => ({
  name: "v:path",
  properties: {
    prefixedAttributes: [
      {
        prefix: "o:",
        map: {
          connecttype: "rect",
          extrusionok: "f"
        }
      }
    ],
    rawMap: {
      gradientshapeok: "t"
    }
  }
}), eb = (e) => {
  const { aspectratio: t, rotation: s } = e || {}, i = {};
  return t && (i.aspectratio = "t"), s && (i.rotation = "t"), {
    name: "o:lock",
    properties: {
      prefixedAttributes: [
        {
          prefix: "v:",
          map: {
            ext: "edit"
          }
        }
      ],
      rawMap: i
    }
  };
};
function jV(e, t, s, i, r) {
  return (e - t) / (s - t) * (r - i) + i;
}
var KV = (e, t) => {
  let s;
  const { recolor: i, brightness: r, contrast: n, id: o } = e;
  if (i && (s = {}, (i === "Washout" || i === "Grayscale") && (s.gain = "19661f", s.blacklevel = "22938f"), (i === "Black & White" || i === "Grayscale") && (s.grayscale = "t", i === "Black & White" && (s.bilevel = "t"))), !i || i === "Grayscale") {
    if (s || (s = {}), n != null && n !== 50) {
      let a = "1";
      n >= 0 && (n < 50 ? a = String(n / 50) : n < 100 ? a = String(50 / (100 - n)) : n === 100 && (a = "2147483647f")), s.gain = a;
    }
    r != null && r !== 50 && (s.blacklevel = jV(r, 0, 100, -0.5, 0.5).toString());
  }
  return {
    name: "v:imagedata",
    properties: {
      prefixedAttributes: [
        {
          prefix: "o:",
          map: {
            relid: `rId${t}`,
            title: o
          }
        }
      ],
      rawMap: s
    }
  };
}, qV = () => {
  const e = [
    "if lineDrawn pixelLineWidth 0",
    "sum @0 1 0",
    "sum 0 0 @1",
    "prod @2 1 2",
    "prod @3 21600 pixelWidth",
    "prod @3 21600 pixelHeight",
    "sum @0 0 1",
    "prod @6 1 2",
    "prod @7 21600 pixelWidth",
    "sum @8 21600 0",
    "prod @7 21600 pixelHeight",
    "sum @10 21600 0"
  ];
  return {
    name: "v:shapetype",
    properties: {
      prefixedAttributes: [
        {
          prefix: "o:",
          map: {
            spt: "75",
            preferrelative: "t"
          }
        }
      ],
      rawMap: {
        coordsize: "21600,21600",
        filled: "f",
        id: "_x0000_t75",
        path: "m@4@5l@4@11@9@11@9@5xe",
        stroked: "f"
      }
    },
    children: [_V(), UV(e), $V(), eb({ aspectratio: !0 })]
  };
}, Df = (e) => Math.floor((e ?? 0) * 0.74999943307122), YV = (e, t) => {
  const { width: s = 0, height: i = 0, altText: r } = e, n = Df(s), o = Df(i);
  return {
    name: "v:shape",
    properties: {
      rawMap: {
        id: e.headerFooterPosition,
        "o:spid": "_x0000_s1025",
        style: `position: absolute; margin-left: 0; margin-top: 10in; margin-bottom: 0; margin-right: 0; width: ${n}pt; height: ${o}pt; z-index: ${t + 1}`,
        type: "#_x0000_t75",
        alt: r
      }
    },
    children: [KV(e, t + 1), eb({ rotation: !0 })]
  };
}, XV = {
  getTemplate(e) {
    const t = Dr.get(e.sheetIndex) || [], s = [
      WV(),
      qV(),
      ...t.map((i, r) => YV(i, r))
    ];
    return {
      name: "xml",
      properties: {
        prefixedAttributes: [
          {
            prefix: "xmlns:",
            map: {
              v: "urn:schemas-microsoft-com:vml",
              o: "urn:schemas-microsoft-com:office:office",
              x: "urn:schemas-microsoft-com:office:excel"
            }
          }
        ]
      },
      children: s
    };
  }
}, ZV = XV, QV = {
  getTemplate(e, t) {
    const s = (t + 1).toString();
    return {
      name: "sheet",
      properties: {
        rawMap: {
          name: e,
          sheetId: s,
          "r:id": `rId${s}`
        }
      }
    };
  }
}, JV = QV, eN = {
  getTemplate(e) {
    return {
      name: "sheets",
      children: e.map((t, s) => JV.getTemplate(t, s))
    };
  }
}, tN = eN, sN = {
  getTemplate(e, t) {
    return {
      name: "workbook",
      properties: {
        prefixedAttributes: [
          {
            prefix: "xmlns:",
            map: {
              r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
            }
          }
        ],
        rawMap: {
          xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
        }
      },
      children: [
        {
          name: "bookViews",
          children: [
            {
              name: "workbookView",
              properties: {
                rawMap: {
                  activeTab: t
                }
              }
            }
          ]
        },
        tN.getTemplate(e)
      ]
    };
  }
}, iN = sN, rN = (e) => Math.ceil((e - 12) / 7 + 1), nN = {
  getTemplate(e) {
    const { min: t, max: s, outlineLevel: i, s: r, width: n, hidden: o, bestFit: a } = e;
    let l = 1, c = "0";
    return n > 1 && (l = rN(n), c = "1"), {
      name: "col",
      properties: {
        rawMap: {
          min: t,
          max: s,
          outlineLevel: i ?? void 0,
          width: l,
          style: r,
          hidden: o ? "1" : "0",
          bestFit: a ? "1" : "0",
          customWidth: c
        }
      }
    };
  }
}, oN = nN, aN = {
  getTemplate(e) {
    return {
      name: "mergeCell",
      properties: {
        rawMap: {
          ref: e
        }
      }
    };
  }
}, lN = aN, cN = (e) => {
  const t = e.charAt(0).toLowerCase();
  return t === "s" ? "inlineStr" : t;
}, dN = {
  getTemplate(e, t, s) {
    const { ref: i, data: r, styleId: n } = e, { type: o, value: a } = r || { type: "empty", value: null };
    let l = o;
    o === "f" ? l = "str" : o.charAt(0) === o.charAt(0).toUpperCase() && (l = cN(o));
    const c = {
      name: "c",
      properties: {
        rawMap: {
          r: i,
          t: l === "empty" ? void 0 : l,
          s: n ? xV(n, s) : void 0
        }
      }
    };
    if (l === "empty")
      return c;
    let d;
    return l === "str" && o === "f" ? d = [
      {
        name: "f",
        textNode: Ke(Su(a), !1)
      }
    ] : l === "inlineStr" ? d = [
      {
        name: "is",
        children: [
          {
            name: "t",
            textNode: Ke(Su(a), !1)
          }
        ]
      }
    ] : d = [
      {
        name: "v",
        textNode: a
      }
    ], Object.assign({}, c, { children: d });
  }
}, uN = dN, hN = (e, t) => {
  const s = [];
  let i = 0;
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    n.mergeAcross && (s.push({
      pos: r,
      excelPos: i
    }), i += n.mergeAcross), i++;
  }
  if (s.length)
    for (let r = s.length - 1; r >= 0; r--) {
      const n = [], o = e[s[r].pos];
      for (let a = 1; a <= o.mergeAcross; a++)
        n.push({
          ref: `${wn(s[r].excelPos + 1 + a)}${t + 1}`,
          styleId: o.styleId,
          data: { type: "empty", value: null }
        });
      n.length && e.splice(s[r].pos + 1, 0, ...n);
    }
}, pN = (e) => {
  var t;
  return ((t = e.data) == null ? void 0 : t.value) !== "" || e.styleId !== void 0;
}, gN = {
  getTemplate(e, t, s) {
    const { collapsed: i, hidden: r, height: n, outlineLevel: o, cells: a = [] } = e;
    hN(a, t);
    const l = a.filter(pN).map((c, d) => uN.getTemplate(c, d, s));
    return {
      name: "row",
      properties: {
        rawMap: {
          r: t + 1,
          collapsed: i ? "1" : "0",
          hidden: r ? "1" : "0",
          ht: n,
          customHeight: n != null ? "1" : "0",
          spans: "1:1",
          outlineLevel: o || void 0
        }
      },
      children: l
    };
  }
}, fN = gN, mN = (e, t, s) => {
  const i = [], r = [];
  e.forEach((a, l) => {
    const c = a.cells;
    let d = 0, u;
    c.forEach((h, p) => {
      const g = p + d + 1, f = wn(g), m = l + 1;
      if (h.mergeAcross) {
        d += h.mergeAcross;
        const w = wn(p + d + 1);
        i.push(`${f}${m}:${w}${m}`);
      }
      t[g - 1] || (t[g - 1] = {});
      const { collapsibleRanges: C } = h;
      C && C.forEach((w) => {
        r.push([g + w[0], g + w[1]]);
      }), u = t[g - 1], u.min = g, u.max = g, h.ref = `${f}${m}`;
    });
  }), r.sort((a, l) => a[0] !== l[0] ? a[0] - l[0] : l[1] - a[1]);
  const n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  return r.filter((a) => {
    const l = a.toString();
    return n.get(l) ? !1 : (n.set(l, !0), !0);
  }).forEach((a) => {
    const l = t.find((d) => d.min == a[0] && d.max == a[1]), c = o.get(a[0]);
    t.push({
      min: a[0],
      max: a[1],
      outlineLevel: s ? void 0 : c || 1,
      width: (l || { width: 100 }).width
    }), o.set(a[0], (c || 0) + 1);
  }), i;
}, CN = (e) => !e || e !== "Portrait" && e !== "Landscape" ? "portrait" : e.toLocaleLowerCase(), vN = (e) => {
  if (e == null)
    return 1;
  const s = [
    "Letter",
    "Letter Small",
    "Tabloid",
    "Ledger",
    "Legal",
    "Statement",
    "Executive",
    "A3",
    "A4",
    "A4 Small",
    "A5",
    "A6",
    "B4",
    "B5",
    "Folio",
    "Envelope",
    "Envelope DL",
    "Envelope C5",
    "Envelope B5",
    "Envelope C3",
    "Envelope C4",
    "Envelope C6",
    "Envelope Monarch",
    "Japanese Postcard",
    "Japanese Double Postcard"
  ].indexOf(e);
  return s === -1 ? 1 : s + 1;
}, wN = (e) => (Object.entries({
  "&[Page]": "&P",
  "&[Pages]": "&N",
  "&[Date]": "&D",
  "&[Time]": "&T",
  "&[Tab]": "&A",
  "&[Path]": "&Z",
  "&[File]": "&F",
  "&[Picture]": "&G"
}).forEach(([s, i]) => {
  e = e.replace(s, i);
}), e), yN = (e) => e === "Center" ? "C" : e === "Right" ? "R" : "L", bN = (e, t) => (t && (e += "&amp;&quot;", e += t.fontName || "Calibri", t.bold !== t.italic ? e += t.bold ? ",Bold" : ",Italic" : t.bold ? e += ",Bold Italic" : e += ",Regular", e += "&quot;", t.size && (e += `&amp;${t.size}`), t.strikeThrough && (e += "&amp;S"), t.underline && (e += `&amp;${t.underline === "Double" ? "E" : "U"}`), t.color && (e += `&amp;K${t.color.replace("#", "").toUpperCase()}`)), e), SN = (e, t, s) => e.reduce((i, r, n) => {
  const o = yN(r.position), a = bN(`${i}&amp;${o}`, r.font), l = ["Left", "Center", "Right"];
  r.position || (r.position = l[n]);
  const { image: c } = r;
  if (r.value === "&[Picture]" && c) {
    const d = `${o}${t}${s}`;
    jN(c, d);
  }
  return `${a}${Ke(wN(r.value))}`;
}, ""), xN = (e) => {
  const t = ["all", "first", "even"], s = [];
  return t.forEach((i) => {
    const r = e[i], n = i === "all" ? "odd" : i;
    if (r)
      for (const [o, a] of Object.entries(r)) {
        const l = `${o.charAt(0).toUpperCase()}${o.slice(1)}`, c = o[0].toUpperCase();
        if (a) {
          const d = i === "all" ? "" : i.toUpperCase();
          s.push({
            name: `${n}${l}`,
            properties: {
              rawMap: { "xml:space": "preserve" }
            },
            textNode: SN(a, c, d)
          });
        }
      }
  }), s;
}, RN = (e) => (t) => (e.length && t.children.push({
  name: "cols",
  children: e.map((s) => oN.getTemplate(s))
}), t), FN = (e, t) => (s) => (e.length && s.children.push({
  name: "sheetData",
  children: e.map((i, r) => fN.getTemplate(i, r, t))
}), s), PN = (e) => (t) => (e.length && t.children.push({
  name: "mergeCells",
  properties: {
    rawMap: {
      count: e.length
    }
  },
  children: e.map((s) => lN.getTemplate(s))
}), t), TN = (e) => (t) => {
  const { top: s = 0.75, right: i = 0.7, bottom: r = 0.75, left: n = 0.7, header: o = 0.3, footer: a = 0.3 } = e;
  return t.children.push({
    name: "pageMargins",
    properties: {
      rawMap: { bottom: r, footer: a, header: o, left: n, right: i, top: s }
    }
  }), t;
}, EN = (e) => (t) => (e && t.children.push({
  name: "pageSetup",
  properties: {
    rawMap: {
      horizontalDpi: 0,
      verticalDpi: 0,
      orientation: CN(e.orientation),
      paperSize: vN(e.pageSize)
    }
  }
}), t), DN = (e) => (t) => {
  if (!e)
    return t;
  const s = e.first != null ? 1 : 0, i = e.even != null ? 1 : 0;
  return t.children.push({
    name: "headerFooter",
    properties: {
      rawMap: {
        differentFirst: s,
        differentOddEven: i
      }
    },
    children: xN(e)
  }), t;
}, AN = (e) => (t) => (e && t.children.push({
  name: "tableParts",
  properties: {
    rawMap: {
      count: "1"
    }
  },
  children: [
    {
      name: "tablePart",
      properties: {
        rawMap: {
          "r:id": `rId${++t.rIdCounter}`
        }
      }
    }
  ]
}), t), MN = (e) => (t) => {
  const s = bn.get(e);
  return s != null && s.length && t.children.push({
    name: "drawing",
    properties: {
      rawMap: {
        "r:id": `rId${++t.rIdCounter}`
      }
    }
  }), t;
}, IN = (e) => (t) => (Dr.get(e) && t.children.push({
  name: "legacyDrawingHF",
  properties: {
    rawMap: {
      "r:id": `rId${++t.rIdCounter}`
    }
  }
}), t), LN = (e = 0, t = 0) => {
  const s = e > 0 || t > 0;
  return s ? [
    {
      name: "pane",
      properties: {
        rawMap: {
          state: s ? "frozen" : void 0,
          topLeftCell: s ? `${wn(e + 1)}${t + 1}` : void 0,
          xSplit: e === 0 ? void 0 : e,
          ySplit: t === 0 ? void 0 : t
        }
      }
    }
  ] : void 0;
}, kN = (e = !1, t, s) => (i) => (i.children.push({
  name: "sheetViews",
  children: [
    {
      name: "sheetView",
      properties: {
        rawMap: {
          rightToLeft: e === !0 ? "1" : "0",
          workbookViewId: "0"
        }
      },
      children: LN(t, s)
    }
  ]
}), i), ON = () => (e) => (e.children.push({
  name: "sheetPr",
  children: [
    {
      name: "outlinePr",
      properties: {
        rawMap: {
          summaryBelow: 0
        }
      }
    }
  ]
}), e), GN = (e) => (t) => {
  const s = e.reduce((i, r) => r.outlineLevel && r.outlineLevel > i ? r.outlineLevel : i, 0);
  return t.children.push({
    name: "sheetFormatPr",
    properties: {
      rawMap: {
        baseColWidth: 10,
        defaultRowHeight: 16,
        outlineLevelRow: s || void 0
      }
    }
  }), t;
}, BN = {
  getTemplate(e) {
    const { worksheet: t, currentSheet: s, config: i } = e, {
      margins: r = {},
      pageSetup: n,
      headerFooterConfig: o,
      suppressColumnOutline: a,
      rightToLeft: l,
      frozenRowCount: c,
      frozenColumnCount: d
    } = i, { table: u } = t, { rows: h, columns: p } = u, g = p && p.length ? mN(h, p, !!a) : [], f = Ki.get(s), { children: m } = [
      ON(),
      kN(l, d, c),
      GN(h),
      RN(p),
      FN(h, s + 1),
      PN(g),
      TN(r),
      EN(n),
      DN(o),
      MN(s),
      IN(s),
      AN(f)
    ].reduce((C, w) => w(C), { children: [], rIdCounter: 0 });
    return {
      name: "worksheet",
      properties: {
        prefixedAttributes: [
          {
            prefix: "xmlns:",
            map: {
              r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
            }
          }
        ],
        rawMap: {
          xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
        }
      },
      children: m
    };
  }
}, VN = BN, Jr = /* @__PURE__ */ new Map(), ji = [], yn = /* @__PURE__ */ new Map(), bn = /* @__PURE__ */ new Map(), Dr = /* @__PURE__ */ new Map(), io = /* @__PURE__ */ new Map(), ca = /* @__PURE__ */ new Map(), Ki = /* @__PURE__ */ new Map(), NN = "AG-GRID-TABLE", jh = "SINGLE_SHEET";
function HN() {
  return jh;
}
function zN(e) {
  jh = e;
}
function WN(e, t, s) {
  qN(t), RV(e, ji.length);
  const i = Object.assign({}, s);
  return s.exportAsExcelTable && (s.colModel.isPivotActive() && (Af("pivot mode"), i.exportAsExcelTable = !1), s.gos.get("masterDetail") && (Af("master/detail"), i.exportAsExcelTable = !1)), $N(t, i), cH(t, i);
}
function Af(e) {
  I(163, { featureName: e });
}
function _N(e) {
  return e.replace(/^[^a-zA-Z_]+/, "_").replace(/\s/g, "_").replace(/[^a-zA-Z0-9_]/g, "_");
}
function UN(e, t) {
  if (Ki.has(e)) {
    I(164);
    return;
  }
  Ki.set(e, t);
}
function $N(e, t) {
  const { exportAsExcelTable: s, prependContent: i, appendContent: r, colModel: n } = t;
  if (!s)
    return;
  const o = typeof s == "boolean" ? {} : s, {
    name: a,
    showColumnStripes: l,
    showRowStripes: c,
    showFilterButton: d,
    highlightFirstColumn: u,
    highlightLastColumn: h
  } = o, p = _N(a || NN), g = ji.length - 1, { table: f } = e, { rows: m, columns: C } = f, w = Lw(n), y = i ? i.length : 0, b = r ? r.length : 0, x = m.length, M = C.length, T = [], F = [];
  for (let k = 0; k < M; k++) {
    const O = C[k];
    T.push(O.displayName || ""), F.push(
      d === "match" || d === void 0 ? O.filterAllowed ?? !1 : d
    );
  }
  if (!T || !T.length || !x || !p) {
    I(165);
    return;
  }
  UN(g, {
    name: `table${Ki.size + 1}`,
    displayName: p,
    columns: T,
    showFilterButtons: F,
    rowRange: [w + y, w + (x - w) - b],
    showRowStripes: c ?? !0,
    showColumnStripes: l ?? !1,
    highlightFirstColumn: u ?? !1,
    highlightLastColumn: h ?? !1
  });
}
function jN(e, t) {
  const s = ji.length - 1, i = e;
  i.headerFooterPosition = t, tb({ imageToAdd: i, idx: s });
  let r = Dr.get(s);
  r || (r = [], Dr.set(s, r)), r.find((n) => n.id === e.id) || r.push(e);
}
function KN(e, t, s, i, r) {
  const n = ji.length, { row: o, column: a } = e.position || {}, l = e;
  i && (t != null && s != null && (!o || !a) && (e.position || (e.position = {}), e.position = Object.assign({}, e.position, {
    row: t,
    column: i.indexOf(s) + 1
  })), lB(l, i), cB(l, r)), tb({ imageToAdd: l, idx: n });
  let c = ca.get(n);
  c || (c = /* @__PURE__ */ new Map(), ca.set(n, c));
  const d = bn.get(n);
  d ? d.push(l) : bn.set(n, [l]), c.get(e.id) || c.set(e.id, { index: c.size, type: e.imageType });
}
function tb(e) {
  const { imageToAdd: t, idx: s } = e, i = yn.get(t.id);
  if (i) {
    const r = i.find((n) => n.sheetId === s);
    r ? r.image.push(t) : i.push({
      sheetId: s,
      image: [t]
    });
  } else
    yn.set(t.id, [{ sheetId: s, image: [t] }]), io.set(t.id, {
      type: t.imageType,
      index: io.size
    });
}
function qN(e) {
  const t = Ke(e.name) || "";
  let s = "";
  for (; ji.indexOf(`${t}${s}`) !== -1; )
    s === "" ? s = "_1" : s = `_${parseInt(s.slice(1), 10) + 1}`;
  e.name = `${t}${s}`, ji.push(e.name);
}
function Mf(e) {
  return Jr.has(e) ? Jr.get(e) : (Jr.set(e, Jr.size), Jr.size - 1);
}
function If() {
  Jr.clear(), yn.clear(), bn.clear(), Dr.clear(), io.clear(), ca.clear(), Ki.clear(), ji = [], jh = "SINGLE_SHEET";
}
function YN(e) {
  return as(iN.getTemplate(ji, e));
}
function XN(e) {
  return as(FV.getTemplate(e));
}
function ZN() {
  return as(AB.getTemplate(Jr));
}
function QN(e) {
  return as(mB.getTemplate(e));
}
function JN(e) {
  return as(gB.getTemplate(e));
}
function eH() {
  const e = wa.getTemplate([
    {
      Id: "rId1",
      Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
      Target: "xl/workbook.xml"
    },
    {
      Id: "rId2",
      Type: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
      Target: "docProps/core.xml"
    }
  ]);
  return as(e);
}
function tH() {
  return as(zV.getTemplate());
}
function sH(e, t) {
  return as(TV.getTemplate(e, t));
}
function iH(e) {
  const t = new Array(e).fill(void 0).map((i, r) => ({
    Id: `rId${r + 1}`,
    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
    Target: `worksheets/sheet${r + 1}.xml`
  })), s = wa.getTemplate([
    ...t,
    {
      Id: `rId${e + 1}`,
      Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
      Target: "theme/theme1.xml"
    },
    {
      Id: `rId${e + 2}`,
      Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
      Target: "styles.xml"
    },
    {
      Id: `rId${e + 3}`,
      Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
      Target: "sharedStrings.xml"
    }
  ]);
  return as(s);
}
function rH(e) {
  return as(FB.getTemplate({ sheetIndex: e }));
}
function nH(e) {
  const t = ca.get(e) || [], s = [];
  for (const [i, r] of t) {
    const { index: n, type: o } = r;
    s.push({
      Id: `rId${n + 1}`,
      Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
      Target: `../media/image${io.get(i).index + 1}.${Tc(o)}`
    });
  }
  return as(wa.getTemplate(s));
}
function oH(e) {
  return as(ZV.getTemplate({ sheetIndex: e }), !0);
}
function aH(e) {
  const t = Dr.get(e) || [], s = [];
  for (let i = 0; i < t.length; i++) {
    const r = t[i], n = io.get(r.id);
    if (!n)
      continue;
    const { index: o, type: a } = n;
    s.push({
      Id: `rId${i + 1}`,
      Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
      Target: `../media/image${o + 1}.${Tc(a)}`
    });
  }
  return as(wa.getTemplate(s));
}
function lH({
  drawingIndex: e,
  vmlDrawingIndex: t,
  tableName: s
} = {}) {
  if (e === void 0 && t === void 0 && s === void 0)
    return "";
  const i = [];
  e != null && i.push({
    Id: `rId${i.length + 1}`,
    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    Target: `../drawings/drawing${e + 1}.xml`
  }), t != null && i.push({
    Id: `rId${i.length + 1}`,
    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    Target: `../drawings/vmlDrawing${t + 1}.vml`
  }), s != null && i.push({
    Id: `rId${i.length + 1}`,
    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table",
    Target: `../tables/${s}.xml`
  });
  const r = wa.getTemplate(i);
  return as(r);
}
function cH(e, t) {
  return as(
    VN.getTemplate({
      worksheet: e,
      currentSheet: ji.length - 1,
      config: t
    })
  );
}
var dH = class extends wy {
  constructor(e) {
    super(e), this.mixedStyles = {}, this.mixedStyleCounter = 0, this.rows = [], this.frozenRowCount = 0, this.skipFrozenRows = !1, this.frozenColumnCount = 0, this.skipFrozenColumns = !1, this.config = Object.assign({}, e), this.stylesByIds = {}, this.config.baseExcelStyles.forEach((t) => {
      this.stylesByIds[t.id] = t;
    }), this.excelStyles = [...this.config.baseExcelStyles, { id: "_quotePrefix", quotePrefix: 1 }];
  }
  addCustomContent(e) {
    e.forEach((t) => {
      const s = this.rows.length + 1;
      let i;
      !this.config.suppressRowOutline && t.outlineLevel != null && (i = t.outlineLevel);
      const r = {
        height: ul(s, t.height || this.config.rowHeight),
        cells: (t.cells || []).map((n, o) => {
          var h, p;
          const a = this.addImage(s, this.columnsToExport[o], (h = n.data) == null ? void 0 : h.value);
          let l = null;
          n.styleId && (l = typeof n.styleId == "string" ? [n.styleId] : n.styleId);
          const c = this.getStyleId(l);
          if (a)
            return this.createCell(
              c,
              this.getDataTypeForValue(a.value),
              a.value == null ? "" : a.value
            );
          const d = ((p = n.data) == null ? void 0 : p.value) ?? "", u = this.getDataTypeForValue(d);
          return n.mergeAcross ? this.createMergedCell(c, u, d, n.mergeAcross) : this.createCell(c, u, d);
        }),
        outlineLevel: i
      };
      t.collapsed != null && (r.collapsed = t.collapsed), t.hidden != null && (r.hidden = t.hidden), this.rows.push(r);
    });
  }
  onNewHeaderGroupingRow() {
    const e = [], { freezeRows: t, headerRowHeight: s } = this.config;
    return this.rows.push({
      cells: e,
      height: ul(this.rows.length + 1, s)
    }), t && this.frozenRowCount++, {
      onColumn: (i, r, n, o, a) => {
        const l = this.config.styleLinker({
          rowType: "HEADER_GROUPING",
          rowIndex: 1,
          value: `grouping-${r}`,
          columnGroup: i
        });
        e.push({
          ...this.createMergedCell(
            this.getStyleId(l),
            this.getDataTypeForValue("string"),
            r,
            o
          ),
          collapsibleRanges: a
        });
      }
    };
  }
  onNewHeaderRow() {
    const { freezeRows: e, headerRowHeight: t } = this.config;
    return e && this.frozenRowCount++, this.onNewRow(this.onNewHeaderColumn, t);
  }
  onNewBodyRow(e) {
    const { freezeRows: t, rowHeight: s } = this.config;
    this.skipFrozenRows || (t === "headersAndPinnedRows" && (e == null ? void 0 : e.rowPinned) === "top" ? this.frozenRowCount++ : typeof t == "function" ? t({ ...this.gos.getGridCommonParams(), node: e }) ? this.frozenRowCount++ : this.skipFrozenRows = !0 : this.skipFrozenRows = !0);
    const i = this.onNewRow(this.onNewBodyColumn, s);
    return e && this.addRowOutlineIfNecessary(e), i;
  }
  prepare(e) {
    super.prepare(e), this.columnsToExport = [...e], this.cols = e.map((t, s) => this.convertColumnToExcel(t, s));
  }
  parse() {
    const e = this.rows.reduce((r, n) => Math.max(r, n.cells.length), 0);
    for (; this.cols.length < e; )
      this.cols.push(this.convertColumnToExcel(null, this.cols.length + 1));
    const { config: t } = this;
    let s;
    if (t.sheetName != null) {
      const { sheetName: r } = t, n = typeof r == "function" ? r(this.gos.getGridCommonParams()) : r;
      s = String(n).substring(0, 31);
    } else
      s = "ag-grid";
    const i = {
      name: s,
      table: {
        columns: this.cols,
        rows: this.rows
      }
    };
    return this.createExcel(i);
  }
  addRowOutlineIfNecessary(e) {
    const { gos: t, suppressRowOutline: s, rowGroupExpandState: i = "expanded" } = this.config;
    if (t.get("groupHideOpenParents") || s || e.level == null)
      return;
    const n = e.footer ? 1 : 0, o = pe(this.rows), a = Math.min(e.level + n, 7);
    if (o.outlineLevel = a, i === "expanded")
      return;
    const l = i === "collapsed";
    if (e.isExpandable()) {
      const c = !l && e.expanded;
      o.collapsed = !c;
    }
    o.hidden = // always show the node if there is no parent to be expanded
    !!e.parent && // or if it is a child of the root node
    e.parent.level !== -1 && (l || this.isAnyParentCollapsed(e.parent));
  }
  isAnyParentCollapsed(e) {
    for (; e && e.level !== -1; ) {
      if (!e.expanded)
        return !0;
      e = e.parent;
    }
    return !1;
  }
  convertColumnToExcel(e, t) {
    const s = this.config.columnWidth, r = (e ? this.extractHeaderValue(e) : void 0) ?? "", n = e ? e.isFilterAllowed() : !1;
    return s ? typeof s == "number" ? { width: s, displayName: r, filterAllowed: n } : { width: s({ column: e, index: t }), displayName: r, filterAllowed: n } : e ? { width: Math.max(e.getActualWidth(), 75), displayName: r, filterAllowed: n } : {
      displayName: r,
      filterAllowed: n
    };
  }
  onNewHeaderColumn(e, t) {
    return (s) => {
      const i = this.extractHeaderValue(s), r = this.config.styleLinker({
        rowType: "HEADER",
        rowIndex: e,
        value: i,
        column: s
      });
      t.push(
        this.createCell(this.getStyleId(r), this.getDataTypeForValue("string"), i)
      );
    };
  }
  onNewBodyColumn(e, t) {
    let s = 0;
    const { freezeColumns: i, rightToLeft: r } = this.config;
    return (n, o, a) => {
      if (s > 0) {
        s -= 1;
        return;
      }
      if (!this.skipFrozenColumns) {
        const g = n.getPinned();
        i === "pinned" && g && (g === !0 || g === "left") !== r ? this.frozenColumnCount++ : typeof i == "function" && i({ ...this.gos.getGridCommonParams(), column: n }) ? this.frozenColumnCount++ : this.skipFrozenColumns = !0;
      }
      const { value: l, valueFormatted: c } = this.extractRowCellValue(
        n,
        o,
        e,
        "excel",
        a
      ), d = this.config.styleLinker({
        rowType: "BODY",
        rowIndex: e,
        value: l,
        column: n,
        node: a
      }), u = this.getStyleId(d), h = n.getColSpan(a), p = this.addImage(e, n, l);
      p ? t.push(
        this.createCell(
          u,
          this.getDataTypeForValue(p.value),
          p.value == null ? "" : p.value
        )
      ) : h > 1 ? (s = h - 1, t.push(
        this.createMergedCell(
          u,
          this.getDataTypeForValue(l),
          l,
          h - 1
        )
      )) : t.push(
        this.createCell(u, this.getDataTypeForValue(l), l, c)
      );
    };
  }
  onNewRow(e, t) {
    const s = [];
    return this.rows.push({
      cells: s,
      height: ul(this.rows.length + 1, t)
    }), {
      onColumn: e.bind(this, this.rows.length, s)()
    };
  }
  createExcel(e) {
    const { excelStyles: t, config: s } = this;
    return this.frozenColumnCount && (s.frozenColumnCount = this.frozenColumnCount), this.frozenRowCount && (s.frozenRowCount = this.frozenRowCount), WN(t, e, s);
  }
  getDataTypeForValue(e) {
    return e === void 0 ? "empty" : this.isNumerical(e) ? "n" : "s";
  }
  getTypeFromStyle(e, t) {
    if (this.isFormula(t))
      return "f";
    if (e && e.dataType)
      switch (e.dataType.toLocaleLowerCase()) {
        case "formula":
          return "f";
        case "string":
          return "s";
        case "number":
          return "n";
        case "datetime":
          return "d";
        case "error":
          return "e";
        case "boolean":
          return "b";
        default:
          I(162, { id: e.id, dataType: e.dataType });
      }
    return null;
  }
  addImage(e, t, s) {
    if (!this.config.addImageToCell)
      return;
    const i = this.config.addImageToCell(e, t, s);
    if (i)
      return KN(i.image, e, t, this.columnsToExport, this.config.rowHeight), i;
  }
  createCell(e, t, s, i) {
    const r = this.getStyleById(e);
    !(r != null && r.dataType) && t === "s" && i && (s = i);
    const n = this.getTypeFromStyle(r, s) || t, { value: o, escaped: a } = this.getCellValue(n, s), l = [];
    return r && l.push(e), a && l.push("_quotePrefix"), e = this.getStyleId(l) || void 0, {
      styleId: e,
      data: {
        type: n,
        value: o
      }
    };
  }
  createMergedCell(e, t, s, i) {
    const r = s ?? "";
    return {
      styleId: this.getStyleById(e) ? e : void 0,
      data: {
        type: t,
        value: t === "s" ? Mf(r).toString() : s
      },
      mergeAcross: i
    };
  }
  getCellValue(e, t) {
    let s = !1;
    if (t == null || e === "s" && t === "")
      return { value: "", escaped: !1 };
    if (e === "s")
      t && t[0] === "'" && (s = !0, t = t.slice(1)), t = Mf(t).toString();
    else if (e === "f")
      t = t.slice(1);
    else if (e === "n") {
      const i = Number(t);
      isNaN(i) ? t = "" : t !== "" && (t = i.toString());
    }
    return { value: t, escaped: s };
  }
  getStyleId(e) {
    if (!e || !e.length)
      return null;
    if (e.length === 1)
      return e[0];
    const t = e.join("-");
    return this.mixedStyles[t] || this.addNewMixedStyle(e), this.mixedStyles[t].excelID;
  }
  deepCloneObject(e) {
    return JSON.parse(JSON.stringify(e));
  }
  addNewMixedStyle(e) {
    this.mixedStyleCounter += 1;
    const t = `mixedStyle${this.mixedStyleCounter}`, s = {};
    for (const r of e)
      for (const n of this.excelStyles)
        n.id === r && bt(s, this.deepCloneObject(n));
    s.id = t;
    const i = e.join("-");
    this.mixedStyles[i] = {
      excelID: t,
      key: i,
      result: s
    }, this.excelStyles.push(s), this.stylesByIds[t] = s;
  }
  isFormula(e) {
    return e == null ? !1 : this.config.autoConvertFormulas && e.toString().startsWith("=");
  }
  isNumerical(e) {
    return typeof e == "bigint" ? !0 : isFinite(e) && e !== "" && !isNaN(parseFloat(e));
  }
  getStyleById(e) {
    return e == null ? null : this.stylesByIds[e] || null;
  }
}, uH = async (e) => {
  let t = 0;
  const s = [], i = new WritableStream({
    write: (o) => {
      s.push(o), t += o.length;
    }
  }), r = new ReadableStream({
    start: (o) => {
      const a = new FileReader();
      a.onload = (l) => {
        var c;
        (c = l.target) != null && c.result && o.enqueue(l.target.result), o.close();
      }, a.readAsArrayBuffer(e);
    }
  }), n = new window.CompressionStream("deflate-raw");
  return await r.pipeThrough(n).pipeTo(i), {
    size: t,
    content: new Blob(s)
  };
}, hH = async (e) => {
  const t = new Blob([e]), { size: s, content: i } = await uH(t), r = new Uint8Array(await i.arrayBuffer());
  return {
    size: s,
    content: r
  };
}, pH = (e) => {
  let t = e.getHours();
  return t <<= 6, t = t | e.getMinutes(), t <<= 5, t = t | e.getSeconds() / 2, t;
}, gH = (e) => {
  let t = e.getFullYear() - 1980;
  return t <<= 4, t = t | e.getMonth() + 1, t <<= 5, t = t | e.getDate(), t;
};
function Kt(e, t) {
  let s = "";
  for (let i = 0; i < t; i++)
    s += String.fromCharCode(e & 255), e >>>= 8;
  return s;
}
var Lf = (e) => {
  if (!e.length)
    return 0;
  let t = -1, s = 0, i = 0, r = 0;
  for (let n = 0; n < e.length; n++)
    s = e[n], i = (t ^ s) & 255, r = fH[i], t = t >>> 8 ^ r;
  return t ^ -1;
}, kf = (e) => e.length ? Lf(typeof e == "string" ? new TextEncoder().encode(e) : e) : 0, fH = /* @__PURE__ */ new Uint32Array([
  0,
  1996959894,
  3993919788,
  2567524794,
  124634137,
  1886057615,
  3915621685,
  2657392035,
  249268274,
  2044508324,
  3772115230,
  2547177864,
  162941995,
  2125561021,
  3887607047,
  2428444049,
  498536548,
  1789927666,
  4089016648,
  2227061214,
  450548861,
  1843258603,
  4107580753,
  2211677639,
  325883990,
  1684777152,
  4251122042,
  2321926636,
  335633487,
  1661365465,
  4195302755,
  2366115317,
  997073096,
  1281953886,
  3579855332,
  2724688242,
  1006888145,
  1258607687,
  3524101629,
  2768942443,
  901097722,
  1119000684,
  3686517206,
  2898065728,
  853044451,
  1172266101,
  3705015759,
  2882616665,
  651767980,
  1373503546,
  3369554304,
  3218104598,
  565507253,
  1454621731,
  3485111705,
  3099436303,
  671266974,
  1594198024,
  3322730930,
  2970347812,
  795835527,
  1483230225,
  3244367275,
  3060149565,
  1994146192,
  31158534,
  2563907772,
  4023717930,
  1907459465,
  112637215,
  2680153253,
  3904427059,
  2013776290,
  251722036,
  2517215374,
  3775830040,
  2137656763,
  141376813,
  2439277719,
  3865271297,
  1802195444,
  476864866,
  2238001368,
  4066508878,
  1812370925,
  453092731,
  2181625025,
  4111451223,
  1706088902,
  314042704,
  2344532202,
  4240017532,
  1658658271,
  366619977,
  2362670323,
  4224994405,
  1303535960,
  984961486,
  2747007092,
  3569037538,
  1256170817,
  1037604311,
  2765210733,
  3554079995,
  1131014506,
  879679996,
  2909243462,
  3663771856,
  1141124467,
  855842277,
  2852801631,
  3708648649,
  1342533948,
  654459306,
  3188396048,
  3373015174,
  1466479909,
  544179635,
  3110523913,
  3462522015,
  1591671054,
  702138776,
  2966460450,
  3352799412,
  1504918807,
  783551873,
  3082640443,
  3233442989,
  3988292384,
  2596254646,
  62317068,
  1957810842,
  3939845945,
  2647816111,
  81470997,
  1943803523,
  3814918930,
  2489596804,
  225274430,
  2053790376,
  3826175755,
  2466906013,
  167816743,
  2097651377,
  4027552580,
  2265490386,
  503444072,
  1762050814,
  4150417245,
  2154129355,
  426522225,
  1852507879,
  4275313526,
  2312317920,
  282753626,
  1742555852,
  4189708143,
  2394877945,
  397917763,
  1622183637,
  3604390888,
  2714866558,
  953729732,
  1340076626,
  3518719985,
  2797360999,
  1068828381,
  1219638859,
  3624741850,
  2936675148,
  906185462,
  1090812512,
  3747672003,
  2825379669,
  829329135,
  1181335161,
  3412177804,
  3160834842,
  628085408,
  1382605366,
  3423369109,
  3138078467,
  570562233,
  1426400815,
  3317316542,
  2998733608,
  733239954,
  1555261956,
  3268935591,
  3050360625,
  752459403,
  1541320221,
  2607071920,
  3965973030,
  1969922972,
  40735498,
  2617837225,
  3943577151,
  1913087877,
  83908371,
  2512341634,
  3803740692,
  2075208622,
  213261112,
  2463272603,
  3855990285,
  2094854071,
  198958881,
  2262029012,
  4057260610,
  1759359992,
  534414190,
  2176718541,
  4139329115,
  1873836001,
  414664567,
  2282248934,
  4279200368,
  1711684554,
  285281116,
  2405801727,
  4167216745,
  1634467795,
  376229701,
  2685067896,
  3608007406,
  1308918612,
  956543938,
  2808555105,
  3495958263,
  1231636301,
  1047427035,
  2932959818,
  3654703836,
  1088359270,
  936918e3,
  2847714899,
  3736837829,
  1202900863,
  817233897,
  3183342108,
  3401237130,
  1404277552,
  615818150,
  3134207493,
  3453421203,
  1423857449,
  601450431,
  3009837614,
  3294710456,
  1567103746,
  711928724,
  3020668471,
  3272380065,
  1510334235,
  755167117
]);
function mH(e) {
  const t = String.fromCharCode;
  function s(u) {
    const h = [];
    if (!u)
      return [];
    const p = u.length;
    let g = 0, f, m;
    for (; g < p; )
      f = u.charCodeAt(g++), f >= 55296 && f <= 56319 && g < p ? (m = u.charCodeAt(g++), (m & 64512) == 56320 ? h.push(((f & 1023) << 10) + (m & 1023) + 65536) : (h.push(f), g--)) : h.push(f);
    return h;
  }
  function i(u) {
    if (u >= 55296 && u <= 57343)
      throw Error(Ws(255, { point: u }));
  }
  function r(u, h) {
    return t(u >> h & 63 | 128);
  }
  function n(u) {
    if (!(u & 4294967168))
      return t(u);
    let h = "";
    return u & 4294965248 ? u & 4294901760 ? u & 4292870144 || (h = t(u >> 18 & 7 | 240), h += r(u, 12), h += r(u, 6)) : (i(u), h = t(u >> 12 & 15 | 224), h += r(u, 6)) : h = t(u >> 6 & 31 | 192), h += t(u & 63 | 128), h;
  }
  const o = s(e), a = o.length;
  let l = -1, c, d = "";
  for (; ++l < a; )
    c = o[l], d += n(c);
  return d;
}
var sb = (e, t, s, i, r, n) => {
  const { content: o, path: a, created: l } = e, c = pH(l), d = gH(l), u = kf(r), h = n !== void 0 ? n : i, p = mH(a), g = p !== a;
  let f = "";
  if (g) {
    const y = Kt(1, 1) + Kt(kf(p), 4) + p;
    f = "up" + Kt(y.length, 2) + y;
  }
  const m = "\0" + // version needed to extract
  (g ? "\0\b" : "\0\0") + // Language encoding flag (EFS) (12th bit turned on)
  Kt(t ? 8 : 0, 2) + // As per ECMA-376 Part 2 specs
  Kt(c, 2) + // last modified time
  Kt(d, 2) + // last modified date
  Kt(h ? u : 0, 4) + Kt(n ?? i, 4) + // compressed size
  Kt(i, 4) + // uncompressed size
  Kt(p.length, 2) + // file name length
  Kt(f.length, 2), C = "PK" + m + p + f, w = "PK\0" + m + // file header
  "\0\0\0\0\0\0" + (o ? "\0\0\0\0" : "\0\0\0") + // external file attributes
  Kt(s, 4) + // relative offset of local header
  p + // file name
  f;
  return {
    localFileHeader: Uint8Array.from(C, (y) => y.charCodeAt(0)),
    centralDirectoryHeader: Uint8Array.from(w, (y) => y.charCodeAt(0))
  };
}, ib = (e) => {
  let t;
  if (typeof e == "string") {
    const s = atob(e.split(";base64,")[1]);
    t = Uint8Array.from(s, (i) => i.charCodeAt(0));
  } else
    t = e;
  return {
    size: t.length,
    content: t
  };
}, CH = async (e, t) => {
  const { content: s } = e, { size: i, content: r } = s ? ib(s) : { size: 0, content: Uint8Array.from([]) };
  let n, o, a = !1;
  if (e.type === "file" && r && i > 0) {
    const d = await hH(r);
    n = d.content, o = d.size, a = !0;
  }
  return {
    ...sb(e, a, t, i, r, o),
    content: n || r,
    isCompressed: a
  };
}, vH = (e, t) => {
  const { content: s } = e, { content: i } = s ? ib(s) : { content: Uint8Array.from([]) };
  return {
    ...sb(e, !1, t, i.length, i, void 0),
    content: i,
    isCompressed: !1
  };
}, wH = (e, t, s) => {
  const i = "PK\0\0\0\0" + Kt(e, 2) + // total number of entries in the central folder
  Kt(e, 2) + // total number of entries in the central folder
  Kt(t, 4) + // size of the central folder
  Kt(s, 4) + // central folder start offset
  "\0\0";
  return Uint8Array.from(i, (r) => r.charCodeAt(0));
}, rb = class {
  constructor() {
    this.folders = [], this.files = [];
  }
  addFolders(e) {
    e.forEach(this.addFolder.bind(this));
  }
  addFolder(e) {
    this.folders.push({
      path: e,
      created: /* @__PURE__ */ new Date(),
      isBase64: !1,
      type: "folder"
    });
  }
  addFile(e, t, s = !1) {
    this.files.push({
      path: e,
      created: /* @__PURE__ */ new Date(),
      content: s ? t : new TextEncoder().encode(t),
      isBase64: s,
      type: "file"
    });
  }
  async getZipFile(e = "application/zip") {
    const t = await this.buildCompressedFileStream();
    return this.clearStream(), new Blob([t], { type: e });
  }
  getUncompressedZipFile(e = "application/zip") {
    const t = this.buildFileStream();
    return this.clearStream(), new Blob([t], { type: e });
  }
  clearStream() {
    this.folders = [], this.files = [];
  }
  packageFiles(e) {
    let t = 0, s = 0;
    for (const c of e) {
      const { localFileHeader: d, centralDirectoryHeader: u, content: h } = c;
      t += d.length + h.length, s += u.length;
    }
    const i = new Uint8Array(t), r = new Uint8Array(s);
    let n = 0, o = 0;
    for (const c of e) {
      const { localFileHeader: d, centralDirectoryHeader: u, content: h } = c;
      i.set(d, n), n += d.length, i.set(h, n), n += h.length, r.set(u, o), o += u.length;
    }
    const a = wH(e.length, s, t), l = new Uint8Array(i.length + r.length + a.length);
    return l.set(i), l.set(r, i.length), l.set(a, i.length + r.length), l;
  }
  async buildCompressedFileStream() {
    const e = [...this.folders, ...this.files], t = [];
    let s = 0;
    for (const i of e) {
      const r = await CH(i, s), { localFileHeader: n, content: o } = r;
      t.push(r), s += n.length + o.length;
    }
    return this.packageFiles(t);
  }
  buildFileStream() {
    const e = [...this.folders, ...this.files], t = [];
    let s = 0;
    for (const i of e) {
      const r = vH(i, s), { localFileHeader: n, content: o } = r;
      t.push(r), s += n.length + o.length;
    }
    return this.packageFiles(t);
  }
}, yH = (e) => {
  if (e.addFolders(["_rels/", "docProps/", "xl/", "xl/theme/", "xl/_rels/", "xl/worksheets/"]), !yn.size)
    return;
  e.addFolders(["xl/worksheets/_rels", "xl/drawings/", "xl/drawings/_rels", "xl/media/"]);
  let t = 0;
  yn.forEach((s) => {
    const i = s[0].image[0], { base64: r, imageType: n } = i;
    e.addFile(`xl/media/image${++t}.${Tc(n)}`, r, !0);
  });
}, bH = (e, t) => {
  let s = 0, i = 0;
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    e.addFile(`xl/worksheets/sheet${r + 1}.xml`, n, !1);
    const o = yn.size > 0 && bn.has(r), a = Ki.size > 0 && Ki.get(r), l = yn.size && Dr.has(r);
    if (!o && !a && !l)
      continue;
    let c, d, u;
    o && (SH(e, r, s), d = s, s++), l && (xH(e, r, i), u = i, i++), a && (c = a.name);
    const h = `xl/worksheets/_rels/sheet${r + 1}.xml.rels`;
    e.addFile(
      h,
      lH({
        tableName: c,
        drawingIndex: d,
        vmlDrawingIndex: u
      })
    );
  }
}, SH = (e, t, s) => {
  const i = "xl/drawings", r = `${i}/drawing${s + 1}.xml`, n = `${i}/_rels/drawing${s + 1}.xml.rels`;
  e.addFile(n, nH(t)), e.addFile(r, rH(t));
}, xH = (e, t, s) => {
  const i = "xl/drawings", r = `${i}/vmlDrawing${s + 1}.vml`, n = `${i}/_rels/vmlDrawing${s + 1}.vml.rels`;
  e.addFile(r, oH(t)), e.addFile(n, aH(t));
}, RH = (e) => {
  const t = Ki, s = Array.from(t.keys());
  for (let i = 0; i < s.length; i++) {
    const r = s[i], n = t.get(r);
    n && e.addFile(`xl/tables/${n.name}.xml`, sH(n, i));
  }
}, FH = (e, t, s, i, r) => {
  e.addFile("xl/workbook.xml", YN(r)), e.addFile("xl/styles.xml", XN(t)), e.addFile("xl/sharedStrings.xml", ZN()), e.addFile("xl/theme/theme1.xml", tH()), e.addFile("xl/_rels/workbook.xml.rels", iH(i)), e.addFile("docProps/core.xml", QN(s)), e.addFile("[Content_Types].xml", JN(i)), e.addFile("_rels/.rels", eH());
}, nb = (e, t, s = {}) => {
  if (!t || t.length === 0)
    return I(159), If(), !1;
  const { fontSize: i = 11, author: r = "AG Grid", activeTab: n = 0 } = s, o = t.length, a = Math.max(Math.min(n, o - 1), 0);
  return yH(e), RH(e), bH(e, t), FH(e, i, r, o, a), If(), !0;
}, ob = (e) => {
  const { data: t, fontSize: s, author: i, activeSheetIndex: r } = e, n = e.mimeType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", o = new rb();
  return nb(o, t, {
    author: i,
    fontSize: s,
    activeTab: r
  }) ? o.getZipFile(n) : Promise.resolve(void 0);
}, Of = (e) => {
  const { data: t, fontSize: s, author: i, activeSheetIndex: r } = e, n = e.mimeType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", o = new rb();
  if (nb(o, t, {
    author: i,
    fontSize: s,
    activeTab: r
  }))
    return o.getUncompressedZipFile(n);
}, PH = (e) => {
  const { fileName: t = "export.xlsx" } = e;
  ob(e).then((s) => {
    if (s) {
      const i = typeof t == "function" ? t() : t;
      _h(i, s);
    }
  });
}, TH = class extends vy {
  constructor() {
    super(...arguments), this.beanName = "excelCreator";
  }
  getMergedParams(e) {
    const t = this.gos.get("defaultExcelExportParams");
    return Object.assign({}, t, e);
  }
  export(e) {
    if (this.isExportSuppressed()) {
      I(160);
      return;
    }
    const t = this.getMergedParams(e), i = {
      data: [this.getData(t)],
      fontSize: t.fontSize,
      author: t.author,
      mimeType: t.mimeType
    };
    this.packageCompressedFile(i).then((r) => {
      if (r) {
        const { fileName: n } = t, o = typeof n == "function" ? n(this.gos.getGridCommonParams()) : n;
        _h(this.getFileName(o), r);
      }
    });
  }
  exportDataAsExcel(e) {
    this.export(e);
  }
  getDataAsExcel(e) {
    const t = this.getMergedParams(e), i = {
      data: [this.getData(t)],
      fontSize: t.fontSize,
      author: t.author,
      mimeType: t.mimeType
    };
    return this.packageFile(i);
  }
  setFactoryMode(e) {
    zN(e);
  }
  getFactoryMode() {
    return HN();
  }
  getSheetDataForExcel(e) {
    const t = this.getMergedParams(e);
    return this.getData(t);
  }
  getMultipleSheetsAsExcel(e) {
    return Of(e);
  }
  exportMultipleSheetsAsExcel(e) {
    PH(e);
  }
  getDefaultFileExtension() {
    return "xlsx";
  }
  createSerializingSession(e) {
    const { colModel: t, colNames: s, rowGroupColsSvc: i, valueSvc: r, gos: n } = this.beans, o = {
      ...e,
      colModel: t,
      colNames: s,
      rowGroupColsSvc: i,
      valueSvc: r,
      gos: n,
      suppressRowOutline: e.suppressRowOutline || e.skipRowGroups,
      headerRowHeight: e.headerRowHeight || e.rowHeight,
      baseExcelStyles: n.get("excelStyles") || [],
      rightToLeft: e.rightToLeft ?? n.get("enableRtl"),
      styleLinker: this.styleLinker.bind(this)
    };
    return new dH(o);
  }
  styleLinker(e) {
    const { rowType: t, rowIndex: s, value: i, column: r, columnGroup: n, node: o } = e, a = t === "HEADER", l = t === "HEADER_GROUPING", c = a ? r : n;
    let d = [];
    const { gos: u, cellStyles: h } = this.beans;
    if (a || l)
      return d.push("header"), l && d.push("headerGroup"), c && (d = d.concat(
        Ch(
          c.getDefinition(),
          u,
          r || null,
          n || null
        )
      )), d;
    const p = u.get("excelStyles"), g = ["cell"];
    if (!p || !p.length)
      return g;
    const f = p.map((C) => C.id), m = r.getDefinition();
    return h == null || h.processAllCellClasses(
      m,
      u.addGridCommonParams({
        value: i,
        data: o.data,
        node: o,
        colDef: m,
        column: r,
        rowIndex: s
      }),
      (C) => {
        f.indexOf(C) > -1 && g.push(C);
      }
    ), g.sort((C, w) => f.indexOf(C) < f.indexOf(w) ? -1 : 1);
  }
  isExportSuppressed() {
    return this.gos.get("suppressExcelExport");
  }
  packageCompressedFile(e) {
    return ob(e);
  }
  packageFile(e) {
    return Of(e);
  }
}, Me = "33.0.4", Je = {
  moduleName: "EnterpriseCore",
  version: Me,
  beans: [iB],
  icons: {
    // accordion open (filter tool panel group, charts group)
    accordionOpen: "tree-open",
    // accordion closed (filter tool panel group, charts group)
    accordionClosed: "tree-closed",
    // accordion indeterminate - shown when some children are expanded and
    //     others are collapsed (filter tool panel group, charts group)
    accordionIndeterminate: "tree-indeterminate",
    // dialog title bar
    close: "cross",
    // X (remove) on column 'pill' after adding it to a drop zone list
    cancel: "cancel",
    // button in chart regular size window title bar (click to maximise)
    maximize: "maximize",
    // button in chart maximised window title bar (click to make regular size)
    minimize: "minimize",
    // drag handle used to pick up draggable columns
    columnDrag: "grip"
  },
  dependsOn: []
}, EH = (
  /*css*/
  '.ag-advanced-filter-header{align-items:center;background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);display:flex;padding-left:var(--ag-cell-horizontal-padding);padding-right:var(--ag-cell-horizontal-padding);position:relative}.ag-advanced-filter{align-items:center;display:flex;width:100%}.ag-advanced-filter-apply-button,.ag-advanced-filter-builder-button{line-height:normal;white-space:nowrap}:where(.ag-ltr) .ag-advanced-filter-apply-button,:where(.ag-ltr) .ag-advanced-filter-builder-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-advanced-filter-apply-button,:where(.ag-rtl) .ag-advanced-filter-builder-button{margin-right:calc(var(--ag-spacing)*2)}.ag-advanced-filter-builder-button{align-items:center;background-color:unset;border:0;display:flex;font-size:var(--ag-font-size);font-weight:600;padding:var(--ag-spacing);&:where(:not(:disabled)){cursor:pointer;&:hover{background-color:var(--ag-row-hover-color)}}}:where(.ag-ltr) .ag-advanced-filter-builder-button-label{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-advanced-filter-builder-button-label{margin-right:var(--ag-spacing)}.ag-advanced-filter-builder{display:flex;flex-direction:column;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.ag-advanced-filter-builder-list{flex:1;overflow:auto}.ag-advanced-filter-builder-button-panel{border-top:var(--ag-advanced-filter-builder-button-bar-border);display:flex;justify-content:flex-end;padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}:where(.ag-ltr) .ag-advanced-filter-builder-apply-button,:where(.ag-ltr) .ag-advanced-filter-builder-cancel-button{margin-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-advanced-filter-builder-apply-button,:where(.ag-rtl) .ag-advanced-filter-builder-cancel-button{margin-right:calc(var(--ag-spacing)*2)}.ag-advanced-filter-builder-item-wrapper{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;overflow:hidden}:where(.ag-ltr) .ag-advanced-filter-builder-item-wrapper{padding-left:calc(var(--ag-icon-size)/2);padding-right:var(--ag-icon-size)}:where(.ag-rtl) .ag-advanced-filter-builder-item-wrapper{padding-left:var(--ag-icon-size);padding-right:calc(var(--ag-icon-size)/2)}:where(.ag-virtual-list-viewport .ag-advanced-filter-builder-item-wrapper) .ag-tab-guard{position:absolute}.ag-advanced-filter-builder-item-tree-lines>*{width:var(--ag-advanced-filter-builder-indent-size)}.ag-advanced-filter-builder-item-tree-line-root{width:var(--ag-icon-size);&:before{height:50%;top:50%}}.ag-advanced-filter-builder-item-tree-line-horizontal,.ag-advanced-filter-builder-item-tree-line-vertical,.ag-advanced-filter-builder-item-tree-line-vertical-bottom,.ag-advanced-filter-builder-item-tree-line-vertical-top{align-items:center;display:flex;height:100%;position:relative;&:after,&:before{content:"";height:100%;position:absolute}}.ag-advanced-filter-builder-item-tree-line-horizontal:after{border-bottom:1px solid var(--ag-border-color);height:50%;top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size))}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-horizontal:after{left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-horizontal:after{right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical:before{top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical:before{border-left:1px solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical:before{border-right:1px solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical-top:before{height:50%;top:0;width:calc(var(--ag-advanced-filter-builder-indent-size) - var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical-top:before{border-left:1px solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical-top:before{border-right:1px solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{height:calc(50% - var(--ag-icon-size)*1.5/2);top:calc(50% + var(--ag-icon-size)*1.5/2);width:calc(var(--ag-icon-size)/2)}:where(.ag-ltr) .ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{border-left:1px solid var(--ag-border-color);left:calc(var(--ag-icon-size)/2)}:where(.ag-rtl) .ag-advanced-filter-builder-item-tree-line-vertical-bottom:before{border-right:1px solid var(--ag-border-color);right:calc(var(--ag-icon-size)/2)}.ag-advanced-filter-builder-item-condition{padding-bottom:var(--ag-spacing);padding-top:var(--ag-spacing)}.ag-advanced-filter-builder-item,.ag-advanced-filter-builder-item-buttons,.ag-advanced-filter-builder-item-condition,.ag-advanced-filter-builder-item-tree-lines,.ag-advanced-filter-builder-pill,.ag-advanced-filter-builder-pill-wrapper{align-items:center;display:flex;height:100%}.ag-advanced-filter-builder-pill-wrapper{margin:0 var(--ag-spacing)}.ag-advanced-filter-builder-pill{border-radius:var(--ag-border-radius);min-height:calc(100% - var(--ag-spacing)*3);min-width:calc(var(--ag-spacing)*2);padding:var(--ag-spacing) calc(var(--ag-spacing)*2);position:relative}:where(.ag-advanced-filter-builder-pill){.ag-advanced-filter-builder-value-number{font-family:monospace;font-weight:700}.ag-advanced-filter-builder-value-empty{color:var(--ag-subtle-text-color)}}:where(.ag-ltr) :where(.ag-advanced-filter-builder-pill){.ag-picker-field-display{margin-right:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-advanced-filter-builder-pill){.ag-picker-field-display{margin-left:var(--ag-spacing)}}.ag-advanced-filter-builder-pill-display{font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-advanced-filter-builder-join-pill{background-color:var(--ag-advanced-filter-builder-join-pill-color);cursor:pointer}.ag-advanced-filter-builder-column-pill{background-color:var(--ag-advanced-filter-builder-column-pill-color);cursor:pointer}.ag-advanced-filter-builder-option-pill{background-color:var(--ag-advanced-filter-builder-option-pill-color);cursor:pointer}.ag-advanced-filter-builder-value-pill{background-color:var(--ag-advanced-filter-builder-value-pill-color);cursor:text;max-width:140px;:where(.ag-advanced-filter-builder-pill-display){display:block}}.ag-advanced-filter-builder-item-buttons>*{margin:0 calc(var(--ag-spacing)*.5)}.ag-advanced-filter-builder-item-button{color:var(--ag-subtle-text-color);cursor:pointer;position:relative}.ag-advanced-filter-builder-item-button,.ag-advanced-filter-builder-pill{&:focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-advanced-filter-builder-item-button-disabled{cursor:default;opacity:.5}.ag-advanced-filter-builder-virtual-list-container{top:var(--ag-spacing)}.ag-advanced-filter-builder-virtual-list-item{cursor:default;display:flex;height:var(--ag-list-item-height);&:hover{background-color:var(--ag-row-hover-color);:where(.ag-advanced-filter-builder-item-button){opacity:1}}}.ag-advanced-filter-builder-invalid{color:var(--ag-invalid-color);cursor:default;margin:0 var(--ag-spacing)}:where(.ag-advanced-filter-builder-validation) .ag-advanced-filter-builder-invalid,:where(.ag-advanced-filter-builder-virtual-list-item-highlight) .ag-advanced-filter-builder-item-button:focus-visible{opacity:1}'
);
function DH(e) {
  var t;
  return ((t = e.filterManager) == null ? void 0 : t.getAdvFilterModel()) ?? null;
}
function AH(e, t) {
  var s;
  (s = e.filterManager) == null || s.setAdvFilterModel(t);
}
function MH(e) {
  var t;
  (t = e.filterManager) == null || t.toggleAdvFilterBuilder(!0, "api");
}
function IH(e) {
  var t;
  (t = e.filterManager) == null || t.toggleAdvFilterBuilder(!1, "api");
}
var LH = {
  ariaAdvancedFilterBuilderItem: (e) => `${e[0]}. Level ${e[1]}. Press ENTER to edit`,
  ariaAdvancedFilterBuilderItemValidation: (e) => `${e[0]}. Level ${e[1]}. ${e[2]} Press ENTER to edit`,
  ariaAdvancedFilterBuilderList: "Advanced Filter Builder List",
  ariaAdvancedFilterBuilderFilterItem: "Filter Condition",
  ariaAdvancedFilterBuilderGroupItem: "Filter Group",
  ariaAdvancedFilterBuilderColumn: "Column",
  ariaAdvancedFilterBuilderOption: "Option",
  ariaAdvancedFilterBuilderValue: "Value",
  ariaAdvancedFilterBuilderJoinOperator: "Join Operator",
  ariaAdvancedFilterInput: "Advanced Filter Input",
  ariaLabelAdvancedFilterAutocomplete: "Advanced Filter Autocomplete",
  advancedFilterContains: "contains",
  advancedFilterNotContains: "does not contain",
  advancedFilterTextEquals: "equals",
  advancedFilterTextNotEqual: "does not equal",
  advancedFilterStartsWith: "begins with",
  advancedFilterEndsWith: "ends with",
  advancedFilterBlank: "is blank",
  advancedFilterNotBlank: "is not blank",
  advancedFilterEquals: "=",
  advancedFilterNotEqual: "!=",
  advancedFilterGreaterThan: ">",
  advancedFilterGreaterThanOrEqual: ">=",
  advancedFilterLessThan: "<",
  advancedFilterLessThanOrEqual: "<=",
  advancedFilterTrue: "is true",
  advancedFilterFalse: "is false",
  advancedFilterAnd: "AND",
  advancedFilterOr: "OR",
  advancedFilterApply: "Apply",
  advancedFilterBuilder: "Builder",
  advancedFilterValidationMissingColumn: "Column is missing",
  advancedFilterValidationMissingOption: "Option is missing",
  advancedFilterValidationMissingValue: "Value is missing",
  advancedFilterValidationInvalidColumn: "Column not found",
  advancedFilterValidationInvalidOption: "Option not found",
  advancedFilterValidationMissingQuote: "Value is missing an end quote",
  advancedFilterValidationNotANumber: "Value is not a number",
  advancedFilterValidationInvalidDate: "Value is not a valid date",
  advancedFilterValidationMissingCondition: "Condition is missing",
  advancedFilterValidationJoinOperatorMismatch: "Join operators within a condition must be the same",
  advancedFilterValidationInvalidJoinOperator: "Join operator not found",
  advancedFilterValidationMissingEndBracket: "Missing end bracket",
  advancedFilterValidationExtraEndBracket: "Too many end brackets",
  advancedFilterValidationMessage: (e) => `Expression has an error. ${e[0]} - ${e[1]}.`,
  advancedFilterValidationMessageAtEnd: (e) => `Expression has an error. ${e[0]} at end of expression.`,
  advancedFilterBuilderTitle: "Advanced Filter",
  advancedFilterBuilderApply: "Apply",
  advancedFilterBuilderCancel: "Cancel",
  advancedFilterBuilderAddButtonTooltip: "Add Filter or Group",
  advancedFilterBuilderRemoveButtonTooltip: "Remove",
  advancedFilterBuilderMoveUpButtonTooltip: "Move Up",
  advancedFilterBuilderMoveDownButtonTooltip: "Move Down",
  advancedFilterBuilderAddJoin: "Add Group",
  advancedFilterBuilderAddCondition: "Add Filter",
  advancedFilterBuilderSelectColumn: "Select a column",
  advancedFilterBuilderSelectOption: "Select an option",
  advancedFilterBuilderEnterValue: "Enter a value...",
  advancedFilterBuilderValidationAlreadyApplied: "Current filter already applied.",
  advancedFilterBuilderValidationIncomplete: "Not all conditions are complete.",
  advancedFilterBuilderValidationSelectColumn: "Must select a column.",
  advancedFilterBuilderValidationSelectOption: "Must select an option.",
  advancedFilterBuilderValidationEnterValue: "Must enter a value."
};
function Fu(e, t, s) {
  if (!e)
    return "";
  const i = s - t;
  return i ? e.slice(0, e.length - i) : e;
}
function Sr(e, t, s, i, r, n, o) {
  const a = s + (!e.length || o ? 0 : 1);
  let l = 0;
  return r && (e[a] === " " ? l = 1 : (i += " ", n && (i += '"'))), { updatedValue: e.slice(0, t) + i + e.slice(a), updatedPosition: t + i.length + l };
}
function kH(e, t, s) {
  let i = t;
  for (; i < s && e[i] === " "; )
    i++;
  return i;
}
function Pu(e, t, s, i) {
  let r = t, n = !1;
  for (; r < e.length; ) {
    const o = e[r];
    if (o === "(") {
      i && e[r - 1] === " " ? n = !0 : r = r - 1;
      break;
    } else if (o === " " || s && o === ")") {
      r = r - 1;
      break;
    }
    r++;
  }
  return { endPosition: r, isEmpty: n };
}
function Kh(e, t, s, i) {
  s !== t && (e.expression = Sr(
    e.expression,
    i - t.length + 1,
    i,
    s
  ).updatedValue);
}
function OH(e) {
  return e.replace(/(['"])/, "\\$1");
}
var GH = class {
  constructor(e, t) {
    this.params = e, this.startPosition = t, this.type = "column", this.valid = !0, this.hasStartChar = !1, this.hasEndChar = !1, this.colName = "";
  }
  parse(e, t) {
    if (e === Tu && !this.colName)
      this.hasStartChar = !0;
    else if (e === Eu && this.hasStartChar) {
      if (this.parseColumn(!1, t))
        return this.hasEndChar = !0, !1;
      this.colName += e;
    } else
      this.colName += e;
  }
  getDisplayValue() {
    return (this.hasStartChar ? Tu : "") + this.colName + (this.hasEndChar ? Eu : "");
  }
  getColId() {
    return this.colId;
  }
  complete(e) {
    this.parseColumn(!0, e);
  }
  getValidationError() {
    return this.valid ? null : {
      message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidColumn"),
      startPosition: this.startPosition,
      endPosition: this.endPosition ?? this.params.expression.length - 1
    };
  }
  parseColumn(e, t) {
    var i;
    this.endPosition = t;
    const s = this.params.advFilterExpSvc.getColId(this.colName);
    return s && this.hasStartChar && (this.colId = s.colId, Kh(this.params, this.colName, s.columnName, t - 1), this.colName = s.columnName, this.column = this.params.colModel.getColDefCol(this.colId), this.column) ? (this.baseCellDataType = ((i = this.params.dataTypeSvc) == null ? void 0 : i.getBaseDataType(this.column)) ?? "text", !0) : (e && (this.valid = !1), this.baseCellDataType = "text", !1);
  }
}, BH = class {
  constructor(e, t, s) {
    this.params = e, this.startPosition = t, this.baseCellDataType = s, this.type = "operator", this.valid = !0, this.expectedNumOperands = 0, this.operator = "";
  }
  parse(e, t) {
    if (e === " " || e === ")") {
      if (this.parseOperator(!1, t - 1))
        return !0;
      this.operator += e;
    } else
      this.operator += e;
  }
  complete(e) {
    this.parseOperator(!0, e);
  }
  getValidationError() {
    return this.valid ? null : {
      message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidOption"),
      startPosition: this.startPosition,
      endPosition: this.endPosition ?? this.params.expression.length - 1
    };
  }
  getDisplayValue() {
    return this.operator;
  }
  getOperatorKey() {
    return this.parsedOperator;
  }
  parseOperator(e, t) {
    const s = this.params.advFilterExpSvc.getDataTypeExpressionOperator(this.baseCellDataType), i = s.findOperator(this.operator);
    if (this.endPosition = t, i) {
      this.parsedOperator = i;
      const n = s.operators[i];
      this.expectedNumOperands = n.numOperands;
      const o = n.displayValue;
      return Kh(this.params, this.operator, o, t), this.operator = o, !0;
    }
    return (e || !(i === null)) && (this.valid = !1), !1;
  }
}, VH = class {
  constructor(e, t, s, i) {
    this.params = e, this.startPosition = t, this.baseCellDataType = s, this.column = i, this.type = "operand", this.valid = !0, this.operand = "", this.validationMessage = null;
  }
  parse(e, t) {
    if (e === " ")
      if (this.quotes)
        this.operand += e;
      else
        return this.parseOperand(!1, t), !0;
    else if (e === ")") {
      if (this.baseCellDataType === "number" || !this.quotes)
        return this.parseOperand(!1, t - 1), !0;
      this.operand += e;
    } else if (!this.operand && !this.quotes && (e === "'" || e === '"'))
      this.quotes = e;
    else {
      if (this.quotes && e === this.quotes)
        return this.parseOperand(!1, t), !1;
      this.operand += e;
    }
  }
  complete(e) {
    this.parseOperand(!0, e);
  }
  getValidationError() {
    return this.validationMessage ? {
      message: this.validationMessage,
      startPosition: this.startPosition,
      endPosition: this.endPosition ?? this.params.expression.length - 1
    } : null;
  }
  getRawValue() {
    return this.operand;
  }
  getModelValue() {
    return this.modelValue;
  }
  parseOperand(e, t) {
    const { advFilterExpSvc: s } = this.params;
    if (this.endPosition = t, this.modelValue = this.operand, e && this.quotes)
      this.valid = !1, this.validationMessage = s.translate("advancedFilterValidationMissingQuote");
    else if (this.modelValue === "")
      this.valid = !1, this.validationMessage = s.translate("advancedFilterValidationMissingValue");
    else {
      const i = s.getOperandModelValue(this.operand, this.baseCellDataType, this.column);
      switch (i != null && (this.modelValue = i), this.baseCellDataType) {
        case "number":
          (this.quotes || isNaN(this.modelValue)) && (this.valid = !1, this.validationMessage = s.translate("advancedFilterValidationNotANumber"));
          break;
        case "date":
        case "dateString":
          i == null && (this.valid = !1, this.validationMessage = s.translate("advancedFilterValidationInvalidDate"));
          break;
      }
    }
  }
}, Tu = "[", Eu = "]", NH = class {
  constructor(e, t) {
    this.params = e, this.startPosition = t, this.isAwaiting = !0;
  }
  parseExpression() {
    var s, i;
    let e = this.startPosition;
    const { expression: t } = this.params;
    for (; e < t.length; ) {
      const r = t[e];
      if (!(r === " " && this.isAwaiting)) {
        if (this.isAwaiting = !1, !this.parser) {
          let o;
          this.columnParser ? this.operatorParser ? (this.operandParser = new VH(
            this.params,
            e,
            this.columnParser.baseCellDataType,
            this.columnParser.column
          ), o = this.operandParser) : (this.operatorParser = new BH(this.params, e, this.columnParser.baseCellDataType), o = this.operatorParser) : (this.columnParser = new GH(this.params, e), o = this.columnParser), this.parser = o;
        }
        const n = this.parser.parse(r, e);
        if (n != null) {
          if (this.isComplete())
            return this.returnEndPosition(n ? e - 1 : e, !0);
          this.parser = void 0, this.isAwaiting = !0;
        }
      }
      e++;
    }
    return (i = (s = this.parser) == null ? void 0 : s.complete) == null || i.call(s, e - 1), this.returnEndPosition(e);
  }
  isValid() {
    return this.isComplete() && this.columnParser.valid && this.operatorParser.valid && (!this.operandParser || this.operandParser.valid);
  }
  getValidationError() {
    var i, r, n;
    const e = ((i = this.columnParser) == null ? void 0 : i.getValidationError()) ?? ((r = this.operatorParser) == null ? void 0 : r.getValidationError()) ?? ((n = this.operandParser) == null ? void 0 : n.getValidationError());
    if (e)
      return e;
    const t = this.params.expression.length;
    let s;
    return this.columnParser ? this.operatorParser ? this.operatorParser.expectedNumOperands && !this.operandParser && (s = "advancedFilterValidationMissingValue") : s = "advancedFilterValidationMissingOption" : s = "advancedFilterValidationMissingColumn", s ? {
      message: this.params.advFilterExpSvc.translate(s),
      startPosition: t,
      endPosition: t
    } : null;
  }
  getFunctionString(e) {
    return this.getFunctionCommon(e, (t, s, i, r) => {
      const n = OH(i), o = t == null ? "" : `, params.operands[${t}]`;
      return `params.operators[${s}].evaluator(expressionProxy.getValue('${n}', node), node, params.evaluatorParams[${r}]${o})`;
    });
  }
  getFunctionParsed(e) {
    return this.getFunctionCommon(e, (t, s, i, r) => (n, o, a) => a.operators[s].evaluator(
      n.getValue(i, o),
      o,
      a.evaluatorParams[r],
      t == null ? void 0 : a.operands[t]
    ));
  }
  getAutocompleteListParams(e) {
    if (this.isColumnPosition(e))
      return this.getColumnAutocompleteListParams(e);
    if (this.isOperatorPosition(e))
      return this.getOperatorAutocompleteListParams(e);
    if (!this.isBeyondEndPosition(e))
      return { enabled: !1 };
  }
  updateExpression(e, t, s) {
    var r, n, o;
    const { expression: i } = this.params;
    if (this.isColumnPosition(e))
      return Sr(
        this.params.expression,
        this.startPosition,
        (r = this.columnParser) != null && r.getColId() ? this.columnParser.endPosition : Pu(i, e).endPosition,
        this.params.advFilterExpSvc.getColumnValue(t),
        !0
      );
    if (this.isOperatorPosition(e)) {
      const a = this.getBaseCellDataTypeFromOperatorAutocompleteType(s), l = this.hasOperand(a, t.key), c = l && this.doesOperandNeedQuotes(a);
      let d;
      if (((n = this.operatorParser) == null ? void 0 : n.startPosition) != null && e < this.operatorParser.startPosition)
        d = Sr(
          i,
          e,
          e,
          t.displayValue ?? t.key,
          l,
          c
        );
      else {
        let u, h = !1;
        if ((o = this.operatorParser) != null && o.getOperatorKey())
          u = this.operatorParser.endPosition;
        else {
          const { endPosition: p, isEmpty: g } = Pu(
            i,
            e,
            !0,
            !0
          );
          u = p, h = g;
        }
        d = Sr(
          i,
          kH(i, this.columnParser.endPosition + 1, u),
          u,
          t.displayValue ?? t.key,
          l,
          c,
          h
        );
      }
      return { ...d, hideAutocomplete: !l };
    }
    return null;
  }
  getModel() {
    const e = this.columnParser.getColId(), t = {
      filterType: this.columnParser.baseCellDataType,
      colId: e,
      type: this.operatorParser.getOperatorKey()
    };
    return this.operatorParser.expectedNumOperands && (t.filter = this.operandParser.getModelValue()), t;
  }
  getFunctionCommon(e, t) {
    var h, p;
    const s = this.columnParser.getColId(), i = (h = this.operatorParser) == null ? void 0 : h.getOperatorKey(), { operators: r, evaluatorParams: n, operands: o } = e, a = this.params.advFilterExpSvc.getExpressionOperator(
      this.columnParser.baseCellDataType,
      i
    ), l = this.addToListAndGetIndex(r, a), c = this.params.advFilterExpSvc.getExpressionEvaluatorParams(s), d = this.addToListAndGetIndex(n, c), u = ((p = this.operatorParser) == null ? void 0 : p.expectedNumOperands) === 0 ? void 0 : this.addToListAndGetIndex(o, this.getOperandValue());
    return t(u, l, s, d);
  }
  getOperandValue() {
    let e = this.operandParser.getRawValue();
    const { baseCellDataType: t, column: s } = this.columnParser;
    switch (t) {
      case "number":
        e = Number(e);
        break;
      case "date":
      case "dateString":
        e = this.params.valueSvc.parseValue(s, null, e, void 0);
        break;
    }
    if (t === "dateString") {
      const { dataTypeSvc: i } = this.params;
      return i ? i.getDateParserFunction(s)(e) : e;
    }
    return e;
  }
  isComplete() {
    return !!(this.operatorParser && (!this.operatorParser.expectedNumOperands || this.operatorParser.expectedNumOperands && this.operandParser));
  }
  isColumnPosition(e) {
    return !this.columnParser || this.columnParser.endPosition == null || e <= this.columnParser.endPosition + 1;
  }
  isOperatorPosition(e) {
    return !this.operatorParser || this.operatorParser.endPosition == null || e <= this.operatorParser.endPosition + 1;
  }
  isBeyondEndPosition(e) {
    return this.isComplete() && this.endPosition != null && e > this.endPosition + 1 && this.endPosition + 1 < this.params.expression.length;
  }
  returnEndPosition(e, t) {
    return this.endPosition = t ? e : e - 1, e;
  }
  getColumnAutocompleteListParams(e) {
    return this.params.advFilterExpSvc.generateAutocompleteListParams(
      this.params.advFilterExpSvc.getColumnAutocompleteEntries(),
      "column",
      this.getColumnSearchString(e)
    );
  }
  getColumnSearchString(e) {
    var n, o, a, l;
    const t = ((n = this.columnParser) == null ? void 0 : n.getDisplayValue()) ?? "", s = Fu(
      t,
      e,
      ((o = this.columnParser) == null ? void 0 : o.endPosition) == null ? this.params.expression.length : this.columnParser.endPosition + 1
    ), i = ((a = this.columnParser) == null ? void 0 : a.hasStartChar) && s.length > 0, r = ((l = this.columnParser) == null ? void 0 : l.hasEndChar) && s.length === t.length + 2;
    return i ? s.slice(1, r ? -1 : void 0) : s;
  }
  getOperatorAutocompleteListParams(e) {
    var r, n, o, a;
    const t = (r = this.columnParser) == null ? void 0 : r.column;
    if (!t)
      return { enabled: !1 };
    const s = this.columnParser.baseCellDataType, i = ((n = this.operatorParser) == null ? void 0 : n.startPosition) != null && e < this.operatorParser.startPosition ? "" : Fu(
      ((o = this.operatorParser) == null ? void 0 : o.getDisplayValue()) ?? "",
      e,
      ((a = this.operatorParser) == null ? void 0 : a.endPosition) == null ? this.params.expression.length : this.operatorParser.endPosition + 1
    );
    return this.params.advFilterExpSvc.generateAutocompleteListParams(
      this.params.advFilterExpSvc.getOperatorAutocompleteEntries(t, s),
      `operator-${s}`,
      i
    );
  }
  getBaseCellDataTypeFromOperatorAutocompleteType(e) {
    return e == null ? void 0 : e.replace("operator-", "");
  }
  hasOperand(e, t) {
    var s;
    return !e || !t || (((s = this.params.advFilterExpSvc.getExpressionOperator(e, t)) == null ? void 0 : s.numOperands) ?? 0) > 0;
  }
  doesOperandNeedQuotes(e) {
    return e !== "number";
  }
  addToListAndGetIndex(e, t) {
    const s = e.length;
    return e.push(t), s;
  }
};
function Ec(e, t, s) {
  let i = !1;
  const r = e.toLocaleLowerCase(), n = r + " ", o = Object.entries(t).find(([, a]) => {
    const l = s(a).toLocaleLowerCase();
    return l.startsWith(n) && (i = !0), l === r;
  });
  return o ? o[0] : i ? null : void 0;
}
function qh(e, t) {
  return (t ?? Object.keys(e)).map((i) => ({
    key: i,
    displayValue: e[i].displayValue
  }));
}
var Gf = class {
  constructor(e) {
    this.params = e, this.initOperators();
  }
  getEntries(e) {
    return qh(this.operators, e);
  }
  findOperator(e) {
    return Ec(e, this.operators, ({ displayValue: t }) => t);
  }
  initOperators() {
    const { translate: e } = this.params;
    this.operators = {
      contains: {
        displayValue: e("advancedFilterContains"),
        evaluator: (t, s, i, r) => this.evaluateExpression(t, s, i, r, !1, (n, o) => n.includes(o)),
        numOperands: 1
      },
      notContains: {
        displayValue: e("advancedFilterNotContains"),
        evaluator: (t, s, i, r) => this.evaluateExpression(t, s, i, r, !0, (n, o) => !n.includes(o)),
        numOperands: 1
      },
      equals: {
        displayValue: e("advancedFilterTextEquals"),
        evaluator: (t, s, i, r) => this.evaluateExpression(t, s, i, r, !1, (n, o) => n === o),
        numOperands: 1
      },
      notEqual: {
        displayValue: e("advancedFilterTextNotEqual"),
        evaluator: (t, s, i, r) => this.evaluateExpression(t, s, i, r, !0, (n, o) => n != o),
        numOperands: 1
      },
      startsWith: {
        displayValue: e("advancedFilterStartsWith"),
        evaluator: (t, s, i, r) => this.evaluateExpression(t, s, i, r, !1, (n, o) => n.startsWith(o)),
        numOperands: 1
      },
      endsWith: {
        displayValue: e("advancedFilterEndsWith"),
        evaluator: (t, s, i, r) => this.evaluateExpression(t, s, i, r, !1, (n, o) => n.endsWith(o)),
        numOperands: 1
      },
      blank: {
        displayValue: e("advancedFilterBlank"),
        evaluator: (t) => t == null || typeof t == "string" && t.trim().length === 0,
        numOperands: 0
      },
      notBlank: {
        displayValue: e("advancedFilterNotBlank"),
        evaluator: (t) => t != null && (typeof t != "string" || t.trim().length > 0),
        numOperands: 0
      }
    };
  }
  evaluateExpression(e, t, s, i, r, n) {
    return e == null ? r : s.caseSensitive ? n(s.valueConverter(e, t), i) : n(s.valueConverter(e, t).toLocaleLowerCase(), i.toLocaleLowerCase());
  }
}, Id = class {
  constructor(e) {
    this.params = e, this.initOperators();
  }
  getEntries(e) {
    return qh(this.operators, e);
  }
  findOperator(e) {
    return Ec(e, this.operators, ({ displayValue: t }) => t);
  }
  initOperators() {
    const { translate: e, equals: t } = this.params;
    this.operators = {
      equals: {
        displayValue: e("advancedFilterEquals"),
        evaluator: (s, i, r, n) => this.evaluateSingleOperandExpression(
          s,
          i,
          r,
          n,
          !!r.includeBlanksInEquals,
          t
        ),
        numOperands: 1
      },
      notEqual: {
        displayValue: e("advancedFilterNotEqual"),
        evaluator: (s, i, r, n) => this.evaluateSingleOperandExpression(
          s,
          i,
          r,
          n,
          !!r.includeBlanksInEquals,
          (o, a) => !t(o, a)
        ),
        numOperands: 1
      },
      greaterThan: {
        displayValue: e("advancedFilterGreaterThan"),
        evaluator: (s, i, r, n) => this.evaluateSingleOperandExpression(
          s,
          i,
          r,
          n,
          !!r.includeBlanksInGreaterThan,
          (o, a) => o > a
        ),
        numOperands: 1
      },
      greaterThanOrEqual: {
        displayValue: e("advancedFilterGreaterThanOrEqual"),
        evaluator: (s, i, r, n) => this.evaluateSingleOperandExpression(
          s,
          i,
          r,
          n,
          !!r.includeBlanksInGreaterThan,
          (o, a) => o >= a
        ),
        numOperands: 1
      },
      lessThan: {
        displayValue: e("advancedFilterLessThan"),
        evaluator: (s, i, r, n) => this.evaluateSingleOperandExpression(
          s,
          i,
          r,
          n,
          !!r.includeBlanksInLessThan,
          (o, a) => o < a
        ),
        numOperands: 1
      },
      lessThanOrEqual: {
        displayValue: e("advancedFilterLessThanOrEqual"),
        evaluator: (s, i, r, n) => this.evaluateSingleOperandExpression(
          s,
          i,
          r,
          n,
          !!r.includeBlanksInLessThan,
          (o, a) => o <= a
        ),
        numOperands: 1
      },
      blank: {
        displayValue: e("advancedFilterBlank"),
        evaluator: (s) => s == null,
        numOperands: 0
      },
      notBlank: {
        displayValue: e("advancedFilterNotBlank"),
        evaluator: (s) => s != null,
        numOperands: 0
      }
    };
  }
  evaluateSingleOperandExpression(e, t, s, i, r, n) {
    return e == null ? r : n(s.valueConverter(e, t), i);
  }
}, HH = class {
  constructor(e) {
    this.params = e, this.initOperators();
  }
  getEntries(e) {
    return qh(this.operators, e);
  }
  findOperator(e) {
    return Ec(e, this.operators, ({ displayValue: t }) => t);
  }
  initOperators() {
    const { translate: e } = this.params;
    this.operators = {
      true: {
        displayValue: e("advancedFilterTrue"),
        evaluator: (t) => !!t,
        numOperands: 0
      },
      false: {
        displayValue: e("advancedFilterFalse"),
        evaluator: (t) => t === !1,
        numOperands: 0
      },
      blank: {
        displayValue: e("advancedFilterBlank"),
        evaluator: (t) => t == null,
        numOperands: 0
      },
      notBlank: {
        displayValue: e("advancedFilterNotBlank"),
        evaluator: (t) => t != null,
        numOperands: 0
      }
    };
  }
}, zH = class extends L {
  constructor() {
    super(...arguments), this.beanName = "advFilterExpSvc", this.columnNameToIdMap = {}, this.columnAutocompleteEntries = null, this.expressionEvaluatorParams = {};
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc, this.colModel = e.colModel, this.colNames = e.colNames, this.dataTypeSvc = e.dataTypeSvc;
  }
  postConstruct() {
    this.expressionJoinOperators = this.generateExpressionJoinOperators(), this.expressionOperators = this.generateExpressionOperators();
  }
  parseJoinOperator(e) {
    const { type: t } = e;
    return this.expressionJoinOperators[t] ?? t;
  }
  getColumnDisplayValue(e) {
    const { colId: t } = e, i = this.getColumnAutocompleteEntries().find(({ key: n }) => n === t);
    let r;
    return i ? (r = i.displayValue, this.columnNameToIdMap[r.toLocaleUpperCase()] = { colId: t, columnName: r }) : r = t, r;
  }
  getOperatorDisplayValue(e) {
    var t;
    return ((t = this.getExpressionOperator(e.filterType, e.type)) == null ? void 0 : t.displayValue) ?? e.type;
  }
  getOperandModelValue(e, t, s) {
    switch (t) {
      case "number":
        return W(e) ? Number(e) : null;
      case "date":
        return ys(this.valueSvc.parseValue(s, null, e, void 0), !1);
      case "dateString": {
        const i = this.valueSvc.parseValue(s, null, e, void 0);
        return this.dataTypeSvc ? ys(this.dataTypeSvc.getDateParserFunction(s)(i) ?? null, !1) : i;
      }
    }
    return e;
  }
  getOperandDisplayValue(e, t) {
    var o;
    const { colId: s, filter: i } = e, r = this.colModel.getColDefCol(s);
    let n = "";
    if (i != null) {
      let a;
      switch (e.filterType) {
        case "number":
          a = Cs(i) ?? "";
          break;
        case "date": {
          const l = Yt(i);
          a = r ? this.valueSvc.formatValue(r, null, l) : null;
          break;
        }
        case "dateString": {
          let l;
          if (this.dataTypeSvc) {
            const c = Yt(i);
            l = r ? (o = this.dataTypeSvc) == null ? void 0 : o.getDateFormatterFunction(r)(c ?? void 0) : null;
          } else
            l = i;
          a = r ? this.valueSvc.formatValue(r, null, l) : null;
          break;
        }
      }
      e.filterType !== "number" && (a = a ?? Cs(i) ?? "", t || (a = `"${a}"`)), n = t ? a : ` ${a}`;
    }
    return n;
  }
  parseColumnFilterModel(e) {
    const t = this.getColumnDisplayValue(e) ?? "", s = this.getOperatorDisplayValue(e) ?? "", i = this.getOperandDisplayValue(e);
    return `[${t}] ${s}${i}`;
  }
  updateAutocompleteCache(e, t) {
    if (t === "column") {
      const { key: s, displayValue: i } = e;
      this.columnNameToIdMap[e.displayValue.toLocaleUpperCase()] = {
        colId: s,
        columnName: i
      };
    }
  }
  translate(e, t) {
    let s = LH[e];
    return typeof s == "function" && (s = s(t)), this.getLocaleTextFunc()(e, s, t);
  }
  generateAutocompleteListParams(e, t, s) {
    return {
      enabled: !0,
      type: t,
      searchString: s,
      entries: e
    };
  }
  getColumnAutocompleteEntries() {
    if (this.columnAutocompleteEntries)
      return this.columnAutocompleteEntries;
    const e = this.colModel.getColDefCols() ?? [], t = [], s = this.gos.get("includeHiddenColumnsInAdvancedFilter");
    return e.forEach((i) => {
      i.getColDef().filter && (s || i.isVisible() || i.isRowGroupActive()) && t.push({
        key: i.getColId(),
        displayValue: this.colNames.getDisplayNameForColumn(i, "advancedFilter")
      });
    }), t.sort((i, r) => {
      const n = i.displayValue ?? "", o = r.displayValue ?? "";
      return n < o ? -1 : o > n ? 1 : 0;
    }), t;
  }
  getOperatorAutocompleteEntries(e, t) {
    const s = this.getActiveOperators(e);
    return this.getDataTypeExpressionOperator(t).getEntries(s);
  }
  getJoinOperatorAutocompleteEntries() {
    return Object.entries(this.expressionJoinOperators).map(([e, t]) => ({ key: e, displayValue: t }));
  }
  getDefaultAutocompleteListParams(e) {
    return this.generateAutocompleteListParams(this.getColumnAutocompleteEntries(), "column", e);
  }
  getDataTypeExpressionOperator(e) {
    return this.expressionOperators[e];
  }
  getExpressionOperator(e, t) {
    var s, i;
    return (i = (s = this.getDataTypeExpressionOperator(e)) == null ? void 0 : s.operators) == null ? void 0 : i[t];
  }
  getExpressionJoinOperators() {
    return this.expressionJoinOperators;
  }
  getColId(e) {
    const t = e.toLocaleUpperCase(), s = this.columnNameToIdMap[t];
    if (s)
      return s;
    const r = this.getColumnAutocompleteEntries().find(
      ({ displayValue: n }) => n.toLocaleUpperCase() === t
    );
    if (r) {
      const { key: n, displayValue: o } = r, a = { colId: n, columnName: o };
      return this.columnNameToIdMap[t] = a, a;
    }
    return null;
  }
  getExpressionEvaluatorParams(e) {
    var n, o;
    let t = this.expressionEvaluatorParams[e];
    if (t)
      return t;
    const s = this.colModel.getColDefCol(e);
    if (!s)
      return { valueConverter: (a) => a };
    switch ((n = this.dataTypeSvc) == null ? void 0 : n.getBaseDataType(s)) {
      case "dateString":
        t = {
          valueConverter: ((o = this.dataTypeSvc) == null ? void 0 : o.getDateParserFunction(s)) ?? ((a) => a)
        };
        break;
      case "object":
        s.getColDef().filterValueGetter ? t = { valueConverter: (a) => a } : t = {
          valueConverter: (a, l) => this.valueSvc.formatValue(s, l, a) ?? (typeof a.toString == "function" ? a.toString() : "")
        };
        break;
      case "text":
      case void 0:
        t = { valueConverter: (a) => Cs(a) };
        break;
      default:
        t = { valueConverter: (a) => a };
        break;
    }
    const { filterParams: r } = s.getColDef();
    return r && ["caseSensitive", "includeBlanksInEquals", "includeBlanksInLessThan", "includeBlanksInGreaterThan"].forEach(
      (a) => {
        const l = r[a];
        l && (t[a] = l);
      }
    ), this.expressionEvaluatorParams[e] = t, t;
  }
  getColumnDetails(e) {
    var i;
    const t = this.colModel.getColDefCol(e) ?? void 0, s = (t ? (i = this.dataTypeSvc) == null ? void 0 : i.getBaseDataType(t) : void 0) ?? "text";
    return { column: t, baseCellDataType: s };
  }
  generateExpressionOperators() {
    const e = (t, s) => this.translate(t, s);
    return {
      text: new Gf({ translate: e }),
      boolean: new HH({ translate: e }),
      object: new Gf({ translate: e }),
      number: new Id({ translate: e, equals: (t, s) => t === s }),
      date: new Id({
        translate: e,
        equals: (t, s) => t.getTime() === s.getTime()
      }),
      dateString: new Id({
        translate: e,
        equals: (t, s) => t.getTime() === s.getTime()
      })
    };
  }
  getColumnValue({ displayValue: e }) {
    return `${Tu}${e}${Eu}`;
  }
  generateExpressionJoinOperators() {
    return {
      AND: this.translate("advancedFilterAnd"),
      OR: this.translate("advancedFilterOr")
    };
  }
  getActiveOperators(e) {
    var i;
    const t = (i = e.getColDef().filterParams) == null ? void 0 : i.filterOptions;
    return t && t.every((r) => typeof r == "string") ? t : void 0;
  }
  resetColumnCaches() {
    this.columnAutocompleteEntries = null, this.columnNameToIdMap = {}, this.expressionEvaluatorParams = {};
  }
}, WH = (
  /*css*/
  ".ag-panel{background-color:var(--ag-panel-background-color);display:flex;flex-direction:column;overflow:hidden;position:relative}.ag-dialog{border:var(--ag-dialog-border);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dialog-shadow);position:absolute}.ag-panel-title-bar{align-items:center;background-color:var(--ag-panel-title-bar-background-color);border-bottom:var(--ag-panel-title-bar-border);color:var(--ag-header-text-color);cursor:default;display:flex;flex:none;height:var(--ag-header-height);padding:var(--ag-spacing) var(--ag-cell-horizontal-padding)}.ag-panel-title-bar-button{cursor:pointer}:where(.ag-ltr) .ag-panel-title-bar-button{margin-left:calc(var(--ag-spacing)*2);margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-panel-title-bar-button{margin-left:var(--ag-spacing);margin-right:calc(var(--ag-spacing)*2)}.ag-panel-title-bar-title{color:var(--ag-header-text-color);flex:1 1 auto;font-weight:500}.ag-panel-title-bar-buttons{display:flex}.ag-panel-content-wrapper{display:flex;flex:1 1 auto;overflow:hidden;position:relative}:where(.ag-dragging-fill-handle) .ag-dialog,:where(.ag-dragging-range-handle) .ag-dialog{opacity:.7;pointer-events:none}"
);
function _H(e) {
  const t = e.cssIdentifier || "default";
  return (
    /* html */
    `<div class="ag-panel ag-${t}-panel" tabindex="-1">
        <div data-ref="eTitleBar" class="ag-panel-title-bar ag-${t}-panel-title-bar ag-unselectable">
            <span data-ref="eTitle" class="ag-panel-title-bar-title ag-${t}-panel-title-bar-title"></span>
            <div data-ref="eTitleBarButtons" class="ag-panel-title-bar-buttons ag-${t}-panel-title-bar-buttons"></div>
        </div>
        <div data-ref="eContentWrapper" class="ag-panel-content-wrapper ag-${t}-panel-content-wrapper"></div>
    </div>`
  );
}
var UH = (
  /* html */
  '<div class="ag-button"></div>'
), ab = class extends _ {
  constructor(e) {
    super(_H(e)), this.config = e, this.closable = !0, this.eContentWrapper = E, this.eTitleBar = E, this.eTitleBarButtons = E, this.eTitle = E, this.registerCSS(WH);
  }
  postConstruct() {
    const {
      component: e,
      closable: t,
      hideTitleBar: s,
      title: i,
      minWidth: r = 250,
      width: n,
      minHeight: o = 250,
      height: a,
      centered: l,
      popup: c,
      x: d,
      y: u
    } = this.config;
    this.positionableFeature = new mc(this.getGui(), {
      minWidth: r,
      width: n,
      minHeight: o,
      height: a,
      centered: l,
      x: d,
      y: u,
      popup: c,
      calculateTopBuffer: () => this.positionableFeature.getHeight() - this.getBodyHeight()
    }), this.createManagedBean(this.positionableFeature);
    const h = this.getGui();
    e && this.setBodyComponent(e), s ? re(this.eTitleBar, !1) : (i && this.setTitle(i), this.setClosable(t ?? this.closable)), this.addManagedElementListeners(this.eTitleBar, {
      mousedown: (p) => {
        if (h.contains(p.relatedTarget) || h.contains(Ie(this.beans)) || this.eTitleBarButtons.contains(p.target)) {
          p.preventDefault();
          return;
        }
        const g = this.eContentWrapper.querySelector(
          "button, [href], input, select, textarea, [tabindex]"
        );
        g && g.focus();
      }
    }), !(c && this.positionableFeature.isPositioned()) && (this.renderComponent && this.renderComponent(), this.positionableFeature.initialisePosition(), this.eContentWrapper.style.height = "0");
  }
  renderComponent() {
    const e = this.getGui();
    e.focus(), this.close = () => {
      e.parentElement.removeChild(e), this.destroy();
    };
  }
  getHeight() {
    return this.positionableFeature.getHeight();
  }
  setHeight(e) {
    this.positionableFeature.setHeight(e);
  }
  getWidth() {
    return this.positionableFeature.getWidth();
  }
  setWidth(e) {
    this.positionableFeature.setWidth(e);
  }
  setClosable(e) {
    if (e !== this.closable && (this.closable = e), e) {
      const t = this.closeButtonComp = new _(UH);
      this.createBean(t);
      const s = t.getGui(), i = ue("close", this.beans);
      i.classList.add("ag-panel-title-bar-button-icon"), s.appendChild(i), this.addTitleBarButton(t), t.addManagedElementListeners(s, { click: this.onBtClose.bind(this) });
    } else if (this.closeButtonComp) {
      const t = this.closeButtonComp.getGui();
      t.parentElement.removeChild(t), this.closeButtonComp = this.destroyBean(this.closeButtonComp);
    }
  }
  setBodyComponent(e) {
    e.setParentComponent(this), this.eContentWrapper.appendChild(e.getGui());
  }
  addTitleBarButton(e, t) {
    const s = this.eTitleBarButtons, i = s.children, r = i.length;
    t == null && (t = r), t = Math.max(0, Math.min(t, r)), e.addCssClass("ag-panel-title-bar-button");
    const n = e.getGui();
    t === 0 ? s.insertAdjacentElement("afterbegin", n) : t === r ? s.insertAdjacentElement("beforeend", n) : i[t - 1].insertAdjacentElement("afterend", n), e.setParentComponent(this);
  }
  getBodyHeight() {
    return nc(this.eContentWrapper);
  }
  getBodyWidth() {
    return jn(this.eContentWrapper);
  }
  setTitle(e) {
    this.eTitle.innerText = e;
  }
  // called when user hits the 'x' in the top right
  onBtClose() {
    this.close();
  }
  destroy() {
    this.closeButtonComp && (this.closeButtonComp = this.destroyBean(this.closeButtonComp));
    const e = this.getGui();
    e && Xt(e) && this.close(), super.destroy();
  }
}, ya = class extends ab {
  constructor(e) {
    super({ ...e, popup: !0 }), this.isMaximizable = !1, this.isMaximized = !1, this.maximizeListeners = [], this.resizeListenerDestroy = null, this.lastPosition = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  postConstruct() {
    var o;
    const e = this.getGui(), { movable: t, resizable: s, maximizable: i, modal: r, postProcessPopupParams: n } = this.config;
    if (this.addCssClass("ag-dialog"), super.postConstruct(), n) {
      const { type: a, eventSource: l, column: c, mouseEvent: d, rowNode: u } = n;
      (o = this.popupSvc) == null || o.callPostProcessPopup(a, e, l, d, c, u);
    }
    if (this.tabGuardFeature = this.createManagedBean(new $w(this)), this.tabGuardFeature.initialiseTabGuard({
      isFocusableContainer: !0,
      onFocusIn: () => {
        var a;
        (a = this.popupSvc) == null || a.bringPopupToFront(e);
      },
      onTabKeyDown: (a) => {
        if (r)
          return;
        const l = a.shiftKey, c = zt(this.beans, e, !1, l);
        (!c || this.tabGuardFeature.getTabGuardCtrl().isTabGuard(c)) && Ui(this.beans, l) && a.preventDefault();
      }
    }), t && this.setMovable(t), i && this.setMaximizable(i), s && this.setResizable(s), !this.config.modal) {
      const a = this.beans.ctrlsSvc.get("gridCtrl");
      a.addFocusableContainer(this), this.addDestroyFunc(() => a.removeFocusableContainer(this));
    }
  }
  setAllowFocus(e) {
    this.tabGuardFeature.getTabGuardCtrl().setAllowFocus(e);
  }
  renderComponent() {
    var a;
    const e = this.getGui(), { alwaysOnTop: t, modal: s, title: i, afterGuiAttached: r } = this.config, n = this.getLocaleTextFunc(), o = (a = this.popupSvc) == null ? void 0 : a.addPopup({
      modal: s,
      eChild: e,
      closeOnEsc: !0,
      closedCallback: this.onClosed.bind(this),
      alwaysOnTop: t,
      ariaLabel: i || n("ariaLabelDialog", "Dialog"),
      afterGuiAttached: r
    });
    o && (this.close = o.hideFunc);
  }
  onClosed(e) {
    var t, s;
    this.destroy(), (s = (t = this.config).closedCallback) == null || s.call(t, e);
  }
  toggleMaximize() {
    const e = this.positionableFeature.getPosition();
    if (this.isMaximized) {
      const { x: t, y: s, width: i, height: r } = this.lastPosition;
      this.setWidth(i), this.setHeight(r), this.positionableFeature.offsetElement(t, s);
    } else
      this.lastPosition.width = this.getWidth(), this.lastPosition.height = this.getHeight(), this.lastPosition.x = e.x, this.lastPosition.y = e.y, this.positionableFeature.offsetElement(0, 0), this.setHeight("100%"), this.setWidth("100%");
    this.isMaximized = !this.isMaximized, this.refreshMaximizeIcon();
  }
  refreshMaximizeIcon() {
    re(this.maximizeIcon, !this.isMaximized), re(this.minimizeIcon, this.isMaximized);
  }
  clearMaximizebleListeners() {
    this.maximizeListeners.length && (this.maximizeListeners.forEach((e) => e()), this.maximizeListeners.length = 0), this.resizeListenerDestroy && (this.resizeListenerDestroy(), this.resizeListenerDestroy = null);
  }
  destroy() {
    this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp), this.clearMaximizebleListeners(), super.destroy();
  }
  setResizable(e) {
    this.positionableFeature.setResizable(e);
  }
  setMovable(e) {
    this.positionableFeature.setMovable(e, this.eTitleBar);
  }
  setMaximizable(e) {
    if (!e) {
      this.clearMaximizebleListeners(), this.maximizeButtonComp && (this.destroyBean(this.maximizeButtonComp), this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0);
      return;
    }
    const t = this.eTitleBar;
    if (!t || e === this.isMaximizable)
      return;
    const s = this.buildMaximizeAndMinimizeElements();
    this.refreshMaximizeIcon(), s.addManagedElementListeners(s.getGui(), {
      click: this.toggleMaximize.bind(this)
    }), this.addTitleBarButton(s, 0), this.maximizeListeners.push(
      ...this.addManagedElementListeners(t, {
        dblclick: this.toggleMaximize.bind(this)
      })
    ), [this.resizeListenerDestroy] = this.addManagedListeners(this.positionableFeature, {
      resize: () => {
        this.isMaximized = !1, this.refreshMaximizeIcon();
      }
    });
  }
  buildMaximizeAndMinimizeElements() {
    const e = this.maximizeButtonComp = this.createBean(
      new _(
        /* html */
        '<div class="ag-dialog-button"></span>'
      )
    ), t = e.getGui();
    return this.maximizeIcon = ue("maximize", this.beans), t.appendChild(this.maximizeIcon), this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon"), this.minimizeIcon = ue("minimize", this.beans), t.appendChild(this.minimizeIcon), this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon"), e;
  }
}, $H = (
  /*css*/
  ".ag-autocomplete{align-items:center;display:flex;width:100%;>*{flex:1 1 auto}}.ag-autocomplete-list-popup{background-color:var(--ag-background-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);padding:0;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-autocomplete-list{height:calc(var(--ag-row-height)*6.5);min-width:200px;position:relative;width:100%}.ag-autocomplete-virtual-list-item{cursor:default;display:flex;height:var(--ag-list-item-height);&:focus-visible:after{content:none}&:hover{background-color:var(--ag-row-hover-color)}}.ag-autocomplete-row{align-items:center;display:flex;flex:1 1 auto;overflow:hidden}.ag-autocomplete-row-label{margin:0 var(--ag-widget-container-horizontal-padding);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-autocomplete-row-selected{background-color:var(--ag-selected-row-background-color)}"
);
function jH(e) {
  return (
    /* html */
    `<div class="ag-virtual-list-viewport ag-${e}-virtual-list-viewport" role="presentation">
            <div class="ag-virtual-list-container ag-${e}-virtual-list-container" data-ref="eContainer"></div>
        </div>`
  );
}
var co = class extends Ti {
  constructor(e) {
    super(jH((e == null ? void 0 : e.cssIdentifier) || "default")), this.renderedRows = /* @__PURE__ */ new Map(), this.rowHeight = 20, this.pageSize = -1, this.isScrolling = !1, this.isHeightFromTheme = !0, this.eContainer = E, this.awaitStableCallbacks = [];
    const { cssIdentifier: t = "default", ariaRole: s = "listbox", listName: i } = e || {};
    this.cssIdentifier = t, this.ariaRole = s, this.listName = i;
  }
  wireBeans(e) {
    this.environment = e.environment;
  }
  postConstruct() {
    this.addScrollListener(), this.rowHeight = this.getItemHeight(), this.addResizeObserver(), this.initialiseTabGuard({
      onFocusIn: (e) => this.onFocusIn(e),
      onFocusOut: (e) => this.onFocusOut(e),
      focusInnerElement: (e) => this.focusInnerElement(e),
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => this.handleKeyDown(e)
    }), this.setAriaProperties(), this.addManagedEventListeners({ gridStylesChanged: this.onGridStylesChanged.bind(this) });
  }
  onGridStylesChanged(e) {
    e.listItemHeightChanged && (this.rowHeight = this.getItemHeight(), this.refresh());
  }
  setAriaProperties() {
    const t = this.getLocaleTextFunc()("ariaDefaultListName", this.listName || "List"), s = this.eContainer;
    nt(s, this.ariaRole), ot(s, t);
  }
  addResizeObserver() {
    const e = () => _s(this.beans, () => this.drawVirtualRows()), t = Ms(this.beans, this.getGui(), e);
    this.addDestroyFunc(t);
  }
  focusInnerElement(e) {
    this.focusRow(e ? this.model.getRowCount() - 1 : 0);
  }
  onFocusIn(e) {
    const t = e.target;
    t.classList.contains("ag-virtual-list-item") && (this.lastFocusedRowIndex = yP(t) - 1);
  }
  onFocusOut(e) {
    this.getFocusableElement().contains(e.relatedTarget) || (this.lastFocusedRowIndex = null);
  }
  handleKeyDown(e) {
    switch (e.key) {
      case P.UP:
      case P.DOWN:
        e.preventDefault(), this.navigate(e.key === P.UP);
        break;
      case P.PAGE_HOME:
      case P.PAGE_END:
      case P.PAGE_UP:
      case P.PAGE_DOWN:
        this.navigateToPage(e.key) !== null && e.preventDefault();
        break;
    }
  }
  onTabKeyDown(e) {
    gt(e), this.forceFocusOutOfContainer(e.shiftKey);
  }
  navigate(e) {
    if (this.lastFocusedRowIndex == null)
      return;
    const t = this.lastFocusedRowIndex + (e ? -1 : 1);
    t < 0 || t >= this.model.getRowCount() || this.focusRow(t);
  }
  navigateToPage(e, t = "focused") {
    let s = !1;
    t === "focused" && (t = this.getLastFocusedRow(), s = !0);
    const i = this.model.getRowCount() - 1;
    let r = -1;
    return e === P.PAGE_HOME ? r = 0 : e === P.PAGE_END ? r = i : e === P.PAGE_DOWN ? r = Math.min(t + this.pageSize, i) : e === P.PAGE_UP && (r = Math.max(t - this.pageSize, 0)), r === -1 ? null : (s ? this.focusRow(r) : this.ensureIndexVisible(r), r);
  }
  getLastFocusedRow() {
    return this.lastFocusedRowIndex;
  }
  focusRow(e) {
    this.isScrolling || (this.isScrolling = !0, this.ensureIndexVisible(e), _s(this.beans, () => {
      if (this.isScrolling = !1, !this.isAlive())
        return;
      const t = this.renderedRows.get(e);
      t && t.eDiv.focus();
    }));
  }
  getComponentAt(e) {
    const t = this.renderedRows.get(e);
    return t && t.rowComponent;
  }
  forEachRenderedRow(e) {
    this.renderedRows.forEach((t, s) => e(t.rowComponent, s));
  }
  getItemHeight() {
    return this.isHeightFromTheme ? this.environment.getDefaultListItemHeight() : this.rowHeight;
  }
  /**
   * Returns true if the view had to be scrolled, otherwise, false.
   */
  ensureIndexVisible(e, t = !0) {
    const s = this.model.getRowCount();
    if (typeof e != "number" || e < 0 || e >= s)
      return I(229, { index: e }), !1;
    const i = e * this.rowHeight, r = i + this.rowHeight, n = this.getGui(), o = n.scrollTop, a = n.offsetHeight, l = o + a, c = t ? 0 : this.rowHeight, d = o > i + c, u = l < r - c;
    if (d)
      return n.scrollTop = i, !0;
    if (u) {
      const h = r - a;
      return n.scrollTop = h, !0;
    }
    return !1;
  }
  setComponentCreator(e) {
    this.componentCreator = e;
  }
  setComponentUpdater(e) {
    this.componentUpdater = e;
  }
  getRowHeight() {
    return this.rowHeight;
  }
  getScrollTop() {
    return this.getGui().scrollTop;
  }
  setRowHeight(e) {
    this.isHeightFromTheme = !1, this.rowHeight = e, this.refresh();
  }
  refresh(e) {
    if (this.model == null || !this.isAlive())
      return;
    const t = this.model.getRowCount();
    this.eContainer.style.height = `${t * this.rowHeight}px`, this.awaitStable(() => {
      this.isAlive() && (this.canSoftRefresh(e) ? this.drawVirtualRows(!0) : (this.clearVirtualRows(), this.drawVirtualRows()));
    });
  }
  awaitStable(e) {
    if (this.awaitStableCallbacks.push(e), this.awaitStableCallbacks.length > 1)
      return;
    const t = this.model.getRowCount();
    hv(
      () => this.eContainer.clientHeight >= t * this.rowHeight,
      () => {
        if (!this.isAlive())
          return;
        const s = this.awaitStableCallbacks;
        this.awaitStableCallbacks = [], s.forEach((i) => i());
      }
    );
  }
  canSoftRefresh(e) {
    return !!(e && this.renderedRows.size && typeof this.model.areRowsEqual == "function" && this.componentUpdater);
  }
  clearVirtualRows() {
    this.renderedRows.forEach((e, t) => this.removeRow(t));
  }
  drawVirtualRows(e) {
    if (!this.isAlive() || !this.model)
      return;
    const t = this.getGui(), s = t.scrollTop, i = s + t.offsetHeight, r = Math.floor(s / this.rowHeight), n = Math.floor(i / this.rowHeight);
    this.pageSize = Math.floor((i - s) / this.rowHeight), this.ensureRowsRendered(r, n, e);
  }
  ensureRowsRendered(e, t, s) {
    this.renderedRows.forEach((i, r) => {
      (r < e || r > t) && r !== this.lastFocusedRowIndex && this.removeRow(r);
    }), s && this.refreshRows();
    for (let i = e; i <= t; i++)
      this.renderedRows.has(i) || i < this.model.getRowCount() && this.insertRow(i);
  }
  insertRow(e) {
    const t = this.model.getRow(e), s = document.createElement("div");
    s.classList.add("ag-virtual-list-item", `ag-${this.cssIdentifier}-virtual-list-item`), nt(s, this.ariaRole === "tree" ? "treeitem" : "option"), ic(s, this.model.getRowCount()), rc(s, e + 1), s.setAttribute("tabindex", "-1"), s.style.height = `${this.rowHeight}px`, s.style.top = `${this.rowHeight * e}px`;
    const i = this.componentCreator(t, s);
    i.addGuiEventListener("focusin", () => this.lastFocusedRowIndex = e), s.appendChild(i.getGui()), this.renderedRows.has(e - 1) ? this.renderedRows.get(e - 1).eDiv.insertAdjacentElement("afterend", s) : this.renderedRows.has(e + 1) ? this.renderedRows.get(e + 1).eDiv.insertAdjacentElement("beforebegin", s) : this.eContainer.appendChild(s), this.renderedRows.set(e, { rowComponent: i, eDiv: s, value: t });
  }
  removeRow(e) {
    const t = this.renderedRows.get(e);
    this.eContainer.removeChild(t.eDiv), this.destroyBean(t.rowComponent), this.renderedRows.delete(e);
  }
  refreshRows() {
    const e = this.model.getRowCount();
    this.renderedRows.forEach((t, s) => {
      var i, r;
      if (s >= e)
        this.removeRow(s);
      else {
        const n = this.model.getRow(s);
        (r = (i = this.model).areRowsEqual) != null && r.call(i, t.value, n) ? this.componentUpdater(n, t.rowComponent) : this.removeRow(s);
      }
    });
  }
  addScrollListener() {
    this.addGuiEventListener("scroll", () => this.drawVirtualRows(), { passive: !0 });
  }
  setModel(e) {
    this.model = e;
  }
  getAriaElement() {
    return this.eContainer;
  }
  destroy() {
    this.isAlive() && (this.clearVirtualRows(), this.awaitStableCallbacks.length = 0, super.destroy());
  }
}, KH = class extends _ {
  constructor() {
    super(
      /* html */
      `
        <div class="ag-autocomplete-row" role="presentation">
            <div class="ag-autocomplete-row-label"></div>
        </div>`
    ), this.hasHighlighting = !1;
  }
  setState(e, t) {
    this.value = e, this.render(), this.updateSelected(t);
  }
  updateSelected(e) {
    this.addOrRemoveCssClass("ag-autocomplete-row-selected", e);
  }
  setSearchString(e) {
    var s;
    let t = !1;
    if (W(e)) {
      const i = (s = this.value) == null ? void 0 : s.toLocaleLowerCase().indexOf(e.toLocaleLowerCase());
      if (i >= 0) {
        t = !0, this.hasHighlighting = !0;
        const r = i + e.length, n = Ke(this.value.slice(0, i)), o = Ke(this.value.slice(i, r)), a = Ke(this.value.slice(r));
        this.getGui().lastElementChild.innerHTML = `${n}<b>${o}</b>${a}`;
      }
    }
    !t && this.hasHighlighting && (this.hasHighlighting = !1, this.render());
  }
  render() {
    this.getGui().lastElementChild.innerHTML = Ke(this.value) ?? "&nbsp;";
  }
}, qH = class extends Lr {
  constructor(e) {
    super(
      /* html */
      `<div class="ag-autocomplete-list-popup">
            <div data-ref="eList" class="ag-autocomplete-list"></div>
        <div>`
    ), this.params = e, this.eList = E, this.searchString = "";
  }
  postConstruct() {
    this.autocompleteEntries = this.params.autocompleteEntries, this.virtualList = this.createManagedBean(new co({ cssIdentifier: "autocomplete" })), this.virtualList.setComponentCreator(this.createRowComponent.bind(this)), this.eList.appendChild(this.virtualList.getGui()), this.virtualList.setModel({
      getRowCount: () => this.autocompleteEntries.length,
      getRow: (t) => this.autocompleteEntries[t]
    });
    const e = this.virtualList.getGui();
    this.addManagedListeners(e, {
      click: () => this.params.onConfirmed(),
      mousemove: this.onMouseMove.bind(this),
      mousedown: (t) => t.preventDefault()
    }), this.setSelectedValue(0);
  }
  onNavigationKeyDown(e, t) {
    e.preventDefault();
    const s = this.autocompleteEntries.indexOf(this.selectedValue), i = t === P.UP ? s - 1 : s + 1;
    this.checkSetSelectedValue(i);
  }
  setSearch(e) {
    this.searchString = e, W(e) ? this.runSearch() : (this.autocompleteEntries = this.params.autocompleteEntries, this.virtualList.refresh(), this.checkSetSelectedValue(0)), this.updateSearchInList();
  }
  runContainsSearch(e, t) {
    let s, i = !1;
    const r = e.toLocaleLowerCase(), n = t.filter((o) => {
      const l = o.toLocaleLowerCase().indexOf(r), c = l === 0, d = l >= 0;
      return d && (!s || !i && c || i === c && o.length < s.length) && (s = o, i = c), d;
    });
    return !s && n.length && (s = n[0]), { topMatch: s, allMatches: n };
  }
  runSearch() {
    const { autocompleteEntries: e, useFuzzySearch: t, forceLastSelection: s } = this.params, i = e.map((l) => l.displayValue ?? l.key);
    let r, n;
    if (t)
      r = Rc({
        inputValue: this.searchString,
        allSuggestions: i,
        hideIrrelevant: !0,
        addSequentialWeight: !0
      }).values, n = r.length ? r[0] : void 0;
    else {
      const l = this.runContainsSearch(this.searchString, i);
      r = l.allMatches, n = l.topMatch;
    }
    let o = e.filter(
      ({ key: l, displayValue: c }) => r.includes(c ?? l)
    );
    if (!o.length && this.selectedValue && (s != null && s(this.selectedValue, this.searchString)) && (o = [this.selectedValue]), this.autocompleteEntries = o, this.virtualList.refresh(), !n)
      return;
    const a = r.indexOf(n);
    this.checkSetSelectedValue(a);
  }
  updateSearchInList() {
    this.virtualList.forEachRenderedRow((e) => e.setSearchString(this.searchString));
  }
  checkSetSelectedValue(e) {
    e >= 0 && e < this.autocompleteEntries.length && this.setSelectedValue(e);
  }
  setSelectedValue(e) {
    const t = this.autocompleteEntries[e];
    this.selectedValue !== t && (this.selectedValue = t, this.virtualList.ensureIndexVisible(e), this.virtualList.forEachRenderedRow((s, i) => {
      s.updateSelected(e === i);
    }));
  }
  createRowComponent(e) {
    const t = new KH();
    return this.createBean(t), t.setState(e.displayValue ?? e.key, e === this.selectedValue), t;
  }
  onMouseMove(e) {
    const t = this.virtualList, s = t.getGui().getBoundingClientRect(), i = t.getScrollTop(), r = e.clientY - s.top + i, n = Math.floor(r / t.getRowHeight());
    this.checkSetSelectedValue(n);
  }
  afterGuiAttached() {
    this.virtualList.refresh();
  }
  getSelectedValue() {
    return this.autocompleteEntries.length ? this.selectedValue ?? null : null;
  }
}, YH = class extends _ {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-autocomplete" role="presentation">
                <ag-input-text-field data-ref="eAutocompleteInput"></ag-input-text-field>
            </div>`,
      [Ks]
    ), this.eAutocompleteInput = E, this.isListOpen = !1, this.lastPosition = 0, this.valid = !0, this.registerCSS($H);
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc;
  }
  postConstruct() {
    this.eAutocompleteInput.onValueChange((e) => this.onValueChanged(e)), this.eAutocompleteInput.getInputElement().setAttribute("autocomplete", "off"), this.addGuiEventListener("keydown", this.onKeyDown.bind(this)), this.addGuiEventListener("click", this.updatePositionAndList.bind(this)), this.addDestroyFunc(() => {
      this.destroyBean(this.autocompleteList);
    }), this.addGuiEventListener("focusout", () => this.onFocusOut());
  }
  onValueChanged(e) {
    const t = St(e);
    this.updateValue(t), this.updateAutocompleteList(t);
  }
  updateValue(e) {
    this.updateLastPosition(), this.dispatchLocalEvent({
      type: "eventValueChanged",
      value: e
    }), this.validate(e);
  }
  updateAutocompleteList(e) {
    var i, r;
    const t = ((i = this.listGenerator) == null ? void 0 : i.call(this, e, this.lastPosition)) ?? { enabled: !1 }, s = this.isListOpen;
    if ((!t.type || t.type !== ((r = this.autocompleteListParams) == null ? void 0 : r.type)) && s && this.closeList(), this.autocompleteListParams = t, t != null && t.enabled) {
      s || this.openList();
      const { searchString: n } = t;
      this.autocompleteList.setSearch(n ?? "");
    } else
      s && this.closeList();
  }
  onKeyDown(e) {
    const t = e.key;
    switch (this.updateLastPosition(), t) {
      case P.ENTER:
        this.onEnterKeyDown(e);
        break;
      case P.TAB:
        this.onTabKeyDown(e);
        break;
      case P.DOWN:
      case P.UP:
        this.onUpDownKeyDown(e, t);
        break;
      case P.LEFT:
      case P.RIGHT:
      case P.PAGE_HOME:
      case P.PAGE_END:
        setTimeout(() => {
          this.updatePositionAndList();
        });
        break;
      case P.ESCAPE:
        this.onEscapeKeyDown(e);
        break;
      case P.SPACE:
        e.ctrlKey && !this.isListOpen && (e.preventDefault(), this.forceOpenList());
        break;
    }
  }
  confirmSelection() {
    var t;
    const e = (t = this.autocompleteList) == null ? void 0 : t.getSelectedValue();
    e && (this.closeList(), this.dispatchLocalEvent({
      type: "eventOptionSelected",
      value: this.getValue(),
      position: this.lastPosition,
      updateEntry: e,
      autocompleteType: this.autocompleteListParams.type
    }));
  }
  onTabKeyDown(e) {
    this.isListOpen && (e.preventDefault(), e.stopPropagation(), this.confirmSelection());
  }
  onEnterKeyDown(e) {
    e.preventDefault(), this.isListOpen ? this.confirmSelection() : this.onCompleted();
  }
  onUpDownKeyDown(e, t) {
    var s;
    e.preventDefault(), this.isListOpen ? (s = this.autocompleteList) == null || s.onNavigationKeyDown(e, t) : this.forceOpenList();
  }
  onEscapeKeyDown(e) {
    this.isListOpen && (e.preventDefault(), e.stopPropagation(), this.closeList(), this.setCaret(this.lastPosition, !0));
  }
  onFocusOut() {
    this.isListOpen && this.closeList();
  }
  updatePositionAndList() {
    this.updateLastPosition(), this.updateAutocompleteList(this.eAutocompleteInput.getValue() ?? null);
  }
  setCaret(e, t) {
    t && Fr(this.beans) && this.eAutocompleteInput.getFocusableElement().focus();
    const s = this.eAutocompleteInput.getInputElement();
    s.setSelectionRange(e, e), e === s.value.length && (s.scrollLeft = s.scrollWidth);
  }
  forceOpenList() {
    this.onValueChanged(this.eAutocompleteInput.getValue());
  }
  updateLastPosition() {
    this.lastPosition = this.eAutocompleteInput.getInputElement().selectionStart ?? 0;
  }
  validate(e) {
    if (!this.validator)
      return;
    const t = this.validationMessage = this.validator(e);
    this.eAutocompleteInput.getInputElement().setCustomValidity(t ?? ""), this.valid = !t, this.dispatchLocalEvent({
      type: "eventValidChanged",
      isValid: this.valid,
      validationMessage: t
    });
  }
  openList() {
    this.isListOpen = !0, this.autocompleteList = this.createBean(
      new qH({
        autocompleteEntries: this.autocompleteListParams.entries,
        onConfirmed: () => this.confirmSelection(),
        forceLastSelection: this.forceLastSelection
      })
    );
    const e = this.autocompleteList.getGui(), t = {
      ePopup: e,
      type: "autocomplete",
      eventSource: this.getGui(),
      position: "under",
      alignSide: this.gos.get("enableRtl") ? "right" : "left",
      keepWithinBounds: !0
    }, s = this.popupSvc.addPopup({
      eChild: e,
      anchorToElement: this.getGui(),
      positionCallback: () => this.popupSvc.positionPopupByComponent(t),
      ariaLabel: this.listAriaLabel
    });
    this.hidePopup = s.hideFunc, this.autocompleteList.afterGuiAttached();
  }
  closeList() {
    this.isListOpen = !1, this.hidePopup(), this.destroyBean(this.autocompleteList), this.autocompleteList = null;
  }
  onCompleted() {
    this.isListOpen && this.closeList(), this.dispatchLocalEvent({
      type: "eventValueConfirmed",
      value: this.getValue(),
      isValid: this.isValid()
    });
  }
  getValue() {
    return St(this.eAutocompleteInput.getValue());
  }
  setInputPlaceholder(e) {
    return this.eAutocompleteInput.setInputPlaceholder(e), this;
  }
  setInputAriaLabel(e) {
    return this.eAutocompleteInput.setInputAriaLabel(e), this;
  }
  setListAriaLabel(e) {
    return this.listAriaLabel = e, this;
  }
  setListGenerator(e) {
    return this.listGenerator = e, this;
  }
  setValidator(e) {
    return this.validator = e, this;
  }
  isValid() {
    return this.valid;
  }
  setValue(e) {
    const { value: t, position: s, silent: i, updateListOnlyIfOpen: r, restoreFocus: n } = e;
    this.eAutocompleteInput.setValue(t, !0), this.setCaret(s ?? this.lastPosition, n), i || this.updateValue(t), (!r || this.isListOpen) && this.updateAutocompleteList(t);
  }
  setForceLastSelection(e) {
    return this.forceLastSelection = e, this;
  }
  setInputDisabled(e) {
    return this.eAutocompleteInput.setDisabled(e), this;
  }
}, XH = {
  selector: "AG-AUTOCOMPLETE",
  component: YH
}, lb = class extends _ {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-advanced-filter" role="presentation" tabindex="-1">
                <ag-autocomplete data-ref="eAutocomplete"></ag-autocomplete>
                <button class="ag-button ag-standard-button ag-advanced-filter-apply-button" data-ref="eApplyFilterButton"></button>
                <button class="ag-button ag-advanced-filter-builder-button" data-ref="eBuilderFilterButton">
                    <span data-ref="eBuilderFilterButtonIcon" aria-hidden="true"></span>
                    <span class="ag-advanced-filter-builder-button-label" data-ref="eBuilderFilterButtonLabel"></span>
                </button>
            </div>`,
      [XH]
    ), this.eAutocomplete = E, this.eApplyFilterButton = E, this.eBuilderFilterButton = E, this.eBuilderFilterButtonIcon = E, this.eBuilderFilterButtonLabel = E, this.expressionParser = null, this.isApplyDisabled = !0, this.builderOpen = !1;
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc, this.advancedFilter = e.advancedFilter, this.filterManager = e.filterManager, this.registry = e.registry;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        getTooltipShowDelayOverride: () => 1e3,
        getLocation: () => "advancedFilter"
      })
    ), this.eAutocomplete.setListGenerator((e, t) => this.generateAutocompleteListParams(t)).setValidator(() => this.validateValue()).setForceLastSelection(
      (e, t) => this.forceLastSelection(e, t)
    ).setInputAriaLabel(this.advFilterExpSvc.translate("ariaAdvancedFilterInput")).setListAriaLabel(this.advFilterExpSvc.translate("ariaLabelAdvancedFilterAutocomplete")), this.refresh(), this.addManagedListeners(this.eAutocomplete, {
      eventValueChanged: ({ value: e }) => this.onValueChanged(e),
      eventValueConfirmed: ({ isValid: e }) => this.onValueConfirmed(e),
      eventOptionSelected: ({ position: e, updateEntry: t, autocompleteType: s }) => this.onOptionSelected(e, t, s),
      eventValidChanged: ({ isValid: e, validationMessage: t }) => this.onValidChanged(e, t)
    }), this.setupApplyButton(), this.setupBuilderButton();
  }
  refresh() {
    const e = this.advancedFilter.getExpressionDisplayValue();
    this.eAutocomplete.setValue({
      value: e ?? "",
      position: e == null ? void 0 : e.length,
      updateListOnlyIfOpen: !0
    });
  }
  setInputDisabled(e) {
    this.eAutocomplete.setInputDisabled(e), Bs(this.eApplyFilterButton, e || this.isApplyDisabled);
  }
  setupApplyButton() {
    this.eApplyFilterButton.innerText = this.advFilterExpSvc.translate("advancedFilterApply"), this.activateTabIndex([this.eApplyFilterButton]), this.addManagedElementListeners(this.eApplyFilterButton, {
      click: () => this.onValueConfirmed(this.eAutocomplete.isValid())
    }), Bs(this.eApplyFilterButton, this.isApplyDisabled);
  }
  setupBuilderButton() {
    this.eBuilderFilterButtonIcon.appendChild(ue("advancedFilterBuilder", this.beans)), this.eBuilderFilterButtonLabel.innerText = this.advFilterExpSvc.translate("advancedFilterBuilder"), this.activateTabIndex([this.eBuilderFilterButton]), this.addManagedElementListeners(this.eBuilderFilterButton, { click: () => this.openBuilder() }), this.addManagedListeners(this.advancedFilter.getCtrl(), {
      advancedFilterBuilderClosed: () => this.closeBuilder()
    });
  }
  onValueChanged(e) {
    var s;
    e = St(e), this.advancedFilter.setExpressionDisplayValue(e), this.expressionParser = this.advancedFilter.createExpressionParser(e);
    const t = (s = this.expressionParser) == null ? void 0 : s.parseExpression();
    t && t !== e && this.eAutocomplete.setValue({ value: t, silent: !0, restoreFocus: !0 });
  }
  onValueConfirmed(e) {
    var t;
    !e || this.isApplyDisabled || (Bs(this.eApplyFilterButton, !0), this.advancedFilter.applyExpression(), (t = this.filterManager) == null || t.onFilterChanged({ source: "advancedFilter" }));
  }
  onOptionSelected(e, t, s) {
    const { updatedValue: i, updatedPosition: r, hideAutocomplete: n } = this.updateExpression(e, t, s);
    this.eAutocomplete.setValue({
      value: i,
      position: r,
      updateListOnlyIfOpen: n,
      restoreFocus: !0
    });
  }
  validateValue() {
    var e, t;
    return (e = this.expressionParser) != null && e.isValid() ? null : ((t = this.expressionParser) == null ? void 0 : t.getValidationMessage()) ?? null;
  }
  onValidChanged(e, t) {
    var s;
    this.isApplyDisabled = !e || this.advancedFilter.isCurrentExpressionApplied(), Bs(this.eApplyFilterButton, this.isApplyDisabled), (s = this.tooltipFeature) == null || s.setTooltipAndRefresh(t);
  }
  generateAutocompleteListParams(e) {
    return this.expressionParser ? this.expressionParser.getAutocompleteListParams(e) : this.advFilterExpSvc.getDefaultAutocompleteListParams("");
  }
  updateExpression(e, t, s) {
    var i;
    return this.advFilterExpSvc.updateAutocompleteCache(t, s), ((i = this.expressionParser) == null ? void 0 : i.updateExpression(e, t, s)) ?? this.advancedFilter.getDefaultExpression(t);
  }
  forceLastSelection({ key: e, displayValue: t }, s) {
    return !!s.toLocaleLowerCase().match(`^${(t ?? e).toLocaleLowerCase()}\\s*$`);
  }
  openBuilder() {
    this.builderOpen || (this.builderOpen = !0, Bs(this.eBuilderFilterButton, !0), this.advancedFilter.getCtrl().toggleFilterBuilder({ source: "ui", eventSource: this.eBuilderFilterButton }));
  }
  closeBuilder() {
    this.builderOpen && (this.builderOpen = !1, Bs(this.eBuilderFilterButton, !1), this.eBuilderFilterButton.focus());
  }
}, ZH = class extends _ {
  constructor(e) {
    super(
      /* html */
      `
            <div class="ag-advanced-filter-header" role="row">
            </div>`
    ), this.enabled = e;
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.focusSvc = e.focusSvc, this.ctrlsSvc = e.ctrlsSvc;
  }
  postConstruct() {
    this.setupAdvancedFilter(this.enabled), this.addDestroyFunc(() => this.destroyBean(this.eAdvancedFilter));
    const e = () => {
      this.enabled && this.setEnabledHeight();
    };
    this.addManagedEventListeners({
      gridColumnsChanged: () => this.onGridColumnsChanged(),
      columnHeaderHeightChanged: e,
      gridStylesChanged: e
    }), this.addManagedPropertyListener("headerHeight", e), this.addManagedPropertyListener("floatingFiltersHeight", e), this.addGuiEventListener("keydown", (t) => this.onKeyDown(t)), this.addGuiEventListener("focusout", (t) => {
      this.getFocusableElement().contains(t.relatedTarget) || this.focusSvc.clearAdvancedFilterColumn();
    });
  }
  getFocusableElement() {
    var e;
    return ((e = this.eAdvancedFilter) == null ? void 0 : e.getGui()) ?? this.getGui();
  }
  setEnabled(e) {
    e !== this.enabled && this.setupAdvancedFilter(e);
  }
  refresh() {
    var e;
    (e = this.eAdvancedFilter) == null || e.refresh();
  }
  getHeight() {
    return this.height;
  }
  setInputDisabled(e) {
    var t;
    (t = this.eAdvancedFilter) == null || t.setInputDisabled(e);
  }
  setupAdvancedFilter(e) {
    const t = this.getGui();
    if (e) {
      this.eAdvancedFilter = this.createBean(new lb());
      const s = this.eAdvancedFilter.getGui();
      this.eAdvancedFilter.addCssClass("ag-advanced-filter-header-cell"), this.setEnabledHeight(), this.setAriaRowIndex(), nt(s, "gridcell"), sh(s, 1), this.setAriaColumnCount(s), t.appendChild(s);
    } else
      ze(t), this.destroyBean(this.eAdvancedFilter), this.height = 0;
    re(t, e), this.enabled = e;
  }
  setEnabledHeight() {
    const e = this.getGui();
    this.height = Eh(this.beans);
    const t = `${this.height}px`;
    e.style.height = t, e.style.minHeight = t;
  }
  setAriaColumnCount(e) {
    KC(e, this.colModel.getCols().length);
  }
  setAriaRowIndex() {
    var e;
    th(this.getGui(), ((e = this.ctrlsSvc.getHeaderRowContainerCtrl()) == null ? void 0 : e.getRowCount()) ?? 0);
  }
  onGridColumnsChanged() {
    this.eAdvancedFilter && (this.setAriaColumnCount(this.eAdvancedFilter.getGui()), this.setAriaRowIndex());
  }
  onKeyDown(e) {
    switch (e.key) {
      case P.ENTER: {
        this.hasFocus() && Dt(this.getFocusableElement()) && e.preventDefault();
        break;
      }
      case P.ESCAPE:
        this.hasFocus() || this.getFocusableElement().focus();
        break;
      case P.UP:
        this.navigateUpDown(!0, e);
        break;
      case P.DOWN:
        this.navigateUpDown(!1, e);
        break;
      case P.TAB:
        if (this.hasFocus())
          this.navigateLeftRight(e);
        else {
          const t = zt(
            this.beans,
            this.getFocusableElement(),
            null,
            e.shiftKey
          );
          t ? (e.preventDefault(), t.focus()) : this.navigateLeftRight(e);
        }
        break;
    }
  }
  navigateUpDown(e, t) {
    this.hasFocus() && this.focusSvc.focusNextFromAdvancedFilter(e) && t.preventDefault();
  }
  navigateLeftRight(e) {
    (e.shiftKey ? this.focusSvc.focusLastHeader() : this.focusSvc.focusNextFromAdvancedFilter(!1, !0)) && e.preventDefault();
  }
  hasFocus() {
    return Ie(this.beans) === this.getFocusableElement();
  }
}, Ld = "ag-list-item-hovered", cb = class extends L {
  constructor(e, t, s) {
    super(), this.comp = e, this.virtualList = t, this.params = s, this.currentDragValue = null, this.lastHoveredListItem = null;
  }
  wireBeans(e) {
    this.dragAndDrop = e.dragAndDrop;
  }
  postConstruct() {
    this.addManagedListeners(this.params.eventSource, {
      [this.params.listItemDragStartEvent]: this.listItemDragStart.bind(this),
      [this.params.listItemDragEndEvent]: this.listItemDragEnd.bind(this)
    }), this.createDropTarget(), this.createAutoScrollService();
  }
  listItemDragStart(e) {
    this.currentDragValue = this.params.getCurrentDragValue(e), this.moveBlocked = this.params.isMoveBlocked(this.currentDragValue);
  }
  listItemDragEnd() {
    window.setTimeout(() => {
      this.currentDragValue = null, this.moveBlocked = !1;
    }, 10);
  }
  createDropTarget() {
    var t;
    const e = {
      isInterestedIn: (s) => s === this.params.dragSourceType,
      getIconName: () => this.moveBlocked ? "pinned" : "move",
      getContainer: () => this.comp.getGui(),
      onDragging: (s) => this.onDragging(s),
      onDragStop: () => this.onDragStop(),
      onDragLeave: () => this.onDragLeave(),
      onDragCancel: () => this.onDragCancel()
    };
    (t = this.dragAndDrop) == null || t.addDropTarget(e);
  }
  createAutoScrollService() {
    const e = this.virtualList.getGui();
    this.autoScrollService = new yh({
      scrollContainer: e,
      scrollAxis: "y",
      getVerticalPosition: () => e.scrollTop,
      setVerticalPosition: (t) => e.scrollTop = t
    });
  }
  onDragging(e) {
    if (!this.currentDragValue || this.moveBlocked)
      return;
    const t = this.getListDragItem(e), s = this.virtualList.getComponentAt(t.rowIndex);
    if (!s)
      return;
    const i = s.getGui().parentElement;
    this.lastHoveredListItem && this.lastHoveredListItem.rowIndex === t.rowIndex && this.lastHoveredListItem.position === t.position || (this.autoScrollService.check(e.event), this.clearHoveredItems(), this.lastHoveredListItem = t, yl(i, Ld), yl(i, `ag-item-highlight-${t.position}`));
  }
  getListDragItem(e) {
    const t = this.virtualList.getGui(), s = parseFloat(window.getComputedStyle(t).paddingTop), i = this.virtualList.getRowHeight(), r = this.virtualList.getScrollTop(), n = Math.max(0, (e.y - s + r) / i), o = this.params.getNumRows(this.comp) - 1, a = Math.min(o, n) | 0;
    return {
      rowIndex: a,
      position: Math.round(n) > n || n > o ? "bottom" : "top",
      component: this.virtualList.getComponentAt(a)
    };
  }
  onDragStop() {
    this.moveBlocked || (this.params.moveItem(this.currentDragValue, this.lastHoveredListItem), this.clearDragProperties());
  }
  onDragCancel() {
    this.clearDragProperties();
  }
  onDragLeave() {
    this.clearDragProperties();
  }
  clearDragProperties() {
    this.clearHoveredItems(), this.autoScrollService.ensureCleared();
  }
  clearHoveredItems() {
    this.virtualList.getGui().querySelectorAll(`.${Ld}`).forEach((t) => {
      [Ld, "ag-item-highlight-top", "ag-item-highlight-bottom"].forEach((s) => {
        t.classList.remove(s);
      });
    }), this.lastHoveredListItem = null;
  }
}, QH = class extends L {
  constructor(e, t) {
    super(), this.comp = e, this.virtualList = t;
  }
  postConstruct() {
    this.createManagedBean(
      new cb(this.comp, this.virtualList, {
        dragSourceType: ni.AdvancedFilterBuilder,
        listItemDragStartEvent: "advancedFilterBuilderDragStarted",
        listItemDragEndEvent: "advancedFilterBuilderDragEnded",
        eventSource: this,
        getCurrentDragValue: (e) => this.getCurrentDragValue(e),
        isMoveBlocked: () => !1,
        getNumRows: (e) => e.getNumItems(),
        moveItem: (e, t) => this.moveItem(e, t)
      })
    );
  }
  getCurrentDragValue(e) {
    return e.item;
  }
  moveItem(e, t) {
    this.comp.moveItem(e, t);
  }
}, JH = class extends _ {
  constructor(e) {
    super(
      /* html */
      `
            <div class="ag-pill" role="option">
                <span class="ag-pill-text" data-ref="eText"></span>
                <span class="ag-button ag-pill-button" data-ref="eButton" role="presentation"></span>
            </div>
        `
    ), this.config = e, this.eText = E, this.eButton = E;
  }
  postConstruct() {
    const { config: e, eButton: t } = this, { onKeyDown: s, onButtonClick: i } = e;
    this.getGui().setAttribute("tabindex", String(this.gos.get("tabIndex"))), this.addGuiEventListener("focus", () => {
      this.eButton.focus();
    }), s && this.addGuiEventListener("keydown", s), i && this.addManagedElementListeners(t, {
      click: i
    });
  }
  toggleCloseButtonClass(e, t) {
    this.eButton.classList.toggle(e, t);
  }
  setText(e) {
    this.eText.textContent = e;
  }
  getText() {
    return this.eText.textContent;
  }
}, ez = class extends _ {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-pill-container" role="listbox"></div>
            `
    ), this.pills = [];
  }
  init(e) {
    this.params = e, this.refresh();
  }
  refresh() {
    this.clearPills();
    const { params: e, onPillKeyDown: t } = this, s = e.getValue();
    if (!Array.isArray(s))
      return;
    const i = s.length;
    for (let r = 0; r < i; r++) {
      const n = s[r], o = this.createBean(
        new JH({
          onButtonClick: () => this.onPillButtonClick(o),
          onKeyDown: t.bind(this)
        })
      ), a = o.getGui();
      rc(a, r + 1), ic(a, i), e.onPillMouseDown && o.addGuiEventListener("mousedown", e.onPillMouseDown), e.announceItemFocus && o.addGuiEventListener("focus", e.announceItemFocus), o.setText(n), o.toggleCloseButtonClass("ag-icon-cancel", !0), this.appendChild(a), this.pills.push(o);
    }
  }
  onNavigationKeyDown(e) {
    const { key: t } = e;
    if (!this.pills.length || t !== P.LEFT && t !== P.RIGHT)
      return;
    e.preventDefault();
    const { params: s, beans: i } = this, r = Ie(i), n = this.getGui();
    if (n.contains(r)) {
      const o = zt(i, n, !1, t === P.LEFT);
      o ? o.focus() : s.eWrapper && s.eWrapper.focus();
    } else {
      const o = ii(n);
      o.length > 0 && o[t === P.RIGHT ? 0 : o.length - 1].focus();
    }
  }
  clearPills() {
    const e = this.getGui();
    e.contains(Ie(this.beans)) && this.params.eWrapper && this.params.eWrapper.focus(), ze(e), this.destroyBeans(this.pills), this.pills = [];
  }
  onPillButtonClick(e) {
    this.deletePill(e);
  }
  onPillKeyDown(e) {
    const t = e.key;
    if (t !== P.DELETE && t !== P.BACKSPACE)
      return;
    e.preventDefault();
    const s = We(this.beans), i = this.pills.findIndex((n) => n.getGui().contains(s.activeElement));
    if (i === -1)
      return;
    const r = this.pills[i];
    r && this.deletePill(r, i);
  }
  deletePill(e, t) {
    const s = e.getText(), i = (this.params.getValue() || []).filter((r) => r !== s);
    if (this.params.setValue(i), !i.length && this.params.eWrapper)
      this.params.eWrapper.focus();
    else if (t != null) {
      const r = this.pills[Math.min(t, this.pills.length - 1)];
      r && r.getFocusableElement().focus();
    }
  }
  destroy() {
    this.clearPills(), super.destroy();
  }
}, tz = (
  /*css*/
  ".ag-rich-select{cursor:default;height:100%}.ag-rich-select-value{align-items:center;background-color:var(--ag-input-background-color);display:flex;height:100%;padding:var(--ag-spacing);:where(.ag-picker-field-display){overflow:hidden;text-overflow:ellipsis;&:where(.ag-display-as-placeholder){opacity:.5}}}.ag-rich-select-list{background-color:var(--ag-input-background-color);border:var(--ag-input-border);border-radius:var(--ag-input-border-radius);box-shadow:var(--ag-dropdown-shadow);height:auto;position:relative;width:100%;:where(.ag-loading-text){padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding)}}.ag-rich-select-row{align-items:center;display:flex;flex:1 1 auto;height:100%;overflow:hidden;padding:0 var(--ag-spacing);white-space:nowrap}.ag-rich-select-row-selected{background-color:var(--ag-selected-row-background-color)}.ag-rich-select-row-highlighted,.ag-rich-select-row:hover{background-image:linear-gradient(var(--ag-row-hover-color),var(--ag-row-hover-color))}.ag-rich-select-row-text-highlight{font-weight:700}.ag-rich-select-field-input{flex:1 1 auto;:where(.ag-input-field-input){border:none!important;box-shadow:none!important;padding:0!important;text-overflow:ellipsis;&::-moz-placeholder{opacity:.8}&::placeholder{opacity:.8}}}:where(.ag-ltr) .ag-rich-select-field-input{left:var(--ag-spacing)}:where(.ag-rtl) .ag-rich-select-field-input{right:var(--ag-spacing)}:where(.ag-popup-editor) .ag-rich-select-value{height:var(--ag-row-height);min-width:200px}.ag-rich-select-virtual-list-item{cursor:default;height:var(--ag-list-item-height)}.ag-pill-container{display:flex;flex-wrap:nowrap;gap:.25rem}.ag-pill{align-items:center;background:var(--ag-select-cell-background-color);border:var(--ag-select-cell-border);border-radius:var(--ag-border-radius);display:flex;padding:0 .25rem;white-space:nowrap}.ag-pill-button{border:none;padding:0;&:hover{color:var(--ag-accent-color);cursor:pointer}}:where(.ag-ltr) .ag-pill-button{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-pill-button{margin-right:var(--ag-spacing)}"
), sz = class extends _ {
  constructor(e) {
    super(
      /* html */
      '<div class="ag-rich-select-row" role="presentation"></div>'
    ), this.params = e;
  }
  wireBeans(e) {
    this.userCompFactory = e.userCompFactory, this.registry = e.registry;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        shouldDisplayTooltip: () => {
          var e;
          return ((e = this.shouldDisplayTooltip) == null ? void 0 : e.call(this)) ?? !0;
        }
      })
    );
  }
  setState(e) {
    let t = "";
    const { params: s } = this;
    s.valueFormatter && (t = s.valueFormatter(e)), this.populateWithRenderer(e, t) || this.populateWithoutRenderer(e, t), this.value = e;
  }
  highlightString(e) {
    const { parsedValue: t } = this;
    if (this.params.cellRenderer || !W(t))
      return;
    let s = W(e);
    if (s) {
      const i = t == null ? void 0 : t.toLocaleLowerCase().indexOf(e.toLocaleLowerCase());
      if (i >= 0) {
        const r = i + e.length, n = Ke(t.slice(0, i), !0), o = Ke(t.slice(i, r), !0), a = Ke(t.slice(r));
        this.renderValueWithoutRenderer(
          /* html */
          `${n}<span class="ag-rich-select-row-text-highlight">${o}</span>${a}`
        );
      } else
        s = !1;
    }
    s || this.renderValueWithoutRenderer(t);
  }
  updateSelected(e) {
    const t = this.getGui();
    sa(t.parentElement, e), this.addOrRemoveCssClass("ag-rich-select-row-selected", e);
  }
  getValue() {
    return this.value;
  }
  toggleHighlighted(e) {
    this.addOrRemoveCssClass("ag-rich-select-row-highlighted", e);
  }
  populateWithoutRenderer(e, t) {
    var o;
    const s = We(this.beans), i = this.getGui(), r = s.createElement("span");
    r.style.overflow = "hidden", r.style.textOverflow = "ellipsis";
    const n = Ke(W(t) ? t : e, !0);
    this.parsedValue = W(n) ? n : null, i.appendChild(r), this.renderValueWithoutRenderer(n), this.shouldDisplayTooltip = un(() => r), (o = this.tooltipFeature) == null || o.setTooltipAndRefresh(this.parsedValue);
  }
  renderValueWithoutRenderer(e) {
    const t = this.getGui().querySelector("span");
    t && (t.innerHTML = W(e) ? e : "&nbsp;");
  }
  populateWithRenderer(e, t) {
    var r;
    let s, i;
    if (this.params.cellRenderer) {
      const n = (r = this.getParentComponent()) == null ? void 0 : r.getParentComponent();
      i = Zv(
        this.userCompFactory,
        this.params,
        {
          value: e,
          valueFormatted: t,
          getValue: () => n == null ? void 0 : n.getValue(),
          setValue: (o) => {
            n == null || n.setValue(o, !0);
          },
          setTooltip: (o, a) => {
            var l;
            this.gos.assertModuleRegistered("Tooltip", 3), this.shouldDisplayTooltip = a, (l = this.tooltipFeature) == null || l.setTooltipAndRefresh(o);
          }
        }
      );
    }
    return i && (s = i.newAgStackInstance()), s && dv(s, this.getGui()), s ? (s.then((n) => {
      this.addDestroyFunc(() => {
        this.destroyBean(n);
      });
    }), !0) : !1;
  }
}, Bf = "ag-rich-select-list", Vf = "ag-rich-select-row", iz = class extends co {
  constructor(e, t, s) {
    super({ cssIdentifier: "rich-select" }), this.params = e, this.richSelectWrapper = t, this.getSearchString = s, this.lastRowHovered = -1, this.selectedItems = /* @__PURE__ */ new Set(), this.params = e, this.setComponentCreator(this.createRowComponent.bind(this)), this.setComponentUpdater(() => {
    });
  }
  postConstruct() {
    super.postConstruct(), this.createLoadingElement();
    const { cellRowHeight: e, pickerAriaLabelKey: t, pickerAriaLabelValue: s } = this.params;
    e && this.setRowHeight(e);
    const i = this.getGui(), r = this.getAriaElement();
    this.addManagedListeners(i, {
      mousemove: this.onMouseMove.bind(this),
      mouseout: this.onMouseOut.bind(this),
      mousedown: this.onMouseDown.bind(this),
      click: this.onClick.bind(this)
    }), i.classList.add(Bf);
    const n = `${Bf}-${this.getCompId()}`;
    r.setAttribute("id", n);
    const a = this.getLocaleTextFunc()(t, s);
    ot(r, a), ih(this.richSelectWrapper, r);
  }
  navigateToPage(e) {
    const t = super.navigateToPage(e, this.lastRowHovered);
    return t != null && _s(this.beans, () => {
      if (!this.isAlive())
        return null;
      this.highlightIndex(t);
    }), t;
  }
  drawVirtualRows(e) {
    super.drawVirtualRows(e), this.refreshSelectedItems();
  }
  highlightFilterMatch(e) {
    this.forEachRenderedRow((t) => {
      t.highlightString(e);
    });
  }
  onNavigationKeyDown(e, t) {
    _s(this.beans, () => {
      if (!this.currentList || !this.isAlive())
        return;
      const s = this.currentList.length, i = this.lastRowHovered, r = e === P.DOWN ? 1 : -1, n = Math.min(Math.max(i === -1 ? 0 : i + r, 0), s - 1);
      this.highlightIndex(n), t();
    });
  }
  selectValue(e) {
    var i, r;
    if (!this.currentList)
      return this.eLoading && this.appendChild(this.eLoading), !1;
    if ((i = this.eLoading) != null && i.offsetParent && ((r = this.eLoading.parentElement) == null || r.removeChild(this.eLoading)), e == null)
      return !1;
    const t = this.getIndicesForValues(e), s = t.length > 0;
    return s && (this.refresh(), this.ensureIndexVisible(t[0]), this.refresh(!0)), this.selectListItems(Array.isArray(e) ? e : [e]), s;
  }
  selectListItems(e, t = !1) {
    t || this.selectedItems.clear();
    for (let s = 0; s < e.length; s++) {
      const i = e[s];
      this.selectedItems.has(i) || this.selectedItems.add(i);
    }
    this.refreshSelectedItems();
  }
  getCurrentList() {
    return this.currentList;
  }
  setCurrentList(e) {
    this.currentList = e, this.setModel({
      getRowCount: () => e.length,
      getRow: (t) => e[t],
      areRowsEqual: (t, s) => t === s
    });
  }
  getSelectedItems() {
    return this.selectedItems;
  }
  getLastItemHovered() {
    return this.currentList[this.lastRowHovered];
  }
  highlightIndex(e, t) {
    this.currentList && (e < 0 || e >= this.currentList.length ? this.lastRowHovered = -1 : (this.lastRowHovered = e, this.ensureIndexVisible(e, !t) && !t && this.refresh(!0)), this.forEachRenderedRow((s, i) => {
      const r = e === i;
      if (s.toggleHighlighted(r), r) {
        const n = `${Vf}-${s.getCompId()}`;
        _C(this.richSelectWrapper, n), this.richSelectWrapper.setAttribute("data-active-option", n);
      }
    }));
  }
  getIndicesForValues(e) {
    const { currentList: t } = this;
    if (!t || t.length === 0 || e == null)
      return [];
    if (Array.isArray(e) || (e = [e]), e.length === 0)
      return [];
    const s = [];
    for (let i = 0; i < e.length; i++) {
      const r = t.indexOf(e[i]);
      r >= 0 && s.push(r);
    }
    return s;
  }
  toggleListItemSelection(e) {
    this.selectedItems.has(e) ? this.selectedItems.delete(e) : this.selectedItems.add(e), this.refreshSelectedItems(), this.dispatchValueSelected();
  }
  refreshSelectedItems() {
    this.forEachRenderedRow((e) => {
      const t = this.selectedItems.has(e.getValue());
      e.updateSelected(t);
    });
  }
  createLoadingElement() {
    const e = We(this.beans), t = this.getLocaleTextFunc(), s = e.createElement("div");
    s.classList.add("ag-loading-text"), s.innerText = t("loadingOoo", "Loading..."), this.eLoading = s;
  }
  createRowComponent(e, t) {
    const s = new sz(this.params);
    t.setAttribute("id", `${Vf}-${s.getCompId()}`), s.setParentComponent(this), this.createBean(s), s.setState(e);
    const { highlightMatch: i, searchType: r = "fuzzy" } = this.params;
    return i && r !== "fuzzy" && s.highlightString(this.getSearchString()), s;
  }
  getRowForMouseEvent(e) {
    const s = this.getGui().getBoundingClientRect(), i = this.getScrollTop(), r = e.clientY - s.top + i;
    return Math.floor(r / this.getRowHeight());
  }
  onMouseMove(e) {
    const t = this.getRowForMouseEvent(e);
    t !== -1 && t != this.lastRowHovered && (this.lastRowHovered = t, this.highlightIndex(t, !0));
  }
  onMouseDown(e) {
    e.preventDefault();
  }
  onMouseOut(e) {
    this.getGui().contains(e.relatedTarget) || this.highlightIndex(-1);
  }
  onClick(e) {
    const { multiSelect: t } = this.params;
    if (!this.currentList)
      return;
    const s = this.getRowForMouseEvent(e), i = this.currentList[s];
    t ? this.toggleListItemSelection(i) : (this.selectListItems([i]), this.dispatchValueSelected());
  }
  dispatchValueSelected() {
    this.dispatchLocalEvent({
      type: "richSelectListRowSelected",
      fromEnterKey: !1,
      value: this.selectedItems
    });
  }
  destroy() {
    super.destroy(), this.eLoading = void 0;
  }
}, Yh = class extends Lh {
  constructor(e) {
    super({
      pickerAriaLabelKey: "ariaLabelRichSelectField",
      pickerAriaLabelValue: "Rich Select Field",
      pickerType: "ag-list",
      className: "ag-rich-select",
      pickerIcon: "richSelectOpen",
      ariaRole: "combobox",
      template: (e == null ? void 0 : e.template) ?? /* html */
      `
            <div class="ag-picker-field" role="presentation">
                <div data-ref="eLabel"></div>
                <div data-ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-rich-select-value ag-picker-collapsed">
                    <span data-ref="eDisplayField" class="ag-picker-field-display"></span>
                    <ag-input-text-field data-ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>
                    <span data-ref="eDeselect" class="ag-rich-select-deselect-button ag-picker-field-icon" role="presentation"></span>
                    <span data-ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></span>
                </div>
            </div>`,
      agComponents: [Ks],
      modalPicker: !1,
      ...e,
      // maxPickerHeight needs to be set after expanding `config`
      maxPickerHeight: (e == null ? void 0 : e.maxPickerHeight) ?? "calc(var(--ag-row-height) * 6.5)"
    }), this.searchString = "", this.searchStringCreator = null, this.eInput = E, this.eDeselect = E, this.skipWrapperAnnouncement = !1;
    const { value: t, valueList: s, searchStringCreator: i } = e || {};
    t !== void 0 && (this.value = t), s != null && (this.values = s), i && (this.searchStringCreator = i), this.registerCSS(tz);
  }
  wireBeans(e) {
    this.userCompFactory = e.userCompFactory, this.ariaAnnounce = e.ariaAnnounce, this.registry = e.registry;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        shouldDisplayTooltip: () => {
          var r;
          return ((r = this.shouldDisplayTooltip) == null ? void 0 : r.call(this)) ?? !0;
        }
      })
    ), super.postConstruct(), this.createListComponent(), this.eDeselect.appendChild(ue("richSelectRemove", this.beans));
    const { allowTyping: e, placeholder: t, suppressDeselectAll: s } = this.config;
    this.eDeselect.classList.add("ag-hidden"), e ? (this.eInput.setAutoComplete(!1).setInputPlaceholder(t), this.eDisplayField.classList.add("ag-hidden")) : this.eInput.setDisplayed(!1), this.setupAriaProperties();
    const { searchDebounceDelay: i = 300 } = this.config;
    this.clearSearchString = Et(this, this.clearSearchString.bind(this), i), this.renderSelectedValue(), e && this.eInput.onValueChange((r) => this.searchTextFromString(r)), this.addManagedElementListeners(this.eWrapper, { focus: this.onWrapperFocus.bind(this) }), this.addManagedElementListeners(this.eWrapper, { focusout: this.onWrapperFocusOut.bind(this) }), s || this.addManagedElementListeners(this.eDeselect, {
      mousedown: this.onDeselectAllMouseDown.bind(this),
      click: this.onDeselectAllClick.bind(this)
    });
  }
  setupAriaProperties() {
    const { eWrapper: e, gos: t } = this;
    e.tabIndex = t.get("tabIndex");
    const s = this.getLocaleTextFunc();
    this.ariaDeleteSelection = s("ariaLabelRichSelectDeleteSelection", "Press DELETE to deselect item"), this.ariaDeselectAllItems = s(
      "ariaLabelRichSelectDeselectAllItems",
      "Press DELETE to deselect all items"
    ), this.ariaToggleSelection = s("ariaLabelRichSelectToggleSelection", "Press SPACE to toggle selection");
  }
  createListComponent() {
    this.listComponent = this.createBean(new iz(this.config, this.eWrapper, () => this.searchString)), this.listComponent.setParentComponent(this), this.addManagedListeners(this.listComponent, {
      richSelectListRowSelected: (e) => {
        this.onListValueSelected(e.value, e.fromEnterKey);
      }
    });
  }
  renderSelectedValue() {
    var p;
    const { value: e, eDisplayField: t, config: s, gos: i } = this, {
      allowTyping: r,
      cellRenderer: n,
      initialInputValue: o,
      multiSelect: a,
      suppressDeselectAll: l,
      suppressMultiSelectPillRenderer: c
    } = s, d = this.config.valueFormatter ? this.config.valueFormatter(e) : e;
    if (r) {
      this.eInput.setValue(o ?? d);
      return;
    }
    if (a && !l) {
      const g = e == null || Array.isArray(e) && e.length === 0;
      this.eDeselect.classList.toggle("ag-hidden", g);
    }
    let u;
    if (a && !c) {
      this.createOrUpdatePillContainer(t);
      return;
    }
    n && (u = Zv(
      this.userCompFactory,
      s,
      {
        value: e,
        valueFormatted: d,
        getValue: () => this.getValue(),
        setValue: (g) => {
          this.setValue(g, !0);
        },
        setTooltip: (g, f) => {
          var m;
          i.assertModuleRegistered("Tooltip", 3), this.shouldDisplayTooltip = f, (m = this.tooltipFeature) == null || m.setTooltipAndRefresh(g);
        }
      }
    ));
    let h;
    if (u && (h = u.newAgStackInstance()), h)
      ze(t), dv(h, t), h.then((g) => {
        this.addDestroyFunc(() => this.destroyBean(g));
      });
    else {
      if (W(this.value))
        t.innerText = d, t.classList.remove("ag-display-as-placeholder");
      else {
        const { placeholder: g } = s;
        W(g) ? (t.innerHTML = `${Ke(g)}`, t.classList.add("ag-display-as-placeholder")) : ze(t);
      }
      this.shouldDisplayTooltip = un(() => this.eDisplayField), (p = this.tooltipFeature) == null || p.setTooltipAndRefresh(d ?? null);
    }
  }
  createPickerComponent() {
    const { values: e } = this;
    return e && this.setValueList({ valueList: e }), this.listComponent;
  }
  setSearchStringCreator(e) {
    this.searchStringCreator = e;
  }
  setValueList(e) {
    const { valueList: t, refresh: s } = e;
    !this.listComponent || this.listComponent.getCurrentList() === t || (this.listComponent.setCurrentList(t), s && (this.values ? this.listComponent.refresh(!0) : (this.values = t, this.isPickerDisplayed && (this.listComponent.selectValue(this.value) || this.listComponent.refresh())), this.alignPickerToComponent()));
  }
  showPicker() {
    super.showPicker();
    const { listComponent: e, value: t } = this;
    if (!e)
      return;
    let s = null;
    this.value != null && (e.selectValue(this.value), s = e.getIndicesForValues(Array.isArray(t) ? t : [t])[0]), s != null ? e.highlightIndex(s) : e.refresh(), this.displayOrHidePicker();
  }
  beforeHidePicker() {
    super.beforeHidePicker();
  }
  createOrUpdatePillContainer(e) {
    if (!this.pillContainer) {
      const t = this.pillContainer = this.createBean(new ez());
      this.addDestroyFunc(() => {
        this.destroyBean(this.pillContainer), this.pillContainer = null;
      }), ze(e), e.appendChild(t.getGui()), t.init({
        eWrapper: this.eWrapper,
        onPillMouseDown: (s) => {
          s.stopImmediatePropagation();
        },
        announceItemFocus: () => {
          this.announceAriaValue(this.ariaDeleteSelection);
        },
        getValue: () => this.getValue(),
        setValue: (s) => this.setValue(s, !0)
      });
    }
    this.doWhileBlockingAnnouncement(() => {
      var t;
      return (t = this.pillContainer) == null ? void 0 : t.refresh();
    });
  }
  doWhileBlockingAnnouncement(e) {
    this.skipWrapperAnnouncement = !0, e(), this.skipWrapperAnnouncement = !1;
  }
  onWrapperFocus() {
    const { eInput: e, config: t } = this, { allowTyping: s, multiSelect: i, suppressDeselectAll: r } = t;
    if (s) {
      const n = e.getFocusableElement();
      n.focus(), n.select();
    } else i && !r && !this.skipWrapperAnnouncement && this.announceAriaValue(this.ariaDeselectAllItems);
  }
  onWrapperFocusOut(e) {
    this.eWrapper.contains(e.relatedTarget) || this.hidePicker();
  }
  onDeselectAllMouseDown(e) {
    e.stopImmediatePropagation();
  }
  onDeselectAllClick() {
    this.setValue([], !0);
  }
  buildSearchStringFromKeyboardEvent(e) {
    let { key: t } = e;
    if (t === P.BACKSPACE)
      this.searchString = this.searchString.slice(0, -1), t = "";
    else if (!Fh(e))
      return;
    e.preventDefault(), this.searchTextFromCharacter(t);
  }
  searchTextFromCharacter(e) {
    this.searchString += e, this.runSearch(), this.clearSearchString();
  }
  searchTextFromString(e) {
    e == null && (e = ""), this.searchString = e, this.runSearch();
  }
  buildSearchStrings(e) {
    const { valueFormatter: t = (i) => i } = this.config;
    let s;
    return typeof e[0] == "number" || typeof e[0] == "string" ? s = e.map((i) => t(i)) : typeof e[0] == "object" && this.searchStringCreator && (s = this.searchStringCreator(e)), s;
  }
  filterListModel(e) {
    const { filterList: t } = this.config;
    t && this.setValueList({ valueList: e, refresh: !0 });
  }
  runSearch() {
    var c, d, u, h, p;
    if (!this.listComponent)
      return;
    const { values: e } = this, t = this.buildSearchStrings(e);
    if (!t) {
      this.listComponent.highlightIndex(-1);
      return;
    }
    const { suggestions: s, filteredValues: i } = this.getSuggestionsAndFilteredValues(this.searchString, t), { filterList: r, highlightMatch: n, searchType: o = "fuzzy" } = this.config, a = i.length, l = !!(r && this.searchString !== "");
    if (this.filterListModel(l ? i : e), s.length) {
      const g = l ? 0 : t.indexOf(s[0]);
      (c = this.listComponent) == null || c.highlightIndex(g);
    } else if ((d = this.listComponent) == null || d.highlightIndex(-1), !l || a)
      (u = this.listComponent) == null || u.ensureIndexVisible(0);
    else if (l) {
      this.getAriaElement().removeAttribute("data-active-option");
      const g = (h = this.listComponent) == null ? void 0 : h.getAriaElement();
      g && _C(g, null);
    }
    n && o !== "fuzzy" && ((p = this.listComponent) == null || p.highlightFilterMatch(this.searchString)), this.displayOrHidePicker();
  }
  getSuggestionsAndFilteredValues(e, t) {
    let s = [];
    const i = [];
    if (!e.length)
      return { suggestions: s, filteredValues: i };
    const { searchType: r = "fuzzy", filterList: n } = this.config;
    if (r === "fuzzy") {
      const o = Rc({
        inputValue: e,
        allSuggestions: t,
        hideIrrelevant: !0,
        addSequentialWeight: !0
      });
      s = o.values;
      const a = o.indices;
      if (n && a.length)
        for (let l = 0; l < a.length; l++)
          i.push(this.values[a[l]]);
    } else
      s = t.filter((o, a) => {
        const l = o.toLocaleLowerCase(), c = this.searchString.toLocaleLowerCase(), d = r === "match" ? l.startsWith(c) : l.indexOf(c) !== -1;
        return n && d && i.push(this.values[a]), d;
      });
    return { suggestions: s, filteredValues: i };
  }
  displayOrHidePicker() {
    if (!this.listComponent)
      return;
    const e = this.listComponent.getGui(), t = this.listComponent.getCurrentList(), s = t ? t.length === 0 : !1;
    e.classList.toggle("ag-hidden", s);
  }
  clearSearchString() {
    this.searchString = "";
  }
  setValue(e, t, s, i) {
    var n, o;
    if (this.value === e)
      return this;
    const r = Array.isArray(e);
    if (e != null) {
      if (!r) {
        const a = (n = this.listComponent) == null ? void 0 : n.getCurrentList();
        if ((a ? a.indexOf(e) : -1) === -1)
          return this;
      }
      s || (o = this.listComponent) == null || o.selectValue(e);
    }
    return super.setValue(e, t), i || this.renderSelectedValue(), this;
  }
  onNavigationKeyDown(e, t, s) {
    var r;
    e.preventDefault();
    const i = t === P.DOWN;
    if (!this.isPickerDisplayed && i) {
      this.showPicker();
      return;
    }
    (r = this.listComponent) == null || r.onNavigationKeyDown(t, s);
  }
  onEnterKeyDown(e) {
    var t;
    if (this.isPickerDisplayed && (e.preventDefault(), (t = this.listComponent) != null && t.getCurrentList())) {
      const s = this.listComponent.getLastItemHovered();
      this.config.multiSelect || s == null ? this.dispatchPickerEventAndHidePicker(this.value, !0) : this.onListValueSelected(/* @__PURE__ */ new Set([s]), !0);
    }
  }
  onDeleteKeyDown(e) {
    const { eWrapper: t, beans: s } = this;
    Ie(s) === t && (e.preventDefault(), this.setValue([], !0));
  }
  onTabKeyDown() {
    const { config: e, isPickerDisplayed: t, listComponent: s } = this, { multiSelect: i } = e;
    if (!(!t || !s)) {
      if (i) {
        const r = this.getValueFromSet(s.getSelectedItems());
        r && this.setValue(r, !1, !0, !0);
      } else
        this.setValue(s.getLastItemHovered(), !1, !0);
      this.hidePicker();
    }
  }
  getValueFromSet(e) {
    const { multiSelect: t } = this.config;
    let s = null;
    for (const i of e) {
      if (e.size === 1 && !t) {
        s = i;
        break;
      }
      s || (s = []), s.push(i);
    }
    return Array.isArray(s) && s.sort(), s;
  }
  onListValueSelected(e, t) {
    const s = this.getValueFromSet(e);
    this.setValue(s, !1, !0), this.config.multiSelect || this.dispatchPickerEventAndHidePicker(s, t);
  }
  dispatchPickerEventAndHidePicker(e, t) {
    const s = {
      type: "fieldPickerValueSelected",
      fromEnterKey: t,
      value: e
    };
    this.dispatchLocalEvent(s), this.hidePicker();
  }
  getFocusableElement() {
    const { allowTyping: e } = this.config;
    return e ? this.eInput.getFocusableElement() : super.getFocusableElement();
  }
  onKeyDown(e) {
    var c;
    const { key: t } = e, { isPickerDisplayed: s, config: i, listComponent: r, pickerComponent: n } = this, { allowTyping: o, multiSelect: a, suppressDeselectAll: l } = i;
    switch (t) {
      case P.LEFT:
      case P.RIGHT:
        (!o || this.pillContainer) && (e.preventDefault(), this.pillContainer && ((c = this.listComponent) == null || c.highlightIndex(-1), this.pillContainer.onNavigationKeyDown(e)));
        break;
      case P.PAGE_HOME:
      case P.PAGE_END:
        if (o) {
          e.preventDefault();
          const d = this.eInput.getInputElement(), u = t === P.PAGE_HOME ? 0 : d.value.length;
          d.setSelectionRange(u, u);
          break;
        }
      case P.PAGE_UP:
      case P.PAGE_DOWN:
        e.preventDefault(), n && (r == null || r.navigateToPage(t));
        break;
      case P.DOWN:
      case P.UP:
        this.onNavigationKeyDown(e, t, () => {
          a && (this.doWhileBlockingAnnouncement(() => this.eWrapper.focus()), this.announceAriaValue(this.ariaToggleSelection));
        });
        break;
      case P.ESCAPE:
        s && (Xt(this.listComponent.getGui()) && (e.preventDefault(), gt(e)), this.hidePicker());
        break;
      case P.ENTER:
        this.onEnterKeyDown(e);
        break;
      case P.SPACE:
        if (s && a && r) {
          e.preventDefault();
          const d = r.getLastItemHovered();
          d && r.toggleListItemSelection(d);
        }
        break;
      case P.TAB:
        this.onTabKeyDown();
        break;
      case P.DELETE:
        a && !l && this.onDeleteKeyDown(e);
        break;
      default:
        o || this.buildSearchStringFromKeyboardEvent(e);
    }
  }
  announceAriaValue(e) {
    var t;
    (t = this.ariaAnnounce) == null || t.announceValue(e, "richSelect");
  }
  destroy() {
    this.listComponent && (this.listComponent = this.destroyBean(this.listComponent)), super.destroy();
  }
}, db = class extends Yh {
  constructor(e) {
    super({
      ...e,
      template: (
        /* html */
        `
                <div class="ag-picker-field" role="presentation">
                    <div data-ref="eLabel"></div>
                    <div data-ref="eWrapper" class="ag-wrapper ag-picker-collapsed">
                        <div data-ref="eDisplayField" class="ag-picker-field-display"></div>
                        <ag-input-text-field data-ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>
                        <span data-ref="eDeselect" class="ag-rich-select-deselect-button ag-picker-field-icon" role="presentation"></span>
                        <div data-ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
                    </div>
                </div>`
      ),
      agComponents: [Ks]
    }), this.params = e;
  }
  showPicker() {
    setTimeout(() => super.showPicker());
  }
  hidePicker() {
    setTimeout(() => super.hidePicker());
  }
  postConstruct() {
    super.postConstruct();
    const { wrapperClassName: e, ariaLabel: t } = this.params;
    re(this.eDisplayField, !1), e && this.eWrapper.classList.add(e), xr(this.eWrapper, ""), ot(this.eWrapper, t);
  }
  onEnterKeyDown(e) {
    gt(e), this.isPickerDisplayed ? super.onEnterKeyDown(e) : (e.preventDefault(), this.showPicker());
  }
}, ub = class extends L {
  constructor(e, t, s) {
    super(), this.eGui = e, this.focusWrapper = t, this.eFocusableComp = s;
  }
  postConstruct() {
    this.addManagedElementListeners(this.eGui, {
      keydown: (t) => {
        switch (t.key) {
          case P.TAB:
            t.defaultPrevented || gt(t);
            break;
          case P.UP:
          case P.DOWN:
            gt(t);
            break;
          case P.ESCAPE:
            if (Ds(t))
              return;
            this.eGui.contains(Ie(this.beans)) && (t.preventDefault(), gt(t), this.focusWrapper.focus());
            break;
        }
      }
    });
    const e = "ag-advanced-filter-builder-virtual-list-item-highlight";
    this.addManagedListeners(this.focusWrapper, {
      keydown: (t) => {
        switch (t.key) {
          case P.ENTER:
            if (Ds(t))
              return;
            Ie(this.beans) === this.focusWrapper && (t.preventDefault(), gt(t), this.eFocusableComp.getFocusableElement().focus());
            break;
        }
      },
      focusin: () => {
        this.focusWrapper.classList.add(e);
      },
      focusout: (t) => {
        this.focusWrapper.contains(t.relatedTarget) || this.focusWrapper.classList.remove(e);
      }
    });
  }
};
function hb(e, t) {
  return {
    pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderAddField",
    pickerAriaLabelValue: "Advanced Filter Builder Add Field",
    pickerType: "ag-list",
    valueList: [
      {
        key: "condition",
        displayValue: e("advancedFilterBuilderAddCondition")
      },
      {
        key: "join",
        displayValue: e("advancedFilterBuilderAddJoin")
      }
    ],
    valueFormatter: (s) => s == null ? null : s.displayValue ?? s.key,
    pickerIcon: "advancedFilterBuilderAdd",
    maxPickerWidth: `${t ?? 120}px`,
    wrapperClassName: "ag-advanced-filter-builder-item-button",
    ariaLabel: e("advancedFilterBuilderAddButtonTooltip")
  };
}
var rz = class extends _ {
  constructor(e, t) {
    super(
      /* html */
      `
            <div class="ag-advanced-filter-builder-item-wrapper" role="presentation">
                <div data-ref="eItem" class="ag-advanced-filter-builder-item" role="presentation">
                    <div class="ag-advanced-filter-builder-item-tree-lines" aria-hidden="true">
                        <div class="ag-advanced-filter-builder-item-tree-line-vertical-top ag-advanced-filter-builder-item-tree-line-horizontal"></div>
                    </div>
                </div>
            </div>
        `
    ), this.item = e, this.focusWrapper = t, this.eItem = E;
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc, this.registry = e.registry;
  }
  postConstruct() {
    var s;
    ha(this.focusWrapper, 2);
    const e = hb(
      (i) => this.advFilterExpSvc.translate(i),
      (s = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : s.addSelectWidth
    ), t = this.createManagedBean(new db(e));
    this.addManagedListeners(t, {
      fieldPickerValueSelected: ({ value: i }) => {
        this.dispatchLocalEvent({
          type: "advancedFilterBuilderAdded",
          item: this.item,
          isJoin: i.key === "join"
        });
      }
    }), this.eItem.appendChild(t.getGui()), this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => t.getGui(),
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip")
      })
    ), this.createManagedBean(
      new ub(this.getGui(), this.focusWrapper, t)
    ), ot(
      this.focusWrapper,
      this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItem", [
        this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip"),
        `${this.item.level + 1}`
      ])
    );
  }
  afterAdd() {
  }
}, nz = class extends _ {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-advanced-filter-builder-item-condition" role="presentation"></div>
        `
    ), this.validationMessage = null;
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc;
  }
  init(e) {
    const { item: t, createPill: s } = e;
    this.item = t, this.createPill = s, this.filterModel = t.filterModel, this.setupColumnCondition(this.filterModel), this.validate(), this.addDestroyFunc(() => this.destroyBeans([this.eColumnPill, this.eOperatorPill, this.eOperandPill]));
  }
  getDragName() {
    return this.filterModel.colId ? this.advFilterExpSvc.parseColumnFilterModel(this.filterModel) : this.getDefaultColumnDisplayValue();
  }
  getAriaLabel() {
    return `${this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderFilterItem")} ${this.getDragName()}`;
  }
  getValidationMessage() {
    return this.validationMessage;
  }
  getFocusableElement() {
    return this.eColumnPill.getFocusableElement();
  }
  setupColumnCondition(e) {
    const t = this.advFilterExpSvc.getColumnDetails(e.colId);
    this.baseCellDataType = t.baseCellDataType, this.column = t.column, this.numOperands = this.getNumOperands(this.getOperatorKey()), this.eColumnPill = this.createPill({
      key: this.getColumnKey(),
      displayValue: this.getColumnDisplayValue() ?? this.getDefaultColumnDisplayValue(),
      cssClass: "ag-advanced-filter-builder-column-pill",
      isSelect: !0,
      getEditorParams: () => ({ values: this.advFilterExpSvc.getColumnAutocompleteEntries() }),
      update: (s) => this.setColumnKey(s),
      pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderColumnSelectField",
      pickerAriaLabelValue: "Advanced Filter Builder Column Select Field",
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderColumn")
    }), this.getGui().appendChild(this.eColumnPill.getGui()), W(this.getColumnKey()) && (this.createOperatorPill(), this.hasOperand() && this.createOperandPill());
  }
  createOperatorPill() {
    this.eOperatorPill = this.createPill({
      key: this.getOperatorKey(),
      displayValue: this.getOperatorDisplayValue() ?? this.getDefaultOptionSelectValue(),
      cssClass: "ag-advanced-filter-builder-option-pill",
      isSelect: !0,
      getEditorParams: () => ({ values: this.getOperatorAutocompleteEntries() }),
      update: (e) => this.setOperatorKey(e),
      pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderOptionSelectField",
      pickerAriaLabelValue: "Advanced Filter Builder Option Select Field",
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderOption")
    }), this.eColumnPill.getGui().insertAdjacentElement("afterend", this.eOperatorPill.getGui());
  }
  createOperandPill() {
    const { filter: e } = this.filterModel, t = (typeof e == "number" ? Cs(e) : e) ?? "";
    this.eOperandPill = this.createPill({
      key: t,
      // Convert from the input format to display format.
      // Input format matches model format except for numbers, but these get stringified anyway
      valueFormatter: (s) => this.advFilterExpSvc.getOperandDisplayValue({ ...this.filterModel, filter: s }, !0),
      baseCellDataType: this.baseCellDataType,
      cssClass: "ag-advanced-filter-builder-value-pill",
      isSelect: !1,
      update: (s) => this.setOperand(s),
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderValue")
    }), this.getGui().appendChild(this.eOperandPill.getGui());
  }
  getColumnKey() {
    return this.filterModel.colId;
  }
  getColumnDisplayValue() {
    return this.advFilterExpSvc.getColumnDisplayValue(this.filterModel);
  }
  getOperatorKey() {
    return this.filterModel.type;
  }
  getOperatorDisplayValue() {
    return this.advFilterExpSvc.getOperatorDisplayValue(this.filterModel);
  }
  getOperandDisplayValue() {
    return this.advFilterExpSvc.getOperandDisplayValue(this.filterModel, !0);
  }
  hasOperand() {
    return this.numOperands > 0;
  }
  getOperatorAutocompleteEntries() {
    return this.column ? this.advFilterExpSvc.getOperatorAutocompleteEntries(this.column, this.baseCellDataType) : [];
  }
  setColumnKey(e) {
    this.eOperatorPill || this.createOperatorPill();
    const t = this.advFilterExpSvc.getColumnDetails(e);
    this.column = t.column;
    const s = t.baseCellDataType;
    this.baseCellDataType !== s && (this.baseCellDataType = s, this.setOperatorKey(void 0), this.eOperatorPill && (ut(this.eOperatorPill.getGui()), this.destroyBean(this.eOperatorPill), this.createOperatorPill()), this.validate()), this.filterModel.colId = e, this.filterModel.filterType = this.baseCellDataType;
  }
  setOperatorKey(e) {
    const t = this.getNumOperands(e);
    t !== this.numOperands && (this.numOperands = t, t === 0 ? this.destroyOperandPill() : (this.createOperandPill(), this.baseCellDataType !== "number" && this.setOperand(""))), this.filterModel.type = e, this.validate();
  }
  setOperand(e) {
    let t = e;
    this.baseCellDataType === "number" && (t = W(e) ? Number(e) : ""), this.filterModel.filter = t, this.validate();
  }
  getNumOperands(e) {
    var t;
    return ((t = this.advFilterExpSvc.getExpressionOperator(this.baseCellDataType, e)) == null ? void 0 : t.numOperands) ?? 0;
  }
  destroyOperandPill() {
    delete this.filterModel.filter, this.getGui().removeChild(this.eOperandPill.getGui()), this.destroyBean(this.eOperandPill), this.eOperandPill = void 0;
  }
  validate() {
    let e = null;
    W(this.getColumnKey()) ? W(this.getOperatorKey()) ? this.numOperands > 0 && !W(this.getOperandDisplayValue()) && (e = this.advFilterExpSvc.translate("advancedFilterBuilderValidationEnterValue")) : e = this.advFilterExpSvc.translate("advancedFilterBuilderValidationSelectOption") : e = this.advFilterExpSvc.translate("advancedFilterBuilderValidationSelectColumn"), this.item.valid = !e, e !== this.validationMessage && (this.validationMessage = e, this.dispatchLocalEvent({
      type: "advancedFilterBuilderValidChanged"
    }));
  }
  getDefaultColumnDisplayValue() {
    return this.advFilterExpSvc.translate("advancedFilterBuilderSelectColumn");
  }
  getDefaultOptionSelectValue() {
    return this.advFilterExpSvc.translate("advancedFilterBuilderSelectOption");
  }
}, oz = class extends _ {
  constructor(e) {
    super(
      /* html */
      `
            <div class="ag-advanced-filter-builder-pill-wrapper" role="presentation">
                <div data-ref="ePill" class="ag-advanced-filter-builder-pill" role="button">
                    <span data-ref="eLabel" class="ag-advanced-filter-builder-pill-display"></span>
                </div>
            </div>
        `
    ), this.params = e, this.ePill = E, this.eLabel = E;
    const { value: t, valueFormatter: s } = e;
    this.value = t, this.displayValue = s(t);
  }
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc;
  }
  postConstruct() {
    const { cssClass: e, ariaLabel: t } = this.params;
    this.ePill.classList.add(e), this.activateTabIndex([this.ePill]), this.eLabel.id = `${this.getCompId()}`, sc(this.ePill, this.eLabel.id), ot(this.ePill, t), this.renderValue(), this.addManagedListeners(this.ePill, {
      click: (s) => {
        s.preventDefault(), this.showEditor();
      },
      keydown: (s) => {
        switch (s.key) {
          case P.ENTER:
            s.preventDefault(), gt(s), this.showEditor();
            break;
        }
      }
    }), this.addDestroyFunc(() => this.destroyBean(this.eEditor));
  }
  getFocusableElement() {
    return this.ePill;
  }
  showEditor() {
    if (this.eEditor)
      return;
    re(this.ePill, !1), this.eEditor = this.createEditorComp(this.params.type), this.eEditor.setValue(this.value);
    const e = this.eEditor.getGui();
    this.eEditor.addManagedElementListeners(e, {
      keydown: (t) => {
        switch (t.key) {
          case P.ENTER:
            t.preventDefault(), gt(t), this.updateValue(!0);
            break;
          case P.ESCAPE:
            t.preventDefault(), gt(t), this.hideEditor(!0);
            break;
        }
      },
      focusout: () => this.updateValue(!1)
    }), this.getGui().appendChild(e), this.eEditor.getFocusableElement().focus();
  }
  createEditorComp(e) {
    let t;
    switch (e) {
      case "text":
        t = new li();
        break;
      case "number":
        t = new vc();
        break;
      case "date":
        t = new Ww();
        break;
    }
    return this.createBean(t);
  }
  hideEditor(e) {
    const { eEditor: t } = this;
    t && (this.eEditor = void 0, this.getGui().removeChild(t.getGui()), this.destroyBean(t), re(this.ePill, !0), e && this.ePill.focus());
  }
  renderValue() {
    let e;
    const { displayValue: t, eLabel: s } = this, { classList: i } = s;
    i.remove(
      "ag-advanced-filter-builder-value-empty",
      "ag-advanced-filter-builder-value-number",
      "ag-advanced-filter-builder-value-text"
    ), W(t) ? this.params.type === "number" ? (e = t, i.add("ag-advanced-filter-builder-value-number")) : (e = `"${t}"`, i.add("ag-advanced-filter-builder-value-text")) : (e = this.advFilterExpSvc.translate("advancedFilterBuilderEnterValue"), i.add("ag-advanced-filter-builder-value-empty")), s.innerText = e;
  }
  updateValue(e) {
    if (!this.eEditor)
      return;
    const t = this.eEditor.getValue() ?? "";
    this.dispatchLocalEvent({
      type: "fieldValueChanged",
      value: t
    }), this.value = t, this.displayValue = this.params.valueFormatter(t), this.renderValue(), this.hideEditor(e);
  }
}, az = class extends _ {
  wireBeans(e) {
    this.advFilterExpSvc = e.advFilterExpSvc;
  }
  constructor() {
    super(
      /* html */
      `
            <div class="ag-advanced-filter-builder-item-condition" role="presentation"></div>
        `
    );
  }
  init(e) {
    const { item: t, createPill: s } = e, i = t.filterModel;
    this.filterModel = i, this.ePill = s({
      key: i.type,
      displayValue: this.advFilterExpSvc.parseJoinOperator(i),
      cssClass: "ag-advanced-filter-builder-join-pill",
      isSelect: !0,
      getEditorParams: () => ({
        values: this.advFilterExpSvc.getJoinOperatorAutocompleteEntries()
      }),
      update: (r) => i.type = r,
      pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderJoinSelectField",
      pickerAriaLabelValue: "Advanced Filter Builder Join Operator Select Field",
      ariaLabel: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderJoinOperator")
    }), this.getGui().appendChild(this.ePill.getGui()), this.addDestroyFunc(() => this.destroyBean(this.ePill));
  }
  getDragName() {
    return this.advFilterExpSvc.parseJoinOperator(this.filterModel);
  }
  getAriaLabel() {
    return `${this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderGroupItem")} ${this.getDragName()}`;
  }
  getValidationMessage() {
    return null;
  }
  getFocusableElement() {
    return this.ePill.getFocusableElement();
  }
}, lz = class extends Yh {
  constructor(e) {
    super({
      ...e,
      template: (
        /* html */
        `
                <div class="ag-picker-field ag-advanced-filter-builder-pill-wrapper" role="presentation">
                    <div data-ref="eLabel"></div>
                    <div data-ref="eWrapper" class="ag-wrapper ag-advanced-filter-builder-pill ag-picker-collapsed">
                        <div data-ref="eDisplayField" class="ag-picker-field-display ag-advanced-filter-builder-pill-display"></div>
                        <ag-input-text-field data-ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>
                        <span data-ref="eDeselect" class="ag-rich-select-deselect-button ag-picker-field-icon" role="presentation"></span>
                        <div data-ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
                    </div>
                </div>`
      ),
      agComponents: [Ks]
    }), this.params = e;
  }
  getFocusableElement() {
    return this.eWrapper;
  }
  showPicker() {
    setTimeout(() => super.showPicker());
  }
  hidePicker() {
    setTimeout(() => super.hidePicker());
  }
  postConstruct() {
    super.postConstruct();
    const { wrapperClassName: e, ariaLabel: t } = this.params;
    this.eWrapper.classList.add(e), xr(this.eWrapper, ""), ot(this.eWrapper, t);
  }
  createPickerComponent() {
    if (!this.values) {
      const { values: e } = this.params.getEditorParams();
      this.values = e;
      const t = this.value.key, s = e.find((i) => i.key === t) ?? {
        key: t,
        displayValue: this.value.displayValue
      };
      this.value = s;
    }
    return super.createPickerComponent();
  }
  onEnterKeyDown(e) {
    gt(e), this.isPickerDisplayed ? super.onEnterKeyDown(e) : (e.preventDefault(), this.showPicker());
  }
}, kd = class extends Ti {
  constructor(e, t, s) {
    super(
      /* html */
      `
            <div class="ag-advanced-filter-builder-item-wrapper" role="presentation">
                <div class="ag-advanced-filter-builder-item" role="presentation">
                    <div data-ref="eTreeLines" class="ag-advanced-filter-builder-item-tree-lines" aria-hidden="true"></div>
                    <span data-ref="eDragHandle" class="ag-drag-handle" aria-hidden="true"></span>
                    <span data-ref="eValidation" class="ag-advanced-filter-builder-item-button ag-advanced-filter-builder-invalid" aria-hidden="true"></span>
                </div>
                <div data-ref="eButtons" class="ag-advanced-filter-builder-item-buttons">
                    <span data-ref="eMoveUpButton" class="ag-advanced-filter-builder-item-button" role="button"></span>
                    <span data-ref="eMoveDownButton" class="ag-advanced-filter-builder-item-button" role="button"></span>
                    <div data-ref="eAddButton" role="presentation"></div>
                    <span data-ref="eRemoveButton" class="ag-advanced-filter-builder-item-button" role="button"></span>
                </div>
            </div>
        `
    ), this.item = e, this.dragFeature = t, this.focusWrapper = s, this.eTreeLines = E, this.eDragHandle = E, this.eButtons = E, this.eValidation = E, this.eMoveUpButton = E, this.eMoveDownButton = E, this.eAddButton = E, this.eRemoveButton = E, this.moveUpDisabled = !1, this.moveDownDisabled = !1;
  }
  wireBeans(e) {
    this.dragAndDrop = e.dragAndDrop, this.advFilterExpSvc = e.advFilterExpSvc, this.registry = e.registry;
  }
  postConstruct() {
    const { filterModel: e, level: t, showMove: s } = this.item, i = e.filterType === "join";
    if (this.ePillWrapper = this.createManagedBean(i ? new az() : new nz()), this.ePillWrapper.init({ item: this.item, createPill: (r) => this.createPill(r) }), this.eDragHandle.insertAdjacentElement("afterend", this.ePillWrapper.getGui()), t === 0) {
      const r = document.createElement("div");
      r.classList.add("ag-advanced-filter-builder-item-tree-line-vertical-bottom"), r.classList.add("ag-advanced-filter-builder-item-tree-line-root"), this.eTreeLines.appendChild(r), re(this.eDragHandle, !1), re(this.eButtons, !1), ns(this.focusWrapper, !0);
    } else
      this.setupTreeLines(t), this.eDragHandle.appendChild(ue("advancedFilterBuilderDrag", this.beans)), this.setupValidation(), this.setupMoveButtons(s), this.setupAddButton(), this.setupRemoveButton(), this.setupDragging(), this.updateAriaExpanded();
    ha(this.focusWrapper, t + 1), this.initialiseTabGuard({}), this.createManagedBean(
      new ub(this.getGui(), this.focusWrapper, this.ePillWrapper)
    ), this.updateAriaLabel(), this.addManagedListeners(this.ePillWrapper, {
      advancedFilterBuilderValueChanged: () => this.dispatchLocalEvent({
        type: "advancedFilterBuilderValueChanged"
      }),
      advancedFilterBuilderValidChanged: () => this.updateValidity()
    });
  }
  setState(e) {
    var a, l;
    const { level: t } = this.item;
    if (t === 0)
      return;
    const { showMove: s } = this.item, { disableMoveUp: i, disableMoveDown: r, treeLines: n, showStartTreeLine: o } = e;
    this.updateTreeLines(n, o), this.updateAriaExpanded(), s && (this.moveUpDisabled = !!i, this.moveDownDisabled = !!r, this.eMoveUpButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", i), this.eMoveDownButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", r), wl(this.eMoveUpButton, !!i), wl(this.eMoveDownButton, !!r), (a = this.moveUpTooltipFeature) == null || a.refreshTooltip(), (l = this.moveDownTooltipFeature) == null || l.refreshTooltip());
  }
  focusMoveButton(e) {
    (e ? this.eMoveUpButton : this.eMoveDownButton).focus();
  }
  afterAdd() {
    this.ePillWrapper.getFocusableElement().focus();
  }
  setupTreeLines(e) {
    for (let t = 0; t < e; t++) {
      const s = document.createElement("div");
      this.eTreeLines.appendChild(s);
    }
  }
  updateTreeLines(e, t) {
    const s = e.length - 1, { children: i } = this.eTreeLines;
    for (let n = 0; n < s; n++) {
      const o = i.item(n);
      o && o.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !e[n]);
    }
    const r = i.item(s);
    if (r) {
      r.classList.add("ag-advanced-filter-builder-item-tree-line-horizontal");
      const n = e[s];
      r.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical-top", n), r.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !n);
    }
    this.eDragHandle.classList.toggle(
      "ag-advanced-filter-builder-item-tree-line-vertical-bottom",
      t
    );
  }
  setupValidation() {
    this.eValidation.appendChild(ue("advancedFilterBuilderInvalid", this.beans)), this.validationTooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eValidation,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.ePillWrapper.getValidationMessage(),
        getTooltipShowDelayOverride: () => 1e3
      })
    ), this.updateValidity();
  }
  setupAddButton() {
    var s;
    const e = hb(
      (i) => this.advFilterExpSvc.translate(i),
      (s = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : s.addSelectWidth
    ), t = this.createManagedBean(new db(e));
    this.addManagedListeners(t, {
      fieldPickerValueSelected: ({ value: i }) => this.dispatchLocalEvent({
        type: "advancedFilterBuilderAdded",
        item: this.item,
        isJoin: i.key === "join"
      })
    }), this.eAddButton.appendChild(t.getGui()), this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eAddButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.advFilterExpSvc.translate("advancedFilterBuilderAddButtonTooltip")
      })
    );
  }
  setupRemoveButton() {
    this.eRemoveButton.appendChild(ue("advancedFilterBuilderRemove", this.beans)), this.addManagedListeners(this.eRemoveButton, {
      click: () => this.removeItem(),
      keydown: (e) => {
        switch (e.key) {
          case P.ENTER:
            e.preventDefault(), gt(e), this.removeItem();
            break;
        }
      }
    }), this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eRemoveButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.advFilterExpSvc.translate("advancedFilterBuilderRemoveButtonTooltip")
      })
    ), ot(this.eRemoveButton, this.advFilterExpSvc.translate("advancedFilterBuilderRemoveButtonTooltip")), this.activateTabIndex([this.eRemoveButton]);
  }
  setupMoveButtons(e) {
    e ? (this.eMoveUpButton.appendChild(ue("advancedFilterBuilderMoveUp", this.beans)), this.addManagedListeners(this.eMoveUpButton, {
      click: () => this.moveItem(!0),
      keydown: (t) => {
        switch (t.key) {
          case P.ENTER:
            t.preventDefault(), gt(t), this.moveItem(!0);
            break;
        }
      }
    }), this.moveUpTooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eMoveUpButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.moveUpDisabled ? null : this.advFilterExpSvc.translate("advancedFilterBuilderMoveUpButtonTooltip")
      })
    ), ot(
      this.eMoveUpButton,
      this.advFilterExpSvc.translate("advancedFilterBuilderMoveUpButtonTooltip")
    ), this.eMoveDownButton.appendChild(ue("advancedFilterBuilderMoveDown", this.beans)), this.addManagedListeners(this.eMoveDownButton, {
      click: () => this.moveItem(!1),
      keydown: (t) => {
        switch (t.key) {
          case P.ENTER:
            t.preventDefault(), gt(t), this.moveItem(!1);
            break;
        }
      }
    }), this.moveDownTooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eMoveDownButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.moveDownDisabled ? null : this.advFilterExpSvc.translate("advancedFilterBuilderMoveDownButtonTooltip")
      })
    ), ot(
      this.eMoveDownButton,
      this.advFilterExpSvc.translate("advancedFilterBuilderMoveDownButtonTooltip")
    ), this.activateTabIndex([this.eMoveUpButton, this.eMoveDownButton])) : (re(this.eMoveUpButton, !1), re(this.eMoveDownButton, !1));
  }
  updateValidity() {
    var e;
    iv(this.eValidation, !this.item.valid), (e = this.validationTooltipFeature) == null || e.refreshTooltip(), this.updateAriaLabel();
  }
  createPill(e) {
    const { key: t, cssClass: s, update: i, ariaLabel: r } = e, n = (o) => {
      o != null && (i(o), this.dispatchLocalEvent({
        type: "advancedFilterBuilderValueChanged"
      }));
    };
    if (e.isSelect) {
      const { getEditorParams: o, pickerAriaLabelKey: a, pickerAriaLabelValue: l, displayValue: c } = e, d = this.gos.get("advancedFilterBuilderParams"), u = `${(d == null ? void 0 : d.pillSelectMinWidth) ?? 140}px`, h = `${(d == null ? void 0 : d.pillSelectMaxWidth) ?? 200}px`, p = this.createBean(
        new lz({
          pickerAriaLabelKey: a,
          pickerAriaLabelValue: l,
          pickerType: "ag-list",
          value: {
            key: t,
            displayValue: c
          },
          valueFormatter: (g) => g == null ? null : g.displayValue ?? g.key,
          variableWidth: !0,
          minPickerWidth: u,
          maxPickerWidth: h,
          getEditorParams: o,
          wrapperClassName: s,
          ariaLabel: r,
          pickerIcon: "advancedFilterBuilderSelectOpen"
        })
      );
      return this.addManagedListeners(p, {
        fieldPickerValueSelected: ({ value: g }) => n(g == null ? void 0 : g.key)
      }), p;
    } else {
      const { baseCellDataType: o, valueFormatter: a } = e, l = this.createBean(
        new oz({
          value: t,
          valueFormatter: a,
          cssClass: s,
          type: this.getInputType(o),
          ariaLabel: r
        })
      );
      return this.addManagedListeners(l, { fieldValueChanged: ({ value: c }) => n(c) }), l;
    }
  }
  getInputType(e) {
    switch (e) {
      case "text":
      case "object":
      case "boolean":
        return "text";
      case "number":
        return "number";
      case "date":
      case "dateString":
        return "date";
    }
  }
  setupDragging() {
    const e = {
      type: ni.AdvancedFilterBuilder,
      eElement: this.eDragHandle,
      dragItemName: () => this.ePillWrapper.getDragName(),
      getDefaultIconName: () => "notAllowed",
      getDragItem: () => ({}),
      onDragStarted: () => this.dragFeature.dispatchLocalEvent({
        type: "advancedFilterBuilderDragStarted",
        item: this.item
      }),
      onDragStopped: () => this.dragFeature.dispatchLocalEvent({
        type: "advancedFilterBuilderDragEnded"
      })
    };
    this.dragAndDrop.addDragSource(e, !0), this.addDestroyFunc(() => this.dragAndDrop.removeDragSource(e));
  }
  updateAriaLabel() {
    const e = this.ePillWrapper.getAriaLabel(), t = `${this.item.level + 1}`, s = this.ePillWrapper.getValidationMessage();
    let i;
    s ? i = this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItemValidation", [
      e,
      t,
      s
    ]) : i = this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderItem", [e, t]), ot(this.focusWrapper, i);
  }
  updateAriaExpanded() {
    UC(this.focusWrapper);
    const { filterModel: e } = this.item;
    (e == null ? void 0 : e.filterType) === "join" && e.conditions.length && ns(this.focusWrapper, !0);
  }
  removeItem() {
    this.dispatchLocalEvent({
      type: "advancedFilterBuilderRemoved",
      item: this.item
    });
  }
  moveItem(e) {
    this.dispatchLocalEvent({
      type: "advancedFilterBuilderMoved",
      item: this.item,
      backwards: e
    });
  }
}, cz = class extends _ {
  constructor() {
    super(
      /* html */
      `
            <div role="presentation" class="ag-advanced-filter-builder" tabindex="-1">
                <div role="presentation" class="ag-advanced-filter-builder-list" data-ref="eList"></div>
                <div role="presentation" class="ag-advanced-filter-builder-button-panel">
                    <button class="ag-button ag-standard-button ag-advanced-filter-builder-apply-button" data-ref="eApplyFilterButton"></button>
                    <button class="ag-button ag-standard-button ag-advanced-filter-builder-cancel-button" data-ref="eCancelFilterButton"></button>
                </div>
            </div>`
    ), this.eList = E, this.eApplyFilterButton = E, this.eCancelFilterButton = E, this.validationMessage = null;
  }
  wireBeans(e) {
    this.filterManager = e.filterManager, this.advancedFilter = e.advancedFilter, this.advFilterExpSvc = e.advFilterExpSvc, this.registry = e.registry;
  }
  postConstruct() {
    const { showMoveButtons: e } = this.gos.get("advancedFilterBuilderParams") ?? {};
    this.showMove = !!e, this.addManagedPropertyListener("advancedFilterBuilderParams", ({ currentValue: t }) => {
      this.showMove = !!(t != null && t.showMoveButtons), this.refreshList(!1);
    }), this.filterModel = this.setupFilterModel(), this.setupVirtualList(), this.dragFeature = this.createManagedBean(new QH(this, this.virtualList)), this.setupButtons();
  }
  refresh() {
    const e = this.virtualList;
    let t = e.getLastFocusedRow();
    this.setupFilterModel(), this.validateItems(), this.refreshList(!1), t != null && (e.getComponentAt(t) || (t = 0), e.focusRow(t));
  }
  getNumItems() {
    return this.items.length;
  }
  moveItem(e, t) {
    !t || !e || this.moveItemToIndex(e, t.rowIndex, t.position);
  }
  afterGuiAttached() {
    this.virtualList.awaitStable(() => this.virtualList.focusRow(0));
  }
  setupVirtualList() {
    const e = this.virtualList = this.createManagedBean(
      new co({
        cssIdentifier: "advanced-filter-builder",
        ariaRole: "tree",
        listName: this.advFilterExpSvc.translate("ariaAdvancedFilterBuilderList")
      })
    );
    e.setComponentCreator(this.createItemComponent.bind(this)), e.setComponentUpdater(this.updateItemComponent.bind(this)), e.setRowHeight(40), this.eList.appendChild(e.getGui()), e.setModel({
      getRowCount: () => this.items.length,
      getRow: (t) => this.items[t],
      areRowsEqual: (t, s) => t === s
    }), this.buildList(), e.refresh();
  }
  setupButtons() {
    this.eApplyFilterButton.innerText = this.advFilterExpSvc.translate("advancedFilterBuilderApply"), this.activateTabIndex([this.eApplyFilterButton]), this.addManagedElementListeners(this.eApplyFilterButton, {
      click: () => {
        var t;
        this.advancedFilter.setModel(this.filterModel), (t = this.filterManager) == null || t.onFilterChanged({ source: "advancedFilter" }), this.close();
      }
    }), this.validationTooltipFeature = this.createOptionalManagedBean(
      this.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.eApplyFilterButton,
        getLocation: () => "advancedFilter",
        getTooltipValue: () => this.validationMessage,
        getTooltipShowDelayOverride: () => 1e3
      })
    ), this.validate();
    const e = (t) => this.addOrRemoveCssClass("ag-advanced-filter-builder-validation", t);
    this.addManagedListeners(this.eApplyFilterButton, {
      mouseenter: () => e(!0),
      mouseleave: () => e(!1)
    }), this.eCancelFilterButton.innerText = this.advFilterExpSvc.translate("advancedFilterBuilderCancel"), this.activateTabIndex([this.eCancelFilterButton]), this.addManagedElementListeners(this.eCancelFilterButton, { click: () => this.close() });
  }
  removeItemFromParent(e) {
    const t = e.parent.conditions.indexOf(e.filterModel);
    return e.parent.conditions.splice(t, 1), t;
  }
  moveItemToIndex(e, t, s) {
    var a;
    const i = this.items[t], r = ((a = i.filterModel) == null ? void 0 : a.filterType) === "join" && s === "bottom", n = r ? i.filterModel : i.parent;
    if (!n || this.isChildOrSelf(n, e.filterModel) || i === e)
      return;
    this.removeItemFromParent(e);
    let o;
    r ? o = 0 : (o = n.conditions.indexOf(i.filterModel), o === -1 ? o = n.conditions.length : s === "bottom" && (o += 1)), n.conditions.splice(o, 0, e.filterModel), this.refreshList(!1);
  }
  isChildOrSelf(e, t) {
    return e === t || t.filterType === "join" && t.conditions.some((s) => this.isChildOrSelf(e, s));
  }
  setupFilterModel() {
    const e = this.formatFilterModel(this.advancedFilter.getModel());
    return this.stringifiedModel = JSON.stringify(e), e;
  }
  formatFilterModel(e) {
    return e = e ?? {
      filterType: "join",
      type: "AND",
      conditions: []
    }, e.filterType !== "join" && (e = {
      filterType: "join",
      type: "AND",
      conditions: [e]
    }), e;
  }
  buildList() {
    const e = (t, s, i, r) => {
      s.push({ filterModel: t, level: i, parent: r, valid: !0, showMove: this.showMove }), t.filterType === "join" && (t.conditions.forEach(
        (n) => e(n, s, i + 1, t)
      ), i === 0 && s.push({ filterModel: null, level: i + 1, parent: t, valid: !0 }));
    };
    this.items = [], e(this.filterModel, this.items, 0);
  }
  refreshList(e) {
    if (!e) {
      const t = [];
      this.items.forEach((s) => {
        s.valid || t.push(s.filterModel);
      }), this.buildList(), t.length && this.items.forEach((s) => {
        s.filterModel && t.includes(s.filterModel) && (s.valid = !1);
      });
    }
    this.virtualList.refresh(e), this.validate();
  }
  updateItemComponent(e, t) {
    const s = this.items.indexOf(e), i = (a, l) => {
      const c = this.items.find((u) => u.filterModel === a), d = c == null ? void 0 : c.parent;
      if (d) {
        const { conditions: u } = d;
        i(d, l), l.push(u[u.length - 1] === a);
      }
    }, r = [], { filterModel: n } = e;
    n && (i(n, r), r[0] = !1);
    const o = (n == null ? void 0 : n.filterType) === "join" && !!n.conditions.length;
    t.setState({
      disableMoveUp: s === 1,
      disableMoveDown: !this.canMoveDown(e, s),
      treeLines: r,
      showStartTreeLine: o
    });
  }
  createItemComponent(e, t) {
    const s = this.createBean(
      e.filterModel ? new kd(e, this.dragFeature, t) : new rz(e, t)
    );
    return s.addManagedListeners(s, {
      advancedFilterBuilderRemoved: ({ item: i }) => this.removeItem(i),
      advancedFilterBuilderValueChanged: () => this.validate(),
      advancedFilterBuilderAdded: ({ item: i, isJoin: r }) => this.addItem(i, r),
      advancedFilterBuilderMoved: ({ item: i, backwards: r }) => this.moveItemUpDown(i, r)
    }), s instanceof kd && this.updateItemComponent(e, s), s;
  }
  addItem(e, t) {
    var u;
    const { parent: s, level: i, filterModel: r } = e, n = (r == null ? void 0 : r.filterType) === "join", o = t ? {
      filterType: "join",
      type: "AND",
      conditions: []
    } : {}, a = n ? r : s;
    let l = n ? 0 : a.conditions.indexOf(r);
    l >= 0 ? (n || (l += 1), a.conditions.splice(l, 0, o)) : a.conditions.push(o);
    let c = this.items.indexOf(e);
    const d = c >= 0;
    if (d) {
      e.filterModel && c++;
      const h = [
        {
          filterModel: o,
          level: n ? i + 1 : i,
          parent: a,
          valid: t,
          showMove: this.showMove
        }
      ];
      this.items.splice(c, 0, ...h);
    }
    this.refreshList(d), d && ((u = this.virtualList.getComponentAt(c)) == null || u.afterAdd());
  }
  removeItem(e) {
    var a;
    const t = e.parent, { filterModel: s } = e, i = t.conditions.indexOf(s);
    t.conditions.splice(i, 1);
    const r = ((a = e.filterModel) == null ? void 0 : a.filterType) === "join", n = this.items.indexOf(e), o = !r && n >= 0;
    o && this.items.splice(n, 1), this.refreshList(o), n >= 0 && this.virtualList.focusRow(n);
  }
  moveItemUpDown(e, t) {
    const s = this.items.indexOf(e), i = t ? s - 1 : s + 1;
    if (i === 0 || !t && !this.canMoveDown(e, s))
      return;
    const r = this.items[i], n = this.removeItemFromParent(e), { level: o, filterModel: a, parent: l } = e, {
      level: c,
      filterModel: d,
      parent: u
    } = r;
    if (t)
      if (c === o && d.filterType === "join")
        d.conditions.push(a);
      else if (c <= o) {
        const p = u.conditions.indexOf(d);
        u.conditions.splice(p, 0, a);
      } else
        l.conditions[n - 1].conditions.push(a);
    else if (c === o)
      if (d.filterType === "join")
        d.conditions.splice(0, 0, a);
      else {
        const p = u.conditions.indexOf(d);
        u.conditions.splice(p + 1, 0, a);
      }
    else if (n < l.conditions.length)
      l.conditions.splice(n + 1, 0, a);
    else {
      const p = this.items.find((f) => f.filterModel === l), g = p.parent.conditions.indexOf(p.filterModel) + 1;
      p.parent.conditions.splice(g, 0, a);
    }
    this.refreshList(!1);
    const h = this.items.findIndex(
      ({ filterModel: p }) => p === a
    );
    if (h >= 0) {
      const p = this.virtualList.getComponentAt(h);
      p instanceof kd && p.focusMoveButton(t);
    }
  }
  canMoveDown(e, t) {
    return !(e.level === 1 && t === this.items.length - 2 || e.level === 1 && e.parent.conditions[e.parent.conditions.length - 1] === e.filterModel);
  }
  close() {
    this.advancedFilter.getCtrl().toggleFilterBuilder({ source: "ui" });
  }
  validate() {
    var t;
    let e = !this.items.every(({ valid: s }) => s);
    e ? this.validationMessage = this.advFilterExpSvc.translate("advancedFilterBuilderValidationIncomplete") : (e = JSON.stringify(this.filterModel) === this.stringifiedModel, e ? this.validationMessage = this.advFilterExpSvc.translate(
      "advancedFilterBuilderValidationAlreadyApplied"
    ) : this.validationMessage = null), Bs(this.eApplyFilterButton, e), (t = this.validationTooltipFeature) == null || t.refreshTooltip();
  }
  validateItems() {
    const e = (s) => {
      s.type = void 0;
    }, t = (s) => {
      delete s.filter;
    };
    this.items.forEach((s) => {
      if (!s.valid || !s.filterModel || s.filterModel.filterType === "join")
        return;
      const { filterModel: i } = s, { colId: r } = i, n = this.advFilterExpSvc.getColumnAutocompleteEntries().find(({ key: c }) => c === r), o = this.advFilterExpSvc.getColumnDetails(i.colId);
      if (!n || !o.column) {
        s.valid = !1, i.colId = void 0, e(i), t(i);
        return;
      }
      const l = this.advFilterExpSvc.getDataTypeExpressionOperator(o.baseCellDataType).operators[i.type];
      if (!l) {
        s.valid = !1, e(i), t(i);
        return;
      }
      if (l.numOperands > 0 && !W(i.filter)) {
        s.valid = !1;
        return;
      }
    });
  }
}, dz = class extends L {
  constructor(e) {
    super(), this.enabled = e;
  }
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc, this.popupSvc = e.popupSvc, this.advFilterExpSvc = e.advFilterExpSvc, this.environment = e.environment;
  }
  postConstruct() {
    this.hasAdvancedFilterParent = !!this.gos.get("advancedFilterParent"), this.ctrlsSvc.whenReady(this, () => this.setAdvancedFilterComp()), this.addManagedEventListeners({
      advancedFilterEnabledChanged: ({ enabled: e }) => this.onEnabledChanged(e)
    }), this.addManagedPropertyListener("advancedFilterParent", () => this.updateComps()), this.addDestroyFunc(() => {
      this.destroyAdvancedFilterComp(), this.destroyBean(this.eBuilderComp), this.eBuilderDialog && this.eBuilderDialog.isAlive() && this.destroyBean(this.eBuilderDialog);
    });
  }
  setupHeaderComp(e) {
    var t;
    this.eHeaderComp && ((t = this.eHeaderComp) == null || t.getGui().remove(), this.destroyBean(this.eHeaderComp)), this.eHeaderComp = this.createManagedBean(
      new ZH(this.enabled && !this.hasAdvancedFilterParent)
    ), e.insertAdjacentElement("beforebegin", this.eHeaderComp.getGui());
  }
  focusHeaderComp() {
    return this.eHeaderComp ? (this.eHeaderComp.getFocusableElement().focus(), !0) : !1;
  }
  refreshComp() {
    var e, t;
    (e = this.eFilterComp) == null || e.refresh(), (t = this.eHeaderComp) == null || t.refresh();
  }
  refreshBuilderComp() {
    var e;
    (e = this.eBuilderComp) == null || e.refresh();
  }
  getHeaderHeight() {
    var e;
    return ((e = this.eHeaderComp) == null ? void 0 : e.getHeight()) ?? 0;
  }
  setInputDisabled(e) {
    var t, s;
    (t = this.eFilterComp) == null || t.setInputDisabled(e), (s = this.eHeaderComp) == null || s.setInputDisabled(e);
  }
  toggleFilterBuilder(e) {
    const { source: t, force: s, eventSource: i } = e;
    if (s && this.eBuilderDialog || s === !1 && !this.eBuilderDialog)
      return;
    if (this.eBuilderDialog) {
      this.builderDestroySource = t, this.destroyBean(this.eBuilderDialog);
      return;
    }
    this.setInputDisabled(!0);
    const { width: r, height: n, minWidth: o } = this.getBuilderDialogSize();
    this.eBuilderComp = this.createBean(new cz()), this.eBuilderDialog = this.createBean(
      new ya({
        title: this.advFilterExpSvc.translate("advancedFilterBuilderTitle"),
        component: this.eBuilderComp,
        width: r,
        height: n,
        resizable: !0,
        movable: !0,
        maximizable: !0,
        centered: !0,
        closable: !0,
        minWidth: o,
        afterGuiAttached: () => {
          var a;
          return (a = this.eBuilderComp) == null ? void 0 : a.afterGuiAttached();
        },
        postProcessPopupParams: {
          type: "advancedFilterBuilder",
          eventSource: i
        }
      })
    ), this.dispatchFilterBuilderVisibleChangedEvent(t, !0), this.eBuilderDialog.addEventListener("destroyed", () => {
      this.destroyBean(this.eBuilderComp), this.eBuilderComp = void 0, this.eBuilderDialog = void 0, this.setInputDisabled(!1), this.dispatchLocalEvent({
        type: "advancedFilterBuilderClosed"
      }), this.dispatchFilterBuilderVisibleChangedEvent(this.builderDestroySource ?? "ui", !1), this.builderDestroySource = void 0;
    });
  }
  dispatchFilterBuilderVisibleChangedEvent(e, t) {
    this.eventSvc.dispatchEvent({
      type: "advancedFilterBuilderVisibleChanged",
      source: e,
      visible: t
    });
  }
  getBuilderDialogSize() {
    var o;
    const e = ((o = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : o.minWidth) ?? 500, t = this.popupSvc.getPopupParent(), s = Math.round(gn(t)) - 2, i = Math.round(oc(t) * 0.75) - 2, r = Math.min(Math.max(600, e), s), n = Math.min(600, i);
    return { width: r, height: n, minWidth: e };
  }
  onEnabledChanged(e) {
    this.enabled = e, this.updateComps();
  }
  updateComps() {
    this.setAdvancedFilterComp(), this.setHeaderCompEnabled(), this.eventSvc.dispatchEvent({
      type: "headerHeightChanged"
    });
  }
  setAdvancedFilterComp() {
    if (this.destroyAdvancedFilterComp(), !this.enabled)
      return;
    const e = this.gos.get("advancedFilterParent");
    if (this.hasAdvancedFilterParent = !!e, e) {
      const t = this.createBean(new lb()), s = t.getGui();
      this.environment.applyThemeClasses(s), s.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr"), e.appendChild(s), this.eFilterComp = t;
    }
  }
  setHeaderCompEnabled() {
    var e;
    (e = this.eHeaderComp) == null || e.setEnabled(this.enabled && !this.hasAdvancedFilterParent);
  }
  destroyAdvancedFilterComp() {
    this.eFilterComp && (ut(this.eFilterComp.getGui()), this.destroyBean(this.eFilterComp));
  }
}, uz = class {
  constructor(e) {
    this.params = e, this.operators = [], this.operatorStartPositions = [], this.operatorEndPositions = [], this.activeOperator = 0, this.validationError = null;
  }
  parseExpression(e) {
    this.operators.push(""), this.operatorStartPositions.push(e), this.operatorEndPositions.push(void 0);
    const { expression: t } = this.params;
    for (; e < t.length; ) {
      const s = t[e];
      if (s === " ") {
        if (this.parseOperator(e - 1))
          return this.activeOperator++, e - 1;
        this.operators[this.activeOperator] += s;
      } else
        this.operators[this.activeOperator] += s;
      e++;
    }
    return this.parseOperator(e - 1), e;
  }
  isValid() {
    return !this.validationError && (!this.operators.length || !!this.parsedOperator);
  }
  getValidationError() {
    return this.validationError;
  }
  getFunction() {
    return this.parsedOperator === "OR" ? "||" : "&&";
  }
  getModel() {
    return this.parsedOperator === "OR" ? "OR" : "AND";
  }
  getAutocompleteListParams(e, t) {
    let s;
    if (t == null)
      s = "";
    else {
      const r = this.operators[t], n = this.operatorEndPositions[t];
      s = Fu(
        r,
        e,
        n == null ? this.params.expression.length : n + 1
      );
    }
    let i = this.params.advFilterExpSvc.getJoinOperatorAutocompleteEntries();
    return (t || t == null && this.activeOperator) && (i = i.filter(({ key: r }) => r === this.parsedOperator)), this.params.advFilterExpSvc.generateAutocompleteListParams(i, "join", s);
  }
  updateExpression(e, t, s) {
    let { expression: i } = this.params;
    const r = t.displayValue ?? t.key;
    if (s === 0)
      for (let a = this.operatorEndPositions.length - 1; a > 0; a--) {
        const l = this.operatorEndPositions[a];
        l != null && (i = Sr(
          i,
          this.operatorStartPositions[a],
          l,
          r
        ).updatedValue);
      }
    const n = this.operatorStartPositions.length > s ? this.operatorStartPositions[s] : e, o = (this.operatorEndPositions.length > s ? this.operatorEndPositions[s] : void 0) ?? Pu(i, e, !0).endPosition;
    return Sr(i, n, o, r, !0);
  }
  getNumOperators() {
    return this.operators.length;
  }
  getLastOperatorEndPosition() {
    return this.operatorEndPositions[this.operatorEndPositions.length - 1];
  }
  parseOperator(e) {
    const t = this.operators.length > this.activeOperator ? this.operators[this.activeOperator] : "", s = this.params.advFilterExpSvc.getExpressionJoinOperators(), i = Ec(t, s, (r) => r);
    if (i) {
      this.operatorEndPositions[this.activeOperator] = e;
      const r = s[i];
      if (this.activeOperator) {
        if (i !== this.parsedOperator)
          return this.validationError || (this.validationError = {
            message: this.params.advFilterExpSvc.translate(
              "advancedFilterValidationJoinOperatorMismatch"
            ),
            startPosition: e - t.length + 1,
            endPosition: e
          }), !1;
      } else
        this.parsedOperator = i;
      return t !== r && (Kh(this.params, t, r, e), this.operators[this.activeOperator] = r), !0;
    } else return i === null ? !1 : (this.validationError || (this.validationError = {
      message: this.params.advFilterExpSvc.translate("advancedFilterValidationInvalidJoinOperator"),
      startPosition: e - t.length + 1,
      endPosition: e
    }), !0);
  }
}, hz = class pb {
  constructor(t, s) {
    this.params = t, this.startPosition = s, this.expectingExpression = !0, this.expectingOperator = !1, this.expressionParsers = [], this.operatorParser = new uz(this.params), this.missingEndBracket = !1, this.extraEndBracket = !1;
  }
  parseExpression() {
    let t = this.startPosition;
    const { expression: s } = this.params;
    for (; t < s.length; ) {
      const i = s[t];
      if (i === "(" && !this.expectingOperator) {
        const r = new pb(this.params, t + 1);
        t = r.parseExpression(), this.expressionParsers.push(r), this.expectingExpression = !1, this.expectingOperator = !0;
      } else {
        if (i === ")")
          return this.endPosition = t - 1, this.startPosition === 0 && (this.extraEndBracket = !0), t;
        if (i !== " ") if (this.expectingExpression) {
          const r = new NH(this.params, t);
          t = r.parseExpression(), this.expressionParsers.push(r), this.expectingExpression = !1, this.expectingOperator = !0;
        } else this.expectingOperator && (t = this.operatorParser.parseExpression(t), this.expectingOperator = !1, this.expectingExpression = !0);
      }
      t++;
    }
    return this.startPosition > 0 && (this.missingEndBracket = !0), t;
  }
  isValid() {
    return !this.missingEndBracket && !this.extraEndBracket && this.expressionParsers.length === this.operatorParser.getNumOperators() + 1 && this.operatorParser.isValid() && this.expressionParsers.every((t) => t.isValid());
  }
  getValidationError() {
    const t = this.operatorParser.getValidationError();
    for (let i = 0; i < this.expressionParsers.length; i++) {
      const r = this.expressionParsers[i].getValidationError();
      if (r)
        return t && t.startPosition < r.startPosition ? t : r;
    }
    if (t)
      return t;
    if (this.extraEndBracket)
      return {
        message: this.params.advFilterExpSvc.translate("advancedFilterValidationExtraEndBracket"),
        startPosition: this.endPosition + 1,
        endPosition: this.endPosition + 1
      };
    let s;
    return this.expressionParsers.length === this.operatorParser.getNumOperators() ? s = "advancedFilterValidationMissingCondition" : this.missingEndBracket && (s = "advancedFilterValidationMissingEndBracket"), s ? {
      message: this.params.advFilterExpSvc.translate(s),
      startPosition: this.params.expression.length,
      endPosition: this.params.expression.length
    } : null;
  }
  getFunctionString(t) {
    const s = this.expressionParsers.length > 1, i = this.expressionParsers.map((r) => r.getFunctionString(t)).join(` ${this.operatorParser.getFunction()} `);
    return s ? `(${i})` : i;
  }
  getFunctionParsed(t) {
    const s = this.operatorParser.getFunction(), i = this.expressionParsers.map((n) => n.getFunctionParsed(t)), r = s === "&&" ? "every" : "some";
    return (n, o, a) => i[r]((l) => l(n, o, a));
  }
  getAutocompleteListParams(t) {
    if (this.endPosition != null && t > this.endPosition + 1)
      return;
    if (!this.expressionParsers.length)
      return this.getColumnAutocompleteListParams();
    const s = this.getExpressionParserIndex(t);
    if (s == null)
      return this.params.expression[t] === "(" ? { enabled: !1 } : this.getColumnAutocompleteListParams();
    const r = this.expressionParsers[s].getAutocompleteListParams(t);
    if (!r) {
      if (s < this.expressionParsers.length - 1)
        return this.operatorParser.getAutocompleteListParams(t, s);
      if (this.expressionParsers.length === this.operatorParser.getNumOperators()) {
        const n = this.operatorParser.getLastOperatorEndPosition();
        return n == null || t <= n + 1 ? this.operatorParser.getAutocompleteListParams(t, this.operatorParser.getNumOperators() - 1) : this.getColumnAutocompleteListParams();
      }
      return this.params.expression[t - 1] === ")" ? { enabled: !1 } : this.operatorParser.getAutocompleteListParams(t);
    }
    return r;
  }
  updateExpression(t, s, i) {
    const r = this.params.expression, n = this.getExpressionParserIndex(t);
    if (n == null) {
      const l = i === "column" ? this.params.advFilterExpSvc.getColumnValue(s) : s.displayValue ?? s.key;
      return Sr(r, this.startPosition, this.startPosition, l, !0);
    }
    const a = this.expressionParsers[n].updateExpression(t, s, i);
    return a ?? (i === "column" ? Sr(
      r,
      t,
      r.length - 1,
      this.params.advFilterExpSvc.getColumnValue(s),
      !0
    ) : this.endPosition != null && t > this.endPosition + 1 ? null : this.operatorParser.updateExpression(t, s, n));
  }
  getModel() {
    return this.expressionParsers.length > 1 ? {
      filterType: "join",
      type: this.operatorParser.getModel(),
      conditions: this.expressionParsers.map((t) => t.getModel())
    } : this.expressionParsers[0].getModel();
  }
  getColumnAutocompleteListParams() {
    return this.params.advFilterExpSvc.generateAutocompleteListParams(
      this.params.advFilterExpSvc.getColumnAutocompleteEntries(),
      "column",
      ""
    );
  }
  getExpressionParserIndex(t) {
    let s;
    for (let i = 0; i < this.expressionParsers.length && !(this.expressionParsers[i].startPosition > t); i++)
      s = i;
    return s;
  }
}, pz = class {
  constructor(e) {
    this.params = e, this.valid = !1;
  }
  parseExpression() {
    this.joinExpressionParser = new hz(this.params, 0);
    const e = this.joinExpressionParser.parseExpression();
    return this.valid = e >= this.params.expression.length - 1 && this.joinExpressionParser.isValid(), this.params.expression;
  }
  isValid() {
    return this.valid;
  }
  getValidationMessage() {
    const e = this.joinExpressionParser.getValidationError();
    if (!e)
      return null;
    const { message: t, startPosition: s, endPosition: i } = e;
    return s < this.params.expression.length ? this.params.advFilterExpSvc.translate("advancedFilterValidationMessage", [
      t,
      this.params.expression.slice(s, i + 1).trim()
    ]) : this.params.advFilterExpSvc.translate("advancedFilterValidationMessageAtEnd", [t]);
  }
  getFunctionString() {
    const e = this.createFunctionParams();
    return {
      functionString: `return ${this.joinExpressionParser.getFunctionString(e)};`,
      params: e
    };
  }
  getFunctionParsed() {
    const e = this.createFunctionParams();
    return {
      expressionFunction: this.joinExpressionParser.getFunctionParsed(e),
      params: e
    };
  }
  getAutocompleteListParams(e) {
    return this.joinExpressionParser.getAutocompleteListParams(e) ?? { enabled: !1 };
  }
  updateExpression(e, t, s) {
    return this.joinExpressionParser.updateExpression(e, t, s);
  }
  getModel() {
    return this.isValid() ? this.joinExpressionParser.getModel() : null;
  }
  createFunctionParams() {
    return {
      operands: [],
      operators: [],
      evaluatorParams: []
    };
  }
}, gz = class extends L {
  constructor() {
    super(...arguments), this.beanName = "advancedFilter", this.appliedExpression = null, this.expression = null, this.isValid = !0;
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc, this.colModel = e.colModel, this.dataTypeSvc = e.dataTypeSvc, this.advFilterExpSvc = e.advFilterExpSvc, this.filterValueSvc = e.filterValueSvc;
  }
  postConstruct() {
    this.setEnabled(this.gos.get("enableAdvancedFilter"), !0), this.ctrl = this.createManagedBean(new dz(this.enabled)), this.expressionProxy = {
      getValue: (e, t) => {
        const s = this.colModel.getColDefCol(e);
        return s ? this.filterValueSvc.getValue(s, t) : void 0;
      }
    }, this.addManagedPropertyListener("enableAdvancedFilter", (e) => this.setEnabled(!!e.currentValue)), this.addManagedEventListeners({
      newColumnsLoaded: (e) => this.onNewColumnsLoaded(e)
    }), this.addManagedPropertyListener("includeHiddenColumnsInAdvancedFilter", () => this.updateValidity());
  }
  isEnabled() {
    return this.enabled;
  }
  isFilterPresent() {
    return !!this.expressionFunction;
  }
  doesFilterPass(e) {
    return this.expressionFunction(this.expressionProxy, e, this.expressionParams);
  }
  getModel() {
    const e = this.createExpressionParser(this.appliedExpression);
    return e == null || e.parseExpression(), (e == null ? void 0 : e.getModel()) ?? null;
  }
  setModel(e) {
    const t = (i, r) => {
      if (i.filterType === "join") {
        const n = this.advFilterExpSvc.parseJoinOperator(i), o = i.conditions.map((a) => t(a)).filter((a) => W(a)).join(` ${n} `);
        return r || i.conditions.length <= 1 ? o : `(${o})`;
      } else
        return this.advFilterExpSvc.parseColumnFilterModel(i);
    }, s = e ? t(e, !0) : null;
    this.setExpressionDisplayValue(s), this.applyExpression(), this.ctrl.refreshComp(), this.ctrl.refreshBuilderComp();
  }
  getExpressionDisplayValue() {
    return this.expression;
  }
  setExpressionDisplayValue(e) {
    this.expression = e;
  }
  isCurrentExpressionApplied() {
    return this.appliedExpression === this.expression;
  }
  createExpressionParser(e) {
    return e ? new pz({
      expression: e,
      colModel: this.colModel,
      dataTypeSvc: this.dataTypeSvc,
      valueSvc: this.valueSvc,
      advFilterExpSvc: this.advFilterExpSvc
    }) : null;
  }
  getDefaultExpression(e) {
    const t = this.advFilterExpSvc.getColumnValue(e) + " ";
    return {
      updatedValue: t,
      updatedPosition: t.length
    };
  }
  isHeaderActive() {
    return !this.gos.get("advancedFilterParent");
  }
  getCtrl() {
    return this.ctrl;
  }
  setEnabled(e, t) {
    const s = this.enabled, i = Ye(this.gos) || Lt(this.gos);
    e && !i && I(123), this.enabled = e && i, !t && this.enabled !== s && this.eventSvc.dispatchEvent({
      type: "advancedFilterEnabledChanged",
      enabled: this.enabled
    });
  }
  applyExpression() {
    const e = this.createExpressionParser(this.expression);
    e == null || e.parseExpression(), this.applyExpressionFromParser(e);
  }
  applyExpressionFromParser(e) {
    if (this.isValid = !e || e.isValid(), !e || !this.isValid) {
      this.expressionFunction = null, this.expressionParams = null, this.appliedExpression = null;
      return;
    }
    const { expressionFunction: t, params: s } = this.getFunction(e);
    this.expressionFunction = t, this.expressionParams = s, this.appliedExpression = this.expression;
  }
  getFunction(e) {
    if (this.gos.get("suppressAdvancedFilterEval"))
      return e.getFunctionParsed();
    {
      const { functionString: t, params: s } = e.getFunctionString();
      return {
        expressionFunction: new Function(
          "expressionProxy",
          "node",
          "params",
          t
        ),
        params: s
      };
    }
  }
  updateValidity() {
    this.advFilterExpSvc.resetColumnCaches();
    const e = this.createExpressionParser(this.expression);
    e == null || e.parseExpression();
    const s = (!e || e.isValid()) !== this.isValid;
    return this.applyExpressionFromParser(e), this.ctrl.refreshComp(), this.ctrl.refreshBuilderComp(), s;
  }
  onNewColumnsLoaded(e) {
    var s;
    if (e.source !== "gridInitializing" || !((s = this.dataTypeSvc) != null && s.isPendingInference))
      return;
    this.ctrl.setInputDisabled(!0);
    const [t] = this.addManagedEventListeners({
      dataTypesInferred: () => {
        t == null || t(), this.ctrl.setInputDisabled(!1);
      }
    });
  }
}, fz = {
  moduleName: "AdvancedFilter",
  version: Me,
  beans: [gz, zH],
  icons: {
    // Builder button in Advanced Filter
    advancedFilterBuilder: "group",
    // drag handle used to pick up Advanced Filter Builder rows
    advancedFilterBuilderDrag: "grip",
    // Advanced Filter Builder row validation error
    advancedFilterBuilderInvalid: "not-allowed",
    // shown on Advanced Filter Builder rows to move them up
    advancedFilterBuilderMoveUp: "up",
    // shown on Advanced Filter Builder rows to move them down
    advancedFilterBuilderMoveDown: "down",
    // shown on Advanced Filter Builder rows to add new rows
    advancedFilterBuilderAdd: "plus",
    // shown on Advanced Filter Builder rows to remove row
    advancedFilterBuilderRemove: "minus",
    // shown on Advanced Filter Builder selection pills
    advancedFilterBuilderSelectOpen: "small-down",
    // remove for rich select editor pills
    richSelectRemove: "cancel"
  },
  apiFunctions: {
    getAdvancedFilterModel: DH,
    setAdvancedFilterModel: AH,
    showAdvancedFilterBuilder: MH,
    hideAdvancedFilterBuilder: IH
  },
  dependsOn: [Je, Fc, ao, Yi, $h],
  css: [EH]
};
function mz(e) {
  var t;
  return ((t = e.sideBar) == null ? void 0 : t.comp.isDisplayed()) ?? !1;
}
function Cz(e, t) {
  var s;
  (s = e.sideBar) == null || s.comp.setDisplayed(t);
}
function vz(e, t) {
  var s;
  (s = e.sideBar) == null || s.comp.setSideBarPosition(t);
}
function wz(e, t) {
  var s;
  (s = e.sideBar) == null || s.comp.openToolPanel(t, "api");
}
function yz(e) {
  var t;
  (t = e.sideBar) == null || t.comp.close("api");
}
function bz(e) {
  var t;
  return ((t = e.sideBar) == null ? void 0 : t.comp.openedItem()) ?? null;
}
function Sz(e) {
  var t;
  (t = e.sideBar) == null || t.comp.refresh();
}
function xz(e) {
  var t;
  return ((t = e.sideBar) == null ? void 0 : t.comp.isToolPanelShowing()) ?? !1;
}
function Rz(e, t) {
  var i;
  const s = (i = e.sideBar) == null ? void 0 : i.comp.getToolPanelInstance(t);
  return Cn(s);
}
function Fz(e) {
  var t;
  return (t = e.sideBar) == null ? void 0 : t.comp.getDef();
}
function Du(e, t) {
  if (!t)
    return null;
  const s = ii(e), i = s.indexOf(t);
  if (i === -1)
    return null;
  let r = -1;
  for (let n = i - 1; n >= 0; n--)
    if (s[n].classList.contains(hn.TAB_GUARD_TOP)) {
      r = n;
      break;
    }
  return r <= 0 ? null : s[r - 1];
}
function gb(e, t) {
  if (!t)
    return !1;
  const s = e.querySelectorAll(`.${bw}`);
  if (!s.length)
    return !1;
  for (let i = 0; i < s.length; i++)
    if (s[i].contains(t))
      return !0;
  return !1;
}
var Pz = (
  /*css*/
  '.ag-tool-panel-wrapper{cursor:default;display:flex;overflow:hidden auto;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--ag-side-bar-panel-width)}.ag-select-agg-func-item{align-items:center;display:flex;flex:1 1 auto;flex-flow:row nowrap;height:100%;overflow:hidden;position:relative;text-overflow:ellipsis;white-space:nowrap;>*{flex:none}}.ag-tool-panel-horizontal-resize{cursor:ew-resize;height:100%;position:absolute;top:0;width:5px;z-index:1}.ag-side-bar{background-color:var(--ag-side-bar-background-color);display:flex;flex-direction:row-reverse;position:relative}:where(.ag-ltr) :where(.ag-side-bar-left) .ag-tool-panel-horizontal-resize{right:-3px}:where(.ag-rtl) :where(.ag-side-bar-left) .ag-tool-panel-horizontal-resize{left:-3px}:where(.ag-ltr) :where(.ag-side-bar-right) .ag-tool-panel-horizontal-resize{left:-3px}:where(.ag-rtl) :where(.ag-side-bar-right) .ag-tool-panel-horizontal-resize{right:-3px}.ag-side-bar-left{flex-direction:row;order:-1}.ag-side-buttons{background-color:var(--ag-side-button-bar-background-color);padding-top:var(--ag-side-button-bar-top-padding);position:relative}.ag-side-button{background-color:var(--ag-side-button-background-color);border-bottom:var(--ag-side-button-selected-border);border-bottom-color:transparent;border-top:var(--ag-side-button-selected-border);border-top-color:transparent;color:var(--ag-side-button-text-color);position:relative;&:before{background-color:transparent;bottom:0;content:"";display:block;position:absolute;top:0;transition:background-color var(--ag-side-button-selected-underline-transition-duration);width:var(--ag-side-button-selected-underline-width)}&:hover{background-color:var(--ag-side-button-hover-background-color);color:var(--ag-side-button-hover-text-color)}&.ag-selected{background-color:var(--ag-side-button-selected-background-color);border-bottom:var(--ag-side-button-selected-border);color:var(--ag-side-button-selected-text-color);&:where(:not(:first-of-type)){border-top:var(--ag-side-button-selected-border)}&:before{background-color:var(--ag-side-button-selected-underline-color)}}}:where(.ag-ltr) .ag-side-button{&:before{left:0}}:where(.ag-rtl) .ag-side-button{&:before{right:0}}.ag-side-button-button{align-items:center;cursor:pointer;display:flex;flex-direction:column;gap:var(--ag-spacing);position:relative;white-space:nowrap;width:100%;&:focus{box-shadow:none}}:where(.ag-ltr) .ag-side-button-button{padding:var(--ag-side-button-vertical-padding) var(--ag-side-button-right-padding) var(--ag-side-button-vertical-padding) var(--ag-side-button-left-padding)}:where(.ag-rtl) .ag-side-button-button{padding:var(--ag-side-button-vertical-padding) var(--ag-side-button-left-padding) var(--ag-side-button-vertical-padding) var(--ag-side-button-right-padding)}.ag-side-button-button:focus-visible{box-shadow:inset var(--ag-focus-shadow)}.ag-side-button-label{writing-mode:vertical-lr}@media (resolution <= 1.5x){.ag-side-button-label{font-family:"Segoe UI",var(--ag-font-family)}:where(.ag-ltr) .ag-side-button-label{transform:rotate(.05deg)}:where(.ag-rtl) .ag-side-button-label{transform:rotate(-.05deg)}}:where(.ag-ltr) .ag-side-bar-left,:where(.ag-rtl) .ag-side-bar-right{border-right:var(--ag-side-panel-border);:where(.ag-tool-panel-wrapper){border-left:var(--ag-side-panel-border)}}:where(.ag-ltr) .ag-side-bar-right,:where(.ag-rtl) .ag-side-bar-left{border-left:var(--ag-side-panel-border);:where(.ag-tool-panel-wrapper){border-right:var(--ag-side-panel-border)}}'
), Tz = class extends _ {
  constructor(e) {
    super(), this.toolPanelDef = e, this.eToggleButton = E, this.eIconWrapper = E, this.eLabel = E;
  }
  getToolPanelId() {
    return this.toolPanelDef.id;
  }
  postConstruct() {
    const e = this.createTemplate();
    this.setTemplate(e, []), this.setLabel(), this.setIcon(), this.addManagedElementListeners(this.eToggleButton, { click: this.onButtonPressed.bind(this) }), this.eToggleButton.setAttribute("id", `ag-${this.getCompId()}-button`);
  }
  createTemplate() {
    return (
      /* html */
      `<div class="ag-side-button" role="presentation">
                <button type="button" data-ref="eToggleButton" tabindex="-1" role="tab" aria-expanded="false" class="ag-button ag-side-button-button">
                    <div data-ref="eIconWrapper" class="ag-side-button-icon-wrapper" aria-hidden="true"></div>
                    <span data-ref="eLabel" class="ag-side-button-label"></span>
                </button>
            </div>`
    );
  }
  setLabel() {
    const e = this.getLocaleTextFunc(), t = this.toolPanelDef, s = e(t.labelKey, t.labelDefault);
    this.eLabel.innerText = s;
  }
  setIcon() {
    this.eIconWrapper.insertAdjacentElement(
      "afterbegin",
      ue(this.toolPanelDef.iconKey, this.beans)
    );
  }
  onButtonPressed() {
    this.dispatchLocalEvent({ type: "toggleButtonClicked" });
  }
  setSelected(e) {
    this.addOrRemoveCssClass("ag-selected", e), ns(this.eToggleButton, e);
  }
}, Ez = class extends _ {
  constructor() {
    super(
      /* html */
      '<div class="ag-side-buttons" role="tablist"></div>'
    ), this.buttonComps = [];
  }
  postConstruct() {
    this.addManagedElementListeners(this.getFocusableElement(), { keydown: this.handleKeyDown.bind(this) });
  }
  handleKeyDown(e) {
    if (!(e.key !== P.TAB || !e.shiftKey)) {
      if (Ui(this.beans, !0)) {
        e.preventDefault();
        return;
      }
      gt(e);
    }
  }
  setActiveButton(e) {
    this.buttonComps.forEach((t) => {
      t.setSelected(e === t.getToolPanelId());
    });
  }
  addButtonComp(e) {
    const t = this.createBean(new Tz(e));
    return this.buttonComps.push(t), this.appendChild(t), t.addEventListener("toggleButtonClicked", () => {
      this.dispatchLocalEvent({
        type: "sideBarButtonClicked",
        toolPanelId: e.id
      });
    }), t;
  }
  clearButtons() {
    this.buttonComps = this.destroyBeans(this.buttonComps), ze(this.getGui()), super.destroy();
  }
  destroy() {
    this.clearButtons(), super.destroy();
  }
}, Dz = {
  selector: "AG-SIDE-BAR-BUTTONS",
  component: Ez
}, fb = {
  id: "columns",
  labelDefault: "Columns",
  labelKey: "columns",
  iconKey: "columnsToolPanel",
  toolPanel: "agColumnsToolPanel"
}, mb = {
  id: "filters",
  labelDefault: "Filters",
  labelKey: "filters",
  iconKey: "filtersToolPanel",
  toolPanel: "agFiltersToolPanel"
}, $l = {
  columns: fb,
  filters: mb
};
function Au(e) {
  if (!e)
    return;
  if (e === !0)
    return {
      toolPanels: [fb, mb],
      defaultToolPanel: "columns"
    };
  if (typeof e == "string")
    return Au([e]);
  if (Array.isArray(e)) {
    const s = [];
    return e.forEach((i) => {
      const r = $l[i];
      if (!r) {
        I(215, { key: i, defaultByKey: $l });
        return;
      }
      s.push(r);
    }), s.length === 0 ? void 0 : {
      toolPanels: s,
      defaultToolPanel: s[0].id
    };
  }
  return {
    toolPanels: Az(e.toolPanels),
    defaultToolPanel: e.defaultToolPanel,
    hiddenByDefault: e.hiddenByDefault,
    position: e.position
  };
}
function Az(e) {
  const t = [];
  return e && e.forEach((s) => {
    let i = null;
    if (typeof s == "string") {
      const r = $l[s];
      if (!r) {
        I(215, { key: s, defaultByKey: $l });
        return;
      }
      i = r;
    } else
      i = s;
    t.push(i);
  }), t;
}
var Mz = class extends _ {
  constructor() {
    super(
      /* html */
      '<div class="ag-tool-panel-horizontal-resize"></div>'
    ), this.minWidth = 100, this.maxWidth = null;
  }
  postConstruct() {
    const e = this.beans.horizontalResizeSvc.addResizeBar({
      eResizeBar: this.getGui(),
      dragStartPixels: 1,
      onResizeStart: this.onResizeStart.bind(this),
      onResizing: this.onResizing.bind(this),
      onResizeEnd: this.onResizeEnd.bind(this)
    });
    this.addDestroyFunc(e), this.inverted = this.gos.get("enableRtl");
  }
  dispatchResizeEvent(e, t, s) {
    this.eventSvc.dispatchEvent({
      type: "toolPanelSizeChanged",
      width: s,
      started: e,
      ended: t
    });
  }
  onResizeStart() {
    this.startingWidth = this.elementToResize.offsetWidth, this.dispatchResizeEvent(!0, !1, this.startingWidth);
  }
  onResizeEnd(e) {
    return this.onResizing(e, !0);
  }
  onResizing(e, t = !1) {
    const s = this.inverted ? -1 : 1;
    let i = Math.max(this.minWidth, Math.floor(this.startingWidth - e * s));
    this.maxWidth != null && (i = Math.min(this.maxWidth, i)), this.elementToResize.style.width = `${i}px`, this.dispatchResizeEvent(!1, t, i);
  }
};
function Iz(e, t, s) {
  return e.getCompDetails(t, Lz, void 0, s, !0);
}
var Lz = {
  name: "toolPanel",
  optionalMethods: ["refresh", "getState"]
}, kz = class extends _ {
  constructor() {
    super(
      /* html */
      '<div class="ag-tool-panel-wrapper" role="tabpanel"/>'
    );
  }
  postConstruct() {
    const e = this.getGui(), t = this.resizeBar = this.createManagedBean(new Mz());
    e.setAttribute("id", `ag-${this.getCompId()}`), t.elementToResize = e, this.appendChild(t);
  }
  getToolPanelId() {
    return this.toolPanelId;
  }
  setToolPanelDef(e, t) {
    const { id: s, minWidth: i, maxWidth: r, width: n } = e;
    this.toolPanelId = s, this.width = n;
    const o = Iz(this.beans.userCompFactory, e, t);
    if (o == null)
      return !1;
    const a = o.newAgStackInstance();
    this.params = o.params, a.then(this.setToolPanelComponent.bind(this));
    const l = this.resizeBar;
    return i != null && (l.minWidth = i), r != null && (l.maxWidth = r), !0;
  }
  setToolPanelComponent(e) {
    this.toolPanelCompInstance = e, this.appendChild(e.getGui()), this.addDestroyFunc(() => {
      this.destroyBean(e);
    });
    const t = this.width;
    t && (this.getGui().style.width = `${t}px`);
  }
  getToolPanelInstance() {
    return this.toolPanelCompInstance;
  }
  setResizerSizerSide(e) {
    const t = this.gos.get("enableRtl"), s = e === "left", i = t ? s : !s;
    this.resizeBar.inverted = i;
  }
  refresh() {
    var e;
    (e = this.toolPanelCompInstance) == null || e.refresh(this.params);
  }
}, Oz = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="ag-side-bar ag-unselectable">
                <ag-side-bar-buttons data-ref="sideBarButtons"></ag-side-bar-buttons>
            </div>`,
      [Dz]
    ), this.sideBarButtons = E, this.toolPanelWrappers = [], this.registerCSS(Pz);
  }
  postConstruct() {
    this.sideBarButtons.addEventListener("sideBarButtonClicked", this.onToolPanelButtonClicked.bind(this));
    const { beans: e, gos: t } = this, { sideBar: s } = t.get("initialState") ?? {};
    this.setSideBarDef({
      sideBarDef: Au(t.get("sideBar")),
      sideBarState: s
    }), this.addManagedPropertyListener("sideBar", this.onSideBarUpdated.bind(this)), e.sideBar.comp = this;
    const i = this.getFocusableElement();
    this.createManagedBean(
      new Ir(i, {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.handleKeyDown.bind(this)
      })
    ), aw(e, this, i);
  }
  onTabKeyDown(e) {
    if (e.defaultPrevented)
      return;
    const { beans: t, sideBarButtons: s } = this, i = this.getGui(), r = s.getGui(), n = Ie(t), o = i.querySelector(".ag-tool-panel-wrapper:not(.ag-hidden)"), a = e.target;
    if (!o)
      return Ui(t, e.shiftKey, !0);
    if (r.contains(n)) {
      Dt(o, e.shiftKey) && e.preventDefault();
      return;
    }
    if (!e.shiftKey)
      return;
    let l = null;
    o.contains(n) ? l = zt(t, o, void 0, !0) : gb(o, a) && e.shiftKey && (l = Du(o, a)), l || (l = r.querySelector(".ag-selected button")), l && l !== e.target && (e.preventDefault(), l.focus());
  }
  handleKeyDown(e) {
    const t = Ie(this.beans), s = this.sideBarButtons;
    if (!s.getGui().contains(t))
      return;
    const i = s.getGui(), r = Array.prototype.slice.call(i.querySelectorAll(".ag-side-button")), n = r.findIndex((l) => l.contains(t));
    let o = null;
    switch (e.key) {
      case P.LEFT:
      case P.UP:
        o = Math.max(0, n - 1);
        break;
      case P.RIGHT:
      case P.DOWN:
        o = Math.min(n + 1, r.length - 1);
        break;
    }
    if (o === null)
      return;
    const a = r[o].querySelector("button");
    a && (a.focus(), e.preventDefault());
  }
  onToolPanelButtonClicked(e) {
    const t = e.toolPanelId;
    this.openedItem() === t ? this.openToolPanel(void 0, "sideBarButtonClicked") : this.openToolPanel(t, "sideBarButtonClicked");
  }
  clearDownUi() {
    this.sideBarButtons.clearButtons(), this.destroyToolPanelWrappers();
  }
  setSideBarDef({
    sideBarDef: e,
    sideBarState: t,
    existingToolPanelWrappers: s
  }) {
    if (this.setDisplayed(!1), this.sideBar = e, e && e.toolPanels) {
      const i = e.toolPanels;
      if (this.createToolPanelsAndSideButtons(i, t, s), !this.toolPanelWrappers.length)
        return;
      const r = t ? t.visible : !e.hiddenByDefault;
      if (this.setDisplayed(r), this.setSideBarPosition(t ? t.position : e.position), r)
        if (t) {
          const { openToolPanel: n } = t;
          n && this.openToolPanel(n, "sideBarInitializing");
        } else
          this.openToolPanel(e.defaultToolPanel, "sideBarInitializing");
    }
  }
  getDef() {
    return this.sideBar;
  }
  setSideBarPosition(e) {
    e || (e = "right"), this.position = e;
    const t = e === "left", s = t ? "right" : "left";
    return this.addOrRemoveCssClass("ag-side-bar-left", t), this.addOrRemoveCssClass("ag-side-bar-right", !t), this.toolPanelWrappers.forEach((i) => {
      i.setResizerSizerSide(s);
    }), this.dispatchSideBarUpdated(), this;
  }
  setDisplayed(e, t) {
    super.setDisplayed(e, t), this.dispatchSideBarUpdated();
  }
  getState() {
    const e = {};
    return this.toolPanelWrappers.forEach((t) => {
      var s, i;
      e[t.getToolPanelId()] = (i = (s = t.getToolPanelInstance()) == null ? void 0 : s.getState) == null ? void 0 : i.call(s);
    }), {
      visible: this.isDisplayed(),
      position: this.position,
      openToolPanel: this.openedItem(),
      toolPanels: e
    };
  }
  createToolPanelsAndSideButtons(e, t, s) {
    var i;
    for (const r of e)
      this.createToolPanelAndSideButton(
        r,
        (i = t == null ? void 0 : t.toolPanels) == null ? void 0 : i[r.id],
        s == null ? void 0 : s[r.id]
      );
  }
  validateDef(e) {
    var t;
    return e.id == null ? (I(212), !1) : e.toolPanel === "agFiltersToolPanel" && (t = this.beans.filterManager) != null && t.isAdvFilterEnabled() ? (I(213), !1) : !0;
  }
  createToolPanelAndSideButton(e, t, s) {
    if (!this.validateDef(e))
      return;
    let i;
    if (s)
      i = s;
    else if (i = this.createBean(new kz()), !i.setToolPanelDef(e, {
      initialState: t,
      onStateUpdated: () => this.dispatchSideBarUpdated()
    }))
      return;
    i.setDisplayed(!1);
    const r = i.getGui();
    this.appendChild(r), this.toolPanelWrappers.push(i);
    const n = this.sideBarButtons.addButtonComp(e);
    ih(n.eToggleButton, r);
  }
  refresh() {
    this.toolPanelWrappers.forEach((e) => e.refresh());
  }
  openToolPanel(e, t = "api") {
    const s = this.openedItem();
    if (s === e)
      return;
    this.toolPanelWrappers.forEach((n) => {
      const o = e === n.getToolPanelId();
      n.setDisplayed(o);
    });
    const i = this.openedItem();
    s !== i && (this.sideBarButtons.setActiveButton(e), this.raiseToolPanelVisibleEvent(e, s ?? void 0, t));
  }
  getToolPanelInstance(e) {
    const t = this.toolPanelWrappers.filter((s) => s.getToolPanelId() === e)[0];
    if (!t) {
      I(214, { key: e });
      return;
    }
    return t.getToolPanelInstance();
  }
  raiseToolPanelVisibleEvent(e, t, s) {
    const i = !!e && !!t, r = this.eventSvc;
    t && r.dispatchEvent({
      type: "toolPanelVisibleChanged",
      source: s,
      key: t,
      visible: !1,
      switchingToolPanel: i
    }), e && r.dispatchEvent({
      type: "toolPanelVisibleChanged",
      source: s,
      key: e,
      visible: !0,
      switchingToolPanel: i
    });
  }
  close(e = "api") {
    this.openToolPanel(void 0, e);
  }
  isToolPanelShowing() {
    return !!this.openedItem();
  }
  openedItem() {
    let e = null;
    return this.toolPanelWrappers.forEach((t) => {
      t.isDisplayed() && (e = t.getToolPanelId());
    }), e;
  }
  onSideBarUpdated() {
    var s;
    const e = Au(this.gos.get("sideBar")), t = {};
    e && this.sideBar && ((s = e.toolPanels) == null || s.forEach((i) => {
      var c, d;
      const { id: r } = i;
      if (!r)
        return;
      const n = (c = this.sideBar.toolPanels) == null ? void 0 : c.find(
        (u) => u.id === r
      );
      if (!n || i.toolPanel !== n.toolPanel)
        return;
      const o = this.toolPanelWrappers.find((u) => u.getToolPanelId() === r);
      if (!o)
        return;
      const a = this.gos.addGridCommonParams({
        ...i.toolPanelParams ?? {},
        onStateUpdated: () => this.dispatchSideBarUpdated()
      });
      ((d = o.getToolPanelInstance()) == null ? void 0 : d.refresh(a)) === !0 && (this.toolPanelWrappers = this.toolPanelWrappers.filter((u) => u !== o), ut(o.getGui()), t[r] = o);
    })), this.clearDownUi(), this.setSideBarDef({ sideBarDef: e, existingToolPanelWrappers: t });
  }
  dispatchSideBarUpdated() {
    this.eventSvc.dispatchEvent({ type: "sideBarUpdated" });
  }
  destroyToolPanelWrappers() {
    this.toolPanelWrappers.forEach((e) => {
      ut(e.getGui()), this.destroyBean(e);
    }), this.toolPanelWrappers.length = 0;
  }
  destroy() {
    this.destroyToolPanelWrappers(), super.destroy();
  }
}, Gz = {
  selector: "AG-SIDE-BAR",
  component: Oz
}, Bz = class extends L {
  constructor() {
    super(...arguments), this.beanName = "sideBar";
  }
  getSelector() {
    return Gz;
  }
}, Xh = {
  moduleName: "SideBar",
  version: Me,
  beans: [Bz],
  apiFunctions: {
    isSideBarVisible: mz,
    setSideBarVisible: Cz,
    setSideBarPosition: vz,
    openToolPanel: wz,
    closeToolPanel: yz,
    getOpenedToolPanel: bz,
    refreshToolPanel: Sz,
    isToolPanelShowing: xz,
    getToolPanelInstance: Rz,
    getSideBar: Fz
  },
  dependsOn: [Je, Zw]
}, Cb = class extends _ {
  constructor() {
    super(), this.setTemplate(
      /* html */
      "<div></div>"
    );
  }
  init(e) {
    this.params = e, this.cssClassPrefix = this.params.cssClassPrefix ?? "ag-menu-option", this.addAriaAttributes(), this.addIcon(), this.addName(), this.addShortcut(), this.addSubMenu();
  }
  configureDefaults() {
    return !0;
  }
  addAriaAttributes() {
    const { checked: e, subMenu: t } = this.params, s = this.getGui();
    e && XC(s, e), t && ns(s, !1);
  }
  addIcon() {
    if (this.params.isCompact)
      return;
    const e = ss(
      /* html */
      `<span data-ref="eIcon" class="${this.getClassName("part")} ${this.getClassName("icon")}" role="presentation"></span>`
    ), { checked: t, icon: s } = this.params;
    t ? e.appendChild(ue("check", this.beans)) : s && (ac(s) ? e.appendChild(s) : typeof s == "string" ? e.innerHTML = s : I(227)), this.getGui().appendChild(e);
  }
  addName() {
    const e = ss(
      /* html */
      `<span data-ref="eName" class="${this.getClassName("part")} ${this.getClassName("text")}">${this.params.name || ""}</span>`
    );
    this.getGui().appendChild(e);
  }
  addShortcut() {
    if (this.params.isCompact)
      return;
    const e = ss(
      /* html */
      `<span data-ref="eShortcut" class="${this.getClassName("part")} ${this.getClassName("shortcut")}">${this.params.shortcut || ""}</span>`
    );
    this.getGui().appendChild(e);
  }
  addSubMenu() {
    const e = ss(
      /* html */
      `<span data-ref="ePopupPointer" class="${this.getClassName("part")} ${this.getClassName("popup-pointer")}"></span>`
    ), t = this.getGui();
    if (this.params.subMenu) {
      const s = this.gos.get("enableRtl") ? "subMenuOpenRtl" : "subMenuOpen";
      e.appendChild(ue(s, this.beans));
    }
    t.appendChild(e);
  }
  getClassName(e) {
    return `${this.cssClassPrefix}-${e}`;
  }
}, Vz = (
  /*css*/
  '.ag-menu-list{cursor:default;display:table;padding:var(--ag-spacing) 0;width:100%}.ag-menu-option,.ag-menu-separator{display:table-row}.ag-menu-option-part,.ag-menu-separator-part{display:table-cell;vertical-align:middle}.ag-menu-option{cursor:pointer;font-weight:500}:where(.ag-ltr) :where(.ag-menu-option-popup-pointer) .ag-icon{text-align:right}:where(.ag-rtl) :where(.ag-menu-option-popup-pointer) .ag-icon{text-align:left}.ag-menu-option-text{white-space:nowrap}.ag-menu-option-custom{display:contents}.ag-compact-menu-option{display:flex;flex-wrap:nowrap;width:100%}.ag-compact-menu-option-text{flex:1 1 auto;white-space:nowrap}.ag-menu-separator{height:calc(var(--ag-spacing)*2 + 1px)}.ag-menu-separator-part:after{border-top:1px solid var(--ag-menu-separator-color);content:"";display:block}.ag-compact-menu-option-active,.ag-menu-option-active{background-color:var(--ag-row-hover-color)}.ag-compact-menu-option-part,.ag-menu-option-part{line-height:var(--ag-icon-size);padding:calc(var(--ag-spacing) + 2px) 0}.ag-compact-menu-option-disabled,.ag-menu-option-disabled{cursor:not-allowed;opacity:.5}.ag-compact-menu-option-icon,.ag-menu-option-icon{width:var(--ag-icon-size)}:where(.ag-ltr) .ag-compact-menu-option-icon,:where(.ag-ltr) .ag-menu-option-icon{padding-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-compact-menu-option-icon,:where(.ag-rtl) .ag-menu-option-icon{padding-right:calc(var(--ag-spacing)*2)}.ag-compact-menu-option-text,.ag-menu-option-text{padding-left:calc(var(--ag-spacing)*2);padding-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-compact-menu-option-shortcut,:where(.ag-ltr) .ag-menu-option-shortcut{padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-compact-menu-option-shortcut,:where(.ag-rtl) .ag-menu-option-shortcut{padding-left:var(--ag-spacing)}:where(.ag-ltr) .ag-compact-menu-option-popup-pointer,:where(.ag-ltr) .ag-menu-option-popup-pointer{padding-right:var(--ag-spacing)}:where(.ag-rtl) .ag-compact-menu-option-popup-pointer,:where(.ag-rtl) .ag-menu-option-popup-pointer{padding-left:var(--ag-spacing)}.ag-menu-column-select-wrapper{height:265px;overflow:auto;:where(.ag-column-select){height:100%}}.ag-menu:where(.ag-tabs){min-width:290px}.ag-context-menu-loading-icon{pointer-events:none;position:absolute}'
), Dc = {
  moduleName: "MenuItem",
  version: Me,
  userComponents: {
    agMenuItem: Cb
  },
  icons: {
    // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
    check: "tick",
    // icon for sub menu item
    subMenuOpen: "small-right",
    // version of subMenuOpen used in RTL mode
    subMenuOpenRtl: "small-left"
  },
  css: [Vz]
}, Nz = (
  /*css*/
  ".ag-column-select{display:flex;flex:3 1 0px;flex-direction:column;overflow:hidden;position:relative}.ag-column-select-header{align-items:center;display:flex;flex:none;gap:var(--ag-widget-horizontal-spacing);height:var(--ag-header-height);padding-left:var(--ag-widget-container-horizontal-padding);padding-right:var(--ag-widget-container-horizontal-padding);position:relative}.ag-column-select-column,.ag-column-select-column-group{align-items:center;display:flex;gap:var(--ag-widget-horizontal-spacing);height:100%;position:relative;&:where(:not(:last-child)){margin-bottom:var(--ag-widget-vertical-spacing)}}:where(.ag-ltr) .ag-column-select-column,:where(.ag-ltr) .ag-column-select-column-group{padding-left:calc(var(--ag-indentation-level)*var(--ag-column-select-indent-size))}:where(.ag-rtl) .ag-column-select-column,:where(.ag-rtl) .ag-column-select-column-group{padding-right:calc(var(--ag-indentation-level)*var(--ag-column-select-indent-size))}.ag-column-select-header-icon{border-radius:var(--ag-border-radius);cursor:pointer;height:var(--ag-icon-size);position:relative;width:var(--ag-icon-size);&:focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-column-select-header-filter-wrapper{flex:1 1 auto}.ag-column-select-header-filter{width:100%}.ag-column-select-list{flex:1 1 0px;overflow:hidden}:where(.ag-ltr) .ag-column-select-add-group-indent{margin-left:calc(var(--ag-icon-size) + var(--ag-spacing)*1.5)}:where(.ag-rtl) .ag-column-select-add-group-indent{margin-right:calc(var(--ag-icon-size) + var(--ag-spacing)*1.5)}.ag-column-select-column-group-readonly,.ag-column-select-column-readonly{opacity:.5;pointer-events:none}.ag-column-select-virtual-list-viewport{padding:calc(var(--ag-widget-container-vertical-padding)*.5) 0}.ag-column-select-virtual-list-item{padding:0 var(--ag-widget-container-horizontal-padding)}.ag-column-select-column-label{flex:1 1 auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-select-checkbox{display:flex}"
), Hz = 300, zz = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="ag-column-select-header" role="presentation">
            <div data-ref="eExpand" class="ag-column-select-header-icon"></div>
            <ag-checkbox data-ref="eSelect" class="ag-column-select-header-checkbox"></ag-checkbox>
            <ag-input-text-field class="ag-column-select-header-filter-wrapper" data-ref="eFilterTextField"></ag-input-text-field>
        </div>`,
      [ai, Ks]
    ), this.eExpand = E, this.eSelect = E, this.eFilterTextField = E;
  }
  postConstruct() {
    this.createExpandIcons(), this.addManagedListeners(this.eExpand, {
      click: this.onExpandClicked.bind(this),
      keydown: (t) => {
        t.key === P.SPACE && (t.preventDefault(), this.onExpandClicked());
      }
    }), this.addManagedElementListeners(this.eSelect.getInputElement(), { click: this.onSelectClicked.bind(this) }), this.addManagedPropertyListener("functionsReadOnly", () => this.onFunctionsReadOnlyPropChanged()), this.eFilterTextField.setAutoComplete(!1).onValueChange(() => this.onFilterTextChanged()), this.addManagedEventListeners({ newColumnsLoaded: this.showOrHideOptions.bind(this) });
    const e = this.getLocaleTextFunc();
    this.eSelect.setInputAriaLabel(e("ariaColumnSelectAll", "Toggle All Columns Visibility")), this.eFilterTextField.setInputAriaLabel(e("ariaFilterColumnsInput", "Filter Columns Input")), this.activateTabIndex([this.eExpand]);
  }
  onFunctionsReadOnlyPropChanged() {
    const e = this.gos.get("functionsReadOnly");
    this.eSelect.setReadOnly(e), this.eSelect.addOrRemoveCssClass("ag-column-select-column-readonly", e);
  }
  init(e) {
    this.params = e;
    const t = this.gos.get("functionsReadOnly");
    this.eSelect.setReadOnly(t), this.eSelect.addOrRemoveCssClass("ag-column-select-column-readonly", t), this.beans.colModel.ready && this.showOrHideOptions();
  }
  createExpandIcons() {
    const e = this.beans;
    this.eExpand.appendChild(this.eExpandChecked = ue("columnSelectOpen", e)), this.eExpand.appendChild(this.eExpandUnchecked = ue("columnSelectClosed", e)), this.eExpand.appendChild(this.eExpandIndeterminate = ue("columnSelectIndeterminate", e)), this.setExpandState(
      0
      /* EXPANDED */
    );
  }
  // we only show expand / collapse if we are showing columns
  showOrHideOptions() {
    var o;
    const e = this.params, t = !e.suppressColumnFilter, s = !e.suppressColumnSelectAll, i = !e.suppressColumnExpandAll, r = !!((o = this.beans.colModel.colDefCols) != null && o.treeDepth), n = this.getLocaleTextFunc();
    this.eFilterTextField.setInputPlaceholder(n("searchOoo", "Search...")), re(this.eFilterTextField.getGui(), t), re(this.eSelect.getGui(), s), re(this.eExpand, i && r);
  }
  onFilterTextChanged() {
    this.onFilterTextChangedDebounced || (this.onFilterTextChangedDebounced = Et(
      this,
      () => {
        const e = this.eFilterTextField.getValue();
        this.dispatchLocalEvent({ type: "filterChanged", filterText: e });
      },
      Hz
    )), this.onFilterTextChangedDebounced();
  }
  onSelectClicked() {
    this.dispatchLocalEvent({ type: this.selectState ? "unselectAll" : "selectAll" });
  }
  onExpandClicked() {
    this.dispatchLocalEvent({ type: this.expandState === 0 ? "collapseAll" : "expandAll" });
  }
  setExpandState(e) {
    this.expandState = e, re(
      this.eExpandChecked,
      e === 0
      /* EXPANDED */
    ), re(
      this.eExpandUnchecked,
      e === 1
      /* COLLAPSED */
    ), re(
      this.eExpandIndeterminate,
      e === 2
      /* INDETERMINATE */
    );
  }
  setSelectionState(e) {
    this.selectState = e, this.eSelect.setValue(this.selectState);
  }
}, Wz = {
  selector: "AG-PRIMARY-COLS-HEADER",
  component: zz
};
function $n(e) {
  return !!e && typeof e.children < "u";
}
function hr(e) {
  return $n(e) ? e.groupId : e.colId;
}
function vb(e, t, s) {
  const i = (o, a) => {
    const c = o.children.map(hr).includes(hr(a)), d = pe(o.children), u = d && hr(d) !== hr(a);
    return c && u;
  };
  if (!$n(e))
    return !0;
  const r = e, n = s;
  if (i(r, n) || r.groupId === t && !r.children.map(hr).includes(hr(n)))
    return r.children.push(n), !0;
  for (let o = r.children.length - 1; o >= 0 && !vb(r.children[o], t, s); o--)
    ;
  return !1;
}
function _z(e) {
  const t = (r, n) => $n(r) && $n(n) && hr(r) === hr(n), s = (r, n) => {
    if (!$n(n))
      return r;
    const o = r, a = n;
    return a.children && a.groupId && vb(o, a.groupId, a.children[0]) || a.children.forEach((l) => s(o, l)), o;
  }, i = [];
  for (let r = 1; r <= e.length; r++) {
    const n = e[r - 1], o = e[r];
    t(n, o) ? e[r] = s(n, o) : i.push(n);
  }
  return i;
}
function wb(e, t) {
  const s = [], i = (n, o) => {
    if ($n(n)) {
      const a = n, l = typeof a.groupId < "u" ? a.groupId : a.headerName, c = new jo(a, l, !1, o), d = [];
      return a.children.forEach((u) => {
        const h = i(u, o + 1);
        h && d.push(h);
      }), c.setChildren(d), c;
    } else {
      const a = n, l = a.colId ? a.colId : a.field, c = e.getColDefCol(l);
      return c || s.push(a), c;
    }
  }, r = [];
  return t.forEach((n) => {
    const o = i(n, 0);
    o && r.push(o);
  }), s.length > 0 && I(217, { invalidColIds: s }), r;
}
function yb(e, t) {
  const s = Uz(e), i = _z(s);
  t(i);
}
function Uz(e) {
  const t = (r, n) => {
    let o;
    if (ct(r))
      if (r.isPadding())
        o = n;
      else {
        const l = Object.assign({}, r.getColGroupDef());
        l.groupId = r.getGroupId(), l.children = [n], o = l;
      }
    else {
      const l = Object.assign({}, r.getColDef());
      l.colId = r.getColId(), o = l;
    }
    const a = r.getOriginalParent();
    return a ? t(a, o) : o;
  };
  return e.getCols().filter((r) => {
    const n = r.getColDef();
    return r.isPrimary() && !n.showRowGroup;
  }).map((r) => t(r, r.getColDef()));
}
var Nf = class {
  constructor(e, t, s, i = !1, r) {
    this.displayName = e, this.depth = s, this.group = i, this.localEventService = new Mr(), i ? (this.columnGroup = t, this._expanded = r, this.children = []) : this.column = t;
  }
  get expanded() {
    return !!this._expanded;
  }
  set expanded(e) {
    e !== this._expanded && (this._expanded = e, this.localEventService.dispatchEvent({ type: "expandedChanged" }));
  }
  addEventListener(e, t) {
    this.localEventService.addEventListener(e, t);
  }
  removeEventListener(e, t) {
    this.localEventService.removeEventListener(e, t);
  }
};
function bb(e, t, s, i) {
  const r = $z(t);
  Sb(e, r, s, i);
}
function Sb(e, t, s, i) {
  e.colModel.isPivotMode() ? Kz(e, t, s, i) : jz(e, t, s, i);
}
function $z(e) {
  const t = [], s = (i) => {
    i.forEach((r) => {
      r.passesFilter && (r.group ? s(r.children) : t.push(r.column));
    });
  };
  return s(e), t;
}
function jz(e, t, s, i) {
  var n;
  const r = [];
  t.forEach((o) => {
    o.getColDef().lockVisible || o.isVisible() != s && r.push({
      colId: o.getId(),
      hide: !s
    });
  }), r.length > 0 && ws(e, { state: r }, i), (n = e.selectionColSvc) == null || n.refreshVisibility(i);
}
function Kz(e, t, s, i) {
  qz(e, t, s, i);
}
function qz(e, t, s, i) {
  const r = [], a = s ? (l) => {
    var c;
    if (!l.isAnyFunctionActive())
      if (l.isAllowValue()) {
        const d = typeof l.getAggFunc() == "string" ? l.getAggFunc() : (c = e.aggFuncSvc) == null ? void 0 : c.getDefaultAggFunc(l);
        r.push({
          colId: l.getId(),
          aggFunc: d
        });
      } else l.isAllowRowGroup() ? r.push({
        colId: l.getId(),
        rowGroup: !0
      }) : l.isAllowPivot() && r.push({
        colId: l.getId(),
        pivot: !0
      });
  } : (l) => {
    (l.isPivotActive() || l.isRowGroupActive() || l.isValueActive()) && r.push({
      colId: l.getId(),
      pivot: !1,
      rowGroup: !1,
      aggFunc: null
    });
  };
  t.forEach(a), r.length > 0 && ws(e, { state: r }, i);
}
function xb(e, t) {
  const { columns: s, visibleState: i, pivotState: r, eventType: n } = t, o = s.map((a) => {
    const l = a.getColId();
    if (e.colModel.isPivotMode()) {
      const c = r == null ? void 0 : r[l];
      return {
        colId: l,
        pivot: c == null ? void 0 : c.pivot,
        rowGroup: c == null ? void 0 : c.rowGroup,
        aggFunc: c == null ? void 0 : c.aggFunc
      };
    } else
      return {
        colId: l,
        hide: !(i != null && i[l])
      };
  });
  ws(e, { state: o }, n);
}
function Rb(e) {
  return {
    pivot: e.isPivotActive(),
    rowGroup: e.isRowGroupActive(),
    aggFunc: e.isValueActive() ? e.getAggFunc() : void 0
  };
}
function jl(e, t, s, i) {
  const r = t.getCol(s);
  e.groupData || (e.groupData = {});
  const n = r.getColId(), o = e.groupData[n];
  o !== i && (e.groupData[n] = i, e.dispatchCellChangedEvent(r, i, o));
}
function Fb(e, t, s) {
  var i;
  e.group !== s && (e.group && !s && (e.expanded = !1), e.group = s, e.updateHasChildren(), (i = t.selectionSvc) == null || i.updateRowSelectable(e), e.dispatchRowEvent("groupChanged"));
}
function da(e, t) {
  const { gos: s, rowGroupColsSvc: i } = t;
  if (!i || !e)
    return !1;
  const r = s.get("groupLockGroupColumns");
  if (!e.isRowGroupActive() || r === 0)
    return !1;
  if (r === -1)
    return !0;
  const n = i.columns.findIndex((o) => o.getColId() === e.getColId());
  return r > n;
}
var Yz = class extends Ti {
  constructor(e) {
    super(), this.setTemplateFromElement(e.getGui(), void 0, void 0, !0);
  }
  postConstruct() {
    this.initialiseTabGuard({
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => this.handleKeyDown(e)
    });
  }
  handleKeyDown(e) {
    e.key === P.ESCAPE && this.closePanel();
  }
  onTabKeyDown(e) {
    e.defaultPrevented || (this.closePanel(), e.preventDefault());
  }
  closePanel() {
    const e = this.parentComponent;
    e.closeSubMenu(), setTimeout(() => e.getGui().focus(), 0);
  }
};
function Xz(e, t, s) {
  return e.getCompDetails(t, Zz, "agMenuItem", s, !0);
}
var Zz = {
  name: "menuItem",
  optionalMethods: ["setActive", "select", "setExpanded", "configureDefaults"]
}, Mu = class extends L {
  constructor() {
    super(...arguments), this.ACTIVATION_DELAY = 80, this.isActive = !1, this.subMenuIsOpen = !1, this.subMenuIsOpening = !1, this.suppressRootStyles = !0, this.suppressAria = !0, this.suppressFocus = !0;
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc, this.userCompFactory = e.userCompFactory, this.registry = e.registry;
  }
  init(e) {
    var a;
    const { menuItemDef: t, isAnotherSubMenuOpen: s, level: i, childComponent: r, contextParams: n } = e;
    this.params = e.menuItemDef, this.level = i, this.isAnotherSubMenuOpen = s, this.childComponent = r, this.contextParams = n, this.cssClassPrefix = ((a = this.params.menuItemParams) == null ? void 0 : a.cssClassPrefix) ?? "ag-menu-option";
    const o = Xz(this.userCompFactory, this.params, {
      ...t,
      level: i,
      isAnotherSubMenuOpen: s,
      openSubMenu: (l) => this.openSubMenu(l),
      closeSubMenu: () => this.closeSubMenu(),
      closeMenu: (l) => this.closeMenu(l),
      updateTooltip: (l, c) => this.refreshTooltip(l, c),
      onItemActivated: () => this.onItemActivated()
    });
    return (o == null ? void 0 : o.newAgStackInstance().then((l) => {
      var d;
      this.menuItemComp = l;
      const c = (d = l.configureDefaults) == null ? void 0 : d.call(l);
      c && this.configureDefaults(c === !0 ? void 0 : c);
    })) ?? fe.resolve();
  }
  addListeners(e, t) {
    t != null && t.suppressClick || this.addManagedElementListeners(e, { click: (s) => this.onItemSelected(s) }), t != null && t.suppressKeyboardSelect || this.addManagedElementListeners(e, {
      keydown: (s) => {
        (s.key === P.ENTER || s.key === P.SPACE) && (s.preventDefault(), this.onItemSelected(s));
      }
    }), t != null && t.suppressMouseDown || this.addManagedElementListeners(e, {
      mousedown: (s) => {
        s.stopPropagation(), s.preventDefault();
      }
    }), t != null && t.suppressMouseOver || this.addManagedElementListeners(e, {
      mouseenter: () => this.onMouseEnter(),
      mouseleave: () => this.onMouseLeave()
    });
  }
  isDisabled() {
    return !!this.params.disabled;
  }
  openSubMenu(e = !1, t) {
    var c, d;
    if (this.closeSubMenu(), !this.params.subMenu)
      return;
    this.subMenuIsOpening = !0;
    const s = ss(
      /* html */
      '<div class="ag-menu" role="presentation"></div>'
    );
    this.eSubMenuGui = s;
    let i, r = () => {
      this.subMenuIsOpening = !1;
    };
    if (this.childComponent) {
      const u = this.createBean(new Yz(this.childComponent));
      u.setParentComponent(this);
      const h = u.getGui(), p = "mouseenter", g = () => this.cancelDeactivate();
      h.addEventListener(p, g), i = () => h.removeEventListener(p, g), s.appendChild(h), this.childComponent.afterGuiAttached && (r = () => {
        this.childComponent.afterGuiAttached(), this.subMenuIsOpening = !1;
      });
    } else if (this.params.subMenu) {
      const u = this.createBean(new ba(this.level + 1, this.contextParams));
      u.setParentComponent(this), u.addMenuItems(this.params.subMenu), s.appendChild(u.getGui()), this.addManagedListeners(u, { closeMenu: (h) => this.dispatchLocalEvent(h) }), u.addGuiEventListener("mouseenter", () => this.cancelDeactivate()), i = () => this.destroyBean(u), e && (r = () => {
        u.activateFirstItem(), this.subMenuIsOpening = !1;
      });
    }
    const { popupSvc: n } = this, o = () => {
      const u = this.eGui;
      n == null || n.positionPopupForMenu({
        eventSource: u,
        ePopup: s
      });
      const { column: h, node: p } = this.contextParams;
      n == null || n.callPostProcessPopup(
        "subMenu",
        s,
        u,
        t instanceof MouseEvent ? t : void 0,
        h,
        p
      );
    }, a = this.getLocaleTextFunc(), l = n == null ? void 0 : n.addPopup({
      modal: !0,
      eChild: s,
      positionCallback: o,
      anchorToElement: this.eGui,
      ariaLabel: a("ariaLabelSubMenu", "SubMenu"),
      afterGuiAttached: r
    });
    this.subMenuIsOpen = !0, this.setAriaExpanded(!0), this.hideSubMenu = () => {
      var u, h;
      l && l.hideFunc(), this.subMenuIsOpen = !1, this.setAriaExpanded(!1), i(), (h = (u = this.menuItemComp).setExpanded) == null || h.call(u, !1), this.eSubMenuGui = void 0;
    }, (d = (c = this.menuItemComp).setExpanded) == null || d.call(c, !0);
  }
  setAriaExpanded(e) {
    this.suppressAria || ns(this.eGui, e);
  }
  closeSubMenu() {
    this.hideSubMenu && (this.hideSubMenu(), this.hideSubMenu = null, this.setAriaExpanded(!1));
  }
  isSubMenuOpen() {
    return this.subMenuIsOpen;
  }
  isSubMenuOpening() {
    return this.subMenuIsOpening;
  }
  activate(e) {
    var t, s;
    this.cancelActivate(), !this.params.disabled && (this.isActive = !0, this.suppressRootStyles || this.eGui.classList.add(`${this.cssClassPrefix}-active`), (s = (t = this.menuItemComp).setActive) == null || s.call(t, !0), this.suppressFocus || this.eGui.focus({ preventScroll: !0 }), e && this.params.subMenu && window.setTimeout(() => {
      this.isAlive() && this.isActive && this.openSubMenu();
    }, 300), this.onItemActivated());
  }
  deactivate() {
    var e, t;
    this.cancelDeactivate(), this.suppressRootStyles || this.eGui.classList.remove(`${this.cssClassPrefix}-active`), (t = (e = this.menuItemComp).setActive) == null || t.call(e, !1), this.isActive = !1, this.subMenuIsOpen && this.hideSubMenu();
  }
  getGui() {
    return this.menuItemComp.getGui();
  }
  getParentComponent() {
    return this.parentComponent;
  }
  setParentComponent(e) {
    this.parentComponent = e;
  }
  getSubMenuGui() {
    return this.eSubMenuGui;
  }
  onItemSelected(e) {
    var t, s;
    (s = (t = this.menuItemComp).select) == null || s.call(t), this.params.action ? this.beans.frameworkOverrides.wrapOutgoing(
      () => this.params.action(
        this.gos.addGridCommonParams({
          ...this.contextParams
        })
      )
    ) : this.openSubMenu(e && e.type === "keydown", e), !(this.params.subMenu && !this.params.action || this.params.suppressCloseOnSelect) && this.closeMenu(e);
  }
  closeMenu(e) {
    const t = {
      type: "closeMenu"
    };
    e && (e instanceof MouseEvent ? t.mouseEvent = e : t.keyboardEvent = e), this.dispatchLocalEvent(t);
  }
  onItemActivated() {
    const e = {
      type: "menuItemActivated",
      menuItem: this
    };
    this.dispatchLocalEvent(e);
  }
  cancelActivate() {
    this.activateTimeoutId && (window.clearTimeout(this.activateTimeoutId), this.activateTimeoutId = 0);
  }
  cancelDeactivate() {
    this.deactivateTimeoutId && (window.clearTimeout(this.deactivateTimeoutId), this.deactivateTimeoutId = 0);
  }
  onMouseEnter() {
    this.cancelDeactivate(), this.isAnotherSubMenuOpen() ? this.activateTimeoutId = window.setTimeout(() => this.activate(!0), this.ACTIVATION_DELAY) : this.activate(!0);
  }
  onMouseLeave() {
    this.cancelActivate(), this.isSubMenuOpen() ? this.deactivateTimeoutId = window.setTimeout(() => this.deactivate(), this.ACTIVATION_DELAY) : this.deactivate();
  }
  configureDefaults(e) {
    var l, c, d;
    if (!this.menuItemComp) {
      setTimeout(() => this.configureDefaults(e));
      return;
    }
    let t = this.menuItemComp.getGui();
    const { suppressRootStyles: s, suppressTooltip: i, suppressAria: r, suppressTabIndex: n, suppressFocus: o } = e || {}, a = (c = (l = this.menuItemComp).getRootElement) == null ? void 0 : c.call(l);
    a && (s || t.classList.add("ag-menu-option-custom"), t = a), this.eGui = t, this.suppressRootStyles = !!s, this.suppressRootStyles || (t.classList.add(this.cssClassPrefix), (d = this.params.cssClasses) == null || d.forEach((u) => t.classList.add(u)), this.params.disabled && t.classList.add(`${this.cssClassPrefix}-disabled`)), i || this.refreshTooltip(this.params.tooltip), this.suppressAria = !!r, this.suppressAria || (nt(t, "treeitem"), ha(t, this.level + 1), this.params.disabled && wl(t, !0)), n || t.setAttribute("tabindex", "-1"), this.params.disabled || this.addListeners(t, e), this.suppressFocus = !!o;
  }
  refreshTooltip(e, t) {
    if (this.tooltip = e, this.tooltipFeature = this.destroyBean(this.tooltipFeature), !e || !this.menuItemComp)
      return;
    const s = this.registry.createDynamicBean("tooltipFeature", !1, {
      getGui: () => this.getGui(),
      getTooltipValue: () => this.tooltip,
      getLocation: () => "menu",
      shouldDisplayTooltip: t
    });
    s && (this.tooltipFeature = this.createBean(s));
  }
  destroy() {
    var e, t;
    this.tooltipFeature = this.destroyBean(this.tooltipFeature), (t = (e = this.menuItemComp) == null ? void 0 : e.destroy) == null || t.call(e), super.destroy();
  }
}, ba = class extends Ti {
  constructor(e = 0, t) {
    super(
      /* html */
      '<div class="ag-menu-list" role="tree"></div>'
    ), this.level = e, this.menuItems = [], this.params = t ?? {
      column: null,
      node: null,
      value: null
    };
  }
  postConstruct() {
    this.initialiseTabGuard({
      onTabKeyDown: (e) => this.onTabKeyDown(e),
      handleKeyDown: (e) => this.handleKeyDown(e),
      onFocusIn: (e) => this.handleFocusIn(e),
      onFocusOut: (e) => this.handleFocusOut(e)
    });
  }
  onTabKeyDown(e) {
    const t = this.getParentComponent(), s = t && t.getGui();
    s && s.classList.contains("ag-focus-managed") || e.preventDefault(), e.shiftKey && this.closeIfIsChild(e);
  }
  handleKeyDown(e) {
    switch (e.key) {
      case P.UP:
      case P.RIGHT:
      case P.DOWN:
      case P.LEFT:
        e.preventDefault(), this.handleNavKey(e.key);
        break;
      case P.ESCAPE:
        this.closeIfIsChild() && gt(e);
        break;
    }
  }
  handleFocusIn(e) {
    var s, i;
    const t = e.relatedTarget;
    !this.tabGuardFeature.getTabGuardCtrl().isTabGuard(t) && (this.getGui().contains(t) || (i = (s = this.activeMenuItem) == null ? void 0 : s.getSubMenuGui()) != null && i.contains(t)) || (this.activeMenuItem ? this.activeMenuItem.activate() : this.activateFirstItem());
  }
  handleFocusOut(e) {
    var s;
    const t = e.relatedTarget;
    !this.activeMenuItem || this.getGui().contains(t) || (s = this.activeMenuItem.getSubMenuGui()) != null && s.contains(t) || this.activeMenuItem.isSubMenuOpening() || this.activeMenuItem.deactivate();
  }
  clearActiveItem() {
    this.activeMenuItem && (this.activeMenuItem.deactivate(), this.activeMenuItem = null);
  }
  addMenuItems(e) {
    e != null && fe.all(
      e.map((t) => t === "separator" ? fe.resolve({ eGui: this.createSeparator() }) : typeof t == "string" ? (I(228, { menuItemOrString: t }), fe.resolve({ eGui: null })) : this.addItem(t))
    ).then((t) => {
      (t ?? []).forEach((s) => {
        s != null && s.eGui && (this.appendChild(s.eGui), s.comp && this.menuItems.push(s.comp));
      });
    });
  }
  addItem(e) {
    const t = this.createManagedBean(new Mu());
    return t.init({
      menuItemDef: e,
      isAnotherSubMenuOpen: () => this.menuItems.some((s) => s.isSubMenuOpen()),
      level: this.level,
      contextParams: this.params
    }).then(() => (t.setParentComponent(this), this.addManagedListeners(t, {
      closeMenu: (s) => {
        this.dispatchLocalEvent(s);
      },
      menuItemActivated: (s) => {
        this.activeMenuItem && this.activeMenuItem !== s.menuItem && this.activeMenuItem.deactivate(), this.activeMenuItem = s.menuItem;
      }
    }), {
      comp: t,
      eGui: t.getGui()
    }));
  }
  activateFirstItem() {
    const e = this.menuItems.filter((t) => !t.isDisabled())[0];
    e && e.activate();
  }
  createSeparator() {
    return ss(
      /* html */
      `
            <div class="ag-menu-separator" aria-hidden="true">
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
            </div>`
    );
  }
  handleNavKey(e) {
    switch (e) {
      case P.UP:
      case P.DOWN: {
        const s = this.findNextItem(e === P.UP);
        s && s !== this.activeMenuItem && s.activate();
        return;
      }
    }
    const t = this.gos.get("enableRtl") ? P.RIGHT : P.LEFT;
    e === t ? this.closeIfIsChild() : this.openChild();
  }
  closeIfIsChild(e) {
    const t = this.getParentComponent();
    return t && t instanceof Mu ? (e && e.preventDefault(), t.closeSubMenu(), t.getGui().focus(), !0) : !1;
  }
  openChild() {
    this.activeMenuItem && this.activeMenuItem.openSubMenu(!0);
  }
  findNextItem(e) {
    const t = this.menuItems.filter((r) => !r.isDisabled());
    if (!t.length)
      return;
    if (!this.activeMenuItem)
      return e ? pe(t) : t[0];
    e && t.reverse();
    let s, i = !1;
    for (let r = 0; r < t.length; r++) {
      const n = t[r];
      if (!i) {
        n === this.activeMenuItem && (i = !0);
        continue;
      }
      s = n;
      break;
    }
    return i && !s ? t[0] : s || this.activeMenuItem;
  }
  destroy() {
    this.clearActiveItem(), super.destroy();
  }
}, Pb = class extends _ {
  constructor(e, t, s) {
    super(
      /* html */
      '<div class="ag-menu"></div>'
    ), this.column = e, this.mouseEvent = t, this.parentEl = s, this.displayName = null;
  }
  postConstruct() {
    const {
      column: e,
      beans: { colNames: t }
    } = this;
    this.initializeProperties(e);
    let s;
    if (Ri(e) ? s = t.getDisplayNameForColumn(e, "columnToolPanel") : s = t.getDisplayNameForProvidedColumnGroup(null, e, "columnToolPanel"), this.displayName = s, this.buildMenuItemMap(), this.isActive()) {
      this.mouseEvent.preventDefault();
      const i = this.getMappedMenuItems();
      if (i.length === 0)
        return;
      this.displayContextMenu(i);
    }
  }
  initializeProperties(e) {
    let t;
    ct(e) ? t = e.getLeafColumns() : t = [e], this.columns = t, this.allowGrouping = t.some((s) => s.isPrimary() && s.isAllowRowGroup()), this.allowValues = t.some((s) => s.isPrimary() && s.isAllowValue()), this.allowPivoting = this.beans.colModel.isPivotMode() && t.some((s) => s.isPrimary() && s.isAllowPivot());
  }
  buildMenuItemMap() {
    const e = this.getLocaleTextFunc(), { beans: t, displayName: s } = this, { rowGroupColsSvc: i, valueColsSvc: r, pivotColsSvc: n, colModel: o } = t, a = /* @__PURE__ */ new Map();
    this.menuItemMap = a, a.set("rowGroup", {
      allowedFunction: (l) => l.isPrimary() && l.isAllowRowGroup() && !da(l, t),
      activeFunction: (l) => l.isRowGroupActive(),
      activateLabel: () => `${e("groupBy", "Group by")} ${s}`,
      deactivateLabel: () => `${e("ungroupBy", "Un-Group by")} ${s}`,
      activateFunction: () => i == null ? void 0 : i.setColumns(this.addColumnsToList(i.columns), "toolPanelUi"),
      deActivateFunction: () => i == null ? void 0 : i.setColumns(this.removeColumnsFromList(i.columns), "toolPanelUi"),
      addIcon: "menuAddRowGroup",
      removeIcon: "menuRemoveRowGroup"
    }), a.set("value", {
      allowedFunction: (l) => l.isPrimary() && l.isAllowValue(),
      activeFunction: (l) => l.isValueActive(),
      activateLabel: () => e("addToValues", `Add ${s} to values`, [s]),
      deactivateLabel: () => e("removeFromValues", `Remove ${s} from values`, [s]),
      activateFunction: () => r == null ? void 0 : r.setColumns(this.addColumnsToList(r.columns), "toolPanelUi"),
      deActivateFunction: () => r == null ? void 0 : r.setColumns(this.removeColumnsFromList(r.columns), "toolPanelUi"),
      addIcon: "valuePanel",
      removeIcon: "valuePanel"
    }), a.set("pivot", {
      allowedFunction: (l) => o.isPivotMode() && l.isPrimary() && l.isAllowPivot(),
      activeFunction: (l) => l.isPivotActive(),
      activateLabel: () => e("addToLabels", `Add ${s} to labels`, [s]),
      deactivateLabel: () => e("removeFromLabels", `Remove ${s} from labels`, [s]),
      activateFunction: () => n == null ? void 0 : n.setColumns(this.addColumnsToList(n.columns), "toolPanelUi"),
      deActivateFunction: () => n == null ? void 0 : n.setColumns(this.removeColumnsFromList(n.columns), "toolPanelUi"),
      addIcon: "pivotPanel",
      removeIcon: "pivotPanel"
    });
  }
  addColumnsToList(e) {
    return [...e].concat(this.columns.filter((t) => e.indexOf(t) === -1));
  }
  removeColumnsFromList(e) {
    return e.filter((t) => this.columns.indexOf(t) === -1);
  }
  displayContextMenu(e) {
    const t = this.getGui(), s = this.createBean(new ba()), i = this.getLocaleTextFunc();
    let r = () => {
    };
    t.appendChild(s.getGui()), s.addMenuItems(e), s.addManagedListeners(s, {
      closeMenu: () => {
        this.parentEl.focus(), r();
      }
    });
    const n = this.beans.popupSvc, o = n.addPopup({
      modal: !0,
      eChild: t,
      closeOnEsc: !0,
      afterGuiAttached: () => Dt(s.getGui()),
      ariaLabel: i("ariaLabelContextMenu", "Context Menu"),
      closedCallback: (a) => {
        a instanceof KeyboardEvent && this.parentEl.focus(), this.destroyBean(s);
      }
    });
    o && (r = o.hideFunc), n.positionPopupUnderMouseEvent({
      type: "columnContextMenu",
      mouseEvent: this.mouseEvent,
      ePopup: t
    });
  }
  isActive() {
    return this.allowGrouping || this.allowValues || this.allowPivoting;
  }
  getMappedMenuItems() {
    const e = [], { menuItemMap: t, columns: s, displayName: i, beans: r } = this;
    for (const n of t.values()) {
      const o = s.some((l) => n.allowedFunction(l) && !n.activeFunction(l)), a = s.some((l) => n.allowedFunction(l) && n.activeFunction(l));
      o && e.push({
        name: n.activateLabel(i),
        icon: ue(n.addIcon, r, null),
        action: () => n.activateFunction()
      }), a && e.push({
        name: n.deactivateLabel(i),
        icon: ue(n.removeIcon, r, null),
        action: () => n.deActivateFunction()
      });
    }
    return e;
  }
}, Tb = class extends _ {
  constructor(e, t, s, i) {
    super(), this.modelItem = e, this.allowDragging = t, this.eventType = s, this.focusWrapper = i, this.cbSelect = E, this.eLabel = E, this.eGroupOpenedIcon = E, this.eGroupClosedIcon = E, this.eColumnGroupIcons = E, this.processingColumnStateChange = !1;
    const { columnGroup: r, depth: n, displayName: o } = e;
    this.columnGroup = r, this.columnDepth = n, this.displayName = o;
  }
  postConstruct() {
    this.setTemplate(
      /* html */
      `<div class="ag-column-select-column-group">
                <span class="ag-column-group-icons" data-ref="eColumnGroupIcons" >
                    <span class="ag-column-group-closed-icon" data-ref="eGroupClosedIcon"></span>
                    <span class="ag-column-group-opened-icon" data-ref="eGroupOpenedIcon"></span>
                </span>
                <ag-checkbox data-ref="cbSelect" class="ag-column-select-checkbox"></ag-checkbox>
                <span class="ag-column-select-column-label" data-ref="eLabel"></span>
            </div>`,
      [ai]
    );
    const {
      beans: e,
      cbSelect: t,
      eLabel: s,
      displayName: i,
      columnDepth: r,
      modelItem: n,
      focusWrapper: o,
      columnGroup: a
    } = this, { registry: l, gos: c } = e, d = ue("columnDrag", e);
    this.eDragHandle = d, d.classList.add("ag-drag-handle", "ag-column-select-column-group-drag-handle");
    const u = t.getGui(), h = t.getInputElement();
    u.insertAdjacentElement("afterend", d), h.setAttribute("tabindex", "-1"), s.innerHTML = i ?? "", this.setupExpandContract(), this.addCssClass("ag-column-select-indent-" + r), this.getGui().style.setProperty("--ag-indentation-level", String(r)), this.tooltipFeature = this.createOptionalManagedBean(
      l.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        getLocation: () => "columnToolPanelColumnGroup",
        shouldDisplayTooltip: yc(c, () => s)
      })
    ), this.addManagedEventListeners({ columnPivotModeChanged: this.onColumnStateChanged.bind(this) }), this.addManagedElementListeners(s, { click: this.onLabelClicked.bind(this) }), this.addManagedListeners(t, { fieldValueChanged: this.onCheckboxChanged.bind(this) }), this.addManagedListeners(n, { expandedChanged: this.onExpandChanged.bind(this) }), this.addManagedListeners(o, {
      keydown: this.handleKeyDown.bind(this),
      contextmenu: this.onContextMenu.bind(this)
    }), this.setOpenClosedIcons(), this.setupDragging(), this.onColumnStateChanged(), this.addVisibilityListenersToAllChildren(), this.refreshAriaExpanded(), this.refreshAriaLabel(), this.setupTooltip(), rw(a.getColGroupDef(), c, null, a).forEach((g) => this.addOrRemoveCssClass(g, !0));
  }
  getColumns() {
    return this.columnGroup.getLeafColumns();
  }
  setupTooltip() {
    const e = this.columnGroup.getColGroupDef();
    if (!e)
      return;
    const t = () => {
      var s;
      return (s = this.tooltipFeature) == null ? void 0 : s.setTooltipAndRefresh(e.headerTooltip);
    };
    t(), this.addManagedEventListeners({ newColumnsLoaded: t });
  }
  handleKeyDown(e) {
    switch (e.key) {
      case P.LEFT:
        e.preventDefault(), this.modelItem.expanded = !1;
        break;
      case P.RIGHT:
        e.preventDefault(), this.modelItem.expanded = !0;
        break;
      case P.SPACE:
        e.preventDefault(), this.isSelectable() && this.onSelectAllChanged(!this.isSelected());
        break;
    }
  }
  onContextMenu(e) {
    const { columnGroup: t, gos: s } = this;
    if (s.get("functionsReadOnly"))
      return;
    const i = this.createBean(new Pb(t, e, this.focusWrapper));
    this.addDestroyFunc(() => {
      i.isAlive() && this.destroyBean(i);
    });
  }
  addVisibilityListenersToAllChildren() {
    const e = this.onColumnStateChanged.bind(this);
    this.columnGroup.getLeafColumns().forEach((t) => {
      this.addManagedListeners(t, {
        visibleChanged: e,
        columnValueChanged: e,
        columnPivotChanged: e,
        columnRowGroupChanged: e
      });
    });
  }
  setupDragging() {
    if (!this.allowDragging) {
      re(this.eDragHandle, !1);
      return;
    }
    const e = this.beans, { gos: t, eventSvc: s, dragAndDrop: i } = e;
    let r = !t.get("suppressDragLeaveHidesColumns");
    const n = {
      type: ni.ToolPanel,
      eElement: this.eDragHandle,
      dragItemName: this.displayName,
      getDefaultIconName: () => r ? "hide" : "notAllowed",
      getDragItem: () => this.createDragItem(),
      onDragStarted: () => {
        r = !t.get("suppressDragLeaveHidesColumns"), s.dispatchEvent({
          type: "columnPanelItemDragStart",
          column: this.columnGroup
        });
      },
      onDragStopped: () => {
        s.dispatchEvent({
          type: "columnPanelItemDragEnd"
        });
      },
      onGridEnter: (o) => {
        r && xb(e, {
          columns: this.columnGroup.getLeafColumns(),
          visibleState: o == null ? void 0 : o.visibleState,
          pivotState: o == null ? void 0 : o.pivotState,
          eventType: this.eventType
        });
      },
      onGridExit: () => {
        r && this.onChangeCommon(!1);
      }
    };
    i.addDragSource(n, !0), this.addDestroyFunc(() => i.removeDragSource(n));
  }
  createDragItem() {
    const e = this.columnGroup.getLeafColumns(), t = {}, s = {};
    return e.forEach((i) => {
      const r = i.getId();
      t[r] = i.isVisible(), s[r] = Rb(i);
    }), {
      columns: e,
      visibleState: t,
      pivotState: s
    };
  }
  setupExpandContract() {
    const { beans: e, eGroupClosedIcon: t, eGroupOpenedIcon: s, eColumnGroupIcons: i } = this;
    t.appendChild(br("columnSelectClosed", e, null)), s.appendChild(br("columnSelectOpen", e, null));
    const r = this.onExpandOrContractClicked.bind(this);
    this.addManagedElementListeners(t, { click: r }), this.addManagedElementListeners(s, { click: r });
    const n = new fr(i, !0);
    this.addManagedListeners(n, { tap: r }), this.addDestroyFunc(n.destroy.bind(n));
  }
  onLabelClicked() {
    const e = !this.cbSelect.getValue();
    this.onChangeCommon(e);
  }
  onCheckboxChanged(e) {
    this.onChangeCommon(e.selected);
  }
  getVisibleLeafColumns() {
    const e = [], t = (s) => {
      s.forEach((i) => {
        i.passesFilter && (i.group ? t(i.children) : e.push(i.column));
      });
    };
    return t(this.modelItem.children), e;
  }
  onChangeCommon(e) {
    this.refreshAriaLabel(), !this.processingColumnStateChange && bb(this.beans, this.modelItem.children, e, this.eventType);
  }
  refreshAriaLabel() {
    const { cbSelect: e, focusWrapper: t, displayName: s } = this, i = this.getLocaleTextFunc(), r = i("ariaColumnGroup", "Column Group"), n = e.getValue(), o = n === void 0 ? i("ariaIndeterminate", "indeterminate") : n ? i("ariaVisible", "visible") : i("ariaHidden", "hidden"), a = i("ariaToggleVisibility", "Press SPACE to toggle visibility");
    ot(t, `${s} ${r}`), e.setInputAriaLabel(`${a} (${o})`), sc(t, e.getInputElement().id);
  }
  onColumnStateChanged() {
    const e = this.workOutSelectedValue(), t = this.workOutReadOnlyValue();
    this.processingColumnStateChange = !0;
    const s = this.cbSelect;
    s.setValue(e), s.setReadOnly(t), this.addOrRemoveCssClass("ag-column-select-column-group-readonly", t), this.processingColumnStateChange = !1;
  }
  workOutSelectedValue() {
    const e = this.beans.colModel.isPivotMode(), t = this.getVisibleLeafColumns();
    let s = 0, i = 0;
    if (t.forEach((r) => {
      !e && r.getColDef().lockVisible || (this.isColumnChecked(r, e) ? s++ : i++);
    }), !(s > 0 && i > 0))
      return s > 0;
  }
  workOutReadOnlyValue() {
    const e = this.beans.colModel.isPivotMode();
    let t = 0;
    return this.columnGroup.getLeafColumns().forEach((s) => {
      e ? s.isAnyFunctionAllowed() && t++ : s.getColDef().lockVisible || t++;
    }), t === 0;
  }
  isColumnChecked(e, t) {
    if (t) {
      const s = e.isPivotActive(), i = e.isRowGroupActive(), r = e.isValueActive();
      return s || i || r;
    }
    return e.isVisible();
  }
  onExpandOrContractClicked() {
    const e = this.modelItem, t = e.expanded;
    e.expanded = !t;
  }
  onExpandChanged() {
    this.setOpenClosedIcons(), this.refreshAriaExpanded();
  }
  setOpenClosedIcons() {
    const e = this.modelItem.expanded;
    re(this.eGroupClosedIcon, !e), re(this.eGroupOpenedIcon, e);
  }
  refreshAriaExpanded() {
    ns(this.focusWrapper, this.modelItem.expanded);
  }
  getDisplayName() {
    return this.displayName;
  }
  onSelectAllChanged(e) {
    const t = this.cbSelect, s = t.getValue();
    !t.isReadOnly() && (e && !s || !e && s) && t.toggle();
  }
  isSelected() {
    return this.cbSelect.getValue();
  }
  isSelectable() {
    return !this.cbSelect.isReadOnly();
  }
  setSelected(e) {
    this.cbSelect.setValue(e, !0);
  }
}, Qz = class extends L {
  constructor(e, t) {
    super(), this.comp = e, this.virtualList = t;
  }
  postConstruct() {
    this.createManagedBean(
      new cb(this.comp, this.virtualList, {
        dragSourceType: ni.ToolPanel,
        listItemDragStartEvent: "columnPanelItemDragStart",
        listItemDragEndEvent: "columnPanelItemDragEnd",
        eventSource: this.eventSvc,
        getCurrentDragValue: (e) => this.getCurrentDragValue(e),
        isMoveBlocked: (e) => this.isMoveBlocked(e),
        getNumRows: (e) => e.getDisplayedColsList().length,
        moveItem: (e, t) => this.moveItem(this.getCurrentColumnsBeingMoved(e), t)
      })
    );
  }
  getCurrentDragValue(e) {
    return e.column;
  }
  getCurrentColumnsBeingMoved(e) {
    return ct(e) ? e.getLeafColumns() : e ? [e] : [];
  }
  isMoveBlocked(e) {
    return this.gos.get("suppressMovableColumns") ? !0 : !!this.getCurrentColumnsBeingMoved(e).find((r) => {
      const n = r.getColDef();
      return !!n.suppressMovable || !!n.lockPosition;
    });
  }
  moveItem(e, t) {
    var o;
    if (!t)
      return;
    const { component: s } = t;
    let i = null, r = t.position === "top";
    if (s instanceof Tb ? (i = s.getColumns()[0], r = !0) : s && (i = s.column), !i)
      return;
    const n = this.getMoveTargetIndex({
      currentColumns: e,
      lastHoveredColumn: i,
      isBefore: r
    });
    n != null && ((o = this.beans.colMoves) == null || o.moveColumns(e, n, "toolPanelUi"));
  }
  getMoveTargetIndex(e) {
    const { currentColumns: t, lastHoveredColumn: s, isBefore: i } = e;
    if (!s || !t)
      return null;
    const r = this.beans.colModel.getCols(), n = r.indexOf(s), o = i ? n : n + 1, a = this.getMoveDiff(r, t, o);
    return o - a;
  }
  getMoveDiff(e, t, s) {
    if (!t)
      return 0;
    const i = t[0], r = t.length;
    return e.indexOf(i) < s ? r : 0;
  }
}, Jz = class extends _ {
  constructor(e, t, s, i) {
    super(), this.allowDragging = t, this.groupsExist = s, this.focusWrapper = i, this.eLabel = E, this.cbSelect = E, this.processingColumnStateChange = !1;
    const { column: r, depth: n, displayName: o } = e;
    this.column = r, this.columnDept = n, this.displayName = o;
  }
  postConstruct() {
    this.setTemplate(
      /* html */
      `<div class="ag-column-select-column">
                <ag-checkbox data-ref="cbSelect" class="ag-column-select-checkbox"></ag-checkbox>
                <span class="ag-column-select-column-label" data-ref="eLabel"></span>
            </div>`,
      [ai]
    );
    const {
      beans: e,
      cbSelect: t,
      displayName: s,
      eLabel: i,
      columnDept: r,
      groupsExist: n,
      column: o,
      gos: a,
      focusWrapper: l
    } = this, c = ue("columnDrag", e);
    this.eDragHandle = c, c.classList.add("ag-drag-handle", "ag-column-select-column-drag-handle");
    const d = t.getGui(), u = t.getInputElement();
    d.insertAdjacentElement("afterend", c), u.setAttribute("tabindex", "-1");
    const h = Ke(s);
    i.innerHTML = h, n && this.addCssClass("ag-column-select-add-group-indent"), this.addCssClass(`ag-column-select-indent-${r}`), this.getGui().style.setProperty("--ag-indentation-level", String(r)), this.tooltipFeature = this.createOptionalManagedBean(
      e.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        getLocation: () => "columnToolPanelColumn",
        getColDef: () => o.getColDef(),
        shouldDisplayTooltip: yc(a, () => i)
      })
    ), this.setupDragging();
    const p = this.onColumnStateChanged.bind(this);
    this.addManagedEventListeners({ columnPivotModeChanged: p }), this.addManagedListeners(o, {
      columnValueChanged: p,
      columnPivotChanged: p,
      columnRowGroupChanged: p,
      visibleChanged: p
    }), this.addManagedListeners(l, {
      keydown: this.handleKeyDown.bind(this),
      contextmenu: this.onContextMenu.bind(this)
    }), this.addManagedPropertyListener("functionsReadOnly", this.onColumnStateChanged.bind(this)), this.addManagedListeners(t, { fieldValueChanged: this.onCheckboxChanged.bind(this) }), this.addManagedElementListeners(i, { click: this.onLabelClicked.bind(this) }), this.onColumnStateChanged(), this.refreshAriaLabel(), this.setupTooltip(), rw(o.getColDef(), a, o, null).forEach((f) => this.addOrRemoveCssClass(f, !0));
  }
  getColumn() {
    return this.column;
  }
  setupTooltip() {
    const e = () => {
      var t;
      return (t = this.tooltipFeature) == null ? void 0 : t.setTooltipAndRefresh(this.column.getColDef().headerTooltip);
    };
    e(), this.addManagedEventListeners({ newColumnsLoaded: e });
  }
  onContextMenu(e) {
    const { column: t, gos: s } = this;
    if (s.get("functionsReadOnly"))
      return;
    const i = this.createBean(new Pb(t, e, this.focusWrapper));
    this.addDestroyFunc(() => {
      i.isAlive() && this.destroyBean(i);
    });
  }
  handleKeyDown(e) {
    e.key === P.SPACE && (e.preventDefault(), this.isSelectable() && this.onSelectAllChanged(!this.isSelected()));
  }
  onLabelClicked() {
    if (this.gos.get("functionsReadOnly"))
      return;
    const e = !this.cbSelect.getValue();
    this.onChangeCommon(e);
  }
  onCheckboxChanged(e) {
    this.onChangeCommon(e.selected);
  }
  onChangeCommon(e) {
    this.cbSelect.isReadOnly() || (this.refreshAriaLabel(), !this.processingColumnStateChange && Sb(this.beans, [this.column], e, "toolPanelUi"));
  }
  refreshAriaLabel() {
    const { cbSelect: e, focusWrapper: t, displayName: s } = this, i = this.getLocaleTextFunc(), r = i("ariaColumn", "Column"), n = e.getValue() ? i("ariaVisible", "visible") : i("ariaHidden", "hidden"), o = i("ariaToggleVisibility", "Press SPACE to toggle visibility");
    ot(t, `${s} ${r}`), this.cbSelect.setInputAriaLabel(`${o} (${n})`), sc(t, e.getInputElement().id);
  }
  setupDragging() {
    const e = this.eDragHandle;
    if (!this.allowDragging) {
      re(e, !1);
      return;
    }
    const t = this.beans, { gos: s, eventSvc: i, dragAndDrop: r } = t;
    let n = !s.get("suppressDragLeaveHidesColumns");
    const o = {
      type: ni.ToolPanel,
      eElement: e,
      dragItemName: this.displayName,
      getDefaultIconName: () => n ? "hide" : "notAllowed",
      getDragItem: () => this.createDragItem(),
      onDragStarted: () => {
        n = !s.get("suppressDragLeaveHidesColumns"), i.dispatchEvent({
          type: "columnPanelItemDragStart",
          column: this.column
        });
      },
      onDragStopped: () => {
        i.dispatchEvent({
          type: "columnPanelItemDragEnd"
        });
      },
      onGridEnter: (a) => {
        n && xb(t, {
          columns: [this.column],
          visibleState: a == null ? void 0 : a.visibleState,
          pivotState: a == null ? void 0 : a.pivotState,
          eventType: "toolPanelUi"
        });
      },
      onGridExit: () => {
        n && this.onChangeCommon(!1);
      }
    };
    r.addDragSource(o, !0), this.addDestroyFunc(() => r.removeDragSource(o));
  }
  createDragItem() {
    const e = this.column.getColId(), t = { [e]: this.column.isVisible() }, s = { [e]: Rb(this.column) };
    return {
      columns: [this.column],
      visibleState: t,
      pivotState: s
    };
  }
  onColumnStateChanged() {
    this.processingColumnStateChange = !0;
    const e = this.beans.colModel.isPivotMode();
    if (e) {
      const i = this.column.isAnyFunctionActive();
      this.cbSelect.setValue(i);
    } else
      this.cbSelect.setValue(this.column.isVisible());
    let t = !0, s = !0;
    if (e) {
      const i = this.gos.get("functionsReadOnly"), r = !this.column.isAnyFunctionAllowed();
      t = !i && !r, s = t;
    } else {
      const { enableRowGroup: i, enableValue: r, lockPosition: n, suppressMovable: o, lockVisible: a } = this.column.getColDef(), l = !!i || !!r, c = !!n || !!o;
      t = !a, s = l || !c;
    }
    this.cbSelect.setReadOnly(!t), this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !s), this.addOrRemoveCssClass("ag-column-select-column-readonly", !s && !t), this.cbSelect.setPassive(!1), this.processingColumnStateChange = !1;
  }
  getDisplayName() {
    return this.displayName;
  }
  onSelectAllChanged(e) {
    const t = this.cbSelect;
    e !== t.getValue() && (t.isReadOnly() || t.toggle());
  }
  isSelected() {
    return this.cbSelect.getValue();
  }
  isSelectable() {
    return !this.cbSelect.isReadOnly();
  }
  isExpandable() {
    return !1;
  }
  setExpanded(e) {
    I(158);
  }
}, eW = class {
  constructor(e) {
    this.items = e;
  }
  getRowCount() {
    return this.items.length;
  }
  getRow(e) {
    return this.items[e];
  }
}, tW = "ag-column-select-list", sW = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="${tW}" role="presentation"></div>`
    ), this.destroyColumnItemFuncs = [], this.hasLoadedInitialState = !1, this.isInitialState = !1;
  }
  wireBeans(e) {
    this.colModel = e.colModel;
  }
  destroy() {
    this.destroyColumnTree(), super.destroy();
  }
  destroyColumnTree() {
    this.allColsTree = [], this.destroyColumnItemFuncs.forEach((e) => e()), this.destroyColumnItemFuncs = [];
  }
  init(e, t, s) {
    this.params = e, this.allowDragging = t, this.eventType = s, e.suppressSyncLayoutWithGrid || this.addManagedEventListeners({ columnMoved: this.onColumnsChanged.bind(this) }), this.addManagedEventListeners({
      newColumnsLoaded: this.onColumnsChanged.bind(this)
    });
    const i = this.fireSelectionChangedEvent.bind(this);
    this.addManagedEventListeners({
      columnPivotChanged: i,
      columnPivotModeChanged: i,
      columnRowGroupChanged: i,
      columnValueChanged: i,
      columnVisible: i,
      newColumnsLoaded: i
    }), this.expandGroupsByDefault = !e.contractColumnSelection;
    const r = this.createManagedBean(
      new co({
        cssIdentifier: "column-select",
        ariaRole: "tree"
      })
    );
    this.virtualList = r, this.appendChild(r.getGui()), r.setComponentCreator((n, o) => (ha(o, n.depth + 1), this.createComponentFromItem(n, o))), this.colModel.ready && this.onColumnsChanged(), !e.suppressColumnMove && this.createManagedBean(new Qz(this, r));
  }
  createComponentFromItem(e, t) {
    const s = this.allowDragging;
    if (e.group) {
      const r = new Tb(e, s, this.eventType, t);
      return this.createBean(r), r;
    }
    const i = new Jz(e, s, this.groupsExist, t);
    return this.createBean(i), i;
  }
  onColumnsChanged() {
    const e = this.params;
    this.hasLoadedInitialState || (this.hasLoadedInitialState = !0, this.isInitialState = !!e.initialState);
    const t = this.getExpandedStates(), s = this.colModel.isPivotMode();
    !e.suppressSyncLayoutWithGrid && !s ? this.buildTreeFromWhatGridIsDisplaying() : this.buildTreeFromProvidedColumnDefs(), this.setExpandedStates(t), this.markFilteredColumns(), this.flattenAndFilterModel(), this.isInitialState = !1;
  }
  getDisplayedColsList() {
    return this.displayedColsList;
  }
  getExpandedStates() {
    const e = {};
    if (this.isInitialState) {
      const { expandedGroupIds: t } = this.params.initialState;
      return t.forEach((s) => {
        e[s] = !0;
      }), e;
    }
    return this.allColsTree ? (this.forEachItem((t) => {
      if (!t.group)
        return;
      const s = t.columnGroup;
      s && (e[s.getId()] = t.expanded);
    }), e) : {};
  }
  setExpandedStates(e) {
    if (!this.allColsTree)
      return;
    const { isInitialState: t } = this;
    this.forEachItem((s) => {
      if (!s.group)
        return;
      const i = s.columnGroup;
      if (i) {
        const r = e[i.getId()];
        (r != null || t) && (s.expanded = !!r);
      }
    });
  }
  buildTreeFromWhatGridIsDisplaying() {
    yb(this.colModel, this.setColumnLayout.bind(this));
  }
  setColumnLayout(e) {
    const t = wb(this.colModel, e);
    this.buildListModel(t), this.groupsExist = e.some((s) => s && typeof s.children < "u"), this.markFilteredColumns(), this.flattenAndFilterModel();
  }
  buildTreeFromProvidedColumnDefs() {
    var t;
    const e = this.colModel;
    this.buildListModel(e.getColDefColTree()), this.groupsExist = !!((t = e.colDefCols) != null && t.treeDepth);
  }
  buildListModel(e) {
    const t = this.onColumnExpanded.bind(this), s = (a) => {
      a.addEventListener("expandedChanged", t);
      const l = a.removeEventListener.bind(a, "expandedChanged", t);
      this.destroyColumnItemFuncs.push(l);
    }, i = this.beans.colNames, r = (a, l, c) => {
      a.forEach((d) => {
        ct(d) ? n(d, l, c) : o(d, l, c);
      });
    }, n = (a, l, c) => {
      const d = a.getColGroupDef();
      if (d && d.suppressColumnsToolPanel)
        return;
      if (a.isPadding()) {
        r(a.getChildren(), l, c);
        return;
      }
      const h = i.getDisplayNameForProvidedColumnGroup(null, a, "columnToolPanel"), p = new Nf(
        h,
        a,
        l,
        !0,
        this.expandGroupsByDefault
      );
      c.push(p), s(p), r(a.getChildren(), l + 1, p.children);
    }, o = (a, l, c) => {
      if (a.getColDef() && a.getColDef().suppressColumnsToolPanel)
        return;
      const u = i.getDisplayNameForColumn(a, "columnToolPanel");
      c.push(new Nf(u, a, l));
    };
    this.destroyColumnTree(), r(e, 0, this.allColsTree);
  }
  onColumnExpanded() {
    this.flattenAndFilterModel();
  }
  flattenAndFilterModel() {
    this.displayedColsList = [];
    const e = (i) => {
      i.passesFilter && (this.displayedColsList.push(i), i.group && i.expanded && i.children.forEach(e));
    }, t = this.virtualList;
    this.allColsTree.forEach(e), t.setModel(new eW(this.displayedColsList));
    const s = t.getLastFocusedRow();
    t.refresh(), s != null && this.focusRowIfAlive(s), this.notifyListeners(), this.refreshAriaLabel();
  }
  refreshAriaLabel() {
    const e = this.getLocaleTextFunc(), t = e("ariaColumnPanelList", "Column List"), s = e("columns", "Columns"), i = this.displayedColsList.length;
    ot(this.virtualList.getAriaElement(), `${t} ${i} ${s}`);
  }
  focusRowIfAlive(e) {
    window.setTimeout(() => {
      this.isAlive() && this.virtualList.focusRow(e);
    }, 0);
  }
  forEachItem(e) {
    const t = (i) => {
      i.forEach((r) => {
        e(r), r.group && t(r.children);
      });
    }, s = this.allColsTree;
    s && t(s);
  }
  doSetExpandedAll(e) {
    this.forEachItem((t) => {
      t.group && (t.expanded = e);
    });
  }
  setGroupsExpanded(e, t) {
    if (!t) {
      this.doSetExpandedAll(e);
      return;
    }
    const s = [];
    this.forEachItem((r) => {
      if (!r.group)
        return;
      const n = r.columnGroup.getId();
      t.indexOf(n) >= 0 && (r.expanded = e, s.push(n));
    });
    const i = t.filter((r) => !s.includes(r));
    i.length > 0 && I(157, { unrecognisedGroupIds: i });
  }
  getExpandState() {
    let e = 0, t = 0;
    return this.forEachItem((s) => {
      s.group && (s.expanded ? e++ : t++);
    }), e > 0 && t > 0 ? 2 : t > 0 ? 1 : 0;
  }
  doSetSelectedAll(e) {
    bb(this.beans, this.allColsTree, e, this.eventType);
  }
  getSelectionState() {
    let e = 0, t = 0;
    const s = this.colModel.isPivotMode();
    if (this.forEachItem((i) => {
      if (i.group || !i.passesFilter)
        return;
      const r = i.column, n = r.getColDef();
      let o;
      if (s) {
        if (!r.isAllowPivot() && !r.isAllowRowGroup() && !r.isAllowValue())
          return;
        o = r.isValueActive() || r.isPivotActive() || r.isRowGroupActive();
      } else {
        if (n.lockVisible)
          return;
        o = r.isVisible();
      }
      o ? e++ : t++;
    }), !(e > 0 && t > 0))
      return !(e === 0 || t > 0);
  }
  setFilterText(e) {
    this.filterText = W(e) ? e.toLowerCase() : null, this.markFilteredColumns(), this.flattenAndFilterModel();
  }
  markFilteredColumns() {
    const e = (s) => {
      if (!W(this.filterText))
        return !0;
      const i = s.displayName;
      return i == null || i.toLowerCase().indexOf(this.filterText) !== -1;
    }, t = (s, i) => {
      let r = !1;
      if (s.group) {
        const o = e(s);
        s.children.forEach((a) => {
          const l = t(a, o || i);
          l && (r = l);
        });
      }
      const n = i || r ? !0 : e(s);
      return s.passesFilter = n, n;
    };
    this.allColsTree.forEach((s) => t(s, !1));
  }
  notifyListeners() {
    this.fireGroupExpandedEvent(), this.fireSelectionChangedEvent();
  }
  fireGroupExpandedEvent() {
    const e = this.getExpandState();
    this.dispatchLocalEvent({ type: "groupExpanded", state: e });
  }
  fireSelectionChangedEvent() {
    if (!this.allColsTree)
      return;
    const e = this.getSelectionState();
    this.dispatchLocalEvent({ type: "selectionChanged", state: e });
  }
  getExpandedGroups() {
    const e = [];
    return this.allColsTree && this.forEachItem((t) => {
      t.group && t.expanded && e.push(t.columnGroup.getId());
    }), e;
  }
}, iW = {
  selector: "AG-PRIMARY-COLS-LIST",
  component: sW
}, Eb = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="ag-column-select">
            <ag-primary-cols-header data-ref="primaryColsHeaderPanel"></ag-primary-cols-header>
            <ag-primary-cols-list data-ref="primaryColsListPanel"></ag-primary-cols-list>
        </div>`,
      [Wz, iW]
    ), this.primaryColsHeaderPanel = E, this.primaryColsListPanel = E, this.registerCSS(Nz);
  }
  // we allow dragging in the toolPanel, but not when this component appears in the column menu
  init(e, t, s) {
    const { primaryColsHeaderPanel: i, primaryColsListPanel: r } = this;
    i.init(t);
    const n = t.suppressColumnFilter, o = t.suppressColumnSelectAll;
    t.suppressColumnExpandAll && n && o && i.setDisplayed(!1), this.addManagedListeners(r, {
      groupExpanded: (l) => {
        i.setExpandState(l.state), t.onStateUpdated();
      },
      selectionChanged: (l) => i.setSelectionState(l.state)
    }), r.init(t, e, s), this.addManagedListeners(i, {
      expandAll: r.doSetExpandedAll.bind(r, !0),
      collapseAll: r.doSetExpandedAll.bind(r, !1),
      selectAll: r.doSetSelectedAll.bind(r, !0),
      unselectAll: r.doSetSelectedAll.bind(r, !1),
      filterChanged: (l) => r.setFilterText(l.filterText)
    }), this.positionableFeature = this.createManagedBean(new mc(this.getGui(), { minHeight: 100 }));
  }
  toggleResizable(e) {
    this.positionableFeature.setResizable(e ? { bottom: !0 } : !1);
  }
  expandGroups(e) {
    this.primaryColsListPanel.setGroupsExpanded(!0, e);
  }
  collapseGroups(e) {
    this.primaryColsListPanel.setGroupsExpanded(!1, e);
  }
  setColumnLayout(e) {
    this.primaryColsListPanel.setColumnLayout(e);
  }
  syncLayoutWithGrid() {
    this.primaryColsListPanel.onColumnsChanged();
  }
  getExpandedGroups() {
    return this.primaryColsListPanel.getExpandedGroups();
  }
}, rW = (
  /*css*/
  ".ag-column-panel{display:flex;flex:1 1 auto;flex-direction:column;overflow:hidden}.ag-pivot-mode-panel{display:flex;height:var(--ag-header-height)}.ag-pivot-mode-select{align-items:center;display:flex}:where(.ag-ltr) .ag-pivot-mode-select{margin-left:var(--ag-widget-container-horizontal-padding)}:where(.ag-rtl) .ag-pivot-mode-select{margin-right:var(--ag-widget-container-horizontal-padding)}.ag-column-panel-column-select{border-bottom:var(--ag-tool-panel-separator-border)}.ag-column-panel-column-select:where(:nth-child(n+2 of :not(.ag-hidden))){border-top:var(--ag-tool-panel-separator-border)}:where(.ag-column-panel) .ag-column-drop-vertical{flex:1 1 0px;min-height:50px;&:where(:not(.ag-last-column-drop)){border-bottom:var(--ag-tool-panel-separator-border)}}"
), nW = class extends _ {
  constructor() {
    super(
      /* html */
      '<div class="ag-column-panel"></div>'
    ), this.initialised = !1, this.childDestroyFuncs = [], this.registerCSS(rW);
  }
  wireBeans(e) {
    this.colToolPanelFactory = e.colToolPanelFactory;
  }
  // lazy initialise the panel
  setVisible(e) {
    super.setDisplayed(e), e && !this.initialised && this.init(this.params);
  }
  init(e) {
    const s = {
      ...this.gos.addGridCommonParams({
        suppressColumnMove: !1,
        suppressColumnSelectAll: !1,
        suppressColumnFilter: !1,
        suppressColumnExpandAll: !1,
        contractColumnSelection: !1,
        suppressPivotMode: !1,
        suppressRowGroups: !1,
        suppressValues: !1,
        suppressPivots: !1,
        suppressSyncLayoutWithGrid: !1
      }),
      ...e
    };
    this.params = s;
    const { childDestroyFuncs: i, colToolPanelFactory: r, gos: n } = this, o = n.isModuleRegistered("SharedPivot"), a = o || n.isModuleRegistered("SharedRowGrouping");
    !s.suppressPivotMode && r && o && (this.pivotModePanel = r.createPivotModePanel(this, i));
    const l = this.createBean(new Eb());
    if (this.primaryColsPanel = l, i.push(() => this.destroyBean(this.primaryColsPanel)), l.init(!0, s, "toolPanelUi"), l.addCssClass("ag-column-panel-column-select"), this.appendChild(l), r) {
      !s.suppressRowGroups && a && (this.rowGroupDropZonePanel = r.createRowGroupPanel(this, i)), !s.suppressValues && a && (this.valuesDropZonePanel = r.createValuesPanel(this, i)), !s.suppressPivots && o && (this.pivotDropZonePanel = r.createPivotPanel(this, i)), this.setLastVisible();
      const [c] = this.addManagedEventListeners({
        columnPivotModeChanged: () => {
          this.resetChildrenHeight(), this.setLastVisible();
        }
      });
      i.push(() => c());
    }
    this.initialised = !0;
  }
  setPivotModeSectionVisible(e) {
    const t = this.colToolPanelFactory;
    t && (this.pivotModePanel = t.setPanelVisible(
      this.pivotModePanel,
      e,
      t.createPivotModePanel.bind(t, this, this.childDestroyFuncs, !0)
    ), this.setLastVisible());
  }
  setRowGroupsSectionVisible(e) {
    const t = this.colToolPanelFactory;
    t && (this.rowGroupDropZonePanel = t.setPanelVisible(
      this.rowGroupDropZonePanel,
      e,
      t.createRowGroupPanel.bind(t, this, this.childDestroyFuncs)
    ), this.setLastVisible());
  }
  setValuesSectionVisible(e) {
    const t = this.colToolPanelFactory;
    t && (this.valuesDropZonePanel = t.setPanelVisible(
      this.valuesDropZonePanel,
      e,
      t.createValuesPanel.bind(t, this, this.childDestroyFuncs)
    ), this.setLastVisible());
  }
  setPivotSectionVisible(e) {
    var s;
    const t = this.colToolPanelFactory;
    t && (this.pivotDropZonePanel = t.setPanelVisible(
      this.pivotDropZonePanel,
      e,
      t.createPivotPanel.bind(t, this, this.childDestroyFuncs)
    ), (s = this.pivotDropZonePanel) == null || s.setDisplayed(e), this.setLastVisible());
  }
  setResizers() {
    [this.primaryColsPanel, this.rowGroupDropZonePanel, this.valuesDropZonePanel, this.pivotDropZonePanel].forEach(
      (e) => {
        if (!e)
          return;
        const t = e.getGui();
        e.toggleResizable(
          !t.classList.contains("ag-last-column-drop") && !t.classList.contains("ag-hidden")
        );
      }
    );
  }
  setLastVisible() {
    const e = this.getGui();
    Array.prototype.slice.call(e.querySelectorAll(".ag-column-drop")).forEach((r) => r.classList.remove("ag-last-column-drop"));
    const s = e.querySelectorAll(".ag-column-drop:not(.ag-hidden)"), i = pe(s);
    i && i.classList.add("ag-last-column-drop"), this.setResizers();
  }
  resetChildrenHeight() {
    const t = this.getGui().children;
    for (let s = 0; s < t.length; s++) {
      const { style: i } = t[s];
      i.removeProperty("height"), i.removeProperty("flex");
    }
  }
  expandColumnGroups(e) {
    this.primaryColsPanel.expandGroups(e);
  }
  collapseColumnGroups(e) {
    this.primaryColsPanel.collapseGroups(e);
  }
  setColumnLayout(e) {
    this.primaryColsPanel.setColumnLayout(e);
  }
  syncLayoutWithGrid() {
    this.primaryColsPanel.syncLayoutWithGrid();
  }
  destroyChildren() {
    const e = this.childDestroyFuncs;
    e.forEach((t) => t()), e.length = 0, ze(this.getGui());
  }
  refresh(e) {
    return this.destroyChildren(), this.init(e), !0;
  }
  getState() {
    return {
      expandedGroupIds: this.primaryColsPanel.getExpandedGroups()
    };
  }
  destroy() {
    this.destroyChildren(), super.destroy();
  }
}, oW = (
  /*css*/
  ".ag-column-drop{align-items:center;display:inline-flex;overflow:auto;position:relative;width:100%}.ag-column-drop-list{align-items:center;display:flex}.ag-column-drop-cell{align-items:center;background-color:var(--ag-column-drop-cell-background-color);border:var(--ag-column-drop-cell-border);border-radius:500px;color:var(--ag-column-drop-cell-text-color);display:flex;padding:calc(var(--ag-spacing)*.25);position:relative;&:focus-visible{box-shadow:var(--ag-focus-shadow)}:where(.ag-drag-handle){color:var(--ag-column-drop-cell-drag-handle-color)}}:where(.ag-ltr) .ag-column-drop-cell{padding-left:calc(var(--ag-spacing)*.75)}:where(.ag-rtl) .ag-column-drop-cell{padding-right:calc(var(--ag-spacing)*.75)}.ag-column-drop-cell-text{flex:1 1 auto;margin:0 var(--ag-spacing);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ag-column-drop-vertical{align-items:stretch;display:flex;flex-direction:column;min-height:75px;overflow:hidden}.ag-column-drop-vertical-title-bar{align-items:center;display:flex;flex:none;padding:var(--ag-widget-container-vertical-padding) calc(var(--ag-spacing)*2) 0}.ag-column-drop-vertical-list{align-items:stretch;flex-direction:column;flex-grow:1;overflow-x:auto;padding-bottom:var(--ag-spacing);padding-left:var(--ag-spacing);padding-right:var(--ag-spacing);position:relative;>*{flex:none}}:where(.ag-column-drop-empty) .ag-column-drop-vertical-list{overflow:hidden}.ag-column-drop-vertical-empty-message{align-items:center;border:1px dashed;border-color:var(--ag-border-color);display:flex;inset:0;justify-content:center;margin:calc(var(--ag-spacing)*1.5) calc(var(--ag-spacing)*2);overflow:hidden;padding:calc(var(--ag-spacing)*2);position:absolute}.ag-column-drop-cell-button{cursor:pointer;min-width:0;opacity:.75;&:hover{opacity:1}}.ag-column-drop-wrapper{display:flex}.ag-column-drop-horizontal-half-width{width:50%!important}.ag-column-drop-cell-ghost{opacity:.5}.ag-column-drop-horizontal{background-color:var(--ag-header-background-color);border-bottom:var(--ag-header-row-border);gap:var(--ag-cell-widget-spacing);height:var(--ag-header-height);overflow:hidden;white-space:nowrap}:where(.ag-ltr) .ag-column-drop-horizontal{padding-left:var(--ag-cell-horizontal-padding)}:where(.ag-rtl) .ag-column-drop-horizontal{padding-right:var(--ag-cell-horizontal-padding)}.ag-column-drop-horizontal-list{gap:var(--ag-cell-widget-spacing)}.ag-column-drop-vertical-cell{margin-top:var(--ag-spacing)}:where(.ag-ltr) .ag-column-drop-vertical-icon{margin-right:var(--ag-widget-horizontal-spacing)}:where(.ag-rtl) .ag-column-drop-vertical-icon{margin-left:var(--ag-widget-horizontal-spacing)}.ag-select-agg-func-popup{background:var(--ag-background-color);border:1px solid var(--ag-border-color);border-radius:var(--ag-border-radius);box-shadow:var(--ag-dropdown-shadow);height:calc(var(--ag-spacing)*5*3.5);padding:0;position:absolute}.ag-select-agg-func-virtual-list-item{cursor:default;&:hover{background-color:var(--ag-selected-row-background-color)}}:where(.ag-ltr) .ag-select-agg-func-virtual-list-item{padding-left:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-select-agg-func-virtual-list-item{padding-right:calc(var(--ag-spacing)*2)}:where(.ag-ltr) .ag-column-drop-horizontal-half-width:where(:not(:last-child)){border-right:1px solid var(--ag-border-color)}:where(.ag-rtl) .ag-column-drop-horizontal-half-width:where(:not(:last-child)){border-left:1px solid var(--ag-border-color)}"
);
function Hf(e, t, s) {
  e == null || t == null || e.splice(s, 0, ...t);
}
var Db = class extends _ {
  constructor(e) {
    super(
      /* html */
      '<div class="ag-unselectable" role="presentation"></div>'
    ), this.horizontal = e, this.state = "notDragging", this.guiDestroyFunctions = [], this.childPillComponents = [], this.resizeEnabled = !1, this.addElementClasses(this.getGui()), this.ePillDropList = document.createElement("div"), this.addElementClasses(this.ePillDropList, "list"), nt(this.ePillDropList, "listbox"), this.registerCSS(oW);
  }
  toggleResizable(e) {
    this.positionableFeature.setResizable(e ? { bottom: !0 } : !1), this.resizeEnabled = e;
  }
  isSourceEventFromTarget(e) {
    const { dropZoneTarget: t, dragSource: s } = e;
    return t.contains(s.eElement);
  }
  destroy() {
    this.destroyGui(), super.destroy();
  }
  destroyGui() {
    this.guiDestroyFunctions.forEach((e) => e()), this.guiDestroyFunctions.length = 0, this.childPillComponents.length = 0, ze(this.getGui()), ze(this.ePillDropList);
  }
  init(e) {
    this.params = e ?? {}, this.createManagedBean(
      new Ir(this.getFocusableElement(), {
        onTabKeyDown: this.onTabKeyDown.bind(this),
        handleKeyDown: this.onKeyDown.bind(this)
      })
    ), this.setupDropTarget(), this.positionableFeature = new mc(this.getGui()), this.createManagedBean(this.positionableFeature), this.refreshGui(), ot(this.ePillDropList, this.getAriaLabel());
  }
  onTabKeyDown(e) {
    const t = ii(this.getFocusableElement(), null, !0), s = t.length;
    if (s === 0)
      return;
    const { shiftKey: i } = e, r = Ie(this.beans), n = r === t[0], o = r === pe(t);
    s === 1 || n && i || o && !i || t[i ? 0 : s - 1].focus();
  }
  onKeyDown(e) {
    const { key: t } = e, s = !this.horizontal;
    let i = t === P.DOWN, r = t === P.UP;
    if (!s) {
      const o = this.gos.get("enableRtl");
      i = !o && t === P.RIGHT || o && t === P.LEFT, r = !o && t === P.LEFT || o && t === P.RIGHT;
    }
    if (!i && !r)
      return;
    const n = zt(this.beans, this.getFocusableElement(), !1, r);
    n && (e.preventDefault(), n.focus());
  }
  addElementClasses(e, t) {
    t = t ? `-${t}` : "";
    const s = this.horizontal ? "horizontal" : "vertical";
    e.classList.add(`ag-column-drop${t}`, `ag-column-drop-${s}${t}`);
  }
  setupDropTarget() {
    var e;
    this.dropTarget = {
      getContainer: this.getGui.bind(this),
      getIconName: this.getIconName.bind(this),
      onDragging: this.onDragging.bind(this),
      onDragEnter: this.onDragEnter.bind(this),
      onDragLeave: this.onDragLeave.bind(this),
      onDragStop: this.onDragStop.bind(this),
      onDragCancel: this.onDragCancel.bind(this),
      isInterestedIn: this.isInterestedIn.bind(this)
    }, (e = this.beans.dragAndDrop) == null || e.addDropTarget(this.dropTarget);
  }
  minimumAllowedNewInsertIndex() {
    return 0;
  }
  checkInsertIndex(e) {
    const t = this.getNewInsertIndex(e);
    if (t < 0)
      return !1;
    const s = this.minimumAllowedNewInsertIndex(), i = Math.max(s, t), r = i !== this.insertIndex;
    return r && (this.insertIndex = i), r;
  }
  getNewInsertIndex(e) {
    const t = e.event, s = this.horizontal ? t.clientX : t.clientY, i = this.childPillComponents.map((n) => n.getGui().getBoundingClientRect()), r = i.findIndex(
      (n) => this.horizontal ? n.right > s && n.left < s : n.top < s && n.bottom > s
    );
    if (r === -1) {
      const n = this.gos.get("enableRtl");
      return i.every((l) => s > (this.horizontal ? l.right : l.bottom)) ? n && this.horizontal ? 0 : this.childPillComponents.length : i.every((l) => s < (this.horizontal ? l.left : l.top)) ? n && this.horizontal ? this.childPillComponents.length : 0 : this.insertIndex;
    }
    return this.insertIndex <= r ? r + 1 : r;
  }
  checkDragStartedBySelf(e) {
    this.state === "notDragging" && (this.state = "rearrangeItems", this.potentialDndItems = this.getItems(e.dragSource.getDragItem()), this.refreshGui(), this.checkInsertIndex(e), this.refreshGui());
  }
  onDragging(e) {
    this.checkDragStartedBySelf(e), this.checkInsertIndex(e) && this.refreshGui();
  }
  handleDragEnterEnd(e) {
  }
  onDragEnter(e) {
    const t = this.getItems(e.dragSource.getDragItem());
    this.state = "newItemsIn";
    const s = t.filter((r) => this.isItemDroppable(r, e)), i = s.every(
      (r) => this.childPillComponents.map((n) => n.getItem()).indexOf(r) !== -1
    );
    if (s.length !== 0) {
      if (this.potentialDndItems = s, i) {
        this.state = "notDragging";
        return;
      }
      this.handleDragEnterEnd(e), this.checkInsertIndex(e), this.refreshGui();
    }
  }
  isPotentialDndItems() {
    var e;
    return !!((e = this.potentialDndItems) != null && e.length);
  }
  handleDragLeaveEnd(e) {
  }
  onDragLeave(e) {
    if (this.state === "rearrangeItems") {
      const t = this.getItems(e.dragSource.getDragItem());
      this.removeItems(t);
    }
    this.isPotentialDndItems() && (this.handleDragLeaveEnd(e), this.potentialDndItems = [], this.refreshGui()), this.state = "notDragging";
  }
  onDragCancel(e) {
    this.isPotentialDndItems() && (this.state === "newItemsIn" && this.handleDragLeaveEnd(e), this.potentialDndItems = [], this.refreshGui()), this.state = "notDragging";
  }
  onDragStop() {
    this.isPotentialDndItems() && (this.state === "newItemsIn" ? this.addItems(this.potentialDndItems) : this.rearrangeItems(this.potentialDndItems), this.potentialDndItems = [], this.refreshGui()), this.state = "notDragging";
  }
  removeItems(e) {
    const t = this.getExistingItems().filter((s) => !e.includes(s));
    this.updateItems(t);
  }
  addItems(e) {
    if (!e)
      return;
    const t = this.getExistingItems().slice(), s = e.filter((i) => t.indexOf(i) < 0);
    Hf(t, s, this.insertIndex), this.updateItems(t);
  }
  addItem(e) {
    this.insertIndex = this.getExistingItems().length, this.addItems([e]), this.refreshGui();
  }
  rearrangeItems(e) {
    const t = this.getNonGhostItems().slice();
    return Hf(t, e, this.insertIndex), Ht(t, this.getExistingItems()) ? !1 : (this.updateItems(t), !0);
  }
  refreshGui() {
    const e = this.ePillDropList.scrollTop, t = this.resizeEnabled, s = this.getFocusedItem(), { eGridDiv: i } = this.beans;
    let r = zt(this.beans, i);
    r || (r = zt(this.beans, i, !1, !0)), this.toggleResizable(!1), this.destroyGui(), this.addIconAndTitleToGui(), this.addEmptyMessageToGui(), this.addItemsToGui(), this.horizontal || (this.ePillDropList.scrollTop = e), t && this.toggleResizable(t), gc() && this.restoreFocus(s, r);
  }
  getFocusedItem() {
    const e = this.getGui(), t = Ie(this.beans);
    return e.contains(t) ? Array.from(e.querySelectorAll(".ag-column-drop-cell")).indexOf(t) : -1;
  }
  restoreFocus(e, t) {
    const s = this.getGui(), i = Array.from(s.querySelectorAll(".ag-column-drop-cell"));
    if (e === -1)
      return;
    i.length === 0 && t.focus();
    const r = Math.min(i.length - 1, e), n = i[r];
    n && n.focus();
  }
  focusList(e) {
    const t = e ? this.childPillComponents.length - 1 : 0;
    this.restoreFocus(t, this.getFocusableElement());
  }
  getNonGhostItems() {
    const e = this.getExistingItems();
    return this.isPotentialDndItems() ? e.filter((t) => !this.potentialDndItems.includes(t)) : e;
  }
  addItemsToGui() {
    const t = this.getNonGhostItems().map((s) => this.createItemComponent(s, !1));
    if (this.isPotentialDndItems()) {
      const s = this.potentialDndItems.map((i) => this.createItemComponent(i, !0));
      this.insertIndex >= t.length ? t.push(...s) : t.splice(this.insertIndex, 0, ...s);
    }
    this.appendChild(this.ePillDropList), t.forEach((s, i) => {
      i > 0 && this.addArrow(this.ePillDropList), this.ePillDropList.appendChild(s.getGui());
    }), this.addAriaLabelsToComponents();
  }
  addAriaLabelsToComponents() {
    this.childPillComponents.forEach((e, t) => {
      const s = e.getGui();
      rc(s, t + 1), ic(s, this.childPillComponents.length);
    });
  }
  createItemComponent(e, t) {
    const s = this.createPillComponent(e, this.dropTarget, t, this.horizontal);
    return s.addEventListener("columnRemove", this.removeItems.bind(this, [e])), this.createBean(s), this.guiDestroyFunctions.push(() => this.destroyBean(s)), t || this.childPillComponents.push(s), s;
  }
  addIconAndTitleToGui() {
    const { title: e, icon: t } = this.params;
    if (!e || !t)
      return;
    const s = document.createElement("div");
    if (eh(s, !0), this.addElementClasses(s, "title-bar"), this.addElementClasses(t, "icon"), this.addOrRemoveCssClass("ag-column-drop-empty", this.isExistingItemsEmpty()), s.appendChild(t), !this.horizontal) {
      const i = document.createElement("span");
      this.addElementClasses(i, "title"), i.innerHTML = e, s.appendChild(i);
    }
    this.appendChild(s);
  }
  isExistingItemsEmpty() {
    return this.getExistingItems().length === 0;
  }
  addEmptyMessageToGui() {
    const { emptyMessage: e } = this.params;
    if (!e || !this.isExistingItemsEmpty() || this.isPotentialDndItems())
      return;
    const t = document.createElement("span");
    t.innerHTML = e, this.addElementClasses(t, "empty-message"), this.ePillDropList.appendChild(t);
  }
  addArrow(e) {
    if (this.horizontal) {
      const t = this.gos.get("enableRtl"), s = ue(t ? "panelDelimiterRtl" : "panelDelimiter", this.beans);
      this.addElementClasses(s, "cell-separator"), e.appendChild(s);
    }
  }
}, Ab = class extends _ {
  constructor(e, t, s, i, r) {
    super(), this.dragSourceDropTarget = e, this.ghost = t, this.horizontal = s, this.template = i, this.agComponents = r, this.eText = E, this.eDragHandle = E, this.eButton = E;
  }
  postConstruct() {
    this.setTemplate(
      this.template ?? /* html */
      `
            <span role="option">
              <span data-ref="eDragHandle" class="ag-drag-handle ag-column-drop-cell-drag-handle" role="presentation"></span>
              <span data-ref="eText" class="ag-column-drop-cell-text" aria-hidden="true"></span>
              <span data-ref="eButton" class="ag-column-drop-cell-button" role="presentation"></span>
            </span>`,
      this.agComponents
    );
    const e = this.getGui(), { beans: t, eDragHandle: s, eText: i, eButton: r } = this;
    this.addElementClasses(e), this.addElementClasses(s, "drag-handle"), this.addElementClasses(i, "text"), this.addElementClasses(r, "button"), s.appendChild(ue("columnDrag", t)), r.appendChild(ue("cancel", t)), this.tooltipFeature = this.createOptionalManagedBean(
      t.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui()
      })
    ), this.setupComponents(), !this.ghost && this.isDraggable() && this.addDragSource(), this.setupAria(), this.setupTooltip(), this.activateTabIndex(), this.refreshDraggable();
  }
  isDraggable() {
    return !0;
  }
  refreshDraggable() {
    this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !this.isDraggable());
  }
  setupAria() {
    const e = this.getLocaleTextFunc(), t = [this.getAriaDisplayName()];
    this.addAdditionalAriaInstructions(t, e), ot(this.getGui(), t.join(". "));
  }
  addAdditionalAriaInstructions(e, t) {
    if (this.isRemovable()) {
      const s = t("ariaDropZoneColumnComponentDescription", "Press DELETE to remove");
      e.push(s);
    }
  }
  setupTooltip() {
    const e = () => {
      var t;
      return (t = this.tooltipFeature) == null ? void 0 : t.setTooltipAndRefresh(this.getTooltip());
    };
    e(), this.addManagedEventListeners({ newColumnsLoaded: e });
  }
  getDragSourceId() {
  }
  getDefaultIconName() {
    return "notAllowed";
  }
  addDragSource() {
    const {
      beans: { dragAndDrop: e },
      eDragHandle: t
    } = this, s = this.createGetDragItem(), i = this.getDefaultIconName(), r = {
      type: this.getDragSourceType(),
      sourceId: this.getDragSourceId(),
      eElement: t,
      getDefaultIconName: () => i,
      getDragItem: s,
      dragItemName: this.getDisplayName()
    };
    e == null || e.addDragSource(r, !0), this.addDestroyFunc(() => e == null ? void 0 : e.removeDragSource(r));
  }
  setupComponents() {
    this.setTextValue(), this.setupRemove(), this.ghost && this.addCssClass("ag-column-drop-cell-ghost");
  }
  isRemovable() {
    return !0;
  }
  refreshRemove() {
    re(this.eButton, this.isRemovable());
  }
  setupRemove() {
    this.refreshRemove();
    const e = { type: "columnRemove" };
    this.addGuiEventListener("keydown", (s) => this.onKeyDown(s)), this.addManagedElementListeners(this.eButton, {
      click: (s) => {
        this.dispatchLocalEvent(e), s.stopPropagation();
      }
    });
    const t = new fr(this.eButton);
    this.addManagedListeners(t, {
      tap: () => this.dispatchLocalEvent(e)
    }), this.addDestroyFunc(t.destroy.bind(t));
  }
  onKeyDown(e) {
    e.key === P.DELETE && this.isRemovable() && (e.preventDefault(), this.dispatchLocalEvent({ type: "columnRemove" }));
  }
  getDisplayValue() {
    return this.getDisplayName();
  }
  setTextValue() {
    const e = this.getDisplayValue(), t = Ke(e);
    this.eText.innerHTML = t;
  }
  addElementClasses(e, t) {
    t = t ? `-${t}` : "";
    const s = this.horizontal ? "horizontal" : "vertical";
    e.classList.add(`ag-column-drop-cell${t}`, `ag-column-drop-${s}-cell${t}`);
  }
  destroy() {
    super.destroy(), this.dragSourceDropTarget = null;
  }
}, aW = class extends Ab {
  constructor(e, t, s, i, r) {
    super(t, s, r), this.column = e, this.dropZonePurpose = i, this.eSortIndicator = E, this.popupShowing = !1;
  }
  postConstruct() {
    const { sortSvc: e, colNames: t } = this.beans;
    this.template = /* html */
    `
            <span role="option">
                <span data-ref="eDragHandle" class="ag-drag-handle ag-column-drop-cell-drag-handle" role="presentation"></span>
                <span data-ref="eText" class="ag-column-drop-cell-text" aria-hidden="true"></span>
                ${e ? '<ag-sort-indicator data-ref="eSortIndicator"></ag-sort-indicator>' : ""}
                <span data-ref="eButton" class="ag-column-drop-cell-button" role="presentation"></span>
            </span>
        `, e && (this.agComponents = [e.getSortIndicatorSelector()]), this.displayName = t.getDisplayNameForColumn(this.column, "columnDrop"), super.postConstruct(), e && (this.setupSort(), this.addManagedEventListeners({
      sortChanged: () => {
        this.setupAria();
      }
    })), this.isGroupingZone() && this.addManagedPropertyListener("groupLockGroupColumns", () => {
      this.refreshRemove(), this.refreshDraggable(), this.setupAria();
    });
  }
  getItem() {
    return this.column;
  }
  getDisplayName() {
    return this.displayName;
  }
  getTooltip() {
    return this.column.getColDef().headerTooltip;
  }
  addAdditionalAriaInstructions(e, t) {
    const s = this.gos.get("rowGroupPanelSuppressSort"), i = this.gos.get("functionsReadOnly");
    if (this.isAggregationZone() && !i) {
      const r = t(
        "ariaDropZoneColumnValueItemDescription",
        "Press ENTER to change the aggregation type"
      );
      e.push(r);
    }
    if (this.isGroupingZone() && this.column.isSortable() && !s) {
      const r = t("ariaDropZoneColumnGroupItemDescription", "Press ENTER to sort");
      e.push(r);
    }
    super.addAdditionalAriaInstructions(e, t);
  }
  isDraggable() {
    return this.isReadOnly();
  }
  isRemovable() {
    return this.isReadOnly();
  }
  isReadOnly() {
    return !this.isGroupingAndLocked() && !this.gos.get("functionsReadOnly");
  }
  getAriaDisplayName() {
    const e = this.getLocaleTextFunc(), { name: t, aggFuncName: s } = this.getColumnAndAggFuncName(), i = e("ariaDropZoneColumnComponentAggFuncSeparator", " of "), r = {
      asc: e("ariaDropZoneColumnComponentSortAscending", "ascending"),
      desc: e("ariaDropZoneColumnComponentSortDescending", "descending")
    }, n = this.column.getSort(), o = this.gos.get("rowGroupPanelSuppressSort");
    return [
      s && `${s}${i}`,
      t,
      this.isGroupingZone() && !o && n && `, ${r[n]}`
    ].filter((a) => !!a).join("");
  }
  getColumnAndAggFuncName() {
    const e = this.displayName;
    let t = "";
    if (this.isAggregationZone()) {
      const s = this.column.getAggFunc(), i = typeof s == "string" ? s : "agg";
      t = this.getLocaleTextFunc()(i, i);
    }
    return { name: e, aggFuncName: t };
  }
  setupSort() {
    if (!(!this.column.isSortable() || !this.isGroupingZone()) && !this.gos.get("rowGroupPanelSuppressSort")) {
      this.eSortIndicator.setupSort(this.column, !0);
      const e = (t) => {
        t.preventDefault(), this.beans.sortSvc.progressSortFromEvent(this.column, t);
      };
      this.addGuiEventListener("click", e), this.addGuiEventListener("keydown", (t) => {
        t.key === P.ENTER && this.isGroupingZone() && e(t);
      });
    }
  }
  getDefaultIconName() {
    return "hide";
  }
  createGetDragItem() {
    const { column: e } = this;
    return () => {
      const t = {};
      return t[e.getId()] = e.isVisible(), {
        columns: [e],
        visibleState: t
      };
    };
  }
  setupComponents() {
    super.setupComponents(), this.isAggregationZone() && !this.gos.get("functionsReadOnly") && this.addGuiEventListener("click", this.onShowAggFuncSelection.bind(this));
  }
  onKeyDown(e) {
    super.onKeyDown(e), e.key === P.ENTER && this.isAggregationZone() && !this.gos.get("functionsReadOnly") && (e.preventDefault(), this.onShowAggFuncSelection());
  }
  getDisplayValue() {
    const { name: e, aggFuncName: t } = this.getColumnAndAggFuncName();
    return this.isAggregationZone() ? `${t}(${e})` : e;
  }
  onShowAggFuncSelection() {
    if (this.popupShowing)
      return;
    this.popupShowing = !0;
    const { aggFuncSvc: e, popupSvc: t } = this.beans, s = new co({ cssIdentifier: "select-agg-func" }), i = e.getFuncNames(this.column), r = this.getGui(), n = s.getGui();
    s.setModel({
      getRow: function(h) {
        return i[h];
      },
      getRowCount: function() {
        return i.length;
      }
    }), this.createBean(s);
    const o = ss(
      /* html*/
      '<div class="ag-select-agg-func-popup"></div>'
    );
    o.style.top = "0px", o.style.left = "0px", o.appendChild(n), o.style.width = `${r.clientWidth}px`;
    const [a] = this.addManagedElementListeners(o, {
      focusout: (h) => {
        !o.contains(h.relatedTarget) && d && d.hideFunc();
      }
    }), l = (h) => {
      this.destroyBean(s), this.popupShowing = !1, (h == null ? void 0 : h.key) === "Escape" && r.focus(), a && a();
    }, c = this.getLocaleTextFunc(), d = t.addPopup({
      modal: !0,
      eChild: o,
      closeOnEsc: !0,
      closedCallback: l,
      ariaLabel: c("ariaLabelAggregationFunction", "Aggregation Function")
    });
    d && s.setComponentCreator(this.createAggSelect.bind(this, d.hideFunc)), s.addGuiEventListener("keydown", (h) => {
      if (h.key === P.ENTER || h.key === P.SPACE) {
        const p = s.getLastFocusedRow();
        if (p == null)
          return;
        const g = s.getComponentAt(p);
        g && g.selectItem();
      }
    }), t.positionPopupByComponent({
      type: "aggFuncSelect",
      eventSource: r,
      ePopup: o,
      keepWithinBounds: !0,
      column: this.column,
      position: "under"
    }), s.refresh();
    let u = i.findIndex((h) => h === this.column.getAggFunc());
    u === -1 && (u = 0), s.focusRow(u);
  }
  createAggSelect(e, t) {
    const s = () => {
      var a, l;
      e(), this.getGui().focus(), (l = (a = this.beans.valueColsSvc) == null ? void 0 : a.setColumnAggFunc) == null || l.call(a, this.column, t, "toolPanelDragAndDrop");
    }, i = this.getLocaleTextFunc(), r = t.toString(), n = i(r, r);
    return new lW(s, n);
  }
  isGroupingAndLocked() {
    return this.isGroupingZone() && da(this.column, this.beans);
  }
  isAggregationZone() {
    return this.dropZonePurpose === "aggregation";
  }
  isGroupingZone() {
    return this.dropZonePurpose === "rowGroup";
  }
  getDragSourceType() {
    return ni.ToolPanel;
  }
  destroy() {
    super.destroy(), this.column = null;
  }
}, lW = class extends _ {
  constructor(e, t) {
    super(
      /* html */
      '<div class="ag-select-agg-func-item"/>'
    ), this.selectItem = e, this.getGui().innerText = t, this.addGuiEventListener("click", this.selectItem);
  }
}, Zh = class extends Db {
  constructor(e, t) {
    super(e), this.dropZonePurpose = t, this.addElementClasses(this.getGui(), this.dropZonePurpose.toLowerCase());
  }
  init(e) {
    super.init(e), this.addManagedEventListeners({ newColumnsLoaded: this.refreshGui.bind(this) }), this.addManagedPropertyListeners(
      ["functionsReadOnly", "rowGroupPanelSuppressSort", "groupLockGroupColumns"],
      this.refreshGui.bind(this)
    );
  }
  getItems(e) {
    return e.columns ?? [];
  }
  isInterestedIn(e) {
    return e === ni.HeaderCell || e === ni.ToolPanel;
  }
  minimumAllowedNewInsertIndex() {
    const { gos: e, rowGroupColsSvc: t } = this.beans, s = e.get("groupLockGroupColumns"), i = (t == null ? void 0 : t.columns.length) ?? 0;
    return s === -1 ? i : Math.min(s, i);
  }
  showOrHideColumnOnExit(e) {
    return this.isRowGroupPanel() && bv(this.gos, !0) && !e.fromNudge;
  }
  handleDragEnterEnd(e) {
    if (this.showOrHideColumnOnExit(e)) {
      const i = e.dragSource.getDragItem().columns;
      this.setColumnsVisible(i, !1, "uiColumnDragged");
    }
  }
  handleDragLeaveEnd(e) {
    if (this.showOrHideColumnOnExit(e)) {
      const s = e.dragSource.getDragItem();
      this.setColumnsVisible(s.columns, !0, "uiColumnDragged");
    }
  }
  setColumnsVisible(e, t, s) {
    if (e) {
      const i = e.filter((r) => !r.getColDef().lockVisible);
      this.beans.colModel.setColsVisible(i, t, s);
    }
  }
  isRowGroupPanel() {
    return this.dropZonePurpose === "rowGroup";
  }
  createPillComponent(e, t, s, i) {
    return new aW(e, t, s, this.dropZonePurpose, i);
  }
}, Mb = class extends Zh {
  constructor(e) {
    super(e, "pivot");
  }
  postConstruct() {
    const e = this.getLocaleTextFunc(), t = e("pivotColumnsEmptyMessage", "Drag here to set column labels"), s = e("pivots", "Column Labels");
    super.init({
      icon: ue("pivotPanel", this.beans, null),
      emptyMessage: t,
      title: s
    }), this.addManagedEventListeners({
      newColumnsLoaded: this.refresh.bind(this),
      columnPivotChanged: this.refresh.bind(this),
      columnPivotModeChanged: this.checkVisibility.bind(this)
    }), this.refresh();
  }
  getAriaLabel() {
    return this.getLocaleTextFunc()("ariaPivotDropZonePanelLabel", "Column Labels");
  }
  refresh() {
    this.checkVisibility(), this.refreshGui();
  }
  checkVisibility() {
    const e = this.beans.colModel, t = e.isPivotMode();
    if (this.horizontal)
      switch (this.gos.get("pivotPanelShow")) {
        case "always":
          this.setDisplayed(t);
          break;
        case "onlyWhenPivoting": {
          const s = e.isPivotActive();
          this.setDisplayed(t && s);
          break;
        }
        default:
          this.setDisplayed(!1);
          break;
      }
    else
      this.setDisplayed(t);
  }
  isItemDroppable(e, t) {
    return this.gos.get("functionsReadOnly") || !e.isPrimary() ? !1 : e.isAllowPivot() && (!e.isPivotActive() || this.isSourceEventFromTarget(t));
  }
  updateItems(e) {
    var t;
    (t = this.beans.pivotColsSvc) == null || t.setColumns(e, "toolPanelUi");
  }
  getIconName() {
    return this.isPotentialDndItems() ? "pivot" : "notAllowed";
  }
  getExistingItems() {
    var e;
    return ((e = this.beans.pivotColsSvc) == null ? void 0 : e.columns) ?? [];
  }
}, Ib = class extends Zh {
  constructor(e) {
    super(e, "rowGroup");
  }
  postConstruct() {
    const e = this.getLocaleTextFunc(), t = e("rowGroupColumnsEmptyMessage", "Drag here to set row groups"), s = e("groups", "Row Groups");
    super.init({
      icon: ue("rowGroupPanel", this.beans, null),
      emptyMessage: t,
      title: s
    }), this.addManagedEventListeners({ columnRowGroupChanged: this.refreshGui.bind(this) });
  }
  getAriaLabel() {
    return this.getLocaleTextFunc()("ariaRowGroupDropZonePanelLabel", "Row Groups");
  }
  isItemDroppable(e, t) {
    return this.gos.get("functionsReadOnly") || !e.isPrimary() ? !1 : e.isAllowRowGroup() && (!e.isRowGroupActive() || this.isSourceEventFromTarget(t));
  }
  updateItems(e) {
    var t;
    (t = this.beans.rowGroupColsSvc) == null || t.setColumns(e, "toolPanelUi");
  }
  getIconName() {
    return this.isPotentialDndItems() ? "group" : "notAllowed";
  }
  getExistingItems() {
    var e;
    return ((e = this.beans.rowGroupColsSvc) == null ? void 0 : e.columns) ?? [];
  }
}, cW = class extends Zh {
  constructor(e) {
    super(e, "aggregation");
  }
  postConstruct() {
    const e = this.getLocaleTextFunc(), t = e("valueColumnsEmptyMessage", "Drag here to aggregate"), s = e("values", "Values");
    super.init({
      icon: ue("valuePanel", this.beans, null),
      emptyMessage: t,
      title: s
    }), this.addManagedEventListeners({ columnValueChanged: this.refreshGui.bind(this) });
  }
  getAriaLabel() {
    return this.getLocaleTextFunc()("ariaValuesDropZonePanelLabel", "Values");
  }
  getIconName() {
    return this.isPotentialDndItems() ? "aggregate" : "notAllowed";
  }
  isItemDroppable(e, t) {
    return this.gos.get("functionsReadOnly") || !e.isPrimary() ? !1 : e.isAllowValue() && (!e.isValueActive() || this.isSourceEventFromTarget(t));
  }
  updateItems(e) {
    var t;
    (t = this.beans.valueColsSvc) == null || t.setColumns(e, "toolPanelUi");
  }
  getExistingItems() {
    var e;
    return ((e = this.beans.valueColsSvc) == null ? void 0 : e.columns) ?? [];
  }
}, dW = class extends _ {
  constructor() {
    super(...arguments), this.cbPivotMode = E;
  }
  createTemplate() {
    return (
      /* html */
      `<div class="ag-pivot-mode-panel">
                <ag-toggle-button data-ref="cbPivotMode" class="ag-pivot-mode-select"></ag-toggle-button>
            </div>`
    );
  }
  postConstruct() {
    this.setTemplate(this.createTemplate(), [VD]);
    const e = this.cbPivotMode, { colModel: t, ctrlsSvc: s, gos: i } = this.beans;
    e.setValue(t.isPivotMode());
    const r = this.getLocaleTextFunc();
    e.setLabel(r("pivotMode", "Pivot Mode"));
    const n = () => {
      const a = !!e.getValue();
      a !== t.isPivotMode() && (i.updateGridOptions({ options: { pivotMode: a }, source: "toolPanelUi" }), s.getHeaderRowContainerCtrls().forEach((l) => l.refresh()));
    }, o = () => {
      const a = t.isPivotMode();
      e.setValue(a);
    };
    this.addManagedListeners(e, { fieldValueChanged: n }), this.addManagedEventListeners({
      newColumnsLoaded: o,
      columnPivotModeChanged: o
    });
  }
}, uW = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colToolPanelFactory";
  }
  setPanelVisible(e, t, s) {
    return e ? e.setDisplayed(t) : t && (e = s()), e;
  }
  createRowGroupPanel(e, t) {
    return this.createPanel(e, t, new Ib(!1));
  }
  createValuesPanel(e, t) {
    return this.createPanel(e, t, new cW(!1));
  }
  createPivotPanel(e, t) {
    return this.createPanel(e, t, new Mb(!1));
  }
  createPivotModePanel(e, t, s) {
    return this.createPanel(e, t, new dW(), s);
  }
  createPanel(e, t, s, i) {
    return s = e.createBean(s), t.push(() => e.destroyBean(s)), i ? e.prependChild(s) : e.appendChild(s), s;
  }
}, hW = {
  moduleName: "ColumnsToolPanel",
  version: Me,
  beans: [uW],
  userComponents: { agColumnsToolPanel: nW },
  icons: {
    // column tool panel tab
    columnsToolPanel: "columns",
    // "Group by {column-name}" item in column header menu
    menuAddRowGroup: "group",
    // "Un-Group by {column-name}" item in column header menu
    menuRemoveRowGroup: "group",
    // identifies the pivot drop zone
    pivotPanel: "pivot",
    // "Row groups" drop zone in column tool panel
    rowGroupPanel: "group",
    // columns tool panel Values drop zone
    valuePanel: "aggregation",
    // column tool panel column group contracted (click to expand)
    columnSelectClosed: "tree-closed",
    // column tool panel column group expanded (click to contract)
    columnSelectOpen: "tree-open",
    // column tool panel header expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    columnSelectIndeterminate: "tree-indeterminate"
  },
  dependsOn: [
    Je,
    Xh,
    Oh,
    ao,
    Yi,
    Dc
  ]
}, pW = class extends L {
  constructor() {
    super(...arguments), this.beanName = "chartMenuItemMapper";
  }
  getChartItems(e) {
    var c, d;
    const t = this.beans, s = t.chartSvc, i = e === "pivotChart";
    if (!s)
      return null;
    const r = this.getLocaleTextFunc.bind(this), n = i ? new gW(t, s, r) : new fW(t, s, r), o = s.isEnterprise();
    let a = n.getMenuItem();
    if (a && a.subMenu && !o) {
      const u = (h) => {
        var p;
        return {
          ...h,
          subMenu: (p = h.subMenu) == null ? void 0 : p.filter((g) => !g._enterprise).map((g) => u(g))
        };
      };
      a = u(a);
    }
    const l = (d = (c = this.gos.get("chartToolPanelsDef")) == null ? void 0 : c.settingsPanel) == null ? void 0 : d.chartGroupsDef;
    return l && (a = this.filterAndOrderChartMenu(
      a,
      l,
      n.getConfigLookup()
    )), this.cleanInternals(a);
  }
  // Remove our internal _key and _enterprise properties so this does not leak out of the class on the menu items.
  cleanInternals(e) {
    if (!e)
      return e;
    const t = (s) => {
      var i;
      return s == null || delete s._key, s == null || delete s._enterprise, (i = s == null ? void 0 : s.subMenu) == null || i.forEach((r) => t(r)), s;
    };
    return t(e);
  }
  buildLookup(e) {
    const t = {}, s = (i) => {
      t[i._key] = i, i.subMenu && i.subMenu.forEach((r) => s(r));
    };
    return s(e), t;
  }
  /**
   * Make the MenuItem match the charts provided and their ordering on the ChartGroupsDef config object as provided by the user.
   */
  filterAndOrderChartMenu(e, t, s) {
    var n;
    const i = this.buildLookup(e), r = { ...e, subMenu: [] };
    return Object.entries(t).forEach(([o, a]) => {
      var d, u;
      const l = s[o];
      if (l === null)
        return;
      if (l == null) {
        I(173, { group: o });
        return;
      }
      const c = i[l._key];
      if (c)
        if (c.subMenu) {
          const h = a.map((p) => {
            const g = l[p];
            if (g == null) {
              I(174, { group: o, chartType: p });
              return;
            }
            return i[g];
          }).filter((p) => p !== void 0);
          h.length > 0 && (c.subMenu = h, (d = r.subMenu) == null || d.push(c));
        } else
          (u = r.subMenu) == null || u.push(c);
    }), ((n = r.subMenu) == null ? void 0 : n.length) == 0 ? null : r;
  }
}, gW = class {
  constructor(e, t, s) {
    this.beans = e, this.chartSvc = t, this.getLocaleTextFunc = s;
  }
  getMenuItem() {
    const e = this.getLocaleTextFunc(), t = (s, i, r, n, o = !1) => ({
      name: e(s, i),
      action: () => this.chartSvc.createPivotChart({ chartType: r }),
      _key: n,
      _enterprise: o
    });
    return {
      name: e("pivotChart", "Pivot Chart"),
      _key: "pivotChart",
      subMenu: [
        {
          _key: "pivotColumnChart",
          name: e("columnChart", "Column"),
          subMenu: [
            t("groupedColumn", "Grouped&lrm;", "groupedColumn", "pivotGroupedColumn"),
            t("stackedColumn", "Stacked&lrm;", "stackedColumn", "pivotStackedColumn"),
            t(
              "normalizedColumn",
              "100% Stacked&lrm;",
              "normalizedColumn",
              "pivotNormalizedColumn"
            )
          ]
        },
        {
          _key: "pivotBarChart",
          name: e("barChart", "Bar"),
          subMenu: [
            t("groupedBar", "Grouped&lrm;", "groupedBar", "pivotGroupedBar"),
            t("stackedBar", "Stacked&lrm;", "stackedBar", "pivotStackedBar"),
            t("normalizedBar", "100% Stacked&lrm;", "normalizedBar", "pivotNormalizedBar")
          ]
        },
        {
          _key: "pivotPieChart",
          name: e("pieChart", "Pie"),
          subMenu: [
            t("pie", "Pie&lrm;", "pie", "pivotPie"),
            t("donut", "Donut&lrm;", "donut", "pivotDonut")
          ]
        },
        {
          _key: "pivotLineChart",
          name: e("lineChart", "Line"),
          subMenu: [
            t("lineChart", "Line&lrm;", "line", "pivotLineChart"),
            t("stackedLine", "Stacked&lrm;", "stackedLine", "pivotStackedLine"),
            t("normalizedLine", "100% Stacked&lrm;", "normalizedLine", "pivotNormalizedLine")
          ]
        },
        {
          _key: "pivotAreaChart",
          name: e("areaChart", "Area"),
          subMenu: [
            t("areaChart", "Area&lrm;", "area", "pivotArea"),
            t("stackedArea", "Stacked&lrm;", "stackedArea", "pivotStackedArea"),
            t("normalizedArea", "100% Stacked&lrm;", "normalizedArea", "pivotNormalizedArea")
          ]
        },
        {
          _key: "pivotXYChart",
          name: e("xyChart", "X Y (Scatter)"),
          subMenu: [
            t("scatter", "Scatter&lrm;", "scatter", "pivotScatter"),
            t("bubble", "Bubble&lrm;", "bubble", "pivotBubble")
          ]
        },
        {
          _key: "pivotStatisticalChart",
          _enterprise: !1,
          // histogram chart is available in both community and enterprise distributions
          name: e("statisticalChart", "Statistical"),
          subMenu: [t("histogramChart", "Histogram&lrm;", "histogram", "pivotHistogram", !1)]
        },
        {
          _key: "pivotHierarchicalChart",
          _enterprise: !0,
          name: e("hierarchicalChart", "Hierarchical"),
          subMenu: [
            t("treemapChart", "Treemap&lrm;", "treemap", "pivotTreemap", !0),
            t("sunburstChart", "Sunburst&lrm;", "sunburst", "pivotSunburst", !0)
          ]
        },
        {
          _key: "pivotCombinationChart",
          name: e("combinationChart", "Combination"),
          subMenu: [
            t("columnLineCombo", "Column & Line&lrm;", "columnLineCombo", "pivotColumnLineCombo"),
            t("AreaColumnCombo", "Area & Column&lrm;", "areaColumnCombo", "pivotAreaColumnCombo")
          ]
        }
      ],
      icon: ue("chart", this.beans, void 0)
    };
  }
  getConfigLookup() {
    return {
      columnGroup: {
        _key: "pivotColumnChart",
        column: "pivotGroupedColumn",
        stackedColumn: "pivotStackedColumn",
        normalizedColumn: "pivotNormalizedColumn"
      },
      barGroup: {
        _key: "pivotBarChart",
        bar: "pivotGroupedBar",
        stackedBar: "pivotStackedBar",
        normalizedBar: "pivotNormalizedBar"
      },
      pieGroup: {
        _key: "pivotPieChart",
        pie: "pivotPie",
        donut: "pivotDonut",
        doughnut: "pivotDonut"
      },
      lineGroup: {
        _key: "pivotLineChart",
        line: "pivotLineChart",
        stackedLine: "pivotStackedLine",
        normalizedLine: "pivotNormalizedLine"
      },
      areaGroup: {
        _key: "pivotAreaChart",
        area: "pivotArea",
        stackedArea: "pivotStackedArea",
        normalizedArea: "pivotNormalizedArea"
      },
      scatterGroup: {
        _key: "pivotXYChart",
        bubble: "pivotBubble",
        scatter: "pivotScatter"
      },
      combinationGroup: {
        _key: "pivotCombinationChart",
        columnLineCombo: "pivotColumnLineCombo",
        areaColumnCombo: "pivotAreaColumnCombo",
        customCombo: null
        // Not currently supported
      },
      hierarchicalGroup: {
        _key: "pivotHierarchicalChart",
        treemap: "pivotTreemap",
        sunburst: "pivotSunburst"
      },
      statisticalGroup: {
        _key: "pivotStatisticalChart",
        histogram: "pivotHistogram",
        // Some statistical charts do not currently support pivot mode
        rangeBar: null,
        rangeArea: null,
        boxPlot: null
      },
      // Polar charts do not support pivot mode
      polarGroup: null,
      // Specialized charts do not currently support pivot mode
      specializedGroup: null
    };
  }
}, fW = class {
  constructor(e, t, s) {
    this.beans = e, this.chartSvc = t, this.getLocaleTextFunc = s;
  }
  getMenuItem() {
    const e = this.getLocaleTextFunc(), t = (s, i, r, n, o = !1) => ({
      name: e(s, i),
      action: () => this.chartSvc.createChartFromCurrentRange(r),
      _key: n,
      _enterprise: o
    });
    return {
      name: e("chartRange", "Chart Range"),
      _key: "chartRange",
      subMenu: [
        {
          name: e("columnChart", "Column"),
          subMenu: [
            t("groupedColumn", "Grouped&lrm;", "groupedColumn", "rangeGroupedColumn"),
            t("stackedColumn", "Stacked&lrm;", "stackedColumn", "rangeStackedColumn"),
            t(
              "normalizedColumn",
              "100% Stacked&lrm;",
              "normalizedColumn",
              "rangeNormalizedColumn"
            )
          ],
          _key: "rangeColumnChart"
        },
        {
          name: e("barChart", "Bar"),
          subMenu: [
            t("groupedBar", "Grouped&lrm;", "groupedBar", "rangeGroupedBar"),
            t("stackedBar", "Stacked&lrm;", "stackedBar", "rangeStackedBar"),
            t("normalizedBar", "100% Stacked&lrm;", "normalizedBar", "rangeNormalizedBar")
          ],
          _key: "rangeBarChart"
        },
        {
          name: e("pieChart", "Pie"),
          subMenu: [
            t("pie", "Pie&lrm;", "pie", "rangePie"),
            t("donut", "Donut&lrm;", "donut", "rangeDonut")
          ],
          _key: "rangePieChart"
        },
        {
          name: e("lineChart", "Line"),
          subMenu: [
            t("lineChart", "Line&lrm;", "line", "rangeLineChart"),
            t("stackedLine", "Stacked&lrm;", "stackedLine", "rangeStackedLine"),
            t("normalizedLine", "100% Stacked&lrm;", "normalizedLine", "rangeNormalizedLine")
          ],
          _key: "rangeLineChart"
        },
        {
          name: e("areaChart", "Area"),
          subMenu: [
            t("areaChart", "Area&lrm;", "area", "rangeArea"),
            t("stackedArea", "Stacked&lrm;", "stackedArea", "rangeStackedArea"),
            t("normalizedArea", "100% Stacked&lrm;", "normalizedArea", "rangeNormalizedArea")
          ],
          _key: "rangeAreaChart"
        },
        {
          name: e("xyChart", "X Y (Scatter)"),
          subMenu: [
            t("scatter", "Scatter&lrm;", "scatter", "rangeScatter"),
            t("bubble", "Bubble&lrm;", "bubble", "rangeBubble")
          ],
          _key: "rangeXYChart"
        },
        {
          name: e("polarChart", "Polar"),
          subMenu: [
            t("radarLine", "Radar Line&lrm;", "radarLine", "rangeRadarLine"),
            t("radarArea", "Radar Area&lrm;", "radarArea", "rangeRadarArea"),
            t("nightingale", "Nightingale&lrm;", "nightingale", "rangeNightingale"),
            t("radialColumn", "Radial Column&lrm;", "radialColumn", "rangeRadialColumn"),
            t("radialBar", "Radial Bar&lrm;", "radialBar", "rangeRadialBar")
          ],
          _key: "rangePolarChart",
          _enterprise: !0
        },
        {
          name: e("statisticalChart", "Statistical"),
          subMenu: [
            t("boxPlot", "Box Plot&lrm;", "boxPlot", "rangeBoxPlot", !0),
            t("histogramChart", "Histogram&lrm;", "histogram", "rangeHistogram", !1),
            t("rangeBar", "Range Bar&lrm;", "rangeBar", "rangeRangeBar", !0),
            t("rangeArea", "Range Area&lrm;", "rangeArea", "rangeRangeArea", !0)
          ],
          _key: "rangeStatisticalChart",
          _enterprise: !1
          // histogram chart is available in both community and enterprise distributions
        },
        {
          name: e("hierarchicalChart", "Hierarchical"),
          subMenu: [
            t("treemap", "Treemap&lrm;", "treemap", "rangeTreemap"),
            t("sunburst", "Sunburst&lrm;", "sunburst", "rangeSunburst")
          ],
          _key: "rangeHierarchicalChart",
          _enterprise: !0
        },
        {
          name: e("specializedChart", "Specialized"),
          subMenu: [
            t("heatmap", "Heatmap&lrm;", "heatmap", "rangeHeatmap"),
            t("waterfall", "Waterfall&lrm;", "waterfall", "rangeWaterfall")
          ],
          _key: "rangeSpecializedChart",
          _enterprise: !0
        },
        {
          name: e("combinationChart", "Combination"),
          subMenu: [
            t("columnLineCombo", "Column & Line&lrm;", "columnLineCombo", "rangeColumnLineCombo"),
            t("AreaColumnCombo", "Area & Column&lrm;", "areaColumnCombo", "rangeAreaColumnCombo")
          ],
          _key: "rangeCombinationChart"
        }
      ],
      icon: ue("chart", this.beans, void 0)
    };
  }
  getConfigLookup() {
    return {
      columnGroup: {
        _key: "rangeColumnChart",
        column: "rangeGroupedColumn",
        stackedColumn: "rangeStackedColumn",
        normalizedColumn: "rangeNormalizedColumn"
      },
      barGroup: {
        _key: "rangeBarChart",
        bar: "rangeGroupedBar",
        stackedBar: "rangeStackedBar",
        normalizedBar: "rangeNormalizedBar"
      },
      pieGroup: {
        _key: "rangePieChart",
        pie: "rangePie",
        donut: "rangeDonut",
        doughnut: "rangeDonut"
      },
      lineGroup: {
        _key: "rangeLineChart",
        line: "rangeLineChart",
        stackedLine: "rangeStackedLine",
        normalizedLine: "rangeNormalizedLine"
      },
      areaGroup: {
        _key: "rangeAreaChart",
        area: "rangeArea",
        stackedArea: "rangeStackedArea",
        normalizedArea: "rangeNormalizedArea"
      },
      scatterGroup: {
        _key: "rangeXYChart",
        bubble: "rangeBubble",
        scatter: "rangeScatter"
      },
      polarGroup: {
        _key: "rangePolarChart",
        radarLine: "rangeRadarLine",
        radarArea: "rangeRadarArea",
        nightingale: "rangeNightingale",
        radialColumn: "rangeRadialColumn",
        radialBar: "rangeRadialBar"
      },
      statisticalGroup: {
        _key: "rangeStatisticalChart",
        boxPlot: "rangeBoxPlot",
        histogram: "rangeHistogram",
        rangeBar: "rangeRangeBar",
        rangeArea: "rangeRangeArea"
      },
      hierarchicalGroup: {
        _key: "rangeHierarchicalChart",
        treemap: "rangeTreemap",
        sunburst: "rangeSunburst"
      },
      specializedGroup: {
        _key: "rangeSpecializedChart",
        heatmap: "rangeHeatmap",
        waterfall: "rangeWaterfall"
      },
      combinationGroup: {
        _key: "rangeCombinationChart",
        columnLineCombo: "rangeColumnLineCombo",
        areaColumnCombo: "rangeAreaColumnCombo",
        customCombo: null
        // Not currently supported
      }
    };
  }
}, mW = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colChooserFactory";
  }
  createColumnSelectPanel(e, t, s, i) {
    const r = e.createManagedBean(new Eb()), n = i ?? (t == null ? void 0 : t.getColDef().columnChooserParams) ?? {}, {
      contractColumnSelection: o,
      suppressColumnExpandAll: a,
      suppressColumnFilter: l,
      suppressColumnSelectAll: c,
      suppressSyncLayoutWithGrid: d,
      columnLayout: u
    } = n;
    return r.init(
      !!s,
      this.gos.addGridCommonParams({
        suppressColumnMove: !1,
        suppressValues: !1,
        suppressPivots: !1,
        suppressRowGroups: !1,
        suppressPivotMode: !1,
        contractColumnSelection: !!o,
        suppressColumnExpandAll: !!a,
        suppressColumnFilter: !!l,
        suppressColumnSelectAll: !!c,
        suppressSyncLayoutWithGrid: !!u || !!d,
        onStateUpdated: () => {
        }
      }),
      "columnMenu"
    ), u && r.setColumnLayout(u), r;
  }
  showColumnChooser({ column: e, chooserParams: t, eventSource: s }) {
    this.hideActiveColumnChooser();
    const i = this.createColumnSelectPanel(this, e, !0, t), r = this.getLocaleTextFunc(), n = this.beans, { visibleCols: o, focusSvc: a, menuUtils: l } = n, c = o.allCols.indexOf(e), d = e ? a.focusedHeader : null;
    this.activeColumnChooserDialog = this.createBean(
      new ya({
        title: r("chooseColumns", "Choose Columns"),
        component: i,
        width: 300,
        height: 300,
        resizable: !0,
        movable: !0,
        centered: !0,
        closable: !0,
        afterGuiAttached: () => {
          var u;
          (u = zt(n, i.getGui())) == null || u.focus({
            preventScroll: !0
          }), this.dispatchVisibleChangedEvent(!0, e);
        },
        closedCallback: (u) => {
          const h = this.activeColumnChooser.getGui();
          this.destroyBean(this.activeColumnChooser), this.activeColumnChooser = void 0, this.activeColumnChooserDialog = void 0, this.dispatchVisibleChangedEvent(!1, e), e && l.restoreFocusOnClose(
            { column: e, headerPosition: d, columnIndex: c, eventSource: s },
            h,
            u,
            !0
          );
        },
        postProcessPopupParams: {
          type: "columnChooser",
          column: e,
          eventSource: s
        }
      })
    ), this.activeColumnChooser = i;
  }
  hideActiveColumnChooser() {
    this.destroyBean(this.activeColumnChooserDialog);
  }
  dispatchVisibleChangedEvent(e, t) {
    this.eventSvc.dispatchEvent({
      type: "columnMenuVisibleChanged",
      visible: e,
      switchingTab: !1,
      key: "columnChooser",
      column: t ?? null
    });
  }
}, Xr = "separator";
function Lb(e, t) {
  if (e)
    for (let s = e.length - 2; s >= 0; s--) {
      const i = e[s] === t, r = e[s + 1] === t;
      i && r && e.splice(s + 1, 1);
    }
}
var CW = class extends L {
  constructor() {
    super(...arguments), this.beanName = "menuItemMapper";
  }
  mapWithStockItems(e, t, s, i) {
    if (!e)
      return [];
    const r = [], n = this.getLocaleTextFunc(), { beans: o, gos: a } = this, {
      validation: l,
      pinnedCols: c,
      colAutosize: d,
      aggFuncSvc: u,
      rowGroupColsSvc: h,
      colNames: p,
      colModel: g,
      clipboardSvc: f,
      expansionSvc: m,
      focusSvc: C,
      csvCreator: w,
      excelCreator: y,
      menuSvc: b,
      colChooserFactory: x,
      sortSvc: M,
      chartMenuItemMapper: T,
      valueColsSvc: F
    } = o, k = (O, D, $, j) => {
      switch (l == null || l.validateMenuItem(O), O) {
        case "pinSubMenu":
          return c && D ? {
            name: n("pinColumn", "Pin Column"),
            icon: ue("menuPin", o, null),
            subMenu: ["clearPinned", "pinLeft", "pinRight"]
          } : null;
        case "pinLeft":
          return c && D ? {
            name: n("pinLeft", "Pin Left"),
            action: () => c.setColsPinned([D], "left", j),
            checked: !!D && D.isPinnedLeft()
          } : null;
        case "pinRight":
          return c && D ? {
            name: n("pinRight", "Pin Right"),
            action: () => c.setColsPinned([D], "right", j),
            checked: !!D && D.isPinnedRight()
          } : null;
        case "clearPinned":
          return c && D ? {
            name: n("noPin", "No Pin"),
            action: () => c.setColsPinned([D], null, j),
            checked: !!D && !D.isPinned()
          } : null;
        case "valueAggSubMenu":
          return u && F && (D != null && D.isPrimary() || D != null && D.getColDef().pivotValueColumn) ? {
            name: n("valueAggregation", "Value Aggregation"),
            icon: ue("menuValue", o, null),
            subMenu: vW(D, u, F, n),
            disabled: a.get("functionsReadOnly")
          } : null;
        case "autoSizeThis":
          return d ? {
            name: n("autosizeThisColumn", "Autosize This Column"),
            action: () => d.autoSizeColumn(D, j, a.get("skipHeaderOnAutoSize"))
          } : null;
        case "autoSizeAll":
          return d ? {
            name: n("autosizeAllColumns", "Autosize All Columns"),
            action: () => d.autoSizeAllColumns(j, a.get("skipHeaderOnAutoSize"))
          } : null;
        case "rowGroup":
          return h ? {
            name: n("groupBy", "Group by") + " " + Ke(p.getDisplayNameForColumn(D, "header")),
            disabled: a.get("functionsReadOnly") || (D == null ? void 0 : D.isRowGroupActive()) || !(D != null && D.getColDef().enableRowGroup),
            action: () => h.addColumns([D], j),
            icon: ue("menuAddRowGroup", o, null)
          } : null;
        case "rowUnGroup":
          if (h && a.isModuleRegistered("SharedRowGrouping")) {
            const J = D == null ? void 0 : D.getColDef().showRowGroup, X = a.get("groupLockGroupColumns");
            let ie, Ce, ae;
            if (J === !0)
              ie = n("ungroupAll", "Un-Group All"), Ce = a.get("functionsReadOnly") || X === -1 || X >= (h.columns.length ?? 0), ae = () => h.setColumns(h.columns.slice(0, X), j);
            else if (typeof J == "string") {
              const ge = g.getColDefCol(J), Se = ge != null ? Ke(p.getDisplayNameForColumn(ge, "header")) : J;
              ie = n("ungroupBy", "Un-Group by") + " " + Se, Ce = a.get("functionsReadOnly") || da(ge, o), ae = () => {
                h.removeColumns([J], j);
              };
            } else
              ie = n("ungroupBy", "Un-Group by") + " " + Ke(p.getDisplayNameForColumn(D, "header")), Ce = a.get("functionsReadOnly") || !(D != null && D.isRowGroupActive()) || !(D != null && D.getColDef().enableRowGroup) || da(D, o), ae = () => h.removeColumns([D], j);
            return {
              name: ie,
              disabled: Ce,
              action: ae,
              icon: ue("menuRemoveRowGroup", o, null)
            };
          } else
            return null;
        case "resetColumns":
          return {
            name: n("resetColumns", "Reset Columns"),
            action: () => Bv(o, j)
          };
        case "expandAll":
          return m ? {
            name: n("expandAll", "Expand All Row Groups"),
            action: () => m.expandAll(!0)
          } : null;
        case "contractAll":
          return m ? {
            name: n("collapseAll", "Collapse All Row Groups"),
            action: () => m.expandAll(!1)
          } : null;
        case "copy":
          return f ? {
            name: n("copy", "Copy"),
            shortcut: n("ctrlC", "Ctrl+C"),
            icon: ue("clipboardCopy", o, null),
            action: () => f.copyToClipboard()
          } : null;
        case "copyWithHeaders":
          return f ? {
            name: n("copyWithHeaders", "Copy with Headers"),
            // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
            icon: ue("clipboardCopy", o, null),
            action: () => f.copyToClipboard({ includeHeaders: !0 })
          } : null;
        case "copyWithGroupHeaders":
          return f ? {
            name: n("copyWithGroupHeaders", "Copy with Group Headers"),
            // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
            icon: ue("clipboardCopy", o, null),
            action: () => f.copyToClipboard({ includeHeaders: !0, includeGroupHeaders: !0 })
          } : null;
        case "cut":
          if (f) {
            const J = C.getFocusedCell(), X = J ? ri(o, J) : null, ie = X ? J == null ? void 0 : J.column.isCellEditable(X) : !1;
            return {
              name: n("cut", "Cut"),
              shortcut: n("ctrlX", "Ctrl+X"),
              icon: ue("clipboardCut", o, null),
              disabled: !ie || a.get("suppressCutToClipboard"),
              action: () => f.cutToClipboard(void 0, "contextMenu")
            };
          } else
            return null;
        case "paste":
          return f ? {
            name: n("paste", "Paste"),
            shortcut: n("ctrlV", "Ctrl+V"),
            disabled: !0,
            icon: ue("clipboardPaste", o, null),
            action: () => f.pasteFromClipboard()
          } : null;
        case "export": {
          const J = [];
          return !a.get("suppressCsvExport") && w && J.push("csvExport"), !a.get("suppressExcelExport") && y && J.push("excelExport"), J.length ? {
            name: n("export", "Export"),
            subMenu: J,
            icon: ue("save", o, null)
          } : null;
        }
        case "csvExport":
          return w ? {
            name: n("csvExport", "CSV Export"),
            icon: ue("csvExport", o, null),
            action: () => w.exportDataAsCsv()
          } : null;
        case "excelExport":
          return y ? {
            name: n("excelExport", "Excel Export"),
            icon: ue("excelExport", o, null),
            action: () => y.exportDataAsExcel()
          } : null;
        case "separator":
          return "separator";
        case "pivotChart":
        case "chartRange":
          return T.getChartItems(O);
        case "columnFilter":
          return b && D ? {
            name: n("columnFilter", "Column Filter"),
            icon: ue("filter", o, null),
            action: () => b.showFilterMenu({
              column: D,
              buttonElement: $(),
              containerType: "columnFilter",
              positionBy: "button"
            })
          } : null;
        case "columnChooser":
          return x ? {
            name: n("columnChooser", "Choose Columns"),
            icon: ue("columns", o, null),
            action: () => x.showColumnChooser({
              column: D,
              eventSource: $()
            })
          } : null;
        case "sortAscending":
          return M ? {
            name: n("sortAscending", "Sort Ascending"),
            icon: ue("sortAscending", o, null),
            action: () => M.setSortForColumn(D, "asc", !1, j)
          } : null;
        case "sortDescending":
          return M ? {
            name: n("sortDescending", "Sort Descending"),
            icon: ue("sortDescending", o, null),
            action: () => M.setSortForColumn(D, "desc", !1, j)
          } : null;
        case "sortUnSort":
          return M ? {
            name: n("sortUnSort", "Clear Sort"),
            icon: ue("sortUnSort", o, null),
            action: () => M.setSortForColumn(D, null, !1, j)
          } : null;
        default:
          return I(176, { key: O }), null;
      }
    };
    return e.forEach((O) => {
      let D;
      if (typeof O == "string" ? D = k(O, t, s, i) : D = { ...O }, !D)
        return;
      const $ = D, { subMenu: j } = $;
      j && j instanceof Array && ($.subMenu = this.mapWithStockItems(
        j,
        t,
        s,
        i
      )), D != null && r.push(D);
    }), Lb(r, Xr), r;
  }
};
function vW(e, t, s, i) {
  let r;
  if (e.isPrimary())
    r = e;
  else {
    const o = e.getColDef().pivotValueColumn;
    r = W(o) ? o : void 0;
  }
  const n = [];
  if (r) {
    const o = r.isValueActive(), a = t.getFuncNames(r);
    n.push({
      name: i("noAggregation", "None"),
      action: () => {
        s.removeColumns([r], "contextMenu"), s.setColumnAggFunc(r, void 0, "contextMenu");
      },
      checked: !o
    }), a.forEach((l) => {
      n.push({
        name: i(l, t.getDefaultFuncLabel(l)),
        action: () => {
          s.setColumnAggFunc(r, l, "contextMenu"), s.addColumns([r], "contextMenu");
        },
        checked: o && r.getAggFunc() === l
      });
    });
  }
  return n;
}
var wW = class extends L {
  constructor() {
    super(...arguments), this.beanName = "colMenuFactory";
  }
  createMenu(e, t, s, i) {
    const r = e.createManagedBean(
      new ba(0, {
        column: s ?? null,
        node: null,
        value: null
      })
    ), n = this.beans.menuItemMapper.mapWithStockItems(
      t,
      s ?? null,
      i,
      "columnMenu"
    );
    return r.addMenuItems(n), r;
  }
  getMenuItems(e = null, t = null) {
    var n;
    const s = this.getDefaultMenuOptions(e);
    let i;
    const r = (n = (e == null ? void 0 : e.getColDef()) ?? (t == null ? void 0 : t.getColGroupDef())) == null ? void 0 : n.mainMenuItems;
    if (Array.isArray(r))
      i = r;
    else if (typeof r == "function")
      i = r(
        this.gos.addGridCommonParams({
          column: e,
          columnGroup: t,
          defaultItems: s
        })
      );
    else {
      const o = this.gos.getCallback("getMainMenuItems");
      o ? i = o({
        column: e,
        columnGroup: t,
        defaultItems: s
      }) : i = s;
    }
    return Lb(i, Xr), i;
  }
  getDefaultMenuOptions(e) {
    const t = [], { beans: s, gos: i } = this, {
      colChooserFactory: r,
      rowGroupColsSvc: n,
      colModel: o,
      expansionSvc: a,
      sortSvc: l,
      menuSvc: c,
      pinnedCols: d,
      aggFuncSvc: u,
      colAutosize: h
    } = s, p = Mt(i), g = () => {
      !p && r && t.push("columnChooser"), t.push("resetColumns");
    };
    if (!e)
      return g(), t;
    const { colDef: f } = e, m = d && !f.lockPinned, C = (n == null ? void 0 : n.columns.length) ?? 0, w = C > 0, y = e.isPrimary(), b = u && // if primary, then only allow aggValue if grouping and it's a value columns
    y && w && e.isAllowValue() || // secondary columns can always have aggValue, as it means it's a pivot value column
    !y;
    if (l && !p && e.isSortable()) {
      const x = e.getSort();
      x !== "asc" && t.push("sortAscending"), x !== "desc" && t.push("sortDescending"), x && t.push("sortUnSort"), t.push(Xr);
    }
    if (c != null && c.isFilterMenuItemEnabled(e) && (t.push("columnFilter"), t.push(Xr)), m && t.push("pinSubMenu"), b && t.push("valueAggSubMenu"), (m || b) && t.push(Xr), h && (t.push("autoSizeThis"), t.push("autoSizeAll"), t.push(Xr)), n && i.isModuleRegistered("SharedRowGrouping")) {
      const x = t.length;
      f.showRowGroup ? t.push("rowUnGroup") : e.isAllowRowGroup() && y && (e.isRowGroupActive() ? da(e, s) || t.push("rowUnGroup") : t.push("rowGroup")), t.length > x && t.push(Xr);
    }
    return g(), a && Ye(i) && (i.get("treeData") || C > (o.isPivotMode() ? 1 : 0)) && (t.push("expandAll"), t.push("contractAll")), t;
  }
}, yW = "ag-menu", zf = "ag-context-menu-open", bW = "ag-context-menu-loading-icon", SW = class extends L {
  constructor() {
    super(...arguments), this.beanName = "contextMenuSvc", this.destroyLoadingSpinner = null, this.lastPromise = 0;
  }
  hideActiveMenu() {
    this.destroyBean(this.activeMenu);
  }
  getMenuItems(e, t, s, i) {
    const r = [], { clipboardSvc: n, chartSvc: o, csvCreator: a, excelCreator: l, colModel: c, rangeSvc: d, gos: u } = this.beans;
    if (W(e) && n && t && (u.get("suppressCutToClipboard") || r.push("cut"), r.push("copy", "copyWithHeaders", "copyWithGroupHeaders", "paste", "separator")), u.get("enableCharts") && o && (c.isPivotMode() && r.push("pivotChart"), d && !d.isEmpty() && r.push("chartRange")), W(e)) {
      const f = u.get("suppressExcelExport") || !l, m = u.get("suppressCsvExport") || !a;
      !yr() && (!f || !m) && r.push("export");
    }
    const h = r.length ? r : void 0, p = t == null ? void 0 : t.getColDef().contextMenuItems;
    if (Array.isArray(p))
      return p;
    if (typeof p == "function")
      return p(
        u.addGridCommonParams({
          column: t,
          node: e,
          value: s,
          defaultItems: h,
          event: i
        })
      );
    const g = u.getCallback("getContextMenuItems");
    return g ? g({ column: t, node: e, value: s, defaultItems: h, event: i }) : r;
  }
  getContextMenuPosition(e, t) {
    const s = this.getRowCtrl(e), i = this.getCellGui(s, t);
    if (!i)
      return s ? { x: 0, y: s.getRowYPosition() } : { x: 0, y: 0 };
    const r = i.getBoundingClientRect();
    return {
      x: r.x + r.width / 2,
      y: r.y + r.height / 2
    };
  }
  showContextMenu(e) {
    const t = e.rowNode, s = e.column;
    let { anchorToElement: i, value: r } = e;
    t && s && r == null && (r = this.beans.valueSvc.getValueForDisplay(s, t)), i == null && (i = this.getContextMenuAnchorElement(t, s)), this.onContextMenu(
      e.mouseEvent ?? null,
      e.touchEvent ?? null,
      t ?? null,
      s ?? null,
      r,
      i
    );
  }
  handleContextMenuMouseEvent(e, t, s, i) {
    const r = (s == null ? void 0 : s.rowNode) ?? null, n = (i == null ? void 0 : i.column) ?? null, { valueSvc: o, ctrlsSvc: a } = this.beans, l = n ? o.getValue(n, r) : null, c = a.getGridBodyCtrl(), d = i ? i.eGui : c.eGridBody;
    this.showContextMenu({
      mouseEvent: e,
      touchEvent: t,
      rowNode: r,
      column: n,
      value: l,
      anchorToElement: d
    });
  }
  onContextMenu(e, t, s, i, r, n) {
    this.beans.menuUtils.onContextMenu(
      e,
      t,
      (o) => this.showMenu(s, i, r, o, n)
    );
  }
  showMenu(e, t, s, i, r) {
    const n = this.getMenuItems(e, t, s, i);
    if (bT(n)) {
      const o = this.lastPromise + 1;
      return this.lastPromise = o, this.destroyLoadingSpinner || this.createLoadingIcon(i), n.then((a) => {
        var c;
        if (this.lastPromise !== o)
          return;
        // check if there are actual menu items to be displayed
        a && a.length && // check if the element that triggered the context menu was removed from the DOM
        Xt(i.target) && // overlay was displayed
        !((c = this.beans.overlays) != null && c.isExclusive()) && this.createContextMenu({ menuItems: a, node: e, column: t, value: s, mouseEvent: i, anchorToElement: r }), this.destroyLoadingSpinner && this.destroyLoadingSpinner();
      }), !0;
    }
    return n === void 0 || !(n != null && n.length) ? !1 : (this.createContextMenu({ menuItems: n, node: e, column: t, value: s, mouseEvent: i, anchorToElement: r }), !0);
  }
  createLoadingIcon(e) {
    var l;
    const { beans: t } = this, s = this.getLocaleTextFunc(), i = ue("loadingMenuItems", t), r = document.createElement("div");
    r.classList.add(bW), r.appendChild(i);
    const n = Yn(t), o = lc(t);
    if (!o) {
      I(54);
      return;
    }
    o.appendChild(r), (l = t.ariaAnnounce) == null || l.announceValue(
      s("ariaLabelLoadingContextMenu", "Loading Context Menu"),
      "contextmenu"
    ), t.environment.applyThemeClasses(r), nu(r, e, t);
    const a = (c) => {
      nu(r, c, t);
    };
    n.addEventListener("mousemove", a), this.destroyLoadingSpinner = () => {
      n.removeEventListener("mousemove", a), o.removeChild(r), this.destroyLoadingSpinner = null;
    };
  }
  createContextMenu(e) {
    const { menuItems: t, node: s, column: i, value: r, mouseEvent: n, anchorToElement: o } = e, { ctrlsSvc: a, focusSvc: l, popupSvc: c } = this.beans, d = a.getGridBodyCtrl().eGridBody, u = new xW(t, i, s, r);
    this.createBean(u);
    const h = u.getGui();
    i || l.clearFocusedCell();
    const p = {
      column: i,
      rowNode: s,
      type: "contextMenu",
      mouseEvent: n,
      ePopup: h,
      // move one pixel away so that accidentally double clicking
      // won't show the browser's contextmenu
      nudgeY: 1
    }, g = this.getLocaleTextFunc(), f = c.addPopup({
      modal: !0,
      eChild: h,
      closeOnEsc: !0,
      closedCallback: (C) => {
        d.classList.remove(zf), this.destroyBean(u), this.dispatchVisibleChangedEvent(!1, C === void 0 ? "api" : "ui");
      },
      click: n,
      positionCallback: () => {
        const C = this.gos.get("enableRtl");
        c.positionPopupUnderMouseEvent({
          ...p,
          nudgeX: C ? (h.offsetWidth + 1) * -1 : 1
        });
      },
      // so when browser is scrolled down, or grid is scrolled, context menu stays with cell
      anchorToElement: o,
      ariaLabel: g("ariaLabelContextMenu", "Context Menu")
    });
    f && (d.classList.add(zf), u.afterGuiAttached({ container: "contextMenu", hidePopup: f.hideFunc })), this.activeMenu && this.hideActiveMenu(), this.activeMenu = u, u.addEventListener("destroyed", () => {
      this.activeMenu === u && (this.activeMenu = null);
    }), f && u.addEventListener(
      "closeMenu",
      (C) => f.hideFunc({
        mouseEvent: C.mouseEvent ?? void 0,
        keyboardEvent: C.keyboardEvent ?? void 0,
        forceHide: !0
      })
    );
    const m = n && n instanceof MouseEvent && n.type === "mousedown";
    this.dispatchVisibleChangedEvent(!0, m ? "api" : "ui");
  }
  dispatchVisibleChangedEvent(e, t = "ui") {
    this.eventSvc.dispatchEvent({
      type: "contextMenuVisibleChanged",
      visible: e,
      source: t
    });
  }
  getRowCtrl(e) {
    const { rowIndex: t, rowPinned: s } = e || {};
    if (t != null)
      return this.beans.rowRenderer.getRowByPosition({ rowIndex: t, rowPinned: s }) || void 0;
  }
  getCellGui(e, t) {
    if (!e || !t)
      return;
    const s = e.getCellCtrl(t);
    return (s == null ? void 0 : s.eGui) || void 0;
  }
  getContextMenuAnchorElement(e, t) {
    const s = this.beans.ctrlsSvc.getGridBodyCtrl().eGridBody, i = this.getRowCtrl(e);
    if (!i)
      return s;
    const r = this.getCellGui(i, t);
    return r || (i.isFullWidth() ? i.getFullWidthElement() : s);
  }
  destroy() {
    var e;
    (e = this.destroyLoadingSpinner) == null || e.call(this), super.destroy();
  }
}, xW = class extends _ {
  constructor(e, t, s, i) {
    super(
      /* html */
      `<div class="${yW}" role="presentation"></div>`
    ), this.menuItems = e, this.column = t, this.node = s, this.value = i, this.menuList = null, this.focusedCell = null;
  }
  postConstruct() {
    const e = this.createManagedBean(
      new ba(0, {
        column: this.column,
        node: this.node,
        value: this.value
      })
    ), t = this.beans.menuItemMapper.mapWithStockItems(
      this.menuItems,
      null,
      () => this.getGui(),
      "contextMenu"
    );
    e.addMenuItems(t), this.appendChild(e), this.menuList = e, e.addEventListener("closeMenu", (s) => this.dispatchLocalEvent(s));
  }
  afterGuiAttached(e) {
    e.hidePopup && this.addDestroyFunc(e.hidePopup), this.focusedCell = this.beans.focusSvc.getFocusedCell();
    const t = this.menuList;
    t && Dt(t.getGui());
  }
  restoreFocusedCell() {
    const { beans: e, focusedCell: t } = this, s = e.focusSvc, i = s.getFocusedCell();
    if (i && t && Jn(i, t)) {
      const { rowIndex: r, rowPinned: n, column: o } = t;
      Fr(e) && s.setFocusedCell({
        rowIndex: r,
        column: o,
        rowPinned: n,
        forceBrowserFocus: !0,
        preventScrollOnBrowserFocus: !gc()
      });
    }
  }
  destroy() {
    this.restoreFocusedCell(), super.destroy();
  }
};
function RW(e) {
  return (
    /* html */
    `<div class="ag-tabs ${e}">
        <div data-ref="eHeader"></div>
        <div data-ref="eBody" role="presentation" class="ag-tabs-body ${e ? `${e}-body` : ""}"></div>
    </div>`
  );
}
var kb = class extends Ti {
  constructor(e) {
    super(RW(e.cssClass)), this.eHeader = E, this.eBody = E, this.items = [], this.tabbedItemScrollMap = /* @__PURE__ */ new Map(), this.params = e;
  }
  postConstruct() {
    this.setupHeader(), this.params.items && this.params.items.forEach((e) => this.addItem(e)), this.initialiseTabGuard({
      onTabKeyDown: this.onTabKeyDown.bind(this),
      handleKeyDown: this.handleKeyDown.bind(this),
      focusInnerElement: this.focusInnerElement.bind(this),
      focusTrapActive: !0
    }), this.addDestroyFunc(() => {
      var e, t, s;
      return (s = (t = (e = this.activeItem) == null ? void 0 : e.tabbedItem) == null ? void 0 : t.afterDetachedCallback) == null ? void 0 : s.call(t);
    });
  }
  setupHeader() {
    const { enableCloseButton: e, cssClass: t } = this.params, s = (i, r) => {
      i.classList.add(`ag-tabs-${r}`), t && i.classList.add(`${t}-${r}`);
    };
    e ? (this.setupCloseButton(s), this.eTabHeader = We(this.beans).createElement("div"), s(this.eHeader, "header-wrapper"), nt(this.eHeader, "presentation"), this.eHeader.appendChild(this.eTabHeader)) : this.eTabHeader = this.eHeader, nt(this.eTabHeader, "tablist"), s(this.eTabHeader, "header");
  }
  setupCloseButton(e) {
    const t = We(this.beans), s = t.createElement("button");
    e(s, "close-button");
    const i = ue("close", this.beans);
    ot(s, this.params.closeButtonAriaLabel), s.appendChild(i), this.addManagedElementListeners(s, { click: () => {
      var n, o;
      return (o = (n = this.params).onCloseClicked) == null ? void 0 : o.call(n);
    } });
    const r = t.createElement("div");
    e(r, "close-button-wrapper"), nt(r, "presentation"), r.appendChild(s), this.eHeader.appendChild(r), this.eCloseButton = s;
  }
  handleKeyDown(e) {
    switch (e.key) {
      case P.RIGHT:
      case P.LEFT: {
        if (!this.eTabHeader.contains(Ie(this.beans)))
          return;
        const t = e.key === P.RIGHT, s = this.gos.get("enableRtl"), i = this.items.indexOf(this.activeItem), r = t !== s ? Math.min(i + 1, this.items.length - 1) : Math.max(i - 1, 0);
        if (i === r)
          return;
        e.preventDefault();
        const n = this.items[r];
        this.showItemWrapper(n), n.eHeaderButton.focus();
        break;
      }
      case P.UP:
      case P.DOWN:
        e.stopPropagation();
        break;
    }
  }
  onTabKeyDown(e) {
    var h, p, g, f;
    if (e.defaultPrevented)
      return;
    const { beans: t, eHeader: s, eBody: i, activeItem: r, params: n } = this, { suppressTrapFocus: o, enableCloseButton: a } = n, l = Ie(t), c = e.target, d = e.shiftKey;
    if (s.contains(l)) {
      e.preventDefault(), a && d && !((h = this.eCloseButton) != null && h.contains(l)) ? (p = this.eCloseButton) == null || p.focus() : o && d ? (g = Du(We(t).body, c)) == null || g.focus() : this.focusBody(e.shiftKey);
      return;
    }
    let u = null;
    if (gb(i, c) && (d && (u = Du(i, c)), !u && !o && (u = r.eHeaderButton)), !u && i.contains(l) && (u = zt(t, i, !1, d), !u)) {
      o && !d ? this.forceFocusOutOfContainer(d) : a && !d ? (e.preventDefault(), (f = this.eCloseButton) == null || f.focus()) : (e.preventDefault(), this.focusHeader());
      return;
    }
    u && (e.preventDefault(), u.focus());
  }
  focusInnerElement(e) {
    e ? this.focusBody(!0) : this.focusHeader();
  }
  focusHeader(e) {
    this.activeItem.eHeaderButton.focus({ preventScroll: e });
  }
  focusBody(e) {
    Dt(this.eBody, e);
  }
  setAfterAttachedParams(e) {
    this.afterAttachedParams = e;
  }
  showFirstItem() {
    this.items.length > 0 && this.showItemWrapper(this.items[0]);
  }
  addItem(e) {
    const t = document.createElement("span");
    nt(t, "tab"), t.setAttribute("tabindex", "-1"), t.appendChild(e.title), t.classList.add("ag-tab"), this.eTabHeader.appendChild(t), ot(t, e.titleLabel);
    const s = {
      tabbedItem: e,
      eHeaderButton: t
    };
    this.items.push(s), t.addEventListener("click", this.showItemWrapper.bind(this, s));
  }
  showItem(e) {
    const t = this.items.find((s) => s.tabbedItem === e);
    t && this.showItemWrapper(t);
  }
  showItemWrapper(e) {
    var i, r, n, o, a, l;
    const { tabbedItem: t, eHeaderButton: s } = e;
    if ((r = (i = this.params).onItemClicked) == null || r.call(i, { item: t }), this.activeItem === e) {
      (o = (n = this.params).onActiveItemClicked) == null || o.call(n);
      return;
    }
    this.lastScrollListener && (this.lastScrollListener = this.lastScrollListener()), ze(this.eBody), t.bodyPromise.then((c) => {
      this.eBody.appendChild(c);
      const d = !gc();
      if (this.params.suppressFocusBodyOnOpen || Dt(this.eBody, !1, d), t.afterAttachedCallback && t.afterAttachedCallback(this.afterAttachedParams), this.params.keepScrollPosition) {
        const u = t.getScrollableContainer && t.getScrollableContainer() || c;
        [this.lastScrollListener] = this.addManagedElementListeners(u, {
          scroll: () => {
            this.tabbedItemScrollMap.set(t.name, u.scrollTop);
          }
        });
        const h = this.tabbedItemScrollMap.get(t.name);
        h !== void 0 && setTimeout(() => {
          u.scrollTop = h;
        }, 0);
      }
    }), this.activeItem && (this.activeItem.eHeaderButton.classList.remove("ag-tab-selected"), (l = (a = this.activeItem.tabbedItem).afterDetachedCallback) == null || l.call(a)), s.classList.add("ag-tab-selected"), this.activeItem = e;
  }
}, pr = "filterMenuTab", gr = "generalMenuTab", Zr = "columnsMenuTab", hl = [gr, pr, Zr], FW = class extends L {
  constructor() {
    super(...arguments), this.beanName = "enterpriseMenuFactory";
  }
  hideActiveMenu() {
    this.destroyBean(this.activeMenu);
  }
  showMenuAfterMouseEvent(e, t, s, i) {
    const { column: r, columnGroup: n } = this.splitColumnOrGroup(e), o = i ? "filterMenuTab" : void 0;
    this.showMenu(
      r,
      n,
      (a) => {
        var c;
        const l = a.getGui();
        this.beans.popupSvc.positionPopupUnderMouseEvent({
          type: s,
          column: r,
          mouseEvent: t,
          ePopup: l
        }), o && ((c = a.showTab) == null || c.call(a, o)), this.dispatchVisibleChangedEvent(!0, !1, r, n, o);
      },
      s,
      o,
      void 0,
      t.target
    );
  }
  splitColumnOrGroup(e) {
    const t = e && Ri(e);
    return { column: t ? e : void 0, columnGroup: t ? void 0 : e };
  }
  showMenuAfterButtonClick(e, t, s, i) {
    let r = -1, n = "left";
    this.gos.get("enableRtl") && (r = 1, n = "right");
    const o = i ? "filterMenuTab" : void 0, a = o ? [o] : void 0, l = Mt(this.gos), c = (l ? 9 : 4) * r, d = l ? -23 : 4, { column: u, columnGroup: h } = this.splitColumnOrGroup(e);
    this.showMenu(
      u,
      h,
      (p) => {
        var f;
        const g = p.getGui();
        this.beans.popupSvc.positionPopupByComponent({
          type: s,
          column: u,
          eventSource: t,
          ePopup: g,
          alignSide: n,
          nudgeX: c,
          nudgeY: d,
          position: "under",
          keepWithinBounds: !0
        }), o && ((f = p.showTab) == null || f.call(p, o)), this.dispatchVisibleChangedEvent(!0, !1, u, h, o);
      },
      s,
      o,
      a,
      t
    );
  }
  showMenu(e, t, s, i, r, n, o) {
    var m;
    const a = this.getMenuParams(e, t, n, o);
    if (!a)
      return;
    const { menu: l, eMenuGui: c, anchorToElement: d, restoreFocusParams: u } = a, h = [], { menuUtils: p, popupSvc: g } = this.beans;
    h.push((C) => {
      const w = l.getGui();
      this.destroyBean(l), e && (Vl(e, !1, "contextMenu"), p.restoreFocusOnClose(u, w, C));
    });
    const f = this.getLocaleTextFunc();
    if (g.addPopup({
      modal: !0,
      eChild: c,
      closeOnEsc: !0,
      closedCallback: (C) => {
        h.forEach((w) => w(C)), this.dispatchVisibleChangedEvent(!1, !1, e, t, r);
      },
      afterGuiAttached: (C) => l.afterGuiAttached(Object.assign({}, { container: i }, C)),
      // if defaultTab is not present, positionCallback will be called
      // after `showTabBasedOnPreviousSelection` is called.
      positionCallback: r ? () => s(l) : void 0,
      ariaLabel: f("ariaLabelColumnMenu", "Column Menu")
    }), r || ((m = l.showTabBasedOnPreviousSelection) == null || m.call(l), s(l)), Rv(this.gos)) {
      const C = g.setPopupPositionRelatedToElement(c, d);
      C && e && this.addStopAnchoring(C, e, h);
    }
    l.addEventListener("tabSelected", (C) => {
      this.dispatchVisibleChangedEvent(!1, !0, e), this.lastSelectedTab = C.key, this.dispatchVisibleChangedEvent(!0, !0, e);
    }), e && Vl(e, !0, "contextMenu"), this.activeMenu = l, l.addEventListener("destroyed", () => {
      this.activeMenu === l && (this.activeMenu = null);
    });
  }
  addStopAnchoring(e, t, s) {
    e.then((i) => {
      t.addEventListener("leftChanged", i), t.addEventListener("visibleChanged", i), s.push(() => {
        t.removeEventListener("leftChanged", i), t.removeEventListener("visibleChanged", i);
      });
    });
  }
  getMenuParams(e, t, s, i) {
    const { focusSvc: r, visibleCols: n, ctrlsSvc: o } = this.beans, a = {
      column: e,
      headerPosition: r.focusedHeader,
      columnIndex: n.allCols.indexOf(e),
      eventSource: i
    }, l = this.createMenu(e, t, a, s, i);
    return l ? {
      menu: l,
      eMenuGui: l.getGui(),
      anchorToElement: i || o.getGridBodyCtrl().eGridBody,
      restoreFocusParams: a
    } : void 0;
  }
  createMenu(e, t, s, i, r) {
    if (Mt(this.gos))
      return this.createBean(
        new PW(e, s, this.lastSelectedTab, i, r)
      );
    {
      const n = this.beans.colMenuFactory.getMenuItems(e, t);
      return n.length ? this.createBean(new TW(n, e, s, r)) : void 0;
    }
  }
  dispatchVisibleChangedEvent(e, t, s, i, r) {
    this.eventSvc.dispatchEvent({
      type: "columnMenuVisibleChanged",
      visible: e,
      switchingTab: t,
      key: this.lastSelectedTab ?? r ?? (Mt(this.gos) ? gr : "columnMenu"),
      column: s ?? null,
      columnGroup: i ?? null
    });
  }
  isMenuEnabled(e) {
    var r;
    if (!Mt(this.gos))
      return !0;
    const t = !((r = this.beans.filterManager) != null && r.isFilterAllowed(e)), s = e.getColDef().menuTabs ?? hl;
    return (t && s.includes(pr) ? s.length - 1 : s.length) > 0;
  }
  showMenuAfterContextMenuEvent(e, t, s) {
    this.beans.menuUtils.onContextMenu(t, s, (i) => (this.showMenuAfterMouseEvent(e, i, "columnMenu"), !0));
  }
}, PW = class extends L {
  constructor(e, t, s, i, r) {
    super(), this.column = e, this.restoreFocusParams = t, this.initialSelection = s, this.restrictTo = i, this.sourceElement = r, this.tabFactories = {}, this.includeChecks = {};
    const { tabFactories: n, includeChecks: o } = this;
    n[gr] = this.createMainPanel.bind(this), n[pr] = this.createFilterPanel.bind(this), n[Zr] = this.createColumnsPanel.bind(this), o[gr] = () => !0, o[pr] = () => {
      var a;
      return e ? !!((a = this.beans.filterManager) != null && a.isFilterAllowed(e)) : !1;
    }, o[Zr] = () => !0;
  }
  postConstruct() {
    var s;
    const e = this.getTabsToCreate().map((i) => this.createTab(i)), t = new kb({
      items: e,
      cssClass: "ag-menu",
      onActiveItemClicked: this.onHidePopup.bind(this),
      onItemClicked: this.onTabItemClicked.bind(this)
    });
    this.tabbedLayout = this.createBean(t), (s = this.mainMenuList) == null || s.setParentComponent(t), this.addDestroyFunc(() => this.destroyBean(t));
  }
  getTabsToCreate() {
    var e;
    return this.restrictTo ? this.restrictTo : (((e = this.column) == null ? void 0 : e.getColDef().menuTabs) ?? hl).filter(
      (t) => this.isValidMenuTabItem(t) && this.isNotSuppressed(t)
    );
  }
  isValidMenuTabItem(e) {
    let t = !0, s = hl;
    return this.restrictTo != null && (t = this.restrictTo.indexOf(e) > -1, s = this.restrictTo), t = t && hl.indexOf(e) > -1, t || I(175, { menuTabName: e, itemsToConsider: s }), t;
  }
  isNotSuppressed(e) {
    return this.includeChecks[e]();
  }
  createTab(e) {
    return this.tabFactories[e]();
  }
  showTabBasedOnPreviousSelection() {
    this.showTab(this.initialSelection);
  }
  showTab(e) {
    const { tabItemColumns: t, tabbedLayout: s, tabItemFilter: i, tabItemGeneral: r } = this;
    t && e === Zr ? s.showItem(t) : i && e === pr ? s.showItem(i) : r && e === gr ? s.showItem(r) : s.showFirstItem();
  }
  onTabItemClicked(e) {
    let t = null;
    switch (e.item) {
      case this.tabItemColumns:
        t = Zr;
        break;
      case this.tabItemFilter:
        t = pr;
        break;
      case this.tabItemGeneral:
        t = gr;
        break;
    }
    t && this.activateTab(t);
  }
  activateTab(e) {
    const t = {
      type: "tabSelected",
      key: e
    };
    this.dispatchLocalEvent(t);
  }
  createMainPanel() {
    const { beans: e, column: t } = this, s = e.colMenuFactory, i = s.createMenu(
      this,
      s.getMenuItems(t),
      this.column,
      () => this.sourceElement ?? this.getGui()
    );
    this.mainMenuList = i, i.addEventListener("closeMenu", this.onHidePopup.bind(this));
    const r = {
      title: ue("legacyMenu", e, t),
      titleLabel: gr.replace("MenuTab", ""),
      bodyPromise: fe.resolve(i.getGui()),
      name: gr
    };
    return this.tabItemGeneral = r, r;
  }
  onHidePopup(e) {
    this.beans.menuUtils.closePopupAndRestoreFocusOnSelect(
      this.hidePopupFunc,
      this.restoreFocusParams,
      e
    );
  }
  createFilterPanel() {
    const e = this.column ? this.createBean(new fc(this.column, "COLUMN_MENU")) : null;
    this.filterComp = e, e != null && e.hasFilter() || be(119);
    const t = (i) => e == null ? void 0 : e.afterGuiAttached(i), s = () => e == null ? void 0 : e.afterGuiDetached();
    return this.tabItemFilter = {
      title: ue("filterTab", this.beans, this.column),
      titleLabel: pr.replace("MenuTab", ""),
      bodyPromise: fe.resolve(e == null ? void 0 : e.getGui()),
      afterAttachedCallback: t,
      afterDetachedCallback: s,
      name: pr
    }, this.tabItemFilter;
  }
  createColumnsPanel() {
    const e = document.createElement("div");
    e.classList.add("ag-menu-column-select-wrapper");
    const { beans: t, column: s } = this, r = t.colChooserFactory.createColumnSelectPanel(
      this,
      s
    ).getGui();
    r.classList.add("ag-menu-column-select"), e.appendChild(r);
    const n = {
      title: ue("columns", t, s),
      //createColumnsIcon(),
      titleLabel: Zr.replace("MenuTab", ""),
      bodyPromise: fe.resolve(e),
      name: Zr
    };
    return this.tabItemColumns = n, n;
  }
  afterGuiAttached(e) {
    const { container: t, hidePopup: s } = e;
    this.tabbedLayout.setAfterAttachedParams({ container: t, hidePopup: s }), s && (this.hidePopupFunc = s, this.addDestroyFunc(s));
  }
  getGui() {
    return this.tabbedLayout.getGui();
  }
  destroy() {
    super.destroy(), this.destroyBean(this.filterComp);
  }
}, TW = class extends _ {
  constructor(e, t, s, i) {
    super(
      /* html */
      `
            <div data-ref="eColumnMenu" role="presentation" class="ag-menu ag-column-menu"></div>
        `
    ), this.menuItems = e, this.column = t, this.restoreFocusParams = s, this.sourceElement = i, this.eColumnMenu = E;
  }
  postConstruct() {
    const e = this.beans.colMenuFactory.createMenu(
      this,
      this.menuItems,
      this.column,
      () => this.sourceElement ?? this.getGui()
    );
    this.mainMenuList = e, e.addEventListener("closeMenu", this.onHidePopup.bind(this)), this.eColumnMenu.appendChild(e.getGui());
  }
  onHidePopup(e) {
    this.beans.menuUtils.closePopupAndRestoreFocusOnSelect(
      this.hidePopupFunc,
      this.restoreFocusParams,
      e
    );
  }
  afterGuiAttached({ hidePopup: e }) {
    e && (this.hidePopupFunc = e, this.addDestroyFunc(e)), Dt(this.mainMenuList.getGui());
  }
};
function EW(e, t) {
  const { contextMenuSvc: s } = e;
  if (!s)
    return;
  const { rowNode: i, column: r, value: n, x: o, y: a } = t || {};
  let { x: l, y: c } = s.getContextMenuPosition(i, r);
  o != null && (l = o), a != null && (c = a), s.showContextMenu({
    mouseEvent: new MouseEvent("mousedown", { clientX: l, clientY: c }),
    rowNode: i,
    column: r,
    value: n
  });
}
function DW(e, t) {
  var s;
  (s = e.colChooserFactory) == null || s.showColumnChooser({ chooserParams: t });
}
function AW(e) {
  var t;
  (t = e.colChooserFactory) == null || t.hideActiveColumnChooser();
}
var MW = class extends L {
  constructor() {
    super(...arguments), this.beanName = "menuUtils";
  }
  restoreFocusOnClose(e, t, s, i) {
    const { eventSource: r } = e, n = s instanceof KeyboardEvent;
    if (!i && !n || !r)
      return;
    const o = Ie(this.beans);
    // focus is outside of comp
    !t.contains(o) && // something else has focus
    !Fr(this.beans) || this.focusHeaderCell(e);
  }
  closePopupAndRestoreFocusOnSelect(e, t, s) {
    let i;
    s && s.keyboardEvent && (i = s.keyboardEvent), e(i && { keyboardEvent: i });
    const r = this.beans, n = r.focusSvc, o = n.getFocusedCell();
    if (Fr(r))
      if (o) {
        const { rowIndex: a, rowPinned: l, column: c } = o;
        n.setFocusedCell({
          rowIndex: a,
          column: c,
          rowPinned: l,
          forceBrowserFocus: !0,
          preventScrollOnBrowserFocus: !0
        });
      } else
        this.focusHeaderCell(t);
  }
  onContextMenu(e, t, s) {
    if (!this.gos.get("allowContextMenuWithControlKey") && e && (e.ctrlKey || e.metaKey) || (e && this.blockMiddleClickScrollsIfNeeded(e), this.gos.get("suppressContextMenu")))
      return;
    const i = e ?? t.touches[0];
    if (s(i)) {
      const r = e ?? t;
      r && r.cancelable && r.preventDefault();
    }
  }
  // make this async for react
  async focusHeaderCell(e) {
    const { column: t, columnIndex: s, headerPosition: i, eventSource: r } = e, { visibleCols: n, headerNavigation: o, focusSvc: a } = this.beans, l = await n.allCols.some((c) => c === t);
    if (!(t && !t.isAlive())) {
      if (l && r && Xt(r)) {
        const c = vh(r);
        c && (t && (o == null || o.scrollToColumn(t)), c.focus());
      } else if (i && s !== -1) {
        const c = n.allCols, d = c[s] || pe(c);
        d && a.focusHeaderPosition({
          headerPosition: {
            headerRowIndex: i.headerRowIndex,
            column: d
          }
        });
      }
    }
  }
  blockMiddleClickScrollsIfNeeded(e) {
    this.gos.get("suppressMiddleClickScrolls") && e.which === 2 && e.preventDefault();
  }
}, Ob = {
  moduleName: "MenuCore",
  version: Me,
  beans: [CW, pW, MW],
  icons: {
    // context menu chart item
    chart: "chart",
    // columns in menu (column chooser / columns tab)
    columns: "columns",
    // loading async menu items
    loadingMenuItems: "loading",
    // "Pin column" item in column header menu
    menuPin: "pin",
    // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
    menuValue: "aggregation",
    // "Group by {column-name}" item in column header menu
    menuAddRowGroup: "group",
    // "Un-Group by {column-name}" item in column header menu
    menuRemoveRowGroup: "group",
    // context menu copy item
    clipboardCopy: "copy",
    // context menu cut item
    clipboardCut: "cut",
    // context menu paste item
    clipboardPaste: "paste",
    // context menu export item
    save: "save",
    // csv export
    csvExport: "csv",
    // excel export,
    excelExport: "excel",
    // show on column header when column is sorted ascending
    sortAscending: "asc",
    // show on column header when column is sorted descending
    sortDescending: "desc",
    // show on column header when column has no sort, only when enabled with colDef.unSortIcon=true
    sortUnSort: "none"
  },
  dependsOn: [Je, Yi, Sy, Dc]
}, IW = {
  moduleName: "ColumnMenu",
  version: Me,
  beans: [FW, wW, mW],
  icons: {
    // menu tab icon in legacy tabbed enterprise column menu
    legacyMenu: "menu",
    // filter tab icon in legacy tabbed enterprise column menu
    filterTab: "filter",
    // column tool panel column group contracted (click to expand)
    columnSelectClosed: "tree-closed",
    // column tool panel column group expanded (click to contract)
    columnSelectOpen: "tree-open",
    // column tool panel header expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    columnSelectIndeterminate: "tree-indeterminate"
  },
  apiFunctions: {
    showColumnChooser: DW,
    hideColumnChooser: AW
  },
  dependsOn: [Ob, ao, Oh]
}, LW = {
  moduleName: "ContextMenu",
  version: Me,
  beans: [SW],
  apiFunctions: {
    showContextMenu: EW
  },
  dependsOn: [Ob]
}, Wf = class extends Lr {
  constructor() {
    super(
      /* html */
      '<div class="ag-cell-edit-wrapper"></div>'
    );
  }
  init(e) {
    this.params = e;
    const { cellStartedEdit: t, values: s } = e;
    ke(s) && I(180);
    const { params: i, valuesPromise: r } = this.buildRichSelectParams(), n = this.createManagedBean(new Yh(i));
    this.richSelect = n, n.addCssClass("ag-cell-editor"), this.appendChild(n), r && r.then((o) => {
      n.setValueList({ valueList: o, refresh: !0 });
      const a = this.getSearchStringCallback(o);
      a && n.setSearchStringCreator(a);
    }), this.addManagedListeners(n, {
      fieldPickerValueSelected: this.onEditorPickerValueSelected.bind(this)
    }), this.focusAfterAttached = t;
  }
  onEditorPickerValueSelected(e) {
    setTimeout(() => this.params.stopEditing(!e.fromEnterKey));
  }
  buildRichSelectParams() {
    const e = this.params, {
      cellRenderer: t,
      cellHeight: s,
      value: i,
      values: r,
      formatValue: n,
      searchDebounceDelay: o,
      valueListGap: a,
      valueListMaxHeight: l,
      valueListMaxWidth: c,
      allowTyping: d,
      filterList: u,
      searchType: h,
      highlightMatch: p,
      valuePlaceholder: g,
      eventKey: f,
      multiSelect: m,
      suppressDeselectAll: C,
      suppressMultiSelectPillRenderer: w
    } = e, y = {
      value: i,
      cellRenderer: t,
      cellRowHeight: s,
      searchDebounceDelay: o,
      valueFormatter: n,
      pickerAriaLabelKey: "ariaLabelRichSelectField",
      pickerAriaLabelValue: "Rich Select Field",
      pickerType: "virtual-list",
      pickerGap: a,
      allowTyping: d,
      filterList: u,
      searchType: h,
      highlightMatch: p,
      maxPickerHeight: l,
      maxPickerWidth: c,
      placeholder: g,
      initialInputValue: (f == null ? void 0 : f.length) === 1 ? f : void 0,
      multiSelect: m,
      suppressDeselectAll: C,
      suppressMultiSelectPillRenderer: w
    };
    let b, x;
    return typeof r == "function" ? b = r(e) : b = r ?? [], Array.isArray(b) ? (y.valueList = b, y.searchStringCreator = this.getSearchStringCallback(b)) : x = b, m && d && (e.allowTyping = y.allowTyping = !1, I(181)), { params: y, valuesPromise: x };
  }
  getSearchStringCallback(e) {
    const t = this.params, { colDef: s } = t;
    if (typeof e[0] != "object" || !s.keyCreator)
      return;
    const { column: i, node: r, data: n } = t;
    return (o) => o.map((a) => {
      const l = this.gos.addGridCommonParams({
        value: a,
        colDef: s,
        column: i,
        node: r,
        data: n
      });
      return s.keyCreator(l);
    });
  }
  // we need to have the gui attached before we can draw the virtual rows, as the
  // virtual row logic needs info about the gui state
  afterGuiAttached() {
    const { focusAfterAttached: e, params: t } = this;
    setTimeout(() => {
      if (!this.isAlive())
        return;
      const s = this.richSelect;
      if (e) {
        const r = s.getFocusableElement();
        r.focus();
        const { allowTyping: n, eventKey: o } = this.params;
        n && (!o || o.length !== 1) && r.select();
      }
      s.showPicker();
      const { eventKey: i } = t;
      i && (i == null ? void 0 : i.length) === 1 && s.searchTextFromString(i);
    });
  }
  focusIn() {
    this.richSelect.getFocusableElement().focus();
  }
  getValue() {
    return this.richSelect.getValue();
  }
  isPopup() {
    return !1;
  }
}, kW = {
  moduleName: "RichSelect",
  version: Me,
  beans: [],
  userComponents: { agRichSelect: Wf, agRichSelectCellEditor: Wf },
  icons: {
    // open icon for rich select editor
    richSelectOpen: "small-down",
    // remove for rich select editor pills
    richSelectRemove: "cancel"
  },
  dependsOn: [Je, Xi]
}, rn = "__AG_SELECT_ALL__", nn = "__AG_ADD_SELECTION_TO_FILTER__", OW = {
  loadingOoo: "Loading...",
  blanks: "(Blanks)",
  searchOoo: "Search...",
  selectAll: "(Select All)",
  selectAllSearchResults: "(Select All Search Results)",
  addCurrentSelectionToFilter: "Add current selection to filter",
  noMatches: "No matches."
}, GW = class extends _ {
  constructor(e) {
    super(
      e.isGroup ? (
        /* html */
        `
            <div class="ag-set-filter-item" aria-hidden="true">
                <span class="ag-set-filter-group-icons">
                    <span class="ag-set-filter-group-closed-icon" data-ref="eGroupClosedIcon"></span>
                    <span class="ag-set-filter-group-opened-icon" data-ref="eGroupOpenedIcon"></span>
                    <span class="ag-set-filter-group-indeterminate-icon" data-ref="eGroupIndeterminateIcon"></span>
                </span>
                <ag-checkbox data-ref="eCheckbox" class="ag-set-filter-item-checkbox"></ag-checkbox>
            </div>`
      ) : (
        /* html */
        `
            <div class="ag-set-filter-item">
                <ag-checkbox data-ref="eCheckbox" class="ag-set-filter-item-checkbox"></ag-checkbox>
            </div>`
      ),
      [ai]
    ), this.eCheckbox = E, this.eGroupOpenedIcon = E, this.eGroupClosedIcon = E, this.eGroupIndeterminateIcon = E, this.formattedValue = null, this.focusWrapper = e.focusWrapper, this.value = e.value, this.params = e.params, this.translate = e.translate, this.valueFormatter = e.valueFormatter, this.item = e.item, this.isSelected = e.isSelected, this.isTree = e.isTree, this.depth = e.depth ?? 0, this.isGroup = e.isGroup, this.groupsExist = e.groupsExist, this.isExpanded = e.isExpanded, this.hasIndeterminateExpandState = e.hasIndeterminateExpandState;
  }
  postConstruct() {
    this.tooltipFeature = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        getColDef: () => this.params.colDef,
        getColumn: () => this.params.column,
        getLocation: () => "setFilterValue",
        shouldDisplayTooltip: () => {
          var e;
          return ((e = this.shouldDisplayTooltip) == null ? void 0 : e.call(this)) ?? !0;
        },
        getValueFormatted: () => this.formattedValue,
        getAdditionalParams: () => this.isTree ? { level: this.depth } : {}
      })
    ), this.addDestroyFunc(() => {
      var e;
      return (e = this.destroyCellRendererComponent) == null ? void 0 : e.call(this);
    }), this.render(), this.eCheckbox.setLabelEllipsis(!0).setValue(this.isSelected, !0).setDisabled(!!this.params.readOnly).getInputElement().setAttribute("tabindex", "-1"), this.refreshVariableAriaLabels(), this.isTree && (this.depth > 0 && (this.addCssClass("ag-set-filter-indent-" + this.depth), this.getGui().style.setProperty("--ag-indentation-level", String(this.depth))), this.isGroup ? this.setupExpansion() : this.groupsExist && this.addCssClass("ag-set-filter-add-group-indent"), ha(this.getAriaElement(), this.depth + 1)), this.refreshAriaChecked(), !this.params.readOnly && this.eCheckbox.onValueChange((e) => this.onCheckboxChanged(!!e));
  }
  getFocusableElement() {
    return this.focusWrapper;
  }
  setupExpansion() {
    const { eGroupClosedIcon: e, eGroupOpenedIcon: t, eGroupIndeterminateIcon: s, hasIndeterminateExpandState: i, beans: r } = this;
    e.appendChild(br("setFilterGroupClosed", r, null)), t.appendChild(br("setFilterGroupOpen", r, null));
    const n = this.onExpandOrContractClicked.bind(this);
    this.addManagedElementListeners(e, { click: n }), this.addManagedElementListeners(t, { click: n }), i && (s.appendChild(br("setFilterGroupIndeterminate", r, null)), this.addManagedElementListeners(s, {
      click: n
    })), this.setExpandedIcons(), this.refreshAriaExpanded();
  }
  onExpandOrContractClicked() {
    this.setExpanded(!this.isExpanded);
  }
  setExpanded(e, t) {
    if (this.isGroup && e !== this.isExpanded) {
      this.isExpanded = e;
      const s = {
        type: "expandedChanged",
        isExpanded: !!e,
        item: this.item
      };
      t || this.dispatchLocalEvent(s), this.setExpandedIcons(), this.refreshAriaExpanded();
    }
  }
  setExpandedIcons() {
    const { isExpanded: e, hasIndeterminateExpandState: t, eGroupClosedIcon: s, eGroupOpenedIcon: i, eGroupIndeterminateIcon: r } = this;
    re(s, t ? e === !1 : !e), re(i, e === !0), t && re(r, e === void 0);
  }
  onCheckboxChanged(e) {
    this.isSelected = e;
    const t = {
      type: "selectionChanged",
      isSelected: e,
      item: this.item
    };
    this.dispatchLocalEvent(t), this.refreshVariableAriaLabels(), this.refreshAriaChecked();
  }
  toggleSelected() {
    this.params.readOnly || this.setSelected(!this.isSelected);
  }
  setSelected(e, t) {
    this.isSelected = e, this.eCheckbox.setValue(e, t), this.refreshAriaChecked();
  }
  refreshVariableAriaLabels() {
    if (!this.isTree)
      return;
    const e = this.getLocaleTextFunc(), t = this.eCheckbox.getValue(), s = t === void 0 ? e("ariaIndeterminate", "indeterminate") : t ? e("ariaVisible", "visible") : e("ariaHidden", "hidden"), i = e("ariaToggleVisibility", "Press SPACE to toggle visibility");
    xr(this.eCheckbox.getInputElement(), void 0), this.eCheckbox.setInputAriaLabel(`${i} (${s})`);
  }
  setupFixedAriaLabels(e) {
    if (!this.isTree)
      return;
    const s = this.getLocaleTextFunc()("ariaFilterValue", "Filter Value"), i = this.getAriaElement();
    ot(i, `${e} ${s}`), sc(i, this.eCheckbox.getInputElement().id);
  }
  refreshAriaChecked() {
    const e = this.getAriaElement();
    XC(e, this.eCheckbox.getValue());
  }
  refreshAriaExpanded() {
    ns(this.getAriaElement(), !!this.isExpanded);
  }
  refresh(e, t, s) {
    var a;
    this.item = e, t !== this.isSelected && this.setSelected(t, !0), this.setExpanded(s, !0);
    const { cellRendererComponent: i, cellRendererParams: r, beans: n, params: o } = this;
    if (this.valueFunction) {
      const l = this.valueFunction();
      this.setTooltipAndCellRendererParams(l, l), i || this.renderCellWithoutCellRenderer();
    }
    if (i) {
      const l = Ml(
        n.userCompFactory,
        o,
        r
      );
      if (!((a = i.refresh) == null ? void 0 : a.call(i, (l == null ? void 0 : l.params) ?? r))) {
        const d = i;
        this.renderCell(), this.destroyBean(d);
      }
    }
  }
  render() {
    const {
      params: { column: e }
    } = this;
    let { value: t } = this, s = null;
    typeof t == "function" ? (this.valueFunction = t, s = this.valueFunction(), t = s) : this.isTree ? s = Cs(t) : s = this.getFormattedValue(e, t), this.formattedValue = s, this.setTooltipAndCellRendererParams(t, s), this.renderCell();
  }
  setTooltipAndCellRendererParams(e, t) {
    var i;
    const s = this.gos;
    if (this.params.showTooltips && (!Xo(s) || !this.params.cellRenderer)) {
      const r = t ?? Cs(e);
      this.shouldDisplayTooltip = yc(
        s,
        () => this.eCheckbox.getGui().querySelector(".ag-label")
      ), (i = this.tooltipFeature) == null || i.setTooltipAndRefresh(r);
    }
    this.cellRendererParams = s.addGridCommonParams({
      value: e,
      valueFormatted: t,
      colDef: this.params.colDef,
      column: this.params.column,
      setTooltip: (r, n) => {
        var o;
        s.assertModuleRegistered("Tooltip", 3), this.shouldDisplayTooltip = n, (o = this.tooltipFeature) == null || o.setTooltipAndRefresh(r);
      }
    });
  }
  getFormattedValue(e, t) {
    return this.beans.valueSvc.formatValue(e, null, t, this.valueFormatter, !1);
  }
  renderCell() {
    const e = Ml(
      this.beans.userCompFactory,
      this.params,
      this.cellRendererParams
    ), t = e == null ? void 0 : e.newAgStackInstance();
    if (t == null) {
      this.renderCellWithoutCellRenderer();
      return;
    }
    t.then((s) => {
      s && (this.cellRendererComponent = s, this.eCheckbox.setLabel(s.getGui()), this.destroyCellRendererComponent = () => this.destroyBean(s));
    });
  }
  renderCellWithoutCellRenderer() {
    const { valueFormatted: e, value: t } = this.cellRendererParams;
    let s = e ?? t ?? this.translate("blanks");
    typeof s != "string" && (I(208), s = ""), this.eCheckbox.setLabel(s), this.setupFixedAriaLabels(s);
  }
  getComponentHolder() {
    return this.params.column.getColDef();
  }
}, Gb = class {
  getModelAsString(e, t) {
    const { values: s } = e || t.getModel() || {}, i = t.getValueModel();
    if (s == null || i == null)
      return "";
    const r = s.filter((a) => i.isKeyAvailable(a)), n = r.length, o = r.slice(0, 10).map((a) => t.getFormattedValue(a));
    return `(${n}) ${o.join(",")}${n > 10 ? ",..." : ""}`;
  }
};
function Iu(e, t, s) {
  let i = e;
  return i ? (i = i.map((r) => Cs(St(r))), !t && s && i.some((r) => r == null) ? pe(i) == null ? null : i.filter((r) => r != null) : i) : null;
}
var BW = class {
  constructor(e, t, s, i, r, n, o, a, l, c) {
    this.rowModel = e, this.filterParams = t, this.createKey = s, this.caseFormat = i, this.valueSvc = r, this.treeDataOrGrouping = n, this.treeData = o, this.groupAllowUnbalanced = a, this.addManagedEventListeners = l, this.rowGroupColsSvc = c;
  }
  extractUniqueValuesAsync(e, t) {
    return new fe((s) => {
      if (this.rowModel.isRowDataLoaded())
        s(this.extractUniqueValues(e, t));
      else {
        const [i] = this.addManagedEventListeners({
          rowCountReady: () => {
            i == null || i(), s(this.extractUniqueValues(e, t));
          }
        });
      }
    });
  }
  extractUniqueValues(e, t) {
    var l;
    const s = /* @__PURE__ */ new Map(), i = this.extractExistingFormattedKeys(t), r = /* @__PURE__ */ new Set(), n = this.treeData, o = (l = this.rowGroupColsSvc) == null ? void 0 : l.columns, a = (c, d) => {
      const u = this.caseFormat(c);
      if (!r.has(u)) {
        r.add(u);
        let h = c, p = St(d);
        const g = i == null ? void 0 : i.get(u);
        g != null && (h = g, p = t.get(g)), s.set(h, p);
      }
    };
    return this.rowModel.forEachLeafNode((c) => {
      if (!c.data || !e(c))
        return;
      if (this.treeDataOrGrouping) {
        this.addValueForTreeDataOrGrouping(c, n, o, a);
        return;
      }
      const d = this.getValue(c);
      d != null && Array.isArray(d) ? (d.forEach((u) => {
        a(this.createKey(u, c), u);
      }), d.length === 0 && a(null, null)) : a(this.createKey(d, c), d);
    }), s;
  }
  addValueForTreeDataOrGrouping(e, t, s = [], i) {
    var o;
    let r;
    if (t) {
      if ((o = e.childrenAfterGroup) != null && o.length)
        return;
      r = e.getRoute() ?? [e.key ?? e.id];
    } else
      r = s.map((a) => this.valueSvc.getKeyForNode(a, e)), r.push(this.getValue(e));
    const n = Iu(r, t, this.groupAllowUnbalanced);
    i(this.createKey(n), n);
  }
  getValue(e) {
    return this.filterParams.getValue(e);
  }
  extractExistingFormattedKeys(e) {
    if (!e)
      return null;
    const t = /* @__PURE__ */ new Map();
    return e.forEach((s, i) => {
      t.set(this.caseFormat(i), i);
    }), t;
  }
}, VW = class {
  constructor({ caseFormat: e }) {
    this.filteringKeys = null, this.filteringKeysCaseFormatted = null, this.hasNoAppliedFilteringKeys = !1, this.caseFormat = e;
  }
  allFilteringKeys() {
    return this.filteringKeys;
  }
  allFilteringKeysCaseFormatted() {
    return this.filteringKeysCaseFormatted;
  }
  setFilteringKeys(e) {
    this.filteringKeys = new Set(e), this.hasNoAppliedFilteringKeys = !this.filteringKeys || this.filteringKeys.size === 0, this.filteringKeysCaseFormatted = /* @__PURE__ */ new Set(), this.filteringKeys.forEach((t) => this.filteringKeysCaseFormatted.add(this.caseFormat(t)));
  }
  addFilteringKey(e) {
    this.filteringKeys == null && (this.filteringKeys = /* @__PURE__ */ new Set(), this.filteringKeysCaseFormatted = /* @__PURE__ */ new Set()), this.filteringKeys.add(e), this.filteringKeysCaseFormatted.add(this.caseFormat(e)), this.hasNoAppliedFilteringKeys && (this.hasNoAppliedFilteringKeys = !1);
  }
  hasCaseFormattedFilteringKey(e) {
    return this.filteringKeysCaseFormatted.has(this.caseFormat(e));
  }
  hasFilteringKey(e) {
    return this.filteringKeys.has(e);
  }
  reset() {
    this.filteringKeys = null, this.filteringKeysCaseFormatted = null, this.hasNoAppliedFilteringKeys = !1;
  }
}, NW = class {
  constructor(e, t, s, i) {
    this.valueSvc = e, this.valueFormatter = t, this.formatter = s, this.column = i, this.displayedKeys = [];
  }
  updateDisplayedValuesToAllAvailable(e, t, s) {
    this.displayedKeys = Array.from(s);
  }
  updateDisplayedValuesToMatchMiniFilter(e, t, s, i, r) {
    this.displayedKeys = [];
    for (const n of s)
      if (n == null)
        r && this.displayedKeys.push(n);
      else {
        const o = e(n), a = this.valueSvc.formatValue(
          this.column,
          null,
          o,
          this.valueFormatter,
          !1
        ), l = this.formatter(a);
        i(l) && this.displayedKeys.push(n);
      }
  }
  getDisplayedValueCount() {
    return this.displayedKeys.length;
  }
  getDisplayedItem(e) {
    return this.displayedKeys[e];
  }
  getSelectAllItem() {
    return rn;
  }
  getAddSelectionToFilterItem() {
    return nn;
  }
  getDisplayedKeys() {
    return this.displayedKeys;
  }
  forEachDisplayedKey(e) {
    this.displayedKeys.forEach(e);
  }
  someDisplayedKey(e) {
    return this.displayedKeys.some(e);
  }
  hasGroups() {
    return !1;
  }
  refresh() {
  }
}, HW = (e) => e ? [String(e.getFullYear()), String(e.getMonth() + 1), String(e.getDate())] : null, _f = class {
  constructor(e, t, s, i) {
    this.formatter = e, this.treeListPathGetter = t, this.treeListFormatter = s, this.treeDataOrGrouping = i, this.allDisplayedItemsTree = [], this.activeDisplayedItemsFlat = [], this.selectAllItem = {
      depth: 0,
      filterPasses: !0,
      available: !0,
      treeKey: rn,
      children: this.allDisplayedItemsTree,
      expanded: !0,
      key: rn,
      parentTreeKeys: []
    }, this.addSelectionToFilterItem = {
      depth: 0,
      filterPasses: !0,
      available: !0,
      treeKey: nn,
      expanded: !0,
      key: nn,
      parentTreeKeys: []
    };
  }
  updateOnParamsChange(e) {
    this.treeListFormatter = e;
  }
  updateDisplayedValuesToAllAvailable(e, t, s, i) {
    i === "reload" ? this.generateItemTree(e, t, s) : i === "otherFilter" ? (this.updateAvailable(s), this.updateExpandAll()) : i === "miniFilter" && (this.resetFilter(), this.updateExpandAll()), this.flattenItems();
  }
  updateDisplayedValuesToMatchMiniFilter(e, t, s, i, r, n) {
    n === "reload" ? this.generateItemTree(e, t, s) : n === "otherFilter" && this.updateAvailable(s), this.updateFilter(i, r), this.updateExpandAll(), this.flattenItems();
  }
  generateItemTree(e, t, s) {
    this.allDisplayedItemsTree = [], this.groupsExist = !1;
    const i = this.getTreeListPathGetter(e, s);
    for (const r of t) {
      const n = e(r), o = i(n) ?? [null];
      o.length > 1 && (this.groupsExist = !0);
      const a = s.has(r);
      let l = this.allDisplayedItemsTree, c, d = [];
      o.forEach((u, h) => {
        l || (l = [], c.children = l), c = l.find((p) => {
          var g;
          return ((g = p.treeKey) == null ? void 0 : g.toUpperCase()) === (u == null ? void 0 : u.toUpperCase());
        }), c || (c = { treeKey: u, depth: h, filterPasses: !0, expanded: !1, available: a, parentTreeKeys: d }, h === o.length - 1 && (c.key = r), l.push(c)), l = c.children, d = [...d, u];
      });
    }
    this.updateAvailable(s), this.selectAllItem.children = this.allDisplayedItemsTree, this.selectAllItem.expanded = !1;
  }
  getTreeListPathGetter(e, t) {
    if (this.treeListPathGetter)
      return this.treeListPathGetter;
    if (this.treeDataOrGrouping)
      return (i) => i;
    let s = !1;
    for (const i of t) {
      const r = e(i);
      if (r instanceof Date) {
        s = !0;
        break;
      } else if (r != null)
        break;
    }
    return s ? HW : (I(211), (i) => [String(i)]);
  }
  flattenItems() {
    this.activeDisplayedItemsFlat = [];
    const e = (t) => {
      t.forEach((s) => {
        !s.filterPasses || !s.available || (this.activeDisplayedItemsFlat.push(s), s.children && s.expanded && e(s.children));
      });
    };
    e(this.allDisplayedItemsTree);
  }
  resetFilter() {
    const e = (t) => {
      t.children && t.children.forEach((s) => {
        e(s);
      }), t.filterPasses = !0;
    };
    this.allDisplayedItemsTree.forEach((t) => e(t));
  }
  updateFilter(e, t) {
    const s = (i) => i.available ? i.treeKey == null ? t : e(
      this.formatter(
        this.treeListFormatter ? this.treeListFormatter(i.treeKey, i.depth, i.parentTreeKeys) : i.treeKey
      )
    ) : !1;
    this.allDisplayedItemsTree.forEach(
      (i) => this.recursiveItemCheck(i, !1, s, "filterPasses")
    );
  }
  getDisplayedValueCount() {
    return this.activeDisplayedItemsFlat.length;
  }
  getDisplayedItem(e) {
    return this.activeDisplayedItemsFlat[e];
  }
  getSelectAllItem() {
    return this.selectAllItem;
  }
  getAddSelectionToFilterItem() {
    return this.addSelectionToFilterItem;
  }
  getDisplayedKeys() {
    const e = [];
    return this.forEachDisplayedKey((t) => e.push(t)), e;
  }
  forEachDisplayedKey(e) {
    const t = (s, i) => {
      s.children ? (!s.expanded || !i) && s.children.forEach((r) => {
        r.filterPasses && t(r, !1);
      }) : e(s.key);
    };
    this.activeDisplayedItemsFlat.forEach((s) => t(s, !0));
  }
  someDisplayedKey(e) {
    const t = (s, i) => {
      if (s.children) {
        if (!s.expanded || !i)
          return s.children.some((r) => r.filterPasses ? t(r, !1) : !1);
      } else
        return e(s.key);
      return !1;
    };
    return this.activeDisplayedItemsFlat.some((s) => t(s, !0));
  }
  hasGroups() {
    return this.groupsExist;
  }
  refresh() {
    this.updateExpandAll(), this.flattenItems();
  }
  updateExpandAll() {
    const e = (s, i, r) => {
      for (const n of s) {
        if (!n.filterPasses || !n.available || !n.children)
          continue;
        if (i = i || !!n.expanded, r = r || !n.expanded, i && r)
          return;
        const o = e(n.children, i, r);
        if (o === void 0)
          return;
        o ? i = !0 : r = !0;
      }
      return i && r ? void 0 : i;
    }, t = this.getSelectAllItem();
    t.expanded = e(t.children, !1, !1);
  }
  recursiveItemCheck(e, t, s, i) {
    let r = !1;
    e.children && e.children.forEach((o) => {
      const a = this.recursiveItemCheck(
        o,
        t || s(e),
        s,
        i
      );
      r = r || a;
    });
    const n = t || r || s(e);
    return e[i] = n, n;
  }
  updateAvailable(e) {
    const t = (s) => e.has(s.key);
    this.allDisplayedItemsTree.forEach((s) => this.recursiveItemCheck(s, !1, t, "available"));
  }
}, zW = class {
  constructor(e) {
    this.localEventService = new Mr(), this.miniFilterText = null, this.addCurrentSelectionToFilter = !1, this.providedValues = null, this.allValues = /* @__PURE__ */ new Map(), this.availableKeys = /* @__PURE__ */ new Set(), this.selectedKeys = /* @__PURE__ */ new Set(), this.initialised = !1;
    const {
      usingComplexObjects: t,
      rowGroupColsSvc: s,
      valueSvc: i,
      treeDataTreeList: r,
      groupingTreeList: n,
      filterParams: o,
      gos: a,
      valueFormatter: l,
      addManagedEventListeners: c
    } = e, {
      column: d,
      colDef: u,
      textFormatter: h,
      doesRowPassOtherFilter: p,
      suppressSorting: g,
      comparator: f,
      rowModel: m,
      values: C,
      caseSensitive: w,
      treeList: y,
      treeListPathGetter: b,
      treeListFormatter: x
    } = o;
    this.filterParams = o, this.gos = a, this.setIsLoading = e.setIsLoading, this.translate = e.translate, this.caseFormat = e.caseFormat, this.createKey = e.createKey, this.usingComplexObjects = !!e.usingComplexObjects, this.formatter = h ?? ((k) => k ?? null), this.doesRowPassOtherFilters = p, this.suppressSorting = g || !1, this.filteringKeys = new VW({ caseFormat: this.caseFormat });
    const M = f ?? u.comparator, T = !!r || !!n;
    this.compareByValue = !!(t && M || T || y && !b), T && !M ? this.entryComparator = this.createTreeDataOrGroupingComparator() : y && !b && !M ? this.entryComparator = ([k, O], [D, $]) => nl(O, $) : this.entryComparator = ([k, O], [D, $]) => M(O, $), this.keyComparator = M ?? nl, this.caseSensitive = !!w;
    const F = a.get("groupAllowUnbalanced");
    Ye(a) && (this.clientSideValuesExtractor = new BW(
      m,
      this.filterParams,
      this.createKey,
      this.caseFormat,
      i,
      T,
      !!r,
      F,
      c,
      s
    )), C == null ? this.valuesType = 2 : (this.valuesType = Array.isArray(C) ? 0 : 1, this.providedValues = C), this.displayValueModel = y ? new _f(
      this.formatter,
      b,
      x,
      r || n
    ) : new NW(i, l, this.formatter, d), this.updateAllValues().then((k) => this.resetSelectionState(k || []));
  }
  addEventListener(e, t, s) {
    this.localEventService.addEventListener(e, t, s);
  }
  removeEventListener(e, t, s) {
    this.localEventService.removeEventListener(e, t, s);
  }
  updateOnParamsChange(e) {
    return new fe((t) => {
      const { values: s, textFormatter: i, suppressSorting: r, treeListFormatter: n } = e, o = this.providedValues, a = this.suppressSorting;
      if (this.filterParams = e, this.formatter = i ?? ((l) => l ?? null), this.suppressSorting = r || !1, this.providedValues = s ?? null, this.displayValueModel instanceof _f && this.displayValueModel.updateOnParamsChange(n), this.providedValues !== o || this.suppressSorting !== a) {
        !s || s.length === 0 ? (this.valuesType = 2, this.providedValues = null) : this.valuesType = Array.isArray(s) ? 0 : 1;
        const l = this.getModel();
        this.updateAllValues().then(() => {
          this.setModel(l).then(() => t());
        });
      } else
        t();
    });
  }
  /**
   * Re-fetches the values used in the filter from the value source.
   * If keepSelection is false, the filter selection will be reset to everything selected,
   * otherwise the current selection will be preserved.
   */
  refreshValues() {
    return new fe((e) => {
      this.allValuesPromise.then(() => {
        const t = this.getModel();
        this.updateAllValues(), this.setModel(t).then(() => e());
      });
    });
  }
  /**
   * Overrides the current values being used for the set filter.
   * If keepSelection is false, the filter selection will be reset to everything selected,
   * otherwise the current selection will be preserved.
   */
  overrideValues(e) {
    return new fe((t) => {
      this.allValuesPromise.then(() => {
        this.valuesType = 0, this.providedValues = e, this.refreshValues().then(() => t());
      });
    });
  }
  /** @return has anything been updated */
  refreshAfterAnyFilterChanged() {
    return this.showAvailableOnly() ? this.allValuesPromise.then((e) => (this.updateAvailableKeys(e ?? [], "otherFilter"), !0)) : fe.resolve(!1);
  }
  isInitialised() {
    return this.initialised;
  }
  updateAllValues() {
    return this.allValuesPromise = new fe((e) => {
      switch (this.valuesType) {
        case 2:
          this.getValuesFromRowsAsync(!1).then((t) => e(this.processAllValues(t)));
          break;
        case 0: {
          e(
            this.processAllValues(
              this.uniqueValues(this.validateProvidedValues(this.providedValues))
            )
          );
          break;
        }
        case 1: {
          this.setIsLoading(!0);
          const t = this.providedValues, { column: s, colDef: i } = this.filterParams, r = this.gos.addGridCommonParams({
            success: (n) => {
              this.setIsLoading(!1), e(this.processAllValues(this.uniqueValues(this.validateProvidedValues(n))));
            },
            colDef: i,
            column: s
          });
          window.setTimeout(() => t(r), 0);
          break;
        }
      }
    }), this.allValuesPromise.then((e) => this.updateAvailableKeys(e || [], "reload")).then(() => this.initialised = !0), this.allValuesPromise;
  }
  processAllValues(e) {
    const t = this.sortKeys(e);
    return this.allValues = e ?? /* @__PURE__ */ new Map(), t;
  }
  validateProvidedValues(e) {
    if (this.usingComplexObjects && (e != null && e.length)) {
      const t = e[0];
      t && typeof t != "object" && typeof t != "function" && (this.createKey(t) == null ? I(209) : I(210));
    }
    return e;
  }
  setValuesType(e) {
    this.valuesType = e;
  }
  getValuesType() {
    return this.valuesType;
  }
  isKeyAvailable(e) {
    return this.availableKeys.has(e);
  }
  showAvailableOnly() {
    return this.valuesType === 2;
  }
  updateAvailableKeys(e, t) {
    const s = this.showAvailableOnly() ? this.sortKeys(this.getValuesFromRows(!0)) : e;
    this.availableKeys = new Set(s), this.localEventService.dispatchEvent({ type: "availableValuesChanged" }), this.updateDisplayedValues(t, e);
  }
  sortKeys(e) {
    const t = e ?? /* @__PURE__ */ new Map();
    if (this.suppressSorting)
      return Array.from(t.keys());
    let s;
    return this.compareByValue ? s = Array.from(t.entries()).sort(this.entryComparator).map(([i]) => i) : s = Array.from(t.keys()).sort(this.keyComparator), this.filterParams.excelMode && t.has(null) && (s = s.filter((i) => i != null), s.push(null)), s;
  }
  getParamsForValuesFromRows(e = !1) {
    if (!this.clientSideValuesExtractor)
      return be(113), null;
    const t = (i) => !e || this.doesRowPassOtherFilters(i), s = e && !this.caseSensitive ? this.allValues : void 0;
    return { predicate: t, existingValues: s };
  }
  getValuesFromRows(e = !1) {
    const t = this.getParamsForValuesFromRows(e);
    return t ? this.clientSideValuesExtractor.extractUniqueValues(t.predicate, t.existingValues) : null;
  }
  getValuesFromRowsAsync(e = !1) {
    const t = this.getParamsForValuesFromRows(e);
    return t ? this.clientSideValuesExtractor.extractUniqueValuesAsync(t.predicate, t.existingValues) : fe.resolve(null);
  }
  /** Sets mini filter value. Returns true if it changed from last value, otherwise false. */
  setMiniFilter(e) {
    return e = St(e), this.miniFilterText === e ? !1 : (e === null && this.setAddCurrentSelectionToFilter(!1), this.miniFilterText = e, this.updateDisplayedValues("miniFilter"), !0);
  }
  getMiniFilter() {
    return this.miniFilterText;
  }
  updateDisplayedValues(e, t) {
    if (e === "expansion") {
      this.displayValueModel.refresh();
      return;
    }
    if (this.miniFilterText == null) {
      this.displayValueModel.updateDisplayedValuesToAllAvailable(
        (n) => this.getValue(n),
        t,
        this.availableKeys,
        e
      );
      return;
    }
    const s = this.caseFormat(this.formatter(this.miniFilterText) || ""), i = (n) => n != null && this.caseFormat(n).indexOf(s) >= 0, r = !!this.filterParams.excelMode && i(this.translate("blanks"));
    this.displayValueModel.updateDisplayedValuesToMatchMiniFilter(
      (n) => this.getValue(n),
      t,
      this.availableKeys,
      i,
      r,
      e
    );
  }
  getDisplayedValueCount() {
    return this.displayValueModel.getDisplayedValueCount();
  }
  getDisplayedItem(e) {
    return this.displayValueModel.getDisplayedItem(e);
  }
  getSelectAllItem() {
    return this.displayValueModel.getSelectAllItem();
  }
  getAddSelectionToFilterItem() {
    return this.displayValueModel.getAddSelectionToFilterItem();
  }
  hasSelections() {
    return this.filterParams.defaultToNothingSelected ? this.selectedKeys.size > 0 : this.allValues.size !== this.selectedKeys.size;
  }
  getKeys() {
    return Array.from(this.allValues.keys());
  }
  getValues() {
    return Array.from(this.allValues.values());
  }
  getValue(e) {
    return this.allValues.get(e);
  }
  setAddCurrentSelectionToFilter(e) {
    this.addCurrentSelectionToFilter = e;
  }
  isInWindowsExcelMode() {
    return this.filterParams.excelMode === "windows";
  }
  isAddCurrentSelectionToFilterChecked() {
    return this.isInWindowsExcelMode() && this.addCurrentSelectionToFilter;
  }
  showAddCurrentSelectionToFilter() {
    return this.isInWindowsExcelMode() && W(this.miniFilterText) && this.miniFilterText.length > 0;
  }
  selectAllMatchingMiniFilter(e = !1) {
    this.miniFilterText == null ? this.selectedKeys = new Set(this.allValues.keys()) : (e && this.selectedKeys.clear(), this.displayValueModel.forEachDisplayedKey((t) => this.selectedKeys.add(t)));
  }
  deselectAllMatchingMiniFilter() {
    this.miniFilterText == null ? this.selectedKeys.clear() : this.displayValueModel.forEachDisplayedKey((e) => this.selectedKeys.delete(e));
  }
  selectKey(e) {
    this.selectedKeys.add(e);
  }
  deselectKey(e) {
    this.filterParams.excelMode && this.isEverythingVisibleSelected() && this.resetSelectionState(this.displayValueModel.getDisplayedKeys()), this.selectedKeys.delete(e);
  }
  isKeySelected(e) {
    return this.selectedKeys.has(e);
  }
  isEverythingVisibleSelected() {
    return !this.displayValueModel.someDisplayedKey((e) => !this.isKeySelected(e));
  }
  isNothingVisibleSelected() {
    return !this.displayValueModel.someDisplayedKey((e) => this.isKeySelected(e));
  }
  getModel() {
    if (!this.hasSelections())
      return null;
    const e = this.isAddCurrentSelectionToFilterChecked() ? this.filteringKeys.allFilteringKeys() : null;
    if (e && e.size > 0) {
      if (this.selectedKeys) {
        const t = /* @__PURE__ */ new Set([
          ...Array.from(e),
          ...Array.from(this.selectedKeys).filter((s) => !e.has(s))
        ]);
        return Array.from(t);
      }
      return Array.from(e);
    }
    return Array.from(this.selectedKeys);
  }
  setModel(e) {
    return this.allValuesPromise.then((t) => {
      if (e == null)
        this.resetSelectionState(t ?? []);
      else {
        this.selectedKeys.clear();
        const s = /* @__PURE__ */ new Map();
        this.allValues.forEach((i, r) => {
          s.set(this.caseFormat(r), r);
        }), e.forEach((i) => {
          const r = this.caseFormat(St(i)), n = s.get(r);
          n !== void 0 && this.selectKey(n);
        });
      }
    });
  }
  uniqueValues(e) {
    const t = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set();
    return (e ?? []).forEach((i) => {
      const r = St(i), n = this.createKey(r), o = this.caseFormat(n);
      s.has(o) || (s.add(o), t.set(n, r));
    }), t;
  }
  resetSelectionState(e) {
    this.filterParams.defaultToNothingSelected ? this.selectedKeys.clear() : this.selectedKeys = new Set(e);
  }
  hasGroups() {
    return this.displayValueModel.hasGroups();
  }
  createTreeDataOrGroupingComparator() {
    return ([e, t], [s, i]) => {
      if (t == null)
        return i == null ? 0 : -1;
      if (i == null)
        return 1;
      for (let r = 0; r < t.length; r++) {
        if (r >= i.length)
          return 1;
        const n = nl(t[r], i[r]);
        if (n !== 0)
          return n;
      }
      return 0;
    };
  }
  setAppliedModelKeys(e) {
    this.filteringKeys.setFilteringKeys(e);
  }
  addToAppliedModelKeys(e) {
    this.filteringKeys.addFilteringKey(e);
  }
  getAppliedModelKeys() {
    return this.filteringKeys.allFilteringKeys();
  }
  getCaseFormattedAppliedModelKeys() {
    return this.filteringKeys.allFilteringKeysCaseFormatted();
  }
  hasAppliedModelKey(e) {
    return this.filteringKeys.hasCaseFormattedFilteringKey(e);
  }
  hasAnyAppliedModelKey() {
    return !this.filteringKeys.hasNoAppliedFilteringKeys;
  }
}, Bb = class extends Cc {
  constructor() {
    super("setFilter"), this.filterType = "set", this.eMiniFilter = E, this.eFilterLoading = E, this.eSetFilterList = E, this.eFilterNoMatches = E, this.caseSensitive = !1, this.treeDataTreeList = !1, this.groupingTreeList = !1, this.hardRefreshVirtualList = !1, this.noValueFormatterSupplied = !1, this.filterModelFormatter = new Gb(), this.updateSetFilterOnParamsChange = (e) => {
      var i;
      this.setFilterParams = e, this.caseSensitive = !!e.caseSensitive;
      const t = e.keyCreator ?? e.colDef.keyCreator;
      this.setValueFormatter(e.valueFormatter, t, !!e.treeList, !!e.colDef.refData);
      const s = e.column.getId().startsWith(Tr);
      this.treeDataTreeList = this.gos.get("treeData") && !!e.treeList && s, this.groupingTreeList = !!((i = this.rowGroupColsSvc) != null && i.columns.length) && !!e.treeList && s, this.createKey = this.generateCreateKey(t, this.treeDataTreeList || this.groupingTreeList);
    };
  }
  wireBeans(e) {
    this.rowGroupColsSvc = e.rowGroupColsSvc, this.valueSvc = e.valueSvc, this.dataTypeSvc = e.dataTypeSvc;
  }
  postConstruct() {
    super.postConstruct();
  }
  // unlike the simple filters, nothing in the set filter UI shows/hides.
  // maybe this method belongs in abstractSimpleFilter???
  updateUiVisibility() {
  }
  createBodyTemplate() {
    return (
      /* html */
      `
            <div class="ag-set-filter">
                <div data-ref="eFilterLoading" class="ag-filter-loading ag-hidden">${this.translateForSetFilter("loadingOoo")}</div>
                <ag-input-text-field class="ag-mini-filter" data-ref="eMiniFilter"></ag-input-text-field>
                <div data-ref="eFilterNoMatches" class="ag-filter-no-matches ag-hidden">${this.translateForSetFilter("noMatches")}</div>
                <div data-ref="eSetFilterList" class="ag-set-filter-list" role="presentation"></div>
            </div>`
    );
  }
  getAgComponents() {
    return [Ks];
  }
  handleKeyDown(e) {
    if (super.handleKeyDown(e), !e.defaultPrevented)
      switch (e.key) {
        case P.SPACE:
          this.handleKeySpace(e);
          break;
        case P.ENTER:
          this.handleKeyEnter(e);
          break;
        case P.LEFT:
          this.handleKeyLeft(e);
          break;
        case P.RIGHT:
          this.handleKeyRight(e);
          break;
      }
  }
  handleKeySpace(e) {
    var t;
    (t = this.getComponentForKeyEvent(e)) == null || t.toggleSelected();
  }
  handleKeyEnter(e) {
    const { excelMode: t, readOnly: s } = this.setFilterParams;
    !t || s || (e.preventDefault(), this.onBtApply(!1, !1, e), this.setFilterParams.excelMode === "mac" && this.eMiniFilter.getInputElement().select());
  }
  handleKeyLeft(e) {
    var t;
    (t = this.getComponentForKeyEvent(e)) == null || t.setExpanded(!1);
  }
  handleKeyRight(e) {
    var t;
    (t = this.getComponentForKeyEvent(e)) == null || t.setExpanded(!0);
  }
  getComponentForKeyEvent(e) {
    if (!this.eSetFilterList.contains(Ie(this.beans)))
      return;
    const t = this.virtualList.getLastFocusedRow();
    if (t == null)
      return;
    const s = this.virtualList.getComponentAt(t);
    if (s == null)
      return;
    e.preventDefault();
    const { readOnly: i } = this.setFilterParams;
    if (!i)
      return s;
  }
  getCssIdentifier() {
    return "set-filter";
  }
  setModel(e) {
    return e == null && this.valueModel.getModel() == null ? (this.setMiniFilter(null), fe.resolve()) : super.setModel(e);
  }
  refresh(e) {
    if (this.applyExcelModeOptions(e), !super.refresh(e))
      return !1;
    const t = this.setFilterParams;
    return [
      "treeList",
      "treeListPathGetter",
      "caseSensitive",
      "comparator",
      "excelMode"
    ].some((i) => e[i] !== (t == null ? void 0 : t[i])) || this.haveColDefParamsChanged(e) ? !1 : (super.updateParams(e), this.updateSetFilterOnParamsChange(e), this.updateMiniFilter(), e.suppressSelectAll !== (t == null ? void 0 : t.suppressSelectAll) && this.createVirtualListModel(e), this.valueModel.updateOnParamsChange(e).then(() => {
      this.refreshFilterValues();
    }), !0);
  }
  haveColDefParamsChanged(e) {
    const { colDef: t, keyCreator: s } = e, { colDef: i, keyCreator: r } = this.setFilterParams, n = s ?? t.keyCreator, o = r ?? (i == null ? void 0 : i.keyCreator), a = t.filterValueGetter !== (i == null ? void 0 : i.filterValueGetter), l = n !== o, c = !!this.dataTypeSvc && !!n && this.dataTypeSvc.getFormatValue(t.cellDataType) === n && t.valueFormatter !== (i == null ? void 0 : i.valueFormatter);
    return a || l || c;
  }
  setModelAndRefresh(e) {
    return this.valueModel.setModel(e).then(() => {
      this.isAlive() && this.checkAndRefreshVirtualList();
    });
  }
  resetUiToDefaults() {
    return this.setMiniFilter(null), this.setModelAndRefresh(null);
  }
  setModelIntoUi(e) {
    this.setMiniFilter(null);
    const t = e == null ? null : e.values;
    return this.setModelAndRefresh(t);
  }
  getModelFromUi() {
    const e = this.valueModel.getModel();
    return e ? { values: e, filterType: this.filterType } : null;
  }
  getValueModel() {
    return this.valueModel;
  }
  areModelsEqual(e, t) {
    return e == null && t == null ? !0 : e != null && t != null && Ht(e.values, t.values);
  }
  setParams(e) {
    this.applyExcelModeOptions(e), super.setParams(e), this.updateSetFilterOnParamsChange(e);
    const t = e.keyCreator ?? e.colDef.keyCreator;
    this.valueModel = new zW({
      filterParams: e,
      setIsLoading: (s) => this.setIsLoading(s),
      translate: (s) => this.translateForSetFilter(s),
      caseFormat: (s) => this.caseFormat(s),
      createKey: this.createKey,
      valueFormatter: this.valueFormatter,
      usingComplexObjects: !!t,
      gos: this.gos,
      rowGroupColsSvc: this.rowGroupColsSvc,
      valueSvc: this.valueSvc,
      treeDataTreeList: this.treeDataTreeList,
      groupingTreeList: this.groupingTreeList,
      addManagedEventListeners: (s) => this.addManagedEventListeners(s)
    }), this.initialiseFilterBodyUi(), this.addEventListenersForDataChanges();
  }
  onAddCurrentSelectionToFilterChange(e) {
    this.valueModel.setAddCurrentSelectionToFilter(e);
  }
  setValueFormatter(e, t, s, i) {
    let r = e;
    if (!r) {
      if (t && !s) {
        be(249);
        return;
      }
      this.noValueFormatterSupplied = !0, i || (r = (n) => Cs(n.value));
    }
    this.valueFormatter = r;
  }
  generateCreateKey(e, t) {
    return t && !e ? (be(250), () => null) : e ? (s, i = null) => {
      const r = this.getKeyCreatorParams(s, i);
      return St(e(r));
    } : (s) => St(Cs(s));
  }
  getFormattedValue(e) {
    let t = this.valueModel.getValue(e);
    this.noValueFormatterSupplied && (this.treeDataTreeList || this.groupingTreeList) && Array.isArray(t) && (t = pe(t));
    const s = this.valueSvc.formatValue(
      this.setFilterParams.column,
      null,
      t,
      this.valueFormatter,
      !1
    );
    return s ?? Cs(t) ?? this.translateForSetFilter("blanks");
  }
  applyExcelModeOptions(e) {
    e.excelMode === "windows" ? (e.buttons || (e.buttons = ["apply", "cancel"]), e.closeOnApply == null && (e.closeOnApply = !0)) : e.excelMode === "mac" && (e.buttons || (e.buttons = ["reset"]), e.applyMiniFilterWhileTyping == null && (e.applyMiniFilterWhileTyping = !0), e.debounceMs == null && (e.debounceMs = 500)), e.excelMode && e.defaultToNothingSelected && (e.defaultToNothingSelected = !1, I(207));
  }
  addEventListenersForDataChanges() {
    this.isValuesTakenFromGrid() && (this.addManagedPropertyListeners(["groupAllowUnbalanced"], () => {
      this.syncAfterDataChange();
    }), this.addManagedEventListeners({
      cellValueChanged: (e) => {
        e.column === this.setFilterParams.column && this.syncAfterDataChange();
      }
    }));
  }
  syncAfterDataChange() {
    return this.valueModel.refreshValues().then(() => {
      this.checkAndRefreshVirtualList(), (!this.applyActive || this.areModelsEqual(this.getModel(), this.getModelFromUi())) && this.onBtApply(!1, !0);
    });
  }
  setIsLoading(e) {
    re(this.eFilterLoading, e), e || (this.hardRefreshVirtualList = !0);
  }
  initialiseFilterBodyUi() {
    this.initVirtualList(), this.initMiniFilter();
  }
  initVirtualList() {
    const t = this.getLocaleTextFunc()("ariaFilterList", "Filter List"), s = !!this.setFilterParams.treeList, i = this.virtualList = this.createBean(
      new co({
        cssIdentifier: "filter",
        ariaRole: s ? "tree" : "listbox",
        listName: t
      })
    ), r = this.eSetFilterList;
    s && r.classList.add("ag-set-filter-tree-list"), r && r.appendChild(i.getGui());
    const { cellHeight: n } = this.setFilterParams;
    n != null && i.setRowHeight(n);
    const o = (l, c) => this.createSetListItem(l, s, c);
    i.setComponentCreator(o);
    const a = (l, c) => this.updateSetListItem(l, c);
    i.setComponentUpdater(a), this.createVirtualListModel(this.setFilterParams);
  }
  createVirtualListModel(e) {
    let t;
    e.suppressSelectAll ? t = new WW(this.valueModel) : t = new _W(this.valueModel, () => this.isSelectAllSelected()), e.treeList && (t = new UW(t)), this.virtualList.setModel(t);
  }
  getSelectAllLabel() {
    const e = this.valueModel.getMiniFilter() == null || !this.setFilterParams.excelMode ? "selectAll" : "selectAllSearchResults";
    return this.translateForSetFilter(e);
  }
  getAddSelectionToFilterLabel() {
    return this.translateForSetFilter("addCurrentSelectionToFilter");
  }
  createSetListItem(e, t, s) {
    const i = this.valueModel.hasGroups(), { isSelected: r, isExpanded: n } = this.isSelectedExpanded(e), { value: o, depth: a, isGroup: l, hasIndeterminateExpandState: c, selectedListener: d, expandedListener: u } = this.newSetListItemAttributes(e), h = {
      focusWrapper: s,
      value: o,
      params: this.setFilterParams,
      translate: (g) => this.translateForSetFilter(g),
      valueFormatter: this.valueFormatter,
      item: e,
      isSelected: r,
      isTree: t,
      depth: a,
      groupsExist: i,
      isGroup: l,
      isExpanded: n,
      hasIndeterminateExpandState: c
    }, p = this.createBean(new GW(h));
    return p.addEventListener("selectionChanged", d), u && p.addEventListener("expandedChanged", u), p;
  }
  newSetTreeItemAttributes(e) {
    var s, i, r, n;
    const t = this.valueModel.hasGroups();
    return e.key === rn ? {
      value: () => this.getSelectAllLabel(),
      isGroup: t,
      depth: e.depth,
      hasIndeterminateExpandState: !0,
      selectedListener: (o) => this.onSelectAll(o.isSelected),
      expandedListener: (o) => this.onExpandAll(o.item, o.isExpanded)
    } : e.key === nn ? {
      value: () => this.getAddSelectionToFilterLabel(),
      depth: e.depth,
      isGroup: !1,
      hasIndeterminateExpandState: !1,
      selectedListener: (o) => {
        this.onAddCurrentSelectionToFilterChange(o.isSelected);
      }
    } : e.children ? {
      value: ((i = (s = this.setFilterParams).treeListFormatter) == null ? void 0 : i.call(s, e.treeKey, e.depth, e.parentTreeKeys)) ?? e.treeKey,
      depth: e.depth,
      isGroup: !0,
      selectedListener: (o) => this.onGroupItemSelected(o.item, o.isSelected),
      expandedListener: (o) => this.onExpandedChanged(o.item, o.isExpanded)
    } : {
      value: ((n = (r = this.setFilterParams).treeListFormatter) == null ? void 0 : n.call(r, e.treeKey, e.depth, e.parentTreeKeys)) ?? e.treeKey,
      depth: e.depth,
      selectedListener: (o) => this.onItemSelected(o.item.key, o.isSelected)
    };
  }
  newSetListItemAttributes(e) {
    return this.isSetFilterModelTreeItem(e) ? this.newSetTreeItemAttributes(e) : e === rn ? {
      value: () => this.getSelectAllLabel(),
      selectedListener: (t) => this.onSelectAll(t.isSelected)
    } : e === nn ? {
      value: () => this.getAddSelectionToFilterLabel(),
      selectedListener: (t) => {
        this.onAddCurrentSelectionToFilterChange(t.isSelected);
      }
    } : {
      value: this.valueModel.getValue(e),
      selectedListener: (t) => this.onItemSelected(t.item, t.isSelected)
    };
  }
  updateSetListItem(e, t) {
    const { isSelected: s, isExpanded: i } = this.isSelectedExpanded(e);
    t.refresh(e, s, i);
  }
  isSelectedExpanded(e) {
    let t, s;
    return this.isSetFilterModelTreeItem(e) ? (s = e.expanded, e.key === rn ? t = this.isSelectAllSelected() : e.key === nn ? t = this.valueModel.isAddCurrentSelectionToFilterChecked() : e.children ? t = this.areAllChildrenSelected(e) : t = this.valueModel.isKeySelected(e.key)) : e === rn ? t = this.isSelectAllSelected() : e === nn ? t = this.valueModel.isAddCurrentSelectionToFilterChecked() : t = this.valueModel.isKeySelected(e), { isSelected: t, isExpanded: s };
  }
  isSetFilterModelTreeItem(e) {
    return (e == null ? void 0 : e.treeKey) !== void 0;
  }
  initMiniFilter() {
    const { eMiniFilter: e } = this, t = this.getLocaleTextFunc();
    e.setDisplayed(!this.setFilterParams.suppressMiniFilter), e.setValue(this.valueModel.getMiniFilter()), e.onValueChange(() => this.onMiniFilterInput()), e.setInputAriaLabel(t("ariaSearchFilterValues", "Search filter values")), this.addManagedElementListeners(e.getInputElement(), {
      keydown: (s) => this.onMiniFilterKeyDown(s)
    });
  }
  updateMiniFilter() {
    const { eMiniFilter: e } = this;
    e.isDisplayed() !== !this.setFilterParams.suppressMiniFilter && e.setDisplayed(!this.setFilterParams.suppressMiniFilter);
    const t = this.valueModel.getMiniFilter();
    e.getValue() !== t && e.setValue(t);
  }
  // we need to have the GUI attached before we can draw the virtual rows, as the
  // virtual row logic needs info about the GUI state
  afterGuiAttached(e) {
    super.afterGuiAttached(e), this.resetExpansion(), this.refreshVirtualList();
    const { eMiniFilter: t } = this;
    t.setInputPlaceholder(this.translateForSetFilter("searchOoo")), (!e || !e.suppressFocus) && (t.isDisplayed() ? t.getFocusableElement().focus() : this.virtualList.awaitStable(() => this.virtualList.focusRow(0)));
  }
  afterGuiDetached() {
    super.afterGuiDetached(), this.setFilterParams.excelMode && this.resetMiniFilter();
    const e = this.getModel();
    (this.setFilterParams.excelMode || !this.areModelsEqual(e, this.getModelFromUi())) && (this.resetUiToActiveModel(e), this.showOrHideResults());
  }
  applyModel(e = "api") {
    this.setFilterParams.excelMode && e !== "rowDataUpdated" && this.valueModel.isEverythingVisibleSelected() && this.valueModel.selectAllMatchingMiniFilter();
    const t = this.valueModel.showAddCurrentSelectionToFilter() && this.valueModel.isAddCurrentSelectionToFilterChecked();
    if (t && !this.getModel())
      return !1;
    const s = super.applyModel(e), i = this.getModel();
    return i ? (t || this.valueModel.setAppliedModelKeys(/* @__PURE__ */ new Set()), i.values.forEach((r) => {
      this.valueModel.addToAppliedModelKeys(r);
    })) : t || this.valueModel.setAppliedModelKeys(null), s;
  }
  isModelValid(e) {
    return this.setFilterParams.excelMode ? e == null || e.values.length > 0 : !0;
  }
  doesFilterPass(e) {
    if (!this.valueModel.getCaseFormattedAppliedModelKeys())
      return !0;
    if (!this.valueModel.hasAnyAppliedModelKey())
      return !1;
    const { node: t } = e;
    if (this.treeDataTreeList)
      return this.doesFilterPassForTreeData(t);
    if (this.groupingTreeList)
      return this.doesFilterPassForGrouping(t);
    const s = this.getValueFromNode(t);
    return s != null && Array.isArray(s) ? s.length === 0 ? this.valueModel.hasAppliedModelKey(null) : s.some((i) => this.isInAppliedModel(this.createKey(i, t))) : this.isInAppliedModel(this.createKey(s, t));
  }
  doesFilterPassForTreeData(e) {
    var t;
    return (t = e.childrenAfterGroup) != null && t.length ? !1 : this.isInAppliedModel(
      this.createKey(
        Iu(
          e.getRoute() ?? [e.key ?? e.id],
          !0,
          this.gos.get("groupAllowUnbalanced")
        )
      )
    );
  }
  doesFilterPassForGrouping(e) {
    var s;
    const t = (((s = this.rowGroupColsSvc) == null ? void 0 : s.columns) ?? []).map(
      (i) => this.valueSvc.getKeyForNode(i, e)
    );
    return t.push(this.getValueFromNode(e)), this.isInAppliedModel(
      this.createKey(Iu(t, !1, this.gos.get("groupAllowUnbalanced")))
    );
  }
  isInAppliedModel(e) {
    return this.valueModel.hasAppliedModelKey(e);
  }
  getValueFromNode(e) {
    return this.setFilterParams.getValue(e);
  }
  getKeyCreatorParams(e, t = null) {
    const { colDef: s, column: i, api: r, context: n } = this.setFilterParams;
    return {
      value: e,
      colDef: s,
      column: i,
      node: t,
      data: t == null ? void 0 : t.data,
      api: r,
      context: n
    };
  }
  onNewRowsLoaded() {
    this.isValuesTakenFromGrid() && this.syncAfterDataChange();
  }
  isValuesTakenFromGrid() {
    return this.valueModel.getValuesType() === 2;
  }
  //noinspection JSUnusedGlobalSymbols
  /**
   * Public method provided so the user can change the value of the filter once
   * the filter has been already started
   * @param values The values to use.
   */
  setFilterValues(e) {
    this.valueModel.overrideValues(e).then(() => {
      this.checkAndRefreshVirtualList(), this.onUiChanged();
    });
  }
  //noinspection JSUnusedGlobalSymbols
  /**
   * Public method provided so the user can reset the values of the filter once that it has started.
   */
  resetFilterValues() {
    this.valueModel.setValuesType(
      2
      /* TAKEN_FROM_GRID_VALUES */
    ), this.syncAfterDataChange();
  }
  refreshFilterValues() {
    this.valueModel.isInitialised() && this.valueModel.refreshValues().then(() => {
      this.hardRefreshVirtualList = !0, this.checkAndRefreshVirtualList(), this.onUiChanged();
    });
  }
  onAnyFilterChanged() {
    setTimeout(() => {
      this.isAlive() && this.valueModel.refreshAfterAnyFilterChanged().then((e) => {
        e && (this.checkAndRefreshVirtualList(), this.showOrHideResults());
      });
    }, 0);
  }
  onMiniFilterInput() {
    if (!this.valueModel.setMiniFilter(this.eMiniFilter.getValue()))
      return;
    const { applyMiniFilterWhileTyping: e, readOnly: t } = this.setFilterParams;
    !t && e ? this.filterOnAllVisibleValues(!1) : this.updateUiAfterMiniFilterChange();
  }
  updateUiAfterMiniFilterChange() {
    const { excelMode: e, readOnly: t } = this.setFilterParams;
    e == null || t ? this.checkAndRefreshVirtualList() : this.valueModel.getMiniFilter() == null ? this.resetUiToActiveModel(this.getModel()) : (this.valueModel.selectAllMatchingMiniFilter(!0), this.checkAndRefreshVirtualList(), this.onUiChanged()), this.showOrHideResults();
  }
  showOrHideResults() {
    const e = this.valueModel.getMiniFilter() != null && this.valueModel.getDisplayedValueCount() < 1;
    re(this.eFilterNoMatches, e), re(this.eSetFilterList, !e);
  }
  resetMiniFilter() {
    this.eMiniFilter.setValue(null, !0), this.valueModel.setMiniFilter(null);
  }
  resetUiToActiveModel(e, t) {
    this.setModelAndRefresh(e == null ? null : e.values).then(() => {
      this.onUiChanged(!1, "prevent"), t == null || t();
    });
  }
  handleCancelEnd(e) {
    this.setMiniFilter(null), super.handleCancelEnd(e);
  }
  onMiniFilterKeyDown(e) {
    const { excelMode: t, readOnly: s } = this.setFilterParams;
    e.key === P.ENTER && !t && !s && this.filterOnAllVisibleValues();
  }
  filterOnAllVisibleValues(e = !0) {
    this.valueModel.selectAllMatchingMiniFilter(!0), this.checkAndRefreshVirtualList(), this.onUiChanged(!1, e ? "immediately" : "debounce"), this.showOrHideResults();
  }
  focusRowIfAlive(e) {
    e != null && window.setTimeout(() => {
      this.isAlive() && this.virtualList.focusRow(e);
    }, 0);
  }
  onSelectAll(e) {
    e ? this.valueModel.selectAllMatchingMiniFilter() : this.valueModel.deselectAllMatchingMiniFilter(), this.refreshAfterSelection();
  }
  onGroupItemSelected(e, t) {
    const s = (i) => {
      i.children ? i.children.forEach((r) => s(r)) : this.selectItem(i.key, t);
    };
    s(e), this.refreshAfterSelection();
  }
  onItemSelected(e, t) {
    this.selectItem(e, t), this.refreshAfterSelection();
  }
  selectItem(e, t) {
    t ? this.valueModel.selectKey(e) : this.valueModel.deselectKey(e);
  }
  onExpandAll(e, t) {
    const s = (i) => {
      i.filterPasses && i.available && i.children && (i.children.forEach((r) => s(r)), i.expanded = t);
    };
    s(e), this.refreshAfterExpansion();
  }
  onExpandedChanged(e, t) {
    e.expanded = t, this.refreshAfterExpansion();
  }
  refreshAfterExpansion() {
    const e = this.virtualList.getLastFocusedRow();
    this.valueModel.updateDisplayedValues("expansion"), this.checkAndRefreshVirtualList(), this.focusRowIfAlive(e);
  }
  refreshAfterSelection() {
    const e = this.virtualList.getLastFocusedRow();
    this.checkAndRefreshVirtualList(), this.onUiChanged(), this.focusRowIfAlive(e);
  }
  setMiniFilter(e) {
    this.eMiniFilter.setValue(e), this.onMiniFilterInput();
  }
  getMiniFilter() {
    return this.valueModel.getMiniFilter();
  }
  checkAndRefreshVirtualList() {
    this.virtualList.refresh(!this.hardRefreshVirtualList), this.hardRefreshVirtualList && (this.hardRefreshVirtualList = !1);
  }
  getFilterKeys() {
    return this.valueModel.getKeys();
  }
  getFilterValues() {
    return this.valueModel.getValues();
  }
  getValues() {
    return this.getFilterKeys();
  }
  refreshVirtualList() {
    this.setFilterParams.refreshValuesOnOpen ? this.refreshFilterValues() : this.checkAndRefreshVirtualList();
  }
  translateForSetFilter(e) {
    return this.getLocaleTextFunc()(e, OW[e]);
  }
  isSelectAllSelected() {
    if (this.setFilterParams.defaultToNothingSelected) {
      if (this.valueModel.hasSelections() && this.valueModel.isEverythingVisibleSelected())
        return !0;
      if (this.valueModel.isNothingVisibleSelected())
        return !1;
    } else {
      if (this.valueModel.hasSelections() && this.valueModel.isNothingVisibleSelected())
        return !1;
      if (this.valueModel.isEverythingVisibleSelected())
        return !0;
    }
  }
  areAllChildrenSelected(e) {
    const t = (s) => {
      if (s.children) {
        let i = !1, r = !1;
        return s.children.some((o) => {
          if (!o.filterPasses || !o.available)
            return !1;
          const a = t(o);
          return a === void 0 ? !0 : (a ? i = !0 : r = !0, i && r);
        }) ? void 0 : i;
      } else
        return this.valueModel.isKeySelected(s.key);
    };
    return this.setFilterParams.defaultToNothingSelected ? this.valueModel.hasSelections() && t(e) : t(e);
  }
  destroy() {
    this.virtualList = this.destroyBean(this.virtualList), super.destroy();
  }
  caseFormat(e) {
    return e == null || typeof e != "string" || this.caseSensitive ? e : e.toUpperCase();
  }
  resetExpansion() {
    if (!this.setFilterParams.treeList)
      return;
    const e = this.valueModel.getSelectAllItem();
    if (this.isSetFilterModelTreeItem(e)) {
      const t = (s) => {
        s.children && (s.children.forEach((i) => t(i)), s.expanded = !1);
      };
      t(e), this.valueModel.updateDisplayedValues("expansion");
    }
  }
  getModelAsString(e) {
    return this.filterModelFormatter.getModelAsString(e, this);
  }
  getPositionableElement() {
    return this.eSetFilterList;
  }
}, WW = class {
  constructor(e) {
    this.model = e;
  }
  getRowCount() {
    return this.model.getDisplayedValueCount();
  }
  getRow(e) {
    return this.model.getDisplayedItem(e);
  }
  areRowsEqual(e, t) {
    return e === t;
  }
}, _W = class {
  constructor(e, t) {
    this.model = e, this.isSelectAllSelected = t;
  }
  getRowCount() {
    const t = this.model.showAddCurrentSelectionToFilter() ? 2 : 1;
    return this.model.getDisplayedValueCount() + t;
  }
  getRow(e) {
    if (e === 0)
      return this.model.getSelectAllItem();
    const t = this.model.showAddCurrentSelectionToFilter(), s = t ? 2 : 1;
    return e === 1 && t ? this.model.getAddSelectionToFilterItem() : this.model.getDisplayedItem(e - s);
  }
  areRowsEqual(e, t) {
    return e === t;
  }
}, UW = class {
  constructor(e) {
    this.model = e;
  }
  getRowCount() {
    return this.model.getRowCount();
  }
  getRow(e) {
    return this.model.getRow(e);
  }
  areRowsEqual(e, t) {
    return e == null && t == null ? !0 : e != null && t != null && e.treeKey === t.treeKey && e.depth === t.depth;
  }
}, $W = class extends _ {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-floating-filter-input ag-set-floating-filter-input" role="presentation">
                <ag-input-text-field data-ref="eFloatingFilterText"></ag-input-text-field>
            </div>`,
      [Ks]
    ), this.eFloatingFilterText = E, this.availableValuesListenerAdded = !1, this.filterModelFormatter = new Gb();
  }
  wireBeans(e) {
    this.colNames = e.colNames;
  }
  init(e) {
    this.params = e, this.eFloatingFilterText.setDisabled(!0).addGuiEventListener("click", () => this.params.showParentFilter()), this.setParams(e);
  }
  setParams(e) {
    const t = this.colNames.getDisplayNameForColumn(e.column, "header", !0), s = this.getLocaleTextFunc();
    this.eFloatingFilterText.setInputAriaLabel(`${t} ${s("ariaFilterInput", "Filter Input")}`);
  }
  refresh(e) {
    this.params = e, this.setParams(e);
  }
  onParentModelChanged(e) {
    this.updateFloatingFilterText(e);
  }
  parentSetFilterInstance(e) {
    this.params.parentFilterInstance((t) => {
      if (!(t instanceof Bb)) {
        be(248);
        return;
      }
      e(t);
    });
  }
  addAvailableValuesListener() {
    this.parentSetFilterInstance((e) => {
      const t = e.getValueModel();
      t && this.addManagedListeners(t, { availableValuesChanged: () => this.updateFloatingFilterText() });
    }), this.availableValuesListenerAdded = !0;
  }
  updateFloatingFilterText(e) {
    this.availableValuesListenerAdded || this.addAvailableValuesListener(), this.parentSetFilterInstance((t) => {
      this.eFloatingFilterText.setValue(this.filterModelFormatter.getModelAsString(e, t));
    });
  }
}, jW = {
  moduleName: "SetFilter",
  version: Me,
  userComponents: { agSetColumnFilter: Bb, agSetColumnFloatingFilter: $W },
  icons: {
    // set filter tree list group contracted (click to expand)
    setFilterGroupClosed: "tree-closed",
    // set filter tree list group expanded (click to contract)
    setFilterGroupOpen: "tree-open",
    // set filter tree list expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    setFilterGroupIndeterminate: "tree-indeterminate"
  },
  dependsOn: [Je, kr]
}, KW = (
  /*css*/
  ".ag-status-bar{border-top:var(--ag-footer-row-border);display:flex;justify-content:space-between;line-height:1.5;overflow:hidden;padding-left:calc(var(--ag-spacing)*4);padding-right:calc(var(--ag-spacing)*4)}.ag-status-panel{display:inline-flex}.ag-status-name-value{font-weight:500;margin-left:var(--ag-spacing);margin-right:var(--ag-spacing);padding-bottom:var(--ag-widget-container-vertical-padding);padding-top:var(--ag-widget-container-vertical-padding);white-space:nowrap}.ag-status-bar-left{display:inline-flex}.ag-status-bar-center{display:inline-flex;text-align:center}.ag-status-bar-right{display:inline-flex}"
);
function qW(e, t, s) {
  return e.getCompDetails(t, YW, void 0, s, !0);
}
var YW = {
  name: "statusPanel",
  optionalMethods: ["refresh"]
}, XW = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="ag-status-bar">
            <div data-ref="eStatusBarLeft" class="ag-status-bar-left" role="status"></div>
            <div data-ref="eStatusBarCenter" class="ag-status-bar-center" role="status"></div>
            <div data-ref="eStatusBarRight" class="ag-status-bar-right" role="status"></div>
        </div>`
    ), this.updateQueued = !1, this.panelsPromise = fe.resolve(), this.eStatusBarLeft = E, this.eStatusBarCenter = E, this.eStatusBarRight = E, this.compDestroyFunctions = {}, this.registerCSS(KW);
  }
  wireBeans(e) {
    this.userCompFactory = e.userCompFactory, this.statusBarSvc = e.statusBarSvc;
  }
  postConstruct() {
    this.processStatusPanels(/* @__PURE__ */ new Map()), this.addManagedPropertyListeners(["statusBar"], this.handleStatusBarChanged.bind(this));
  }
  processStatusPanels(e) {
    var s;
    const t = (s = this.gos.get("statusBar")) == null ? void 0 : s.statusPanels;
    if (t) {
      const i = t.filter(
        (o) => o.align === "left"
      ), r = t.filter(
        (o) => o.align === "center"
      ), n = t.filter(
        (o) => !o.align || o.align === "right"
      );
      this.panelsPromise = fe.all([
        this.createAndRenderComponents(
          i,
          this.eStatusBarLeft,
          e
        ),
        this.createAndRenderComponents(
          r,
          this.eStatusBarCenter,
          e
        ),
        this.createAndRenderComponents(
          n,
          this.eStatusBarRight,
          e
        )
      ]);
    } else
      this.setDisplayed(!1);
  }
  handleStatusBarChanged() {
    this.updateQueued || (this.updateQueued = !0, this.panelsPromise.then(() => {
      this.updateStatusBar(), this.updateQueued = !1;
    }));
  }
  updateStatusBar() {
    var i;
    const e = (i = this.gos.get("statusBar")) == null ? void 0 : i.statusPanels, t = Array.isArray(e) && e.length > 0;
    this.setDisplayed(t);
    const s = /* @__PURE__ */ new Map();
    t && e.forEach((r) => {
      const n = r.key ?? r.statusPanel, o = this.statusBarSvc.getStatusPanel(n);
      if (o != null && o.refresh) {
        const a = this.gos.addGridCommonParams(r.statusPanelParams ?? {});
        o.refresh(a) && (s.set(n, o), delete this.compDestroyFunctions[n], ut(o.getGui()));
      }
    }), this.resetStatusBar(), t && this.processStatusPanels(s);
  }
  resetStatusBar() {
    this.eStatusBarLeft.innerHTML = "", this.eStatusBarCenter.innerHTML = "", this.eStatusBarRight.innerHTML = "", this.destroyComponents(), this.statusBarSvc.unregisterAllComponents();
  }
  destroy() {
    this.destroyComponents(), super.destroy();
  }
  destroyComponents() {
    Object.values(this.compDestroyFunctions).forEach((e) => e()), this.compDestroyFunctions = {};
  }
  createAndRenderComponents(e, t, s) {
    const i = [];
    return e.forEach((r) => {
      const n = r.key || r.statusPanel, o = s.get(n);
      let a;
      if (o)
        a = fe.resolve(o);
      else {
        const l = {}, c = qW(this.userCompFactory, r, l);
        if (c == null)
          return;
        a = c.newAgStackInstance();
      }
      i.push({
        key: n,
        promise: a
      });
    }), fe.all(i.map((r) => r.promise)).then(() => {
      i.forEach((r) => {
        r.promise.then((n) => {
          const o = () => {
            this.destroyBean(n);
          };
          this.isAlive() ? (this.statusBarSvc.registerStatusPanel(r.key, n), t.appendChild(n.getGui()), this.compDestroyFunctions[r.key] = o) : o();
        });
      });
    });
  }
}, ZW = {
  selector: "AG-STATUS-BAR",
  component: XW
}, Sa = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="ag-status-name-value">
            <span data-ref="eLabel"></span>:&nbsp;
            <span data-ref="eValue" class="ag-status-name-value-value"></span>
        </div>`
    ), this.eLabel = E, this.eValue = E;
  }
  setLabel(e, t) {
    this.setDisplayed(!1);
    const s = this.getLocaleTextFunc();
    this.eLabel.innerHTML = s(e, t);
  }
  setValue(e) {
    this.eValue.innerHTML = e;
  }
}, QW = {
  selector: "AG-NAME-VALUE",
  component: Sa
};
function JW(e, t) {
  return typeof e != "number" ? "" : vn(Math.round(e * 100) / 100, t);
}
var e_ = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="ag-status-panel ag-status-panel-aggregations">
            <ag-name-value data-ref="avgAggregationComp"></ag-name-value>
            <ag-name-value data-ref="countAggregationComp"></ag-name-value>
            <ag-name-value data-ref="minAggregationComp"></ag-name-value>
            <ag-name-value data-ref="maxAggregationComp"></ag-name-value>
            <ag-name-value data-ref="sumAggregationComp"></ag-name-value>
        </div>`,
      [QW]
    ), this.sumAggregationComp = E, this.countAggregationComp = E, this.minAggregationComp = E, this.maxAggregationComp = E, this.avgAggregationComp = E;
  }
  postConstruct() {
    if (!Ye(this.gos) && !Lt(this.gos)) {
      I(221);
      return;
    }
    this.avgAggregationComp.setLabel("avg", "Average"), this.countAggregationComp.setLabel("count", "Count"), this.minAggregationComp.setLabel("min", "Min"), this.maxAggregationComp.setLabel("max", "Max"), this.sumAggregationComp.setLabel("sum", "Sum"), this.addManagedEventListeners({
      cellSelectionChanged: this.onCellSelectionChanged.bind(this),
      modelUpdated: this.onCellSelectionChanged.bind(this)
    });
  }
  init(e) {
    this.refresh(e);
  }
  refresh(e) {
    return this.params = e, this.onCellSelectionChanged(), !0;
  }
  setAggregationComponentValue(e, t, s) {
    var r;
    const i = this.getAllowedAggregationValueComponent(e);
    W(i) && i ? (i.setValue(
      JW(t, this.getLocaleTextFunc.bind(this))
    ), i.setDisplayed(s)) : (r = this.getAggregationValueComponent(e)) == null || r.setDisplayed(!1);
  }
  getAllowedAggregationValueComponent(e) {
    const { aggFuncs: t } = this.params;
    return !t || t.includes(e) ? this.getAggregationValueComponent(e) : null;
  }
  getAggregationValueComponent(e) {
    const t = `${e}AggregationComp`;
    return this[t];
  }
  onCellSelectionChanged() {
    const e = this.beans, { rangeSvc: t, valueSvc: s, cellNavigation: i } = e, r = t == null ? void 0 : t.getCellRanges();
    let n = 0, o = 0, a = 0, l = null, c = null;
    const d = {};
    if (r != null && r.length && t)
      for (let p = 0; p < r.length; p++) {
        const g = r[p];
        let f = t.getRangeStartRow(g);
        const m = t.getRangeEndRow(g);
        for (; !(ke(f) || !f || jt(m, f) || !f || !g.columns); )
          g.columns.forEach((w) => {
            if (f === null)
              return;
            const y = cr({
              rowPinned: f.rowPinned,
              column: w,
              rowIndex: f.rowIndex
            });
            if (d[y])
              return;
            d[y] = !0;
            const b = ri(e, f);
            if (ke(b))
              return;
            let x = s.getValue(w, b);
            ke(x) || x === "" || (o++, !(typeof x == "object" && "value" in x && (x = x.value, x === "")) && (typeof x == "string" && (x = Number(x)), typeof x == "number" && !isNaN(x) && (n += x, (c === null || x > c) && (c = x), (l === null || x < l) && (l = x), a++)));
          }), f = i.getRowBelow(f);
      }
    const u = o > 1, h = a > 1;
    this.setAggregationComponentValue("count", o, u), this.setAggregationComponentValue("sum", n, h), this.setAggregationComponentValue("min", l, h), this.setAggregationComponentValue("max", c, h), this.setAggregationComponentValue("avg", n / a, h);
  }
}, t_ = class extends Sa {
  postConstruct() {
    if (this.setLabel("filteredRows", "Filtered"), !Ye(this.gos)) {
      I(222);
      return;
    }
    this.addCssClass("ag-status-panel"), this.addCssClass("ag-status-panel-filtered-row-count"), this.setDisplayed(!0);
    const e = this.onDataChanged.bind(this);
    this.addManagedEventListeners({ modelUpdated: e }), e();
  }
  onDataChanged() {
    const e = this.getTotalRowCountValue(), t = this.getFilteredRowCountValue();
    this.setValue(vn(t, this.getLocaleTextFunc.bind(this))), this.setDisplayed(e !== t);
  }
  getTotalRowCountValue() {
    let e = 0;
    return this.beans.rowModel.forEachNode(() => e += 1), e;
  }
  getFilteredRowCountValue() {
    let e = 0;
    return this.beans.rowModel.forEachNodeAfterFilter((t) => {
      t.group || (e += 1);
    }), e;
  }
  init() {
  }
  refresh() {
    return !0;
  }
}, s_ = class extends Sa {
  postConstruct() {
    const e = this.gos;
    if (!Ye(e) && !Lt(e)) {
      I(223);
      return;
    }
    this.setLabel("selectedRows", "Selected"), this.addCssClass("ag-status-panel"), this.addCssClass("ag-status-panel-selected-row-count"), this.onRowSelectionChanged();
    const t = this.onRowSelectionChanged.bind(this);
    this.addManagedEventListeners({ modelUpdated: t, selectionChanged: t });
  }
  onRowSelectionChanged() {
    var t;
    const e = ((t = this.beans.selectionSvc) == null ? void 0 : t.getSelectionCount()) ?? 0;
    if (e < 0) {
      this.setValue("?"), this.setDisplayed(!0);
      return;
    }
    this.setValue(vn(e, this.getLocaleTextFunc.bind(this))), this.setDisplayed(e > 0);
  }
  init() {
  }
  refresh() {
    return !0;
  }
}, i_ = class extends Sa {
  postConstruct() {
    if (!Ye(this.gos)) {
      I(224);
      return;
    }
    this.setLabel("totalAndFilteredRows", "Rows"), this.addCssClass("ag-status-panel"), this.addCssClass("ag-status-panel-total-and-filtered-row-count"), this.setDisplayed(!0), this.addManagedEventListeners({ modelUpdated: this.onDataChanged.bind(this) }), this.onDataChanged();
  }
  onDataChanged() {
    const e = this.getLocaleTextFunc.bind(this), t = vn(this.getFilteredRowCountValue(), e), s = vn(this.getTotalRowCount(), e);
    if (t === s)
      this.setValue(t);
    else {
      const i = this.getLocaleTextFunc();
      this.setValue(`${t} ${i("of", "of")} ${s}`);
    }
  }
  getFilteredRowCountValue() {
    let e = 0;
    return this.beans.rowModel.forEachNodeAfterFilter((t) => {
      t.group || e++;
    }), e;
  }
  getTotalRowCount() {
    let e = 0;
    return this.beans.rowModel.forEachNode((t) => {
      t.group || e++;
    }), e;
  }
  init() {
  }
  refresh() {
    return !0;
  }
}, r_ = class extends Sa {
  postConstruct() {
    if (this.setLabel("totalRows", "Total Rows"), !Ye(this.gos)) {
      I(225);
      return;
    }
    this.addCssClass("ag-status-panel"), this.addCssClass("ag-status-panel-total-row-count"), this.setDisplayed(!0), this.addManagedEventListeners({ modelUpdated: this.onDataChanged.bind(this) }), this.onDataChanged();
  }
  onDataChanged() {
    this.setValue(vn(this.getRowCountValue(), this.getLocaleTextFunc.bind(this)));
  }
  getRowCountValue() {
    let e = 0;
    return this.beans.rowModel.forEachLeafNode(() => e += 1), e;
  }
  init() {
  }
  refresh() {
    return !0;
  }
};
function n_(e, t) {
  var i;
  const s = (i = e.statusBarSvc) == null ? void 0 : i.getStatusPanel(t);
  return Cn(s);
}
var o_ = class extends L {
  // tslint:disable-next-line
  constructor() {
    super(), this.beanName = "statusBarSvc", this.comps = /* @__PURE__ */ new Map();
  }
  registerStatusPanel(e, t) {
    this.comps.set(e, t);
  }
  unregisterStatusPanel(e) {
    this.comps.delete(e);
  }
  unregisterAllComponents() {
    this.comps.clear();
  }
  getStatusPanel(e) {
    return this.comps.get(e);
  }
  destroy() {
    this.unregisterAllComponents(), super.destroy();
  }
}, a_ = {
  moduleName: "StatusBar",
  version: Me,
  beans: [o_],
  userComponents: {
    agAggregationComponent: e_,
    agTotalRowCountComponent: r_,
    agFilteredRowCountComponent: t_,
    agTotalAndFilteredRowCountComponent: i_,
    agSelectedRowCountComponent: s_
  },
  selectors: [ZW],
  apiFunctions: {
    getStatusPanel: n_
  },
  dependsOn: [Je, Sc]
};
function Vb(e) {
  var t;
  return ((t = e.excelCreator) == null ? void 0 : t.getFactoryMode()) === "MULTI_SHEET" ? (I(161), !1) : !0;
}
function l_(e, t) {
  var s;
  if (Vb(e))
    return (s = e.excelCreator) == null ? void 0 : s.getDataAsExcel(t);
}
function c_(e, t) {
  var s;
  Vb(e) && ((s = e.excelCreator) == null || s.exportDataAsExcel(t));
}
function d_(e, t) {
  var s, i;
  return (s = e.excelCreator) == null || s.setFactoryMode("MULTI_SHEET"), (i = e.excelCreator) == null ? void 0 : i.getSheetDataForExcel(t);
}
function u_(e, t) {
  var s;
  return (s = e.excelCreator) == null ? void 0 : s.getMultipleSheetsAsExcel(t);
}
function h_(e, t) {
  var s;
  (s = e.excelCreator) == null || s.exportMultipleSheetsAsExcel(t);
}
var p_ = {
  moduleName: "ExcelExport",
  version: Me,
  beans: [TH],
  apiFunctions: {
    getDataAsExcel: l_,
    exportDataAsExcel: c_,
    getSheetDataForExcel: d_,
    getMultipleSheetsAsExcel: u_,
    exportMultipleSheetsAsExcel: h_
  },
  dependsOn: [_y, Je]
};
function g_(e) {
  const t = e.cssIdentifier || "default", s = e.direction || "vertical";
  return (
    /* html */
    `
        <div class="ag-group ag-${t}-group" role="presentation">
            <div data-ref="eToolbar" class="ag-group-toolbar ag-${t}-group-toolbar">
                <ag-checkbox data-ref="cbGroupEnabled"></ag-checkbox>
            </div>
            <div data-ref="eContainer" class="ag-group-container ag-group-container-${s} ag-${t}-group-container"></div>
        </div>
    `
  );
}
var qi = class extends _ {
  constructor(e = {}) {
    super(g_(e), [ai]), this.params = e, this.suppressEnabledCheckbox = !0, this.suppressToggleExpandOnEnableChange = !1, this.eToolbar = E, this.cbGroupEnabled = E, this.eContainer = E;
    const {
      enabled: t,
      items: s,
      suppressEnabledCheckbox: i,
      expanded: r,
      suppressToggleExpandOnEnableChange: n,
      useToggle: o
    } = e;
    this.cssIdentifier = e.cssIdentifier || "default", this.enabled = t ?? !0, this.items = s || [], this.useToggle = o ?? !1, this.alignItems = e.alignItems || "center", this.expanded = r ?? !0, i != null && (this.suppressEnabledCheckbox = i), n != null && (this.suppressToggleExpandOnEnableChange = n);
  }
  postConstruct() {
    if (this.setupTitleBar(), this.items.length) {
      const r = this.items;
      this.items = [], this.addItems(r);
    }
    const e = this.getLocaleTextFunc();
    this.cbGroupEnabled.setLabel(e("enabled", "Enabled")), this.enabled && this.setEnabled(this.enabled, void 0, !0), this.setAlignItems(this.alignItems);
    const { onEnableChange: t, onExpandedChange: s, suppressOpenCloseIcons: i } = this.params;
    this.hideEnabledCheckbox(this.suppressEnabledCheckbox), this.hideOpenCloseIcons(i ?? !1), this.refreshChildDisplay(), re(this.eContainer, this.expanded), this.cbGroupEnabled.onValueChange((r) => {
      this.setEnabled(r, !0, this.suppressToggleExpandOnEnableChange), this.dispatchEnableChangeEvent(r);
    }), t != null && this.onEnableChange(t), s != null && this.onExpandedChange(s);
  }
  refreshChildDisplay() {
    var e;
    re(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox), (e = this.eTitleBar) == null || e.refreshOnExpand(this.expanded);
  }
  isExpanded() {
    return this.expanded;
  }
  setAlignItems(e) {
    this.alignItems !== e && this.removeCssClass(`ag-group-item-alignment-${this.alignItems}`), this.alignItems = e;
    const t = `ag-group-item-alignment-${this.alignItems}`;
    return this.addCssClass(t), this;
  }
  toggleGroupExpand(e, t) {
    var s;
    if ((s = this.eTitleBar) != null && s.isSuppressCollapse() && !this.useToggle)
      e = !0, t = !0;
    else if (e = e ?? !this.expanded, this.expanded === e)
      return this;
    return this.expanded = e, this.refreshChildDisplay(), re(this.eContainer, e), t || this.dispatchLocalEvent({
      type: e ? "expanded" : "collapsed"
    }), this;
  }
  addItems(e) {
    e.forEach((t) => this.addItem(t));
  }
  prependItem(e) {
    this.insertItem(e, !0);
  }
  addItem(e) {
    this.insertItem(e, !1);
  }
  insertItem(e, t) {
    const s = this.eContainer, i = e instanceof _ ? e.getGui() : e;
    i.classList.add("ag-group-item", `ag-${this.cssIdentifier}-group-item`), t ? (s.insertAdjacentElement("afterbegin", i), this.items.unshift(i)) : (s.appendChild(i), this.items.push(i));
  }
  hideItem(e, t) {
    const s = this.items[t];
    re(s, !e);
  }
  getItemIndex(e) {
    const t = e instanceof _ ? e.getGui() : e;
    return this.items.indexOf(t);
  }
  setTitle(e) {
    var t;
    return (t = this.eTitleBar) == null || t.setTitle(e), this;
  }
  addTitleBarWidget(e) {
    var t;
    return (t = this.eTitleBar) == null || t.addWidget(e), this;
  }
  addCssClassToTitleBar(e) {
    var t;
    (t = this.eTitleBar) == null || t.addCssClass(e);
  }
  dispatchEnableChangeEvent(e) {
    const t = {
      type: "enableChange",
      enabled: e
    };
    this.dispatchLocalEvent(t);
  }
  setEnabled(e, t, s) {
    var i;
    return this.enabled = e, this.refreshDisabledStyles(), s || this.toggleGroupExpand(e), t || (this.cbGroupEnabled.setValue(e), (i = this.eToggle) == null || i.setValue(e)), this;
  }
  isEnabled() {
    return this.enabled;
  }
  onEnableChange(e) {
    return this.addManagedListeners(this, { enableChange: (t) => e(t.enabled) }), this;
  }
  onExpandedChange(e) {
    return this.addManagedListeners(this, {
      expanded: () => e(!0),
      collapsed: () => e(!1)
    }), this;
  }
  hideEnabledCheckbox(e) {
    return this.suppressEnabledCheckbox = e, this.refreshChildDisplay(), this.refreshDisabledStyles(), this;
  }
  hideOpenCloseIcons(e) {
    var t;
    return (t = this.eTitleBar) == null || t.hideOpenCloseIcons(e), this;
  }
  refreshDisabledStyles() {
    var t;
    const e = !this.enabled;
    this.eContainer.classList.toggle("ag-disabled", e), (t = this.eTitleBar) == null || t.refreshDisabledStyles(this.suppressEnabledCheckbox && e), this.eContainer.classList.toggle("ag-disabled-group-container", e);
  }
  setupTitleBar() {
    const e = this.useToggle ? this.createToggleTitleBar() : this.createDefaultTitleBar();
    this.eToolbar.insertAdjacentElement("beforebegin", e.getGui());
  }
  createDefaultTitleBar() {
    const e = this.createManagedBean(new m_(this.params));
    return this.eTitleBar = e, e.refreshOnExpand(this.expanded), this.addManagedListeners(e, {
      expandedChanged: (t) => this.toggleGroupExpand(t.expanded)
    }), e;
  }
  createToggleTitleBar() {
    const e = this.createManagedBean(
      new oo({
        value: this.enabled,
        label: this.params.title,
        labelAlignment: "left",
        labelWidth: "flex",
        onValueChange: (t) => {
          this.setEnabled(t, !0), this.dispatchEnableChangeEvent(t);
        }
      })
    );
    return e.addCssClass("ag-group-title-bar"), e.addCssClass(`ag-${this.params.cssIdentifier ?? "default"}-group-title-bar ag-unselectable`), this.eToggle = e, this.toggleGroupExpand(this.enabled), e;
  }
}, Od = "ag-disabled-group-title-bar";
function f_(e) {
  const t = e.cssIdentifier ?? "default", s = e.suppressKeyboardNavigation ? "presentation" : "role";
  return (
    /* html */
    `
        <div class="ag-group-title-bar ag-${t}-group-title-bar ag-unselectable" role="${s}">
            <span class="ag-group-title-bar-icon ag-${t}-group-title-bar-icon" data-ref="eGroupOpenedIcon" role="presentation"></span>
            <span class="ag-group-title-bar-icon ag-${t}-group-title-bar-icon" data-ref="eGroupClosedIcon" role="presentation"></span>
            <span data-ref="eTitle" class="ag-group-title ag-${t}-group-title"></span>
        </div>
    `
  );
}
var m_ = class extends _ {
  constructor(e = {}) {
    super(f_(e)), this.suppressOpenCloseIcons = !1, this.suppressKeyboardNavigation = !1, this.eGroupOpenedIcon = E, this.eGroupClosedIcon = E, this.eTitle = E;
    const { title: t, suppressOpenCloseIcons: s, suppressKeyboardNavigation: i } = e;
    t && t.length > 0 && (this.title = t), s != null && (this.suppressOpenCloseIcons = s), this.suppressKeyboardNavigation = i ?? !1;
  }
  postConstruct() {
    this.setTitle(this.title), this.hideOpenCloseIcons(this.suppressOpenCloseIcons), this.setupExpandContract();
  }
  setupExpandContract() {
    this.eGroupClosedIcon.appendChild(br("accordionClosed", this.beans, null)), this.eGroupOpenedIcon.appendChild(br("accordionOpen", this.beans, null)), this.addManagedElementListeners(this.getGui(), {
      click: () => this.dispatchExpandChanged(),
      keydown: (e) => {
        switch (e.key) {
          case P.ENTER:
          case P.SPACE:
            e.preventDefault(), this.dispatchExpandChanged();
            break;
          case P.RIGHT:
          case P.LEFT:
            e.preventDefault(), this.dispatchExpandChanged(e.key === P.RIGHT);
            break;
        }
      }
    });
  }
  refreshOnExpand(e) {
    this.refreshAriaStatus(e), this.refreshOpenCloseIcons(e);
  }
  refreshAriaStatus(e) {
    this.suppressOpenCloseIcons || ns(this.getGui(), e);
  }
  refreshOpenCloseIcons(e) {
    const t = !this.suppressOpenCloseIcons;
    re(this.eGroupOpenedIcon, t && e), re(this.eGroupClosedIcon, t && !e);
  }
  isSuppressCollapse() {
    return this.suppressOpenCloseIcons;
  }
  dispatchExpandChanged(e) {
    const t = {
      type: "expandedChanged",
      expanded: e
    };
    this.dispatchLocalEvent(t);
  }
  setTitle(e) {
    const t = this.getGui(), s = !!e && e.length > 0;
    e = s ? e : void 0, this.eTitle.textContent = e ?? "", re(t, s), e !== this.title && (this.title = e);
    const i = t.classList.contains(Od);
    return this.refreshDisabledStyles(i), this;
  }
  addWidget(e) {
    return this.getGui().appendChild(e), this;
  }
  hideOpenCloseIcons(e) {
    return this.suppressOpenCloseIcons = e, e && this.dispatchExpandChanged(!0), this;
  }
  refreshDisabledStyles(e) {
    const t = this.getGui();
    e ? (t.classList.add(Od), t.removeAttribute("tabindex")) : (t.classList.remove(Od), typeof this.title == "string" && !this.suppressKeyboardNavigation ? t.setAttribute("tabindex", "0") : t.removeAttribute("tabindex"));
  }
}, dt = {
  selector: "AG-GROUP-COMPONENT",
  component: qi
};
function Nb(e) {
  const { filters: t } = e;
  return t && t.length > 0 ? t : [{ filter: "agTextColumnFilter" }, { filter: "agSetColumnFilter" }];
}
function Uf(e, t) {
  if (e != null)
    for (let s = e.length - 1; s >= 0; s--)
      t(e[s], s);
}
function C_(e, t) {
  return t.title != null ? t.title : e instanceof Cc ? e.getFilterTitle() : "Filter";
}
var Hb = class extends Ti {
  constructor() {
    super(
      /* html */
      '<div class="ag-multi-filter ag-menu-list-compact"></div>'
    ), this.filterType = "multi", this.filterDefs = [], this.filters = [], this.guiDestroyFuncs = [], this.filterGuis = [], this.activeFilterIndices = [], this.lastActivatedMenuItem = null, this.afterFiltersReadyFuncs = [];
  }
  postConstruct() {
    this.initialiseTabGuard({
      onFocusIn: (e) => this.onFocusIn(e)
    });
  }
  init(e) {
    this.params = e, this.filterDefs = Nb(e);
    const { column: t, filterChangedCallback: s } = e;
    this.column = t, this.filterChangedCallback = s;
    const i = [];
    return this.filterDefs.forEach((r, n) => {
      const o = this.createFilter(r, n);
      o != null && i.push(o);
    }), new fe((r) => {
      fe.all(i).then((n) => {
        this.filters = n, this.refreshGui("columnMenu").then(() => {
          r();
        });
      });
    }).then(() => {
      this.afterFiltersReadyFuncs.forEach((r) => r()), this.afterFiltersReadyFuncs.length = 0;
    });
  }
  refreshGui(e) {
    return e === this.lastOpenedInContainer ? fe.resolve() : (this.tabGuardFeature.removeAllChildrenExceptTabGuards(), this.destroyChildren(), fe.all(
      this.filters.map((t, s) => {
        const i = this.filterDefs[s], r = C_(t, i);
        let n;
        if (i.display === "subMenu" && e !== "toolPanel")
          n = this.insertFilterMenu(t, r).then(
            (o) => o.getGui()
          );
        else if (i.display === "subMenu" || i.display === "accordion") {
          const o = this.insertFilterGroup(t, r);
          n = fe.resolve(o.getGui());
        } else
          n = fe.resolve(t.getGui());
        return n;
      })
    ).then((t) => {
      t.forEach((s, i) => {
        i > 0 && this.appendChild(ss(
          /* html */
          '<div class="ag-filter-separator"></div>'
        )), this.appendChild(s);
      }), this.filterGuis = t, this.lastOpenedInContainer = e;
    }));
  }
  destroyChildren() {
    this.guiDestroyFuncs.forEach((e) => e()), this.guiDestroyFuncs.length = 0, this.filterGuis.length = 0;
  }
  insertFilterMenu(e, t) {
    const s = this.createBean(new Mu());
    return s.init({
      menuItemDef: {
        name: t,
        subMenu: [],
        cssClasses: ["ag-multi-filter-menu-item"],
        menuItem: Cb,
        menuItemParams: {
          cssClassPrefix: "ag-compact-menu-option",
          isCompact: !0
        }
      },
      level: 0,
      isAnotherSubMenuOpen: () => !1,
      childComponent: e,
      contextParams: {
        column: null,
        node: null,
        value: null
      }
    }).then(() => {
      s.setParentComponent(this), this.guiDestroyFuncs.push(() => this.destroyBean(s)), this.addManagedListeners(s, {
        menuItemActivated: (r) => {
          this.lastActivatedMenuItem && this.lastActivatedMenuItem !== r.menuItem && this.lastActivatedMenuItem.deactivate(), this.lastActivatedMenuItem = r.menuItem;
        }
      });
      const i = s.getGui();
      return s.addManagedElementListeners(i, {
        // `AgMenuList` normally handles keyboard navigation, so need to do here
        keydown: (r) => {
          const { key: n } = r;
          switch (n) {
            case P.UP:
            case P.RIGHT:
            case P.DOWN:
            case P.LEFT:
              r.preventDefault(), n === P.RIGHT && s.openSubMenu(!0);
              break;
          }
        },
        focusin: () => s.activate(),
        focusout: () => {
          !s.isSubMenuOpen() && !s.isSubMenuOpening() && s.deactivate();
        }
      }), s;
    });
  }
  insertFilterGroup(e, t) {
    const s = this.createBean(
      new qi({
        title: t,
        cssIdentifier: "multi-filter"
      })
    );
    return this.guiDestroyFuncs.push(() => this.destroyBean(s)), s.addItem(e.getGui()), s.toggleGroupExpand(!1), e.afterGuiAttached && s.addManagedListeners(s, {
      expanded: () => e.afterGuiAttached({
        container: this.lastOpenedInContainer,
        suppressFocus: !0,
        hidePopup: this.hidePopup
      })
    }), s;
  }
  isFilterActive() {
    return this.filters.some((e) => e.isFilterActive());
  }
  getLastActiveFilterIndex() {
    const e = this.activeFilterIndices;
    return e.length > 0 ? e[e.length - 1] : null;
  }
  doesFilterPass(e, t) {
    let s = !0;
    return this.filters.forEach((i) => {
      !s || i === t || !i.isFilterActive() || (s = i.doesFilterPass(e));
    }), s;
  }
  getModelFromUi() {
    return {
      filterType: this.filterType,
      filterModels: this.filters.map((t) => {
        const s = t;
        return typeof s.getModelFromUi == "function" ? s.getModelFromUi() : null;
      })
    };
  }
  getModel() {
    return this.isFilterActive() ? {
      filterType: this.filterType,
      filterModels: this.filters.map((t) => t.isFilterActive() ? t.getModel() : null)
    } : null;
  }
  setModel(e) {
    const t = (i, r) => new fe((n) => {
      const o = i.setModel(r);
      o ? o.then(() => n()) : n();
    });
    let s = [];
    return e == null ? s = this.filters.map((i, r) => t(i, null).then(() => {
      this.updateActiveList(r);
    })) : this.filters.forEach((i, r) => {
      const n = e.filterModels.length > r ? e.filterModels[r] : null, o = t(i, n).then(() => {
        this.updateActiveList(r);
      });
      s.push(o);
    }), fe.all(s).then(() => {
    });
  }
  applyModel(e = "api") {
    let t = !1;
    return this.filters.forEach((s) => {
      s instanceof Cc && (t = s.applyModel(e) || t);
    }), t;
  }
  getChildFilterInstance(e) {
    return this.filters[e];
  }
  afterGuiAttached(e) {
    let t;
    e ? (this.hidePopup = e.hidePopup, t = this.refreshGui(e.container)) : (this.hidePopup = void 0, t = fe.resolve());
    const s = e == null ? void 0 : e.suppressFocus;
    t.then(() => {
      const { filterDefs: i, filters: r, filterGuis: n, beans: o } = this;
      let a = !!s;
      i && Uf(i, (c, d) => {
        const u = d === 0, h = c.display && c.display !== "inline", p = s || !u || h, g = { ...e ?? {}, suppressFocus: p }, f = r == null ? void 0 : r[d];
        if (f && (this.executeFunctionIfExistsOnFilter(f, "afterGuiAttached", g), u && !p && (a = !0)), !s && u && h) {
          const m = n[d];
          m && (Dt(m) || m.focus({ preventScroll: !0 }), a = !0);
        }
      });
      const l = Ie(o);
      !a && (Fr(o) || this.getGui().contains(l)) && this.forceFocusOutOfContainer(!0);
    });
  }
  afterGuiDetached() {
    this.executeFunctionIfExists("afterGuiDetached");
  }
  onAnyFilterChanged() {
    this.executeFunctionIfExists("onAnyFilterChanged");
  }
  onNewRowsLoaded() {
    this.executeFunctionIfExists("onNewRowsLoaded");
  }
  destroy() {
    this.filters.forEach((e) => this.destroyBean(e)), this.filters.length = 0, this.destroyChildren(), this.hidePopup = void 0, super.destroy();
  }
  executeFunctionIfExists(e, ...t) {
    Uf(this.filters, (s) => {
      this.executeFunctionIfExistsOnFilter(s, e, t);
    });
  }
  executeFunctionIfExistsOnFilter(e, t, ...s) {
    const i = e[t];
    typeof i == "function" && i.apply(e, s);
  }
  createFilter(e, t) {
    const { filterModifiedCallback: s, doesRowPassOtherFilter: i } = this.params, { filterManager: r, userCompFactory: n } = this.beans;
    let o;
    const a = {
      ...r.createFilterParams(this.column, this.column.getColDef()),
      filterModifiedCallback: s,
      filterChangedCallback: (d) => {
        this.executeWhenAllFiltersReady(() => this.filterChanged(t, d));
      },
      doesRowPassOtherFilter: (d) => i(d) && this.doesFilterPass({ node: d, data: d.data }, o)
    }, l = Qv(n, e, a, "agTextColumnFilter");
    if (!l)
      return null;
    const c = l.newAgStackInstance();
    return c.then((d) => o = d), c;
  }
  executeWhenAllFiltersReady(e) {
    var t;
    (((t = this.filters) == null ? void 0 : t.length) ?? 0) > 0 ? e() : this.afterFiltersReadyFuncs.push(e);
  }
  updateActiveList(e) {
    const { filters: t, activeFilterIndices: s } = this, i = t[e];
    kt(s, e), i.isFilterActive() && s.push(e);
  }
  filterChanged(e, t) {
    this.updateActiveList(e), this.filterChangedCallback(t);
    const s = this.filters[e];
    this.filters.forEach((i) => {
      i !== s && typeof i.onAnyFilterChanged == "function" && i.onAnyFilterChanged();
    });
  }
  onFocusIn(e) {
    const t = this.lastActivatedMenuItem;
    t != null && !t.getGui().contains(e.target) && (t.deactivate(), this.lastActivatedMenuItem = null);
  }
  getModelAsString(e) {
    var i, r;
    if (!this.filters || !((i = e == null ? void 0 : e.filterModels) != null && i.length))
      return "";
    const t = this.getLastActiveFilterIndex() ?? 0, s = this.filters[t];
    return ((r = s.getModelAsString) == null ? void 0 : r.call(s, e.filterModels[t])) ?? "";
  }
}, v_ = class extends _ {
  constructor() {
    super(
      /* html */
      '<div class="ag-multi-floating-filter ag-floating-filter-input"></div>'
    ), this.floatingFilters = [], this.compDetailsList = [];
  }
  init(e) {
    this.params = e;
    const { compDetailsList: t } = this.getCompDetailsList(e);
    return this.setParams(t);
  }
  setParams(e) {
    const t = [];
    return e.forEach((s) => {
      const i = s == null ? void 0 : s.newAgStackInstance();
      i != null && (this.compDetailsList.push(s), t.push(i));
    }), fe.all(t).then((s) => {
      s.forEach((i, r) => {
        this.floatingFilters.push(i);
        const n = i.getGui();
        this.appendChild(n), r > 0 && re(n, !1);
      });
    });
  }
  refresh(e) {
    this.params = e;
    const { compDetailsList: t, floatingFilterParamsList: s } = this.getCompDetailsList(e);
    t.length === this.compDetailsList.length && t.every(
      (r, n) => {
        var o;
        return !((o = this.beans.filterManager) != null && o.areFilterCompsDifferent(this.compDetailsList[n], r));
      }
    ) ? s.forEach((r, n) => {
      var a;
      const o = this.floatingFilters[n];
      (a = o.refresh) == null || a.call(o, r);
    }) : (ze(this.getGui()), this.destroyBeans(this.floatingFilters), this.floatingFilters = [], this.compDetailsList = [], this.setParams(t));
  }
  getCompDetailsList(e) {
    const t = [], s = [], i = e.filterParams, r = e.currentParentModel;
    return Nb(i).forEach((n, o) => {
      const a = {
        ...e,
        // set the parent filter instance for each floating filter to the relevant child filter instance
        parentFilterInstance: (c) => {
          this.parentMultiFilterInstance((d) => {
            const u = d.getChildFilterInstance(o);
            u != null && c(u);
          });
        },
        // return the parent model for the specific filter
        currentParentModel: () => {
          var c, d;
          return ((d = (c = r()) == null ? void 0 : c.filterModels) == null ? void 0 : d[o]) ?? null;
        }
      };
      bt(a.filterParams, n.filterParams);
      const l = this.getCompDetails(n, a);
      l && (t.push(l), s.push(a));
    }), { compDetailsList: t, floatingFilterParamsList: s };
  }
  onParentModelChanged(e, t) {
    t && t.afterFloatingFilter || this.parentMultiFilterInstance((s) => {
      if (e == null)
        this.floatingFilters.forEach((i, r) => {
          i.onParentModelChanged(null, t), re(i.getGui(), r === 0);
        });
      else {
        const i = s.getLastActiveFilterIndex();
        this.floatingFilters.forEach((r, n) => {
          const o = e.filterModels.length > n ? e.filterModels[n] : null;
          r.onParentModelChanged(o, t);
          const a = i == null ? n === 0 : n === i;
          re(r.getGui(), a);
        });
      }
    });
  }
  destroy() {
    this.destroyBeans(this.floatingFilters), this.floatingFilters.length = 0, super.destroy();
  }
  getCompDetails(e, t) {
    const { filterManager: s, frameworkOverrides: i, userCompFactory: r } = this.beans, n = xw(
      i,
      e,
      () => s.getDefaultFloatingFilter(this.params.column)
    ) ?? "agReadOnlyFloatingFilter";
    return Jv(r, e, t, n);
  }
  parentMultiFilterInstance(e) {
    this.params.parentFilterInstance((t) => {
      t instanceof Hb || be(120), e(t);
    });
  }
}, w_ = {
  moduleName: "MultiFilter",
  version: Me,
  userComponents: { agMultiColumnFilter: Hb, agMultiColumnFloatingFilter: v_ },
  dependsOn: [Je, kr, Dc]
}, y_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "aggColNameSvc";
  }
  getHeaderName(e, t) {
    if (this.gos.get("suppressAggFuncInHeader"))
      return t;
    const { valueColsSvc: s, colModel: i, rowGroupColsSvc: r } = this.beans, n = e.getColDef().pivotValueColumn, o = W(n);
    let a = null, l;
    if (o) {
      const c = (s == null ? void 0 : s.columns) ?? [], d = this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && c.length === 1, u = e.getColDef().pivotTotalColumnIds !== void 0;
      if (d && !u)
        return t;
      a = n ? n.getAggFunc() : null, l = !0;
    } else {
      const c = e.isValueActive(), d = i.isPivotMode() || (r == null ? void 0 : r.columns.length) !== 0;
      c && d ? (a = e.getAggFunc(), l = !0) : l = !1;
    }
    if (l) {
      const c = typeof a == "string" ? a : "func";
      return `${this.getLocaleTextFunc()(c, c)}(${t})`;
    }
    return t;
  }
}, b_ = {
  sum: "Sum",
  first: "First",
  last: "Last",
  min: "Min",
  max: "Max",
  count: "Count",
  avg: "Average"
}, S_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "aggFuncSvc", this.aggFuncsMap = {}, this.initialised = !1;
  }
  postConstruct() {
    this.init();
  }
  init() {
    this.initialised || (this.initialiseWithDefaultAggregations(), this.addAggFuncs(this.gos.get("aggFuncs")));
  }
  initialiseWithDefaultAggregations() {
    const e = this.aggFuncsMap;
    e.sum = x_, e.first = R_, e.last = F_, e.min = P_, e.max = T_, e.count = E_, e.avg = D_, this.initialised = !0;
  }
  isAggFuncPossible(e, t) {
    const i = this.getFuncNames(e).includes(t), r = W(this.aggFuncsMap[t]);
    return i && r;
  }
  getDefaultFuncLabel(e) {
    return b_[e] ?? e;
  }
  getDefaultAggFunc(e) {
    const t = e.getColDef().defaultAggFunc;
    if (W(t) && this.isAggFuncPossible(e, t))
      return t;
    if (this.isAggFuncPossible(e, "sum"))
      return "sum";
    const s = this.getFuncNames(e);
    return s != null && s.length ? s[0] : null;
  }
  addAggFuncs(e) {
    this.init(), e && Object.entries(e).forEach(([t, s]) => {
      this.aggFuncsMap[t] = s;
    });
  }
  getAggFunc(e) {
    return this.init(), this.aggFuncsMap[e];
  }
  getFuncNames(e) {
    const t = e.getColDef().allowedAggFuncs;
    return t ?? Object.keys(this.aggFuncsMap).sort();
  }
  clear() {
    this.aggFuncsMap = {};
  }
};
function x_(e) {
  const { values: t } = e;
  let s = null;
  for (let i = 0; i < t.length; i++) {
    const r = t[i];
    typeof r == "number" ? s === null ? s = r : s += typeof s == "number" ? r : BigInt(r) : typeof r == "bigint" && (s === null ? s = r : s = (typeof s == "bigint" ? s : BigInt(s)) + r);
  }
  return s;
}
function R_(e) {
  return e.values.length > 0 ? e.values[0] : null;
}
function F_(e) {
  return e.values.length > 0 ? pe(e.values) : null;
}
function P_(e) {
  const { values: t } = e;
  let s = null;
  for (let i = 0; i < t.length; i++) {
    const r = t[i];
    (typeof r == "number" || typeof r == "bigint") && (s === null || s > r) && (s = r);
  }
  return s;
}
function T_(e) {
  const { values: t } = e;
  let s = null;
  for (let i = 0; i < t.length; i++) {
    const r = t[i];
    (typeof r == "number" || typeof r == "bigint") && (s === null || s < r) && (s = r);
  }
  return s;
}
function E_(e) {
  var r, n;
  const { values: t } = e;
  let s = 0;
  for (let o = 0; o < t.length; o++) {
    const a = t[o];
    s += a != null && typeof a.value == "number" ? a.value : 1;
  }
  const i = (n = (r = e.rowNode) == null ? void 0 : r.aggData) == null ? void 0 : n[e.column.getColId()];
  return i && i.value === s ? i : {
    value: s,
    toString: function() {
      return this.value.toString();
    },
    // used for sorting
    toNumber: function() {
      return this.value;
    }
  };
}
function D_(e) {
  var o, a, l;
  const { values: t } = e;
  let s = 0, i = 0;
  for (let c = 0; c < t.length; c++) {
    const d = t[c];
    let u = null;
    typeof d == "number" || typeof d == "bigint" ? (u = d, i++) : d != null && (typeof d.value == "number" || typeof d.value == "bigint") && typeof d.count == "number" && (u = d.value * (typeof d.value == "number" ? d.count : BigInt(d.count)), i += d.count), typeof u == "number" ? s += typeof s == "number" ? u : BigInt(u) : typeof u == "bigint" && (s = (typeof s == "bigint" ? s : BigInt(s)) + u);
  }
  let r = null;
  i > 0 && (r = s / (typeof s == "number" ? i : BigInt(i)));
  const n = (l = (o = e.rowNode) == null ? void 0 : o.aggData) == null ? void 0 : l[(a = e.column) == null ? void 0 : a.getColId()];
  return n && n.count === i && n.value === r ? n : {
    count: i,
    value: r,
    // the grid by default uses toString to render values for an object, so this
    // is a trick to get the default cellRenderer to display the avg value
    toString: function() {
      return typeof this.value == "number" || typeof this.value == "bigint" ? this.value.toString() : "";
    },
    // used for sorting
    toNumber: function() {
      return this.value;
    }
  };
}
function A_(e, t) {
  e.aggFuncSvc && e.aggFuncSvc.addAggFuncs(t);
}
function M_(e) {
  e.aggFuncSvc && e.aggFuncSvc.clear();
}
function I_(e, t, s) {
  var i, r;
  (r = (i = e.valueColsSvc) == null ? void 0 : i.setColumnAggFunc) == null || r.call(i, t, s, "api");
}
var L_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "aggStage", this.refreshProps = /* @__PURE__ */ new Set([
      "getGroupRowAgg",
      "alwaysAggregateAtRootLevel",
      "suppressAggFilteredOnly",
      "grandTotalRow"
    ]), this.step = "aggregate";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.aggFuncSvc = e.aggFuncSvc, this.pivotColsSvc = e.pivotColsSvc, this.valueColsSvc = e.valueColsSvc, this.pivotResultCols = e.pivotResultCols, this.valueSvc = e.valueSvc;
  }
  // it's possible to recompute the aggregate without doing the other parts
  // + api.refreshClientSideRowModel('aggregate')
  execute(e) {
    var r, n, o;
    const t = !((n = (r = this.valueColsSvc) == null ? void 0 : r.columns) != null && n.length), s = !this.gos.getCallback("getGroupRowAgg");
    if (t && s && ((o = e.changedPath) != null && o.active))
      return;
    const i = this.createAggDetails(e);
    this.recursivelyCreateAggData(i);
  }
  createAggDetails(e) {
    var n;
    const t = this.colModel.isPivotActive(), s = (n = this.valueColsSvc) == null ? void 0 : n.columns, i = t && this.pivotColsSvc ? this.pivotColsSvc.columns : [];
    return {
      alwaysAggregateAtRootLevel: this.gos.get("alwaysAggregateAtRootLevel"),
      groupIncludeTotalFooter: !!dc(this.gos),
      changedPath: e.changedPath,
      valueColumns: s ?? [],
      pivotColumns: i,
      filteredOnly: !this.isSuppressAggFilteredOnly(),
      userAggFunc: this.gos.getCallback("getGroupRowAgg")
    };
  }
  isSuppressAggFilteredOnly() {
    return ia(this.gos) !== void 0 || this.gos.get("suppressAggFilteredOnly");
  }
  recursivelyCreateAggData(e) {
    const t = (s) => {
      if (!s.hasChildren()) {
        s.aggData && this.setAggData(s, null);
        return;
      }
      if (s.level === -1 && !e.groupIncludeTotalFooter) {
        const n = !this.colModel.isPivotMode();
        if (!e.alwaysAggregateAtRootLevel && n) {
          this.setAggData(s, null);
          return;
        }
      }
      this.aggregateRowNode(s, e);
    };
    e.changedPath.forEachChangedNodeDepthFirst(t, !0);
  }
  aggregateRowNode(e, t) {
    const s = t.valueColumns.length === 0, i = t.pivotColumns.length === 0;
    let r;
    t.userAggFunc ? r = t.userAggFunc({ nodes: e.childrenAfterFilter }) : s ? r = null : i ? r = this.aggregateRowNodeUsingValuesOnly(e, t) : r = this.aggregateRowNodeUsingValuesAndPivot(e), this.setAggData(e, r), e.sibling && this.setAggData(e.sibling, r);
  }
  aggregateRowNodeUsingValuesAndPivot(e) {
    var r, n;
    const t = {}, s = ((n = (r = this.pivotResultCols) == null ? void 0 : r.getPivotResultCols()) == null ? void 0 : n.list) ?? [];
    let i = !0;
    for (let o = 0; o < s.length; o++) {
      const a = s[o], l = a.getColDef();
      if (l.pivotTotalColumnIds != null) {
        i = !1;
        continue;
      }
      const c = l.pivotKeys ?? [];
      let d;
      e.leafGroup ? d = this.getValuesFromMappedSet(e.childrenMapped, c, l.pivotValueColumn) : d = this.getValuesPivotNonLeaf(e, l.colId), t[l.colId] = this.aggregateValues(
        d,
        l.pivotValueColumn.getAggFunc(),
        l.pivotValueColumn,
        e,
        a
      );
    }
    if (!i)
      for (let o = 0; o < s.length; o++) {
        const a = s[o], l = a.getColDef();
        if (l.pivotTotalColumnIds == null || !l.pivotTotalColumnIds.length)
          continue;
        const c = l.pivotTotalColumnIds.map(
          (d) => t[d]
        );
        t[l.colId] = this.aggregateValues(
          c,
          l.pivotValueColumn.getAggFunc(),
          l.pivotValueColumn,
          e,
          a
        );
      }
    return t;
  }
  aggregateRowNodeUsingValuesOnly(e, t) {
    const s = {}, { changedPath: i, valueColumns: r, filteredOnly: n } = t, o = i.active ? i.getValueColumnsForNode(e, r) : r, a = i.active ? i.getNotValueColumnsForNode(e, r) : null, l = this.getValuesNormal(e, o, n), c = e.aggData;
    return o.forEach((d, u) => {
      s[d.getId()] = this.aggregateValues(
        l[u],
        d.getAggFunc(),
        d,
        e
      );
    }), a && c && a.forEach((d) => {
      s[d.getId()] = c[d.getId()];
    }), s;
  }
  getValuesPivotNonLeaf(e, t) {
    return e.childrenAfterFilter.map((s) => s.aggData[t]);
  }
  getValuesFromMappedSet(e, t, s) {
    let i = e;
    for (let r = 0; r < t.length; r++) {
      const n = t[r];
      i = i ? i[n] : null;
    }
    return i ? i.map((r) => this.valueSvc.getValue(s, r)) : [];
  }
  getValuesNormal(e, t, s) {
    const i = [];
    t.forEach(() => i.push([]));
    const r = t.length, n = s ? e.childrenAfterFilter : e.childrenAfterGroup, o = n.length;
    for (let a = 0; a < o; a++) {
      const l = n[a];
      for (let c = 0; c < r; c++) {
        const d = t[c], u = this.valueSvc.getValue(d, l);
        i[c].push(u);
      }
    }
    return i;
  }
  aggregateValues(e, t, s, i, r) {
    const n = typeof t == "string" ? this.aggFuncSvc.getAggFunc(t) : t;
    if (typeof n != "function")
      return be(109, { aggFuncOrString: t }), null;
    const o = n, a = this.gos.addGridCommonParams({
      values: e,
      column: s,
      colDef: s ? s.getColDef() : void 0,
      pivotResultColumn: r,
      rowNode: i,
      data: i ? i.data : void 0
    });
    return o(a);
  }
  setAggData(e, t) {
    const s = e.aggData;
    if (e.aggData = t, e.__localEventService) {
      const i = (r) => {
        const n = e.aggData ? e.aggData[r] : void 0, o = s ? s[r] : void 0;
        if (n === o)
          return;
        const a = this.colModel.getCol(r);
        a && e.dispatchCellChangedEvent(a, n, o);
      };
      if (s)
        for (const r of Object.keys(s))
          i(r);
      if (t)
        for (const r of Object.keys(t))
          (!s || !(r in s)) && i(r);
    }
  }
}, k_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "filterAggStage", this.refreshProps = /* @__PURE__ */ new Set([]), this.step = "filter_aggregates";
  }
  wireBeans(e) {
    this.filterManager = e.filterManager;
  }
  execute(e) {
    var c, d;
    const t = this.beans.colModel.isPivotMode(), s = ((c = this.filterManager) == null ? void 0 : c.isAggregateFilterPresent()) || ((d = this.filterManager) == null ? void 0 : d.isAggregateQuickFilterPresent()), i = (u) => !u.node.group, r = (u) => u.node.leafGroup, n = ia(this.gos) || (t ? r : i), { changedPath: o } = e, a = (u, h = !1) => {
      u.childrenAfterFilter && (u.childrenAfterAggFilter = u.childrenAfterFilter, h && u.childrenAfterAggFilter.forEach((p) => a(p, h)), this.setAllChildrenCount(u)), u.sibling && (u.sibling.childrenAfterAggFilter = u.childrenAfterAggFilter);
    }, l = (u) => {
      var h;
      u.childrenAfterAggFilter = ((h = u.childrenAfterFilter) == null ? void 0 : h.filter((p) => {
        var m;
        return n({ node: p }) && this.filterManager.doesRowPassAggregateFilters({ rowNode: p }) ? (a(p, !0), !0) : (m = p.childrenAfterAggFilter) == null ? void 0 : m.length;
      })) || null, this.setAllChildrenCount(u), u.sibling && (u.sibling.childrenAfterAggFilter = u.childrenAfterAggFilter);
    };
    o.forEachChangedNodeDepthFirst(s ? l : a, !0);
  }
  /** for tree data, we include all children, groups and leafs */
  setAllChildrenCountTreeData(e) {
    const t = e.childrenAfterAggFilter;
    let s = 0;
    if (t) {
      const i = t.length;
      s = i;
      for (let r = 0; r < i; ++r)
        s += t[r].allChildrenCount ?? 0;
    }
    e.setAllChildrenCount(
      // Maintain the historical behaviour:
      // - allChildrenCount is 0 in the root if there are no children
      // - allChildrenCount is null in any non-root row if there are no children
      s === 0 && e.level >= 0 ? null : s
    );
  }
  /* for grid data, we only count the leafs */
  setAllChildrenCountGridGrouping(e) {
    let t = 0;
    e.childrenAfterAggFilter.forEach((s) => {
      s.group ? t += s.allChildrenCount : t++;
    }), e.setAllChildrenCount(t);
  }
  setAllChildrenCount(e) {
    if (!e.hasChildren()) {
      e.setAllChildrenCount(null);
      return;
    }
    this.gos.get("treeData") ? this.setAllChildrenCountTreeData(e) : this.setAllChildrenCountGridGrouping(e);
  }
}, O_ = /* @__PURE__ */ new Set(["__localEventService", "__objectId", "sticky", "__autoHeights", "__checkAutoHeightsDebounced"]);
function Wi(e, t) {
  if (e.sibling)
    return;
  const s = new bs(t);
  Object.keys(e).forEach((i) => {
    O_.has(i) || (s[i] = e[i]);
  }), s.footer = !0, s.setRowTop(null), s.setRowIndex(null), s.oldRowTop = null, s.id = "rowGroupFooter_" + e.id, s.sibling = e, e.sibling = s;
}
function Qh(e) {
  e.sibling && (e.sibling.setRowTop(null), e.sibling.setRowIndex(null), e.sibling = void 0);
}
var G_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "footerSvc";
  }
  addNodes(e, t, s, i, r, n) {
    var h;
    const o = (h = t[0]) == null ? void 0 : h.parent;
    if (!o)
      return;
    let { index: a } = e;
    const l = i && dc(this.gos), c = Xn(this.gos), d = i && c({ node: o });
    if (o === r) {
      l === n && (Wi(o, this.beans), s(o.sibling, a++));
      return;
    }
    d === n && (Wi(o, this.beans), s(o.sibling, a++));
  }
  getTopDisplayIndex(e, t, s, i) {
    let r = t;
    if (e[0].footer) {
      if (t === 0)
        return 0;
      r -= 1;
    }
    const n = e[e.length - 1], o = r >= s.length;
    return n.footer && o ? n.rowIndex : i(r);
  }
}, zb = class extends gh {
  constructor() {
    super(...arguments), this.beanName = "valueColsSvc", this.eventName = "columnValueChanged", this.columnProcessors = {
      set: (e, t, s) => this.setValueActive(t, e, s),
      add: (e, t, s) => this.setValueActive(!0, e, s),
      remove: (e, t, s) => this.setValueActive(!1, e, s)
    }, this.columnExtractors = {
      setFlagFunc: (e, t, s) => this.setColValueActive(e, t, s),
      getIndexFunc: () => {
      },
      getInitialIndexFunc: () => {
      },
      getValueFunc: (e) => {
        const t = e.aggFunc;
        if (t === null || t === "")
          return null;
        if (t !== void 0)
          return !!t;
      },
      getInitialValueFunc: (e) => e.initialAggFunc != null && e.initialAggFunc != ""
    }, this.modifyColumnsNoEventsCallbacks = {
      addCol: (e) => this.columns.push(e),
      removeCol: (e) => kt(this.columns, e)
    };
  }
  extractCols(e, t) {
    return this.columns = super.extractCols(e, t), this.columns.forEach((s) => {
      const i = s.getColDef();
      i.aggFunc != null && i.aggFunc != "" ? this.setColAggFunc(s, i.aggFunc) : s.getAggFunc() || this.setColAggFunc(s, i.initialAggFunc);
    }), this.columns;
  }
  setColumnAggFunc(e, t, s) {
    if (!e)
      return;
    const i = this.colModel.getColDefCol(e);
    i && (this.setColAggFunc(i, t), this.dispatchColumnChangedEvent(this.eventSvc, this.eventName, [i], s));
  }
  syncColumnWithState(e, t, s) {
    const i = s("aggFunc").value1;
    i !== void 0 && (typeof i == "string" ? (this.setColAggFunc(e, i), e.isValueActive() || (this.setColValueActive(e, !0, t), this.modifyColumnsNoEventsCallbacks.addCol(e))) : (W(i) && I(33), e.isValueActive() && (this.setColValueActive(e, !1, t), this.modifyColumnsNoEventsCallbacks.removeCol(e))));
  }
  setValueActive(e, t, s) {
    if (e !== t.isValueActive() && (this.setColValueActive(t, e, s), e && !t.getAggFunc() && this.aggFuncSvc)) {
      const i = this.aggFuncSvc.getDefaultAggFunc(t);
      this.setColAggFunc(t, i);
    }
  }
  setColAggFunc(e, t) {
    e.aggFunc = t, e.dispatchStateUpdatedEvent("aggFunc");
  }
  setColValueActive(e, t, s) {
    e.aggregationActive !== t && (e.aggregationActive = t, e.dispatchColEvent("columnValueChanged", s));
  }
}, Jh = {
  moduleName: "SharedAggregation",
  version: Me,
  beans: [S_, y_, G_, zb],
  apiFunctions: {
    addAggFuncs: A_,
    clearAggFuncs: M_,
    setColumnAggFunc: I_
  },
  dependsOn: [Je]
}, Wb = {
  moduleName: "Aggregation",
  version: Me,
  beans: [L_, k_],
  rowModels: ["clientSide"],
  dependsOn: [Jh]
}, _b = class extends gh {
  constructor() {
    super(...arguments), this.beanName = "pivotColsSvc", this.eventName = "columnPivotChanged", this.columnProcessors = {
      set: (e, t, s) => this.setColPivotActive(e, t, s),
      add: (e, t, s) => this.setColPivotActive(e, !0, s),
      remove: (e, t, s) => this.setColPivotActive(e, !1, s)
    }, this.columnOrdering = {
      enableProp: "pivot",
      initialEnableProp: "initialPivot",
      indexProp: "pivotIndex",
      initialIndexProp: "initialPivotIndex"
    }, this.columnExtractors = {
      setFlagFunc: (e, t, s) => this.setColPivotActive(e, t, s),
      getIndexFunc: (e) => e.pivotIndex,
      getInitialIndexFunc: (e) => e.initialPivotIndex,
      getValueFunc: (e) => e.pivot,
      getInitialValueFunc: (e) => e.initialPivot
    }, this.modifyColumnsNoEventsCallbacks = {
      addCol: (e) => this.columns.push(e),
      removeCol: (e) => kt(this.columns, e)
    };
  }
  syncColumnWithState(e, t, s, i) {
    const { value1: r, value2: n } = s("pivot", "pivotIndex");
    (r !== void 0 || n !== void 0) && (typeof n == "number" || r ? (e.isPivotActive() || (this.setColPivotActive(e, !0, t), this.modifyColumnsNoEventsCallbacks.addCol(e)), i && typeof n == "number" && (i[e.getId()] = n)) : e.isPivotActive() && (this.setColPivotActive(e, !1, t), this.modifyColumnsNoEventsCallbacks.removeCol(e)));
  }
  setColPivotActive(e, t, s) {
    e.pivotActive !== t && (e.pivotActive = t, e.dispatchColEvent("columnPivotChanged", s)), e.dispatchStateUpdatedEvent("pivot");
  }
}, B_ = class extends gh {
  constructor() {
    super(...arguments), this.beanName = "rowGroupColsSvc", this.eventName = "columnRowGroupChanged", this.columnProcessors = {
      set: (e, t, s) => this.setActive(t, e, s),
      add: (e, t, s) => this.setActive(!0, e, s),
      remove: (e, t, s) => this.setActive(!1, e, s)
    }, this.columnOrdering = {
      enableProp: "rowGroup",
      initialEnableProp: "initialRowGroup",
      indexProp: "rowGroupIndex",
      initialIndexProp: "initialRowGroupIndex"
    }, this.columnExtractors = {
      setFlagFunc: (e, t, s) => this.setColRowGroupActive(e, t, s),
      getIndexFunc: (e) => e.rowGroupIndex,
      getInitialIndexFunc: (e) => e.initialRowGroupIndex,
      getValueFunc: (e) => e.rowGroup,
      getInitialValueFunc: (e) => e.initialRowGroup
    }, this.modifyColumnsNoEventsCallbacks = {
      addCol: (e) => this.columns.push(e),
      removeCol: (e) => kt(this.columns, e)
    };
  }
  moveColumn(e, t, s) {
    if (this.columns.length === 0)
      return;
    const i = this.columns[e], r = this.columns.slice(e, t);
    this.columns.splice(e, 1), this.columns.splice(t, 0, i), this.eventSvc.dispatchEvent({
      type: this.eventName,
      columns: r,
      column: r.length === 1 ? r[0] : null,
      source: s
    });
  }
  syncColumnWithState(e, t, s, i) {
    const { value1: r, value2: n } = s("rowGroup", "rowGroupIndex");
    (r !== void 0 || n !== void 0) && (typeof n == "number" || r ? (e.isRowGroupActive() || (this.setColRowGroupActive(e, !0, t), this.modifyColumnsNoEventsCallbacks.addCol(e)), i && typeof n == "number" && (i[e.getId()] = n)) : e.isRowGroupActive() && (this.setColRowGroupActive(e, !1, t), this.modifyColumnsNoEventsCallbacks.removeCol(e)));
  }
  setActive(e, t, s) {
    e !== t.isRowGroupActive() && (this.setColRowGroupActive(t, e, s), bv(this.gos, e) && this.colModel.setColsVisible([t], !e, s));
  }
  setColRowGroupActive(e, t, s) {
    e.rowGroupActive !== t && (e.rowGroupActive = t, e.dispatchColEvent("columnRowGroupChanged", s)), e.dispatchStateUpdatedEvent("rowGroup");
  }
}, V_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "autoColSvc";
  }
  postConstruct() {
    this.addManagedPropertyListener(
      "autoGroupColumnDef",
      (e) => this.onAutoGroupColumnDefChanged(cn(e.source))
    );
  }
  addAutoCols(e) {
    this.autoCols != null && (e.list = this.autoCols.list.concat(e.list), e.tree = this.autoCols.tree.concat(e.tree), Uv(e));
  }
  createAutoCols(e, t) {
    var M;
    const s = this.beans, { colModel: i, gos: r, rowGroupColsSvc: n, colGroupSvc: o } = s, a = i.isPivotMode(), l = uc(r, a), c = a ? r.get("pivotSuppressAutoColumn") : this.isSuppressAutoCol(), d = n == null ? void 0 : n.columns, h = !(d && d.length > 0 || r.get("treeData")) || c || l, p = () => {
      this.autoCols && (Er(s, this.autoCols.tree), this.autoCols = null);
    };
    if (h) {
      p();
      return;
    }
    const g = this.generateAutoCols(d), f = _v(g, ((M = this.autoCols) == null ? void 0 : M.list) || null), m = e.treeDepth, w = (this.autoCols ? this.autoCols.treeDepth : -1) == m;
    if (f && w)
      return;
    p();
    const y = (o == null ? void 0 : o.findDepth(e.tree)) ?? 0, b = (o == null ? void 0 : o.balanceTreeForAutoCols(g, y)) ?? [];
    this.autoCols = {
      list: g,
      tree: b,
      treeDepth: y,
      map: {}
    }, t((T) => {
      if (!T)
        return null;
      const F = T.filter((k) => !pc(k));
      return [...g, ...F];
    });
  }
  getAutoCol(e) {
    var t;
    return ((t = this.autoCols) == null ? void 0 : t.list.find((s) => ph(s, e))) ?? null;
  }
  getAutoCols() {
    var e;
    return ((e = this.autoCols) == null ? void 0 : e.list) ?? null;
  }
  generateAutoCols(e = []) {
    const t = [], s = this.gos.get("treeData");
    let i = dh(this.gos);
    return s && i && (I(182), i = !1), i ? e.forEach((r, n) => {
      t.push(this.createOneAutoCol(r, n));
    }) : t.push(this.createOneAutoCol()), t;
  }
  updateAutoCols(e) {
    var t;
    (t = this.autoCols) == null || t.list.forEach((s, i) => this.updateOneAutoCol(s, i, e));
  }
  isSuppressAutoCol() {
    const e = this.gos;
    return e.get("groupDisplayType") === "custom" ? !0 : e.get("treeDataDisplayType") === "custom";
  }
  // rowGroupCol and index are missing if groupDisplayType != "multipleColumns"
  createOneAutoCol(e, t) {
    let s;
    e ? s = `${Tr}-${e.getId()}` : s = Tr;
    const i = this.createAutoColDef(s, e, t);
    i.colId = s;
    const r = new hc(i, null, s, !0);
    return this.createBean(r), r;
  }
  /**
   * Refreshes an auto group col to load changes from defaultColDef or autoGroupColDef
   */
  updateOneAutoCol(e, t, s) {
    const i = e.getColDef(), r = typeof i.showRowGroup == "string" ? i.showRowGroup : void 0, n = this.beans, o = r != null ? n.colModel.getColDefCol(r) : void 0, a = this.createAutoColDef(e.getId(), o ?? void 0, t);
    e.setColDef(a, null, s), qv(n, e, a, s);
  }
  createAutoColDef(e, t, s) {
    let i = this.createBaseColDef(t);
    const r = this.gos.get("autoGroupColumnDef");
    bt(i, r), i = Al(this.beans, i, e, !0), this.gos.get("treeData") || ke(i.field) && ke(i.valueGetter) && ke(i.filterValueGetter) && i.filter !== "agGroupColumnFilter" && (i.filter = !1), s && s > 0 && (i.headerCheckboxSelection = !1);
    const n = ti(this.gos), o = i.valueGetter || i.field != null;
    return n && !o && (i.sortIndex = void 0, i.initialSort = void 0), i;
  }
  createBaseColDef(e) {
    const t = this.gos.get("autoGroupColumnDef"), i = {
      headerName: this.getLocaleTextFunc()("group", "Group")
    };
    if (t && (t.cellRenderer || t.cellRendererSelector) || (i.cellRenderer = "agGroupCellRenderer"), e) {
      const n = e.getColDef();
      Object.assign(i, {
        headerName: this.beans.colNames.getDisplayNameForColumn(e, "header"),
        headerValueGetter: n.headerValueGetter
      }), n.cellRenderer && Object.assign(i, {
        cellRendererParams: {
          innerRenderer: n.cellRenderer,
          innerRendererParams: n.cellRendererParams
        }
      }), i.showRowGroup = e.getColId();
    } else
      i.showRowGroup = !0;
    return i;
  }
  onAutoGroupColumnDefChanged(e) {
    this.updateAutoCols(e);
  }
  destroy() {
    var e;
    Er(this.beans, (e = this.autoCols) == null ? void 0 : e.tree), super.destroy();
  }
}, Ub = class extends L {
  addExpandedCss(e, t) {
    t.isExpandable() && (e.push("ag-row-group"), e.push(t.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted"));
  }
  getRowExpandedListeners(e) {
    const { rowNode: t } = e, s = this.updateExpandedCss.bind(this, e, t);
    return {
      expandedChanged: s,
      hasChildrenChanged: s
    };
  }
  setExpanded(e, t, s, i) {
    if (e.expanded === t)
      return;
    e.expanded = t, e.dispatchRowEvent("expandedChanged");
    const r = { ...ww(e, this.gos, "rowGroupOpened"), expanded: t, event: s || null };
    this.dispatchExpandedEvent(r, i), this.beans.rowRenderer.refreshCells({ rowNodes: [e] });
  }
  isExpandable(e) {
    return e.footer ? !1 : this.beans.colModel.isPivotMode() ? e.hasChildren() && !e.leafGroup : e.hasChildren() || e.master;
  }
  updateExpandedCss(e, t) {
    const s = t.isExpandable(), i = t.expanded == !0;
    e.forEachGui(void 0, (r) => {
      const n = r.rowComp;
      n.addOrRemoveCssClass("ag-row-group", s), n.addOrRemoveCssClass("ag-row-group-expanded", s && i), n.addOrRemoveCssClass("ag-row-group-contracted", s && !i), ns(r.element, s && i);
    });
  }
}, N_ = class extends Ub {
  constructor() {
    super(...arguments), this.beanName = "expansionSvc", this.events = [];
  }
  wireBeans(e) {
    this.rowModel = e.rowModel;
  }
  expandRows(e) {
    const t = new Set(e);
    this.rowModel.forEachNode((s) => {
      s.id && t.has(s.id) && (s.expanded = !0);
    }), this.onGroupExpandedOrCollapsed();
  }
  expandAll(e) {
    const { gos: t, colModel: s, eventSvc: i } = this.beans, r = this.rowModel, n = t.get("treeData"), o = s.isPivotActive(), a = (c) => {
      c && c.forEach((d) => {
        const u = () => {
          d.expanded = e, a(d.childrenAfterGroup);
        };
        if (n) {
          W(d.childrenAfterGroup) && u();
          return;
        }
        if (o) {
          !d.leafGroup && u();
          return;
        }
        d.group && u();
      });
    }, l = r.rootNode;
    l && a(l.childrenAfterGroup), r.refreshModel({ step: "map" }), i.dispatchEvent({
      type: "expandOrCollapseAll",
      source: e ? "expandAll" : "collapseAll"
    });
  }
  onGroupExpandedOrCollapsed() {
    this.rowModel.refreshModel({ step: "map" });
  }
  // because the user can call rowNode.setExpanded() many times in one VM turn,
  // we throttle the calls to ClientSideRowModel using animationFrameSvc. this means for 100
  // row nodes getting expanded, we only update the CSRM once, and then we fire all events after
  // CSRM has updated.
  //
  // if we did not do this, then the user could call setExpanded on 100+ rows, causing the grid
  // to re-render 100+ times, which would be a performance lag.
  //
  // we use animationFrameService
  // rather than debounce() so this will get done if anyone flushes the animationFrameService
  // (eg user calls api.ensureRowVisible(), which in turn flushes ).
  dispatchExpandedEvent(e, t) {
    this.events.push(e);
    const s = () => {
      this.rowModel.onRowGroupOpened(), this.events.forEach((i) => this.eventSvc.dispatchEvent(i)), this.events = [];
    };
    t ? s() : (this.dispatchExpandedDebounced == null && (this.dispatchExpandedDebounced = this.debounce(s)), this.dispatchExpandedDebounced());
  }
  // the advantage over normal debounce is the client can call flushAllFrames()
  // to make sure all rendering is complete. we don't wait any milliseconds,
  // as this is intended to batch calls in one VM turn.
  debounce(e) {
    const t = this.beans.animationFrameSvc;
    if (!t)
      return () => window.setTimeout(e, 0);
    let s = !1;
    return () => {
      if (!t.active) {
        window.setTimeout(e, 0);
        return;
      }
      s || (s = !0, t.addDestroyTask(() => {
        s = !1, e();
      }));
    };
  }
}, H_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "flattenStage", this.refreshProps = /* @__PURE__ */ new Set([
      "groupHideParentOfSingleChild",
      "groupRemoveSingleChildren",
      "groupRemoveLowestSingleChildren",
      "groupTotalRow",
      "masterDetail"
    ]), this.step = "map";
  }
  execute(e) {
    const t = e.rowNode, s = [], i = this.beans.colModel.isPivotMode(), r = i && t.leafGroup, n = r ? [t] : t.childrenAfterSort, o = this.getFlattenDetails();
    this.recursivelyAddToRowsToDisplay(o, n, s, i, 0);
    const a = s.length > 0;
    if (!r && // don't show total footer when showRootNode is true (i.e. in pivot mode and no groups)
    a && o.grandTotalRow) {
      Wi(t, this.beans);
      const c = o.grandTotalRow === "top";
      this.addRowNodeToRowsToDisplay(o, t.sibling, s, 0, c);
    }
    return s;
  }
  getFlattenDetails() {
    let e = this.gos.get("groupHideParentOfSingleChild");
    return e || (e = this.gos.get("groupRemoveSingleChildren"), !e && this.gos.get("groupRemoveLowestSingleChildren") && (e = "leafGroupsOnly")), {
      groupHideParentOfSingleChild: e,
      isGroupMultiAutoColumn: dh(this.gos),
      hideOpenParents: this.gos.get("groupHideOpenParents"),
      grandTotalRow: dc(this.gos),
      groupTotalRow: Xn(this.gos)
    };
  }
  recursivelyAddToRowsToDisplay(e, t, s, i, r) {
    var n;
    if (t != null && t.length)
      for (let o = 0; o < t.length; o++) {
        const a = t[o], l = a.hasChildren(), c = i && !l, d = e.groupHideParentOfSingleChild === !0 && l && a.childrenAfterGroup.length === 1, u = e.groupHideParentOfSingleChild === "leafGroupsOnly" && l && a.leafGroup && a.childrenAfterGroup.length === 1, h = i && a.leafGroup, p = e.hideOpenParents && a.expanded && !a.master && !h;
        if (!c && !p && !d && !u && this.addRowNodeToRowsToDisplay(e, a, s, r), !(i && a.leafGroup))
          if (l) {
            const f = d || u;
            if (a.expanded || f) {
              const m = e.groupTotalRow({ node: a });
              m || Qh(a);
              const C = f ? r : r + 1;
              m === "top" && (Wi(a, this.beans), this.addRowNodeToRowsToDisplay(e, a.sibling, s, C)), this.recursivelyAddToRowsToDisplay(
                e,
                a.childrenAfterSort,
                s,
                i,
                C
              ), m === "bottom" && (Wi(a, this.beans), this.addRowNodeToRowsToDisplay(e, a.sibling, s, C));
            }
          } else {
            const f = (n = this.beans.masterDetailSvc) == null ? void 0 : n.getDetail(a);
            f && this.addRowNodeToRowsToDisplay(e, f, s, r);
          }
      }
  }
  // duplicated method, it's also in floatingRowModel
  addRowNodeToRowsToDisplay(e, t, s, i, r) {
    r ? s.unshift(t) : s.push(t), t.setUiLevel(e.isGroupMultiAutoColumn ? 0 : i);
  }
}, $b = class extends L {
  wireBeans(e) {
    this.expressionSvc = e.expressionSvc, this.valueSvc = e.valueSvc, this.colModel = e.colModel, this.visibleCols = e.visibleCols, this.userCompFactory = e.userCompFactory, this.ctrlsSvc = e.ctrlsSvc, this.rowGroupColsSvc = e.rowGroupColsSvc, this.selectionSvc = e.selectionSvc, this.groupHideOpenParentsSvc = e.groupHideOpenParentsSvc;
  }
  init(e, t, s, i, r, n, o) {
    var d, u, h;
    this.params = o, this.eGui = t, this.eCheckbox = s, this.eExpanded = i, this.eContracted = r, this.comp = e, this.compClass = n;
    const { node: a, colDef: l } = o, c = this.isTopLevelFooter();
    if (!c) {
      if (this.isEmbeddedRowMismatch())
        return;
      if (a.footer && this.gos.get("groupHideOpenParents")) {
        const g = l == null ? void 0 : l.showRowGroup, f = (d = a.rowGroupColumn) == null ? void 0 : d.getColId();
        if (g !== f)
          return;
      }
    }
    if (this.setupShowingValueForOpenedParent(), this.findDisplayedGroupNode(), !c) {
      const p = this.rowGroupColsSvc && a.footer && a.rowGroupIndex === this.rowGroupColsSvc.columns.findIndex((b) => b.getColId() === (l == null ? void 0 : l.showRowGroup)), f = this.gos.get("groupDisplayType") != "multipleColumns" || this.gos.get("treeData") || this.gos.get("showOpenedGroup") && this.rowGroupColsSvc && !a.footer && (!a.group || a.rowGroupIndex != null && a.rowGroupIndex > ((u = this.rowGroupColsSvc) == null ? void 0 : u.columns.findIndex(
        (b) => b.getColId() === (l == null ? void 0 : l.showRowGroup)
      ))), m = !a.group && ((l == null ? void 0 : l.field) || (l == null ? void 0 : l.valueGetter)), C = this.isExpandable(), w = this.colModel.isPivotMode() && a.leafGroup && ((h = a.rowGroupColumn) == null ? void 0 : h.getColId()) === (l == null ? void 0 : l.showRowGroup);
      if (!this.showingValueForOpenedParent && !C && !m && !f && !p && !w)
        return;
    }
    this.addExpandAndContract(), this.addFullWidthRowDraggerIfNeeded(), this.addCheckboxIfNeeded(), this.addValueElement(), this.setupIndent(), this.refreshAriaExpanded(), this.addManagedPropertyListener("rowSelection", ({ currentValue: p, previousValue: g }) => {
      const f = typeof p == "object" ? p : void 0, m = typeof g == "object" ? g : void 0;
      (f == null ? void 0 : f.checkboxLocation) !== (m == null ? void 0 : m.checkboxLocation) && this.refreshCheckbox();
    });
  }
  getCellAriaRole() {
    var s, i;
    const e = (s = this.params.colDef) == null ? void 0 : s.cellAriaRole, t = (i = this.params.column) == null ? void 0 : i.getColDef().cellAriaRole;
    return e || t || "gridcell";
  }
  destroy() {
    super.destroy(), this.expandListener = null, this.destroyCheckbox();
  }
  refreshAriaExpanded() {
    const { node: e, eGridCell: t } = this.params;
    if (this.expandListener && (this.expandListener = this.expandListener()), !this.isExpandable()) {
      UC(t);
      return;
    }
    const s = () => {
      ns(t, this.showingValueForOpenedParent || !!e.expanded);
    };
    [this.expandListener] = this.addManagedListeners(e, { expandedChanged: s }) || null, s();
  }
  isTopLevelFooter() {
    var r;
    if (!dc(this.gos) || this.params.value != null || this.params.node.level != -1)
      return !1;
    const t = this.params.colDef;
    if (t == null || t.showRowGroup === !0)
      return !0;
    const i = (r = this.rowGroupColsSvc) == null ? void 0 : r.columns;
    return !i || i.length === 0 ? !0 : i[0].getId() === t.showRowGroup;
  }
  // if we are doing embedded full width rows, we only show the renderer when
  // in the body, or if pinning in the pinned section, or if pinning and RTL,
  // in the right section. otherwise we would have the cell repeated in each section.
  isEmbeddedRowMismatch() {
    if (!this.params.fullWidth || !this.gos.get("embedFullWidthRows"))
      return !1;
    const e = this.params.pinned === "left", t = this.params.pinned === "right", s = !e && !t;
    return this.gos.get("enableRtl") ? this.visibleCols.isPinningLeft() ? !t : !s : this.visibleCols.isPinningLeft() ? !e : !s;
  }
  findDisplayedGroupNode() {
    const e = this.params.column, t = this.params.node;
    if (this.showingValueForOpenedParent) {
      let s = t.parent;
      for (; s != null; ) {
        if (s.rowGroupColumn && e.isRowGroupDisplayed(s.rowGroupColumn.getId())) {
          this.displayedGroupNode = s;
          break;
        }
        s = s.parent;
      }
    }
    ke(this.displayedGroupNode) && (this.displayedGroupNode = t);
  }
  setupShowingValueForOpenedParent() {
    var e;
    this.showingValueForOpenedParent = ((e = this.groupHideOpenParentsSvc) == null ? void 0 : e.isShowingValueForOpenedParent(this.params.node, this.params.column)) ?? !1;
  }
  addValueElement() {
    this.displayedGroupNode.footer ? this.addFooterValue() : (this.addGroupValue(), this.addChildCount());
  }
  addGroupValue() {
    var n;
    const e = this.adjustParamsWithDetailsFromRelatedColumn(), t = this.getInnerCompDetails(e), { valueFormatted: s, value: i } = e;
    let r = s;
    if (r == null) {
      const o = this.displayedGroupNode.rowGroupColumn && ((n = this.params.column) == null ? void 0 : n.isRowGroupDisplayed(this.displayedGroupNode.rowGroupColumn.getId()));
      this.displayedGroupNode.key === "" && this.displayedGroupNode.group && o ? r = this.getLocaleTextFunc()("blanks", "(Blanks)") : r = i ?? null;
    }
    this.comp.setInnerRenderer(t, r);
  }
  adjustParamsWithDetailsFromRelatedColumn() {
    const e = this.displayedGroupNode.rowGroupColumn, t = this.params.column;
    if (!e)
      return this.params;
    if (t != null && !t.isRowGroupDisplayed(e.getId()))
      return this.params;
    const i = this.params, { value: r, node: n } = this.params, o = this.valueSvc.formatValue(e, n, r);
    return {
      ...i,
      valueFormatted: o
    };
  }
  addFooterValue() {
    const e = this.params.totalValueGetter;
    let t = "";
    if (e) {
      const i = {
        ...this.params,
        value: this.params.value
      };
      typeof e == "function" ? t = e(i) : typeof e == "string" ? t = this.expressionSvc ? this.expressionSvc.evaluate(e, i) : "" : I(179);
    } else
      t = this.getLocaleTextFunc()("footerTotal", "Total") + " " + (this.params.value != null ? this.params.value : "");
    const s = this.getInnerCompDetails(this.params);
    this.comp.setInnerRenderer(s, t);
  }
  getInnerCompDetails(e) {
    if (e.fullWidth)
      return fd(this.userCompFactory, this.gos.get("groupRowRendererParams"), e);
    const t = fd(
      this.userCompFactory,
      e,
      e
    ), s = (o) => o && o.componentClass == this.compClass;
    if (t && !s(t))
      return t;
    const i = this.displayedGroupNode.rowGroupColumn, r = i == null ? void 0 : i.getColDef();
    if (!r)
      return;
    const n = Ml(this.userCompFactory, r, e);
    if (n && !s(n))
      return n;
    if (s(n) && r.cellRendererParams && r.cellRendererParams.innerRenderer)
      return fd(
        this.userCompFactory,
        r.cellRendererParams,
        e
      );
  }
  addChildCount() {
    this.params.suppressCount || (this.addManagedListeners(this.displayedGroupNode, {
      allChildrenCountChanged: this.updateChildCount.bind(this)
    }), this.updateChildCount());
  }
  updateChildCount() {
    const e = this.displayedGroupNode.allChildrenCount, i = this.isShowRowGroupForThisRow() && e != null && e >= 0 ? `(${e})` : "";
    this.comp.setChildCount(i);
  }
  isShowRowGroupForThisRow() {
    if (this.gos.get("treeData"))
      return !0;
    const e = this.displayedGroupNode.rowGroupColumn;
    if (!e)
      return !1;
    const t = this.params.column;
    return t == null || t.isRowGroupDisplayed(e.getId());
  }
  addExpandAndContract() {
    var n;
    const e = this.params, t = (o, a) => {
      const l = ue(o, this.beans, null);
      l && (a.appendChild(l), this.addDestroyFunc(() => a.removeChild(l)));
    };
    t("groupExpanded", this.eExpanded), t("groupContracted", this.eContracted);
    const s = e.eGridCell;
    !(((n = this.params.column) == null ? void 0 : n.isCellEditable(e.node)) && this.gos.get("enableGroupEdit")) && this.isExpandable() && !e.suppressDoubleClickExpand && this.addManagedListeners(s, { dblclick: this.onCellDblClicked.bind(this) }), this.addManagedListeners(this.eExpanded, { click: this.onExpandClicked.bind(this) }), this.addManagedListeners(this.eContracted, { click: this.onExpandClicked.bind(this) }), this.addManagedListeners(s, { keydown: this.onKeyDown.bind(this) }), this.addManagedListeners(e.node, { expandedChanged: this.showExpandAndContractIcons.bind(this) }), this.showExpandAndContractIcons();
    const r = this.onRowNodeIsExpandableChanged.bind(this);
    this.addManagedListeners(this.displayedGroupNode, {
      allChildrenCountChanged: r,
      masterChanged: r,
      groupChanged: r,
      hasChildrenChanged: r
    });
  }
  onExpandClicked(e) {
    Ds(e) || (gt(e), this.onExpandOrContract(e));
  }
  onExpandOrContract(e) {
    const t = this.displayedGroupNode, s = !t.expanded;
    !s && t.sticky && this.scrollToStickyNode(t), t.setExpanded(s, e);
  }
  scrollToStickyNode(e) {
    this.ctrlsSvc.getScrollFeature().setVerticalScrollPosition(e.rowTop - e.stickyRowTop);
  }
  isExpandable() {
    if (this.showingValueForOpenedParent)
      return !0;
    const e = this.displayedGroupNode, t = this.colModel.isPivotMode() && e.leafGroup;
    if (!(e.isExpandable() && !e.footer && !t))
      return !1;
    const i = this.params.column;
    return i != null && typeof i.getColDef().showRowGroup == "string" ? this.isShowRowGroupForThisRow() : !0;
  }
  showExpandAndContractIcons() {
    const { params: e, displayedGroupNode: t, colModel: s } = this, { node: i } = e, r = this.isExpandable();
    if (r) {
      const c = this.showingValueForOpenedParent ? !0 : i.expanded;
      this.comp.setExpandedDisplayed(c), this.comp.setContractedDisplayed(!c);
    } else
      this.comp.setExpandedDisplayed(!1), this.comp.setContractedDisplayed(!1);
    const n = s.isPivotMode(), o = n && t.leafGroup, a = r && !o, l = i.footer && i.level === -1;
    this.comp.addOrRemoveCssClass("ag-cell-expandable", a), this.comp.addOrRemoveCssClass("ag-row-group", a), n ? this.comp.addOrRemoveCssClass("ag-pivot-leaf-group", !!o) : l || this.comp.addOrRemoveCssClass("ag-row-group-leaf-indent", !a);
  }
  onRowNodeIsExpandableChanged() {
    this.showExpandAndContractIcons(), this.setIndent(), this.refreshAriaExpanded();
  }
  setupIndent() {
    const e = this.params.node;
    this.params.suppressPadding || (this.addManagedListeners(e, { uiLevelChanged: this.setIndent.bind(this) }), this.setIndent());
  }
  setIndent() {
    if (this.gos.get("groupHideOpenParents"))
      return;
    const e = this.params, t = e.node, s = !!e.colDef, i = this.gos.get("treeData"), n = !s || i || e.colDef.showRowGroup === !0 ? t.uiLevel : 0;
    this.indentClass && this.comp.addOrRemoveCssClass(this.indentClass, !1), this.indentClass = "ag-row-group-indent-" + n, this.comp.addOrRemoveCssClass(this.indentClass, !0), this.eGui.style.setProperty("--ag-indentation-level", String(n));
  }
  addFullWidthRowDraggerIfNeeded() {
    if (!this.params.fullWidth || !this.params.rowDrag || !this.rowDragSvc)
      return;
    const e = this.rowDragSvc.createRowDragComp(() => this.params.value, this.params.node);
    this.createManagedBean(e), this.eGui.insertAdjacentElement("afterbegin", e.getGui());
  }
  addCheckboxIfNeeded() {
    const e = this.displayedGroupNode, t = this.gos.get("rowSelection"), s = Tl(t), i = typeof t == "object" ? s === "autoGroupColumn" && ln(t) : this.params.checkbox, n = (typeof i == "function" || i === !0) && // footers cannot be selected
    !e.footer && // pinned rows cannot be selected
    !e.rowPinned && // details cannot be selected
    !e.detail && !!this.selectionSvc && Es(this.gos);
    if (n) {
      const o = this.selectionSvc.createCheckboxSelectionComponent();
      this.cbComp = o, this.createBean(o), o.init({
        rowNode: this.params.node,
        // when groupHideOpenParents = true and group expanded, we want the checkbox to refer to leaf node state (not group node state)
        column: this.params.column,
        overrides: {
          isVisible: i,
          callbackParams: this.params,
          removeHidden: !0
        }
      }), this.eCheckbox.appendChild(o.getGui());
    }
    this.comp.setCheckboxVisible(n);
  }
  destroyCheckbox() {
    this.cbComp && this.eCheckbox.removeChild(this.cbComp.getGui()), this.cbComp = this.destroyBean(this.cbComp);
  }
  refreshCheckbox() {
    this.destroyCheckbox(), this.addCheckboxIfNeeded();
  }
  onKeyDown(e) {
    !(e.key === P.ENTER) || this.params.suppressEnterExpand || this.params.column && this.params.column.isCellEditable(this.params.node) || this.onExpandOrContract(e);
  }
  onCellDblClicked(e) {
    if (Ds(e))
      return;
    au(this.eExpanded, e) || au(this.eContracted, e) || this.onExpandOrContract(e);
  }
}, z_ = (
  /* html */
  `<span class="ag-cell-wrapper">
        <span class="ag-group-expanded" data-ref="eExpanded"></span>
        <span class="ag-group-contracted" data-ref="eContracted"></span>
        <span class="ag-group-checkbox ag-invisible" data-ref="eCheckbox"></span>
        <span class="ag-group-value" data-ref="eValue"></span>
        <span class="ag-group-child-count" data-ref="eChildCount"></span>
    </span>`
), $f = class extends _ {
  constructor() {
    super(z_), this.eExpanded = E, this.eContracted = E, this.eCheckbox = E, this.eValue = E, this.eChildCount = E;
  }
  init(t) {
    const s = {
      setInnerRenderer: (o, a) => this.setRenderDetails(o, a),
      setChildCount: (o) => this.eChildCount.textContent = o,
      addOrRemoveCssClass: (o, a) => this.addOrRemoveCssClass(o, a),
      setContractedDisplayed: (o) => re(this.eContracted, o),
      setExpandedDisplayed: (o) => re(this.eExpanded, o),
      setCheckboxVisible: (o) => this.eCheckbox.classList.toggle("ag-invisible", !o)
    }, i = this.createManagedBean(new $b()), r = !t.colDef, n = this.getGui();
    i.init(s, n, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, t), r && nt(n, i.getCellAriaRole());
  }
  setRenderDetails(t, s) {
    t ? t.newAgStackInstance().then((i) => {
      if (!i)
        return;
      const r = () => this.destroyBean(i);
      this.isAlive() ? (this.eValue.appendChild(i.getGui()), this.addDestroyFunc(r)) : r();
    }) : this.eValue.innerText = s;
  }
  destroy() {
    this.destroyBean(this.innerCellRenderer), super.destroy();
  }
  refresh() {
    return !1;
  }
}, W_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "showRowGroupCols";
  }
  refresh() {
    this.showRowGroupCols = [], this.showRowGroupColsMap = {};
    const { colModel: e, rowGroupColsSvc: t } = this.beans;
    e.getCols().forEach((s) => {
      const r = s.getColDef().showRowGroup, n = typeof r == "string";
      !n && !(r === !0) || (this.showRowGroupCols.push(s), n ? this.showRowGroupColsMap[r] = s : t && t.columns.forEach((a) => {
        this.showRowGroupColsMap[a.getId()] = s;
      }));
    });
  }
  getShowRowGroupCols() {
    return this.showRowGroupCols;
  }
  getShowRowGroupCol(e) {
    return this.showRowGroupColsMap[e];
  }
  getSourceColumnsForGroupColumn(e) {
    const t = e.getColDef().showRowGroup;
    if (!t)
      return null;
    const { rowGroupColsSvc: s, colModel: i } = this.beans;
    if (t === !0 && s)
      return s.columns.slice(0);
    const r = i.getColDefCol(t);
    return r ? [r] : null;
  }
  isRowGroupDisplayed(e, t) {
    const { colDef: s } = e;
    if ((s == null ? void 0 : s.showRowGroup) == null)
      return !1;
    const i = s.showRowGroup === !0, r = s.showRowGroup === t;
    return i || r;
  }
}, __ = class extends L {
  constructor(e, t) {
    super(), this.createRowCon = e, this.destroyRowCtrls = t, this.stickyTopRowCtrls = [], this.stickyBottomRowCtrls = [], this.extraTopHeight = 0, this.extraBottomHeight = 0;
  }
  postConstruct() {
    this.isClientSide = Ye(this.gos), this.beans.ctrlsSvc.whenReady(this, (e) => {
      this.gridBodyCtrl = e.gridBodyCtrl;
    }), this.resetStickyContainers();
  }
  setOffsetTop(e) {
    this.extraTopHeight !== e && (this.extraTopHeight = e, this.eventSvc.dispatchEvent({
      type: "stickyTopOffsetChanged",
      offset: e
    }));
  }
  setOffsetBottom(e) {
    this.extraBottomHeight !== e && (this.extraBottomHeight = e);
  }
  resetOffsets() {
    this.setOffsetBottom(0), this.setOffsetTop(0);
  }
  /**
   * Get the last pixel of the group, this pixel is used to push the sticky node up out of the viewport.
   */
  getLastPixelOfGroup(e) {
    return this.isClientSide ? $_(e) : U_(e);
  }
  /**
   * Get the first pixel of the group, this pixel is used to push the sticky node down out of the viewport
   */
  getFirstPixelOfGroup(e) {
    return e.footer ? e.sibling.rowTop + e.sibling.rowHeight - 1 : e.hasChildren() ? e.rowTop - 1 : 0;
  }
  updateStickyRows(e) {
    const t = e === "top";
    let s = 0;
    if (!this.canRowsBeSticky())
      return this.refreshNodesAndContainerHeight(e, /* @__PURE__ */ new Set(), s);
    const { rowModel: i, rowRenderer: r } = this.beans, n = t ? r.firstVisibleVPixel - this.extraTopHeight : r.lastVisibleVPixel - this.extraTopHeight, o = /* @__PURE__ */ new Set(), a = (u) => {
      if (o.add(u), t) {
        const h = this.getLastPixelOfGroup(u), p = n + s + u.rowHeight;
        h < p ? u.stickyRowTop = s + (h - p) : u.stickyRowTop = s;
      } else {
        const h = this.getFirstPixelOfGroup(u), p = n - (s + u.rowHeight);
        h > p ? u.stickyRowTop = s - (h - p) : u.stickyRowTop = s;
      }
      s = 0, o.forEach((h) => {
        const p = h.stickyRowTop + h.rowHeight;
        s < p && (s = p);
      });
    }, l = this.areFooterRowsStickySuppressed(), c = this.gos.get("suppressGroupRowsSticky"), d = (u) => {
      if (!u.displayed)
        return !1;
      if (u.footer) {
        if (l === !0 || l === "grand" && u.level === -1 || l === "group" && u.level > -1)
          return !1;
        const h = u.sibling.rowIndex ? u.sibling.rowIndex + 1 === u.rowIndex : !1;
        return e === "bottom" && h ? !1 : !o.has(u);
      }
      return u.isExpandable() ? c === !0 || e === "bottom" ? !1 : !o.has(u) && u.expanded : !1;
    };
    for (let u = 0; u < 100; u++) {
      let h = n + s;
      t || (h = n - s);
      const p = i.getRowIndexAtPixel(h), g = i.getRow(p);
      if (g == null)
        break;
      const m = this.getStickyAncestors(g).find(
        (w) => (t ? w.rowIndex < p : w.rowIndex > p) && d(w)
      );
      if (m) {
        a(m);
        continue;
      }
      if ((t ? g.rowTop < h : g.rowTop + g.rowHeight > h) && d(g)) {
        a(g);
        continue;
      }
      break;
    }
    return t || o.forEach((u) => {
      u.stickyRowTop = s - (u.stickyRowTop + u.rowHeight);
    }), this.refreshNodesAndContainerHeight(e, o, s);
  }
  areFooterRowsStickySuppressed() {
    const e = this.gos.get("suppressStickyTotalRow");
    if (e === !0)
      return !0;
    const t = e === "group", s = e === "grand";
    return t && s ? !0 : s ? "grand" : t ? "group" : !1;
  }
  canRowsBeSticky() {
    const e = cc(this.gos), t = this.areFooterRowsStickySuppressed(), s = this.gos.get("suppressGroupRowsSticky");
    return e && (!t || !s);
  }
  getStickyAncestors(e) {
    const t = [];
    let s = e.footer ? e.sibling : e.parent;
    for (; s; )
      s.sibling && t.push(s.sibling), t.push(s), s = s.parent;
    return t.reverse();
  }
  checkStickyRows() {
    const e = this.updateStickyRows("top"), t = this.updateStickyRows("bottom");
    return e || t;
  }
  destroyStickyCtrls() {
    this.resetStickyContainers();
  }
  resetStickyContainers() {
    this.refreshNodesAndContainerHeight("top", /* @__PURE__ */ new Set(), 0), this.refreshNodesAndContainerHeight("bottom", /* @__PURE__ */ new Set(), 0);
  }
  refreshStickyNode(e) {
    const t = /* @__PURE__ */ new Set();
    if (this.stickyTopRowCtrls.some((s) => s.rowNode === e)) {
      for (let s = 0; s < this.stickyTopRowCtrls.length; s++) {
        const i = this.stickyTopRowCtrls[s].rowNode;
        i !== e && t.add(i);
      }
      this.refreshNodesAndContainerHeight("top", t, this.topContainerHeight) && this.checkStickyRows();
      return;
    }
    for (let s = 0; s < this.stickyBottomRowCtrls.length; s++) {
      const i = this.stickyBottomRowCtrls[s].rowNode;
      i !== e && t.add(i);
    }
    this.refreshNodesAndContainerHeight("bottom", t, this.bottomContainerHeight) && this.checkStickyRows();
  }
  /**
   * Destroy old ctrls and create new ctrls where necessary.
   */
  refreshNodesAndContainerHeight(e, t, s) {
    const i = e === "top", r = i ? this.stickyTopRowCtrls : this.stickyBottomRowCtrls, n = {}, o = [];
    for (let p = 0; p < r.length; p++) {
      const g = r[p].rowNode;
      if (!t.has(g)) {
        n[g.id] = r[p], g.sticky = !1;
        continue;
      }
      o.push(r[p]);
    }
    const a = /* @__PURE__ */ new Set();
    for (let p = 0; p < o.length; p++)
      a.add(o[p].rowNode);
    const l = [];
    t.forEach((p) => {
      a.has(p) || (p.sticky = !0, l.push(this.createRowCon(p, !1, !1)));
    });
    let c = !!l.length || o.length !== r.length;
    i ? this.topContainerHeight !== s && (this.topContainerHeight = s, this.gridBodyCtrl.setStickyTopHeight(s), c = !0) : this.bottomContainerHeight !== s && (this.bottomContainerHeight = s, this.gridBodyCtrl.setStickyBottomHeight(s), c = !0), this.destroyRowCtrls(n, !1);
    const d = [...o, ...l];
    d.sort((p, g) => g.rowNode.rowIndex - p.rowNode.rowIndex), i || d.reverse(), d.forEach((p) => p.setRowTop(p.rowNode.stickyRowTop));
    const u = this.beans.pageBounds;
    let h = 0;
    return i ? (t.forEach((p) => {
      p.rowIndex < u.getFirstRow() && (h += p.rowHeight);
    }), h > this.topContainerHeight && (h = this.topContainerHeight), this.setOffsetTop(h)) : (t.forEach((p) => {
      p.rowIndex > u.getLastRow() && (h += p.rowHeight);
    }), h > this.bottomContainerHeight && (h = this.bottomContainerHeight), this.setOffsetBottom(h)), c ? (i ? this.stickyTopRowCtrls = d : this.stickyBottomRowCtrls = d, !0) : !1;
  }
  ensureRowHeightsValid() {
    let e = !1;
    const t = (s) => {
      const i = s.rowNode;
      if (i.rowHeightEstimated) {
        const r = qt(this.beans, i);
        i.setRowHeight(r.height), e = !0;
      }
    };
    return this.stickyTopRowCtrls.forEach(t), this.stickyBottomRowCtrls.forEach(t), e;
  }
};
function U_(e) {
  var t, s;
  if (e.isExpandable() || e.footer) {
    if (e.master)
      return e.detailNode.rowTop + e.detailNode.rowHeight;
    if (!e.sibling || Math.abs(e.sibling.rowIndex - e.rowIndex) === 1) {
      let r = (t = e.childStore) == null ? void 0 : t.getStoreBounds();
      return e.footer && (r = (s = e.sibling.childStore) == null ? void 0 : s.getStoreBounds()), ((r == null ? void 0 : r.heightPx) ?? 0) + ((r == null ? void 0 : r.topPx) ?? 0);
    }
    return e.footer ? e.rowTop + e.rowHeight : e.sibling.rowTop + e.sibling.rowHeight;
  }
  return Number.MAX_SAFE_INTEGER;
}
function $_(e) {
  if (e.isExpandable() || e.footer) {
    if (e.footer && e.rowIndex === 0)
      return Number.MAX_SAFE_INTEGER;
    if (!e.sibling || Math.abs(e.sibling.rowIndex - e.rowIndex) === 1) {
      let i = e.footer ? e.sibling : e;
      for (; i.isExpandable() && i.expanded; )
        if (i.master)
          i = i.detailNode;
        else if (i.childrenAfterSort) {
          if (i.childrenAfterSort.length === 0)
            break;
          i = pe(i.childrenAfterSort);
        }
      return i.rowTop + i.rowHeight;
    }
    return e.footer ? e.rowTop + e.rowHeight : e.sibling.rowTop + e.sibling.rowHeight;
  }
  return Number.MAX_SAFE_INTEGER;
}
var j_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "stickyRowSvc";
  }
  createStickyRowFeature(e, t, s) {
    const i = this.gos;
    if (cc(i) && Ye(i) || Lt(i))
      return e.createManagedBean(new __(t, s));
  }
}, jb = {
  moduleName: "GroupCellRenderer",
  version: Me,
  userComponents: {
    agGroupRowRenderer: $f,
    agGroupCellRenderer: $f
  },
  dynamicBeans: { groupCellRendererCtrl: $b },
  icons: {
    // shown on row group when contracted (click to expand)
    groupContracted: "tree-closed",
    // shown on row group when expanded (click to contract)
    groupExpanded: "tree-open"
  },
  dependsOn: [Je]
}, Kb = {
  moduleName: "GroupColumn",
  version: Me,
  beans: [V_, W_, B_, _b, zb],
  dependsOn: [Je, jb]
}, Ac = {
  moduleName: "ClientSideRowModelHierarchy",
  version: Me,
  rowModels: ["clientSide"],
  beans: [H_, N_],
  dependsOn: [Je]
}, ep = {
  moduleName: "StickyRow",
  version: Me,
  beans: [j_]
}, K_ = class extends _ {
  constructor() {
    super();
  }
  postConstruct() {
    this.setGui(this.createNorthPanel());
    const e = this.onRowGroupChanged.bind(this);
    this.addManagedEventListeners({
      columnRowGroupChanged: e,
      newColumnsLoaded: e
    }), this.addManagedPropertyListener("rowGroupPanelShow", e), this.addManagedPropertyListener("pivotPanelShow", () => this.onPivotPanelShow()), this.onRowGroupChanged();
  }
  createNorthPanel() {
    const e = document.createElement("div");
    e.classList.add("ag-column-drop-wrapper"), nt(e, "presentation");
    const t = new Ib(!0);
    this.rowGroupComp = this.createManagedBean(t);
    const s = new Mb(!0);
    this.pivotComp = this.createManagedBean(s), e.appendChild(t.getGui()), e.appendChild(s.getGui());
    const i = this.onDropPanelVisible.bind(this);
    return this.addManagedListeners(t, {
      displayChanged: i
    }), this.addManagedListeners(s, {
      displayChanged: i
    }), this.onDropPanelVisible(), e;
  }
  onDropPanelVisible() {
    const { rowGroupComp: e, pivotComp: t } = this, s = e.isDisplayed() && t.isDisplayed(), i = "ag-column-drop-horizontal-half-width";
    e.addOrRemoveCssClass(i, s), t.addOrRemoveCssClass(i, s);
  }
  onRowGroupChanged() {
    var s, i;
    const e = this.rowGroupComp;
    if (!e)
      return;
    const t = this.gos.get("rowGroupPanelShow");
    if (t === "always")
      e.setDisplayed(!0);
    else if (t === "onlyWhenGrouping") {
      const r = ((i = (s = this.beans.rowGroupColsSvc) == null ? void 0 : s.columns) == null ? void 0 : i.length) !== 0;
      e.setDisplayed(r);
    } else
      e.setDisplayed(!1);
  }
  onPivotPanelShow() {
    const e = this.pivotComp;
    if (!e)
      return;
    const t = this.gos.get("pivotPanelShow");
    if (t === "always")
      e.setDisplayed(!0);
    else if (t === "onlyWhenPivoting") {
      const s = this.beans.colModel.isPivotActive();
      e.setDisplayed(s);
    } else
      e.setDisplayed(!1);
  }
}, q_ = {
  selector: "AG-GRID-HEADER-DROP-ZONES",
  component: K_
}, Y_ = class extends Ti {
  constructor() {
    super(
      /* html */
      `
            <div class="ag-group-filter">
                <div data-ref="eGroupField"></div>
                <div data-ref="eUnderlyingFilter"></div>
            </div>
        `
    ), this.eGroupField = E, this.eUnderlyingFilter = E;
  }
  wireBeans(e) {
    this.filterManager = e.filterManager, this.showRowGroupCols = e.showRowGroupCols;
  }
  postConstruct() {
    this.initialiseTabGuard({});
  }
  init(e) {
    return this.updateParams(e).then(() => {
      this.addManagedEventListeners({
        columnRowGroupChanged: () => this.onColumnRowGroupChanged(),
        filterDestroyed: (t) => this.onFilterDestroyed(t)
      });
    });
  }
  refresh(e) {
    return this.updateParams(e), !0;
  }
  updateParams(e) {
    return this.params = e, this.validateParams(), this.updateGroups();
  }
  validateParams() {
    const { colDef: e } = this.params;
    e.field && I(234), e.filterValueGetter && I(235), e.filterParams && I(236);
  }
  updateGroups() {
    const e = this.updateGroupField();
    return this.getUnderlyingFilters(e);
  }
  getSourceColumns() {
    var t;
    if (this.groupColumn = this.params.column, this.gos.get("treeData"))
      return I(237), [];
    const e = (t = this.showRowGroupCols) == null ? void 0 : t.getSourceColumnsForGroupColumn(this.groupColumn);
    return e || (I(183), []);
  }
  updateGroupField() {
    const e = this.eGroupField;
    ze(e), this.eGroupFieldSelect && this.destroyBean(this.eGroupFieldSelect);
    const t = this.getSourceColumns(), s = t.filter((i) => i.isFilterAllowed());
    return s.length ? (t.length === 1 ? (this.selectedColumn = s[0], re(e, !1)) : ((!this.selectedColumn || !s.some((i) => i.getId() === this.selectedColumn.getId())) && (this.selectedColumn = s[0]), this.createGroupFieldSelectElement(s), e.appendChild(this.eGroupFieldSelect.getGui()), e.appendChild(ss(
      /* html */
      '<div class="ag-filter-separator"></div>'
    )), re(e, !0)), s) : (this.selectedColumn = void 0, re(e, !1), null);
  }
  createGroupFieldSelectElement(e) {
    const t = this.createManagedBean(new rs());
    this.eGroupFieldSelect = t;
    const s = this.getLocaleTextFunc();
    t.setLabel(s("groupFilterSelect", "Select field:")), t.setLabelAlignment("top"), t.addOptions(
      e.map((i) => ({
        value: i.getId(),
        text: this.beans.colNames.getDisplayNameForColumn(i, "groupFilter", !1) ?? void 0
      }))
    ), t.setValue(this.selectedColumn.getId()), t.onValueChange((i) => this.updateSelectedColumn(i)), t.addCssClass("ag-group-filter-field-select-wrapper"), e.length === 1 && t.setDisabled(!0);
  }
  getUnderlyingFilters(e) {
    var i;
    if (!e)
      return this.filterColumnPairs = void 0, this.selectedFilter = void 0, (i = this.beans.colFilter) == null || i.setColFilterActive(this.groupColumn, !1, "columnRowGroupChanged"), fe.resolve();
    const t = [], s = [];
    return e.forEach((r) => {
      const n = this.filterManager.getOrCreateFilterWrapper(r);
      n != null && n.filterPromise && t.push(
        n.filterPromise.then((o) => (o && s.push({
          filter: o,
          column: r
        }), r.getId() === this.selectedColumn.getId() && (this.selectedFilter = o ?? void 0), o))
      );
    }), fe.all(t).then(() => {
      var r;
      this.filterColumnPairs = s, (r = this.beans.colFilter) == null || r.setColFilterActive(this.groupColumn, this.isFilterActive(), "columnRowGroupChanged");
    });
  }
  addUnderlyingFilterElement() {
    var t;
    if (ze(this.eUnderlyingFilter), !this.selectedColumn)
      return fe.resolve();
    const e = this.createManagedBean(new fc(this.selectedColumn, "COLUMN_MENU"));
    return this.filterWrapperComp = e, e.hasFilter() ? (this.eUnderlyingFilter.appendChild(e.getGui()), ((t = e.getFilter()) == null ? void 0 : t.then(() => {
      var s, i;
      (s = e.afterGuiAttached) == null || s.call(e, this.afterGuiAttachedParams), !((i = this.afterGuiAttachedParams) != null && i.suppressFocus) && this.eGroupFieldSelect && !this.eGroupFieldSelect.isDisabled() && this.eGroupFieldSelect.getFocusableElement().focus();
    })) ?? fe.resolve()) : fe.resolve();
  }
  updateSelectedColumn(e) {
    var s;
    if (!e)
      return;
    (s = this.filterWrapperComp) == null || s.afterGuiDetached(), this.destroyBean(this.filterWrapperComp);
    const t = this.getFilterColumnPair(e);
    this.selectedColumn = t == null ? void 0 : t.column, this.selectedFilter = t == null ? void 0 : t.filter, this.dispatchLocalEvent({
      type: "selectedColumnChanged"
    }), this.addUnderlyingFilterElement();
  }
  isFilterActive() {
    var e;
    return !!((e = this.filterColumnPairs) != null && e.some(({ filter: t }) => t.isFilterActive()));
  }
  doesFilterPass() {
    return !0;
  }
  getModel() {
    return null;
  }
  setModel() {
    return fe.resolve();
  }
  afterGuiAttached(e) {
    this.afterGuiAttachedParams = e, this.addUnderlyingFilterElement();
  }
  afterGuiDetached() {
    var e, t;
    ze(this.eUnderlyingFilter), (t = (e = this.selectedFilter) == null ? void 0 : e.afterGuiDetached) == null || t.call(e);
  }
  onColumnRowGroupChanged() {
    this.updateGroups().then(() => {
      this.dispatchLocalEvent({
        type: "columnRowGroupChanged"
      });
    });
  }
  onFilterDestroyed({ column: e, source: t }) {
    var i;
    if (t === "gridDestroyed")
      return;
    const s = e.getColId();
    (i = this.filterColumnPairs) != null && i.some(({ column: r }) => r.getColId() === s) && setTimeout(() => {
      this.isAlive() && this.updateGroups();
    });
  }
  getFilterColumnPair(e) {
    var t;
    if (e)
      return (t = this.filterColumnPairs) == null ? void 0 : t.find(({ column: s }) => s.getId() === e);
  }
  getSelectedFilter() {
    return this.selectedFilter;
  }
  getSelectedColumn() {
    return this.selectedColumn;
  }
  isFilterAllowed() {
    return !!this.selectedColumn;
  }
}, X_ = class extends _ {
  constructor() {
    super(
      /* html */
      `
            <div data-ref="eFloatingFilter" class="ag-group-floating-filter ag-floating-filter-input" role="presentation"></div>
        `
    ), this.eFloatingFilter = E, this.haveAddedColumnListeners = !1;
  }
  wireBeans(e) {
    this.filterManager = e.filterManager;
  }
  init(e) {
    this.params = e;
    const t = this.gos.get("groupDisplayType") === "multipleColumns";
    return new fe((s) => {
      this.params.parentFilterInstance((i) => {
        this.parentFilterInstance = i, t ? this.setupUnderlyingFloatingFilterElement().then(() => s()) : (this.setupReadOnlyFloatingFilterElement(), s());
      });
    }).then(() => {
      const s = this.onColChange.bind(this);
      this.addManagedListeners(this.parentFilterInstance, {
        selectedColumnChanged: s,
        columnRowGroupChanged: s
      });
    });
  }
  refresh(e) {
    this.params = e, this.setParams();
  }
  setParams() {
    var s;
    const e = this.beans.colNames.getDisplayNameForColumn(this.params.column, "header", !0), t = this.getLocaleTextFunc();
    (s = this.eFloatingFilterText) == null || s.setInputAriaLabel(`${e} ${t("ariaFilterInput", "Filter Input")}`);
  }
  setupReadOnlyFloatingFilterElement() {
    this.eFloatingFilterText || (this.eFloatingFilterText = this.createManagedBean(new li()), this.eFloatingFilterText.setDisabled(!0).addGuiEventListener("click", () => this.params.showParentFilter()), this.setParams()), this.updateDisplayedValue(), this.eFloatingFilter.appendChild(this.eFloatingFilterText.getGui());
  }
  setupUnderlyingFloatingFilterElement() {
    this.showingUnderlyingFloatingFilter = !1, this.underlyingFloatingFilter = void 0, ze(this.eFloatingFilter);
    const e = this.parentFilterInstance.getSelectedColumn();
    if (e && !e.isVisible()) {
      const t = this.filterManager.getFloatingFilterCompDetails(e, this.params.showParentFilter);
      if (t)
        return this.haveAddedColumnListeners || (this.haveAddedColumnListeners = !0, this.addManagedListeners(e, {
          visibleChanged: this.onColumnVisibleChanged.bind(this),
          colDefChanged: this.onColDefChanged.bind(this)
        })), t.newAgStackInstance().then((s) => {
          var i, r;
          this.underlyingFloatingFilter = s, (r = this.underlyingFloatingFilter) == null || r.onParentModelChanged(
            (i = this.parentFilterInstance.getSelectedFilter()) == null ? void 0 : i.getModel()
          ), this.appendChild(s.getGui()), this.showingUnderlyingFloatingFilter = !0;
        });
    }
    return this.setupReadOnlyFloatingFilterElement(), fe.resolve();
  }
  onColumnVisibleChanged() {
    this.setupUnderlyingFloatingFilterElement();
  }
  onColDefChanged(e) {
    var s, i;
    if (!e.column)
      return;
    const t = this.filterManager.getFloatingFilterCompDetails(
      e.column,
      this.params.showParentFilter
    );
    t && ((i = (s = this.underlyingFloatingFilter) == null ? void 0 : s.refresh) == null || i.call(s, t.params));
  }
  onParentModelChanged(e, t) {
    var s, i;
    this.showingUnderlyingFloatingFilter ? (i = this.underlyingFloatingFilter) == null || i.onParentModelChanged(
      (s = this.parentFilterInstance.getSelectedFilter()) == null ? void 0 : s.getModel(),
      t
    ) : this.updateDisplayedValue();
  }
  updateDisplayedValue() {
    const { eFloatingFilterText: e, parentFilterInstance: t } = this;
    if (!t || !e)
      return;
    const s = t.getSelectedFilter();
    if (!s) {
      e.setValue(""), e.setDisplayed(!1);
      return;
    }
    if (e.setDisplayed(!0), s.getModelAsString) {
      const i = s.getModel();
      e.setValue(i == null ? "" : s.getModelAsString(i));
    } else
      e.setValue("");
  }
  onColChange() {
    this.showingUnderlyingFloatingFilter || this.updateDisplayedValue();
  }
}, Z_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "groupHideOpenParentsSvc";
  }
  updateGroupDataForHideOpenParents(e) {
    if (!this.gos.get("groupHideOpenParents") || this.gos.get("treeData"))
      return;
    const t = (s) => {
      this.pullDownGroupDataForHideOpenParents(s.childrenAfterSort, !1), s.childrenAfterSort.forEach((i) => {
        i.hasChildren() && t(i);
      });
    };
    e && e.executeFromRootNode((s) => t(s));
  }
  pullDownGroupDataForHideOpenParents(e, t) {
    if (!this.gos.get("groupHideOpenParents") || ke(e))
      return;
    const { colModel: s, showRowGroupCols: i } = this.beans;
    e.forEach((r) => {
      ((i == null ? void 0 : i.getShowRowGroupCols()) ?? []).forEach((o) => {
        const a = o.getColDef().showRowGroup;
        if (typeof a != "string") {
          be(110);
          return;
        }
        const l = a, c = s.getColDefCol(l);
        if (c !== r.rowGroupColumn)
          if (t)
            jl(r, s, o.getId(), void 0);
          else {
            const u = this.getFirstChildOfFirstChild(r, c);
            u && jl(r, s, o.getId(), u.key);
          }
      });
    });
  }
  isShowingValueForOpenedParent(e, t) {
    if (!this.gos.get("groupHideOpenParents") || !e.groupData)
      return !1;
    if (e.rowGroupColumn != null) {
      const i = e.rowGroupColumn.getId();
      if (t.isRowGroupDisplayed(i))
        return !1;
    }
    return e.groupData[t.getId()] != null;
  }
  getFirstChildOfFirstChild(e, t) {
    let s = e;
    for (; s; ) {
      const i = s.parent;
      if (i != null && i.childrenAfterSort && s === i.childrenAfterSort[0]) {
        if (i.rowGroupColumn === t)
          return i;
      } else
        return null;
      s = i;
    }
    return null;
  }
}, Gd = class {
  constructor() {
    this.allSets = {}, this.allParents = [];
  }
  removeFromChildrenAfterGroup(e, t) {
    const s = this.getSet(e);
    s.removeFromChildrenAfterGroup[t.id] = !0;
  }
  isRemoveFromAllLeafChildren(e, t) {
    return !!this.getSet(e).removeFromAllLeafChildren[t.id];
  }
  preventRemoveFromAllLeafChildren(e, t) {
    const s = this.getSet(e);
    delete s.removeFromAllLeafChildren[t.id];
  }
  removeFromAllLeafChildren(e, t) {
    const s = this.getSet(e);
    s.removeFromAllLeafChildren[t.id] = !0;
  }
  getSet(e) {
    return this.allSets[e.id] || (this.allSets[e.id] = {
      removeFromAllLeafChildren: {},
      removeFromChildrenAfterGroup: {}
    }, this.allParents.push(e)), this.allSets[e.id];
  }
  getAllParents() {
    return this.allParents;
  }
  flush() {
    this.allParents.forEach((e) => {
      var i;
      const t = this.allSets[e.id];
      e.childrenAfterGroup = e.childrenAfterGroup.filter(
        (r) => !t.removeFromChildrenAfterGroup[r.id]
      ), e.allLeafChildren = ((i = e.allLeafChildren) == null ? void 0 : i.filter((r) => !t.removeFromAllLeafChildren[r.id])) ?? null, e.updateHasChildren();
      const s = e.sibling;
      s && (s.childrenAfterGroup = e.childrenAfterGroup, s.allLeafChildren = e.allLeafChildren);
    }), this.allSets = {}, this.allParents.length = 0;
  }
};
function Q_(e) {
  if (!e)
    return !1;
  const t = e.length;
  if (t < 2)
    return !1;
  let s = !1;
  for (let i = 1; i < t; i++)
    if (jf(e[i - 1], e[i]) > 0) {
      s = !0;
      break;
    }
  return s ? (e.sort(jf), !0) : !1;
}
function jf(e, t) {
  const s = e.sourceRowIndex, i = t.sourceRowIndex, r = s >= 0, n = i >= 0, o = r && n, a = !r && !n;
  return o ? s - i : a ? e.__objectId - t.__objectId : r ? 1 : -1;
}
var J_ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "groupStage", this.refreshProps = /* @__PURE__ */ new Set([
      "groupDefaultExpanded",
      "groupAllowUnbalanced",
      "initialGroupOrderComparator",
      "groupHideOpenParents",
      "groupDisplayType"
    ]), this.step = "group";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.rowGroupColsSvc = e.rowGroupColsSvc, this.valueSvc = e.valueSvc, this.selectionSvc = e.selectionSvc, this.showRowGroupCols = e.showRowGroupCols;
  }
  execute(e) {
    var i;
    const t = this.createGroupingDetails(e);
    if (t.transactions)
      this.handleTransaction(t);
    else {
      const r = e.afterColumnsChanged === !0;
      this.shotgunResetEverything(t, r);
    }
    const s = e.changedPath;
    this.positionLeafsAndGroups(s), this.orderGroups(t), (i = this.selectionSvc) == null || i.updateSelectableAfterGrouping(s);
  }
  positionLeafsAndGroups(e) {
    e.forEachChangedNodeDepthFirst((t) => {
      if (t.childrenAfterGroup) {
        const s = [], i = [];
        let r;
        t.childrenAfterGroup.forEach((n) => {
          var o;
          (o = n.childrenAfterGroup) != null && o.length ? n.key === "" && !r ? r = n : i.push(n) : s.push(n);
        }), r && i.push(r), t.childrenAfterGroup = [...s, ...i];
      }
    }, !1);
  }
  createGroupingDetails(e) {
    var a;
    const { rowNode: t, changedPath: s, rowNodeTransactions: i, rowNodesOrderChanged: r } = e, n = (a = this.rowGroupColsSvc) == null ? void 0 : a.columns;
    return {
      expandByDefault: this.gos.get("groupDefaultExpanded"),
      groupedCols: n,
      rootNode: t,
      pivotMode: this.colModel.isPivotMode(),
      groupedColCount: (n == null ? void 0 : n.length) ?? 0,
      transactions: i,
      rowNodesOrderChanged: !!r,
      // if no transaction, then it's shotgun, changed path would be 'not active' at this point anyway
      changedPath: s,
      groupAllowUnbalanced: this.gos.get("groupAllowUnbalanced"),
      isGroupOpenByDefault: this.gos.getCallback("isGroupOpenByDefault"),
      initialGroupOrderComparator: this.gos.getCallback("initialGroupOrderComparator"),
      keyCreators: (n == null ? void 0 : n.map((l) => l.getColDef().keyCreator)) ?? []
    };
  }
  handleTransaction(e) {
    e.transactions.forEach((t) => {
      var r, n, o;
      const s = new Gd();
      (r = t.remove) != null && r.length && this.removeNodes(t.remove, e, s), (n = t.update) != null && n.length && this.moveNodesInWrongPath(t.update, e, s), (o = t.add) != null && o.length && this.insertNodes(t.add, e);
      const i = s.getAllParents().slice();
      s.flush(), this.removeEmptyGroups(i, e);
    }), e.rowNodesOrderChanged && this.sortChildren(e);
  }
  // this is used when doing delta updates, eg Redux, keeps nodes in right order
  sortChildren(e) {
    e.changedPath.forEachChangedNodeDepthFirst(
      (t) => {
        Q_(t.childrenAfterGroup) && e.changedPath.addParentNode(t);
      },
      !1,
      !0
    );
  }
  orderGroups(e) {
    const t = e.initialGroupOrderComparator;
    W(t) && s(e.rootNode);
    function s(i) {
      W(i.childrenAfterGroup) && // we only want to sort groups, so we do not sort leafs (a leaf group has leafs as children)
      !i.leafGroup && (i.childrenAfterGroup.sort((n, o) => t({ nodeA: n, nodeB: o })), i.childrenAfterGroup.forEach((n) => s(n)));
    }
  }
  getExistingPathForNode(e, t) {
    const s = [];
    let i = e.parent;
    for (; i && i !== t.rootNode; )
      s.push({
        key: i.key,
        rowGroupColumn: i.rowGroupColumn,
        field: i.field
      }), i = i.parent;
    return s.reverse(), s;
  }
  moveNodesInWrongPath(e, t, s) {
    e.forEach((i) => {
      t.changedPath.active && t.changedPath.addParentNode(i.parent);
      const r = (l) => l.key, n = this.getExistingPathForNode(i, t).map(r), o = this.getGroupInfo(i, t).map(r);
      Ht(n, o) || this.moveNode(i, t, s);
    });
  }
  moveNode(e, t, s) {
    if (this.removeNodesFromParents([e], t, s), this.insertOneNode(e, t, s), e.setData(e.data), t.changedPath.active) {
      const i = e.parent;
      t.changedPath.addParentNode(i);
    }
  }
  removeNodes(e, t, s) {
    this.removeNodesFromParents(e, t, s), t.changedPath.active && e.forEach((i) => t.changedPath.addParentNode(i.parent));
  }
  forEachParentGroup(e, t, s) {
    let i = t;
    for (; i && i !== e.rootNode; )
      s(i), i = i.parent;
  }
  removeNodesFromParents(e, t, s) {
    const i = s == null, r = s || new Gd();
    e.forEach((n) => {
      this.removeFromParent(n, r), this.forEachParentGroup(t, n.parent, (o) => {
        r.removeFromAllLeafChildren(o, n);
      });
    }), i && r.flush();
  }
  removeEmptyGroups(e, t) {
    let s = !0;
    const i = (r) => {
      var l;
      const n = this.getChildrenMappedKey(r.key, r.rowGroupColumn), o = r.parent;
      return (o != null && o.childrenMapped ? !o.childrenMapped[n] : !0) ? !1 : !!r.group && (((l = r.childrenAfterGroup) == null ? void 0 : l.length) ?? 0) === 0;
    };
    for (; s; ) {
      s = !1;
      const r = new Gd();
      e.forEach((n) => {
        this.forEachParentGroup(t, n, (o) => {
          var a;
          i(o) && (s = !0, this.removeFromParent(o, r), (a = this.selectionSvc) == null || a.setNodesSelected({
            nodes: [o],
            newValue: !1,
            source: "rowGroupChanged"
          }));
        });
      }), r.flush();
    }
  }
  // removes the node from the parent by:
  // a) removing from childrenAfterGroup (using batchRemover if present, otherwise immediately)
  // b) removing from childrenMapped (immediately)
  // c) setRowTop(null) - as the rowRenderer uses this to know the RowNode is no longer needed
  // d) setRowIndex(null) - as the rowNode will no longer be displayed.
  removeFromParent(e, t) {
    var i;
    e.parent && (t ? t.removeFromChildrenAfterGroup(e.parent, e) : (kt(e.parent.childrenAfterGroup, e), e.parent.updateHasChildren()));
    const s = this.getChildrenMappedKey(e.key, e.rowGroupColumn);
    (i = e.parent) != null && i.childrenMapped && delete e.parent.childrenMapped[s], e.setRowTop(null), e.setRowIndex(null);
  }
  /**
   * This is idempotent, but relies on the `key` field being the same throughout a RowNode's lifetime
   */
  addToParent(e, t) {
    const s = this.getChildrenMappedKey(e.key, e.rowGroupColumn);
    t != null && t.childrenMapped && t.childrenMapped[s] !== e && (t.childrenMapped[s] = e, t.childrenAfterGroup.push(e), Fb(t, this.beans, !0));
  }
  areGroupColsEqual(e, t) {
    return e == null || t == null || e.pivotMode !== t.pivotMode ? !1 : Ht(e.groupedCols, t.groupedCols) && Ht(e.keyCreators, t.keyCreators);
  }
  checkAllGroupDataAfterColsChanged(e) {
    const t = (s) => {
      s && s.forEach((i) => {
        var o;
        if (!i.group)
          return;
        const n = {
          field: i.field,
          key: i.key,
          rowGroupColumn: i.rowGroupColumn,
          leafNode: (o = i.allLeafChildren) == null ? void 0 : o[0]
        };
        this.setGroupData(i, n), t(i.childrenAfterGroup);
      });
    };
    t(e.rootNode.childrenAfterGroup);
  }
  shotgunResetEverything(e, t) {
    var n, o;
    if (this.noChangeInGroupingColumns(e, t))
      return;
    (o = (n = this.selectionSvc) == null ? void 0 : n.filterFromSelection) == null || o.call(n, (a) => !a.group);
    const { groupedCols: s } = e, i = e.rootNode;
    i.leafGroup = s.length === 0, i.childrenAfterGroup = [], i.childrenMapped = {}, i.updateHasChildren();
    const r = i.sibling;
    r && (r.childrenAfterGroup = i.childrenAfterGroup, r.childrenMapped = i.childrenMapped), this.insertNodes(i.allLeafChildren, e);
  }
  noChangeInGroupingColumns(e, t) {
    let s = !1;
    const i = this.showRowGroupCols.getShowRowGroupCols(), r = i ? i.map((n) => n.getId()).join("-") : "";
    return t && (s = this.areGroupColsEqual(e, this.oldGroupingDetails), this.oldGroupDisplayColIds !== r && this.checkAllGroupDataAfterColsChanged(e)), this.oldGroupingDetails = e, this.oldGroupDisplayColIds = r, s;
  }
  insertNodes(e, t) {
    e.forEach((s) => {
      this.insertOneNode(s, t), t.changedPath.active && t.changedPath.addParentNode(s.parent);
    });
  }
  insertOneNode(e, t, s) {
    const i = this.getGroupInfo(e, t), r = this.findParentForNode(e, i, t, s);
    r.group || I(184, { parentGroupData: r.data, childNodeData: e.data }), e.parent = r, e.level = i.length, r.childrenAfterGroup.push(e), r.updateHasChildren();
  }
  findParentForNode(e, t, s, i) {
    let r = s.rootNode;
    return t.forEach((n, o) => {
      r = this.getOrCreateNextNode(r, n, o, s), i != null && i.isRemoveFromAllLeafChildren(r, e) ? i == null || i.preventRemoveFromAllLeafChildren(r, e) : r.allLeafChildren.push(e);
    }), r;
  }
  getOrCreateNextNode(e, t, s, i) {
    var o;
    const r = this.getChildrenMappedKey(t.key, t.rowGroupColumn);
    let n = (o = e == null ? void 0 : e.childrenMapped) == null ? void 0 : o[r];
    return n || (n = this.createGroup(t, e, s, i), this.addToParent(n, e)), n;
  }
  createGroup(e, t, s, i) {
    const r = new bs(this.beans);
    return r.group = !0, r.field = e.field, r.rowGroupColumn = e.rowGroupColumn, this.setGroupData(r, e), r.key = e.key, r.id = this.createGroupId(r, t, s), r.level = s, r.leafGroup = s === i.groupedColCount - 1, r.allLeafChildren = [], r.setAllChildrenCount(0), r.rowGroupIndex = s, r.childrenAfterGroup = [], r.childrenMapped = {}, r.updateHasChildren(), r.parent = t, this.setExpandedInitialValue(i, r), r;
  }
  createGroupId(e, t, s) {
    const i = (r, n) => {
      if (!r.rowGroupColumn)
        return null;
      const o = n ? i(n, n.parent) : null;
      return `${o == null ? "" : o + "-"}${r.rowGroupColumn.getColId()}-${r.key}`;
    };
    return oa + i(e, t);
  }
  setGroupData(e, t) {
    e.groupData = {}, this.showRowGroupCols.getShowRowGroupCols().forEach((i) => {
      const r = e.rowGroupColumn;
      r !== null && i.isRowGroupDisplayed(r.getId()) && (e.groupData[i.getColId()] = this.valueSvc.getValue(r, t.leafNode));
    });
  }
  getChildrenMappedKey(e, t) {
    return t ? t.getId() + "-" + e : e;
  }
  setExpandedInitialValue(e, t) {
    if (e.pivotMode && t.leafGroup) {
      t.expanded = !1;
      return;
    }
    const s = e.isGroupOpenByDefault;
    if (s) {
      const i = {
        rowNode: t,
        field: t.field,
        key: t.key,
        level: t.level,
        rowGroupColumn: t.rowGroupColumn
      };
      t.expanded = s(i) == !0;
      return;
    }
    if (e.expandByDefault === -1) {
      t.expanded = !0;
      return;
    }
    t.expanded = t.level < e.expandByDefault;
  }
  getGroupInfo(e, t) {
    const s = [];
    return t.groupedCols.forEach((i) => {
      let r = this.valueSvc.getKeyForNode(i, e), n = r != null && r !== "";
      if ((t.pivotMode || !t.groupAllowUnbalanced) && !n && (r = "", n = !0), n) {
        const a = {
          key: r,
          field: i.getColDef().field,
          rowGroupColumn: i,
          leafNode: e
        };
        s.push(a);
      }
    }), s;
  }
};
function e2(e, t) {
  var s;
  (s = e.rowGroupColsSvc) == null || s.setColumns(t, "api");
}
function t2(e, t) {
  var s;
  (s = e.rowGroupColsSvc) == null || s.removeColumns(t, "api");
}
function s2(e, t) {
  var s;
  (s = e.rowGroupColsSvc) == null || s.addColumns(t, "api");
}
function i2(e, t, s) {
  var i, r;
  (r = (i = e.rowGroupColsSvc) == null ? void 0 : i.moveColumn) == null || r.call(i, t, s, "api");
}
function r2(e) {
  var t;
  return ((t = e.rowGroupColsSvc) == null ? void 0 : t.columns) ?? [];
}
var qb = {
  moduleName: "SharedRowGrouping",
  version: Me,
  beans: [Z_],
  apiFunctions: {
    setRowGroupColumns: e2,
    removeRowGroupColumns: t2,
    addRowGroupColumns: s2,
    getRowGroupColumns: r2,
    moveRowGroupColumn: i2
  },
  dependsOn: [Je, Jh, Kb, ep]
}, Yb = {
  moduleName: "RowGrouping",
  version: Me,
  beans: [J_],
  rowModels: ["clientSide"],
  dependsOn: [qb, Wb, Ac]
}, n2 = {
  moduleName: "RowGroupingPanel",
  version: Me,
  selectors: [q_],
  icons: {
    // identifies the pivot drop zone
    pivotPanel: "pivot",
    // "Row groups" drop zone in column tool panel
    rowGroupPanel: "group",
    // separator between column 'pills' when you add multiple columns to the header drop zone
    panelDelimiter: "small-right",
    // version of panelDelimiter used in RTL mode
    panelDelimiterRtl: "small-left"
  },
  dependsOn: [Je, Yi]
}, o2 = {
  moduleName: "GroupFilter",
  version: Me,
  userComponents: { agGroupColumnFilter: Y_, agGroupColumnFloatingFilter: X_ },
  dependsOn: [Je, kr]
}, a2 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowModel", this.firstRow = -1, this.lastRow = -1, this.rowCount = -1, this.rowNodesByIndex = {};
  }
  // we don't implement as lazy row heights is not supported in this row model
  ensureRowHeightsValid(e, t, s, i) {
    return !1;
  }
  postConstruct() {
    const e = this.beans;
    this.rowHeight = vs(e), this.addManagedEventListeners({ viewportChanged: this.onViewportChanged.bind(this) }), this.addManagedPropertyListener("viewportDatasource", () => this.updateDatasource()), this.addManagedPropertyListener("rowHeight", () => {
      this.rowHeight = vs(e), this.updateRowHeights();
    });
  }
  start() {
    this.updateDatasource();
  }
  isLastRowIndexKnown() {
    return !0;
  }
  destroy() {
    this.destroyDatasource(), super.destroy();
  }
  destroyDatasource() {
    var t;
    const e = this.datasource;
    e && ((t = e.destroy) == null || t.call(e), this.beans.rowRenderer.datasourceChanged(), this.firstRow = -1, this.lastRow = -1);
  }
  updateDatasource() {
    const e = this.gos.get("viewportDatasource");
    e && this.setViewportDatasource(e);
  }
  getPageSize() {
    return this.gos.get("viewportRowModelPageSize");
  }
  getBufferSize() {
    return this.gos.get("viewportRowModelBufferSize");
  }
  calculateFirstRow(e) {
    const t = this.getBufferSize(), s = this.getPageSize(), i = e - t;
    return i < 0 ? 0 : Math.floor(i / s) * s;
  }
  calculateLastRow(e) {
    if (e === -1)
      return e;
    const t = this.getBufferSize(), s = this.getPageSize(), i = e + t, r = Math.ceil(i / s) * s, n = this.rowCount - 1;
    return Math.min(r, n);
  }
  onViewportChanged(e) {
    var i;
    const t = this.calculateFirstRow(e.firstRow), s = this.calculateLastRow(e.lastRow);
    (this.firstRow !== t || this.lastRow !== s) && (this.firstRow = t, this.lastRow = s, this.purgeRowsNotInViewport(), (i = this.datasource) == null || i.setViewportRange(this.firstRow, this.lastRow));
  }
  purgeRowsNotInViewport() {
    const e = this.rowNodesByIndex;
    Object.keys(e).forEach((t) => {
      const s = parseInt(t, 10);
      if (s < this.firstRow || s > this.lastRow) {
        if (this.isRowFocused(s))
          return;
        delete e[s];
      }
    });
  }
  isRowFocused(e) {
    const t = this.beans.focusSvc.getFocusCellToUseAfterRefresh();
    return !t || t.rowPinned != null ? !1 : t.rowIndex === e;
  }
  setViewportDatasource(e) {
    this.destroyDatasource(), this.datasource = e, this.rowCount = -1, e.init ? e.init({
      setRowCount: this.setRowCount.bind(this),
      setRowData: this.setRowData.bind(this),
      getRow: this.getRow.bind(this)
    }) : I(226);
  }
  getType() {
    return "viewport";
  }
  getRow(e) {
    return this.rowNodesByIndex[e] || (this.rowNodesByIndex[e] = this.createBlankRowNode(e)), this.rowNodesByIndex[e];
  }
  getRowNode(e) {
    let t;
    return this.forEachNode((s) => {
      s.id === e && (t = s);
    }), t;
  }
  getRowCount() {
    return this.rowCount === -1 ? 0 : this.rowCount;
  }
  getRowIndexAtPixel(e) {
    return this.rowHeight !== 0 ? Math.floor(e / this.rowHeight) : 0;
  }
  getRowBounds(e) {
    const t = this.rowHeight;
    return {
      rowHeight: t,
      rowTop: t * e
    };
  }
  updateRowHeights() {
    const e = this.rowHeight;
    this.forEachNode((t) => {
      t.setRowHeight(e), t.setRowTop(e * t.rowIndex);
    }), this.eventSvc.dispatchEvent({
      type: "modelUpdated",
      newData: !1,
      newPage: !1,
      keepRenderedRows: !0,
      animate: !1
    });
  }
  getTopLevelRowCount() {
    return this.getRowCount();
  }
  getTopLevelRowDisplayedIndex(e) {
    return e;
  }
  isEmpty() {
    return this.rowCount > 0;
  }
  isRowsToRender() {
    return this.rowCount > 0;
  }
  getNodesInRangeForSelection(e, t) {
    const s = e.rowIndex, i = t.rowIndex, r = s < this.firstRow || s > this.lastRow, n = i < this.firstRow || i > this.lastRow;
    if (r || n)
      return [];
    const o = [], a = s <= i ? s : i, l = s <= i ? i : s;
    for (let c = a; c <= l; c++)
      o.push(this.rowNodesByIndex[c]);
    return o;
  }
  forEachNode(e) {
    let t = 0;
    Object.keys(this.rowNodesByIndex).forEach((s) => {
      const i = parseInt(s, 10), r = this.rowNodesByIndex[i];
      e(r, t), t++;
    });
  }
  setRowData(e) {
    const t = this.rowNodesByIndex;
    for (const [s, i] of Object.entries(e)) {
      const r = parseInt(s, 10);
      if (r >= this.firstRow && r <= this.lastRow) {
        let n = t[r];
        ke(n) && (n = this.createBlankRowNode(r), t[r] = n), n.setDataAndId(i, r.toString());
      }
    }
  }
  createBlankRowNode(e) {
    const t = new bs(this.beans), s = this.rowHeight;
    return t.setRowHeight(s), t.setRowTop(s * e), t.setRowIndex(e), t;
  }
  setRowCount(e, t = !1) {
    if (e === this.rowCount)
      return;
    this.rowCount = e;
    const s = this.eventSvc;
    s.dispatchEventOnce({
      type: "rowCountReady"
    }), s.dispatchEvent({
      type: "modelUpdated",
      newData: !1,
      newPage: !1,
      keepRenderedRows: t,
      animate: !1
    });
  }
  isRowPresent(e) {
    return !!this.getRowNode(e.id);
  }
}, l2 = {
  moduleName: "ViewportRowModel",
  version: Me,
  rowModels: ["viewport"],
  beans: [a2],
  dependsOn: [Je]
};
function c2(e, t) {
  var s;
  (s = e.clipboardSvc) == null || s.copyToClipboard(t);
}
function d2(e, t) {
  var s;
  (s = e.clipboardSvc) == null || s.cutToClipboard(t);
}
function u2(e, t) {
  var s;
  (s = e.clipboardSvc) == null || s.copySelectedRowsToClipboard(t);
}
function h2(e, t) {
  var s;
  (s = e.clipboardSvc) == null || s.copySelectedRangeToClipboard(t);
}
function p2(e) {
  var t;
  (t = e.clipboardSvc) == null || t.copyRangeDown();
}
function g2(e) {
  var t;
  (t = e.clipboardSvc) == null || t.pasteFromClipboard();
}
var Bd = "paste", Vd = "dragCopy", Kf = "clipboard";
function f2(e, t = ",") {
  const s = [], i = (n) => n === "\r" || n === `
`;
  let r = !1;
  if (e === "")
    return [[""]];
  for (let n = 0, o = 0, a = 0; a < e.length; a++) {
    const l = e[a - 1], c = e[a], d = e[a + 1], u = () => {
      s[n] || (s[n] = []), s[n][o] || (s[n][o] = "");
    };
    if (u(), c === '"' && (r ? d === '"' ? (s[n][o] += '"', a++) : r = !1 : (l === void 0 || l === t || i(l)) && (r = !0)), !r && c !== '"') {
      if (c === t) {
        o++, u();
        continue;
      } else if (i(c)) {
        o = 0, n++, u(), c === "\r" && d === `
` && a++;
        continue;
      }
    }
    s[n][o] += c;
  }
  return s;
}
var m2 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "clipboardSvc", this.clientSideRowModel = null, this.gridCtrl = null, this.lastPasteOperationTime = 0, this.navigatorApiFailed = !1;
  }
  postConstruct() {
    const { gos: e, rowModel: t, ctrlsSvc: s } = this.beans;
    Ye(e) && (this.clientSideRowModel = t), s.whenReady(this, (i) => {
      this.gridCtrl = i.gridCtrl;
    });
  }
  destroy() {
    super.destroy(), this.clientSideRowModel = null, this.gridCtrl = null;
  }
  pasteFromClipboard() {
    !this.gos.get("suppressClipboardApi") && !this.navigatorApiFailed && navigator.clipboard && navigator.clipboard.readText ? navigator.clipboard.readText().then(this.processClipboardData.bind(this)).catch((t) => {
      I(40, { e: t, method: "readText" }), this.navigatorApiFailed = !0, this.pasteFromClipboardLegacy();
    }) : this.pasteFromClipboardLegacy();
  }
  pasteFromClipboardLegacy() {
    let e = !1;
    const t = (s) => {
      const i = (/* @__PURE__ */ new Date()).getTime();
      i - this.lastPasteOperationTime < 50 && (e = !0, s.preventDefault()), this.lastPasteOperationTime = i;
    };
    this.executeOnTempElement(
      (s) => {
        s.addEventListener("paste", t), s.focus({ preventScroll: !0 });
      },
      (s) => {
        const i = s.value;
        e ? this.refocusLastFocusedCell() : this.processClipboardData(i), s.removeEventListener("paste", t);
      }
    );
  }
  refocusLastFocusedCell() {
    const { focusSvc: e } = this.beans, t = e.getFocusedCell();
    t && e.setFocusedCell({
      rowIndex: t.rowIndex,
      column: t.column,
      rowPinned: t.rowPinned,
      forceBrowserFocus: !0
    });
  }
  getClipboardDelimiter() {
    const e = this.gos.get("clipboardDelimiter");
    return W(e) ? e : "	";
  }
  processClipboardData(e) {
    if (e == null)
      return;
    let t = f2(e, this.getClipboardDelimiter());
    const s = this.gos.getCallback("processDataFromClipboard");
    if (s && (t = s({ data: t })), t == null)
      return;
    this.gos.get("suppressLastEmptyLineOnPaste") && this.removeLastLineIfBlank(t);
    const { rangeSvc: i } = this.beans, r = (n, o, a, l) => {
      (i == null ? void 0 : i.isMoreThanOneCell()) && !this.hasOnlyOneValueToPaste(t) ? this.pasteIntoActiveRange(i, t, n, o, l) : this.pasteStartingFromFocusedCell(t, n, o, a, l);
    };
    this.doPasteOperation(r);
  }
  // common code to paste operations, e.g. paste to cell, paste to range, and copy range down
  doPasteOperation(e) {
    const t = "clipboard", { eventSvc: s, focusSvc: i, rowRenderer: r, gos: n } = this.beans;
    s.dispatchEvent({
      type: "pasteStart",
      source: t
    });
    const { clientSideRowModel: o } = this, a = o == null ? void 0 : o.rootNode, l = a && new so(n.get("aggregateOnlyChangedColumns"), a), c = {}, d = [], u = i.getFocusedCell();
    e(c, d, u, l);
    const h = [...d];
    l && (o.doAggregate(l), l.forEachChangedNodeDepthFirst((p) => {
      h.push(p);
    })), r.refreshCells({ rowNodes: h }), this.dispatchFlashCells(c), this.fireRowChanged(d), this.refocusLastFocusedCell(), s.dispatchEvent({
      type: "pasteEnd",
      source: t
    });
  }
  pasteIntoActiveRange(e, t, s, i, r) {
    const n = this.getRangeSize(e) % t.length != 0;
    let o = 0, a = 0;
    const l = (c, d, u, h) => {
      if (h - o >= t.length) {
        if (n)
          return;
        o += a, a = 0;
      }
      const g = t[h - o];
      i.push(d);
      const f = this.gos.getCallback("processCellFromClipboard");
      u.forEach((m, C) => {
        if (!m.isCellEditable(d) || m.isSuppressPaste(d))
          return;
        C >= g.length && (C = C % g.length);
        const w = this.processCell(
          d,
          m,
          g[C],
          Vd,
          f,
          !0
        );
        d.setDataValue(m, w, Bd), r && r.addParentNode(d.parent, [m]);
        const { rowIndex: y, rowPinned: b } = c, x = cr({ rowIndex: y, column: m, rowPinned: b });
        s[x] = !0;
      }), a++;
    };
    this.iterateActiveRanges(!1, l);
  }
  getDisplayedColumnsStartingAt(e) {
    let t = e;
    const s = [], i = this.beans.visibleCols;
    for (; t != null; )
      s.push(t), t = i.getColAfter(t);
    return s;
  }
  pasteStartingFromFocusedCell(e, t, s, i, r) {
    if (!i)
      return;
    const n = { rowIndex: i.rowIndex, rowPinned: i.rowPinned }, o = this.getDisplayedColumnsStartingAt(i.column);
    this.isPasteSingleValueIntoRange(e) ? this.pasteSingleValueIntoRange(e, s, t, r) : this.pasteMultipleValues(
      e,
      n,
      s,
      o,
      t,
      Kf,
      r
    );
  }
  // if range is active, and only one cell, then we paste this cell into all cells in the active range.
  isPasteSingleValueIntoRange(e) {
    const t = this.beans.rangeSvc;
    return this.hasOnlyOneValueToPaste(e) && !!t && !t.isEmpty();
  }
  pasteSingleValueIntoRange(e, t, s, i) {
    const r = e[0][0], n = (o, a, l) => {
      t.push(a), l.forEach(
        (c) => this.updateCellValue(a, c, r, s, Kf, i)
      );
    };
    this.iterateActiveRanges(!1, n);
  }
  hasOnlyOneValueToPaste(e) {
    return e.length === 1 && e[0].length === 1;
  }
  copyRangeDown() {
    const { rangeSvc: e, gos: t, valueSvc: s } = this.beans;
    if (!e || e.isEmpty())
      return;
    const i = [], r = (n, o, a, l) => {
      const c = t.getCallback("processCellForClipboard"), d = t.getCallback("processCellFromClipboard"), u = (h, p, g) => {
        i.length ? (o.push(p), g.forEach((f, m) => {
          if (!f.isCellEditable(p) || f.isSuppressPaste(p))
            return;
          const C = this.processCell(
            p,
            f,
            i[m],
            Vd,
            d,
            !0
          );
          p.setDataValue(f, C, Bd), l && l.addParentNode(p.parent, [f]);
          const { rowIndex: w, rowPinned: y } = h, b = cr({ rowIndex: w, column: f, rowPinned: y });
          n[b] = !0;
        })) : g.forEach((f) => {
          const m = this.processCell(
            p,
            f,
            s.getValue(f, p),
            Vd,
            c,
            !1,
            !0
          );
          i.push(m);
        });
      };
      this.iterateActiveRanges(!0, u);
    };
    this.doPasteOperation(r);
  }
  removeLastLineIfBlank(e) {
    const t = pe(e);
    if (t && t.length === 1 && t[0] === "") {
      if (e.length === 1)
        return;
      kt(e, t);
    }
  }
  fireRowChanged(e) {
    this.gos.get("editType") === "fullRow" && e.forEach((t) => {
      this.eventSvc.dispatchEvent({
        type: "rowValueChanged",
        node: t,
        data: t.data,
        rowIndex: t.rowIndex,
        rowPinned: t.rowPinned
      });
    });
  }
  pasteMultipleValues(e, t, s, i, r, n, o) {
    let a = t;
    const l = this.beans, { gos: c, cellNavigation: d } = l, u = this.clientSideRowModel != null && !c.get("enableGroupEdit") && !c.get("treeData"), h = () => {
      for (; ; ) {
        if (!a)
          return null;
        const p = ri(l, a);
        if (a = d.getRowBelow({
          rowPinned: a.rowPinned,
          rowIndex: a.rowIndex
        }), p == null)
          return null;
        if (!(p.detail || p.footer || u && p.group))
          return p;
      }
    };
    e.forEach((p) => {
      const g = h();
      g && (p.forEach(
        (f, m) => this.updateCellValue(g, i[m], f, r, n, o)
      ), s.push(g));
    });
  }
  updateCellValue(e, t, s, i, r, n) {
    if (!e || !t || !t.isCellEditable(e) || t.isSuppressPaste(e))
      return;
    const o = this.processCell(
      e,
      t,
      s,
      r,
      this.gos.getCallback("processCellFromClipboard"),
      !0
    );
    e.setDataValue(t, o, Bd);
    const { rowIndex: a, rowPinned: l } = e, c = cr({ rowIndex: a, column: t, rowPinned: l });
    i[c] = !0, n && n.addParentNode(e.parent, [t]);
  }
  copyToClipboard(e = {}) {
    this.copyOrCutToClipboard(e);
  }
  cutToClipboard(e = {}, t = "api") {
    this.gos.get("suppressCutToClipboard") || (this.eventSvc.dispatchEvent({
      type: "cutStart",
      source: t
    }), this.copyOrCutToClipboard(e, !0), this.eventSvc.dispatchEvent({
      type: "cutEnd",
      source: t
    }));
  }
  copyOrCutToClipboard(e, t) {
    let { includeHeaders: s, includeGroupHeaders: i } = e;
    const { gos: r, focusSvc: n } = this.beans;
    s == null && (s = r.get("copyHeadersToClipboard")), i == null && (i = r.get("copyGroupHeadersToClipboard"));
    const o = { includeHeaders: s, includeGroupHeaders: i }, a = r.get("rowSelection"), l = r.get("cellSelection");
    let c = null;
    this.shouldCopyCells(l, a) ? (this.copySelectedRangeToClipboard(o), c = 0) : this.shouldCopyRows(a) ? (this.copySelectedRowsToClipboard(o), c = 1) : n.isAnyCellFocused() && (this.copyFocusedCellToClipboard(o), c = 2), t && c !== null && this.clearCellsAfterCopy(c);
  }
  shouldCopyCells(e, t) {
    const { rangeSvc: s, selectionSvc: i, gos: r } = this.beans;
    if (!s || s.isEmpty())
      return !1;
    if (e)
      return !(typeof t == "object" && t.copySelectedRows && !(i != null && i.isEmpty()));
    {
      const n = r.get("suppressCopySingleCellRanges");
      return !(!s.isMoreThanOneCell() && n);
    }
  }
  shouldCopyRows(e) {
    const { selectionSvc: t, gos: s } = this.beans;
    return (t == null ? void 0 : t.isEmpty()) ?? !0 ? !1 : e && typeof e != "string" ? e.copySelectedRows ?? !1 : !s.get("suppressCopyRowsToClipboard");
  }
  clearCellsAfterCopy(e) {
    const t = this.beans, { rangeSvc: s, focusSvc: i, eventSvc: r } = t;
    if (r.dispatchEvent({ type: "keyShortcutChangedCellStart" }), e === 0)
      s.clearCellRangeCellValues({ cellEventSource: "clipboardSvc" });
    else if (e === 1)
      this.clearSelectedRows();
    else {
      const n = i.getFocusedCell();
      if (n == null)
        return;
      const o = ri(t, n);
      o && this.clearCellValue(o, n.column);
    }
    r.dispatchEvent({ type: "keyShortcutChangedCellEnd" });
  }
  clearSelectedRows() {
    const { selectionSvc: e, visibleCols: t } = this.beans, s = (e == null ? void 0 : e.getSelectedNodes()) ?? [], i = t.allCols;
    for (const r of s)
      for (const n of i)
        this.clearCellValue(r, n);
  }
  clearCellValue(e, t) {
    if (!t.isCellEditable(e))
      return;
    const s = this.beans.valueSvc.getDeleteValue(t, e);
    e.setDataValue(t, s, "clipboardSvc");
  }
  iterateActiveRanges(e, t, s) {
    const i = this.beans.rangeSvc;
    if (!i || i.isEmpty())
      return;
    const r = i.getCellRanges();
    e ? this.iterateActiveRange(r[0], t, s, !0) : r.forEach(
      (n, o) => this.iterateActiveRange(n, t, s, o === r.length - 1)
    );
  }
  iterateActiveRange(e, t, s, i) {
    const { rangeSvc: r, cellNavigation: n } = this.beans;
    if (!r)
      return;
    let o = r.getRangeStartRow(e);
    const a = r.getRangeEndRow(e);
    s && e.columns && s(e.columns);
    let l = 0, c = !1;
    for (; !c && o != null; ) {
      const d = ri(this.beans, o);
      c = Pt(o, a), t(o, d, e.columns, l++, c && i), o = n.getRowBelow(o);
    }
  }
  copySelectedRangeToClipboard(e = {}) {
    const t = this.beans.rangeSvc;
    if (!t || t.isEmpty())
      return;
    const s = t.areAllRangesAbleToMerge(), { data: i, cellsToFlash: r } = s ? this.buildDataFromMergedRanges(t, e) : this.buildDataFromRanges(t, e);
    this.copyDataToClipboard(i), this.dispatchFlashCells(r);
  }
  buildDataFromMergedRanges(e, t) {
    const s = /* @__PURE__ */ new Set(), i = e.getCellRanges(), r = /* @__PURE__ */ new Map(), n = [], o = {};
    i.forEach((d) => {
      d.columns.forEach((p) => s.add(p));
      const { rowPositions: u, cellsToFlash: h } = this.getRangeRowPositionsAndCellsToFlash(e, d);
      u.forEach((p) => {
        const g = `${p.rowIndex}-${p.rowPinned || "null"}`;
        r.get(g) || (r.set(g, !0), n.push(p));
      }), Object.assign(o, h);
    });
    const a = this.beans.visibleCols.allCols, l = Array.from(s);
    return l.sort((d, u) => {
      const h = a.indexOf(d), p = a.indexOf(u);
      return h - p;
    }), { data: this.buildExportParams({
      columns: l,
      rowPositions: n,
      includeHeaders: t.includeHeaders,
      includeGroupHeaders: t.includeGroupHeaders
    }), cellsToFlash: o };
  }
  buildDataFromRanges(e, t) {
    const s = e.getCellRanges(), i = [], r = {};
    return s.forEach((n) => {
      const { rowPositions: o, cellsToFlash: a } = this.getRangeRowPositionsAndCellsToFlash(e, n);
      Object.assign(r, a), i.push(
        this.buildExportParams({
          columns: n.columns,
          rowPositions: o,
          includeHeaders: t.includeHeaders,
          includeGroupHeaders: t.includeGroupHeaders
        })
      );
    }), { data: i.join(`
`), cellsToFlash: r };
  }
  getRangeRowPositionsAndCellsToFlash(e, t) {
    const s = [], i = {}, r = e.getRangeStartRow(t), n = e.getRangeEndRow(t);
    let o = r;
    for (; o && (s.push(o), t.columns.forEach((a) => {
      const { rowIndex: l, rowPinned: c } = o, d = cr({ rowIndex: l, column: a, rowPinned: c });
      i[d] = !0;
    }), !Pt(o, n)); )
      o = this.beans.cellNavigation.getRowBelow(o);
    return { rowPositions: s, cellsToFlash: i };
  }
  getCellsToFlashFromRowNodes(e) {
    const t = this.beans.visibleCols.allCols, s = {};
    for (let i = 0; i < e.length; i++) {
      const { level: r, rowIndex: n, rowPinned: o, sibling: a } = e[i], l = r === -1 ? a.rowIndex : n;
      if (l != null)
        for (let c = 0; c < t.length; c++) {
          const d = t[c], u = cr({ rowIndex: l, column: d, rowPinned: o });
          s[u] = !0;
        }
    }
    return s;
  }
  copyFocusedCellToClipboard(e = {}) {
    const t = this.beans.focusSvc.getFocusedCell();
    if (t == null)
      return;
    const s = cr(t), i = { rowPinned: t.rowPinned, rowIndex: t.rowIndex }, r = t.column, n = this.buildExportParams({
      columns: [r],
      rowPositions: [i],
      includeHeaders: e.includeHeaders,
      includeGroupHeaders: e.includeGroupHeaders
    });
    this.copyDataToClipboard(n), this.dispatchFlashCells({ [s]: !0 });
  }
  copySelectedRowsToClipboard(e = {}) {
    var o;
    const { columnKeys: t, includeHeaders: s, includeGroupHeaders: i } = e, r = this.buildExportParams({
      columns: t,
      includeHeaders: s,
      includeGroupHeaders: i
    });
    this.copyDataToClipboard(r);
    const n = ((o = this.beans.selectionSvc) == null ? void 0 : o.getSelectedNodes()) || [];
    this.dispatchFlashCells(this.getCellsToFlashFromRowNodes(n));
  }
  buildExportParams(e) {
    const { columns: t, rowPositions: s, includeHeaders: i = !1, includeGroupHeaders: r = !1 } = e, { gos: n, csvCreator: o } = this.beans, a = {
      columnKeys: t,
      rowPositions: s,
      skipColumnHeaders: !i,
      skipColumnGroupHeaders: !r,
      suppressQuotes: !0,
      columnSeparator: this.getClipboardDelimiter(),
      onlySelected: !s,
      processCellCallback: n.getCallback("processCellForClipboard"),
      processRowGroupCallback: (l) => this.processRowGroupCallback(l),
      processHeaderCallback: n.getCallback("processHeaderForClipboard"),
      processGroupHeaderCallback: n.getCallback("processGroupHeaderForClipboard")
    };
    return o.getDataAsCsv(a, !0);
  }
  processRowGroupCallback({ node: e, column: t }) {
    const { gos: s, valueSvc: i, rowGroupColsSvc: r } = this.beans, n = s.get("treeData");
    let a = (() => {
      var d;
      if (n || !t)
        return e.key;
      const c = (d = e.groupData) == null ? void 0 : d[t.getId()];
      return !c || !e.rowGroupColumn || e.rowGroupColumn.getColDef().useValueFormatterForExport === !1 ? c : i.formatValue(e.rowGroupColumn, e, c) ?? c;
    })();
    if (e.footer) {
      let c = "";
      a && a.length && (c = ` ${a}`), a = `Total${c}`;
    }
    const l = s.getCallback("processCellForClipboard");
    if (l) {
      let c = e.rowGroupColumn;
      return !c && e.footer && e.level === -1 && r && (c = r.columns[0]), l({
        value: a,
        node: e,
        column: c,
        type: "clipboard",
        formatValue: (d) => i.formatValue(c, e, d) ?? d,
        parseValue: (d) => i.parseValue(c, e, d, i.getValue(c, e))
      });
    }
    return a;
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  dispatchFlashCells(e) {
    window.setTimeout(() => {
      this.eventSvc.dispatchEvent({
        type: "flashCells",
        cells: e
      });
    }, 0);
  }
  processCell(e, t, s, i, r, n, o) {
    const a = this.beans.valueSvc;
    return r ? r({
      column: t,
      node: e,
      value: s,
      type: i,
      formatValue: (c) => a.formatValue(t, e ?? null, c) ?? c,
      parseValue: (c) => a.parseValue(t, e ?? null, c, a.getValue(t, e))
    }) : n && t.getColDef().useValueParserForImport !== !1 ? a.parseValue(t, e ?? null, s, a.getValue(t, e)) : o && t.getColDef().useValueFormatterForExport !== !1 ? a.formatValue(t, e ?? null, s) ?? s : s;
  }
  copyDataToClipboard(e) {
    const t = this.gos.getCallback("sendToClipboard");
    if (t) {
      t({ data: e });
      return;
    }
    if (!this.gos.get("suppressClipboardApi") && navigator.clipboard) {
      navigator.clipboard.writeText(e).catch((i) => {
        I(40, { e: i, method: "writeText" }), this.copyDataToClipboardLegacy(e);
      });
      return;
    }
    this.copyDataToClipboardLegacy(e);
  }
  copyDataToClipboardLegacy(e) {
    this.executeOnTempElement((t) => {
      const s = We(this.beans), i = Ie(this.beans);
      t.value = e || " ", t.select(), t.focus({ preventScroll: !0 }), s.execCommand("copy") || I(41), i != null && i.focus != null && i.focus({ preventScroll: !0 });
    });
  }
  executeOnTempElement(e, t) {
    if (!this.gridCtrl)
      return;
    const s = We(this.beans), i = s.createElement("textarea"), r = i.style;
    r.width = "1px", r.height = "1px";
    const n = s.documentElement;
    r.top = n.scrollTop + "px", r.left = n.scrollLeft + "px", r.position = "absolute", r.opacity = "0";
    const o = this.gridCtrl.getGui();
    o.appendChild(i);
    try {
      e(i);
    } catch {
      I(42);
    }
    t ? window.setTimeout(() => {
      t(i), o.removeChild(i);
    }, 100) : o.removeChild(i);
  }
  getRangeSize(e) {
    const t = e.getCellRanges();
    let s = 0, i = 0;
    return t.length > 0 && (s = e.getRangeStartRow(t[0]).rowIndex, i = e.getRangeEndRow(t[0]).rowIndex), s - i + 1;
  }
}, C2 = {
  moduleName: "Clipboard",
  version: Me,
  beans: [m2],
  apiFunctions: {
    copyToClipboard: c2,
    cutToClipboard: d2,
    copySelectedRowsToClipboard: u2,
    copySelectedRangeToClipboard: h2,
    copySelectedRangeDown: p2,
    pasteFromClipboard: g2
  },
  dependsOn: [Je, Uy, Sc, $y]
}, v2 = class extends _ {
  constructor() {
    super(...arguments), this.eExpand = E, this.eFilterTextField = E;
  }
  postConstruct() {
    this.setTemplate(
      /* html */
      `<div class="ag-filter-toolpanel-search" role="presentation">
                <div data-ref="eExpand" class="ag-filter-toolpanel-expand"></div>
                <ag-input-text-field data-ref="eFilterTextField" class="ag-filter-toolpanel-search-input"></ag-input-text-field>
            </div>`,
      [Ks]
    );
    const e = this.getLocaleTextFunc();
    this.eFilterTextField.setAutoComplete(!1).setInputAriaLabel(e("ariaFilterColumnsInput", "Filter Columns Input")).onValueChange(this.onSearchTextChanged.bind(this)), this.createExpandIcons(), this.setExpandState(
      0
      /* EXPANDED */
    ), this.addManagedElementListeners(this.eExpand, { click: this.onExpandClicked.bind(this) }), this.addManagedEventListeners({ newColumnsLoaded: this.showOrHideOptions.bind(this) });
  }
  init(e) {
    this.params = e, this.beans.colModel.ready && this.showOrHideOptions();
  }
  createExpandIcons() {
    const { eExpand: e, beans: t } = this;
    e.appendChild(this.eExpandChecked = ue("accordionOpen", t)), e.appendChild(this.eExpandUnchecked = ue("accordionClosed", t)), e.appendChild(this.eExpandIndeterminate = ue("accordionIndeterminate", t));
  }
  // we only show expand / collapse if we are showing filters
  showOrHideOptions() {
    const { params: e, eFilterTextField: t } = this, s = !e.suppressFilterSearch, i = !e.suppressExpandAll, r = this.getLocaleTextFunc();
    t.setInputPlaceholder(r("searchOoo", "Search..."));
    const n = (a) => a.getOriginalParent() && a.isFilterAllowed(), o = this.beans.colModel.getCols().some(n);
    re(t.getGui(), s), re(this.eExpand, i && o);
  }
  onSearchTextChanged() {
    this.onSearchTextChangedDebounced || (this.onSearchTextChangedDebounced = Et(
      this,
      () => this.dispatchLocalEvent({ type: "searchChanged", searchText: this.eFilterTextField.getValue() }),
      300
    )), this.onSearchTextChangedDebounced();
  }
  onExpandClicked() {
    const e = this.currentExpandState === 0 ? { type: "collapseAll" } : { type: "expandAll" };
    this.dispatchLocalEvent(e);
  }
  setExpandState(e) {
    this.currentExpandState = e, re(
      this.eExpandChecked,
      e === 0
      /* EXPANDED */
    ), re(
      this.eExpandUnchecked,
      e === 1
      /* COLLAPSED */
    ), re(
      this.eExpandIndeterminate,
      e === 2
      /* INDETERMINATE */
    );
  }
}, w2 = {
  selector: "AG-FILTERS-TOOL-PANEL-HEADER",
  component: v2
}, Xb = class extends _ {
  constructor(e, t) {
    super(
      /* html */
      `
            <div class="ag-filter-toolpanel-instance">
                <div class="ag-filter-toolpanel-header ag-filter-toolpanel-instance-header" data-ref="eFilterToolPanelHeader" role="button" aria-expanded="false">
                    <div data-ref="eExpand" class="ag-filter-toolpanel-expand"></div>
                    <span data-ref="eFilterName" class="ag-header-cell-text"></span>
                    <span data-ref="eFilterIcon" class="ag-header-icon ag-filter-icon ag-filter-toolpanel-instance-header-icon" aria-hidden="true"></span>
                </div>
                <div class="ag-filter-toolpanel-instance-body ag-filter" data-ref="agFilterToolPanelBody"></div>
            </div>`
    ), this.hideHeader = e, this.expandedCallback = t, this.eFilterToolPanelHeader = E, this.eFilterName = E, this.agFilterToolPanelBody = E, this.eFilterIcon = E, this.eExpand = E, this.expanded = !1;
  }
  postConstruct() {
    const { beans: e, eExpand: t } = this, s = ue("accordionOpen", e);
    this.eExpandChecked = s;
    const i = ue("accordionClosed", e);
    this.eExpandUnchecked = i, t.appendChild(s), t.appendChild(i);
  }
  setColumn(e) {
    this.column = e;
    const { beans: t, eFilterToolPanelHeader: s, eFilterIcon: i, eExpandChecked: r, hideHeader: n } = this;
    this.eFilterName.innerText = t.colNames.getDisplayNameForColumn(e, "filterToolPanel", !1) || "", this.addManagedListeners(s, {
      click: this.toggleExpanded.bind(this),
      keydown: this.onKeyDown.bind(this)
    }), this.addManagedEventListeners({ filterOpened: this.onFilterOpened.bind(this) }), this.addInIcon("filterActive", i, e), re(i, this.isFilterActive(), { skipAriaHidden: !0 }), re(r, !1), n ? (re(s, !1), s.removeAttribute("tabindex")) : s.setAttribute("tabindex", "0"), this.addManagedListeners(e, { filterChanged: this.onFilterChanged.bind(this) });
  }
  onKeyDown(e) {
    const { key: t } = e, { ENTER: s, SPACE: i, LEFT: r, RIGHT: n } = P;
    t !== s && t !== i && t !== r && t !== n || (e.preventDefault(), t === s || t === i ? this.toggleExpanded() : t === P.LEFT ? this.collapse() : this.expand());
  }
  getColumn() {
    return this.column;
  }
  getColumnFilterName() {
    return this.beans.colNames.getDisplayNameForColumn(this.column, "filterToolPanel", !1);
  }
  addCssClassToTitleBar(e) {
    this.eFilterToolPanelHeader.classList.add(e);
  }
  addInIcon(e, t, s) {
    if (t == null)
      return;
    const i = ue(e, this.beans, s);
    t.appendChild(i);
  }
  isFilterActive() {
    var e;
    return !!((e = this.beans.filterManager) != null && e.isFilterActive(this.column));
  }
  onFilterChanged() {
    re(this.eFilterIcon, this.isFilterActive(), { skipAriaHidden: !0 }), this.dispatchLocalEvent({ type: "filterChanged" });
  }
  toggleExpanded() {
    this.expanded ? this.collapse() : this.expand();
  }
  expand() {
    this.expanded || (this.expanded = !0, ns(this.eFilterToolPanelHeader, !0), re(this.eExpandChecked, !0), re(this.eExpandUnchecked, !1), this.addFilterElement(), this.expandedCallback());
  }
  addFilterElement(e) {
    var i;
    const t = ss(
      /* html */
      '<div class="ag-filter-toolpanel-instance-filter"></div>'
    ), s = this.createManagedBean(new fc(this.column, "TOOLBAR"));
    this.filterWrapperComp = s, s.hasFilter() && ((i = s.getFilter()) == null || i.then((r) => {
      this.underlyingFilter = r, r && (t.appendChild(s.getGui()), this.agFilterToolPanelBody.appendChild(t), s.afterGuiAttached({ container: "toolPanel", suppressFocus: e }));
    }));
  }
  collapse() {
    if (!this.expanded)
      return;
    this.expanded = !1, ns(this.eFilterToolPanelHeader, !1), this.removeFilterElement(), re(this.eExpandChecked, !1), re(this.eExpandUnchecked, !0);
    const e = this.filterWrapperComp;
    e == null || e.afterGuiDetached(), this.destroyBean(e), this.expandedCallback();
  }
  removeFilterElement() {
    ze(this.agFilterToolPanelBody);
  }
  isExpanded() {
    return this.expanded;
  }
  refreshFilter(e) {
    var s;
    if (!this.expanded)
      return;
    const t = this.underlyingFilter;
    t && (e ? typeof t.refreshVirtualList == "function" && t.refreshVirtualList() : (s = t.afterGuiDetached) == null || s.call(t));
  }
  onFilterOpened(e) {
    e.source === "COLUMN_MENU" && e.column === this.column && this.expanded && this.collapse();
  }
}, lr = class Zb extends _ {
  constructor(t, s, i, r, n) {
    super(), this.columnGroup = t, this.childFilterComps = s, this.expandedCallback = i, this.depth = r, this.showingColumn = n, this.filterGroupComp = E;
  }
  postConstruct() {
    const t = {
      cssIdentifier: "filter-toolpanel",
      direction: "vertical"
    };
    this.setTemplate(
      /* html */
      `<div class="ag-filter-toolpanel-group-wrapper">
            <ag-group-component data-ref="filterGroupComp"></ag-group-component>
        </div>`,
      [dt],
      { filterGroupComp: t }
    ), this.setGroupTitle();
    const { filterGroupComp: s, depth: i, childFilterComps: r, gos: n } = this;
    s.setAlignItems("stretch"), s.addCssClass(`ag-filter-toolpanel-group-level-${i}`), s.getGui().style.setProperty("--ag-indentation-level", String(i)), s.addCssClassToTitleBar(`ag-filter-toolpanel-group-level-${i}-header`), r.forEach((o) => {
      s.addItem(o), o.addCssClassToTitleBar(`ag-filter-toolpanel-group-level-${i + 1}-header`), o.getGui().style.setProperty("--ag-indentation-level", String(i + 1));
    }), this.tooltipFeature = this.createOptionalManagedBean(
      this.beans.registry.createDynamicBean("tooltipFeature", !1, {
        getGui: () => this.getGui(),
        getLocation: () => "filterToolPanelColumnGroup",
        shouldDisplayTooltip: yc(
          n,
          () => s.getGui().querySelector(".ag-group-title")
        )
      })
    ), this.refreshFilterClass(), this.addExpandCollapseListeners(), this.addFilterChangedListeners(), this.setupTooltip(), this.addInIcon("filterActive");
  }
  setupTooltip() {
    if (!this.showingColumn)
      return;
    const t = () => {
      var s;
      (s = this.tooltipFeature) == null || s.setTooltipAndRefresh(this.columnGroup.getColDef().headerTooltip);
    };
    t(), this.addManagedEventListeners({ newColumnsLoaded: t });
  }
  addCssClassToTitleBar(t) {
    this.filterGroupComp.addCssClassToTitleBar(t);
  }
  refreshFilters(t) {
    this.childFilterComps.forEach((s) => {
      s instanceof Zb ? s.refreshFilters(t) : s.refreshFilter(t);
    });
  }
  isColumnGroup() {
    return ct(this.columnGroup);
  }
  isExpanded() {
    return this.filterGroupComp.isExpanded();
  }
  getChildren() {
    return this.childFilterComps;
  }
  getFilterGroupName() {
    return this.filterGroupName ?? "";
  }
  getFilterGroupId() {
    return this.columnGroup.getId();
  }
  hideGroupItem(t, s) {
    this.filterGroupComp.hideItem(t, s);
  }
  hideGroup(t) {
    this.setDisplayed(!t);
  }
  addInIcon(t) {
    const s = ue(t, this.beans);
    s && s.classList.add("ag-filter-toolpanel-group-instance-header-icon"), this.filterGroupComp.addTitleBarWidget(s);
  }
  forEachToolPanelFilterChild(t) {
    this.childFilterComps.forEach((s) => {
      s instanceof Xb && t(s);
    });
  }
  addExpandCollapseListeners() {
    const t = this.isColumnGroup() ? () => this.expandedCallback() : () => this.forEachToolPanelFilterChild((i) => i.expand()), s = this.isColumnGroup() ? () => this.expandedCallback() : () => this.forEachToolPanelFilterChild((i) => i.collapse());
    this.addManagedListeners(this.filterGroupComp, {
      expanded: t,
      collapsed: s
    });
  }
  getColumns() {
    return ct(this.columnGroup) ? this.columnGroup.getLeafColumns() : [this.columnGroup];
  }
  addFilterChangedListeners() {
    this.getColumns().forEach((t) => {
      this.addManagedListeners(t, { filterChanged: () => this.refreshFilterClass() });
    }), ct(this.columnGroup) || this.addManagedEventListeners({ filterOpened: this.onFilterOpened.bind(this) });
  }
  refreshFilterClass() {
    const t = this.getColumns(), s = () => t.some((i) => i.isFilterActive());
    this.filterGroupComp.addOrRemoveCssClass("ag-has-filter", s());
  }
  onFilterOpened(t) {
    t.source === "COLUMN_MENU" && t.column === this.columnGroup && this.isExpanded() && this.collapse();
  }
  expand() {
    this.filterGroupComp.toggleGroupExpand(!0);
  }
  collapse() {
    this.filterGroupComp.toggleGroupExpand(!1);
  }
  setGroupTitle() {
    const t = this.columnGroup, s = ct(t) ? this.getColumnGroupName(t) : this.getColumnName(t);
    this.filterGroupName = s, this.filterGroupComp.setTitle(s || "");
  }
  getColumnGroupName(t) {
    return this.beans.colNames.getDisplayNameForProvidedColumnGroup(null, t, "filterToolPanel");
  }
  getColumnName(t) {
    return this.beans.colNames.getDisplayNameForColumn(t, "filterToolPanel", !1);
  }
  destroyFilters() {
    this.childFilterComps = this.destroyBeans(this.childFilterComps), ze(this.getGui());
  }
  destroy() {
    this.destroyFilters(), super.destroy();
  }
}, y2 = class extends _ {
  constructor() {
    super(
      /* html */
      '<div class="ag-filter-list-panel"></div>'
    ), this.initialised = !1, this.hasLoadedInitialState = !1, this.isInitialState = !1, this.filterGroupComps = [], this.suppressOnColumnsChanged = !1, this.onColumnsChangedPending = !1;
  }
  wireBeans(e) {
    this.colModel = e.colModel;
  }
  init(e) {
    this.initialised = !0;
    const t = this.gos.addGridCommonParams({
      suppressExpandAll: !1,
      suppressFilterSearch: !1,
      suppressSyncLayoutWithGrid: !1
    });
    bt(t, e), this.params = t, t.suppressSyncLayoutWithGrid || this.addManagedEventListeners({ columnMoved: () => this.onColumnsChanged() }), this.addManagedEventListeners({
      newColumnsLoaded: () => this.onColumnsChanged(),
      toolPanelVisibleChanged: (s) => {
        s.key === "filters" && this.refreshFilters(s.visible);
      },
      dragStarted: () => {
        this.suppressOnColumnsChanged = !0;
      },
      dragStopped: () => {
        this.suppressOnColumnsChanged = !1, this.onColumnsChangedPending && (this.onColumnsChangedPending = !1, this.onColumnsChanged());
      }
    }), this.colModel.ready && this.onColumnsChanged();
  }
  onColumnsChanged() {
    if (this.suppressOnColumnsChanged) {
      this.onColumnsChangedPending = !0;
      return;
    }
    const e = this.colModel.isPivotMode();
    !this.params.suppressSyncLayoutWithGrid && !e ? this.syncFilterLayout() : this.buildTreeFromProvidedColumnDefs(), this.refreshAriaLabel();
  }
  syncFilterLayout() {
    yb(this.colModel, this.setFiltersLayout.bind(this)), this.refreshAriaLabel();
  }
  buildTreeFromProvidedColumnDefs() {
    const e = this.colModel.getColDefColTree();
    this.recreateFilters(e);
  }
  setFiltersLayout(e) {
    const t = wb(this.colModel, e);
    this.recreateFilters(t);
  }
  recreateFilters(e) {
    const t = Ie(this.beans);
    this.hasLoadedInitialState || (this.hasLoadedInitialState = !0, this.isInitialState = !!this.params.initialState);
    const s = this.getExpansionState();
    this.destroyFilters();
    const i = this.recursivelyAddComps(e, 0, s);
    this.filterGroupComps = i;
    const r = i.length;
    r && (i.forEach((o) => this.appendChild(o)), this.setFirstAndLastVisible(0, r - 1));
    const n = this.searchFilterText;
    W(n) && this.searchFilters(n), this.fireExpandedEvent(), this.getGui().contains(t) && t.focus(), this.isInitialState = !1, this.refreshAriaLabel();
  }
  recursivelyAddComps(e, t, s) {
    return e.map((i) => {
      var l;
      if (ct(i))
        return ((l = this.recursivelyAddFilterGroupComps(i, t, s)) == null ? void 0 : l.flatMap((c) => c)) ?? [];
      const r = i;
      if (!this.shouldDisplayFilter(r))
        return [];
      const n = t === 0, o = new Xb(n, () => this.onFilterExpanded());
      if (this.createBean(o), o.setColumn(r), s.get(r.getId()) && o.expand(), t > 0)
        return o;
      const a = this.createBean(
        new lr(r, [o], this.onGroupExpanded.bind(this), t, !0)
      );
      return a.addCssClassToTitleBar("ag-filter-toolpanel-header"), s.get(a.getFilterGroupId()) || a.collapse(), a;
    }).flatMap((i) => i);
  }
  refreshAriaLabel() {
    const e = this.getLocaleTextFunc(), t = e("ariaFilterPanelList", "Filter List"), s = e("filters", "Filters"), l = this.getGui().querySelectorAll(".ag-filter-toolpanel-group-item:not(.ag-filter-toolpanel-group-wrapper, .ag-hidden)").length;
    ot(this.getAriaElement(), `${t} ${l} ${s}`);
  }
  recursivelyAddFilterGroupComps(e, t, s) {
    if (!this.filtersExistInChildren(e.getChildren()))
      return;
    const i = e.getColGroupDef();
    if (i && i.suppressFiltersToolPanel)
      return [];
    const r = e.isPadding() ? t : t + 1, n = this.recursivelyAddComps(e.getChildren(), r, s).flatMap(
      (l) => l
    );
    if (e.isPadding())
      return n;
    const o = new lr(
      e,
      n,
      this.onGroupExpanded.bind(this),
      t,
      !1
    );
    this.createBean(o), o.addCssClassToTitleBar("ag-filter-toolpanel-header");
    const a = s.get(o.getFilterGroupId());
    return (this.isInitialState && !a || a === !1) && o.collapse(), [o];
  }
  filtersExistInChildren(e) {
    return e.some((t) => ct(t) ? this.filtersExistInChildren(t.getChildren()) : this.shouldDisplayFilter(t));
  }
  shouldDisplayFilter(e) {
    const t = e.getColDef() && e.getColDef().suppressFiltersToolPanel;
    return e.isFilterAllowed() && !t;
  }
  getExpansionState() {
    const e = /* @__PURE__ */ new Map();
    if (this.isInitialState) {
      const { expandedColIds: s, expandedGroupIds: i } = this.params.initialState;
      return s.forEach((r) => e.set(r, !0)), i.forEach((r) => e.set(r, !0)), e;
    }
    const t = (s) => {
      e.set(s.getFilterGroupId(), s.isExpanded()), s.getChildren().forEach((i) => {
        i instanceof lr ? t(i) : e.set(i.getColumn().getId(), i.isExpanded());
      });
    };
    return this.filterGroupComps.forEach(t), e;
  }
  // we don't support refreshing, but must implement because it's on the tool panel interface
  refresh() {
  }
  // lazy initialise the panel
  setVisible(e) {
    super.setDisplayed(e), e && !this.initialised && this.init(this.params);
  }
  expandFilterGroups(e, t) {
    const s = [], i = (r) => {
      const n = r.getFilterGroupId();
      (!t || t.includes(n)) && (e && r.isColumnGroup() ? r.expand() : r.collapse(), s.push(n)), r.getChildren().forEach((a) => {
        a instanceof lr && i(a);
      });
    };
    if (this.filterGroupComps.forEach(i), this.onGroupExpanded(), t) {
      const r = t.filter((n) => s.indexOf(n) < 0);
      r.length > 0 && I(166, { unrecognisedGroupIds: r });
    }
  }
  expandFilters(e, t) {
    const s = [], i = (r) => {
      if (r instanceof lr) {
        let a = !1;
        return r.getChildren().forEach((l) => {
          i(l) && (e ? (r.expand(), a = !0) : r.isColumnGroup() || r.collapse());
        }), a;
      }
      const n = r.getColumn().getColId(), o = !t || t.includes(n);
      return o && (e ? r.expand() : r.collapse(), s.push(n)), o;
    };
    if (this.filterGroupComps.forEach(i), this.onGroupExpanded(), t) {
      const r = t.filter((n) => s.indexOf(n) < 0);
      r.length > 0 && I(167, { unrecognisedColIds: r });
    }
  }
  onGroupExpanded() {
    this.fireExpandedEvent();
  }
  onFilterExpanded() {
    this.dispatchLocalEvent({ type: "filterExpanded" });
  }
  fireExpandedEvent() {
    let e = 0, t = 0;
    const s = (r) => {
      r.isColumnGroup() && (r.isExpanded() ? e++ : t++, r.getChildren().forEach((n) => {
        n instanceof lr && s(n);
      }));
    };
    this.filterGroupComps.forEach(s);
    let i;
    e > 0 && t > 0 ? i = 2 : t > 0 ? i = 1 : i = 0, this.dispatchLocalEvent({ type: "groupExpanded", state: i });
  }
  performFilterSearch(e) {
    this.searchFilterText = W(e) ? e.toLowerCase() : null, this.searchFilters(this.searchFilterText);
  }
  searchFilters(e) {
    const t = (n) => !W(e) || n.toLowerCase().indexOf(e) !== -1, s = (n, o) => {
      if (!(n instanceof lr))
        return t(n.getColumnFilterName() || "");
      const a = n.getChildren(), l = t(n.getFilterGroupName()), c = o || l;
      if (c) {
        n.hideGroup(!1);
        for (let u = 0; u < a.length; u++)
          s(a[u], c), n.hideGroupItem(!1, u);
        return !0;
      }
      let d = !1;
      return a.forEach((u, h) => {
        const p = s(u, o);
        n.hideGroupItem(!p, h), p && (d = !0);
      }), n.hideGroup(!d), d;
    };
    let i, r;
    this.filterGroupComps.forEach((n, o) => {
      s(n, !1), i === void 0 ? n.containsCssClass("ag-hidden") || (i = o, r = o) : !n.containsCssClass("ag-hidden") && r !== o && (r = o);
    }), this.setFirstAndLastVisible(i, r), this.refreshAriaLabel();
  }
  setFirstAndLastVisible(e, t) {
    this.filterGroupComps.forEach((s, i) => {
      s.removeCssClass("ag-first-group-visible"), s.removeCssClass("ag-last-group-visible"), i === e && s.addCssClass("ag-first-group-visible"), i === t && s.addCssClass("ag-last-group-visible");
    });
  }
  refreshFilters(e) {
    this.filterGroupComps.forEach((t) => t.refreshFilters(e));
  }
  getExpandedFiltersAndGroups() {
    const e = [], t = /* @__PURE__ */ new Set(), s = (i) => {
      if (i instanceof lr) {
        i.getChildren().forEach((n) => s(n));
        const r = i.getFilterGroupId();
        i.isExpanded() && !t.has(r) && e.push(r);
      } else
        i.isExpanded() && t.add(i.getColumn().getColId());
    };
    return this.filterGroupComps.forEach(s), { expandedGroupIds: e, expandedColIds: Array.from(t) };
  }
  destroyFilters() {
    this.filterGroupComps = this.destroyBeans(this.filterGroupComps), ze(this.getGui());
  }
  destroy() {
    this.destroyFilters(), super.destroy();
  }
}, b2 = {
  selector: "AG-FILTERS-TOOL-PANEL-LIST",
  component: y2
}, S2 = (
  /*css*/
  ".ag-filter-toolpanel{flex:1 1 0px;min-width:0}.ag-filter-toolpanel-header,.ag-filter-toolpanel-search{align-items:center;color:var(--ag-header-text-color);display:flex;font-weight:500;padding:0 var(--ag-spacing);>*{align-items:center;display:flex}}.ag-filter-toolpanel-header{padding-bottom:var(--ag-spacing);padding-top:var(--ag-spacing);position:relative;&:focus-visible{border-radius:var(--ag-border-radius);box-shadow:inset var(--ag-focus-shadow)}}:where(.ag-ltr) .ag-filter-toolpanel-group-instance-header-icon,:where(.ag-ltr) .ag-filter-toolpanel-instance-header-icon{margin-left:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-toolpanel-group-instance-header-icon,:where(.ag-rtl) .ag-filter-toolpanel-instance-header-icon{margin-right:var(--ag-spacing)}.ag-filter-toolpanel-search{margin-bottom:var(--ag-spacing);margin-top:var(--ag-widget-container-vertical-padding)}:where(.ag-filter-toolpanel-group:not(.ag-has-filter)>.ag-group-title-bar) .ag-filter-toolpanel-group-instance-header-icon{display:none}.ag-filter-toolpanel-search-input{flex-grow:1;height:calc(var(--ag-spacing)*4)}:where(.ag-ltr) .ag-filter-toolpanel-group-title-bar-icon{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-toolpanel-group-title-bar-icon{margin-left:var(--ag-spacing)}.ag-filter-toolpanel-expand{cursor:pointer}:where(.ag-ltr) .ag-filter-toolpanel-expand{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-filter-toolpanel-expand{margin-left:var(--ag-spacing)}:where(.ag-ltr) .ag-filter-toolpanel-group-title-bar,:where(.ag-ltr) .ag-filter-toolpanel-instance-header{padding-left:calc(var(--ag-spacing) + var(--ag-filter-tool-panel-group-indent)*var(--ag-indentation-level))}:where(.ag-rtl) .ag-filter-toolpanel-group-title-bar,:where(.ag-rtl) .ag-filter-toolpanel-instance-header{padding-right:calc(var(--ag-spacing) + var(--ag-filter-tool-panel-group-indent)*var(--ag-indentation-level))}:where(.ag-ltr) .ag-filter-toolpanel-instance-body{margin-left:var(--ag-filter-tool-panel-group-indent)}:where(.ag-rtl) .ag-filter-toolpanel-instance-body{margin-right:var(--ag-filter-tool-panel-group-indent)}.ag-filter-toolpanel-instance-filter{background-color:var(--ag-chrome-background-color)}.ag-filter-toolpanel-group-level-0{border-top:none}"
), x2 = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="ag-filter-toolpanel">
            <ag-filters-tool-panel-header data-ref="filtersToolPanelHeaderPanel"></ag-filters-tool-panel-header>
            <ag-filters-tool-panel-list data-ref="filtersToolPanelListPanel"></ag-filters-tool-panel-list>
         </div>`,
      [w2, b2]
    ), this.filtersToolPanelHeaderPanel = E, this.filtersToolPanelListPanel = E, this.initialised = !1, this.listenerDestroyFuncs = [], this.registerCSS(S2);
  }
  init(e) {
    this.initialised && (this.listenerDestroyFuncs.forEach((a) => a()), this.listenerDestroyFuncs = []), this.initialised = !0;
    const s = {
      ...this.gos.addGridCommonParams({
        suppressExpandAll: !1,
        suppressFilterSearch: !1,
        suppressSyncLayoutWithGrid: !1
      }),
      ...e
    };
    this.params = s;
    const { filtersToolPanelHeaderPanel: i, filtersToolPanelListPanel: r } = this;
    i.init(s), r.init(s);
    const n = s.suppressExpandAll, o = s.suppressFilterSearch;
    n && o && i.setDisplayed(!1), this.listenerDestroyFuncs.push(
      ...this.addManagedListeners(i, {
        expandAll: () => r.expandFilterGroups(!0),
        collapseAll: () => r.expandFilterGroups(!1),
        searchChanged: (a) => r.performFilterSearch(a.searchText)
      }),
      ...this.addManagedListeners(r, {
        filterExpanded: s.onStateUpdated,
        groupExpanded: (a) => {
          i.setExpandState(a.state), s.onStateUpdated();
        }
      })
    );
  }
  // lazy initialise the panel
  setVisible(e) {
    super.setDisplayed(e), e && !this.initialised && this.init(this.params);
  }
  setFilterLayout(e) {
    this.filtersToolPanelListPanel.setFiltersLayout(e);
  }
  expandFilterGroups(e) {
    this.filtersToolPanelListPanel.expandFilterGroups(!0, e);
  }
  collapseFilterGroups(e) {
    this.filtersToolPanelListPanel.expandFilterGroups(!1, e);
  }
  expandFilters(e) {
    this.filtersToolPanelListPanel.expandFilters(!0, e);
  }
  collapseFilters(e) {
    this.filtersToolPanelListPanel.expandFilters(!1, e);
  }
  syncLayoutWithGrid() {
    this.filtersToolPanelListPanel.syncFilterLayout();
  }
  refresh(e) {
    return this.init(e), !0;
  }
  getState() {
    return this.filtersToolPanelListPanel.getExpandedFiltersAndGroups();
  }
}, R2 = {
  moduleName: "FiltersToolPanel",
  version: Me,
  userComponents: { agFiltersToolPanel: x2 },
  icons: {
    // filter tool panel tab
    filtersToolPanel: "filter"
  },
  dependsOn: [Xh, Je, kr]
}, Qb = class extends L {
  constructor() {
    super(...arguments), this.loadRowDataVersion = 0;
  }
  init(e, t) {
    this.params = t, this.comp = e, t.pinned == null && (this.setAutoHeightClasses(), this.setupRefreshStrategy(), this.createDetailGrid(), this.loadRowData(), this.addManagedEventListeners({ fullWidthRowFocused: this.onFullWidthRowFocused.bind(this) }));
  }
  onFullWidthRowFocused(e) {
    const t = this.params, s = { rowIndex: t.node.rowIndex, rowPinned: t.node.rowPinned }, i = { rowIndex: e.rowIndex, rowPinned: e.rowPinned };
    Pt(s, i) && Dt(this.comp.getGui(), e.fromBelow);
  }
  setAutoHeightClasses() {
    const e = this.gos.get("detailRowAutoHeight"), t = e ? "ag-details-row-auto-height" : "ag-details-row-fixed-height", s = e ? "ag-details-grid-auto-height" : "ag-details-grid-fixed-height", i = this.comp;
    i.addOrRemoveCssClass(t, !0), i.addOrRemoveDetailGridCssClass(s, !0);
  }
  setupRefreshStrategy() {
    const e = this.params.refreshStrategy;
    if (e == "everything" || e == "nothing" || e == "rows") {
      this.refreshStrategy = e;
      return;
    }
    e != null && I(170, { providedStrategy: e }), this.refreshStrategy = "rows";
  }
  createDetailGrid() {
    const { params: e, gos: t } = this;
    if (ke(e.detailGridOptions)) {
      I(171);
      return;
    }
    const s = { ...e.detailGridOptions };
    t.get("detailRowAutoHeight") && (s.domLayout = "autoHeight"), s.theme || (s.theme = t.get("theme")), this.comp.setDetailGrid(s);
  }
  registerDetailWithMaster(e) {
    const t = this.params, s = t.node.id, i = t.api, r = {
      id: s,
      api: e
    }, n = t.node;
    i.isDestroyed() || (i.addDetailGridInfo(s, r), n.detailGridInfo = r, this.addDestroyFunc(() => {
      n.detailGridInfo === r && (i.isDestroyed() || i.removeDetailGridInfo(s), n.detailGridInfo = null);
    }));
  }
  loadRowData() {
    var n, o, a;
    this.loadRowDataVersion++;
    const e = this.loadRowDataVersion, t = this.params;
    if (((n = t.detailGridOptions) == null ? void 0 : n.rowModelType) === "serverSide") {
      (a = (o = t.node.detailGridInfo) == null ? void 0 : o.api) == null || a.refreshServerSide({ purge: !0 });
      return;
    }
    const s = t.getDetailRowData;
    if (!s) {
      I(172);
      return;
    }
    const i = (l) => {
      this.loadRowDataVersion === e && this.comp.setRowData(l);
    }, r = {
      node: t.node,
      // we take data from node, rather than params.data
      // as the data could have been updated with new instance
      data: t.node.data,
      successCallback: i,
      context: this.gos.getGridCommonParams().context
    };
    s(r);
  }
  refresh() {
    switch (this.refreshStrategy) {
      case "nothing":
        return !0;
      case "everything":
        return !1;
    }
    return this.loadRowData(), !0;
  }
}, F2 = class {
  constructor(e) {
    this.parentWrapper = e;
  }
  wrap(e, t, s, i) {
    return this.parentWrapper.wrap(e, t, s, i);
  }
}, P2 = class extends _ {
  constructor() {
    super(...arguments), this.eDetailGrid = E;
  }
  wireBeans(t) {
    this.context = t.context;
  }
  init(t) {
    this.params = t, this.selectAndSetTemplate();
    const s = {
      addOrRemoveCssClass: (i, r) => this.addOrRemoveCssClass(i, r),
      addOrRemoveDetailGridCssClass: (i, r) => this.eDetailGrid.classList.toggle(i, r),
      setDetailGrid: (i) => this.setDetailGrid(i),
      setRowData: (i) => this.setRowData(i),
      getGui: () => this.eDetailGrid
    };
    this.ctrl = this.createManagedBean(new Qb()), this.ctrl.init(s, t);
  }
  refresh() {
    return this.ctrl && this.ctrl.refresh();
  }
  selectAndSetTemplate() {
    const t = this.params;
    if (t.pinned) {
      this.setTemplate(
        /* html*/
        '<div class="ag-details-row"></div>'
      );
      return;
    }
    const s = () => {
      this.setTemplate(
        /* html */
        `<div class="ag-details-row" role="gridcell">
                <div data-ref="eDetailGrid" class="ag-details-grid" role="presentation"></div>
            </div>`
      );
    };
    if (ke(t.template))
      s();
    else if (typeof t.template == "string")
      this.setTemplate(t.template, []);
    else if (typeof t.template == "function") {
      const i = t.template, r = i(t);
      this.setTemplate(r, []);
    } else
      I(168), s();
    this.eDetailGrid == null && I(169);
  }
  setDetailGrid(t) {
    if (!this.eDetailGrid)
      return;
    const s = this.context.getBean("frameworkCompWrapper"), i = new F2(s), { frameworkOverrides: r } = this.beans, n = r0(this.eDetailGrid, t, {
      frameworkOverrides: r,
      providedBeanInstances: {
        frameworkCompWrapper: i
      },
      modules: iw(this.params.api.getGridId(), t.rowModelType ?? "clientSide")
    });
    this.detailApi = n, this.ctrl.registerDetailWithMaster(n), this.addDestroyFunc(() => {
      n == null || n.destroy();
    });
  }
  setRowData(t) {
    var s;
    (s = this.detailApi) == null || s.setGridOption("rowData", t);
  }
};
function Mc(e, t) {
  var i;
  const s = (i = e.masterDetailSvc) == null ? void 0 : i.store;
  return s ? t(s) : void 0;
}
function T2(e, t, s) {
  Mc(e, (i) => {
    i[t] = s;
  });
}
function E2(e, t) {
  Mc(e, (s) => {
    delete s[t];
  });
}
function D2(e, t) {
  return Mc(e, (s) => s[t]);
}
function A2(e, t) {
  Mc(e, (s) => {
    let i = 0;
    Object.values(s).forEach((r) => {
      r && t(r, i++);
    });
  });
}
var M2 = (
  /*css*/
  ".ag-details-row{width:100%}.ag-details-row-fixed-height{height:100%}.ag-details-grid{width:100%}.ag-details-grid-fixed-height{height:100%}"
), I2 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "masterDetailSvc", this.store = {};
  }
  isEnabled() {
    const e = this.gos;
    return e.get("masterDetail") && // TODO: AG-1752: [Tree Data] Allow tree data leaf rows to serve as master rows for detail grids (Tree Data hosting Master/Detail)"
    !e.get("treeData");
  }
  postConstruct() {
    Ye(this.gos) && (this.enabled = this.isEnabled(), this.addManagedEventListeners({ beforeRefreshModel: this.beforeRefreshModel.bind(this) }));
  }
  beforeRefreshModel({ params: e }) {
    if (e.changedProps) {
      const t = this.isEnabled();
      if (this.enabled !== t) {
        this.setMasters(null);
        return;
      }
    }
    e.rowDataUpdated && this.setMasters(e.changedRowNodes);
  }
  setMasters(e) {
    var o, a;
    const t = this.isEnabled();
    this.enabled = t;
    const s = this.gos, i = s.get("isRowMaster"), r = s.get("groupDefaultExpanded"), n = (l, c, d) => {
      var p;
      const u = l.master;
      let h = t;
      if (t)
        if (c || d) {
          if (i) {
            const g = l.data;
            h = !!g && !!i(g);
          }
        } else
          h = u;
      if (h && c)
        if (r === -1)
          l.expanded = !0;
        else {
          const g = ((p = this.beans.rowGroupColsSvc) == null ? void 0 : p.columns.length) ?? 0;
          l.expanded = g < r;
        }
      else !h && u && (l.expanded = !1);
      h !== u && (l.master = h, l.dispatchRowEvent("masterChanged"));
    };
    if (e) {
      const l = e.updates;
      for (const c of l.keys()) {
        const d = l.get(c);
        n(c, d, !d);
      }
    } else {
      const l = (a = (o = ci(this.beans)) == null ? void 0 : o.rootNode) == null ? void 0 : a.allLeafChildren;
      if (l)
        for (let c = 0, d = l.length; c < d; ++c)
          n(l[c], !0, !1);
    }
  }
  /** Used by flatten stage to get or create a detail node from a master node */
  getDetail(e) {
    if (!e.master || !e.expanded)
      return null;
    let t = e.detailNode;
    return t || (t = new bs(this.beans), t.detail = !0, t.selectable = !1, t.parent = e, W(e.id) && (t.id = "detail_" + e.id), t.data = e.data, t.level = e.level + 1, e.detailNode = t, t);
  }
  setupDetailRowAutoHeight(e, t) {
    const { gos: s, beans: i } = this;
    if (!s.get("detailRowAutoHeight"))
      return;
    const r = () => {
      const o = t.clientHeight;
      if (o != null && o > 0) {
        const a = () => {
          const { rowModel: l } = this.beans, { rowNode: c } = e;
          c.setRowHeight(o), (Ye(s) || Lt(s)) && l.onRowHeightChanged();
        };
        window.setTimeout(a, 0);
      }
    }, n = Ms(i, t, r);
    e.addDestroyFunc(n), r();
  }
  destroy() {
    this.store = {}, super.destroy();
  }
}, L2 = {
  moduleName: "SharedMasterDetail",
  version: Me,
  beans: [I2],
  userComponents: { agDetailCellRenderer: P2 },
  dynamicBeans: { detailCellRendererCtrl: Qb },
  apiFunctions: {
    addDetailGridInfo: T2,
    removeDetailGridInfo: E2,
    getDetailGridInfo: D2,
    forEachDetailGridInfo: A2
  },
  dependsOn: [Je, jb, ep],
  css: [M2]
}, k2 = {
  moduleName: "MasterDetail",
  version: Me,
  dependsOn: [L2, Ac]
}, Jb = class extends _ {
  constructor() {
    super(...arguments), this.changedCalculatedValues = !1, this.dragging = !1, this.shouldDestroyOnEndDragging = !1;
  }
  postConstruct() {
    const { dragSvc: e, rangeSvc: t } = this.beans;
    e.addDragSource({
      dragStartPixels: 0,
      eElement: this.getGui(),
      onDragStart: this.onDragStart.bind(this),
      onDragging: (s) => {
        this.dragging = !0, t.autoScrollService.check(s), this.changedCalculatedValues && (this.onDrag(s), this.changedCalculatedValues = !1);
      },
      onDragStop: (s) => {
        this.dragging = !1, this.onDragEnd(s), this.clearDragProperties(), this.shouldDestroyOnEndDragging && this.destroy();
      },
      onDragCancel: () => {
        this.dragging = !1, this.onDragCancel(), this.clearDragProperties();
      }
    }), this.addManagedElementListeners(this.getGui(), { mousedown: this.preventRangeExtension.bind(this) });
  }
  getLastCellHovered() {
    return this.lastCellHovered;
  }
  preventRangeExtension(e) {
    e.stopPropagation();
  }
  onDragStart(e) {
    [this.cellHoverListener] = this.addManagedElementListeners(this.beans.ctrlsSvc.get("gridCtrl").getGui(), {
      mousemove: this.updateValuesOnMove.bind(this)
    }), document.body.classList.add(this.getDraggingCssClass());
  }
  getDraggingCssClass() {
    return `ag-dragging-${this.type === 0 ? "fill" : "range"}-handle`;
  }
  updateValuesOnMove(e) {
    const t = pw(this.gos, e);
    !t || this.lastCellHovered && Jn(t, this.lastCellHovered) || (this.lastCellHovered = t, this.changedCalculatedValues = !0);
  }
  clearDragProperties() {
    this.clearValues(), this.beans.rangeSvc.autoScrollService.ensureCleared(), document.body.classList.remove(this.getDraggingCssClass());
  }
  getType() {
    return this.type;
  }
  refresh(e) {
    const t = this.cellCtrl, s = this.getGui(), i = pe(this.beans.rangeSvc.getCellRanges()), r = i.startRow, n = i.endRow;
    if (r && n && (jt(n, r) ? (this.rangeStartRow = n, this.rangeEndRow = r) : (this.rangeStartRow = r, this.rangeEndRow = n)), t !== e || !Xt(s)) {
      this.cellCtrl = e;
      const o = e.comp.getParentOfValue();
      o && o.appendChild(s);
    }
    this.cellRange = i;
  }
  clearValues() {
    this.lastCellHovered = void 0, this.removeListeners();
  }
  removeListeners() {
    const e = this.cellHoverListener;
    e && (e(), this.cellHoverListener = void 0);
  }
  destroy() {
    var t;
    if (!this.shouldDestroyOnEndDragging && this.dragging) {
      re(this.getGui(), !1), this.shouldDestroyOnEndDragging = !0;
      return;
    }
    this.shouldDestroyOnEndDragging = !1, super.destroy(), this.removeListeners();
    const e = this.getGui();
    (t = e.parentElement) == null || t.removeChild(e);
  }
};
function O2(e) {
  const t = e.length;
  let s = 0;
  if (t <= 1)
    return e;
  for (let u = 0; u < e.length; u++) {
    const h = e[u], p = h.toString().split("e-");
    if (p.length > 1) {
      s = Math.max(s, parseInt(p[1], 10));
      continue;
    }
    Math.floor(h) !== h && (s = Math.max(s, h.toString().split(".")[1].length));
  }
  let i = 0, r = 0, n = 0, o = 0, a = 0;
  for (let u = 0; u < t; u++)
    a = e[u], i += u, r += a, o += u * u, n += u * a;
  const l = (t * n - i * r) / (t * o - i * i), c = r / t - l * i / t, d = [];
  for (let u = 0; u <= t; u++)
    d.push(parseFloat((u * l + c).toFixed(s)));
  return d;
}
var G2 = class extends Jb {
  constructor() {
    super(
      /* html */
      '<div class="ag-fill-handle"></div>'
    ), this.markedCells = [], this.cellValues = [], this.isUp = !1, this.isLeft = !1, this.isReduce = !1, this.type = 0;
  }
  updateValuesOnMove(e) {
    super.updateValuesOnMove(e), this.initialXY || (this.initialXY = Ko(this.beans, e));
    const { x: t, y: s } = this.initialXY, { x: i, y: r } = Ko(this.beans, e), n = Math.abs(t - i), o = Math.abs(s - r), a = this.getFillHandleDirection();
    let l;
    a === "xy" ? l = n > o ? "x" : "y" : l = a, l !== this.dragAxis && (this.dragAxis = l, this.changedCalculatedValues = !0);
  }
  onDrag(e) {
    if (!this.initialPosition) {
      const s = this.cellCtrl;
      if (!s)
        return;
      this.initialPosition = s.cellPosition;
    }
    const t = this.getLastCellHovered();
    t && this.markPathFrom(this.initialPosition, t);
  }
  onDragEnd(e) {
    if (this.initialXY = null, !this.markedCells.length)
      return;
    const t = this.dragAxis === "x", { cellRange: s, rangeStartRow: i, rangeEndRow: r, beans: n } = this, o = s.columns.length;
    let a;
    const { rangeSvc: l, eventSvc: c } = n;
    if (!this.isUp && !this.isLeft)
      a = l.createCellRangeFromCellRangeParams({
        rowStartIndex: i.rowIndex,
        rowStartPinned: i.rowPinned,
        columnStart: s.columns[0],
        rowEndIndex: t ? r.rowIndex : this.lastCellMarked.rowIndex,
        rowEndPinned: t ? r.rowPinned : this.lastCellMarked.rowPinned,
        columnEnd: t ? this.lastCellMarked.column : s.columns[o - 1]
      });
    else {
      const d = t ? i : this.lastCellMarked;
      a = l.createCellRangeFromCellRangeParams({
        rowStartIndex: d.rowIndex,
        rowStartPinned: d.rowPinned,
        columnStart: t ? this.lastCellMarked.column : s.columns[0],
        rowEndIndex: r.rowIndex,
        rowEndPinned: r.rowPinned,
        columnEnd: s.columns[o - 1]
      });
    }
    a && (c.dispatchEvent({
      type: "fillStart"
    }), this.handleValueChanged(s, a, e), l.setCellRanges([a]), c.dispatchEvent({
      type: "fillEnd",
      initialRange: s,
      finalRange: a
    }));
  }
  onDragCancel() {
    this.initialXY = null, this.markedCells.length && this.clearMarkedPath();
  }
  getFillHandleDirection() {
    var t;
    const e = (t = hd(this.gos)) == null ? void 0 : t.direction;
    return e ? e !== "x" && e !== "y" && e !== "xy" ? (I(177), "xy") : e : "xy";
  }
  handleValueChanged(e, t, s) {
    var x;
    const { rangeSvc: i, gos: r, cellNavigation: n, valueSvc: o } = this.beans, a = i.getRangeEndRow(e), l = i.getRangeStartRow(e), c = i.getRangeEndRow(t), d = i.getRangeStartRow(t), u = this.dragAxis === "y";
    if (this.isReduce && !((x = hd(r)) != null && x.suppressClearOnFillReduction)) {
      const M = u ? e.columns : e.columns.filter((F) => t.columns.indexOf(F) < 0), T = u ? n.getRowBelow(c) : d;
      T && this.clearCellsInRange(T, a, M);
      return;
    }
    const h = [], p = [], g = [], f = [];
    let m = !0, C = 0;
    const w = () => {
      h.length = 0, p.length = 0, g.length = 0, f.length = 0, C = 0;
    }, y = (M, T) => {
      let F = this.isUp ? a : l, k = !1;
      for (u && (m = !0, w()); !k && F; ) {
        const O = ri(this.beans, F);
        if (!O)
          break;
        u && M ? b(
          h,
          M,
          O,
          () => !Pt(F, this.isUp ? l : a)
        ) : T && (m = !0, w(), T.forEach(
          (D) => b(
            h,
            D,
            O,
            () => D !== (this.isLeft ? e.columns[0] : pe(e.columns))
          )
        )), k = Pt(F, this.isUp ? d : c), F = this.isUp ? n.getRowAbove(F) : n.getRowBelow(F);
      }
    }, b = (M, T, F, k) => {
      let O, D = !1;
      if (m)
        O = o.getValue(T, F), p.push(O), g.push(o.getValue(T, F, !0)), f.push(o.formatValue(T, F, O)), m = k();
      else {
        const { value: $, fromUserFunction: j, sourceCol: J, sourceRowNode: X } = this.processValues({
          event: s,
          values: M,
          initialValues: p,
          initialNonAggregatedValues: g,
          initialFormattedValues: f,
          col: T,
          rowNode: F,
          idx: C++
        });
        if (O = $, T.isCellEditable(F)) {
          const ie = o.getValue(T, F);
          if (!j) {
            if (J) {
              const Ce = J.getColDef();
              if (Ce.useValueFormatterForExport !== !1 && Ce.valueFormatter) {
                const ae = o.formatValue(J, X, O);
                ae != null && (O = ae);
              }
            }
            T.getColDef().useValueParserForImport !== !1 && (O = o.parseValue(
              T,
              F,
              // if no sourceCol, then currentValue is a number
              J ? O : Cs(O),
              ie
            ));
          }
          !j || ie !== O ? F.setDataValue(T, O, "rangeSvc") : D = !0;
        }
      }
      D || M.push({
        value: O,
        column: T,
        rowNode: F
      });
    };
    if (u)
      e.columns.forEach((M) => {
        y(M);
      });
    else {
      const M = this.isLeft ? [...t.columns].reverse() : t.columns;
      y(void 0, M);
    }
  }
  clearCellsInRange(e, t, s) {
    const i = {
      startRow: e,
      endRow: t,
      columns: s,
      startColumn: s[0]
    };
    this.beans.rangeSvc.clearCellRangeCellValues({ cellRanges: [i] });
  }
  processValues(e) {
    var p;
    const { event: t, values: s, initialValues: i, initialNonAggregatedValues: r, initialFormattedValues: n, col: o, rowNode: a, idx: l } = e, c = (p = hd(this.gos)) == null ? void 0 : p.setFillValue, d = this.dragAxis === "y";
    let u;
    if (d ? u = this.isUp ? "up" : "down" : u = this.isLeft ? "left" : "right", c) {
      const g = this.gos.addGridCommonParams({
        event: t,
        values: s.map(({ value: m }) => m),
        initialValues: i,
        initialNonAggregatedValues: r,
        initialFormattedValues: n,
        currentIndex: l,
        currentCellValue: this.beans.valueSvc.getValue(o, a),
        direction: u,
        column: o,
        rowNode: a
      }), f = c(g);
      if (f !== !1)
        return { value: f, fromUserFunction: !0 };
    }
    const h = !s.some(({ value: g }) => {
      const f = parseFloat(g);
      return isNaN(f) || f.toString() !== g.toString();
    });
    if (t.altKey || !h) {
      if (h && i.length === 1) {
        const C = this.isUp || this.isLeft ? -1 : 1;
        return { value: parseFloat(pe(s).value) + 1 * C, fromUserFunction: !1 };
      }
      const { value: g, column: f, rowNode: m } = s[l % s.length];
      return { value: g, fromUserFunction: !1, sourceCol: f, sourceRowNode: m };
    }
    return {
      value: pe(O2(s.map(({ value: g }) => Number(g)))),
      fromUserFunction: !1
    };
  }
  clearValues() {
    this.clearMarkedPath(), this.clearCellValues(), this.lastCellMarked = void 0, super.clearValues();
  }
  clearMarkedPath() {
    this.markedCells.forEach((e) => {
      if (!e.isAlive())
        return;
      const { comp: t } = e;
      t.addOrRemoveCssClass("ag-selection-fill-top", !1), t.addOrRemoveCssClass("ag-selection-fill-right", !1), t.addOrRemoveCssClass("ag-selection-fill-bottom", !1), t.addOrRemoveCssClass("ag-selection-fill-left", !1);
    }), this.markedCells.length = 0, this.isUp = !1, this.isLeft = !1, this.isReduce = !1;
  }
  clearCellValues() {
    this.cellValues.length = 0;
  }
  markPathFrom(e, t) {
    if (this.clearMarkedPath(), this.clearCellValues(), this.dragAxis === "y") {
      if (Pt(t, e))
        return;
      const s = jt(t, e), { rangeStartRow: i, rangeEndRow: r } = this;
      s && (t.rowPinned == i.rowPinned && t.rowIndex >= i.rowIndex || i.rowPinned != r.rowPinned && t.rowPinned == r.rowPinned && t.rowIndex <= r.rowIndex) ? (this.reduceVertical(e, t), this.isReduce = !0) : (this.extendVertical(e, t, s), this.isReduce = !1);
    } else {
      const s = e.column, i = t.column;
      if (s === i)
        return;
      const r = this.beans.visibleCols.allCols, n = r.indexOf(s), o = r.indexOf(i);
      o <= n && o >= r.indexOf(this.cellRange.columns[0]) ? (this.reduceHorizontal(e, t), this.isReduce = !0) : (this.extendHorizontal(e, t, o < n), this.isReduce = !1);
    }
    this.lastCellMarked = t;
  }
  extendVertical(e, t, s) {
    const i = this.beans, { rangeSvc: r, cellNavigation: n } = i;
    let o = e;
    do {
      const a = this.cellRange, l = a.columns.length;
      for (let c = 0; c < l; c++) {
        const d = a.columns[c], h = { ...{ rowIndex: o.rowIndex, rowPinned: o.rowPinned }, column: d }, p = r.isCellInSpecificRange(h, a), g = Pt(o, e);
        if (s && (this.isUp = !0), !g) {
          const f = yi(i, h);
          if (f) {
            this.markedCells.push(f);
            const m = f.comp;
            p || (m.addOrRemoveCssClass("ag-selection-fill-left", c === 0), m.addOrRemoveCssClass("ag-selection-fill-right", c === l - 1)), m.addOrRemoveCssClass(
              s ? "ag-selection-fill-top" : "ag-selection-fill-bottom",
              Pt(o, t)
            );
          }
        }
      }
      if (Pt(o, t))
        break;
    } while (
      // tslint:disable-next-line
      o = s ? n.getRowAbove(o) : n.getRowBelow(o)
    );
  }
  reduceVertical(e, t) {
    let s = e;
    const i = this.beans, r = i.cellNavigation;
    do {
      const n = this.cellRange, o = n.columns.length, a = Pt(s, t);
      for (let l = 0; l < o; l++) {
        const d = { ...{ rowIndex: s.rowIndex, rowPinned: s.rowPinned }, column: n.columns[l] }, u = yi(i, d);
        u && (this.markedCells.push(u), u.comp.addOrRemoveCssClass("ag-selection-fill-bottom", Pt(s, t)));
      }
      if (a)
        break;
    } while (s = r.getRowAbove(s));
  }
  extendHorizontal(e, t, s) {
    const i = this.beans, { visibleCols: r, cellNavigation: n } = i, o = r.allCols, a = o.indexOf(s ? t.column : e.column), l = o.indexOf(s ? this.cellRange.columns[0] : t.column), c = s ? 0 : 1, d = o.slice(a + c, l + c), { rangeStartRow: u, rangeEndRow: h } = this;
    d.forEach((p) => {
      let g = u, f = !1;
      do {
        f = Pt(g, h);
        const m = yi(i, {
          rowIndex: g.rowIndex,
          rowPinned: g.rowPinned,
          column: p
        });
        if (m) {
          this.markedCells.push(m);
          const C = m.comp;
          C.addOrRemoveCssClass("ag-selection-fill-top", Pt(g, u)), C.addOrRemoveCssClass("ag-selection-fill-bottom", Pt(g, h)), s ? (this.isLeft = !0, C.addOrRemoveCssClass("ag-selection-fill-left", p === d[0])) : C.addOrRemoveCssClass("ag-selection-fill-right", p === pe(d));
        }
        g = n.getRowBelow(g);
      } while (!f);
    });
  }
  reduceHorizontal(e, t) {
    const s = this.beans, { visibleCols: i, cellNavigation: r } = s, n = i.allCols, o = n.indexOf(t.column), a = n.indexOf(e.column), l = n.slice(o, a), { rangeStartRow: c, rangeEndRow: d } = this;
    l.forEach((u) => {
      let h = c, p = !1;
      do {
        p = Pt(h, d);
        const g = yi(this.beans, {
          rowIndex: h.rowIndex,
          rowPinned: h.rowPinned,
          column: u
        });
        g && (this.markedCells.push(g), g.comp.addOrRemoveCssClass("ag-selection-fill-right", u === l[0])), h = r.getRowBelow(h);
      } while (!p);
    });
  }
  refresh(e) {
    const t = this.beans.rangeSvc.getCellRanges()[0];
    if (!t.startRow || !t.endRow) {
      this.destroy();
      return;
    }
    super.refresh(e);
  }
}, B2 = class extends Jb {
  constructor() {
    super(
      /* html */
      '<div class="ag-range-handle"></div>'
    ), this.type = 1, this.rangeFixed = !1;
  }
  onDrag(e) {
    const t = this.getLastCellHovered();
    if (!t)
      return;
    const s = this.beans.rangeSvc, i = s.getCellRanges(), r = pe(i);
    this.rangeFixed || (this.fixRangeStartEnd(r), this.rangeFixed = !0), this.endPosition = {
      rowIndex: t.rowIndex,
      rowPinned: t.rowPinned,
      column: t.column
    }, i.length === 2 && i[0].type === Vs.DIMENSION && r.type === Vs.VALUE && !Pt(this.endPosition, s.getRangeEndRow(r)) && s.updateRangeEnd(
      i[0],
      {
        ...this.endPosition,
        column: i[0].columns[0]
      },
      !0
    ), s.extendLatestRangeToCell(this.endPosition);
  }
  onDragEnd(e) {
    const t = pe(this.beans.rangeSvc.getCellRanges());
    this.fixRangeStartEnd(t), this.rangeFixed = !1;
  }
  onDragCancel() {
    this.rangeFixed = !1;
  }
  fixRangeStartEnd(e) {
    const t = this.beans.rangeSvc, s = t.getRangeStartRow(e), i = t.getRangeEndRow(e), r = e.columns[0];
    e.startRow = s, e.endRow = i, e.startColumn = r;
  }
}, V2 = (
  /*css*/
  ".ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing),.ag-cell-range-selected.ag-cell-range-chart,.ag-cell-range-selected:not(.ag-cell-focus){background-color:var(--ag-range-selection-background-color);&.ag-cell-range-chart{background-color:var(--ag-range-selection-chart-background-color)!important;&.ag-cell-range-chart-category{background-color:var(--ag-range-selection-chart-category-background-color)!important}}}.ag-cell-range-selected-1.ag-cell-range-chart,.ag-cell-range-selected-1:not(.ag-cell-focus),.ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing){background-color:var(--ag-range-selection-background-color)}.ag-cell-range-selected-2.ag-cell-range-chart,.ag-cell-range-selected-2:not(.ag-cell-focus){background-image:linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color))}.ag-cell-range-selected-3.ag-cell-range-chart,.ag-cell-range-selected-3:not(.ag-cell-focus){background-image:linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color)),linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color))}.ag-cell-range-selected-4.ag-cell-range-chart,.ag-cell-range-selected-4:not(.ag-cell-focus){background-image:linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color)),linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color)),linear-gradient(var(--ag-range-selection-background-color),var(--ag-range-selection-background-color))}.ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell){&.ag-cell-range-top{border-top-color:var(--ag-range-selection-border-color);border-top-style:var(--ag-range-selection-border-style)}&.ag-cell-range-right{border-right-color:var(--ag-range-selection-border-color);border-right-style:var(--ag-range-selection-border-style)}&.ag-cell-range-bottom{border-bottom-color:var(--ag-range-selection-border-color);border-bottom-style:var(--ag-range-selection-border-style)}&.ag-cell-range-left{border-left-color:var(--ag-range-selection-border-color);border-left-style:var(--ag-range-selection-border-style)}}.ag-cell.ag-selection-fill-top,.ag-cell.ag-selection-fill-top.ag-cell-range-selected{border-top:1px dashed;border-top-color:var(--ag-range-selection-border-color)}:where(.ag-ltr) .ag-cell.ag-selection-fill-right,:where(.ag-ltr) .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-right:1px dashed var(--ag-range-selection-border-color)!important}:where(.ag-rtl) .ag-cell.ag-selection-fill-right,:where(.ag-rtl) .ag-cell.ag-selection-fill-right.ag-cell-range-selected{border-left:1px dashed var(--ag-range-selection-border-color)!important}.ag-cell.ag-selection-fill-bottom,.ag-cell.ag-selection-fill-bottom.ag-cell-range-selected{border-bottom:1px dashed;border-bottom-color:var(--ag-range-selection-border-color)}:where(.ag-ltr) .ag-cell.ag-selection-fill-left,:where(.ag-ltr) .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-left:1px dashed var(--ag-range-selection-border-color)!important}:where(.ag-rtl) .ag-cell.ag-selection-fill-left,:where(.ag-rtl) .ag-cell.ag-selection-fill-left.ag-cell-range-selected{border-right:1px dashed var(--ag-range-selection-border-color)!important}.ag-fill-handle,.ag-range-handle{background-color:var(--ag-range-selection-border-color);bottom:-1px;height:6px;position:absolute;width:6px}:where(.ag-ltr) .ag-fill-handle,:where(.ag-ltr) .ag-range-handle{right:-1px}:where(.ag-rtl) .ag-fill-handle,:where(.ag-rtl) .ag-range-handle{left:-1px}.ag-fill-handle{cursor:cell}:where(.ag-ltr) .ag-range-handle{cursor:nwse-resize}:where(.ag-rtl) .ag-range-handle{cursor:nesw-resize}"
);
function N2(e) {
  var t;
  return ((t = e.rangeSvc) == null ? void 0 : t.getCellRanges()) ?? null;
}
function H2(e, t) {
  var s;
  (s = e.rangeSvc) == null || s.addCellRange(t);
}
function qf(e) {
  var t;
  (t = e.rangeSvc) == null || t.removeAllCellRanges();
}
var Oo = "ag-cell-range-selected", z2 = "ag-cell-range-chart", W2 = "ag-cell-range-single-cell", _2 = "ag-cell-range-chart-category", U2 = "ag-cell-range-handle", $2 = "ag-cell-range-top", j2 = "ag-cell-range-right", K2 = "ag-cell-range-bottom", q2 = "ag-cell-range-left";
function Y2(e) {
  var i;
  const t = e.get("cellSelection");
  return t !== void 0 ? typeof t != "boolean" ? ((i = t.handle) == null ? void 0 : i.mode) === "range" : !1 : e.get("enableRangeHandle");
}
function Yf(e) {
  var i;
  const t = e.get("cellSelection");
  return t !== void 0 ? typeof t != "boolean" ? ((i = t.handle) == null ? void 0 : i.mode) === "fill" : !1 : e.get("enableFillHandle");
}
var X2 = class {
  constructor(e, t) {
    this.beans = e, this.cellCtrl = t, this.rangeSvc = e.rangeSvc;
  }
  setComp(e, t) {
    this.cellComp = e, this.eGui = t, this.onCellSelectionChanged();
  }
  onCellSelectionChanged() {
    const e = this.cellComp;
    if (!e)
      return;
    const { rangeSvc: t, cellCtrl: s, eGui: i } = this, r = t.getCellRangeCount(s.cellPosition);
    this.rangeCount = r;
    const n = this.getHasChartRange();
    this.hasChartRange = n, e.addOrRemoveCssClass(Oo, r !== 0), e.addOrRemoveCssClass(`${Oo}-1`, r === 1), e.addOrRemoveCssClass(`${Oo}-2`, r === 2), e.addOrRemoveCssClass(`${Oo}-3`, r === 3), e.addOrRemoveCssClass(`${Oo}-4`, r >= 4), e.addOrRemoveCssClass(z2, n), sa(i, r > 0 ? !0 : void 0), e.addOrRemoveCssClass(W2, this.isSingleCell()), this.updateRangeBorders(), this.refreshHandle();
  }
  updateRangeBorders() {
    const e = this.getRangeBorders(), t = this.isSingleCell(), s = !t && e.top, i = !t && e.right, r = !t && e.bottom, n = !t && e.left, o = this.cellComp;
    o.addOrRemoveCssClass($2, s), o.addOrRemoveCssClass(j2, i), o.addOrRemoveCssClass(K2, r), o.addOrRemoveCssClass(q2, n);
  }
  isSingleCell() {
    const { rangeSvc: e } = this;
    return this.rangeCount === 1 && !!e && !e.isMoreThanOneCell();
  }
  getHasChartRange() {
    const { rangeSvc: e } = this;
    if (!this.rangeCount || !e)
      return !1;
    const t = e.getCellRanges();
    return t.length > 0 && t.every((s) => [Vs.DIMENSION, Vs.VALUE].includes(s.type));
  }
  updateRangeBordersIfRangeCount() {
    this.rangeCount > 0 && (this.updateRangeBorders(), this.refreshHandle());
  }
  getRangeBorders() {
    const e = this.beans.gos.get("enableRtl");
    let t = !1, s = !1, i = !1, r = !1;
    const {
      rangeSvc: n,
      beans: { visibleCols: o },
      cellCtrl: { cellPosition: a }
    } = this, l = a.column;
    let c, d;
    e ? (c = o.getColAfter(l), d = o.getColBefore(l)) : (c = o.getColBefore(l), d = o.getColAfter(l));
    const u = n.getCellRanges().filter((h) => n.isCellInSpecificRange(a, h));
    c || (r = !0), d || (s = !0);
    for (let h = 0; h < u.length && !(t && s && i && r); h++) {
      const p = u[h], g = n.getRangeStartRow(p), f = n.getRangeEndRow(p);
      !t && Pt(g, a) && (t = !0), !i && Pt(f, a) && (i = !0), !r && c && p.columns.indexOf(c) < 0 && (r = !0), !s && d && p.columns.indexOf(d) < 0 && (s = !0);
    }
    return { top: t, right: s, bottom: i, left: r };
  }
  refreshHandle() {
    if (this.beans.context.isDestroyed())
      return;
    const e = this.shouldHaveSelectionHandle();
    this.selectionHandle && !e && (this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle)), e && this.addSelectionHandle(), this.cellComp.addOrRemoveCssClass(U2, !!this.selectionHandle);
  }
  shouldHaveSelectionHandle() {
    const e = this.beans.gos, t = this.rangeSvc, s = t.getCellRanges(), i = s.length;
    if (this.rangeCount < 1 || i < 1)
      return !1;
    const r = pe(s), { cellPosition: n } = this.cellCtrl, o = Yf(e) && !this.cellCtrl.column.isSuppressFillHandle(), a = Y2(e);
    let l = i === 1 && !this.cellCtrl.editing && (o || a);
    if (this.hasChartRange) {
      const d = s[0].type === Vs.DIMENSION && t.isCellInSpecificRange(n, s[0]);
      this.cellComp.addOrRemoveCssClass(_2, d), l = r.type === Vs.VALUE;
    }
    return l && r.endRow != null && t.isContiguousRange(r) && t.isBottomRightCell(r, n);
  }
  addSelectionHandle() {
    var n;
    const { beans: e, rangeSvc: t } = this, s = pe(t.getCellRanges()).type, r = Yf(e.gos) && ke(s) ? 0 : 1;
    if (this.selectionHandle && this.selectionHandle.getType() !== r && (this.selectionHandle = e.context.destroyBean(this.selectionHandle)), !this.selectionHandle) {
      const o = e.registry.createDynamicBean(
        r === 0 ? "fillHandle" : "rangeHandle",
        !1
      );
      o && (this.selectionHandle = e.context.createBean(o));
    }
    (n = this.selectionHandle) == null || n.refresh(this.cellCtrl);
  }
  destroy() {
    this.beans.context.destroyBean(this.selectionHandle);
  }
}, Z2 = class extends L {
  constructor(e) {
    super(), this.eContainer = e;
  }
  postConstruct() {
    const { beans: e, gos: t, eContainer: s } = this, i = e.rangeSvc, r = {
      eElement: s,
      onDragStart: i.onDragStart.bind(i),
      onDragStop: i.onDragStop.bind(i),
      onDragging: i.onDragging.bind(i)
    }, n = e.dragSvc, o = n.addDragSource.bind(n, r), a = n.removeDragSource.bind(n, r);
    this.addManagedPropertyListeners(["enableRangeSelection", "cellSelection"], () => {
      is(t) ? o() : a();
    }), this.addDestroyFunc(a), is(t) && o();
  }
}, Q2 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rangeSvc", this.cellRanges = [], this.bodyScrollListener = this.onBodyScroll.bind(this), this.dragging = !1, this.intersectionRange = !1;
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.dragSvc = e.dragSvc, this.colModel = e.colModel, this.visibleCols = e.visibleCols, this.cellNavigation = e.cellNavigation, this.pinnedRowModel = e.pinnedRowModel, this.ctrlsSvc = e.ctrlsSvc;
  }
  postConstruct() {
    const e = this.onColumnsChanged.bind(this), t = () => this.removeAllCellRanges(), s = this.refreshLastRangeStart.bind(this);
    this.addManagedEventListeners({
      newColumnsLoaded: e,
      columnVisible: e,
      columnValueChanged: e,
      columnPivotModeChanged: t,
      columnRowGroupChanged: t,
      columnPivotChanged: t,
      columnGroupOpened: s,
      columnMoved: s,
      columnPinned: s
    }), this.ctrlsSvc.whenReady(this, (i) => {
      const r = i.gridBodyCtrl;
      this.autoScrollService = new yh({
        scrollContainer: r.eBodyViewport,
        scrollAxis: "xy",
        getVerticalPosition: () => r.scrollFeature.getVScrollPosition().top,
        setVerticalPosition: (n) => r.scrollFeature.setVerticalScrollPosition(n),
        getHorizontalPosition: () => r.scrollFeature.getHScrollPosition().left,
        setHorizontalPosition: (n) => r.scrollFeature.setHorizontalScrollPosition(n),
        shouldSkipVerticalScroll: () => !It(this.gos, "normal"),
        shouldSkipHorizontalScroll: () => !r.scrollFeature.isHorizontalScrollShowing()
      });
    });
  }
  // Called for both columns loaded & column visibility events
  onColumnsChanged() {
    this.refreshLastRangeStart();
    const e = this.visibleCols.allCols;
    this.cellRanges.forEach((s) => {
      const i = s.columns;
      s.columns = s.columns.filter(
        (n) => n.isVisible() && e.indexOf(n) !== -1
      ), !Ht(i, s.columns) && this.dispatchChangedEvent(!1, !0, s.id);
    });
    const t = this.cellRanges.length;
    this.cellRanges = this.cellRanges.filter((s) => s.columns.length > 0), t > this.cellRanges.length && this.dispatchChangedEvent(!1, !0);
  }
  refreshLastRangeStart() {
    const e = pe(this.cellRanges);
    e && this.refreshRangeStart(e);
  }
  isContiguousRange(e) {
    const t = e.columns;
    if (!t.length)
      return !1;
    const s = this.visibleCols.allCols, i = t.map((r) => s.indexOf(r)).sort((r, n) => r - n);
    return pe(i) - i[0] + 1 === t.length;
  }
  getRangeStartRow(e) {
    var i;
    return e.startRow && e.endRow ? jt(e.startRow, e.endRow) ? e.startRow : e.endRow : { rowIndex: 0, rowPinned: (((i = this.pinnedRowModel) == null ? void 0 : i.getPinnedTopRowCount()) ?? 0) > 0 ? "top" : null };
  }
  getRangeEndRow(e) {
    var i;
    if (e.startRow && e.endRow)
      return jt(e.startRow, e.endRow) ? e.endRow : e.startRow;
    const t = ((i = this.pinnedRowModel) == null ? void 0 : i.getPinnedBottomRowCount()) ?? 0;
    return t > 0 ? {
      rowIndex: t - 1,
      rowPinned: "bottom"
    } : {
      rowIndex: this.rowModel.getRowCount() - 1,
      rowPinned: null
    };
  }
  setRangeToCell(e, t = !1) {
    if (!is(this.gos))
      return;
    const s = this.calculateColumnsBetween(e.column, e.column);
    if (!s)
      return;
    (za(this.gos) || !t || ke(this.cellRanges)) && this.removeAllCellRanges(!0);
    const r = {
      rowIndex: e.rowIndex,
      rowPinned: e.rowPinned
    }, n = {
      startRow: r,
      endRow: r,
      columns: s,
      startColumn: e.column
    };
    this.cellRanges.push(n), this.setNewestRangeStartCell(e), this.onDragStop(), this.dispatchChangedEvent(!0, !0);
  }
  extendLatestRangeToCell(e) {
    if (this.isEmpty() || !this.newestRangeStartCell)
      return;
    const t = pe(this.cellRanges);
    this.updateRangeEnd(t, e);
  }
  updateRangeEnd(e, t, s = !1) {
    const i = t.column, r = this.calculateColumnsBetween(e.startColumn, i);
    !r || this.isLastCellOfRange(e, t) || (e.columns = r, e.endRow = { rowIndex: t.rowIndex, rowPinned: t.rowPinned }, s || this.dispatchChangedEvent(!0, !0, e.id));
  }
  refreshRangeStart(e) {
    const { startColumn: t, columns: s } = e, i = (l, c) => {
      const d = e.columns.filter((u) => u !== l);
      l ? (e.startColumn = l, e.columns = c ? [l, ...d] : [...d, l]) : e.columns = d;
    }, { left: r, right: n } = this.getRangeEdgeColumns(e);
    if (t === s[0] && t !== r) {
      i(r, !0);
      return;
    }
    if (t === pe(s) && t === n) {
      i(n, !1);
      return;
    }
  }
  getRangeEdgeColumns(e) {
    const t = this.visibleCols.allCols, s = e.columns.map((i) => t.indexOf(i)).filter((i) => i > -1).sort((i, r) => i - r);
    return {
      left: t[s[0]],
      right: t[pe(s)]
    };
  }
  // returns true if successful, false if not successful
  extendLatestRangeInDirection(e) {
    if (this.isEmpty() || !this.newestRangeStartCell)
      return;
    const t = e.key, s = e.ctrlKey || e.metaKey, i = pe(this.cellRanges), r = this.newestRangeStartCell, n = i.columns[0], o = pe(i.columns), a = i.endRow.rowIndex, l = i.endRow.rowPinned, d = { column: r.column === n ? o : n, rowIndex: a, rowPinned: l }, u = this.cellNavigation.getNextCellToFocus(t, d, s);
    if (u)
      return this.setCellRange({
        rowStartIndex: r.rowIndex,
        rowStartPinned: r.rowPinned,
        rowEndIndex: u.rowIndex,
        rowEndPinned: u.rowPinned,
        columnStart: r.column,
        columnEnd: u.column
      }), u;
  }
  setCellRange(e) {
    is(this.gos) && (this.removeAllCellRanges(!0), this.addCellRange(e));
  }
  setCellRanges(e) {
    Ht(this.cellRanges, e) || this.verifyCellRanges(this.gos) && (this.removeAllCellRanges(!0), e.forEach((t) => {
      t.columns && t.startRow && this.setNewestRangeStartCell({
        rowIndex: t.startRow.rowIndex,
        rowPinned: t.startRow.rowPinned,
        column: t.columns[0]
      }), this.cellRanges.push(t);
    }), this.dispatchChangedEvent(!1, !0));
  }
  setNewestRangeStartCell(e) {
    this.newestRangeStartCell = e;
  }
  clearCellRangeCellValues(e) {
    let { cellRanges: t } = e;
    const { cellEventSource: s = "rangeSvc", dispatchWrapperEvents: i, wrapperEventSource: r = "deleteKey" } = e;
    i && (this.eventSvc.dispatchEvent({
      type: "cellSelectionDeleteStart",
      source: r
    }), this.eventSvc.dispatchEvent({
      type: "rangeDeleteStart",
      source: r
    })), t || (t = this.cellRanges), t.forEach((n) => {
      this.forEachRowInRange(n, (o) => {
        const a = ri(this.beans, o);
        if (a)
          for (let l = 0; l < n.columns.length; l++) {
            const c = this.colModel.getCol(n.columns[l]);
            if (!c || !c.isCellEditable(a))
              continue;
            const d = this.beans.valueSvc.getDeleteValue(c, a);
            a.setDataValue(c, d, s);
          }
      });
    }), i && (this.eventSvc.dispatchEvent({
      type: "cellSelectionDeleteEnd",
      source: r
    }), this.eventSvc.dispatchEvent({
      type: "rangeDeleteEnd",
      source: r
    }));
  }
  createCellRangeFromCellRangeParams(e) {
    return this.createPartialCellRangeFromRangeParams(e, !1);
  }
  // Range service can't normally support a range without columns, but charts can
  createPartialCellRangeFromRangeParams(e, t) {
    let s, i = !1;
    if (e.columns)
      s = e.columns.map((o) => this.colModel.getCol(o)).filter((o) => o);
    else {
      const o = this.colModel.getCol(e.columnStart), a = this.colModel.getCol(e.columnEnd);
      if (!o || !a)
        return;
      s = this.calculateColumnsBetween(o, a), s && s.length && (i = s[0] !== o);
    }
    if (!s || !t && s.length === 0)
      return;
    const r = e.rowStartIndex != null ? {
      rowIndex: e.rowStartIndex,
      rowPinned: e.rowStartPinned || null
    } : void 0, n = e.rowEndIndex != null ? {
      rowIndex: e.rowEndIndex,
      rowPinned: e.rowEndPinned || null
    } : void 0;
    return {
      startRow: r,
      endRow: n,
      columns: s,
      startColumn: i ? pe(s) : s[0]
    };
  }
  verifyCellRanges(e) {
    const t = $P(e) && za(e) && this.cellRanges.length > 0;
    return t && I(93), !t;
  }
  addCellRange(e) {
    const t = this.gos;
    if (!is(t) || !this.verifyCellRanges(t))
      return;
    const s = this.createCellRangeFromCellRangeParams(e);
    s && (s.startRow && this.setNewestRangeStartCell({
      rowIndex: s.startRow.rowIndex,
      rowPinned: s.startRow.rowPinned,
      column: s.startColumn
    }), this.cellRanges.push(s), this.dispatchChangedEvent(!1, !0, s.id));
  }
  getCellRanges() {
    return this.cellRanges;
  }
  isEmpty() {
    return this.cellRanges.length === 0;
  }
  isMoreThanOneCell() {
    const e = this.cellRanges.length;
    if (e === 0)
      return !1;
    if (e > 1)
      return !0;
    const t = this.cellRanges[0], s = this.getRangeStartRow(t), i = this.getRangeEndRow(t);
    return s.rowPinned !== i.rowPinned || s.rowIndex !== i.rowIndex || t.columns.length !== 1;
  }
  areAllRangesAbleToMerge() {
    const e = /* @__PURE__ */ new Map();
    if (this.cellRanges.length <= 1)
      return !0;
    this.cellRanges.forEach((i) => {
      this.forEachRowInRange(i, (r) => {
        const n = `${r.rowPinned || "normal"}_${r.rowIndex}`, o = e.get(n), a = i.columns.map((l) => l.getId());
        if (o) {
          const l = a.filter((c) => o.indexOf(c) === -1);
          o.push(...l);
        } else
          e.set(n, a);
      });
    });
    let s;
    for (const i of e.values()) {
      const r = i.sort().join();
      if (s === void 0) {
        s = r;
        continue;
      }
      if (s !== r)
        return !1;
    }
    return !0;
  }
  forEachRowInRange(e, t) {
    const s = this.getRangeStartRow(e), i = this.getRangeEndRow(e);
    let r = s;
    for (; r && (t(r), !Pt(r, i)); )
      r = this.cellNavigation.getRowBelow(r);
  }
  removeAllCellRanges(e) {
    this.isEmpty() || (this.onDragStop(), this.cellRanges.length = 0, e || this.dispatchChangedEvent(!1, !0));
  }
  // as the user is dragging outside of the panel, the div starts to scroll, which in turn
  // means we are selection more (or less) cells, but the mouse isn't moving, so we recalculate
  // the selection my mimicking a new mouse event
  onBodyScroll() {
    this.dragging && this.lastMouseEvent && this.onDragging(this.lastMouseEvent);
  }
  isCellInAnyRange(e) {
    return this.getCellRangeCount(e) > 0;
  }
  isCellInSpecificRange(e, t) {
    const s = t.columns !== null && t.columns.includes(e.column), i = this.isRowInRange(e.rowIndex, e.rowPinned, t);
    return s && i;
  }
  isLastCellOfRange(e, t) {
    const { startRow: s, endRow: i } = e, r = jt(s, i) ? i : s, n = t.rowIndex === r.rowIndex && t.rowPinned === r.rowPinned, o = e.columns[0], a = pe(e.columns), l = e.startColumn === o ? a : o;
    return t.column === l && n;
  }
  isBottomRightCell(e, t) {
    const s = this.visibleCols.allCols, i = e.columns.map((c) => s.indexOf(c)).sort((c, d) => c - d), { startRow: r, endRow: n } = e, o = jt(r, n) ? n : r, a = s.indexOf(t.column) === pe(i), l = t.rowIndex === o.rowIndex && St(t.rowPinned) === St(o.rowPinned);
    return a && l;
  }
  // returns the number of ranges this cell is in
  getCellRangeCount(e) {
    return this.isEmpty() ? 0 : this.cellRanges.filter((t) => this.isCellInSpecificRange(e, t)).length;
  }
  isRowInRange(e, t, s) {
    const i = this.getRangeStartRow(s), r = this.getRangeEndRow(s), n = { rowIndex: e, rowPinned: t || null }, o = n.rowIndex === i.rowIndex && n.rowPinned == i.rowPinned, a = n.rowIndex === r.rowIndex && n.rowPinned == r.rowPinned;
    if (o || a)
      return !0;
    const l = !jt(n, i), c = jt(n, r);
    return l && c;
  }
  getDraggingRange() {
    return this.draggingRange;
  }
  onDragStart(e) {
    var c;
    if (!is(this.gos))
      return;
    const { ctrlKey: t, metaKey: s, shiftKey: i } = e, r = t || s, o = !za(this.gos) ? r : !1, a = i && !!((c = this.cellRanges) != null && c.length);
    !o && (!a || W(pe(this.cellRanges).type)) && this.removeAllCellRanges(!0);
    const l = this.dragSvc.startTarget;
    if (l && this.updateValuesOnMove(l), !!this.lastCellHovered) {
      if (this.dragging = !0, this.lastMouseEvent = e, this.intersectionRange = o && this.getCellRangeCount(this.lastCellHovered) > 1, a || this.setNewestRangeStartCell(this.lastCellHovered), this.cellRanges.length > 0)
        this.draggingRange = pe(this.cellRanges);
      else {
        const d = {
          rowIndex: this.lastCellHovered.rowIndex,
          rowPinned: this.lastCellHovered.rowPinned
        };
        this.draggingRange = {
          startRow: d,
          endRow: d,
          columns: [this.lastCellHovered.column],
          startColumn: this.newestRangeStartCell.column
        }, this.cellRanges.push(this.draggingRange);
      }
      this.ctrlsSvc.getGridBodyCtrl().eBodyViewport.addEventListener("scroll", this.bodyScrollListener, { passive: !0 }), this.dispatchChangedEvent(!0, !1, this.draggingRange.id);
    }
  }
  intersectLastRange(e) {
    if (e && this.dragging || za(this.gos) || this.isEmpty())
      return;
    const t = pe(this.cellRanges), s = this.getRangeStartRow(t), i = this.getRangeEndRow(t), r = [];
    this.cellRanges.slice(0, -1).forEach((n) => {
      const o = this.getRangeStartRow(n), a = this.getRangeEndRow(n), l = n.columns, c = l.filter((u) => t.columns.indexOf(u) === -1);
      if (c.length === l.length) {
        r.push(n);
        return;
      }
      if (jt(i, o) || jt(a, s)) {
        r.push(n);
        return;
      }
      const d = r.length;
      if (jt(o, s)) {
        const u = {
          columns: [...l],
          startColumn: t.startColumn,
          startRow: { ...o },
          endRow: this.cellNavigation.getRowAbove(s)
        };
        r.push(u);
      }
      if (c.length > 0) {
        const u = {
          columns: c,
          startColumn: c.includes(t.startColumn) ? t.startColumn : c[0],
          startRow: this.rowMax([{ ...s }, { ...o }]),
          endRow: this.rowMin([{ ...i }, { ...a }])
        };
        r.push(u);
      }
      jt(i, a) && r.push({
        columns: [...l],
        startColumn: t.startColumn,
        startRow: this.cellNavigation.getRowBelow(i),
        endRow: { ...a }
      }), r.length - d === 1 && (r[r.length - 1].id = n.id);
    }), this.cellRanges = r, e && this.dispatchChangedEvent(!1, !0);
  }
  rowMax(e) {
    let t;
    return e.forEach((s) => {
      (t === void 0 || jt(t, s)) && (t = s);
    }), t;
  }
  rowMin(e) {
    let t;
    return e.forEach((s) => {
      (t === void 0 || jt(s, t)) && (t = s);
    }), t;
  }
  updateValuesOnMove(e) {
    const t = wh(this.gos, e), s = t == null ? void 0 : t.cellPosition;
    if (this.cellHasChanged = !1, !(!s || this.lastCellHovered && Jn(s, this.lastCellHovered))) {
      if (t != null && t.editing) {
        this.dragSvc.cancelDrag(e);
        return;
      }
      this.lastCellHovered && (this.cellHasChanged = !0), this.lastCellHovered = s;
    }
  }
  onDragging(e) {
    if (!this.dragging || !e)
      return;
    this.updateValuesOnMove(e.target), this.lastMouseEvent = e;
    const t = this.lastCellHovered, s = (n) => t && t.rowPinned === n && this.newestRangeStartCell.rowPinned === n, i = s("top") || s("bottom");
    if (this.autoScrollService.check(e, i), !this.cellHasChanged)
      return;
    const r = this.calculateColumnsBetween(
      this.newestRangeStartCell.column,
      t.column
    );
    r && (this.draggingRange.endRow = {
      rowIndex: t.rowIndex,
      rowPinned: t.rowPinned
    }, this.draggingRange.columns = r, this.dispatchChangedEvent(!1, !1, this.draggingRange.id));
  }
  onDragStop() {
    if (!this.dragging)
      return;
    const { id: e } = this.draggingRange;
    this.autoScrollService.ensureCleared(), this.ctrlsSvc.getGridBodyCtrl().eBodyViewport.removeEventListener("scroll", this.bodyScrollListener), this.lastMouseEvent = null, this.dragging = !1, this.draggingRange = void 0, this.lastCellHovered = void 0, this.intersectionRange && (this.intersectionRange = !1, this.intersectLastRange()), this.dispatchChangedEvent(!1, !0, e);
  }
  dispatchChangedEvent(e, t, s) {
    this.eventSvc.dispatchEvent({
      type: "cellSelectionChanged",
      started: e,
      finished: t,
      id: s
    }), this.eventSvc.dispatchEvent({
      type: "rangeSelectionChanged",
      started: e,
      finished: t,
      id: s
    });
  }
  calculateColumnsBetween(e, t) {
    const s = this.visibleCols.allCols, i = e === t, r = s.indexOf(e);
    if (r < 0) {
      I(178, { colId: e.getId() });
      return;
    }
    const n = i ? r : s.indexOf(t);
    if (n < 0) {
      I(178, { colId: t.getId() });
      return;
    }
    if (i)
      return [e];
    const o = Math.min(r, n), a = o === r ? n : r, l = [];
    for (let c = o; c <= a; c++)
      l.push(s[c]);
    return l;
  }
  createDragListenerFeature(e) {
    return new Z2(e);
  }
  createCellRangeFeature(e, t) {
    return new X2(e, t);
  }
}, eS = {
  moduleName: "CellSelection",
  version: Me,
  beans: [Q2],
  dynamicBeans: { fillHandle: G2, rangeHandle: B2 },
  apiFunctions: {
    getCellRanges: N2,
    addCellRange: H2,
    clearRangeSelection: qf,
    clearCellSelection: qf
  },
  dependsOn: [Je, Sc, kh],
  css: [V2]
}, J2 = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="ag-loading">
            <span class="ag-loading-icon" data-ref="eLoadingIcon"></span>
            <span class="ag-loading-text" data-ref="eLoadingText"></span>
        </div>`
    ), this.eLoadingIcon = E, this.eLoadingText = E;
  }
  init(e) {
    e.node.failedLoad ? this.setupFailed() : this.setupLoading();
  }
  setupFailed() {
    const e = this.getLocaleTextFunc();
    this.eLoadingText.innerText = e("loadingError", "ERR");
  }
  setupLoading() {
    const e = ue("groupLoading", this.beans, null);
    e && this.eLoadingIcon.appendChild(e);
    const t = this.getLocaleTextFunc();
    this.eLoadingText.innerText = t("loadingOoo", "Loading");
  }
  refresh(e) {
    return !1;
  }
}, eU = class extends _ {
  constructor() {
    super(
      /* html */
      '<div class="ag-skeleton-container"></div>'
    );
  }
  init(e) {
    const t = `ag-cell-skeleton-renderer-${this.getCompId()}`;
    this.getGui().setAttribute("id", t), this.addDestroyFunc(() => xr(e.eParentOfValue)), xr(e.eParentOfValue, t), e.node.failedLoad ? this.setupFailed() : this.setupLoading(e);
  }
  setupFailed() {
    const e = this.getLocaleTextFunc();
    this.getGui().innerText = e("loadingError", "ERR");
    const t = e("ariaSkeletonCellLoadingFailed", "Row failed to load");
    ot(this.getGui(), t);
  }
  setupLoading(e) {
    const s = We(this.beans).createElement("div");
    s.classList.add("ag-skeleton-effect");
    const i = e.node.rowIndex;
    if (i != null) {
      const o = 75 + 25 * (i % 2 === 0 ? Math.sin(i) : Math.cos(i));
      s.style.width = `${o}%`;
    }
    this.getGui().appendChild(s);
    const n = this.getLocaleTextFunc()("ariaSkeletonCellLoading", "Row data is loading");
    ot(this.getGui(), n);
  }
  refresh(e) {
    return !1;
  }
}, tU = {
  moduleName: "LoadingCellRenderer",
  version: Me,
  userComponents: {
    agLoadingCellRenderer: J2
  },
  icons: {
    // rotating spinner shown by the loading cell renderer
    groupLoading: "loading"
  },
  dependsOn: [Je]
}, sU = {
  moduleName: "SkeletonCellRenderer",
  version: Me,
  userComponents: {
    agSkeletonCellRenderer: eU
  },
  dependsOn: [Je]
};
function iU(e) {
  return e.colModel.isPivotMode();
}
function rU(e, t, s) {
  var i;
  return ((i = e.pivotResultCols) == null ? void 0 : i.lookupPivotResultCol(t, s)) ?? null;
}
function nU(e, t) {
  var s;
  (s = e.valueColsSvc) == null || s.setColumns(t, "api");
}
function oU(e) {
  var t;
  return ((t = e.valueColsSvc) == null ? void 0 : t.columns) ?? [];
}
function aU(e, t) {
  var s;
  (s = e.valueColsSvc) == null || s.removeColumns(t, "api");
}
function lU(e, t) {
  var s;
  (s = e.valueColsSvc) == null || s.addColumns(t, "api");
}
function cU(e, t) {
  var s;
  (s = e.pivotColsSvc) == null || s.setColumns(t, "api");
}
function dU(e, t) {
  var s;
  (s = e.pivotColsSvc) == null || s.removeColumns(t, "api");
}
function uU(e, t) {
  var s;
  (s = e.pivotColsSvc) == null || s.addColumns(t, "api");
}
function hU(e) {
  var t;
  return ((t = e.pivotColsSvc) == null ? void 0 : t.columns) ?? [];
}
function pU(e, t) {
  var s;
  (s = e.pivotResultCols) == null || s.setPivotResultCols(t, "api");
}
function gU(e) {
  var s;
  const t = (s = e.pivotResultCols) == null ? void 0 : s.getPivotResultCols();
  return t ? t.list : null;
}
var Xf = "PivotRowTotal_", fU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "pivotColDefSvc";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.pivotColsSvc = e.pivotColsSvc, this.valueColsSvc = e.valueColsSvc, this.colNames = e.colNames;
  }
  postConstruct() {
    const e = () => this.gos.get("serverSidePivotResultFieldSeparator") ?? "_";
    this.fieldSeparator = e(), this.addManagedPropertyListener("serverSidePivotResultFieldSeparator", () => {
      this.fieldSeparator = e();
    });
    const t = () => this.gos.get("pivotDefaultExpanded");
    this.pivotDefaultExpanded = t(), this.addManagedPropertyListener("pivotDefaultExpanded", () => {
      this.pivotDefaultExpanded = t();
    });
  }
  createPivotColumnDefs(e) {
    const t = this.createPivotColumnsFromUniqueValues(e);
    function s(n, o = []) {
      return n.forEach((a) => {
        a.children !== void 0 ? s(a.children, o) : o.push(a);
      }), o;
    }
    const i = s(t);
    this.addRowGroupTotals(t, i), this.addExpandablePivotGroups(t, i), this.addPivotTotalsToGroups(t, i);
    const r = i.map((n) => ({ ...n }));
    return {
      pivotColumnGroupDefs: t,
      pivotColumnDefs: r
    };
  }
  createPivotColumnsFromUniqueValues(e) {
    var r;
    const t = ((r = this.pivotColsSvc) == null ? void 0 : r.columns) ?? [], s = t.length;
    return this.recursivelyBuildGroup(
      0,
      e,
      [],
      s,
      t
    );
  }
  recursivelyBuildGroup(e, t, s, i, r) {
    var c;
    const n = (c = this.valueColsSvc) == null ? void 0 : c.columns;
    if (e >= i)
      return this.buildMeasureCols(s);
    const o = r[e].getColDef(), a = this.headerNameComparator.bind(this, o.pivotComparator);
    if ((n == null ? void 0 : n.length) === 1 && this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && e === i - 1) {
      const d = [];
      for (const u of Object.keys(t)) {
        const h = [...s, u], p = this.createColDef(n[0], u, h);
        p.columnGroupShow = "open", d.push(p);
      }
      return d.sort(a), d;
    }
    const l = [];
    for (const [d, u] of Object.entries(t)) {
      const h = this.pivotDefaultExpanded === -1 || e < this.pivotDefaultExpanded, p = [...s, d];
      l.push({
        children: this.recursivelyBuildGroup(e + 1, u, p, i, r),
        headerName: d,
        pivotKeys: p,
        columnGroupShow: "open",
        openByDefault: h,
        groupId: this.generateColumnGroupId(p)
      });
    }
    return l.sort(a), l;
  }
  buildMeasureCols(e) {
    var s;
    const t = ((s = this.valueColsSvc) == null ? void 0 : s.columns) ?? [];
    return t.length === 0 ? [this.createColDef(null, "-", e)] : t.map((i) => {
      const r = this.colNames.getDisplayNameForColumn(i, "header");
      return {
        ...this.createColDef(i, r, e),
        columnGroupShow: "open"
      };
    });
  }
  addExpandablePivotGroups(e, t) {
    const s = this.gos.get("suppressExpandablePivotGroups");
    if (s || this.gos.get("pivotColumnGroupTotals"))
      return;
    const i = (r, n, o) => {
      var c;
      if ("children" in r) {
        const d = /* @__PURE__ */ new Map();
        r.children.forEach((h) => {
          i(h, n, d);
        });
        const u = !r.children.some((h) => h.children);
        (c = this.valueColsSvc) == null || c.columns.forEach((h) => {
          const p = this.colNames.getDisplayNameForColumn(h, "header"), g = this.createColDef(h, p, r.pivotKeys);
          g.pivotTotalColumnIds = d.get(h.getColId()), g.columnGroupShow = s ? "open" : "closed", g.aggFunc = h.getAggFunc(), u || (r.children.push(g), n.push(g));
        }), this.merge(o, d);
        return;
      }
      if (!r.pivotValueColumn)
        return;
      const a = r.pivotValueColumn.getColId();
      o.has(a) ? o.get(a).push(r.colId) : o.set(a, [r.colId]);
    };
    e.forEach((r) => {
      i(r, t, /* @__PURE__ */ new Map());
    });
  }
  addPivotTotalsToGroups(e, t) {
    var n;
    if (!this.gos.get("pivotColumnGroupTotals"))
      return;
    const s = this.gos.get("pivotColumnGroupTotals") === "after", i = (n = this.valueColsSvc) == null ? void 0 : n.columns, r = i == null ? void 0 : i.map((o) => o.getAggFunc());
    if (!(!r || r.length < 1 || !this.sameAggFuncs(r)) && i) {
      const o = i[0];
      e.forEach((a) => {
        this.recursivelyAddPivotTotal(a, t, o, s);
      });
    }
  }
  recursivelyAddPivotTotal(e, t, s, i) {
    const r = e;
    if (!r.children) {
      const o = e;
      return o.colId ? [o.colId] : null;
    }
    let n = [];
    if (r.children.forEach((o) => {
      const a = this.recursivelyAddPivotTotal(o, t, s, i);
      a && (n = n.concat(a));
    }), r.children.length > 1) {
      const a = this.getLocaleTextFunc()("pivotColumnGroupTotals", "Total"), l = this.createColDef(s, a, e.pivotKeys, !0);
      l.pivotTotalColumnIds = n, l.aggFunc = s.getAggFunc(), l.columnGroupShow = this.gos.get("suppressExpandablePivotGroups") ? "open" : void 0;
      const c = e.children;
      i ? c.push(l) : c.unshift(l), t.push(l);
    }
    return n;
  }
  addRowGroupTotals(e, t) {
    var o;
    if (!this.gos.get("pivotRowTotals"))
      return;
    const s = this.gos.get("pivotRowTotals") === "after", r = (((o = this.valueColsSvc) == null ? void 0 : o.columns) ?? []).slice();
    s || r.reverse();
    const n = r.length > 1 || !this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
    for (let a = 0; a < r.length; a++) {
      const l = r[a], c = this.colNames.getDisplayNameForColumn(l, "header"), d = this.createColDef(l, c, []), u = [];
      for (let p = 0; p < t.length; p++) {
        const g = t[p];
        g.pivotValueColumn === l && u.push(g.colId);
      }
      d.pivotTotalColumnIds = u, d.colId = Xf + d.colId;
      const h = n ? {
        children: [d],
        pivotKeys: [],
        groupId: `${Xf}_pivotGroup_${l.getColId()}`
      } : d;
      t.push(d), s ? e.push(h) : e.unshift(h);
    }
  }
  createColDef(e, t, s, i = !1) {
    const r = {};
    if (e) {
      const n = e.getColDef();
      Object.assign(r, n), r.hide = !1;
    }
    return r.headerName = t, r.colId = this.generateColumnId(
      s || [],
      e && !i ? e.getColId() : ""
    ), r.field = r.colId, r.valueGetter = (n) => {
      var o;
      return (o = n.data) == null ? void 0 : o[n.colDef.field];
    }, r.pivotKeys = s, r.pivotValueColumn = e, r.filter === !0 && (r.filter = "agNumberColumnFilter"), r;
  }
  sameAggFuncs(e) {
    if (e.length == 1)
      return !0;
    for (let t = 1; t < e.length; t++)
      if (e[t] !== e[0])
        return !1;
    return !0;
  }
  headerNameComparator(e, t, s) {
    return e ? e(t.headerName, s.headerName) : t.headerName && !s.headerName ? 1 : !t.headerName && s.headerName ? -1 : !t.headerName || !s.headerName ? 0 : t.headerName < s.headerName ? -1 : t.headerName > s.headerName ? 1 : 0;
  }
  merge(e, t) {
    t.forEach((s, i) => {
      const n = [...e.has(i) ? e.get(i) : [], ...s];
      e.set(i, n);
    });
  }
  generateColumnGroupId(e) {
    var s;
    return `pivotGroup_${(((s = this.pivotColsSvc) == null ? void 0 : s.columns) ?? []).map((i) => i.getColId()).join("-")}_${e.join("-")}`;
  }
  generateColumnId(e, t) {
    var i;
    return `pivot_${(((i = this.pivotColsSvc) == null ? void 0 : i.columns) ?? []).map((r) => r.getColId()).join("-")}_${e.join("-")}_${t}`;
  }
  /**
   * Used by the SSRM to create secondary columns from provided fields
   * @param fields
   */
  createColDefsFromFields(e) {
    const t = {};
    for (let r = 0; r < e.length; r++) {
      const o = e[r].split(this.fieldSeparator);
      let a = t;
      for (let l = 0; l < o.length; l++) {
        const c = o[l];
        a[c] == null && (a[c] = {}), a = a[c];
      }
    }
    const s = (r, n, o, a) => {
      const l = [];
      for (const u of Object.keys(o)) {
        const h = o[u], p = s(`${r}${this.fieldSeparator}${u}`, u, h, a + 1);
        l.push(p);
      }
      if (l.length === 0) {
        const u = this.colModel.getColDefCol(n);
        if (u) {
          const p = this.colNames.getDisplayNameForColumn(u, "header") ?? n, g = this.createColDef(u, p, void 0, !1);
          return g.colId = r, g.aggFunc = u.getAggFunc(), g.valueGetter = (f) => {
            var m;
            return (m = f.data) == null ? void 0 : m[r];
          }, g;
        }
        return {
          colId: r,
          headerName: n,
          // this is to support using pinned rows, normally the data will be extracted from the aggData object using the colId
          // however pinned rows still access the data object by field, this prevents values with dots from being treated as complex objects
          valueGetter: (p) => {
            var g;
            return (g = p.data) == null ? void 0 : g[r];
          }
        };
      }
      return this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && l.length === 1 && "colId" in l[0] ? (l[0].headerName = n, l[0]) : {
        openByDefault: this.pivotDefaultExpanded === -1 || a < this.pivotDefaultExpanded,
        groupId: r,
        headerName: n,
        children: l
      };
    }, i = [];
    for (const r of Object.keys(t)) {
      const n = t[r], o = s(r, r, n, 0);
      i.push(o);
    }
    return i;
  }
}, mU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "pivotResultCols";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.visibleCols = e.visibleCols;
  }
  destroy() {
    var e;
    Er(this.beans, (e = this.pivotResultCols) == null ? void 0 : e.tree), super.destroy();
  }
  isPivotResultColsPresent() {
    return this.pivotResultCols != null;
  }
  lookupPivotResultCol(e, t) {
    if (this.pivotResultCols == null)
      return null;
    const s = this.colModel.getColDefCol(t);
    let i = null;
    return this.pivotResultCols.list.forEach((r) => {
      const n = r.getColDef().pivotKeys, o = r.getColDef().pivotValueColumn;
      Ht(n, e) && o === s && (i = r);
    }), i;
  }
  getPivotResultCols() {
    return this.pivotResultCols;
  }
  getPivotResultCol(e) {
    return this.pivotResultCols ? this.colModel.getColFromCollection(e, this.pivotResultCols) : null;
  }
  setPivotResultCols(e, t) {
    var s, i;
    if (this.colModel.ready && !(e == null && this.pivotResultCols == null)) {
      if (e) {
        this.processPivotResultColDef(e);
        const r = $v(
          this.beans,
          e,
          !1,
          ((s = this.pivotResultCols) == null ? void 0 : s.tree) || this.previousPivotResultCols || void 0,
          t
        );
        Er(this.beans, (i = this.pivotResultCols) == null ? void 0 : i.tree, r.columnTree);
        const n = r.columnTree, o = r.treeDept, a = hh(n), l = {};
        this.pivotResultCols = { tree: n, treeDepth: o, list: a, map: l }, this.pivotResultCols.list.forEach((d) => this.pivotResultCols.map[d.getId()] = d);
        const c = !!this.previousPivotResultCols;
        this.previousPivotResultCols = null, this.colModel.refreshCols(!c);
      } else
        this.previousPivotResultCols = this.pivotResultCols ? this.pivotResultCols.tree : null, this.pivotResultCols = null, this.colModel.refreshCols(!1);
      this.visibleCols.refresh(t);
    }
  }
  processPivotResultColDef(e) {
    const t = this.gos.get("processPivotResultColDef"), s = this.gos.get("processPivotResultColGroupDef");
    if (!t && !s)
      return;
    const i = (r) => {
      r.forEach((n) => {
        if (W(n.children)) {
          const a = n;
          s && s(a), i(a.children);
        } else
          t && t(n);
      });
    };
    e && i(e);
  }
}, Zf = "Exceeded maximum allowed pivot column count.", CU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "pivotStage", this.refreshProps = /* @__PURE__ */ new Set([
      "removePivotHeaderRowWhenSingleValueColumn",
      "pivotRowTotals",
      "pivotColumnGroupTotals",
      "suppressExpandablePivotGroups"
    ]), this.step = "pivot", this.uniqueValues = {}, this.lastTimeFailed = !1, this.maxUniqueValues = -1, this.currentUniqueCount = 0;
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc, this.colModel = e.colModel, this.pivotResultCols = e.pivotResultCols, this.rowGroupColsSvc = e.rowGroupColsSvc, this.valueColsSvc = e.valueColsSvc, this.pivotColsSvc = e.pivotColsSvc, this.pivotColDefSvc = e.pivotColDefSvc;
  }
  execute(e) {
    const t = e.changedPath;
    this.colModel.isPivotActive() ? this.executePivotOn(t) : this.executePivotOff(t);
  }
  executePivotOff(e) {
    this.aggregationColumnsHashLastTime = null, this.uniqueValues = {}, this.pivotResultCols.isPivotResultColsPresent() && (this.pivotResultCols.setPivotResultCols(null, "rowModelUpdated"), e && (e.active = !1));
  }
  executePivotOn(e) {
    var C, w, y;
    const t = ((C = this.valueColsSvc) == null ? void 0 : C.columns.length) ?? 1, s = this.gos.get("pivotMaxGeneratedColumns");
    this.maxUniqueValues = s === -1 ? -1 : s / t;
    let i;
    try {
      i = this.bucketUpRowNodes(e);
    } catch (b) {
      if (b.message === Zf) {
        this.pivotResultCols.setPivotResultCols([], "rowModelUpdated"), this.eventSvc.dispatchEvent({
          type: "pivotMaxColumnsExceeded",
          message: b.message
        }), this.lastTimeFailed = !0;
        return;
      }
      throw b;
    }
    const r = this.setUniqueValues(i), n = ((w = this.valueColsSvc) == null ? void 0 : w.columns) ?? [], o = n.map((b) => `${b.getId()}-${b.getColDef().headerName}`).join("#"), a = n.map((b) => b.getAggFunc().toString()).join("#"), l = this.aggregationColumnsHashLastTime !== o, c = this.aggregationFuncsHashLastTime !== a;
    this.aggregationColumnsHashLastTime = o, this.aggregationFuncsHashLastTime = a;
    const d = (((y = this.rowGroupColsSvc) == null ? void 0 : y.columns) ?? []).map((b) => b.getId()).join("#"), u = d !== this.groupColumnsHashLastTime;
    this.groupColumnsHashLastTime = d;
    const h = this.gos.get("pivotRowTotals"), p = this.gos.get("pivotColumnGroupTotals"), g = this.gos.get("suppressExpandablePivotGroups"), f = this.gos.get("removePivotHeaderRowWhenSingleValueColumn"), m = h !== this.pivotRowTotalsLastTime || p !== this.pivotColumnGroupTotalsLastTime || g !== this.suppressExpandablePivotGroupsLastTime || f !== this.removePivotHeaderRowWhenSingleValueColumnLastTime;
    if (this.pivotRowTotalsLastTime = h, this.pivotColumnGroupTotalsLastTime = p, this.suppressExpandablePivotGroupsLastTime = g, this.removePivotHeaderRowWhenSingleValueColumnLastTime = f, this.lastTimeFailed || r || l || u || c || m) {
      const { pivotColumnGroupDefs: b, pivotColumnDefs: x } = this.pivotColDefSvc.createPivotColumnDefs(
        this.uniqueValues
      );
      this.pivotColumnDefs = x, this.pivotResultCols.setPivotResultCols(b, "rowModelUpdated"), e && (e.active = !1);
    }
    this.lastTimeFailed = !1;
  }
  setUniqueValues(e) {
    const t = JSON.stringify(e), s = JSON.stringify(this.uniqueValues);
    return t !== s ? (this.uniqueValues = e, !0) : !1;
  }
  bucketUpRowNodes(e) {
    this.currentUniqueCount = 0;
    const t = {};
    e.forEachChangedNodeDepthFirst((i) => {
      i.leafGroup && (i.childrenMapped = null);
    });
    const s = (i) => {
      var r;
      i.leafGroup ? this.bucketRowNode(i, t) : (r = i.childrenAfterFilter) == null || r.forEach(s);
    };
    return e.executeFromRootNode(s), t;
  }
  bucketRowNode(e, t) {
    var i;
    const s = (i = this.pivotColsSvc) == null ? void 0 : i.columns;
    (s == null ? void 0 : s.length) === 0 ? e.childrenMapped = null : e.childrenMapped = this.bucketChildren(e.childrenAfterFilter, s, 0, t), e.sibling && (e.sibling.childrenMapped = e.childrenMapped);
  }
  bucketChildren(e, t = [], s, i) {
    const r = {}, n = t[s];
    if (e.forEach((o) => {
      let a = this.valueSvc.getKeyForNode(n, o);
      if (ke(a) && (a = ""), !i[a]) {
        this.currentUniqueCount += 1, i[a] = {};
        const l = this.maxUniqueValues !== -1, c = this.currentUniqueCount > this.maxUniqueValues;
        if (l && c)
          throw Error(Zf);
      }
      r[a] || (r[a] = []), r[a].push(o);
    }), s === t.length - 1)
      return r;
    {
      const o = {};
      for (const [a, l] of Object.entries(r))
        o[a] = this.bucketChildren(l, t, s + 1, i[a]);
      return o;
    }
  }
  getPivotColumnDefs() {
    return this.pivotColumnDefs;
  }
}, tS = {
  moduleName: "SharedPivot",
  version: Me,
  beans: [mU, fU, _b],
  apiFunctions: {
    isPivotMode: iU,
    getPivotResultColumn: rU,
    setValueColumns: nU,
    getValueColumns: oU,
    removeValueColumns: aU,
    addValueColumns: lU,
    setPivotColumns: cU,
    removePivotColumns: dU,
    addPivotColumns: uU,
    getPivotColumns: hU,
    setPivotResultColumns: pU,
    getPivotResultColumns: gU
  },
  dependsOn: [qb, ty]
}, vU = {
  moduleName: "Pivot",
  version: Me,
  rowModels: ["clientSide"],
  beans: [CU],
  dependsOn: [tS, Yb, Ac]
}, wU = (e, t) => e.treeNode.sourceIdx - t.treeNode.sourceIdx, yU = Tt.values(), Ja = (e, t) => {
  e.parent = null, e.treeNode = null, t ? e.childrenAfterGroup = [] : (e.level = 0, e.childrenAfterGroup = null, e.allLeafChildren = null);
}, bU = class Lu {
  constructor(t, s, i) {
    this.parent = t, this.key = s, this.level = i, this.children = null, this.invalidatedHead = null, this.invalidatedNext = void 0, this.row = null, this.oldRow = null, this.duplicateRows = null, this.childrenAfterGroup = Tt, this.allLeafChildren = Tt, this.childrenChanged = !1, this.leafChildrenChanged = !1, this.sourceIdx = -1;
  }
  /** Returns the number of children in this node */
  get size() {
    var t;
    return ((t = this.children) == null ? void 0 : t.size) ?? 0;
  }
  isEmptyFillerNode() {
    var t, s;
    return !((t = this.row) != null && t.data) && !((s = this.children) != null && s.size);
  }
  /** Returns an iterator able to iterate all children in this node, in order of insertion */
  enumChildren() {
    var t;
    return ((t = this.children) == null ? void 0 : t.values()) ?? yU;
  }
  /**
   * Gets a node a key in the given parent. If the node does not exists, creates a filler node, with null row.
   * We cast to string just to be sure the user passed a string correctly and not a number or something else.
   * @param key - The key of the node to get.
   * @param append - If true, the node will be moved to the end of the children list.
   * @returns the node at the given key, or a new filler node inserted there if it does not exist.
   */
  upsertKey(t) {
    var i, r;
    typeof t != "string" && (t = String(t));
    let s = (i = this.children) == null ? void 0 : i.get(t);
    return s || (s = new Lu(this, t, this.level + 1), (r = this.children ?? (this.children = /* @__PURE__ */ new Map())) == null || r.set(s.key, s)), s;
  }
  /** Same as upsertKey, but moves the node to the end no matter what. */
  appendKey(t) {
    var r;
    const s = this.children;
    typeof t != "string" && (t = String(t));
    let i = s == null ? void 0 : s.get(t);
    return i ? (s.delete(t), s.set(t, i)) : (i = new Lu(this, t, this.level + 1), (r = this.children ?? (this.children = /* @__PURE__ */ new Map())) == null || r.set(i.key, i)), i;
  }
  /** Removes this node from the parent, and free memory. This node cannot be used after this. */
  destroy() {
    var i;
    const { row: t, parent: s } = this;
    s !== null && ((i = s == null ? void 0 : s.children) == null || i.delete(this.key), t !== null && Ja(t, !0), this.parent = null);
  }
  /**
   * Sets the row for the TreeNode.
   * If the row is already set, it will be replaced with the new row, and the old row will be orphaned.
   * childrenAfterGroup and allLeafChildren will be reassigned.
   * @returns True if the row changed
   */
  setRow(t) {
    const { level: s, row: i, childrenAfterGroup: r } = this;
    if (s < 0)
      i !== null && i !== t && Ja(i, !0);
    else {
      if (i === t)
        return !1;
      i !== null ? (t !== null && (t.allLeafChildren = i.allLeafChildren ?? this.allLeafChildren ?? Tt), Ja(i, !1)) : t !== null && (t.allLeafChildren = this.allLeafChildren ?? Tt);
    }
    return t !== null && (t.level = s, t.childrenAfterGroup = r, t.treeNode = this), this.row = t, !0;
  }
  /**
   * Removes a row from the tree node.
   * If the row is the main row, it will be replaced with the first row in the duplicate rows, if any.
   * If the row is a duplicate row, it will be removed from the duplicate rows.
   * @param rowToRemove - The row to be removed.
   * @returns `true` if the row was successfully removed, `false` if the row was not found.
   */
  removeRow(t) {
    const { level: s, row: i, duplicateRows: r, childrenAfterGroup: n } = this;
    if (i === t) {
      const o = this.popDuplicateRow();
      o ? (this.row = o, o.childrenAfterGroup = n, s >= 0 && (o.allLeafChildren = i.allLeafChildren ?? this.allLeafChildren ?? Tt)) : this.row = null;
    } else {
      if (!(r != null && r.delete(t)))
        return !1;
      r.size === 0 && (this.duplicateRows = null);
    }
    return Ja(t, s < 0), !0;
  }
  /**
   * Adds a duplicate row to the tree node.
   * @param newRow - The new row to be added.
   * @returns A boolean indicating whether the row was successfully added.
   */
  addDuplicateRow(t) {
    const { level: s } = this;
    let i = this.duplicateRows;
    if (i === null)
      i = /* @__PURE__ */ new Set(), this.duplicateRows = i;
    else if (i.has(t))
      return !1;
    return i.add(t), t.treeNode = this, t.level = s, s >= 0 && (t.allLeafChildren = Tt), t.childrenAfterGroup = Tt, !0;
  }
  /**
   * This is needed to be sure that the row is the duplicate row with the smallest sourceRowIndex, in O(n).
   * @returns this.row
   */
  sortFirstDuplicateRow() {
    const t = this.duplicateRows, s = this.row;
    if (!s || !t)
      return s;
    let i = s;
    for (const r of t)
      r.sourceRowIndex < i.sourceRowIndex && (i = r);
    return i !== s && (i.childrenAfterGroup = this.childrenAfterGroup, i.allLeafChildren = s.allLeafChildren ?? this.allLeafChildren ?? Tt, s.childrenAfterGroup = Tt, s.allLeafChildren = Tt, t.delete(i), t.add(s), this.row = i), i;
  }
  /** Pops the first duplicate row from the list of duplicates */
  popDuplicateRow() {
    let t = null;
    const s = this.duplicateRows;
    return s !== null && (t = s.values().next().value, t !== null && s.delete(t) && s.size === 0 && (this.duplicateRows = null)), t;
  }
  /**
   * Dequeues the next child invalidated node to be committed. Order is not deterministic.
   * @returns the next child node to be committed, or null if all children were already dequeued.
   */
  dequeueInvalidated() {
    const t = this.invalidatedHead;
    return t !== null && (this.invalidatedHead = t.invalidatedNext ?? null, t.invalidatedNext = void 0), t;
  }
  /**
   * Invalidates this node and all its parents until the root is reached.
   * Order of invalidated nodes is not deterministic.
   * The root itself cannot be invalidated, as it has no parents.
   * If a node is already invalidated, it will stop the recursion.
   */
  invalidate() {
    let t = this, s = this.parent;
    for (; s !== null && t.invalidatedNext === void 0; )
      t.invalidatedNext = s.invalidatedHead, s.invalidatedHead = t, t = s, s = t.parent;
  }
  /** Marks childrenChanged in the parent, so the childrenAfterGroup will be recomputed and invalidates the parent. */
  invalidateOrder() {
    var s, i;
    const t = this.parent;
    t !== null && !t.childrenChanged && ((((s = this.children) == null ? void 0 : s.size) ?? 0) > 1 || !((i = t.row) != null && i.data)) && (t.childrenChanged = !0, t.invalidate());
  }
  /**
   * When we receive rowNodeOrder not undefined, we need to update the rowPosition of the node,
   * to ensure it will be sorted in the right order in childrenAfterGroup.
   * This function makes sense to be called only in the post-order commit DFS
   * as it assumes children's childrenAfterGroup is already updated.
   * @returns the rowPosition the node should have.
   */
  getNewSourceIdx() {
    var s, i;
    const t = this.row;
    return t != null && t.data ? t.sourceRowIndex : ((i = (s = this.childrenAfterGroup[0]) == null ? void 0 : s.treeNode) == null ? void 0 : i.sourceIdx) ?? this.sourceIdx;
  }
  /**
   * This is called in post order during commit to update the childrenAfterGroup array.
   * It uses the rowNodeOrder map to sort the children in the right order, if is passed.
   * It assumes all children childrenAfterGroup are up to date and rows all created.
   *
   * It replaces the array with _EmptyArray if there are no children, to reduce memory usage and GC pressure.
   * It does sort the children only if strictly needed, to avoid unnecessary work.
   *
   * If the order changes, also the order in the children map will be updated,
   * so the next call to enumChildren() will return the children in the right order.
   */
  updateChildrenAfterGroup(t) {
    var l;
    this.childrenChanged = !1;
    const s = t && ((l = this.children) == null ? void 0 : l.size) || 0;
    if (s === 0)
      return this.row.childrenAfterGroup = Tt, this.childrenAfterGroup.length === 0 ? !1 : (this.leafChildrenChanged = !0, this.childrenAfterGroup = Tt, !0);
    let i = !1, r = this.childrenAfterGroup;
    r === Tt ? (r = new Array(s), this.childrenAfterGroup = r, this.row.childrenAfterGroup = r, i = !0) : r.length !== s && (r.length = s, i = !0);
    let n = 0, o = -1, a = !1;
    for (const c of this.enumChildren()) {
      const d = c.getNewSourceIdx();
      d < o && (a = !0), o = d, c.sourceIdx = d;
      const u = c.row;
      r[n] !== u && (r[n] = u, i = !0), ++n;
    }
    return i && (this.leafChildrenChanged = !0), a && this.reorderChildrenList(r), i || a;
  }
  /** This reorders the given array and rebuild the children map. */
  reorderChildrenList(t) {
    const s = t.length, i = this.children;
    t.sort(wU), i.clear();
    for (let r = 0; r < s; ++r) {
      const n = t[r].treeNode;
      i.set(n.key, n);
    }
  }
  /**
   * Rebuild the allLeafChildren rows array of a node. It uses childrenAfterGroup, we assume to be already updated.
   * This is called in post order during commit, after the childrenAfterGroup are updated with updateChildrenAfterGroup().
   * It uses the childrenAfterGroup and allLeafChildren of all the children, we assume they are updated.
   */
  updateAllLeafChildren() {
    var o, a;
    const { parent: t, row: s, childrenAfterGroup: i } = this;
    this.leafChildrenChanged = !1;
    let r = !1;
    const n = i.length;
    if (n === 0)
      r = ((o = s.allLeafChildren) == null ? void 0 : o.length) !== 0, s.allLeafChildren = Tt, this.allLeafChildren = Tt;
    else if (n === 1 && ((a = i[0].allLeafChildren) != null && a.length))
      s.allLeafChildren = i[0].allLeafChildren, this.allLeafChildren = null, r = !0;
    else {
      let l = this.allLeafChildren;
      (l === Tt || l === null) && (l = [], this.allLeafChildren = l);
      const c = l.length;
      let d = 0;
      for (let u = 0; u < n; ++u) {
        const h = i[u], p = h.allLeafChildren, g = p.length;
        if (g)
          for (let f = 0; f < g; ++f) {
            const m = p[f];
            (d >= c || l[d] !== m) && (l[d] = m, r = !0), ++d;
          }
        else
          (d >= c || l[d] !== h) && h && (l[d] = h, r = !0), ++d;
      }
      c !== d && (l.length = d, r = !0), s.allLeafChildren !== l && (s.allLeafChildren = l, r = !0);
    }
    r && t && (t.leafChildrenChanged = !0);
  }
}, SU = (e) => (e.treeNodeFlags & 1) !== 0, sS = (e) => (e.treeNodeFlags & 2) !== 0, Qf = (e) => (e.treeNodeFlags & 4) !== 0, xU = (e) => (e.treeNodeFlags & 8) !== 0, Jf = (e) => (e.treeNodeFlags & 16) !== 0, em = (e, t) => {
  t ? e.treeNodeFlags |= 2 : e.treeNodeFlags &= -3;
}, RU = (e) => {
  const t = e.treeNodeFlags;
  t & 1 && (e.treeNodeFlags = t | 4);
}, FU = (e) => {
  const t = e.treeNodeFlags;
  t & 1 && (e.treeNodeFlags = t | 12);
}, Oi = (e) => {
  e.treeNodeFlags |= 16;
}, tm = (e) => {
  const t = e.level < 0, s = e.treeNodeFlags, i = (s & 1) !== 0;
  if (e.treeNodeFlags = 1 | s & -29, !i || t) {
    const r = e.childrenAfterGroup;
    e.childrenAfterFilter = r, e.childrenAfterAggFilter = r, e.childrenAfterSort = r;
  }
  if (t) {
    const r = e.sibling;
    r && (r.childrenAfterGroup = e.childrenAfterGroup, r.childrenMapped = e.childrenMapped);
  }
}, Go = (e) => {
  e.treeNodeFlags = 0;
}, PU = (e, t, s) => {
  if (t !== s && t !== null && t.group && sS(t) && !e.isGroupOpenByDefault)
    return t.expanded;
  const i = e.isGroupOpenByDefault;
  return i ? i({
    rowNode: s,
    field: s.field,
    key: s.key,
    level: s.level,
    rowGroupColumn: s.rowGroupColumn
  }) == !0 : e.expandByDefault === -1 || s.level < e.expandByDefault;
}, iS = class extends Hw {
  constructor() {
    super(...arguments), this.oldGroupDisplayColIds = "", this.rowsPendingDestruction = null, this.treeRoot = null;
  }
  activate(e) {
    super.activate(e), (this.treeRoot ?? (this.treeRoot = new bU(null, "", -1))).setRow(e);
  }
  destroy() {
    super.destroy(), this.treeRoot = null, this.rowsPendingDestruction = null, this.oldGroupDisplayColIds = "";
  }
  deactivate() {
    const e = this.treeRoot;
    if (e) {
      const t = e.row;
      t !== null && (e.removeRow(t), Go(t)), this.treeDestroy(e);
    }
    this.commitDestroyedRows(), super.deactivate(), this.treeRoot = null, this.oldGroupDisplayColIds = "";
  }
  /** Add or updates the row to a non-root node, preparing the tree correctly for the commit. */
  treeSetRow(e, t, s) {
    var o;
    const { level: i, row: r } = e;
    if (i < 0)
      return !1;
    let n = !1;
    if (r !== t) {
      const a = t.treeNode;
      a !== null && a !== e && (a.removeRow(t), a.invalidate()), r === null ? (e.setRow(t), n = !0) : r.data ? e.addDuplicateRow(t) && (n = !0) : (e.setRow(t), this.destroyRow(r, !0), n = !0);
    }
    return !s && !Qf(t) && (RU(t), n = !0), n && e.invalidate(), (o = this.rowsPendingDestruction) == null || o.delete(t), n;
  }
  /**
   * Overwrites the row property of a non-root node to null.
   * @returns The previous row, if any, that was overwritten.
   */
  treeRemove(e, t) {
    const { parent: s, level: i } = e;
    if (i < 0)
      return;
    let r = !1;
    e.removeRow(t) && (r = !0, s && (s.childrenChanged = !0), this.destroyRow(t, !t.data)), r && e.invalidate();
  }
  /** Commit the changes performed to the tree */
  treeCommit(e) {
    var o, a;
    const { treeRoot: t, rootNode: s } = this;
    if (!t || !s)
      return;
    const i = this.treeData, r = {
      rootNode: s,
      changedPath: e,
      treeData: i,
      expandByDefault: this.gos.get("groupDefaultExpanded"),
      isGroupOpenByDefault: this.gos.getCallback("isGroupOpenByDefault")
    };
    this.treeCommitChildren(r, t, !1);
    const n = t.row;
    n && (i && (n.leafGroup = !1), t.childrenChanged && t.updateChildrenAfterGroup(i) && Oi(n), Jf(n) && (o = r.changedPath) != null && o.active && r.changedPath.addParentNode(n), tm(n), n.updateHasChildren()), this.commitDestroyedRows(), (a = this.beans.selectionSvc) == null || a.updateSelectableAfterGrouping(e);
  }
  /** Calls commitChild for each invalidated child, recursively. We commit only the invalidated paths. */
  treeCommitChildren(e, t, s) {
    var i, r;
    for (; ; ) {
      const n = t.dequeueInvalidated();
      if (n === null)
        break;
      n.parent === t && this.treeCommitChild(e, n, s || !(((i = t.row) == null ? void 0 : i.expanded) ?? !0));
    }
    t.childrenChanged || (t.childrenChanged = (e.treeData ? t.size : 0) !== ((r = t.row.childrenAfterGroup) == null ? void 0 : r.length));
  }
  /** Commit the changes performed to a node and its children */
  treeCommitChild(e, t, s) {
    if (t.isEmptyFillerNode()) {
      this.treeClear(t);
      return;
    }
    if (this.treeCommitPreOrder(e, t), this.treeCommitChildren(e, t, s), t.isEmptyFillerNode()) {
      this.treeClear(t);
      return;
    }
    this.treeCommitPostOrder(e, t, s);
  }
  treeCommitPreOrder(e, t) {
    let s = t.row;
    if (s === null ? (s = this.createFillerRow(t), t.setRow(s)) : (s = t.sortFirstDuplicateRow(), s.allChildrenCount === void 0 && (s.allChildrenCount = null)), e.treeData) {
      if (s.parent = t.parent.row, t.oldRow !== s)
        for (const r of t.enumChildren()) {
          const n = r.row;
          n !== null && (n.parent = s);
        }
      const i = t.key;
      s.key !== i ? (s.key = i, FU(s), this.setGroupData(s, i)) : s.groupData || this.setGroupData(s, i);
    } else
      s.key = t.key, s.parent = e.rootNode;
  }
  treeCommitPostOrder(e, t, s) {
    var h, p, g;
    const i = t.parent, r = t.row, n = t.oldRow, o = e.treeData;
    t.childrenChanged && t.updateChildrenAfterGroup(o) && Oi(r), t.leafChildrenChanged && t.updateAllLeafChildren();
    const a = !!((h = r.childrenAfterGroup) != null && h.length), l = a || !r.data, c = r.group;
    c !== l ? (Oi(r), Fb(r, this.beans, l), !l && !r.expanded && em(r, !1)) : r.hasChildren() !== a && (Oi(r), r.updateHasChildren()), l && !sS(r) && (r.expanded = PU(e, n, r), em(r, !0)), Qf(r) && (Oi(i.row), xU(r) && r.setData(r.data)), n !== r && (t.oldRow = r, n !== null && (c || t.size !== 0) && Oi(r), i.childrenChanged = !0, Oi(i.row)), Jf(r) && (o && ((p = e.changedPath) != null && p.active) ? e.changedPath.addParentNode(r) : Oi(e.rootNode)), tm(r), (g = t.duplicateRows) != null && g.size && !t.duplicateRowsWarned && (t.duplicateRowsWarned = !0, I(186, {
      rowId: r.id,
      rowData: r.data,
      duplicateRowsData: Array.from(t.duplicateRows).map((f) => f.data)
    })), s && r.rowIndex !== null && r.clearRowTopAndRowIndex();
    const d = t.getNewSourceIdx(), u = t.sourceIdx;
    u !== d && (t.sourceIdx = d, u !== -1 && (i.childrenChanged = !0));
  }
  createFillerRow(e) {
    const t = new bs(this.beans);
    t.key = e.key, t.group = !0, t.field = null, t.leafGroup = !1, t.rowGroupIndex = null, t.allChildrenCount = null;
    let s = e.level + "-" + e.key, i = e.parent;
    for (; i !== null; ) {
      const r = i.parent;
      if (r === null)
        break;
      s = `${i.level}-${i.key}-${s}`, i = r;
    }
    return t.id = oa + s, t;
  }
  setGroupData(e, t) {
    var r;
    const s = {};
    e.groupData = s;
    const i = (r = this.beans.showRowGroupCols) == null ? void 0 : r.getShowRowGroupCols();
    if (i)
      for (const n of i)
        s[n.getColId()] = t;
  }
  /** Called to clear a subtree. */
  treeClear(e) {
    const { parent: t, oldRow: s, row: i, level: r } = e;
    if (t !== null && s !== null && (t.childrenChanged = !0, t.row !== null && Oi(t.row)), i !== null && r >= 0) {
      let n = e.row;
      for (; n !== null && e.removeRow(n); )
        this.destroyRow(n, !n.data), n = e.row;
    }
    for (const n of e.enumChildren())
      this.treeClear(n);
    e.destroy();
  }
  /** Called by the deactivate, to destroy the whole tree. */
  treeDestroy(e) {
    const { row: t, level: s, duplicateRows: i } = e;
    if (t && (s >= 0 && !t.data ? this.destroyRow(t, !0) : Go(t)), i)
      for (const r of i)
        s >= 0 && !r.data ? this.destroyRow(r, !0) : Go(r);
    for (const r of e.enumChildren())
      this.treeDestroy(r);
    e.destroy();
  }
  /**
   * Finalizes the deletion of a row.
   * @param immediate If true, the row is deleted immediately.
   * If false, the row is marked for deletion, and will be deleted later with this.deleteDeletedRows()
   */
  destroyRow(e, t) {
    if (e.isSelected())
      t = !1;
    else if (!SU(e)) {
      Go(e);
      return;
    }
    if (!t) {
      (this.rowsPendingDestruction ?? (this.rowsPendingDestruction = /* @__PURE__ */ new Set())).add(e);
      return;
    }
    Go(e), e.clearRowTopAndRowIndex(), e.groupData = null;
  }
  /**
   * destroyRow can defer the deletion to the end of the commit stage.
   * This method finalizes the deletion of rows that were marked for deletion.
   */
  commitDestroyedRows() {
    const { rowsPendingDestruction: e } = this;
    let t = null;
    if (e !== null) {
      for (const s of e)
        this.destroyRow(s, !0), s.isSelected() && (t ?? (t = [])).push(s);
      this.rowsPendingDestruction = null;
    }
    t && this.deselectNodes(t);
  }
  refreshModel(e) {
    var t, s, i;
    if (e.afterColumnsChanged)
      if (this.treeData) {
        const r = ((s = (t = this.beans.showRowGroupCols) == null ? void 0 : t.getShowRowGroupCols()) == null ? void 0 : s.map((n) => n.getId()).join("-")) ?? "";
        if (this.oldGroupDisplayColIds !== r) {
          this.oldGroupDisplayColIds = r;
          const n = (i = this.rootNode) == null ? void 0 : i.childrenAfterGroup;
          if (n)
            for (let o = 0, a = n.length ?? 0; o < a; ++o) {
              const l = n[o], c = l.treeNode;
              c && this.setGroupData(l, c.key);
            }
        }
      } else
        this.oldGroupDisplayColIds = "";
  }
}, TU = (e) => {
  if (typeof e != "string" || !e.length)
    return [];
  const t = e.split(".");
  return t.includes("__proto__") ? [] : t;
}, EU = (e) => {
  const t = TU(e);
  let s = null;
  const i = t.length - 1;
  return i === 0 ? s = (r) => r == null ? void 0 : r[e] : i > 0 ? s = (r) => {
    let n = r;
    for (let o = 0; o <= i && n !== null && n !== void 0; ++o)
      if (n = n[t[o]], o < i && typeof n != "object" && n !== void 0)
        return null;
    return n;
  } : s = () => {
  }, s.path = e, s;
}, DU = class extends iS {
  constructor() {
    super(...arguments), this.beanName = "csrmChildrenTreeNodeSvc", this.childrenGetter = null;
  }
  get treeData() {
    return this.gos.get("treeData");
  }
  extractRowData() {
    const e = this.treeRoot;
    return e && Array.from(e.enumChildren(), (t) => t.row.data);
  }
  destroy() {
    super.destroy(), this.childrenGetter = null;
  }
  activate(e) {
    const t = this.childrenGetter, s = this.gos.get("treeDataChildrenField");
    (!t || t.path !== s) && (this.childrenGetter = EU(s)), super.activate(e);
  }
  loadNewRowData(e) {
    const t = this.treeRoot, s = this.rootNode, i = this.childrenGetter, r = /* @__PURE__ */ new Map(), n = [];
    s.allLeafChildren = n, this.treeClear(t), t.setRow(s);
    const o = (a, l) => {
      let c = r.get(l);
      if (c !== void 0) {
        be(2, { nodeId: c.id });
        return;
      }
      c = this.createRowNode(l, n.length), r.set(l, c), n.push(c), a = a.upsertKey(c.id), this.treeSetRow(a, c, !0);
      const d = i == null ? void 0 : i(l);
      if (d)
        for (let u = 0, h = d.length; u < h; ++u)
          o(a, d[u]);
    };
    for (let a = 0, l = e.length; a < l; ++a)
      o(t, e[a]);
    this.treeCommit();
  }
  setImmutableRowData(e, t) {
    const s = this.gos, i = this.treeRoot, r = this.rootNode, n = this.childrenGetter, o = _i(s), a = !s.get("suppressMaintainUnsortedOrder"), l = /* @__PURE__ */ new Map(), c = new so(!1, r);
    e.changedPath = c;
    const d = e.changedRowNodes, u = r.allLeafChildren, h = [], p = [];
    let g = !1, f = !1;
    const w = a ? (x, M) => {
      const T = M == null ? void 0 : M.length;
      let F = !0, k = -1;
      for (let O = 0; O < T; ++O) {
        const D = y(x, M[O]);
        D >= 0 && (D < k && (F = !1), k = D);
      }
      F || (g = !0, x.childrenChanged || (x.childrenChanged = !0, x.invalidate()));
    } : (x, M) => {
      for (let T = 0, F = M.length; T < F; ++T)
        y(x, M[T]);
    }, y = (x, M) => {
      let T = l.get(M);
      if (T !== void 0)
        return I(2, { nodeId: T.id }), -1;
      const F = o({ data: M, level: x.level + 1 });
      let k = !1;
      T = this.getRowNode(F), T ? T.data !== M && (d.update(T), T.updateData(M), !T.selectable && T.isSelected() && p.push(T)) : (T = this.createRowNode(M, -1), d.add(T), k = !0), l.set(M, T);
      let O, D;
      a ? (D = x.appendKey(T.id), O = T.sourceRowIndex, T.sourceRowIndex = h.push(T) - 1) : (D = x.upsertKey(T.id), O = -1), this.treeSetRow(D, T, k) && (f = !0);
      const $ = n == null ? void 0 : n(M);
      return $ && w(D, $), O;
    };
    if (w(i, t), u)
      for (let x = 0, M = u.length; x < M; ++x) {
        const T = u[x], F = T.treeNode;
        if (F) {
          const k = T.data;
          k && !l.has(k) && (d.remove(T), this.treeRemove(F, T));
        }
      }
    if (!a) {
      const x = (M) => {
        for (const T of M.enumChildren()) {
          const F = T.row;
          F && (F.sourceRowIndex = h.push(F) - 1, x(T));
        }
      };
      x(i);
    }
    r.allLeafChildren = h, i.allLeafChildren = h, p.length && this.deselectNodes(p), this.treeCommit(c);
    const b = r.sibling;
    b && (b.allLeafChildren = h), (f || g) && (e.step = "group", e.rowDataUpdated = !0, e.rowNodesOrderChanged = g);
  }
  refreshModel(e) {
    var i, r;
    const { rootNode: t, treeRoot: s } = this;
    if (s) {
      if ((i = e.changedProps) != null && i.has("treeData") && !e.newData) {
        s.setRow(t);
        const n = t == null ? void 0 : t.allLeafChildren;
        if (n)
          for (let o = 0, a = n.length; o < a; ++o) {
            const l = n[o];
            l.groupData = null, (r = l.treeNode) == null || r.invalidate();
          }
        this.treeCommit();
      }
      super.refreshModel(e);
    }
  }
}, AU = class extends iS {
  constructor() {
    super(...arguments), this.beanName = "csrmPathTreeNodeSvc";
  }
  loadNewRowData(e) {
    const t = this.rootNode, s = this.treeRoot;
    this.treeClear(s), s.setRow(t), super.loadNewRowData(e);
    const i = t.allLeafChildren, r = this.gos.get("getDataPath");
    for (let n = 0, o = i.length; n < o; ++n)
      this.addOrUpdateRow(r, i[n], !0);
    this.treeCommit();
  }
  get treeData() {
    const e = this.gos;
    return e.get("treeData") && !!e.get("getDataPath");
  }
  refreshModel(e) {
    const t = e.changedRowNodes;
    t && this.executeTransactions(t, e.changedPath, e.rowNodesOrderChanged), super.refreshModel(e);
  }
  executeTransactions(e, t, s) {
    var a;
    const i = this.treeRoot;
    if (!i)
      return;
    i.setRow(this.rootNode);
    for (const l of e.removals) {
      const c = l.treeNode;
      c && this.treeRemove(c, l);
    }
    const r = e.updates, n = this.gos.get("getDataPath");
    for (const l of r.keys())
      this.addOrUpdateRow(n, l, r.get(l));
    const o = (a = i.row) == null ? void 0 : a.allLeafChildren;
    if (s && o)
      for (let l = 0, c = o.length; l < c; ++l) {
        const d = o[l].treeNode;
        d && d.sourceIdx !== l && d.invalidateOrder();
      }
    this.treeCommit(t);
  }
  addOrUpdateRow(e, t, s) {
    const i = this.treeRoot;
    if (!this.treeData) {
      this.treeSetRow(i.upsertKey(t.id), t, s);
      return;
    }
    const r = e == null ? void 0 : e(t.data), n = r == null ? void 0 : r.length;
    if (!n)
      I(185, { data: t.data });
    else {
      let o = 0, a = i;
      do
        a = a.upsertKey(r[o++]);
      while (o < n);
      this.treeSetRow(a, t, s);
    }
  }
}, rS = {
  moduleName: "SharedTreeData",
  version: Me,
  dependsOn: [Je, Jh, Kb, ep]
}, MU = {
  moduleName: "TreeData",
  version: Me,
  beans: [AU, DU],
  rowModels: ["clientSide"],
  dependsOn: [rS, Wb, Ac]
}, IU = "ag-Grid-MissingKey", LU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "ssrmBlockUtils";
  }
  wireBeans(e) {
    this.valueSvc = e.valueSvc, this.showRowGroupCols = e.showRowGroupCols, this.nodeManager = e.ssrmNodeManager, this.expansionSvc = e.expansionSvc, this.serverSideRowModel = e.rowModel, this.storeFactory = e.ssrmStoreFactory;
  }
  createRowNode(e) {
    const t = new bs(this.beans), s = e.rowHeight != null ? e.rowHeight : vs(this.beans);
    return t.setRowHeight(s), t.group = e.group, t.leafGroup = e.leafGroup, t.level = e.level, t.uiLevel = e.level, t.parent = e.parent, t.stub = !0, t.__needsRefreshWhenVisible = !1, t.group && (t.expanded = !1, t.field = e.field, t.rowGroupColumn = e.rowGroupColumn), t;
  }
  destroyRowNode(e, t = !1) {
    e.childStore && !t && (this.destroyBean(e.childStore), e.childStore = null), e.sibling && !e.footer && this.destroyRowNode(e.sibling, !1), e.clearRowTopAndRowIndex(), e.id != null && this.nodeManager.removeNode(e);
  }
  setTreeGroupInfo(e) {
    e.updateHasChildren();
    const t = this.gos.get("getServerSideGroupKey"), s = e.hasChildren();
    s && t != null && (e.key = t(e.data)), !s && e.childStore != null && (this.destroyBean(e.childStore), e.childStore = null, e.expanded = !1);
  }
  setRowGroupInfo(e) {
    if (e.key = this.valueSvc.getValue(e.rowGroupColumn, e), (e.key === null || e.key === void 0) && ah(() => {
      var r;
      I(190, { rowGroupId: (r = e.rowGroupColumn) == null ? void 0 : r.getId(), data: e.data });
    }, "SSBlock-BadKey"), this.gos.get("groupAllowUnbalanced") && e.key === "") {
      const r = this.serverSideRowModel.getParams();
      e.childStore = this.createBean(this.storeFactory.createStore(r, e));
    }
    Xn(this.beans.gos)({ node: e }) && (Wi(e, this.beans), e.sibling && (e.sibling.uiLevel = e.uiLevel + 1));
  }
  setMasterDetailInfo(e) {
    const t = this.gos.get("isRowMaster");
    t != null ? e.master = t(e.data) : e.master = !0;
  }
  updateDataIntoRowNode(e, t) {
    e.updateData(t), this.gos.get("treeData") ? (this.setTreeGroupInfo(e), this.setChildCountIntoRowNode(e)) : e.group ? (this.setChildCountIntoRowNode(e), e.footer || (Xn(this.beans.gos)({ node: e }) ? e.sibling ? e.sibling.updateData(t) : Wi(e, this.beans) : e.sibling && Qh(e))) : this.gos.get("masterDetail");
  }
  setDataIntoRowNode(e, t, s, i) {
    var n;
    e.stub = !1;
    const r = this.gos.get("treeData");
    e.setDataAndId(t, s), r ? this.setTreeGroupInfo(e) : e.group ? this.setRowGroupInfo(e) : this.gos.get("masterDetail") && this.setMasterDetailInfo(e), (r || e.group) && (this.setGroupDataIntoRowNode(e), this.setChildCountIntoRowNode(e)), W(t) && (e.setRowHeight(qt(this.beans, e, !1, i).height), (n = e.sibling) == null || n.setRowHeight(
      qt(this.beans, e.sibling, !1, i).height
    ));
  }
  setChildCountIntoRowNode(e) {
    const t = this.gos.get("getChildCount");
    t && e.setAllChildrenCount(t(e.data));
  }
  setGroupDataIntoRowNode(e) {
    var i;
    const t = ((i = this.showRowGroupCols) == null ? void 0 : i.getShowRowGroupCols()) ?? [], s = this.gos.get("treeData");
    t.forEach((r) => {
      if (e.groupData == null && (e.groupData = {}), s)
        e.groupData[r.getColId()] = e.key;
      else if (r.isRowGroupDisplayed(e.rowGroupColumn.getId())) {
        const n = this.valueSvc.getValue(e.rowGroupColumn, e);
        e.groupData[r.getColId()] = n;
      }
    });
  }
  clearDisplayIndex(e) {
    var i;
    e.clearRowTopAndRowIndex(), e.hasChildren() && !!e.childStore && ((i = e.childStore) == null || i.clearDisplayIndexes()), e.master && e.detailNode && e.detailNode.clearRowTopAndRowIndex();
  }
  setDisplayIndex(e, t, s, i) {
    const r = this.gos.get("groupAllowUnbalanced") && e.group && e.key === "";
    if (this.gos.get("groupHideOpenParents") && e.group && e.expanded || r ? (e.setRowIndex(null), e.setRowTop(null)) : (e.setRowIndex(t.value++), e.setRowTop(s.value), s.value += e.rowHeight), e.setUiLevel(i), e.footer)
      return;
    if (e.master && (e.expanded && e.detailNode ? (e.detailNode.setRowIndex(t.value++), e.detailNode.setRowTop(s.value), s.value += e.detailNode.rowHeight) : e.detailNode && e.detailNode.clearRowTopAndRowIndex()), e.hasChildren() && !!e.childStore) {
      const l = e.childStore;
      e.expanded || r ? l.setDisplayIndexes(t, s, r ? i : i + 1) : l.clearDisplayIndexes();
    }
  }
  extractRowBounds(e, t) {
    const s = (i) => ({
      rowHeight: i.rowHeight,
      rowTop: i.rowTop
    });
    if (e.rowIndex === t)
      return s(e);
    if (e.hasChildren() && e.expanded && e.childStore) {
      const i = e.childStore;
      if (i.isDisplayIndexInStore(t))
        return i.getRowBounds(t);
    } else if (e.master && e.expanded && e.detailNode && e.detailNode.rowIndex === t)
      return s(e.detailNode);
  }
  isPixelInNodeRange(e, t) {
    return !W(e.rowTop) || !W(e.rowHeight) ? !1 : t >= e.rowTop && t < e.rowTop + e.rowHeight;
  }
  getIndexAtPixel(e, t) {
    if (this.isPixelInNodeRange(e, t))
      return e.rowIndex;
    const s = e.master && e.expanded, i = e.detailNode;
    if (s && i && this.isPixelInNodeRange(i, t))
      return e.detailNode.rowIndex;
    if (e.hasChildren() && e.expanded && e.childStore) {
      const r = e.childStore;
      if (r.isPixelInRange(t))
        return r.getRowIndexAtPixel(t);
    }
    return null;
  }
  createNodeIdPrefix(e) {
    const t = [];
    let s = e;
    for (; s && s.level >= 0; )
      s.key === "" ? t.push(IU) : t.push(s.key), s = s.parent;
    if (t.length > 0)
      return t.reverse().join("-");
  }
  checkOpenByDefault(e) {
    var t;
    return (t = this.expansionSvc) == null ? void 0 : t.checkOpenByDefault(e);
  }
}, kU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "ssrmExpandListener";
  }
  wireBeans(e) {
    this.serverSideRowModel = e.rowModel, this.storeFactory = e.ssrmStoreFactory;
  }
  postConstruct() {
    Lt(this.gos) && this.addManagedEventListeners({ rowGroupOpened: this.onRowGroupOpened.bind(this) });
  }
  onRowGroupOpened(e) {
    const t = e.node;
    if (t.expanded) {
      if (t.master)
        this.createDetailNode(t);
      else if (ke(t.childStore)) {
        const s = this.serverSideRowModel.getParams();
        t.childStore = this.createBean(this.storeFactory.createStore(s, t));
      }
    } else this.gos.get("purgeClosedRowNodes") && W(t.childStore) && (t.childStore = this.destroyBean(t.childStore));
    this.eventSvc.dispatchEvent({ type: "storeUpdated" });
  }
  createDetailNode(e) {
    if (W(e.detailNode))
      return e.detailNode;
    const t = new bs(this.beans);
    t.detail = !0, t.selectable = !1, t.parent = e, W(e.id) && (t.id = "detail_" + e.id), t.data = e.data, t.level = e.level + 1;
    const s = 200, i = qt(this.beans, t).height;
    return t.rowHeight = i || s, e.detailNode = t, t;
  }
}, OU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "ssrmFilterListener";
  }
  wireBeans(e) {
    this.serverSideRowModel = e.rowModel, this.filterManager = e.filterManager, this.listenerUtils = e.ssrmListenerUtils;
  }
  postConstruct() {
    Lt(this.gos) && this.addManagedEventListeners({
      advancedFilterEnabledChanged: () => this.onFilterChanged(!0),
      filterChanged: () => this.onFilterChanged()
    });
  }
  onFilterChanged(e) {
    var l, c;
    const t = this.serverSideRowModel.getParams();
    if (!t)
      return;
    const s = t.filterModel;
    let i, r;
    if ((l = this.filterManager) != null && l.isAdvFilterEnabled()) {
      i = this.filterManager.getAdvFilterModel();
      const d = e ? Object.keys(s ?? {}) : this.getAdvancedFilterColumns(s), u = this.getAdvancedFilterColumns(i);
      d.forEach((h) => u.add(h)), r = Array.from(u);
    } else if (i = ((c = this.filterManager) == null ? void 0 : c.getFilterModel()) ?? {}, e) {
      const d = this.getAdvancedFilterColumns(s);
      Object.keys(i).forEach((u) => d.add(u)), r = Array.from(d);
    } else
      r = this.findChangedColumns(s, i);
    const n = this.listenerUtils.isSortingWithValueColumn(r), o = this.listenerUtils.isSortingWithSecondaryColumn(r), a = {
      valueColChanged: n,
      secondaryColChanged: o,
      changedColumns: r
    };
    this.serverSideRowModel.refreshAfterFilter(i, a);
  }
  findChangedColumns(e, t) {
    const s = {};
    Object.keys(e).forEach((r) => s[r] = !0), Object.keys(t).forEach((r) => s[r] = !0);
    const i = [];
    return Object.keys(s).forEach((r) => {
      const n = JSON.stringify(e[r]), o = JSON.stringify(t[r]);
      n != o && i.push(r);
    }), i;
  }
  getAdvancedFilterColumns(e) {
    const t = /* @__PURE__ */ new Set();
    if (!e)
      return t;
    const s = (i) => {
      i.filterType === "join" ? i.conditions.forEach((r) => s(r)) : t.add(i.colId);
    };
    return s(e), t;
  }
}, GU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "ssrmListenerUtils";
  }
  wireBeans(e) {
    this.pivotResultCols = e.pivotResultCols, this.valueColsSvc = e.valueColsSvc;
  }
  isSortingWithValueColumn(e) {
    var s;
    const t = (((s = this.valueColsSvc) == null ? void 0 : s.columns) ?? []).map((i) => i.getColId());
    for (let i = 0; i < e.length; i++)
      if (t.indexOf(e[i]) > -1)
        return !0;
    return !1;
  }
  isSortingWithSecondaryColumn(e) {
    var i;
    const t = (i = this.pivotResultCols) == null ? void 0 : i.getPivotResultCols();
    if (!t)
      return !1;
    const s = t.list.map((r) => r.getColId());
    for (let r = 0; r < e.length; r++)
      if (s.indexOf(e[r]) > -1)
        return !0;
    return !1;
  }
}, BU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "ssrmSortSvc";
  }
  wireBeans(e) {
    this.sortSvc = e.sortSvc, this.serverSideRowModel = e.rowModel, this.listenerUtils = e.ssrmListenerUtils;
  }
  postConstruct() {
    Lt(this.gos) && this.addManagedEventListeners({ sortChanged: this.onSortChanged.bind(this) });
  }
  onSortChanged() {
    const e = this.serverSideRowModel.getParams();
    if (!e)
      return;
    const t = this.sortSvc.getSortModel(), s = e.sortModel, i = this.findChangedColumnsInSort(t, s), r = this.listenerUtils.isSortingWithValueColumn(i), n = this.listenerUtils.isSortingWithSecondaryColumn(i), o = {
      valueColChanged: r,
      secondaryColChanged: n,
      changedColumns: i
    };
    this.serverSideRowModel.refreshAfterSort(t, o);
  }
  // returns back all the cols that were effected by the sorting. eg if we were sorting by col A,
  // and now we are sorting by col B, the list of impacted cols should be A and B. so if a cache
  // is impacted by sorting on A or B then it needs to be refreshed. this includes where the cache
  // was previously sorted by A and then the A sort now needs to be cleared.
  findChangedColumnsInSort(e, t) {
    let s = [];
    [e, t].forEach((n) => {
      if (n) {
        const o = n.map((a) => a.colId);
        s = s.concat(o);
      }
    });
    const i = (n, o) => {
      const a = n ? n.sort : null, l = o ? o.sort : null;
      return a !== l;
    }, r = (n, o) => {
      const a = n ? t.indexOf(n) : -1, l = o ? e.indexOf(o) : -1;
      return a !== l;
    };
    return s.filter((n) => {
      const o = t.find((l) => l.colId === n), a = e.find((l) => l.colId === n);
      return i(o, a) || r(o, a);
    });
  }
}, VU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "ssrmNodeManager", this.rowNodes = {};
  }
  addRowNode(e) {
    const t = e.id;
    this.rowNodes[t] && I(187, {
      rowId: t,
      firstData: this.rowNodes[t].data,
      secondData: e.data
    }), this.rowNodes[t] = e;
  }
  removeNode(e) {
    const t = e.id;
    this.rowNodes[t] && (this.rowNodes[t] = void 0);
  }
  destroy() {
    this.clear(), super.destroy();
  }
  clear() {
    this.rowNodes = {}, super.destroy();
  }
}, NU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowModel", this.onRowHeightChanged_debounced = Et(this, this.onRowHeightChanged.bind(this), 100), this.pauseStoreUpdateListening = !1, this.started = !1, this.managingPivotResultColumns = !1;
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.colNames = e.colNames, this.pivotResultCols = e.pivotResultCols, this.rowGroupColsSvc = e.rowGroupColsSvc, this.pivotColsSvc = e.pivotColsSvc, this.valueColsSvc = e.valueColsSvc, this.filterManager = e.filterManager, this.sortSvc = e.sortSvc, this.rowRenderer = e.rowRenderer, this.nodeManager = e.ssrmNodeManager, this.storeFactory = e.ssrmStoreFactory, this.pivotColDefSvc = e.pivotColDefSvc;
  }
  // we don't implement as lazy row heights is not supported in this row model
  ensureRowHeightsValid() {
    return !1;
  }
  start() {
    this.started = !0, this.updateDatasource();
  }
  destroyDatasource() {
    this.datasource && (this.datasource.destroy && this.datasource.destroy(), this.rowRenderer.datasourceChanged(), this.datasource = void 0);
  }
  postConstruct() {
    const e = this.resetRootStore.bind(this);
    this.addManagedEventListeners({
      newColumnsLoaded: this.onColumnEverything.bind(this),
      storeUpdated: this.onStoreUpdated.bind(this),
      columnValueChanged: e,
      columnPivotChanged: e,
      columnRowGroupChanged: e,
      columnPivotModeChanged: e
    }), this.addManagedPropertyListeners(
      [
        /**
         * Following properties omitted as they are likely to come with undesired  side effects.
         * 'getRowId', 'isRowMaster', 'getRowHeight', 'isServerSideGroup', 'getServerSideGroupKey',
         * */
        "masterDetail",
        "treeData",
        "removePivotHeaderRowWhenSingleValueColumn",
        "cacheBlockSize"
      ],
      e
    ), this.addManagedPropertyListener("groupAllowUnbalanced", () => this.onStoreUpdated()), this.addManagedPropertyListener("rowHeight", () => this.resetRowHeights()), this.verifyProps(), this.addManagedPropertyListener("serverSideDatasource", () => this.updateDatasource());
  }
  updateDatasource() {
    const e = this.gos.get("serverSideDatasource");
    e && this.setDatasource(e);
  }
  verifyProps() {
    Es(this.gos) && !this.gos.exists("getRowId") && I(188);
  }
  setDatasource(e) {
    this.started && (this.destroyDatasource(), this.datasource = e, this.resetRootStore());
  }
  applyRowData(e, t, s) {
    const i = this.getRootStore();
    if (!i)
      return;
    const r = i.getChildStore(s);
    r && r.applyRowData(e, t, e.rowData.length);
  }
  isLastRowIndexKnown() {
    const e = this.getRootStore();
    return e ? e.isLastRowIndexKnown() : !1;
  }
  onColumnEverything() {
    var c, d, u, h;
    if (!this.storeParams) {
      this.resetRootStore();
      return;
    }
    const e = this.columnsToValueObjects((c = this.rowGroupColsSvc) == null ? void 0 : c.columns), t = this.columnsToValueObjects((d = this.valueColsSvc) == null ? void 0 : d.columns), s = this.columnsToValueObjects((u = this.pivotColsSvc) == null ? void 0 : u.columns), i = (p) => {
      const g = {};
      p.oldCols.forEach((C) => g[C.id] = C);
      const f = p.newCols.every((C) => {
        const w = g[C.id];
        return w && delete g[C.id], w && w.field === C.field && w.aggFunc === C.aggFunc;
      }), m = !p.allowRemovedColumns && !!Object.values(g).length;
      return f && !m;
    }, r = !Kn(this.storeParams.sortModel, ((h = this.sortSvc) == null ? void 0 : h.getSortModel()) ?? []), n = !i({
      oldCols: this.storeParams.rowGroupCols,
      newCols: e
    }), o = !i({
      oldCols: this.storeParams.pivotCols,
      newCols: s
    }), a = !!(e != null && e.length) && !i({
      oldCols: this.storeParams.valueCols,
      newCols: t,
      allowRemovedColumns: !0
    });
    if (r || n || o || a)
      this.resetRootStore();
    else {
      const p = this.createStoreParams();
      this.storeParams.rowGroupCols = p.rowGroupCols, this.storeParams.pivotCols = p.pivotCols, this.storeParams.valueCols = p.valueCols;
    }
  }
  destroyRootStore() {
    !this.rootNode || !this.rootNode.childStore || (this.rootNode.childStore = this.destroyBean(this.rootNode.childStore), this.nodeManager.clear());
  }
  refreshAfterSort(e, t) {
    this.storeParams && (this.storeParams.sortModel = e);
    const s = this.getRootStore();
    s && (s.refreshAfterSort(t), this.onStoreUpdated());
  }
  generateSecondaryColumns(e) {
    var s;
    if (!this.pivotColDefSvc) {
      this.gos.assertModuleRegistered("SharedPivot", 2);
      return;
    }
    const t = this.pivotColDefSvc.createColDefsFromFields(e);
    this.managingPivotResultColumns = !0, (s = this.pivotResultCols) == null || s.setPivotResultCols(t, "rowModelUpdated");
  }
  resetRowHeights() {
    const e = this.resetRowHeightsForAllRowNodes(), t = qt(this.beans, this.rootNode);
    if (this.rootNode.setRowHeight(t.height, t.estimated), this.rootNode.sibling) {
      const s = qt(this.beans, this.rootNode.sibling);
      this.rootNode.sibling.setRowHeight(s.height, s.estimated);
    }
    e && this.onRowHeightChanged();
  }
  resetRowHeightsForAllRowNodes() {
    let e = !1;
    return this.forEachNode((t) => {
      const s = qt(this.beans, t);
      t.setRowHeight(s.height, s.estimated);
      const i = t.detailNode;
      if (i) {
        const r = qt(this.beans, i);
        i.setRowHeight(r.height, r.estimated);
      }
      if (t.sibling) {
        const r = qt(this.beans, t.sibling);
        i.setRowHeight(r.height, r.estimated);
      }
      e = !0;
    }), e;
  }
  resetRootStore() {
    var e;
    this.destroyRootStore(), this.rootNode = new bs(this.beans), this.rootNode.group = !0, this.rootNode.level = -1, this.datasource && (this.storeParams = this.createStoreParams(), this.rootNode.childStore = this.createBean(this.storeFactory.createStore(this.storeParams, this.rootNode)), this.updateRowIndexesAndBounds()), this.managingPivotResultColumns && ((e = this.pivotResultCols) == null || e.setPivotResultCols(null, "api"), this.managingPivotResultColumns = !1), this.dispatchModelUpdated(!0);
  }
  columnsToValueObjects(e = []) {
    return e.map(
      (t) => ({
        id: t.getId(),
        aggFunc: t.getAggFunc(),
        displayName: this.colNames.getDisplayNameForColumn(t, "model"),
        field: t.getColDef().field
      })
    );
  }
  createStoreParams() {
    var n, o, a, l, c, d, u;
    const e = this.columnsToValueObjects((n = this.rowGroupColsSvc) == null ? void 0 : n.columns), t = this.columnsToValueObjects((o = this.valueColsSvc) == null ? void 0 : o.columns), s = this.columnsToValueObjects((a = this.pivotColsSvc) == null ? void 0 : a.columns), i = ch(this.gos);
    return {
      // the columns the user has grouped and aggregated by
      valueCols: t,
      rowGroupCols: e,
      pivotCols: s,
      pivotMode: this.colModel.isPivotMode(),
      // sort and filter model
      filterModel: (l = this.filterManager) != null && l.isAdvFilterEnabled() ? (c = this.filterManager) == null ? void 0 : c.getAdvFilterModel() : ((d = this.filterManager) == null ? void 0 : d.getFilterModel()) ?? {},
      sortModel: ((u = this.sortSvc) == null ? void 0 : u.getSortModel()) ?? [],
      datasource: this.datasource,
      lastAccessedSequence: { value: 0 },
      // blockSize: blockSize == null ? 100 : blockSize,
      dynamicRowHeight: i
    };
  }
  getParams() {
    return this.storeParams;
  }
  dispatchModelUpdated(e = !1) {
    this.eventSvc.dispatchEvent({
      type: "modelUpdated",
      animate: !e,
      keepRenderedRows: !e,
      newPage: !1,
      newData: !1
    });
  }
  onStoreUpdated() {
    this.pauseStoreUpdateListening || (this.updateRowIndexesAndBounds(), this.dispatchModelUpdated());
  }
  /** This method is debounced. It is used for row auto-height. If we don't debounce,
   * then the Row Models will end up recalculating each row position
   * for each row height change and result in the Row Renderer laying out rows.
   * This is particularly bad if using print layout, and showing eg 1,000 rows,
   * each row will change it's height, causing Row Model to update 1,000 times.
   */
  onRowHeightChangedDebounced() {
    this.onRowHeightChanged_debounced();
  }
  onRowHeightChanged() {
    this.updateRowIndexesAndBounds(), this.dispatchModelUpdated();
  }
  updateRowIndexesAndBounds() {
    const e = this.getRootStore();
    e && e.setDisplayIndexes({ value: 0 }, { value: 0 }, 0);
  }
  retryLoads() {
    const e = this.getRootStore();
    e && (e.retryLoads(), this.onStoreUpdated());
  }
  getRow(e) {
    const t = this.getRootStore();
    if (t)
      return t.getRowUsingDisplayIndex(e);
  }
  /**
   * Pauses the store, to prevent it updating the UI. This is used when doing batch updates to the store.
   */
  setPaused(e) {
    this.pauseStoreUpdateListening = e;
  }
  expandAll(e) {
    this.pauseStoreUpdateListening = !0, this.forEachNode((t) => {
      t.stub || t.hasChildren() && t.setExpanded(e);
    }), this.pauseStoreUpdateListening = !1, this.onStoreUpdated();
  }
  refreshAfterFilter(e, t) {
    this.storeParams && (this.storeParams.filterModel = e);
    const s = this.getRootStore();
    s && (s.refreshAfterFilter(t), this.onStoreUpdated());
  }
  getRootStore() {
    var e;
    return (e = this.rootNode) == null ? void 0 : e.childStore;
  }
  getRowCount() {
    const e = this.getRootStore();
    return e ? e.getDisplayIndexEnd() : 0;
  }
  getTopLevelRowCount() {
    const e = this.getRootStore();
    return e ? e.getRowCount() : 1;
  }
  getTopLevelRowDisplayedIndex(e) {
    const t = this.getRootStore();
    return t ? t.getTopLevelRowDisplayedIndex(e) : e;
  }
  getRowBounds(e) {
    const t = this.getRootStore();
    return t ? t.getRowBounds(e) : {
      rowTop: 0,
      rowHeight: vs(this.beans)
    };
  }
  getBlockStates() {
    const e = this.getRootStore();
    if (!e)
      return;
    const t = {};
    return e.forEachStoreDeep((s) => {
      Object.entries(s.getBlockStates()).forEach(([i, r]) => {
        t[i] = r;
      });
    }), t;
  }
  getRowIndexAtPixel(e) {
    const t = this.getRootStore();
    return e <= 0 || !t ? 0 : t.getRowIndexAtPixel(e);
  }
  isEmpty() {
    return !1;
  }
  isRowsToRender() {
    return this.getRootStore() != null && this.getRowCount() > 0;
  }
  getType() {
    return "serverSide";
  }
  forEachNode(e) {
    const t = this.getRootStore();
    t && t.forEachNodeDeep(e);
  }
  forEachNodeAfterFilterAndSort(e, t = !1) {
    const s = this.getRootStore();
    s && s.forEachNodeDeepAfterFilterAndSort(e, void 0, t);
  }
  /** @return false if store hasn't started */
  executeOnStore(e, t) {
    if (!this.started)
      return !1;
    const s = this.getRootStore();
    if (!s)
      return !0;
    const i = s.getChildStore(e);
    return i && t(i), !0;
  }
  refreshStore(e = {}) {
    const t = e.route ? e.route : [];
    this.executeOnStore(t, (s) => s.refreshStore(e.purge == !0));
  }
  getStoreState() {
    const e = [], t = this.getRootStore();
    return t && t.addStoreStates(e), e;
  }
  getNodesInRangeForSelection(e, t) {
    const s = e.rowIndex, i = t.rowIndex;
    if (s === null && i === null)
      return [];
    if (i === null)
      return e ? [e] : [];
    if (s === null)
      return [t];
    const r = [], [n, o] = [s, i].sort((a, l) => a - l);
    return this.forEachNode((a) => {
      const l = a.rowIndex;
      l == null || a.stub || l >= n && l <= o && r.push(a);
    }), r.length !== o - n + 1 ? null : r;
  }
  getRowNode(e) {
    let t;
    return this.forEachNode((s) => {
      s.id === e && (t = s), s.detailNode && s.detailNode.id === e && (t = s.detailNode);
    }), t;
  }
  isRowPresent(e) {
    return !!this.getRowNode(e.id);
  }
  setRowCount(e, t) {
    const s = this.getRootStore();
    s && s.setRowCount(e, t);
  }
  destroy() {
    this.destroyDatasource(), this.destroyRootStore(), super.destroy();
  }
};
function HU(e) {
  var t;
  return ((t = e.selectionSvc) == null ? void 0 : t.getSelectionState()) ?? null;
}
function zU(e, t) {
  var s;
  (s = e.selectionSvc) == null || s.setSelectionState(t, "api");
}
function WU(e, t) {
  var s;
  return (s = e.ssrmTxnManager) == null ? void 0 : s.applyTransaction(t);
}
function _U(e, t) {
  var r;
  const s = t.startRow ?? 0, i = t.route ?? [];
  if (s < 0) {
    I(189, { startRow: s });
    return;
  }
  (r = lo(e)) == null || r.applyRowData(t.successParams, s, i);
}
function UU(e, t, s) {
  var i;
  return (i = e.ssrmTxnManager) == null ? void 0 : i.applyTransactionAsync(t, s);
}
function $U(e) {
  var t;
  (t = lo(e)) == null || t.retryLoads();
}
function jU(e) {
  var t;
  return (t = e.ssrmTxnManager) == null ? void 0 : t.flushAsyncTransactions();
}
function KU(e, t) {
  var s;
  (s = lo(e)) == null || s.refreshStore(t);
}
function qU(e) {
  var t;
  return ((t = lo(e)) == null ? void 0 : t.getStoreState()) ?? [];
}
var YU = class extends Ub {
  constructor() {
    super(...arguments), this.beanName = "expansionSvc", this.queuedRowIds = /* @__PURE__ */ new Set();
  }
  wireBeans(e) {
    this.serverSideRowModel = e.rowModel;
  }
  postConstruct() {
    this.addManagedEventListeners({
      columnRowGroupChanged: () => {
        this.queuedRowIds.clear();
      }
    });
  }
  checkOpenByDefault(e) {
    if (!e.isExpandable())
      return;
    if (this.queuedRowIds.has(e.id)) {
      this.queuedRowIds.delete(e.id), e.setExpanded(!0);
      return;
    }
    const t = this.gos.getCallback("isServerSideGroupOpenByDefault");
    if (!t)
      return;
    const s = {
      data: e.data,
      rowNode: e
    };
    t(s) && e.setExpanded(!0);
  }
  expandRows(e) {
    e.forEach((t) => {
      const s = this.serverSideRowModel.getRowNode(t);
      s ? s.setExpanded(!0) : this.queuedRowIds.add(t);
    });
  }
  expandAll(e) {
    this.serverSideRowModel.expandAll(e);
  }
  onGroupExpandedOrCollapsed() {
  }
  dispatchExpandedEvent(e) {
    this.eventSvc.dispatchEvent(e);
  }
}, Nd = class extends L {
  constructor() {
    super(...arguments), this.selectedState = { selectAll: !1, toggledNodes: /* @__PURE__ */ new Set() }, this.selectAllUsed = !1, this.selectedNodes = {};
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.selectionSvc = e.selectionSvc;
  }
  getSelectedState() {
    return {
      selectAll: this.selectedState.selectAll,
      toggledNodes: [...this.selectedState.toggledNodes]
    };
  }
  setSelectedState(e) {
    if (typeof e != "object") {
      be(115);
      return;
    }
    if (!("selectAll" in e)) {
      be(116);
      return;
    }
    if (typeof e.selectAll != "boolean") {
      be(117);
      return;
    }
    if (!("toggledNodes" in e) || !Array.isArray(e.toggledNodes))
      return I(197);
    const t = {
      selectAll: e.selectAll,
      toggledNodes: /* @__PURE__ */ new Set()
    };
    e.toggledNodes.forEach((i) => {
      typeof i == "string" ? t.toggledNodes.add(i) : I(196, { key: i });
    });
    const s = t.selectAll || t.toggledNodes.size > 1;
    if (uh(this.gos) && !Pr(this.gos) && s) {
      I(198);
      return;
    }
    this.selectedState = t;
  }
  deleteSelectionStateFromParent(e, t) {
    if (this.selectedState.toggledNodes.size === 0)
      return !1;
    let s = !1;
    return t.forEach((i) => {
      this.selectedState.toggledNodes.delete(i) && (s = !0);
    }), s;
  }
  setNodesSelected(e) {
    const { nodes: t, clearSelection: s, newValue: i } = e;
    if (t.length === 0)
      return 0;
    const r = s && i;
    if (!Pr(this.gos) || r) {
      if (t.length > 1)
        return be(241), 0;
      const o = t[0], a = o.footer ? o.sibling : o;
      return i && a.selectable ? (this.selectedNodes = { [a.id]: a }, this.selectedState = {
        selectAll: !1,
        toggledNodes: /* @__PURE__ */ new Set([a.id])
      }) : (this.selectedNodes = {}, this.selectedState = {
        selectAll: !1,
        toggledNodes: /* @__PURE__ */ new Set()
      }), 1;
    }
    const n = (o, a = i) => {
      const l = o.footer ? o.sibling : o;
      a && l.selectable ? this.selectedNodes[l.id] = l : delete this.selectedNodes[l.id], a === this.selectedState.selectAll || !l.selectable ? this.selectedState.toggledNodes.delete(l.id) : this.selectedState.toggledNodes.add(l.id);
    };
    return t.forEach((o) => n(o)), 1;
  }
  processNewRow(e) {
    this.selectedNodes[e.id] && (this.selectedNodes[e.id] = e);
  }
  isNodeSelected(e) {
    const t = this.selectedState.toggledNodes.has(e.id);
    return this.selectedState.selectAll ? !t : t;
  }
  getSelectedNodes() {
    return this.selectAllUsed && I(199), Object.values(this.selectedNodes);
  }
  getSelectedRows() {
    return this.getSelectedNodes().map((e) => e.data);
  }
  getSelectionCount() {
    return this.selectedState.selectAll ? -1 : this.selectedState.toggledNodes.size;
  }
  isEmpty() {
    var e;
    return !this.selectedState.selectAll && !((e = this.selectedState.toggledNodes) != null && e.size);
  }
  selectAllRowNodes() {
    this.selectedState = { selectAll: !0, toggledNodes: /* @__PURE__ */ new Set() }, this.selectedNodes = {}, this.selectAllUsed = !0;
  }
  deselectAllRowNodes() {
    this.selectedState = { selectAll: !1, toggledNodes: /* @__PURE__ */ new Set() }, this.selectedNodes = {};
  }
  getSelectAllState() {
    return this.selectedState.selectAll ? this.selectedState.toggledNodes.size > 0 ? null : !0 : this.selectedState.toggledNodes.size > 0 ? null : !1;
  }
}, Hd = class extends L {
  constructor() {
    super(...arguments), this.selectedState = { selectAllChildren: !1, toggledNodes: /* @__PURE__ */ new Map() };
  }
  wireBeans(e) {
    this.rowModel = e.rowModel, this.rowGroupColsSvc = e.rowGroupColsSvc, this.filterManager = e.filterManager, this.selectionSvc = e.selectionSvc;
  }
  postConstruct() {
    this.addManagedEventListeners({
      // if model has updated, a store may now be fully loaded to clean up indeterminate states
      modelUpdated: () => this.removeRedundantState(),
      // when the grouping changes, the state no longer makes sense, so reset the state.
      columnRowGroupChanged: () => this.selectionSvc.reset("rowGroupChanged")
    });
  }
  getSelectedState() {
    const e = this.gos.get("treeData"), t = (s, i, r) => {
      var o;
      const n = {
        nodeId: r
      };
      if ((e || this.rowGroupColsSvc && i <= ((o = this.rowGroupColsSvc) == null ? void 0 : o.columns.length)) && (n.selectAllChildren = s.selectAllChildren), s.toggledNodes.size) {
        const a = [];
        s.toggledNodes.forEach((l, c) => {
          const d = t(l, i + 1, c);
          a.push(d);
        }), n.toggledNodes = a;
      }
      return n;
    };
    return t(this.selectedState, 0);
  }
  setSelectedState(e) {
    if ("selectAll" in e) {
      be(111);
      return;
    }
    const t = (s, i) => {
      var a;
      if (typeof s != "object")
        throw be(243), new Error();
      if ("selectAllChildren" in s && typeof s.selectAllChildren != "boolean")
        throw be(244), new Error();
      if ("toggledNodes" in s) {
        if (!Array.isArray(s.toggledNodes))
          throw be(245), new Error();
        if (!s.toggledNodes.every(
          (c) => typeof c == "object" && "nodeId" in c && typeof c.nodeId == "string"
        ))
          throw be(246), new Error();
      }
      const r = s.selectAllChildren ?? !i, n = (a = s.toggledNodes) == null ? void 0 : a.map((l) => [
        l.nodeId,
        t(l, r)
      ]);
      if (n == null ? void 0 : n.some(
        ([, l]) => r === l.selectAllChildren && l.toggledNodes.size === 0
      ))
        throw be(247), new Error();
      return {
        selectAllChildren: r,
        toggledNodes: new Map(n)
      };
    };
    try {
      this.selectedState = t(e, !!e.selectAllChildren);
    } catch {
    }
  }
  deleteSelectionStateFromParent(e, t) {
    let s = this.selectedState;
    const i = [...e];
    for (; s && i.length; )
      s = s.toggledNodes.get(i.pop());
    if (!s)
      return !1;
    let r = !1;
    return t.forEach((n) => {
      s != null && s.toggledNodes.delete(n) && (r = !0);
    }), r && this.removeRedundantState(), r;
  }
  setNodesSelected({ nodes: e, newValue: t, clearSelection: s }) {
    if (e.length === 0)
      return 0;
    const i = s && t;
    if (!Pr(this.gos) || i) {
      if (e.length > 1)
        return be(241), 0;
      this.deselectAllRowNodes();
    }
    return e.forEach((r) => {
      const n = r.footer ? r.sibling : r, o = this.getRouteToNode(n);
      this.recursivelySelectNode(o, this.selectedState, t);
    }), this.removeRedundantState(), 1;
  }
  isNodeSelected(e) {
    const t = this.getRouteToNode(e);
    return this.isNodePathSelected(t, this.selectedState);
  }
  isNodePathSelected([e, ...t], s) {
    if (t.length === 0) {
      const i = s.toggledNodes.has(e.id);
      if (e.hasChildren()) {
        const r = s.toggledNodes.get(e.id);
        if (r && r.toggledNodes.size)
          return;
      }
      return s.selectAllChildren ? !i : i;
    }
    if (s.toggledNodes.has(e.id)) {
      const i = s.toggledNodes.get(e.id);
      if (i)
        return this.isNodePathSelected(t, i);
    }
    return s.selectAllChildren;
  }
  getRouteToNode(e) {
    const t = [];
    let s = e;
    for (; s.parent; )
      t.push(s), s = s.parent;
    return t.reverse();
  }
  removeRedundantState() {
    var t;
    if ((t = this.filterManager) != null && t.isAnyFilterPresent())
      return;
    const e = (s = this.selectedState, i, r) => {
      if (s.toggledNodes.forEach((a, l) => {
        e(a, l, s);
      }), i) {
        const a = this.rowModel.getRowNode(i), l = a == null ? void 0 : a.childStore;
        if ((l == null ? void 0 : l.isLastRowIndexKnown()) && s.toggledNodes.size >= l.getRowCount()) {
          for (const u of s.toggledNodes.entries()) {
            const [h, p] = u;
            if (p.toggledNodes.size > 0 || !this.rowModel.getRowNode(h))
              return;
          }
          s.selectAllChildren = !s.selectAllChildren, s.toggledNodes.clear();
        }
      }
      const n = s.toggledNodes.size === 0, o = (r == null ? void 0 : r.selectAllChildren) === s.selectAllChildren;
      n && o && (r == null || r.toggledNodes.delete(i));
    };
    e();
  }
  recursivelySelectNode([e, ...t], s, i) {
    if (!e)
      return;
    if (!t.length) {
      const a = e.selectable;
      if (s.selectAllChildren === i || !a) {
        s.toggledNodes.delete(e.id);
        return;
      }
      const c = {
        selectAllChildren: i,
        toggledNodes: /* @__PURE__ */ new Map()
      };
      s.toggledNodes.set(e.id, c);
      return;
    }
    const n = s.toggledNodes.has(e.id), o = s.toggledNodes.get(e.id) ?? {
      selectAllChildren: s.selectAllChildren,
      toggledNodes: /* @__PURE__ */ new Map()
    };
    n || s.toggledNodes.set(e.id, o), this.recursivelySelectNode(t, o, i), s.selectAllChildren === o.selectAllChildren && o.toggledNodes.size === 0 && s.toggledNodes.delete(e.id);
  }
  getSelectedNodes() {
    I(202);
    const e = [];
    return this.rowModel.forEachNode((t) => {
      t.isSelected() && e.push(t);
    }), e;
  }
  processNewRow() {
  }
  getSelectedRows() {
    return this.getSelectedNodes().map((e) => e.data);
  }
  getSelectionCount() {
    return -1;
  }
  isEmpty() {
    var e;
    return !this.selectedState.selectAllChildren && !((e = this.selectedState.toggledNodes) != null && e.size);
  }
  selectAllRowNodes() {
    this.selectedState = { selectAllChildren: !0, toggledNodes: /* @__PURE__ */ new Map() };
  }
  deselectAllRowNodes() {
    this.selectedState = { selectAllChildren: !1, toggledNodes: /* @__PURE__ */ new Map() };
  }
  getSelectAllState() {
    return this.selectedState.selectAllChildren ? this.selectedState.toggledNodes.size > 0 ? null : !0 : this.selectedState.toggledNodes.size > 0 ? null : !1;
  }
}, XU = class extends zw {
  constructor() {
    super(...arguments), this.beanName = "selectionSvc";
  }
  postConstruct() {
    super.postConstruct(), this.addManagedPropertyListeners(["groupSelectsChildren", "rowSelection"], () => {
      const s = mn(this.gos), i = s && this.selectionStrategy instanceof Nd ? Hd : !s && this.selectionStrategy instanceof Hd ? Nd : void 0;
      i && (this.destroyBean(this.selectionStrategy), this.selectionStrategy = this.createManagedBean(new i()), this.shotgunResetNodeSelectionState(), this.dispatchSelectionChanged("api"));
    }), this.addManagedPropertyListeners(["rowSelection"], () => {
      const s = Zn(this.gos);
      s !== this.selectionMode && (this.selectionMode = s, this.deselectAllRowNodes({ source: "api" }));
    }), this.selectionMode = Zn(this.gos);
    const t = mn(this.gos) ? Hd : Nd;
    this.selectionStrategy = this.createManagedBean(new t());
  }
  handleSelectionEvent(e, t, s) {
    if (this.isRowSelectionBlocked(t))
      return 0;
    let i = 0;
    const r = this.inferNodeSelections(t, e.shiftKey, e.metaKey || e.ctrlKey, s);
    return r == null ? 0 : ("select" in r ? (r.reset ? this.selectionStrategy.deselectAllRowNodes({ source: "api" }) : this.selectionStrategy.setNodesSelected({ nodes: r.deselect, newValue: !1, source: s }), i = this.selectionStrategy.setNodesSelected({ nodes: r.select, newValue: !0, source: s })) : i = this.selectionStrategy.setNodesSelected({
      nodes: [r.node],
      newValue: r.newValue,
      clearSelection: r.clearSelection,
      event: e,
      source: s
    }), this.shotgunResetNodeSelectionState(), this.dispatchSelectionChanged(s), i);
  }
  getSelectionState() {
    return this.selectionStrategy.getSelectedState();
  }
  setSelectionState(e, t) {
    if (!Es(this.gos)) {
      I(132);
      return;
    }
    Array.isArray(e) || (this.selectionStrategy.setSelectedState(e), this.shotgunResetNodeSelectionState(), this.dispatchSelectionChanged(t));
  }
  setNodesSelected(e) {
    if (!Es(this.gos) && e.newValue)
      return I(132), 0;
    const { nodes: t, ...s } = e;
    if (t.length > 1 && this.selectionMode !== "multiRow")
      return I(130), 0;
    const i = {
      nodes: t.filter((n) => n.selectable),
      ...s
    };
    if (!i.nodes.length)
      return 0;
    const r = this.selectionStrategy.setNodesSelected(i);
    return this.shotgunResetNodeSelectionState(i.source), this.dispatchSelectionChanged(i.source), r;
  }
  /**
   * Deletes the selection state for a set of nodes, for use after deleting nodes via
   * transaction. As this is designed for transactions, all nodes should belong to the same group.
   */
  deleteSelectionStateFromParent(e, t) {
    this.selectionStrategy.deleteSelectionStateFromParent(e, t) && (this.shotgunResetNodeSelectionState(), this.dispatchSelectionChanged("api"));
  }
  shotgunResetNodeSelectionState(e) {
    this.beans.rowModel.forEachNode((t) => {
      if (t.stub)
        return;
      const s = this.selectionStrategy.isNodeSelected(t);
      s !== t.isSelected() && this.selectRowNode(t, s, void 0, e);
    });
  }
  getSelectedNodes() {
    return this.selectionStrategy.getSelectedNodes();
  }
  getSelectedRows() {
    return this.selectionStrategy.getSelectedRows();
  }
  getSelectionCount() {
    return this.selectionStrategy.getSelectionCount();
  }
  syncInRowNode(e) {
    this.selectionStrategy.processNewRow(e);
    const t = this.selectionStrategy.isNodeSelected(e);
    if (t != !1 && !e.selectable) {
      this.selectionStrategy.setNodesSelected({
        nodes: [e],
        newValue: !1,
        source: "api"
      }), this.shotgunResetNodeSelectionState(), this.dispatchSelectionChanged("api");
      return;
    }
    e.__selected = t;
  }
  reset() {
    this.selectionStrategy.deselectAllRowNodes({ source: "api" }), this.selectionCtx.reset();
  }
  isEmpty() {
    return this.selectionStrategy.isEmpty();
  }
  hasNodesToSelect() {
    return !0;
  }
  selectAllRowNodes(e) {
    if (!Es(this.gos)) {
      I(132);
      return;
    }
    if (sm(e), uh(this.gos) && !Pr(this.gos))
      return I(130);
    this.selectionStrategy.selectAllRowNodes(e), this.selectionCtx.reset(), this.beans.rowModel.forEachNode((t) => {
      t.stub || this.selectRowNode(t, !0, void 0, e.source);
    }), this.dispatchSelectionChanged(e.source);
  }
  deselectAllRowNodes(e) {
    sm(e), this.selectionStrategy.deselectAllRowNodes(e), this.selectionCtx.reset(), this.beans.rowModel.forEachNode((t) => {
      t.stub || this.selectRowNode(t, !1, void 0, e.source);
    }), this.dispatchSelectionChanged(e.source);
  }
  getSelectAllState(e) {
    return this.selectionStrategy.getSelectAllState(e);
  }
  // used by CSRM
  getBestCostNodeSelection() {
    return I(194, { method: "getBestCostNodeSelection" });
  }
  /**
   * Updates the selectable state for a node by invoking isRowSelectable callback.
   * If the node is not selectable, it will be deselected.
   *
   * Callers:
   *  - property isRowSelectable changed
   *  - after grouping / treeData
   */
  updateSelectable() {
    if (!Es(this.gos))
      return;
    const e = [];
    this.beans.rowModel.forEachNode((t) => {
      !this.updateRowSelectable(t, !0) && t.isSelected() && e.push(t);
    }), e.length && this.setNodesSelected({
      nodes: e,
      newValue: !1,
      source: "selectableChanged"
    });
  }
  updateSelectableAfterGrouping() {
    return be(194, { method: "updateSelectableAfterGrouping" });
  }
};
function sm({ selectAll: e }) {
  (e === "filtered" || e === "currentPage") && I(195, { justCurrentPage: e === "currentPage" });
}
var ZU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "rowChildrenSvc";
  }
  getHasChildrenValue(e) {
    const t = this.gos.get("treeData"), s = this.gos.get("isServerSideGroup");
    return !e.stub && !e.footer && (t ? !!s && s(e.data) : !!e.group);
  }
}, QU = class extends L {
  constructor() {
    super(...arguments), this.beanName = "lazyBlockLoadingSvc", this.outboundRequests = 0, this.cacheLoadingNodesMap = /* @__PURE__ */ new Map(), this.isCheckQueued = !1, this.nextBlockToLoad = void 0;
  }
  wireBeans(e) {
    this.rowRenderer = e.rowRenderer, this.rowModel = e.rowModel;
  }
  postConstruct() {
    this.maxOutboundRequests = yv(this.gos);
  }
  subscribe(e) {
    this.cacheLoadingNodesMap.set(e, /* @__PURE__ */ new Set());
  }
  unsubscribe(e) {
    this.cacheLoadingNodesMap.delete(e);
  }
  /**
   * Queues a microtask to check if any blocks need to be loaded.
   */
  queueLoadCheck() {
    this.isCheckQueued || (this.isCheckQueued = !0, window.queueMicrotask(() => {
      this.queueLoadAction(), this.isCheckQueued = !1;
    }));
  }
  onLoadComplete() {
    this.outboundRequests -= 1, this.queueLoadCheck();
  }
  hasAvailableLoadBandwidth() {
    return this.maxOutboundRequests === void 0 ? !0 : this.outboundRequests < this.maxOutboundRequests;
  }
  queueLoadAction() {
    const e = this.getBlockToLoad();
    if (!e)
      return;
    const t = this.nextBlockToLoad && this.nextBlockToLoad.cache === e.cache && this.nextBlockToLoad.index === e.index;
    if (!t && (!this.nextBlockToLoad || !t)) {
      this.nextBlockToLoad = e, window.clearTimeout(this.loaderTimeout);
      const s = Number(this.nextBlockToLoad.index), i = this.nextBlockToLoad.cache, r = e.index + e.cache.getBlockSize();
      this.loaderTimeout = window.setTimeout(() => {
        i.isAlive() && (this.loaderTimeout = void 0, this.attemptLoad(i, s, r), this.nextBlockToLoad = void 0);
      }, this.gos.get("blockLoadDebounceMillis"));
    }
  }
  attemptLoad(e, t, s) {
    this.hasAvailableLoadBandwidth() && (this.executeLoad(e, t, s), this.queueLoadCheck());
  }
  executeLoad(e, t, s) {
    var u;
    const i = e.getSsrmParams(), r = {
      startRow: t,
      endRow: s,
      rowGroupCols: i.rowGroupCols,
      valueCols: i.valueCols,
      pivotCols: i.pivotCols,
      pivotMode: i.pivotMode,
      groupKeys: e.store.getParentNode().getRoute() ?? [],
      filterModel: i.filterModel,
      sortModel: i.sortModel
    }, n = this.cacheLoadingNodesMap.get(e), o = () => {
      for (let h = 0; h < s - t; h++)
        n.delete(t + h);
    }, a = () => {
      for (let h = 0; h < s - t; h++)
        n.add(t + h);
    }, l = (h) => {
      this.onLoadComplete(), e.onLoadSuccess(t, s - t, h), o();
    }, c = () => {
      this.onLoadComplete(), e.onLoadFailed(t, s - t), o();
    }, d = this.gos.addGridCommonParams({
      request: r,
      success: l,
      fail: c,
      parentNode: e.store.getParentNode()
    });
    a(), this.outboundRequests += 1, (u = e.getSsrmParams().datasource) == null || u.getRows(d);
  }
  getBlockToLoad() {
    var a, l;
    const e = this.rowRenderer.firstRenderedRow, t = this.rowRenderer.lastRenderedRow;
    for (let c = e; c <= t; c++) {
      const d = this.rowModel.getRow(c);
      if (!d)
        continue;
      const u = (a = d.parent) == null ? void 0 : a.childStore;
      if (!u)
        continue;
      const h = u.getCache(), p = h.getNodes().getBy("node", d);
      if (!p)
        continue;
      const g = this.cacheLoadingNodesMap.get(h);
      if (!(g != null && g.has(p.index)) && (d.__needsRefreshWhenVisible || d.stub && !d.failedLoad))
        return {
          cache: h,
          index: h.getBlockStartIndex(p.index)
        };
    }
    let s = null, i = null, r = Number.MAX_SAFE_INTEGER;
    for (const c of this.cacheLoadingNodesMap.keys())
      c.getNodesToRefresh().forEach((u) => {
        if (u.rowIndex == null) {
          i = u, s = c;
          return;
        }
        const h = c.getNodes().getBy("node", u);
        if (!h)
          return;
        const p = this.cacheLoadingNodesMap.get(c);
        if (p != null && p.has(h.index))
          return;
        const g = Math.abs(e - u.rowIndex), f = Math.abs(u.rowIndex - t);
        g < r && (i = u, r = g, s = c), f < r && (i = u, r = f, s = c);
      });
    if (!s)
      return;
    const n = s, o = (l = n.getNodes().getBy("node", i)) == null ? void 0 : l.index;
    return o == null ? void 0 : {
      cache: n,
      index: n.getBlockStartIndex(o)
    };
  }
  isRowLoading(e, t) {
    var s;
    return ((s = this.cacheLoadingNodesMap.get(e)) == null ? void 0 : s.has(t)) ?? !1;
  }
}, JU = class {
  constructor(...e) {
    this.indexes = e, this.maps = new Map(this.indexes.map((t) => [t, /* @__PURE__ */ new Map()]));
  }
  getSize() {
    return this.maps.get(this.indexes[0]).size;
  }
  getBy(e, t) {
    return this.maps.get(e).get(t);
  }
  set(e) {
    this.indexes.forEach((t) => {
      this.maps.get(t).set(e[t], e);
    });
  }
  delete(e) {
    this.indexes.forEach((t) => {
      this.maps.get(t).delete(e[t]);
    });
  }
  clear() {
    this.maps.forEach((e) => e.clear());
  }
  getIterator(e) {
    return this.maps.get(e).values();
  }
  forEach(e) {
    const t = this.getIterator(this.indexes[0]);
    let s;
    for (; (s = t.next()) && !s.done; )
      e(s.value);
  }
  find(e) {
    const t = this.getIterator(this.indexes[0]);
    let s;
    for (; (s = t.next()) && !s.done; )
      if (e(s.value))
        return s.value;
  }
  filter(e) {
    const t = this.getIterator(this.indexes[0]);
    let s;
    const i = [];
    for (; (s = t.next()) && !s.done; )
      e(s.value) && i.push(s.value);
    return i;
  }
}, e$ = 100, zd = class extends L {
  constructor(e, t, s, i) {
    super(), this.live = !0, this.removedNodeCache = /* @__PURE__ */ new Map(), this.store = e, this.numberOfRows = t, this.isLastRowKnown = s, this.storeParams = i;
  }
  wireBeans(e) {
    this.rowRenderer = e.rowRenderer, this.blockUtils = e.ssrmBlockUtils, this.focusSvc = e.focusSvc, this.nodeManager = e.ssrmNodeManager, this.serverSideRowModel = e.rowModel, this.rowNodeSorter = e.rowNodeSorter, this.sortSvc = e.sortSvc, this.lazyBlockLoadingSvc = e.lazyBlockLoadingSvc, this.colModel = e.colModel;
  }
  postConstruct() {
    this.lazyBlockLoadingSvc.subscribe(this), this.nodeMap = new JU("index", "id", "node"), this.nodeDisplayIndexMap = /* @__PURE__ */ new Map(), this.nodesToRefresh = /* @__PURE__ */ new Set(), this.defaultNodeIdPrefix = this.blockUtils.createNodeIdPrefix(this.store.getParentNode()), this.getRowIdFunc = _i(this.gos), this.isMasterDetail = this.gos.get("masterDetail");
  }
  destroy() {
    this.lazyBlockLoadingSvc.unsubscribe(this), this.numberOfRows = 0, this.nodeMap.forEach((e) => this.blockUtils.destroyRowNode(e.node)), this.nodeMap.clear(), this.nodeDisplayIndexMap.clear(), this.nodesToRefresh.clear(), this.live = !1, super.destroy();
  }
  /**
   * Get the row node for a specific display index from this store
   * @param displayIndex the display index of the node to find
   * @returns undefined if the node is not in the store bounds, otherwise will always return a node
   */
  getRowByDisplayIndex(e) {
    var l, c, d, u, h;
    if (!this.store.isDisplayIndexInStore(e))
      return;
    const t = this.nodeDisplayIndexMap.get(e);
    if (t)
      return (t.stub || t.__needsRefreshWhenVisible) && this.lazyBlockLoadingSvc.queueLoadCheck(), t;
    if (this.gos.get("groupHideOpenParents") || this.gos.get("groupAllowUnbalanced")) {
      const p = this.nodeMap.find(
        (g) => {
          var f;
          return !!((f = g.node.childStore) != null && f.isDisplayIndexInStore(e));
        }
      );
      if (p)
        return (l = p.node.childStore) == null ? void 0 : l.getRowUsingDisplayIndex(e);
    }
    if (e === this.store.getDisplayIndexStart())
      return this.createStubNode(0, e);
    const i = this.nodeDisplayIndexMap.get(e - 1);
    if (i) {
      if (this.isMasterDetail && i.master && i.expanded)
        return i.detailNode;
      if (i.expanded && ((c = i.childStore) != null && c.isDisplayIndexInStore(e)))
        return (d = i.childStore) == null ? void 0 : d.getRowUsingDisplayIndex(
          e
        );
      const p = this.nodeMap.getBy("node", i);
      return this.createStubNode(p.index + 1, e);
    }
    const r = this.getSurroundingNodesByDisplayIndex(e);
    if (r == null) {
      const p = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - e);
      return this.createStubNode(p, e);
    }
    const { previousNode: n, nextNode: o } = r;
    if (n && n.node.expanded && ((u = n.node.childStore) != null && u.isDisplayIndexInStore(e)))
      return (h = n.node.childStore) == null ? void 0 : h.getRowUsingDisplayIndex(e);
    if (o) {
      const p = o.node.rowIndex - e, g = o.index - p;
      return this.createStubNode(g, e);
    }
    const a = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - e);
    return this.createStubNode(a, e);
  }
  /**
   * Used for creating and positioning a stub node without firing a store updated event
   */
  createStubNode(e, t) {
    const s = this.store.getRowBounds(t), i = this.createRowAtIndex(e, null, (r) => {
      r.setRowIndex(t), r.setRowTop(s.rowTop), this.nodeDisplayIndexMap.set(t, r);
    });
    if (e === 0 && this.gos.get("groupHideOpenParents")) {
      const r = this.store.getParentNode().groupData;
      if (r)
        for (const n of Object.keys(r))
          jl(i, this.colModel, n, r[n]);
    }
    return this.lazyBlockLoadingSvc.queueLoadCheck(), i;
  }
  /**
   * @param index The row index relative to this store
   * @returns A rowNode at the given store index
   */
  getRowByStoreIndex(e) {
    var t;
    return (t = this.nodeMap.getBy("index", e)) == null ? void 0 : t.node;
  }
  /**
   * Given a number of rows, skips through the given sequence & row top reference (using default row height)
   * @param numberOfRowsToSkip number of rows to skip over in the given sequence
   * @param displayIndexSeq the sequence in which to skip
   * @param nextRowTop the row top reference in which to skip
   */
  skipDisplayIndexes(e, t, s) {
    if (e === 0)
      return;
    const i = vs(this.beans);
    t.value += e, s.value += e * i;
  }
  /**
   * @param displayIndexSeq the number sequence for generating the display index of each row
   * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
   */
  setDisplayIndexes(e, t, s) {
    this.nodeDisplayIndexMap.clear();
    const i = {};
    this.nodeMap.forEach((o) => {
      i[o.index] = o.node;
    });
    let r = -1;
    for (const o of Object.keys(i)) {
      const a = i[o], l = Number(o), c = l - 1 - r;
      this.skipDisplayIndexes(c, e, t);
      const d = l === 0;
      if (a.setFirstChild(d), d && this.gos.get("groupHideOpenParents")) {
        const u = this.store.getParentNode().groupData;
        if (u)
          for (const h of Object.keys(u))
            jl(a, this.colModel, h, d ? u[h] : void 0);
      }
      this.blockUtils.setDisplayIndex(a, e, t, s), a.rowIndex != null && this.nodeDisplayIndexMap.set(a.rowIndex, a), r = l;
    }
    const n = this.numberOfRows - 1 - r;
    this.skipDisplayIndexes(n, e, t), this.purgeExcessRows();
  }
  getRowCount() {
    return this.numberOfRows;
  }
  setRowCount(e, t) {
    this.numberOfRows = e, t != null && (this.isLastRowKnown = t, t === !1 && (this.numberOfRows += 1)), this.fireStoreUpdatedEvent();
  }
  getNodes() {
    return this.nodeMap;
  }
  getNodeCachedByDisplayIndex(e) {
    return this.nodeDisplayIndexMap.get(e) ?? null;
  }
  getNodesToRefresh() {
    return this.nodesToRefresh;
  }
  /**
   * @returns the previous and next loaded row nodes surrounding the given display index
   */
  getSurroundingNodesByDisplayIndex(e) {
    let t, s;
    return this.nodeMap.forEach((i) => {
      if (e > i.node.rowIndex) {
        (s == null || s.node.rowIndex < i.node.rowIndex) && (s = i);
        return;
      }
      if (t == null || t.node.rowIndex > i.node.rowIndex) {
        t = i;
        return;
      }
    }), !s && !t ? null : { previousNode: s, nextNode: t };
  }
  /**
   * Get or calculate the display index for a given store index
   * @param storeIndex the rows index within this store
   * @returns the rows visible display index relative to the grid
   */
  getDisplayIndexFromStoreIndex(e) {
    var o;
    const t = this.nodeMap.getBy("index", e);
    if (t)
      return t.node.rowIndex;
    let s, i;
    if (this.nodeMap.forEach((a) => {
      if (e > a.index) {
        (i == null || i.index < a.index) && (i = a);
        return;
      }
      if (s == null || s.index > a.index) {
        s = a;
        return;
      }
    }), !s)
      return this.store.getDisplayIndexEnd() - (this.numberOfRows - e);
    if (!i)
      return this.store.getDisplayIndexStart() + e;
    const r = e - i.index;
    return (((o = i.node.childStore) == null ? void 0 : o.getDisplayIndexEnd()) ?? i.node.rowIndex) + r;
  }
  /**
   * Creates a new row and inserts it at the given index
   * @param atStoreIndex the node index relative to this store
   * @param data the data object to populate the node with
   * @returns the new row node
   */
  createRowAtIndex(e, t, s) {
    var n, o;
    const i = this.nodeMap.getBy("index", e);
    if (i) {
      const { node: a } = i;
      if (a.__needsRefreshWhenVisible = !1, this.doesNodeMatch(t, a))
        return this.blockUtils.updateDataIntoRowNode(a, t), this.nodesToRefresh.delete(a), a;
      if (this.getRowIdFunc == null && a.hasChildren() && a.expanded)
        return this.nodesToRefresh.delete(a), a;
      this.destroyRowAtIndex(e);
    }
    if (t && this.getRowIdFunc != null) {
      const a = this.getRowId(t), l = a && ((n = this.removedNodeCache) == null ? void 0 : n.get(a));
      if (l)
        return (o = this.removedNodeCache) == null || o.delete(a), this.blockUtils.updateDataIntoRowNode(l, t), this.nodeMap.set({
          id: l.id,
          node: l,
          index: e
        }), this.nodesToRefresh.delete(l), l.__needsRefreshWhenVisible = !1, l;
      const c = this.nodeMap.getBy("id", a);
      if (c) {
        this.nodeMap.delete(c);
        const { node: d, index: u } = c;
        return this.blockUtils.updateDataIntoRowNode(d, t), this.nodeMap.set({
          id: d.id,
          node: d,
          index: e
        }), this.nodesToRefresh.delete(d), d.__needsRefreshWhenVisible = !1, this.getBlockStartIndex(u) === this.getBlockStartIndex(e) || this.markBlockForVerify(u), d;
      }
    }
    const r = this.blockUtils.createRowNode(this.store.getRowDetails());
    if (t != null) {
      const a = this.getPrefixedId(this.store.getIdSequence().value++);
      this.blockUtils.setDataIntoRowNode(r, t, a, void 0), this.serverSideRowModel.setPaused(!0), this.blockUtils.checkOpenByDefault(r), this.serverSideRowModel.setPaused(!1), this.nodeManager.addRowNode(r);
    }
    return this.nodeMap.set({
      id: r.id,
      node: r,
      index: e
    }), s && s(r), r;
  }
  getBlockStates() {
    const e = {}, t = {};
    this.nodeMap.forEach(({ node: n, index: o }) => {
      const a = this.getBlockStartIndex(o);
      !n.stub && !n.failedLoad && (e[a] = (e[a] ?? 0) + 1);
      let l = "loaded";
      n.failedLoad ? l = "failed" : this.lazyBlockLoadingSvc.isRowLoading(this, a) ? l = "loading" : (this.nodesToRefresh.has(n) || n.stub) && (l = "needsLoading"), t[a] || (t[a] = /* @__PURE__ */ new Set()), t[a].add(l);
    });
    const s = {
      loading: 4,
      failed: 3,
      needsLoading: 2,
      loaded: 1
    }, i = this.blockUtils.createNodeIdPrefix(this.store.getParentNode()), r = {};
    return Object.entries(t).forEach(([n, o]) => {
      const l = [...o].sort(
        (u, h) => (s[u] ?? 0) - (s[h] ?? 0)
      )[0], c = Number(n) / this.getBlockSize(), d = i ? `${i}-${c}` : String(c);
      r[d] = {
        blockNumber: c,
        startRow: Number(n),
        endRow: Number(n) + this.getBlockSize(),
        pageStatus: l,
        loadedRowCount: e[n] ?? 0
      };
    }), r;
  }
  destroyRowAtIndex(e) {
    const t = this.nodeMap.getBy("index", e);
    t && (this.nodeMap.delete(t), this.nodeDisplayIndexMap.delete(t.node.rowIndex), this.nodesToRefresh.size > 0 ? this.removedNodeCache.set(t.node.id, t.node) : this.blockUtils.destroyRowNode(t.node), this.nodesToRefresh.delete(t.node));
  }
  getSsrmParams() {
    return this.store.getSsrmParams();
  }
  /**
   * @param id the base id to be prefixed
   * @returns a node id with prefix if required
   */
  getPrefixedId(e) {
    return this.defaultNodeIdPrefix ? this.defaultNodeIdPrefix + "-" + e : e.toString();
  }
  markBlockForVerify(e) {
    const [t, s] = this.getBlockBounds(e);
    this.nodeMap.filter((r) => r.index >= t && r.index < s).forEach(({ node: r }) => {
      r.__needsRefreshWhenVisible = !0;
    });
  }
  doesNodeMatch(e, t) {
    if (t.stub)
      return !1;
    const s = this.getRowId(e);
    return s === null ? t.data === e : t.id === s;
  }
  /**
   * Deletes any stub nodes not within the given range
   */
  purgeStubsOutsideOfViewport() {
    const { firstRenderedRow: e, lastRenderedRow: t } = this.rowRenderer, s = this.getBlockStartIndex(e), [, i] = this.getBlockBounds(t);
    this.nodeMap.forEach((r) => {
      this.lazyBlockLoadingSvc.isRowLoading(this, r.index) || r.node.failedLoad || r.node.stub && (r.index < s || r.index > i) && this.destroyRowAtIndex(r.index);
    });
  }
  getBlocksDistanceFromRow(e, t) {
    const s = {};
    return e.forEach(({ node: i, index: r }) => {
      const [n, o] = this.getBlockBounds(r);
      if (n in s)
        return;
      const a = Math.abs(i.rowIndex - t);
      let l;
      const c = this.nodeMap.getBy("index", [o - 1]);
      c && (l = Math.abs(c.node.rowIndex - t));
      const d = l == null || a < l ? a : l;
      s[n] = d;
    }), Object.entries(s);
  }
  purgeExcessRows() {
    if (this.purgeStubsOutsideOfViewport(), this.store.getDisplayIndexEnd() == null || this.storeParams.maxBlocksInCache == null)
      return;
    const { firstRenderedRow: e, lastRenderedRow: t } = this.rowRenderer, s = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set();
    this.nodeMap.forEach(({ index: p, node: g }) => {
      const f = this.getBlockStartIndex(p);
      s.add(f), g.rowIndex >= e && g.rowIndex <= t && i.add(f);
    });
    const r = Math.max(i.size, this.storeParams.maxBlocksInCache ?? 0), o = s.size - r;
    if (o <= 0)
      return;
    let a = Number.MAX_SAFE_INTEGER, l = Number.MIN_SAFE_INTEGER;
    i.forEach((p) => {
      a > p && (a = p), l < p && (l = p);
    });
    const c = this.nodeMap.filter(({ node: p, index: g }) => {
      const f = this.getBlockStartIndex(g);
      return !(f >= a && f <= l) && !this.isNodeCached(p);
    });
    if (c.length === 0)
      return;
    const d = e + (t - e) / 2, u = this.getBlocksDistanceFromRow(c, d), h = this.getBlockSize();
    u.sort((p, g) => Math.sign(g[1] - p[1]));
    for (let p = 0; p < Math.min(o, u.length); p++) {
      const g = Number(u[p][0]);
      for (let f = g; f < g + h; f++) {
        const m = this.nodeMap.getBy("index", f);
        !m || this.isNodeCached(m.node) || this.destroyRowAtIndex(f);
      }
    }
  }
  isNodeFocused(e) {
    const t = this.focusSvc.getFocusCellToUseAfterRefresh();
    return !t || t.rowPinned != null ? !1 : t.rowIndex === e.rowIndex;
  }
  isNodeCached(e) {
    const t = this.gos.get("groupAllowUnbalanced") && e.key === "";
    return e.isExpandable() && e.expanded || this.isNodeFocused(e) || t;
  }
  extractDuplicateIds(e) {
    if (this.getRowIdFunc == null)
      return [];
    const t = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
    return e.forEach((i) => {
      const r = this.getRowId(i);
      if (t.has(r)) {
        s.add(r);
        return;
      }
      t.add(r);
    }), [...s];
  }
  onLoadSuccess(e, t, s) {
    if (!this.live)
      return;
    const i = s.groupLevelInfo;
    if (this.store.setStoreInfo(i), this.getRowIdFunc != null) {
      const o = this.extractDuplicateIds(s.rowData);
      if (o.length > 0) {
        const a = o.join(", ");
        I(205, { duplicateIdText: a }), this.onLoadFailed(e, t);
        return;
      }
    }
    s.pivotResultFields && this.serverSideRowModel.generateSecondaryColumns(s.pivotResultFields);
    const r = this.nodesToRefresh.size > 0;
    if (s.rowData.forEach((o, a) => {
      var d;
      const l = e + a, c = this.nodeMap.getBy("index", l);
      if ((d = c == null ? void 0 : c.node) != null && d.stub) {
        this.createRowAtIndex(l, o);
        return;
      }
      if (c && this.doesNodeMatch(o, c.node)) {
        this.blockUtils.updateDataIntoRowNode(c.node, o), this.nodesToRefresh.delete(c.node), c.node.__needsRefreshWhenVisible = !1;
        return;
      }
      this.createRowAtIndex(l, o);
    }), s.rowCount != null && s.rowCount !== -1)
      this.numberOfRows = s.rowCount, this.isLastRowKnown = !0;
    else if (t > s.rowData.length)
      this.numberOfRows = e + s.rowData.length, this.isLastRowKnown = !0;
    else if (!this.isLastRowKnown) {
      const o = e + s.rowData.length + 1;
      o > this.numberOfRows && (this.numberOfRows = o);
    }
    this.isLastRowKnown && this.nodeMap.filter((a) => a.index >= this.numberOfRows).forEach((a) => this.destroyRowAtIndex(a.index)), this.fireStoreUpdatedEvent();
    const n = this.nodesToRefresh.size === 0;
    r && n && this.fireRefreshFinishedEvent();
  }
  fireRefreshFinishedEvent() {
    this.nodesToRefresh.size === 0 && (this.removedNodeCache.forEach((t) => {
      this.blockUtils.destroyRowNode(t);
    }), this.removedNodeCache = /* @__PURE__ */ new Map(), this.store.fireRefreshFinishedEvent());
  }
  /**
   * @returns true if all rows are loaded
   */
  isStoreFullyLoaded() {
    const e = this.isLastRowKnown, t = this.nodeMap.getSize() === this.numberOfRows;
    if (!e || !t || this.nodesToRefresh.size > 0)
      return;
    let s = -1;
    return this.nodeMap.find((r) => (s += 1, !!(r.index !== s || r.node.__needsRefreshWhenVisible || r.node.stub))) == null;
  }
  isLastRowIndexKnown() {
    return this.isLastRowKnown;
  }
  onLoadFailed(e, t) {
    if (!this.live)
      return;
    const s = this.nodesToRefresh.size > 0;
    for (let r = e; r < e + t && r < this.getRowCount(); r++) {
      let { node: n } = this.nodeMap.getBy("index", r) ?? {};
      n && this.nodesToRefresh.delete(n), (!n || !n.stub) && (n && !n.stub && this.destroyRowAtIndex(r), n = this.createRowAtIndex(r)), n.__needsRefreshWhenVisible = !1, n.failedLoad = !0;
    }
    const i = this.nodesToRefresh.size === 0;
    s && i && this.fireRefreshFinishedEvent(), this.fireStoreUpdatedEvent();
  }
  markNodesForRefresh() {
    this.nodeMap.forEach((e) => {
      e.node.stub && !e.node.failedLoad || this.nodesToRefresh.add(e.node);
    }), this.lazyBlockLoadingSvc.queueLoadCheck(), this.isLastRowKnown && this.numberOfRows === 0 && (this.numberOfRows = 1, this.isLastRowKnown = !1, this.fireStoreUpdatedEvent());
  }
  isNodeInCache(e) {
    return !!this.nodeMap.getBy("id", e);
  }
  // gets called 1) row count changed 2) cache purged 3) items inserted
  fireStoreUpdatedEvent() {
    this.live && this.store.fireStoreUpdatedEvent();
  }
  getRowId(e) {
    if (this.getRowIdFunc == null)
      return null;
    const { level: t } = this.store.getRowDetails(), s = this.store.getParentNode().getRoute() ?? [];
    return this.getRowIdFunc({
      data: e,
      parentKeys: s.length > 0 ? s : void 0,
      level: t
    });
  }
  getOrderedNodeMap() {
    const e = {};
    return this.nodeMap.forEach((t) => e[t.index] = t), e;
  }
  clearDisplayIndexes() {
    this.nodeDisplayIndexMap.clear();
  }
  /**
   * Client side sorting
   */
  clientSideSortRows() {
    var r;
    const e = ((r = this.sortSvc) == null ? void 0 : r.getSortOptions()) ?? [];
    if (!e.some((n) => n.sort != null) || !this.rowNodeSorter)
      return;
    const s = new Array(this.nodeMap.getSize());
    this.nodeMap.forEach((n) => s[n.index] = n.node), this.nodeMap.clear(), this.rowNodeSorter.doFullSort(s, e).forEach((n, o) => {
      this.nodeMap.set({
        id: n.id,
        node: n,
        index: o
      });
    });
  }
  /**
   * Transaction Support here
   */
  updateRowNodes(e) {
    const t = [];
    return e.forEach((s) => {
      const i = this.getRowId(s), r = this.nodeMap.getBy("id", i);
      r && (this.blockUtils.updateDataIntoRowNode(r.node, s), t.push(r.node));
    }), t;
  }
  insertRowNodes(e, t) {
    const s = this.store.getRowCount() - (this.store.getParentNode().sibling ? 1 : 0), i = t == null && this.isLastRowKnown ? s : t;
    if (i == null || s < i)
      return [];
    const r = {};
    e.forEach((l) => {
      const c = this.getRowId(l);
      c && this.isNodeInCache(c) || (r[c] = l);
    });
    const n = Object.values(r), o = n.length;
    if (o === 0)
      return [];
    const a = this.nodeMap.filter((l) => l.index >= i);
    return a.forEach((l) => this.nodeMap.delete(l)), a.forEach((l) => {
      this.nodeMap.set({
        node: l.node,
        index: l.index + o,
        id: l.id
      });
    }), this.numberOfRows += o, n.map(
      (l, c) => this.createRowAtIndex(i + c, l)
    );
  }
  removeRowNodes(e) {
    const t = [], s = [];
    let i = 0;
    const r = [...e], n = this.getOrderedNodeMap();
    let o = -1;
    for (const a of Object.keys(n)) {
      o += 1;
      const l = n[a], c = r.findIndex((u) => u === l.id);
      if (c !== -1) {
        r.splice(c, 1), this.destroyRowAtIndex(Number(a)), t.push(l.node), i += 1;
        continue;
      }
      if (i === 0)
        continue;
      const d = Number(a);
      o !== d && s.push(l.node), this.nodeMap.delete(l), this.nodeMap.set({
        id: l.id,
        node: l.node,
        index: d - i
      });
    }
    return this.numberOfRows -= this.isLastRowIndexKnown() ? e.length : i, r.length > 0 && s.length > 0 && (s.forEach((a) => a.__needsRefreshWhenVisible = !0), this.lazyBlockLoadingSvc.queueLoadCheck()), t;
  }
  /**
   * Return the block size configured for this cache
   */
  getBlockSize() {
    return this.storeParams.cacheBlockSize || e$;
  }
  /**
   * Get the start index of the loading block for a given index
   */
  getBlockStartIndex(e) {
    const t = this.getBlockSize();
    return e - e % t;
  }
  /**
   * Get the start and end index of a block, given a row store index
   */
  getBlockBounds(e) {
    const t = this.getBlockStartIndex(e), s = this.getBlockSize();
    return [t, t + s];
  }
}, t$ = class extends L {
  constructor(e, t, s) {
    super(), this.idSequence = { value: 0 }, this.ssrmParams = e, this.parentRowNode = s, this.storeParams = t, this.level = s.level + 1, this.group = e.rowGroupCols ? this.level < e.rowGroupCols.length : !1, this.leafGroup = e.rowGroupCols ? this.level === e.rowGroupCols.length - 1 : !1, this.info = {};
  }
  wireBeans(e) {
    this.blockUtils = e.ssrmBlockUtils, this.storeUtils = e.ssrmStoreUtils, this.selectionSvc = e.selectionSvc, this.rowGroupColsSvc = e.rowGroupColsSvc;
  }
  postConstruct() {
    let e = 1;
    if (this.level === 0 && (e = this.storeUtils.getServerSideInitialRowCount() ?? 1, this.eventSvc.dispatchEventOnce({
      type: "rowCountReady"
    })), this.cache = this.createManagedBean(new zd(this, e, !1, this.storeParams)), !this.gos.get("treeData") && this.group && this.rowGroupColsSvc) {
      const s = this.ssrmParams.rowGroupCols[this.level];
      this.groupField = s.field, this.rowGroupColumn = this.rowGroupColsSvc.columns[this.level];
    }
  }
  destroy() {
    this.displayIndexStart = void 0, this.displayIndexEnd = void 0, this.destroyBean(this.cache), super.destroy();
  }
  /**
   * Given a server response, ingest the rows outside of the data source lifecycle.
   *
   * @param rowDataParams the server response containing the rows to ingest
   * @param startRow the index to start ingesting rows
   * @param expectedRows the expected number of rows in the response (used to determine if the last row index is known)
   */
  applyRowData(e, t, s) {
    this.cache.onLoadSuccess(t, s, e);
  }
  /**
   * Applies a given transaction to the data set within this store
   *
   * @param transaction an object containing delta instructions determining the changes to apply to this store
   * @returns an object determining the status of this transaction and effected nodes
   */
  applyTransaction(e) {
    var d, u, h;
    const t = _i(this.gos);
    if (!t)
      return I(206), {
        status: wi.Cancelled
      };
    const s = this.gos.getCallback("isApplyServerSideTransaction");
    if (s) {
      const p = {
        transaction: e,
        parentNode: this.parentRowNode,
        groupLevelInfo: this.info
      };
      if (!s(p))
        return { status: wi.Cancelled };
    }
    const i = this.cache.isStoreFullyLoaded();
    let r;
    (d = e.update) != null && d.length && (r = this.cache.updateRowNodes(e.update));
    let n;
    if ((u = e.add) != null && u.length) {
      let p = e.addIndex;
      p != null && p < 0 && (p = void 0), n = this.cache.insertRowNodes(e.add, p);
    }
    let o;
    if ((h = e.remove) != null && h.length) {
      const p = e.remove.map(
        (f) => t({ level: this.level, parentKeys: this.parentRowNode.getRoute() ?? [], data: f })
      ), g = [...new Set(p)];
      o = this.cache.removeRowNodes(g);
    }
    const a = this.gos.get("serverSideEnableClientSideSort"), l = (r == null ? void 0 : r.length) || (n == null ? void 0 : n.length);
    return i && a && l && this.cache.clientSideSortRows(), this.updateSelectionAfterTransaction(r, o), {
      status: wi.Applied,
      update: r,
      add: n,
      remove: o
    };
  }
  updateSelectionAfterTransaction(e, t) {
    if (!this.selectionSvc)
      return;
    const s = [];
    e == null || e.forEach((i) => {
      i.isSelected() && !i.selectable && s.push(i);
    }), t == null || t.forEach((i) => {
      i.isSelected() && s.push(i);
    }), s.length && this.selectionSvc.setNodesSelected({
      newValue: !1,
      clearSelection: !1,
      nodes: s,
      source: "rowDataChanged"
    });
  }
  /**
   * Clear the display indexes, used for fading rows out when stores are not being destroyed
   */
  clearDisplayIndexes() {
    this.displayIndexStart = void 0, this.displayIndexEnd = void 0, this.cache.getNodes().forEach((e) => this.blockUtils.clearDisplayIndex(e.node)), this.parentRowNode.sibling && this.blockUtils.clearDisplayIndex(this.parentRowNode.sibling), this.cache.clearDisplayIndexes();
  }
  /**
   * @returns an index representing the last sequentially displayed row in the grid for this store
   */
  getDisplayIndexStart() {
    return this.displayIndexStart;
  }
  /**
   * @returns the index representing one after the last sequentially displayed row in the grid for this store
   */
  getDisplayIndexEnd() {
    return this.displayIndexEnd;
  }
  /**
   * @returns the virtual size of this store
   */
  getRowCount() {
    return this.parentRowNode.sibling ? this.cache.getRowCount() + 1 : this.cache.getRowCount();
  }
  /**
   * Sets the current row count of the store, and whether the last row index is known
   */
  setRowCount(e, t) {
    this.cache.setRowCount(e, t);
  }
  /**
   * Given a display index, returns whether that row is within this store or a child store of this store
   *
   * @param displayIndex the visible index of a row
   * @returns whether or not the row exists within this store
   */
  isDisplayIndexInStore(e) {
    return this.cache.getRowCount() === 0 ? !1 : this.displayIndexStart <= e && e < this.getDisplayIndexEnd();
  }
  /**
   * Recursively sets up the display indexes and top position of every node belonging to this store.
   *
   * Called after a row height changes, or a store updated event.
   *
   * @param displayIndexSeq the number sequence for generating the display index of each row
   * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
   */
  setDisplayIndexes(e, t, s) {
    this.displayIndexStart = e.value, this.topPx = t.value;
    const i = this.parentRowNode.level > -1 && Xn(this.gos)({ node: this.parentRowNode });
    i || Qh(this.parentRowNode), i === "top" && (Wi(this.parentRowNode, this.beans), this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, e, t, s)), this.cache.setDisplayIndexes(e, t, s), i === "bottom" && (Wi(this.parentRowNode, this.beans), this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, e, t, s)), this.displayIndexEnd = e.value, this.heightPx = t.value - this.topPx;
  }
  /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
   */
  forEachStoreDeep(e, t = { value: 0 }) {
    e(this, t.value++), this.cache.getNodes().forEach((s) => {
      const i = s.node.childStore;
      i && i.forEachStoreDeep(e, t);
    });
  }
  /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
   */
  forEachNodeDeep(e, t = { value: 0 }) {
    this.cache.getNodes().forEach((s) => {
      e(s.node, t.value++);
      const i = s.node.childStore;
      i && i.forEachNodeDeep(e, t);
    });
  }
  /**
   * Recursively applies a provided function to every node
   *
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeep
   */
  forEachNodeDeepAfterFilterAndSort(e, t = { value: 0 }, s = !1) {
    const i = this.parentRowNode.level > -1 && Xn(this.gos)({ node: this.parentRowNode });
    i === "top" && e(this.parentRowNode.sibling, t.value++);
    const r = this.cache.getOrderedNodeMap();
    for (const n of Object.values(r)) {
      e(n.node, t.value++);
      const o = n.node.childStore;
      o && o.forEachNodeDeepAfterFilterAndSort(e, t, s);
    }
    i === "bottom" && e(this.parentRowNode.sibling, t.value++);
  }
  /**
   * Removes the failed status from all nodes, and marks them as stub to encourage reloading
   */
  retryLoads() {
    this.cache.getNodes().forEach(({ node: e }) => {
      e.failedLoad && (e.failedLoad = !1, e.__needsRefreshWhenVisible = !0, e.stub = !0);
    }), this.forEachChildStoreShallow((e) => e.retryLoads()), this.fireStoreUpdatedEvent();
  }
  /**
   * Given a display index, returns the row at that location.
   *
   * @param displayRowIndex the displayed index within the grid to search for
   * @returns the row node if the display index falls within the store, if it didn't exist this will create a new stub to return
   */
  getRowUsingDisplayIndex(e) {
    return this.parentRowNode.sibling && e === this.parentRowNode.sibling.rowIndex ? this.parentRowNode.sibling : this.cache.getRowByDisplayIndex(e);
  }
  /**
   * Given a display index, returns the row top and height for the row at that index.
   *
   * @param displayIndex the display index of the node
   * @returns an object containing the rowTop and rowHeight of the node at the given displayIndex
   */
  getRowBounds(e) {
    if (!this.isDisplayIndexInStore(e))
      return null;
    const t = this.cache.getNodeCachedByDisplayIndex(e);
    if (t) {
      const a = this.blockUtils.extractRowBounds(t, e);
      if (a)
        return a;
    }
    const { previousNode: s, nextNode: i } = this.cache.getSurroundingNodesByDisplayIndex(e) ?? {};
    if (s) {
      const a = this.blockUtils.extractRowBounds(s.node, e);
      if (a != null)
        return a;
    }
    const r = vs(this.beans);
    if (i) {
      const a = (i.node.rowIndex - e) * r;
      return {
        rowTop: i.node.rowTop - a,
        rowHeight: r
      };
    }
    const n = this.topPx + this.heightPx, o = (this.getDisplayIndexEnd() - e) * r;
    return {
      rowTop: n - o,
      rowHeight: r
    };
  }
  /**
   * Given a vertical pixel, determines whether this store contains a row at that pixel
   *
   * @param pixel a vertical pixel position from the grid
   * @returns whether that pixel points to a virtual space belonging to this store
   */
  isPixelInRange(e) {
    return e >= this.topPx && e < this.topPx + this.heightPx;
  }
  /**
   * Given a vertical pixel, returns the row existing at that pixel location
   *
   * @param pixel a vertical pixel position from the grid
   * @returns the display index at the given pixel location
   */
  getRowIndexAtPixel(e) {
    if (e < this.topPx)
      return this.getDisplayIndexStart();
    if (e >= this.topPx + this.heightPx)
      return this.getDisplayIndexEnd() - 1;
    if (this.parentRowNode.sibling && e > this.parentRowNode.sibling.rowTop && e < this.parentRowNode.sibling.rowTop + this.parentRowNode.sibling.rowHeight)
      return this.parentRowNode.sibling.rowIndex;
    let t = Number.MAX_SAFE_INTEGER, s = null, i = Number.MAX_SAFE_INTEGER, r = null;
    if (this.cache.getNodes().forEach(({ node: l }) => {
      const c = Math.abs(e - l.rowTop);
      if (l.rowTop < e) {
        c < t && (t = c, s = l);
        return;
      }
      c < i && (i = c, r = l);
    }), s = s, r = r, s) {
      const l = this.blockUtils.getIndexAtPixel(s, e);
      if (l != null)
        return l;
    }
    const n = vs(this.beans);
    if (r) {
      const l = r.rowTop, c = Math.ceil((l - e) / n);
      return r.rowIndex - c;
    }
    const o = this.topPx + this.heightPx, a = Math.floor((o - e) / n);
    return this.getDisplayIndexEnd() - a;
  }
  /**
   * Given a path of group keys, returns the child store for that group.
   *
   * @param keys the grouping path to the desired store
   * @returns the child store for the given keys, or null if not found
   */
  getChildStore(e) {
    return this.storeUtils.getChildStore(e, this, (t) => {
      const s = this.cache.getNodes().find((i) => i.node.key == t);
      return s ? s.node : null;
    });
  }
  /**
   * Executes a provided callback on each child store belonging to this store
   *
   * @param cb the callback to execute
   */
  forEachChildStoreShallow(e) {
    this.cache.getNodes().forEach(({ node: t }) => {
      t.childStore && e(t.childStore);
    });
  }
  /**
   * Executes after a change to sorting, determines recursively whether this store or a child requires refreshed.
   *
   * If a purge refresh occurs, the row count is preserved.
   *
   * @param params a set of properties pertaining to the sort changes
   */
  refreshAfterSort(e) {
    if (this.storeUtils.isServerSideSortAllLevels() || this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, e)) {
      const s = this.cache.isStoreFullyLoaded(), i = this.gos.get("serverSideEnableClientSideSort");
      if (!(s && i)) {
        const n = this.cache.getRowCount(), o = this.cache.isLastRowIndexKnown();
        this.destroyBean(this.cache), this.cache = this.createManagedBean(new zd(this, n, o, this.storeParams));
        return;
      }
      this.cache.clientSideSortRows();
    }
    this.forEachChildStoreShallow((s) => s.refreshAfterSort(e));
  }
  /**
   * Executes after a change to filtering, determines recursively whether this store or a child requires refreshed.
   *
   * If a refresh occurs, the row count is reset.
   *
   * @param params a set of properties pertaining to the filter changes
   */
  refreshAfterFilter(e) {
    if (!this.storeUtils.isServerSideOnlyRefreshFilteredGroups() || this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, e)) {
      this.refreshStore(!0);
      return;
    }
    this.forEachChildStoreShallow((s) => s.refreshAfterFilter(e));
  }
  /**
   * Marks all existing nodes as requiring reloaded, and triggers a load check
   *
   * @param purge whether to remove all nodes and data in favour of stub nodes
   */
  refreshStore(e) {
    if (e) {
      this.destroyBean(this.cache), this.cache = this.createManagedBean(new zd(this, 1, !1, this.storeParams)), this.fireStoreUpdatedEvent();
      return;
    }
    this.cache.markNodesForRefresh();
  }
  /**
   * Used for pagination, given a local/store index, returns the display index of that row
   *
   * @param topLevelIndex the store index of a row
   * @returns the display index for the given store index
   */
  getTopLevelRowDisplayedIndex(e) {
    return this.cache.getDisplayIndexFromStoreIndex(e) ?? e;
  }
  /**
   * Used for pagination to determine if the last page is known, and for aria to determine if the last grid row is known
   *
   * @returns whether the last index of this store is known, or if lazy loading still required
   */
  isLastRowIndexKnown() {
    return this.cache.isLastRowIndexKnown();
  }
  /**
   * Used by the selection service to select a range of nodes
   *
   * @param firstInRange the first node in the range to find
   * @param lastInRange the last node in the range to find
   * @returns a range of nodes between firstInRange and lastInRange inclusive
   */
  getRowNodesInRange(e, t) {
    return this.cache.getNodes().filter(({ node: s }) => s.rowIndex >= e.rowIndex && s.rowIndex <= t.rowIndex).map(({ node: s }) => s);
  }
  /**
   * Mutates a given array to add this stores state, and recursively add all the children store states.
   *
   * @param result a mutable results array
   */
  addStoreStates(e) {
    e.push({
      route: this.parentRowNode.getRoute() ?? [],
      rowCount: this.getRowCount(),
      lastRowIndexKnown: this.isLastRowIndexKnown(),
      info: this.info,
      maxBlocksInCache: this.storeParams.maxBlocksInCache,
      cacheBlockSize: this.storeParams.cacheBlockSize
    }), this.forEachChildStoreShallow((t) => t.addStoreStates(e));
  }
  getIdSequence() {
    return this.idSequence;
  }
  getParentNode() {
    return this.parentRowNode;
  }
  getRowDetails() {
    return {
      field: this.groupField,
      group: this.group,
      leafGroup: this.leafGroup,
      level: this.level,
      parent: this.parentRowNode,
      rowGroupColumn: this.rowGroupColumn
    };
  }
  getSsrmParams() {
    return this.ssrmParams;
  }
  setStoreInfo(e) {
    e && Object.assign(this.info, e);
  }
  // gets called 1) row count changed 2) cache purged
  fireStoreUpdatedEvent() {
    this.eventSvc.dispatchEvent({
      type: "storeUpdated"
    });
  }
  // gets called when row data updated, and no more refreshing needed
  fireRefreshFinishedEvent() {
    this.eventSvc.dispatchEvent({
      type: "storeRefreshed",
      route: this.parentRowNode.getRoute()
    });
  }
  getBlockStates() {
    return this.cache.getBlockStates();
  }
  getStoreBounds() {
    return {
      topPx: this.topPx,
      heightPx: this.heightPx
    };
  }
  getCache() {
    return this.cache;
  }
}, s$ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "ssrmStoreFactory";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.rowGroupColsSvc = e.rowGroupColsSvc, this.pivotColsSvc = e.pivotColsSvc, this.rowAutoHeight = e.rowAutoHeight;
  }
  createStore(e, t) {
    const s = this.getStoreParams(e, t);
    return new t$(e, s, t);
  }
  getStoreParams(e, t) {
    const s = this.getLevelSpecificParams(t), i = this.getBlockSize(s), r = this.getMaxBlocksInCache(e, s);
    return {
      cacheBlockSize: i,
      maxBlocksInCache: r
    };
  }
  getMaxBlocksInCache(e, t) {
    var r;
    const s = t && t.maxBlocksInCache != null ? t.maxBlocksInCache : this.gos.get("maxBlocksInCache");
    if (s != null && s >= 0) {
      if (e.dynamicRowHeight) {
        I(203);
        return;
      }
      if ((r = this.rowAutoHeight) != null && r.active) {
        I(204);
        return;
      }
      return s;
    }
  }
  getBlockSize(e) {
    const t = e && e.cacheBlockSize != null ? e.cacheBlockSize : this.gos.get("cacheBlockSize");
    return t != null && t > 0 ? t : 100;
  }
  getLevelSpecificParams(e) {
    var r, n;
    const t = this.gos.getCallback("getServerSideGroupLevelParams");
    if (!t)
      return;
    const s = {
      level: e.level + 1,
      parentRowNode: e.level >= 0 ? e : void 0,
      rowGroupColumns: ((r = this.rowGroupColsSvc) == null ? void 0 : r.columns) ?? [],
      pivotColumns: ((n = this.pivotColsSvc) == null ? void 0 : n.columns) ?? [],
      pivotMode: this.colModel.isPivotMode()
    };
    return t(s);
  }
}, i$ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "ssrmStoreUtils";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.serverSideRowModel = e.rowModel, this.storeFactory = e.ssrmStoreFactory;
  }
  getChildStore(e, t, s) {
    if (!(e != null && e.length))
      return t;
    const i = e[0], r = s(i);
    if (r) {
      if (e.length === 1 && !r.childStore) {
        const a = this.serverSideRowModel.getParams();
        r.childStore = this.createBean(this.storeFactory.createStore(a, r));
      }
      const n = e.slice(1, e.length), o = r.childStore;
      return o ? o.getChildStore(n) : null;
    }
    return null;
  }
  isServerRefreshNeeded(e, t, s) {
    if (s.valueColChanged || s.secondaryColChanged)
      return !0;
    const i = e.level + 1;
    if (!(i < t.length))
      return !0;
    const o = t[i].id;
    return s.changedColumns.indexOf(o) > -1 ? !0 : this.colModel.getCols().filter((d) => d.getColDef().showRowGroup && s.changedColumns.includes(d.getId())).map((d) => d.getColDef().showRowGroup).some((d) => d === !0 || d === o);
  }
  getServerSideInitialRowCount() {
    return this.gos.get("serverSideInitialRowCount");
  }
  isServerSideSortAllLevels() {
    return this.gos.get("serverSideSortAllLevels") && Lt(this.gos);
  }
  isServerSideOnlyRefreshFilteredGroups() {
    return this.gos.get("serverSideOnlyRefreshFilteredGroups") && Lt(this.gos);
  }
}, r$ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "ssrmTxnManager", this.asyncTransactions = [];
  }
  wireBeans(e) {
    this.valueCache = e.valueCache, this.serverSideRowModel = e.rowModel, this.selectionSvc = e.selectionSvc;
  }
  postConstruct() {
    Lt(this.gos);
  }
  applyTransactionAsync(e, t) {
    this.asyncTransactionsTimeout == null && this.scheduleExecuteAsync(), this.asyncTransactions.push({ transaction: e, callback: t });
  }
  scheduleExecuteAsync() {
    const e = this.gos.get("asyncTransactionWaitMillis");
    this.asyncTransactionsTimeout = window.setTimeout(() => {
      this.executeAsyncTransactions();
    }, e);
  }
  executeAsyncTransactions() {
    var r;
    if (!this.asyncTransactions)
      return;
    const e = [], t = [], s = [];
    let i = !1;
    this.asyncTransactions.forEach((n) => {
      let o;
      if (this.serverSideRowModel.executeOnStore(n.transaction.route, (c) => {
        o = c.applyTransaction(n.transaction);
      }) ? o == null && (o = { status: wi.StoreNotFound }) : o = { status: wi.StoreNotStarted }, t.push(o), o.status == wi.StoreLoading) {
        s.push(n);
        return;
      }
      n.callback && e.push(() => n.callback(o)), o.status === wi.Applied && (i = !0);
    }), e.length > 0 && window.setTimeout(() => {
      e.forEach((n) => n());
    }, 0), this.asyncTransactionsTimeout = void 0, this.asyncTransactions = s, i && ((r = this.valueCache) == null || r.onDataChanged(), this.eventSvc.dispatchEvent({ type: "storeUpdated" })), t.length > 0 && this.eventSvc.dispatchEvent({
      type: "asyncTransactionsFlushed",
      results: t
    });
  }
  flushAsyncTransactions() {
    this.asyncTransactionsTimeout != null && clearTimeout(this.asyncTransactionsTimeout), this.executeAsyncTransactions();
  }
  applyTransaction(e) {
    var i;
    let t;
    if (this.serverSideRowModel.executeOnStore(e.route, (r) => {
      t = r.applyTransaction(e);
    }))
      if (t) {
        if ((i = this.valueCache) == null || i.onDataChanged(), t.remove && this.selectionSvc) {
          const r = t.remove.map((n) => n.id);
          this.selectionSvc.deleteSelectionStateFromParent(e.route || [], r);
        }
        return this.eventSvc.dispatchEvent({ type: "storeUpdated" }), t;
      } else
        return { status: wi.StoreNotFound };
    else return { status: wi.StoreNotStarted };
  }
}, n$ = {
  moduleName: "ServerSideRowModel",
  version: Me,
  rowModels: ["serverSide"],
  beans: [
    NU,
    kU,
    i$,
    LU,
    VU,
    r$,
    OU,
    s$,
    GU,
    XU,
    QU,
    ZU,
    YU,
    BU
  ],
  dependsOn: [
    Je,
    zh,
    Ny,
    tS,
    rS,
    tU,
    sU
  ]
}, o$ = {
  moduleName: "ServerSideRowModelApi",
  version: Me,
  rowModels: ["serverSide"],
  apiFunctions: {
    getServerSideSelectionState: HU,
    setServerSideSelectionState: zU,
    applyServerSideTransaction: WU,
    applyServerSideTransactionAsync: UU,
    applyServerSideRowData: _U,
    retryServerSideLoads: $U,
    flushServerSideAsyncTransactions: jU,
    refreshServerSide: KU,
    getServerSideGroupLevelState: qU
  },
  dependsOn: [Je, Hy, zy]
}, a$ = (
  /*css*/
  ".ag-sparkline-wrapper{height:100%;left:0;position:absolute;top:0;width:100%}.ag-sparkline-wrapper :where(canvas){position:absolute}"
), Wd = Symbol("WrappedFunctionMarker"), im = (e, t) => {
  if (e[Wd])
    return e;
  const s = (...i) => t(e, ...i);
  return s[Wd] = Wd, s;
}, l$ = ["ag-default", "ag-material", "ag-sheets", "ag-polychroma", "ag-vivid"], c$ = class extends _ {
  constructor() {
    super(
      /* html */
      `<div class="ag-sparkline-wrapper">
            <span data-ref="eSparkline"></span>
        </div>`
    ), this.eSparkline = E;
  }
  postConstruct() {
    this.addManagedPropertyListeners(["chartThemeOverrides", "chartThemes"], (e) => this.refresh(this.params));
  }
  init(e) {
    this.refresh(e);
    const t = Ms(this.beans, this.getGui(), () => this.refresh(e));
    this.addDestroyFunc(() => t());
  }
  getThemeName() {
    return (this.gos.get("chartThemes") || l$)[0];
  }
  refresh(e) {
    var i, r, n, o, a;
    this.params = e;
    const { clientWidth: t, clientHeight: s } = this.getGui();
    if (!this.sparklineInstance && e && t > 0 && s) {
      this.sparklineOptions = {
        container: this.eSparkline,
        width: t,
        height: s,
        ...e.sparklineOptions,
        data: this.processData(e.value)
      }, (i = this.sparklineOptions.tooltip) != null && i.renderer ? this.wrapTooltipRenderer() : this.sparklineOptions.tooltip = {
        ...this.sparklineOptions.tooltip,
        renderer: (c) => ({ content: this.createDefaultContent(c) })
      };
      const l = (r = this.sparklineOptions) == null ? void 0 : r.theme;
      return this.sparklineOptions.type === "bar" && this.sparklineOptions.itemStyler ? this.wrapItemStyler(this.sparklineOptions) : (a = (o = (n = l == null ? void 0 : l.overrides) == null ? void 0 : n.bar) == null ? void 0 : o.series) != null && a.itemStyler && this.wrapItemStyler(l.overrides.bar.series), this.updateTheme(this.sparklineOptions), this.sparklineInstance = e.createSparkline(this.sparklineOptions), !0;
    } else if (this.sparklineInstance) {
      const l = e == null ? void 0 : e.value;
      return this.sparklineOptions.width = t, this.sparklineOptions.height = s, this.sparklineOptions.data = this.processData(l), this.updateTheme(this.sparklineOptions), this.sparklineInstance.updateDelta(this.sparklineOptions), !0;
    }
    return !1;
  }
  updateTheme(e) {
    const t = this.getThemeName();
    typeof e.theme == "string" || !e.theme ? e.theme = t : e.theme && (e.theme.baseTheme = t);
  }
  processData(e = []) {
    return e.length === 0 ? e : e.filter((t) => t != null);
  }
  createContext() {
    var e, t;
    return {
      data: (e = this.params) == null ? void 0 : e.data,
      cellData: (t = this.params) == null ? void 0 : t.value
    };
  }
  createDefaultContent(e, t) {
    var o;
    const s = t == null ? void 0 : t.title, i = this.sparklineOptions.xKey, r = Array.isArray((o = this.sparklineOptions.data) == null ? void 0 : o[0]);
    return `${!s && (i || r) ? `${e.xValue} ` : ""}${e.yValue}`;
  }
  wrapItemStyler(e) {
    e.itemStyler = im(e.itemStyler, (t, s) => t({
      ...s,
      context: this.createContext()
    }));
  }
  wrapTooltipRenderer() {
    this.sparklineOptions.tooltip = {
      ...this.sparklineOptions.tooltip,
      renderer: im(this.sparklineOptions.tooltip.renderer, (e, t) => {
        const s = e({
          ...t,
          context: this.createContext()
        });
        return typeof s == "string" ? s : {
          content: this.createDefaultContent(t, s),
          ...s
        };
      })
    };
  }
  destroy() {
    var e;
    super.destroy(), (e = this.sparklineInstance) == null || e.destroy();
  }
}, rm = "Sparklines", d$ = {
  moduleName: rm,
  version: Me,
  dependsOn: [Je],
  validate: () => ({
    isValid: !1,
    message: Cv(258)
  }),
  with: (e) => (e.setup(), {
    moduleName: rm,
    version: Me,
    dependsOn: [Je],
    css: [a$],
    userComponents: {
      agSparklineCellRenderer: {
        classImp: c$,
        /** Default params for provided components */
        params: { createSparkline: e.createSparkline }
      }
    },
    validate: () => ({ isValid: !0 })
  })
}, u$ = class extends L {
  constructor(e) {
    super(), this.beanName = "agChartsExports", this.isEnterprise = !1, this.create = e.create, this._Theme = e._Theme, this._Scene = e._Scene, this.isEnterprise = e.isEnterprise, this._Util = e._Util;
  }
};
function nm(e) {
  return e.chart != null ? e.chart : e;
}
function en(e, t, s) {
  if (e == null)
    return s;
  const i = t.split(".");
  let r = e;
  for (; i.length > 1; )
    if (r = r[i.shift()], r == null)
      return s;
  const n = r[i[0]];
  return n ?? s;
}
function h$(e, t, s) {
  if (e == null)
    return;
  const i = t.split(".");
  let r = e;
  i.forEach((n, o) => {
    r[n] || (r[n] = {}), o < i.length - 1 && (r = r[n]);
  }), r[i[i.length - 1]] = s;
}
var p$ = {
  column: "bar",
  groupedColumn: "bar",
  stackedColumn: "bar",
  normalizedColumn: "bar",
  bar: "bar",
  groupedBar: "bar",
  stackedBar: "bar",
  normalizedBar: "bar",
  line: "line",
  stackedLine: "line",
  normalizedLine: "line",
  scatter: "scatter",
  bubble: "bubble",
  pie: "pie",
  donut: "donut",
  doughnut: "donut",
  area: "area",
  stackedArea: "area",
  normalizedArea: "area",
  histogram: "histogram",
  radarLine: "radar-line",
  radarArea: "radar-area",
  nightingale: "nightingale",
  radialColumn: "radial-column",
  radialBar: "radial-bar",
  sunburst: "sunburst",
  rangeBar: "range-bar",
  rangeArea: "range-area",
  boxPlot: "box-plot",
  treemap: "treemap",
  heatmap: "heatmap",
  waterfall: "waterfall"
}, g$ = /* @__PURE__ */ new Set(["columnLineCombo", "areaColumnCombo", "customCombo"]), f$ = ["grouped", "stacked", "normalized"], nS = {
  area: {
    isCartesian: !0,
    canInvert: !0
  },
  bar: {
    isCartesian: !0,
    canInvert: !0
  },
  histogram: {
    isCartesian: !0
  },
  line: {
    isCartesian: !0,
    canInvert: !0
  },
  pie: {
    isPie: !0
  },
  donut: {
    isPie: !0,
    canInvert: !0
  },
  scatter: {
    isCartesian: !0
  },
  bubble: {
    isCartesian: !0
  },
  "radial-column": {
    isPolar: !0,
    isEnterprise: !0,
    isRadial: !0,
    canInvert: !0
  },
  "radial-bar": {
    isPolar: !0,
    isEnterprise: !0,
    isRadial: !0,
    canInvert: !0
  },
  "radar-line": {
    isPolar: !0,
    isEnterprise: !0,
    canInvert: !0
  },
  "radar-area": {
    isPolar: !0,
    isEnterprise: !0,
    canInvert: !0
  },
  nightingale: {
    isPolar: !0,
    isEnterprise: !0,
    canInvert: !0
  },
  "range-bar": {
    isCartesian: !0,
    isEnterprise: !0,
    canSwitchDirection: !0
  },
  "range-area": {
    isCartesian: !0,
    isEnterprise: !0
  },
  "box-plot": {
    isCartesian: !0,
    isEnterprise: !0,
    canSwitchDirection: !0
  },
  treemap: {
    isEnterprise: !0,
    isHierarchical: !0
  },
  sunburst: {
    isEnterprise: !0,
    isHierarchical: !0
  },
  heatmap: {
    isCartesian: !0,
    isEnterprise: !0
  },
  waterfall: {
    isCartesian: !0,
    isEnterprise: !0,
    canSwitchDirection: !0
  }
};
function m$(e) {
  return !!nS[e];
}
function tp(e) {
  return g$.has(e);
}
function Or(e, t) {
  var s;
  return !!((s = nS[e]) != null && s[t]);
}
function C$(e) {
  return Or(at(e), "isEnterprise");
}
var v$ = /* @__PURE__ */ new Set(["stackedColumn", "normalizedColumn", "stackedBar", "normalizedBar"]);
function w$(e) {
  return v$.has(e);
}
function vr(e) {
  return Or(e, "isCartesian");
}
function ku(e) {
  return Or(e, "isPolar");
}
function y$(e) {
  return Or(e, "isRadial");
}
function on(e) {
  return Or(e, "isHierarchical");
}
function ua(e) {
  return e === "doughnut" ? "donut" : e;
}
function oS(e) {
  return p$[e];
}
function at(e) {
  return oS(e) ?? "line";
}
function aS(e) {
  return Or(e, "isPie");
}
function b$(e) {
  return e === "pie" || e === "waterfall" || e === "histogram";
}
function Ou(e) {
  return on(at(e)) ? void 0 : 1;
}
function Kl(e) {
  return on(at(e)) ? 2 : b$(e) ? 1 : void 0;
}
function lS(e) {
  return !tp(e) && Or(at(e), "canInvert");
}
function S$(e) {
  return Or(at(e), "canSwitchDirection");
}
function sp(e) {
  switch (e) {
    case "groupedColumn":
    case "stackedColumn":
    case "normalizedColumn":
    case "groupedBar":
    case "stackedBar":
    case "normalizedBar":
    case "stackedLine":
    case "normalizedLine":
    case "stackedArea":
    case "normalizedArea":
      return `${e}Full`;
    case "doughnut":
      return "donut";
    case "areaColumnCombo":
      return "AreaColumnCombo";
    default:
      return e;
  }
}
var cS = ["number", "category", "grouped-category", "log", "time"];
function x$(e) {
  switch (e) {
    case "bar":
    case "stackedBar":
    case "normalizedBar":
      return ["number", "category"];
    case "groupedBar":
      return ["number", "grouped-category"];
    case "column":
    case "stackedColumn":
    case "normalizedColumn":
    case "line":
    case "stackedLine":
    case "normalizedLine":
    case "area":
    case "stackedArea":
    case "normalizedArea":
    case "histogram":
      return ["category", "number"];
    case "groupedColumn":
      return ["grouped-category", "number"];
    case "scatter":
    case "bubble":
      return ["number", "number"];
    default:
      return;
  }
}
function R$(e, t, s, i, r) {
  const { chartOptionsToRestore: n, chartPaletteToRestore: o, chartThemeToRestore: a, agChartsExports: l } = e, c = A$(e), d = ip(c, l._Theme), u = d ? { baseTheme: c } : dS(e, c) ?? {}, h = e.getGridOptionsChartThemeOverrides(), p = e.apiChartThemeOverrides, g = at(e.chartType), f = e.crossFiltering ? P$(t, e, g) : void 0, w = [
    d ? E$(e, s, (() => {
      const y = (b) => b ? Object.keys(b).some((x) => en(b[x], "title.enabled", !1)) : !1;
      return y(h) || y(p);
    })()) : void 0,
    D$(),
    i,
    f,
    h,
    p,
    { ...n ?? {} },
    r
  ].filter((y) => !!y).reduce(
    (y, b) => ({
      baseTheme: y,
      overrides: b
    }),
    u
  );
  if (o && c === a) {
    const y = e.agChartsExports._Theme.getChartTheme(u).palette;
    F$(o, y) || (w.palette = o);
  }
  return w;
}
function F$(e, t) {
  const s = (i, r) => i === r ? !0 : (i == null ? void 0 : i.length) !== (r == null ? void 0 : r.length) ? !1 : (i == null ? void 0 : i.every((n, o) => n === (r == null ? void 0 : r[o]))) ?? !1;
  return s(e.fills, t.fills) && s(e.strokes, t.strokes);
}
function ip(e, t) {
  return Object.keys(t.themes).includes(e);
}
function P$(e, t, s) {
  const i = {
    listeners: {
      legendItemClick: (r) => {
        const n = e.getChart(), o = [r.seriesId, `${r.seriesId}-filtered-out`];
        n.series.filter((a) => o.includes(a.id)).forEach((a) => a.toggleSeriesItem(void 0, "category", r.itemId, void 0));
      }
    }
  };
  return {
    [s]: {
      tooltip: {
        delay: 500
      },
      legend: i,
      listeners: {
        click: (r) => t.crossFilterCallback(r, !0)
      }
    }
  };
}
var T$ = cS.reduce(
  (e, t) => ({ ...e, [t]: { title: { _enabledFromTheme: !0 } } }),
  {}
);
function E$(e, t, s) {
  const i = e.getExtraPaddingDirections();
  return {
    common: {
      ...t ? { animation: { duration: 500 } } : void 0,
      axes: T$,
      padding: {
        // don't add extra padding when a title is present!
        top: !s && i.includes("top") ? 40 : 20,
        right: i.includes("right") ? 30 : 20,
        bottom: i.includes("bottom") ? 40 : 20,
        left: i.includes("left") ? 30 : 20
      },
      suppressFieldDotNotation: !0
    }
  };
}
function D$() {
  return {
    pie: {
      series: {
        title: { _enabledFromTheme: !0 },
        calloutLabel: { _enabledFromTheme: !0 },
        sectorLabel: {
          enabled: !1,
          _enabledFromTheme: !0
        }
      }
    },
    donut: {
      series: {
        title: { _enabledFromTheme: !0 },
        calloutLabel: { _enabledFromTheme: !0 },
        sectorLabel: {
          enabled: !1,
          _enabledFromTheme: !0
        }
      }
    }
  };
}
function A$(e) {
  let t = e.getChartThemeName();
  const s = e.getChartThemes();
  return s.includes(t) || (t = s[0]), t;
}
function dS(e, t) {
  const { customChartThemes: s } = e, i = s && s[t];
  return i || I(140, { name: t }), i;
}
var xa = class {
  constructor(e) {
    this.chartProxyParams = e, this.clearThemeOverrides = !1, this.agChartsExports = e.agChartsExports, this.chart = e.chartInstance, this.chartType = e.chartType, this.crossFiltering = e.crossFiltering, this.crossFilterCallback = e.crossFilterCallback, this.standaloneChartType = at(this.chartType), this.chart == null ? this.chart = e.agChartsExports.create(this.getCommonChartOptions()) : this.clearThemeOverrides = !0;
  }
  crossFilteringReset() {
  }
  update(e) {
    this.getChartRef().update(this.getUpdateOptions(e, this.getCommonChartOptions(e.updatedOverrides)));
  }
  updateThemeOverrides(e) {
    this.getChartRef().updateDelta({ theme: { overrides: e } });
  }
  getChart() {
    return nm(this.chart);
  }
  getChartRef() {
    return this.chart;
  }
  downloadChart(e, t, s) {
    const { chart: i } = this, r = nm(i), n = t || (r.title ? r.title.text : "chart"), { width: o, height: a } = e || {};
    i.download({ width: o, height: a, fileName: n, fileFormat: s });
  }
  getChartImageDataURL(e) {
    return this.getChart().getCanvasDataURL(e);
  }
  getChartOptions() {
    return this.chart.getOptions();
  }
  getChartThemeOverrides() {
    return this.getChartOptions().theme.overrides ?? {};
  }
  getChartPalette() {
    return this.agChartsExports._Theme.getChartTheme(this.getChartOptions().theme).palette;
  }
  setPaired(e) {
    const t = at(this.chartProxyParams.chartType);
    this.chart.updateDelta({ theme: { overrides: { [t]: { paired: e } } } });
  }
  isPaired() {
    const e = at(this.chartProxyParams.chartType);
    return en(this.getChartThemeOverrides(), `${e}.paired`, !0);
  }
  lookupCustomChartTheme(e) {
    return dS(this.chartProxyParams, e);
  }
  getSeriesGroupType() {
  }
  transformCategoryData(e, t) {
    return e.map((s, i) => {
      const r = s[t], n = r && r.toString ? r.toString() : "", o = { ...s };
      return o[t] = { id: i, value: r, toString: () => n }, o;
    });
  }
  getCommonChartOptions(e) {
    var n;
    const t = this.clearThemeOverrides ? {} : ((n = this.chart) == null ? void 0 : n.getOptions()) ?? {}, s = this.chart != null ? this.getActiveFormattingPanelOverrides() : void 0;
    this.clearThemeOverrides = !1;
    const i = R$(
      this.chartProxyParams,
      this,
      this.agChartsExports.isEnterprise,
      this.getChartThemeDefaults(),
      e ?? s
    ), r = {
      ...t,
      mode: "integrated"
    };
    return r.theme = i, r.container = this.chartProxyParams.parentElement, r;
  }
  getChartThemeDefaults() {
    const e = this.getSeriesChartThemeDefaults(), t = e ? {
      [this.standaloneChartType]: e
    } : {}, s = {
      enabled: !0,
      snap: !0,
      label: {
        enabled: !1
      }
    }, i = this.agChartsExports.isEnterprise ? {
      zoom: {
        enabled: !0
      },
      animation: {
        enabled: !0,
        duration: 500
      },
      axes: {
        number: { crosshair: s },
        category: { crosshair: s },
        log: { crosshair: s },
        time: { crosshair: s }
      }
    } : {};
    return i.minHeight = 0, i.minWidth = 0, i.navigator = {
      enabled: !1
    }, {
      common: i,
      ...t
    };
  }
  getSeriesChartThemeDefaults() {
  }
  getActiveFormattingPanelOverrides() {
    var t;
    if (this.clearThemeOverrides)
      return {};
    const e = (t = this.chart) == null ? void 0 : t.getOptions().theme;
    return (e == null ? void 0 : e.overrides) ?? {};
  }
  destroy({ keepChartInstance: e = !1 } = {}) {
    if (e)
      return this.chart.resetAnimations(), this.chart;
    this.destroyChart();
  }
  destroyChart() {
    this.chart && (this.chart.destroy(), this.chart = void 0);
  }
}, Gr = class extends xa {
  constructor(e) {
    super(e), this.crossFilteringAllPoints = /* @__PURE__ */ new Set(), this.crossFilteringSelectedPoints = [];
  }
  getUpdateOptions(e, t) {
    const s = this.getAxes(e, t);
    return {
      ...t,
      data: this.getData(e, s),
      axes: s,
      series: this.getSeries(e)
    };
  }
  getData(e, t) {
    const s = ["area", "line"].includes(this.standaloneChartType);
    return this.crossFiltering && s ? this.getCrossFilterData(e) : this.getDataTransformedData(e, t);
  }
  getDataTransformedData(e, t) {
    const s = t[0].type, { categories: i, data: r } = e, [n] = i;
    switch (s) {
      case "category":
        return this.transformCategoryData(r, n.id);
      case "time":
        return this.transformTimeData(r, n.id);
      default:
        return r;
    }
  }
  getXAxisType(e) {
    return e.grouping ? "grouped-category" : this.isXAxisOfType(e, "time", (t) => t instanceof Date) ? "time" : this.isXAxisOfType(e, "number") ? "number" : "category";
  }
  isXAxisOfType(e, t, s) {
    const [i] = e.categories;
    if (i != null && i.chartDataType)
      return i.chartDataType === t;
    if (!s)
      return !1;
    const r = e.data[0];
    return r ? s(r[i.id]) : !1;
  }
  transformTimeData(e, t) {
    var i;
    return ((i = e[0]) == null ? void 0 : i[t]) instanceof Date ? e : e.map((r) => {
      const n = r[t];
      return typeof n == "string" ? {
        ...r,
        [t]: new Date(n)
      } : r;
    });
  }
  crossFilteringReset() {
    this.crossFilteringSelectedPoints = [], this.crossFilteringAllPoints.clear();
  }
  crossFilteringPointSelected(e) {
    return this.crossFilteringSelectedPoints.length == 0 || this.crossFilteringSelectedPoints.includes(e);
  }
  crossFilteringDeselectedPoints() {
    return this.crossFilteringSelectedPoints.length > 0 && this.crossFilteringAllPoints.size !== this.crossFilteringSelectedPoints.length;
  }
  extractLineAreaCrossFilterSeries(e, t) {
    const [s] = t.categories, i = (r) => this.standaloneChartType === "area" ? t.getCrossFilteringContext().lastSelectedChartId === t.chartId ? r + "-total" : r : r + "-total";
    return e.map((r) => (r.yKey = i(r.yKey), r.listeners = {
      nodeClick: (n) => {
        const o = n.datum[r.xKey], a = n.event.metaKey || n.event.ctrlKey;
        this.crossFilteringAddSelectedPoint(a, o), this.crossFilterCallback(n);
      }
    }, r.marker = {
      itemStyler: (n) => {
        const o = n.datum[s.id];
        return {
          fill: n.highlighted ? "yellow" : n.fill,
          size: n.highlighted ? 14 : this.crossFilteringPointSelected(o) ? 8 : 0
        };
      }
    }, this.standaloneChartType === "area" && (r.fillOpacity = this.crossFilteringDeselectedPoints() ? 0.3 : 1), this.standaloneChartType === "line" && (r.strokeOpacity = this.crossFilteringDeselectedPoints() ? 0.3 : 1), r));
  }
  getCrossFilterData(e) {
    this.crossFilteringAllPoints.clear();
    const [t] = e.categories, s = e.fields[0].colId, i = `${s}-filtered-out`, r = e.getCrossFilteringContext().lastSelectedChartId;
    return e.data.map((n) => {
      const o = n[t.id];
      this.crossFilteringAllPoints.add(o);
      const a = this.crossFilteringPointSelected(o);
      return this.standaloneChartType === "area" && r === e.chartId && (n[`${s}-total`] = a ? n[s] : n[s] + n[i]), this.standaloneChartType === "line" && (n[`${s}-total`] = a ? n[s] : n[s] + n[i]), n;
    });
  }
  crossFilteringAddSelectedPoint(e, t) {
    e ? this.crossFilteringSelectedPoints.push(t) : this.crossFilteringSelectedPoints = [t];
  }
  isHorizontal(e) {
    const t = this.standaloneChartType;
    if (t !== "waterfall" && t !== "box-plot" && t !== "range-bar")
      return !1;
    const s = e.theme, i = (r) => {
      var o, a, l;
      const n = (l = (a = (o = r == null ? void 0 : r.overrides) == null ? void 0 : o[t]) == null ? void 0 : a.series) == null ? void 0 : l.direction;
      return n != null ? n === "horizontal" : typeof (r == null ? void 0 : r.baseTheme) == "object" ? i(r.baseTheme) : !1;
    };
    return i(s);
  }
}, M$ = class extends Gr {
  constructor(e) {
    super(e);
  }
  getSeries(e) {
    const t = e.fields[0];
    return [
      {
        type: this.standaloneChartType,
        xKey: t.colId,
        xName: t.displayName,
        yName: this.chartProxyParams.translate("histogramFrequency"),
        areaPlot: !1
        // only constant width is supported via integrated charts
      }
    ];
  }
  getAxes(e) {
    return [
      {
        type: "number",
        position: "bottom"
      },
      {
        type: "number",
        position: "left"
      }
    ];
  }
}, I$ = class extends Gr {
  constructor(e) {
    super(e);
  }
  getAxes(e, t) {
    return [
      {
        type: this.getXAxisType(e),
        position: this.isHorizontal(t) ? "left" : "bottom"
      },
      {
        type: "number",
        position: this.isHorizontal(t) ? "bottom" : "left"
      }
    ];
  }
  getSeries(e) {
    const [t] = e.categories, [s] = e.fields;
    return [{
      type: this.standaloneChartType,
      xKey: t.id,
      xName: t.name,
      yKey: s.colId,
      yName: s.displayName ?? void 0
    }];
  }
}, pl = "AG-GRID-DEFAULT-LABEL-KEY";
function L$(e, t) {
  const s = uS(e, i, r);
  return rp(s);
  function i(o) {
    return t.length;
  }
  function r(o, a) {
    const l = t[a], c = o[l];
    return n(c);
  }
  function n(o) {
    return o == null ? null : String(o);
  }
}
function k$(e, t) {
  const s = uS(e, i, r);
  return rp(s);
  function i(n) {
    var o;
    return ((o = t(n)) == null ? void 0 : o.length) ?? 0;
  }
  function r(n, o) {
    const a = t(n);
    if (!a)
      return null;
    const l = a.length - 1 - o;
    return a[l];
  }
}
function rp(e, t = null, s) {
  const { depth: i, rootValues: r, value: n, children: o } = e;
  if (r)
    return r.map((l) => ({ [pl]: t, ...l }));
  if (i === 0)
    return [{ [pl]: t, ...n }];
  const a = [];
  for (const [l, c] of o.entries())
    a.push(...rp(c, l, !0));
  return s ? [
    {
      [pl]: t,
      children: a,
      ...n ?? {}
    }
  ] : a;
}
function uS(e, t, s) {
  const i = { depth: 0, children: /* @__PURE__ */ new Map() };
  return e.forEach((n) => {
    const o = t(n);
    r(n, o, s, 0, i);
  }), i;
  function r(n, o, a, l, c) {
    if (l === o)
      return l === 0 ? (c.rootValues || (c.rootValues = []), c.rootValues.push(n)) : c.value = n, c;
    {
      const d = a(n, l), u = c.children.get(d), h = r(
        n,
        o,
        a,
        l + 1,
        u || { depth: 0, children: /* @__PURE__ */ new Map() }
      );
      return c.children.set(d, h), c.depth = Math.max(1 + h.depth, c.depth), c;
    }
  }
}
var O$ = class extends xa {
  constructor(e) {
    super(e);
  }
  getUpdateOptions(e, t) {
    const { fields: s } = e, [i, r] = s;
    return {
      ...t,
      series: this.getSeries(i, r),
      data: this.getData(e, i, r)
    };
  }
  getSeriesChartThemeDefaults() {
    return {
      gradientLegend: {
        gradient: {
          preferredLength: 200
        }
      }
    };
  }
  getSeries(e, t) {
    return [
      {
        type: this.standaloneChartType,
        labelKey: pl,
        // Size and color fields are inferred from the range data
        sizeKey: e == null ? void 0 : e.colId,
        sizeName: (e == null ? void 0 : e.displayName) ?? void 0,
        colorKey: t == null ? void 0 : t.colId,
        colorName: (t == null ? void 0 : t.displayName) ?? void 0
      }
    ];
  }
  getData(e, t, s) {
    const { categories: i, data: r, groupData: n, grouping: o } = e;
    if (o) {
      const a = s ? r.concat(
        (n == null ? void 0 : n.map((l) => {
          const c = { ...l };
          return delete c[t.colId], c;
        })) ?? []
      ) : r;
      return k$(a, (l) => {
        var c;
        return ((c = l[Tr]) == null ? void 0 : c.labels) ?? null;
      });
    } else {
      const a = i.map(({ id: l }) => l);
      return L$(r, a);
    }
  }
}, G$ = class extends xa {
  constructor(e) {
    super(e);
  }
  getAxes(e) {
    const t = this.standaloneChartType === "radial-bar";
    return [
      { type: t ? "angle-number" : "angle-category" },
      { type: t ? "radius-category" : "radius-number" }
    ];
  }
  getSeries(e) {
    const { fields: t, categories: s, seriesGroupType: i } = e, [r] = s, n = this.standaloneChartType === "radial-bar", o = this.getSeriesGroupTypeOptions(i);
    return t.map((a) => ({
      type: this.standaloneChartType,
      angleKey: n ? a.colId : r.id,
      angleName: n ? a.displayName ?? void 0 : r.name,
      radiusKey: n ? r.id : a.colId,
      radiusName: n ? r.name : a.displayName ?? void 0,
      ...o
    }));
  }
  getSeriesGroupType() {
    var i, r;
    const e = this.standaloneChartType;
    if (!["nightingale", "radial-bar", "radial-column"].includes(e))
      return;
    const t = (r = (i = this.getChart().series) == null ? void 0 : i[0]) == null ? void 0 : r.properties.toJson(), s = () => t.normalizedTo ? "normalized" : "stacked";
    return e === "nightingale" ? t.grouped ? "grouped" : s() : t.stacked ? s() : "grouped";
  }
  getUpdateOptions(e, t) {
    const s = this.getAxes(e);
    return {
      ...t,
      data: this.getData(e, s),
      axes: s,
      series: this.getSeries(e)
    };
  }
  getData(e, t) {
    if (t.some((i) => i.type === "angle-category" || i.type === "radius-category")) {
      const [i] = e.categories;
      return this.transformCategoryData(e.data, i.id);
    } else
      return e.data;
  }
  getSeriesGroupTypeOptions(e) {
    return e ? {
      grouped: e === "grouped" || void 0,
      stacked: e !== "grouped" || void 0,
      normalizedTo: e === "normalized" ? 100 : void 0
    } : {};
  }
};
function B$(e, t) {
  return e.reduce((s, i, r, n) => s.concat(t(i, r, n)), new Array());
}
var V$ = "AG-GRID-DEFAULT-HEATMAP-CATEGORY-KEY", N$ = "AG-GRID-DEFAULT-HEATMAP-SERIES-KEY", H$ = "AG-GRID-DEFAULT-HEATMAP-VALUE-KEY", z$ = class extends xa {
  constructor(e) {
    super(e);
  }
  getUpdateOptions(e, t) {
    const s = N$, i = H$, r = V$;
    return {
      ...t,
      series: this.getSeries(e, s, i, r),
      data: this.getData(e, s, i, r)
    };
  }
  getSeries(e, t, s, i) {
    const [r] = e.categories;
    return [
      {
        type: this.standaloneChartType,
        // The axis keys reference synthetic fields based on the category values and series column names
        yKey: i,
        xKey: t,
        // The color key references a synthetic field based on the series column value for a specific cell
        colorKey: s,
        yName: r.name,
        // We don't know how to label the 'x' series, as it is a synthetic series created from the set of all input columns
        // In future releases we may want to consider inferring the series label from column groupings etc
        xName: void 0,
        colorName: void 0
      }
    ];
  }
  getData(e, t, s, i) {
    const [r] = e.categories;
    return B$(e.data, (n, o) => {
      const a = n[r.id], l = a == null ? "" : String(a), c = { id: o, value: a, toString: () => l };
      return e.fields.map(({ colId: d, displayName: u }) => ({
        ...n,
        [t]: u,
        [s]: n[d],
        [i]: c
      }));
    });
  }
  getSeriesChartThemeDefaults() {
    return {
      gradientLegend: {
        gradient: {
          preferredLength: 200
        }
      },
      series: {
        tooltip: {
          renderer: W$
        }
      }
    };
  }
};
function W$(e) {
  const { xKey: t, yKey: s, colorKey: i, yName: r, datum: n } = e;
  return {
    title: "",
    data: [
      { label: r, value: n[s] },
      { label: n[t], value: i && n[i] }
    ].map(({ label: a, value: l }) => ({ label: String(a), value: String(l) }))
  };
}
var _$ = class extends L {
  wireBeans(e) {
    this.sortSvc = e.sortSvc, this.gridRowModel = e.rowModel, this.colModel = e.colModel, this.valueSvc = e.valueSvc, this.pivotResultCols = e.pivotResultCols, this.rowNodeSorter = e.rowNodeSorter, this.aggStage = e.aggStage;
  }
  getData(e) {
    if (e.crossFiltering) {
      if (e.grouping)
        return I(141), { chartData: [], colNames: {} };
      if (!Ye(this.gos))
        return I(142), { chartData: [], colNames: {} };
    }
    Lt(this.gos) && e.pivoting && this.updatePivotKeysForSSRM();
    const s = this.extractRowsFromGridRowModel(e);
    return s.chartData = this.aggregateRowsByDimension(e, s.chartData), s;
  }
  extractRowsFromGridRowModel(e) {
    const { crossFiltering: t, startRow: s, endRow: i, valueCols: r, dimensionCols: n, grouping: o } = e;
    let a = [];
    const l = {}, c = {}, d = {};
    let u = {}, h = [], p;
    if (t)
      u = this.getFilteredRowNodes(), h = this.getAllRowNodes(), p = h.length;
    else {
      const m = this.gridRowModel.getRowCount() - 1;
      s === i && s === 0 && n.length === 0 && r.length === 0 ? p = 0 : p = (i >= 0 ? Math.min(i, m) : m) - s + 1;
    }
    p > 0 && r.forEach((m) => {
      let C = [];
      const w = m.getColDef().pivotKeys;
      w && (C = w.slice());
      const y = m.getColDef().headerName;
      y && C.push(y), C.length > 0 && (l[m.getId()] = C);
    });
    let g = 0;
    for (let m = 0; m < p; m++) {
      const C = t ? h[m] : this.gridRowModel.getRow(m + s);
      if (C.footer || C.detail) {
        g++;
        continue;
      }
      const w = {};
      n.forEach((y) => {
        const b = y.colId, x = this.colModel.getCol(b);
        if (x) {
          const M = this.valueSvc.getValue(x, C);
          if (o) {
            const T = M != null && M.toString ? String(M.toString()) : "", F = this.getGroupLabels(C, T);
            w[b] = F.slice().reverse(), C.group && (c[F.toString()] = m - g);
            const k = F.slice(1, F.length).toString();
            k && (d[k] = c[k]);
          } else
            w[b] = M;
        } else
          w[Fi] = m + 1;
      }), r.forEach((y) => {
        const b = y.getColId();
        if (t) {
          const x = b + "-filtered-out", M = this.valueSvc.getValue(y, C), T = M != null && typeof M.toNumber == "function" ? M.toNumber() : M;
          u[C.id] ? (w[b] = T, w[x] = e.aggFunc || e.isScatter ? void 0 : 0) : (w[b] = e.aggFunc || e.isScatter ? void 0 : 0, w[x] = T);
        } else {
          let x = this.valueSvc.getValue(y, C);
          x && Object.prototype.hasOwnProperty.call(x, "toString") && (x = parseFloat(x.toString())), w[b] = x != null && typeof x.toNumber == "function" ? x.toNumber() : x;
        }
      }), a.push(w);
    }
    let f;
    if (o) {
      const m = Object.values(d), C = a;
      a = [], f = [];
      for (let w = 0; w < C.length; w++)
        (m.includes(w) ? f : a).push(C[w]);
    }
    return { chartData: a, colNames: l, groupChartData: f };
  }
  aggregateRowsByDimension(e, t) {
    const s = e.dimensionCols;
    if (!e.aggFunc || s.length === 0)
      return t;
    const i = pe(s), r = i && i.colId, n = {}, o = [];
    if (t.forEach((a) => {
      let l = n;
      s.forEach((c) => {
        const d = c.colId, u = a[d];
        if (d === r) {
          let h = l[u];
          h || (h = { __children: [] }, s.forEach((p) => {
            const g = p.colId;
            h[g] = a[g];
          }), l[u] = h, o.push(h)), h.__children.push(a);
        } else
          l[u] || (l[u] = {}), l = l[u];
      });
    }), this.gos.assertModuleRegistered("SharedRowGrouping", 1)) {
      const a = this.aggStage;
      o.forEach(
        (l) => e.valueCols.forEach((c) => {
          if (e.crossFiltering)
            e.valueCols.forEach((d) => {
              const u = d.getColId(), h = l.__children.filter((C) => typeof C[u] < "u").map((C) => C[u]), p = a.aggregateValues(h, e.aggFunc);
              l[d.getId()] = p && typeof p.value < "u" ? p.value : p;
              const g = `${u}-filtered-out`, f = l.__children.filter((C) => typeof C[g] < "u").map((C) => C[g]), m = a.aggregateValues(f, e.aggFunc);
              l[g] = m && typeof m.value < "u" ? m.value : m;
            });
          else {
            const d = l.__children.map((h) => h[c.getId()]), u = a.aggregateValues(d, e.aggFunc);
            l[c.getId()] = u && typeof u.value < "u" ? u.value : u;
          }
        })
      );
    }
    return o;
  }
  updatePivotKeysForSSRM() {
    var s, i;
    const e = (i = (s = this.pivotResultCols) == null ? void 0 : s.getPivotResultCols()) == null ? void 0 : i.list;
    if (!e)
      return;
    const t = this.extractPivotKeySeparator(e);
    e.forEach((r) => {
      if (t === "")
        r.getColDef().pivotKeys = [];
      else {
        const n = r.getColId().split(t);
        r.getColDef().pivotKeys = n.slice(0, n.length - 1);
      }
    });
  }
  extractPivotKeySeparator(e) {
    if (e.length === 0)
      return "";
    const t = (i, r) => {
      const n = i.getGroupId();
      return i.getParent() ? t(i.getParent(), n) : r.split(n)[1][0];
    }, s = e[0];
    return s.getParent() == null ? "" : t(s.getParent(), s.getColId());
  }
  getGroupLabels(e, t) {
    const s = [t];
    for (; e && e.level !== 0; )
      e = e.parent, e && s.push(e.key);
    return s;
  }
  getFilteredRowNodes() {
    const e = {};
    return this.gridRowModel.forEachNodeAfterFilterAndSort((t) => {
      e[t.id] = t;
    }), e;
  }
  getAllRowNodes() {
    const e = [];
    return this.gridRowModel.forEachNode((t) => {
      e.push(t);
    }), this.sortRowNodes(e);
  }
  sortRowNodes(e) {
    var s;
    const t = (s = this.sortSvc) == null ? void 0 : s.getSortOptions();
    return !t || t.length == 0 || !this.rowNodeSorter ? e : this.rowNodeSorter.doFullSort(e, t);
  }
}, U$ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "chartColSvc", this.valueColsWithoutSeriesType = /* @__PURE__ */ new Set();
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.colNames = e.colNames, this.valueSvc = e.valueSvc;
  }
  postConstruct() {
    const e = () => this.valueColsWithoutSeriesType.clear();
    this.addManagedEventListeners({
      newColumnsLoaded: e,
      rowDataUpdated: e
    });
  }
  getColumn(e) {
    return this.colModel.getColDefCol(e);
  }
  getAllDisplayedColumns() {
    return this.beans.visibleCols.allCols;
  }
  getColDisplayName(e, t) {
    const s = "chart", i = this.colNames.getDisplayNameForColumn(e, s);
    if (t) {
      const r = [i], n = (o) => {
        if (!o)
          return;
        const a = this.colNames.getDisplayNameForColumnGroup(o, s);
        a != null && a.length && (r.unshift(a), n(o.getParent()));
      };
      return n(e.getParent()), r.join(" - ");
    }
    return i;
  }
  getRowGroupColumns() {
    var e;
    return ((e = this.beans.rowGroupColsSvc) == null ? void 0 : e.columns) ?? [];
  }
  getGroupDisplayColumns() {
    var e;
    return ((e = this.beans.showRowGroupCols) == null ? void 0 : e.getShowRowGroupCols()) ?? [];
  }
  isPivotMode() {
    return this.colModel.isPivotMode();
  }
  isPivotActive() {
    return this.colModel.isPivotActive();
  }
  getChartColumns() {
    const e = this.colModel.getCols(), t = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
    return e.forEach((i) => {
      const r = i.getColDef(), n = r.chartDataType;
      if (n)
        switch (n) {
          case "category":
          case "time":
            t.add(i);
            return;
          case "series":
            s.add(i);
            return;
          case "excluded":
            return;
          default:
            I(153, { chartDataType: n });
            break;
        }
      if (r.colId === "ag-Grid-AutoColumn") {
        t.add(i);
        return;
      }
      if (!i.isPrimary()) {
        s.add(i);
        return;
      }
      (this.isInferredValueCol(i) ? s : t).add(i);
    }), { dimensionCols: t, valueCols: s };
  }
  isInferredValueCol(e) {
    const t = e.getColId();
    if (t === "ag-Grid-AutoColumn")
      return !1;
    const s = ri(this.beans, { rowIndex: 0, rowPinned: null });
    if (!s)
      return this.valueColsWithoutSeriesType.has(t);
    let i = this.valueSvc.getValue(e, s);
    i == null && (i = this.extractLeafData(s, e)), i != null && typeof i.toNumber == "function" && (i = i.toNumber());
    const r = typeof i == "number";
    return r && this.valueColsWithoutSeriesType.add(t), r;
  }
  extractLeafData(e, t) {
    if (!e.allLeafChildren)
      return null;
    for (let s = 0; s < e.allLeafChildren.length; s++) {
      const i = e.allLeafChildren[s], r = this.valueSvc.getValue(t, i);
      if (r != null)
        return r;
    }
    return null;
  }
  destroy() {
    this.valueColsWithoutSeriesType.clear(), super.destroy();
  }
}, $$ = /* @__PURE__ */ new Set(["line", "groupedColumn", "stackedColumn", "area", "stackedArea"]), j$ = class extends L {
  constructor(e) {
    super(), this.suppressComboChartWarnings = !1, this.chartDataModel = e, this.seriesChartTypes = e.params.seriesChartTypes ?? [];
  }
  postConstruct() {
    this.initComboCharts();
  }
  update(e) {
    this.seriesChartTypes = e ?? this.seriesChartTypes, this.initComboCharts(), this.updateSeriesChartTypes();
  }
  initComboCharts() {
    const e = this.seriesChartTypes && this.seriesChartTypes.length > 0;
    (this.chartDataModel.chartType === "customCombo" || e) && (this.chartDataModel.chartType = "customCombo", this.savedCustomSeriesChartTypes = this.seriesChartTypes || []);
  }
  updateSeriesChartTypes() {
    if (this.chartDataModel.isComboChart()) {
      if (this.seriesChartTypes = this.seriesChartTypes.map((e) => {
        const t = ["groupedColumn", "stackedColumn", "stackedArea"].includes(e.chartType);
        return e.secondaryAxis = t ? !1 : e.secondaryAxis, e;
      }), this.chartDataModel.chartType === "customCombo") {
        this.updateSeriesChartTypesForCustomCombo();
        return;
      }
      this.updateChartSeriesTypesForBuiltInCombos();
    }
  }
  updateSeriesChartTypesForCustomCombo() {
    !(this.seriesChartTypes && this.seriesChartTypes.length > 0) && !this.suppressComboChartWarnings && I(150), this.seriesChartTypes = this.seriesChartTypes.map((i) => ($$.has(i.chartType) || (I(151, { chartType: i.chartType }), i.chartType = "line"), i));
    const t = (i) => {
      (!this.savedCustomSeriesChartTypes || this.savedCustomSeriesChartTypes.length === 0) && (this.savedCustomSeriesChartTypes = this.seriesChartTypes);
      const r = this.savedCustomSeriesChartTypes.find((n) => n.colId === i.colId);
      return r || (i.selected && !this.suppressComboChartWarnings && I(152, { colId: i.colId }), {
        colId: i.colId,
        chartType: "line",
        secondaryAxis: !1
      });
    }, s = this.chartDataModel.valueColState.map(t);
    this.seriesChartTypes = s, this.savedCustomSeriesChartTypes = s, this.suppressComboChartWarnings = !0;
  }
  updateChartSeriesTypesForBuiltInCombos() {
    const { chartType: e, valueColState: t } = this.chartDataModel, s = e === "columnLineCombo" ? "groupedColumn" : "stackedArea", i = e === "columnLineCombo" ? "line" : "groupedColumn", r = t.filter((o) => o.selected), n = Math.ceil(r.length / 2);
    this.seriesChartTypes = r.map((o, a) => {
      const l = a >= n ? i : s;
      return { colId: o.colId, chartType: l, secondaryAxis: !1 };
    });
  }
}, Fi = "AG-GRID-DEFAULT-CATEGORY", K$ = class extends L {
  constructor(e) {
    super(), this.unlinked = !1, this.chartData = [], this.valueColState = [], this.dimensionColState = [], this.colNames = {}, this.crossFiltering = !1, this.grouping = !1, this.params = e, this.chartId = e.chartId, this.setParams(e);
  }
  wireBeans(e) {
    this.rangeSvc = e.rangeSvc, this.chartTranslation = e.chartTranslation;
  }
  setParams(e) {
    const {
      chartType: t,
      pivotChart: s,
      chartThemeName: i,
      switchCategorySeries: r,
      aggFunc: n,
      cellRange: o,
      suppressChartRanges: a,
      unlinkChart: l,
      crossFiltering: c,
      seriesGroupType: d
    } = e;
    this.chartType = t, this.pivotChart = s ?? !1, this.chartThemeName = i, this.switchCategorySeries = !!r, this.aggFunc = n, this.referenceCellRange = o, this.suppliedCellRange = o, this.suppressChartRanges = a ?? !1, this.unlinked = !!l, this.crossFiltering = !!c, this.seriesGroupType = d;
  }
  postConstruct() {
    this.datasource = this.createManagedBean(new _$()), this.chartColSvc = this.createManagedBean(new U$()), this.comboChartModel = this.createManagedBean(new j$(this)), this.updateCellRanges({ setColsFromRange: !0 }), this.updateData();
  }
  updateModel(e) {
    const { cellRange: t, seriesChartTypes: s } = e;
    t !== this.suppliedCellRange && (this.dimensionCellRange = void 0, this.valueCellRange = void 0), this.setParams(e), this.updateSelectedDimensions(t == null ? void 0 : t.columns), this.updateCellRanges({ setColsFromRange: !0 }), (this.isComboChart() || s) && this.comboChartModel.update(s), this.unlinked || this.updateData();
  }
  updateCellRanges(e) {
    const { updatedColState: t, resetOrder: s, maintainColState: i, setColsFromRange: r } = e ?? {};
    this.valueCellRange && (this.referenceCellRange = this.valueCellRange);
    const { dimensionCols: n, valueCols: o } = this.chartColSvc.getChartColumns(), a = this.getAllColumnsFromRanges();
    t && this.updateColumnState(t, s), this.setDimensionCellRange(n, a, t), this.setValueCellRange(o, a, r), !t && !i && (this.resetColumnState(), this.syncDimensionCellRange()), this.comboChartModel.updateSeriesChartTypes();
  }
  updateData() {
    const { startRow: e, endRow: t } = this.getRowIndexes();
    this.pivotChart && this.resetColumnState(), this.grouping = this.isGrouping();
    const s = {
      aggFunc: this.aggFunc,
      dimensionCols: this.getSelectedDimensions(),
      grouping: this.grouping,
      pivoting: this.isPivotActive(),
      crossFiltering: this.crossFiltering,
      valueCols: this.getSelectedValueCols(),
      startRow: e,
      endRow: t,
      isScatter: ["scatter", "bubble"].includes(this.chartType)
    }, { chartData: i, colNames: r, groupChartData: n } = this.datasource.getData(s);
    this.chartData = i, this.groupChartData = n, this.colNames = r, this.categoryAxisType = void 0;
  }
  isGrouping() {
    const e = this.gos.get("treeData"), t = e ? null : this.chartColSvc.getRowGroupColumns(), s = e || t && t.length > 0, i = this.getSelectedDimensions().map(({ colId: o }) => o), n = this.chartColSvc.getGroupDisplayColumns().map((o) => o.getColId()).some((o) => i.includes(o));
    return !!s && n;
  }
  getSelectedValueCols() {
    return this.valueColState.filter((e) => e.selected).map((e) => e.column);
  }
  getSelectedDimensions() {
    return this.dimensionColState.filter((e) => e.selected);
  }
  getColDisplayName(e, t) {
    return this.chartColSvc.getColDisplayName(e, t);
  }
  isPivotMode() {
    return this.chartColSvc.isPivotMode();
  }
  getChartDataType(e) {
    const t = this.chartColSvc.getColumn(e);
    return t ? t.getColDef().chartDataType : void 0;
  }
  isPivotActive() {
    return this.chartColSvc.isPivotActive();
  }
  createCellRange(e, ...t) {
    return {
      id: this.chartId,
      // set range ID to match chart ID so we can identify changes to the ranges for this chart
      startRow: this.referenceCellRange.startRow,
      endRow: this.referenceCellRange.endRow,
      columns: t,
      startColumn: e === Vs.DIMENSION || this.referenceCellRange.startColumn == null ? t[0] : this.referenceCellRange.startColumn,
      type: e
    };
  }
  getAllColumnsFromRanges() {
    if (this.pivotChart)
      return new Set(this.chartColSvc.getAllDisplayedColumns());
    const e = this.dimensionCellRange || this.valueCellRange ? [] : this.referenceCellRange.columns;
    return this.dimensionCellRange && e.push(...this.dimensionCellRange.columns), this.valueCellRange && e.push(...this.valueCellRange.columns), new Set(e);
  }
  getRowIndexes() {
    let e = 0, t = 0;
    const { rangeSvc: s, valueCellRange: i, dimensionCellRange: r } = this, n = i || r;
    if (s && n) {
      e = s.getRangeStartRow(n).rowIndex;
      const o = s.getRangeEndRow(n);
      t = o.rowPinned === "bottom" ? -1 : o.rowIndex;
    }
    return { startRow: e, endRow: t };
  }
  resetColumnState() {
    const { dimensionCols: e, valueCols: t } = this.chartColSvc.getChartColumns(), s = this.getAllColumnsFromRanges(), i = this.valueColState.length < 1;
    this.dimensionColState = [], this.valueColState = [];
    const r = on(at(this.chartType));
    let n = !1, o = 1;
    const a = this.suppliedCellRange.columns[0];
    e.forEach((d) => {
      const u = d.getColId() === "ag-Grid-AutoColumn";
      let h = !1;
      this.crossFiltering && this.aggFunc ? a.getColId() === d.getColId() && (h = !0) : h = u ? !0 : (!n || r) && s.has(d), this.dimensionColState.push({
        column: d,
        colId: d.getColId(),
        displayName: this.getColDisplayName(d),
        selected: h,
        order: o++
      }), h && (n = !0);
    });
    const l = {
      colId: Fi,
      displayName: this.chartTranslation.translate("defaultCategory"),
      selected: !n,
      // if no dimensions in range select the default
      order: 0
    };
    this.dimensionColState.unshift(l);
    const c = this.referenceCellRange.columns.filter(
      (d) => t.has(d)
    );
    t.forEach((d) => {
      i && this.referenceCellRange.columns.includes(d) && (d = c.shift()), this.valueColState.push({
        column: d,
        colId: d.getColId(),
        displayName: this.getColDisplayName(d),
        selected: s.has(d),
        order: o++
      });
    });
  }
  updateColumnState(e, t) {
    const s = (c) => c.colId === e.colId, { dimensionColState: i, valueColState: r } = this, n = i.find(s), o = r.find(s);
    if (n)
      if (on(at(this.chartType)))
        n.selected = e.selected;
      else {
        const d = e.selected ? n : i.filter((u) => u !== n).find(({ selected: u }) => u);
        i.forEach((u) => u.selected = u === d);
      }
    else o && (o.selected = e.selected);
    const a = [...i, ...r], l = [];
    t || (a.forEach((c, d) => {
      d === e.order && l.push(e.colId), c.colId !== e.colId && l.push(c.colId);
    }), a.forEach((c) => {
      const d = l.indexOf(c.colId);
      c.order = d >= 0 ? l.indexOf(c.colId) : a.length - 1;
    })), this.reorderColState();
  }
  reorderColState() {
    const e = (t, s) => t.order - s.order;
    this.dimensionColState.sort(e), this.valueColState.sort(e);
  }
  setDimensionCellRange(e, t, s) {
    this.dimensionCellRange = void 0;
    const i = on(at(this.chartType));
    if (!s && !this.dimensionColState.length) {
      const a = new Array();
      e.forEach((l) => {
        a.length > 0 && !i || !t.has(l) || a.push(l);
      }), a.length > 0 && (this.dimensionCellRange = this.createCellRange(Vs.DIMENSION, ...a));
      return;
    }
    let r = s ? [s] : [];
    if (this.crossFiltering && this.aggFunc) {
      const a = this.suppliedCellRange.columns[0];
      r = this.dimensionColState.filter(
        (l) => l.colId === a.getColId()
      );
    } else (i || r.length === 0 || r.some(({ column: a }) => !a || !e.has(a))) && (r = this.dimensionColState.filter((a) => a.selected));
    const n = r.length === 1 ? r[0].colId === Fi : !1, o = r.map(({ column: a }) => a).filter((a) => a != null);
    o.length > 0 && !n && (this.dimensionCellRange = this.createCellRange(Vs.DIMENSION, ...o));
  }
  setValueCellRange(e, t, s) {
    this.valueCellRange = void 0;
    const i = [], r = Kl(this.chartType);
    let n = 0;
    if (e.forEach((o) => {
      s ? (r == null || n < r) && t.has(o) && (i.push(o), n++) : this.valueColState.some((a) => a.selected && a.colId === o.getColId()) && i.push(o);
    }), i.length > 0) {
      let o = [];
      this.valueColState.length > 0 ? o = this.valueColState.map((a) => a.colId) : t.forEach((a) => o.push(a.getColId())), i.sort((a, l) => o.indexOf(a.getColId()) - o.indexOf(l.getColId())), this.valueCellRange = this.createCellRange(Vs.VALUE, ...i);
    }
  }
  resetCellRanges(e, t) {
    if (!e && !t)
      return;
    const { dimensionCols: s, valueCols: i } = this.chartColSvc.getChartColumns(), r = this.getAllColumnsFromRanges();
    e && this.setDimensionCellRange(s, r), t && this.setValueCellRange(i, r);
  }
  updateSelectedDimensions(e) {
    const t = new Set(e.map((i) => i.getColId()));
    if (on(at(this.chartType))) {
      const i = this.dimensionColState.filter((n) => t.has(n.colId)), r = new Set(i.map((n) => n.colId));
      this.dimensionColState = this.dimensionColState.map((n) => ({
        ...n,
        selected: r.has(n.colId)
      }));
    } else {
      const r = (this.dimensionColState.find((n) => t.has(n.colId)) || this.dimensionColState[0]).colId;
      this.dimensionColState = this.dimensionColState.map((n) => ({
        ...n,
        selected: n.colId === r
      }));
    }
  }
  syncDimensionCellRange() {
    const e = this.getSelectedDimensions();
    if (e.length === 0)
      return;
    const t = e.map(({ column: s }) => s).filter((s) => s != null);
    t.length > 0 && (this.dimensionCellRange = this.createCellRange(Vs.DIMENSION, ...t));
  }
  isComboChart(e) {
    return tp(e ?? this.chartType);
  }
}, hS = class extends Gr {
  constructor(e) {
    super(e);
  }
  getAxes(e, t) {
    return [
      {
        type: this.getXAxisType(e),
        position: this.isHorizontal(t) ? "left" : "bottom"
      },
      {
        type: "number",
        position: this.isHorizontal(t) ? "bottom" : "left"
      }
    ];
  }
  computeSeriesStatistics(e, t) {
    const { data: s, fields: i } = e, [r] = e.categories, n = r.id || Fi, o = this.groupDataByCategory(n, s);
    return Array.from(o).map(([a, l]) => {
      const c = { [r.id]: a };
      return i.forEach((d, u) => {
        const h = l.map((p) => p[d.colId]).filter((p) => typeof p == "number" && !isNaN(p));
        Object.entries(t(h)).forEach(([p, g]) => {
          const f = `${p}:${u}`;
          c[f] = h.length > 0 ? g : null;
        });
      }), c;
    });
  }
  groupDataByCategory(e, t) {
    const s = (i) => {
      if (e === Fi)
        return 1;
      const r = i[e];
      return r == null ? "" : r instanceof Date ? r.getTime() : r;
    };
    return t.reduce((i, r) => {
      const n = s(r), o = i.get(n);
      return o ? o.push(r) : i.set(n, [r]), i;
    }, /* @__PURE__ */ new Map());
  }
}, q$ = class extends hS {
  constructor(e) {
    super(e);
  }
  getSeries(e) {
    const [t] = e.categories;
    return e.fields.map((s, i) => ({
      type: this.standaloneChartType,
      // xKey/xName refer to category buckets
      xKey: t.id,
      xName: t.name,
      // yName is used to label the series
      yName: s.displayName ?? void 0,
      // custom field labels shown in the tooltip
      minName: "Min",
      q1Name: "Q1",
      medianName: "Median",
      q3Name: "Q3",
      maxName: "Max",
      // generated 'synthetic fields' from getData()
      minKey: `min:${i}`,
      q1Key: `q1:${i}`,
      medianKey: `median:${i}`,
      q3Key: `q3:${i}`,
      maxKey: `max:${i}`
    }));
  }
  getData(e) {
    return this.computeSeriesStatistics(e, (t) => {
      const s = t.sort((i, r) => i - r);
      return {
        min: s[0],
        q1: this.quantile(s, 0.25),
        median: this.quantile(s, 0.5),
        q3: this.quantile(s, 0.75),
        max: s[s.length - 1]
      };
    });
  }
  quantile(e, t) {
    const s = (e.length - 1) * t, i = Math.floor(s), r = s - i;
    return e[i + 1] !== void 0 ? e[i] + r * (e[i + 1] - e[i]) : e[i];
  }
}, Y$ = class extends hS {
  constructor(e) {
    super(e);
  }
  getSeries(e) {
    const [t] = e.categories;
    return e.fields.map((s, i) => ({
      type: this.standaloneChartType,
      // xKey/xName refer to category buckets
      xKey: t.id,
      xName: t.name,
      // yName is used to label the series
      yName: s.displayName ?? void 0,
      // custom field labels shown in the tooltip
      yLowName: "Min",
      yHighName: "Max",
      // generated 'synthetic fields' from getData()
      yLowKey: `min:${i}`,
      yHighKey: `max:${i}`
    }));
  }
  getData(e) {
    return this.computeSeriesStatistics(e, (t) => ({
      min: Math.min(...t),
      max: Math.max(...t)
    }));
  }
}, X$ = class extends L {
  constructor() {
    super(...arguments), this.beanName = "enterpriseChartProxyFactory";
  }
  createChartProxy(e) {
    switch (e.chartType) {
      case "histogram":
        return new M$(e);
      case "radarLine":
      case "radarArea":
      case "nightingale":
      case "radialColumn":
      case "radialBar":
        return new G$(e);
      case "rangeBar":
      case "rangeArea":
        return new Y$(e);
      case "boxPlot":
        return new q$(e);
      case "treemap":
      case "sunburst":
        return new O$(e);
      case "heatmap":
        return new z$(e);
      case "waterfall":
        return new I$(e);
    }
  }
}, pS = class extends L {
  constructor(e, t, s, i) {
    super(), this.chartController = e, this.eGui = t, this.cssClass = s, this.createPanels = i, this.panels = [];
  }
  postConstruct() {
    this.addManagedListeners(this.chartController, {
      chartUpdated: () => this.refreshPanels(!0),
      chartApiUpdate: () => this.refreshPanels(!1)
    });
  }
  addComponent(e) {
    this.createBean(e), this.panels.push(e), e.addCssClass(this.cssClass), this.eGui.appendChild(e.getGui());
  }
  refreshPanels(e) {
    const t = this.chartController.getChartType(), s = this.chartController.isGrouping(), i = at(t);
    e && t === this.chartType && s === this.isGrouping || (this.destroyPanels(), this.createPanels(t, i), this.chartType = t, this.isGrouping = s);
  }
  destroyPanels() {
    this.panels.forEach((e) => {
      ut(e.getGui()), this.destroyBean(e);
    }), this.panels = [];
  }
  destroy() {
    this.destroyPanels(), super.destroy();
  }
}, Z$ = class extends _ {
  constructor(e) {
    super(), this.chartMenuParamsFactory = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = this.chartMenuParamsFactory.addEnableParams(
      "animation.enabled",
      {
        cssIdentifier: "charts-advanced-settings-top-level",
        direction: "vertical",
        suppressOpenCloseIcons: !0,
        title: this.chartTranslation.translate("animation"),
        suppressEnabledCheckbox: !0,
        useToggle: !0
      }
    ), t = this.chartMenuParamsFactory.getDefaultNumberInputParams(
      "animation.duration",
      "durationMillis",
      {
        min: 0
      }
    );
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="animationGroup">
                <ag-input-number-field data-ref="animationHeightInput"></ag-input>
            </ag-group-component>
        </div>`,
      [dt, wc],
      {
        animationGroup: e,
        animationHeightInput: t
      }
    );
  }
}, Q$ = class extends li {
  constructor() {
    super({
      template: (
        /* html */
        `
            <div role="presentation" class="ag-color-input">
                <div data-ref="eLabel" class="ag-input-field-label"></div>
                <div data-ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation">
                    <input data-ref="eInput" class="ag-input-field-input">
                    <div data-ref="eColor" class="ag-color-input-color"></div>
                </div>
            </div>`
      )
    }), this.eColor = E;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation, this.color = e.agChartsExports._Util.Color;
  }
  setColor(e) {
    const t = e.toRgbaString();
    this.setValue(this.color.fromString(t).toHexString().toUpperCase(), !0), this.eColor.style.backgroundColor = t;
  }
  setValue(e, t) {
    const s = this.color.validColorString(e ?? "");
    return this.eInput.setCustomValidity(s ? "" : this.chartTranslation.translate("invalidColor")), super.setValue(e, t), s && !t && this.dispatchLocalEvent({ type: "colorChanged" }), this;
  }
  onColorChanged(e) {
    this.addManagedListeners(this, { colorChanged: () => e(this.color.fromString(this.value)) });
  }
}, J$ = {
  selector: "AG-COLOR-INPUT",
  component: Q$
}, om = 8, el = [], ej = class extends _ {
  constructor(e) {
    super(
      /* html */
      `<div class="ag-color-panel" tabindex="-1">
            <div data-ref="spectrumColor" class="ag-spectrum-color">
                <div class="ag-spectrum-sat ag-spectrum-fill">
                    <div data-ref="spectrumVal" class="ag-spectrum-val ag-spectrum-fill">
                        <div data-ref="spectrumDragger" class="ag-spectrum-dragger"></div>
                    </div>
                </div>
            </div>
            <div class="ag-spectrum-tools">
                <div data-ref="spectrumHue" class="ag-spectrum-hue ag-spectrum-tool">
                    <div class="ag-spectrum-hue-background"></div>
                    <div data-ref="spectrumHueSlider" class="ag-spectrum-slider"></div>
                </div>
                <div data-ref="spectrumAlpha" class="ag-spectrum-alpha ag-spectrum-tool">
                    <div class="ag-spectrum-alpha-background"></div>
                    <div data-ref="spectrumAlphaSlider" class="ag-spectrum-slider"></div>
                </div>
                <ag-color-input data-ref="colorInput"></ag-color-input>
                <div data-ref="recentColors" class="ag-recent-colors"></div>
            </div>
        </div>`,
      [J$]
    ), this.H = 1, this.S = 1, this.B = 1, this.A = 1, this.isSpectrumDragging = !1, this.isSpectrumHueDragging = !1, this.isSpectrumAlphaDragging = !1, this.colorChanged = !1, this.spectrumColor = E, this.spectrumVal = E, this.spectrumDragger = E, this.spectrumHue = E, this.spectrumHueSlider = E, this.spectrumAlpha = E, this.spectrumAlphaSlider = E, this.colorInput = E, this.recentColors = E, this.picker = e.picker;
  }
  wireBeans(e) {
    this._Color = e.agChartsExports._Util.Color;
  }
  postConstruct() {
    this.initTabIndex(), this.initRecentColors(), this.addGuiEventListener("focus", () => this.spectrumColor.focus()), this.addGuiEventListener("keydown", (e) => {
      e.key === P.ENTER && !e.defaultPrevented && this.destroy();
    }), this.addManagedListeners(this.spectrumColor, { keydown: (e) => this.moveDragger(e) }), this.addManagedListeners(this.spectrumAlphaSlider, { keydown: (e) => this.moveAlphaSlider(e) }), this.addManagedListeners(this.spectrumHueSlider, { keydown: (e) => this.moveHueSlider(e) }), this.addManagedListeners(this.spectrumVal, { mousedown: this.onSpectrumDraggerDown.bind(this) }), this.addManagedListeners(this.spectrumHue, { mousedown: this.onSpectrumHueDown.bind(this) }), this.addManagedListeners(this.spectrumAlpha, { mousedown: this.onSpectrumAlphaDown.bind(this) }), this.addGuiEventListener("mousemove", (e) => {
      this.onSpectrumDraggerMove(e), this.onSpectrumHueMove(e), this.onSpectrumAlphaMove(e);
    }), this.addManagedListeners(document, { mouseup: this.onMouseUp.bind(this) }), this.colorInput.onColorChanged(this.setColor.bind(this)), this.addManagedListeners(this.recentColors, {
      click: this.onRecentColorClick.bind(this),
      keydown: (e) => {
        (e.key === P.ENTER || e.key === P.SPACE) && (e.preventDefault(), this.onRecentColorClick(e));
      }
    });
  }
  initTabIndex() {
    const e = this.tabIndex = this.gos.get("tabIndex").toString();
    this.spectrumColor.setAttribute("tabindex", e), this.spectrumHueSlider.setAttribute("tabindex", e), this.spectrumAlphaSlider.setAttribute("tabindex", e);
  }
  refreshSpectrumRect() {
    return this.spectrumValRect = this.spectrumVal.getBoundingClientRect();
  }
  refreshHueRect() {
    return this.spectrumHueRect = this.spectrumHue.getBoundingClientRect();
  }
  refreshAlphaRect() {
    return this.spectrumAlphaRect = this.spectrumAlpha.getBoundingClientRect();
  }
  onSpectrumDraggerDown(e) {
    e.preventDefault(), this.refreshSpectrumRect(), this.isSpectrumDragging = !0, this.moveDragger(e);
  }
  onSpectrumDraggerMove(e) {
    this.isSpectrumDragging && this.moveDragger(e);
  }
  onSpectrumHueDown(e) {
    this.refreshHueRect(), this.isSpectrumHueDragging = !0, this.moveHueSlider(e);
  }
  onSpectrumHueMove(e) {
    this.isSpectrumHueDragging && this.moveHueSlider(e);
  }
  onSpectrumAlphaDown(e) {
    this.refreshAlphaRect(), this.isSpectrumAlphaDragging = !0, this.moveAlphaSlider(e);
  }
  onSpectrumAlphaMove(e) {
    this.isSpectrumAlphaDragging && this.moveAlphaSlider(e);
  }
  onMouseUp() {
    this.isSpectrumDragging = !1, this.isSpectrumHueDragging = !1, this.isSpectrumAlphaDragging = !1;
  }
  moveDragger(e) {
    const t = this.spectrumValRect;
    if (!t)
      return;
    let s, i;
    if (e instanceof MouseEvent)
      s = e.clientX - t.left, i = e.clientY - t.top;
    else {
      const r = e.key === P.LEFT, n = e.key === P.RIGHT, o = e.key === P.UP, a = e.key === P.DOWN, l = o || a, c = r || n;
      if (!l && !c)
        return;
      e.preventDefault();
      const { x: d, y: u } = this.getSpectrumValue();
      s = d + (c ? r ? -5 : 5 : 0), i = u + (l ? o ? -5 : 5 : 0);
    }
    s = Math.max(s, 0), s = Math.min(s, t.width), i = Math.max(i, 0), i = Math.min(i, t.height), this.setSpectrumValue(s / t.width, 1 - i / t.height);
  }
  moveHueSlider(e) {
    const t = this.spectrumHueRect;
    if (!t)
      return;
    const s = this.moveSlider(this.spectrumHueSlider, e);
    s != null && (this.H = 1 - s / t.width, this.update());
  }
  moveAlphaSlider(e) {
    const t = this.spectrumAlphaRect;
    if (!t)
      return;
    const s = this.moveSlider(this.spectrumAlphaSlider, e);
    s != null && (this.A = s / t.width, this.update());
  }
  moveSlider(e, t) {
    var o;
    const s = e.getBoundingClientRect(), i = (o = e.parentElement) == null ? void 0 : o.getBoundingClientRect();
    if (!e || !i)
      return null;
    const r = s.width / 2;
    let n;
    if (t instanceof MouseEvent)
      n = Math.floor(t.clientX - i.left);
    else {
      const a = t.key === P.LEFT, l = t.key === P.RIGHT;
      if (!a && !l)
        return null;
      t.preventDefault();
      const c = a ? -5 : 5;
      n = parseFloat(e.style.left) + r + c;
    }
    return n = Math.max(n, 0), n = Math.min(n, i.width), e.style.left = n - r + "px", n;
  }
  update(e) {
    const { A: t, S: s, B: i, H: r, _Color: n } = this, o = r * 360, a = n.fromHSB(o, s, i, t), l = a.toRgbaString(), d = n.fromHSB(o, s, i).toRgbaString(), h = n.fromHSB(o, 1, 1).toRgbaString(), p = this.picker;
    n.fromString(p.getValue()).toRgbaString() !== l && (this.colorChanged = !0), p.setValue(l), this.spectrumColor.style.backgroundColor = h, this.spectrumDragger.style.backgroundColor = d, this.spectrumHueSlider.style.backgroundColor = h, this.spectrumAlpha.style.setProperty(
      "--ag-internal-spectrum-alpha-color-from",
      n.fromHSB(o, s, i, 0).toRgbaString()
    ), this.spectrumAlpha.style.setProperty("--ag-internal-spectrum-alpha-color-to", d), this.spectrumAlpha.style.setProperty("--ag-internal-spectrum-alpha-color", l), e || this.colorInput.setColor(a);
  }
  /**
   * @param saturation In the [0, 1] interval.
   * @param brightness In the [0, 1] interval.
   */
  setSpectrumValue(e, t, s) {
    const i = this.spectrumValRect || this.refreshSpectrumRect();
    if (i == null)
      return;
    const r = this.spectrumDragger, n = r.getBoundingClientRect();
    e = Math.max(0, e), e = Math.min(1, e), t = Math.max(0, t), t = Math.min(1, t), this.S = e, this.B = t, r.style.left = e * i.width - n.width / 2 + "px", r.style.top = (1 - t) * i.height - n.height / 2 + "px", this.update(s);
  }
  getSpectrumValue() {
    const e = this.spectrumDragger, t = e.getBoundingClientRect(), s = parseFloat(e.style.left) + t.width / 2, i = parseFloat(e.style.top) + t.height / 2;
    return { x: s, y: i };
  }
  initRecentColors() {
    const e = el, t = e.map((s, i) => (
      /* html */
      `<div class="ag-recent-color" id=${i} style="background-color: ${s}; width: 15px; height: 15px;" recent-color="${s}" tabIndex="${this.tabIndex}"></div>`
    ));
    this.recentColors.innerHTML = t.join(""), re(this.recentColors, !!e.length);
  }
  setValue(e) {
    const t = this._Color.fromString(e);
    this.setColor(t, !0);
  }
  setColor(e, t) {
    const [s, i, r] = e.toHSB();
    this.H = (isNaN(s) ? 0 : s) / 360, this.A = e.a;
    const n = this.spectrumHueRect || this.refreshHueRect(), o = this.spectrumAlphaRect || this.refreshAlphaRect();
    this.spectrumHueSlider.style.left = `${(this.H - 1) * -n.width - this.spectrumHueSlider.getBoundingClientRect().width / 2}px`, this.spectrumAlphaSlider.style.left = `${this.A * o.width - this.spectrumAlphaSlider.getBoundingClientRect().width / 2}px`, this.setSpectrumValue(i, r, !t);
  }
  onRecentColorClick(e) {
    const t = e.target;
    if (!W(t.id))
      return;
    const s = parseInt(t.id, 10);
    this.setValue(el[s]), this.destroy();
  }
  addRecentColor() {
    const t = this._Color.fromHSB(this.H * 360, this.S, this.B, this.A).toRgbaString();
    let s = el;
    !this.colorChanged || s[0] === t || (s = s.filter((i) => i != t), s = [t].concat(s), s.length > om && (s = s.slice(0, om)), el = s);
  }
  destroy() {
    this.addRecentColor(), super.destroy();
  }
}, gS = class extends Lh {
  constructor(e) {
    super({
      pickerAriaLabelKey: "ariaLabelColorPicker",
      pickerAriaLabelValue: "Color Picker",
      pickerType: "ag-list",
      className: "ag-color-picker",
      pickerIcon: "chartsColorPicker",
      ...e
    });
  }
  postConstruct() {
    const e = We(this.beans);
    this.eDisplayFieldColor = e.createElement("span"), this.eDisplayFieldColor.classList.add("ag-color-picker-color"), this.eDisplayFieldText = e.createElement("span"), this.eDisplayFieldText.classList.add("ag-color-picker-value"), this.eDisplayField.appendChild(this.eDisplayFieldColor), this.eDisplayField.appendChild(this.eDisplayFieldText), super.postConstruct(), this.value && this.setValue(this.value);
  }
  createPickerComponent() {
    const e = this.eWrapper.getBoundingClientRect(), t = this.beans.popupSvc.getParentRect();
    return this.createBean(
      new ya({
        closable: !1,
        modal: !0,
        hideTitleBar: !0,
        minWidth: 190,
        width: 190,
        height: 250,
        x: e.right - t.left - 190,
        y: e.top - t.top - 250 - (this.config.pickerGap ?? 0),
        postProcessPopupParams: {
          type: "colorPicker",
          eventSource: this.eWrapper
        }
      })
    );
  }
  renderAndPositionPicker() {
    const e = this.pickerComponent, t = this.createBean(new ej({ picker: this }));
    return e.addCssClass("ag-color-dialog"), t.addDestroyFunc(() => {
      e.isAlive() && this.destroyBean(e);
    }), e.setParentComponent(this), e.setBodyComponent(t), t.setValue(this.getValue()), t.getGui().focus(), e.addDestroyFunc(() => {
      this.isDestroyingPicker ? this.isDestroyingPicker = !1 : (this.beforeHidePicker(), this.isDestroyingPicker = !0, t.isAlive() && this.destroyBean(t), this.isAlive() && this.getFocusableElement().focus());
    }), () => {
      var s;
      return (s = this.pickerComponent) == null ? void 0 : s.close();
    };
  }
  setValue(e) {
    return this.value === e ? this : (this.eDisplayFieldColor.style.backgroundColor = e, this.eDisplayFieldText.textContent = this.beans.agChartsExports._Util.Color.fromString(
      e
    ).toHexString().toUpperCase(), super.setValue(e));
  }
  getValue() {
    return this.value;
  }
}, Ei = {
  selector: "AG-COLOR-PICKER",
  component: gS
}, tj = class extends _ {
  constructor(e) {
    super(), this.chartMenuParamsFactory = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = this.chartMenuParamsFactory.addEnableParams(
      "crosshair.enabled",
      {
        cssIdentifier: "charts-advanced-settings-top-level",
        direction: "vertical",
        suppressOpenCloseIcons: !0,
        title: this.chartTranslation.translate("crosshair"),
        suppressEnabledCheckbox: !0,
        useToggle: !0
      }
    ), t = this.chartMenuParamsFactory.getDefaultCheckboxParams(
      "crosshair.label.enabled",
      "crosshairLabel"
    ), s = this.chartMenuParamsFactory.getDefaultCheckboxParams(
      "crosshair.snap",
      "crosshairSnap"
    ), i = this.chartMenuParamsFactory.getDefaultColorPickerParams(
      "crosshair.stroke",
      "color"
    );
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="crosshairGroup">
                <ag-checkbox data-ref="crosshairLabelCheckbox"></ag-checkbox>
                <ag-checkbox data-ref="crosshairSnapCheckbox"></ag-checkbox>
                <ag-color-picker data-ref="crosshairStrokeColorPicker"></ag-color-picker>
            </ag-group-component>
        </div>`,
      [dt, ai, Ei],
      {
        crosshairGroup: e,
        crosshairLabelCheckbox: t,
        crosshairSnapCheckbox: s,
        crosshairStrokeColorPicker: i
      }
    );
  }
}, sj = class extends mr {
  constructor(e) {
    super(e, "ag-range-field", "range");
  }
  postConstruct() {
    super.postConstruct();
    const { min: e, max: t, step: s } = this.config;
    e != null && this.setMinValue(e), t != null && this.setMaxValue(t), this.setStep(s || 1);
  }
  addInputListeners() {
    this.addManagedElementListeners(this.eInput, {
      input: (e) => {
        const t = e.target.value;
        this.setValue(t);
      }
    });
  }
  setMinValue(e) {
    return this.min = e, this.eInput.setAttribute("min", e.toString()), this;
  }
  setMaxValue(e) {
    return this.max = e, this.eInput.setAttribute("max", e.toString()), this;
  }
  setStep(e) {
    return this.eInput.setAttribute("step", e.toString()), this;
  }
  setValue(e, t) {
    this.min != null && (e = Math.max(parseFloat(e), this.min).toString()), this.max != null && (e = Math.min(parseFloat(e), this.max).toString());
    const s = super.setValue(e, t);
    return this.eInput.value = e, s;
  }
}, ij = {
  selector: "AG-INPUT-RANGE",
  component: sj
}, Ts = class extends Ih {
  constructor(e) {
    super(
      e,
      /* html */
      `<div class="ag-slider">
            <label data-ref="eLabel"></label>
            <div class="ag-wrapper ag-slider-wrapper">
                <ag-input-range data-ref="eSlider"></ag-input-range>
                <ag-input-number-field data-ref="eText"></ag-input-number-field>
            </div>
        </div>`,
      [ij, wc]
    ), this.eLabel = E, this.eSlider = E, this.eText = E, this.labelAlignment = "top";
  }
  postConstruct() {
    super.postConstruct(), this.eSlider.addCssClass("ag-slider-field");
    const { minValue: e, maxValue: t, textFieldWidth: s, step: i, value: r, onValueChange: n } = this.config;
    e != null && this.setMinValue(e), t != null && this.setMaxValue(t), s != null && this.setTextFieldWidth(s), i != null && this.setStep(i), r != null && this.setValue(r), n != null && this.onValueChange(n);
  }
  onValueChange(e) {
    return this.addManagedListeners(this.eText, {
      fieldValueChanged: () => {
        const t = parseFloat(this.eText.getValue());
        this.eSlider.setValue(t.toString(), !0), e(t || 0);
      }
    }), this.addManagedListeners(this.eSlider, {
      fieldValueChanged: () => {
        const t = this.eSlider.getValue();
        this.eText.setValue(t, !0), e(parseFloat(t));
      }
    }), this;
  }
  setSliderWidth(e) {
    return this.eSlider.setWidth(e), this;
  }
  setTextFieldWidth(e) {
    return this.eText.setWidth(e), this;
  }
  setMinValue(e) {
    return this.eSlider.setMinValue(e), this.eText.setMin(e), this;
  }
  setMaxValue(e) {
    return this.eSlider.setMaxValue(e), this.eText.setMax(e), this;
  }
  getValue() {
    return this.eText.getValue();
  }
  setValue(e, t) {
    return this.getValue() === e ? this : (this.eText.setValue(e, !0), this.eSlider.setValue(e, !0), t || this.dispatchLocalEvent({ type: "fieldValueChanged" }), this);
  }
  setStep(e) {
    return this.eSlider.setStep(e), this.eText.setStep(e), this;
  }
}, xs = {
  selector: "AG-SLIDER",
  component: Ts
}, rj = class extends _ {
  constructor(e) {
    super(), this.chartMenuParamsFactory = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = this.chartMenuParamsFactory.addEnableParams(
      "navigator.enabled",
      {
        cssIdentifier: "charts-advanced-settings-top-level",
        direction: "vertical",
        suppressOpenCloseIcons: !0,
        title: this.chartTranslation.translate("navigator"),
        suppressEnabledCheckbox: !0,
        useToggle: !0
      }
    ), t = this.chartMenuParamsFactory.getDefaultSliderParams(
      "navigator.height",
      "height",
      60
    );
    t.minValue = 10;
    const s = this.chartMenuParamsFactory.getDefaultCheckboxParams(
      "navigator.miniChart.enabled",
      "miniChart"
    );
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="navigatorGroup">
                <ag-slider data-ref="navigatorHeightSlider"></ag-slider>
                <ag-checkbox data-ref="navigatorMiniChartCheckbox"></ag-checkbox>
            </ag-group-component>
        </div>`,
      [dt, xs, ai],
      {
        navigatorGroup: e,
        navigatorHeightSlider: t,
        navigatorMiniChartCheckbox: s
      }
    );
  }
}, nj = class extends _ {
  constructor(e) {
    super(), this.chartMenuParamsFactory = e, this.zoomScrollingStepInput = E;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = this.chartMenuParamsFactory.addEnableParams("zoom.enabled", {
      cssIdentifier: "charts-advanced-settings-top-level",
      direction: "vertical",
      suppressOpenCloseIcons: !0,
      title: this.chartTranslation.translate("zoom"),
      suppressEnabledCheckbox: !0,
      useToggle: !0
    }), t = this.chartMenuParamsFactory.getDefaultCheckboxParams(
      "zoom.enableScrolling",
      "scrollingZoom"
    ), s = this.chartMenuParamsFactory.getDefaultSliderParams(
      "zoom.scrollingStep",
      "scrollingStep",
      1
    );
    s.step = 0.01, s.minValue = s.step;
    const i = this.chartMenuParamsFactory.getDefaultCheckboxParams(
      "zoom.enableSelecting",
      "selectingZoom"
    );
    t.onValueChange = /* @__PURE__ */ ((r) => (n) => {
      r && (r(n), this.zoomScrollingStepInput.setDisabled(!n));
    })(t.onValueChange), this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="zoomGroup">
                <ag-checkbox data-ref="zoomSelectingCheckbox"></ag-checkbox>
                <ag-checkbox data-ref="zoomScrollingCheckbox"></ag-checkbox>
                <ag-slider data-ref="zoomScrollingStepInput"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, ai, xs],
      {
        zoomGroup: e,
        zoomScrollingCheckbox: t,
        zoomScrollingStepInput: s,
        zoomSelectingCheckbox: i
      }
    ), this.zoomScrollingStepInput.setDisabled(!t.value);
  }
}, oj = ["navigator", "zoom", "animation", "crosshair"], aj = class extends _ {
  constructor(e) {
    super(
      /* html */
      '<div class="ag-chart-advanced-settings-wrapper"></div>'
    ), this.chartMenuContext = e;
  }
  postConstruct() {
    this.chartPanelFeature = this.createManagedBean(
      new pS(
        this.chartMenuContext.chartController,
        this.getGui(),
        "ag-chart-advanced-settings-section",
        (e, t) => this.createPanels(e, t)
      )
    ), this.chartPanelFeature.refreshPanels();
  }
  createPanels(e, t) {
    oj.forEach((s) => {
      if (!this.isGroupPanelShownForSeries(s, t))
        return;
      const i = this.createPanel(s);
      this.chartPanelFeature.addComponent(i);
    });
  }
  isGroupPanelShownForSeries(e, t) {
    return e === "animation" || vr(t);
  }
  createPanel(e) {
    const { chartMenuParamsFactory: t, chartAxisMenuParamsFactory: s } = this.chartMenuContext;
    switch (e) {
      case "navigator":
        return new rj(t);
      case "zoom":
        return new nj(t);
      case "animation":
        return new Z$(t);
      case "crosshair":
        return new tj(s);
    }
  }
}, lj = class extends L {
  constructor() {
    super(...arguments), this.beanName = "advSettingsMenuFactory";
  }
  showMenu(e, t) {
    this.hideMenu();
    const s = this.createBean(new cj(e));
    this.activeDialog = this.createBean(
      new ya({
        title: this.beans.chartTranslation.translate("advancedSettings"),
        component: s,
        width: 300,
        height: 400,
        resizable: !0,
        movable: !0,
        centered: !0,
        closable: !0,
        afterGuiAttached: () => {
          var i;
          (i = ii(s.getGui())[0]) == null || i.focus();
        },
        closedCallback: () => {
          this.activeMenu = this.destroyBean(this.activeMenu), this.activeDialog = void 0, t == null || t.focus({ preventScroll: !0 });
        }
      })
    ), this.activeMenu = s;
  }
  hideMenu() {
    this.activeDialog && this.destroyBean(this.activeDialog);
  }
  destroy() {
    this.activeMenu = this.destroyBean(this.activeMenu), this.activeDialog = this.destroyBean(this.activeDialog), super.destroy();
  }
}, cj = class extends Ti {
  constructor(e) {
    super(
      /* html */
      '<div class="ag-chart-advanced-settings"></div>'
    ), this.chartMenuContext = e;
  }
  postConstruct() {
    this.advancedSettingsPanel = this.createManagedBean(new aj(this.chartMenuContext)), this.getGui().appendChild(this.advancedSettingsPanel.getGui()), this.initialiseTabGuard({
      onTabKeyDown: this.onTabKeyDown.bind(this),
      focusTrapActive: !0
    });
  }
  onTabKeyDown(e) {
    if (e.defaultPrevented)
      return;
    e.preventDefault();
    const t = e.shiftKey, s = this.advancedSettingsPanel.getGui(), i = zt(this.beans, s, !1, t);
    if (i)
      i.focus();
    else {
      const r = ii(s);
      r.length && r[t ? r.length - 1 : 0].focus();
    }
  }
}, dj = class extends L {
  constructor() {
    super(...arguments), this.beanName = "chartMenuListFactory";
  }
  wireBeans(e) {
    this.popupSvc = e.popupSvc, this.chartMenuSvc = e.chartMenuSvc, this.chartTranslation = e.chartTranslation;
  }
  showMenuList(e) {
    const { eventSource: t, showMenu: s, chartMenuContext: i } = e, r = this.chartMenuSvc.doChartToolPanelsExist(i.chartController), n = this.mapWithStockItems(
      this.getMenuItems(i.chartController, r),
      i,
      s,
      t,
      r
    );
    if (!n.length)
      return;
    const o = this.createBean(new uj(n));
    this.activeChartMenuList = o;
    let a = -1, l = "left";
    this.gos.get("enableRtl") && (a = 1, l = "right");
    const c = o.getGui();
    this.popupSvc.addPopup({
      modal: !0,
      eChild: c,
      closeOnEsc: !0,
      closedCallback: () => {
        this.destroyBean(o), this.activeChartMenuList = void 0, Fr(this.beans) && t.focus({ preventScroll: !0 });
      },
      afterGuiAttached: (d) => o.afterGuiAttached(d),
      positionCallback: () => {
        this.popupSvc.positionPopupByComponent({
          type: "chartMenu",
          eventSource: t,
          ePopup: c,
          alignSide: l,
          nudgeX: 4 * a,
          nudgeY: 4,
          position: "under",
          keepWithinBounds: !0
        });
      },
      ariaLabel: "Chart Menu"
    });
  }
  getMenuItems(e, t) {
    const s = [
      ...t ? ["chartEdit"] : [],
      ...e.isEnterprise() ? ["chartAdvancedSettings"] : [],
      e.isChartLinked() ? "chartUnlink" : "chartLink",
      "chartDownload"
    ], i = this.gos.get("chartMenuItems");
    return i ? Array.isArray(i) ? i : i(
      this.gos.addGridCommonParams({
        defaultItems: s
      })
    ) : s;
  }
  mapWithStockItems(e, t, s, i, r) {
    if (!e)
      return [];
    const n = [];
    return e.forEach((o) => {
      let a;
      if (typeof o == "string" ? a = this.getStockMenuItem(
        o,
        t,
        s,
        i,
        r
      ) : a = { ...o }, !a)
        return;
      const { subMenu: l } = a;
      Array.isArray(l) && (a.subMenu = this.mapWithStockItems(
        l,
        t,
        s,
        i,
        r
      )), n.push(a);
    }), n;
  }
  getStockMenuItem(e, t, s, i, r) {
    switch (e) {
      case "chartEdit":
        return r ? this.createMenuItem(this.chartTranslation.translate("chartEdit"), "chartsMenuEdit", s) : null;
      case "chartAdvancedSettings":
        return this.createMenuItem(
          this.chartTranslation.translate("chartAdvancedSettings"),
          "chartsMenuAdvancedSettings",
          () => this.chartMenuSvc.openAdvancedSettings(t, i)
        );
      case "chartUnlink":
        return t.chartController.isChartLinked() ? this.createMenuItem(
          this.chartTranslation.translate("chartUnlink"),
          "unlinked",
          () => this.chartMenuSvc.toggleLinked(t)
        ) : null;
      case "chartLink":
        return t.chartController.isChartLinked() ? null : this.createMenuItem(
          this.chartTranslation.translate("chartLink"),
          "linked",
          () => this.chartMenuSvc.toggleLinked(t)
        );
      case "chartDownload":
        return this.createMenuItem(
          this.chartTranslation.translate("chartDownload"),
          "chartsDownload",
          () => this.chartMenuSvc.downloadChart(t)
        );
    }
    return null;
  }
  createMenuItem(e, t, s) {
    return {
      name: e,
      icon: ue(t, this.beans, null),
      action: s
    };
  }
  destroy() {
    this.destroyBean(this.activeChartMenuList), super.destroy();
  }
}, uj = class extends _ {
  constructor(e) {
    super(
      /* html */
      `
            <div data-ref="eChartsMenu" role="presentation" class="ag-menu ag-chart-menu-popup"></div>
        `
    ), this.menuItems = e, this.eChartsMenu = E;
  }
  postConstruct() {
    this.mainMenuList = this.createManagedBean(new ba(0)), this.mainMenuList.addMenuItems(this.menuItems), this.mainMenuList.addEventListener("closeMenu", this.onHidePopup.bind(this)), this.eChartsMenu.appendChild(this.mainMenuList.getGui());
  }
  onHidePopup() {
    var e;
    (e = this.hidePopupFunc) == null || e.call(this);
  }
  afterGuiAttached({ hidePopup: e }) {
    e && (this.hidePopupFunc = e, this.addDestroyFunc(e)), Dt(this.mainMenuList.getGui());
  }
}, hj = class extends L {
  constructor() {
    super(...arguments), this.beanName = "chartCrossFilterSvc";
  }
  wireBeans(e) {
    this.colModel = e.colModel, this.valueSvc = e.valueSvc, this.filterManager = e.filterManager, Ye(this.gos, e.rowModel) && (this.clientSideRowModel = e.rowModel);
  }
  filter(e, t = !1) {
    var r;
    const s = ((r = this.filterManager) == null ? void 0 : r.getFilterModel()) ?? {};
    if (t) {
      this.resetFilters(s);
      return;
    }
    const i = this.extractFilterColId(e);
    this.isValidColumnFilter(i) ? this.updateFilters(s, e, i) : I(154, { colId: i });
  }
  resetFilters(e) {
    var s, i;
    Object.keys(e).length > 0 && ((s = this.filterManager) == null || s.setFilterModel(null), (i = this.filterManager) == null || i.onFilterChanged({ source: "api" }));
  }
  updateFilters(e, t, s) {
    var o;
    const i = this.extractFilterColId(t), r = t.datum[i];
    if (r === void 0)
      return;
    const n = r.toString();
    if (t.event.metaKey || t.event.ctrlKey) {
      const a = this.getCurrentGridValuesForCategory(s), l = a.includes(n);
      let c;
      l ? c = a.filter((d) => d !== n) : (c = a, c.push(n)), e[s] = this.getUpdatedFilterModel(s, c);
    } else {
      const a = [n];
      e = { [s]: this.getUpdatedFilterModel(s, a) };
    }
    (o = this.filterManager) == null || o.setFilterModel(e);
  }
  getUpdatedFilterModel(e, t) {
    return this.getColumnFilterType(e) === "agMultiColumnFilter" ? { filterType: "multi", filterModels: [null, { filterType: "set", values: t }] } : { filterType: "set", values: t };
  }
  getCurrentGridValuesForCategory(e) {
    var i;
    const t = [], s = this.getColumnById(e);
    return (i = this.clientSideRowModel) == null || i.forEachNodeAfterFilter((r) => {
      if (s && !r.group) {
        const n = this.valueSvc.getValue(s, r) + "";
        t.includes(n) || t.push(n);
      }
    }), t;
  }
  extractFilterColId(e) {
    return e.xKey || e.calloutLabelKey;
  }
  isValidColumnFilter(e) {
    e.indexOf("-filtered-out") && (e = e.replace("-filtered-out", ""));
    const t = this.getColumnFilterType(e);
    return typeof t == "boolean" ? t : ["agSetColumnFilter", "agMultiColumnFilter"].includes(t);
  }
  getColumnFilterType(e) {
    const t = this.getColumnById(e);
    if (t)
      return t.getColDef().filter;
  }
  getColumnById(e) {
    return this.colModel.getCol(e);
  }
}, pj = [
  "chartUnlink",
  "chartLink",
  "chartDownload",
  "chartMenu"
], gl = {
  settings: "chartSettings",
  data: "chartData",
  format: "chartFormat"
}, gj = class extends L {
  constructor() {
    super(...arguments), this.beanName = "chartMenuSvc";
  }
  wireBeans(e) {
    this.advSettingsMenuFactory = e.advSettingsMenuFactory;
  }
  downloadChart(e, t, s, i) {
    e.chartController.getChartProxy().downloadChart(t, s, i);
  }
  toggleLinked(e) {
    e.chartController.detachChartRange();
  }
  openAdvancedSettings(e, t) {
    var s;
    (s = this.advSettingsMenuFactory) == null || s.showMenu(e, t);
  }
  hideAdvancedSettings() {
    var e;
    (e = this.advSettingsMenuFactory) == null || e.hideMenu();
  }
  getChartToolbarOptions() {
    const e = ["chartMenu"], t = this.gos.getCallback("getChartToolbarItems");
    return t ? t({
      defaultItems: e
    }).filter((i) => pj.includes(i) ? !0 : (I(155, { option: i }), !1)) : e;
  }
  getChartToolPanels(e) {
    var o;
    const t = this.gos.get("chartToolPanelsDef");
    let i = ((o = t == null ? void 0 : t.panels) == null ? void 0 : o.map((a) => {
      const l = gl[a];
      return l || I(156, { panel: a }), l;
    }).filter((a) => !!a)) ?? Object.values(gl);
    e.isPivotChart() && (i = i.filter((a) => a !== "chartData"));
    const r = t == null ? void 0 : t.defaultToolPanel, n = r && gl[r] || i[0];
    return {
      panels: i,
      defaultPanel: n
    };
  }
  doesChartToolbarExist() {
    return this.getChartToolbarOptions().length > 0;
  }
  doChartToolPanelsExist(e) {
    const { panels: t } = this.getChartToolPanels(e);
    return t.length > 0;
  }
}, fj = {
  pivotChartTitle: "Pivot Chart",
  rangeChartTitle: "Range Chart",
  settings: "Chart",
  data: "Set Up",
  format: "Customize",
  categories: "Categories",
  defaultCategory: "(None)",
  series: "Series",
  switchCategorySeries: "Switch Category / Series",
  categoryValues: "Category Values",
  seriesLabels: "Series Labels",
  aggregate: "Aggregate",
  xyValues: "X Y Values",
  paired: "Paired Mode",
  axis: "Axis",
  xAxis: "Horizontal Axis",
  yAxis: "Vertical Axis",
  polarAxis: "Polar Axis",
  radiusAxis: "Radius Axis",
  navigator: "Navigator",
  zoom: "Zoom",
  animation: "Animation",
  crosshair: "Crosshair",
  color: "Color",
  thickness: "Thickness",
  preferredLength: "Preferred Length",
  xType: "X Type",
  axisType: "Axis Type",
  automatic: "Automatic",
  category: "Category",
  number: "Number",
  time: "Time",
  timeFormat: "Time Format",
  autoRotate: "Auto Rotate",
  labelRotation: "Rotation",
  circle: "Circle",
  polygon: "Polygon",
  square: "Square",
  cross: "Cross",
  diamond: "Diamond",
  plus: "Plus",
  triangle: "Triangle",
  heart: "Heart",
  orientation: "Orientation",
  fixed: "Fixed",
  parallel: "Parallel",
  perpendicular: "Perpendicular",
  radiusAxisPosition: "Position",
  ticks: "Ticks",
  gridLines: "Grid Lines",
  width: "Width",
  height: "Height",
  length: "Length",
  padding: "Padding",
  spacing: "Spacing",
  chartStyle: "Chart Style",
  title: "Title",
  chartTitles: "Titles",
  chartTitle: "Chart Title",
  chartSubtitle: "Subtitle",
  horizontalAxisTitle: "Horizontal Axis Title",
  verticalAxisTitle: "Vertical Axis Title",
  polarAxisTitle: "Polar Axis Title",
  titlePlaceholder: "Chart Title",
  background: "Background",
  font: "Font",
  weight: "Weight",
  top: "Top",
  right: "Right",
  bottom: "Bottom",
  left: "Left",
  labels: "Labels",
  calloutLabels: "Callout Labels",
  sectorLabels: "Sector Labels",
  positionRatio: "Position Ratio",
  size: "Size",
  shape: "Shape",
  minSize: "Minimum Size",
  maxSize: "Maximum Size",
  legend: "Legend",
  position: "Position",
  markerSize: "Marker Size",
  markerStroke: "Marker Stroke",
  markerPadding: "Marker Padding",
  itemSpacing: "Item Spacing",
  itemPaddingX: "Item Padding X",
  itemPaddingY: "Item Padding Y",
  layoutHorizontalSpacing: "Horizontal Spacing",
  layoutVerticalSpacing: "Vertical Spacing",
  strokeWidth: "Stroke Width",
  offset: "Offset",
  offsets: "Offsets",
  tooltips: "Tooltips",
  callout: "Callout",
  markers: "Markers",
  shadow: "Shadow",
  blur: "Blur",
  xOffset: "X Offset",
  yOffset: "Y Offset",
  lineWidth: "Line Width",
  lineDash: "Line Dash",
  lineDashOffset: "Dash Offset",
  scrollingZoom: "Scrolling",
  scrollingStep: "Scrolling Step",
  selectingZoom: "Selecting",
  durationMillis: "Duration (ms)",
  crosshairLabel: "Label",
  crosshairSnap: "Snap to Node",
  normal: "Normal",
  bold: "Bold",
  italic: "Italic",
  boldItalic: "Bold Italic",
  predefined: "Predefined",
  fillOpacity: "Fill Opacity",
  strokeColor: "Line Color",
  strokeOpacity: "Line Opacity",
  miniChart: "Mini-Chart",
  histogramBinCount: "Bin count",
  connectorLine: "Connector Line",
  seriesItems: "Series Items",
  seriesItemType: "Item Type",
  seriesItemPositive: "Positive",
  seriesItemNegative: "Negative",
  seriesItemLabels: "Item Labels",
  columnGroup: "Column",
  barGroup: "Bar",
  pieGroup: "Pie",
  lineGroup: "Line",
  scatterGroup: "X Y (Scatter)",
  areaGroup: "Area",
  polarGroup: "Polar",
  statisticalGroup: "Statistical",
  hierarchicalGroup: "Hierarchical",
  specializedGroup: "Specialized",
  combinationGroup: "Combination",
  groupedColumnTooltip: "Grouped",
  stackedColumnTooltip: "Stacked",
  normalizedColumnTooltip: "100% Stacked",
  groupedBarTooltip: "Grouped",
  stackedBarTooltip: "Stacked",
  normalizedBarTooltip: "100% Stacked",
  pieTooltip: "Pie",
  donutTooltip: "Donut",
  lineTooltip: "Line",
  stackedLineTooltip: "Stacked",
  normalizedLineTooltip: "100% Stacked",
  groupedAreaTooltip: "Area",
  stackedAreaTooltip: "Stacked",
  normalizedAreaTooltip: "100% Stacked",
  scatterTooltip: "Scatter",
  bubbleTooltip: "Bubble",
  histogramTooltip: "Histogram",
  radialColumnTooltip: "Radial Column",
  radialBarTooltip: "Radial Bar",
  radarLineTooltip: "Radar Line",
  radarAreaTooltip: "Radar Area",
  nightingaleTooltip: "Nightingale",
  rangeBarTooltip: "Range Bar",
  rangeAreaTooltip: "Range Area",
  boxPlotTooltip: "Box Plot",
  treemapTooltip: "Treemap",
  sunburstTooltip: "Sunburst",
  waterfallTooltip: "Waterfall",
  heatmapTooltip: "Heatmap",
  columnLineComboTooltip: "Column & Line",
  areaColumnComboTooltip: "Area & Column",
  customComboTooltip: "Custom Combination",
  innerRadius: "Inner Radius",
  startAngle: "Start Angle",
  endAngle: "End Angle",
  reverseDirection: "Reverse Direction",
  groupPadding: "Group Padding",
  seriesPadding: "Series Padding",
  tile: "Tile",
  whisker: "Whisker",
  cap: "Cap",
  capLengthRatio: "Length Ratio",
  labelPlacement: "Placement",
  inside: "Inside",
  outside: "Outside",
  noDataToChart: "No data available to be charted.",
  pivotChartRequiresPivotMode: "Pivot Chart requires Pivot Mode enabled.",
  chartSettingsToolbarTooltip: "Menu",
  chartLinkToolbarTooltip: "Linked to Grid",
  chartUnlinkToolbarTooltip: "Unlinked from Grid",
  chartDownloadToolbarTooltip: "Download Chart",
  chartMenuToolbarTooltip: "Menu",
  chartEdit: "Edit Chart",
  chartAdvancedSettings: "Advanced Settings",
  chartLink: "Link to Grid",
  chartUnlink: "Unlink from Grid",
  chartDownload: "Download Chart",
  histogramFrequency: "Frequency",
  seriesChartType: "Series Chart Type",
  seriesType: "Series Type",
  secondaryAxis: "Secondary Axis",
  seriesAdd: "Add a series",
  categoryAdd: "Add a category",
  bar: "Bar",
  column: "Column",
  histogram: "Histogram",
  advancedSettings: "Advanced Settings",
  direction: "Direction",
  horizontal: "Horizontal",
  vertical: "Vertical",
  seriesGroupType: "Group Type",
  groupedSeriesGroupType: "Grouped",
  stackedSeriesGroupType: "Stacked",
  normalizedSeriesGroupType: "100% Stacked",
  legendEnabled: "Enabled",
  invalidColor: "Color value is invalid",
  groupedColumnFull: "Grouped Column",
  stackedColumnFull: "Stacked Column",
  normalizedColumnFull: "100% Stacked Column",
  groupedBarFull: "Grouped Bar",
  stackedBarFull: "Stacked Bar",
  normalizedBarFull: "100% Stacked Bar",
  stackedAreaFull: "Stacked Area",
  normalizedAreaFull: "100% Stacked Area",
  stackedLineFull: "Stacked Line",
  normalizedLineFull: "100% Stacked Line",
  customCombo: "Custom Combination",
  // menu items
  groupedColumn: "Grouped",
  stackedColumn: "Stacked",
  pie: "Pie",
  donut: "Donut",
  line: "Line",
  scatter: "Scatter",
  bubble: "Bubble",
  area: "Area",
  stackedArea: "Stacked",
  radarLine: "Radar Line",
  radarArea: "Radar Area",
  nightingale: "Nightingale",
  radialColumn: "Radial Column",
  radialBar: "Radial Bar",
  boxPlot: "Box Plot",
  rangeBar: "Range Bar",
  rangeArea: "Range Area",
  treemap: "Treemap",
  sunburst: "Sunburst",
  waterfall: "Waterfall",
  heatmap: "Heatmap",
  columnLineCombo: "Column & Line",
  AreaColumnCombo: "Area & Column",
  // aria
  ariaChartMenuClose: "Close Chart Edit Menu",
  ariaChartSelected: "Selected",
  // group
  group: "Group",
  // time formats
  timeFormatSlashesDDMMYYYY: "DD/MM/YYYY",
  timeFormatSlashesMMDDYYYY: "MM/DD/YYYY",
  timeFormatSlashesDDMMYY: "DD/MM/YY",
  timeFormatSlashesMMDDYY: "MM/DD/YY",
  timeFormatDotsDDMYY: "DD.M.YY",
  timeFormatDotsMDDYY: "M.DD.YY",
  timeFormatDashesYYYYMMDD: "YYYY-MM-DD",
  timeFormatSpacesDDMMMMYYYY: "DD MMMM YYYY",
  timeFormatHHMMSS: "HH:MM:SS",
  timeFormatHHMMSSAmPm: "HH:MM:SS AM/PM",
  // agg funcs
  sum: "Sum",
  first: "First",
  last: "Last",
  min: "Min",
  max: "Max",
  count: "Count",
  avg: "Average"
}, mj = class extends L {
  constructor() {
    super(...arguments), this.beanName = "chartTranslation";
  }
  translate(e) {
    const t = this.getLocaleTextFunc(), s = fj[e];
    return t(e, s);
  }
}, uo = (e) => (t) => t == null ? !0 : e(t), am = (e) => typeof e == "string", fS = (e) => typeof e == "boolean", Cj = (e) => typeof e == "object", Bi = (e, t) => (s) => `AG Grid - unable to update chart as invalid params supplied:  \`${e}: ${s}\`, expected ${t}.`, mS = (e) => `${e} is not supported in AG Charts Community ('ag-charts-enterprise' hasn't been loaded). See https://www.ag-grid.com/javascript-data-grid/integrated-charts-installation/ for more details.`, vj = ["doughnut"], np = [
  "type",
  "chartId",
  "chartType",
  "chartThemeName",
  "chartThemeOverrides",
  "unlinkChart"
];
function wj(e) {
  return !!oS(e) || tp(e);
}
function yj(e) {
  return vj.includes(e);
}
var bj = uo(
  (e) => {
    if (wj(e))
      return !0;
    if (yj(e)) {
      const t = ua(e);
      return Si(`The chart type '${e}' has been deprecated. Please use '${t}' instead.`), t;
    }
    return !1;
  }
), Sj = uo((e) => typeof e == "object"), xj = uo((e) => typeof e == "object"), Rj = uo((e) => typeof e == "string" || typeof e == "function"), CS = (e) => ({
  property: "chartType",
  validationFn: uo(
    (t) => e || !t || !C$(t)
  ),
  warnMessage: (t) => mS(`The '${t}' chart type`)
}), vS = (e) => ({
  property: "switchCategorySeries",
  validationFn: uo((t) => {
    if (!t || e)
      return !0;
  }),
  warnMessage: () => mS("'switchCategorySeries' has been ignored as it"),
  warnIfFixed: !0
}), op = () => [
  { property: "chartId", validationFn: am, warnMessage: Bi("chartId", "string") },
  {
    property: "chartType",
    validationFn: bj,
    warnMessage: Bi("chartType", "ChartType")
  },
  {
    property: "chartThemeName",
    validationFn: am,
    warnMessage: Bi("chartThemeName", "string")
  },
  {
    property: "chartThemeOverrides",
    validationFn: Sj,
    warnMessage: Bi("chartThemeOverrides", "AgChartThemeOverrides")
  },
  { property: "unlinkChart", validationFn: fS, warnMessage: Bi("unlinkChart", "boolean") }
], wS = (e) => [
  {
    property: "cellRange",
    validationFn: xj,
    warnMessage: Bi("cellRange", "ChartParamsCellRange")
  },
  {
    property: "suppressChartRanges",
    validationFn: fS,
    warnMessage: Bi("suppressChartRanges", "boolean")
  },
  {
    property: "aggFunc",
    validationFn: Rj,
    warnMessage: Bi("aggFunc", "string or IAggFunc")
  },
  vS(e)
];
function Fj(e, t) {
  switch (e.type) {
    case "rangeChartUpdate":
      return Tj(e, t);
    case "pivotChartUpdate":
      return Ej(e);
    case "crossFilterChartUpdate":
      return Dj(e, t);
    default:
      return Si(
        `Invalid value supplied for 'type': ${e.type}. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.`
      ), !1;
  }
}
function Pj(e, t) {
  return Ic(e, [
    CS(t),
    vS(t)
  ]);
}
function Tj(e, t) {
  const s = [
    ...op(),
    CS(t),
    ...wS(t),
    {
      property: "seriesChartTypes",
      validationFn: (i) => i === void 0 || Array.isArray(i) && i.every(Cj),
      warnMessage: Bi("seriesChartTypes", "Array of SeriesChartType")
    }
  ];
  return Ic(
    e,
    s,
    [
      ...np,
      "cellRange",
      "suppressChartRanges",
      "switchCategorySeries",
      "aggFunc",
      "seriesChartTypes",
      "seriesGroupType"
    ],
    "UpdateRangeChartParams"
  );
}
function Ej(e) {
  const t = [...op()];
  return Ic(e, t, [...np], "UpdatePivotChartParams");
}
function Dj(e, t) {
  const s = [
    ...op(),
    ...wS(t)
  ];
  return Ic(
    e,
    s,
    [...np, "cellRange", "suppressChartRanges", "aggFunc"],
    "UpdateCrossFilterChartParams"
  );
}
function Ic(e, t, s, i) {
  let r;
  for (const n of t) {
    const { property: o, validationFn: a, warnMessage: l, warnIfFixed: c } = n;
    if (o in e) {
      const d = e[o], u = a(d);
      if (u === !0)
        continue;
      if (u === !1)
        return Si(l(d)), !1;
      r = r || { ...e }, r[o] = u, c && Si(l(d));
    }
  }
  if (s) {
    for (const n of Object.keys(e))
      if (!s.includes(n))
        return Si(`Unexpected property supplied. ${i} does not contain: \`${n}\`.`), !1;
  }
  return r || !0;
}
var yS = ["ag-default", "ag-material", "ag-sheets", "ag-polychroma", "ag-vivid"], Aj = class extends L {
  constructor(e) {
    super(), this.model = e, this.isEnterprise = () => this.agChartsExports.isEnterprise;
  }
  wireBeans(e) {
    this.rangeSvc = e.rangeSvc, this.agChartsExports = e.agChartsExports;
  }
  postConstruct() {
    this.setChartRange(), this.model.unlinked && this.rangeSvc && this.rangeSvc.setCellRanges([]);
    const e = this.updateForGridChange.bind(this, {});
    this.addManagedEventListeners({
      cellSelectionChanged: (t) => {
        t.id && t.id === this.model.chartId && this.updateForRangeChange();
      },
      columnMoved: e,
      columnPinned: e,
      columnVisible: e,
      columnRowGroupChanged: e,
      modelUpdated: e,
      cellValueChanged: this.updateForDataChange.bind(this)
    });
  }
  update(e) {
    if (!this.validUpdateType(e))
      return !1;
    const t = Fj(e, this.agChartsExports.isEnterprise);
    if (!t)
      return !1;
    const s = t === !0 ? e : t;
    return this.applyValidatedChartParams(s), !0;
  }
  applyValidatedChartParams(e) {
    var l;
    const { chartId: t, chartType: s, chartThemeName: i, unlinkChart: r } = e, o = { ...{
      chartId: t,
      pivotChart: this.model.pivotChart,
      chartType: s ?? this.model.chartType,
      chartThemeName: i ?? this.model.chartThemeName,
      unlinkChart: r ?? this.model.unlinked,
      cellRange: this.model.suppliedCellRange,
      switchCategorySeries: this.model.switchCategorySeries,
      aggFunc: this.model.aggFunc,
      seriesChartTypes: void 0,
      suppressChartRanges: !1,
      crossFiltering: !1
    } };
    switch (e.type) {
      case "rangeChartUpdate":
        o.cellRange = this.createCellRange(e) ?? this.model.suppliedCellRange, o.switchCategorySeries = e.switchCategorySeries ?? this.model.switchCategorySeries, o.aggFunc = e.aggFunc ?? this.model.aggFunc, o.seriesChartTypes = e.seriesChartTypes, o.suppressChartRanges = e.suppressChartRanges ?? this.model.suppressChartRanges, o.seriesGroupType = e.seriesGroupType ?? this.model.seriesGroupType;
        break;
      case "crossFilterChartUpdate":
        o.cellRange = this.createCellRange(e) ?? this.model.suppliedCellRange, o.switchCategorySeries = !1, o.aggFunc = e.aggFunc ?? this.model.aggFunc, o.crossFiltering = !0, o.suppressChartRanges = e.suppressChartRanges ?? this.model.suppressChartRanges;
        break;
      case "pivotChartUpdate":
        o.switchCategorySeries = !1;
        break;
    }
    this.model.updateModel(o), o.unlinkChart || o.suppressChartRanges ? (l = this.rangeSvc) == null || l.setCellRanges([]) : this.setChartRange();
  }
  updateForGridChange(e) {
    if (this.model.unlinked)
      return;
    const { maintainColState: t, setColsFromRange: s } = e ?? {};
    this.model.updateCellRanges({ maintainColState: t, setColsFromRange: s }), this.model.updateData(), this.setChartRange();
  }
  updateForDataChange() {
    this.model.unlinked || (this.model.updateData(), this.raiseChartModelUpdateEvent());
  }
  updateForRangeChange() {
    this.updateForGridChange({ setColsFromRange: !0 }), this.raiseChartRangeSelectionChangedEvent();
  }
  updateForPanelChange(e) {
    this.model.updateCellRanges(e), this.model.updateData(), e.skipAnimation && this.getChartProxy().getChartRef().skipAnimations(), this.setChartRange(), this.raiseChartRangeSelectionChangedEvent();
  }
  updateThemeOverrides(e) {
    this.chartProxy.updateThemeOverrides(e);
  }
  getChartUpdateParams(e) {
    const s = this.getSelectedValueColState().map((o) => ({ colId: o.colId, displayName: o.displayName })), i = this.getChartData(), r = this.getSelectedDimensions(), n = {
      data: i,
      groupData: this.model.groupChartData,
      grouping: this.isGrouping(),
      categories: r.map((o) => ({
        id: o.colId,
        name: o.displayName,
        chartDataType: this.model.categoryAxisType ?? this.model.getChartDataType(o.colId)
      })),
      fields: s,
      chartId: this.getChartId(),
      getCrossFilteringContext: () => ({ lastSelectedChartId: "xxx" }),
      //this.params.crossFilteringContext, //TODO
      seriesChartTypes: this.getSeriesChartTypes(),
      updatedOverrides: e,
      seriesGroupType: this.model.seriesGroupType
    };
    return this.isCategorySeriesSwitched() ? this.invertCategorySeriesParams(n) : n;
  }
  invertCategorySeriesParams(e) {
    const [t] = e.categories, s = [{ id: Fi, name: "" }], i = e.data.map((n, o) => {
      const a = `${t.id}:${o}`, l = n[t.id], c = l == null ? "" : String(l);
      return { colId: a, displayName: c };
    }), r = e.fields.map((n) => {
      const o = {
        [Fi]: n.displayName
      };
      for (const [a, l] of e.data.entries()) {
        const c = `${t.id}:${a}`, d = l[n.colId];
        o[c] = d;
      }
      return o;
    });
    return {
      ...e,
      categories: s,
      fields: i,
      data: r
    };
  }
  getChartModel() {
    const e = this.model.pivotChart ? "pivot" : "range", t = this.isComboChart() ? this.model.comboChartModel.seriesChartTypes : void 0;
    return {
      modelType: e,
      chartId: this.model.chartId,
      chartType: this.model.chartType,
      chartThemeName: this.getChartThemeName(),
      chartOptions: this.chartProxy.getChartThemeOverrides(),
      chartPalette: this.chartProxy.getChartPalette(),
      cellRange: this.getCellRangeParams(),
      switchCategorySeries: this.model.switchCategorySeries,
      suppressChartRanges: this.model.suppressChartRanges,
      aggFunc: this.model.aggFunc,
      unlinkChart: this.model.unlinked,
      seriesChartTypes: t,
      seriesGroupType: this.model.seriesGroupType
    };
  }
  getChartId() {
    return this.model.chartId;
  }
  getChartData() {
    return this.model.chartData;
  }
  getChartType() {
    return this.model.chartType;
  }
  setChartType(e) {
    this.updateMultiSeriesAndCategory(this.model.chartType, e), this.model.chartType = e, this.model.comboChartModel.updateSeriesChartTypes(), this.model.switchCategorySeries = !1, this.model.categoryAxisType = void 0, this.model.seriesGroupType = void 0, this.raiseChartModelUpdateEvent(), this.raiseChartOptionsChangedEvent();
  }
  isCategorySeriesSwitched() {
    return this.model.switchCategorySeries && !this.model.isGrouping();
  }
  switchCategorySeries(e) {
    lS(this.getChartType()) && (this.model.switchCategorySeries = e, this.raiseChartModelUpdateEvent());
  }
  getAggFunc() {
    return this.model.aggFunc;
  }
  setAggFunc(e, t) {
    this.model.aggFunc !== e && (this.model.aggFunc = e, !t && (this.model.updateData(), this.raiseChartModelUpdateEvent()));
  }
  updateMultiSeriesAndCategory(e, t) {
    const s = (a, l) => {
      let c = 0;
      for (const d of a)
        d.selected && (c >= l ? d.selected = !1 : c++);
      c === 0 && (a[0].selected = !0);
    }, i = Ou(t), r = Kl(t), n = i != null && (Ou(e) ?? 100) > (i ?? 100), o = r != null && (Kl(e) ?? 100) > (r ?? 100);
    n && s(this.model.dimensionColState, i), o && s(this.model.valueColState, r), (n || o) && (this.model.resetCellRanges(n, o), this.setChartRange(!0));
  }
  setChartThemeName(e, t) {
    this.model.chartThemeName = e, t || (this.raiseChartModelUpdateEvent(), this.raiseChartOptionsChangedEvent());
  }
  getChartThemeName() {
    return this.model.chartThemeName;
  }
  isPivotChart() {
    return this.model.pivotChart;
  }
  isPivotMode() {
    return this.model.isPivotMode();
  }
  isGrouping() {
    return this.model.isGrouping();
  }
  isCrossFilterChart() {
    return this.model.crossFiltering;
  }
  getThemeNames() {
    return this.gos.get("chartThemes") || yS;
  }
  getThemes() {
    return this.getThemeNames().map((t) => {
      const i = ip(t, this.agChartsExports._Theme) ? t : this.chartProxy.lookupCustomChartTheme(t);
      return this.agChartsExports._Theme.getChartTheme(i);
    });
  }
  getPalettes() {
    return this.getThemes().map((t) => t.palette);
  }
  getThemeTemplateParameters() {
    return this.getThemes().map((t) => t.getTemplateParameters());
  }
  getValueColState() {
    return this.model.valueColState.map(this.displayNameMapper.bind(this));
  }
  getSelectedValueColState() {
    return this.getValueColState().filter((e) => e.selected);
  }
  getSelectedDimensions() {
    return this.model.getSelectedDimensions();
  }
  displayNameMapper(e) {
    const { column: t } = e;
    if (t)
      e.displayName = this.model.getColDisplayName(t, this.model.isPivotMode());
    else {
      const s = this.model.colNames[e.colId];
      e.displayName = s ? s.join(" - ") : this.model.getColDisplayName(t);
    }
    return e;
  }
  getColStateForMenu() {
    return { dimensionCols: this.model.dimensionColState, valueCols: this.getValueColState() };
  }
  setChartRange(e = !1) {
    this.rangeSvc && !this.model.suppressChartRanges && !this.model.unlinked && this.rangeSvc.setCellRanges(this.getCellRanges()), e || this.raiseChartModelUpdateEvent();
  }
  detachChartRange() {
    this.model.unlinked = !this.model.unlinked, this.model.unlinked ? this.rangeSvc && this.rangeSvc.setCellRanges([]) : this.updateForGridChange(), this.dispatchLocalEvent({ type: "chartLinkedChanged" });
  }
  setChartProxy(e) {
    this.chartProxy = e;
  }
  getChartProxy() {
    return this.chartProxy;
  }
  isActiveXYChart() {
    return ["scatter", "bubble"].includes(this.getChartType());
  }
  isChartLinked() {
    return !this.model.unlinked;
  }
  customComboExists() {
    const e = this.model.comboChartModel.savedCustomSeriesChartTypes;
    return e && e.length > 0;
  }
  getSeriesChartTypes() {
    return this.model.comboChartModel.seriesChartTypes;
  }
  isComboChart(e) {
    return this.model.isComboChart(e);
  }
  updateSeriesChartType(e, t, s) {
    const i = this.model.comboChartModel.seriesChartTypes.find((r) => r.colId === e);
    if (i) {
      const r = this.model.chartType !== "customCombo";
      r && (this.model.chartType = "customCombo");
      const n = i.chartType;
      t != null && (i.chartType = t), s != null && (i.secondaryAxis = s), this.model.comboChartModel.savedCustomSeriesChartTypes = this.model.comboChartModel.seriesChartTypes, this.model.comboChartModel.updateSeriesChartTypes(), this.updateForDataChange(), r && this.dispatchLocalEvent({
        type: "chartTypeChanged"
      }), n !== t && this.dispatchLocalEvent({
        type: "chartSeriesChartTypeChanged"
      }), this.raiseChartOptionsChangedEvent();
    }
  }
  getActiveSeriesChartTypes() {
    const e = this.getSelectedValueColState().map((t) => t.colId);
    return this.getSeriesChartTypes().filter((t) => e.includes(t.colId));
  }
  getChartSeriesTypes(e) {
    const t = e ?? this.getChartType();
    return this.isComboChart(t) ? ["line", "bar", "area"] : [at(t)];
  }
  getChartSeriesType() {
    const e = this.getSeriesChartTypes();
    if (e.length === 0)
      return "bar";
    const t = e[0].chartType;
    return t === "columnLineCombo" ? "bar" : t === "areaColumnCombo" ? "area" : at(t);
  }
  getCellRanges() {
    return [this.model.dimensionCellRange, this.model.valueCellRange].filter((e) => e);
  }
  createCellRange(e) {
    var t;
    return e.cellRange && ((t = this.rangeSvc) == null ? void 0 : t.createPartialCellRangeFromRangeParams(e.cellRange, !0));
  }
  validUpdateType(e) {
    if (!e.type)
      return I(136), !1;
    const t = {
      "Range Chart": () => !this.isPivotChart() && !this.isCrossFilterChart(),
      "Pivot Chart": () => this.isPivotChart(),
      "Cross Filter Chart": () => this.isCrossFilterChart()
    }, s = Object.keys(t).find((r) => t[r]()) ?? "Range Chart", i = e.type === `${s[0].toLowerCase()}${s.slice(1).replace(/ /g, "")}Update`;
    return i || I(137, { currentChartType: s, type: e.type }), i;
  }
  getCellRangeParams() {
    const e = this.getCellRanges(), t = e[0], s = t && t.startRow || null, i = t && t.endRow || null;
    return {
      rowStartIndex: s && s.rowIndex,
      rowStartPinned: s && s.rowPinned,
      rowEndIndex: i && i.rowIndex,
      rowEndPinned: i && i.rowPinned,
      columns: e.reduce(
        (r, n) => r.concat(n.columns.map((o) => o.getId())),
        []
      )
    };
  }
  setCategoryAxisType(e) {
    this.model.categoryAxisType = e, this.raiseChartModelUpdateEvent();
  }
  getSeriesGroupType() {
    return this.model.seriesGroupType ?? this.chartProxy.getSeriesGroupType();
  }
  setSeriesGroupType(e) {
    this.model.seriesGroupType = e, this.raiseChartModelUpdateEvent();
  }
  raiseChartModelUpdateEvent() {
    this.dispatchLocalEvent({ type: "chartModelUpdate" });
  }
  raiseChartUpdatedEvent() {
    this.dispatchLocalEvent({ type: "chartUpdated" });
  }
  raiseChartApiUpdateEvent() {
    this.dispatchLocalEvent({ type: "chartApiUpdate" });
  }
  raiseChartOptionsChangedEvent() {
    const { chartId: e, chartType: t } = this.getChartModel();
    this.eventSvc.dispatchEvent({
      type: "chartOptionsChanged",
      chartId: e,
      chartType: t,
      chartThemeName: this.getChartThemeName(),
      chartOptions: this.chartProxy.getChartThemeOverrides()
    });
  }
  raiseChartRangeSelectionChangedEvent() {
    this.eventSvc.dispatchEvent({
      type: "chartRangeSelectionChanged",
      id: this.model.chartId,
      chartId: this.model.chartId,
      cellRange: this.getCellRangeParams()
    });
  }
  destroy() {
    super.destroy(), this.rangeSvc && this.rangeSvc.setCellRanges([]);
  }
}, Mj = class extends Gr {
  constructor(e) {
    super(e);
  }
  getAxes(e) {
    const t = [
      {
        type: this.getXAxisType(e),
        position: "bottom"
      },
      {
        type: "number",
        position: "left"
      }
    ];
    if (this.isNormalised()) {
      const s = t[1];
      s.label = { ...s.label, formatter: (i) => Math.round(i.value) + "%" };
    }
    return t;
  }
  getSeries(e) {
    const [t] = e.categories, s = e.fields.map(
      (i) => ({
        type: this.standaloneChartType,
        xKey: t.id,
        xName: t.name,
        yKey: i.colId,
        yName: i.displayName,
        normalizedTo: this.chartType === "normalizedArea" ? 100 : void 0,
        stacked: ["normalizedArea", "stackedArea"].includes(this.chartType)
      })
    );
    return this.crossFiltering ? this.extractLineAreaCrossFilterSeries(s, e) : s;
  }
  isNormalised() {
    return !this.crossFiltering && this.chartType === "normalizedArea";
  }
};
function lm(e, t) {
  const s = parseInt(e.slice(1, 3), 16), i = parseInt(e.slice(3, 5), 16), r = parseInt(e.slice(5, 7), 16);
  return t ? `rgba(${s}, ${i}, ${r}, ${t})` : `rgba(${s}, ${i}, ${r})`;
}
var Ij = /* @__PURE__ */ new Set(["bar", "groupedBar", "stackedBar", "normalizedBar"]), Lj = class extends Gr {
  constructor(e) {
    super(e);
  }
  getAxes(e) {
    const t = [
      {
        type: this.getXAxisType(e),
        position: this.isHorizontal() ? "left" : "bottom"
      },
      {
        type: "number",
        position: this.isHorizontal() ? "bottom" : "left"
      }
    ];
    if (this.isNormalised()) {
      const s = t[1];
      s.label = { ...s.label, formatter: (i) => Math.round(i.value) + "%" };
    }
    return t;
  }
  getSeries(e) {
    const [t] = e.categories, s = e.fields.map(
      (i) => ({
        type: this.standaloneChartType,
        direction: this.isHorizontal() ? "horizontal" : "vertical",
        stacked: this.crossFiltering || w$(this.chartType),
        normalizedTo: this.isNormalised() ? 100 : void 0,
        xKey: t.id,
        xName: t.name,
        yKey: i.colId,
        yName: i.displayName
      })
    );
    return this.crossFiltering ? this.extractCrossFilterSeries(s) : s;
  }
  extractCrossFilterSeries(e) {
    const t = this.getChartPalette(), s = (n, o) => {
      var a, l;
      return {
        ...n,
        highlightStyle: { item: { fill: void 0 } },
        fill: (a = t == null ? void 0 : t.fills) == null ? void 0 : a[o],
        stroke: (l = t == null ? void 0 : t.strokes) == null ? void 0 : l[o],
        listeners: {
          nodeClick: this.crossFilterCallback
        }
      };
    }, i = (n) => {
      const o = n.yKey + "-filtered-out";
      return {
        ...n,
        yKey: o,
        fill: lm(n.fill, "0.3"),
        stroke: lm(n.stroke, "0.3"),
        showInLegend: !1
      };
    }, r = [];
    for (let n = 0; n < e.length; n++) {
      const o = e[n];
      r.push(s(o, n)), r.push(i(s(o, n)));
    }
    return r;
  }
  isNormalised() {
    const e = ["normalizedColumn", "normalizedBar"];
    return !this.crossFiltering && e.includes(this.chartType);
  }
  isHorizontal() {
    return Ij.has(this.chartType);
  }
}, kj = class extends Gr {
  constructor(e) {
    super(e);
  }
  getAxes(e) {
    const t = [
      {
        type: this.getXAxisType(e),
        position: "bottom"
      },
      {
        type: "number",
        position: "left"
      }
    ];
    if (this.isNormalised()) {
      const s = t[1];
      s.label = { ...s.label, formatter: (i) => Math.round(i.value) + "%" };
    }
    return t;
  }
  getSeries(e) {
    const [t] = e.categories, s = ["normalizedLine", "stackedLine"].includes(this.chartType), i = e.fields.map(
      (r) => ({
        type: this.standaloneChartType,
        xKey: t.id,
        xName: t.name,
        yKey: r.colId,
        yName: r.displayName,
        normalizedTo: s && this.isNormalised() ? 100 : void 0,
        stacked: s
      })
    );
    return this.crossFiltering ? this.extractLineAreaCrossFilterSeries(i, e) : i;
  }
  isNormalised() {
    const e = ["normalizedLine"];
    return !this.crossFiltering && e.includes(this.chartType);
  }
}, Oj = class extends Gr {
  constructor(e) {
    super(e);
  }
  getAxes(e) {
    return [
      {
        type: "number",
        position: "bottom"
      },
      {
        type: "number",
        position: "left"
      }
    ];
  }
  getSeries(e) {
    const [t] = e.categories, s = this.isPaired(), i = this.getSeriesDefinitions(e.fields, s), r = t.id === Fi ? void 0 : t, n = i.map((o) => o != null && o.sizeField ? {
      type: "bubble",
      xKey: o.xField.colId,
      xName: o.xField.displayName ?? void 0,
      yKey: o.yField.colId,
      yName: o.yField.displayName ?? void 0,
      title: `${o.yField.displayName} vs ${o.xField.displayName}`,
      sizeKey: o.sizeField.colId,
      sizeName: o.sizeField.displayName ?? "",
      labelKey: r ? r.id : o.yField.colId,
      labelName: r ? r.name : void 0
    } : {
      type: "scatter",
      xKey: o.xField.colId,
      xName: o.xField.displayName ?? void 0,
      yKey: o.yField.colId,
      yName: o.yField.displayName ?? void 0,
      title: `${o.yField.displayName} vs ${o.xField.displayName}`,
      labelKey: r ? r.id : o.yField.colId,
      labelName: r ? r.name : void 0
    });
    return this.crossFiltering ? this.extractCrossFilterSeries(n, e) : n;
  }
  extractCrossFilterSeries(e, t) {
    const { data: s } = t, i = this.getChartPalette(), r = (c) => `${c}-filtered-out`, n = (c, d) => {
      const u = [1 / 0, -1 / 0];
      if (d != null)
        for (const h of c) {
          const p = h[d] ?? h[r(d)];
          p < u[0] && (u[0] = p), p > u[1] && (u[1] = p);
        }
      if (u[0] <= u[1])
        return u;
    }, o = (c, d) => {
      var g, f;
      const u = (g = i == null ? void 0 : i.fills) == null ? void 0 : g[d], h = (f = i == null ? void 0 : i.strokes) == null ? void 0 : f[d];
      let p;
      if (c.type === "bubble") {
        const { sizeKey: m } = c;
        p = n(s, m);
      }
      return {
        ...c,
        fill: u,
        stroke: h,
        domain: p,
        highlightStyle: { item: { fill: "yellow" } },
        listeners: {
          ...c.listeners,
          nodeClick: this.crossFilterCallback
        }
      };
    }, a = (c) => {
      const { yKey: d, xKey: u } = c;
      let h = {};
      return c.type === "bubble" && (h = { sizeKey: r(c.sizeKey) }), {
        ...c,
        ...h,
        yKey: r(d),
        xKey: r(u),
        fillOpacity: 0.3,
        strokeOpacity: 0.3,
        showInLegend: !1,
        listeners: {
          ...c.listeners,
          nodeClick: (p) => {
            const g = p.datum[r(u)], f = {
              ...p,
              xKey: u,
              datum: { ...p.datum, [u]: g }
            };
            this.crossFilterCallback(f);
          }
        }
      };
    }, l = e.map(o);
    return [...l, ...l.map(a)];
  }
  getSeriesDefinitions(e, t) {
    if (e.length < 2)
      return [];
    const s = this.chartType === "bubble";
    if (t)
      return s ? e.map(
        (r, n) => n % 3 === 0 ? {
          xField: r,
          yField: e[n + 1],
          sizeField: e[n + 2]
        } : null
      ).filter((r) => r && r.yField && r.sizeField) : e.map(
        (r, n) => n % 2 === 0 ? {
          xField: r,
          yField: e[n + 1]
        } : null
      ).filter((r) => r && r.yField);
    const i = e[0];
    return s ? e.map(
      (r, n) => n % 2 === 1 ? {
        xField: i,
        yField: r,
        sizeField: e[n + 1]
      } : null
    ).filter((r) => r && r.sizeField) : e.filter((r, n) => n > 0).map((r) => ({ xField: i, yField: r }));
  }
}, Gj = class extends Gr {
  constructor(e) {
    super(e);
  }
  getAxes(e) {
    const t = e ? e.fields : [], s = new Map(t.map((o) => [o.colId, o])), { primaryYKeys: i, secondaryYKeys: r } = this.getYKeys(t, e.seriesChartTypes), n = [
      {
        type: this.getXAxisType(e),
        position: "bottom"
      }
    ];
    return i.length > 0 && n.push({
      type: "number",
      keys: i,
      position: "left"
    }), r.length > 0 && r.forEach((o) => {
      const a = s.get(o);
      if (!(a && a.colId === o))
        return;
      const c = {
        type: "number",
        keys: [o],
        position: "right"
      };
      n.push(c);
    }), n;
  }
  getSeries(e) {
    const { fields: t, seriesChartTypes: s } = e, [i] = e.categories;
    return t.map((r) => {
      const n = s.find((o) => o.colId === r.colId);
      if (n) {
        const o = n.chartType, l = ["groupedColumn", "groupedBar"].includes(o) ? { grouped: !0 } : {};
        return {
          type: at(o),
          xKey: i.id,
          yKey: r.colId,
          yName: r.displayName,
          stacked: ["stackedArea", "stackedColumn"].includes(o),
          ...l
        };
      }
    });
  }
  getYKeys(e, t) {
    const s = [], i = [];
    return e.forEach((r) => {
      const n = r.colId, o = t.find((a) => a.colId === n);
      o && (o.secondaryAxis ? i.push(n) : s.push(n));
    }), { primaryYKeys: s, secondaryYKeys: i };
  }
};
function Bj(e) {
  const t = e.currentOffset;
  e.currentOffset -= e.offsetAmount;
  const s = e.currentOffset;
  return e.currentOffset -= e.offsetAmount, { outerRadiusOffset: t, innerRadiusOffset: s };
}
var Vj = class extends xa {
  constructor(e) {
    super(e);
  }
  getUpdateOptions(e, t) {
    return {
      ...t,
      data: this.crossFiltering ? this.getCrossFilterData(e) : e.data,
      series: this.getSeries(e)
    };
  }
  getSeries(e) {
    const [t] = e.categories, s = e.fields.length, i = {
      currentOffset: 0,
      offsetAmount: s > 1 ? 20 : 40
    }, r = this.getFields(e).map(
      (n) => {
        var a;
        const o = {
          type: this.standaloneChartType,
          angleKey: n.colId,
          angleName: n.displayName,
          sectorLabelKey: n.colId,
          calloutLabelName: t.name,
          calloutLabelKey: t.id
        };
        if (this.chartType === "donut" || this.chartType === "doughnut") {
          const { outerRadiusOffset: l, innerRadiusOffset: c } = Bj(i), d = n.displayName ? {
            title: { text: n.displayName, showInLegend: s > 1 }
          } : void 0;
          return {
            ...o,
            type: "donut",
            outerRadiusOffset: l,
            innerRadiusOffset: c,
            ...d,
            calloutLine: {
              colors: (a = this.getChartPalette()) == null ? void 0 : a.strokes
            }
          };
        }
        return o;
      }
    );
    return this.crossFiltering ? this.extractCrossFilterSeries(r) : r;
  }
  getCrossFilterData(e) {
    const t = e.fields[0].colId, s = `${t}-filtered-out`;
    return e.data.map((i) => {
      const r = i[t] + i[s];
      return i[`${t}-total`] = r, i[s] = 1, i[t] = i[t] / r, i;
    });
  }
  extractCrossFilterSeries(e) {
    const t = this.getChartPalette(), s = (a) => ({
      ...a,
      legendItemKey: a.calloutLabelKey,
      calloutLabel: { enabled: !1 },
      // hide labels on primary series
      highlightStyle: { item: { fill: void 0 } },
      radiusKey: a.angleKey,
      angleKey: a.angleKey + "-total",
      radiusMin: 0,
      radiusMax: 1,
      listeners: {
        nodeClick: this.crossFilterCallback
      }
    }), i = (a, l) => ({
      ...o,
      radiusKey: l + "-filtered-out",
      fills: this.changeOpacity(a.fills ?? (t == null ? void 0 : t.fills) ?? [], 0.3),
      strokes: this.changeOpacity(a.strokes ?? (t == null ? void 0 : t.strokes) ?? [], 0.3),
      showInLegend: !1
    }), r = e[0], n = r.angleKey, o = s(r);
    return [i(s(r), n), o];
  }
  getFields(e) {
    return this.chartType === "pie" ? e.fields.slice(0, 1) : e.fields;
  }
  changeOpacity(e, t) {
    const s = this.agChartsExports._Util.Color;
    return e.map((i) => {
      const r = s.fromString(i);
      return new s(r.r, r.g, r.b, t).toHexString();
    });
  }
}, Nj = class extends _ {
  constructor() {
    super(
      /* html */
      '<div class="ag-chart-menu" data-ref="eMenu"></div>'
    ), this.eMenu = E, this.buttonListenersDestroyFuncs = [];
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  updateParams(e) {
    const { buttons: t } = e;
    this.createButtons(t);
  }
  createButtons(e) {
    this.buttonListenersDestroyFuncs.forEach((s) => s == null ? void 0 : s()), this.buttonListenersDestroyFuncs = [];
    const t = this.eMenu;
    ze(t), e.forEach((s) => {
      const { buttonName: i, iconName: r, callback: n } = s, o = this.createButton(r), a = this.chartTranslation.translate(
        i + "ToolbarTooltip"
      );
      a && o instanceof HTMLElement && (o.title = a), this.buttonListenersDestroyFuncs.push(
        ...this.addManagedElementListeners(o, {
          click: (l) => n(l.currentTarget)
        })
      ), t.appendChild(o);
    });
  }
  createButton(e) {
    const t = ue(e, this.beans);
    t.classList.add("ag-chart-menu-icon");
    const s = We(this.beans).createElement("button");
    return s.appendChild(t), s.classList.add("ag-chart-menu-toolbar-button"), s;
  }
  destroy() {
    this.buttonListenersDestroyFuncs = [], super.destroy();
  }
}, Hj = (
  /*css*/
  ".ag-pill-select{display:flex;flex-direction:column}:where(.ag-pill-select){.ag-column-drop-list{padding:0}.ag-select{padding-top:var(--ag-spacing)}.ag-picker-field-wrapper{background-color:transparent;border:0}.ag-picker-field-display{cursor:pointer;font-weight:500}.ag-picker-field-display,.ag-picker-field-icon{color:var(--ag-chart-menu-label-color)}}"
), zj = class extends _ {
  constructor(e) {
    super(
      /* html */
      '<div class="ag-pill-select" role="presentation"></div>'
    ), this.config = e ?? {};
    const { selectedValueList: t, valueFormatter: s, valueList: i } = this.config;
    this.selectedValues = t ?? [], this.valueList = i ?? [], this.valueFormatter = s ?? ((r) => Ke(r)), this.registerCSS(Hj);
  }
  postConstruct() {
    const { ariaLabel: e, onValuesChange: t, dragSourceId: s } = this.config;
    this.dropZonePanel = this.createManagedBean(
      new _j(
        {
          getValues: () => this.selectedValues,
          setValues: (r) => this.updateValues(r),
          isDraggable: () => this.selectedValues.length > 1
        },
        (r) => this.valueFormatter(r),
        e,
        s
      )
    ), this.getGui().appendChild(this.dropZonePanel.getGui()), this.initSelect(), t != null && (this.onValuesChange = t);
  }
  setValues(e, t) {
    const { added: s, removed: i, updated: r } = this.getChanges(this.valueList, e);
    let n = !1;
    return (s.length || i.length || r.length) && (n = !0), this.valueList = e, this.updateValues(t, n, !0), this;
  }
  setValueFormatter(e) {
    return this.valueFormatter = e, this;
  }
  initSelect() {
    const e = this.createSelectOptions();
    if (!e.length)
      return !1;
    const { selectPlaceholder: t } = this.config;
    return this.eSelect = this.createBean(
      new rs({
        options: e,
        placeholder: t,
        onValueChange: (s) => this.addValue(s),
        pickerIcon: "chartsMenuAdd"
      })
    ), this.getGui().appendChild(this.eSelect.getGui()), !0;
  }
  createSelectOptions() {
    const e = [], { maxSelection: t } = this.config;
    return t && this.selectedValues.length >= t || this.valueList.forEach((s) => {
      this.selectedValues.includes(s) || e.push({ value: s, text: this.valueFormatter(s) });
    }), e;
  }
  addValue(e) {
    this.dropZonePanel.addItem(e);
  }
  updateValues(e, t, s) {
    var d, u, h, p, g;
    const i = this.selectedValues;
    this.selectedValues = e;
    const r = this.getChanges(i, e), n = t || r.added.length || r.removed.length, o = Ie(this.beans), a = (d = this.eSelect) == null ? void 0 : d.getGui().contains(o), l = (u = this.dropZonePanel) == null ? void 0 : u.getGui().contains(o);
    s || (h = this.onValuesChange) == null || h.call(this, r);
    const c = n ? !this.refreshSelect() : !1;
    this.dropZonePanel.refreshGui(), n && a && (c ? this.dropZonePanel.focusList(!0) : (p = this.eSelect) == null || p.getFocusableElement().focus()), l && !e.length && ((g = this.eSelect) == null || g.getFocusableElement().focus());
  }
  getChanges(e, t) {
    const s = t.filter((n) => !e.includes(n)), i = e.filter((n) => !t.includes(n)), r = t.filter((n, o) => e[o] !== n);
    return { added: s, removed: i, updated: r, selected: t };
  }
  refreshSelect() {
    if (!this.eSelect)
      return this.initSelect();
    const e = this.createSelectOptions();
    return e.length ? (this.eSelect.clearOptions().addOptions(e).setValue(void 0, !0), !0) : (ut(this.eSelect.getGui()), this.eSelect = this.destroyBean(this.eSelect), !1);
  }
  destroy() {
    this.destroyBean(this.eSelect), super.destroy();
  }
}, Wj = class extends Ab {
  constructor(e, t, s, i, r, n) {
    super(t, s, !1), this.value = e, this.valueFormatter = i, this.draggable = r, this.sourceId = n;
  }
  getItem() {
    return this.value;
  }
  getDisplayName() {
    return this.valueFormatter(this.value);
  }
  getAriaDisplayName() {
    return this.getDisplayName();
  }
  getTooltip() {
  }
  createGetDragItem() {
    return () => ({
      value: this.value
    });
  }
  getDragSourceType() {
    return ni.ChartPanel;
  }
  getDragSourceId() {
    return this.sourceId;
  }
  isDraggable() {
    return this.draggable;
  }
}, _j = class extends Db {
  constructor(e, t, s, i) {
    super(!1), this.model = e, this.valueFormatter = t, this.ariaLabel = s, this.sourceId = i;
  }
  postConstruct() {
    super.init();
  }
  isItemDroppable(e, t) {
    return this.isSourceEventFromTarget(t) || this.sourceId != null && this.sourceId === t.dragSource.sourceId;
  }
  updateItems(e) {
    this.model.setValues(e);
  }
  getExistingItems() {
    return this.model.getValues();
  }
  getIconName() {
    return this.isPotentialDndItems() ? "move" : "notAllowed";
  }
  getAriaLabel() {
    return this.ariaLabel;
  }
  createPillComponent(e, t, s) {
    return new Wj(
      e,
      t,
      s,
      this.valueFormatter,
      this.model.isDraggable(),
      this.sourceId
    );
  }
  getItems(e) {
    return [e.value];
  }
  isInterestedIn(e) {
    return e === ni.ChartPanel;
  }
}, bS = class extends _ {
  constructor(e, t, s, i) {
    super(i), this.chartController = e, this.allowMultipleSelection = t, this.maxSelection = s;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  addItem(e) {
    this.groupComp.addItem(e);
  }
  createGroup(e, t, s, i, r) {
    if (this.allowMultipleSelection) {
      const n = e.filter((o) => o.selected);
      this.valuePillSelect = this.groupComp.createManagedBean(
        new zj({
          valueList: e,
          selectedValueList: n,
          valueFormatter: t,
          selectPlaceholder: this.chartTranslation.translate(s),
          dragSourceId: i,
          onValuesChange: (o) => this.onValueChange(o),
          maxSelection: this.maxSelection
        })
      ), this.groupComp.addItem(this.valuePillSelect);
    } else {
      const n = this.createValueSelectParams(e);
      n.onValueChange = (o) => {
        e.forEach((a) => {
          a.selected = !1;
        }), o.selected = !0, o.colId === Fi && this.chartController.setAggFunc(void 0, !0), this.chartController.updateForPanelChange({ updatedColState: o, skipAnimation: r == null ? void 0 : r() });
      }, this.valueSelect = this.groupComp.createManagedBean(new rs(n)), this.groupComp.addItem(this.valueSelect);
    }
  }
  refreshValueSelect(e) {
    if (!this.valueSelect)
      return;
    const { options: t, value: s } = this.createValueSelectParams(e);
    this.valueSelect.clearOptions().addOptions(t).setValue(s, !0);
  }
  createValueSelectParams(e) {
    let t;
    return {
      options: e.map((i) => {
        const r = i.displayName ?? "";
        return i.selected && (t = i), {
          value: i,
          text: r
        };
      }),
      value: t
    };
  }
  onValueChange({ added: e, updated: t, removed: s, selected: i }) {
    let r, n;
    const o = () => {
      i.forEach((a, l) => {
        a.order = l;
      }), n = !0;
    };
    e.length ? (r = e[0], r.selected = !0, o()) : s.length ? (r = s[0], r.selected = !1) : t.length && (o(), r = t[0]), r && this.chartController.updateForPanelChange({ updatedColState: r, resetOrder: n });
  }
  destroy() {
    this.valuePillSelect = void 0, this.valueSelect = void 0, super.destroy();
  }
}, Uj = "sum", $j = class extends bS {
  constructor(e, t, s, i, r) {
    super(
      e,
      s,
      void 0,
      /* html */
      '<div id="categoriesGroup"></div>'
    ), this.title = t, this.dimensionCols = i, this.isOpen = r;
  }
  postConstruct() {
    this.groupComp = this.createBean(
      new qi({
        title: this.title,
        enabled: !0,
        suppressEnabledCheckbox: !0,
        suppressOpenCloseIcons: !1,
        cssIdentifier: "charts-data",
        expanded: this.isOpen
      })
    ), this.createGroup(
      this.dimensionCols,
      (e) => e.displayName ?? "",
      "categoryAdd",
      "categorySelect",
      () => !this.chartController.getAggFunc()
    ), this.createAggFuncControls(this.dimensionCols), this.getGui().appendChild(this.groupComp.getGui());
  }
  refresh(e) {
    var t;
    (t = this.valuePillSelect) == null || t.setValues(
      e,
      e.filter((s) => s.selected)
    ), this.refreshValueSelect(e), this.refreshAggFuncControls(e, this.chartController.getAggFunc());
  }
  createAggFuncControls(e) {
    const t = this.chartController.getAggFunc();
    this.groupComp.addItem(
      this.aggFuncToggle = this.createBean(
        new oo({
          label: this.chartTranslation.translate("aggregate"),
          labelAlignment: "left",
          labelWidth: "flex",
          inputWidth: "flex",
          value: t != null,
          onValueChange: (s) => {
            var r, n;
            const i = s ? Uj : void 0;
            this.chartController.setAggFunc(i), (r = this.aggFuncSelect) == null || r.setValue(i, !0), (n = this.aggFuncSelect) == null || n.setDisplayed(i != null);
          }
        })
      )
    ), this.groupComp.addItem(
      this.aggFuncSelect = this.createBean(
        new rs({
          options: [
            { value: "sum", text: this.chartTranslation.translate("sum") },
            { value: "first", text: this.chartTranslation.translate("first") },
            { value: "last", text: this.chartTranslation.translate("last") },
            { value: "min", text: this.chartTranslation.translate("min") },
            { value: "max", text: this.chartTranslation.translate("max") },
            { value: "count", text: this.chartTranslation.translate("count") },
            { value: "avg", text: this.chartTranslation.translate("avg") }
          ],
          value: typeof t == "string" ? t : void 0,
          onValueChange: (s) => {
            this.chartController.setAggFunc(s);
          }
        })
      )
    ), this.refreshAggFuncControls(e, t);
  }
  refreshAggFuncControls(e, t) {
    var r, n, o, a;
    const i = e.filter((l) => l.selected).some((l) => l.colId !== Fi);
    (r = this.aggFuncToggle) == null || r.setValue(t != null), (n = this.aggFuncSelect) == null || n.setValue(typeof t == "string" ? t : void 0, !0), (o = this.aggFuncToggle) == null || o.setDisplayed(i), (a = this.aggFuncSelect) == null || a.setDisplayed(i && t != null);
  }
  clearAggFuncControls() {
    this.aggFuncToggle = this.destroyBean(this.aggFuncToggle), this.aggFuncSelect = this.destroyBean(this.aggFuncSelect);
  }
  destroy() {
    this.clearAggFuncControls(), this.groupComp = this.destroyBean(this.groupComp), super.destroy();
  }
}, Sn = class extends L {
  constructor(e) {
    super(), this.chartOptionsProxy = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  getDefaultColorPickerParams(e, t, s) {
    return this.addValueParams(
      e,
      {
        label: this.chartTranslation.translate(t ?? "color"),
        labelWidth: "flex",
        inputWidth: "flex",
        labelAlignment: "top",
        pickerGap: 6
      },
      s
    );
  }
  getDefaultNumberInputParams(e, t, s) {
    return this.addValueParams(
      e,
      {
        label: this.chartTranslation.translate(t),
        labelAlignment: "top",
        labelWidth: "flex",
        inputWidth: "flex",
        precision: s == null ? void 0 : s.precision,
        step: s == null ? void 0 : s.step,
        min: s == null ? void 0 : s.min,
        max: s == null ? void 0 : s.max
      },
      {
        parseInputValue: (i) => {
          const r = Number(i);
          return isNaN(r) ? void 0 : r;
        },
        formatInputValue: (i) => i == null ? "" : `${i}`
      }
    );
  }
  getDefaultSliderParams(e, t, s, i) {
    let r = this.chartOptionsProxy.getValue(e) ?? 0;
    i && Array.isArray(r) && (r = r[0]);
    const n = this.getDefaultSliderParamsWithoutValueParams(r, t, s);
    return n.onValueChange = (o) => this.chartOptionsProxy.setValue(e, i ? [o] : o), n;
  }
  getDefaultSliderParamsWithoutValueParams(e, t, s) {
    return {
      label: this.chartTranslation.translate(t),
      minValue: 0,
      maxValue: Math.max(e, s),
      textFieldWidth: 45,
      value: `${e}`
    };
  }
  getDefaultCheckboxParams(e, t, s) {
    const i = this.chartOptionsProxy.getValue(e), r = {
      label: this.chartTranslation.translate(t),
      value: i,
      readOnly: s == null ? void 0 : s.readOnly,
      passive: s == null ? void 0 : s.passive
    };
    return r.onValueChange = (n) => {
      this.chartOptionsProxy.setValue(e, typeof n == "boolean" ? n : void 0);
    }, r;
  }
  getDefaultSelectParams(e, t, s) {
    return this.getDefaultSelectParamsWithoutValueParams(
      t,
      s,
      this.chartOptionsProxy.getValue(e),
      (i) => {
        this.chartOptionsProxy.setValue(e, i);
      }
    );
  }
  getDefaultSelectParamsWithoutValueParams(e, t, s, i) {
    return {
      label: this.chartTranslation.translate(e),
      labelAlignment: "top",
      options: t,
      pickerGap: 6,
      value: s,
      onValueChange: i
    };
  }
  getDefaultFontPanelParams(e, t) {
    const s = (i) => `${e}.${i}`;
    return this.addEnableParams(s("enabled"), {
      name: this.chartTranslation.translate(t),
      suppressEnabledCheckbox: !1,
      chartMenuParamsFactory: this,
      keyMapper: s
    });
  }
  addValueParams(e, t, s) {
    const i = this.chartOptionsProxy.getValue(e);
    return t.value = s != null && s.formatInputValue ? s.formatInputValue(i) : i, t.onValueChange = (r) => {
      const n = s != null && s.parseInputValue ? s.parseInputValue(r) : r;
      this.chartOptionsProxy.setValue(e, n);
    }, t;
  }
  addEnableParams(e, t) {
    return t.enabled = this.chartOptionsProxy.getValue(e) ?? !1, t.onEnableChange = (s) => this.chartOptionsProxy.setValue(e, s), t;
  }
  getChartOptions() {
    return this.chartOptionsProxy;
  }
}, jj = class extends _ {
  constructor(e, t) {
    super(), this.chartMenuContext = e, this.isOpen = t, this.chartSpecificGroup = E, this.hasContent = !1;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation, this.chartSvc = e.chartSvc;
  }
  postConstruct() {
    const t = {
      title: this.getTitle(),
      enabled: !0,
      suppressEnabledCheckbox: !0,
      suppressOpenCloseIcons: !1,
      cssIdentifier: "charts-data",
      expanded: this.isOpen,
      items: [...this.createDirectionSelect(), this.createGroupTypeSelect()]
    };
    this.setTemplate(
      /* html */
      `
            <div id="chartSpecificGroup">
                <ag-group-component data-ref="chartSpecificGroup"></ag-group-component>
            </div>`,
      [dt],
      {
        chartSpecificGroup: t
      }
    ), this.setDisplayed(this.hasContent);
  }
  refresh() {
    this.hasContent = !1, this.chartSpecificGroup.setTitle(this.getTitle()), this.updateDirectionSelect(), this.updateGroupTypeSelect(), this.setDisplayed(this.hasContent);
  }
  getTitle() {
    const e = this.chartMenuContext.chartController.getChartType();
    return this.chartTranslation.translate(sp(e));
  }
  createDirectionSelect() {
    if (!this.chartSvc.isEnterprise())
      return [];
    const { chartOptionsService: e, chartController: t } = this.chartMenuContext, s = e.getSeriesOptionsProxy(
      () => at(t.getChartType())
    ), i = this.createManagedBean(
      new Sn(s)
    ), r = ["horizontal", "vertical"].map((a) => ({
      value: a,
      text: this.chartTranslation.translate(a)
    })), n = i.getDefaultSelectParams("direction", "direction", r), o = n.onValueChange;
    return n.onValueChange = (a) => {
      o(a), t.raiseChartModelUpdateEvent();
    }, this.directionSelect = this.createManagedBean(new rs(n)), this.updateDirectionSelect(), [this.directionSelect];
  }
  updateDirectionSelect() {
    const e = S$(this.chartMenuContext.chartController.getChartType());
    this.updateDisplayed(this.directionSelect, e);
  }
  createGroupTypeSelect() {
    const { chartController: e, chartMenuParamsFactory: t } = this.chartMenuContext;
    return this.groupTypeSelect = this.createManagedBean(
      new rs(
        t.getDefaultSelectParamsWithoutValueParams(
          "seriesGroupType",
          f$.map((s) => ({
            value: s,
            text: this.chartTranslation.translate(`${s}SeriesGroupType`)
          })),
          e.getSeriesGroupType(),
          (s) => e.setSeriesGroupType(s)
        )
      )
    ), this.updateGroupTypeSelect(), this.groupTypeSelect;
  }
  updateGroupTypeSelect() {
    const e = ["radialColumn", "radialBar", "nightingale"].includes(
      this.chartMenuContext.chartController.getChartType()
    );
    this.updateDisplayed(this.groupTypeSelect, e);
  }
  updateDisplayed(e, t) {
    e == null || e.setDisplayed(t), e && (this.hasContent = this.hasContent || t);
  }
}, Kj = class extends _ {
  constructor(e, t, s) {
    super(
      /* html */
      '<div id="seriesChartTypeGroup"></div>'
    ), this.chartController = e, this.columns = t, this.isOpen = s, this.selectedColIds = [], this.chartTypeComps = /* @__PURE__ */ new Map(), this.secondaryAxisComps = /* @__PURE__ */ new Map();
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    this.createSeriesChartTypeGroup(this.columns);
  }
  refresh(e) {
    Ht(this.getValidColIds(e), this.selectedColIds) ? this.refreshComps() : this.recreate(e);
  }
  recreate(e) {
    this.isOpen = this.seriesChartTypeGroupComp.isExpanded(), ze(this.getGui()), this.destroyBean(this.seriesChartTypeGroupComp), this.columns = e, this.selectedColIds = [], this.clearComps(), this.postConstruct();
  }
  getValidColIds(e) {
    const t = this.chartController.getSeriesChartTypes();
    return e.filter((s) => s.selected && !!t.filter((i) => i.colId === s.colId)[0]).map(({ colId: s }) => s);
  }
  createSeriesChartTypeGroup(e) {
    this.seriesChartTypeGroupComp = this.createBean(
      new qi({
        title: this.chartTranslation.translate("seriesChartType"),
        enabled: !0,
        suppressEnabledCheckbox: !0,
        suppressOpenCloseIcons: !1,
        cssIdentifier: "charts-data",
        expanded: this.isOpen
      })
    );
    const t = this.chartController.getSeriesChartTypes();
    e.forEach((s) => {
      if (!s.selected)
        return;
      const i = t.filter((c) => c.colId === s.colId)[0];
      if (!i)
        return;
      this.selectedColIds.push(s.colId);
      const r = this.seriesChartTypeGroupComp.createManagedBean(
        new qi({
          title: s.displayName,
          enabled: !0,
          suppressEnabledCheckbox: !0,
          suppressOpenCloseIcons: !0,
          cssIdentifier: "charts-format-sub-level"
        })
      ), n = (c) => ["groupedColumn", "stackedColumn", "stackedArea"].includes(c), o = this.seriesChartTypeGroupComp.createManagedBean(
        new Pn({
          label: this.chartTranslation.translate("secondaryAxis"),
          labelWidth: "flex",
          disabled: n(i.chartType),
          value: !!i.secondaryAxis,
          onValueChange: (c) => this.chartController.updateSeriesChartType(s.colId, void 0, c)
        })
      );
      r.addItem(o);
      const a = ["line", "area", "stackedArea", "groupedColumn", "stackedColumn"].map(
        (c) => ({
          value: c,
          text: this.chartTranslation.translate(sp(c))
        })
      ), l = r.createManagedBean(
        new rs({
          options: a,
          value: i.chartType,
          onValueChange: (c) => this.chartController.updateSeriesChartType(s.colId, c)
        })
      );
      r.addItem(l), this.seriesChartTypeGroupComp.addItem(r), this.chartTypeComps.set(s.colId, l), this.secondaryAxisComps.set(s.colId, o);
    }), this.getGui().appendChild(this.seriesChartTypeGroupComp.getGui());
  }
  refreshComps() {
    const e = this.chartController.getSeriesChartTypes();
    this.selectedColIds.forEach((t) => {
      const s = e.find((n) => n.colId === t);
      if (!s)
        return;
      const i = this.chartTypeComps.get(t), r = this.secondaryAxisComps.get(t);
      i == null || i.setValue(s.chartType), r == null || r.setValue(!!s.secondaryAxis), r == null || r.setDisabled(this.isSecondaryAxisDisabled(s.chartType));
    });
  }
  clearComps() {
    this.chartTypeComps.clear(), this.secondaryAxisComps.clear();
  }
  isSecondaryAxisDisabled(e) {
    return ["groupedColumn", "stackedColumn", "stackedArea"].includes(e);
  }
  destroy() {
    this.clearComps(), this.seriesChartTypeGroupComp = this.destroyBean(this.seriesChartTypeGroupComp), super.destroy();
  }
}, qj = class extends bS {
  constructor(e, t, s, i, r, n, o) {
    super(
      e,
      i,
      r,
      /* html */
      '<div id="seriesGroup"></div>'
    ), this.chartOptionsService = t, this.title = s, this.valueCols = n, this.isOpen = o;
  }
  postConstruct() {
    if (this.groupComp = this.createBean(
      new qi({
        title: this.title,
        enabled: !0,
        suppressEnabledCheckbox: !0,
        suppressOpenCloseIcons: !1,
        cssIdentifier: "charts-data",
        expanded: this.isOpen
      })
    ), this.chartController.isActiveXYChart()) {
      const e = this.groupComp.createManagedBean(
        new oo({
          label: this.chartTranslation.translate("paired"),
          labelAlignment: "left",
          labelWidth: "flex",
          inputWidth: "flex",
          value: this.chartOptionsService.getPairedMode(),
          onValueChange: (t) => {
            this.chartOptionsService.setPairedMode(!!t), this.chartController.updateForGridChange({ maintainColState: !0 });
          }
        })
      );
      this.groupComp.addItem(e);
    }
    this.createGroup(this.valueCols, this.generateGetSeriesLabel(this.valueCols), "seriesAdd", "seriesSelect"), this.getGui().appendChild(this.groupComp.getGui());
  }
  refresh(e) {
    var t, s;
    (t = this.valuePillSelect) == null || t.setValueFormatter(this.generateGetSeriesLabel(e)), (s = this.valuePillSelect) == null || s.setValues(
      e,
      e.filter((i) => i.selected)
    ), this.refreshValueSelect(e);
  }
  generateGetSeriesLabel(e) {
    if (!this.chartController.isActiveXYChart())
      return (n) => n.displayName ?? "";
    const t = e.filter((n) => n.selected), s = this.chartController.getChartType() === "bubble", i = this.chartOptionsService.getPairedMode(), r = /* @__PURE__ */ new Map();
    return r.set(0, "X"), r.set(1, "Y"), r.set(2, "size"), (n) => {
      const o = n.displayName ?? "";
      if (!n.selected)
        return o;
      const a = t.indexOf(n);
      if (a === -1)
        return o;
      let l;
      return i ? l = r.get(a % (s ? 3 : 2)) : a === 0 ? l = "X" : l = s && a % 2 === 0 ? "size" : "Y", `${o} (${l})`;
    };
  }
  destroy() {
    this.groupComp = this.destroyBean(this.groupComp), super.destroy();
  }
}, Yj = {
  groups: [
    { type: "categories", isOpen: !0 },
    { type: "series", isOpen: !0 },
    { type: "seriesChartType", isOpen: !0 },
    { type: "chartSpecific", isOpen: !0 }
  ]
}, Xj = class extends _ {
  constructor(e) {
    super(
      /* html */
      '<div class="ag-chart-data-wrapper ag-scrollable-container"></div>'
    ), this.chartMenuContext = e, this.isSwitchCategorySeriesToggled = !1, this.restoreSwitchCategorySeriesToggleFocus = !1, this.panels = [], this.chartController = e.chartController;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation, this.chartSvc = e.chartSvc;
  }
  postConstruct() {
    this.createSwitchCategorySeriesToggle(), this.isSwitchCategorySeriesToggled = this.chartController.isCategorySeriesSwitched(), this.updatePanels();
    const e = this.updatePanels.bind(this);
    this.addManagedListeners(this.chartController, {
      chartModelUpdate: e,
      chartApiUpdate: e
    });
  }
  destroy() {
    this.clearPanelComponents(), super.destroy();
  }
  updatePanels() {
    var o, a, l, c, d;
    const e = this.chartType, t = this.isSwitchCategorySeriesToggled, { dimensionCols: s, valueCols: i } = this.chartController.getColStateForMenu();
    this.chartType = this.chartController.getChartType(), this.isSwitchCategorySeriesToggled = this.chartController.isCategorySeriesSwitched();
    const r = this.isSwitchCategorySeriesToggled !== t;
    this.canRefresh(e, this.chartType) && !r ? ((o = this.categoriesDataPanel) == null || o.refresh(s), (a = this.seriesDataPanel) == null || a.refresh(i), (l = this.seriesChartTypePanel) == null || l.refresh(i), (c = this.chartSpecificPanel) == null || c.refresh()) : this.recreatePanels(s, i);
    const n = lS(this.chartType) && this.chartSvc.isEnterprise() && !this.chartController.isGrouping();
    re(this.switchCategorySeriesToggle.getGui(), n), r && ((d = this.switchCategorySeriesToggle) == null || d.setValue(this.chartController.isCategorySeriesSwitched())), this.restoreSwitchCategorySeriesToggleFocus && (this.restoreSwitchCategorySeriesToggleFocus = !1, n && this.switchCategorySeriesToggle.getFocusableElement().focus());
  }
  canRefresh(e, t) {
    if (e === void 0)
      return !1;
    if (e === t)
      return !0;
    const s = (i) => ["columnLineCombo", "areaColumnCombo", "customCombo"].includes(i);
    return !!(s(e) && s(t));
  }
  recreatePanels(e, t) {
    var r, n;
    this.clearPanelComponents();
    const { chartType: s } = this;
    if (!s)
      return;
    const i = this.chartController.isCategorySeriesSwitched();
    (r = this.getDataPanelDef().groups) == null || r.forEach(({ type: o, isOpen: a }) => {
      o === (i ? "series" : "categories") ? (this.categoriesDataPanel = this.createBean(
        new $j(
          this.chartController,
          this.getCategoryGroupTitle(i),
          this.getCategoryGroupMultipleSelect(s, i),
          e,
          a
        )
      ), this.panels.push(this.categoriesDataPanel)) : o === (i ? "categories" : "series") ? (this.seriesDataPanel = this.createBean(
        new qj(
          this.chartController,
          this.chartMenuContext.chartOptionsService,
          this.getSeriesGroupTitle(i),
          this.getSeriesGroupMultipleSelect(s, i),
          this.getSeriesGroupMaxSelection(s, i),
          t,
          a
        )
      ), this.panels.push(this.seriesDataPanel)) : o === "seriesChartType" ? this.chartController.isComboChart() && (this.seriesChartTypePanel = this.createBean(
        new Kj(this.chartController, t, a)
      ), this.panels.push(this.seriesChartTypePanel)) : o === "chartSpecific" ? (this.chartSpecificPanel = this.createBean(new jj(this.chartMenuContext, a)), this.panels.push(this.chartSpecificPanel)) : I(144, { type: o });
    }), (n = i ? this.categoriesDataPanel : this.seriesDataPanel) == null || n.addItem(
      this.switchCategorySeriesToggle.getGui()
    ), this.addPanelComponents();
  }
  addPanelComponents() {
    if (!this.panels.length)
      return;
    const t = We(this.beans).createDocumentFragment();
    for (const s of this.panels)
      s.addCssClass("ag-chart-data-section"), t.appendChild(s.getGui());
    this.getGui().appendChild(t);
  }
  clearPanelComponents() {
    const e = this.getGui();
    this.panels.forEach((t) => {
      e.removeChild(t.getGui()), this.destroyBean(t);
    }), this.panels = [];
  }
  getDataPanelDef() {
    var e;
    return ((e = this.gos.get("chartToolPanelsDef")) == null ? void 0 : e.dataPanel) ?? Yj;
  }
  getCategoryGroupTitle(e) {
    return e ? this.chartTranslation.translate("seriesLabels") : this.chartTranslation.translate(this.chartController.isActiveXYChart() ? "labels" : "categories");
  }
  getCategoryGroupMultipleSelect(e, t) {
    return t ? !1 : Ou(e) !== 1;
  }
  getSeriesGroupTitle(e) {
    return e ? this.chartTranslation.translate("categoryValues") : this.chartTranslation.translate(this.chartController.isActiveXYChart() ? "xyValues" : "series");
  }
  getSeriesGroupMultipleSelect(e, t) {
    return this.getSeriesGroupMaxSelection(e, t) !== 1;
  }
  getSeriesGroupMaxSelection(e, t) {
    if (!t)
      return Kl(e);
  }
  createSwitchCategorySeriesToggle() {
    this.switchCategorySeriesToggle = this.createManagedBean(
      new oo({
        label: this.chartTranslation.translate("switchCategorySeries"),
        labelAlignment: "left",
        labelWidth: "flex",
        inputWidth: "flex",
        value: this.chartController.isCategorySeriesSwitched(),
        onValueChange: (e) => {
          this.restoreSwitchCategorySeriesToggleFocus = !0, this.chartController.switchCategorySeries(e);
        }
      })
    );
  }
}, Zj = class extends Ih {
  constructor(e) {
    super(
      e,
      /* html */
      `<div class="ag-angle-select">
            <div data-ref="eLabel"></div>
            <div class="ag-wrapper ag-angle-select-wrapper">
                <div class="ag-angle-select-field">
                    <div data-ref="eParentCircle" class="ag-angle-select-parent-circle">
                        <div data-ref="eChildCircle" class="ag-angle-select-child-circle"></div>
                    </div>
                </div>
                <ag-input-number-field data-ref="eAngleValue"></ag-input-number-field>
            </div>
        </div>`,
      [wc]
    ), this.eLabel = E, this.eParentCircle = E, this.eChildCircle = E, this.eAngleValue = E, this.radius = 0, this.offsetX = 0, this.offsetY = 0;
  }
  wireBeans(e) {
    this.dragSvc = e.dragSvc;
  }
  postConstruct() {
    var s;
    super.postConstruct();
    const { value: e, onValueChange: t } = this.config;
    e != null && this.setValue(e, void 0, !0), t != null && this.onValueChange(t), this.dragListener = {
      eElement: this.eParentCircle,
      dragStartPixels: 0,
      onDragStart: () => {
        this.parentCircleRect = this.eParentCircle.getBoundingClientRect();
      },
      onDragging: (i) => this.calculateAngleDrag(i),
      onDragStop: () => {
      }
    }, (s = this.dragSvc) == null || s.addDragSource(this.dragListener), this.eAngleValue.setLabel("").setLabelWidth(5).setInputWidth(45).setMin(0).setMax(360).setValue(`${this.degrees}`).onValueChange((i) => {
      (i == null || i === "") && (i = "0"), i = this.eAngleValue.normalizeValue(i);
      let r = parseFloat(i);
      r > 180 && (r = r - 360), this.setValue(r);
    }), this.updateNumberInput(), W(this.getValue()) && this.eAngleValue.setValue(this.normalizeNegativeValue(this.getValue()).toString()), this.addManagedListeners(this, {
      fieldValueChanged: () => {
        this.eAngleValue.getInputElement().contains(Ie(this.beans)) || this.updateNumberInput();
      }
    });
  }
  updateNumberInput() {
    const e = this.normalizeNegativeValue(this.getValue());
    this.eAngleValue.setValue(e.toString());
  }
  positionChildCircle(e) {
    const t = this.parentCircleRect || { width: 24, height: 24 }, s = this.eChildCircle, i = t.width / 2, r = t.height / 2;
    s.style.left = `${i + Math.cos(e) * 8}px`, s.style.top = `${r + Math.sin(e) * 8}px`;
  }
  calculatePolar() {
    const e = this.offsetX, t = this.offsetY, s = Math.atan2(t, e);
    this.degrees = this.toDegrees(s), this.radius = Math.sqrt(e * e + t * t), this.positionChildCircle(s);
  }
  calculateCartesian() {
    const e = this.toRadians(this.getValue()), t = this.getRadius();
    this.setOffsetX(Math.cos(e) * t).setOffsetY(Math.sin(e) * t);
  }
  setOffsetX(e) {
    return this.offsetX !== e && (this.offsetX = e, this.calculatePolar()), this;
  }
  setOffsetY(e) {
    return this.offsetY !== e && (this.offsetY = e, this.calculatePolar()), this;
  }
  calculateAngleDrag(e) {
    const t = this.parentCircleRect, s = t.width / 2, i = t.height / 2, r = e.clientX - t.left, n = e.clientY - t.top, o = r - s, a = n - i, l = Math.atan2(a, o);
    this.setValue(l, !0);
  }
  toDegrees(e) {
    return e / Math.PI * 180;
  }
  toRadians(e) {
    return e / 180 * Math.PI;
  }
  normalizeNegativeValue(e) {
    return e < 0 ? 360 + e : e;
  }
  normalizeAngle180(e) {
    return e %= Math.PI * 2, e < -Math.PI ? e += Math.PI * 2 : e >= Math.PI && (e -= Math.PI * 2), e;
  }
  getRadius() {
    return this.radius;
  }
  setRadius(e) {
    return this.radius === e ? this : (this.radius = e, this.calculateCartesian(), this);
  }
  onValueChange(e) {
    return this.addManagedListeners(this, {
      fieldValueChanged: () => {
        e(this.degrees);
      }
    }), this;
  }
  getValue(e) {
    return e ? this.toRadians(this.degrees) : this.degrees;
  }
  setValue(e, t, s) {
    let i;
    return t ? i = e : i = this.normalizeAngle180(this.toRadians(e)), e = this.toDegrees(i), this.degrees !== e && (this.degrees = Math.floor(e), this.calculateCartesian(), this.positionChildCircle(i), s || this.dispatchLocalEvent({ type: "fieldValueChanged" })), this;
  }
  setWidth(e) {
    return si(this.getGui(), e), this;
  }
  setDisabled(e) {
    return super.setDisabled(e), this.eAngleValue.setDisabled(e), this;
  }
  destroy() {
    var e;
    (e = this.dragSvc) == null || e.removeDragSource(this.dragListener), super.destroy();
  }
};
function Qj(e) {
  return e[0].toUpperCase() + e.substring(1).toLowerCase();
}
var xn = class extends _ {
  constructor(e) {
    super(), this.params = e, this.fontGroup = E, this.activeComps = [], this.chartOptions = e.chartMenuParamsFactory.getChartOptions();
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const {
      cssIdentifier: e = "charts-format-sub-level",
      name: t,
      enabled: s,
      onEnableChange: i,
      suppressEnabledCheckbox: r,
      chartMenuParamsFactory: n,
      keyMapper: o
    } = this.params, a = {
      cssIdentifier: e,
      direction: "vertical",
      suppressOpenCloseIcons: !0,
      title: t,
      enabled: s,
      suppressEnabledCheckbox: !0,
      onEnableChange: (l) => {
        i && i(l);
      },
      useToggle: !r
    };
    this.setTemplate(
      /* html */
      `<div class="ag-font-panel">
        <ag-group-component data-ref="fontGroup">
            <ag-select data-ref="familySelect"></ag-select>
            <ag-select data-ref="weightStyleSelect"></ag-select>
            <div class="ag-charts-font-size-color">
                <ag-select data-ref="sizeSelect"></ag-select>
                <ag-color-picker data-ref="colorPicker"></ag-color-picker>
            </div>
        </ag-group-component>
    </div>`,
      [dt, ma, Ei],
      {
        fontGroup: a,
        familySelect: this.getFamilySelectParams(),
        weightStyleSelect: this.getWeightStyleSelectParams(),
        sizeSelect: this.getSizeSelectParams(),
        colorPicker: n.getDefaultColorPickerParams(o("color"))
      }
    ), this.addOrRemoveCssClass("ag-font-panel-no-header", !t);
  }
  addItem(e, t) {
    t ? this.fontGroup.prependItem(e) : this.fontGroup.addItem(e), this.activeComps.push(e);
  }
  setEnabled(e) {
    this.fontGroup.setEnabled(e);
  }
  getFamilySelectParams() {
    const e = [
      "Arial, sans-serif",
      "Aria Black, sans-serif",
      "Book Antiqua,  serif",
      "Charcoal, sans-serif",
      "Comic Sans MS, cursive",
      "Courier, monospace",
      "Courier New, monospace",
      "Gadget, sans-serif",
      "Geneva, sans-serif",
      "Helvetica, sans-serif",
      "Impact, sans-serif",
      "Lucida Console, monospace",
      "Lucida Grande, sans-serif",
      "Lucida Sans Unicode,  sans-serif",
      "Monaco, monospace",
      "Palatino Linotype, serif",
      "Palatino, serif",
      "Times New Roman, serif",
      "Times, serif",
      "Verdana, sans-serif"
    ], t = this.getInitialFontValue("fontFamily");
    let s = e[0];
    if (t) {
      const n = e.map((o) => o.toLowerCase()).indexOf(t.toLowerCase());
      if (n >= 0)
        s = e[n];
      else {
        const o = Qj(t);
        e.push(o), s = o;
      }
    }
    const i = e.sort().map((r) => ({ value: r, text: r }));
    return this.params.chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams(
      "font",
      i,
      `${s}`,
      (r) => this.setFont({ fontFamily: r })
    );
  }
  getSizeSelectParams() {
    const e = [8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36], t = this.getInitialFontValue("fontSize");
    e.includes(t) || e.push(t);
    const s = e.sort((i, r) => i - r).map((i) => ({ value: `${i}`, text: `${i}` }));
    return this.params.chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams(
      "size",
      s,
      `${t}`,
      (i) => this.setFont({ fontSize: parseInt(i, 10) })
    );
  }
  getWeightStyleSelectParams() {
    const e = this.getInitialFontValue("fontWeight") ?? "normal", t = this.getInitialFontValue("fontStyle") ?? "normal", s = [
      { name: "normal", weight: "normal", style: "normal" },
      { name: "bold", weight: "bold", style: "normal" },
      { name: "italic", weight: "normal", style: "italic" },
      { name: "boldItalic", weight: "bold", style: "italic" }
    ];
    let i = s.find((n) => n.weight === e && n.style === t);
    i || (i = { name: "predefined", weight: e, style: t }, s.unshift(i));
    const r = s.map((n) => ({
      value: n.name,
      text: this.chartTranslation.translate(n.name)
    }));
    return this.params.chartMenuParamsFactory.getDefaultSelectParamsWithoutValueParams(
      "weight",
      r,
      i.name,
      (n) => {
        const o = s.find((a) => a.name === n);
        this.setFont({ fontWeight: o.weight, fontStyle: o.style });
      }
    );
  }
  destroyActiveComps() {
    this.activeComps.forEach((e) => {
      ut(e.getGui()), this.destroyBean(e);
    });
  }
  destroy() {
    this.destroyActiveComps(), super.destroy();
  }
  setFont(e) {
    const { keyMapper: t } = this.params;
    Object.entries(e).forEach(([s, i]) => {
      i && this.chartOptions.setValue(t(s), i);
    });
  }
  getInitialFontValue(e) {
    const { keyMapper: t } = this.params;
    return this.chartOptions.getValue(t(e));
  }
}, Jj = class extends _ {
  constructor(e) {
    super(), this.chartMenuUtils = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const { chartMenuUtils: e } = this, t = e.addEnableParams("tick.enabled", {
      cssIdentifier: "charts-format-sub-level",
      direction: "vertical",
      suppressOpenCloseIcons: !0,
      title: this.chartTranslation.translate("ticks"),
      suppressEnabledCheckbox: !0,
      useToggle: !0
    }), s = e.getDefaultColorPickerParams("tick.stroke"), i = e.getDefaultSliderParams("tick.width", "width", 10), r = e.getDefaultSliderParams("tick.size", "length", 30);
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="axisTicksGroup">
                <ag-color-picker data-ref="axisTicksColorPicker"></ag-color-picker>
                <ag-slider data-ref="axisTicksWidthSlider"></ag-slider>
                <ag-slider data-ref="axisTicksSizeSlider"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, Ei, xs],
      {
        axisTicksGroup: t,
        axisTicksColorPicker: s,
        axisTicksWidthSlider: i,
        axisTicksSizeSlider: r
      }
    );
  }
}, e3 = class extends _ {
  constructor(e) {
    super(), this.chartMenuUtils = e, this.chartOptions = e.getChartOptions();
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = this.chartMenuUtils.addEnableParams("gridLine.enabled", {
      cssIdentifier: "charts-format-sub-level",
      direction: "vertical",
      suppressOpenCloseIcons: !0,
      title: this.chartTranslation.translate("gridLines"),
      suppressEnabledCheckbox: !0,
      useToggle: !0
    }), t = this.getGridLineColorPickerParams("color"), s = this.getGridLineWidthSliderParams("thickness"), i = this.getGridLineDashSliderParams("lineDash");
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="gridLineGroup">
                <ag-color-picker data-ref="gridLineColorPicker"></ag-color-picker>
                <ag-slider data-ref="gridLineWidthSlider"></ag-slider>
                <ag-slider data-ref="gridLineLineDashSlider"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, Ei, xs],
      {
        gridLineGroup: e,
        gridLineColorPicker: t,
        gridLineWidthSlider: s,
        gridLineLineDashSlider: i
      }
    );
  }
  getGridLineColorPickerParams(e) {
    return this.chartMenuUtils.getDefaultColorPickerParams("gridLine.style", e, {
      formatInputValue: (t) => {
        var s;
        return (s = t == null ? void 0 : t[0]) == null ? void 0 : s.stroke;
      },
      parseInputValue: (t) => {
        const s = this.chartOptions.getValue("gridLine.style") ?? [];
        return s.length === 0 ? [{ stroke: t, lineDash: [] }] : [{ ...s[0], stroke: t }];
      }
    });
  }
  getGridLineWidthSliderParams(e) {
    return this.chartMenuUtils.getDefaultSliderParams("gridLine.width", e, 10);
  }
  getGridLineDashSliderParams(e) {
    var r, n;
    const t = this.chartOptions.getValue("gridLine.style"), s = (n = (r = t == null ? void 0 : t[0]) == null ? void 0 : r.lineDash) == null ? void 0 : n[0], i = this.chartMenuUtils.getDefaultSliderParamsWithoutValueParams(s ?? 0, e, 30);
    return i.onValueChange = (o) => {
      const a = this.chartOptions.getValue("gridLine.style.0.stroke");
      this.chartOptions.setValue("gridLine.style", [
        { lineDash: [o], stroke: a }
      ]);
    }, i;
  }
}, t3 = "%d %B %Y", tl = class extends _ {
  constructor(e, t) {
    super(), this.axisType = e, this.options = t, this.axisGroup = E, this.axisTypeSelect = E, this.axisPositionSelect = E, this.axisTimeFormatSelect = E, this.activePanels = [], this.axisLabelUpdateFuncs = [];
    const { chartOptionsService: s, seriesType: i } = t;
    this.chartOptionsSeriesProxy = s.getSeriesOptionsProxy(() => i);
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    var m;
    const {
      isExpandedOnInit: e,
      chartOptionsService: t,
      chartController: s,
      registerGroupComponent: i
    } = this.options, r = this.axisType, n = {
      cssIdentifier: "charts-format-top-level",
      direction: "vertical",
      title: this.translate(r),
      expanded: e,
      suppressEnabledCheckbox: !0
    }, o = t.getCartesianAxisOptionsProxy(this.axisType), a = this.createManagedBean(new Sn(o)), l = this.createManagedBean(
      new Sn(t.getCartesianAxisThemeOverridesProxy(this.axisType))
    ), c = this.getAxisTypeSelectParams(
      a,
      t.getCartesianAxisAppliedThemeOverridesProxy(this.axisType)
    ), d = this.getAxisPositionSelectParams(a), u = this.getAxisTimeFormatSelectParams(a), h = this.getAxisColorInputParams(l), p = this.getAxisLineWidthSliderParams(l);
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="axisGroup">
                <ag-select data-ref="axisTypeSelect"></ag-select>
                <ag-select data-ref="axisTimeFormatSelect"></ag-select>
                <ag-select data-ref="axisPositionSelect"></ag-select>
                <ag-color-picker data-ref="axisColorInput"></ag-color-picker>
                <ag-slider data-ref="axisLineWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, ma, Ei, xs],
      {
        axisGroup: n,
        axisTypeSelect: c ?? void 0,
        axisPositionSelect: d ?? void 0,
        axisTimeFormatSelect: u ?? void 0,
        axisColorInput: h,
        axisLineWidthSlider: p
      }
    ), i(this.axisGroup), this.axisTypeSelect.setDisplayed(!!((m = c.options) != null && m.length)), d || this.removeTemplateComponent(this.axisPositionSelect);
    const g = () => {
      const C = o.getValue("type") === "time";
      re(this.axisTimeFormatSelect.getGui(), C);
    };
    u ? (g(), this.addManagedEventListeners({
      chartOptionsChanged: () => {
        g();
      }
    })) : this.removeTemplateComponent(this.axisTimeFormatSelect), this.initGridLines(l), this.initAxisTicks(l), this.initAxisLabels(l);
    const f = () => this.axisLabelUpdateFuncs.forEach((C) => C());
    this.addManagedListeners(s, {
      chartUpdated: f,
      chartModelUpdate: () => setTimeout(() => {
        this.isAlive() && (this.refreshAxisTypeSelect(a), g());
      })
    });
  }
  getAxisTypeSelectParams(e, t) {
    const s = e.getChartOptions(), i = this.getAxisTypeSelectOptions(), r = e.getDefaultSelectParams("type", "axisType", i);
    return r.onValueChange = (n) => {
      const o = s.getValue("type");
      if (n === o)
        return;
      const a = t.getValue("*"), l = o === "time", c = n === "time", d = l !== c ? c ? t3 : void 0 : null;
      if (this.options.chartOptionsService.setCartesianCategoryAxisType(this.axisType, n), d !== null) {
        const u = s.getValue("label") ?? {};
        s.setValue("label", {
          ...u,
          format: d
        });
      }
      t.setValue("*", a);
    }, r;
  }
  refreshAxisTypeSelect(e) {
    const t = this.getAxisTypeSelectOptions(), s = !!t.length;
    this.axisTypeSelect.setDisplayed(s), s && this.axisTypeSelect.clearOptions().addOptions(t).setValue(e.getChartOptions().getValue("type"));
  }
  getAxisTypeSelectOptions() {
    const { chartController: e } = this.options, t = e.getChartType(), s = () => {
      const i = e.getChartData()[0];
      return i ? e.getSelectedDimensions().every((r) => !isNaN(parseFloat(i[r.colId]))) : !1;
    };
    return ["heatmap", "histogram", "boxPlot", "rangeBar", "scatter", "bubble"].includes(t) || e.isGrouping() || !this.isCategoryAxis() || e.isCategorySeriesSwitched() || !s() ? [] : ["category", "number", "time"].map((i) => ({
      value: i,
      text: this.translate(i)
    }));
  }
  isCategoryAxis() {
    const e = this.chartOptionsSeriesProxy.getValue("direction") === "horizontal";
    return e && this.axisType === "yAxis" || !e && this.axisType === "xAxis";
  }
  getAxisPositionSelectParams(e) {
    const t = ((s, i) => {
      switch (s) {
        case "heatmap":
          return null;
        default:
          switch (i) {
            case "xAxis":
              return [
                { value: "top", text: this.translate("top") },
                { value: "bottom", text: this.translate("bottom") }
              ];
            case "yAxis":
              return [
                { value: "left", text: this.translate("left") },
                { value: "right", text: this.translate("right") }
              ];
          }
      }
    })(this.options.chartController.getChartType(), this.axisType);
    return t ? e.getDefaultSelectParams("position", "position", t) : null;
  }
  getAxisTimeFormatSelectParams(e) {
    if (!this.isCategoryAxis())
      return null;
    const t = [
      { value: "%d/%m/%Y", text: this.translate("timeFormatSlashesDDMMYYYY") },
      { value: "%m/%d/%Y", text: this.translate("timeFormatSlashesMMDDYYYY") },
      { value: "%d/%m/%y", text: this.translate("timeFormatSlashesDDMMYY") },
      { value: "%m/%d/%y", text: this.translate("timeFormatSlashesMMDDYY") },
      { value: "%d.%e.%y", text: this.translate("timeFormatDotsDDMYY") },
      { value: "%e.%d.%y", text: this.translate("timeFormatDotsMDDYY") },
      { value: "%Y-%m-%d", text: this.translate("timeFormatDashesYYYYMMDD") },
      { value: "%d %B %Y", text: this.translate("timeFormatSpacesDDMMMMYYYY") },
      { value: "%H:%M:%S", text: this.translate("timeFormatHHMMSS") },
      { value: "%I:%M:%S %p", text: this.translate("timeFormatHHMMSSAmPm") }
    ];
    return e.getDefaultSelectParams("label.format", "timeFormat", t);
  }
  getAxisColorInputParams(e) {
    return e.getDefaultColorPickerParams("line.stroke");
  }
  getAxisLineWidthSliderParams(e) {
    const t = e.getChartOptions(), s = () => t.getValue("line.enabled") ? t.getValue("line.width") : null, i = (n) => {
      t.setValues([
        { expression: "line.enabled", value: n != null },
        { expression: "line.width", value: n ?? 0 }
      ]);
    }, r = e.getDefaultSliderParamsWithoutValueParams(
      s() ?? 0,
      "thickness",
      10
    );
    return r.onValueChange = (n) => {
      i(n === 0 ? null : n);
    }, r;
  }
  initGridLines(e) {
    if (this.options.chartController.getChartType() === "heatmap")
      return;
    const s = this.createBean(new e3(e));
    this.axisGroup.addItem(s), this.activePanels.push(s);
  }
  initAxisTicks(e) {
    if (!this.hasConfigurableAxisTicks())
      return;
    const t = this.createBean(new Jj(e));
    this.axisGroup.addItem(t), this.activePanels.push(t);
  }
  hasConfigurableAxisTicks() {
    switch (this.options.chartController.getChartType()) {
      case "radarLine":
      case "radarArea":
      case "rangeBar":
      case "boxPlot":
      case "waterfall":
        return !1;
      default:
        return !0;
    }
  }
  initAxisLabels(e) {
    const t = {
      name: this.translate("labels"),
      enabled: !0,
      suppressEnabledCheckbox: !0,
      chartMenuParamsFactory: e,
      keyMapper: (i) => `label.${i}`
    }, s = this.createBean(new xn(t));
    this.axisGroup.addItem(s), this.activePanels.push(s), this.addAdditionalLabelComps(s, e);
  }
  addAdditionalLabelComps(e, t) {
    this.addLabelPadding(e, t);
    const s = this.createRotationWidget("labelRotation", t), i = this.initLabelRotation(s, t);
    e.addItem(i), e.addItem(s);
  }
  initLabelRotation(e, t) {
    const s = t.getChartOptions(), i = () => s.getValue("label.rotation"), r = () => s.getValue("label.autoRotate"), n = (c) => {
      c && (this.prevRotation = i()), s.setValues([
        { expression: "label.autoRotate", value: c },
        // Clear the rotation option when activating auto-rotate, reinstate the previous value when deactivating
        { expression: "label.rotation", value: c ? void 0 : this.prevRotation }
      ]), e.setDisplayed(!c);
    }, a = typeof i() == "number" ? !1 : r(), l = this.createBean(
      new Pn({
        label: this.translate("autoRotate"),
        value: a,
        onValueChange: n
      })
    );
    return e.setDisplayed(!a), l;
  }
  createRotationWidget(e, t) {
    const s = t.getChartOptions(), i = () => s.getValue("label.rotation"), r = (l) => s.setValue("label.rotation", l), o = `${this.chartTranslation.translate(e)} °`, a = new Zj({
      label: o,
      labelWidth: "flex",
      value: i() ?? 0,
      onValueChange: r
    });
    return this.axisLabelUpdateFuncs.push(() => {
      a.setValue(i() ?? 0);
    }), this.createBean(a);
  }
  addLabelPadding(e, t) {
    const s = this.createBean(
      new Ts(t.getDefaultSliderParams("label.spacing", "padding", 30))
    );
    e.addItem(s);
  }
  translate(e) {
    return this.chartTranslation.translate(e);
  }
  removeTemplateComponent(e) {
    ut(e.getGui()), this.destroyBean(e);
  }
  destroyActivePanels() {
    this.activePanels.forEach((e) => {
      ut(e.getGui()), this.destroyBean(e);
    });
  }
  destroy() {
    this.destroyActivePanels(), super.destroy();
  }
}, s3 = class extends _ {
  constructor(e) {
    super(), this.options = e, this.axisGroup = E;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const { isExpandedOnInit: e, chartAxisMenuParamsFactory: t, registerGroupComponent: s } = this.options, i = {
      cssIdentifier: "charts-format-top-level",
      direction: "vertical",
      title: this.translate("polarAxis"),
      expanded: e,
      suppressEnabledCheckbox: !0
    }, r = t.getDefaultColorPickerParams("line.stroke"), n = t.getDefaultSliderParams(
      "line.width",
      "thickness",
      10
    );
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="axisGroup">
                <ag-color-picker data-ref="axisColorInput"></ag-color-picker>
                <ag-slider data-ref="axisLineWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, Ei, xs],
      {
        axisGroup: i,
        axisColorInput: r,
        axisLineWidthSlider: n
      }
    ), s(this.axisGroup), this.initAxis(), this.initAxisLabels(), this.initRadiusAxis();
  }
  initAxis() {
    const e = this.options.chartController.getChartType();
    if (["radarLine", "radarArea"].includes(e)) {
      const s = [
        { value: "circle", text: this.translate("circle") },
        { value: "polygon", text: this.translate("polygon") }
      ];
      this.axisGroup.addItem(
        this.createSelect({
          labelKey: "shape",
          options: s,
          property: "shape"
        })
      );
    }
    e !== "pie" && this.axisGroup.addItem(
      this.createSlider({
        labelKey: "innerRadius",
        defaultMaxValue: 1,
        property: "innerRadiusRatio"
      })
    );
  }
  initAxisLabels() {
    const e = {
      name: this.translate("labels"),
      enabled: !0,
      suppressEnabledCheckbox: !0,
      chartMenuParamsFactory: this.options.chartAxisMenuParamsFactory,
      keyMapper: (i) => `label.${i}`
    }, t = this.createManagedBean(new xn(e)), s = this.createOrientationWidget();
    t.addItem(s), this.axisGroup.addItem(t);
  }
  createOrientationWidget() {
    const e = [
      { value: "fixed", text: this.translate("fixed") },
      { value: "parallel", text: this.translate("parallel") },
      { value: "perpendicular", text: this.translate("perpendicular") }
    ];
    return this.createSelect({
      labelKey: "orientation",
      options: e,
      property: "label.orientation"
    });
  }
  initRadiusAxis() {
    const e = at(this.options.chartController.getChartType());
    if (!y$(e))
      return;
    const t = [
      this.createSlider({
        labelKey: "groupPadding",
        defaultMaxValue: 1,
        property: "paddingInner"
      }),
      this.createSlider({
        labelKey: "seriesPadding",
        defaultMaxValue: 1,
        property: "groupPaddingInner"
      })
    ], s = this.createManagedBean(
      new qi({
        cssIdentifier: "charts-format-sub-level",
        direction: "vertical",
        suppressOpenCloseIcons: !0,
        enabled: !0,
        suppressEnabledCheckbox: !0,
        title: this.translate("padding"),
        items: t
      })
    ).hideEnabledCheckbox(!0).hideOpenCloseIcons(!0);
    this.axisGroup.addItem(s);
  }
  createSlider(e) {
    const { labelKey: t, defaultMaxValue: s, step: i = 0.05, property: r } = e, n = this.options.chartAxisMenuParamsFactory.getDefaultSliderParams(
      r,
      t,
      s
    );
    return n.step = i, this.createManagedBean(new Ts(n));
  }
  createSelect(e) {
    const { labelKey: t, options: s, property: i } = e;
    return this.createManagedBean(
      new rs(this.options.chartAxisMenuParamsFactory.getDefaultSelectParams(i, t, s))
    );
  }
  translate(e) {
    return this.chartTranslation.translate(e);
  }
}, i3 = class extends _ {
  constructor(e) {
    super(), this.chartMenuUtils = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = this.chartMenuUtils.addEnableParams(
      "background.visible",
      {
        cssIdentifier: "charts-format-sub-level",
        direction: "vertical",
        suppressOpenCloseIcons: !0,
        title: this.chartTranslation.translate("background"),
        suppressEnabledCheckbox: !0,
        useToggle: !0
      }
    ), t = this.chartMenuUtils.getDefaultColorPickerParams("background.fill");
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="chartBackgroundGroup">
                <ag-color-picker data-ref="colorPicker"></ag-color-picker>
            </ag-group-component>
        <div>`,
      [dt, Ei],
      {
        chartBackgroundGroup: e,
        colorPicker: t
      }
    );
  }
}, r3 = class extends _ {
  constructor(e, t) {
    super(), this.chartMenuUtils = e, this.chartController = t, this.paddingTopSlider = E;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = {
      cssIdentifier: "charts-format-sub-level",
      direction: "vertical",
      suppressOpenCloseIcons: !0,
      title: this.chartTranslation.translate("padding"),
      suppressEnabledCheckbox: !0
    }, t = (s) => this.chartMenuUtils.getDefaultSliderParams("padding." + s, s, 200);
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="chartPaddingGroup">
                <ag-slider data-ref="paddingTopSlider"></ag-slider>
                <ag-slider data-ref="paddingRightSlider"></ag-slider>
                <ag-slider data-ref="paddingBottomSlider"></ag-slider>
                <ag-slider data-ref="paddingLeftSlider"></ag-slider>
            </ag-group-component>
        <div>`,
      [dt, xs],
      {
        chartPaddingGroup: e,
        paddingTopSlider: t("top"),
        paddingRightSlider: t("right"),
        paddingBottomSlider: t("bottom"),
        paddingLeftSlider: t("left")
      }
    ), this.addManagedEventListeners({
      chartOptionsChanged: (s) => {
        this.updateTopPadding(s.chartOptions);
      }
    });
  }
  updateTopPadding(e) {
    const t = [...this.chartController.getChartSeriesTypes(), "common"].map((s) => {
      var i, r;
      return (r = (i = e[s]) == null ? void 0 : i.padding) == null ? void 0 : r.top;
    }).find((s) => s != null);
    t != null && this.paddingTopSlider.setValue(`${t}`);
  }
}, n3 = class extends _ {
  constructor(e) {
    super(), this.options = e, this.chartGroup = E;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const {
      chartController: e,
      chartMenuParamsFactory: t,
      isExpandedOnInit: s,
      registerGroupComponent: i
    } = this.options, r = {
      cssIdentifier: "charts-format-top-level",
      direction: "vertical",
      title: this.chartTranslation.translate("chartStyle"),
      expanded: s,
      suppressEnabledCheckbox: !0,
      items: [
        this.createManagedBean(new r3(t, e)),
        this.createManagedBean(new i3(t))
      ]
    };
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="chartGroup"></ag-group-component>
        </div>`,
      [dt],
      { chartGroup: r }
    ), i(this.chartGroup);
  }
}, o3 = class extends L {
  constructor(e) {
    super(), this.groupContainer = e, this.id = 0, this.groupComponents = /* @__PURE__ */ new Map();
  }
  addGroupComponent(e) {
    const t = this.id++;
    this.groupComponents.set(t, e), e.isExpanded() && (this.expandedGroupComponent = t), e.onExpandedChange((s) => {
      var i;
      if (s) {
        const r = this.expandedGroupComponent;
        if (this.expandedGroupComponent = t, r != null) {
          const n = e.getGui(), o = n.offsetTop - this.groupContainer.parentElement.scrollTop;
          (i = this.groupComponents.get(r)) == null || i.toggleGroupExpand(!1, !0);
          let a = n.offsetTop - o;
          a < 0 && (a = 0), a !== this.groupContainer.parentElement.scrollTop && (this.groupContainer.parentElement.scrollTop = a);
        }
      } else
        this.expandedGroupComponent = void 0;
    });
  }
  destroy() {
    this.groupComponents.clear(), super.destroy();
  }
}, a3 = class extends _ {
  constructor(e) {
    super(), this.options = e, this.legendGroup = E, this.isGradient = ["treemap", "sunburst", "heatmap"].includes(e.seriesType), this.key = this.isGradient ? "gradientLegend" : "legend";
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const { chartMenuParamsFactory: e, isExpandedOnInit: t, registerGroupComponent: s } = this.options, i = this.createManagedBean(
      new rs(
        e.getDefaultSelectParams(
          `${this.key}.position`,
          "position",
          ["top", "right", "bottom", "left"].map((o) => ({
            value: o,
            text: this.chartTranslation.translate(o)
          }))
        )
      )
    ), r = this.createManagedBean(
      new qi(
        e.addEnableParams(`${this.key}.enabled`, {
          cssIdentifier: "charts-format-sub-level",
          direction: "vertical",
          suppressOpenCloseIcons: !0,
          title: this.chartTranslation.translate("legendEnabled"),
          suppressEnabledCheckbox: !0,
          useToggle: !0,
          items: [
            this.createLabelPanel(e),
            i,
            ...this.getItems(e)
          ]
        })
      )
    ), n = {
      cssIdentifier: "charts-format-top-level",
      direction: "vertical",
      title: this.chartTranslation.translate("legend"),
      suppressEnabledCheckbox: !0,
      expanded: t,
      items: [r]
    };
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="legendGroup">
            </ag-group-component>
        </div>`,
      [dt],
      {
        legendGroup: n
      }
    ), s(this.legendGroup);
  }
  getItems(e) {
    const t = (s, i, r) => this.createManagedBean(
      new Ts(
        e.getDefaultSliderParams(
          `${this.key}.${s}`,
          i,
          r
        )
      )
    );
    return this.isGradient ? [
      this.createManagedBean(
        new Pn(
          e.addValueParams("gradientLegend.reverseOrder", {
            label: this.chartTranslation.translate("reverseDirection"),
            labelWidth: "flex"
          })
        )
      ),
      t("gradient.thickness", "thickness", 40),
      t("gradient.preferredLength", "preferredLength", 300),
      t("spacing", "spacing", 200)
    ] : [
      t("spacing", "spacing", 200),
      t("item.marker.size", "markerSize", 40),
      t("item.marker.strokeWidth", "markerStroke", 10),
      t("item.marker.padding", "itemSpacing", 20),
      t("item.paddingX", "layoutHorizontalSpacing", 50),
      t("item.paddingY", "layoutVerticalSpacing", 50)
    ];
  }
  createLabelPanel(e) {
    const t = this.isGradient ? "gradientLegend.scale.label" : "legend.item.label", s = {
      enabled: !0,
      suppressEnabledCheckbox: !0,
      chartMenuParamsFactory: e,
      keyMapper: (i) => `${t}.${i}`,
      cssIdentifier: "charts-format-sub-level-no-header"
    };
    return this.createManagedBean(new xn(s));
  }
}, l3 = class extends _ {
  constructor(e) {
    super(), this.chartMenuUtils = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = {
      cssIdentifier: "charts-format-sub-level",
      direction: "vertical",
      title: this.chartTranslation.translate("callout"),
      enabled: !0,
      suppressOpenCloseIcons: !0,
      suppressEnabledCheckbox: !0
    };
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="calloutGroup">
                <ag-slider data-ref="calloutLengthSlider"></ag-slider>
                <ag-slider data-ref="calloutStrokeWidthSlider"></ag-slider>
                <ag-slider data-ref="labelOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, xs],
      {
        calloutGroup: e,
        calloutLengthSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLine.length", "length", 40),
        calloutStrokeWidthSlider: this.chartMenuUtils.getDefaultSliderParams(
          "calloutLine.strokeWidth",
          "strokeWidth",
          10
        ),
        labelOffsetSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLabel.offset", "offset", 30)
      }
    );
  }
}, c3 = class extends _ {
  constructor(e) {
    super(), this.chartMenuUtils = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = {
      cssIdentifier: "charts-format-sub-level",
      direction: "vertical",
      title: this.chartTranslation.translate("cap"),
      enabled: !0,
      suppressOpenCloseIcons: !0,
      suppressEnabledCheckbox: !0
    }, t = this.chartMenuUtils.getDefaultSliderParams(
      "cap.lengthRatio",
      "capLengthRatio",
      1
    );
    t.step = 0.05, this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="capsGroup">
                <ag-slider data-ref="capLengthRatioSlider"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, xs],
      {
        capsGroup: e,
        capLengthRatioSlider: t
      }
    );
  }
}, d3 = class extends _ {
  constructor(e) {
    super(), this.chartMenuUtils = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = {
      cssIdentifier: "charts-format-sub-level",
      direction: "vertical",
      title: this.chartTranslation.translate("connectorLine"),
      enabled: !0,
      suppressOpenCloseIcons: !0,
      suppressEnabledCheckbox: !0
    };
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="lineGroup">
                <ag-color-picker data-ref="lineColorPicker"></ag-color-picker>
                <ag-slider data-ref="lineStrokeWidthSlider"></ag-slider>
                <ag-slider data-ref="lineOpacitySlider"></ag-slider>
                <ag-slider data-ref="lineDashSlider"></ag-slider>                
            </ag-group-component>
        </div>`,
      [dt, Ei, xs],
      {
        lineGroup: e,
        lineColorPicker: this.chartMenuUtils.getDefaultColorPickerParams("line.stroke"),
        lineStrokeWidthSlider: this.getSliderParams("strokeWidth", 10, "line.strokeWidth"),
        lineDashSlider: this.getSliderParams("lineDash", 30, "line.lineDash", 1, !0),
        lineOpacitySlider: this.getSliderParams("strokeOpacity", 1, "line.strokeOpacity", 0.05)
      }
    );
  }
  getSliderParams(e, t, s, i = 1, r = !1) {
    const n = this.chartMenuUtils.getDefaultSliderParams(s, e, t, r);
    return n.step = i, n;
  }
};
function SS(e) {
  return ["square", "circle", "cross", "diamond", "plus", "triangle", "heart"].map((t) => ({
    value: t,
    text: e.translate(t)
  }));
}
var u3 = class extends _ {
  constructor(e) {
    super(), this.chartMenuUtils = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = this.chartMenuUtils.addEnableParams("marker.enabled", {
      cssIdentifier: "charts-format-sub-level",
      direction: "vertical",
      title: this.chartTranslation.translate("markers"),
      suppressEnabledCheckbox: !0,
      useToggle: !0,
      suppressOpenCloseIcons: !0
    });
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="seriesMarkersGroup">
                <ag-select data-ref="seriesMarkerShapeSelect"></ag-select>
                <ag-slider data-ref="seriesMarkerSizeSlider"></ag-slider>
                <ag-slider data-ref="seriesMarkerStrokeWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, ma, xs],
      {
        seriesMarkersGroup: e,
        seriesMarkerShapeSelect: this.chartMenuUtils.getDefaultSelectParams(
          "marker.shape",
          "shape",
          SS(this.chartTranslation)
        ),
        seriesMarkerSizeSlider: this.chartMenuUtils.getDefaultSliderParams("marker.size", "size", 60),
        seriesMarkerStrokeWidthSlider: this.chartMenuUtils.getDefaultSliderParams(
          "marker.strokeWidth",
          "strokeWidth",
          10
        )
      }
    );
  }
}, h3 = class extends _ {
  constructor(e) {
    super(), this.chartMenuUtils = e, this.seriesItemsGroup = E, this.activePanels = [];
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = {
      cssIdentifier: "charts-format-sub-level",
      direction: "vertical",
      title: this.chartTranslation.translate("seriesItems"),
      enabled: !0,
      suppressOpenCloseIcons: !0,
      suppressEnabledCheckbox: !0
    };
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="seriesItemsGroup">
                <ag-select data-ref="seriesItemSelect"></ag-select>
            </ag-group-component>
        </div>`,
      [dt, ma],
      {
        seriesItemsGroup: e,
        seriesItemSelect: this.getSeriesItemsParams()
      }
    ), this.initSeriesControls();
  }
  getSeriesItemsParams() {
    const e = [
      { value: "positive", text: this.chartTranslation.translate("seriesItemPositive") },
      { value: "negative", text: this.chartTranslation.translate("seriesItemNegative") }
    ], t = (s) => {
      this.destroyActivePanels(), this.initSeriesControls(s);
    };
    return this.chartMenuUtils.getDefaultSelectParamsWithoutValueParams(
      "seriesItemType",
      e,
      "positive",
      t
    );
  }
  initSeriesControls(e = "positive") {
    this.initSlider("strokeWidth", 10, `item.${e}.strokeWidth`), this.initSlider("lineDash", 30, `item.${e}.lineDash`, 1, !0), this.initSlider("strokeOpacity", 1, `item.${e}.strokeOpacity`, 0.05, !1), this.initSlider("fillOpacity", 1, `item.${e}.fillOpacity`, 0.05, !1), this.initItemLabels(e);
  }
  initSlider(e, t, s, i = 1, r = !1) {
    const n = this.chartMenuUtils.getDefaultSliderParams(s, e, t, r);
    n.step = i;
    const o = this.seriesItemsGroup.createManagedBean(new Ts(n));
    this.seriesItemsGroup.addItem(o), this.activePanels.push(o);
  }
  initItemLabels(e) {
    const t = this.chartMenuUtils.getDefaultFontPanelParams(
      `item.${e}.label`,
      "seriesItemLabels"
    ), s = this.createBean(new xn(t));
    this.seriesItemsGroup.addItem(s), this.activePanels.push(s);
  }
  destroyActivePanels() {
    this.activePanels.forEach((e) => {
      ut(e.getGui()), this.destroyBean(e);
    });
  }
  destroy() {
    this.destroyActivePanels(), super.destroy();
  }
}, p3 = class extends _ {
  constructor(e, t = "shadow") {
    super(), this.chartMenuUtils = e, this.propertyKey = t;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = this.propertyKey, t = this.chartMenuUtils.addEnableParams(
      `${e}.enabled`,
      {
        cssIdentifier: "charts-format-sub-level",
        direction: "vertical",
        suppressOpenCloseIcons: !0,
        title: this.chartTranslation.translate("shadow"),
        suppressEnabledCheckbox: !0,
        useToggle: !0
      }
    ), s = this.chartMenuUtils.getDefaultColorPickerParams(`${e}.color`);
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="shadowGroup">
                <ag-color-picker data-ref="shadowColorPicker"></ag-color-picker>
                <ag-slider data-ref="shadowBlurSlider"></ag-slider>
                <ag-slider data-ref="shadowXOffsetSlider"></ag-slider>
                <ag-slider data-ref="shadowYOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, Ei, xs],
      {
        shadowGroup: t,
        shadowColorPicker: s,
        shadowBlurSlider: this.getSliderParams("blur", 0, 20),
        shadowXOffsetSlider: this.getSliderParams("xOffset", -10, 10),
        shadowYOffsetSlider: this.getSliderParams("yOffset", -10, 10)
      }
    );
  }
  getSliderParams(e, t, s) {
    const i = `${this.propertyKey}.${e}`, r = this.chartMenuUtils.getDefaultSliderParams(i, e, s);
    return r.minValue = t, r;
  }
}, g3 = class extends _ {
  constructor(e) {
    super(), this.chartMenuUtils = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = {
      cssIdentifier: "charts-format-sub-level",
      direction: "vertical",
      enabled: !0,
      suppressOpenCloseIcons: !0,
      suppressEnabledCheckbox: !0
    };
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="groupSpacing">
                <ag-slider data-ref="groupPaddingSlider"></ag-slider>
                <ag-slider data-ref="groupSpacingSlider"></ag-slider>
            </ag-group-component>
            <ag-group-component data-ref="tileSpacing">
                <ag-slider data-ref="tilePaddingSlider"></ag-slider>
                <ag-slider data-ref="tileSpacingSlider"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, xs],
      {
        groupSpacing: { ...e, title: this.chartTranslation.translate("group") },
        tileSpacing: { ...e, title: this.chartTranslation.translate("tile") },
        groupPaddingSlider: this.getSliderParams("padding", "group.padding"),
        groupSpacingSlider: this.getSliderParams("spacing", "group.gap"),
        tilePaddingSlider: this.getSliderParams("padding", "tile.padding"),
        tileSpacingSlider: this.getSliderParams("spacing", "tile.gap")
      }
    );
  }
  getSliderParams(e, t) {
    return this.chartMenuUtils.getDefaultSliderParams(t, e, 10);
  }
}, f3 = class extends _ {
  constructor(e) {
    super(), this.chartMenuUtils = e;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const e = {
      cssIdentifier: "charts-format-sub-level",
      direction: "vertical",
      title: this.chartTranslation.translate("whisker"),
      enabled: !0,
      suppressOpenCloseIcons: !0,
      suppressEnabledCheckbox: !0
    };
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="whiskersGroup">
                <ag-color-picker data-ref="whiskerColorPicker"></ag-color-picker>
                <ag-slider data-ref="whiskerThicknessSlider"></ag-slider>
                <ag-slider data-ref="whiskerOpacitySlider"></ag-slider>
                <ag-slider data-ref="whiskerLineDashSlider"></ag-slider>
                <ag-slider data-ref="whiskerLineDashOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`,
      [dt, Ei, xs],
      {
        whiskersGroup: e,
        whiskerColorPicker: this.chartMenuUtils.getDefaultColorPickerParams("whisker.stroke"),
        whiskerThicknessSlider: this.chartMenuUtils.getDefaultSliderParams(
          "whisker.strokeWidth",
          "strokeWidth",
          10
        ),
        whiskerOpacitySlider: this.chartMenuUtils.getDefaultSliderParams(
          "whisker.strokeOpacity",
          "strokeOpacity",
          1
        ),
        whiskerLineDashSlider: this.chartMenuUtils.getDefaultSliderParams(
          "whisker.lineDash",
          "lineDash",
          30,
          !0
        ),
        whiskerLineDashOffsetSlider: this.chartMenuUtils.getDefaultSliderParams(
          "whisker.lineDashOffset",
          "lineDashOffset",
          30
        )
      }
    );
  }
}, yt = "tooltips", gs = "strokeWidth", Fs = "lineDash", Ut = "lineOpacity", Ps = "fillOpacity", Vt = "labels", jr = "shadow", m3 = class extends _ {
  constructor(e) {
    super(), this.options = e, this.seriesGroup = E, this.activePanels = [], this.widgetFuncs = {
      lineWidth: () => this.initStrokeWidth("lineWidth"),
      [gs]: () => this.initStrokeWidth("strokeWidth"),
      lineColor: () => this.initLineColor(),
      [Fs]: () => this.initLineDash(),
      [Ut]: () => this.initOpacity("strokeOpacity"),
      [Ps]: () => this.initOpacity("fillOpacity"),
      markers: () => new u3(this.chartMenuUtils),
      [Vt]: () => this.initLabels(),
      sectorLabels: () => this.initSectorLabels(),
      [jr]: () => new p3(this.chartMenuUtils),
      [yt]: () => this.initTooltips(),
      bins: () => this.initBins(),
      whiskers: () => new f3(this.chartMenuUtils),
      caps: () => new c3(this.chartMenuUtils),
      connectorLine: () => new d3(this.chartMenuUtils),
      seriesItems: () => new h3(this.chartMenuUtils),
      tileSpacing: () => new g3(this.chartMenuUtils),
      shape: () => this.initShape(),
      size: () => this.initSize("size", "size"),
      minSize: () => this.initSize("size", "minSize"),
      maxSize: () => this.initSize("maxSize", "maxSize")
    }, this.seriesWidgetMappings = {
      bar: [yt, gs, Fs, Ut, Ps, Vt, jr],
      pie: [yt, gs, Ut, Ps, Vt, "sectorLabels", jr],
      donut: [yt, gs, Ut, Ps, Vt, "sectorLabels", jr],
      line: [yt, "lineWidth", Fs, Ut, "markers", Vt],
      scatter: [yt, "shape", "size", gs, Vt],
      bubble: [yt, "shape", "minSize", "maxSize", gs, Vt],
      area: [yt, "lineWidth", Fs, Ut, Ps, "markers", Vt, jr],
      histogram: [yt, "bins", gs, Fs, Ut, Ps, Vt, jr],
      "radial-column": [yt, gs, Fs, Ut, Ps, Vt],
      "radial-bar": [yt, gs, Fs, Ut, Ps, Vt],
      "radar-line": [yt, gs, Fs, Ut, "markers", Vt],
      "radar-area": [yt, gs, Fs, Ut, Ps, "markers", Vt],
      nightingale: [yt, gs, Fs, Ut, Ps, Vt],
      "box-plot": [yt, gs, Fs, Ut, Ps, "whiskers", "caps"],
      "range-bar": [yt, gs, Fs, Ut, Ps, Vt],
      "range-area": [yt, "lineWidth", Fs, Ut, Ps, "markers", Vt, jr],
      treemap: [yt, "tileSpacing"],
      sunburst: [yt],
      heatmap: [yt, Vt, "lineColor", "lineWidth", Ut],
      waterfall: [yt, "connectorLine", "seriesItems"]
    }, this.seriesType = e.seriesType;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const {
      isExpandedOnInit: e,
      chartOptionsService: t,
      chartController: s,
      registerGroupComponent: i
    } = this.options, r = {
      cssIdentifier: "charts-format-top-level",
      direction: "vertical",
      title: this.translate("series"),
      expanded: e,
      suppressEnabledCheckbox: !0
    };
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="seriesGroup">
            </ag-group-component>
        </div>`,
      [dt],
      { seriesGroup: r }
    ), i(this.seriesGroup), this.chartMenuUtils = this.createManagedBean(
      new Sn(t.getSeriesOptionsProxy(() => this.seriesType))
    ), this.addManagedListeners(s, { chartSeriesChartTypeChanged: this.refreshWidgets.bind(this) }), this.refreshWidgets();
  }
  refreshWidgets() {
    const { chartController: e } = this.options;
    this.destroyActivePanels(), e.getChartProxy().getChart().waitForUpdate().then(() => {
      this.isAlive() && (e.isComboChart() && (this.updateSeriesType(), this.initSeriesSelect()), (this.seriesWidgetMappings[this.seriesType] ?? []).forEach((i) => {
        const r = this.widgetFuncs[i]();
        let n;
        if (Array.isArray(r)) {
          const o = this.createBean(r[0]);
          n = o, r[1](o);
        } else
          n = this.createBean(r);
        this.seriesGroup.addItem(n), this.activePanels.push(n);
      }));
    }).catch((s) => be(105, { e: s }));
  }
  initSeriesSelect() {
    const e = this.createBean(
      new rs(
        this.chartMenuUtils.getDefaultSelectParamsWithoutValueParams(
          "seriesType",
          this.getSeriesSelectOptions(),
          `${this.seriesType}`,
          (t) => {
            this.seriesType = t, this.refreshWidgets();
          }
        )
      )
    );
    this.seriesGroup.addItem(e), this.activePanels.push(e);
  }
  initTooltips() {
    return new oo(
      this.chartMenuUtils.addValueParams("tooltip.enabled", {
        label: this.translate("tooltips"),
        labelAlignment: "left",
        labelWidth: "flex",
        inputWidth: "flex"
      })
    );
  }
  initLineColor() {
    return new gS(this.chartMenuUtils.getDefaultColorPickerParams("stroke", "strokeColor"));
  }
  initStrokeWidth(e) {
    return new Ts(this.chartMenuUtils.getDefaultSliderParams("strokeWidth", e, 10));
  }
  initLineDash() {
    return new Ts(this.chartMenuUtils.getDefaultSliderParams("lineDash", "lineDash", 30, !0));
  }
  initOpacity(e) {
    const t = this.chartMenuUtils.getDefaultSliderParams(e, e, 1);
    return t.step = 0.05, new Ts(t);
  }
  initLabels() {
    const e = aS(this.seriesType), t = e ? "calloutLabel" : "label", s = e ? "calloutLabels" : "labels", i = this.chartMenuUtils.getDefaultFontPanelParams(t, s);
    return [new xn(i), (o) => {
      if (e) {
        const a = o.createManagedBean(new l3(this.chartMenuUtils));
        o.addItem(a), this.activePanels.push(a);
      }
      if (this.seriesType === "range-bar") {
        const a = [
          { value: "inside", text: this.translate("inside") },
          { value: "outside", text: this.translate("outside") }
        ], l = o.createManagedBean(
          new rs(
            this.chartMenuUtils.getDefaultSelectParams("label.placement", "labelPlacement", a)
          )
        );
        o.addItem(l), this.activePanels.push(l);
        const c = o.createManagedBean(
          new Ts(this.chartMenuUtils.getDefaultSliderParams("label.padding", "padding", 200))
        );
        o.addItem(c), this.activePanels.push(c);
      }
    }];
  }
  initSectorLabels() {
    const e = this.chartMenuUtils.getDefaultFontPanelParams("sectorLabel", "sectorLabels");
    return [new xn(e), (i) => {
      const r = this.chartMenuUtils.getDefaultSliderParams(
        "sectorLabel.positionRatio",
        "positionRatio",
        1
      );
      r.step = 0.05;
      const n = i.createManagedBean(new Ts(r));
      i.addItem(n);
    }];
  }
  initBins() {
    const e = this.chartMenuUtils.getDefaultSliderParams("binCount", "histogramBinCount", 20), t = this.chartMenuUtils.getChartOptions(), s = (t.getValue("bins") ?? t.getValue("calculatedBins", !0)).length;
    return e.value = `${s}`, e.maxValue = Math.max(s, 20), new Ts(e);
  }
  initShape() {
    return new rs(
      this.chartMenuUtils.getDefaultSelectParams("shape", "shape", SS(this.chartTranslation))
    );
  }
  initSize(e, t) {
    return new Ts(this.chartMenuUtils.getDefaultSliderParams(e, t, 60));
  }
  getSeriesSelectOptions() {
    const e = this.getActiveSeriesTypes();
    return ["area", "bar", "line"].filter((t) => e.includes(t)).map((t) => ({ value: t, text: this.translate(t) }));
  }
  updateSeriesType() {
    const e = this.getActiveSeriesTypes();
    !e.includes(this.seriesType) && e.length > 0 && (this.seriesType = e[0]);
  }
  getActiveSeriesTypes() {
    return this.options.chartController.getActiveSeriesChartTypes().map((e) => at(e.chartType));
  }
  translate(e) {
    return this.chartTranslation.translate(e);
  }
  destroyActivePanels() {
    this.activePanels.forEach((e) => {
      ut(e.getGui()), this.destroyBean(e);
    });
  }
  destroy() {
    this.destroyActivePanels(), super.destroy();
  }
}, Wo = class extends _ {
  constructor(e, t, s) {
    super(
      /* html */
      "<div></div>"
    ), this.chartMenuUtils = e, this.name = t, this.key = s, this.chartOptions = e.getChartOptions();
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    this.initFontPanel();
  }
  hasTitle() {
    const e = this.chartOptions.getValue(this.key);
    return e && e.enabled && e.text && e.text.length > 0;
  }
  initFontPanel() {
    const e = this.hasTitle(), t = {
      name: this.chartTranslation.translate(this.name),
      enabled: e,
      suppressEnabledCheckbox: !1,
      chartMenuParamsFactory: this.chartMenuUtils,
      keyMapper: (s) => `${this.key}.${s}`,
      onEnableChange: (s) => this.onEnableChange(s)
    };
    this.fontPanel = this.createManagedBean(new xn(t)), this.fontPanel.addItem(this.createBean(new li(this.getTextInputParams())), !0), this.fontPanel.addItem(this.createBean(new Ts(this.getSpacingSliderParams()))), this.getGui().appendChild(this.fontPanel.getGui());
  }
  getTextInputParams() {
    return this.chartMenuUtils.addValueParams(`${this.key}.text`, {
      label: this.chartTranslation.translate("title"),
      labelAlignment: "top"
    });
  }
  getSpacingSliderParams() {
    return this.chartMenuUtils.getDefaultSliderParams(`${this.key}.spacing`, "spacing", 100);
  }
  onEnableChange(e) {
    this.chartOptions.setValue(`${this.key}.enabled`, e);
  }
}, C3 = class extends Wo {
  wireBeans(e) {
    super.wireBeans(e), this.chartMenuSvc = e.chartMenuSvc;
  }
  postConstruct() {
    this.titlePlaceholder = this.chartTranslation.translate("titlePlaceholder"), super.postConstruct(), this.addManagedEventListeners({
      chartTitleEdit: () => {
        this.fontPanel.setEnabled(this.hasTitle());
      }
    });
  }
  getTextInputParams() {
    const e = super.getTextInputParams();
    return this.shouldOverrideTextWithPlaceholder(e.value) && (e.value = this.titlePlaceholder), e;
  }
  getSpacingSliderParams() {
    const e = super.getSpacingSliderParams();
    return e.value = "10", e;
  }
  onEnableChange(e) {
    if (this.chartMenuSvc.doesChartToolbarExist()) {
      const s = this.chartOptions.getValue("padding.top");
      this.chartOptions.setValue("padding.top", e ? s - 20 : s + 20);
    }
    this.chartOptions.setValue(`${this.key}.enabled`, e);
    const t = this.chartOptions.getValue(`${this.key}.text`);
    e && this.shouldOverrideTextWithPlaceholder(t) && this.chartOptions.setValue(`${this.key}.text`, this.titlePlaceholder);
  }
  shouldOverrideTextWithPlaceholder(e) {
    return e === "Title" || (e == null ? void 0 : e.trim().length) === 0;
  }
}, v3 = class extends _ {
  constructor(e) {
    super(), this.options = e, this.titleGroup = E;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    const {
      chartMenuParamsFactory: e,
      chartAxisMenuParamsFactory: t,
      chartOptionsService: s,
      seriesType: i,
      isExpandedOnInit: r = !1,
      registerGroupComponent: n
    } = this.options, o = [];
    if (vr(i)) {
      const l = (c) => this.createManagedBean(
        new Sn(s.getCartesianAxisThemeOverridesProxy(c))
      );
      o.push(
        this.createManagedBean(new Wo(l("xAxis"), "horizontalAxisTitle", "title"))
      ), o.push(
        this.createManagedBean(new Wo(l("yAxis"), "verticalAxisTitle", "title"))
      );
    } else ku(i) && o.push(
      this.createManagedBean(new Wo(t, "polarAxisTitle", "title"))
    );
    const a = {
      cssIdentifier: "charts-format-top-level",
      direction: "vertical",
      title: this.chartTranslation.translate("chartTitles"),
      expanded: r,
      suppressEnabledCheckbox: !0,
      items: [
        this.createManagedBean(new C3(e, "chartTitle", "title")),
        this.createManagedBean(new Wo(e, "chartSubtitle", "subtitle")),
        ...o
      ]
    };
    this.setTemplate(
      /* html */
      `<div>
            <ag-group-component data-ref="titleGroup"></ag-group-component>
        </div>`,
      [dt],
      { titleGroup: a }
    ), n(this.titleGroup);
  }
}, w3 = {
  groups: [{ type: "chart" }, { type: "titles" }, { type: "legend" }, { type: "series" }, { type: "axis" }]
}, y3 = class extends _ {
  constructor(e) {
    super(
      /* html */
      '<div class="ag-chart-format-wrapper"></div>'
    ), this.chartMenuContext = e;
  }
  postConstruct() {
    this.groupExpansionFeature = this.createManagedBean(new o3(this.getGui())), this.chartPanelFeature = this.createManagedBean(
      new pS(
        this.chartMenuContext.chartController,
        this.getGui(),
        "ag-chart-format-section",
        (e, t) => this.createPanels(t)
      )
    ), this.chartPanelFeature.refreshPanels();
  }
  createPanels(e) {
    var s;
    let t = !1;
    (s = this.getFormatPanelDef().groups) == null || s.forEach(({ type: i, isOpen: r = !1 }) => {
      if (!this.isGroupPanelShownInSeries(i, e))
        return;
      r && (t && I(145, { group: i }), t = !0);
      const n = (a) => this.groupExpansionFeature.addGroupComponent(a), o = {
        ...this.chartMenuContext,
        isExpandedOnInit: r,
        seriesType: e,
        registerGroupComponent: n
      };
      switch (i) {
        case "chart":
          this.chartPanelFeature.addComponent(new n3(o));
          break;
        case "titles":
          this.chartPanelFeature.addComponent(new v3(o));
          break;
        case "legend":
          this.chartPanelFeature.addComponent(new a3(o));
          break;
        case "axis":
          ku(e) ? this.chartPanelFeature.addComponent(new s3(o)) : vr(e) && (this.chartPanelFeature.addComponent(new tl("xAxis", o)), this.chartPanelFeature.addComponent(new tl("yAxis", o)));
          break;
        case "horizontalAxis":
          this.chartPanelFeature.addComponent(new tl("xAxis", o));
          break;
        case "verticalAxis":
          this.chartPanelFeature.addComponent(new tl("yAxis", o));
          break;
        case "series":
          this.chartPanelFeature.addComponent(new m3(o));
          break;
        default:
          I(147, { group: i });
      }
    });
  }
  getFormatPanelDef() {
    var t;
    const e = (t = this.gos.get("chartToolPanelsDef")) == null ? void 0 : t.formatPanel;
    return e || w3;
  }
  isGroupPanelShownInSeries(e, t) {
    return ["chart", "titles", "legend", "series"].includes(e) || vr(t) && ["axis", "horizontalAxis", "verticalAxis"].includes(e) || ku(t) && e === "axis";
  }
};
function Ra(e) {
  const {
    stacked: t,
    size: s,
    padding: i,
    xScalePadding: r,
    xScaleDomain: n,
    yScaleDomain: o,
    agChartsExports: { _Scene: a }
  } = e, l = new a.BandScale();
  l.domain = n, l.range = [i, s - i], l.paddingInner = r, l.paddingOuter = r;
  const c = new a.LinearScale();
  c.domain = o, c.range = [s - i, i];
  const d = (u, h, p) => u.map((g, f) => {
    const m = p.convert(g), C = new a.Rect();
    return C.x = h.convert(f), C.y = m, C.width = h.bandwidth, C.height = p.convert(0) - m, C.strokeWidth = 0, C.crisp = !0, C;
  });
  return t ? e.data.map((u) => d(u, l, c)) : d(e.data, l, c);
}
function xS(e, t, s, i) {
  const r = [0, t[0].length - 1], n = t.reduce(
    (l, c) => (c.forEach((d) => {
      d < l[0] && (l[0] = d), d > l[1] && (l[1] = d);
    }), l),
    [1 / 0, -1 / 0]
  );
  n[0]--, n[n.length - 1]++;
  const o = new e.LinearScale();
  o.domain = r, o.range = [i, s - i];
  const a = new e.LinearScale();
  return a.domain = n, a.range = [s - i, i], { xScale: o, yScale: a };
}
function RS(e, t, s) {
  return e.map(
    (i) => i.map((r, n) => [
      n > 0 ? "lineTo" : "moveTo",
      t.convert(n),
      s.convert(r)
    ])
  );
}
function FS(e, t) {
  const s = new e.Path();
  return t.forEach(([i, r, n]) => s.path[i](r, n)), s;
}
function b3(e, t, s) {
  return e.map((i, r, n) => {
    const a = [...s ? S3(n, r, t) : PS(i, t)].reverse().map(([d, u, h]) => ["lineTo", u, h]), l = i[0], c = pe(a);
    return (l[1] !== c[1] || l[2] !== c[2]) && a.push(["lineTo", l[1], l[2]]), [...i, ...a];
  });
}
function S3(e, t, s) {
  return t === 0 ? PS(e[t], s) : [...e[t - 1]];
}
function PS(e, t) {
  return e.map(([s, i]) => [s, i, t.convert(0)]);
}
function ap({ _Scene: e }, t, s, i, r) {
  const { xScale: n, yScale: o } = xS(e, s, i, r), l = RS(s, n, o).map((d) => {
    const u = FS(e, d);
    return u.strokeWidth = 3, u.lineCap = "round", u.fill = void 0, u;
  }), c = new e.Group();
  return c.setClipRect(new e.BBox(r, r, i - r * 2, i - r * 2)), c.append(l), t.append(c), l;
}
function x3(e, t, s, i, r, n = !1) {
  const { xScale: o, yScale: a } = xS(e, s, i, r), l = b3(RS(s, o, a), a, n), c = new e.Group();
  c.setClipRect(new e.BBox(r, r, i - r * 2, i - r * 2));
  const d = l.map((u) => FS(e, u));
  return c.append(d), t.append(c), d;
}
function TS(e) {
  return e.map(
    (t, s, i) => t.map((r, n) => i.slice(0, s + 1).reduce((o, a) => o + a[n], 0))
  );
}
function ES(e) {
  const t = e.map((s, i) => e.reduce((r, n) => Math.max(r, n[i]), 0));
  return e.map((s) => s.map((i, r) => i / t[r] * 19));
}
function DS(e, t, s, i, r, n, o = 0) {
  const { _Scene: a } = e, l = new a.LinearScale();
  l.domain = [0, 7], l.range = [-Math.PI, Math.PI].map((g) => g + Math.PI / 2);
  const c = new a.LinearScale();
  c.domain = [0, 10], c.range = [r, n];
  const d = [], u = i / 2, h = s.map((g) => {
    const f = new a.Path();
    return f.strokeWidth = 1, f.strokeOpacity = 0.5, f.lineCap = "round", f.fill = void 0, f.fillOpacity = 0.8, g.forEach((m, C) => {
      const w = l.convert(C), y = r + n - c.convert(m), b = y * Math.cos(w) + u, x = y * Math.sin(w) + u;
      if (f.path[C > 0 ? "lineTo" : "moveTo"](b, x), o > 0) {
        const M = new a.Circle();
        M.x = b, M.y = x, M.size = o, d.push(M);
      }
    }), f.path.closePath(), f;
  }), p = new a.Group();
  return p.append([...h, ...d]), t.append(p), { paths: h, markers: d };
}
function Lc(e) {
  let [t, s] = [1 / 0, -1 / 0];
  return { processedData: e.reduce((r, n, o) => {
    const a = o > 0 ? r[o - 1] : void 0;
    r[o] ?? (r[o] = []);
    const l = r[o];
    return n.forEach((c, d) => {
      a && (c += a[d]), l[d] = c, l[d] < t && (t = l[d]), l[d] > s && (s = l[d]);
    }), r;
  }, []), min: t, max: s };
}
var R3 = "ag-chart-mini-thumbnail-canvas", ho = class extends _ {
  constructor(e, t, s) {
    super(), this.agChartsExports = t, this.tooltipName = s, this.size = 58, this.padding = 5;
    const { _Scene: i } = t;
    this.root = new i.Group();
    const r = new i.Scene({
      width: this.size,
      height: this.size
    });
    r.canvas.element.classList.add(R3), r.setRoot(this.root), r.setContainer(e), this.scene = r;
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    this.scene.canvas.element.title = this.chartTranslation.translate(this.tooltipName);
    try {
      this.scene.render();
    } catch (e) {
      be(108, { e });
    }
  }
}, ls = class extends ho {
  constructor(e, t, s) {
    super(e, t, s), this.stroke = "gray", this.axisOvershoot = 3;
  }
  postConstruct() {
    const { _Scene: e } = this.agChartsExports, t = this.size, s = this.padding, i = new e.Line();
    i.x1 = s, i.y1 = s, i.x2 = s, i.y2 = t - s + this.axisOvershoot, i.stroke = this.stroke;
    const r = new e.Line();
    r.x1 = s - this.axisOvershoot + 1, r.y1 = t - s, r.x2 = t - s + 1, r.y2 = t - s, r.stroke = this.stroke;
    const n = this.root;
    n.append(i), n.append(r), super.postConstruct();
  }
}, AS = class extends ls {
  constructor(e, t, s, i) {
    super(e, t, "groupedColumnTooltip"), this.columnData = [2, 3, 4];
    const { root: r, columnData: n, size: o, padding: a } = this;
    this.columns = Ra({
      stacked: !1,
      root: r,
      data: n,
      size: o,
      padding: a,
      xScaleDomain: [0, 1, 2],
      yScaleDomain: [0, 4],
      xScalePadding: 0.3,
      agChartsExports: t
    }), r.append(this.columns), this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.columns.forEach((s, i) => {
      s.fill = e[i], s.stroke = t[i];
    });
  }
};
AS.chartType = "groupedColumn";
var lp = class MS extends ls {
  constructor(t, s, i, r, n, o, a = MS.data, l = [0, 16], c = "stackedColumnTooltip") {
    super(t, s, c);
    const { root: d, size: u, padding: h } = this;
    this.stackedColumns = Ra({
      stacked: !0,
      root: d,
      data: a,
      size: u,
      padding: h,
      xScaleDomain: [0, 1, 2],
      yScaleDomain: l,
      xScalePadding: 0.3,
      agChartsExports: s
    }), d.append([].concat.apply([], this.stackedColumns)), this.updateColors(i, r);
  }
  updateColors(t, s) {
    this.stackedColumns.forEach(
      (i, r) => i.forEach((n) => {
        n.fill = t[r], n.stroke = s[r];
      })
    );
  }
};
lp.chartType = "stackedColumn";
lp.data = [
  [8, 12, 16],
  [6, 9, 12],
  [2, 3, 4]
];
var IS = lp, cp = class LS extends IS {
  constructor(t, s, i, r, n, o) {
    super(
      t,
      s,
      i,
      r,
      n,
      o,
      LS.data,
      [0, 10],
      "normalizedColumnTooltip"
    );
  }
};
cp.chartType = "normalizedColumn";
cp.data = [
  [10, 10, 10],
  [6, 7, 8],
  [2, 4, 6]
];
var F3 = cp, kS = class extends ls {
  constructor(e, t, s, i) {
    super(e, t, "groupedBarTooltip");
    const { _Scene: r } = t, n = this.padding, o = this.size, a = [2, 3, 4], l = new r.BandScale();
    l.domain = [0, 1, 2], l.range = [n, o - n], l.paddingInner = 0.3, l.paddingOuter = 0.3;
    const c = new r.LinearScale();
    c.domain = [0, 4], c.range = [o - n, n];
    const d = c.convert(0), u = l.bandwidth;
    this.bars = a.map((h, p) => {
      const g = new r.Rect();
      return g.x = n, g.y = l.convert(p), g.width = d - c.convert(h), g.height = u, g.strokeWidth = 0, g.crisp = !0, g;
    }), this.updateColors(s, i), this.root.append(this.bars);
  }
  updateColors(e, t) {
    this.bars.forEach((s, i) => {
      s.fill = e[i], s.stroke = t[i];
    });
  }
};
kS.chartType = "groupedBar";
var dp = class OS extends ls {
  constructor(t, s, i, r, n, o, a = OS.data, l = [0, 16], c = "stackedBarTooltip") {
    super(t, s, c);
    const { _Scene: d } = s, u = this.size, h = this.padding, p = new d.BandScale();
    p.domain = [0, 1, 2], p.range = [h, u - h], p.paddingInner = 0.3, p.paddingOuter = 0.3;
    const g = new d.LinearScale();
    g.domain = l, g.range = [u - h, h];
    const f = g.convert(0), m = p.bandwidth;
    this.bars = a.map(
      (C) => C.map((w, y) => {
        const b = new d.Rect();
        return b.x = h, b.y = p.convert(y), b.width = f - g.convert(w), b.height = m, b.strokeWidth = 0, b.crisp = !0, b;
      })
    ), this.updateColors(i, r), this.root.append([].concat.apply([], this.bars));
  }
  updateColors(t, s) {
    this.bars.forEach(
      (i, r) => i.forEach((n) => {
        n.fill = t[r], n.stroke = s[r];
      })
    );
  }
};
dp.chartType = "stackedBar";
dp.data = [
  [8, 12, 16],
  [6, 9, 12],
  [2, 3, 4]
];
var GS = dp, up = class BS extends GS {
  constructor(t, s, i, r, n, o) {
    super(
      t,
      s,
      i,
      r,
      n,
      o,
      BS.data,
      [0, 10],
      "normalizedBarTooltip"
    );
  }
};
up.chartType = "normalizedBar";
up.data = [
  [10, 10, 10],
  [6, 7, 8],
  [2, 4, 6]
];
var P3 = up, ql = class extends ho {
  constructor(e, t, s, i, r, n, o = 0.6, a = "donutTooltip") {
    super(e, t, a);
    const {
      size: l,
      padding: c,
      agChartsExports: { _Scene: d }
    } = this, u = (l - c * 2) / 2, h = u + c, p = d.toRadians, g = [
      [p(-90), p(30)],
      [p(30), p(120)],
      [p(120), p(180)],
      [p(180), p(210)],
      [p(210), p(240)],
      [p(240), p(270)]
    ];
    this.sectors = g.map(([f, m]) => {
      const C = new d.Sector();
      return C.centerX = h, C.centerY = h, C.innerRadius = u * o, C.outerRadius = u, C.startAngle = f, C.endAngle = m, C.stroke = void 0, C.strokeWidth = 0, C.inset = 0.75, C;
    }), this.updateColors(s, i), this.root.append(this.sectors);
  }
  updateColors(e, t) {
    this.sectors.forEach((s, i) => {
      s.fill = e[i % e.length], s.stroke = t[i % t.length];
    });
  }
};
ql.chartType = "donut";
var VS = class extends ql {
  constructor(e, t, s, i, r, n) {
    super(e, t, s, i, r, n, 0, "pieTooltip");
  }
};
VS.chartType = "pie";
var hp = class NS extends ls {
  constructor(t, s, i, r, n, o, a = NS.data, l = "lineTooltip") {
    super(t, s, l);
    const { size: c, padding: d, root: u } = this;
    this.lines = ap(s, u, a, c, d), this.updateColors(i, r);
  }
  updateColors(t, s) {
    this.lines.forEach((i, r) => {
      i.stroke = t[r];
    });
  }
};
hp.chartType = "line";
hp.data = [
  [1, 3, 5],
  [2, 6, 4],
  [5, 3, 1]
];
var Fa = hp, pp = class HS extends Fa {
  constructor(t, s, i, r, n, o, a = HS.data, l = "stackedLineTooltip") {
    super(t, s, i, r, n, o, a, l);
  }
};
pp.chartType = "stackedLine";
pp.data = TS(Fa.data);
var zS = pp, gp = class WS extends Fa {
  constructor(t, s, i, r, n, o, a = WS.data, l = "normalizedLineTooltip") {
    super(t, s, i, r, n, o, a, l);
  }
};
gp.chartType = "normalizedLine";
gp.data = ES(zS.data);
var T3 = gp, _S = class extends ls {
  constructor(e, t, s, i) {
    super(e, t, "scatterTooltip");
    const {
      size: r,
      padding: n,
      agChartsExports: { _Scene: o }
    } = this, a = [
      [
        [0.3, 3],
        [1.1, 0.9],
        [2, 0.4],
        [3.4, 2.4]
      ],
      [
        [0, 0.3],
        [1, 2],
        [2.4, 1.4],
        [3, 0]
      ]
    ], l = new o.LinearScale();
    l.domain = [-0.5, 4], l.range = [n * 2, r - n];
    const c = new o.LinearScale();
    c.domain = [-0.5, 3.5], c.range = [r - n, n];
    const d = [];
    a.forEach((h) => {
      h.forEach(([p, g]) => {
        const f = new o.Arc();
        f.strokeWidth = 0, f.centerX = l.convert(p), f.centerY = c.convert(g), f.radius = 2.5, d.push(f);
      });
    }), this.points = d, this.updateColors(s, i);
    const u = new o.Group();
    u.setClipRect(new o.BBox(n, n, r - n * 2, r - n * 2)), u.append(this.points), this.root.append(u);
  }
  updateColors(e, t) {
    this.points.forEach((s, i) => {
      s.stroke = t[i % t.length], s.fill = e[i % e.length];
    });
  }
};
_S.chartType = "scatter";
var US = class extends ls {
  constructor(e, t, s, i) {
    super(e, t, "bubbleTooltip");
    const {
      size: r,
      padding: n,
      agChartsExports: { _Scene: o }
    } = this, a = [
      [
        [0.1, 0.3, 5],
        [0.5, 0.4, 7],
        [0.2, 0.8, 7]
      ],
      [
        [0.8, 0.7, 5],
        [0.7, 0.3, 9]
      ]
    ], l = new o.LinearScale();
    l.domain = [0, 1], l.range = [n * 2, r - n];
    const c = new o.LinearScale();
    c.domain = [0, 1], c.range = [r - n, n];
    const d = [];
    a.forEach((h) => {
      h.forEach(([p, g, f]) => {
        const m = new o.Arc();
        m.strokeWidth = 0, m.centerX = l.convert(p), m.centerY = c.convert(g), m.radius = f, m.fillOpacity = 0.7, d.push(m);
      });
    }), this.points = d, this.updateColors(s, i);
    const u = new o.Group();
    u.setClipRect(new o.BBox(n, n, r - n * 2, r - n * 2)), u.append(this.points), this.root.append(u);
  }
  updateColors(e, t) {
    this.points.forEach((s, i) => {
      s.stroke = t[i % t.length], s.fill = e[i % e.length];
    });
  }
};
US.chartType = "bubble";
var fp = class $S extends ls {
  constructor(t, s, i, r, n, o, a = $S.data, l = "groupedAreaTooltip", c = !1) {
    super(t, s, l), this.areas = x3(s._Scene, this.root, a, this.size, this.padding, c), this.updateColors(i, r);
  }
  updateColors(t, s) {
    this.areas.forEach((i, r) => {
      i.fill = t[r], i.stroke = s[r], i.strokeWidth = 1, i.strokeOpacity = 0.75, i.fillOpacity = 0.7;
    });
  }
};
fp.chartType = "area";
fp.data = Fa.data;
var mp = fp, Cp = class jS extends mp {
  constructor(t, s, i, r, n, o, a = jS.data, l = "stackedAreaTooltip") {
    super(
      t,
      s,
      i,
      r,
      n,
      o,
      a,
      l,
      !0
    );
  }
  updateColors(t, s) {
    this.areas.forEach((i, r) => {
      i.fill = t[r], i.stroke = s[r];
    });
  }
};
Cp.chartType = "stackedArea";
Cp.data = TS(mp.data);
var vp = Cp, wp = class KS extends vp {
  constructor(t, s, i, r, n, o, a = KS.data, l = "normalizedAreaTooltip") {
    super(t, s, i, r, n, o, a, l);
  }
};
wp.chartType = "normalizedArea";
wp.data = ES(vp.data);
var E3 = wp, qS = class extends ls {
  constructor(e, t, s, i) {
    super(e, t, "histogramTooltip");
    const {
      padding: r,
      size: n,
      agChartsExports: { _Scene: o }
    } = this, a = [2, 5, 11, 13, 10, 6, 1], l = new o.LinearScale();
    l.domain = [0, a.length], l.range = [r, n - r];
    const c = new o.LinearScale();
    c.domain = [0, a.reduce((u, h) => Math.max(u, h), 0)], c.range = [n - r, r];
    const d = c.convert(0);
    this.bars = a.map((u, h) => {
      const p = c.convert(u), g = l.convert(h), f = l.convert(h + 1), m = new o.Rect();
      return m.x = g, m.y = p, m.width = f - g, m.height = d - p, m.strokeWidth = 1, m.strokeOpacity = 0.75, m.crisp = !0, m;
    }), this.updateColors(s, i), this.root.append(this.bars);
  }
  updateColors([e], [t]) {
    this.bars.forEach((s) => {
      s.fill = e, s.stroke = t;
    });
  }
};
qS.chartType = "histogram";
var po = class extends ho {
  constructor(e, t, s) {
    super(e, t, s), this.stroke = "gray", this.showRadiusAxisLine = !0, this.showAngleAxisLines = !0;
  }
  postConstruct() {
    const { _Scene: e } = this.agChartsExports, t = this.size, s = this.padding, i = s * 2, r = (t - i) / 2, n = this.showAngleAxisLines ? [r, r * 0.8, r * 0.6, r * 0.4] : [], o = new e.Line();
    o.x1 = t / 2, o.y1 = s, o.x2 = t / 2, o.y2 = t - s - r - n[n.length - 1], o.stroke = this.stroke, o.strokeOpacity = 0.5, o.fill = void 0, o.visible = this.showRadiusAxisLine;
    const a = s + r;
    this.gridLines = n.map((c, d) => {
      const u = new e.Path();
      return u.path.arc(a, a, c, 0, 2 * Math.PI), u.strokeWidth = 1, u.stroke = this.stroke, u.strokeOpacity = d === 0 ? 0.5 : 0.2, u.fill = void 0, u;
    });
    const l = this.root;
    l.append(o), this.gridLines.length > 0 && l.append(this.gridLines), super.postConstruct();
  }
}, YS = class extends po {
  constructor(e, t, s, i) {
    super(e, t, "radialColumnTooltip"), this.data = [
      [6, 8, 10, 2, 6, 5],
      [4, 4, 3, 6, 4, 4],
      [5, 4, 2, 9, 8, 9]
    ], this.showRadiusAxisLine = !1;
    const {
      padding: r,
      size: n,
      data: o,
      agChartsExports: { _Scene: a }
    } = this, l = (n - r * 2) / 2, d = l * 0.4, u = new a.BandScale();
    u.domain = o[0].map((C, w) => w), u.range = [0, 2 * Math.PI], u.paddingInner = 0, u.paddingOuter = 0;
    const h = u.bandwidth * 0.7, { processedData: p, max: g } = Lc(o), f = new a.LinearScale();
    f.domain = [0, g], f.range = [d, l];
    const m = this.size / 2;
    this.series = p.map((C, w) => {
      const b = w === 0 ? void 0 : p[w - 1], x = new a.TranslatableGroup({ zIndex: 1e6 }), M = C.map((T, F) => {
        const k = b == null ? void 0 : b[F], O = f.convert(T), D = f.convert(k ?? 0), $ = u.convert(F), j = $ + h, J = a.getRadialColumnWidth($, j, l, 0.5, 0.5), X = new a.RadialColumnShape();
        return X.columnWidth = J, X.innerRadius = D, X.outerRadius = O, X.startAngle = $, X.endAngle = j, X.isBeveled = !0, X.axisInnerRadius = d, X.axisOuterRadius = l, X.stroke = void 0, X.strokeWidth = 0, X;
      });
      return x.append(M), x.translationX = m, x.translationY = m, x;
    }), this.root.append(this.series), this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.series.forEach((s, i) => {
      for (const r of s.children())
        r.fill = e[i % e.length], r.stroke = t[i % t.length];
    });
  }
};
YS.chartType = "radialColumn";
var XS = class extends po {
  constructor(e, t, s, i) {
    super(e, t, "radialBarTooltip"), this.data = [
      [6, 8, 10],
      [4, 4, 3],
      [5, 4, 2]
    ], this.showRadiusAxisLine = !1;
    const {
      size: r,
      padding: n,
      data: o,
      agChartsExports: { _Scene: a }
    } = this, l = (r - n) / 2, d = l * 0.4, u = new a.BandScale();
    u.domain = o[0].map((y, b) => b), u.range = [d, l], u.paddingInner = 0.5, u.paddingOuter = 0;
    const h = u.bandwidth, { processedData: p, max: g } = Lc(o), f = new a.LinearScale();
    f.domain = [0, Math.ceil(g * 1.5)];
    const m = 3 / 2 * Math.PI, C = m + 2 * Math.PI;
    f.range = [m, C];
    const w = r / 2;
    this.series = p.map((y, b) => {
      const x = b < 0 ? void 0 : p[b - 1], M = new a.Group({ zIndex: 1e6 }), T = y.map((F, k) => {
        const O = (x == null ? void 0 : x[k]) ?? 0, D = u.convert(k), $ = D - h, j = f.convert(O), J = f.convert(F), X = new a.Sector();
        return X.centerX = w, X.centerY = w, X.innerRadius = $, X.outerRadius = D, X.startAngle = j, X.endAngle = J, X.stroke = void 0, X.strokeWidth = 0, X;
      });
      return M.append(T), M;
    }), this.root.append(this.series), this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.series.forEach((s, i) => {
      for (const r of s.children())
        r.fill = e[i % e.length], r.stroke = t[i % t.length];
    });
  }
};
XS.chartType = "radialBar";
var ZS = class extends po {
  constructor(e, t, s, i) {
    super(e, t, "radarLineTooltip"), this.markerSize = 4, this.data = [
      [8, 7, 8, 7, 8, 8, 7, 8],
      [6, 8, 5, 10, 6, 7, 4, 6],
      [0, 3, 3, 5, 4, 4, 2, 0]
    ], this.showRadiusAxisLine = !1;
    const { size: r, padding: n, root: o, data: a } = this, l = (r - n * 2) / 2, c = 0, { paths: d, markers: u } = DS(
      t,
      o,
      a,
      r,
      l,
      c,
      this.markerSize
    );
    this.lines = d, this.markers = u, this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.lines.forEach((s, i) => {
      const r = this.data[i].length;
      s.stroke = e[i];
      const n = i * r, o = n + r;
      this.markers.slice(n, o).forEach((l) => {
        l.stroke = t[i], l.fill = e[i];
      });
    });
  }
};
ZS.chartType = "radarLine";
var QS = class extends po {
  constructor(e, t, s, i) {
    super(e, t, "radarAreaTooltip"), this.data = [
      [8, 10, 5, 7, 4, 1, 5, 8],
      [1, 1, 2, 7, 7, 8, 10, 1],
      [4, 5, 9, 9, 4, 2, 3, 4]
    ];
    const { size: r, padding: n, root: o, data: a } = this;
    this.showRadiusAxisLine = !1;
    const l = (r - n * 2) / 2, c = l - r * 0.3;
    this.areas = DS(t, o, a, r, l, c).paths, this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.areas.forEach((s, i) => {
      s.fill = e[i], s.stroke = t[i];
    });
  }
};
QS.chartType = "radarArea";
var JS = class extends po {
  constructor(e, t, s, i) {
    super(e, t, "nightingaleTooltip"), this.data = [
      [6, 10, 9, 8, 7, 8],
      [4, 6, 5, 4, 5, 5],
      [3, 5, 4, 3, 4, 7]
    ], this.showRadiusAxisLine = !1;
    const {
      size: r,
      padding: n,
      data: o,
      agChartsExports: { _Scene: a }
    } = this, l = (r - n * 2) / 2, c = new a.BandScale();
    c.domain = o[0].map((f, m) => m), c.range = [-Math.PI, Math.PI], c.paddingInner = 0, c.paddingOuter = 0;
    const d = c.bandwidth * 0.7, { processedData: u, max: h } = Lc(o), p = new a.LinearScale();
    p.domain = [0, h], p.range = [0, l];
    const g = r / 2;
    this.series = u.map((f, m) => {
      const C = m < 0 ? void 0 : u[m - 1], w = new a.Group({ zIndex: 1e6 }), y = f.map((b, x) => {
        const M = C == null ? void 0 : C[x], T = p.convert(b), F = p.convert(M ?? 0), k = c.convert(x), O = k + d, D = new a.Sector();
        return D.centerX = g, D.centerY = g, D.innerRadius = F, D.outerRadius = T, D.startAngle = k, D.endAngle = O, D.stroke = void 0, D.strokeWidth = 0, D;
      });
      return w.append(y), w;
    }), this.root.append(this.series), this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.series.forEach((s, i) => {
      for (const r of s.children())
        r.fill = e[i % e.length], r.stroke = t[i % t.length];
    });
  }
};
JS.chartType = "nightingale";
var ex = class extends ls {
  constructor(e, t, s, i) {
    super(e, t, "rangeBarTooltip");
    const r = [3, 3.5, 3];
    this.bars = this.createRangeBar(this.root, r, this.size, this.padding, "vertical"), this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.bars.forEach((s, i) => {
      s.fill = e[i], s.stroke = t[i];
    });
  }
  createRangeBar(e, t, s, i, r) {
    const n = r === "horizontal", o = 2 * i, { _Scene: a } = this.agChartsExports, l = new a.BandScale();
    l.domain = t.map((g, f) => f), l.range = [i, s - i], l.paddingInner = 0.3, l.paddingOuter = 0.3;
    const c = 0.7, d = 1.3, u = new a.LinearScale();
    u.domain = [
      t.reduce((g, f) => Math.min(g, f), 1 / 0) * c,
      t.reduce((g, f) => Math.max(g, f), 0) * d
    ], u.range = [o, s - o];
    const h = l.bandwidth, p = t.map((g, f) => {
      const [m, C] = [g * c, g * d], w = l.convert(f), y = u.convert(m), b = u.convert(C) - y, x = new a.Rect();
      return x.x = n ? y : w, x.y = n ? w : y, x.width = n ? b : h, x.height = n ? h : b, x.strokeWidth = 0, x.crisp = !0, x;
    });
    return e.append(p), p;
  }
};
ex.chartType = "rangeBar";
var tx = class extends ls {
  constructor(e, t, s, i) {
    super(e, t, "rangeAreaTooltip");
    const r = 4, n = [
      _d({ offset: 0.375 * r, length: r, pattern: { low: 3, high: 5, period: r } }),
      _d({ offset: 0.375 * r, length: r, pattern: { low: 2.25, high: 4.25, period: r } }),
      _d({ offset: 0.75 * r, length: r, pattern: { low: 2.5, high: 4.5, period: r } })
    ], o = 1.75, a = n.map(
      (d) => d.map(([u, h]) => ({
        x: u,
        low: h - 0.5 * o,
        high: h + 0.5 * o
      }))
    ), { lines: l, areas: c } = this.createRangeArea(this.root, a, this.size, this.padding);
    this.lines = l, this.areas = c, this.updateColors(s, i);
  }
  updateColors(e, t) {
    e = dm(e, 1, 2), t = dm(t, 1, 2), this.lines.forEach(([s, i], r) => {
      s.fill = void 0, s.stroke = t[r], i.fill = void 0, i.stroke = t[r];
    }), this.areas.forEach((s, i) => {
      s.fill = e[i];
    });
  }
  createRangeArea(e, t, s, i) {
    const r = t.reduce((f, m) => m.reduce((C, { x: w }) => Math.min(C, w), f), 1 / 0), n = t.reduce((f, m) => m.reduce((C, { x: w }) => Math.max(C, w), f), -1 / 0), o = t.reduce((f, m) => m.reduce((C, { low: w }) => Math.min(C, w), f), 1 / 0), a = t.reduce(
      (f, m) => m.reduce((C, { high: w }) => Math.max(C, w), f),
      -1 / 0
    ), { _Scene: l } = this.agChartsExports, c = new l.LinearScale();
    c.domain = [r, n], c.range = [i, s - i];
    const d = 2 * i, u = new l.LinearScale();
    u.domain = [o, a], u.range = [s - d, d];
    const h = [], p = [];
    return t.map((f) => {
      const m = new l.Path(), C = new l.Path(), w = new l.Path();
      return h.push([m, C]), p.push(w), m.strokeWidth = 0, C.strokeWidth = 0, w.strokeWidth = 0, w.fillOpacity = 0.8, m.path.clear(), C.path.clear(), w.path.clear(), f.map((y, b) => {
        const { x, low: M, high: T } = y, F = c.convert(x), k = u.convert(M), O = u.convert(T), D = b > 0 ? "lineTo" : "moveTo";
        return m.path[D](F, O), C.path[D](F, k), w.path[D](F, O), [F, k];
      });
    }).forEach((f, m) => {
      const C = f.length - 1, w = p[m];
      for (let y = C; y >= 0; y--) {
        const [b, x] = f[y];
        w.path.lineTo(b, x);
      }
    }), e.append(p.concat(...h)), { lines: h, areas: p };
  }
};
tx.chartType = "rangeArea";
function _d(e) {
  const { offset: t, length: s, pattern: i } = e, r = a(t, s, i), n = 0, o = s;
  return (r.length === 0 || r[0][0] !== n) && r.unshift(l(n, t, i)), r[r.length - 1][0] !== o && r.push(l(o, t, i)), r;
  function a(d, u, h) {
    const { period: p } = h, g = d / p, m = [0, 0.5].map((w) => w - g).map(cm).sort((w, y) => w - y);
    return Array.from(
      { length: Math.floor(m.length * (p / u)) },
      (w, y) => m[y % m.length] + Math.floor(y / m.length)
    ).map((w) => w * p).map((w) => l(w, d, h));
  }
  function l(d, u, h) {
    return [d, c(u + d, h)];
  }
  function c(d, u) {
    const { low: h, high: p, period: g } = u, f = cm(d / g), m = f > 0.5 ? 1 - 2 * (f - 0.5) : 2 * f;
    return h + (p - h) * m;
  }
}
function cm(e) {
  const t = e % 1;
  return t < 0 ? t + 1 : t;
}
function dm(e, t, s) {
  const i = [...e], r = i[t];
  return i[t] = i[s], i[s] = r, i;
}
var sx = class extends ls {
  constructor(e, t, s, i, r, n) {
    super(e, t, "boxPlotTooltip");
    const {
      size: o,
      padding: a,
      agChartsExports: { _Scene: l }
    } = this, c = [11, 11.5, 10.5], d = 1.2, u = 1.1, h = 0.9, p = 0.8, g = new l.LinearScale();
    g.domain = [
      c.reduce((w, y) => Math.min(w, y), 1 / 0) * p,
      c.reduce((w, y) => Math.max(w, y), 0) * d
    ], g.range = [o - 1.5 * a, a];
    const f = new l.BandScale();
    f.domain = c.map((w, y) => y), f.range = [a, o - a], f.paddingInner = 0.4, f.paddingOuter = 0.2;
    const m = Math.round(f.bandwidth), C = Math.round(f.bandwidth / 2);
    this.boxPlotGroups = c.map((w, y) => {
      const [b, x, M, T] = [
        w * p,
        w * h,
        w * u,
        w * d
      ], F = Math.round(g.convert(M)), k = Math.round(f.convert(y)), O = Math.round(k + m), D = Math.round(g.convert(x)), $ = Math.round(g.convert(b)), j = Math.round(g.convert(w)), J = Math.round(g.convert(T)), X = k + C, ie = new l.Group(), Ce = new l.Rect(), ae = new l.Line(), ge = new l.Line(), Se = new l.Line(), xe = new l.Line(), ce = new l.Line();
      return Ce.x = k, Ce.y = F, Ce.width = m, Ce.height = D - F, Ce.strokeWidth = 1, Ce.strokeOpacity = 0.75, Ce.crisp = !0, this.setLineProperties(ae, k, O, j, j), this.setLineProperties(ge, X, X, J, F), this.setLineProperties(Se, X, X, $, D), this.setLineProperties(xe, k, O, J, J), this.setLineProperties(ce, k, O, $, $), ie.append([Ce, ae, ge, Se, xe, ce]), ie;
    }), this.updateColors(s, i, r, n), this.root.append(this.boxPlotGroups);
  }
  updateColors(e, t, s, i) {
    const {
      agChartsExports: { _Util: r, _Theme: n }
    } = this, o = s == null ? void 0 : s.get(n.themeSymbols.DEFAULT_BACKGROUND_COLOUR), a = (Array.isArray(o) ? o[0] : o) ?? "white";
    this.boxPlotGroups.forEach((l, c) => {
      for (const d of l.children()) {
        const u = e[c % e.length];
        d.fill = i ? u : r.interpolateColor(u, a)(0.7), d.stroke = t[c % t.length];
      }
    });
  }
  setLineProperties(e, t, s, i, r) {
    e.x1 = t, e.x2 = s, e.y1 = i, e.y2 = r, e.strokeOpacity = 0.75;
  }
};
sx.chartType = "boxPlot";
var ix = class extends ho {
  constructor(e, t, s, i, r, n) {
    super(e, t, "treemapTooltip");
    const {
      size: o,
      padding: a,
      agChartsExports: { _Scene: l }
    } = this, c = [
      [1, 1],
      [3, 2, 1]
    ], u = c.length % 2 === 0 ? 0.3 : 0.2, h = [a, o - a], p = c.length, g = p * (p + 1) / 2, f = u / (p - 1), m = h[1] - h[0], C = m - u;
    let w = h[0];
    this.rects = c.reduce((b, x, M) => {
      b ?? (b = []);
      const T = (p - M) / g, F = C * T, k = x.length, O = x.reduce((X, ie) => X += ie, 0), D = u / (k - 1 || 1), $ = k > 1 ? m - u : m;
      let j = h[0];
      const J = x.map((X) => {
        const ie = new l.Rect(), Ce = $ * X / O;
        return ie.x = w, ie.y = j, ie.width = F, ie.height = Ce, ie.strokeWidth = 0.75, ie.crisp = !0, j += Ce + D, ie;
      });
      return w += F + f, b.push(...J), b;
    }, []), this.updateColors(s, i, r, n);
    const y = new l.Group();
    y.setClipRect(new l.BBox(a, a, o - a, o - a)), y.append(this.rects), this.root.append(y);
  }
  updateColors(e, t, s, i) {
    const r = s == null ? void 0 : s.get(
      this.agChartsExports._Theme.themeSymbols.DEFAULT_BACKGROUND_COLOUR
    ), n = (Array.isArray(r) ? r[0] : r) ?? "white";
    this.rects.forEach((o, a) => {
      o.fill = e[a % t.length], o.stroke = i ? t[a % t.length] : n;
    });
  }
};
ix.chartType = "treemap";
var rx = class extends po {
  constructor(e, t, s, i) {
    super(e, t, "sunburstTooltip"), this.data = [
      [[], []],
      [[], []],
      [[], []]
    ], this.angleOffset = -Math.PI / 2, this.innerRadiusRatio = 0, this.showRadiusAxisLine = !1, this.showAngleAxisLines = !1;
    const {
      data: r,
      size: n,
      padding: o,
      angleOffset: a,
      innerRadiusRatio: l,
      agChartsExports: { _Scene: c }
    } = this, d = (n - o * 2) / 2, u = [a + 0, a + 2 * Math.PI], h = Math.abs(u[1] - u[0]), p = [d * l, d], g = Math.abs(p[1] - p[0]);
    let f = 0;
    const m = (x, M) => {
      x.forEach((T) => {
        const F = M + 1;
        f = Math.max(f, F), m(T, F);
      });
    };
    m(r, 0);
    const C = g / f, w = this.size / 2, y = u[0];
    this.series = [];
    const b = (x, M, T, F, k) => {
      if (!Array.isArray(x))
        return;
      const D = M + 1;
      let $ = T;
      x.forEach((j, J, X) => {
        let ie = k;
        ie || (ie = new c.Group(), this.series.push(ie));
        const Ce = p[0] + M * C, ae = p[0] + D * C, ge = 1 / X.length, Se = $, xe = Se + F * ge, ce = new c.Sector();
        ce.centerX = w, ce.centerY = w, ce.innerRadius = Ce, ce.outerRadius = ae, ce.startAngle = Se, ce.endAngle = xe, ce.stroke = void 0, ce.strokeWidth = 0, ce.inset = 0.75, $ = xe, ie.append(ce), b(j, D, Se, Math.abs(xe - Se), ie);
      });
    };
    b(r, 0, y, h), this.root.append(this.series), this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.series.forEach((s, i) => {
      for (const r of s.children())
        r.fill = e[i % e.length], r.stroke = t[i % t.length];
    });
  }
};
rx.chartType = "sunburst";
var nx = class extends ho {
  constructor(e, t, s, i, r, n) {
    super(e, t, "heatmapTooltip");
    const {
      size: o,
      padding: a,
      agChartsExports: { _Scene: l }
    } = this, c = 3, d = Array.from(
      { length: c },
      (C, w) => Array.from({ length: c }, (y, b) => b)
    ), u = d.map((C, w) => w), h = new l.BandScale();
    h.domain = u, h.range = [a, o - a], h.paddingInner = 0.01, h.paddingOuter = 0.1;
    const p = new l.BandScale();
    p.domain = u, p.range = [a, o - a], p.paddingInner = 0.01, p.paddingOuter = 0.1;
    const g = h.bandwidth ?? 0, f = p.bandwidth ?? 0;
    this.rects = d.reduce((C, w, y) => {
      C ?? (C = []);
      const b = w.map((x, M) => {
        const T = new l.Rect();
        return T.x = h.convert(y), T.y = p.convert(M), T.width = g, T.height = f, T.strokeWidth = 0, T.crisp = !0, T;
      });
      return C.push(...b), C;
    }, []), this.updateColors(s, i, r, n);
    const m = new l.Group();
    m.setClipRect(new l.BBox(a, a, o - a, o - a)), m.append(this.rects), this.root.append(m);
  }
  updateColors(e, t, s, i) {
    const { _Theme: r, _Util: n } = this.agChartsExports, o = s == null ? void 0 : s.get(r.themeSymbols.DEFAULT_DIVERGING_SERIES_COLOR_RANGE), a = s == null ? void 0 : s.get(r.themeSymbols.DEFAULT_BACKGROUND_COLOUR), l = (Array.isArray(a) ? a[0] : a) ?? "white", c = i ? [e[0], e[1]] : o, d = i ? t[0] : l, u = n.interpolateColor(c[0], c[1]);
    this.rects.forEach((h, p) => {
      h.fill = u(p * 0.2), h.stroke = d;
    });
  }
};
nx.chartType = "heatmap";
var ox = class extends ls {
  constructor(e, t, s, i, r, n) {
    super(e, t, "waterfallTooltip"), this.data = [4, 3, -3, 6, -3], this.bars = this.createWaterfall(this.root, this.data, this.size, this.padding, "vertical").bars, this.updateColors(s, i, r, n);
  }
  updateColors(e, t, s, i) {
    const {
      data: r,
      agChartsExports: {
        _Theme: { themeSymbols: n }
      }
    } = this, o = {
      fill: i ? e[0] : s == null ? void 0 : s.get(n.PALETTE_ALT_UP_FILL),
      stroke: i ? t[0] : s == null ? void 0 : s.get(n.PALETTE_ALT_UP_STROKE)
    }, a = {
      fill: i ? e[1] : s == null ? void 0 : s.get(n.PALETTE_ALT_DOWN_FILL),
      stroke: i ? t[1] : s == null ? void 0 : s.get(n.PALETTE_ALT_DOWN_STROKE)
    };
    this.bars.forEach((l, c) => {
      const d = r[c] >= 0;
      l.fill = d ? o.fill : a.fill, l.stroke = d ? o.stroke : a.stroke;
    });
  }
  createWaterfall(e, t, s, i, r) {
    const n = 2 * i, { processedData: o, min: a, max: l } = Lc(t.map((y) => [y])), c = o.reduce((y, b) => y.concat(b), []), { _Scene: d } = this.agChartsExports, u = new d.LinearScale();
    u.domain = [Math.min(a, 0), l], u.range = [s - n, n];
    const h = new d.BandScale();
    h.domain = t.map((y, b) => b), h.range = [i, s - i], h.paddingInner = 0.2, h.paddingOuter = 0.3;
    const p = h.bandwidth, g = new d.Path();
    g.stroke = "#575757", g.strokeWidth = 0;
    const f = Math.floor(g.strokeWidth) % 2 / 2, m = g.path;
    m.clear();
    const C = r === "horizontal", w = c.map((y, b) => {
      const x = b > 0 ? c[b - 1] : 0, T = t[b] > 0, F = Math.round(u.convert(y)), k = Math.round(u.convert(x)), O = (T ? F : k) - f, D = (T ? k : F) + f, $ = Math.abs(D - O), j = h.convert(b), J = new d.Rect();
      J.x = C ? O : j, J.y = C ? j : O, J.width = C ? $ : p, J.height = C ? p : $, J.strokeWidth = 0, J.crisp = !0;
      const X = F + f, ie = k + f;
      if (b > 0) {
        const ge = C ? ie : J.x, Se = C ? J.y : ie;
        m.lineTo(ge, Se);
      }
      const Ce = C ? X : J.x, ae = C ? J.y : X;
      return m.moveTo(Ce, ae), J;
    });
    return e.append([g, ...w]), { bars: w };
  }
};
ox.chartType = "waterfall";
var ax = class extends ls {
  constructor(e, t, s, i) {
    super(e, t, "columnLineComboTooltip"), this.columnData = [3, 4], this.lineData = [[5, 4, 6, 5, 4]];
    const { root: r, columnData: n, lineData: o, size: a, padding: l } = this;
    this.columns = Ra({
      stacked: !1,
      root: r,
      data: n,
      size: a,
      padding: l,
      xScaleDomain: [0, 1],
      yScaleDomain: [0, 4],
      xScalePadding: 0.5,
      agChartsExports: t
    }), r.append(this.columns), this.lines = ap(t, r, o, a, l), this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.columns.forEach((s, i) => {
      s.fill = e[i], s.stroke = t[i];
    }), this.lines.forEach((s, i) => {
      s.stroke = e[i + 2];
    });
  }
};
ax.chartType = "columnLineCombo";
var lx = class extends ls {
  constructor(e, t, s, i) {
    super(e, t, "areaColumnComboTooltip"), this.columnData = [3, 4.5], this.areaData = [[5, 4, 6, 5, 4]];
    const {
      root: r,
      columnData: n,
      areaData: o,
      size: a,
      padding: l,
      agChartsExports: { _Scene: c }
    } = this;
    this.columns = Ra({
      stacked: !1,
      root: r,
      data: n,
      size: a,
      padding: l,
      xScaleDomain: [0, 1],
      yScaleDomain: [0, 6],
      xScalePadding: 0.5,
      agChartsExports: t
    });
    const d = new c.BandScale();
    d.range = [l, a - l], d.domain = [0, 1, 2, 3, 4], d.paddingInner = 1, d.paddingOuter = 0;
    const u = new c.LinearScale();
    u.range = [a - l, l], u.domain = [0, 6];
    const h = [], p = u.convert(0), g = d.convert(0);
    o.forEach((C, w) => {
      const y = h[w] || (h[w] = []);
      C.forEach((x, M) => {
        const T = x, F = M, k = d.convert(F), O = u.convert(T);
        y[M] = { x: k, y: O };
      });
      const b = d.convert(C.length - 1);
      h[w].push(
        {
          x: b,
          y: p
        },
        {
          x: g,
          y: p
        }
      );
    }), this.areas = h.map((C) => {
      const w = new c.Path();
      w.strokeWidth = 0, w.fillOpacity = 0.8;
      const y = w.path;
      return C.forEach((b, x) => y[x > 0 ? "lineTo" : "moveTo"](b.x, b.y)), w;
    });
    const f = new c.Group();
    f.setClipRect(new c.BBox(l, l, a - l * 2, a - l * 2));
    const m = new c.Group();
    m.setClipRect(new c.BBox(l, l, a - l * 2, a - l * 2)), f.append(this.areas), m.append(this.columns), r.append(f), r.append(m), this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.areas.forEach((s, i) => {
      s.fill = e[i], s.stroke = t[i];
    }), this.columns.forEach((s, i) => {
      s.fill = e[i + 1], s.stroke = t[i + 1];
    });
  }
};
lx.chartType = "areaColumnCombo";
var cx = class extends ho {
  constructor(e, t, s, i) {
    super(e, t, "customComboTooltip"), this.columnData = [3, 4], this.lineData = [[5, 4, 6, 5, 4]];
    const {
      root: r,
      columnData: n,
      lineData: o,
      size: a,
      padding: l,
      agChartsExports: { _Scene: c }
    } = this;
    this.columns = Ra({
      stacked: !1,
      root: r,
      data: n,
      size: a,
      padding: l,
      xScaleDomain: [0, 1],
      yScaleDomain: [0, 4],
      xScalePadding: 0.5,
      agChartsExports: t
    }), r.append(this.columns), this.lines = ap(this.agChartsExports, r, o, a, l);
    const d = "grey", u = 3, h = new c.Line();
    h.x1 = l, h.y1 = l, h.x2 = l, h.y2 = a - l + u, h.stroke = d;
    const p = new c.Line();
    p.x1 = l - u + 1, p.y1 = a - l, p.x2 = a - l + 1, p.y2 = a - l, p.stroke = d;
    const g = new c.Path();
    this.buildPenIconPath(g), g.fill = "whitesmoke", g.stroke = "darkslategrey", g.strokeWidth = 1, r.append([p, h, g]), this.updateColors(s, i);
  }
  updateColors(e, t) {
    this.columns.forEach((s, i) => {
      s.fill = e[i], s.stroke = t[i];
    }), this.lines.forEach((s, i) => {
      s.stroke = e[i + 2];
    });
  }
  buildPenIconPath(e) {
    const { path: t } = e;
    t.moveTo(25.76, 43.46), t.lineTo(31.27, 48.53), t.moveTo(49.86, 22), t.lineTo(49.86, 22), t.cubicCurveTo(49.01994659053345, 21.317514933510974, 47.89593834348529, 21.09645997825817, 46.86, 21.41), t.lineTo(46.86, 21.41), t.cubicCurveTo(45.55460035985361, 21.77260167850787, 44.38777081121966, 22.517979360321792, 43.51, 23.55), t.lineTo(25.51, 43.8), t.lineTo(25.43, 43.89), t.lineTo(23.01, 51.89), t.lineTo(22.83, 52.46), t.lineTo(31.02, 48.86), t.lineTo(49.02, 28.52), t.lineTo(49.02, 28.52), t.cubicCurveTo(49.940716461596224, 27.521914221246085, 50.54302631059587, 26.2720342455763, 50.75, 24.93), t.lineTo(50.75, 24.93), t.cubicCurveTo(50.95363374988308, 23.866379846512814, 50.62080640232334, 22.77066734274871, 49.86, 22), t.closePath(), t.moveTo(41.76, 25.5), t.lineTo(47.34, 30.5), t.moveTo(40.74, 26.65), t.lineTo(46.25, 31.71);
  }
};
cx.chartType = "customCombo";
var um = {
  columnGroup: {
    column: { range: !0, pivot: !0, enterprise: !1, icon: AS },
    stackedColumn: { range: !0, pivot: !0, enterprise: !1, icon: IS },
    normalizedColumn: { range: !0, pivot: !0, enterprise: !1, icon: F3 }
  },
  barGroup: {
    bar: { range: !0, pivot: !0, enterprise: !1, icon: kS },
    stackedBar: { range: !0, pivot: !0, enterprise: !1, icon: GS },
    normalizedBar: { range: !0, pivot: !0, enterprise: !1, icon: P3 }
  },
  pieGroup: {
    pie: { range: !0, pivot: !0, enterprise: !1, icon: VS },
    donut: { range: !0, pivot: !0, enterprise: !1, icon: ql },
    doughnut: { range: !0, pivot: !0, enterprise: !1, icon: ql }
  },
  lineGroup: {
    line: { range: !0, pivot: !0, enterprise: !1, icon: Fa },
    stackedLine: { range: !0, pivot: !0, enterprise: !1, icon: zS },
    normalizedLine: { range: !0, pivot: !0, enterprise: !1, icon: T3 }
  },
  scatterGroup: {
    scatter: { range: !0, pivot: !0, enterprise: !1, icon: _S },
    bubble: { range: !0, pivot: !0, enterprise: !1, icon: US }
  },
  areaGroup: {
    area: { range: !0, pivot: !0, enterprise: !1, icon: mp },
    stackedArea: { range: !0, pivot: !0, enterprise: !1, icon: vp },
    normalizedArea: { range: !0, pivot: !0, enterprise: !1, icon: E3 }
  },
  polarGroup: {
    radarLine: { range: !0, pivot: !1, enterprise: !0, icon: ZS },
    radarArea: { range: !0, pivot: !1, enterprise: !0, icon: QS },
    nightingale: { range: !0, pivot: !1, enterprise: !0, icon: JS },
    radialColumn: { range: !0, pivot: !1, enterprise: !0, icon: YS },
    radialBar: { range: !0, pivot: !1, enterprise: !0, icon: XS }
  },
  statisticalGroup: {
    boxPlot: { range: !0, pivot: !1, enterprise: !0, icon: sx },
    histogram: { range: !0, pivot: !1, enterprise: !1, icon: qS },
    rangeBar: { range: !0, pivot: !1, enterprise: !0, icon: ex },
    rangeArea: { range: !0, pivot: !1, enterprise: !0, icon: tx }
  },
  hierarchicalGroup: {
    treemap: { range: !0, pivot: !0, enterprise: !0, icon: ix },
    sunburst: { range: !0, pivot: !0, enterprise: !0, icon: rx }
  },
  specializedGroup: {
    heatmap: { range: !0, pivot: !1, enterprise: !0, icon: nx },
    waterfall: { range: !0, pivot: !1, enterprise: !0, icon: ox }
  },
  combinationGroup: {
    columnLineCombo: { range: !0, pivot: !0, enterprise: !1, icon: ax },
    areaColumnCombo: { range: !0, pivot: !0, enterprise: !1, icon: lx },
    customCombo: { range: !0, pivot: !0, enterprise: !1, icon: cx }
  }
}, D3 = {
  columnGroup: ["column", "stackedColumn", "normalizedColumn"],
  barGroup: ["bar", "stackedBar", "normalizedBar"],
  pieGroup: ["pie", "donut"],
  lineGroup: ["line", "stackedLine", "normalizedLine"],
  areaGroup: ["area", "stackedArea", "normalizedArea"],
  scatterGroup: ["scatter", "bubble"],
  polarGroup: ["radarLine", "radarArea", "nightingale", "radialColumn", "radialBar"],
  statisticalGroup: ["boxPlot", "histogram", "rangeBar", "rangeArea"],
  hierarchicalGroup: ["treemap", "sunburst"],
  specializedGroup: ["heatmap", "waterfall"],
  combinationGroup: ["columnLineCombo", "areaColumnCombo", "customCombo"]
}, A3 = class extends _ {
  constructor(e, t, s, i, r, n = D3) {
    super(
      /* html */
      '<div class="ag-chart-settings-mini-wrapper"></div>'
    ), this.wrappers = /* @__PURE__ */ new Map(), this.chartController = e, this.fills = t, this.strokes = s, this.themeTemplateParameters = i, this.isCustomTheme = r, this.chartGroups = { ...n };
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    !this.chartController.customComboExists() && this.chartGroups.combinationGroup && (this.chartGroups.combinationGroup = this.chartGroups.combinationGroup.filter(
      (n) => n !== "customCombo"
    ));
    const e = this.getGui(), t = this.chartController.isEnterprise(), s = this.chartController.isPivotChart(), i = !s, r = Object.keys(this.chartGroups).map((n) => {
      const o = n in um ? um[n] : void 0;
      if (!o)
        return I(148, { group: n }), null;
      const l = (this.chartGroups[n] ?? []).map((c) => {
        const d = c in o ? o[c] : void 0;
        return d ? !t && d.enterprise ? null : i && d.range || s && d.pivot ? d : null : (I(149, { group: n, chartType: c }), null);
      }).filter((c) => c != null);
      return l.length === 0 ? null : {
        label: this.chartTranslation.translate(n),
        items: l
      };
    }).filter((n) => n != null);
    for (const { label: n, items: o } of r) {
      const a = this.createBean(
        new qi({
          title: n,
          suppressEnabledCheckbox: !0,
          enabled: !0,
          suppressOpenCloseIcons: !0,
          cssIdentifier: "charts-settings",
          direction: "horizontal",
          suppressKeyboardNavigation: !0
        })
      );
      for (const l of o) {
        const c = l.icon, d = document.createElement("div");
        d.classList.add("ag-chart-mini-thumbnail"), d.setAttribute("tabindex", "0"), d.setAttribute("role", "button");
        const u = c.chartType, h = () => {
          this.chartController.setChartType(u), this.updateSelectedMiniChart();
        };
        this.addManagedListeners(d, {
          click: h,
          keydown: (p) => {
            (p.key == P.ENTER || p.key === P.SPACE) && (p.preventDefault(), h());
          }
        }), this.wrappers.set(u, d), this.createBean(
          new c(
            d,
            this.beans.agChartsExports,
            this.fills,
            this.strokes,
            this.themeTemplateParameters,
            this.isCustomTheme
          )
        ), a.addItem(d);
      }
      e.appendChild(a.getGui());
    }
    this.updateSelectedMiniChart();
  }
  updateSelectedMiniChart() {
    const e = this.chartController.getChartType();
    this.wrappers.forEach((t, s) => {
      const i = s === e;
      t.classList.toggle("ag-selected", i);
      const r = this.chartTranslation.translate(sp(s)), n = i ? `${r}. ${this.chartTranslation.translate("ariaChartSelected")}` : r;
      ot(t, n);
    });
  }
  destroy() {
    this.wrappers.clear(), super.destroy();
  }
}, M3 = class extends _ {
  constructor(e) {
    super(
      /* html */
      `<div class="ag-chart-settings-wrapper">
            <div data-ref="eMiniChartsContainer" class="ag-chart-settings-mini-charts-container ag-scrollable-container"></div>
            <div data-ref="eNavBar" class="ag-chart-settings-nav-bar">
                <div data-ref="ePrevBtn" class="ag-chart-settings-prev">
                    <button type="button" class="ag-button ag-chart-settings-prev-button"></button>
                </div>
                <div data-ref="eCardSelector" class="ag-chart-settings-card-selector"></div>
                <div data-ref="eNextBtn" class="ag-chart-settings-next">
                    <button type="button" class="ag-button ag-chart-settings-next-button"></button>
                </div>
            </div>
        </div>`
    ), this.chartController = e, this.eMiniChartsContainer = E, this.eNavBar = E, this.eCardSelector = E, this.ePrevBtn = E, this.eNextBtn = E, this.miniChartsContainers = [], this.cardItems = [], this.activePaletteIndex = 0, this.palettes = [], this.themes = [];
  }
  postConstruct() {
    this.resetPalettes(), this.ePrevBtn.insertAdjacentElement("afterbegin", ue("chartsThemePrevious", this.beans)), this.eNextBtn.insertAdjacentElement("afterbegin", ue("chartsThemeNext", this.beans)), this.addManagedElementListeners(this.ePrevBtn, { click: () => this.setActivePalette(this.getPrev(), "left") }), this.addManagedElementListeners(this.eNextBtn, { click: () => this.setActivePalette(this.getNext(), "right") });
    const e = () => this.resetPalettes(!0);
    this.addManagedListeners(this.chartController, {
      chartTypeChanged: e,
      chartApiUpdate: e
    }), this.scrollSelectedIntoView();
  }
  scrollSelectedIntoView() {
    setTimeout(() => {
      const e = (i) => !i.getGui().classList.contains("ag-hidden"), s = this.miniChartsContainers.find(e).getGui().querySelector(".ag-selected");
      if (s) {
        const i = s.offsetParent;
        i && this.eMiniChartsContainer.scrollTo(0, i.offsetTop);
      }
    }, 250);
  }
  resetPalettes(e) {
    var n, o;
    const t = this.chartController.getPalettes(), s = this.chartController.getThemeTemplateParameters(), i = (o = (n = this.gos.get("chartToolPanelsDef")) == null ? void 0 : n.settingsPanel) == null ? void 0 : o.chartGroupsDef;
    if (Ht(t, this.palettes) && !e || this.isAnimating)
      return;
    this.palettes = t, this.themes = this.chartController.getThemeNames(), this.activePaletteIndex = this.themes.findIndex((a) => a === this.chartController.getChartThemeName()), this.cardItems = [], ze(this.eCardSelector), this.destroyMiniCharts();
    const { themes: r } = this;
    this.palettes.forEach((a, l) => {
      const c = this.activePaletteIndex === l, { fills: d = [], strokes: u = [] } = a, h = r[l], p = !ip(h, this.beans.agChartsExports._Theme), g = this.createBean(
        new A3(
          this.chartController,
          d,
          u,
          s[l],
          p,
          i
        )
      );
      this.miniChartsContainers.push(g), this.eMiniChartsContainer.appendChild(g.getGui()), this.addCardLink(l), c ? g.updateSelectedMiniChart() : g.setDisplayed(!1);
    }), re(this.eNavBar, this.palettes.length > 1), yl(this.cardItems[this.activePaletteIndex], "ag-selected", "ag-not-selected");
  }
  addCardLink(e) {
    const t = document.createElement("div");
    t.classList.add("ag-chart-settings-card-item"), this.addManagedElementListeners(t, {
      click: () => {
        this.setActivePalette(e, e < this.activePaletteIndex ? "left" : "right");
      }
    }), this.eCardSelector.appendChild(t), this.cardItems.push(t);
  }
  getPrev() {
    let e = this.activePaletteIndex - 1;
    return e < 0 && (e = this.palettes.length - 1), e;
  }
  getNext() {
    let e = this.activePaletteIndex + 1;
    return e >= this.palettes.length && (e = 0), e;
  }
  setActivePalette(e, t) {
    if (this.isAnimating || this.activePaletteIndex === e)
      return;
    yl(this.cardItems[e], "ag-selected", "ag-not-selected");
    const s = this.miniChartsContainers[this.activePaletteIndex], i = s.getGui(), r = this.miniChartsContainers[e], n = r.getGui();
    s.updateSelectedMiniChart(), r.updateSelectedMiniChart();
    const o = t === "left" ? -1 : 1, a = n.style.left = `${gn(this.getGui()) * o}px`;
    this.activePaletteIndex = e, this.isAnimating = !0;
    const l = "ag-animating";
    r.setDisplayed(!0), s.addCssClass(l), r.addCssClass(l), this.chartController.setChartThemeName(this.themes[e]), window.setTimeout(() => {
      i.style.left = `${-parseFloat(a)}px`, n.style.left = "0px";
    }, 0), window.setTimeout(() => {
      this.isAnimating = !1, s.removeCssClass(l), r.removeCssClass(l), s.setDisplayed(!1);
    }, 300);
  }
  destroyMiniCharts() {
    ze(this.eMiniChartsContainer), this.miniChartsContainers = this.destroyBeans(this.miniChartsContainers);
  }
  destroy() {
    this.destroyMiniCharts(), super.destroy();
  }
}, I3 = "data", L3 = "format", k3 = class extends _ {
  constructor(e, t) {
    super(), this.panels = e, this.chartMenuContext = t, this.tabs = [];
  }
  wireBeans(e) {
    this.chartTranslation = e.chartTranslation;
  }
  postConstruct() {
    this.panels.forEach((e) => {
      const t = e.replace("chart", "").toLowerCase(), s = this.createPanel(t), i = this.createTab(e, t, s);
      this.tabs.push(i), this.addDestroyFunc(() => this.destroyBean(s));
    }), this.tabbedLayout = new kb({
      items: this.tabs,
      cssClass: "ag-chart-tabbed-menu",
      keepScrollPosition: !0,
      suppressFocusBodyOnOpen: !0,
      suppressTrapFocus: !0,
      enableCloseButton: !0,
      closeButtonAriaLabel: this.chartTranslation.translate("ariaChartMenuClose"),
      onCloseClicked: () => {
        var e;
        (e = this.eventSource) == null || e.focus({ preventScroll: !0 }), this.dispatchLocalEvent({ type: "closed" });
      }
    }), this.createBean(this.tabbedLayout);
  }
  createTab(e, t, s) {
    const i = document.createElement("div");
    i.classList.add("ag-chart-tab", `ag-chart-${t}`), this.createBean(s), i.appendChild(s.getGui());
    const r = document.createElement("div"), n = this.chartTranslation.translate(t);
    return r.innerText = n, {
      title: r,
      titleLabel: n,
      bodyPromise: fe.resolve(i),
      getScrollableContainer: () => i.querySelector(".ag-scrollable-container") || i,
      name: e
    };
  }
  showTab(e) {
    const t = this.tabs[e];
    this.tabbedLayout.showItem(t);
  }
  getGui() {
    return this.tabbedLayout && this.tabbedLayout.getGui();
  }
  showMenu(e, t) {
    var s;
    this.eventSource = e, t || (s = this.tabbedLayout) == null || s.focusHeader(!0);
  }
  destroy() {
    this.parentComponent && this.parentComponent.isAlive() && this.destroyBean(this.parentComponent), super.destroy();
  }
  createPanel(e) {
    switch (e) {
      case I3:
        return new Xj(this.chartMenuContext);
      case L3:
        return new y3(this.chartMenuContext);
      default:
        return new M3(this.chartMenuContext.chartController);
    }
  }
}, O3 = class extends _ {
  constructor(e, t, s) {
    super(
      /* html */
      '<div class="ag-chart-menu-wrapper"></div>'
    ), this.eChartContainer = e, this.eMenuPanelContainer = t, this.chartMenuContext = s, this.buttons = {
      chartLink: { iconName: "linked", callback: () => this.chartMenuSvc.toggleLinked(this.chartMenuContext) },
      chartUnlink: {
        iconName: "unlinked",
        callback: () => this.chartMenuSvc.toggleLinked(this.chartMenuContext)
      },
      chartDownload: {
        iconName: "chartsDownload",
        callback: () => this.chartMenuSvc.downloadChart(this.chartMenuContext)
      },
      chartMenu: { iconName: "chartsMenu", callback: (i) => this.showMenuList(i) }
    }, this.panels = [], this.menuVisible = !1, this.chartController = s.chartController;
  }
  wireBeans(e) {
    this.chartMenuSvc = e.chartMenuSvc, this.chartMenuListFactory = e.chartMenuListFactory, this.environment = e.environment;
  }
  postConstruct() {
    this.chartToolbar = this.createManagedBean(new Nj()), this.getGui().appendChild(this.chartToolbar.getGui()), this.refreshToolbarAndPanels(), this.addManagedEventListeners({
      chartCreated: (e) => {
        var t;
        e.chartId === this.chartController.getChartId() && ((t = this.gos.get("chartToolPanelsDef")) != null && t.defaultToolPanel) && this.showMenu({ panel: this.defaultPanel, suppressFocus: !0 });
      }
    }), this.addManagedListeners(this.chartController, {
      chartLinkedChanged: this.refreshToolbarAndPanels.bind(this)
    }), this.refreshMenuClasses(), this.addManagedListeners(this.chartController, { chartApiUpdate: this.refreshToolbarAndPanels.bind(this) });
  }
  isVisible() {
    return this.menuVisible;
  }
  getExtraPaddingDirections() {
    return ["chartMenu", "chartLink", "chartUnlink", "chartDownload"].some(
      (e) => this.chartToolbarOptions.includes(e)
    ) ? ["top"] : [];
  }
  refreshToolbarAndPanels() {
    this.initToolbarOptionsAndPanels(), this.updateToolbar();
  }
  initToolbarOptionsAndPanels() {
    const { panels: e, defaultPanel: t } = this.chartMenuSvc.getChartToolPanels(this.chartController);
    this.panels = e, this.defaultPanel = t, this.chartToolbarOptions = this.chartMenuSvc.getChartToolbarOptions();
  }
  updateToolbar() {
    const e = this.chartToolbarOptions.map((t) => {
      const { iconName: s, callback: i } = this.buttons[t];
      return {
        buttonName: t,
        iconName: s,
        callback: i
      };
    });
    this.chartToolbar.updateParams({ buttons: e });
  }
  createMenuPanel(e) {
    const t = this.menuPanel = this.createBean(
      new ab({
        height: "100%",
        closable: !0,
        hideTitleBar: !0,
        cssIdentifier: "chart-menu"
      })
    );
    return t.setParentComponent(this), this.eMenuPanelContainer.appendChild(t.getGui()), this.tabbedMenu = this.createBean(new k3(this.panels, this.chartMenuContext)), this.addManagedListeners(this.tabbedMenu, {
      closed: () => {
        this.hideMenu();
      }
    }), this.addManagedListeners(t, { destroyed: () => this.destroyBean(this.tabbedMenu) }), new fe((s) => {
      window.setTimeout(() => {
        t.setBodyComponent(this.tabbedMenu), this.tabbedMenu.showTab(e), s(t);
      }, 100);
    });
  }
  showContainer(e, t) {
    this.menuPanel && (this.menuVisible = !0, this.refreshMenuClasses(), this.tabbedMenu.showMenu(e, t));
  }
  showMenu(e) {
    const { panel: t, eventSource: s, suppressFocus: i } = e ?? {};
    if (this.menuPanel && !t)
      this.showContainer(s, i);
    else {
      const r = t || this.defaultPanel;
      let n = this.panels.indexOf(r);
      n < 0 && (I(143, { panel: t }), n = this.panels.indexOf(this.defaultPanel)), this.menuPanel ? (this.tabbedMenu.showTab(n), this.showContainer(s, i)) : this.createMenuPanel(n).then(() => this.showContainer(s, i));
    }
  }
  hideMenu() {
    this.menuVisible = !1, this.refreshMenuClasses();
  }
  refreshMenuClasses() {
    this.eChartContainer.classList.toggle("ag-chart-menu-visible", this.menuVisible), this.eChartContainer.classList.toggle("ag-chart-menu-hidden", !this.menuVisible);
  }
  showMenuList(e) {
    this.chartMenuListFactory.showMenuList({
      eventSource: e,
      showMenu: () => this.showMenu({ eventSource: e }),
      chartMenuContext: this.chartMenuContext
    });
  }
  destroy() {
    super.destroy(), this.menuPanel && this.menuPanel.isAlive() && this.destroyBean(this.menuPanel), this.tabbedMenu && this.tabbedMenu.isAlive() && this.destroyBean(this.tabbedMenu);
  }
}, dx = ["number", "category", "time", "grouped-category"], G3 = ["angle-category", "angle-number", "radius-category", "radius-number"], B3 = [...dx, ...G3], V3 = class extends L {
  constructor(e) {
    super(), this.chartController = e;
  }
  getChartThemeOverridesProxy() {
    return {
      getValue: (e) => this.getChartOption(e),
      setValue: (e, t) => this.setChartThemeOverrides([{ expression: e, value: t }]),
      setValues: (e) => this.setChartThemeOverrides(e)
    };
  }
  getAxisThemeOverridesProxy() {
    return {
      getValue: (e) => this.getAxisProperty(e),
      setValue: (e, t) => this.setAxisThemeOverrides([{ expression: e, value: t }]),
      setValues: (e) => this.setAxisThemeOverrides(e)
    };
  }
  getCartesianAxisOptionsProxy(e) {
    return {
      getValue: (t) => this.getCartesianAxisProperty(e, t),
      setValue: (t, s) => this.setCartesianAxisOptions(e, [{ expression: t, value: s }]),
      setValues: (t) => this.setCartesianAxisOptions(e, t)
    };
  }
  getCartesianAxisThemeOverridesProxy(e) {
    return {
      getValue: (t) => this.getCartesianAxisProperty(e, t),
      setValue: (t, s) => this.setCartesianAxisThemeOverrides(e, [{ expression: t, value: s }]),
      setValues: (t) => this.setCartesianAxisThemeOverrides(e, t)
    };
  }
  getCartesianAxisAppliedThemeOverridesProxy(e) {
    return {
      getValue: (t) => this.getCartesianAxisThemeOverride(
        e,
        // Allow the caller to specify a wildcard expression to retrieve the whole set of overrides
        t === "*" ? null : t
      ),
      setValue: (t, s) => this.setCartesianAxisThemeOverrides(
        e,
        // Allow the caller to specify a wildcard expression to set the whole set of overrides
        [{ expression: t === "*" ? null : t, value: s }]
      ),
      setValues: (t) => this.setCartesianAxisThemeOverrides(e, t)
    };
  }
  getSeriesOptionsProxy(e) {
    return {
      getValue: (t, s) => this.getSeriesOption(e(), t, s),
      setValue: (t, s) => this.setSeriesOptions(e(), [{ expression: t, value: s }]),
      setValues: (t) => this.setSeriesOptions(e(), t)
    };
  }
  /**
   * Determine the set of theme overrides that should be retained when transitioning from one chart type to another.
   */
  getPersistedChartThemeOverrides(e, t, s, i) {
    const r = this.getRetainedChartThemeOverrideKeys(s, i), n = this.getRetainedChartAxisThemeOverrideKeys(
      null,
      s,
      i
    ), o = this.createChartOptions();
    for (const a of r) {
      const l = this.retrieveChartOptionsThemeOverride(e, s, a);
      l !== void 0 && this.assignChartOptionsThemeOverride(o, i, a, l);
    }
    return t && this.assignPersistedAxisOverrides({
      existingAxes: t,
      retainedChartAxisThemeOverrideKeys: n,
      existingChartOptions: e,
      targetChartOptions: o,
      existingChartType: s,
      targetChartType: i
    }), o.theme.overrides;
  }
  assignPersistedAxisOverrides(e) {
    const {
      existingAxes: t,
      retainedChartAxisThemeOverrideKeys: s,
      existingChartOptions: i,
      targetChartOptions: r,
      existingChartType: n,
      targetChartType: o
    } = e;
    for (const { expression: a, targetAxisTypes: l } of s)
      for (const c of t.map((d) => d.type)) {
        const d = this.retrieveChartOptionsThemeOverride(
          i,
          n,
          ["axes", c, a].join(".")
        );
        if (d !== void 0)
          for (const u of l)
            this.assignChartOptionsThemeOverride(
              r,
              o,
              ["axes", u, a].join("."),
              d
            );
      }
  }
  getRetainedChartThemeOverrideKeys(e, t) {
    const s = ["animation"], i = ["zoom", "navigator"], r = ((n, o) => {
      const a = new Array();
      return vr(at(n)) && vr(at(o)) && a.push(...i), a;
    })(e, t);
    return [...s, ...r];
  }
  getRetainedChartAxisThemeOverrideKeys(e, t, s) {
    return vr(at(t)) && vr(at(s)) ? this.getRetainedCartesianAxisThemeOverrideKeys(e).map((r) => ({ expression: r, targetAxisTypes: dx })) : [];
  }
  getRetainedCartesianAxisThemeOverrideKeys(e) {
    const t = e === "xAxis" ? ["", ".top", ".bottom"] : e === "yAxis" ? ["", ".left", ".right"] : ["", ".left", ".right", ".top", ".bottom"], s = ["crosshair"], i = new Array();
    for (const r of s)
      for (const n of t)
        i.push(`${r}${n}`);
    return i;
  }
  getChartOption(e) {
    return en(this.getChart(), e, void 0);
  }
  setChartThemeOverrides(e) {
    const t = this.getChartType(), s = this.createChartOptions();
    for (const { expression: i, value: r } of e)
      this.assignChartOptionsThemeOverride(s, t, i, r);
    this.applyChartOptions(s);
  }
  applyChartOptions(e, t) {
    if (Object.keys(e).length === 0)
      return;
    this.updateChart(e), !(t != null && t.silent) && this.raiseChartOptionsChangedEvent();
  }
  awaitChartOptionUpdate(e) {
    this.chartController.getChartProxy().getChart().waitForUpdate().then(() => e()).catch((s) => be(108, { e: s }));
  }
  getAxisProperty(e) {
    var t;
    return en((t = this.getChart().axes) == null ? void 0 : t[0], e, void 0);
  }
  setAxisThemeOverrides(e) {
    var r;
    const t = this.getChart(), s = this.getChartType(), i = this.createChartOptions();
    for (const { expression: n, value: o } of e) {
      const a = (r = t.axes) == null ? void 0 : r.filter((l) => {
        const c = n.split(".");
        let d = l;
        for (const u of c) {
          if (!(u in d))
            return !1;
          d = d[u];
        }
        return !0;
      });
      if (a)
        for (const l of a)
          this.isValidAxisType(l) && this.assignChartAxisThemeOverride(i, s, l.type, null, n, o);
    }
    this.applyChartOptions(i);
  }
  getCartesianAxisProperty(e, t) {
    const s = this.getChartAxes(), i = this.getCartesianAxis(s, e);
    return en(i, t, void 0);
  }
  getCartesianAxisThemeOverride(e, t) {
    const s = this.getChartAxes(), i = this.getCartesianAxis(s, e);
    if (!i || !this.isValidAxisType(i))
      return;
    const r = this.getChartType(), n = this.getChart().getOptions();
    return this.retrieveChartAxisThemeOverride(
      n,
      r,
      i.type,
      e === "yAxis" ? ["left", "right"] : ["bottom", "top"],
      t
    );
  }
  setCartesianAxisThemeOverrides(e, t) {
    const s = this.getChartAxes(), i = this.getCartesianAxis(s, e);
    if (!i || !this.isValidAxisType(i))
      return;
    const r = this.getChartType(), n = this.createChartOptions();
    for (const { expression: o, value: a } of t)
      this.assignChartAxisThemeOverride(
        n,
        r,
        i.type,
        e === "yAxis" ? ["left", "right"] : ["bottom", "top"],
        o,
        a
      );
    this.applyChartOptions(n);
  }
  setCartesianAxisOptions(e, t) {
    this.updateCartesianAxisOptions(e, (s, i, r) => {
      const n = i.indexOf(r);
      for (const { expression: o, value: a } of t)
        this.assignChartOption(s, `axes.${n}.${o}`, a);
    });
  }
  updateCartesianAxisOptions(e, t) {
    const s = this.getChart().getOptions(), i = "axes" in s ? s.axes : void 0;
    if (!s || !i)
      return;
    const r = this.getChartAxes(), n = this.getCartesianAxis(r, e);
    if (!n)
      return;
    const o = this.createChartOptions();
    o.axes = i, t(o, r, n, s), this.applyChartOptions(o);
  }
  setCartesianCategoryAxisType(e, t) {
    this.updateCartesianAxisOptions(e, (s, i, r, n) => {
      const o = this.getChartType();
      this.assignPersistedAxisOverrides({
        existingAxes: [r],
        retainedChartAxisThemeOverrideKeys: this.getRetainedChartAxisThemeOverrideKeys(
          e,
          o,
          o
        ),
        existingChartOptions: n,
        targetChartOptions: s,
        existingChartType: o,
        targetChartType: o
      }), this.assignChartOption(s, "axes.0.type", t), this.chartController.setCategoryAxisType(t);
    });
  }
  getCartesianAxis(e, t) {
    if (!(e.length < 2))
      switch (t) {
        case "xAxis":
          return e[0].direction === "x" ? e[0] : e[1];
        case "yAxis":
          return e[1].direction === "y" ? e[1] : e[0];
      }
  }
  getSeriesOption(e, t, s) {
    const i = this.getChart().series.find((r) => N3(e, r));
    return en(s ? i : i == null ? void 0 : i.properties.toJson(), t, void 0);
  }
  setSeriesOptions(e, t) {
    const s = this.createChartOptions();
    for (const { expression: i, value: r } of t)
      this.assignChartOptionsSeriesThemeOverride(s, e, `series.${i}`, r);
    this.applyChartOptions(s);
  }
  getPairedMode() {
    return this.chartController.getChartProxy().isPaired();
  }
  setPairedMode(e) {
    this.chartController.getChartProxy().setPaired(e);
  }
  getChartAxes() {
    return this.getChart().axes ?? [];
  }
  retrieveChartAxisThemeOverride(e, t, s, i, r) {
    if (i)
      for (const n of i) {
        const o = this.retrieveChartOptionsThemeOverride(
          e,
          t,
          ["axes", s, n, ...r ? [r] : []].join(".")
        );
        if (o !== void 0)
          return o;
      }
    else
      return this.retrieveChartOptionsThemeOverride(
        e,
        t,
        ["axes", s, ...r ? [r] : []].join(".")
      );
  }
  assignChartAxisThemeOverride(e, t, s, i, r, n) {
    if (i)
      for (const o of i)
        this.assignChartOptionsThemeOverride(
          e,
          t,
          ["axes", s, o, ...r ? [r] : []].join("."),
          n
        );
    else
      this.assignChartOptionsThemeOverride(
        e,
        t,
        ["axes", s, ...r ? [r] : []].join("."),
        n
      );
  }
  isValidAxisType(e) {
    return B3.includes(e.type);
  }
  getChartType() {
    return this.chartController.getChartType();
  }
  getChart() {
    return this.chartController.getChartProxy().getChart();
  }
  updateChart(e) {
    const t = this.chartController.getChartProxy().getChartRef();
    t.skipAnimations(), t.updateDelta(e);
  }
  createChartOptions() {
    return {
      theme: {
        overrides: {}
      }
    };
  }
  retrieveChartOptionsThemeOverride(e, t, s) {
    const i = this.getChartThemeOverridesSeriesTypeKeys(t);
    for (const r of i) {
      const n = this.retrieveChartOptionsSeriesThemeOverride(e, r, s);
      if (n !== void 0)
        return n;
    }
  }
  assignChartOptionsThemeOverride(e, t, s, i) {
    const r = this.getChartThemeOverridesSeriesTypeKeys(t);
    for (const n of r)
      this.assignChartOptionsSeriesThemeOverride(e, n, s, i);
  }
  retrieveChartOptionsSeriesThemeOverride(e, t, s) {
    return this.retrieveChartOption(
      e,
      ["theme", "overrides", t, ...s ? [s] : []].join(".")
    );
  }
  assignChartOptionsSeriesThemeOverride(e, t, s, i) {
    this.assignChartOption(
      e,
      ["theme", "overrides", t, ...s ? [s] : []].join("."),
      i
    );
  }
  getChartThemeOverridesSeriesTypeKeys(e) {
    const t = this.chartController.getChartSeriesTypes(e);
    return this.chartController.isComboChart() && t.push("common"), t;
  }
  retrieveChartOption(e, t) {
    return en(e, t, void 0);
  }
  assignChartOption(e, t, s) {
    h$(e, t, s);
  }
  raiseChartOptionsChangedEvent() {
    const e = this.chartController.getChartModel();
    this.eventSvc.dispatchEvent({
      type: "chartOptionsChanged",
      chartId: e.chartId,
      chartType: e.chartType,
      chartThemeName: this.chartController.getChartThemeName(),
      chartOptions: e.chartOptions
    });
  }
  destroy() {
    super.destroy();
  }
};
function N3(e, t) {
  return m$(e) && t.type === e;
}
var H3 = class extends _ {
  constructor(e) {
    super(
      /* html */
      `
            <div style="height: 100%; width: 100%;">
                <div class="ag-chart" data-ref="eWrapper">
                    <div data-ref="eChartContainer" class="ag-chart-components-wrapper ag-chart-menu-hidden">
                        <div data-ref="eChart" class="ag-chart-canvas-wrapper"></div>
                        <div data-ref="eEmpty" class="ag-chart-empty-text ag-unselectable"></div>
                    </div>
                    <div data-ref="eMenuContainer" class="ag-chart-docked-container"></div>
                </div>
            </div>
            `
    ), this.eChart = E, this.eWrapper = E, this.eChartContainer = E, this.eMenuContainer = E, this.eEmpty = E, this.params = e;
  }
  wireBeans(e) {
    this.crossFilterService = e.chartCrossFilterSvc, this.chartTranslation = e.chartTranslation, this.chartMenuSvc = e.chartMenuSvc, this.focusSvc = e.focusSvc, this.popupSvc = e.popupSvc, this.enterpriseChartProxyFactory = e.enterpriseChartProxyFactory, this.environment = e.environment;
  }
  postConstruct() {
    const e = {
      ...this.params,
      chartType: ua(this.params.chartType),
      chartThemeName: this.getThemeName()
    }, t = this.gos.get("enableRtl");
    this.eWrapper.classList.add(t ? "ag-rtl" : "ag-ltr");
    const s = this.createBean(new K$(e));
    this.chartController = this.createManagedBean(new Aj(s)), this.chartOptionsService = this.createManagedBean(new V3(this.chartController)), this.validateCustomThemes(), this.createChart(), this.params.insideDialog ? this.addDialog() : (this.addManagedEventListeners({
      gridStylesChanged: this.updateTheme.bind(this)
    }), this.updateTheme()), this.addMenu(), this.addManagedElementListeners(this.getGui(), { focusin: this.setActiveChartCellRange.bind(this) }), this.addManagedListeners(this.chartController, { chartModelUpdate: this.update.bind(this) }), this.addManagedPropertyListeners(
      ["chartThemeOverrides", "chartThemes"],
      this.reactivePropertyUpdate.bind(this)
    ), this.update(), this.raiseChartCreatedEvent();
  }
  updateTheme() {
    this.environment.applyThemeClasses(this.getGui());
  }
  createChart() {
    let e;
    this.chartProxy && (e = this.chartProxy.destroy({ keepChartInstance: !0 }));
    const t = (r, n) => {
      const o = this.params.crossFilteringContext;
      o.lastSelectedChartId = n ? "" : this.chartController.getChartId(), n && this.params.crossFilteringResetCallback(), this.crossFilterService.filter(r, n);
    }, s = this.chartController.getChartType(), i = {
      agChartsExports: this.beans.agChartsExports,
      chartType: s,
      chartInstance: e,
      getChartThemeName: this.getChartThemeName.bind(this),
      getChartThemes: this.getChartThemes.bind(this),
      customChartThemes: this.gos.get("customChartThemes"),
      getGridOptionsChartThemeOverrides: () => this.getGridOptionsChartThemeOverrides(),
      getExtraPaddingDirections: () => {
        var r;
        return ((r = this.chartMenu) == null ? void 0 : r.getExtraPaddingDirections()) ?? [];
      },
      apiChartThemeOverrides: this.params.chartThemeOverrides,
      crossFiltering: this.params.crossFiltering ?? !1,
      crossFilterCallback: t,
      parentElement: this.eChart,
      grouping: this.chartController.isGrouping(),
      chartThemeToRestore: this.params.chartThemeName,
      chartOptionsToRestore: this.params.chartOptionsToRestore,
      chartPaletteToRestore: this.params.chartPaletteToRestore,
      seriesChartTypes: this.chartController.getSeriesChartTypes(),
      translate: (r) => this.chartTranslation.translate(r)
    };
    if (this.params.chartOptionsToRestore = void 0, this.chartType = s, this.chartProxy = this.createChartProxy(i), !this.chartProxy) {
      I(138, { chartType: i.chartType });
      return;
    }
    this.chartController.setChartProxy(this.chartProxy), this.createMenuContext();
  }
  createMenuContext() {
    if (this.chartMenuContext)
      return;
    const e = this.createManagedBean(
      new Sn(this.chartOptionsService.getChartThemeOverridesProxy())
    ), t = this.createManagedBean(
      new Sn(this.chartOptionsService.getAxisThemeOverridesProxy())
    );
    this.chartMenuContext = {
      chartController: this.chartController,
      chartOptionsService: this.chartOptionsService,
      chartMenuParamsFactory: e,
      chartAxisMenuParamsFactory: t
    };
  }
  getChartThemeName() {
    return this.chartController.getChartThemeName();
  }
  getChartThemes() {
    return this.chartController.getThemeNames();
  }
  getGridOptionsChartThemeOverrides() {
    return this.gos.get("chartThemeOverrides");
  }
  createChartProxy(e) {
    var i;
    const { chartType: t } = e;
    switch (t) {
      case "column":
      case "bar":
      case "groupedColumn":
      case "stackedColumn":
      case "normalizedColumn":
      case "groupedBar":
      case "stackedBar":
      case "normalizedBar":
        return new Lj(e);
      case "pie":
      case "donut":
      case "doughnut":
        return new Vj(e);
      case "area":
      case "stackedArea":
      case "normalizedArea":
        return new Mj(e);
      case "line":
      case "stackedLine":
      case "normalizedLine":
        return new kj(e);
      case "scatter":
      case "bubble":
        return new Oj(e);
      case "columnLineCombo":
      case "areaColumnCombo":
      case "customCombo":
        return new Gj(e);
    }
    const s = (i = this.enterpriseChartProxyFactory) == null ? void 0 : i.createChartProxy(e);
    if (!s)
      throw Ws(251, { chartType: t });
    return s;
  }
  addDialog() {
    const e = this.chartTranslation.translate(this.params.pivotChart ? "pivotChartTitle" : "rangeChartTitle"), { width: t, height: s } = this.getBestDialogSize(), i = this.params.focusDialogOnOpen ? () => setTimeout(() => Dt(this.getGui())) : void 0;
    this.chartDialog = new ya({
      resizable: !0,
      movable: !0,
      maximizable: !0,
      title: e,
      width: t,
      height: s,
      component: this,
      centered: !0,
      closable: !0,
      afterGuiAttached: i,
      postProcessPopupParams: {
        type: "chart"
      }
    }), this.createBean(this.chartDialog), this.chartDialog.addEventListener("destroyed", () => {
      this.destroy(), this.chartMenuSvc.hideAdvancedSettings();
      const r = this.focusSvc.getFocusedCell();
      setTimeout(() => {
        this.focusSvc.isAlive() && (r ? this.focusSvc.setFocusedCell({ ...r, forceBrowserFocus: !0 }) : lw(this.beans));
      });
    });
  }
  getBestDialogSize() {
    const e = this.popupSvc.getPopupParent(), t = gn(e) * 0.75, s = oc(e) * 0.75, i = 0.553, r = this.chartProxy.getChart();
    let n = this.params.insideDialog ? 850 : r.width, o = this.params.insideDialog ? 470 : r.height;
    return (n > t || o > s) && (n = Math.min(n, t), o = Math.round(n * i), o > s && (o = s, n = Math.min(n, Math.round(o / i)))), { width: n, height: o };
  }
  addMenu() {
    this.params.crossFiltering || (this.chartMenu = this.createBean(
      new O3(this.eChartContainer, this.eMenuContainer, this.chartMenuContext)
    ), this.eChartContainer.appendChild(this.chartMenu.getGui()));
  }
  update(e) {
    if (e != null && e.chartId && !this.chartController.update(e))
      return;
    const t = this.chartTypeChanged(e), s = t || this.chartEmpty ? ((r) => {
      const n = this.chartType, o = r, a = this.chartProxy.getChart(), l = a == null ? void 0 : a.getOptions(), c = a == null ? void 0 : a.axes;
      return this.chartOptionsService.getPersistedChartThemeOverrides(
        l,
        c,
        n,
        o ?? n
      );
    })(t) : void 0;
    t && this.createChart(), s && (e != null && e.chartThemeOverrides) && bt(s, e.chartThemeOverrides);
    const i = s ?? (e == null ? void 0 : e.chartThemeOverrides);
    this.updateChart(i), e != null && e.chartId && this.chartProxy.getChart().waitForUpdate().then(() => {
      this.chartController.raiseChartApiUpdateEvent();
    });
  }
  updateChart(e) {
    const { chartProxy: t } = this, s = this.chartController.getSelectedValueColState(), i = this.chartController.getChartData(), r = this.handleEmptyChart(i, s.length);
    if (this.chartEmpty = r, r) {
      e && this.chartController.updateThemeOverrides(e);
      return;
    }
    const n = this.chartController.getChartUpdateParams(e);
    t.update(n), this.chartProxy.getChart().waitForUpdate().then(() => {
      this.chartController.raiseChartUpdatedEvent();
    });
  }
  chartTypeChanged(e) {
    const [t, s] = [this.chartController.getChartType(), e == null ? void 0 : e.chartType], i = s ? ua(s) : void 0;
    return this.chartType !== t ? i ?? t : i && t !== i ? i : null;
  }
  getChartModel() {
    return this.chartController.getChartModel();
  }
  getChartImageDataURL(e) {
    return this.chartProxy.getChartImageDataURL(e);
  }
  handleEmptyChart(e, t) {
    const s = this.chartController.isPivotChart() && !this.chartController.isPivotMode(), i = this.chartController.getChartType();
    let r = 1;
    this.chartController.isActiveXYChart() ? r = i === "bubble" ? 3 : 2 : on(at(i)) && (r = 0);
    const n = t < r || e.length === 0;
    if (this.eChart) {
      const o = s || n;
      re(this.eChart, !o), re(this.eEmpty, o);
    }
    return s ? (this.eEmpty.innerText = this.chartTranslation.translate("pivotChartRequiresPivotMode"), !0) : n ? (this.eEmpty.innerText = this.chartTranslation.translate("noDataToChart"), !0) : !1;
  }
  downloadChart(e, t, s) {
    this.chartProxy.downloadChart(e, t, s);
  }
  openChartToolPanel(e) {
    const t = e && gl[e];
    this.chartMenu.showMenu({ panel: t });
  }
  closeChartToolPanel() {
    this.chartMenu.hideMenu();
  }
  getChartId() {
    return this.chartController.getChartId();
  }
  getUnderlyingChart() {
    return this.chartProxy.getChartRef();
  }
  crossFilteringReset() {
    this.chartProxy.crossFilteringReset();
  }
  setActiveChartCellRange(e) {
    this.getGui().contains(e.relatedTarget) || this.chartController.setChartRange(!0);
  }
  getThemeName() {
    const e = this.gos.get("chartThemes") || yS;
    if (e.length === 0)
      throw new Error(Ws(254));
    const { chartThemeName: t } = this.params;
    return e.includes(t) ? t : e[0];
  }
  getAllKeysInObjects(e) {
    const t = {};
    return e.filter((s) => s != null).forEach((s) => {
      Object.keys(s).forEach((i) => t[i] = null);
    }), Object.keys(t);
  }
  validateCustomThemes() {
    const e = this.getChartThemes(), t = this.gos.get("customChartThemes");
    t && this.getAllKeysInObjects([t]).forEach((s) => {
      e.includes(s) || I(139, { customThemeName: s });
    });
  }
  reactivePropertyUpdate() {
    this.chartController.setChartThemeName(this.getThemeName(), !0);
    const e = this.getChartId(), t = this.chartController.isCrossFilterChart() ? "crossFilter" : this.getChartModel().modelType, s = this.gos.get("chartThemeOverrides") || {};
    this.update({
      type: `${t}ChartUpdate`,
      chartId: e,
      chartThemeOverrides: s
    });
  }
  raiseChartCreatedEvent() {
    this.chartProxy.getChart().waitForUpdate().then(() => {
      this.eventSvc.dispatchEvent({
        type: "chartCreated",
        chartId: this.chartController.getChartId()
      });
    });
  }
  raiseChartDestroyedEvent() {
    this.eventSvc.dispatchEvent({
      type: "chartDestroyed",
      chartId: this.chartController.getChartId()
    });
  }
  destroy() {
    var t;
    super.destroy(), this.chartProxy && this.chartProxy.destroy(), this.destroyBean(this.chartMenu), this.chartDialog && this.chartDialog.isAlive() && this.destroyBean(this.chartDialog), (t = this.onDestroyColorSchemeChangeListener) == null || t.call(this);
    const e = this.getGui();
    ze(e), ut(e), this.raiseChartDestroyedEvent();
  }
};
function z3(e) {
  return e.version, e.version == null && (e.version = s4(e)), e = $t("23.0.0", e, W3), e = $t("24.0.0", e, _3), e = $t("25.1.0", e, U3), e = $t("26.0.0", e, $3), e = $t("26.1.0", e, j3), e = $t("26.2.0", e, K3), e = $t("28.0.0", e, q3), e = $t("28.2.0", e, Y3), e = $t("29.0.0", e, X3), e = $t("29.1.0", e, ux), e = $t("29.2.0", e, hx), e = $t("30.0.0", e, Z3), e = $t("31.0.0", e, Q3), e = $t("32.0.0", e, J3), e = $t("33.0.0", e, e4), e = t4(e), e = $t(Me, e, (t) => t), e;
}
function W3(e) {
  return e = Nt("chartOptions.legend.item.marker.type", "shape", e), e = Nt("chartOptions.seriesDefaults.marker.type", "shape", e), e = Nt("chartOptions.legend.padding", "spacing", e), e;
}
function _3(e) {
  e = et("chartOptions.seriesDefaults.marker.minSize", e);
  const {
    chartType: t,
    chartPalette: s,
    // Migrate.
    chartOptions: { xAxis: i, yAxis: r, ...n },
    ...o
  } = e, a = x$(t), l = a == null ? void 0 : a.map((d, u) => ({
    type: d,
    ...u === 0 ? i : r
  }));
  return {
    chartType: t,
    chartThemeName: {
      borneo: "ag-default",
      material: "ag-material",
      bright: "ag-vivid"
    }[s] ?? "ag-default",
    chartOptions: {
      ...n,
      axes: l,
      xAxis: i,
      yAxis: r
    },
    ...o
  };
}
function U3(e) {
  return e = Nt("chartOptions.seriesDefaults.label.minRequiredAngle", "minAngle", e), e;
}
function $3(e) {
  return e = Ni("chartOptions.seriesDefaults.highlightStyle", e, ({ dimOpacity: s, ...i }) => ({
    ...i,
    ...s != null ? { series: { dimOpacity: s } } : {}
  })), e = et("chart", e), e = et("chartOptions.seriesDefaults.tooltipClass", e), e = et("chartOptions.seriesDefaults.tooltipTracking", e), e = pm("chartOptions.axes[].label.rotation", 0, e), e = pm("chartOptions.axes[].label.rotation", 335, e), e;
}
function j3(e) {
  const t = ({ item: s, series: i, ...r }) => ({
    item: { ...r, ...s },
    ...i ? { series: i } : {}
  });
  return e = Ni("chartOptions.seriesDefaults.highlightStyle", e, t), e = Ni("chartOptions.series[].highlightStyle", e, t), e;
}
function K3(e) {
  e = fl("chartOptions.seriesDefaults.fill.opacity", "chartOptions.seriesDefaults.fillOpacity", e), e = fl("chartOptions.seriesDefaults.stroke.opacity", "chartOptions.seriesDefaults.strokeOpacity", e), e = fl("chartOptions.seriesDefaults.stroke.width", "chartOptions.seriesDefaults.strokeWidth", e), e = et("chartOptions.seriesDefaults.fill", e), e = et("chartOptions.seriesDefaults.stroke", e), e = et("chartOptions.seriesDefaults.callout.colors", e), e = et("chartOptions.xAxis", e), e = et("chartOptions.yAxis", e);
  const {
    chartType: t,
    // disable no-unused-vars because `series` is required here, even though
    // unused, because it serves to take the `series` key out of otherChartOptions
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    chartOptions: { axes: s, series: i, seriesDefaults: r, ...n },
    ...o
  } = e, a = ua(t), l = at(a), c = [l], d = {};
  if (!aS(l)) {
    const h = { top: {}, bottom: {}, left: {}, right: {} }, p = s.map(({ type: g, ...f }) => ({
      [g]: { ...h, ...f }
    })).reduce(fm, {});
    cS.filter((g) => p[g] == null).forEach((g) => {
      p[g] = { ...h };
    }), d.axes = p;
  }
  const u = c.map((h) => ({
    [h]: {
      ...d,
      series: r,
      ...n
    }
  })).reduce(fm, {});
  return e = {
    ...o,
    chartType: a,
    chartOptions: u
  }, e;
}
function q3(e) {
  return e = et("chartOptions.*.title.padding", e), e = et("chartOptions.*.subtitle.padding", e), e = et("chartOptions.*.axes.*.title.padding", e), e = yp("chartOptions.*.axes.*.title.enabled", !1, e), e;
}
function Y3(e) {
  return e = Nt("chartOptions.pie.series.callout", "calloutLine", e), e = Nt("chartOptions.pie.series.label", "calloutLabel", e), e = Nt("chartOptions.pie.series.labelKey", "sectorLabelKey", e), e = Nt("chartOptions.pie.series.labelName", "sectorLabelName", e), e = Nt("chartOptions.donut.series.callout", "calloutLine", e), e = Nt("chartOptions.donut.series.label", "calloutLabel", e), e = Nt("chartOptions.donut.series.labelKey", "sectorLabelKey", e), e = Nt("chartOptions.donut.series.labelName", "sectorLabelName", e), e;
}
function X3(e) {
  return e = Bo("chartOptions.scatter.series.fill", "chartOptions.scatter.series.marker.fill", e), e = Bo(
    "chartOptions.scatter.series.fillOpacity",
    "chartOptions.scatter.series.marker.fillOpacity",
    e
  ), e = Bo("chartOptions.scatter.series.stroke", "chartOptions.scatter.series.marker.stroke", e), e = Bo(
    "chartOptions.scatter.series.strokeOpacity",
    "chartOptions.scatter.series.marker.strokeOpacity",
    e
  ), e = Bo(
    "chartOptions.scatter.series.strokeWidth",
    "chartOptions.scatter.series.marker.strokeWidth",
    e
  ), e = fl("chartOptions.scatter.series.paired", "chartOptions.scatter.paired", e), e;
}
function ux(e) {
  return e = et("chartOptions.axes[].tick.count", e), e;
}
function hx(e) {
  return e = Ni("chartOptions.*.tooltip", e, ({ tracking: s, ...i }) => {
    const r = { ...i };
    return s === !1 ? (r.position ?? (r.position = { type: "pointer" }), r.range ?? (r.range = "nearest")) : s === !0 && (r.position ?? (r.position = { type: "node" }), r.range ?? (r.range = "nearest")), r;
  }), e;
}
function Z3(e) {
  return e = Nt("chartOptions.pie.series.labelKey", "sectorLabelKey", e), e = Nt("chartOptions.pie.series.labelName", "sectorLabelName", e), e = ux(e), e = hx(e), e = et("chartOptions.*.series.flipXY", e), e = px("chartOptions.common.legend.enabled", !0, e), e = yp("chartOptions.common.legend.position", "right", e), e;
}
function Q3(e) {
  const t = {
    "ag-pastel": "ag-sheets",
    "ag-solar": "ag-polychroma"
  }, s = Nt("chartOptions.column", "bar", e), i = t[s.chartThemeName] || s.chartThemeName;
  return {
    ...s,
    chartThemeName: i
  };
}
function J3(e) {
  return e = oi("chartOptions.*.autoSize", !0, e, (t, s) => {
    t[s] === !0 || t[s] === !1 && (t.minHeight = 600, t.minWidth = 300), delete t[s];
  }), e;
}
function e4(e) {
  return e = et("chartOptions.*.axes.category.label.format", e), e = et("chartOptions.*.axes.category.crosshair.label.format", e), e = et("chartOptions.*.axes.angle-category.label.format", e), e = et("chartOptions.*.axes.radius-category.label.format", e), e = Nt("chartOptions.*.axes.*.label.padding", "spacing", e), e = Nt("chartOptions.*.navigator.miniChart.label.padding", "spacing", e), e = et("chartOptions.*.axes.*.crossLines.label.className", e), e = oi("chartOptions.*.axes.*.crossLines.label.position", !0, e, (t, s) => {
    typeof t[s] == "string" && (t[s] = t[s].replace(/([A-Z])/, "-$1").toLowerCase());
  }), e = et("chartOptions.bullet", e), e = gm("chartOptions.bar.series.label.placement", e, {
    inside: "inside-center",
    outside: "inside-end"
  }), e = gm("chartOptions.waterfall.series.item.*.label.placement", e, {
    inside: "inside-center",
    start: "outside-start",
    end: "outside-end"
  }), e = et("chartOptions.*.navigator.min", e), e = et("chartOptions.*.navigator.max", e), e = et("chartOptions.*.zoom.ratioX", e), e = et("chartOptions.*.zoom.ratioY", e), e = et("chartOptions.*.zoom.rangeX", e), e = et("chartOptions.*.zoom.rangeY", e), e;
}
function t4(e) {
  return e = et("chartOptions.*.width", e), e = et("chartOptions.*.height", e), e = yp("chartOptions.*.axes.category.label.autoRotate", !0, e), e;
}
function s4(e) {
  var c, d;
  const t = e;
  if (e.version != null)
    return e.version;
  const s = (u, ...h) => Object.keys(u || {}).some((p) => h.includes(p)), i = t.chartOptions, r = s(i, "seriesDefaults") ? i == null ? void 0 : i.seriesDefaults : i == null ? void 0 : i[Object.keys(i)[0]], n = {
    "27.0.0": s(t, "seriesChartTypes"),
    "26.2.0": !s(i, "seriesDefaults"),
    "26.1.0": s(r == null ? void 0 : r.highlightStyle, "item"),
    "26.0.0": s(r == null ? void 0 : r.highlightStyle, "series"),
    // '26.0.0': modelAny.chart === undefined,
    "25.1.0": s(r == null ? void 0 : r.label, "minAngle"),
    "25.0.0": s(t, "modelType", "aggFunc", "unlinkChart", "suppressChartRanges") || s(r, "lineDash", "lineDashOffset"),
    "24.0.0": s(t, "chartThemeName", "chart") || s(i, "series"),
    "23.2.0": s(i, "navigator"),
    "23.0.0": s((d = (c = i == null ? void 0 : i.legend) == null ? void 0 : c.item) == null ? void 0 : d.marker, "shape"),
    "22.1.0": s(t, "chartPalette", "chartType")
  }, o = "27.1.0", a = Object.entries(n).filter(([u, h]) => h), [l = o] = a[0];
  return l;
}
function $t(e, t, s) {
  if (hm(e) > hm(t.version)) {
    const i = s(t);
    return i.version = e, i;
  }
  return t;
}
function i4(e) {
  const t = e.includes("-beta") ? e.replace(/-beta.*/, "") : e, s = typeof t == "string" ? t.split(".").map((i) => Number(i)) : [];
  if (s.length !== 3 || s.some((i) => isNaN(i)))
    throw new Error(Ws(253, { version: t }));
  return {
    major: s[0],
    minor: s[1],
    patch: s[2]
  };
}
function hm(e) {
  const { major: t, minor: s, patch: i } = i4(e);
  return t * 1e4 + s * 100 + i;
}
function pm(e, t, s) {
  return oi(e, !0, s, (i, r) => {
    i[r] === t && delete i[r];
  });
}
function yp(e, t, s) {
  return oi(e, !1, s, (i, r) => {
    i[r] == null && (i[r] = t);
  });
}
function px(e, t, s) {
  typeof e == "string" && (e = e.split("."));
  const i = e[0];
  return e.length > 1 && (s[i] = px(e.slice(1), t, s[i] ?? {})), Object.keys(s).includes(i) || (s[i] = t), s;
}
function fl(e, t, s) {
  let i, r = !1;
  return s = oi(e, !0, s, (n, o) => {
    r = !0, i = n[o], delete n[o];
  }), r ? oi(t, !1, s, (n, o) => {
    n[o] = i;
  }) : s;
}
function Bo(e, t, s) {
  let i, r = !1;
  return s = oi(e, !0, s, (n, o) => {
    r = !0, i = n[o], delete n[o];
  }), r ? oi(t, !1, s, (n, o) => {
    n[o] === void 0 && (n[o] = i);
  }) : s;
}
function Nt(e, t, s) {
  return oi(e, !0, s, (i, r) => {
    i[t] = i[r], delete i[r];
  });
}
function et(e, t) {
  return oi(e, !0, t, (s, i) => delete s[i]);
}
function oi(e, t, s, i) {
  const r = e instanceof Array ? e : e.split("."), n = r.slice(0, r.length - 1), o = r[r.length - 1];
  return Ni(n, s, (a) => {
    const l = Object.keys(a).includes(o);
    if (t && !l)
      return a;
    const c = { ...a };
    return i(c, o), c;
  });
}
function Ni(e, t, s) {
  const i = e instanceof Array ? e : e.split(".");
  if (t = { ...t }, i.length === 0)
    return s(t);
  if (i[0].startsWith("{")) {
    const r = i[0].substring(1, i[0].lastIndexOf("}")).split(",");
    for (const n of r)
      t[n] != null && (t[n] = Ni(i.slice(1), t[n], s));
  } else if (i[0].endsWith("[]")) {
    const r = i[0].substring(0, e[0].indexOf("["));
    t[r] instanceof Array && (t[r] = t[r].map((n) => Ni(i.slice(1), n, s)));
  } else if (i[0] === "*")
    for (const r of Object.keys(t))
      t[r] = Ni(i.slice(1), t[r], s);
  else t[i[0]] != null && (t[i[0]] = Ni(i.slice(1), t[i[0]], s));
  return t;
}
function gm(e, t, s) {
  return oi(e, !0, t, (i, r) => {
    typeof i[r] == "string" && (i[r] = s[r] ?? r);
  });
}
var fm = (e, t) => ({ ...e, ...t }), r4 = class extends L {
  constructor() {
    super(...arguments), this.beanName = "chartSvc", this.activeCharts = /* @__PURE__ */ new Set(), this.activeChartComps = /* @__PURE__ */ new Set(), this.crossFilteringContext = {
      lastSelectedChartId: ""
    }, this.isEnterprise = () => this.agChartsExports.isEnterprise;
  }
  wireBeans(e) {
    this.visibleCols = e.visibleCols, this.rangeSvc = e.rangeSvc, this.agChartsExports = e.agChartsExports;
  }
  updateChart(e) {
    if (this.activeChartComps.size === 0) {
      I(124);
      return;
    }
    const t = [...this.activeChartComps].find((s) => s.getChartId() === e.chartId);
    if (!t) {
      I(125, { chartId: e.chartId });
      return;
    }
    t.update(e);
  }
  getChartModels() {
    const e = [], t = (s) => ({ ...s, version: Me });
    return this.activeChartComps.forEach((s) => e.push(t(s.getChartModel()))), e;
  }
  getChartRef(e) {
    let t;
    return this.activeCharts.forEach((s) => {
      s.chartId === e && (t = s);
    }), t;
  }
  getChartComp(e) {
    let t;
    return this.activeChartComps.forEach((s) => {
      s.getChartId() === e && (t = s);
    }), t;
  }
  getChartImageDataURL(e) {
    let t;
    return this.activeChartComps.forEach((s) => {
      s.getChartId() === e.chartId && (t = s.getChartImageDataURL(e.fileFormat));
    }), t;
  }
  downloadChart(e) {
    const t = Array.from(this.activeChartComps).find((s) => s.getChartId() === e.chartId);
    t == null || t.downloadChart(e.dimensions, e.fileName, e.fileFormat);
  }
  openChartToolPanel(e) {
    const t = Array.from(this.activeChartComps).find((s) => s.getChartId() === e.chartId);
    t == null || t.openChartToolPanel(e.panel);
  }
  closeChartToolPanel(e) {
    const t = Array.from(this.activeChartComps).find((s) => s.getChartId() === e);
    t == null || t.closeChartToolPanel();
  }
  createChartFromCurrentRange(e = "groupedColumn", t) {
    const s = this.getSelectedRange();
    return this.createChart({ cellRange: s, chartType: e, focusDialogOnOpen: !t });
  }
  restoreChart(e, t) {
    if (!e) {
      I(126);
      return;
    }
    e.version !== Me && (e = z3(e));
    let s, i, r, n;
    if (e.modelType === "pivot" ? (this.gos.updateGridOptions({ options: { pivotMode: !0 }, source: "pivotChart" }), s = this.createCellRange(void 0, !0), i = !0, r = !0) : (s = this.createCellRange(e.cellRange), n = e.chartPalette, r = e.suppressChartRanges), !!s)
      return this.createChart({
        ...e,
        cellRange: s,
        pivotChart: i,
        suppressChartRanges: r,
        chartContainer: t,
        chartOptionsToRestore: e.chartOptions,
        chartPaletteToRestore: n
      });
  }
  createRangeChart(e, t) {
    const s = this.createCellRange(e.cellRange);
    if (s)
      return this.createChart({
        ...e,
        cellRange: s,
        focusDialogOnOpen: !t
      });
  }
  createPivotChart(e, t) {
    this.gos.updateGridOptions({ options: { pivotMode: !0 }, source: "pivotChart" });
    const s = this.createCellRange(void 0, !0);
    if (s)
      return this.createChart({
        ...e,
        cellRange: s,
        pivotChart: !0,
        suppressChartRanges: !0,
        focusDialogOnOpen: !t
      });
  }
  createCrossFilterChart(e, t) {
    const s = this.createCellRange(e.cellRange);
    if (!s)
      return;
    const r = typeof e.suppressChartRanges < "u" && e.suppressChartRanges !== null ? e.suppressChartRanges : !0;
    return this.createChart({
      ...e,
      cellRange: s,
      suppressChartRanges: r,
      crossFiltering: !0,
      focusDialogOnOpen: !t
    });
  }
  createChart(e) {
    const t = Pj(e, this.agChartsExports.isEnterprise);
    if (!t)
      return;
    e = t === !0 ? e : t;
    const { chartType: s, chartContainer: i } = e, r = this.gos.getCallback("createChartContainer"), n = {
      ...e,
      chartId: this.generateId(),
      chartType: ua(s),
      insideDialog: !(i || r),
      crossFilteringContext: this.crossFilteringContext,
      crossFilteringResetCallback: () => this.activeChartComps.forEach((l) => l.crossFilteringReset())
    }, o = new H3(n);
    this.createBean(o);
    const a = this.createChartRef(o);
    return i ? i.appendChild(a.chartElement) : r ? r(a) : o.addEventListener("destroyed", () => {
      this.activeChartComps.delete(o), this.activeCharts.delete(a);
    }), a;
  }
  createChartRef(e) {
    const t = {
      destroyChart: () => {
        this.activeCharts.has(t) && (this.destroyBean(e), this.activeChartComps.delete(e), this.activeCharts.delete(t));
      },
      focusChart: () => {
        Dt(e.getGui());
      },
      chartElement: e.getGui(),
      chart: e.getUnderlyingChart(),
      chartId: e.getChartModel().chartId
    };
    return this.activeCharts.add(t), this.activeChartComps.add(e), t;
  }
  getSelectedRange() {
    var t;
    const e = ((t = this.rangeSvc) == null ? void 0 : t.getCellRanges()) ?? [];
    return e.length > 0 ? e[0] : { columns: [] };
  }
  generateId() {
    return `id-${Math.random().toString(36).substring(2, 18)}`;
  }
  createCellRange(e, t) {
    var r;
    const s = t ? {
      rowStartIndex: null,
      rowStartPinned: void 0,
      rowEndIndex: null,
      rowEndPinned: void 0,
      columns: this.visibleCols.allCols.map((n) => n.getColId())
    } : e, i = s && ((r = this.rangeSvc) == null ? void 0 : r.createPartialCellRangeFromRangeParams(s, !0));
    return i || I(127, { allRange: t }), i;
  }
  destroy() {
    this.activeCharts.forEach((e) => e.destroyChart()), super.destroy();
  }
};
function n4(e) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var t;
    return (t = e.chartSvc) == null ? void 0 : t.getChartModels();
  });
}
function o4(e, t) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var s;
    return (s = e.chartSvc) == null ? void 0 : s.getChartRef(t);
  });
}
function a4(e, t) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var s;
    return (s = e.chartSvc) == null ? void 0 : s.getChartImageDataURL(t);
  });
}
function l4(e, t) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var s;
    return (s = e.chartSvc) == null ? void 0 : s.downloadChart(t);
  });
}
function c4(e, t) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var s;
    return (s = e.chartSvc) == null ? void 0 : s.openChartToolPanel(t);
  });
}
function d4(e, t) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var s;
    return (s = e.chartSvc) == null ? void 0 : s.closeChartToolPanel(t.chartId);
  });
}
function u4(e, t) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var s;
    return (s = e.chartSvc) == null ? void 0 : s.createRangeChart(t, !0);
  });
}
function h4(e, t) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var s;
    return (s = e.chartSvc) == null ? void 0 : s.createPivotChart(t, !0);
  });
}
function p4(e, t) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var s;
    return (s = e.chartSvc) == null ? void 0 : s.createCrossFilterChart(t, !0);
  });
}
function g4(e, t) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var s;
    return (s = e.chartSvc) == null ? void 0 : s.updateChart(t);
  });
}
function f4(e, t, s) {
  return e.frameworkOverrides.wrapIncoming(() => {
    var i;
    return (i = e.chartSvc) == null ? void 0 : i.restoreChart(t, s);
  });
}
var m4 = (
  /*css*/
  `.ag-chart{display:flex;height:100%;position:relative;width:100%}.ag-chart-components-wrapper{display:flex}.ag-chart-canvas-wrapper,.ag-chart-components-wrapper{flex:1 1 auto;position:relative}.ag-chart-menu{background:var(--ag-background-color);background-color:color-mix(in srgb,transparent,var(--ag-background-color) 30%);border-radius:var(--ag-border-radius);display:flex;flex-direction:row;gap:20px;padding:4px 2px;position:absolute;top:8px;width:auto;--ag-icon-size:20px}:where(.ag-ltr) .ag-chart-menu{justify-content:right;right:calc(var(--ag-cell-horizontal-padding) + var(--ag-spacing) - 4px)}:where(.ag-rtl) .ag-chart-menu{justify-content:left;left:calc(var(--ag-cell-horizontal-padding) + var(--ag-spacing) - 4px)}:where(.ag-chart) .ag-chart-menu{display:none}:where(.ag-chart-menu-hidden:hover) .ag-chart-menu{display:block}.ag-chart-docked-container{min-width:var(--ag-chart-menu-panel-width);position:relative}:where(.ag-chart-menu-hidden)~.ag-chart-docked-container{display:none}.ag-chart-tabbed-menu{display:flex;flex-direction:column;height:100%;overflow:hidden;width:100%}.ag-chart-tabbed-menu-header{cursor:default;flex:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-chart-tabbed-menu-body{align-items:stretch;display:flex;flex:1 1 auto;overflow:hidden;position:relative;&:after{background:linear-gradient(var(--ag-background-color),transparent);content:"";display:block;height:16px;left:0;position:absolute;right:0;top:0}}.ag-chart-tab{overflow:hidden;overflow-y:auto;width:100%}.ag-chart-settings{overflow-x:hidden}.ag-chart-settings-wrapper{display:flex;flex-direction:column;height:100%;overflow:hidden;position:relative;width:100%}.ag-chart-settings-nav-bar{align-items:center;border-top:1px solid var(--ag-border-color);display:flex;height:30px;padding:0 10px;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.ag-chart-settings-card-selector{align-items:center;display:flex;flex:1 1 auto;height:100%;justify-content:space-around;padding:0 10px}.ag-chart-settings-card-item{background-color:var(--ag-foreground-color);border-radius:4px;cursor:pointer;height:8px;position:relative;width:8px;&.ag-not-selected{opacity:.2}&:before{background-color:transparent;content:" ";display:block;height:20px;left:50%;margin-left:-10px;margin-top:-10px;position:absolute;top:50%;width:20px}&.ag-selected{background-color:var(--ag-accent-color)}}.ag-chart-settings-next,.ag-chart-settings-prev{flex:none;position:relative;&:focus-within{border-radius:1px;box-shadow:var(--ag-focus-shadow)}}.ag-chart-settings-next-button,.ag-chart-settings-prev-button{cursor:pointer;height:100%;left:0;opacity:0;position:absolute;top:0;width:100%}.ag-chart-settings-mini-charts-container{flex:1 1 auto;overflow:hidden auto;position:relative}.ag-chart-settings-mini-wrapper{display:flex;flex-direction:column;left:0;min-height:100%;overflow:hidden;padding-bottom:var(--ag-widget-container-vertical-padding);position:absolute;top:0;width:100%;&.ag-animating{transition:left .3s;transition-timing-function:ease-in-out}}.ag-chart-mini-thumbnail{border:1px solid var(--ag-border-color);border-radius:5px;cursor:pointer;&.ag-selected{border-color:var(--ag-accent-color);border-width:2px}&:focus-visible{border-color:var(--ag-accent-color);box-shadow:var(--ag-focus-shadow)}}.ag-chart-mini-thumbnail-canvas{display:block}.ag-chart-advanced-settings-wrapper,.ag-chart-data-wrapper,.ag-chart-format-wrapper{display:flex;flex-direction:column;padding-bottom:16px;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ag-chart-advanced-settings-wrapper,.ag-chart-data-wrapper{height:100%;overflow-y:auto}.ag-chart-advanced-settings{background-color:var(--ag-chrome-background-color)}.ag-chart-advanced-settings,.ag-chart-advanced-settings-wrapper{width:100%}.ag-chart-advanced-settings-wrapper{padding-bottom:0}.ag-chart-advanced-settings-section{border-bottom:1px solid var(--ag-border-color);display:flex;margin:0;padding-bottom:var(--ag-widget-container-vertical-padding);padding-top:var(--ag-widget-container-vertical-padding)}.ag-chart-empty-text{align-items:center;background-color:var(--ag-background-color);display:flex;height:100%;justify-content:center;top:0;width:100%}.ag-charts-font-size-color{align-self:stretch;display:flex;justify-content:space-between}.ag-charts-data-group-item{padding-bottom:var(--ag-widget-container-vertical-padding);position:relative}.ag-charts-data-group-item:where(:not(:last-child)){margin-bottom:var(--ag-spacing)}.ag-chart-menu-icon{border-radius:var(--ag-border-radius);cursor:pointer;margin:2px 0;opacity:.8;&:hover{opacity:1}}.ag-chart-menu-toolbar-button{background-color:unset;border:0;border-radius:1px;padding:0 2px}.ag-chart-data-column-drag-handle{margin-left:var(--ag-spacing)}.ag-charts-advanced-settings-top-level-group-title-bar{background-color:unset;position:relative}.ag-charts-data-group-container{padding:calc(var(--ag-widget-container-vertical-padding)*.5) var(--ag-widget-container-horizontal-padding)}.ag-charts-data-group-item:where(:not(.ag-charts-format-sub-level-group,.ag-pill-select,.ag-select)){height:var(--ag-list-item-height)}.ag-charts-data-group-item:where(.ag-picker-field){margin-top:var(--ag-spacing)}.ag-charts-advanced-settings-top-level-group-container,.ag-charts-format-top-level-group-container{margin-left:calc(var(--ag-spacing)*2);padding:var(--ag-spacing)}.ag-charts-advanced-settings-top-level-group-item,.ag-charts-format-top-level-group-item{margin:var(--ag-spacing) 0}.ag-charts-format-sub-level-group-container{display:flex;flex-direction:column;padding:var(--ag-widget-vertical-spacing) 0}.ag-charts-settings-group-container{display:grid;grid-template-columns:60px 1fr 60px 1fr 60px;padding:var(--ag-spacing);row-gap:8px;:where(.ag-chart-mini-thumbnail:nth-child(3n+1)){grid-column:1}:where(.ag-chart-mini-thumbnail:nth-child(3n+2)){grid-column:3}:where(.ag-chart-mini-thumbnail:nth-child(3n+3)){grid-column:5}}.ag-chart-data-section,.ag-chart-format-section{display:flex;margin:0;:where(.ag-label:not(.ag-group-title-bar)){color:var(--ag-chart-menu-label-color)}:where(.ag-label-align-top .ag-label){margin-bottom:var(--ag-widget-vertical-spacing);margin-top:calc(var(--ag-widget-vertical-spacing)*.5)}:where(.ag-slider.ag-label-align-top .ag-label){margin-bottom:0}:where(label){display:inline-block}}.ag-chart-menu-panel{--ag-panel-background-color:var(--ag-chrome-background-color)}:where(.ag-ltr) .ag-chart-menu-panel{border-left:1px solid var(--ag-border-color)}:where(.ag-rtl) .ag-chart-menu-panel{border-right:1px solid var(--ag-border-color)}.ag-charts-data-group-title-bar,.ag-charts-format-top-level-group-title-bar,.ag-charts-settings-group-container,.ag-charts-settings-group-title-bar{border-top:none;font-weight:500;padding:0 calc(var(--ag-spacing)*1.5)}.ag-charts-format-sub-level-group-title-bar{background:none;font-weight:500;padding:var(--ag-widget-vertical-spacing) 0}.ag-chart-data-wrapper,.ag-chart-format-wrapper,.ag-charts-data-group-container,.ag-charts-data-group-title-bar,.ag-charts-format-sub-level-group,.ag-charts-format-sub-level-group-container>*,.ag-charts-format-sub-level-group-item:last-child,.ag-charts-format-top-level-group,.ag-charts-format-top-level-group-item,.ag-charts-format-top-level-group-title-bar,.ag-charts-settings-group-container,.ag-charts-settings-group-title-bar,:where(.ag-charts-format-top-level-group) .ag-charts-format-top-level-group-container{margin:0;padding:0}.ag-charts-data-group-title-bar,.ag-charts-format-top-level-group-title-bar,.ag-charts-settings-group-title-bar{padding:var(--ag-widget-container-vertical-padding) var(--ag-widget-container-horizontal-padding);position:relative}.ag-charts-data-group,.ag-charts-format-top-level-group{border-top:1px solid var(--ag-border-color)}:where(.ag-charts-data-group) .ag-charts-data-group-container,:where(.ag-charts-format-top-level-group) .ag-charts-format-top-level-group-container,:where(.ag-charts-settings-group) .ag-charts-settings-group-container{padding:0 var(--ag-widget-container-horizontal-padding)}.ag-charts-format-sub-level-group-container>*,.ag-charts-format-sub-level-no-header-group-container>*,.ag-charts-format-top-level-group-container>*{margin-bottom:var(--ag-widget-vertical-spacing)}.ag-charts-advanced-settings-top-level-group-container{margin:0}:where(.ag-charts-advanced-settings-top-level-group){.ag-charts-advanced-settings-top-level-group-container,.ag-charts-advanced-settings-top-level-group-title-bar{padding:0 var(--ag-widget-container-horizontal-padding)}}.ag-charts-advanced-settings-top-level-group-item{margin-bottom:0;margin-top:calc(var(--ag-widget-vertical-spacing)*2)}.ag-chart-settings-card-item.ag-not-selected:hover{opacity:.35}.ag-angle-select{align-items:center;display:flex}.ag-angle-select-wrapper{display:flex}.ag-angle-select-parent-circle{background-color:var(--ag-background-color);border:1px solid;border-color:var(--ag-border-color);border-radius:12px;display:block;height:24px;position:relative;width:24px}.ag-angle-select-child-circle{background-color:var(--ag-foreground-color);border-radius:3px;height:6px;left:12px;margin-left:-3px;margin-top:-4px;position:absolute;top:4px;width:6px}.ag-slider-wrapper{display:flex;:where(.ag-input-field){flex:1 1 auto}}.ag-color-panel{display:flex;flex-direction:column;padding:var(--ag-spacing);text-align:center;width:100%}.ag-spectrum-color{cursor:default;flex:1 1 auto;overflow:visible;position:relative}.ag-spectrum-fill{inset:0;position:absolute}.ag-spectrum-val{background-image:linear-gradient(0deg,#000,hsla(20,42%,65%,0));cursor:pointer}.ag-spectrum-dragger{background:#000;border:3px solid #fff;border-radius:18px;box-shadow:0 0 2px 0 rgba(0,0,0,.24);cursor:pointer;height:18px;pointer-events:none;position:absolute;width:18px}.ag-spectrum-alpha,.ag-spectrum-hue{cursor:default}.ag-spectrum-hue-background{background:linear-gradient(270deg,red 3%,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red);height:100%;width:100%}.ag-spectrum-alpha-background{background:linear-gradient(to right,var(--ag-internal-spectrum-alpha-color-from),var(--ag-internal-spectrum-alpha-color-to)),url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4"><rect x="0" y="0" width="4" height="4" fill="%23fff"/><path d="M0 0H2V4H4V2H0Z" fill="%23b2b2b2"/></svg>') 0 0 /4px 4px;height:100%;width:100%}.ag-spectrum-tool{border-radius:2px;cursor:pointer;height:11px;margin-bottom:10px;position:relative}.ag-spectrum-slider{border:2px solid #fff;border-radius:13px;box-shadow:0 1px 4px 0 rgba(0,0,0,.37);height:13px;margin-top:-12px;pointer-events:none;position:absolute;width:13px}:where(.ag-spectrum-alpha) .ag-spectrum-slider{background:linear-gradient(to bottom,var(--ag-internal-spectrum-alpha-color),var(--ag-internal-spectrum-alpha-color)) var(--ag-background-color)}.ag-recent-colors{display:flex;gap:6px;margin-bottom:2px;margin-left:var(--ag-spacing);margin-right:var(--ag-spacing)}.ag-recent-color{border:1px solid var(--ag-border-color);cursor:pointer}.ag-angle-select[disabled]{opacity:.5;pointer-events:none}:where(.ag-ltr) .ag-angle-select-field,:where(.ag-ltr) .ag-slider-field{margin-right:calc(var(--ag-spacing)*2)}:where(.ag-rtl) .ag-angle-select-field,:where(.ag-rtl) .ag-slider-field{margin-left:calc(var(--ag-spacing)*2)}.ag-color-dialog{border-radius:5px}:where(.ag-color-picker){.ag-picker-field-wrapper{padding-left:var(--ag-spacing);padding-right:var(--ag-spacing)}.ag-picker-field-display{align-items:center;display:flex;flex-direction:row;min-height:var(--ag-list-item-height)}}:where(.ag-ltr) .ag-color-picker-color,:where(.ag-ltr) .ag-color-picker-value{margin-right:var(--ag-spacing)}:where(.ag-rtl) .ag-color-picker-color,:where(.ag-rtl) .ag-color-picker-value{margin-left:var(--ag-spacing)}.ag-spectrum-tools{padding-bottom:0;padding-left:0;padding-right:0}.ag-spectrum-alpha-background,.ag-spectrum-hue-background{border-radius:2px}.ag-color-input-color,.ag-color-picker-color,.ag-recent-color{border-radius:4px}.ag-spectrum-sat{background-image:linear-gradient(90deg,#fff,hsla(20,42%,65%,0))}.ag-recent-color,.ag-spectrum-color,.ag-spectrum-slider{&:where(:not(:disabled,[readonly])):focus-visible{box-shadow:var(--ag-focus-shadow)}}.ag-color-input-color,.ag-color-picker-color{border:1px solid var(--ag-border-color);border-radius:2px;height:var(--ag-icon-size);width:var(--ag-icon-size)}:where(.ag-color-input){.ag-color-input-color{position:absolute}}:where(.ag-ltr) :where(.ag-color-input){.ag-input-field-input{padding-left:calc(var(--ag-icon-size) + var(--ag-spacing)*2)}.ag-color-input-color{margin-left:var(--ag-spacing)}}:where(.ag-rtl) :where(.ag-color-input){.ag-input-field-input{padding-right:calc(var(--ag-icon-size) + var(--ag-spacing)*2)}.ag-color-input-color{margin-right:var(--ag-spacing)}}.ag-range-field{align-items:center;display:flex;:where(.ag-input-wrapper){height:100%}}.ag-range-field-input{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;height:100%;overflow:visible;padding:0;width:100%;&:disabled{opacity:.5}}.ag-range-field-input{&::-webkit-slider-runnable-track{background-color:var(--ag-border-color);border-radius:1.5px;height:3px;margin:0;padding:0;width:100%}&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background-color:var(--ag-background-color);border:1px solid var(--ag-border-color);border-radius:100%;height:var(--ag-icon-size);margin:0;padding:0;transform:translateY(calc(var(--ag-icon-size)*-.5 + 1.5px));width:var(--ag-icon-size)}&:focus::-webkit-slider-thumb{border-color:var(--ag-accent-color);box-shadow:var(--ag-focus-shadow)}&:active::-webkit-slider-runnable-track{background-color:var(--ag-accent-color)}}.ag-range-field-input{&::-moz-range-track{background-color:var(--ag-border-color);border-radius:1.5px;height:3px;margin:0;padding:0;width:100%}&::-moz-ag-range-thumb{-moz-appearance:none;appearance:none;background-color:var(--ag-background-color);border:1px solid var(--ag-border-color);border-radius:100%;height:var(--ag-icon-size);margin:0;padding:0;transform:translateY(calc(var(--ag-icon-size)*-.5 + 1.5px));width:var(--ag-icon-size)}&:focus::-moz-ag-range-thumb{border-color:var(--ag-accent-color);box-shadow:var(--ag-focus-shadow)}&:active::-moz-ag-range-track{background-color:var(--ag-accent-color)}}`
), gx = 28, fx = 6;
function Gu(e) {
  return e && e.match(/\d+\.\d+\.\d+/);
}
function C4({
  gridMajorVersion: e,
  chartsMajorVersion: t
}) {
  const s = parseInt(e, 10), i = parseInt(t, 10), r = s - gx, n = i - fx, o = r >= 0;
  return r === n && o;
}
function v4(e) {
  if (!e || !Gu(e))
    return;
  const [t, s] = e.split(".") || [], i = `${t}.${s}.x`, n = parseInt(t, 10) - gx + fx;
  if (n < 0)
    return;
  const a = `${n}.${s}.x`;
  return {
    gridMajorMinor: i,
    chartsMajorMinor: a
  };
}
function sl({
  type: e,
  gridVersion: t,
  chartsVersion: s
}) {
  const i = "AG Grid: AG Grid version is incompatible. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.";
  if (!t)
    return i;
  const r = v4(t);
  if (!r)
    return i;
  const { gridMajorMinor: n, chartsMajorMinor: o } = r;
  return e === "incompatible" ? `AG Grid version ${t} and AG Charts version ${s} is not supported. AG Grid version ${n} should be used with AG Chart ${o}. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.` : e === "invalidCharts" ? `AG Grid version ${n} should be used with AG Chart ${o} not ${s}. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.` : i;
}
function w4({
  gridVersion: e,
  chartsVersion: t
}) {
  if (!Gu(t))
    return {
      isValid: !1,
      message: sl({ type: "invalidCharts", gridVersion: e, chartsVersion: t })
    };
  if (!Gu(e))
    return {
      isValid: !1,
      message: sl({ type: "invalidGrid", gridVersion: e, chartsVersion: t })
    };
  const [s, i] = e.split(".") || [], [r, n, o] = t.split(".") || [], a = C4({
    gridMajorVersion: s,
    chartsMajorVersion: r
  });
  return a && i === n || o.includes("beta") ? {
    isValid: !0
  } : !a || i !== n ? {
    isValid: !1,
    message: sl({ type: "incompatible", gridVersion: e, chartsVersion: t })
  } : {
    isValid: !1,
    message: sl({ type: "invalid", gridVersion: e, chartsVersion: t })
  };
}
var y4 = {
  // shown on top right of chart when chart is linked to range data (click to unlink)
  linked: "linked",
  // shown on top right of chart when chart is not linked to range data (click to link)
  unlinked: "unlinked",
  // icon to open charts menu
  chartsMenu: "menu-alt",
  // download chart
  chartsDownload: "save",
  // Edit Chart menu item shown in Integrated Charts menu
  chartsMenuEdit: "chart",
  // Advanced Settings menu item shown in Integrated Charts menu
  chartsMenuAdvancedSettings: "settings",
  // shown in Integrated Charts menu add fields
  chartsMenuAdd: "plus",
  // shown in Integrated Charts tool panel color picker
  chartsColorPicker: "small-down",
  // previous in Integrated Charts settings tool panel theme switcher
  chartsThemePrevious: "previous",
  // next in Integrated Charts settings tool panel theme switcher
  chartsThemeNext: "next"
}, b4 = {
  getChartModels: n4,
  getChartRef: o4,
  getChartImageDataURL: a4,
  downloadChart: l4,
  openChartToolPanel: c4,
  closeChartToolPanel: d4,
  createRangeChart: u4,
  createPivotChart: h4,
  createCrossFilterChart: p4,
  updateChart: g4,
  restoreChart: f4
}, mm = [
  eS,
  Je,
  ao,
  Yi,
  Dc
], Cm = "IntegratedCharts", S4 = {
  moduleName: Cm,
  version: Me,
  dependsOn: mm,
  // included to avoid other false positive warnings about missing modules
  validate: () => ({
    isValid: !1,
    message: Cv(257)
  }),
  with: (e) => {
    var t;
    if (e.setup(), (t = e.setGridContext) == null || t.call(e, !0), e.isEnterprise && e.setLicenseKey) {
      const s = {
        setLicenseKey: e.setLicenseKey
      };
      zo.setChartsLicenseManager(s);
    }
    return {
      moduleName: Cm,
      version: Me,
      icons: y4,
      apiFunctions: b4,
      dependsOn: mm,
      css: [m4],
      validate: () => w4({
        gridVersion: Me,
        chartsVersion: e.VERSION
      }),
      beans: [
        // bind the params to the constructor to avoid the need for static properties
        u$.bind(null, e),
        r4,
        mj,
        hj,
        dj,
        gj,
        // Include enterprise beans for now for all users as tiny compared to charts bundle size
        X$,
        lj
      ]
    };
  }
}, vm = [
  Q1,
  C2,
  hW,
  p_,
  R2,
  k2,
  IW,
  LW,
  eS,
  kW,
  Yb,
  n2,
  o2,
  n$,
  o$,
  jW,
  w_,
  fz,
  Xh,
  a_,
  l2,
  vU,
  MU
], wm = "AllEnterprise", x4 = {
  with: (e) => ({
    moduleName: wm,
    version: Me,
    dependsOn: [...vm, S4.with(e), d$.with(e)]
  }),
  moduleName: wm,
  version: Me,
  dependsOn: vm
};
dE.registerModules([x4]);
s0({ theme: "legacy" });
var il = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function di(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bu = { exports: {} }, Vn = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ud, ym;
function kc() {
  if (ym) return Ud;
  ym = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
  function i(n) {
    if (n == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(n);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var n = new String("abc");
      if (n[5] = "de", Object.getOwnPropertyNames(n)[0] === "5")
        return !1;
      for (var o = {}, a = 0; a < 10; a++)
        o["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(o).map(function(d) {
        return o[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ud = r() ? Object.assign : function(n, o) {
    for (var a, l = i(n), c, d = 1; d < arguments.length; d++) {
      a = Object(arguments[d]);
      for (var u in a)
        t.call(a, u) && (l[u] = a[u]);
      if (e) {
        c = e(a);
        for (var h = 0; h < c.length; h++)
          s.call(a, c[h]) && (l[c[h]] = a[c[h]]);
      }
    }
    return l;
  }, Ud;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bm;
function R4() {
  if (bm) return Vn;
  bm = 1, kc();
  var e = q, t = 60103;
  if (Vn.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var s = Symbol.for;
    t = s("react.element"), Vn.Fragment = s("react.fragment");
  }
  var i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, r = Object.prototype.hasOwnProperty, n = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, l, c) {
    var d, u = {}, h = null, p = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (d in l) r.call(l, d) && !n.hasOwnProperty(d) && (u[d] = l[d]);
    if (a && a.defaultProps) for (d in l = a.defaultProps, l) u[d] === void 0 && (u[d] = l[d]);
    return { $$typeof: t, type: a, key: h, ref: p, props: u, _owner: i.current };
  }
  return Vn.jsx = o, Vn.jsxs = o, Vn;
}
var $d = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Sm;
function F4() {
  return Sm || (Sm = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = q, s = kc(), i = 60103, r = 60106;
      e.Fragment = 60107;
      var n = 60108, o = 60114, a = 60109, l = 60110, c = 60112, d = 60113, u = 60120, h = 60115, p = 60116, g = 60121, f = 60122, m = 60117, C = 60129, w = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var y = Symbol.for;
        i = y("react.element"), r = y("react.portal"), e.Fragment = y("react.fragment"), n = y("react.strict_mode"), o = y("react.profiler"), a = y("react.provider"), l = y("react.context"), c = y("react.forward_ref"), d = y("react.suspense"), u = y("react.suspense_list"), h = y("react.memo"), p = y("react.lazy"), g = y("react.block"), f = y("react.server.block"), m = y("react.fundamental"), y("react.scope"), y("react.opaque.id"), C = y("react.debug_trace_mode"), y("react.offscreen"), w = y("react.legacy_hidden");
      }
      var b = typeof Symbol == "function" && Symbol.iterator, x = "@@iterator";
      function M(R) {
        if (R === null || typeof R != "object")
          return null;
        var V = b && R[b] || R[x];
        return typeof V == "function" ? V : null;
      }
      var T = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function F(R) {
        {
          for (var V = arguments.length, z = new Array(V > 1 ? V - 1 : 0), Y = 1; Y < V; Y++)
            z[Y - 1] = arguments[Y];
          k("error", R, z);
        }
      }
      function k(R, V, z) {
        {
          var Y = T.ReactDebugCurrentFrame, K = Y.getStackAddendum();
          K !== "" && (V += "%s", z = z.concat([K]));
          var Le = z.map(function(Fe) {
            return "" + Fe;
          });
          Le.unshift("Warning: " + V), Function.prototype.apply.call(console[R], console, Le);
        }
      }
      var O = !1;
      function D(R) {
        return !!(typeof R == "string" || typeof R == "function" || R === e.Fragment || R === o || R === C || R === n || R === d || R === u || R === w || O || typeof R == "object" && R !== null && (R.$$typeof === p || R.$$typeof === h || R.$$typeof === a || R.$$typeof === l || R.$$typeof === c || R.$$typeof === m || R.$$typeof === g || R[0] === f));
      }
      function $(R, V, z) {
        var Y = V.displayName || V.name || "";
        return R.displayName || (Y !== "" ? z + "(" + Y + ")" : z);
      }
      function j(R) {
        return R.displayName || "Context";
      }
      function J(R) {
        if (R == null)
          return null;
        if (typeof R.tag == "number" && F("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof R == "function")
          return R.displayName || R.name || null;
        if (typeof R == "string")
          return R;
        switch (R) {
          case e.Fragment:
            return "Fragment";
          case r:
            return "Portal";
          case o:
            return "Profiler";
          case n:
            return "StrictMode";
          case d:
            return "Suspense";
          case u:
            return "SuspenseList";
        }
        if (typeof R == "object")
          switch (R.$$typeof) {
            case l:
              var V = R;
              return j(V) + ".Consumer";
            case a:
              var z = R;
              return j(z._context) + ".Provider";
            case c:
              return $(R, R.render, "ForwardRef");
            case h:
              return J(R.type);
            case g:
              return J(R._render);
            case p: {
              var Y = R, K = Y._payload, Le = Y._init;
              try {
                return J(Le(K));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var X = 0, ie, Ce, ae, ge, Se, xe, ce;
      function Re() {
      }
      Re.__reactDisabledLog = !0;
      function De() {
        {
          if (X === 0) {
            ie = console.log, Ce = console.info, ae = console.warn, ge = console.error, Se = console.group, xe = console.groupCollapsed, ce = console.groupEnd;
            var R = {
              configurable: !0,
              enumerable: !0,
              value: Re,
              writable: !0
            };
            Object.defineProperties(console, {
              info: R,
              log: R,
              warn: R,
              error: R,
              group: R,
              groupCollapsed: R,
              groupEnd: R
            });
          }
          X++;
        }
      }
      function Xe() {
        {
          if (X--, X === 0) {
            var R = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: s({}, R, {
                value: ie
              }),
              info: s({}, R, {
                value: Ce
              }),
              warn: s({}, R, {
                value: ae
              }),
              error: s({}, R, {
                value: ge
              }),
              group: s({}, R, {
                value: Se
              }),
              groupCollapsed: s({}, R, {
                value: xe
              }),
              groupEnd: s({}, R, {
                value: ce
              })
            });
          }
          X < 0 && F("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var He = T.ReactCurrentDispatcher, $e;
      function Ct(R, V, z) {
        {
          if ($e === void 0)
            try {
              throw Error();
            } catch (K) {
              var Y = K.stack.trim().match(/\n( *(at )?)/);
              $e = Y && Y[1] || "";
            }
          return `
` + $e + R;
        }
      }
      var we = !1, _e;
      {
        var tt = typeof WeakMap == "function" ? WeakMap : Map;
        _e = new tt();
      }
      function Oe(R, V) {
        if (!R || we)
          return "";
        {
          var z = _e.get(R);
          if (z !== void 0)
            return z;
        }
        var Y;
        we = !0;
        var K = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Le;
        Le = He.current, He.current = null, De();
        try {
          if (V) {
            var Fe = function() {
              throw Error();
            };
            if (Object.defineProperty(Fe.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Fe, []);
              } catch (ht) {
                Y = ht;
              }
              Reflect.construct(R, [], Fe);
            } else {
              try {
                Fe.call();
              } catch (ht) {
                Y = ht;
              }
              R.call(Fe.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (ht) {
              Y = ht;
            }
            R();
          }
        } catch (ht) {
          if (ht && Y && typeof ht.stack == "string") {
            for (var Pe = ht.stack.split(`
`), Ge = Y.stack.split(`
`), ye = Pe.length - 1, Ne = Ge.length - 1; ye >= 1 && Ne >= 0 && Pe[ye] !== Ge[Ne]; )
              Ne--;
            for (; ye >= 1 && Ne >= 0; ye--, Ne--)
              if (Pe[ye] !== Ge[Ne]) {
                if (ye !== 1 || Ne !== 1)
                  do
                    if (ye--, Ne--, Ne < 0 || Pe[ye] !== Ge[Ne]) {
                      var Rt = `
` + Pe[ye].replace(" at new ", " at ");
                      return typeof R == "function" && _e.set(R, Rt), Rt;
                    }
                  while (ye >= 1 && Ne >= 0);
                break;
              }
          }
        } finally {
          we = !1, He.current = Le, Xe(), Error.prepareStackTrace = K;
        }
        var wt = R ? R.displayName || R.name : "", Gt = wt ? Ct(wt) : "";
        return typeof R == "function" && _e.set(R, Gt), Gt;
      }
      function je(R, V, z) {
        return Oe(R, !1);
      }
      function Qe(R) {
        var V = R.prototype;
        return !!(V && V.isReactComponent);
      }
      function Ue(R, V, z) {
        if (R == null)
          return "";
        if (typeof R == "function")
          return Oe(R, Qe(R));
        if (typeof R == "string")
          return Ct(R);
        switch (R) {
          case d:
            return Ct("Suspense");
          case u:
            return Ct("SuspenseList");
        }
        if (typeof R == "object")
          switch (R.$$typeof) {
            case c:
              return je(R.render);
            case h:
              return Ue(R.type, V, z);
            case g:
              return je(R._render);
            case p: {
              var Y = R, K = Y._payload, Le = Y._init;
              try {
                return Ue(Le(K), V, z);
              } catch {
              }
            }
          }
        return "";
      }
      var xt = {}, qs = T.ReactDebugCurrentFrame;
      function Rs(R) {
        if (R) {
          var V = R._owner, z = Ue(R.type, R._source, V ? V.type : null);
          qs.setExtraStackFrame(z);
        } else
          qs.setExtraStackFrame(null);
      }
      function pi(R, V, z, Y, K) {
        {
          var Le = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Fe in R)
            if (Le(R, Fe)) {
              var Pe = void 0;
              try {
                if (typeof R[Fe] != "function") {
                  var Ge = Error((Y || "React class") + ": " + z + " type `" + Fe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof R[Fe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Ge.name = "Invariant Violation", Ge;
                }
                Pe = R[Fe](V, Fe, Y, z, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ye) {
                Pe = ye;
              }
              Pe && !(Pe instanceof Error) && (Rs(K), F("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Y || "React class", z, Fe, typeof Pe), Rs(null)), Pe instanceof Error && !(Pe.message in xt) && (xt[Pe.message] = !0, Rs(K), F("Failed %s type: %s", z, Pe.message), Rs(null));
            }
        }
      }
      var cs = T.ReactCurrentOwner, vt = Object.prototype.hasOwnProperty, ds = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Is, Ze;
      function Ys(R) {
        if (vt.call(R, "ref")) {
          var V = Object.getOwnPropertyDescriptor(R, "ref").get;
          if (V && V.isReactWarning)
            return !1;
        }
        return R.ref !== void 0;
      }
      function Nr(R) {
        if (vt.call(R, "key")) {
          var V = Object.getOwnPropertyDescriptor(R, "key").get;
          if (V && V.isReactWarning)
            return !1;
        }
        return R.key !== void 0;
      }
      function Qi(R, V) {
        typeof R.ref == "string" && cs.current;
      }
      function qe(R, V) {
        {
          var z = function() {
            Is || (Is = !0, F("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", V));
          };
          z.isReactWarning = !0, Object.defineProperty(R, "key", {
            get: z,
            configurable: !0
          });
        }
      }
      function ft(R, V) {
        {
          var z = function() {
            Ze || (Ze = !0, F("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", V));
          };
          z.isReactWarning = !0, Object.defineProperty(R, "ref", {
            get: z,
            configurable: !0
          });
        }
      }
      var Ot = function(R, V, z, Y, K, Le, Fe) {
        var Pe = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: i,
          // Built-in properties that belong on the element
          type: R,
          key: V,
          ref: z,
          props: Fe,
          // Record the component responsible for creating this element.
          _owner: Le
        };
        return Pe._store = {}, Object.defineProperty(Pe._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Pe, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Y
        }), Object.defineProperty(Pe, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: K
        }), Object.freeze && (Object.freeze(Pe.props), Object.freeze(Pe)), Pe;
      };
      function Hr(R, V, z, Y, K) {
        {
          var Le, Fe = {}, Pe = null, Ge = null;
          z !== void 0 && (Pe = "" + z), Nr(V) && (Pe = "" + V.key), Ys(V) && (Ge = V.ref, Qi(V, K));
          for (Le in V)
            vt.call(V, Le) && !ds.hasOwnProperty(Le) && (Fe[Le] = V[Le]);
          if (R && R.defaultProps) {
            var ye = R.defaultProps;
            for (Le in ye)
              Fe[Le] === void 0 && (Fe[Le] = ye[Le]);
          }
          if (Pe || Ge) {
            var Ne = typeof R == "function" ? R.displayName || R.name || "Unknown" : R;
            Pe && qe(Fe, Ne), Ge && ft(Fe, Ne);
          }
          return Ot(R, Pe, Ge, K, Y, cs.current, Fe);
        }
      }
      var Ls = T.ReactCurrentOwner, Ii = T.ReactDebugCurrentFrame;
      function At(R) {
        if (R) {
          var V = R._owner, z = Ue(R.type, R._source, V ? V.type : null);
          Ii.setExtraStackFrame(z);
        } else
          Ii.setExtraStackFrame(null);
      }
      var gi;
      gi = !1;
      function Ji(R) {
        return typeof R == "object" && R !== null && R.$$typeof === i;
      }
      function fi() {
        {
          if (Ls.current) {
            var R = J(Ls.current.type);
            if (R)
              return `

Check the render method of \`` + R + "`.";
          }
          return "";
        }
      }
      function En(R) {
        return "";
      }
      var er = {};
      function Dn(R) {
        {
          var V = fi();
          if (!V) {
            var z = typeof R == "string" ? R : R.displayName || R.name;
            z && (V = `

Check the top-level render call using <` + z + ">.");
          }
          return V;
        }
      }
      function zr(R, V) {
        {
          if (!R._store || R._store.validated || R.key != null)
            return;
          R._store.validated = !0;
          var z = Dn(V);
          if (er[z])
            return;
          er[z] = !0;
          var Y = "";
          R && R._owner && R._owner !== Ls.current && (Y = " It was passed a child from " + J(R._owner.type) + "."), At(R), F('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', z, Y), At(null);
        }
      }
      function Wr(R, V) {
        {
          if (typeof R != "object")
            return;
          if (Array.isArray(R))
            for (var z = 0; z < R.length; z++) {
              var Y = R[z];
              Ji(Y) && zr(Y, V);
            }
          else if (Ji(R))
            R._store && (R._store.validated = !0);
          else if (R) {
            var K = M(R);
            if (typeof K == "function" && K !== R.entries)
              for (var Le = K.call(R), Fe; !(Fe = Le.next()).done; )
                Ji(Fe.value) && zr(Fe.value, V);
          }
        }
      }
      function _r(R) {
        {
          var V = R.type;
          if (V == null || typeof V == "string")
            return;
          var z;
          if (typeof V == "function")
            z = V.propTypes;
          else if (typeof V == "object" && (V.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          V.$$typeof === h))
            z = V.propTypes;
          else
            return;
          if (z) {
            var Y = J(V);
            pi(z, R.props, "prop", Y, R);
          } else if (V.PropTypes !== void 0 && !gi) {
            gi = !0;
            var K = J(V);
            F("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", K || "Unknown");
          }
          typeof V.getDefaultProps == "function" && !V.getDefaultProps.isReactClassApproved && F("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Fo(R) {
        {
          for (var V = Object.keys(R.props), z = 0; z < V.length; z++) {
            var Y = V[z];
            if (Y !== "children" && Y !== "key") {
              At(R), F("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Y), At(null);
              break;
            }
          }
          R.ref !== null && (At(R), F("Invalid attribute `ref` supplied to `React.Fragment`."), At(null));
        }
      }
      function Li(R, V, z, Y, K, Le) {
        {
          var Fe = D(R);
          if (!Fe) {
            var Pe = "";
            (R === void 0 || typeof R == "object" && R !== null && Object.keys(R).length === 0) && (Pe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Ge = En();
            Ge ? Pe += Ge : Pe += fi();
            var ye;
            R === null ? ye = "null" : Array.isArray(R) ? ye = "array" : R !== void 0 && R.$$typeof === i ? (ye = "<" + (J(R.type) || "Unknown") + " />", Pe = " Did you accidentally export a JSX literal instead of a component?") : ye = typeof R, F("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ye, Pe);
          }
          var Ne = Hr(R, V, z, K, Le);
          if (Ne == null)
            return Ne;
          if (Fe) {
            var Rt = V.children;
            if (Rt !== void 0)
              if (Y)
                if (Array.isArray(Rt)) {
                  for (var wt = 0; wt < Rt.length; wt++)
                    Wr(Rt[wt], R);
                  Object.freeze && Object.freeze(Rt);
                } else
                  F("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Wr(Rt, R);
          }
          return R === e.Fragment ? Fo(Ne) : _r(Ne), Ne;
        }
      }
      function A(R, V, z) {
        return Li(R, V, z, !0);
      }
      function N(R, V, z) {
        return Li(R, V, z, !1);
      }
      var B = N, se = A;
      e.jsx = B, e.jsxs = se;
    }();
  }($d)), $d;
}
process.env.NODE_ENV === "production" ? Bu.exports = R4() : Bu.exports = F4();
var me = Bu.exports, Ee = function() {
  return Ee = Object.assign || function(t) {
    for (var s, i = 1, r = arguments.length; i < r; i++) {
      s = arguments[i];
      for (var n in s) Object.prototype.hasOwnProperty.call(s, n) && (t[n] = s[n]);
    }
    return t;
  }, Ee.apply(this, arguments);
};
function Us(e, t) {
  var s = {};
  for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (s[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, i = Object.getOwnPropertySymbols(e); r < i.length; r++)
      t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (s[i[r]] = e[i[r]]);
  return s;
}
function P4(e, t, s, i) {
  function r(n) {
    return n instanceof s ? n : new s(function(o) {
      o(n);
    });
  }
  return new (s || (s = Promise))(function(n, o) {
    function a(d) {
      try {
        c(i.next(d));
      } catch (u) {
        o(u);
      }
    }
    function l(d) {
      try {
        c(i.throw(d));
      } catch (u) {
        o(u);
      }
    }
    function c(d) {
      d.done ? n(d.value) : r(d.value).then(a, l);
    }
    c((i = i.apply(e, t || [])).next());
  });
}
function T4(e, t) {
  var s = { label: 0, sent: function() {
    if (n[0] & 1) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, i, r, n, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(c) {
    return function(d) {
      return l([c, d]);
    };
  }
  function l(c) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, c[0] && (s = 0)), s; ) try {
      if (i = 1, r && (n = c[0] & 2 ? r.return : c[0] ? r.throw || ((n = r.return) && n.call(r), 0) : r.next) && !(n = n.call(r, c[1])).done) return n;
      switch (r = 0, n && (c = [c[0] & 2, n.value]), c[0]) {
        case 0:
        case 1:
          n = c;
          break;
        case 4:
          return s.label++, { value: c[1], done: !1 };
        case 5:
          s.label++, r = c[1], c = [0];
          continue;
        case 7:
          c = s.ops.pop(), s.trys.pop();
          continue;
        default:
          if (n = s.trys, !(n = n.length > 0 && n[n.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            s = 0;
            continue;
          }
          if (c[0] === 3 && (!n || c[1] > n[0] && c[1] < n[3])) {
            s.label = c[1];
            break;
          }
          if (c[0] === 6 && s.label < n[1]) {
            s.label = n[1], n = c;
            break;
          }
          if (n && s.label < n[2]) {
            s.label = n[2], s.ops.push(c);
            break;
          }
          n[2] && s.ops.pop(), s.trys.pop();
          continue;
      }
      c = t.call(e, s);
    } catch (d) {
      c = [6, d], r = 0;
    } finally {
      i = n = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function E4(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, s = t && e[t], i = 0;
  if (s) return s.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && i >= e.length && (e = void 0), { value: e && e[i++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function As(e, t) {
  var s = typeof Symbol == "function" && e[Symbol.iterator];
  if (!s) return e;
  var i = s.call(e), r, n = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = i.next()).done; ) n.push(r.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      r && !r.done && (s = i.return) && s.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return n;
}
function Ar(e, t, s) {
  if (s || arguments.length === 2) for (var i = 0, r = t.length, n; i < r; i++)
    (n || !(i in t)) && (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
  return e.concat(n || Array.prototype.slice.call(t));
}
function D4(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
function A4() {
  this.__data__ = [], this.size = 0;
}
var M4 = A4;
function I4(e, t) {
  return e === t || e !== e && t !== t;
}
var Pa = I4, L4 = Pa;
function k4(e, t) {
  for (var s = e.length; s--; )
    if (L4(e[s][0], t))
      return s;
  return -1;
}
var Oc = k4, O4 = Oc, G4 = Array.prototype, B4 = G4.splice;
function V4(e) {
  var t = this.__data__, s = O4(t, e);
  if (s < 0)
    return !1;
  var i = t.length - 1;
  return s == i ? t.pop() : B4.call(t, s, 1), --this.size, !0;
}
var N4 = V4, H4 = Oc;
function z4(e) {
  var t = this.__data__, s = H4(t, e);
  return s < 0 ? void 0 : t[s][1];
}
var W4 = z4, _4 = Oc;
function U4(e) {
  return _4(this.__data__, e) > -1;
}
var $4 = U4, j4 = Oc;
function K4(e, t) {
  var s = this.__data__, i = j4(s, e);
  return i < 0 ? (++this.size, s.push([e, t])) : s[i][1] = t, this;
}
var q4 = K4, Y4 = M4, X4 = N4, Z4 = W4, Q4 = $4, J4 = q4;
function go(e) {
  var t = -1, s = e == null ? 0 : e.length;
  for (this.clear(); ++t < s; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
go.prototype.clear = Y4;
go.prototype.delete = X4;
go.prototype.get = Z4;
go.prototype.has = Q4;
go.prototype.set = J4;
var Gc = go, e5 = Gc;
function t5() {
  this.__data__ = new e5(), this.size = 0;
}
var s5 = t5;
function i5(e) {
  var t = this.__data__, s = t.delete(e);
  return this.size = t.size, s;
}
var r5 = i5;
function n5(e) {
  return this.__data__.get(e);
}
var o5 = n5;
function a5(e) {
  return this.__data__.has(e);
}
var l5 = a5, c5 = typeof il == "object" && il && il.Object === Object && il, mx = c5, d5 = mx, u5 = typeof self == "object" && self && self.Object === Object && self, h5 = d5 || u5 || Function("return this")(), Di = h5, p5 = Di, g5 = p5.Symbol, fo = g5, xm = fo, Cx = Object.prototype, f5 = Cx.hasOwnProperty, m5 = Cx.toString, Vo = xm ? xm.toStringTag : void 0;
function C5(e) {
  var t = f5.call(e, Vo), s = e[Vo];
  try {
    e[Vo] = void 0;
    var i = !0;
  } catch {
  }
  var r = m5.call(e);
  return i && (t ? e[Vo] = s : delete e[Vo]), r;
}
var v5 = C5, w5 = Object.prototype, y5 = w5.toString;
function b5(e) {
  return y5.call(e);
}
var S5 = b5, Rm = fo, x5 = v5, R5 = S5, F5 = "[object Null]", P5 = "[object Undefined]", Fm = Rm ? Rm.toStringTag : void 0;
function T5(e) {
  return e == null ? e === void 0 ? P5 : F5 : Fm && Fm in Object(e) ? x5(e) : R5(e);
}
var mo = T5;
function E5(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ai = E5;
const D5 = /* @__PURE__ */ di(Ai);
var A5 = mo, M5 = Ai, I5 = "[object AsyncFunction]", L5 = "[object Function]", k5 = "[object GeneratorFunction]", O5 = "[object Proxy]";
function G5(e) {
  if (!M5(e))
    return !1;
  var t = A5(e);
  return t == L5 || t == k5 || t == I5 || t == O5;
}
var bp = G5, B5 = Di, V5 = B5["__core-js_shared__"], N5 = V5, jd = N5, Pm = function() {
  var e = /[^.]+$/.exec(jd && jd.keys && jd.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function H5(e) {
  return !!Pm && Pm in e;
}
var z5 = H5, W5 = Function.prototype, _5 = W5.toString;
function U5(e) {
  if (e != null) {
    try {
      return _5.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var vx = U5, $5 = bp, j5 = z5, K5 = Ai, q5 = vx, Y5 = /[\\^$.*+?()[\]{}|]/g, X5 = /^\[object .+?Constructor\]$/, Z5 = Function.prototype, Q5 = Object.prototype, J5 = Z5.toString, eK = Q5.hasOwnProperty, tK = RegExp(
  "^" + J5.call(eK).replace(Y5, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function sK(e) {
  if (!K5(e) || j5(e))
    return !1;
  var t = $5(e) ? tK : X5;
  return t.test(q5(e));
}
var iK = sK;
function rK(e, t) {
  return e == null ? void 0 : e[t];
}
var nK = rK, oK = iK, aK = nK;
function lK(e, t) {
  var s = aK(e, t);
  return oK(s) ? s : void 0;
}
var Tn = lK, cK = Tn, dK = Di, uK = cK(dK, "Map"), Sp = uK, hK = Tn, pK = hK(Object, "create"), Bc = pK, Tm = Bc;
function gK() {
  this.__data__ = Tm ? Tm(null) : {}, this.size = 0;
}
var fK = gK;
function mK(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var CK = mK, vK = Bc, wK = "__lodash_hash_undefined__", yK = Object.prototype, bK = yK.hasOwnProperty;
function SK(e) {
  var t = this.__data__;
  if (vK) {
    var s = t[e];
    return s === wK ? void 0 : s;
  }
  return bK.call(t, e) ? t[e] : void 0;
}
var xK = SK, RK = Bc, FK = Object.prototype, PK = FK.hasOwnProperty;
function TK(e) {
  var t = this.__data__;
  return RK ? t[e] !== void 0 : PK.call(t, e);
}
var EK = TK, DK = Bc, AK = "__lodash_hash_undefined__";
function MK(e, t) {
  var s = this.__data__;
  return this.size += this.has(e) ? 0 : 1, s[e] = DK && t === void 0 ? AK : t, this;
}
var IK = MK, LK = fK, kK = CK, OK = xK, GK = EK, BK = IK;
function Co(e) {
  var t = -1, s = e == null ? 0 : e.length;
  for (this.clear(); ++t < s; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
Co.prototype.clear = LK;
Co.prototype.delete = kK;
Co.prototype.get = OK;
Co.prototype.has = GK;
Co.prototype.set = BK;
var VK = Co, Em = VK, NK = Gc, HK = Sp;
function zK() {
  this.size = 0, this.__data__ = {
    hash: new Em(),
    map: new (HK || NK)(),
    string: new Em()
  };
}
var WK = zK;
function _K(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var UK = _K, $K = UK;
function jK(e, t) {
  var s = e.__data__;
  return $K(t) ? s[typeof t == "string" ? "string" : "hash"] : s.map;
}
var Vc = jK, KK = Vc;
function qK(e) {
  var t = KK(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var YK = qK, XK = Vc;
function ZK(e) {
  return XK(this, e).get(e);
}
var QK = ZK, JK = Vc;
function e6(e) {
  return JK(this, e).has(e);
}
var t6 = e6, s6 = Vc;
function i6(e, t) {
  var s = s6(this, e), i = s.size;
  return s.set(e, t), this.size += s.size == i ? 0 : 1, this;
}
var r6 = i6, n6 = WK, o6 = YK, a6 = QK, l6 = t6, c6 = r6;
function vo(e) {
  var t = -1, s = e == null ? 0 : e.length;
  for (this.clear(); ++t < s; ) {
    var i = e[t];
    this.set(i[0], i[1]);
  }
}
vo.prototype.clear = n6;
vo.prototype.delete = o6;
vo.prototype.get = a6;
vo.prototype.has = l6;
vo.prototype.set = c6;
var xp = vo, d6 = Gc, u6 = Sp, h6 = xp, p6 = 200;
function g6(e, t) {
  var s = this.__data__;
  if (s instanceof d6) {
    var i = s.__data__;
    if (!u6 || i.length < p6 - 1)
      return i.push([e, t]), this.size = ++s.size, this;
    s = this.__data__ = new h6(i);
  }
  return s.set(e, t), this.size = s.size, this;
}
var f6 = g6, m6 = Gc, C6 = s5, v6 = r5, w6 = o5, y6 = l5, b6 = f6;
function wo(e) {
  var t = this.__data__ = new m6(e);
  this.size = t.size;
}
wo.prototype.clear = C6;
wo.prototype.delete = v6;
wo.prototype.get = w6;
wo.prototype.has = y6;
wo.prototype.set = b6;
var Rp = wo, S6 = "__lodash_hash_undefined__";
function x6(e) {
  return this.__data__.set(e, S6), this;
}
var R6 = x6;
function F6(e) {
  return this.__data__.has(e);
}
var P6 = F6, T6 = xp, E6 = R6, D6 = P6;
function Yl(e) {
  var t = -1, s = e == null ? 0 : e.length;
  for (this.__data__ = new T6(); ++t < s; )
    this.add(e[t]);
}
Yl.prototype.add = Yl.prototype.push = E6;
Yl.prototype.has = D6;
var A6 = Yl;
function M6(e, t) {
  for (var s = -1, i = e == null ? 0 : e.length; ++s < i; )
    if (t(e[s], s, e))
      return !0;
  return !1;
}
var I6 = M6;
function L6(e, t) {
  return e.has(t);
}
var k6 = L6, O6 = A6, G6 = I6, B6 = k6, V6 = 1, N6 = 2;
function H6(e, t, s, i, r, n) {
  var o = s & V6, a = e.length, l = t.length;
  if (a != l && !(o && l > a))
    return !1;
  var c = n.get(e), d = n.get(t);
  if (c && d)
    return c == t && d == e;
  var u = -1, h = !0, p = s & N6 ? new O6() : void 0;
  for (n.set(e, t), n.set(t, e); ++u < a; ) {
    var g = e[u], f = t[u];
    if (i)
      var m = o ? i(f, g, u, t, e, n) : i(g, f, u, e, t, n);
    if (m !== void 0) {
      if (m)
        continue;
      h = !1;
      break;
    }
    if (p) {
      if (!G6(t, function(C, w) {
        if (!B6(p, w) && (g === C || r(g, C, s, i, n)))
          return p.push(w);
      })) {
        h = !1;
        break;
      }
    } else if (!(g === f || r(g, f, s, i, n))) {
      h = !1;
      break;
    }
  }
  return n.delete(e), n.delete(t), h;
}
var wx = H6, z6 = Di, W6 = z6.Uint8Array, yx = W6;
function _6(e) {
  var t = -1, s = Array(e.size);
  return e.forEach(function(i, r) {
    s[++t] = [r, i];
  }), s;
}
var U6 = _6;
function $6(e) {
  var t = -1, s = Array(e.size);
  return e.forEach(function(i) {
    s[++t] = i;
  }), s;
}
var j6 = $6, Dm = fo, Am = yx, K6 = Pa, q6 = wx, Y6 = U6, X6 = j6, Z6 = 1, Q6 = 2, J6 = "[object Boolean]", e7 = "[object Date]", t7 = "[object Error]", s7 = "[object Map]", i7 = "[object Number]", r7 = "[object RegExp]", n7 = "[object Set]", o7 = "[object String]", a7 = "[object Symbol]", l7 = "[object ArrayBuffer]", c7 = "[object DataView]", Mm = Dm ? Dm.prototype : void 0, Kd = Mm ? Mm.valueOf : void 0;
function d7(e, t, s, i, r, n, o) {
  switch (s) {
    case c7:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case l7:
      return !(e.byteLength != t.byteLength || !n(new Am(e), new Am(t)));
    case J6:
    case e7:
    case i7:
      return K6(+e, +t);
    case t7:
      return e.name == t.name && e.message == t.message;
    case r7:
    case o7:
      return e == t + "";
    case s7:
      var a = Y6;
    case n7:
      var l = i & Z6;
      if (a || (a = X6), e.size != t.size && !l)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      i |= Q6, o.set(e, t);
      var d = q6(a(e), a(t), i, r, n, o);
      return o.delete(e), d;
    case a7:
      if (Kd)
        return Kd.call(e) == Kd.call(t);
  }
  return !1;
}
var u7 = d7;
function h7(e, t) {
  for (var s = -1, i = t.length, r = e.length; ++s < i; )
    e[r + s] = t[s];
  return e;
}
var Fp = h7, p7 = Array.isArray, ui = p7;
const g7 = /* @__PURE__ */ di(ui);
var f7 = Fp, m7 = ui;
function C7(e, t, s) {
  var i = t(e);
  return m7(e) ? i : f7(i, s(e));
}
var bx = C7;
function v7(e, t) {
  for (var s = -1, i = e == null ? 0 : e.length, r = 0, n = []; ++s < i; ) {
    var o = e[s];
    t(o, s, e) && (n[r++] = o);
  }
  return n;
}
var w7 = v7;
function y7() {
  return [];
}
var Sx = y7, b7 = w7, S7 = Sx, x7 = Object.prototype, R7 = x7.propertyIsEnumerable, Im = Object.getOwnPropertySymbols, F7 = Im ? function(e) {
  return e == null ? [] : (e = Object(e), b7(Im(e), function(t) {
    return R7.call(e, t);
  }));
} : S7, Pp = F7;
function P7(e, t) {
  for (var s = -1, i = Array(e); ++s < e; )
    i[s] = t(s);
  return i;
}
var T7 = P7;
function E7(e) {
  return e != null && typeof e == "object";
}
var Zi = E7, D7 = mo, A7 = Zi, M7 = "[object Arguments]";
function I7(e) {
  return A7(e) && D7(e) == M7;
}
var L7 = I7, Lm = L7, k7 = Zi, xx = Object.prototype, O7 = xx.hasOwnProperty, G7 = xx.propertyIsEnumerable, B7 = Lm(/* @__PURE__ */ function() {
  return arguments;
}()) ? Lm : function(e) {
  return k7(e) && O7.call(e, "callee") && !G7.call(e, "callee");
}, Nc = B7, Xl = { exports: {} };
function V7() {
  return !1;
}
var N7 = V7;
Xl.exports;
(function(e, t) {
  var s = Di, i = N7, r = t && !t.nodeType && t, n = r && !0 && e && !e.nodeType && e, o = n && n.exports === r, a = o ? s.Buffer : void 0, l = a ? a.isBuffer : void 0, c = l || i;
  e.exports = c;
})(Xl, Xl.exports);
var Ta = Xl.exports, H7 = 9007199254740991, z7 = /^(?:0|[1-9]\d*)$/;
function W7(e, t) {
  var s = typeof e;
  return t = t ?? H7, !!t && (s == "number" || s != "symbol" && z7.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Tp = W7, _7 = 9007199254740991;
function U7(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= _7;
}
var Rx = U7, $7 = mo, j7 = Rx, K7 = Zi, q7 = "[object Arguments]", Y7 = "[object Array]", X7 = "[object Boolean]", Z7 = "[object Date]", Q7 = "[object Error]", J7 = "[object Function]", e8 = "[object Map]", t8 = "[object Number]", s8 = "[object Object]", i8 = "[object RegExp]", r8 = "[object Set]", n8 = "[object String]", o8 = "[object WeakMap]", a8 = "[object ArrayBuffer]", l8 = "[object DataView]", c8 = "[object Float32Array]", d8 = "[object Float64Array]", u8 = "[object Int8Array]", h8 = "[object Int16Array]", p8 = "[object Int32Array]", g8 = "[object Uint8Array]", f8 = "[object Uint8ClampedArray]", m8 = "[object Uint16Array]", C8 = "[object Uint32Array]", lt = {};
lt[c8] = lt[d8] = lt[u8] = lt[h8] = lt[p8] = lt[g8] = lt[f8] = lt[m8] = lt[C8] = !0;
lt[q7] = lt[Y7] = lt[a8] = lt[X7] = lt[l8] = lt[Z7] = lt[Q7] = lt[J7] = lt[e8] = lt[t8] = lt[s8] = lt[i8] = lt[r8] = lt[n8] = lt[o8] = !1;
function v8(e) {
  return K7(e) && j7(e.length) && !!lt[$7(e)];
}
var w8 = v8;
function y8(e) {
  return function(t) {
    return e(t);
  };
}
var Ep = y8, Zl = { exports: {} };
Zl.exports;
(function(e, t) {
  var s = mx, i = t && !t.nodeType && t, r = i && !0 && e && !e.nodeType && e, n = r && r.exports === i, o = n && s.process, a = function() {
    try {
      var l = r && r.require && r.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = a;
})(Zl, Zl.exports);
var Dp = Zl.exports, b8 = w8, S8 = Ep, km = Dp, Om = km && km.isTypedArray, x8 = Om ? S8(Om) : b8, Hc = x8, R8 = T7, F8 = Nc, P8 = ui, T8 = Ta, E8 = Tp, D8 = Hc, A8 = Object.prototype, M8 = A8.hasOwnProperty;
function I8(e, t) {
  var s = P8(e), i = !s && F8(e), r = !s && !i && T8(e), n = !s && !i && !r && D8(e), o = s || i || r || n, a = o ? R8(e.length, String) : [], l = a.length;
  for (var c in e)
    (t || M8.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    n && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    E8(c, l))) && a.push(c);
  return a;
}
var Fx = I8, L8 = Object.prototype;
function k8(e) {
  var t = e && e.constructor, s = typeof t == "function" && t.prototype || L8;
  return e === s;
}
var zc = k8;
function O8(e, t) {
  return function(s) {
    return e(t(s));
  };
}
var Px = O8, G8 = Px, B8 = G8(Object.keys, Object), V8 = B8, N8 = zc, H8 = V8, z8 = Object.prototype, W8 = z8.hasOwnProperty;
function _8(e) {
  if (!N8(e))
    return H8(e);
  var t = [];
  for (var s in Object(e))
    W8.call(e, s) && s != "constructor" && t.push(s);
  return t;
}
var Tx = _8, U8 = bp, $8 = Rx;
function j8(e) {
  return e != null && $8(e.length) && !U8(e);
}
var yo = j8;
const K8 = /* @__PURE__ */ di(yo);
var q8 = Fx, Y8 = Tx, X8 = yo;
function Z8(e) {
  return X8(e) ? q8(e) : Y8(e);
}
var Ap = Z8, Q8 = bx, J8 = Pp, e9 = Ap;
function t9(e) {
  return Q8(e, e9, J8);
}
var Ex = t9, Gm = Ex, s9 = 1, i9 = Object.prototype, r9 = i9.hasOwnProperty;
function n9(e, t, s, i, r, n) {
  var o = s & s9, a = Gm(e), l = a.length, c = Gm(t), d = c.length;
  if (l != d && !o)
    return !1;
  for (var u = l; u--; ) {
    var h = a[u];
    if (!(o ? h in t : r9.call(t, h)))
      return !1;
  }
  var p = n.get(e), g = n.get(t);
  if (p && g)
    return p == t && g == e;
  var f = !0;
  n.set(e, t), n.set(t, e);
  for (var m = o; ++u < l; ) {
    h = a[u];
    var C = e[h], w = t[h];
    if (i)
      var y = o ? i(w, C, h, t, e, n) : i(C, w, h, e, t, n);
    if (!(y === void 0 ? C === w || r(C, w, s, i, n) : y)) {
      f = !1;
      break;
    }
    m || (m = h == "constructor");
  }
  if (f && !m) {
    var b = e.constructor, x = t.constructor;
    b != x && "constructor" in e && "constructor" in t && !(typeof b == "function" && b instanceof b && typeof x == "function" && x instanceof x) && (f = !1);
  }
  return n.delete(e), n.delete(t), f;
}
var o9 = n9, a9 = Tn, l9 = Di, c9 = a9(l9, "DataView"), d9 = c9, u9 = Tn, h9 = Di, p9 = u9(h9, "Promise"), g9 = p9, f9 = Tn, m9 = Di, C9 = f9(m9, "Set"), v9 = C9, w9 = Tn, y9 = Di, b9 = w9(y9, "WeakMap"), S9 = b9, Vu = d9, Nu = Sp, Hu = g9, zu = v9, Wu = S9, Dx = mo, bo = vx, Bm = "[object Map]", x9 = "[object Object]", Vm = "[object Promise]", Nm = "[object Set]", Hm = "[object WeakMap]", zm = "[object DataView]", R9 = bo(Vu), F9 = bo(Nu), P9 = bo(Hu), T9 = bo(zu), E9 = bo(Wu), Qr = Dx;
(Vu && Qr(new Vu(new ArrayBuffer(1))) != zm || Nu && Qr(new Nu()) != Bm || Hu && Qr(Hu.resolve()) != Vm || zu && Qr(new zu()) != Nm || Wu && Qr(new Wu()) != Hm) && (Qr = function(e) {
  var t = Dx(e), s = t == x9 ? e.constructor : void 0, i = s ? bo(s) : "";
  if (i)
    switch (i) {
      case R9:
        return zm;
      case F9:
        return Bm;
      case P9:
        return Vm;
      case T9:
        return Nm;
      case E9:
        return Hm;
    }
  return t;
});
var Ea = Qr, qd = Rp, D9 = wx, A9 = u7, M9 = o9, Wm = Ea, _m = ui, Um = Ta, I9 = Hc, L9 = 1, $m = "[object Arguments]", jm = "[object Array]", rl = "[object Object]", k9 = Object.prototype, Km = k9.hasOwnProperty;
function O9(e, t, s, i, r, n) {
  var o = _m(e), a = _m(t), l = o ? jm : Wm(e), c = a ? jm : Wm(t);
  l = l == $m ? rl : l, c = c == $m ? rl : c;
  var d = l == rl, u = c == rl, h = l == c;
  if (h && Um(e)) {
    if (!Um(t))
      return !1;
    o = !0, d = !1;
  }
  if (h && !d)
    return n || (n = new qd()), o || I9(e) ? D9(e, t, s, i, r, n) : A9(e, t, l, s, i, r, n);
  if (!(s & L9)) {
    var p = d && Km.call(e, "__wrapped__"), g = u && Km.call(t, "__wrapped__");
    if (p || g) {
      var f = p ? e.value() : e, m = g ? t.value() : t;
      return n || (n = new qd()), r(f, m, s, i, n);
    }
  }
  return h ? (n || (n = new qd()), M9(e, t, s, i, r, n)) : !1;
}
var G9 = O9, B9 = G9, qm = Zi;
function Ax(e, t, s, i, r) {
  return e === t ? !0 : e == null || t == null || !qm(e) && !qm(t) ? e !== e && t !== t : B9(e, t, s, i, Ax, r);
}
var V9 = Ax, N9 = V9;
function H9(e, t) {
  return N9(e, t);
}
var z9 = H9;
const Mx = /* @__PURE__ */ di(z9);
function W9(e) {
  return e == null;
}
var _9 = W9;
const Pi = /* @__PURE__ */ di(_9);
var U9 = {
  name: "cellEditorField",
  autoFocus: !0,
  showHelperTextInTooltip: !0
};
function $9(e) {
  var t = e.initialValue, s = e.parseValue, i = e.eventKey;
  return i === "Backspace" || i === "Delete" ? null : i === "Enter" || Pi(i) ? t : s(i);
}
function So(e) {
  var t = e.validate, s = e.validationSchema, i = e.initialValue, r = e.onValueChange, n = e.parseValue, o = e.eventKey, a = Te(function() {
    return $9({ initialValue: i, parseValue: n, eventKey: o });
  }, [o, i, n]), l = tP({
    validate: t,
    validationSchema: s,
    initialValues: { cellEditorField: a },
    enableReinitialize: !0,
    validateOnChange: !0,
    onSubmit: function(f) {
      r(f.cellEditorField);
    }
  }), c = l.handleSubmit, d = l.values, u = l.dirty, h = l.initialValues, p = l.submitCount, g = l.isValid;
  return Wt(function() {
    p === 0 && h.cellEditorField !== i && c();
  }, [h, c, i, p]), Wt(function() {
    u && d.cellEditorField !== h.cellEditorField && (g ? c() : r(i));
  }, [c, d, u, h, g, r, i]), {
    formik: l,
    fieldProps: U9
  };
}
function tre(e) {
  var t, s = e.initialValue, i = e.onValueChange, r = e.validate, n = e.validationSchema, o = e.eventKey, a = e.parseValue, l = e.TextFieldProps, c = l === void 0 ? {} : l, d = Us(e, ["initialValue", "onValueChange", "validate", "validationSchema", "eventKey", "parseValue", "TextFieldProps"]), u = So({
    initialValue: s,
    onValueChange: i,
    validate: r,
    validationSchema: n,
    eventKey: o,
    parseValue: a
  }), h = u.formik, p = u.fieldProps, g = p.autoFocus, f = Us(p, ["autoFocus"]);
  return /* @__PURE__ */ me.jsx(ro, { value: h, children: /* @__PURE__ */ me.jsx(YF, { size: "extraSmall", isOptionEqualToValue: Mx, TextFieldProps: Ee(Ee({}, c), { InputProps: Ee({ autoFocus: g }, (t = c.InputProps) !== null && t !== void 0 ? t : {}) }), ...f, ...d }) });
}
function sre(e) {
  var t, s = e.onValueChange, i = e.initialValue, r = e.validate, n = e.validationSchema, o = e.eventKey, a = e.parseValue, l = e.TextFieldProps, c = l === void 0 ? {} : l, d = Us(e, ["onValueChange", "initialValue", "validate", "validationSchema", "eventKey", "parseValue", "TextFieldProps"]), u = So({
    initialValue: i,
    onValueChange: s,
    validate: r,
    validationSchema: n,
    eventKey: o,
    parseValue: a
  }), h = u.formik, p = u.fieldProps, g = p.autoFocus, f = Us(p, ["autoFocus"]);
  return /* @__PURE__ */ me.jsx(ro, { value: h, children: /* @__PURE__ */ me.jsx(XF, { size: "extraSmall", isOptionEqualToValue: Mx, TextFieldProps: Ee(Ee({}, c), { InputProps: Ee({ autoFocus: g }, (t = c.InputProps) !== null && t !== void 0 ? t : {}) }), ...f, ...d }) });
}
var j9 = function(e) {
  var t = e.onValueChange, s = e.parseValue, i = e.eventKey, r = e.initialValue, n = e.validate, o = e.validationSchema, a = Us(e, ["onValueChange", "parseValue", "eventKey", "initialValue", "validate", "validationSchema"]), l = So({
    initialValue: r,
    onValueChange: t,
    validate: n,
    validationSchema: o,
    eventKey: i,
    parseValue: s
  }), c = l.formik, d = l.fieldProps;
  return /* @__PURE__ */ me.jsx(ro, { value: c, children: /* @__PURE__ */ me.jsx(ZF, { size: "extraSmall", ...d, ...a, hiddenLabel: !0 }) });
}, ire = function(e, t) {
  var s = e.onValueChange, i = e.initialValue, r = e.validate, n = e.validationSchema, o = e.eventKey, a = e.parseValue, l = Us(e, ["onValueChange", "initialValue", "validate", "validationSchema", "eventKey", "parseValue"]), c = So({
    initialValue: i,
    onValueChange: s,
    validate: r,
    validationSchema: n,
    eventKey: o,
    parseValue: a
  }), d = c.formik, u = c.fieldProps;
  return /* @__PURE__ */ me.jsx(ro, { value: d, children: /* @__PURE__ */ me.jsx(QF, { size: "extraSmall", ...u, ...l, hiddenLabel: !0 }) });
};
function K9(e) {
  var t = e.onValueChange, s = e.initialValue, i = e.validate, r = e.validationSchema, n = e.eventKey, o = e.parseValue;
  e.ref;
  var a = e.SelectProps, l = Us(e, ["onValueChange", "initialValue", "validate", "validationSchema", "eventKey", "parseValue", "ref", "SelectProps"]), c = So({
    initialValue: s,
    onValueChange: t,
    validate: i,
    validationSchema: r,
    eventKey: n,
    parseValue: o
  }), d = c.formik, u = c.fieldProps, h = Te(function() {
    return Ee(Ee({
      // Select needs to be opened when rendered
      defaultOpen: !0
    }, a), { MenuProps: Ee(Ee({}, a == null ? void 0 : a.MenuProps), {
      /**
       * Avoid stop editing when opening Menu component as Popup
       * https://www.ag-grid.com/javascript-data-grid/component-filter/#custom-filters-containing-a-popup-element
       */
      className: "ag-custom-component-popup"
    }) });
  }, [a]);
  return /* @__PURE__ */ me.jsx(ro, { value: d, children: /* @__PURE__ */ me.jsx(JF, { size: "extraSmall", ...u, ...l, SelectProps: h, hiddenLabel: !0 }) });
}
var Ym = function(e) {
  var t = e.onValueChange, s = e.initialValue, i = e.validate, r = e.validationSchema, n = e.eventKey, o = e.parseValue, a = Us(e, ["onValueChange", "initialValue", "validate", "validationSchema", "eventKey", "parseValue"]), l = So({
    initialValue: s,
    onValueChange: t,
    validate: i,
    validationSchema: r,
    eventKey: n,
    parseValue: o
  }), c = l.formik, d = l.fieldProps;
  return /* @__PURE__ */ me.jsx(ro, { value: c, children: /* @__PURE__ */ me.jsx(eP, { size: "extraSmall", ...a, ...d, hiddenLabel: !0 }) });
}, q9 = {
  agNumberCellEditor: function(e) {
    var t = e.initialValue, s = e.onValueChange, i = e.parseValue, r = e.eventKey, n = e.validationSchema, o = e.validate;
    return /* @__PURE__ */ me.jsx(j9, { initialValue: t, onValueChange: s, parseValue: i, eventKey: r, validationSchema: n, validate: o });
  },
  agTextCellEditor: function(e) {
    var t = e.initialValue, s = e.onValueChange, i = e.parseValue, r = e.eventKey, n = e.validationSchema, o = e.validate;
    return /* @__PURE__ */ me.jsx(Ym, { initialValue: t, onValueChange: s, parseValue: i, eventKey: r, validationSchema: n, validate: o });
  },
  agLargeTextCellEditor: function(e) {
    var t = e.initialValue, s = e.onValueChange, i = e.parseValue, r = e.eventKey, n = e.validationSchema, o = e.validate;
    return /* @__PURE__ */ me.jsx(Ym, { multiline: !0, initialValue: t, onValueChange: s, parseValue: i, eventKey: r, validationSchema: n, validate: o });
  },
  agSelectCellEditor: function(e) {
    var t = e.initialValue, s = e.onValueChange, i = e.values, r = e.parseValue, n = e.eventKey, o = e.validationSchema, a = e.validate;
    return /* @__PURE__ */ me.jsx(K9, { options: i.map(function(l) {
      return { label: l, value: l };
    }), initialValue: t, onValueChange: s, parseValue: r, eventKey: n, validationSchema: o, validate: a });
  }
}, Y9 = function(e) {
  var t = e.data, s = e.value, i = e.valueFormatted, r = e.getStatusColor;
  return s ? /* @__PURE__ */ me.jsx(Zu, { display: "flex", alignItems: "center", height: "100%", children: /* @__PURE__ */ me.jsx(sP, { color: r(s, t), label: i ?? s.toString(), slotProps: {
    label: { variant: "body2" }
  } }) }) : /* @__PURE__ */ me.jsx(Xu, { variant: "body2", component: "span", children: i });
}, rre = q.forwardRef(function(e, t) {
  var s, i, r = e.iconProps, n = e.tooltipProps, o = e.valueFormatted, a = e.secondaryText;
  return !a && !r && !n ? /* @__PURE__ */ me.jsx(Zu, { height: "100%", alignContent: "center", textAlign: "right", children: o }) : /* @__PURE__ */ me.jsxs(vl, { direction: "row", flex: 1, alignItems: "center", justifyContent: "end", gap: 1, height: "100%", children: [
    n && /* @__PURE__ */ me.jsx(VC, { ...n, ref: t, children: /* @__PURE__ */ me.jsx(Bg, { role: "img", fontSize: "small", color: "error", ...r, children: (s = r == null ? void 0 : r.children) !== null && s !== void 0 ? s : /* @__PURE__ */ me.jsx(Qd, {}) }) }),
    !n && r && /* @__PURE__ */ me.jsx(Bg, { role: "img", fontSize: "small", color: "error", ...r, children: (i = r.children) !== null && i !== void 0 ? i : /* @__PURE__ */ me.jsx(Qd, {}) }),
    /* @__PURE__ */ me.jsxs(vl, { flex: 1, textAlign: "right", lineHeight: 1, children: [
      o,
      /* @__PURE__ */ me.jsx(Xu, { component: "span", variant: "caption", children: a })
    ] })
  ] });
}), X9 = function(e) {
  var t = e.severity;
  return t === "NONE" ? null : t === "INFO" ? /* @__PURE__ */ me.jsx(iP, { fontSize: "small", color: "info" }) : t === "ERROR" ? /* @__PURE__ */ me.jsx(Qd, { fontSize: "small", color: "error" }) : /* @__PURE__ */ me.jsx(rP, { fontSize: "small", color: "warning" });
}, Z9 = function(e) {
  var t = e.data, s = e.value;
  return !t || !s || s.severity === "NONE" ? null : /* @__PURE__ */ me.jsx(Zu, { display: "flex", alignItems: "center", height: "100%", children: /* @__PURE__ */ me.jsx(X9, { severity: s.severity }) });
}, Q9 = {
  rowAlertCellRenderer: Z9,
  dotStatusCellRenderer: Y9
}, nre = {
  AnimateShowChangeCellRenderer: "agAnimateShowChangeCellRenderer",
  GroupCellRenderer: "agGroupCellRenderer",
  RowAlertCellRenderer: "rowAlertCellRenderer",
  DotStatusCellRenderer: "dotStatusCellRenderer"
}, Zt = q.createContext({}), Da = (e, t, s, i) => {
  if (!e || e.componentFromFramework || t.isDestroyed())
    return;
  const n = e.newAgStackInstance();
  let o, a, l = !1;
  return n.then((c) => {
    if (l) {
      t.destroyBean(c);
      return;
    }
    o = c, a = o.getGui(), s.appendChild(a), Xm(i, o);
  }), () => {
    var c;
    l = !0, o && ((c = a == null ? void 0 : a.parentElement) == null || c.removeChild(a), t.destroyBean(o), i && Xm(i, void 0));
  };
}, Xm = (e, t) => {
  if (e)
    if (e instanceof Function)
      e(t);
    else {
      const s = e;
      s.current = t;
    }
}, Js = (...e) => e.filter((s) => s != null && s !== "").join(" "), Hs = class Ix {
  constructor(...t) {
    this.classesMap = {}, t.forEach((s) => {
      this.classesMap[s] = !0;
    });
  }
  setClass(t, s) {
    if (!!this.classesMap[t] == s)
      return this;
    const r = new Ix();
    return r.classesMap = { ...this.classesMap }, r.classesMap[t] = s, r;
  }
  toString() {
    return Object.keys(this.classesMap).filter((s) => this.classesMap[s]).join(" ");
  }
}, xo = (e) => {
  const t = () => typeof Symbol == "function" && Symbol.for, s = () => t() ? Symbol.for("react.memo") : 60115;
  return typeof e == "function" && !(e.prototype && e.prototype.isReactComponent) || typeof e == "object" && e.$$typeof === s();
}, GC, _u = (GC = q.version) == null ? void 0 : GC.split(".")[0], J9 = _u === "16" || _u === "17";
function eq() {
  return _u === "19";
}
var ml = !1;
function tq(e) {
  return ml || setTimeout(() => ml = !1, 0), ml = !0, e();
}
var Mp = (e, t) => {
  !J9 && e && !ml ? gP.flushSync(t) : t();
};
function Ip(e, t, s) {
  if (t == null || e == null)
    return t;
  if (e === t || t.length === 0 && e.length === 0)
    return e;
  if (s || e.length === 0 && t.length > 0 || e.length > 0 && t.length === 0)
    return t;
  const i = [], r = [], n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  for (let a = 0; a < t.length; a++) {
    const l = t[a];
    o.set(l.instanceId, l);
  }
  for (let a = 0; a < e.length; a++) {
    const l = e[a];
    n.set(l.instanceId, l), o.has(l.instanceId) && i.push(l);
  }
  for (let a = 0; a < t.length; a++) {
    const l = t[a], c = l.instanceId;
    n.has(c) || r.push(l);
  }
  return i.length === e.length && r.length === 0 ? e : i.length === 0 && r.length === t.length ? t : i.length === 0 ? r : r.length === 0 ? i : [...i, ...r];
}
var Lx = qu((e, t) => {
  var Ce;
  const { registry: s, context: i } = _t(Zt), r = Q(null), n = Q(null), o = Q(null), a = Q(null), l = Q(null), c = Q(), [d, u] = le(), [h, p] = le(), [g, f] = le(), [m, C] = le(() => new Hs()), [w, y] = le(() => new Hs("ag-hidden")), [b, x] = le(() => new Hs("ag-hidden")), [M, T] = le(() => new Hs("ag-invisible"));
  Yu(t, () => ({
    // force new instance when grid tries to refresh
    refresh() {
      return !1;
    }
  })), wr(() => Da(d, i, n.current), [d]);
  const F = he((ae) => {
    if (r.current = ae, !ae) {
      c.current = i.destroyBean(c.current);
      return;
    }
    const ge = {
      setInnerRenderer: (xe, ce) => {
        u(xe), f(ce);
      },
      setChildCount: (xe) => p(xe),
      addOrRemoveCssClass: (xe, ce) => C((Re) => Re.setClass(xe, ce)),
      setContractedDisplayed: (xe) => x((ce) => ce.setClass("ag-hidden", !xe)),
      setExpandedDisplayed: (xe) => y((ce) => ce.setClass("ag-hidden", !xe)),
      setCheckboxVisible: (xe) => T((ce) => ce.setClass("ag-invisible", !xe))
    }, Se = s.createDynamicBean("groupCellRendererCtrl", !0);
    Se && (c.current = i.createBean(Se), c.current.init(
      ge,
      ae,
      o.current,
      a.current,
      l.current,
      Lx,
      e
    ));
  }, []), k = Te(() => `ag-cell-wrapper ${m.toString()}`, [m]), O = Te(() => `ag-group-expanded ${w.toString()}`, [w]), D = Te(
    () => `ag-group-contracted ${b.toString()}`,
    [b]
  ), $ = Te(() => `ag-group-checkbox ${M.toString()}`, [M]), j = d && d.componentFromFramework, J = j ? d.componentClass : void 0, X = d == null && g != null, ie = Ke(g, !0);
  return /* @__PURE__ */ q.createElement(
    "span",
    {
      className: k,
      ref: F,
      ...e.colDef ? {} : { role: (Ce = c.current) == null ? void 0 : Ce.getCellAriaRole() }
    },
    /* @__PURE__ */ q.createElement("span", { className: O, ref: a }),
    /* @__PURE__ */ q.createElement("span", { className: D, ref: l }),
    /* @__PURE__ */ q.createElement("span", { className: $, ref: o }),
    /* @__PURE__ */ q.createElement("span", { className: "ag-group-value", ref: n }, X && /* @__PURE__ */ q.createElement(q.Fragment, null, ie), j && /* @__PURE__ */ q.createElement(J, { ...d.params })),
    /* @__PURE__ */ q.createElement("span", { className: "ag-group-child-count" }, h)
  );
}), Zm = Lx, Wc = BC({
  setMethods: () => {
  }
}), sq = (e) => {
  const { initialProps: t, addUpdateCallback: s, CustomComponentClass: i, setMethods: r } = e, [{ key: n, ...o }, a] = le(t);
  return Wt(() => {
    s((l) => a(l));
  }, []), /* @__PURE__ */ q.createElement(Wc.Provider, { value: { setMethods: r } }, /* @__PURE__ */ q.createElement(i, { key: n, ...o }));
}, iq = Ss(sq), rq = 0;
function Qm() {
  return `agPortalKey_${++rq}`;
}
var kx = class {
  constructor(e, t, s, i) {
    this.portal = null, this.oldPortal = null, this.reactComponent = e, this.portalManager = t, this.componentType = s, this.suppressFallbackMethods = !!i, this.statelessComponent = this.isStateless(this.reactComponent), this.key = Qm(), this.portalKey = Qm(), this.instanceCreated = this.isStatelessComponent() ? fe.resolve(!1) : new fe((r) => {
      this.resolveInstanceCreated = r;
    });
  }
  getGui() {
    return this.eParentElement;
  }
  /** `getGui()` returns the parent element. This returns the actual root element. */
  getRootElement() {
    return this.eParentElement.firstChild;
  }
  destroy() {
    this.componentInstance && typeof this.componentInstance.destroy == "function" && this.componentInstance.destroy();
    const e = this.portal;
    e && this.portalManager.destroyPortal(e);
  }
  createParentElement(e) {
    const t = this.portalManager.getComponentWrappingElement(), s = document.createElement(t || "div");
    return s.classList.add("ag-react-container"), e.reactContainer = s, s;
  }
  statelessComponentRendered() {
    return this.eParentElement.childElementCount > 0 || this.eParentElement.childNodes.length > 0;
  }
  getFrameworkComponentInstance() {
    return this.componentInstance;
  }
  isStatelessComponent() {
    return this.statelessComponent;
  }
  getReactComponentName() {
    return this.reactComponent.name;
  }
  getMemoType() {
    return this.hasSymbol() ? Symbol.for("react.memo") : 60115;
  }
  hasSymbol() {
    return typeof Symbol == "function" && Symbol.for;
  }
  isStateless(e) {
    return typeof e == "function" && !(e.prototype && e.prototype.isReactComponent) || typeof e == "object" && e.$$typeof === this.getMemoType();
  }
  hasMethod(e) {
    const t = this.getFrameworkComponentInstance();
    return !!t && t[e] != null || this.fallbackMethodAvailable(e);
  }
  callMethod(e, t) {
    const s = this.getFrameworkComponentInstance();
    if (this.isStatelessComponent())
      return this.fallbackMethod(e, t && t[0] ? t[0] : {});
    if (!s) {
      setTimeout(() => this.callMethod(e, t));
      return;
    }
    const i = s[e];
    if (i)
      return i.apply(s, t);
    if (this.fallbackMethodAvailable(e))
      return this.fallbackMethod(e, t && t[0] ? t[0] : {});
  }
  addMethod(e, t) {
    this[e] = t;
  }
  init(e) {
    return this.eParentElement = this.createParentElement(e), this.createOrUpdatePortal(e), new fe((t) => this.createReactComponent(t));
  }
  createOrUpdatePortal(e) {
    this.isStatelessComponent() || (this.ref = (t) => {
      var s;
      this.componentInstance = t, (s = this.resolveInstanceCreated) == null || s.call(this, !0), this.resolveInstanceCreated = void 0;
    }, e.ref = this.ref), this.reactElement = this.createElement(this.reactComponent, { ...e, key: this.key }), this.portal = HC(
      this.reactElement,
      this.eParentElement,
      this.portalKey
      // fixed deltaRowModeRefreshCompRenderer
    );
  }
  createElement(e, t) {
    return KF(e, t);
  }
  createReactComponent(e) {
    this.portalManager.mountReactPortal(this.portal, this, e);
  }
  rendered() {
    return this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
  }
  /*
   * fallback methods - these will be invoked if a corresponding instance method is not present
   * for example if refresh is called and is not available on the component instance, then refreshComponent on this
   * class will be invoked instead
   *
   * Currently only refresh is supported
   */
  refreshComponent(e) {
    this.oldPortal = this.portal, this.createOrUpdatePortal(e), this.portalManager.updateReactPortal(this.oldPortal, this.portal);
  }
  fallbackMethod(e, t) {
    const s = this[`${e}Component`];
    if (!this.suppressFallbackMethods && s)
      return s.bind(this)(t);
  }
  fallbackMethodAvailable(e) {
    return this.suppressFallbackMethods ? !1 : !!this[`${e}Component`];
  }
};
function Lp(e, t, s) {
  e.forEach((i) => {
    const r = t[i];
    r && (s[i] = r);
  });
}
var Mi = class extends kx {
  constructor() {
    super(...arguments), this.awaitUpdateCallback = new fe((e) => {
      this.resolveUpdateCallback = e;
    }), this.wrapperComponent = iq;
  }
  init(e) {
    return this.sourceParams = e, super.init(this.getProps());
  }
  addMethod() {
  }
  getInstance() {
    return this.instanceCreated.then(() => this.componentInstance);
  }
  getFrameworkComponentInstance() {
    return this;
  }
  createElement(e, t) {
    return super.createElement(this.wrapperComponent, {
      initialProps: t,
      CustomComponentClass: e,
      setMethods: (s) => this.setMethods(s),
      addUpdateCallback: (s) => {
        this.updateCallback = () => (s(this.getProps()), new fe((i) => {
          setTimeout(() => {
            i();
          });
        })), this.resolveUpdateCallback();
      }
    });
  }
  setMethods(e) {
    this.providedMethods = e, Lp(this.getOptionalMethods(), this.providedMethods, this);
  }
  getOptionalMethods() {
    return [];
  }
  getProps() {
    return {
      ...this.sourceParams,
      key: this.key,
      ref: this.ref
    };
  }
  refreshProps() {
    return this.updateCallback ? this.updateCallback() : new fe(
      (e) => this.awaitUpdateCallback.then(() => {
        this.updateCallback().then(() => e());
      })
    );
  }
}, nq = class extends Mi {
  refresh(e) {
    return this.sourceParams = e, this.refreshProps(), !0;
  }
}, oq = class extends Mi {
  constructor() {
    super(...arguments), this.date = null, this.onDateChange = (e) => this.updateDate(e);
  }
  getDate() {
    return this.date;
  }
  setDate(e) {
    this.date = e, this.refreshProps();
  }
  refresh(e) {
    this.sourceParams = e, this.refreshProps();
  }
  getOptionalMethods() {
    return ["afterGuiAttached", "setInputPlaceholder", "setInputAriaLabel", "setDisabled"];
  }
  updateDate(e) {
    this.setDate(e), this.sourceParams.onDateChanged();
  }
  getProps() {
    const e = super.getProps();
    return e.date = this.date, e.onDateChange = this.onDateChange, delete e.onDateChanged, e;
  }
}, aq = class extends Mi {
  constructor() {
    super(...arguments), this.label = "", this.icon = null, this.shake = !1;
  }
  setIcon(e, t) {
    this.icon = e, this.shake = t, this.refreshProps();
  }
  setLabel(e) {
    this.label = e, this.refreshProps();
  }
  getProps() {
    const e = super.getProps(), { label: t, icon: s, shake: i } = this;
    return e.label = t, e.icon = s, e.shake = i, e;
  }
}, lq = class extends Mi {
  constructor() {
    super(...arguments), this.model = null, this.onModelChange = (e) => this.updateModel(e), this.onUiChange = () => this.sourceParams.filterChangedCallback(), this.expectingNewMethods = !0, this.hasBeenActive = !1;
  }
  isFilterActive() {
    return this.model != null;
  }
  doesFilterPass(e) {
    return this.providedMethods.doesFilterPass(e);
  }
  getModel() {
    return this.model;
  }
  setModel(e) {
    return this.expectingNewMethods = !0, this.model = e, this.hasBeenActive || (this.hasBeenActive = this.isFilterActive()), this.refreshProps();
  }
  refresh(e) {
    return this.sourceParams = e, this.refreshProps(), !0;
  }
  getOptionalMethods() {
    return ["afterGuiAttached", "afterGuiDetached", "onNewRowsLoaded", "getModelAsString", "onAnyFilterChanged"];
  }
  setMethods(e) {
    var t;
    this.expectingNewMethods === !1 && this.hasBeenActive && ((t = this.providedMethods) == null ? void 0 : t.doesFilterPass) !== (e == null ? void 0 : e.doesFilterPass) && setTimeout(() => {
      this.sourceParams.filterChangedCallback();
    }), this.expectingNewMethods = !1, super.setMethods(e);
  }
  updateModel(e) {
    this.setModel(e).then(() => this.sourceParams.filterChangedCallback());
  }
  getProps() {
    const e = super.getProps();
    return e.model = this.model, e.onModelChange = this.onModelChange, e.onUiChange = this.onUiChange, delete e.filterChangedCallback, delete e.filterModifiedCallback, e;
  }
};
function Ox(e, t) {
  e.parentFilterInstance((s) => {
    (s.setModel(t) || fe.resolve()).then(() => {
      e.filterParams.filterChangedCallback();
    });
  });
}
var cq = class {
  constructor(e, t) {
    this.floatingFilterParams = e, this.refreshProps = t, this.model = null, this.onModelChange = (s) => this.updateModel(s);
  }
  getProps() {
    return {
      ...this.floatingFilterParams,
      model: this.model,
      onModelChange: this.onModelChange
    };
  }
  onParentModelChanged(e) {
    this.model = e, this.refreshProps();
  }
  refresh(e) {
    this.floatingFilterParams = e, this.refreshProps();
  }
  setMethods(e) {
    Lp(this.getOptionalMethods(), e, this);
  }
  getOptionalMethods() {
    return ["afterGuiAttached"];
  }
  updateModel(e) {
    this.model = e, this.refreshProps(), Ox(this.floatingFilterParams, e);
  }
}, dq = class extends Mi {
  constructor() {
    super(...arguments), this.model = null, this.onModelChange = (e) => this.updateModel(e);
  }
  onParentModelChanged(e) {
    this.model = e, this.refreshProps();
  }
  refresh(e) {
    this.sourceParams = e, this.refreshProps();
  }
  getOptionalMethods() {
    return ["afterGuiAttached"];
  }
  updateModel(e) {
    this.model = e, this.refreshProps(), Ox(this.sourceParams, e);
  }
  getProps() {
    const e = super.getProps();
    return e.model = this.model, e.onModelChange = this.onModelChange, e;
  }
}, uq = class extends Mi {
  refresh(e) {
    this.sourceParams = e, this.refreshProps();
  }
}, hq = class extends Mi {
  constructor() {
    super(...arguments), this.active = !1, this.expanded = !1, this.onActiveChange = (e) => this.updateActive(e);
  }
  setActive(e) {
    this.awaitSetActive(e);
  }
  setExpanded(e) {
    this.expanded = e, this.refreshProps();
  }
  getOptionalMethods() {
    return ["select", "configureDefaults"];
  }
  awaitSetActive(e) {
    return this.active = e, this.refreshProps();
  }
  updateActive(e) {
    const t = this.awaitSetActive(e);
    e && t.then(() => this.sourceParams.onItemActivated());
  }
  getProps() {
    const e = super.getProps();
    return e.active = this.active, e.expanded = this.expanded, e.onActiveChange = this.onActiveChange, delete e.onItemActivated, e;
  }
}, pq = class extends Mi {
  refresh(e) {
    this.sourceParams = e, this.refreshProps();
  }
}, gq = class extends Mi {
  refresh(e) {
    return this.sourceParams = e, this.refreshProps(), !0;
  }
}, fq = class extends Mi {
  constructor() {
    super(...arguments), this.onStateChange = (e) => this.updateState(e);
  }
  refresh(e) {
    return this.sourceParams = e, this.refreshProps(), !0;
  }
  getState() {
    return this.state;
  }
  updateState(e) {
    this.state = e, this.refreshProps(), this.sourceParams.onStateUpdated();
  }
  getProps() {
    const e = super.getProps();
    return e.state = this.state, e.onStateChange = this.onStateChange, e;
  }
};
function kp() {
  I(231);
}
var mq = 1e3, Cq = class {
  constructor(e, t, s) {
    this.destroyed = !1, this.portals = [], this.hasPendingPortalUpdate = !1, this.wrappingElement = t || "div", this.refresher = e, this.maxComponentCreationTimeMs = s || mq;
  }
  getPortals() {
    return this.portals;
  }
  destroy() {
    this.destroyed = !0;
  }
  destroyPortal(e) {
    this.portals = this.portals.filter((t) => t !== e), this.batchUpdate();
  }
  getComponentWrappingElement() {
    return this.wrappingElement;
  }
  mountReactPortal(e, t, s) {
    this.portals = [...this.portals, e], this.waitForInstance(t, s), this.batchUpdate();
  }
  updateReactPortal(e, t) {
    this.portals[this.portals.indexOf(e)] = t, this.batchUpdate();
  }
  batchUpdate() {
    this.hasPendingPortalUpdate || (setTimeout(() => {
      this.destroyed || (this.refresher(), this.hasPendingPortalUpdate = !1);
    }), this.hasPendingPortalUpdate = !0);
  }
  waitForInstance(e, t, s = Date.now()) {
    if (this.destroyed) {
      t(null);
      return;
    }
    if (e.rendered())
      t(e);
    else {
      if (Date.now() - s >= this.maxComponentCreationTimeMs && !this.hasPendingPortalUpdate)
        return;
      window.setTimeout(() => {
        this.waitForInstance(e, t, s);
      });
    }
  }
}, vq = ({ ctrl: e }) => {
  const t = e.isAlive(), { context: s } = _t(Zt), i = t ? e.column.getColId() : void 0, [r, n] = le(), o = Q(), a = Q(null), l = Q(null), c = Q(null), d = Q(), u = Q();
  t && !u.current && (u.current = new ga(() => a.current));
  const h = he((m) => {
    var y;
    if (a.current = m, o.current = m ? s.createBean(new no()) : s.destroyBean(o.current), !m || !t)
      return;
    const C = {
      setWidth: (b) => {
        a.current && (a.current.style.width = b);
      },
      addOrRemoveCssClass: (b, x) => u.current.addOrRemoveCssClass(b, x),
      setAriaSort: (b) => {
        a.current && (b ? qC(a.current, b) : YC(a.current));
      },
      setUserCompDetails: (b) => n(b),
      getUserCompInstance: () => d.current || void 0
    };
    e.setComp(C, m, l.current, c.current, o.current);
    const w = e.getSelectAllGui();
    w && ((y = l.current) == null || y.insertAdjacentElement("afterend", w), o.current.addDestroyFunc(() => w.remove()));
  }, []);
  wr(
    () => Da(r, s, c.current, d),
    [r]
  ), Wt(() => {
    e.setDragSource(a.current);
  }, [r]);
  const p = Te(() => !!((r == null ? void 0 : r.componentFromFramework) && xo(r.componentClass)), [r]), g = r && r.componentFromFramework, f = r && r.componentClass;
  return /* @__PURE__ */ q.createElement("div", { ref: h, className: "ag-header-cell", "col-id": i, role: "columnheader" }, /* @__PURE__ */ q.createElement("div", { ref: l, className: "ag-header-cell-resize", role: "presentation" }), /* @__PURE__ */ q.createElement("div", { ref: c, className: "ag-header-cell-comp-wrapper", role: "presentation" }, g && p && /* @__PURE__ */ q.createElement(f, { ...r.params }), g && !p && /* @__PURE__ */ q.createElement(f, { ...r.params, ref: d })));
}, wq = Ss(vq), yq = ({ ctrl: e }) => {
  const { context: t, gos: s } = _t(Zt), [i, r] = le(
    () => new Hs("ag-header-cell", "ag-floating-filter")
  ), [n, o] = le(() => new Hs()), [a, l] = le(
    () => new Hs("ag-floating-filter-button", "ag-hidden")
  ), [c, d] = le("false"), [u, h] = le(), [, p] = le(1), g = Q(), f = Q(null), m = Q(null), C = Q(null), w = Q(null), y = Q(), b = Q(), x = (ie) => {
    ie != null && y.current && y.current(ie);
  }, M = he((ie) => {
    if (f.current = ie, g.current = ie ? t.createBean(new no()) : t.destroyBean(g.current), !ie)
      return;
    b.current = new fe((ae) => {
      y.current = ae;
    });
    const Ce = {
      addOrRemoveCssClass: (ae, ge) => r((Se) => Se.setClass(ae, ge)),
      addOrRemoveBodyCssClass: (ae, ge) => o((Se) => Se.setClass(ae, ge)),
      setButtonWrapperDisplayed: (ae) => {
        l((ge) => ge.setClass("ag-hidden", !ae)), d(ae ? "false" : "true");
      },
      setWidth: (ae) => {
        f.current && (f.current.style.width = ae);
      },
      setCompDetails: (ae) => h(ae),
      getFloatingFilterComp: () => b.current ? b.current : null,
      setMenuIcon: (ae) => {
        var ge;
        return (ge = w.current) == null ? void 0 : ge.appendChild(ae);
      }
    };
    e.setComp(Ce, ie, w.current, m.current, g.current);
  }, []);
  wr(
    () => Da(u, t, m.current, x),
    [u]
  );
  const T = Te(() => i.toString(), [i]), F = Te(() => n.toString(), [n]), k = Te(() => a.toString(), [a]), O = Te(() => !!(u && u.componentFromFramework && xo(u.componentClass)), [u]), D = Te(() => s.get("reactiveCustomComponents"), []), $ = Te(() => {
    if (u)
      if (D) {
        const ie = new cq(
          u.params,
          () => p((Ce) => Ce + 1)
        );
        return x(ie), ie;
      } else u.componentFromFramework && kp();
  }, [u]), j = $ == null ? void 0 : $.getProps(), J = u && u.componentFromFramework, X = u && u.componentClass;
  return /* @__PURE__ */ q.createElement("div", { ref: M, className: T, role: "gridcell" }, /* @__PURE__ */ q.createElement("div", { ref: m, className: F, role: "presentation" }, J && !D && /* @__PURE__ */ q.createElement(X, { ...u.params, ref: O ? () => {
  } : x }), J && D && /* @__PURE__ */ q.createElement(
    Wc.Provider,
    {
      value: {
        setMethods: (ie) => $.setMethods(ie)
      }
    },
    /* @__PURE__ */ q.createElement(X, { ...j })
  )), /* @__PURE__ */ q.createElement(
    "div",
    {
      ref: C,
      "aria-hidden": c,
      className: k,
      role: "presentation"
    },
    /* @__PURE__ */ q.createElement(
      "button",
      {
        ref: w,
        type: "button",
        className: "ag-button ag-floating-filter-button-button",
        tabIndex: -1
      }
    )
  ));
}, bq = Ss(yq), Sq = ({ ctrl: e }) => {
  const { context: t } = _t(Zt), [s, i] = le(() => new Hs()), [r, n] = le(() => new Hs()), [o, a] = le("false"), [l, c] = le(), [d, u] = le(), h = Te(() => e.column.getUniqueId(), []), p = Q(), g = Q(null), f = Q(null), m = Q(null), C = Q(), w = he((F) => {
    if (g.current = F, p.current = F ? t.createBean(new no()) : t.destroyBean(p.current), !F)
      return;
    const k = {
      setWidth: (O) => {
        g.current && (g.current.style.width = O);
      },
      addOrRemoveCssClass: (O, D) => i(($) => $.setClass(O, D)),
      setHeaderWrapperHidden: (O) => {
        const D = m.current;
        D && (O ? D.style.setProperty("display", "none") : D.style.removeProperty("display"));
      },
      setHeaderWrapperMaxHeight: (O) => {
        const D = m.current;
        D && (O != null ? D.style.setProperty("max-height", `${O}px`) : D.style.removeProperty("max-height"), D.classList.toggle("ag-header-cell-comp-wrapper-limited-height", O != null));
      },
      setUserCompDetails: (O) => u(O),
      setResizableDisplayed: (O) => {
        n((D) => D.setClass("ag-hidden", !O)), a(O ? "false" : "true");
      },
      setAriaExpanded: (O) => c(O),
      getUserCompInstance: () => C.current || void 0
    };
    e.setComp(k, F, f.current, m.current, p.current);
  }, []);
  wr(() => Da(d, t, m.current), [d]), Wt(() => {
    g.current && e.setDragSource(g.current);
  }, [d]);
  const y = Te(() => !!((d == null ? void 0 : d.componentFromFramework) && xo(d.componentClass)), [d]), b = Te(() => "ag-header-group-cell " + s.toString(), [s]), x = Te(
    () => "ag-header-cell-resize " + r.toString(),
    [r]
  ), M = d && d.componentFromFramework, T = d && d.componentClass;
  return /* @__PURE__ */ q.createElement("div", { ref: w, className: b, "col-id": h, role: "columnheader", "aria-expanded": l }, /* @__PURE__ */ q.createElement("div", { ref: m, className: "ag-header-cell-comp-wrapper", role: "presentation" }, M && y && /* @__PURE__ */ q.createElement(T, { ...d.params }), M && !y && /* @__PURE__ */ q.createElement(T, { ...d.params, ref: C })), /* @__PURE__ */ q.createElement("div", { ref: f, "aria-hidden": o, className: x }));
}, xq = Ss(Sq), Rq = ({ ctrl: e }) => {
  const { context: t } = _t(Zt), { topOffset: s, rowHeight: i } = Te(() => e.getTopAndHeight(), []), r = e.getAriaRowIndex(), n = e.headerRowClass, [o, a] = le(() => i + "px"), [l, c] = le(() => s + "px"), d = Q(null), u = Q(null), [h, p] = le(() => e.getHeaderCtrls()), g = Q(), f = Q(null), m = he((y) => {
    if (f.current = y, g.current = y ? t.createBean(new no()) : t.destroyBean(g.current), !y)
      return;
    const b = {
      setHeight: (x) => a(x),
      setTop: (x) => c(x),
      setHeaderCtrls: (x, M, T) => {
        u.current = d.current, d.current = x;
        const F = Ip(u.current, x, M);
        F !== u.current && Mp(T, () => p(F));
      },
      setWidth: (x) => {
        f.current && (f.current.style.width = x);
      }
    };
    e.setComp(b, g.current, !1);
  }, []), C = Te(
    () => ({
      height: o,
      top: l
    }),
    [o, l]
  ), w = he((y) => {
    switch (e.type) {
      case "group":
        return /* @__PURE__ */ q.createElement(xq, { ctrl: y, key: y.instanceId });
      case "filter":
        return /* @__PURE__ */ q.createElement(bq, { ctrl: y, key: y.instanceId });
      default:
        return /* @__PURE__ */ q.createElement(wq, { ctrl: y, key: y.instanceId });
    }
  }, []);
  return /* @__PURE__ */ q.createElement("div", { ref: m, className: n, role: "row", style: C, "aria-rowindex": r }, h.map(w));
}, Fq = Ss(Rq), Pq = ({ pinned: e }) => {
  const [t, s] = le(!0), [i, r] = le([]), { context: n } = _t(Zt), o = Q(null), a = Q(null), l = Q(), c = e === "left", d = e === "right", u = !c && !d, h = he((f) => {
    if (o.current = f, l.current = f ? n.createBean(new Bw(e)) : n.destroyBean(l.current), !f)
      return;
    const m = {
      setDisplayed: s,
      setCtrls: (C) => r(C),
      // centre only
      setCenterWidth: (C) => {
        a.current && (a.current.style.width = C);
      },
      setViewportScrollLeft: (C) => {
        o.current && (o.current.scrollLeft = C);
      },
      // pinned only
      setPinnedContainerWidth: (C) => {
        o.current && (o.current.style.width = C, o.current.style.minWidth = C, o.current.style.maxWidth = C);
      }
    };
    l.current.setComp(m, o.current);
  }, []), p = t ? "" : "ag-hidden", g = () => i.map((f) => /* @__PURE__ */ q.createElement(Fq, { ctrl: f, key: f.instanceId }));
  return /* @__PURE__ */ q.createElement(q.Fragment, null, c && /* @__PURE__ */ q.createElement(
    "div",
    {
      ref: h,
      className: "ag-pinned-left-header " + p,
      "aria-hidden": !t,
      role: "rowgroup"
    },
    g()
  ), d && /* @__PURE__ */ q.createElement(
    "div",
    {
      ref: h,
      className: "ag-pinned-right-header " + p,
      "aria-hidden": !t,
      role: "rowgroup"
    },
    g()
  ), u && /* @__PURE__ */ q.createElement("div", { ref: h, className: "ag-header-viewport " + p, role: "presentation" }, /* @__PURE__ */ q.createElement("div", { ref: a, className: "ag-header-container", role: "rowgroup" }, g())));
}, Yd = Ss(Pq), Tq = () => {
  const [e, t] = le(() => new Hs()), [s, i] = le(), { context: r } = _t(Zt), n = Q(null), o = Q(), a = he((d) => {
    if (n.current = d, o.current = d ? r.createBean(new Ow()) : r.destroyBean(o.current), !d)
      return;
    const u = {
      addOrRemoveCssClass: (h, p) => t((g) => g.setClass(h, p)),
      setHeightAndMinHeight: (h) => i(h)
    };
    o.current.setComp(u, d, d);
  }, []), l = Te(() => "ag-header " + e.toString(), [e]), c = Te(
    () => ({
      height: s,
      minHeight: s
    }),
    [s]
  );
  return /* @__PURE__ */ q.createElement("div", { ref: a, className: l, style: c, role: "presentation" }, /* @__PURE__ */ q.createElement(Yd, { pinned: "left" }), /* @__PURE__ */ q.createElement(Yd, { pinned: null }), /* @__PURE__ */ q.createElement(Yd, { pinned: "right" }));
}, Eq = Ss(Tq), Dq = (e, t) => {
  Wt(() => {
    const s = t.current;
    if (s) {
      const i = s.parentElement;
      if (i) {
        const r = document.createComment(e);
        return i.insertBefore(r, s), () => {
          i.removeChild(r);
        };
      }
    }
  }, [e]);
}, tn = Dq, Aq = class {
  constructor(e, t) {
    this.cellEditorParams = e, this.refreshProps = t, this.instanceCreated = new fe((s) => {
      this.resolveInstanceCreated = s;
    }), this.onValueChange = (s) => this.updateValue(s), this.value = e.value;
  }
  getProps() {
    return {
      ...this.cellEditorParams,
      initialValue: this.cellEditorParams.value,
      value: this.value,
      onValueChange: this.onValueChange
    };
  }
  getValue() {
    return this.value;
  }
  refresh(e) {
    this.cellEditorParams = e, this.refreshProps();
  }
  setMethods(e) {
    Lp(this.getOptionalMethods(), e, this);
  }
  getInstance() {
    return this.instanceCreated.then(() => this.componentInstance);
  }
  setRef(e) {
    var t;
    this.componentInstance = e, (t = this.resolveInstanceCreated) == null || t.call(this), this.resolveInstanceCreated = void 0;
  }
  getOptionalMethods() {
    return ["isCancelBeforeStart", "isCancelAfterEnd", "focusIn", "focusOut", "afterGuiAttached"];
  }
  updateValue(e) {
    this.value = e, this.refreshProps();
  }
}, Mq = (e) => {
  const t = Q(e), s = Q(), i = Q(!1), r = Q(!1), [, n] = le(0);
  i.current && (r.current = !0), Wt(() => (i.current || (s.current = t.current(), i.current = !0), n((o) => o + 1), () => {
    var o;
    r.current && ((o = s.current) == null || o.call(s));
  }), []);
}, Iq = (e) => {
  const [t, s] = le(), { context: i, popupSvc: r, localeSvc: n, gos: o, editSvc: a } = _t(Zt);
  return Mq(() => {
    var M, T;
    const { editDetails: l, cellCtrl: c, eParentCell: d } = e, { compDetails: u } = l, h = o.get("stopEditingWhenCellsLoseFocus"), p = i.createBean(a.createPopupEditorWrapper(u.params)), g = p.getGui();
    if (e.jsChildComp) {
      const F = e.jsChildComp.getGui();
      F && g.appendChild(F);
    }
    const { column: f, rowNode: m } = c, C = {
      column: f,
      rowNode: m,
      type: "popupCellEditor",
      eventSource: d,
      ePopup: g,
      position: l.popupPosition,
      keepWithinBounds: !0
    }, w = r == null ? void 0 : r.positionPopupByComponent.bind(r, C), y = Qu(n), b = r == null ? void 0 : r.addPopup({
      modal: h,
      eChild: g,
      closeOnEsc: !0,
      closedCallback: () => {
        c.onPopupEditorClosed();
      },
      anchorToElement: d,
      positionCallback: w,
      ariaLabel: y("ariaLabelCellEditor", "Cell Editor")
    }), x = b ? b.hideFunc : void 0;
    return s(p), (T = (M = e.jsChildComp) == null ? void 0 : M.afterGuiAttached) == null || T.call(M), () => {
      x == null || x(), i.destroyBean(p);
    };
  }), /* @__PURE__ */ q.createElement(q.Fragment, null, t && e.wrappedContent && HC(e.wrappedContent, t.getGui()));
}, Jm = Ss(Iq), Lq = (e, t, s, i, r, n) => {
  const { context: o } = _t(Zt), a = he(() => {
    const l = r.current;
    if (!l)
      return;
    const c = l.getGui();
    c && c.parentElement && c.parentElement.removeChild(c), o.destroyBean(l), r.current = void 0;
  }, []);
  Wt(() => {
    const l = e != null, c = (e == null ? void 0 : e.compDetails) && !e.compDetails.componentFromFramework, d = t && s == null;
    if (!(l && c && !d)) {
      a();
      return;
    }
    const h = e.compDetails;
    if (r.current) {
      const g = r.current, m = g.refresh != null && e.force == !1 ? g.refresh(h.params) : !1;
      if (m === !0 || m === void 0)
        return;
      a();
    }
    h.newAgStackInstance().then((g) => {
      if (!g)
        return;
      const f = g.getGui();
      if (!f)
        return;
      (t ? s : n.current).appendChild(f), r.current = g;
    });
  }, [e, t, i]), Wt(() => a, []);
}, kq = Lq, Oq = (e, t, s) => {
  const { compProxy: i } = e;
  s(i);
  const r = i.getProps(), n = xo(t);
  return /* @__PURE__ */ q.createElement(
    Wc.Provider,
    {
      value: {
        setMethods: (o) => i.setMethods(o)
      }
    },
    n ? /* @__PURE__ */ q.createElement(t, { ...r }) : /* @__PURE__ */ q.createElement(t, { ...r, ref: (o) => i.setRef(o) })
  );
}, eC = (e, t, s) => {
  const i = e.compProxy;
  return /* @__PURE__ */ q.createElement(q.Fragment, null, i ? Oq(e, t, s) : /* @__PURE__ */ q.createElement(t, { ...e.compDetails.params, ref: s }));
}, Gq = (e, t, s, i, r) => {
  const n = e.compDetails, o = n.componentClass, a = n.componentFromFramework && !e.popup, l = n.componentFromFramework && e.popup, c = !n.componentFromFramework && e.popup;
  return /* @__PURE__ */ q.createElement(q.Fragment, null, a && eC(e, o, t), l && /* @__PURE__ */ q.createElement(
    Jm,
    {
      editDetails: e,
      cellCtrl: i,
      eParentCell: s,
      wrappedContent: eC(e, o, t)
    }
  ), c && r && /* @__PURE__ */ q.createElement(
    Jm,
    {
      editDetails: e,
      cellCtrl: i,
      eParentCell: s,
      jsChildComp: r
    }
  ));
}, Bq = (e, t, s, i, r, n, o) => {
  const { compDetails: a, value: l } = e, c = !a, d = a && a.componentFromFramework, u = a && a.componentClass, h = l != null && l.toString ? l.toString() : l, p = () => /* @__PURE__ */ q.createElement(q.Fragment, null, c && /* @__PURE__ */ q.createElement(q.Fragment, null, h), d && !n && /* @__PURE__ */ q.createElement(u, { ...a.params, key: t, ref: i }), d && n && /* @__PURE__ */ q.createElement(u, { ...a.params, key: t }));
  return /* @__PURE__ */ q.createElement(q.Fragment, null, r ? /* @__PURE__ */ q.createElement("span", { role: "presentation", id: `cell-${s}`, className: "ag-cell-value", ref: o }, p()) : p());
}, Vq = ({
  cellCtrl: e,
  printLayout: t,
  editingRow: s
}) => {
  const { context: i } = _t(Zt), { colIdSanitised: r, instanceId: n } = e, o = Q(), [a, l] = le(
    () => e.isCellRenderer() ? void 0 : { compDetails: void 0, value: e.getValueToDisplay(), force: !1 }
  ), [c, d] = le(), [u, h] = le(1), [p, g] = le(), [f, m] = le(!1), [C, w] = le(!1), [y, b] = le(!1), [x, M] = le(), T = Te(() => e.isForceWrapper(), [e]), F = Te(() => e.getCellAriaRole(), [e]), k = Q(null), O = Q(null), D = Q(), $ = Q(), j = Q(), J = Q([]), X = Q(), [ie, Ce] = le(0), ae = he((we) => {
    X.current = we, Ce((_e) => _e + 1);
  }, []), ge = a != null && (f || y || C), Se = T || ge, xe = he(
    (we) => {
      if ($.current = we, we) {
        const _e = we.isCancelBeforeStart && we.isCancelBeforeStart();
        setTimeout(() => {
          _e ? (e.stopEditing(!0), e.focusCell(!0)) : e.cellEditorAttached();
        });
      }
    },
    [e]
  ), ce = Q();
  ce.current || (ce.current = new ga(() => k.current)), kq(a, Se, X.current, ie, D, k);
  const Re = Q();
  wr(() => {
    var Qe;
    const we = Re.current, _e = a;
    if (Re.current = a, we == null || we.compDetails == null || _e == null || _e.compDetails == null)
      return;
    const tt = we.compDetails, Oe = _e.compDetails;
    if (tt.componentClass != Oe.componentClass || ((Qe = O.current) == null ? void 0 : Qe.refresh) == null)
      return;
    O.current.refresh(Oe.params) != !0 && h((Ue) => Ue + 1);
  }, [a]), wr(() => {
    if (!(c && !c.compDetails.componentFromFramework))
      return;
    const _e = c.compDetails, tt = c.popup === !0, Oe = _e.newAgStackInstance();
    return Oe.then((je) => {
      if (!je)
        return;
      const Qe = je.getGui();
      if (xe(je), !tt) {
        const Ue = (T ? j : k).current;
        Ue == null || Ue.appendChild(Qe), je.afterGuiAttached && je.afterGuiAttached();
      }
      M(je);
    }), () => {
      Oe.then((je) => {
        var Ue;
        const Qe = je.getGui();
        i.destroyBean(je), xe(void 0), M(void 0), (Ue = Qe == null ? void 0 : Qe.parentElement) == null || Ue.removeChild(Qe);
      });
    };
  }, [c]);
  const De = he(
    (we) => {
      if (j.current = we, !we) {
        J.current.forEach((tt) => tt()), J.current = [];
        return;
      }
      const _e = (tt) => {
        if (tt) {
          const Oe = tt.getGui();
          we.insertAdjacentElement("afterbegin", Oe), J.current.push(() => {
            i.destroyBean(tt), ut(Oe);
          });
        }
        return tt;
      };
      if (f) {
        const tt = e.createSelectionCheckbox();
        _e(tt);
      }
      y && _e(e.createDndSource()), C && _e(e.createRowDragComp());
    },
    [e, i, y, C, f]
  ), Xe = he((we) => {
    if (k.current = we, o.current = we ? i.createBean(new no()) : i.destroyBean(o.current), !we || !e)
      return;
    const _e = {
      addOrRemoveCssClass: (Oe, je) => ce.current.addOrRemoveCssClass(Oe, je),
      setUserStyles: (Oe) => g(Oe),
      getFocusableElement: () => k.current,
      setIncludeSelection: (Oe) => m(Oe),
      setIncludeRowDrag: (Oe) => w(Oe),
      setIncludeDndSource: (Oe) => b(Oe),
      getCellEditor: () => $.current || null,
      getCellRenderer: () => O.current ?? D.current,
      getParentOfValue: () => X.current ?? j.current ?? k.current,
      setRenderDetails: (Oe, je, Qe) => {
        l((Ue) => (Ue == null ? void 0 : Ue.compDetails) !== Oe || (Ue == null ? void 0 : Ue.value) !== je || (Ue == null ? void 0 : Ue.force) !== Qe ? {
          value: je,
          compDetails: Oe,
          force: Qe
        } : Ue);
      },
      setEditDetails: (Oe, je, Qe, Ue) => {
        if (Oe) {
          let xt;
          Ue ? xt = new Aq(
            Oe.params,
            () => h((qs) => qs + 1)
          ) : Oe.componentFromFramework && kp(), d({
            compDetails: Oe,
            popup: je,
            popupPosition: Qe,
            compProxy: xt
          }), je || l(void 0);
        } else
          d((xt) => {
            xt != null && xt.compProxy && ($.current = void 0);
          });
      }
    }, tt = j.current || void 0;
    e.setComp(_e, we, tt, t, s, o.current);
  }, []), He = Te(() => {
    var _e;
    return !!(((_e = a == null ? void 0 : a.compDetails) == null ? void 0 : _e.componentFromFramework) && xo(a.compDetails.componentClass));
  }, [a]);
  wr(() => {
    k.current && (ce.current.addOrRemoveCssClass("ag-cell-value", !Se), ce.current.addOrRemoveCssClass("ag-cell-inline-editing", !!c && !c.popup), ce.current.addOrRemoveCssClass("ag-cell-popup-editing", !!c && !!c.popup), ce.current.addOrRemoveCssClass("ag-cell-not-inline-editing", !c || !!c.popup), e.setInlineEditingCss(), e.shouldRestoreFocus() && !e.editing && k.current.focus({ preventScroll: !0 }));
  });
  const $e = () => /* @__PURE__ */ q.createElement(q.Fragment, null, a != null && Bq(
    a,
    u,
    n,
    O,
    Se,
    He,
    ae
  ), c != null && Gq(c, xe, k.current, e, x)), Ct = he(() => e.onFocusOut(), []);
  return /* @__PURE__ */ q.createElement("div", { ref: Xe, style: p, role: F, "col-id": r, onBlur: Ct }, Se ? /* @__PURE__ */ q.createElement("div", { className: "ag-cell-wrapper", role: "presentation", ref: De }, $e()) : $e());
}, Nq = Ss(Vq), Hq = ({ rowCtrl: e, containerType: t }) => {
  const { context: s, gos: i } = _t(Zt), r = Q(), n = Q(e.getDomOrder()), o = e.isFullWidth(), a = e.rowNode.displayed, [l, c] = le(
    () => a ? e.rowNode.getRowIndexString() : null
  ), [d, u] = le(() => e.rowId), [h, p] = le(() => e.businessKey), [g, f] = le(() => e.rowStyles), m = Q(null), C = Q(null), [w, y] = le(() => null), [b, x] = le(), [M, T] = le(
    () => a ? e.getInitialRowTop(t) : void 0
  ), [F, k] = le(
    () => a ? e.getInitialTransform(t) : void 0
  ), O = Q(null), D = Q(), $ = Q(!1), [j, J] = le(0);
  Wt(() => {
    var Xe;
    if ($.current || !b || j > 10)
      return;
    const De = (Xe = O.current) == null ? void 0 : Xe.firstChild;
    De ? (e.setupDetailRowAutoHeight(De), $.current = !0) : J((He) => He + 1);
  }, [b, j]);
  const X = Q();
  X.current || (X.current = new ga(() => O.current));
  const ie = he((De) => {
    if (O.current = De, r.current = De ? s.createBean(new no()) : s.destroyBean(r.current), !De) {
      e.unsetComp(t);
      return;
    }
    if (!e.isAlive())
      return;
    const Xe = {
      // the rowTop is managed by state, instead of direct style manipulation by rowCtrl (like all the other styles)
      // as we need to have an initial value when it's placed into he DOM for the first time, for animation to work.
      setTop: T,
      setTransform: k,
      // i found using React for managing classes at the row level was to slow, as modifying classes caused a lot of
      // React code to execute, so avoiding React for managing CSS Classes made the grid go much faster.
      addOrRemoveCssClass: (He, $e) => X.current.addOrRemoveCssClass(He, $e),
      setDomOrder: (He) => n.current = He,
      setRowIndex: c,
      setRowId: u,
      setRowBusinessKey: p,
      setUserStyles: f,
      // if we don't maintain the order, then cols will be ripped out and into the dom
      // when cols reordered, which would stop the CSS transitions from working
      setCellCtrls: (He, $e) => {
        C.current = m.current, m.current = He;
        const Ct = Ip(C.current, He, n.current);
        Ct !== C.current && Mp($e, () => y(Ct));
      },
      showFullWidth: (He) => x(He),
      getFullWidthCellRenderer: () => D.current,
      refreshFullWidth: (He) => xe.current ? (x(($e) => ({
        ...$e,
        params: He()
      })), !0) : !D.current || !D.current.refresh ? !1 : D.current.refresh(He())
    };
    e.setComp(Xe, De, t, r.current);
  }, []);
  wr(
    () => Da(b, s, O.current, D),
    [b]
  );
  const Ce = Te(() => {
    const De = { top: M, transform: F };
    return Object.assign(De, g), De;
  }, [M, F, g]), ae = o && (b == null ? void 0 : b.componentFromFramework), ge = !o && w != null, Se = Te(() => !!((b == null ? void 0 : b.componentFromFramework) && xo(b.componentClass)), [b]), xe = Q(!1);
  Wt(() => {
    xe.current = Se && !!b && !!i.get("reactiveCustomComponents");
  }, [Se, b]);
  const ce = () => w == null ? void 0 : w.map((De) => /* @__PURE__ */ q.createElement(
    Nq,
    {
      cellCtrl: De,
      editingRow: e.editing,
      printLayout: e.printLayout,
      key: De.instanceId
    }
  )), Re = () => {
    const De = b.componentClass;
    return /* @__PURE__ */ q.createElement(q.Fragment, null, Se ? /* @__PURE__ */ q.createElement(De, { ...b.params }) : /* @__PURE__ */ q.createElement(De, { ...b.params, ref: D }));
  };
  return /* @__PURE__ */ q.createElement(
    "div",
    {
      ref: ie,
      role: "row",
      style: Ce,
      "row-index": l,
      "row-id": d,
      "row-business-key": h
    },
    ge && ce(),
    ae && Re()
  );
}, zq = Ss(Hq), Wq = ({ name: e }) => {
  const { context: t } = _t(Zt), s = Te(() => sn(e), [e]), i = Q(null), r = Q(null), n = Q([]), o = Q([]), [a, l] = le(() => []), c = Q(!1), d = Q(), u = Te(() => Js(s.viewport), [s]), h = Te(() => Js(s.container), [s]), p = s.type === "center", g = p ? i : r;
  tn(" AG Row Container " + e + " ", g);
  const f = he(() => p ? i.current != null && r.current != null : r.current != null, []), m = he(() => p ? i.current == null && r.current == null : r.current == null, []), C = he(() => {
    if (m() && (d.current = t.destroyBean(d.current)), f()) {
      const x = (T) => {
        const F = Ip(
          o.current,
          n.current,
          c.current
        );
        F !== o.current && (o.current = F, Mp(T, () => l(F)));
      }, M = {
        setHorizontalScroll: (T) => {
          i.current && (i.current.scrollLeft = T);
        },
        setViewportHeight: (T) => {
          i.current && (i.current.style.height = T);
        },
        setRowCtrls: ({ rowCtrls: T, useFlushSync: F }) => {
          const k = !!F && n.current.length > 0 && T.length > 0;
          n.current = T, x(k);
        },
        setDomOrder: (T) => {
          c.current != T && (c.current = T, x(!1));
        },
        setContainerWidth: (T) => {
          r.current && (r.current.style.width = T);
        },
        setOffsetTop: (T) => {
          r.current && (r.current.style.transform = `translateY(${T})`);
        }
      };
      d.current = t.createBean(new Tw(e)), d.current.setComp(M, r.current, i.current);
    }
  }, [f, m]), w = he(
    (x) => {
      r.current = x, C();
    },
    [C]
  ), y = he(
    (x) => {
      i.current = x, C();
    },
    [C]
  ), b = () => /* @__PURE__ */ q.createElement("div", { className: h, ref: w, role: "rowgroup" }, a.map((x) => /* @__PURE__ */ q.createElement(zq, { rowCtrl: x, containerType: s.type, key: x.instanceId })));
  return /* @__PURE__ */ q.createElement(q.Fragment, null, p ? /* @__PURE__ */ q.createElement("div", { className: u, ref: y, role: "presentation" }, b()) : b());
}, _q = Ss(Wq), Uq = () => {
  const e = _t(Zt), { context: t, overlays: s } = e, [i, r] = le(""), [n, o] = le(0), [a, l] = le(0), [c, d] = le("0px"), [u, h] = le("0px"), [p, g] = le("100%"), [f, m] = le("0px"), [C, w] = le("0px"), [y, b] = le("100%"), [x, M] = le(""), [T, F] = le(""), [k, O] = le(null), [D, $] = le(""), [j, J] = le(null), [X, ie] = le("ag-layout-normal"), Ce = Q();
  Ce.current || (Ce.current = new ga(() => ae.current));
  const ae = Q(null), ge = Q(null), Se = Q(null), xe = Q(null), ce = Q(null), Re = Q(null), De = Q(null), Xe = Q([]), He = Q([]);
  tn(" AG Grid Body ", ae), tn(" AG Pinned Top ", ge), tn(" AG Sticky Top ", Se), tn(" AG Middle ", Re), tn(" AG Pinned Bottom ", De);
  const $e = he((vt) => {
    if (ae.current = vt, !vt) {
      Xe.current = t.destroyBeans(Xe.current), He.current.forEach((qe) => qe()), He.current = [];
      return;
    }
    if (!t)
      return;
    const ds = (qe, ft) => {
      qe.appendChild(ft), He.current.push(() => qe.removeChild(ft));
    }, Is = (qe) => {
      const ft = t.createBean(new qe());
      return Xe.current.push(ft), ft;
    }, Ze = (qe, ft, Ot) => {
      ds(qe, document.createComment(Ot)), ds(qe, Is(ft).getGui());
    };
    Ze(vt, Mw, " AG Fake Horizontal Scroll ");
    const Ys = s == null ? void 0 : s.getOverlayWrapperCompClass();
    Ys && Ze(vt, Ys, " AG Overlay Wrapper "), ce.current && Ze(ce.current, Iw, " AG Fake Vertical Scroll ");
    const Nr = {
      setRowAnimationCssOnBodyViewport: r,
      setColumnCount: (qe) => {
        ae.current && jC(ae.current, qe);
      },
      setRowCount: (qe) => {
        ae.current && $C(ae.current, qe);
      },
      setTopHeight: o,
      setBottomHeight: l,
      setStickyTopHeight: d,
      setStickyTopTop: h,
      setStickyTopWidth: g,
      setTopDisplay: M,
      setBottomDisplay: F,
      setColumnMovingCss: (qe, ft) => Ce.current.addOrRemoveCssClass(qe, ft),
      updateLayoutClasses: ie,
      setAlwaysVerticalScrollClass: O,
      setPinnedTopBottomOverflowY: $,
      setCellSelectableCss: (qe, ft) => J(ft ? qe : null),
      setBodyViewportWidth: (qe) => {
        Re.current && (Re.current.style.width = qe);
      },
      registerBodyViewportResizeListener: (qe) => {
        if (Re.current) {
          const ft = Ms(e, Re.current, qe);
          He.current.push(() => ft());
        }
      },
      setStickyBottomHeight: m,
      setStickyBottomBottom: w,
      setStickyBottomWidth: b,
      setGridRootRole: (qe) => vt.setAttribute("role", qe)
    }, Qi = t.createBean(new Dw());
    Xe.current.push(Qi), Qi.setComp(
      Nr,
      vt,
      Re.current,
      ge.current,
      De.current,
      Se.current,
      xe.current
    );
  }, []), Ct = Te(() => Js("ag-root", "ag-unselectable", X), [X]), we = Te(
    () => Js(
      "ag-body-viewport",
      i,
      X,
      k,
      j
    ),
    [i, X, k, j]
  ), _e = Te(() => Js("ag-body", X), [X]), tt = Te(() => Js("ag-floating-top", j), [j]), Oe = Te(() => Js("ag-sticky-top", j), [j]), je = Te(
    () => Js("ag-sticky-bottom", f === "0px" ? "ag-hidden" : null, j),
    [j, f]
  ), Qe = Te(() => Js("ag-floating-bottom", j), [j]), Ue = Te(
    () => ({
      height: n,
      minHeight: n,
      display: x,
      overflowY: D
    }),
    [n, x, D]
  ), xt = Te(
    () => ({
      height: c,
      top: u,
      width: p
    }),
    [c, u, p]
  ), qs = Te(
    () => ({
      height: f,
      bottom: C,
      width: y
    }),
    [f, C, y]
  ), Rs = Te(
    () => ({
      height: a,
      minHeight: a,
      display: T,
      overflowY: D
    }),
    [a, T, D]
  ), pi = (vt) => /* @__PURE__ */ q.createElement(_q, { name: vt, key: `${vt}-container` }), cs = ({
    section: vt,
    children: ds,
    className: Is,
    style: Ze
  }) => /* @__PURE__ */ q.createElement("div", { ref: vt, className: Is, role: "presentation", style: Ze }, ds.map(pi));
  return /* @__PURE__ */ q.createElement("div", { ref: $e, className: Ct }, /* @__PURE__ */ q.createElement(Eq, null), cs({
    section: ge,
    className: tt,
    style: Ue,
    children: ["topLeft", "topCenter", "topRight", "topFullWidth"]
  }), /* @__PURE__ */ q.createElement("div", { className: _e, ref: ce, role: "presentation" }, cs({
    section: Re,
    className: we,
    children: ["left", "center", "right", "fullWidth"]
  })), cs({
    section: Se,
    className: Oe,
    style: xt,
    children: ["stickyTopLeft", "stickyTopCenter", "stickyTopRight", "stickyTopFullWidth"]
  }), cs({
    section: xe,
    className: je,
    style: qs,
    children: ["stickyBottomLeft", "stickyBottomCenter", "stickyBottomRight", "stickyBottomFullWidth"]
  }), cs({
    section: De,
    className: Qe,
    style: Rs,
    children: ["bottomLeft", "bottomCenter", "bottomRight", "bottomFullWidth"]
  }));
}, $q = Ss(Uq), jq = (e, t) => {
  const { children: s, eFocusableElement: i, onTabKeyDown: r, gridCtrl: n, forceFocusOutWhenTabGuardsAreEmpty: o } = e, { context: a } = _t(Zt), l = Q(null), c = Q(null), d = Q(), u = (m) => {
    const C = m == null ? void 0 : parseInt(m, 10).toString();
    [l, c].forEach((w) => {
      var y, b;
      C === void 0 ? (y = w.current) == null || y.removeAttribute("tabindex") : (b = w.current) == null || b.setAttribute("tabindex", C);
    });
  };
  Yu(t, () => ({
    forceFocusOutOfContainer(m) {
      var C;
      (C = d.current) == null || C.forceFocusOutOfContainer(m);
    }
  }));
  const h = he(() => {
    const m = l.current, C = c.current;
    if (!m && !C) {
      d.current = a.destroyBean(d.current);
      return;
    }
    if (m && C) {
      const w = {
        setTabIndex: u
      };
      d.current = a.createBean(
        new Uw({
          comp: w,
          eTopGuard: m,
          eBottomGuard: C,
          eFocusableElement: i,
          onTabKeyDown: r,
          forceFocusOutWhenTabGuardsAreEmpty: o,
          focusInnerElement: (y) => n.focusInnerElement(y)
        })
      );
    }
  }, []), p = he(
    (m) => {
      l.current = m, h();
    },
    [h]
  ), g = he(
    (m) => {
      c.current = m, h();
    },
    [h]
  ), f = (m) => {
    const C = m === "top" ? hn.TAB_GUARD_TOP : hn.TAB_GUARD_BOTTOM;
    return /* @__PURE__ */ q.createElement(
      "div",
      {
        className: `${hn.TAB_GUARD} ${C}`,
        role: "presentation",
        ref: m === "top" ? p : g
      }
    );
  };
  return /* @__PURE__ */ q.createElement(q.Fragment, null, f("top"), s, f("bottom"));
}, Kq = qu(jq), qq = Ss(Kq), Yq = ({ context: e }) => {
  const [t, s] = le(""), [i, r] = le(""), [n, o] = le(null), [a, l] = le(null), [c, d] = le(!1), [u, h] = le(), p = Q(), g = Q(null), f = Q(), [m, C] = le(null), w = Q(() => {
  }), y = Q(), b = Q([]), x = he(() => {
  }, []), M = Te(() => e.isDestroyed() ? null : e.getBeans(), [e]);
  tn(" AG Grid ", g);
  const T = he(($) => {
    if (g.current = $, p.current = $ ? e.createBean(new Kw()) : e.destroyBean(p.current), !$ || e.isDestroyed())
      return;
    const j = p.current;
    w.current = j.focusInnerElement.bind(j);
    const J = {
      destroyGridUi: () => {
      },
      // do nothing, as framework users destroy grid by removing the comp
      setRtlClass: s,
      forceFocusOutOfContainer: (X) => {
        var ie, Ce;
        if (!X && ((ie = y.current) != null && ie.isDisplayed())) {
          y.current.forceFocusOutOfContainer(X);
          return;
        }
        (Ce = f.current) == null || Ce.forceFocusOutOfContainer(X);
      },
      updateLayoutClasses: r,
      getFocusableContainers: () => {
        var Ce;
        const X = [], ie = (Ce = g.current) == null ? void 0 : Ce.querySelector(".ag-root");
        return ie && X.push({ getGui: () => ie }), b.current.forEach((ae) => {
          ae.isDisplayed() && X.push(ae);
        }), X;
      },
      setCursor: o,
      setUserSelect: l
    };
    j.setComp(J, $, $), d(!0);
  }, []);
  Wt(() => {
    const $ = p.current, j = g.current;
    if (!u || !M || !$ || !m || !j)
      return;
    const J = [], {
      watermarkSelector: X,
      paginationSelector: ie,
      sideBarSelector: Ce,
      statusBarSelector: ae,
      gridHeaderDropZonesSelector: ge
    } = $.getOptionalSelectors(), Se = [];
    if (ge) {
      const ce = e.createBean(new ge.component()), Re = ce.getGui();
      j.insertAdjacentElement("afterbegin", Re), Se.push(Re), J.push(ce);
    }
    if (Ce) {
      const ce = e.createBean(new Ce.component()), Re = ce.getGui(), De = m.querySelector(".ag-tab-guard-bottom");
      De && (De.insertAdjacentElement("beforebegin", Re), Se.push(Re)), J.push(ce), b.current.push(ce);
    }
    const xe = (ce) => {
      const Re = e.createBean(new ce()), De = Re.getGui();
      return j.insertAdjacentElement("beforeend", De), Se.push(De), J.push(Re), Re;
    };
    if (ae && xe(ae.component), ie) {
      const ce = xe(ie.component);
      y.current = ce, b.current.push(ce);
    }
    return X && xe(X.component), () => {
      e.destroyBeans(J), Se.forEach((ce) => {
        var Re;
        (Re = ce.parentElement) == null || Re.removeChild(ce);
      });
    };
  }, [u, m, M]);
  const F = Te(
    () => Js("ag-root-wrapper", t, i),
    [t, i]
  ), k = Te(
    () => Js("ag-root-wrapper-body", "ag-focus-managed", i),
    [i]
  ), O = Te(
    () => ({
      userSelect: a ?? "",
      WebkitUserSelect: a ?? "",
      cursor: n ?? ""
    }),
    [a, n]
  ), D = he(($) => {
    f.current = $, h($ !== null);
  }, []);
  return /* @__PURE__ */ q.createElement("div", { ref: T, className: F, style: O, role: "presentation" }, /* @__PURE__ */ q.createElement("div", { className: k, ref: C, role: "presentation" }, c && m && M && /* @__PURE__ */ q.createElement(Zt.Provider, { value: M }, /* @__PURE__ */ q.createElement(
    qq,
    {
      ref: D,
      eFocusableElement: m,
      onTabKeyDown: x,
      gridCtrl: p.current,
      forceFocusOutWhenTabGuardsAreEmpty: !0
    },
    // we wait for initialised before rending the children, so GridComp has created and registered with it's
    // GridCtrl before we create the child GridBodyComp. Otherwise the GridBodyComp would initialise first,
    // before we have set the the Layout CSS classes, causing the GridBodyComp to render rows to a grid that
    // doesn't have it's height specified, which would result if all the rows getting rendered (and if many rows,
    // hangs the UI)
    /* @__PURE__ */ q.createElement($q, null)
  ))));
}, Xq = Ss(Yq), Zq = class extends L {
  wireBeans(e) {
    this.ctrlsSvc = e.ctrlsSvc;
  }
  areHeaderCellsRendered() {
    return this.ctrlsSvc.getHeaderRowContainerCtrls().every((e) => e.getAllCtrls().every((t) => t.areCellsRendered()));
  }
}, Qq = {
  gridOptions: void 0,
  modules: void 0,
  containerStyle: void 0,
  className: void 0,
  setGridApi: void 0,
  componentWrappingElement: void 0,
  maxComponentCreationTimeMs: void 0,
  children: void 0
}, Gx = new Set(Object.keys(Qq)), Bx = (e) => {
  var m;
  const t = Q(), s = Q(null), i = Q(null), r = Q([]), n = Q([]), o = Q(e), a = Q(), l = Q(), c = Q(!1), [d, u] = le(void 0), [, h] = le(0), p = he((C) => {
    if (s.current = C, !C) {
      r.current.forEach((D) => D()), r.current.length = 0;
      return;
    }
    const w = e.modules || [];
    i.current || (i.current = new Cq(
      () => h((D) => D + 1),
      e.componentWrappingElement,
      e.maxComponentCreationTimeMs
    ), r.current.push(() => {
      var D;
      (D = i.current) == null || D.destroy(), i.current = null;
    }));
    const y = qP(
      e.gridOptions,
      e,
      Object.keys(e).filter((D) => !Gx.has(D))
    ), b = () => {
      if (c.current) {
        const D = () => {
          var j;
          return (j = a.current) != null && j.shouldQueueUpdates() ? void 0 : n.current.shift();
        };
        let $ = D();
        for (; $; )
          $(), $ = D();
      }
    }, x = new sY(b);
    a.current = x;
    const M = new Zq(), T = {
      providedBeanInstances: {
        frameworkCompWrapper: new eY(
          i.current,
          y.reactiveCustomComponents ?? i0("reactiveCustomComponents") ?? !0
        ),
        renderStatus: M
      },
      modules: w,
      frameworkOverrides: x,
      setThemeOnGridDiv: !0
    }, F = (D) => {
      u(D), D.createBean(M), r.current.push(() => {
        D.destroy();
      }), D.getBean("ctrlsSvc").whenReady(
        {
          addDestroyFunc: ($) => {
            r.current.push($);
          }
        },
        () => {
          var j;
          if (D.isDestroyed())
            return;
          const $ = t.current;
          $ && ((j = e.setGridApi) == null || j.call(e, $));
        }
      );
    }, k = (D) => {
      D.getBean("ctrlsSvc").whenReady(
        {
          addDestroyFunc: ($) => {
            r.current.push($);
          }
        },
        () => {
          n.current.forEach(($) => $()), n.current.length = 0, c.current = !0;
        }
      );
    }, O = new fy();
    y.gridId ?? (y.gridId = l.current), t.current = O.create(
      C,
      y,
      F,
      k,
      T
    ), r.current.push(() => {
      t.current = void 0;
    }), t.current && (l.current = t.current.getGridId());
  }, []), g = Te(() => ({
    height: "100%",
    ...e.containerStyle || {}
  }), [e.containerStyle]), f = he((C) => {
    var w;
    c.current && !((w = a.current) != null && w.shouldQueueUpdates()) ? C() : n.current.push(C);
  }, []);
  return Wt(() => {
    const C = Jq(o.current, e);
    o.current = e, f(() => {
      t.current && YP(C, t.current);
    });
  }, [e]), /* @__PURE__ */ q.createElement("div", { style: g, className: e.className, ref: p }, d && !d.isDestroyed() ? /* @__PURE__ */ q.createElement(Xq, { context: d }) : null, ((m = i.current) == null ? void 0 : m.getPortals()) ?? null);
};
function Jq(e, t) {
  const s = {};
  return Object.keys(t).forEach((i) => {
    if (Gx.has(i))
      return;
    const r = t[i];
    e[i] !== r && (s[i] = r);
  }), s;
}
var eY = class extends C0 {
  constructor(e, t) {
    super(), this.parent = e, this.reactiveCustomComponents = t;
  }
  createWrapper(e, t) {
    if (this.reactiveCustomComponents) {
      const r = ((n) => {
        switch (n) {
          case "filter":
            return lq;
          case "floatingFilterComponent":
            return dq;
          case "dateComponent":
            return oq;
          case "dragAndDropImageComponent":
            return aq;
          case "loadingOverlayComponent":
            return uq;
          case "noRowsOverlayComponent":
            return pq;
          case "statusPanel":
            return gq;
          case "toolPanel":
            return fq;
          case "menuItem":
            return hq;
          case "cellRenderer":
            return nq;
        }
      })(t.name);
      if (r)
        return new r(e, this.parent, t);
    } else
      switch (t.name) {
        case "filter":
        case "floatingFilterComponent":
        case "dateComponent":
        case "dragAndDropImageComponent":
        case "loadingOverlayComponent":
        case "noRowsOverlayComponent":
        case "statusPanel":
        case "toolPanel":
        case "menuItem":
        case "cellRenderer":
          kp();
          break;
      }
    const s = !t.cellRenderer && t.name !== "toolPanel";
    return new kx(e, this.parent, t, s);
  }
}, tY = qu((e, t) => {
  const s = _t(Zt), { registry: i, context: r, gos: n, rowModel: o } = s, [a, l] = le(() => new Hs()), [c, d] = le(() => new Hs()), [u, h] = le(), [p, g] = le(), f = Q(), m = Q(null), C = Q(), w = Te(
    () => iw(e.api.getGridId(), (u == null ? void 0 : u.rowModelType) ?? "clientSide"),
    [e]
  ), y = Te(() => a.toString() + " ag-details-row", [a]), b = Te(() => c.toString() + " ag-details-grid", [c]);
  t && Yu(t, () => ({
    refresh() {
      var T;
      return ((T = f.current) == null ? void 0 : T.refresh()) ?? !1;
    }
  })), e.template && I(230);
  const x = he((T) => {
    var O;
    if (m.current = T, !T) {
      f.current = r.destroyBean(f.current), (O = C.current) == null || O.call(C);
      return;
    }
    const F = {
      addOrRemoveCssClass: (D, $) => l((j) => j.setClass(D, $)),
      addOrRemoveDetailGridCssClass: (D, $) => d((j) => j.setClass(D, $)),
      setDetailGrid: (D) => h(D),
      setRowData: (D) => g(D),
      getGui: () => m.current
    }, k = i.createDynamicBean("detailCellRendererCtrl", !0);
    if (k && (r.createBean(k), k.init(F, e), f.current = k, n.get("detailRowAutoHeight"))) {
      const D = () => {
        if (m.current == null)
          return;
        const $ = m.current.clientHeight;
        $ != null && $ > 0 && setTimeout(() => {
          e.node.setRowHeight($), (Ye(n) || Lt(n)) && o.onRowHeightChanged();
        }, 0);
      };
      C.current = Ms(s, T, D), D();
    }
  }, []), M = he((T) => {
    var F;
    (F = f.current) == null || F.registerDetailWithMaster(T);
  }, []);
  return /* @__PURE__ */ q.createElement("div", { className: y, ref: x }, u && /* @__PURE__ */ q.createElement(
    Bx,
    {
      className: b,
      ...u,
      modules: w,
      rowData: p,
      setGridApi: M
    }
  ));
}), sY = class extends jw {
  constructor(e) {
    super("react"), this.processQueuedUpdates = e, this.queueUpdates = !1, this.frameworkComponents = {
      agGroupCellRenderer: Zm,
      agGroupRowRenderer: Zm,
      agDetailCellRenderer: tY
    }, this.wrapIncoming = (t, s) => s === "ensureVisible" ? tq(t) : t(), this.renderingEngine = "react";
  }
  frameworkComponent(e) {
    return this.frameworkComponents[e];
  }
  isFrameworkComponent(e) {
    if (!e)
      return !1;
    const t = e.prototype;
    return !(t && "getGui" in t);
  }
  getLockOnRefresh() {
    this.queueUpdates = !0;
  }
  releaseLockOnRefresh() {
    this.queueUpdates = !1, this.processQueuedUpdates();
  }
  shouldQueueUpdates() {
    return this.queueUpdates;
  }
  runWhenReadyAsync() {
    return eq();
  }
}, Vx = class extends qF {
  constructor() {
    super(...arguments), this.apiListeners = [], this.setGridApi = (e) => {
      this.api = e, this.apiListeners.forEach((t) => t(e));
    };
  }
  registerApiListener(e) {
    this.apiListeners.push(e);
  }
  componentWillUnmount() {
    this.apiListeners.length = 0;
  }
  render() {
    return /* @__PURE__ */ q.createElement(Bx, { ...this.props, setGridApi: this.setGridApi });
  }
};
function iY(e) {
  const { setMethods: t } = _t(Wc);
  t(e);
}
function rY(e) {
  return iY(e);
}
var tC = NC("div")({
  height: "100%",
  width: "100%"
}), Nx = function(e) {
  var t = e.children;
  return /* @__PURE__ */ me.jsx(tC, { className: "cmg-data-grid", children: /* @__PURE__ */ me.jsx(tC, { className: "ag-theme-quartz ag-theme-cmgag", children: t }) });
}, nY = Tx, oY = Ea, aY = Nc, lY = ui, cY = yo, dY = Ta, uY = zc, hY = Hc, pY = "[object Map]", gY = "[object Set]", fY = Object.prototype, mY = fY.hasOwnProperty;
function CY(e) {
  if (e == null)
    return !0;
  if (cY(e) && (lY(e) || typeof e == "string" || typeof e.splice == "function" || dY(e) || hY(e) || aY(e)))
    return !e.length;
  var t = oY(e);
  if (t == pY || t == gY)
    return !e.size;
  if (uY(e))
    return !nY(e).length;
  for (var s in e)
    if (mY.call(e, s))
      return !1;
  return !0;
}
var vY = CY;
const Hx = /* @__PURE__ */ di(vY);
var wY = Tn, yY = function() {
  try {
    var e = wY(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), zx = yY, sC = zx;
function bY(e, t, s) {
  t == "__proto__" && sC ? sC(e, t, {
    configurable: !0,
    enumerable: !0,
    value: s,
    writable: !0
  }) : e[t] = s;
}
var Op = bY, SY = Op, xY = Pa;
function RY(e, t, s) {
  (s !== void 0 && !xY(e[t], s) || s === void 0 && !(t in e)) && SY(e, t, s);
}
var Wx = RY;
function FY(e) {
  return function(t, s, i) {
    for (var r = -1, n = Object(t), o = i(t), a = o.length; a--; ) {
      var l = o[e ? a : ++r];
      if (s(n[l], l, n) === !1)
        break;
    }
    return t;
  };
}
var PY = FY, TY = PY, EY = TY(), DY = EY, Ql = { exports: {} };
Ql.exports;
(function(e, t) {
  var s = Di, i = t && !t.nodeType && t, r = i && !0 && e && !e.nodeType && e, n = r && r.exports === i, o = n ? s.Buffer : void 0, a = o ? o.allocUnsafe : void 0;
  function l(c, d) {
    if (d)
      return c.slice();
    var u = c.length, h = a ? a(u) : new c.constructor(u);
    return c.copy(h), h;
  }
  e.exports = l;
})(Ql, Ql.exports);
var _x = Ql.exports, iC = yx;
function AY(e) {
  var t = new e.constructor(e.byteLength);
  return new iC(t).set(new iC(e)), t;
}
var Gp = AY, MY = Gp;
function IY(e, t) {
  var s = t ? MY(e.buffer) : e.buffer;
  return new e.constructor(s, e.byteOffset, e.length);
}
var Ux = IY;
function LY(e, t) {
  var s = -1, i = e.length;
  for (t || (t = Array(i)); ++s < i; )
    t[s] = e[s];
  return t;
}
var $x = LY, kY = Ai, rC = Object.create, OY = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!kY(t))
      return {};
    if (rC)
      return rC(t);
    e.prototype = t;
    var s = new e();
    return e.prototype = void 0, s;
  };
}(), GY = OY, BY = Px, VY = BY(Object.getPrototypeOf, Object), Bp = VY, NY = GY, HY = Bp, zY = zc;
function WY(e) {
  return typeof e.constructor == "function" && !zY(e) ? NY(HY(e)) : {};
}
var jx = WY, _Y = yo, UY = Zi;
function $Y(e) {
  return UY(e) && _Y(e);
}
var jY = $Y, KY = mo, qY = Bp, YY = Zi, XY = "[object Object]", ZY = Function.prototype, QY = Object.prototype, Kx = ZY.toString, JY = QY.hasOwnProperty, eX = Kx.call(Object);
function tX(e) {
  if (!YY(e) || KY(e) != XY)
    return !1;
  var t = qY(e);
  if (t === null)
    return !0;
  var s = JY.call(t, "constructor") && t.constructor;
  return typeof s == "function" && s instanceof s && Kx.call(s) == eX;
}
var qx = tX;
function sX(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var Yx = sX, iX = Op, rX = Pa, nX = Object.prototype, oX = nX.hasOwnProperty;
function aX(e, t, s) {
  var i = e[t];
  (!(oX.call(e, t) && rX(i, s)) || s === void 0 && !(t in e)) && iX(e, t, s);
}
var Vp = aX, lX = Vp, cX = Op;
function dX(e, t, s, i) {
  var r = !s;
  s || (s = {});
  for (var n = -1, o = t.length; ++n < o; ) {
    var a = t[n], l = i ? i(s[a], e[a], a, s, e) : void 0;
    l === void 0 && (l = e[a]), r ? cX(s, a, l) : lX(s, a, l);
  }
  return s;
}
var Ro = dX;
function uX(e) {
  var t = [];
  if (e != null)
    for (var s in Object(e))
      t.push(s);
  return t;
}
var hX = uX, pX = Ai, gX = zc, fX = hX, mX = Object.prototype, CX = mX.hasOwnProperty;
function vX(e) {
  if (!pX(e))
    return fX(e);
  var t = gX(e), s = [];
  for (var i in e)
    i == "constructor" && (t || !CX.call(e, i)) || s.push(i);
  return s;
}
var wX = vX, yX = Fx, bX = wX, SX = yo;
function xX(e) {
  return SX(e) ? yX(e, !0) : bX(e);
}
var Aa = xX, RX = Ro, FX = Aa;
function PX(e) {
  return RX(e, FX(e));
}
var TX = PX, nC = Wx, EX = _x, DX = Ux, AX = $x, MX = jx, oC = Nc, aC = ui, IX = jY, LX = Ta, kX = bp, OX = Ai, GX = qx, BX = Hc, lC = Yx, VX = TX;
function NX(e, t, s, i, r, n, o) {
  var a = lC(e, s), l = lC(t, s), c = o.get(l);
  if (c) {
    nC(e, s, c);
    return;
  }
  var d = n ? n(a, l, s + "", e, t, o) : void 0, u = d === void 0;
  if (u) {
    var h = aC(l), p = !h && LX(l), g = !h && !p && BX(l);
    d = l, h || p || g ? aC(a) ? d = a : IX(a) ? d = AX(a) : p ? (u = !1, d = EX(l, !0)) : g ? (u = !1, d = DX(l, !0)) : d = [] : GX(l) || oC(l) ? (d = a, oC(a) ? d = VX(a) : (!OX(a) || kX(a)) && (d = MX(l))) : u = !1;
  }
  u && (o.set(l, d), r(d, l, i, n, o), o.delete(l)), nC(e, s, d);
}
var HX = NX, zX = Rp, WX = Wx, _X = DY, UX = HX, $X = Ai, jX = Aa, KX = Yx;
function Xx(e, t, s, i, r) {
  e !== t && _X(t, function(n, o) {
    if (r || (r = new zX()), $X(n))
      UX(e, t, o, s, Xx, i, r);
    else {
      var a = i ? i(KX(e, o), n, o + "", e, t, r) : void 0;
      a === void 0 && (a = n), WX(e, o, a);
    }
  }, jX);
}
var qX = Xx;
function YX(e) {
  return e;
}
var Zx = YX;
function XX(e, t, s) {
  switch (s.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, s[0]);
    case 2:
      return e.call(t, s[0], s[1]);
    case 3:
      return e.call(t, s[0], s[1], s[2]);
  }
  return e.apply(t, s);
}
var ZX = XX, QX = ZX, cC = Math.max;
function JX(e, t, s) {
  return t = cC(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var i = arguments, r = -1, n = cC(i.length - t, 0), o = Array(n); ++r < n; )
      o[r] = i[t + r];
    r = -1;
    for (var a = Array(t + 1); ++r < t; )
      a[r] = i[r];
    return a[t] = s(o), QX(e, this, a);
  };
}
var Qx = JX;
function eZ(e) {
  return function() {
    return e;
  };
}
var tZ = eZ, sZ = tZ, dC = zx, iZ = Zx, rZ = dC ? function(e, t) {
  return dC(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: sZ(t),
    writable: !0
  });
} : iZ, nZ = rZ, oZ = 800, aZ = 16, lZ = Date.now;
function cZ(e) {
  var t = 0, s = 0;
  return function() {
    var i = lZ(), r = aZ - (i - s);
    if (s = i, r > 0) {
      if (++t >= oZ)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var dZ = cZ, uZ = nZ, hZ = dZ, pZ = hZ(uZ), Jx = pZ, gZ = Zx, fZ = Qx, mZ = Jx;
function CZ(e, t) {
  return mZ(fZ(e, t, gZ), e + "");
}
var vZ = CZ, wZ = Pa, yZ = yo, bZ = Tp, SZ = Ai;
function xZ(e, t, s) {
  if (!SZ(s))
    return !1;
  var i = typeof t;
  return (i == "number" ? yZ(s) && bZ(t, s.length) : i == "string" && t in s) ? wZ(s[t], e) : !1;
}
var RZ = xZ, FZ = vZ, PZ = RZ;
function TZ(e) {
  return FZ(function(t, s) {
    var i = -1, r = s.length, n = r > 1 ? s[r - 1] : void 0, o = r > 2 ? s[2] : void 0;
    for (n = e.length > 3 && typeof n == "function" ? (r--, n) : void 0, o && PZ(s[0], s[1], o) && (n = r < 3 ? void 0 : n, r = 1), t = Object(t); ++i < r; ) {
      var a = s[i];
      a && e(t, a, i, n);
    }
    return t;
  });
}
var EZ = TZ, DZ = qX, AZ = EZ, MZ = AZ(function(e, t, s, i) {
  DZ(e, t, s, i);
}), IZ = MZ;
const Jl = /* @__PURE__ */ di(IZ);
var LZ = mo, kZ = Zi, OZ = "[object Symbol]";
function GZ(e) {
  return typeof e == "symbol" || kZ(e) && LZ(e) == OZ;
}
var Np = GZ, BZ = ui, VZ = Np, NZ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, HZ = /^\w*$/;
function zZ(e, t) {
  if (BZ(e))
    return !1;
  var s = typeof e;
  return s == "number" || s == "symbol" || s == "boolean" || e == null || VZ(e) ? !0 : HZ.test(e) || !NZ.test(e) || t != null && e in Object(t);
}
var WZ = zZ, eR = xp, _Z = "Expected a function";
function Hp(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(_Z);
  var s = function() {
    var i = arguments, r = t ? t.apply(this, i) : i[0], n = s.cache;
    if (n.has(r))
      return n.get(r);
    var o = e.apply(this, i);
    return s.cache = n.set(r, o) || n, o;
  };
  return s.cache = new (Hp.Cache || eR)(), s;
}
Hp.Cache = eR;
var UZ = Hp, $Z = UZ, jZ = 500;
function KZ(e) {
  var t = $Z(e, function(i) {
    return s.size === jZ && s.clear(), i;
  }), s = t.cache;
  return t;
}
var qZ = KZ, YZ = qZ, XZ = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ZZ = /\\(\\)?/g, QZ = YZ(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(XZ, function(s, i, r, n) {
    t.push(r ? n.replace(ZZ, "$1") : i || s);
  }), t;
}), JZ = QZ;
function eQ(e, t) {
  for (var s = -1, i = e == null ? 0 : e.length, r = Array(i); ++s < i; )
    r[s] = t(e[s], s, e);
  return r;
}
var tR = eQ, uC = fo, tQ = tR, sQ = ui, iQ = Np, hC = uC ? uC.prototype : void 0, pC = hC ? hC.toString : void 0;
function sR(e) {
  if (typeof e == "string")
    return e;
  if (sQ(e))
    return tQ(e, sR) + "";
  if (iQ(e))
    return pC ? pC.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var rQ = sR, nQ = rQ;
function oQ(e) {
  return e == null ? "" : nQ(e);
}
var zp = oQ, aQ = ui, lQ = WZ, cQ = JZ, dQ = zp;
function uQ(e, t) {
  return aQ(e) ? e : lQ(e, t) ? [e] : cQ(dQ(e));
}
var _c = uQ, hQ = Np;
function pQ(e) {
  if (typeof e == "string" || hQ(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Wp = pQ, gQ = Vp, fQ = _c, mQ = Tp, gC = Ai, CQ = Wp;
function vQ(e, t, s, i) {
  if (!gC(e))
    return e;
  t = fQ(t, e);
  for (var r = -1, n = t.length, o = n - 1, a = e; a != null && ++r < n; ) {
    var l = CQ(t[r]), c = s;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return e;
    if (r != o) {
      var d = a[l];
      c = i ? i(d, l, a) : void 0, c === void 0 && (c = gC(d) ? d : mQ(t[r + 1]) ? [] : {});
    }
    gQ(a, l, c), a = a[l];
  }
  return e;
}
var wQ = vQ, yQ = wQ;
function bQ(e, t, s) {
  return e == null ? e : yQ(e, t, s);
}
var SQ = bQ;
const Uc = /* @__PURE__ */ di(SQ);
function xQ(e) {
  return !!(typeof e == "object" && e && "server" in e);
}
function ore(e) {
  return !!(typeof e == "object" && e && "children" in e && Array.isArray(e.children));
}
function iR(e) {
  return e.reduce(function(t, s) {
    var i = s.getColDef(), r = s.getColId();
    return xQ(i) ? t.set(r, i) : t;
  }, /* @__PURE__ */ new Map());
}
function are(e) {
  var t, s = (t = e.colId) !== null && t !== void 0 ? t : e.field;
  if (!s)
    throw new Error("ColDef must have a colId or field property");
  return s;
}
var RQ = _c, FQ = Wp;
function PQ(e, t) {
  t = RQ(t, e);
  for (var s = 0, i = t.length; e != null && s < i; )
    e = e[FQ(t[s++])];
  return s && s == i ? e : void 0;
}
var rR = PQ, TQ = rR;
function EQ(e, t, s) {
  var i = e == null ? void 0 : TQ(e, t);
  return i === void 0 ? s : i;
}
var DQ = EQ;
const AQ = /* @__PURE__ */ di(DQ);
var MQ = NC(nP)(mC || (mC = D4([`
  max-width: 300px;
  & .MuiAutocomplete-inputRoot {
    // To match the ag-grid filter input style (white background)
    background-color: var(--ag-filter-input-background);
  }
`], [`
  max-width: 300px;
  & .MuiAutocomplete-inputRoot {
    // To match the ag-grid filter input style (white background)
    background-color: var(--ag-filter-input-background);
  }
`]))), fC = [], nR = "CMG_CUSTOM_ASYNC_AUTOCOMPLETE_FILTER_TYPE";
function lre(e) {
  var t = this, s, i = e.model, r = e.onModelChange, n = e.onFetchOptions, o = e.getValue, a = As(le(!1), 2), l = a[0], c = a[1], d = Q(), u = Q(null), h = As(le(i), 2), p = h[0], g = h[1];
  Wt(function() {
    g(i);
  }, [i]);
  var f = he(function(T, F) {
    return P4(t, void 0, void 0, function() {
      var k;
      return T4(this, function(O) {
        switch (O.label) {
          case 0:
            c(!0), O.label = 1;
          case 1:
            return O.trys.push([1, 3, 4, 5]), [4, n(T, F)];
          case 2:
            return [2, O.sent()];
          case 3:
            return k = O.sent(), console.error("Error fetching options:", k), [3, 5];
          case 4:
            return c(!1), [
              7
              /*endfinally*/
            ];
          case 5:
            return [2, {
              data: fC,
              pagination: { hasNext: !1 }
            }];
        }
      });
    });
  }, [n]), m = he(function(T, F) {
    if (F.length === 0) {
      g(null);
      return;
    }
    var k = {
      filterType: nR,
      values: F
    };
    g(k);
  }, []), C = he(function() {
    g(null), r(null), d.current && d.current();
  }, [r]), w = he(function() {
    r(p), d.current && d.current();
  }, [r, p]), y = he(function(T) {
    var F = T.node, k = o(F);
    return k && typeof k == "string" && (i != null && i.values.length) ? i.values.includes(k) : !0;
  }, [o, i == null ? void 0 : i.values]), b = he(function(T) {
    var F;
    d.current = T.hidePopup, (F = u.current) === null || F === void 0 || F.focus();
  }, []), x = he(function() {
    if (!(i != null && i.values) || i.values.length === 0)
      return "";
    var T = i.values.length;
    return "(".concat(T, ") ").concat(i.values.join(","));
  }, [i]);
  rY({ doesFilterPass: y, getModelAsString: x, afterGuiAttached: b });
  var M = (s = p == null ? void 0 : p.values) !== null && s !== void 0 ? s : fC;
  return /* @__PURE__ */ me.jsxs("div", { className: "ag-filter", children: [
    /* @__PURE__ */ me.jsx("div", { className: "ag-filter-body-wrapper ag-simple-filter-body-wrapper", children: /* @__PURE__ */ me.jsx(MQ, { size: "extraSmall", isLoadingOptions: l, onFetchOptions: f, TextFieldProps: {
      placeholder: "Search...",
      inputRef: u
    }, multiple: !0, value: M, onChange: m }) }),
    /* @__PURE__ */ me.jsxs("div", { className: "ag-filter-apply-panel", children: [
      /* @__PURE__ */ me.jsx("button", { type: "button", className: "ag-button ag-standard-button ag-filter-apply-panel-button", onClick: C, children: "Reset" }),
      /* @__PURE__ */ me.jsx("button", { type: "button", className: "ag-button ag-standard-button ag-filter-apply-panel-button", onClick: w, children: "Apply" })
    ] })
  ] });
}
var mC;
function Br(e) {
  return !!(typeof e == "object" && e && "filterType" in e);
}
function IQ(e) {
  return Br(e) && e.filterType === "set";
}
function LQ(e) {
  return Br(e) && e.filterType === "date";
}
function kQ(e) {
  return Br(e) && e.filterType === "multi";
}
function OQ(e) {
  return Br(e) && "operator" in e && "conditions" in e;
}
var GQ = function(e) {
  return Br(e) && "type" in e && "filter" in e;
};
function BQ(e) {
  return Br(e) && "type" in e && e.type === "blank";
}
function VQ(e) {
  return Br(e) && "type" in e && e.type === "notBlank";
}
function NQ(e) {
  return Br(e) && e.filterType === nR;
}
function cre(e) {
  var t = function(s) {
    var i = s.getValue, r = i(e);
    return typeof r == "string" ? mP(r) : CP(r) ? r : null;
  };
  return {
    filter: "agDateColumnFilter",
    filterValueGetter: t,
    filterParams: {
      filterOptions: [
        "equals",
        "notEqual",
        "lessThan",
        "greaterThan",
        "inRange",
        "blank",
        "notBlank"
      ],
      includeBlanksInRange: !0,
      inRangeInclusive: !0
    }
  };
}
function dre(e) {
  return function(t) {
    var s = t.data, i = AQ(s, e.field);
    return typeof i != "number" ? null : Number((i * 100).toFixed(e.precision));
  };
}
var oR = function(e) {
  return e !== null && "selectAll" in e && "toggledNodes" in e;
}, HQ = function(e, t) {
  return e.reduce(function(s, i) {
    var r, n, o, a = (o = (n = (r = t.getRowNode(i)) === null || r === void 0 ? void 0 : r.parent) === null || n === void 0 ? void 0 : n.id) !== null && o !== void 0 ? o : "", l = i.replace(a, "");
    return l ? Ar(Ar([], As(s), !1), [l], !1) : s;
  }, []);
}, ure = function(e) {
  var t = e.api, s = !!t.getRowGroupColumns().length, i = t.getServerSideSelectionState();
  if (!oR(i))
    return null;
  var r = s ? HQ(i.toggledNodes, t) : i.toggledNodes;
  return i.selectAll ? {
    selectAll: !0,
    unselectedRowIds: i.toggledNodes,
    unselectedRowIdsFlat: r
  } : {
    selectAll: !1,
    selectedRowIds: i.toggledNodes,
    selectedRowIdsFlat: r
  };
}, hre = function(e) {
  var t = e.api.getServerSideSelectionState();
  if (oR(t)) {
    var s = t.toggledNodes, i = s.filter(function(r) {
      var n;
      return !!(!((n = e.api.getRowNode(r)) === null || n === void 0) && n.selectable);
    });
    i.length !== s.length && e.api.setServerSideSelectionState({
      selectAll: t.selectAll,
      toggledNodes: i
    });
  }
}, pre = function(e, t) {
  return function(s, i) {
    var r, n;
    if (!i.match(e))
      return i;
    var o = 0;
    try {
      for (var a = E4(s), l = a.next(); !l.done; l = a.next()) {
        var c = l.value;
        if (c.colId.match(e) && o++, c.colId === i)
          break;
      }
    } catch (d) {
      r = { error: d };
    } finally {
      try {
        l && !l.done && (n = a.return) && n.call(a);
      } finally {
        if (r) throw r.error;
      }
    }
    return "".concat(t).concat(o);
  };
}, zQ = /ⓘ/, gre = function(e) {
  var t = e === void 0 ? {} : e, s = t.gridRow, i = s === void 0 ? function(o) {
    var a, l = o.value;
    return (a = l == null ? void 0 : l.toString()) !== null && a !== void 0 ? a : "-";
  } : s, r = t.groupRow, n = r === void 0 ? function(o) {
    var a, l, c = o.value, d = o.colDef;
    return d.headerName ? "".concat(d.headerName.replace(zQ, "").trim(), ": ").concat((a = c == null ? void 0 : c.toString()) !== null && a !== void 0 ? a : "-") : "".concat((l = c == null ? void 0 : c.toString()) !== null && l !== void 0 ? l : "-");
  } : r;
  return function(o) {
    var a;
    return !((a = o.node) === null || a === void 0) && a.isExpandable() ? n(o) : i(o);
  };
}, ec;
(function(e) {
  e.Asc = "ASC", e.Desc = "DESC";
})(ec || (ec = {}));
var aR = {
  equals: "eq",
  notEqual: "neq",
  /**
   * Blank | Not blank filter is interpreted as `eq: null` | `neq: null`
   */
  blank: "eq",
  notBlank: "neq"
}, WQ = Ee(Ee({}, aR), { contains: "contains", notContains: "ncontains", startsWith: "startsWith", endsWith: "endsWith" }), _Q = Ee(Ee({}, aR), { greaterThan: "gt", greaterThanOrEqual: "gte", lessThan: "lt", lessThanOrEqual: "lte" });
function tc(e, t) {
  if (g7(e))
    return e.concat(t);
}
function lR(e, t) {
  var s, i;
  if (!e || !t)
    return null;
  switch (e) {
    case "text":
      return (s = WQ[t]) !== null && s !== void 0 ? s : null;
    case "number":
    case "date":
      return (i = _Q[t]) !== null && i !== void 0 ? i : null;
    default:
      throw new Error("Unsupported filter type: ".concat(e));
  }
}
function UQ(e) {
  var t = e.filter, s = e.context, i = e.key;
  return t.conditions.length ? t.conditions.reduce(function(r, n) {
    var o = lR(n.filterType, n.type), a = As(cR({
      filter: n,
      key: i,
      context: s,
      operationType: o
    }), 2), l = a[0], c = a[1];
    return c && r.push(Uc({}, l, c)), r;
  }, []) : {};
}
function $Q(e) {
  var t = e.filter, s = e.context, i = e.key;
  return t.filterModels ? t.filterModels.reduce(function(r, n) {
    var o;
    if (!n)
      return r;
    var a = _p((o = {}, o[i] = Ee({}, n), o), s);
    return Jl(r, a, tc);
  }, {}) : {};
}
function cR(e) {
  var t, s, i, r = e.filter, n = e.key, o = e.operationType, a = e.context;
  return OQ(r) ? [r.operator.toLowerCase(), UQ({ filter: r, key: n, context: a })] : kQ(r) ? ["", $Q({ filter: r, key: n, context: a })] : IQ(r) ? [n, { in: r.values }] : NQ(r) ? [n, { in: r.values }] : o ? GQ(r) ? [n, (t = {}, t[o] = r.filter, t)] : LQ(r) && r.dateFrom ? [n, (s = {}, s[o] = fP(r.dateFrom, "UTC").toISOString(), s)] : BQ(r) || VQ(r) ? [n, (i = {}, i[o] = null, i)] : [n, null] : [n, null];
}
function jQ(e) {
  var t = e.acc, s = e.context, i = e.fieldPath, r = e.filterValue, n = e.filterValueGetter;
  if (!r)
    return t;
  var o = Uc({}, i, n(r, s));
  return Jl(t, o, tc);
}
function _p(e, t, s) {
  if (e)
    return Object.entries(e).reduce(function(i, r) {
      var n, o, a = As(r, 2), l = a[0], c = a[1], d = "type" in c, u = d ? lR(c.filterType, c.type) : null, h = (o = (n = s == null ? void 0 : s.get(l)) === null || n === void 0 ? void 0 : n.server) !== null && o !== void 0 ? o : {}, p = h.filterValueGetter, g = h.filterFieldPath, f = As(cR({
        filter: c,
        key: g ?? l,
        context: t,
        operationType: u
      }), 2), m = f[0], C = f[1];
      return p ? jQ({
        acc: i,
        context: t,
        fieldPath: m,
        filterValue: C,
        filterValueGetter: p
      }) : Hx(C) ? i : m || g ? Jl(i, Uc({}, m, C), tc) : Jl(i, C, tc);
    }, {});
}
function KQ(e, t, s) {
  return typeof e == "function" ? e(s, t) : e ?? t;
}
function qQ(e, t) {
  return e.reduce(function(s, i) {
    var r, n, o = i.colId, a = i.sort, l = (n = (r = t == null ? void 0 : t.get(o)) === null || r === void 0 ? void 0 : r.server) !== null && n !== void 0 ? n : {}, c = l.sortFieldPath, d = l.sortValueGetter, u = a === "asc" ? ec.Asc : ec.Desc, h = KQ(c, o, e), p = d ? d(u) : u;
    return Ar(Ar([], As(s), !1), [Uc({}, h, p)], !1);
  }, []);
}
function fre(e) {
  var t = e.getData, s = e.onDataReceived;
  return {
    getRows: function(i) {
      var r, n = i.api, o = i.context, a = i.parentNode, l = i.request, c = i.success, d = i.fail, u = (r = l.startRow) !== null && r !== void 0 ? r : 0, h = Pi(l.endRow) ? void 0 : l.endRow - u, p = iR(n.getAllGridColumns()), g = {
        skip: u,
        take: h,
        order: qQ(l.sortModel, p),
        where: _p(l.filterModel, o, p)
      };
      t(g, l, o, a).then(function(f) {
        var m = f.rowData, C = f.rowCount, w = f.meta;
        s == null || s(m, w, o), c({ rowData: m, rowCount: C });
      }).catch(function(f) {
        console.error(f), d();
      });
    }
  };
}
var dR = BC({
  onExport: function() {
    return null;
  },
  getColDefs: function() {
    return [];
  },
  registerGridApi: function() {
    return null;
  },
  getFilters: function() {
    return null;
  },
  getRowData: function() {
    return [];
  },
  getOpenedToolPanel: function() {
    return null;
  },
  getDataContextObject: function() {
    return null;
  },
  getSheetDataForExcel: function() {
  },
  getColIds: function() {
    return [];
  },
  getFilteredRowCount: function() {
    return 0;
  },
  setFilters: function() {
    return null;
  },
  refreshCells: function() {
    return null;
  },
  refreshServerSide: function() {
    return null;
  },
  applyServerSideTransaction: function() {
  },
  applyGridState: function() {
    return null;
  },
  getState: function() {
    return null;
  },
  addEventListener: function() {
    return null;
  },
  removeEventListener: function() {
    return null;
  },
  isEditModeActive: function() {
    return !1;
  },
  isGridReady: !1
});
function mre(e) {
  var t = e.children, s = As(le(), 2), i = s[0], r = s[1];
  Wt(function() {
    return function() {
      r(void 0);
    };
  }, []);
  var n = he(function() {
    !i || i.isDestroyed() || i.exportDataAsExcel();
  }, [i]), o = he(function(F) {
    if (!(!i || i.isDestroyed()))
      return i.getSheetDataForExcel(F);
  }, [i]), a = he(function() {
    if (!i || i.isDestroyed())
      return null;
    var F = i.getGridOption("context");
    return F ?? null;
  }, [i]), l = he(function() {
    if (!(!i || i.isDestroyed()))
      return i.getColumnDefs();
  }, [i]), c = he(function() {
    return !i || i.isDestroyed() ? [] : i.getAllGridColumns().map(function(F) {
      return F.getColId();
    });
  }, [i]), d = he(function() {
    var F;
    if (!i || i.isDestroyed())
      return null;
    var k = i.getFilterModel(), O = iR(i.getAllGridColumns()), D = (F = i.getGridOption("context")) !== null && F !== void 0 ? F : {};
    return {
      filterModel: k,
      filterInput: _p(k, D, O)
    };
  }, [i]), u = he(function() {
    if (!i || i.isDestroyed())
      return null;
    var F = i.getRowGroupColumns().length > 0;
    if (!F)
      return i.getDisplayedRowCount();
    var k = 0;
    return i.forEachNode(function(O) {
      var D, $;
      O.leafGroup && (k += ($ = (D = O.childrenAfterFilter) === null || D === void 0 ? void 0 : D.length) !== null && $ !== void 0 ? $ : 0);
    }, !1), k;
  }, [i]), h = he(function(F) {
    !i || i.isDestroyed() || i.setFilterModel(F);
  }, [i]), p = he(function(F) {
    return !i || i.isDestroyed() ? [] : F != null && F.length ? F.map(function(k) {
      var O;
      return (O = i.getRowNode(k)) === null || O === void 0 ? void 0 : O.data;
    }).filter(Boolean) : i.getRenderedNodes().map(function(k) {
      return k.data;
    });
  }, [i]), g = he(function() {
    return !i || i.isDestroyed() ? null : i.getState();
  }, [i]), f = he(function() {
    return i ? i.getOpenedToolPanel() : null;
  }, [i]), m = he(function(F) {
    !i || i.isDestroyed() || i.refreshCells(F);
  }, [i]), C = he(function(F) {
    !i || i.isDestroyed() || i.refreshServerSide(F);
  }, [i]), w = he(function(F) {
    if (!(!i || i.isDestroyed()))
      return i.applyServerSideTransaction(F);
  }, [i]), y = he(function() {
    for (var F = [], k = 0; k < arguments.length; k++)
      F[k] = arguments[k];
    !i || i.isDestroyed() || i.addEventListener.apply(i, Ar([], As(F), !1));
  }, [i]), b = he(function() {
    for (var F = [], k = 0; k < arguments.length; k++)
      F[k] = arguments[k];
    !i || i.isDestroyed() || i.removeEventListener.apply(i, Ar([], As(F), !1));
  }, [i]), x = he(function() {
    return !i || i.isDestroyed() ? !1 : !!i.getEditingCells().length;
  }, [i]), M = he(function(F, k) {
    var O = F.sort, D = F.columnSizing, $ = F.columnVisibility, j = F.columnPinning, J = F.rowGroup;
    return k.map(function(X) {
      var ie, Ce, ae, ge, Se, xe = X.colId, ce = Us(X, ["colId"]), Re = D == null ? void 0 : D.columnSizingModel.find(function($e) {
        return $e.colId === xe;
      }), De = O == null ? void 0 : O.sortModel.findIndex(function($e) {
        return $e.colId === xe;
      }), Xe = Pi(De) ? null : O == null ? void 0 : O.sortModel[De], He = null;
      return j != null && j.leftColIds.includes(xe) && (He = "left"), !He && (j != null && j.rightColIds.includes(xe)) && (He = "right"), {
        colId: xe,
        sort: (ie = Xe == null ? void 0 : Xe.sort) !== null && ie !== void 0 ? ie : null,
        sortIndex: De ?? null,
        width: (Ce = Re == null ? void 0 : Re.width) !== null && Ce !== void 0 ? Ce : ce.width,
        flex: (ae = Re == null ? void 0 : Re.flex) !== null && ae !== void 0 ? ae : ce.flex,
        hide: (ge = $ == null ? void 0 : $.hiddenColIds.includes(xe)) !== null && ge !== void 0 ? ge : null,
        rowGroup: (Se = J == null ? void 0 : J.groupColIds.includes(xe)) !== null && Se !== void 0 ? Se : null,
        pinned: He
      };
    });
  }, []), T = he(function(F) {
    if (!(!i || i.isDestroyed())) {
      var k = F.filter, O = F.columnOrder, D = O != null && O.orderedColIds.length ? i.getColumnState().sort(function(j, J) {
        var X = O.orderedColIds.indexOf(j.colId), ie = O.orderedColIds.indexOf(J.colId);
        return X - ie;
      }) : i.getColumnState(), $ = M(F, D);
      k != null && k.filterModel && i.setFilterModel(k.filterModel), i.applyColumnState({ state: $, applyOrder: !0 });
    }
  }, [i, M]);
  return /* @__PURE__ */ me.jsx(dR.Provider, { value: {
    onExport: n,
    getSheetDataForExcel: o,
    getColDefs: l,
    getColIds: c,
    registerGridApi: r,
    getState: g,
    getFilters: d,
    getFilteredRowCount: u,
    getRowData: p,
    getOpenedToolPanel: f,
    getDataContextObject: a,
    setFilters: h,
    refreshCells: m,
    refreshServerSide: C,
    applyGridState: T,
    applyServerSideTransaction: w,
    addEventListener: y,
    removeEventListener: b,
    isEditModeActive: x,
    isGridReady: !!i
  }, children: t });
}
var Up = function() {
  return _t(dR);
}, YQ = 16, XQ = function(e) {
  var t = e.api, s = e.numOfRows, i = s === void 0 ? 20 : s, r = Array.from(Array(i).keys()), n = t.getAllDisplayedVirtualColumns().filter(function(o) {
    return o.isVisible();
  }).map(function(o) {
    return o.getActualWidth() - YQ;
  });
  return /* @__PURE__ */ me.jsx(oP, { tabIndex: 0, role: "progressbar", children: /* @__PURE__ */ me.jsx(aP, { children: /* @__PURE__ */ me.jsx(lP, { children: r.map(function(o) {
    return /* @__PURE__ */ me.jsx(cP, { children: n.map(function(a, l) {
      return /* @__PURE__ */ me.jsx(dP, { children: /* @__PURE__ */ me.jsx(uP, { width: a }) }, l);
    }) }, o);
  }) }) }) });
}, Uu = { exports: {} }, Kr = {};
/** @license React v17.0.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CC;
function ZQ() {
  if (CC) return Kr;
  CC = 1;
  var e = kc(), t = q;
  function s(A) {
    for (var N = "https://reactjs.org/docs/error-decoder.html?invariant=" + A, B = 1; B < arguments.length; B++) N += "&args[]=" + encodeURIComponent(arguments[B]);
    return "Minified React error #" + A + "; visit " + N + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var i = 60106, r = 60107, n = 60108, o = 60114, a = 60109, l = 60110, c = 60112, d = 60113, u = 60120, h = 60115, p = 60116, g = 60121, f = 60117, m = 60119, C = 60129, w = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var y = Symbol.for;
    i = y("react.portal"), r = y("react.fragment"), n = y("react.strict_mode"), o = y("react.profiler"), a = y("react.provider"), l = y("react.context"), c = y("react.forward_ref"), d = y("react.suspense"), u = y("react.suspense_list"), h = y("react.memo"), p = y("react.lazy"), g = y("react.block"), f = y("react.fundamental"), m = y("react.scope"), C = y("react.debug_trace_mode"), w = y("react.legacy_hidden");
  }
  function b(A) {
    if (A == null) return null;
    if (typeof A == "function") return A.displayName || A.name || null;
    if (typeof A == "string") return A;
    switch (A) {
      case r:
        return "Fragment";
      case i:
        return "Portal";
      case o:
        return "Profiler";
      case n:
        return "StrictMode";
      case d:
        return "Suspense";
      case u:
        return "SuspenseList";
    }
    if (typeof A == "object") switch (A.$$typeof) {
      case l:
        return (A.displayName || "Context") + ".Consumer";
      case a:
        return (A._context.displayName || "Context") + ".Provider";
      case c:
        var N = A.render;
        return N = N.displayName || N.name || "", A.displayName || (N !== "" ? "ForwardRef(" + N + ")" : "ForwardRef");
      case h:
        return b(A.type);
      case g:
        return b(A._render);
      case p:
        N = A._payload, A = A._init;
        try {
          return b(A(N));
        } catch {
        }
    }
    return null;
  }
  var x = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, M = {};
  function T(A, N) {
    for (var B = A._threadCount | 0; B <= N; B++) A[B] = A._currentValue2, A._threadCount = B + 1;
  }
  function F(A, N, B, se) {
    if (se && (se = A.contextType, typeof se == "object" && se !== null)) return T(se, B), se[B];
    if (A = A.contextTypes) {
      B = {};
      for (var R in A) B[R] = N[R];
      N = B;
    } else N = M;
    return N;
  }
  for (var k = new Uint16Array(16), O = 0; 15 > O; O++) k[O] = O + 1;
  k[15] = 0;
  var D = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $ = Object.prototype.hasOwnProperty, j = {}, J = {};
  function X(A) {
    return $.call(J, A) ? !0 : $.call(j, A) ? !1 : D.test(A) ? J[A] = !0 : (j[A] = !0, !1);
  }
  function ie(A, N, B, se) {
    if (B !== null && B.type === 0) return !1;
    switch (typeof N) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return B !== null ? !B.acceptsBooleans : (A = A.toLowerCase().slice(0, 5), A !== "data-" && A !== "aria-");
      default:
        return !1;
    }
  }
  function Ce(A, N, B, se) {
    if (N === null || typeof N > "u" || ie(A, N, B)) return !0;
    if (B !== null) switch (B.type) {
      case 3:
        return !N;
      case 4:
        return N === !1;
      case 5:
        return isNaN(N);
      case 6:
        return isNaN(N) || 1 > N;
    }
    return !1;
  }
  function ae(A, N, B, se, R, V, z) {
    this.acceptsBooleans = N === 2 || N === 3 || N === 4, this.attributeName = se, this.attributeNamespace = R, this.mustUseProperty = B, this.propertyName = A, this.type = N, this.sanitizeURL = V, this.removeEmptyString = z;
  }
  var ge = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(A) {
    ge[A] = new ae(A, 0, !1, A, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(A) {
    var N = A[0];
    ge[N] = new ae(N, 1, !1, A[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(A) {
    ge[A] = new ae(A, 2, !1, A.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(A) {
    ge[A] = new ae(A, 2, !1, A, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(A) {
    ge[A] = new ae(A, 3, !1, A.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(A) {
    ge[A] = new ae(A, 3, !0, A, null, !1, !1);
  }), ["capture", "download"].forEach(function(A) {
    ge[A] = new ae(A, 4, !1, A, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(A) {
    ge[A] = new ae(A, 6, !1, A, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(A) {
    ge[A] = new ae(A, 5, !1, A.toLowerCase(), null, !1, !1);
  });
  var Se = /[\-:]([a-z])/g;
  function xe(A) {
    return A[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(A) {
    var N = A.replace(
      Se,
      xe
    );
    ge[N] = new ae(N, 1, !1, A, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(A) {
    var N = A.replace(Se, xe);
    ge[N] = new ae(N, 1, !1, A, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(A) {
    var N = A.replace(Se, xe);
    ge[N] = new ae(N, 1, !1, A, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(A) {
    ge[A] = new ae(A, 1, !1, A.toLowerCase(), null, !1, !1);
  }), ge.xlinkHref = new ae("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(A) {
    ge[A] = new ae(A, 1, !1, A.toLowerCase(), null, !0, !0);
  });
  var ce = /["'&<>]/;
  function Re(A) {
    if (typeof A == "boolean" || typeof A == "number") return "" + A;
    A = "" + A;
    var N = ce.exec(A);
    if (N) {
      var B = "", se, R = 0;
      for (se = N.index; se < A.length; se++) {
        switch (A.charCodeAt(se)) {
          case 34:
            N = "&quot;";
            break;
          case 38:
            N = "&amp;";
            break;
          case 39:
            N = "&#x27;";
            break;
          case 60:
            N = "&lt;";
            break;
          case 62:
            N = "&gt;";
            break;
          default:
            continue;
        }
        R !== se && (B += A.substring(R, se)), R = se + 1, B += N;
      }
      A = R !== se ? B + A.substring(R, se) : B;
    }
    return A;
  }
  function De(A, N) {
    var B = ge.hasOwnProperty(A) ? ge[A] : null, se;
    return (se = A !== "style") && (se = B !== null ? B.type === 0 : !(!(2 < A.length) || A[0] !== "o" && A[0] !== "O" || A[1] !== "n" && A[1] !== "N")), se || Ce(A, N, B) ? "" : B !== null ? (A = B.attributeName, se = B.type, se === 3 || se === 4 && N === !0 ? A + '=""' : (B.sanitizeURL && (N = "" + N), A + '="' + (Re(N) + '"'))) : X(A) ? A + '="' + (Re(N) + '"') : "";
  }
  function Xe(A, N) {
    return A === N && (A !== 0 || 1 / A === 1 / N) || A !== A && N !== N;
  }
  var He = typeof Object.is == "function" ? Object.is : Xe, $e = null, Ct = null, we = null, _e = !1, tt = !1, Oe = null, je = 0;
  function Qe() {
    if ($e === null) throw Error(s(321));
    return $e;
  }
  function Ue() {
    if (0 < je) throw Error(s(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function xt() {
    return we === null ? Ct === null ? (_e = !1, Ct = we = Ue()) : (_e = !0, we = Ct) : we.next === null ? (_e = !1, we = we.next = Ue()) : (_e = !0, we = we.next), we;
  }
  function qs(A, N, B, se) {
    for (; tt; ) tt = !1, je += 1, we = null, B = A(N, se);
    return Rs(), B;
  }
  function Rs() {
    $e = null, tt = !1, Ct = null, je = 0, we = Oe = null;
  }
  function pi(A, N) {
    return typeof N == "function" ? N(A) : N;
  }
  function cs(A, N, B) {
    if ($e = Qe(), we = xt(), _e) {
      var se = we.queue;
      if (N = se.dispatch, Oe !== null && (B = Oe.get(se), B !== void 0)) {
        Oe.delete(se), se = we.memoizedState;
        do
          se = A(se, B.action), B = B.next;
        while (B !== null);
        return we.memoizedState = se, [se, N];
      }
      return [we.memoizedState, N];
    }
    return A = A === pi ? typeof N == "function" ? N() : N : B !== void 0 ? B(N) : N, we.memoizedState = A, A = we.queue = { last: null, dispatch: null }, A = A.dispatch = ds.bind(null, $e, A), [we.memoizedState, A];
  }
  function vt(A, N) {
    if ($e = Qe(), we = xt(), N = N === void 0 ? null : N, we !== null) {
      var B = we.memoizedState;
      if (B !== null && N !== null) {
        var se = B[1];
        e: if (se === null) se = !1;
        else {
          for (var R = 0; R < se.length && R < N.length; R++) if (!He(N[R], se[R])) {
            se = !1;
            break e;
          }
          se = !0;
        }
        if (se) return B[0];
      }
    }
    return A = A(), we.memoizedState = [A, N], A;
  }
  function ds(A, N, B) {
    if (!(25 > je)) throw Error(s(301));
    if (A === $e) if (tt = !0, A = { action: B, next: null }, Oe === null && (Oe = /* @__PURE__ */ new Map()), B = Oe.get(N), B === void 0) Oe.set(N, A);
    else {
      for (N = B; N.next !== null; ) N = N.next;
      N.next = A;
    }
  }
  function Is() {
  }
  var Ze = null, Ys = { readContext: function(A) {
    var N = Ze.threadID;
    return T(A, N), A[N];
  }, useContext: function(A) {
    Qe();
    var N = Ze.threadID;
    return T(A, N), A[N];
  }, useMemo: vt, useReducer: cs, useRef: function(A) {
    $e = Qe(), we = xt();
    var N = we.memoizedState;
    return N === null ? (A = { current: A }, we.memoizedState = A) : N;
  }, useState: function(A) {
    return cs(pi, A);
  }, useLayoutEffect: function() {
  }, useCallback: function(A, N) {
    return vt(function() {
      return A;
    }, N);
  }, useImperativeHandle: Is, useEffect: Is, useDebugValue: Is, useDeferredValue: function(A) {
    return Qe(), A;
  }, useTransition: function() {
    return Qe(), [function(A) {
      A();
    }, !1];
  }, useOpaqueIdentifier: function() {
    return (Ze.identifierPrefix || "") + "R:" + (Ze.uniqueID++).toString(36);
  }, useMutableSource: function(A, N) {
    return Qe(), N(A._source);
  } }, Nr = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
  function Qi(A) {
    switch (A) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  var qe = { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }, ft = e({ menuitem: !0 }, qe), Ot = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Hr = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Ot).forEach(function(A) {
    Hr.forEach(function(N) {
      N = N + A.charAt(0).toUpperCase() + A.substring(1), Ot[N] = Ot[A];
    });
  });
  var Ls = /([A-Z])/g, Ii = /^ms-/, At = t.Children.toArray, gi = x.ReactCurrentDispatcher, Ji = { listing: !0, pre: !0, textarea: !0 }, fi = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, En = {}, er = {};
  function Dn(A) {
    if (A == null) return A;
    var N = "";
    return t.Children.forEach(A, function(B) {
      B != null && (N += B);
    }), N;
  }
  var zr = Object.prototype.hasOwnProperty, Wr = { children: null, dangerouslySetInnerHTML: null, suppressContentEditableWarning: null, suppressHydrationWarning: null };
  function _r(A, N) {
    if (A === void 0) throw Error(s(152, b(N) || "Component"));
  }
  function Fo(A, N, B) {
    function se(z, Y) {
      var K = Y.prototype && Y.prototype.isReactComponent, Le = F(Y, N, B, K), Fe = [], Pe = !1, Ge = { isMounted: function() {
        return !1;
      }, enqueueForceUpdate: function() {
        if (Fe === null) return null;
      }, enqueueReplaceState: function(Po, st) {
        Pe = !0, Fe = [st];
      }, enqueueSetState: function(Po, st) {
        if (Fe === null) return null;
        Fe.push(st);
      } };
      if (K) {
        if (K = new Y(z.props, Le, Ge), typeof Y.getDerivedStateFromProps == "function") {
          var ye = Y.getDerivedStateFromProps.call(null, z.props, K.state);
          ye != null && (K.state = e({}, K.state, ye));
        }
      } else if ($e = {}, K = Y(
        z.props,
        Le,
        Ge
      ), K = qs(Y, z.props, K, Le), K == null || K.render == null) {
        A = K, _r(A, Y);
        return;
      }
      if (K.props = z.props, K.context = Le, K.updater = Ge, Ge = K.state, Ge === void 0 && (K.state = Ge = null), typeof K.UNSAFE_componentWillMount == "function" || typeof K.componentWillMount == "function") if (typeof K.componentWillMount == "function" && typeof Y.getDerivedStateFromProps != "function" && K.componentWillMount(), typeof K.UNSAFE_componentWillMount == "function" && typeof Y.getDerivedStateFromProps != "function" && K.UNSAFE_componentWillMount(), Fe.length) {
        Ge = Fe;
        var Ne = Pe;
        if (Fe = null, Pe = !1, Ne && Ge.length === 1) K.state = Ge[0];
        else {
          ye = Ne ? Ge[0] : K.state;
          var Rt = !0;
          for (Ne = Ne ? 1 : 0; Ne < Ge.length; Ne++) {
            var wt = Ge[Ne];
            wt = typeof wt == "function" ? wt.call(K, ye, z.props, Le) : wt, wt != null && (Rt ? (Rt = !1, ye = e({}, ye, wt)) : e(ye, wt));
          }
          K.state = ye;
        }
      } else Fe = null;
      if (A = K.render(), _r(A, Y), typeof K.getChildContext == "function" && (z = Y.childContextTypes, typeof z == "object")) {
        var Gt = K.getChildContext();
        for (var ht in Gt) if (!(ht in z)) throw Error(s(108, b(Y) || "Unknown", ht));
      }
      Gt && (N = e({}, N, Gt));
    }
    for (; t.isValidElement(A); ) {
      var R = A, V = R.type;
      if (typeof V != "function") break;
      se(R, V);
    }
    return { child: A, context: N };
  }
  var Li = function() {
    function A(B, se, R) {
      t.isValidElement(B) ? B.type !== r ? B = [B] : (B = B.props.children, B = t.isValidElement(B) ? [B] : At(B)) : B = At(B), B = { type: null, domNamespace: Nr.html, children: B, childIndex: 0, context: M, footer: "" };
      var V = k[0];
      if (V === 0) {
        var z = k;
        V = z.length;
        var Y = 2 * V;
        if (!(65536 >= Y)) throw Error(s(304));
        var K = new Uint16Array(Y);
        for (K.set(z), k = K, k[0] = V + 1, z = V; z < Y - 1; z++) k[z] = z + 1;
        k[Y - 1] = 0;
      } else k[0] = k[V];
      this.threadID = V, this.stack = [B], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = se, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [], this.uniqueID = 0, this.identifierPrefix = R && R.identifierPrefix || "";
    }
    var N = A.prototype;
    return N.destroy = function() {
      if (!this.exhausted) {
        this.exhausted = !0, this.clearProviders();
        var B = this.threadID;
        k[B] = k[0], k[0] = B;
      }
    }, N.pushProvider = function(B) {
      var se = ++this.contextIndex, R = B.type._context, V = this.threadID;
      T(R, V);
      var z = R[V];
      this.contextStack[se] = R, this.contextValueStack[se] = z, R[V] = B.props.value;
    }, N.popProvider = function() {
      var B = this.contextIndex, se = this.contextStack[B], R = this.contextValueStack[B];
      this.contextStack[B] = null, this.contextValueStack[B] = null, this.contextIndex--, se[this.threadID] = R;
    }, N.clearProviders = function() {
      for (var B = this.contextIndex; 0 <= B; B--) this.contextStack[B][this.threadID] = this.contextValueStack[B];
    }, N.read = function(B) {
      if (this.exhausted) return null;
      var se = Ze;
      Ze = this;
      var R = gi.current;
      gi.current = Ys;
      try {
        for (var V = [""], z = !1; V[0].length < B; ) {
          if (this.stack.length === 0) {
            this.exhausted = !0;
            var Y = this.threadID;
            k[Y] = k[0], k[0] = Y;
            break;
          }
          var K = this.stack[this.stack.length - 1];
          if (z || K.childIndex >= K.children.length) {
            var Le = K.footer;
            if (Le !== "" && (this.previousWasTextNode = !1), this.stack.pop(), K.type === "select") this.currentSelectValue = null;
            else if (K.type != null && K.type.type != null && K.type.type.$$typeof === a) this.popProvider(K.type);
            else if (K.type === d) {
              this.suspenseDepth--;
              var Fe = V.pop();
              if (z) {
                z = !1;
                var Pe = K.fallbackFrame;
                if (!Pe) throw Error(s(303));
                this.stack.push(Pe), V[this.suspenseDepth] += "<!--$!-->";
                continue;
              } else V[this.suspenseDepth] += Fe;
            }
            V[this.suspenseDepth] += Le;
          } else {
            var Ge = K.children[K.childIndex++], ye = "";
            try {
              ye += this.render(Ge, K.context, K.domNamespace);
            } catch (Ne) {
              throw Ne != null && typeof Ne.then == "function" ? Error(s(294)) : Ne;
            } finally {
            }
            V.length <= this.suspenseDepth && V.push(""), V[this.suspenseDepth] += ye;
          }
        }
        return V[0];
      } finally {
        gi.current = R, Ze = se, Rs();
      }
    }, N.render = function(B, se, R) {
      if (typeof B == "string" || typeof B == "number")
        return R = "" + B, R === "" ? "" : this.makeStaticMarkup ? Re(R) : this.previousWasTextNode ? "<!-- -->" + Re(R) : (this.previousWasTextNode = !0, Re(R));
      if (se = Fo(B, se, this.threadID), B = se.child, se = se.context, B === null || B === !1) return "";
      if (!t.isValidElement(B)) {
        if (B != null && B.$$typeof != null)
          throw R = B.$$typeof, Error(R === i ? s(257) : s(258, R.toString()));
        return B = At(B), this.stack.push({ type: null, domNamespace: R, children: B, childIndex: 0, context: se, footer: "" }), "";
      }
      var V = B.type;
      if (typeof V == "string") return this.renderDOM(B, se, R);
      switch (V) {
        case w:
        case C:
        case n:
        case o:
        case u:
        case r:
          return B = At(B.props.children), this.stack.push({
            type: null,
            domNamespace: R,
            children: B,
            childIndex: 0,
            context: se,
            footer: ""
          }), "";
        case d:
          throw Error(s(294));
        case m:
          throw Error(s(343));
      }
      if (typeof V == "object" && V !== null) switch (V.$$typeof) {
        case c:
          $e = {};
          var z = V.render(B.props, B.ref);
          return z = qs(V.render, B.props, z, B.ref), z = At(z), this.stack.push({ type: null, domNamespace: R, children: z, childIndex: 0, context: se, footer: "" }), "";
        case h:
          return B = [t.createElement(V.type, e({ ref: B.ref }, B.props))], this.stack.push({ type: null, domNamespace: R, children: B, childIndex: 0, context: se, footer: "" }), "";
        case a:
          return V = At(B.props.children), R = { type: B, domNamespace: R, children: V, childIndex: 0, context: se, footer: "" }, this.pushProvider(B), this.stack.push(R), "";
        case l:
          V = B.type, z = B.props;
          var Y = this.threadID;
          return T(V, Y), V = At(z.children(V[Y])), this.stack.push({ type: B, domNamespace: R, children: V, childIndex: 0, context: se, footer: "" }), "";
        case f:
          throw Error(s(338));
        case p:
          return V = B.type, z = V._init, V = z(V._payload), B = [t.createElement(V, e({ ref: B.ref }, B.props))], this.stack.push({
            type: null,
            domNamespace: R,
            children: B,
            childIndex: 0,
            context: se,
            footer: ""
          }), "";
      }
      throw Error(s(130, V == null ? V : typeof V, ""));
    }, N.renderDOM = function(B, se, R) {
      var V = B.type.toLowerCase();
      if (!En.hasOwnProperty(V)) {
        if (!fi.test(V)) throw Error(s(65, V));
        En[V] = !0;
      }
      var z = B.props;
      if (V === "input") z = e({ type: void 0 }, z, { defaultChecked: void 0, defaultValue: void 0, value: z.value != null ? z.value : z.defaultValue, checked: z.checked != null ? z.checked : z.defaultChecked });
      else if (V === "textarea") {
        var Y = z.value;
        if (Y == null) {
          Y = z.defaultValue;
          var K = z.children;
          if (K != null) {
            if (Y != null) throw Error(s(92));
            if (Array.isArray(K)) {
              if (!(1 >= K.length)) throw Error(s(93));
              K = K[0];
            }
            Y = "" + K;
          }
          Y == null && (Y = "");
        }
        z = e({}, z, { value: void 0, children: "" + Y });
      } else if (V === "select") this.currentSelectValue = z.value != null ? z.value : z.defaultValue, z = e({}, z, { value: void 0 });
      else if (V === "option") {
        K = this.currentSelectValue;
        var Le = Dn(z.children);
        if (K != null) {
          var Fe = z.value != null ? z.value + "" : Le;
          if (Y = !1, Array.isArray(K)) {
            for (var Pe = 0; Pe < K.length; Pe++)
              if ("" + K[Pe] === Fe) {
                Y = !0;
                break;
              }
          } else Y = "" + K === Fe;
          z = e(
            { selected: void 0, children: void 0 },
            z,
            { selected: Y, children: Le }
          );
        }
      }
      if (Y = z) {
        if (ft[V] && (Y.children != null || Y.dangerouslySetInnerHTML != null)) throw Error(s(137, V));
        if (Y.dangerouslySetInnerHTML != null) {
          if (Y.children != null) throw Error(s(60));
          if (!(typeof Y.dangerouslySetInnerHTML == "object" && "__html" in Y.dangerouslySetInnerHTML)) throw Error(s(61));
        }
        if (Y.style != null && typeof Y.style != "object") throw Error(s(62));
      }
      Y = z, K = this.makeStaticMarkup, Le = this.stack.length === 1, Fe = "<" + B.type;
      e: if (V.indexOf("-") === -1) Pe = typeof Y.is == "string";
      else switch (V) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          Pe = !1;
          break e;
        default:
          Pe = !0;
      }
      for (st in Y) if (zr.call(Y, st)) {
        var Ge = Y[st];
        if (Ge != null) {
          if (st === "style") {
            var ye = void 0, Ne = "", Rt = "";
            for (ye in Ge) if (Ge.hasOwnProperty(ye)) {
              var wt = ye.indexOf("--") === 0, Gt = Ge[ye];
              if (Gt != null) {
                if (wt) var ht = ye;
                else if (ht = ye, er.hasOwnProperty(ht)) ht = er[ht];
                else {
                  var Po = ht.replace(Ls, "-$1").toLowerCase().replace(Ii, "-ms-");
                  ht = er[ht] = Po;
                }
                Ne += Rt + ht + ":", Rt = ye, wt = Gt == null || typeof Gt == "boolean" || Gt === "" ? "" : wt || typeof Gt != "number" || Gt === 0 || Ot.hasOwnProperty(Rt) && Ot[Rt] ? ("" + Gt).trim() : Gt + "px", Ne += wt, Rt = ";";
              }
            }
            Ge = Ne || null;
          }
          ye = null, Pe ? Wr.hasOwnProperty(st) || (ye = st, ye = X(ye) && Ge != null ? ye + '="' + (Re(Ge) + '"') : "") : ye = De(st, Ge), ye && (Fe += " " + ye);
        }
      }
      K || Le && (Fe += ' data-reactroot=""');
      var st = Fe;
      Y = "", qe.hasOwnProperty(V) ? st += "/>" : (st += ">", Y = "</" + B.type + ">");
      e: {
        if (K = z.dangerouslySetInnerHTML, K != null) {
          if (K.__html != null) {
            K = K.__html;
            break e;
          }
        } else if (K = z.children, typeof K == "string" || typeof K == "number") {
          K = Re(K);
          break e;
        }
        K = null;
      }
      return K != null ? (z = [], Ji.hasOwnProperty(V) && K.charAt(0) === `
` && (st += `
`), st += K) : z = At(z.children), B = B.type, R = R == null || R === "http://www.w3.org/1999/xhtml" ? Qi(B) : R === "http://www.w3.org/2000/svg" && B === "foreignObject" ? "http://www.w3.org/1999/xhtml" : R, this.stack.push({ domNamespace: R, type: V, children: z, childIndex: 0, context: se, footer: Y }), this.previousWasTextNode = !1, st;
    }, A;
  }();
  return Kr.renderToNodeStream = function() {
    throw Error(s(207));
  }, Kr.renderToStaticMarkup = function(A, N) {
    A = new Li(A, !0, N);
    try {
      return A.read(1 / 0);
    } finally {
      A.destroy();
    }
  }, Kr.renderToStaticNodeStream = function() {
    throw Error(s(208));
  }, Kr.renderToString = function(A, N) {
    A = new Li(A, !1, N);
    try {
      return A.read(1 / 0);
    } finally {
      A.destroy();
    }
  }, Kr.version = "17.0.2", Kr;
}
var qr = {};
/** @license React v17.0.2
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vC;
function QQ() {
  return vC || (vC = 1, process.env.NODE_ENV !== "production" && function() {
    var e = q, t = kc();
    function s(v) {
      for (var S = "https://reactjs.org/docs/error-decoder.html?invariant=" + v, G = 1; G < arguments.length; G++)
        S += "&args[]=" + encodeURIComponent(arguments[G]);
      return "Minified React error #" + v + "; visit " + S + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var i = "17.0.2", r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(v) {
      {
        for (var S = arguments.length, G = new Array(S > 1 ? S - 1 : 0), H = 1; H < S; H++)
          G[H - 1] = arguments[H];
        a("warn", v, G);
      }
    }
    function o(v) {
      {
        for (var S = arguments.length, G = new Array(S > 1 ? S - 1 : 0), H = 1; H < S; H++)
          G[H - 1] = arguments[H];
        a("error", v, G);
      }
    }
    function a(v, S, G) {
      {
        var H = r.ReactDebugCurrentFrame, U = H.getStackAddendum();
        U !== "" && (S += "%s", G = G.concat([U]));
        var ne = G.map(function(ee) {
          return "" + ee;
        });
        ne.unshift("Warning: " + S), Function.prototype.apply.call(console[v], console, ne);
      }
    }
    var l = 60106, c = 60107, d = 60108, u = 60114, h = 60109, p = 60110, g = 60112, f = 60113, m = 60120, C = 60115, w = 60116, y = 60121, b = 60117, x = 60119, M = 60129, T = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var F = Symbol.for;
      F("react.element"), l = F("react.portal"), c = F("react.fragment"), d = F("react.strict_mode"), u = F("react.profiler"), h = F("react.provider"), p = F("react.context"), g = F("react.forward_ref"), f = F("react.suspense"), m = F("react.suspense_list"), C = F("react.memo"), w = F("react.lazy"), y = F("react.block"), F("react.server.block"), b = F("react.fundamental"), x = F("react.scope"), F("react.opaque.id"), M = F("react.debug_trace_mode"), F("react.offscreen"), T = F("react.legacy_hidden");
    }
    function k(v, S, G) {
      var H = S.displayName || S.name || "";
      return v.displayName || (H !== "" ? G + "(" + H + ")" : G);
    }
    function O(v) {
      return v.displayName || "Context";
    }
    function D(v) {
      if (v == null)
        return null;
      if (typeof v.tag == "number" && o("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof v == "function")
        return v.displayName || v.name || null;
      if (typeof v == "string")
        return v;
      switch (v) {
        case c:
          return "Fragment";
        case l:
          return "Portal";
        case u:
          return "Profiler";
        case d:
          return "StrictMode";
        case f:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case p:
            var S = v;
            return O(S) + ".Consumer";
          case h:
            var G = v;
            return O(G._context) + ".Provider";
          case g:
            return k(v, v.render, "ForwardRef");
          case C:
            return D(v.type);
          case y:
            return D(v._render);
          case w: {
            var H = v, U = H._payload, ne = H._init;
            try {
              return D(ne(U));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = !1, j = 0, J, X, ie, Ce, ae, ge, Se;
    function xe() {
    }
    xe.__reactDisabledLog = !0;
    function ce() {
      {
        if (j === 0) {
          J = console.log, X = console.info, ie = console.warn, Ce = console.error, ae = console.group, ge = console.groupCollapsed, Se = console.groupEnd;
          var v = {
            configurable: !0,
            enumerable: !0,
            value: xe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: v,
            log: v,
            warn: v,
            error: v,
            group: v,
            groupCollapsed: v,
            groupEnd: v
          });
        }
        j++;
      }
    }
    function Re() {
      {
        if (j--, j === 0) {
          var v = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: t({}, v, {
              value: J
            }),
            info: t({}, v, {
              value: X
            }),
            warn: t({}, v, {
              value: ie
            }),
            error: t({}, v, {
              value: Ce
            }),
            group: t({}, v, {
              value: ae
            }),
            groupCollapsed: t({}, v, {
              value: ge
            }),
            groupEnd: t({}, v, {
              value: Se
            })
          });
        }
        j < 0 && o("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = r.ReactCurrentDispatcher, Xe;
    function He(v, S, G) {
      {
        if (Xe === void 0)
          try {
            throw Error();
          } catch (U) {
            var H = U.stack.trim().match(/\n( *(at )?)/);
            Xe = H && H[1] || "";
          }
        return `
` + Xe + v;
      }
    }
    var $e = !1, Ct;
    {
      var we = typeof WeakMap == "function" ? WeakMap : Map;
      Ct = new we();
    }
    function _e(v, S) {
      if (!v || $e)
        return "";
      {
        var G = Ct.get(v);
        if (G !== void 0)
          return G;
      }
      var H;
      $e = !0;
      var U = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ne;
      ne = De.current, De.current = null, ce();
      try {
        if (S) {
          var ee = function() {
            throw Error();
          };
          if (Object.defineProperty(ee.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ee, []);
            } catch (mt) {
              H = mt;
            }
            Reflect.construct(v, [], ee);
          } else {
            try {
              ee.call();
            } catch (mt) {
              H = mt;
            }
            v.call(ee.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (mt) {
            H = mt;
          }
          v();
        }
      } catch (mt) {
        if (mt && H && typeof mt.stack == "string") {
          for (var oe = mt.stack.split(`
`), te = H.stack.split(`
`), Be = oe.length - 1, Ve = te.length - 1; Be >= 1 && Ve >= 0 && oe[Be] !== te[Ve]; )
            Ve--;
          for (; Be >= 1 && Ve >= 0; Be--, Ve--)
            if (oe[Be] !== te[Ve]) {
              if (Be !== 1 || Ve !== 1)
                do
                  if (Be--, Ve--, Ve < 0 || oe[Be] !== te[Ve]) {
                    var Ft = `
` + oe[Be].replace(" at new ", " at ");
                    return typeof v == "function" && Ct.set(v, Ft), Ft;
                  }
                while (Be >= 1 && Ve >= 0);
              break;
            }
        }
      } finally {
        $e = !1, De.current = ne, Re(), Error.prepareStackTrace = U;
      }
      var Bt = v ? v.displayName || v.name : "", ve = Bt ? He(Bt) : "";
      return typeof v == "function" && Ct.set(v, ve), ve;
    }
    function tt(v, S, G) {
      return _e(v, !1);
    }
    function Oe(v) {
      var S = v.prototype;
      return !!(S && S.isReactComponent);
    }
    function je(v, S, G) {
      if (v == null)
        return "";
      if (typeof v == "function")
        return _e(v, Oe(v));
      if (typeof v == "string")
        return He(v);
      switch (v) {
        case f:
          return He("Suspense");
        case m:
          return He("SuspenseList");
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case g:
            return tt(v.render);
          case C:
            return je(v.type, S, G);
          case y:
            return tt(v._render);
          case w: {
            var H = v, U = H._payload, ne = H._init;
            try {
              return je(ne(U), S, G);
            } catch {
            }
          }
        }
      return "";
    }
    var Qe = {}, Ue = r.ReactDebugCurrentFrame;
    function xt(v) {
      if (v) {
        var S = v._owner, G = je(v.type, v._source, S ? S.type : null);
        Ue.setExtraStackFrame(G);
      } else
        Ue.setExtraStackFrame(null);
    }
    function qs(v, S, G, H, U) {
      {
        var ne = Function.call.bind(Object.prototype.hasOwnProperty);
        for (var ee in v)
          if (ne(v, ee)) {
            var oe = void 0;
            try {
              if (typeof v[ee] != "function") {
                var te = Error((H || "React class") + ": " + G + " type `" + ee + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[ee] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              oe = v[ee](S, ee, H, G, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Be) {
              oe = Be;
            }
            oe && !(oe instanceof Error) && (xt(U), o("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", H, G, ee, typeof oe), xt(null)), oe instanceof Error && !(oe.message in Qe) && (Qe[oe.message] = !0, xt(U), o("Failed %s type: %s", G, oe.message), xt(null));
          }
      }
    }
    var Rs;
    Rs = /* @__PURE__ */ new Set();
    var pi = {};
    Object.freeze(pi);
    function cs(v, S) {
      var G = v.contextTypes;
      if (!G)
        return pi;
      var H = {};
      for (var U in G)
        H[U] = S[U];
      return H;
    }
    function vt(v, S, G) {
      qs(v, S, G, "Component");
    }
    function ds(v, S) {
      for (var G = v._threadCount | 0; G <= S; G++)
        v[G] = v._currentValue2, v._threadCount = G + 1;
    }
    function Is(v, S, G, H) {
      if (H) {
        var U = v.contextType;
        if ("contextType" in v) {
          var ne = (
            // Allow null for conditional declaration
            U === null || U !== void 0 && U.$$typeof === p && U._context === void 0
          );
          if (!ne && !Rs.has(v)) {
            Rs.add(v);
            var ee = "";
            U === void 0 ? ee = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof U != "object" ? ee = " However, it is set to a " + typeof U + "." : U.$$typeof === h ? ee = " Did you accidentally pass the Context.Provider instead?" : U._context !== void 0 ? ee = " Did you accidentally pass the Context.Consumer instead?" : ee = " However, it is set to an object with keys {" + Object.keys(U).join(", ") + "}.", o("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", D(v) || "Component", ee);
          }
        }
        if (typeof U == "object" && U !== null)
          return ds(U, G), U[G];
        {
          var oe = cs(v, S);
          return v.contextTypes && vt(v.contextTypes, oe, "context"), oe;
        }
      } else {
        var te = cs(v, S);
        return v.contextTypes && vt(v.contextTypes, te, "context"), te;
      }
    }
    for (var Ze = new Uint16Array(16), Ys = 0; Ys < 15; Ys++)
      Ze[Ys] = Ys + 1;
    Ze[15] = 0;
    function Nr() {
      var v = Ze, S = v.length, G = S * 2;
      if (!(G <= 65536))
        throw Error("Maximum number of concurrent React renderers exceeded. This can happen if you are not properly destroying the Readable provided by React. Ensure that you call .destroy() on it if you no longer want to read from it, and did not read to the end. If you use .pipe() this should be automatic.");
      var H = new Uint16Array(G);
      H.set(v), Ze = H, Ze[0] = S + 1;
      for (var U = S; U < G - 1; U++)
        Ze[U] = U + 1;
      return Ze[G - 1] = 0, S;
    }
    function Qi() {
      var v = Ze[0];
      return v === 0 ? Nr() : (Ze[0] = Ze[v], v);
    }
    function qe(v) {
      Ze[v] = Ze[0], Ze[0] = v;
    }
    var ft = 0, Ot = 1, Hr = 2, Ls = 3, Ii = 4, At = 5, gi = 6, Ji = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", fi = Ji + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", En = "data-reactroot", er = new RegExp("^[" + Ji + "][" + fi + "]*$"), Dn = Object.prototype.hasOwnProperty, zr = {}, Wr = {};
    function _r(v) {
      return Dn.call(Wr, v) ? !0 : Dn.call(zr, v) ? !1 : er.test(v) ? (Wr[v] = !0, !0) : (zr[v] = !0, o("Invalid attribute name: `%s`", v), !1);
    }
    function Fo(v, S, G) {
      return S !== null ? S.type === ft : v.length > 2 && (v[0] === "o" || v[0] === "O") && (v[1] === "n" || v[1] === "N");
    }
    function Li(v, S, G, H) {
      if (G !== null && G.type === ft)
        return !1;
      switch (typeof S) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (G !== null)
            return !G.acceptsBooleans;
          var U = v.toLowerCase().slice(0, 5);
          return U !== "data-" && U !== "aria-";
        }
        default:
          return !1;
      }
    }
    function A(v, S, G, H) {
      if (S === null || typeof S > "u" || Li(v, S, G))
        return !0;
      if (G !== null)
        switch (G.type) {
          case Ls:
            return !S;
          case Ii:
            return S === !1;
          case At:
            return isNaN(S);
          case gi:
            return isNaN(S) || S < 1;
        }
      return !1;
    }
    function N(v) {
      return se.hasOwnProperty(v) ? se[v] : null;
    }
    function B(v, S, G, H, U, ne, ee) {
      this.acceptsBooleans = S === Hr || S === Ls || S === Ii, this.attributeName = H, this.attributeNamespace = U, this.mustUseProperty = G, this.propertyName = v, this.type = S, this.sanitizeURL = ne, this.removeEmptyString = ee;
    }
    var se = {}, R = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    R.forEach(function(v) {
      se[v] = new B(
        v,
        ft,
        !1,
        // mustUseProperty
        v,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(v) {
      var S = v[0], G = v[1];
      se[S] = new B(
        S,
        Ot,
        !1,
        // mustUseProperty
        G,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(v) {
      se[v] = new B(
        v,
        Hr,
        !1,
        // mustUseProperty
        v.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(v) {
      se[v] = new B(
        v,
        Hr,
        !1,
        // mustUseProperty
        v,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(v) {
      se[v] = new B(
        v,
        Ls,
        !1,
        // mustUseProperty
        v.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(v) {
      se[v] = new B(
        v,
        Ls,
        !0,
        // mustUseProperty
        v,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(v) {
      se[v] = new B(
        v,
        Ii,
        !1,
        // mustUseProperty
        v,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(v) {
      se[v] = new B(
        v,
        gi,
        !1,
        // mustUseProperty
        v,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(v) {
      se[v] = new B(
        v,
        At,
        !1,
        // mustUseProperty
        v.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var V = /[\-\:]([a-z])/g, z = function(v) {
      return v[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(v) {
      var S = v.replace(V, z);
      se[S] = new B(
        S,
        Ot,
        !1,
        // mustUseProperty
        v,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(v) {
      var S = v.replace(V, z);
      se[S] = new B(
        S,
        Ot,
        !1,
        // mustUseProperty
        v,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(v) {
      var S = v.replace(V, z);
      se[S] = new B(
        S,
        Ot,
        !1,
        // mustUseProperty
        v,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(v) {
      se[v] = new B(
        v,
        Ot,
        !1,
        // mustUseProperty
        v.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Y = "xlinkHref";
    se[Y] = new B(
      "xlinkHref",
      Ot,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(v) {
      se[v] = new B(
        v,
        Ot,
        !1,
        // mustUseProperty
        v.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var K = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Le = !1;
    function Fe(v) {
      !Le && K.test(v) && (Le = !0, o("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(v)));
    }
    var Pe = /["'&<>]/;
    function Ge(v) {
      var S = "" + v, G = Pe.exec(S);
      if (!G)
        return S;
      var H, U = "", ne, ee = 0;
      for (ne = G.index; ne < S.length; ne++) {
        switch (S.charCodeAt(ne)) {
          case 34:
            H = "&quot;";
            break;
          case 38:
            H = "&amp;";
            break;
          case 39:
            H = "&#x27;";
            break;
          case 60:
            H = "&lt;";
            break;
          case 62:
            H = "&gt;";
            break;
          default:
            continue;
        }
        ee !== ne && (U += S.substring(ee, ne)), ee = ne + 1, U += H;
      }
      return ee !== ne ? U + S.substring(ee, ne) : U;
    }
    function ye(v) {
      return typeof v == "boolean" || typeof v == "number" ? "" + v : Ge(v);
    }
    function Ne(v) {
      return '"' + ye(v) + '"';
    }
    function Rt() {
      return En + '=""';
    }
    function wt(v, S) {
      var G = N(v);
      if (v !== "style" && Fo(v, G) || A(v, S, G))
        return "";
      if (G !== null) {
        var H = G.attributeName, U = G.type;
        return U === Ls || U === Ii && S === !0 ? H + '=""' : (G.sanitizeURL && (S = "" + S, Fe(S)), H + "=" + Ne(S));
      } else if (_r(v))
        return v + "=" + Ne(S);
      return "";
    }
    function Gt(v, S) {
      return !_r(v) || S == null ? "" : v + "=" + Ne(S);
    }
    function ht(v, S) {
      return v === S && (v !== 0 || 1 / v === 1 / S) || v !== v && S !== S;
    }
    var Po = typeof Object.is == "function" ? Object.is : ht, st = null, Ia = null, it = null, To = !1, La = !1, tr = null, ka = 0, MR = 25, mi = !1, An;
    function Ur() {
      if (st === null)
        throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return mi && o("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), st;
    }
    function IR(v, S) {
      if (S === null)
        return o("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", An), !1;
      v.length !== S.length && o(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, An, "[" + v.join(", ") + "]", "[" + S.join(", ") + "]");
      for (var G = 0; G < S.length && G < v.length; G++)
        if (!Po(v[G], S[G]))
          return !1;
      return !0;
    }
    function $p() {
      if (ka > 0)
        throw Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function $c() {
      return it === null ? Ia === null ? (To = !1, Ia = it = $p()) : (To = !0, it = Ia) : it.next === null ? (To = !1, it = it.next = $p()) : (To = !0, it = it.next), it;
    }
    function jp(v) {
      st = v, mi = !1;
    }
    function Kp(v, S, G, H) {
      for (; La; )
        La = !1, ka += 1, it = null, G = v(S, H);
      return qp(), G;
    }
    function qp() {
      mi = !1, st = null, La = !1, Ia = null, ka = 0, tr = null, it = null;
    }
    function LR(v, S) {
      var G = Mn.threadID;
      return ds(v, G), mi && o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), v[G];
    }
    function kR(v, S) {
      An = "useContext", Ur();
      var G = Mn.threadID;
      return ds(v, G), v[G];
    }
    function jc(v, S) {
      return typeof S == "function" ? S(v) : S;
    }
    function OR(v) {
      return An = "useState", Yp(
        jc,
        // useReducer has a special case to support lazy useState initializers
        v
      );
    }
    function Yp(v, S, G) {
      if (v !== jc && (An = "useReducer"), st = Ur(), it = $c(), To) {
        var H = it.queue, U = H.dispatch;
        if (tr !== null) {
          var ne = tr.get(H);
          if (ne !== void 0) {
            tr.delete(H);
            var ee = it.memoizedState, oe = ne;
            do {
              var te = oe.action;
              mi = !0, ee = v(ee, te), mi = !1, oe = oe.next;
            } while (oe !== null);
            return it.memoizedState = ee, [ee, U];
          }
        }
        return [it.memoizedState, U];
      } else {
        mi = !0;
        var Be;
        v === jc ? Be = typeof S == "function" ? S() : S : Be = G !== void 0 ? G(S) : S, mi = !1, it.memoizedState = Be;
        var Ve = it.queue = {
          last: null,
          dispatch: null
        }, Ft = Ve.dispatch = VR.bind(null, st, Ve);
        return [it.memoizedState, Ft];
      }
    }
    function Xp(v, S) {
      st = Ur(), it = $c();
      var G = S === void 0 ? null : S;
      if (it !== null) {
        var H = it.memoizedState;
        if (H !== null && G !== null) {
          var U = H[1];
          if (IR(G, U))
            return H[0];
        }
      }
      mi = !0;
      var ne = v();
      return mi = !1, it.memoizedState = [ne, G], ne;
    }
    function GR(v) {
      st = Ur(), it = $c();
      var S = it.memoizedState;
      if (S === null) {
        var G = {
          current: v
        };
        return Object.seal(G), it.memoizedState = G, G;
      } else
        return S;
    }
    function BR(v, S) {
      An = "useLayoutEffect", o("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function VR(v, S, G) {
      if (!(ka < MR))
        throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (v === st) {
        La = !0;
        var H = {
          action: G,
          next: null
        };
        tr === null && (tr = /* @__PURE__ */ new Map());
        var U = tr.get(S);
        if (U === void 0)
          tr.set(S, H);
        else {
          for (var ne = U; ne.next !== null; )
            ne = ne.next;
          ne.next = H;
        }
      }
    }
    function NR(v, S) {
      return Xp(function() {
        return v;
      }, S);
    }
    function HR(v, S, G) {
      return Ur(), S(v._source);
    }
    function zR(v) {
      return Ur(), v;
    }
    function WR() {
      Ur();
      var v = function(S) {
        S();
      };
      return [v, !1];
    }
    function _R() {
      return (Mn.identifierPrefix || "") + "R:" + (Mn.uniqueID++).toString(36);
    }
    function Kc() {
    }
    var Mn = null;
    function Zp(v) {
      Mn = v;
    }
    var UR = {
      readContext: LR,
      useContext: kR,
      useMemo: Xp,
      useReducer: Yp,
      useRef: GR,
      useState: OR,
      useLayoutEffect: BR,
      useCallback: NR,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: Kc,
      // Effects are not run in the server environment.
      useEffect: Kc,
      // Debugging effect
      useDebugValue: Kc,
      useDeferredValue: zR,
      useTransition: WR,
      useOpaqueIdentifier: _R,
      // Subscriptions are not setup in a server environment.
      useMutableSource: HR
    }, Oa = "http://www.w3.org/1999/xhtml", Qp = "http://www.w3.org/1998/Math/MathML", qc = "http://www.w3.org/2000/svg", Yc = {
      html: Oa,
      mathml: Qp,
      svg: qc
    };
    function Jp(v) {
      switch (v) {
        case "svg":
          return qc;
        case "math":
          return Qp;
        default:
          return Oa;
      }
    }
    function $R(v, S) {
      return v == null || v === Oa ? Jp(S) : v === qc && S === "foreignObject" ? Oa : v;
    }
    var jR = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Xc(v, S) {
      jR[S.type] || S.onChange || S.onInput || S.readOnly || S.disabled || S.value == null || o("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), S.onChange || S.readOnly || S.disabled || S.checked == null || o("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    var eg = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, KR = t({
      menuitem: !0
    }, eg), qR = "__html";
    function YR(v, S) {
      if (S) {
        if (KR[v] && !(S.children == null && S.dangerouslySetInnerHTML == null))
          throw Error(v + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (S.dangerouslySetInnerHTML != null) {
          if (S.children != null)
            throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (!(typeof S.dangerouslySetInnerHTML == "object" && qR in S.dangerouslySetInnerHTML))
            throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!S.suppressContentEditableWarning && S.contentEditable && S.children != null && o("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), !(S.style == null || typeof S.style == "object"))
          throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    var Eo = {
      animationIterationCount: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function XR(v, S) {
      return v + S.charAt(0).toUpperCase() + S.substring(1);
    }
    var ZR = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Eo).forEach(function(v) {
      ZR.forEach(function(S) {
        Eo[XR(S, v)] = Eo[v];
      });
    });
    function QR(v, S, G) {
      var H = S == null || typeof S == "boolean" || S === "";
      return H ? "" : !G && typeof S == "number" && S !== 0 && !(Eo.hasOwnProperty(v) && Eo[v]) ? S + "px" : ("" + S).trim();
    }
    var JR = /([A-Z])/g, eF = /^ms-/;
    function tF(v) {
      return v.replace(JR, "-$1").toLowerCase().replace(eF, "-ms-");
    }
    function Zc(v, S) {
      if (v.indexOf("-") === -1)
        return typeof S.is == "string";
      switch (v) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var tg = function() {
    };
    {
      var sF = /^(?:webkit|moz|o)[A-Z]/, iF = /^-ms-/, rF = /-(.)/g, sg = /;\s*$/, In = {}, Qc = {}, ig = !1, rg = !1, nF = function(v) {
        return v.replace(rF, function(S, G) {
          return G.toUpperCase();
        });
      }, oF = function(v) {
        In.hasOwnProperty(v) && In[v] || (In[v] = !0, o(
          "Unsupported style property %s. Did you mean %s?",
          v,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          nF(v.replace(iF, "ms-"))
        ));
      }, aF = function(v) {
        In.hasOwnProperty(v) && In[v] || (In[v] = !0, o("Unsupported vendor-prefixed style property %s. Did you mean %s?", v, v.charAt(0).toUpperCase() + v.slice(1)));
      }, lF = function(v, S) {
        Qc.hasOwnProperty(S) && Qc[S] || (Qc[S] = !0, o(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, v, S.replace(sg, "")));
      }, cF = function(v, S) {
        ig || (ig = !0, o("`NaN` is an invalid value for the `%s` css style property.", v));
      }, dF = function(v, S) {
        rg || (rg = !0, o("`Infinity` is an invalid value for the `%s` css style property.", v));
      };
      tg = function(v, S) {
        v.indexOf("-") > -1 ? oF(v) : sF.test(v) ? aF(v) : sg.test(S) && lF(v, S), typeof S == "number" && (isNaN(S) ? cF(v, S) : isFinite(S) || dF(v, S));
      };
    }
    var uF = tg, ng = {
      "aria-current": 0,
      // state
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Ln = {}, hF = new RegExp("^(aria)-[" + fi + "]*$"), pF = new RegExp("^(aria)[A-Z][" + fi + "]*$"), gF = Object.prototype.hasOwnProperty;
    function fF(v, S) {
      {
        if (gF.call(Ln, S) && Ln[S])
          return !0;
        if (pF.test(S)) {
          var G = "aria-" + S.slice(4).toLowerCase(), H = ng.hasOwnProperty(G) ? G : null;
          if (H == null)
            return o("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", S), Ln[S] = !0, !0;
          if (S !== H)
            return o("Invalid ARIA attribute `%s`. Did you mean `%s`?", S, H), Ln[S] = !0, !0;
        }
        if (hF.test(S)) {
          var U = S.toLowerCase(), ne = ng.hasOwnProperty(U) ? U : null;
          if (ne == null)
            return Ln[S] = !0, !1;
          if (S !== ne)
            return o("Unknown ARIA attribute `%s`. Did you mean `%s`?", S, ne), Ln[S] = !0, !0;
        }
      }
      return !0;
    }
    function mF(v, S) {
      {
        var G = [];
        for (var H in S) {
          var U = fF(v, H);
          U || G.push(H);
        }
        var ne = G.map(function(ee) {
          return "`" + ee + "`";
        }).join(", ");
        G.length === 1 ? o("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", ne, v) : G.length > 1 && o("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", ne, v);
      }
    }
    function CF(v, S) {
      Zc(v, S) || mF(v, S);
    }
    var og = !1;
    function vF(v, S) {
      {
        if (v !== "input" && v !== "textarea" && v !== "select")
          return;
        S != null && S.value === null && !og && (og = !0, v === "select" && S.multiple ? o("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", v) : o("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", v));
      }
    }
    var ag = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, lg = function() {
    };
    {
      var Jt = {}, wF = Object.prototype.hasOwnProperty, cg = /^on./, yF = /^on[^A-Z]/, bF = new RegExp("^(aria)-[" + fi + "]*$"), SF = new RegExp("^(aria)[A-Z][" + fi + "]*$");
      lg = function(v, S, G, H) {
        if (wF.call(Jt, S) && Jt[S])
          return !0;
        var U = S.toLowerCase();
        if (U === "onfocusin" || U === "onfocusout")
          return o("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Jt[S] = !0, !0;
        if (H != null) {
          var ne = H.registrationNameDependencies, ee = H.possibleRegistrationNames;
          if (ne.hasOwnProperty(S))
            return !0;
          var oe = ee.hasOwnProperty(U) ? ee[U] : null;
          if (oe != null)
            return o("Invalid event handler property `%s`. Did you mean `%s`?", S, oe), Jt[S] = !0, !0;
          if (cg.test(S))
            return o("Unknown event handler property `%s`. It will be ignored.", S), Jt[S] = !0, !0;
        } else if (cg.test(S))
          return yF.test(S) && o("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", S), Jt[S] = !0, !0;
        if (bF.test(S) || SF.test(S))
          return !0;
        if (U === "innerhtml")
          return o("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Jt[S] = !0, !0;
        if (U === "aria")
          return o("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Jt[S] = !0, !0;
        if (U === "is" && G !== null && G !== void 0 && typeof G != "string")
          return o("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof G), Jt[S] = !0, !0;
        if (typeof G == "number" && isNaN(G))
          return o("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", S), Jt[S] = !0, !0;
        var te = N(S), Be = te !== null && te.type === ft;
        if (ag.hasOwnProperty(U)) {
          var Ve = ag[U];
          if (Ve !== S)
            return o("Invalid DOM property `%s`. Did you mean `%s`?", S, Ve), Jt[S] = !0, !0;
        } else if (!Be && S !== U)
          return o("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", S, U), Jt[S] = !0, !0;
        return typeof G == "boolean" && Li(S, G, te) ? (G ? o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', G, S, S, G, S) : o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', G, S, S, G, S, S, S), Jt[S] = !0, !0) : Be ? !0 : Li(S, G, te) ? (Jt[S] = !0, !1) : ((G === "false" || G === "true") && te !== null && te.type === Ls && (o("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", G, S, G === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', S, G), Jt[S] = !0), !0);
      };
    }
    var xF = function(v, S, G) {
      {
        var H = [];
        for (var U in S) {
          var ne = lg(v, U, S[U], G);
          ne || H.push(U);
        }
        var ee = H.map(function(oe) {
          return "`" + oe + "`";
        }).join(", ");
        H.length === 1 ? o("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", ee, v) : H.length > 1 && o("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", ee, v);
      }
    };
    function RF(v, S, G) {
      Zc(v, S) || xF(v, S, G);
    }
    var sr = e.Children.toArray, ki = [], Jc = r.ReactCurrentDispatcher, Ga, ed = null, dg = function() {
      return "";
    }, ug = function(v) {
      return "";
    }, hg = function(v, S) {
    }, pg = function(v) {
    }, gg = function(v) {
    }, fg = function() {
    }, mg = !1;
    Ga = r.ReactDebugCurrentFrame, hg = function(v, S) {
      CF(v, S), vF(v, S), RF(v, S, null);
    }, ug = function(v) {
      return je(v.type, v._source, null);
    }, pg = function(v) {
      ki.push(v), ki.length === 1 && (ed = Ga.getCurrentStack, Ga.getCurrentStack = dg);
    }, gg = function(v) {
      var S = ki[ki.length - 1], G = S[S.length - 1];
      G.debugElementStack.push(v);
    }, fg = function() {
      ki.pop(), ki.length === 0 && (Ga.getCurrentStack = ed, ed = null);
    }, dg = function() {
      if (ki.length === 0)
        return "";
      for (var v = ki[ki.length - 1], S = "", G = v.length - 1; G >= 0; G--)
        for (var H = v[G], U = H.debugElementStack, ne = U.length - 1; ne >= 0; ne--)
          S += ug(U[ne]);
      return S;
    };
    var Cg = !1, vg = !1, wg = !1, yg = !1, bg = !1, Sg = {}, xg = {}, Rg = {}, Fg = {}, Pg = {}, Tg = {}, Eg = ["value", "defaultValue"], FF = {
      listing: !0,
      pre: !0,
      textarea: !0
    }, PF = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Dg = {};
    function TF(v) {
      if (!Dg.hasOwnProperty(v)) {
        if (!PF.test(v))
          throw Error("Invalid tag: " + v);
        Dg[v] = !0;
      }
    }
    var td = {}, EF = function(v) {
      if (td.hasOwnProperty(v))
        return td[v];
      var S = tF(v);
      return td[v] = S, S;
    };
    function DF(v) {
      var S = "", G = "";
      for (var H in v)
        if (v.hasOwnProperty(H)) {
          var U = H.indexOf("--") === 0, ne = v[H];
          U || uF(H, ne), ne != null && (S += G + (U ? H : EF(H)) + ":", S += QR(H, ne, U), G = ";");
        }
      return S || null;
    }
    function Ag(v, S) {
      {
        var G = v.constructor, H = G && D(G) || "ReactClass", U = H + "." + S;
        if (Sg[U])
          return;
        o(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, S, S, H), Sg[U] = !0;
      }
    }
    function AF(v) {
      return v.prototype && v.prototype.isReactComponent;
    }
    function MF(v) {
      var S = v.dangerouslySetInnerHTML;
      if (S != null) {
        if (S.__html != null)
          return S.__html;
      } else {
        var G = v.children;
        if (typeof G == "string" || typeof G == "number")
          return ye(G);
      }
      return null;
    }
    function IF(v) {
      if (!e.isValidElement(v))
        return sr(v);
      var S = v;
      if (S.type !== c)
        return [S];
      var G = S.props.children;
      if (!e.isValidElement(G))
        return sr(G);
      var H = G;
      return [H];
    }
    function LF(v) {
      if (v == null)
        return v;
      var S = "";
      return e.Children.forEach(v, function(G) {
        G != null && (S += G, !bg && typeof G != "string" && typeof G != "number" && (bg = !0, o("Only strings and numbers are supported as <option> children.")));
      }), S;
    }
    var kF = Object.prototype.hasOwnProperty, OF = "style", GF = {
      children: null,
      dangerouslySetInnerHTML: null,
      suppressContentEditableWarning: null,
      suppressHydrationWarning: null
    };
    function BF(v, S, G, H, U, ne) {
      var ee = "<" + v, oe = Zc(S, G);
      for (var te in G)
        if (kF.call(G, te)) {
          var Be = G[te];
          if (Be != null) {
            te === OF && (Be = DF(Be));
            var Ve = null;
            oe ? GF.hasOwnProperty(te) || (Ve = Gt(te, Be)) : Ve = wt(te, Be), Ve && (ee += " " + Ve);
          }
        }
      return U || ne && (ee += " " + Rt()), ee;
    }
    function Mg(v, S) {
      if (v === void 0)
        throw Error((D(S) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
    }
    function VF(v, S, G) {
      for (; e.isValidElement(v); ) {
        var H = v, U = H.type;
        if (gg(H), typeof U != "function")
          break;
        ne(H, U);
      }
      function ne(ee, oe) {
        var te = AF(oe), Be = Is(oe, S, G, te), Ve = [], Ft = !1, Bt = {
          isMounted: function(nr) {
            return !1;
          },
          enqueueForceUpdate: function(nr) {
            if (Ve === null)
              return Ag(nr, "forceUpdate"), null;
          },
          enqueueReplaceState: function(nr, On) {
            Ft = !0, Ve = [On];
          },
          enqueueSetState: function(nr, On) {
            if (Ve === null)
              return Ag(nr, "setState"), null;
            Ve.push(On);
          }
        }, ve;
        if (te) {
          if (ve = new oe(ee.props, Be, Bt), typeof oe.getDerivedStateFromProps == "function") {
            if (ve.state === null || ve.state === void 0) {
              var mt = D(oe) || "Unknown";
              Tg[mt] || (o("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", mt, ve.state === null ? "null" : "undefined", mt), Tg[mt] = !0);
            }
            var es = oe.getDerivedStateFromProps.call(null, ee.props, ve.state);
            if (es === void 0) {
              var us = D(oe) || "Unknown";
              Pg[us] || (o("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", us), Pg[us] = !0);
            }
            es != null && (ve.state = t({}, ve.state, es));
          }
        } else {
          if (oe.prototype && typeof oe.prototype.render == "function") {
            var hs = D(oe) || "Unknown";
            xg[hs] || (o("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", hs, hs), xg[hs] = !0);
          }
          var ir = {};
          if (jp(ir), ve = oe(ee.props, Be, Bt), ve = Kp(oe, ee.props, ve, Be), ve != null && ve.render != null) {
            var ks = D(oe) || "Unknown";
            Rg[ks] || (o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ks, ks, ks), Rg[ks] = !0);
          }
          if (ve == null || ve.render == null) {
            v = ve, Mg(v, oe);
            return;
          }
        }
        ve.props = ee.props, ve.context = Be, ve.updater = Bt;
        var Xs = ve.state;
        if (Xs === void 0 && (ve.state = Xs = null), typeof ve.UNSAFE_componentWillMount == "function" || typeof ve.componentWillMount == "function") {
          if (typeof ve.componentWillMount == "function") {
            if (ve.componentWillMount.__suppressDeprecationWarning !== !0) {
              var rr = D(oe) || "Unknown";
              Fg[rr] || (n(
                // keep this warning in sync with ReactStrictModeWarning.js
                `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
                rr
              ), Fg[rr] = !0);
            }
            typeof oe.getDerivedStateFromProps != "function" && ve.componentWillMount();
          }
          if (typeof ve.UNSAFE_componentWillMount == "function" && typeof oe.getDerivedStateFromProps != "function" && ve.UNSAFE_componentWillMount(), Ve.length) {
            var Os = Ve, Zs = Ft;
            if (Ve = null, Ft = !1, Zs && Os.length === 1)
              ve.state = Os[0];
            else {
              for (var Ci = Zs ? Os[0] : ve.state, Ba = !0, kn = Zs ? 1 : 0; kn < Os.length; kn++) {
                var Qs = Os[kn], Do = typeof Qs == "function" ? Qs.call(ve, Ci, ee.props, Be) : Qs;
                Do != null && (Ba ? (Ba = !1, Ci = t({}, Ci, Do)) : t(Ci, Do));
              }
              ve.state = Ci;
            }
          } else
            Ve = null;
        }
        v = ve.render(), v === void 0 && ve.render._isMockFunction && (v = null), Mg(v, oe);
        var $r;
        {
          if (typeof ve.getChildContext == "function") {
            var Va = oe.childContextTypes;
            if (typeof Va == "object") {
              $r = ve.getChildContext();
              for (var Na in $r)
                if (!(Na in Va))
                  throw Error((D(oe) || "Unknown") + '.getChildContext(): key "' + Na + '" is not defined in childContextTypes.');
            } else
              o("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", D(oe) || "Unknown");
          }
          $r && (S = t({}, S, $r));
        }
      }
      return {
        child: v,
        context: S
      };
    }
    var Ig = /* @__PURE__ */ function() {
      function v(G, H, U) {
        var ne = IF(G), ee = {
          type: null,
          // Assume all trees start in the HTML namespace (not totally true, but
          // this is what we did historically)
          domNamespace: Yc.html,
          children: ne,
          childIndex: 0,
          context: pi,
          footer: ""
        };
        ee.debugElementStack = [], this.threadID = Qi(), this.stack = [ee], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = H, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [], this.uniqueID = 0, this.identifierPrefix = U && U.identifierPrefix || "", this.contextProviderStack = [];
      }
      var S = v.prototype;
      return S.destroy = function() {
        this.exhausted || (this.exhausted = !0, this.clearProviders(), qe(this.threadID));
      }, S.pushProvider = function(H) {
        var U = ++this.contextIndex, ne = H.type._context, ee = this.threadID;
        ds(ne, ee);
        var oe = ne[ee];
        this.contextStack[U] = ne, this.contextValueStack[U] = oe, this.contextProviderStack[U] = H, ne[ee] = H.props.value;
      }, S.popProvider = function(H) {
        var U = this.contextIndex;
        (U < 0 || H !== this.contextProviderStack[U]) && o("Unexpected pop.");
        var ne = this.contextStack[U], ee = this.contextValueStack[U];
        this.contextStack[U] = null, this.contextValueStack[U] = null, this.contextProviderStack[U] = null, this.contextIndex--, ne[this.threadID] = ee;
      }, S.clearProviders = function() {
        for (var H = this.contextIndex; H >= 0; H--) {
          var U = this.contextStack[H], ne = this.contextValueStack[H];
          U[this.threadID] = ne;
        }
      }, S.read = function(H) {
        if (this.exhausted)
          return null;
        var U = Mn;
        Zp(this);
        var ne = Jc.current;
        Jc.current = UR;
        try {
          for (var ee = [""], oe = !1; ee[0].length < H; ) {
            if (this.stack.length === 0) {
              this.exhausted = !0, qe(this.threadID);
              break;
            }
            var te = this.stack[this.stack.length - 1];
            if (oe || te.childIndex >= te.children.length) {
              var Be = te.footer;
              if (Be !== "" && (this.previousWasTextNode = !1), this.stack.pop(), te.type === "select")
                this.currentSelectValue = null;
              else if (te.type != null && te.type.type != null && te.type.type.$$typeof === h) {
                var Ve = te.type;
                this.popProvider(Ve);
              } else if (te.type === f) {
                this.suspenseDepth--;
                var Ft = ee.pop();
                if (oe) {
                  oe = !1;
                  var Bt = te.fallbackFrame;
                  if (!Bt)
                    throw Error("ReactDOMServer did not find an internal fallback frame for Suspense. This is a bug in React. Please file an issue.");
                  this.stack.push(Bt), ee[this.suspenseDepth] += "<!--$!-->";
                  continue;
                } else
                  ee[this.suspenseDepth] += Ft;
              }
              ee[this.suspenseDepth] += Be;
              continue;
            }
            var ve = te.children[te.childIndex++], mt = "";
            pg(this.stack), te.debugElementStack.length = 0;
            try {
              mt += this.render(ve, te.context, te.domNamespace);
            } catch (es) {
              if (es != null && typeof es.then == "function") {
                if (!$) throw Error("ReactDOMServer does not yet support Suspense.");
              } else
                throw es;
            } finally {
              fg();
            }
            ee.length <= this.suspenseDepth && ee.push(""), ee[this.suspenseDepth] += mt;
          }
          return ee[0];
        } finally {
          Jc.current = ne, Zp(U), qp();
        }
      }, S.render = function(H, U, ne) {
        if (typeof H == "string" || typeof H == "number") {
          var ee = "" + H;
          return ee === "" ? "" : this.makeStaticMarkup ? ye(ee) : this.previousWasTextNode ? "<!-- -->" + ye(ee) : (this.previousWasTextNode = !0, ye(ee));
        } else {
          var oe, te = VF(H, U, this.threadID);
          if (oe = te.child, U = te.context, oe === null || oe === !1)
            return "";
          if (!e.isValidElement(oe)) {
            if (oe != null && oe.$$typeof != null) {
              var Be = oe.$$typeof;
              throw Error(Be === l ? "Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render." : "Unknown element-like object type: " + Be.toString() + ". This is likely a bug in React. Please file an issue.");
            }
            var Ve = sr(oe), Ft = {
              type: null,
              domNamespace: ne,
              children: Ve,
              childIndex: 0,
              context: U,
              footer: ""
            };
            return Ft.debugElementStack = [], this.stack.push(Ft), "";
          }
          var Bt = oe, ve = Bt.type;
          if (typeof ve == "string")
            return this.renderDOM(Bt, U, ne);
          switch (ve) {
            case T:
            case M:
            case d:
            case u:
            case m:
            case c: {
              var mt = sr(oe.props.children), es = {
                type: null,
                domNamespace: ne,
                children: mt,
                childIndex: 0,
                context: U,
                footer: ""
              };
              return es.debugElementStack = [], this.stack.push(es), "";
            }
            case f:
              throw Error("ReactDOMServer does not yet support Suspense.");
            case x:
              throw Error("ReactDOMServer does not yet support scope components.");
          }
          if (typeof ve == "object" && ve !== null)
            switch (ve.$$typeof) {
              case g: {
                var us = oe, hs, ir = {};
                jp(ir), hs = ve.render(us.props, us.ref), hs = Kp(ve.render, us.props, hs, us.ref), hs = sr(hs);
                var ks = {
                  type: null,
                  domNamespace: ne,
                  children: hs,
                  childIndex: 0,
                  context: U,
                  footer: ""
                };
                return ks.debugElementStack = [], this.stack.push(ks), "";
              }
              case C: {
                var Xs = oe, rr = [e.createElement(ve.type, t({
                  ref: Xs.ref
                }, Xs.props))], Os = {
                  type: null,
                  domNamespace: ne,
                  children: rr,
                  childIndex: 0,
                  context: U,
                  footer: ""
                };
                return Os.debugElementStack = [], this.stack.push(Os), "";
              }
              case h: {
                var Zs = oe, Ci = Zs.props, Ba = sr(Ci.children), kn = {
                  type: Zs,
                  domNamespace: ne,
                  children: Ba,
                  childIndex: 0,
                  context: U,
                  footer: ""
                };
                return kn.debugElementStack = [], this.pushProvider(Zs), this.stack.push(kn), "";
              }
              case p: {
                var Qs = oe.type;
                Qs._context === void 0 ? Qs !== Qs.Consumer && (mg || (mg = !0, o("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : Qs = Qs._context;
                var Do = oe.props, $r = this.threadID;
                ds(Qs, $r);
                var Va = Qs[$r], Na = sr(Do.children(Va)), nr = {
                  type: oe,
                  domNamespace: ne,
                  children: Na,
                  childIndex: 0,
                  context: U,
                  footer: ""
                };
                return nr.debugElementStack = [], this.stack.push(nr), "";
              }
              case b:
                throw Error("ReactDOMServer does not yet support the fundamental API.");
              case w: {
                var On = oe, Lg = oe.type, _F = Lg._payload, UF = Lg._init, $F = UF(_F), jF = [e.createElement($F, t({
                  ref: On.ref
                }, On.props))], kg = {
                  type: null,
                  domNamespace: ne,
                  children: jF,
                  childIndex: 0,
                  context: U,
                  footer: ""
                };
                return kg.debugElementStack = [], this.stack.push(kg), "";
              }
            }
          var sd = "";
          {
            var Og = Bt._owner;
            (ve === void 0 || typeof ve == "object" && ve !== null && Object.keys(ve).length === 0) && (sd += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Gg = Og ? D(Og) : null;
            Gg && (sd += `

Check the render method of \`` + Gg + "`.");
          }
          throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (ve == null ? ve : typeof ve) + "." + sd);
        }
      }, S.renderDOM = function(H, U, ne) {
        var ee = H.type.toLowerCase(), oe = ne;
        ne === Yc.html && (oe = Jp(ee)), oe === Yc.html && ee !== H.type && o("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", H.type), TF(ee);
        var te = H.props;
        if (ee === "input")
          Xc("input", te), te.checked !== void 0 && te.defaultChecked !== void 0 && !vg && (o("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", te.type), vg = !0), te.value !== void 0 && te.defaultValue !== void 0 && !Cg && (o("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", te.type), Cg = !0), te = t({
            type: void 0
          }, te, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: te.value != null ? te.value : te.defaultValue,
            checked: te.checked != null ? te.checked : te.defaultChecked
          });
        else if (ee === "textarea") {
          Xc("textarea", te), te.value !== void 0 && te.defaultValue !== void 0 && !yg && (o("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), yg = !0);
          var Be = te.value;
          if (Be == null) {
            var Ve = te.defaultValue, Ft = te.children;
            if (Ft != null) {
              if (o("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), Ve != null)
                throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
              if (Array.isArray(Ft)) {
                if (!(Ft.length <= 1))
                  throw Error("<textarea> can only have at most one child.");
                Ft = Ft[0];
              }
              Ve = "" + Ft;
            }
            Ve == null && (Ve = ""), Be = Ve;
          }
          te = t({}, te, {
            value: void 0,
            children: "" + Be
          });
        } else if (ee === "select") {
          {
            Xc("select", te);
            for (var Bt = 0; Bt < Eg.length; Bt++) {
              var ve = Eg[Bt];
              if (te[ve] != null) {
                var mt = Array.isArray(te[ve]);
                te.multiple && !mt ? o("The `%s` prop supplied to <select> must be an array if `multiple` is true.", ve) : !te.multiple && mt && o("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", ve);
              }
            }
            te.value !== void 0 && te.defaultValue !== void 0 && !wg && (o("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), wg = !0);
          }
          this.currentSelectValue = te.value != null ? te.value : te.defaultValue, te = t({}, te, {
            value: void 0
          });
        } else if (ee === "option") {
          var es = null, us = this.currentSelectValue, hs = LF(te.children);
          if (us != null) {
            var ir;
            if (te.value != null ? ir = te.value + "" : ir = hs, es = !1, Array.isArray(us)) {
              for (var ks = 0; ks < us.length; ks++)
                if ("" + us[ks] === ir) {
                  es = !0;
                  break;
                }
            } else
              es = "" + us === ir;
            te = t({
              selected: void 0,
              children: void 0
            }, te, {
              selected: es,
              children: hs
            });
          }
        }
        hg(ee, te), YR(ee, te);
        var Xs = BF(H.type, ee, te, oe, this.makeStaticMarkup, this.stack.length === 1), rr = "";
        eg.hasOwnProperty(ee) ? Xs += "/>" : (Xs += ">", rr = "</" + H.type + ">");
        var Os, Zs = MF(te);
        Zs != null ? (Os = [], FF.hasOwnProperty(ee) && Zs.charAt(0) === `
` && (Xs += `
`), Xs += Zs) : Os = sr(te.children);
        var Ci = {
          domNamespace: $R(ne, H.type),
          type: ee,
          children: Os,
          childIndex: 0,
          context: U,
          footer: rr
        };
        return Ci.debugElementStack = [], this.stack.push(Ci), this.previousWasTextNode = !1, Xs;
      }, v;
    }();
    function NF(v, S) {
      var G = new Ig(v, !1, S);
      try {
        var H = G.read(1 / 0);
        return H;
      } finally {
        G.destroy();
      }
    }
    function HF(v, S) {
      var G = new Ig(v, !0, S);
      try {
        var H = G.read(1 / 0);
        return H;
      } finally {
        G.destroy();
      }
    }
    function zF() {
      throw Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function WF() {
      throw Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    qr.renderToNodeStream = zF, qr.renderToStaticMarkup = HF, qr.renderToStaticNodeStream = WF, qr.renderToString = NF, qr.version = i;
  }()), qr;
}
process.env.NODE_ENV === "production" ? Uu.exports = ZQ() : Uu.exports = QQ();
var JQ = Uu.exports, eJ = function(e) {
  var t = e.getVariant, s = e.getContent, i = Us(e, ["getVariant", "getContent"]), r = t == null ? void 0 : t(i), n = s == null ? void 0 : s(i);
  return !n && typeof i.value != "string" ? null : /* @__PURE__ */ me.jsx(VC, { variant: r ?? "info", title: n ? /* @__PURE__ */ me.jsx(n, { ...i }) : i.value, components: {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    Transition: function(o) {
      var a = o.children;
      return a;
    },
    Popper: function(o) {
      var a = o.children;
      if (typeof a == "function") {
        var l = a;
        return /* @__PURE__ */ me.jsx(l, { placement: "auto" });
      }
      return /* @__PURE__ */ me.jsx(q.Fragment, { children: a });
    }
  }, children: /* @__PURE__ */ me.jsx(q.Fragment, {}) });
}, tJ = {
  CELL_ERROR: "data-grid-cell-error",
  CELL_WARNING: "data-grid-cell-warning",
  CELL_SUCCESS: "data-grid-cell-success",
  CELL_WITH_TOOLTIP: "data-grid-cell-with-tooltip"
}, Cre = {
  ROW_DISABLED: "data-grid-row-disabled"
}, Xd, _o = {
  buttons: ["reset", "apply"],
  closeOnApply: !0
}, sJ = {
  date: {
    filterParams: Ee(Ee({}, _o), { filterOptions: ["equals", "notEqual", "lessThan", "greaterThan"] })
  },
  number: {
    filterParams: Ee(Ee({}, _o), { filterOptions: [
      "equals",
      "notEqual",
      "lessThan",
      "lessThanOrEqual",
      "greaterThan",
      "greaterThanOrEqual"
    ] })
  },
  text: {
    filterParams: Ee(Ee({}, _o), { filterOptions: ["contains", "notContains", "equals", "notEqual", "startsWith", "endsWith"] })
  },
  boolean: {
    cellRenderer: function(e) {
      var t = e.value;
      return typeof t != "boolean" ? "-" : t ? "Yes" : "No";
    },
    filter: "agSetColumnFilter",
    filterParams: Ee(Ee({}, _o), { valueFormatter: function(e) {
      var t = e.value;
      return typeof t != "boolean" ? "(Blanks)" : t ? "Yes" : "No";
    } })
  }
}, uR = {
  type: ["text"],
  filter: "agTextColumnFilter",
  filterParams: _o,
  tooltipComponent: eJ,
  singleClickEdit: !1,
  cellClassRules: (Xd = {
    "data-grid-editable-cell": function(e) {
      var t = e.colDef, s = e.node;
      return s.rowPinned ? !1 : typeof t.editable == "function" ? t.editable(e) : !!t.editable;
    }
  }, Xd[tJ.CELL_WITH_TOOLTIP] = function(e) {
    var t = e.value, s = e.colDef;
    return Pi(s.tooltipField) || Pi(t) ? !1 : K8(t) || D5(t) ? !Hx(t) : !0;
  }, Xd)
}, hR = {
  suppressGroupChangesColumnVisibility: !0,
  stopEditingWhenCellsLoseFocus: !0,
  enterNavigatesVerticallyAfterEdit: !0,
  enableCellEditingOnBackspace: !0,
  maintainColumnOrder: !0,
  columnTypes: sJ,
  columnMenu: "new",
  paginationPageSize: 100,
  tooltipShowDelay: 100,
  tooltipHideDelay: 1e4,
  tooltipInteraction: !0,
  components: Ee(Ee({}, q9), Q9)
}, pR = {
  columnsTab: /* @__PURE__ */ me.jsx(hP, { titleAccess: "Columns", "aria-label": "Columns tab", fontSize: "small" }),
  filterTab: /* @__PURE__ */ me.jsx(pP, { titleAccess: "Filters", "aria-label": "Filters tab", fontSize: "small" })
}, gR = function(e) {
  return Object.entries(e).reduce(function(t, s) {
    var i, r, n = As(s, 2), o = n[0], a = n[1];
    return typeof a == "string" ? Ee(Ee({}, t), (i = {}, i[o] = a, i)) : Ee(Ee({}, t), (r = {}, r[o] = function() {
      return JQ.renderToStaticMarkup(a);
    }, r));
  }, {});
};
function vre(e) {
  var t = e.defaultColDefOverride, s = e.onGridReady, i = e.onFilterChanged, r = e.onModelUpdated, n = e.icons, o = Us(e, ["defaultColDefOverride", "onGridReady", "onFilterChanged", "onModelUpdated", "icons"]), a = Up().registerGridApi, l = Te(function() {
    return gR(Ee(Ee({}, pR), n));
  }, [n]), c = Te(function() {
    return Ee(Ee({}, uR), t);
  }, [t]), d = he(function(g) {
    a(g.api), s == null || s(g);
  }, [a, s]), u = he(function(g) {
    g.api.deselectAll(), i == null || i(g);
  }, [i]), h = he(function(g) {
    g.api.getDisplayedRowCount() === 0 ? g.api.showNoRowsOverlay() : g.api.hideOverlay(), r == null || r(g);
  }, [r]), p = he(function(g) {
    g.api.deselectAll();
  }, []);
  return /* @__PURE__ */ me.jsx(Nx, { children: /* @__PURE__ */ me.jsx(Vx, { ...hR, defaultColDef: c, ...o, onGridReady: d, onFilterChanged: u, onModelUpdated: h, onColumnRowGroupChanged: p, icons: l, loadingOverlayComponent: XQ }) });
}
function iJ(e, t) {
  for (var s = -1, i = e == null ? 0 : e.length; ++s < i && t(e[s], s, e) !== !1; )
    ;
  return e;
}
var rJ = iJ, nJ = Ro, oJ = Ap;
function aJ(e, t) {
  return e && nJ(t, oJ(t), e);
}
var lJ = aJ, cJ = Ro, dJ = Aa;
function uJ(e, t) {
  return e && cJ(t, dJ(t), e);
}
var hJ = uJ, pJ = Ro, gJ = Pp;
function fJ(e, t) {
  return pJ(e, gJ(e), t);
}
var mJ = fJ, CJ = Fp, vJ = Bp, wJ = Pp, yJ = Sx, bJ = Object.getOwnPropertySymbols, SJ = bJ ? function(e) {
  for (var t = []; e; )
    CJ(t, wJ(e)), e = vJ(e);
  return t;
} : yJ, fR = SJ, xJ = Ro, RJ = fR;
function FJ(e, t) {
  return xJ(e, RJ(e), t);
}
var PJ = FJ, TJ = bx, EJ = fR, DJ = Aa;
function AJ(e) {
  return TJ(e, DJ, EJ);
}
var mR = AJ, MJ = Object.prototype, IJ = MJ.hasOwnProperty;
function LJ(e) {
  var t = e.length, s = new e.constructor(t);
  return t && typeof e[0] == "string" && IJ.call(e, "index") && (s.index = e.index, s.input = e.input), s;
}
var kJ = LJ, OJ = Gp;
function GJ(e, t) {
  var s = t ? OJ(e.buffer) : e.buffer;
  return new e.constructor(s, e.byteOffset, e.byteLength);
}
var BJ = GJ, VJ = /\w*$/;
function NJ(e) {
  var t = new e.constructor(e.source, VJ.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var HJ = NJ, wC = fo, yC = wC ? wC.prototype : void 0, bC = yC ? yC.valueOf : void 0;
function zJ(e) {
  return bC ? Object(bC.call(e)) : {};
}
var WJ = zJ, _J = Gp, UJ = BJ, $J = HJ, jJ = WJ, KJ = Ux, qJ = "[object Boolean]", YJ = "[object Date]", XJ = "[object Map]", ZJ = "[object Number]", QJ = "[object RegExp]", JJ = "[object Set]", eee = "[object String]", tee = "[object Symbol]", see = "[object ArrayBuffer]", iee = "[object DataView]", ree = "[object Float32Array]", nee = "[object Float64Array]", oee = "[object Int8Array]", aee = "[object Int16Array]", lee = "[object Int32Array]", cee = "[object Uint8Array]", dee = "[object Uint8ClampedArray]", uee = "[object Uint16Array]", hee = "[object Uint32Array]";
function pee(e, t, s) {
  var i = e.constructor;
  switch (t) {
    case see:
      return _J(e);
    case qJ:
    case YJ:
      return new i(+e);
    case iee:
      return UJ(e, s);
    case ree:
    case nee:
    case oee:
    case aee:
    case lee:
    case cee:
    case dee:
    case uee:
    case hee:
      return KJ(e, s);
    case XJ:
      return new i();
    case ZJ:
    case eee:
      return new i(e);
    case QJ:
      return $J(e);
    case JJ:
      return new i();
    case tee:
      return jJ(e);
  }
}
var gee = pee, fee = Ea, mee = Zi, Cee = "[object Map]";
function vee(e) {
  return mee(e) && fee(e) == Cee;
}
var wee = vee, yee = wee, bee = Ep, SC = Dp, xC = SC && SC.isMap, See = xC ? bee(xC) : yee, xee = See, Ree = Ea, Fee = Zi, Pee = "[object Set]";
function Tee(e) {
  return Fee(e) && Ree(e) == Pee;
}
var Eee = Tee, Dee = Eee, Aee = Ep, RC = Dp, FC = RC && RC.isSet, Mee = FC ? Aee(FC) : Dee, Iee = Mee, Lee = Rp, kee = rJ, Oee = Vp, Gee = lJ, Bee = hJ, Vee = _x, Nee = $x, Hee = mJ, zee = PJ, Wee = Ex, _ee = mR, Uee = Ea, $ee = kJ, jee = gee, Kee = jx, qee = ui, Yee = Ta, Xee = xee, Zee = Ai, Qee = Iee, Jee = Ap, ete = Aa, tte = 1, ste = 2, ite = 4, CR = "[object Arguments]", rte = "[object Array]", nte = "[object Boolean]", ote = "[object Date]", ate = "[object Error]", vR = "[object Function]", lte = "[object GeneratorFunction]", cte = "[object Map]", dte = "[object Number]", wR = "[object Object]", ute = "[object RegExp]", hte = "[object Set]", pte = "[object String]", gte = "[object Symbol]", fte = "[object WeakMap]", mte = "[object ArrayBuffer]", Cte = "[object DataView]", vte = "[object Float32Array]", wte = "[object Float64Array]", yte = "[object Int8Array]", bte = "[object Int16Array]", Ste = "[object Int32Array]", xte = "[object Uint8Array]", Rte = "[object Uint8ClampedArray]", Fte = "[object Uint16Array]", Pte = "[object Uint32Array]", rt = {};
rt[CR] = rt[rte] = rt[mte] = rt[Cte] = rt[nte] = rt[ote] = rt[vte] = rt[wte] = rt[yte] = rt[bte] = rt[Ste] = rt[cte] = rt[dte] = rt[wR] = rt[ute] = rt[hte] = rt[pte] = rt[gte] = rt[xte] = rt[Rte] = rt[Fte] = rt[Pte] = !0;
rt[ate] = rt[vR] = rt[fte] = !1;
function Cl(e, t, s, i, r, n) {
  var o, a = t & tte, l = t & ste, c = t & ite;
  if (s && (o = r ? s(e, i, r, n) : s(e)), o !== void 0)
    return o;
  if (!Zee(e))
    return e;
  var d = qee(e);
  if (d) {
    if (o = $ee(e), !a)
      return Nee(e, o);
  } else {
    var u = Uee(e), h = u == vR || u == lte;
    if (Yee(e))
      return Vee(e, a);
    if (u == wR || u == CR || h && !r) {
      if (o = l || h ? {} : Kee(e), !a)
        return l ? zee(e, Bee(o, e)) : Hee(e, Gee(o, e));
    } else {
      if (!rt[u])
        return r ? e : {};
      o = jee(e, u, a);
    }
  }
  n || (n = new Lee());
  var p = n.get(e);
  if (p)
    return p;
  n.set(e, o), Qee(e) ? e.forEach(function(m) {
    o.add(Cl(m, t, s, m, e, n));
  }) : Xee(e) && e.forEach(function(m, C) {
    o.set(C, Cl(m, t, s, C, e, n));
  });
  var g = c ? l ? _ee : Wee : l ? ete : Jee, f = d ? void 0 : g(e);
  return kee(f || e, function(m, C) {
    f && (C = m, m = e[C]), Oee(o, C, Cl(m, t, s, C, e, n));
  }), o;
}
var Tte = Cl;
function Ete(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Dte = Ete;
function Ate(e, t, s) {
  var i = -1, r = e.length;
  t < 0 && (t = -t > r ? 0 : r + t), s = s > r ? r : s, s < 0 && (s += r), r = t > s ? 0 : s - t >>> 0, t >>>= 0;
  for (var n = Array(r); ++i < r; )
    n[i] = e[i + t];
  return n;
}
var yR = Ate, Mte = rR, Ite = yR;
function Lte(e, t) {
  return t.length < 2 ? e : Mte(e, Ite(t, 0, -1));
}
var kte = Lte, Ote = _c, Gte = Dte, Bte = kte, Vte = Wp;
function Nte(e, t) {
  return t = Ote(t, e), e = Bte(e, t), e == null || delete e[Vte(Gte(t))];
}
var Hte = Nte, zte = qx;
function Wte(e) {
  return zte(e) ? void 0 : e;
}
var _te = Wte, PC = fo, Ute = Nc, $te = ui, TC = PC ? PC.isConcatSpreadable : void 0;
function jte(e) {
  return $te(e) || Ute(e) || !!(TC && e && e[TC]);
}
var Kte = jte, qte = Fp, Yte = Kte;
function bR(e, t, s, i, r) {
  var n = -1, o = e.length;
  for (s || (s = Yte), r || (r = []); ++n < o; ) {
    var a = e[n];
    t > 0 && s(a) ? t > 1 ? bR(a, t - 1, s, i, r) : qte(r, a) : i || (r[r.length] = a);
  }
  return r;
}
var Xte = bR, Zte = Xte;
function Qte(e) {
  var t = e == null ? 0 : e.length;
  return t ? Zte(e, 1) : [];
}
var Jte = Qte, ese = Jte, tse = Qx, sse = Jx;
function ise(e) {
  return sse(tse(e, void 0, ese), e + "");
}
var rse = ise, nse = tR, ose = Tte, ase = Hte, lse = _c, cse = Ro, dse = _te, use = rse, hse = mR, pse = 1, gse = 2, fse = 4, mse = use(function(e, t) {
  var s = {};
  if (e == null)
    return s;
  var i = !1;
  t = nse(t, function(n) {
    return n = lse(n, e), i || (i = n.length > 1), n;
  }), cse(e, hse(e), s), i && (s = ose(s, pse | gse | fse, dse));
  for (var r = t.length; r--; )
    ase(s, t[r]);
  return s;
}), Cse = mse;
const vse = /* @__PURE__ */ di(Cse);
var wse = function(e, t) {
  var s = e.filter(function(r) {
    return r.isFilterActive();
  }).map(function(r) {
    return r.getColId();
  }), i = e.filter(function(r) {
    return !r.isFilterActive();
  }).map(function(r) {
    return r.getColId();
  });
  return Ar(Ar([], As(t.filter(function(r) {
    return !i.includes(r);
  })), !1), As(s), !1);
}, yse = function(e) {
  var t = e.filterLimit;
  if (!Pi(t) && t <= 0)
    throw new Error("filterLimit must be greater than 0");
  var s = Q([]), i = he(function(r) {
    var n = r.api, o = r.columns;
    if (!Pi(t)) {
      var a = n.getFilterModel(), l = Object.keys(a).length;
      if (l > t) {
        var c = s.current.slice(t - l);
        n.setFilterModel(vse(a, c));
      }
      s.current = wse(o, s.current);
    }
  }, [t, s]);
  return { applyLimitOnFilterChanged: i };
}, bse = 1, Sse = function() {
  var e = he(function(t) {
    var s = t.api, i = t.columns;
    if (!Pi(i)) {
      var r = s.getRowGroupColumns();
      if (r.length > bse) {
        var n = i[i.length - 1].getColId(), o = r.map(function(a) {
          return a.getColId();
        }).filter(function(a) {
          return a !== n;
        });
        s.removeRowGroupColumns(o);
      }
    }
  }, []);
  return { applyLimitOnColumnRowGroupChanged: e };
}, xse = function(e) {
  var t = e.sortLimit;
  if (!Pi(t) && t <= 0)
    throw new Error("sortLimit must be greater than 0");
  var s = he(function(i) {
    var r, n, o = i.api, a = (n = (r = o.getState().sort) === null || r === void 0 ? void 0 : r.sortModel) !== null && n !== void 0 ? n : [];
    if (!Pi(t) && a.length > t) {
      var l = a[a.length - 2];
      o.applyColumnState({
        state: [{ colId: l.colId, sort: null }],
        applyOrder: !1
      });
    }
  }, [t]);
  return { applyLimitOnSortChanged: s };
}, Rse = Ee(Ee({}, hR), {
  rowModelType: "serverSide",
  /**
   * Enable skeleton loading
   */
  suppressServerSideFullWidthLoadingRow: !0
}), Zd = { selectAll: !1, toggledNodes: [] };
function wre(e) {
  var t = e.defaultColDefOverride, s = e.onGridReady, i = e.onFilterChanged, r = e.onModelUpdated, n = e.icons, o = Us(e, ["defaultColDefOverride", "onGridReady", "onFilterChanged", "onModelUpdated", "icons"]), a = Up().registerGridApi, l = Te(function() {
    return gR(Ee(Ee({}, pR), n));
  }, [n]), c = Te(function() {
    return Ee(Ee({}, uR), t);
  }, [t]), d = Q(o.columnDefs), u = xse({
    sortLimit: o.sortLimit
  }).applyLimitOnSortChanged, h = yse({
    filterLimit: o.filterLimit
  }).applyLimitOnFilterChanged, p = Sse().applyLimitOnColumnRowGroupChanged, g = he(function(b) {
    p(b), b.api.setServerSideSelectionState(Zd);
  }, [p]), f = he(function(b) {
    a(b.api), s == null || s(b);
  }, [a, s]), m = he(function(b) {
    d.current = b.api.getColumnDefs();
  }, []), C = he(function(b) {
    h(b), b.api.setServerSideSelectionState(Zd), i == null || i(b);
  }, [h, i]), w = he(function(b) {
    u(b), b.api.setServerSideSelectionState(Zd);
  }, [u]), y = he(function(b) {
    b.api.getDisplayedRowCount() === 0 ? b.api.showNoRowsOverlay() : b.api.hideOverlay(), r == null || r(b);
  }, [r]);
  return /* @__PURE__ */ me.jsx(Nx, { children: /* @__PURE__ */ me.jsx(Vx, { ...Rse, defaultColDef: c, ...o, onFilterChanged: C, onModelUpdated: y, onSortChanged: w, onColumnRowGroupChanged: g, onGridReady: f, onGridColumnsChanged: m, icons: l }) });
}
var Fse = yR;
function Pse(e, t, s) {
  var i = e.length;
  return s = s === void 0 ? i : s, !t && s >= i ? e : Fse(e, t, s);
}
var Tse = Pse, Ese = "\\ud800-\\udfff", Dse = "\\u0300-\\u036f", Ase = "\\ufe20-\\ufe2f", Mse = "\\u20d0-\\u20ff", Ise = Dse + Ase + Mse, Lse = "\\ufe0e\\ufe0f", kse = "\\u200d", Ose = RegExp("[" + kse + Ese + Ise + Lse + "]");
function Gse(e) {
  return Ose.test(e);
}
var SR = Gse;
function Bse(e) {
  return e.split("");
}
var Vse = Bse, xR = "\\ud800-\\udfff", Nse = "\\u0300-\\u036f", Hse = "\\ufe20-\\ufe2f", zse = "\\u20d0-\\u20ff", Wse = Nse + Hse + zse, _se = "\\ufe0e\\ufe0f", Use = "[" + xR + "]", $u = "[" + Wse + "]", ju = "\\ud83c[\\udffb-\\udfff]", $se = "(?:" + $u + "|" + ju + ")", RR = "[^" + xR + "]", FR = "(?:\\ud83c[\\udde6-\\uddff]){2}", PR = "[\\ud800-\\udbff][\\udc00-\\udfff]", jse = "\\u200d", TR = $se + "?", ER = "[" + _se + "]?", Kse = "(?:" + jse + "(?:" + [RR, FR, PR].join("|") + ")" + ER + TR + ")*", qse = ER + TR + Kse, Yse = "(?:" + [RR + $u + "?", $u, FR, PR, Use].join("|") + ")", Xse = RegExp(ju + "(?=" + ju + ")|" + Yse + qse, "g");
function Zse(e) {
  return e.match(Xse) || [];
}
var Qse = Zse, Jse = Vse, eie = SR, tie = Qse;
function sie(e) {
  return eie(e) ? tie(e) : Jse(e);
}
var iie = sie, rie = Tse, nie = SR, oie = iie, aie = zp;
function lie(e) {
  return function(t) {
    t = aie(t);
    var s = nie(t) ? oie(t) : void 0, i = s ? s[0] : t.charAt(0), r = s ? rie(s, 1).join("") : t.slice(1);
    return i[e]() + r;
  };
}
var cie = lie, die = cie, uie = die("toUpperCase"), hie = uie, pie = zp, gie = hie;
function fie(e) {
  return gie(pie(e).toLowerCase());
}
var mie = fie;
const Cie = /* @__PURE__ */ di(mie);
var DR = function(e) {
  var t = e.value;
  return t ? Cie(t.replaceAll("_", " ")) : "-";
}, vie = function(e, t) {
  if (t === void 0 && (t = 1), !e || e.length === 0)
    return "-";
  var s = e.slice(0, t).join(", ");
  return e.length <= t ? s : "".concat(s, " +").concat(e.length - t, "...");
};
const yre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  enumValueFormatter: DR,
  truncatedArrayValueFormatter: vie
}, Symbol.toStringTag, { value: "Module" }));
var Ku;
(function(e) {
  e.Error = "ERROR", e.None = "NONE", e.Warning = "WARNING";
})(Ku || (Ku = {}));
var EC;
(function(e) {
  e.Acknowledged = "ACKNOWLEDGED", e.Rejected = "REJECTED", e.Unacknowledged = "UNACKNOWLEDGED";
})(EC || (EC = {}));
var DC;
(function(e) {
  e.Blanket = "BLANKET", e.Expired = "EXPIRED", e.NotOnFile = "NOT_ON_FILE", e.Partial = "PARTIAL";
})(DC || (DC = {}));
var AC;
(function(e) {
  e.Active = "ACTIVE", e.Cancelled = "CANCELLED", e.Duplicate = "DUPLICATE";
})(AC || (AC = {}));
var MC;
(function(e) {
  e.Limit = "LIMIT", e.Market = "MARKET", e.Pass = "PASS", e.Scaled = "SCALED";
})(MC || (MC = {}));
var IC;
(function(e) {
  e.Failed = "FAILED", e.InProgress = "IN_PROGRESS", e.NotSent = "NOT_SENT", e.Sent = "SENT";
})(IC || (IC = {}));
var LC;
(function(e) {
  e.Asc = "ASC", e.Desc = "DESC";
})(LC || (LC = {}));
var bre = function(e) {
  return e === void 0 && (e = {}), Ee({ headerName: "⚠", lockPosition: "left", width: 90, resizable: !0, suppressFillHandle: !0, cellRenderer: "rowAlertCellRenderer", filter: "agSetColumnFilter", filterParams: {
    values: Object.values(Ku),
    valueFormatter: DR
  } }, e);
}, Sre = function(e) {
  return e === void 0 && (e = {}), Ee({
    // Default configuration which is overridable
    lockVisible: !0
  }, e);
}, wie = function(e, t) {
  return e.selectAll ? t - e.unselectedRowIdsFlat.length : e.selectedRowIdsFlat.length;
}, xre = function(e) {
  var t = e.minRowSelectionCount, s = t === void 0 ? 2 : t, i = e.totalSelectableRowCount, r = i === void 0 ? 0 : i, n = e.rowSelectionState, o = e.children, a = r >= s && (n.selectAll || n.selectedRowIdsFlat.length >= s), l = wie(n, r);
  return a ? /* @__PURE__ */ me.jsxs(vl, { direction: { md: "row" }, alignItems: { md: "center" }, gap: 1, px: 4, py: 1, bgcolor: function(c) {
    return c.palette.background.lightBlue;
  }, children: [
    /* @__PURE__ */ me.jsx(Xu, { variant: "highlight1", flex: "1", children: "Selected: ".concat(l) }),
    /* @__PURE__ */ me.jsx(vl, { direction: "row", gap: 1, children: o })
  ] }) : null;
}, Rre = function(e) {
  var t = Up(), s = t.getState, i = t.addEventListener, r = t.removeEventListener, n = t.isGridReady, o = he(function() {
    var a;
    e((a = s()) !== null && a !== void 0 ? a : {});
  }, [s, e]);
  Wt(function() {
    return window.addEventListener("beforeunload", o), function() {
      window.removeEventListener("beforeunload", o);
    };
  }, [o]), Wt(function() {
    if (n)
      return i("gridPreDestroyed", o), function() {
        r("gridPreDestroyed", o);
      };
  }, [i, o, n, r]);
};
function Qt(e) {
  return function(t) {
    return Ee(Ee({}, e), t);
  };
}
function hi(e) {
  return e === void 0 && (e = {}), Qt({
    getGridId: jest.fn(),
    addDetailGridInfo: jest.fn(),
    removeDetailGridInfo: jest.fn(),
    getDetailGridInfo: jest.fn(),
    forEachDetailGridInfo: jest.fn(),
    getDataAsCsv: jest.fn(),
    exportDataAsCsv: jest.fn(),
    getDataAsExcel: jest.fn(),
    exportDataAsExcel: jest.fn(),
    getSheetDataForExcel: jest.fn(),
    getMultipleSheetsAsExcel: jest.fn(),
    exportMultipleSheetsAsExcel: jest.fn(),
    setGridAriaProperty: jest.fn(),
    getPinnedTopRowCount: jest.fn(),
    getPinnedBottomRowCount: jest.fn(),
    getPinnedTopRow: jest.fn(),
    getPinnedBottomRow: jest.fn(),
    expireValueCache: jest.fn(),
    getVerticalPixelRange: jest.fn(),
    getHorizontalPixelRange: jest.fn(),
    refreshCells: jest.fn(),
    flashCells: jest.fn(),
    redrawRows: jest.fn(),
    refreshHeader: jest.fn(),
    isAnyFilterPresent: jest.fn(),
    isColumnFilterPresent: jest.fn(),
    isQuickFilterPresent: jest.fn(),
    setRowNodeExpanded: jest.fn(),
    onGroupExpandedOrCollapsed: jest.fn(),
    refreshClientSideRowModel: jest.fn(),
    isAnimationFrameQueueEmpty: jest.fn(),
    flushAllAnimationFrames: jest.fn(),
    getRowNode: jest.fn(),
    getSizesForCurrentTheme: jest.fn(),
    expandAll: jest.fn(),
    collapseAll: jest.fn(),
    addRenderedRowListener: jest.fn(),
    getQuickFilter: jest.fn(),
    getAdvancedFilterModel: jest.fn(),
    setAdvancedFilterModel: jest.fn(),
    showAdvancedFilterBuilder: jest.fn(),
    hideAdvancedFilterBuilder: jest.fn(),
    setNodesSelected: jest.fn(),
    selectAll: jest.fn(),
    deselectAll: jest.fn(),
    selectAllFiltered: jest.fn(),
    deselectAllFiltered: jest.fn(),
    getServerSideSelectionState: jest.fn(),
    setServerSideSelectionState: jest.fn(),
    selectAllOnCurrentPage: jest.fn(),
    deselectAllOnCurrentPage: jest.fn(),
    showLoadingOverlay: jest.fn(),
    showNoRowsOverlay: jest.fn(),
    hideOverlay: jest.fn(),
    getSelectedNodes: jest.fn(),
    getSelectedRows: jest.fn(),
    getBestCostNodeSelection: jest.fn(),
    getRenderedNodes: jest.fn(),
    ensureColumnVisible: jest.fn(),
    ensureIndexVisible: jest.fn(),
    ensureNodeVisible: jest.fn(),
    forEachLeafNode: jest.fn(),
    forEachNode: jest.fn(),
    forEachNodeAfterFilter: jest.fn(),
    forEachNodeAfterFilterAndSort: jest.fn(),
    destroyFilter: jest.fn(),
    getStatusPanel: jest.fn(),
    getColumnDef: jest.fn(),
    getColumnDefs: jest.fn(),
    onFilterChanged: jest.fn(),
    onSortChanged: jest.fn(),
    setFilterModel: jest.fn(),
    getFilterModel: jest.fn(),
    getColumnFilterModel: jest.fn(),
    setColumnFilterModel: jest.fn(),
    getFocusedCell: jest.fn(),
    clearFocusedCell: jest.fn(),
    setFocusedCell: jest.fn(),
    setFocusedHeader: jest.fn(),
    addRowDropZone: jest.fn(),
    removeRowDropZone: jest.fn(),
    getRowDropZoneParams: jest.fn(),
    isSideBarVisible: jest.fn(),
    setSideBarVisible: jest.fn(),
    setSideBarPosition: jest.fn(),
    openToolPanel: jest.fn(),
    closeToolPanel: jest.fn(),
    getOpenedToolPanel: jest.fn(),
    refreshToolPanel: jest.fn(),
    isToolPanelShowing: jest.fn(),
    getToolPanelInstance: jest.fn(),
    getSideBar: jest.fn(),
    resetRowHeights: jest.fn(),
    setRowCount: jest.fn(),
    onRowHeightChanged: jest.fn(),
    getCellValue: jest.fn(),
    addEventListener: jest.fn(),
    removeEventListener: jest.fn(),
    addGlobalListener: jest.fn(),
    removeGlobalListener: jest.fn(),
    dispatchEvent: jest.fn(),
    destroy: jest.fn(),
    isDestroyed: jest.fn(),
    resetQuickFilter: jest.fn(),
    getCellRanges: jest.fn(),
    addCellRange: jest.fn(),
    clearRangeSelection: jest.fn(),
    undoCellEditing: jest.fn(),
    redoCellEditing: jest.fn(),
    getCurrentUndoSize: jest.fn(),
    getCurrentRedoSize: jest.fn(),
    getChartModels: jest.fn(),
    getChartRef: jest.fn(),
    getChartImageDataURL: jest.fn(),
    downloadChart: jest.fn(),
    openChartToolPanel: jest.fn(),
    closeChartToolPanel: jest.fn(),
    createRangeChart: jest.fn(),
    createPivotChart: jest.fn(),
    createCrossFilterChart: jest.fn(),
    updateChart: jest.fn(),
    restoreChart: jest.fn(),
    copyToClipboard: jest.fn(),
    cutToClipboard: jest.fn(),
    copySelectedRowsToClipboard: jest.fn(),
    copySelectedRangeToClipboard: jest.fn(),
    copySelectedRangeDown: jest.fn(),
    pasteFromClipboard: jest.fn(),
    showContextMenu: jest.fn(),
    showColumnChooser: jest.fn(),
    showColumnFilter: jest.fn(),
    showColumnMenu: jest.fn(),
    hidePopupMenu: jest.fn(),
    hideColumnChooser: jest.fn(),
    tabToNextCell: jest.fn(),
    tabToPreviousCell: jest.fn(),
    getCellRendererInstances: jest.fn(),
    getCellEditorInstances: jest.fn(),
    getEditingCells: jest.fn(),
    stopEditing: jest.fn(),
    startEditingCell: jest.fn(),
    addAggFuncs: jest.fn(),
    clearAggFuncs: jest.fn(),
    applyServerSideTransaction: jest.fn(),
    applyServerSideTransactionAsync: jest.fn(),
    applyServerSideRowData: jest.fn(),
    retryServerSideLoads: jest.fn(),
    flushServerSideAsyncTransactions: jest.fn(),
    applyTransaction: jest.fn(),
    applyTransactionAsync: jest.fn(),
    flushAsyncTransactions: jest.fn(),
    refreshInfiniteCache: jest.fn(),
    purgeInfiniteCache: jest.fn(),
    refreshServerSide: jest.fn(),
    getServerSideGroupLevelState: jest.fn(),
    getInfiniteRowCount: jest.fn(),
    isLastRowIndexKnown: jest.fn(),
    getCacheBlockState: jest.fn(),
    getFirstDisplayedRowIndex: jest.fn(),
    getLastDisplayedRowIndex: jest.fn(),
    getDisplayedRowAtIndex: jest.fn(),
    getDisplayedRowCount: jest.fn(),
    paginationIsLastPageFound: jest.fn(),
    paginationGetPageSize: jest.fn(),
    paginationGetCurrentPage: jest.fn(),
    paginationGetTotalPages: jest.fn(),
    paginationGetRowCount: jest.fn(),
    paginationGoToNextPage: jest.fn(),
    paginationGoToPreviousPage: jest.fn(),
    paginationGoToFirstPage: jest.fn(),
    paginationGoToLastPage: jest.fn(),
    paginationGoToPage: jest.fn(),
    sizeColumnsToFit: jest.fn(),
    setColumnGroupOpened: jest.fn(),
    getColumnGroup: jest.fn(),
    getProvidedColumnGroup: jest.fn(),
    getDisplayNameForColumn: jest.fn(),
    getDisplayNameForColumnGroup: jest.fn(),
    getColumn: jest.fn(),
    getColumns: jest.fn(),
    applyColumnState: jest.fn(),
    getColumnState: jest.fn(),
    resetColumnState: jest.fn(),
    getColumnGroupState: jest.fn(),
    setColumnGroupState: jest.fn(),
    resetColumnGroupState: jest.fn(),
    isPinning: jest.fn(),
    isPinningLeft: jest.fn(),
    isPinningRight: jest.fn(),
    getDisplayedColAfter: jest.fn(),
    getDisplayedColBefore: jest.fn(),
    setColumnsVisible: jest.fn(),
    setColumnsPinned: jest.fn(),
    getAllGridColumns: jest.fn(),
    getDisplayedLeftColumns: jest.fn(),
    getDisplayedCenterColumns: jest.fn(),
    getDisplayedRightColumns: jest.fn(),
    getAllDisplayedColumns: jest.fn(),
    getAllDisplayedVirtualColumns: jest.fn(),
    moveColumnByIndex: jest.fn(),
    moveColumns: jest.fn(),
    moveRowGroupColumn: jest.fn(),
    setColumnAggFunc: jest.fn(),
    setColumnWidths: jest.fn(),
    isPivotMode: jest.fn(),
    getPivotResultColumn: jest.fn(),
    setValueColumns: jest.fn(),
    getValueColumns: jest.fn(),
    removeValueColumns: jest.fn(),
    addValueColumns: jest.fn(),
    setRowGroupColumns: jest.fn(),
    removeRowGroupColumns: jest.fn(),
    addRowGroupColumns: jest.fn(),
    getRowGroupColumns: jest.fn(),
    setPivotColumns: jest.fn(),
    removePivotColumns: jest.fn(),
    addPivotColumns: jest.fn(),
    getPivotColumns: jest.fn(),
    getLeftDisplayedColumnGroups: jest.fn(),
    getCenterDisplayedColumnGroups: jest.fn(),
    getRightDisplayedColumnGroups: jest.fn(),
    getAllDisplayedColumnGroups: jest.fn(),
    autoSizeColumns: jest.fn(),
    autoSizeAllColumns: jest.fn(),
    setPivotResultColumns: jest.fn(),
    getPivotResultColumns: jest.fn(),
    getState: jest.fn(),
    getGridOption: jest.fn(),
    setGridOption: jest.fn(),
    updateGridOptions: jest.fn(),
    isRowDataEmpty: jest.fn(),
    clearCellSelection: jest.fn(),
    isColumnHovered: jest.fn(),
    getColumnFilterInstance: jest.fn()
  })(e);
}
function yie(e) {
  return e === void 0 && (e = {}), Qt({})(e);
}
function Ma(e) {
  return e === void 0 && (e = {}), Qt({
    getUserProvidedColDef: jest.fn(),
    isRowGroupDisplayed: jest.fn(),
    isPrimary: jest.fn(),
    isFilterAllowed: jest.fn(),
    isFieldContainsDots: jest.fn(),
    isTooltipEnabled: jest.fn(),
    isTooltipFieldContainsDots: jest.fn(),
    addEventListener: jest.fn(),
    removeEventListener: jest.fn(),
    isSuppressNavigable: jest.fn(),
    isCellEditable: jest.fn(),
    isSuppressFillHandle: jest.fn(),
    isAutoHeight: jest.fn(),
    isAutoHeaderHeight: jest.fn(),
    isRowDrag: jest.fn(),
    isDndSource: jest.fn(),
    isCellCheckboxSelection: jest.fn(),
    isSuppressPaste: jest.fn(),
    isMenuVisible: jest.fn(),
    getSort: jest.fn(),
    isSortable: jest.fn(),
    isSortAscending: jest.fn(),
    isSortDescending: jest.fn(),
    isSortNone: jest.fn(),
    isSorting: jest.fn(),
    getSortIndex: jest.fn(),
    getAggFunc: jest.fn(),
    getRight: jest.fn(),
    isFilterActive: jest.fn(),
    isHovered: jest.fn(),
    isFirstRightPinned: jest.fn(),
    isLastLeftPinned: jest.fn(),
    isPinned: jest.fn(),
    isPinnedLeft: jest.fn(),
    isPinnedRight: jest.fn(),
    isSpanHeaderHeight: jest.fn(),
    getColumnGroupPaddingInfo: jest.fn(),
    getColDef: jest.fn(),
    getColId: jest.fn(),
    getAutoHeaderHeight: jest.fn(),
    getColSpan: jest.fn(),
    getRowSpan: jest.fn(),
    isGreaterThanMax: jest.fn(),
    getMaxWidth: jest.fn(),
    getFlex: jest.fn(),
    isRowGroupActive: jest.fn(),
    isPivotActive: jest.fn(),
    isAnyFunctionActive: jest.fn(),
    isAnyFunctionAllowed: jest.fn(),
    isValueActive: jest.fn(),
    isAllowPivot: jest.fn(),
    isAllowValue: jest.fn(),
    isAllowRowGroup: jest.fn(),
    isColumn: !0,
    getUniqueId: jest.fn(),
    getActualWidth: jest.fn(),
    getMinWidth: jest.fn(),
    getLeft: jest.fn(),
    getDefinition: jest.fn(),
    getColumnGroupShow: jest.fn(),
    getParent: jest.fn(),
    isResizable: jest.fn(),
    isEmptyGroup: jest.fn(),
    isMoving: jest.fn(),
    getPinned: jest.fn(),
    isVisible: jest.fn(),
    getInstanceId: jest.fn(),
    getOriginalParent: jest.fn(),
    getId: jest.fn()
  })(e);
}
var AR = Qt({
  startRow: 0,
  endRow: 100,
  rowGroupCols: [],
  valueCols: [],
  pivotCols: [],
  pivotMode: !1,
  groupKeys: [],
  filterModel: null,
  sortModel: []
});
function bie(e) {
  e === void 0 && (e = {});
  var t = hi();
  return Qt(Ee({ request: AR(), parentNode: Vr(), success: jest.fn(), fail: jest.fn(), context: {}, api: t }, e))();
}
function Vr(e) {
  return e === void 0 && (e = {}), Qt(Ee({ setSelected: jest.fn(), isSelected: jest.fn(), isRowPinned: jest.fn(), isExpandable: jest.fn(), setExpanded: jest.fn(), isFullWidthCell: jest.fn(), isHovered: jest.fn(), addEventListener: jest.fn(), removeEventListener: jest.fn(), resetQuickFilterAggregateText: jest.fn(), depthFirstSearch: jest.fn(), setRowHeight: jest.fn(), setData: jest.fn(), updateData: jest.fn(), setDataValue: jest.fn(), getRoute: jest.fn(), id: void 0, data: void 0, displayed: !1, rowPinned: void 0, selectable: !1, rowHeight: void 0, rowTop: null, group: void 0, firstChild: !1, lastChild: !1, childIndex: 0, level: 0, uiLevel: 0, parent: null, stub: !1, failedLoad: !1, rowIndex: null, quickFilterAggregateText: null, master: !1, detail: !1, field: null, key: null, groupData: null, aggData: void 0, rowGroupColumn: null, rowGroupIndex: null, expanded: !1, leafGroup: !1, allLeafChildren: [], allChildrenCount: null, childrenAfterGroup: null, childrenAfterSort: null, childrenAfterFilter: null, footer: !1, sibling: null }, e))();
}
function Sie(e) {
  return e === void 0 && (e = {}), Qt({
    value: null,
    data: {},
    valueFormatted: null,
    node: Vr(),
    eGridCell: document.createElement("div"),
    eParentOfValue: document.createElement("div"),
    registerRowDragger: jest.fn(),
    setTooltip: jest.fn(),
    api: hi(),
    context: {}
  })(e);
}
function xie(e) {
  return e === void 0 && (e = {}), Qt({
    api: hi(),
    context: {},
    onStateChange: jest.fn(),
    state: void 0
  })(e);
}
function Rie(e) {
  return e === void 0 && (e = {}), Qt({
    api: hi(),
    context: {}
  })(e);
}
function Fie(e) {
  return e === void 0 && (e = {}), Qt({
    value: null,
    data: {},
    node: Vr(),
    rowIndex: 0,
    eGridCell: document.createElement("div"),
    api: hi(),
    context: {},
    initialValue: void 0,
    onValueChange: jest.fn(),
    eventKey: null,
    column: Ma(),
    colDef: {},
    cellStartedEdit: !1,
    onKeyDown: jest.fn(),
    stopEditing: jest.fn(),
    parseValue: jest.fn(),
    formatValue: jest.fn()
  })(e);
}
function Pie(e) {
  return e === void 0 && (e = {}), Qt({
    data: {},
    value: null,
    context: {},
    colDef: {},
    api: hi(),
    location: "cell"
  })(e);
}
function Tie(e) {
  return Qt({
    node: Vr(),
    api: hi(),
    data: {},
    context: {}
  })(e);
}
function Eie(e) {
  return e === void 0 && (e = {}), Qt({
    column: Ma(),
    colDef: {},
    value: void 0,
    data: void 0,
    node: Vr(),
    rowIndex: 0,
    api: hi(),
    context: void 0
  })(e);
}
function Die(e) {
  return Qt({
    api: hi(),
    colDef: {},
    column: Ma(),
    context: {},
    data: void 0,
    newValue: void 0,
    node: Vr(),
    oldValue: void 0,
    rowIndex: 0,
    rowPinned: void 0,
    type: "cellEditingStopped",
    value: void 0,
    valueChanged: !1
  })(e);
}
function Aie(e) {
  return Qt({
    source: void 0,
    api: hi(),
    colDef: {},
    column: Ma(),
    context: {},
    data: {},
    newValue: void 0,
    node: Vr(),
    oldValue: void 0,
    rowIndex: 0,
    rowPinned: void 0,
    type: "cellValueChanged",
    value: void 0
  })(e);
}
const Mie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  makeCellClassParams: Eie,
  makeCellEditingStoppedEvent: Die,
  makeCellValueChangedEvent: Aie,
  makeColumn: Ma,
  makeCustomCellEditorProps: Fie,
  makeCustomCellRendererProps: Sie,
  makeCustomStatusPanelProps: Rie,
  makeCustomToolPanelProps: xie,
  makeCustomTooltipProps: Pie,
  makeGridApi: hi,
  makeGridState: yie,
  makeRowHeightParams: Tie,
  makeRowNode: Vr,
  makeServerSideGetRowsParams: bie,
  makeServerSideGetRowsRequest: AR
}, Symbol.toStringTag, { value: "Module" }));
function Iie(e) {
  return e === void 0 && (e = {}), Qt(Ee({ onExport: jest.fn(), getSheetDataForExcel: jest.fn(), getColDefs: jest.fn(), getColIds: jest.fn(), registerGridApi: jest.fn(), getFilters: jest.fn(), getFilteredRowCount: jest.fn(), getState: jest.fn(), getRowData: jest.fn(), getOpenedToolPanel: jest.fn(), getDataContextObject: jest.fn(), setFilters: jest.fn(), refreshCells: jest.fn(), refreshServerSide: jest.fn(), applyServerSideTransaction: jest.fn(), applyGridState: jest.fn(), addEventListener: jest.fn(), removeEventListener: jest.fn(), isEditModeActive: jest.fn(), isGridReady: !1 }, e))();
}
const Lie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  makeDataGridContext: Iie
}, Symbol.toStringTag, { value: "Module" }));
var Fre = Ee(Ee({}, Mie), Lie);
export {
  tre as AsyncAutocompleteFieldCellEditor,
  lre as AsyncAutocompleteFilter,
  sre as AutocompleteFieldCellEditor,
  xre as BulkActionToolPanel,
  tJ as CellClassNames,
  nre as CellRenderers,
  vre as ClientDataGrid,
  mre as DataGridContextProvider,
  Y9 as DotStatusCellRenderer,
  iB as LicenseManager,
  j9 as NumericFieldCellEditor,
  rre as NumericTotalCellRenderer,
  ire as PercentageFieldCellEditor,
  Z9 as RowAlertCellRenderer,
  Cre as RowClassNames,
  K9 as SelectFieldCellEditor,
  wre as ServerDataGrid,
  Ym as TextFieldCellEditor,
  q9 as cellEditorComponents,
  Q9 as cellRendererComponents,
  dre as createPercentageFilterValueGetter,
  gre as createValueFormatter,
  PH as exportMultipleSheetsAsExcel,
  yre as formatters,
  are as getColDefId,
  fre as getDataSource,
  cre as getDateStringClientFilterProps,
  HQ as getLeafNodeRowIds,
  bre as getRowAlertCol,
  Sre as getSelectableCol,
  iR as getServerColDefMapByColId,
  ure as getServerSideRowSelectionState,
  pre as getSortFieldPath,
  ore as isColGroupDef,
  OQ as isCombinedSimpleFilter,
  NQ as isCustomAsyncAutocompleteFilter,
  LQ as isDateFilter,
  kQ as isMultiFilter,
  xQ as isServerColDef,
  oR as isServerSideSelectionState,
  IQ as isSetFilter,
  BQ as isSimpleBlankFilter,
  GQ as isSimpleFilter,
  VQ as isSimpleNotBlankFilter,
  hre as reselectServerSideRowSelectionState,
  Fre as testUtil,
  Up as useDataGridContext,
  Rre as useSaveGridState
};
//# sourceMappingURL=index.es.js.map
